import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** currency.js */
  Currency: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** Custom scalar type for precise decimal values using decimal.js */
  Decimal: { input: any; output: any; }
  /** Duration scalar unit */
  Duration: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** Length scalar unit */
  Length: { input: any; output: any; }
  /** Weight/Mass scalar unit */
  Mass: { input: any; output: any; }
  /** Percentage scalar unit */
  Percent: { input: any; output: any; }
  /** Volume scalar unit */
  Volume: { input: any; output: any; }
};

export type AblyTokenOutput = {
  __typename?: 'AblyTokenOutput';
  token?: Maybe<Scalars['String']['output']>;
};

export type AcceptCustomerPortalOrderInput = {
  orderUuid: Scalars['String']['input'];
};

export type AcceptCustomerPortalOrderOutput = AcceptCustomerPortalOrderSuccessOutput | MutationErrorOutput;

export type AcceptCustomerPortalOrderSuccessOutput = {
  __typename?: 'AcceptCustomerPortalOrderSuccessOutput';
  acceptedAt: Scalars['DateTime']['output'];
  orderUuid: Scalars['String']['output'];
};

export type AcceptEdiOrApiOrderInput = {
  uuid: Scalars['String']['input'];
};

export type AcceptEdiOrApiOrderOutput = {
  __typename?: 'AcceptEdiOrApiOrderOutput';
  uuid: Scalars['String']['output'];
};

export type AcceptOrderDelegationInput = {
  uuid: Scalars['String']['input'];
};

export type AcceptOrganizationPeerInput = {
  peerUuid: Scalars['String']['input'];
};

export enum AccessLevel {
  Read = 'READ',
  Write = 'WRITE'
}

export type AccessorialChargeDetailsEntity = {
  __typename?: 'AccessorialChargeDetailsEntity';
  accessorialName: Scalars['String']['output'];
  accessorialUuid: Scalars['String']['output'];
  chargeDetailsByContact: Array<ContactAccessorialChargeDetailsEntity>;
  chargeDetailsByTerminal: Array<TerminalAccessorialChargeDetailsEntity>;
};

export type AccessorialChargeDetailsReportArgs = {
  /** If not specified, returns report for all company-only accessorials. */
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  includeContactsWithNoShipments: Scalars['Boolean']['input'];
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceStatuses: Array<InvoiceStatus>;
  /** If specified, only returns shipments on orders with this controlling terminal */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type AccessorialCreateInput = {
  attemptsAccessorialCreateInput?: InputMaybe<AttemptsAccessorialCreateInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  ediCode?: InputMaybe<Scalars['String']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  invoiceDisplayName?: InputMaybe<Scalars['String']['input']>;
  isAuthoCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultGlobalSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  matchingGlobalAccessorial?: InputMaybe<Scalars['String']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  percentageAccessorialCreateInput?: InputMaybe<PercentageAccessorialCreateInput>;
  qboItemId?: InputMaybe<Scalars['String']['input']>;
  skidBasedAccessorialCreateInput?: InputMaybe<SkidBasedAccessorialCreateInput>;
  specialAccessorialCreateInput?: InputMaybe<SpecialAccessorialCreateInput>;
  standardAccessorialCreateInput?: InputMaybe<StandardAccessorialCreateInput>;
  storageDaysAccessorialCreateInput?: InputMaybe<StorageDaysAccessorialCreateInput>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  unitBasedAccessorialCreateInput?: InputMaybe<UnitBasedAccessorialCreateInput>;
  waitTimeAccessorialCreateInput?: InputMaybe<WaitTimeAccessorialCreateInput>;
  weightBasedAccessorialCreateInput?: InputMaybe<WeightBasedAccessorialCreateInput>;
  zoneBasedAccessorialCreateInput?: InputMaybe<ZoneBasedAccessorialCreateInput>;
};

export type AccessorialDateRangeConfigEntity = {
  __typename?: 'AccessorialDateRangeConfigEntity';
  accessorialRanges: Array<AccessorialRangeEntity>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fuelProfile?: Maybe<FuelProfileEntity>;
  /** @deprecated Use the fuel surcharge rate from the fuel profile instead. */
  fuelSurchargePercentageRate?: Maybe<Scalars['Float']['output']>;
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  /** Rate in dollars */
  rate: Scalars['Float']['output'];
  specialChargeGroups: Array<SpecialAccessorialChargeGroupEntity>;
  specialMatrixItems: Array<SpecialAccessorialMatrixItemEntity>;
  startDate: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type AccessorialGroupEntity = {
  __typename?: 'AccessorialGroupEntity';
  accessorials: Array<AccessorialUnion>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AccessorialInterface = {
  code?: Maybe<Scalars['String']['output']>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  uuid: Scalars['String']['output'];
};

export enum AccessorialPercentageBasis {
  AllCharges = 'ALL_CHARGES',
  Freight = 'FREIGHT',
  FreightAndFuel = 'FREIGHT_AND_FUEL'
}

export type AccessorialRangeCreateInput = {
  lessThanOrEqualToValue: Scalars['Int']['input'];
  rateUsdCents: Scalars['Float']['input'];
};

export type AccessorialRangeEntity = {
  __typename?: 'AccessorialRangeEntity';
  lessThanOrEqualToValue: Scalars['Int']['output'];
  rateUsdCents: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type AccessorialRangeUpdateInput = {
  lessThanOrEqualToValue?: InputMaybe<Scalars['Int']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AccessorialRangeUpdatesInput = {
  accessorialRangeUpdateInputs: Array<AccessorialRangeUpdateInput>;
  accessorialUuid: Scalars['String']['input'];
};

export type AccessorialToMappingInput = {
  desktopMapping?: InputMaybe<Scalars['String']['input']>;
  fileMapping?: InputMaybe<Scalars['String']['input']>;
  qboItemId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type AccessorialToQuickbooksMappingCreateInput = {
  accessorialUuid: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId: Scalars['String']['input'];
};

export type AccessorialToQuickbooksMappingEntity = {
  __typename?: 'AccessorialToQuickbooksMappingEntity';
  accessorial: AccessorialInterface;
  createdAt: Scalars['DateTime']['output'];
  quickbooksId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type AccessorialToQuickbooksMappingUpdateInput = {
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum AccessorialType {
  Attempts = 'ATTEMPTS',
  Percentage = 'PERCENTAGE',
  Skid = 'SKID',
  Special = 'SPECIAL',
  Standard = 'STANDARD',
  StorageDays = 'STORAGE_DAYS',
  Unit = 'UNIT',
  WaitTime = 'WAIT_TIME',
  Weight = 'WEIGHT',
  ZoneBased = 'ZONE_BASED'
}

export type AccessorialUnion = AttemptsAccessorialEntity | PercentageAccessorialEntity | SkidBasedAccessorialEntity | SpecialAccessorialEntity | StandardAccessorialEntity | StorageDaysAccessorialEntity | UnitBasedAccessorialEntity | WaitTimeAccessorialEntity | WeightBasedAccessorialEntity | ZoneBasedAccessorialEntity;

export type AccessorialUpdateInput = {
  attemptsAccessorialUpdateInput?: InputMaybe<AttemptsAccessorialUpdateInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  ediCode?: InputMaybe<Scalars['String']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  invoiceDisplayName?: InputMaybe<Scalars['String']['input']>;
  isAuthoCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultGlobalSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  matchingGlobalAccessorial?: InputMaybe<Scalars['String']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  percentageAccessorialUpdateInput?: InputMaybe<PercentageAccessorialUpdateInput>;
  qboItemId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingChargeName?: InputMaybe<Scalars['String']['input']>;
  skidBasedAccessorialUpdateInput?: InputMaybe<SkidBasedAccessorialUpdateInput>;
  specialAccessorialUpdateInput?: InputMaybe<SpecialAccessorialUpdateInput>;
  standardAccessorialUpdateInput?: InputMaybe<StandardAccessorialUpdateInput>;
  storageDaysAccessorialUpdateInput?: InputMaybe<StorageDaysAccessorialUpdateInput>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  unitBasedAccessorialUpdateInput?: InputMaybe<UnitBasedAccessorialUpdateInput>;
  waitTimeAccessorialUpdateInput?: InputMaybe<WaitTimeAccessorialUpdateInput>;
  weightBasedAccessorialUpdateInput?: InputMaybe<WeightBasedAccessorialUpdateInput>;
  zoneBasedAccessorialUpdateInput?: InputMaybe<ZoneBasedAccessorialUpdateInput>;
};

export type AccountingReportFilterTypesErrorOutput = {
  __typename?: 'AccountingReportFilterTypesErrorOutput';
  errorMessage: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AccountingReportFilterTypesInput = {
  /** The report type to return the list of filters for */
  reportType: AccountingReportTypeV2;
};

export type AccountingReportFilterTypesSuccessOutput = {
  __typename?: 'AccountingReportFilterTypesSuccessOutput';
  /** A list of report filter types that are required for the specified accounting report type in the query input */
  reportFilterTypes: Array<ReportFilterType>;
  success: Scalars['Boolean']['output'];
};

export type AccountingReportFiltersOutput = AccountingReportFilterTypesErrorOutput | AccountingReportFilterTypesSuccessOutput;

export enum AccountingReportType {
  AgingReport = 'AgingReport'
}

export enum AccountingReportTypeV2 {
  AgingReportDetailed = 'AGING_REPORT_DETAILED',
  DunningReport = 'DUNNING_REPORT'
}

export enum AccountsReceivableCustomerFilter {
  All = 'ALL',
  NonzeroBalance = 'NONZERO_BALANCE'
}

export type AccountsReceivableReportArgs = {
  /** If true, calculate customer balance as of the provided end date in dateFilters. If false, calculate overall customer balance with no date filter. */
  calculateBalanceAsOfEndDate: Scalars['Boolean']['input'];
  customerFilter?: InputMaybe<AccountsReceivableCustomerFilter>;
  dateFilter?: InputMaybe<DateFilterStartEnd>;
};

/** Accounts receivable report data for a particular contact */
export type AccountsReceivableReportDataForContactEntity = {
  __typename?: 'AccountsReceivableReportDataForContactEntity';
  /** Overall balance of contact (invoices minus payments), in dollars */
  balance: Scalars['Float']['output'];
  /** Contact reference number (Account ID) */
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  /** Contact display name */
  displayName: Scalars['String']['output'];
  /** Sum of credit (paymentType = CREDIT) amounts that have been applied to this contacts invoices, in dollars */
  totalCredits: Scalars['Float']['output'];
  /** Sum of debit (paymentType = DEBIT) amounts that have been applied to this contacts invoices, in dollars */
  totalDebits: Scalars['Float']['output'];
  /** Sum of posted invoice totals, in dollars */
  totalInvoices: Scalars['Float']['output'];
  /** Sum of payment (paymentType = PAYMENT) amounts that have been applied to this contacts invoices, in dollars */
  totalPayments: Scalars['Float']['output'];
  /** Sum of credit (paymentType = CREDIT) amounts that have not been applied, in dollars */
  unappliedCredits: Scalars['Float']['output'];
  /** Sum of debit (paymentType = DEBIT) amounts that have not been applied, in dollars */
  unappliedDebits: Scalars['Float']['output'];
  /** Sum of payment (paymentType = PAYMENT) amounts that have not been applied, in dollars */
  unappliedPayments: Scalars['Float']['output'];
};

export type AcknowledgeMyStopChangeInput = {
  stopUuid: Scalars['String']['input'];
};

export type AcknowledgeMyStopChangeOutput = AcknowledgeMyStopChangeSuccessOutput | MutationErrorOutput;

export type AcknowledgeMyStopChangeSuccessOutput = {
  __typename?: 'AcknowledgeMyStopChangeSuccessOutput';
  stop: StopEntity;
  /** Whether the stop was updated. This could be false if, for example, the stop had been re-assigned to a different driver. */
  updated: Scalars['Boolean']['output'];
};

export type AcknowledgeQuoteAttentionInput = {
  orderQuoteUuid: Scalars['String']['input'];
};

export type AcknowledgeQuoteAttentionOutput = AcknowledgeQuoteAttentionSuccessOutput | MutationErrorOutput;

export type AcknowledgeQuoteAttentionSuccessOutput = {
  __typename?: 'AcknowledgeQuoteAttentionSuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
  status: OrderQuoteStatus;
};

export type AcknowledgeRouteChangesInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type AddApiUserContactMappingInput = {
  apiUserUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
};

export type AddDriversToRouteInput = {
  driverUuids: Array<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

export type AddLineItemsToSettlementBillsInput = {
  settlementBillCreateInputs?: InputMaybe<Array<NewSettlementBillInput>>;
  settlementBillUpdateInputs?: InputMaybe<Array<ExistingSettlementBillInput>>;
};

export type AddLineItemsToSettlementBillsOutput = AddLineItemsToSettlementBillsSuccessOutput | MutationErrorOutput;

export type AddLineItemsToSettlementBillsSuccessOutput = {
  __typename?: 'AddLineItemsToSettlementBillsSuccessOutput';
  driverSettlementBills: Array<DriverSettlementBillEntity>;
};

export type AddOrdersToExistingInvoiceErrorOutput = {
  __typename?: 'AddOrdersToExistingInvoiceErrorOutput';
  attemptedOrdersToAdd: Array<OrderToAddToInvoice>;
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToExistingInvoiceResult = AddOrdersToExistingInvoiceErrorOutput | AddOrdersToInvoiceSuccessOutput;

export type AddOrdersToInvoiceSuccessOutput = {
  __typename?: 'AddOrdersToInvoiceSuccessOutput';
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  ordersAdded: Array<OrderAddedToInvoice>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToInvoicesForContactErrorOutput = {
  __typename?: 'AddOrdersToInvoicesForContactErrorOutput';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  proposedNewInvoicesToCreate: Array<NewInvoiceToCreate>;
  proposedUpdatesToExistingInvoices: Array<ExistingInvoiceToUpdate>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToInvoicesForContactOutput = AddOrdersToInvoicesForContactErrorOutput | AddOrdersToInvoicesForContactSuccessOutput;

export type AddOrdersToInvoicesForContactSuccessOutput = {
  __typename?: 'AddOrdersToInvoicesForContactSuccessOutput';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  existingInvoiceAdds: Array<AddOrdersToExistingInvoiceResult>;
  newInvoiceAdds: Array<AddOrdersToNewInvoiceResult>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToInvoicesInput = {
  addToExistingInvoices: Scalars['Boolean']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type AddOrdersToInvoicesOutput = AddOrdersToInvoicesSuccessOutput | MutationErrorOutput;

export type AddOrdersToInvoicesSuccessOutput = {
  __typename?: 'AddOrdersToInvoicesSuccessOutput';
  invoicesAddedToByContact: Array<AddOrdersToInvoicesForContactOutput>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToManifestInput = {
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type AddOrdersToManifestOutput = {
  __typename?: 'AddOrdersToManifestOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type AddOrdersToManifestV2Input = {
  /** When true, allows adding orders whose origin terminal does not match the manifest start terminal, provided the order has a single misrouted piece at the manifest start terminal. */
  forceOriginMismatch?: InputMaybe<Scalars['Boolean']['input']>;
  manifestUuid: Scalars['String']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type AddOrdersToManifestV2Output = AddOrdersToManifestV2PreviousManifestErrorOutput | AddOrdersToManifestV2SuccessOutput | MutationErrorOutput;

/** An error that occurs when adding orders to a manifest. */
export type AddOrdersToManifestV2PreviousManifestErrorOutput = {
  __typename?: 'AddOrdersToManifestV2PreviousManifestErrorOutput';
  /** An array of errors that occur when forceOriginMismatch is true but the order does not have a single misrouted piece at the manifest start terminal */
  invalidMisroutedOverrideErrors: Array<InvalidMisroutedOverrideError>;
  /** An array of errors that occur when adding orders to an initial manifest that have a different start terminal from the start terminal of the manifest being added to */
  originTerminalMismatchErrors: Array<OriginTerminalMismatchError>;
  /** An array of errors that occur when adding orders to a manifest that are on a previous manifest with a different end terminal from the start terminal of the manifest being added to */
  previousManifestErrors: Array<PreviousManifestError>;
  /** An array of errors that occur when the manifest departs a terminal on the order's route but arrives at a terminal the order is not routed to */
  routeDestinationMismatchErrors: Array<RouteDestinationMismatchError>;
};

export type AddOrdersToManifestV2SuccessOutput = {
  __typename?: 'AddOrdersToManifestV2SuccessOutput';
  lineHaulManifest: LineHaulManifestEntity;
};

export type AddOrdersToNewInvoiceErrorOutput = {
  __typename?: 'AddOrdersToNewInvoiceErrorOutput';
  attemptedOrdersToAdd: Array<OrderToAddToInvoice>;
  /** this is null when the invoice could not be created. it is not null when we created the invoice but could not add orders to it */
  createdInvoiceName?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddOrdersToNewInvoiceResult = AddOrdersToInvoiceSuccessOutput | AddOrdersToNewInvoiceErrorOutput;

export type AddPiecesToPieceReceiptInput = {
  /** Client-side ISO-8601 timestamp of when the user actually scanned the piece(s). Used to preserve real scan time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  /** Existing pieces to add, each optionally moved to a new location */
  existingPieces?: InputMaybe<Array<PieceReceiptExistingPieceInput>>;
  /** New pieces to create and attach to the receipt */
  newPieces?: InputMaybe<Array<PieceReceiptNewPieceInput>>;
  /** When set, nest every piece in this request under this existing container piece (must already be a container on the receipt). */
  parentPieceUuid?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the piece receipt to add pieces to */
  pieceReceiptUuid: Scalars['String']['input'];
};

export type AddPiecesToPieceReceiptOutput = {
  __typename?: 'AddPiecesToPieceReceiptOutput';
  /** Number of pieces newly created and attached */
  createdCount: Scalars['Int']['output'];
  /** Number of existing pieces linked */
  linkedCount: Scalars['Int']['output'];
  /** The piece receipt the pieces were added to */
  pieceReceipt: PieceReceiptEntity;
};

export type AddRouteStopInput = {
  address: AddressUpsertInput;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  routeUuid: Scalars['String']['input'];
  serviceTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  stopType: StopType;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type AddServiceToContactInput = {
  contactUuid: Scalars['String']['input'];
  serviceUuid: Scalars['String']['input'];
};

export type AddStopToRouteInput = {
  routeUuid: Scalars['String']['input'];
  stopUuid: Scalars['String']['input'];
};

export type AddTagToLegInput = {
  legUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type AddTagToOrderInput = {
  orderUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type AddTestAccessorialChargeInput = {
  accessorialUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type AddTestAccessorialChargeOutput = {
  __typename?: 'AddTestAccessorialChargeOutput';
  customChargeUuid: Scalars['String']['output'];
};

export type AddThirdPartyUserToContactInput = {
  contactUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type AddUserToRoleInput = {
  userUuid: Scalars['String']['input'];
  /** The UUID of the role to add the user to */
  uuid: Scalars['String']['input'];
};

export type AddUserToRoleOutput = {
  __typename?: 'AddUserToRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type AdditionalChargesRoutingRule = {
  /** Services to apply this rule to */
  services: Array<Scalars['String']['input']>;
  /** Target for additional charges */
  target: Scalars['String']['input'];
  /** Terminal code for terminal target */
  terminalCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateInput = {
  associatedContactUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  driverInstructions?: InputMaybe<Scalars['String']['input']>;
  geocodeQuality?: InputMaybe<AddressGeocodeQuality>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  preventCoordRecompute?: InputMaybe<Scalars['Boolean']['input']>;
  receivingHoursEnd?: InputMaybe<Scalars['DateTime']['input']>;
  receivingHoursStart?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  type?: InputMaybe<AddressType>;
  zip: Scalars['String']['input'];
};

export type AddressEntity = {
  __typename?: 'AddressEntity';
  associatedContact?: Maybe<ContactPersonEntity>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  driverInstructions?: Maybe<Scalars['String']['output']>;
  formattedAddress: Scalars['String']['output'];
  geocodeQuality?: Maybe<AddressGeocodeQuality>;
  iataCode?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  preventCoordRecompute?: Maybe<Scalars['Boolean']['output']>;
  receivingHoursEnd?: Maybe<Scalars['DateTime']['output']>;
  receivingHoursStart?: Maybe<Scalars['DateTime']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  state: Scalars['String']['output'];
  type: AddressType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressForCachedStop = {
  __typename?: 'AddressForCachedStop';
  city: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  routeName?: Maybe<Scalars['String']['output']>;
  routeNameUuid?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export enum AddressGeocodeQuality {
  Approximate = 'APPROXIMATE',
  Exact = 'EXACT',
  Unresolved = 'UNRESOLVED'
}

export enum AddressType {
  Record = 'RECORD',
  Template = 'TEMPLATE'
}

/** Filter fields for the address type enum field */
export type AddressTypeFilter = {
  /** Filter for records where the address type is equal to the provided address type value */
  eq?: InputMaybe<StandardStopType>;
};

export type AddressUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  driverInstructions?: InputMaybe<Scalars['String']['input']>;
  geocodeQuality?: InputMaybe<AddressGeocodeQuality>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preventCoordRecompute?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use preventCoordRecompute instead */
  recalculateLatLong?: InputMaybe<Scalars['Boolean']['input']>;
  receivingHoursEnd?: InputMaybe<Scalars['DateTime']['input']>;
  receivingHoursStart?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AddressType>;
  uuid: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressUpsertInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  driverInstructions?: InputMaybe<Scalars['String']['input']>;
  geocodeQuality?: InputMaybe<AddressGeocodeQuality>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  preventCoordRecompute?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use preventCoordRecompute instead */
  preventCoordRecomputeInBackend?: InputMaybe<Scalars['Boolean']['input']>;
  receivingHoursEnd?: InputMaybe<Scalars['DateTime']['input']>;
  receivingHoursStart?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  state: Scalars['String']['input'];
  type?: InputMaybe<AddressType>;
  uuid: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AdhocApplyPlanBillingPartyEntity = {
  __typename?: 'AdhocApplyPlanBillingPartyEntity';
  contactUuid?: Maybe<Scalars['String']['output']>;
  mechanism: Scalars['String']['output'];
  senderVerdict?: Maybe<Scalars['String']['output']>;
};

export type AdhocApplyPlanDeadlineTypeEntity = {
  __typename?: 'AdhocApplyPlanDeadlineTypeEntity';
  mechanism: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdhocApplyPlanDuplicateEntity = {
  __typename?: 'AdhocApplyPlanDuplicateEntity';
  duplicateOrderUuid?: Maybe<Scalars['String']['output']>;
  isDuplicate: Scalars['Boolean']['output'];
  wouldAdoptOrphanUuid?: Maybe<Scalars['String']['output']>;
};

export type AdhocApplyPlanEntity = {
  __typename?: 'AdhocApplyPlanEntity';
  billingParty: AdhocApplyPlanBillingPartyEntity;
  deadlineType?: Maybe<AdhocApplyPlanDeadlineTypeEntity>;
  duplicate?: Maybe<AdhocApplyPlanDuplicateEntity>;
  service?: Maybe<AdhocApplyPlanServiceEntity>;
};

export type AdhocApplyPlanServiceEntity = {
  __typename?: 'AdhocApplyPlanServiceEntity';
  mechanism: Scalars['String']['output'];
  serviceId?: Maybe<Scalars['String']['output']>;
};

export type AdhocEmailSimulationInput = {
  fromAddress: Scalars['String']['input'];
  receivedAt?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type AdhocPreviewBatchEntity = {
  __typename?: 'AdhocPreviewBatchEntity';
  actorEmail: Scalars['String']['output'];
  aggregateCostUsd?: Maybe<Scalars['Float']['output']>;
  aggregateInputTokens?: Maybe<Scalars['Float']['output']>;
  aggregateOutputTokens?: Maybe<Scalars['Float']['output']>;
  companyUuid: Scalars['String']['output'];
  emailSimulation?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<AdhocPreviewBatchMemberEntity>;
  status: Scalars['String']['output'];
};

export type AdhocPreviewBatchMemberEntity = {
  __typename?: 'AdhocPreviewBatchMemberEntity';
  adhocRunId?: Maybe<Scalars['String']['output']>;
  applyPlan?: Maybe<AdhocApplyPlanEntity>;
  dispatchError?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  extractedFields?: Maybe<Scalars['JSON']['output']>;
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  runStatus?: Maybe<Scalars['String']['output']>;
  uploadId: Scalars['String']['output'];
  usage?: Maybe<Scalars['JSON']['output']>;
};

export type AdhocPreviewExemplarEntity = {
  __typename?: 'AdhocPreviewExemplarEntity';
  cosineSimilarity: Scalars['Float']['output'];
  documentId: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  fieldValues: Scalars['JSON']['output'];
  source: Scalars['String']['output'];
};

export type AdhocPreviewResultEntity = {
  __typename?: 'AdhocPreviewResultEntity';
  applyPlan?: Maybe<AdhocApplyPlanEntity>;
  companyUuid: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  exemplars: Array<AdhocPreviewExemplarEntity>;
  extractedFields?: Maybe<Scalars['JSON']['output']>;
  runId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  usage?: Maybe<Scalars['JSON']['output']>;
};

export type AdhocPreviewTriggerEntity = {
  __typename?: 'AdhocPreviewTriggerEntity';
  runId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AdjustmentStopDriverMapCreateInput = {
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revenueFlatRate?: InputMaybe<Scalars['Float']['input']>;
};

export type AdminSyncInvoicesToQuickbooksInput = {
  actingUserUuid: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  options?: InputMaybe<QuickbooksSyncOptionsInput>;
  uuids: Array<Scalars['String']['input']>;
};

export type AdoptDriverSettlementPayTermsInput = {
  stopDriverMapUuids: Array<Scalars['String']['input']>;
};

export type AdoptDriverSettlementPayTermsResult = {
  __typename?: 'AdoptDriverSettlementPayTermsResult';
  adopted: Scalars['Boolean']['output'];
  captureState: SettlementPayTermsCaptureState;
  stopDriverMapUuid: Scalars['String']['output'];
  terms: StopDriverMapPayTermsEntity;
};

/** Runs the next lifecycle step of every selected order, one step per order per call. */
export type AdvanceOutboundBenchOrdersInput = {
  companyActors?: InputMaybe<Array<BenchCompanyActorInput>>;
  /** Required, and must be true, when the backend runs in production. Ignored elsewhere. */
  confirmProductionSend?: InputMaybe<Scalars['Boolean']['input']>;
  /** An active driver of the orders' company. ROUTE_STOP assigns the route it creates to this driver; without one, ROUTE_STOP and START_ROUTE block. */
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  integrationType: BenchIntegrationType;
  /** Report outbound EDI rows created since this instant: the start of the run, so rows sent after a step returned still show. */
  reportEdiSince?: InputMaybe<Scalars['DateTime']['input']>;
  selection: BenchOrderSelectionInput;
  /** Send the 990 ACCEPTED for an order that arrived live. A live order has no draft to approve, so ACCEPT_TENDER sends the 990 itself, once, when the partnership does not auto-accept. Omitted or false leaves live orders without a 990. */
  send990ForLiveOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Steps to leave out of this run. The plan reports them SKIPPED, and the run moves on to the next step. Empty or omitted runs every step. */
  skippedSteps?: InputMaybe<Array<BenchStepSelectorInput>>;
};

export type AgentFieldsEntity = {
  __typename?: 'AgentFieldsEntity';
  activeTerminals: Array<TerminalEntity>;
  defaultDriver: DriverEntity;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** The open invoice value for a contact within the specified day range */
export type AgingReportBucketEntity = {
  __typename?: 'AgingReportBucketEntity';
  /** Include invoices with date greater than this many days before the aging report start date. If null, there is no lower bound */
  greaterThanOrEqualToDays?: Maybe<Scalars['Float']['output']>;
  /** Optional display label for this bucket. When null, consumers derive the label from the day boundaries (legacy behavior). */
  label?: Maybe<Scalars['String']['output']>;
  /** Include invoices with date less than or equal to this many days before the aging report start date. If null, there is no upper bound */
  lessThanOrEqualToDays?: Maybe<Scalars['Float']['output']>;
  /** The total value of open invoices in this bucket in dollars */
  openInvoiceValue: Scalars['Float']['output'];
};

/**
 * The standard output type for an invoice aging report file (generally PDF or CSV)
 *   which has been generated on the backend and uploaded to S3
 */
export type AgingReportFileOutput = {
  __typename?: 'AgingReportFileOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Aging report data for a particular contact that includes the contact invoices and buckets with open invoice values by start and end day ranges */
export type AgingReportForContactEntity = {
  __typename?: 'AgingReportForContactEntity';
  contactAddress?: Maybe<AddressEntity>;
  contactUuid: Scalars['String']['output'];
  /** Contact display name */
  displayName: Scalars['String']['output'];
  invoices: Array<InvoiceForAgingReportEntity>;
  openInvoiceValueBuckets: Array<AgingReportBucketEntity>;
  /** Net total of unapplied payments for this contact in dollars. Informational only and NOT included in openInvoiceValueBuckets[0] (Balance). Credits and payments are negative; debits are positive. */
  unappliedPaymentsTotal: Scalars['Float']['output'];
};

export enum AgingReportType {
  Detailed = 'DETAILED',
  Summary = 'SUMMARY'
}

export type AirportInfoEntity = {
  __typename?: 'AirportInfoEntity';
  address: AddressEntity;
  createdAt: Scalars['DateTime']['output'];
  iataCode?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  terminal: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type AirportInfoUpdateOutput = {
  __typename?: 'AirportInfoUpdateOutput';
  airportInfo: AirportInfoEntity;
};

export enum ApiAddressLocationType {
  Commercial = 'COMMERCIAL',
  Residential = 'RESIDENTIAL'
}

export type ApiKeyAdminConnectOrgsInput = {
  apiKeyUuid: Scalars['String']['input'];
  organizationUuids: Array<Scalars['String']['input']>;
};

export type ApiKeyAdminCreateInput = {
  customMapping?: InputMaybe<Scalars['Boolean']['input']>;
  emitAppointmentCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  emitTerminalHandoffEvents?: InputMaybe<Scalars['Boolean']['input']>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<OutboundWebhookEventType>>;
  idFormat?: InputMaybe<ApiUserIdFormat>;
  name: Scalars['String']['input'];
  payloadShapes?: InputMaybe<Array<WebhookPayloadShape>>;
  /** @deprecated Use webhookTimestampMode instead (TC-1130). */
  sendCompanyLocalTimestamps?: InputMaybe<Scalars['Boolean']['input']>;
  webhookAuthHeaderName?: InputMaybe<Scalars['String']['input']>;
  webhookAuthHeaderValue?: InputMaybe<Scalars['String']['input']>;
  webhookTimestampMode?: InputMaybe<WebhookTimestampMode>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum ApiKeyAdminCsvImportKeyOutcome {
  Conflict = 'CONFLICT',
  Create = 'CREATE',
  Merge = 'MERGE'
}

export enum ApiKeyAdminCsvImportOrgOutcome {
  AlreadyLinked = 'ALREADY_LINKED',
  Ambiguous = 'AMBIGUOUS',
  NotFound = 'NOT_FOUND',
  Ok = 'OK',
  Stale = 'STALE'
}

export type ApiKeyAdminCsvImportOrgRow = {
  __typename?: 'ApiKeyAdminCsvImportOrgRow';
  companyName: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  organizationDisplayName: Scalars['String']['output'];
  outcome: ApiKeyAdminCsvImportOrgOutcome;
  rowNumber: Scalars['Int']['output'];
};

export type ApiKeyAdminCsvImportReport = {
  __typename?: 'ApiKeyAdminCsvImportReport';
  apiKey: Scalars['String']['output'];
  applied: Scalars['Boolean']['output'];
  keyMessage?: Maybe<Scalars['String']['output']>;
  keyName: Scalars['String']['output'];
  keyOutcome: ApiKeyAdminCsvImportKeyOutcome;
  orgRows: Array<ApiKeyAdminCsvImportOrgRow>;
  orgsToLink: Scalars['Int']['output'];
};

export type ApiKeyAdminDetailEntity = {
  __typename?: 'ApiKeyAdminDetailEntity';
  apiKey: ApiKeyAdminEntity;
  linkedOrgs: Array<ApiKeyAdminLinkedOrgEntity>;
};

export type ApiKeyAdminDisconnectOrgInput = {
  apiKeyUuid: Scalars['String']['input'];
  organizationUuid: Scalars['String']['input'];
};

export type ApiKeyAdminEntity = {
  __typename?: 'ApiKeyAdminEntity';
  apiKey: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customMapping: Scalars['Boolean']['output'];
  emitAppointmentCancelledEvents: Scalars['Boolean']['output'];
  emitTerminalHandoffEvents: Scalars['Boolean']['output'];
  enableStaging: Scalars['Boolean']['output'];
  eventTypes: Array<OutboundWebhookEventType>;
  idFormat: ApiUserIdFormat;
  name: Scalars['String']['output'];
  orgCount: Scalars['Float']['output'];
  payloadShapes: Array<WebhookPayloadShape>;
  /** @deprecated Use webhookTimestampMode instead (TC-1130). */
  sendCompanyLocalTimestamps: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  webhookAuthHeaderName?: Maybe<Scalars['String']['output']>;
  webhookAuthHeaderValue?: Maybe<Scalars['String']['output']>;
  webhookTimestampMode: WebhookTimestampMode;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type ApiKeyAdminEventTypeCatalogEntryEntity = {
  __typename?: 'ApiKeyAdminEventTypeCatalogEntryEntity';
  deprecated: Scalars['Boolean']['output'];
  eventType: OutboundWebhookEventType;
  requiresAppointmentCancelledOptIn: Scalars['Boolean']['output'];
  requiresTerminalHandoffOptIn: Scalars['Boolean']['output'];
};

export type ApiKeyAdminEventTypeCatalogShapeEntity = {
  __typename?: 'ApiKeyAdminEventTypeCatalogShapeEntity';
  eventTypes: Array<ApiKeyAdminEventTypeCatalogEntryEntity>;
  isStandard: Scalars['Boolean']['output'];
  shape: WebhookPayloadShape;
};

export type ApiKeyAdminImportCsvInput = {
  csvText: Scalars['String']['input'];
  dryRun: Scalars['Boolean']['input'];
};

export type ApiKeyAdminLinkedOrgEntity = {
  __typename?: 'ApiKeyAdminLinkedOrgEntity';
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  organizationDisplayName: Scalars['String']['output'];
  organizationUuid: Scalars['String']['output'];
};

export type ApiKeyAdminListInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ApiKeyAdminSortField>;
};

export type ApiKeyAdminListItemEntity = {
  __typename?: 'ApiKeyAdminListItemEntity';
  createdAt: Scalars['DateTime']['output'];
  customMapping: Scalars['Boolean']['output'];
  emitAppointmentCancelledEvents: Scalars['Boolean']['output'];
  emitTerminalHandoffEvents: Scalars['Boolean']['output'];
  enableStaging: Scalars['Boolean']['output'];
  eventTypes: Array<OutboundWebhookEventType>;
  idFormat: ApiUserIdFormat;
  name: Scalars['String']['output'];
  orgCount: Scalars['Int']['output'];
  payloadShapes: Array<WebhookPayloadShape>;
  /** @deprecated Use webhookTimestampMode instead (TC-1130). */
  sendCompanyLocalTimestamps: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  webhookAuthHeaderName?: Maybe<Scalars['String']['output']>;
  webhookTimestampMode: WebhookTimestampMode;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type ApiKeyAdminListResult = {
  __typename?: 'ApiKeyAdminListResult';
  apiKeys: Array<ApiKeyAdminListItemEntity>;
  totalCount: Scalars['Int']['output'];
};

export type ApiKeyAdminOrgSearchInput = {
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyAdminOrgSearchResult = {
  __typename?: 'ApiKeyAdminOrgSearchResult';
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  organizationDisplayName: Scalars['String']['output'];
  organizationUuid: Scalars['String']['output'];
};

export type ApiKeyAdminPreviewMappingInput = {
  apiKeyUuid: Scalars['String']['input'];
  examplePayload: Scalars['String']['input'];
  mappingTemplate: Scalars['String']['input'];
  shape: WebhookPayloadShape;
};

export type ApiKeyAdminSetMappingTemplateInput = {
  apiKeyUuid: Scalars['String']['input'];
  mappingTemplate?: InputMaybe<Scalars['String']['input']>;
  shape: WebhookPayloadShape;
};

export type ApiKeyAdminSetStatusMappingsInput = {
  apiKeyUuid: Scalars['String']['input'];
  mappings: Array<ApiKeyAdminStatusMappingInput>;
};

export enum ApiKeyAdminSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  OrgCount = 'ORG_COUNT'
}

export type ApiKeyAdminStatusMappingEntity = {
  __typename?: 'ApiKeyAdminStatusMappingEntity';
  category: StatusMappingCategory;
  externalName: Scalars['String']['output'];
  internalName: Scalars['String']['output'];
};

export type ApiKeyAdminStatusMappingInput = {
  category: StatusMappingCategory;
  externalName: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
};

export type ApiKeyAdminUpdateInput = {
  customMapping?: InputMaybe<Scalars['Boolean']['input']>;
  emitAppointmentCancelledEvents?: InputMaybe<Scalars['Boolean']['input']>;
  emitTerminalHandoffEvents?: InputMaybe<Scalars['Boolean']['input']>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<OutboundWebhookEventType>>;
  idFormat?: InputMaybe<ApiUserIdFormat>;
  name?: InputMaybe<Scalars['String']['input']>;
  payloadShapes?: InputMaybe<Array<WebhookPayloadShape>>;
  /** @deprecated Use webhookTimestampMode instead (TC-1130). */
  sendCompanyLocalTimestamps?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  webhookAuthHeaderName?: InputMaybe<Scalars['String']['input']>;
  webhookAuthHeaderValue?: InputMaybe<Scalars['String']['input']>;
  webhookTimestampMode?: InputMaybe<WebhookTimestampMode>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyAdminWebhookShapeConfigEntity = {
  __typename?: 'ApiKeyAdminWebhookShapeConfigEntity';
  mappingTemplate?: Maybe<Scalars['String']['output']>;
  urlPath?: Maybe<Scalars['String']['output']>;
  webhookShape: WebhookPayloadShape;
};

export type ApiLogConnection = {
  __typename?: 'ApiLogConnection';
  edges: Array<ApiLogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ApiLogEdge = {
  __typename?: 'ApiLogEdge';
  cursor: Scalars['String']['output'];
  node: ApiLogEntity;
};

export type ApiLogEntity = {
  __typename?: 'ApiLogEntity';
  createdAt: Scalars['DateTime']['output'];
  direction: ApiRequestDirection;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  freightSnapTransaction?: Maybe<FreightSnapTransactionEntity>;
  payload?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<ApiResponseStatus>;
  sourceIpAddress?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ApiRequestDirection {
  Received = 'RECEIVED',
  Sent = 'SENT'
}

export enum ApiResponseStatus {
  Http_200 = 'HTTP_200',
  Http_500 = 'HTTP_500',
  HttpOther = 'HTTP_OTHER'
}

export type ApiUserCreateInput = {
  apiKey: Scalars['String']['input'];
  customMapping?: InputMaybe<Scalars['Boolean']['input']>;
  echoApiReceivedAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  emitTerminalHandoffEvents?: InputMaybe<Scalars['Boolean']['input']>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  idFormat: ApiUserIdFormat;
  name: Scalars['String']['input'];
  payloadShapes?: InputMaybe<Array<WebhookPayloadShape>>;
  sendAddressEnrichedPayload?: InputMaybe<Scalars['Boolean']['input']>;
  webhookAuthHeaderName?: InputMaybe<Scalars['String']['input']>;
  webhookAuthHeaderValue?: InputMaybe<Scalars['String']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ApiUserEntity = {
  __typename?: 'ApiUserEntity';
  apiKey: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customMapping: Scalars['Boolean']['output'];
  echoApiReceivedAddresses: Scalars['Boolean']['output'];
  emitAppointmentCancelledEvents: Scalars['Boolean']['output'];
  emitTerminalHandoffEvents: Scalars['Boolean']['output'];
  enableStaging: Scalars['Boolean']['output'];
  eventTypes: Array<OutboundWebhookEventType>;
  idFormat: ApiUserIdFormat;
  name: Scalars['String']['output'];
  payloadShapes: Array<WebhookPayloadShape>;
  sendAddressEnrichedPayload: Scalars['Boolean']['output'];
  /** @deprecated Use webhookTimestampMode instead (TC-1130). */
  sendCompanyLocalTimestamps: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  webhookAuthHeaderName?: Maybe<Scalars['String']['output']>;
  webhookAuthHeaderValue?: Maybe<Scalars['String']['output']>;
  webhookTimestampMode: WebhookTimestampMode;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export enum ApiUserIdFormat {
  ApiName = 'API_NAME',
  Uuid = 'UUID'
}

export type ApiUserUpdateInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  customMapping?: InputMaybe<Scalars['Boolean']['input']>;
  echoApiReceivedAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  emitTerminalHandoffEvents?: InputMaybe<Scalars['Boolean']['input']>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  idFormat?: InputMaybe<ApiUserIdFormat>;
  name?: InputMaybe<Scalars['String']['input']>;
  payloadShapes?: InputMaybe<Array<WebhookPayloadShape>>;
  sendAddressEnrichedPayload?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  webhookAuthHeaderName?: InputMaybe<Scalars['String']['input']>;
  webhookAuthHeaderValue?: InputMaybe<Scalars['String']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ApplyDebitToPaymentInput = {
  amountInCents: Scalars['Int']['input'];
  sourcePaymentUuid: Scalars['String']['input'];
  targetPaymentUuid: Scalars['String']['input'];
};

export type ApplyDelegationAccessorialProposalInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  expectedQuantity: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ApplyRouteOptimizationInput = {
  proposals: Array<ProposedRouteSequenceInput>;
};

/** Who moved a stop appointment from one status to another. */
export enum AppointmentActor {
  Client = 'CLIENT',
  Company = 'COMPANY',
  System = 'SYSTEM'
}

export enum AppointmentCallStatus {
  Busy = 'BUSY',
  Called = 'CALLED',
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotCalled = 'NOT_CALLED',
  NoAnswer = 'NO_ANSWER',
  Rejected = 'REJECTED'
}

export type AppointmentConfirmationInfoOutput = {
  __typename?: 'AppointmentConfirmationInfoOutput';
  appointmentConfirmed: Scalars['Boolean']['output'];
  /** The date and time of the appointment in a human-readable format, local to the stop */
  appointmentDateTime: Scalars['String']['output'];
  /** @deprecated Use appointmentDateTime instead */
  appointmentInfoString: Scalars['String']['output'];
  /** @deprecated Use appointmentConfirmed and rescheduleRequested instead */
  appointmentTextStatus: AppointmentTextStatus;
  /** @deprecated Legacy API, always true */
  hasAppointment: Scalars['Boolean']['output'];
  /** @deprecated Use stopType instead */
  pickupOrDelivery?: Maybe<PickupOrDelivery>;
  /** Whether the contact person of the stop has requested to reschedule the appointment */
  rescheduleRequested: Scalars['Boolean']['output'];
  stopType?: Maybe<StopType>;
};

export type AppointmentOption = {
  __typename?: 'AppointmentOption';
  date: PlainDate;
  endTime: PlainTime;
  /** The appointment date in a human-readable format, local to the stop timezone */
  humanDate: Scalars['String']['output'];
  startTime: PlainTime;
};

export type AppointmentOptions = {
  __typename?: 'AppointmentOptions';
  /** Whether the appointment has been set either by the contact person or manually, possibly not confirmed */
  appointmentExists: Scalars['Boolean']['output'];
  /** A descriptive user-facing message to display */
  message?: Maybe<Scalars['String']['output']>;
  options: Array<AppointmentOption>;
  /** The number of options the API generates per page (i.e., per query). If the API returns fewer options than specified here, then we have reached the last page of possible options. */
  pageSize: Scalars['Int']['output'];
  /** Whether the contact person of the stop has requested to reschedule the appointment */
  rescheduleRequested: Scalars['Boolean']['output'];
};

export type AppointmentOptionsInput = {
  /** The start date and time from which to query for options */
  from?: InputMaybe<PlainDateTimeInput>;
  stopUuid: Scalars['String']['input'];
};

export enum AppointmentSchedulerModel {
  SchedulingResource = 'SCHEDULING_RESOURCE',
  SchedulingZone = 'SCHEDULING_ZONE'
}

/** The lifecycle state of a stop appointment. Only CANCELLED is stored; the rest are derived from the legacy stop columns. */
export enum AppointmentStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Executed = 'EXECUTED',
  RescheduleRequested = 'RESCHEDULE_REQUESTED',
  Scheduled = 'SCHEDULED'
}

export type AppointmentStatusHistoryConnection = {
  __typename?: 'AppointmentStatusHistoryConnection';
  edges: Array<AppointmentStatusHistoryEdge>;
  pageInfo: PageInfo;
};

export type AppointmentStatusHistoryEdge = {
  __typename?: 'AppointmentStatusHistoryEdge';
  cursor: Scalars['String']['output'];
  node: AppointmentStatusHistoryEntity;
};

export type AppointmentStatusHistoryEntity = {
  __typename?: 'AppointmentStatusHistoryEntity';
  actor: AppointmentActor;
  createdAt: Scalars['DateTime']['output'];
  fromStatus?: Maybe<AppointmentStatus>;
  previousAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  previousCustomerBookingNotes?: Maybe<Scalars['String']['output']>;
  previousEndAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  toStatus: AppointmentStatus;
  userDisplayName?: Maybe<Scalars['String']['output']>;
  userUuid?: Maybe<Scalars['String']['output']>;
};

export enum AppointmentTextStatus {
  Confirmed = 'CONFIRMED',
  NotSent = 'NOT_SENT',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

/** A dispatcher action on a stop appointment. */
export enum AppointmentTransitionAction {
  Cancel = 'CANCEL',
  Confirm = 'CONFIRM',
  Reschedule = 'RESCHEDULE'
}

export enum AppointmentWindowType {
  Soft = 'SOFT',
  SoftEnd = 'SOFT_END',
  SoftStart = 'SOFT_START',
  Strict = 'STRICT'
}

export type ApproveQuoteInput = {
  orderUuid: Scalars['String']['input'];
  quoteUuid: Scalars['String']['input'];
};

export type ApproveQuoteReplyInput = {
  draftReplyUuid: Scalars['String']['input'];
  /** The reply text to send in place of the drafted one; approving replaces the stored draft body with it */
  editedBodyText?: InputMaybe<Scalars['String']['input']>;
  orderQuoteUuid: Scalars['String']['input'];
  /** Required when the sender was recovered from a forwarded message */
  recipientConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApproveQuoteReplyOutput = ApproveQuoteReplySuccessOutput | MutationErrorOutput | QuoteReplyRefusedOutput;

export type ApproveQuoteReplySuccessOutput = {
  __typename?: 'ApproveQuoteReplySuccessOutput';
  approvedAt: Scalars['DateTime']['output'];
  draftReplyUuid: Scalars['String']['output'];
  orderQuoteUuid: Scalars['String']['output'];
};

/** This is the graphql input for archiving an organization */
export type ArchiveOrganizationInput = {
  uuid: Scalars['String']['input'];
};

export type ArchiveOrganizationOutput = ArchiveOrganizationSuccessOutput | MutationErrorOutput;

export type ArchiveOrganizationSuccessOutput = {
  __typename?: 'ArchiveOrganizationSuccessOutput';
  /** The archived org */
  organization: OrganizationEntity;
};

export type ArchiveTariffChainInput = {
  id: Scalars['String']['input'];
};

export type ArchiveTariffChainOutput = ArchiveTariffChainSuccessOutput | MutationErrorOutput;

export type ArchiveTariffChainSuccessOutput = {
  __typename?: 'ArchiveTariffChainSuccessOutput';
  /** The tariff chain that was archived */
  tariffChain: TariffChainEntity;
};

export type ArchivedUserExistsOutput = {
  __typename?: 'ArchivedUserExistsOutput';
  archivedUserUuid: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ArriveAtStopInput = {
  /** A user entered value for when the driver arrived at the stop> If set to null, the default arrival date is used */
  arrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
  stopUuid: Scalars['String']['input'];
};

/** The expected input to mark a set of stops as arrived */
export type ArriveAtStopsInput = {
  arriveAtStopInputs: Array<ArriveAtStopInput>;
};

export type ArriveAtStopsOutput = ArriveAtStopsSuccessOutput | MutationErrorOutput;

export type ArriveAtStopsSuccessOutput = {
  __typename?: 'ArriveAtStopsSuccessOutput';
  /** The list of stop UUIDs that were successfully marked as arrived */
  arrivedStopUuids: Array<Scalars['String']['output']>;
  /** The list of stop UUIDs that were not marked as arrived */
  failedStopUuids: Array<Scalars['String']['output']>;
};

export type AssignDockDoorInput = {
  doorEventAt?: InputMaybe<Scalars['String']['input']>;
  doorPosition?: InputMaybe<Scalars['Int']['input']>;
  isReturnLeg?: InputMaybe<Scalars['Boolean']['input']>;
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid: Scalars['String']['input'];
};

export type AssignInventoryItemsToStorageUnitInput = {
  itemUuid: Scalars['String']['input'];
  /** The number of inventory items to assign to the specified storage unit */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
  /** The UUID of the storage unit to assign the inventory items */
  uuid: Scalars['String']['input'];
};

export type AssignInventoryItemsToStorageUnitOutput = {
  __typename?: 'AssignInventoryItemsToStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export type AssignLineHaulRouteInput = {
  /** Lets the route replace legs that are planned on manifests that have not left yet. Only the line-haul dispatch board Change route sends it, and only companies on line-haul networks honour it; every other caller keeps the refusal of an order that is already partially dispatched. */
  allowRepathDispatched?: InputMaybe<Scalars['Boolean']['input']>;
  legs: Array<LineHaulRouteLegInput>;
  orderUuid: Scalars['String']['input'];
};

export type AssignLineHaulRouteOutput = {
  __typename?: 'AssignLineHaulRouteOutput';
  laneUuid: Scalars['String']['output'];
  legCount: Scalars['Int']['output'];
  orderUuid: Scalars['String']['output'];
};

export type AssignOrderToTrailerInput = {
  manifestUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
  trailerEquipmentUuid: Scalars['String']['input'];
};

export type AssignOutboundReferenceNumberToStorageUnitsInput = {
  outboundReferenceNumber: Scalars['String']['input'];
  /** The UUIDs of the storage units to assign the outbound reference number to */
  uuids: Array<Scalars['String']['input']>;
};

export type AssignOutboundReferenceNumberToStorageUnitsOutput = {
  __typename?: 'AssignOutboundReferenceNumberToStorageUnitsOutput';
  success: Scalars['Boolean']['output'];
};

export type AssignPackagesToManifestInput = {
  manifestUuid: Scalars['String']['input'];
  packageUuids: Array<Scalars['String']['input']>;
};

export type AttemptsAccessorialCreateInput = {
  name: Scalars['String']['input'];
};

export type AttemptsAccessorialEntity = AccessorialInterface & {
  __typename?: 'AttemptsAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  rate: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type AttemptsAccessorialUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  orderEvent: OrderEventEntity;
  snapshotDifference?: Maybe<AuditLogSnapshotDifference>;
};

export type AuditLogSnapshotDifference = {
  __typename?: 'AuditLogSnapshotDifference';
  inboundStopDifferences?: Maybe<SnapshotStopDifferences>;
  orderDifferences?: Maybe<SnapshotOrderDifferences>;
  outboundStopDifferences?: Maybe<SnapshotStopDifferences>;
};

export type AuditReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  daysPastDue?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  isPastDue?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  reportAggregationPeriod: ReportAggregationPeriod;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuditReportBucketEntity = {
  __typename?: 'AuditReportBucketEntity';
  assigned: Array<Scalars['String']['output']>;
  attempted: Array<Scalars['String']['output']>;
  billingIssues: Array<Scalars['String']['output']>;
  cancelledFinalized: Array<Scalars['String']['output']>;
  cancelledUnfinalized: Array<Scalars['String']['output']>;
  contactUuid?: Maybe<Scalars['String']['output']>;
  daysPastDue?: Maybe<Scalars['Float']['output']>;
  endDate: Scalars['DateTime']['output'];
  noAction: Array<Scalars['String']['output']>;
  noChargeFinalized: Array<Scalars['String']['output']>;
  onHand: Array<Scalars['String']['output']>;
  onHold: Array<Scalars['String']['output']>;
  onInvoicePosted: Array<Scalars['String']['output']>;
  onInvoiceUnposted: Array<Scalars['String']['output']>;
  partiallyComplete: Array<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  unfinalized: Array<Scalars['String']['output']>;
};

export type AutoApplyAccessorialConfigAddressEntity = {
  __typename?: 'AutoApplyAccessorialConfigAddressEntity';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AutoApplyAccessorialConfigAddressInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AutoApplyAccessorialConfigEntity = {
  __typename?: 'AutoApplyAccessorialConfigEntity';
  /** @deprecated Use accessorials instead */
  accessorial: AccessorialUnion;
  accessorials: Array<AccessorialUnion>;
  addresses: Array<AutoApplyAccessorialConfigAddressEntity>;
  contact?: Maybe<ContactEntity>;
  contactsToExcludeFromRule?: Maybe<Array<ContactEntity>>;
  contactsToIncludeWithRule?: Maybe<Array<ContactEntity>>;
  createdAt: Scalars['DateTime']['output'];
  ruleType: AutoApplyAccessorialRuleType;
  service?: Maybe<ServiceEntity>;
  stopType?: Maybe<PickupOrDelivery>;
  tag?: Maybe<TagEntity>;
  tariffZone?: Maybe<TariffZoneEntity>;
  tariffZoneGroup?: Maybe<TariffZoneGroupEntity>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zipCodes: Array<Scalars['String']['output']>;
};

export enum AutoApplyAccessorialRuleType {
  Address = 'ADDRESS',
  Contact = 'CONTACT',
  ContactAndService = 'CONTACT_AND_SERVICE',
  ContactAndServiceAndTag = 'CONTACT_AND_SERVICE_AND_TAG',
  Global = 'GLOBAL',
  IsHazmat = 'IS_HAZMAT',
  IsInBond = 'IS_IN_BOND',
  Residential = 'RESIDENTIAL',
  Service = 'SERVICE',
  ServiceAndTag = 'SERVICE_AND_TAG',
  StopType = 'STOP_TYPE',
  StopTypeAndTerminal = 'STOP_TYPE_AND_TERMINAL',
  TariffZone = 'TARIFF_ZONE',
  TariffZoneGroup = 'TARIFF_ZONE_GROUP',
  ZipCode = 'ZIP_CODE'
}

export type AutoCreateRoutesV2Input = {
  /** Client-generated request UUID. Reuse the same id across retries of a single logical commit so the backend's idempotency cache returns the same summary on every retry. Mint a fresh id for a separate logical action: a new Preview after a Commit, or a fresh commit attempt against a different planning date / criteria override. Only commit submissions ever populate the cache. */
  clientRequestId: Scalars['String']['input'];
  /** Optional per-run criteria override. When null, the persisted RouteAutomationSettings are applied verbatim. */
  criteriaOverride?: InputMaybe<PopulationCriteriaInput>;
  /** When true, runs eligibility + matching + heuristic truck-fit and returns a Preview summary without writing anything. Preview never consults the idempotency cache - every Preview executes fresh against live data, so a Preview submitted after a Commit with the same clientRequestId returns Preview-computed numbers instead of the Commit's cached result. This is intentional so the dispatcher always sees the current eligibility set, not a stale snapshot. The Preview pipeline also skips recurring-order materialization and uses an approximate truck-fit, so Preview totals can diverge from a subsequent Commit; see the AutoRoutingService docstring. */
  dryRun: Scalars['Boolean']['input'];
  /** Calendar day to plan routes for, expressed as an ISO-8601 plain date string (YYYY-MM-DD). Matched against Stop.serviceDateIso8601 or Stop.deadlineTime depending on the settings dueDateSource. */
  planningDate: Scalars['String']['input'];
  /** UUID of the terminal selected on the dispatcher toolbar. Used as the primary terminal for any new Route this call materializes. When null (terminals disabled for this company, or the dispatcher hasn't picked one) the service falls back to the most common terminal among each route's stops. */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type AutoCreateRoutesV2Output = {
  __typename?: 'AutoCreateRoutesV2Output';
  /** True when the run was a dry-run preview (transaction rolled back). False when the run was committed. */
  dryRun: Scalars['Boolean']['output'];
  /** Total number of stops considered eligible by the criteria filter. */
  eligibleStopCount: Scalars['Int']['output'];
  /** Stops that were placed onto a route during this run. */
  matchedStopCount: Scalars['Int']['output'];
  /** True when the response is a replayed cached summary (idempotency key collision). */
  replayed: Scalars['Boolean']['output'];
  routeSummaries: Array<AutoCreateRoutesV2RouteSummary>;
  /** Number of existing auto-created routes that received new appended slots in this run. */
  routesAppended: Scalars['Int']['output'];
  /** Number of new Route rows materialized in this run. */
  routesCreated: Scalars['Int']['output'];
  /** Stops that were eligible but could not be placed. */
  unmatchedStopCount: Scalars['Int']['output'];
  unmatchedStops: Array<AutoCreateRoutesV2UnmatchedStop>;
};

export type AutoCreateRoutesV2RouteSummary = {
  __typename?: 'AutoCreateRoutesV2RouteSummary';
  /** True when this run created the route; false when an existing unlocked auto-created route was appended to. */
  created: Scalars['Boolean']['output'];
  /** Display name of the auto-assigned Equipment. Null when no fit was found or auto-assign is off. */
  equipmentName?: Maybe<Scalars['String']['output']>;
  /** UUID of the Equipment auto-assigned to this route when `autoAssignTrucks` is on and a fit was found. Null otherwise. */
  equipmentUuid?: Maybe<Scalars['String']['output']>;
  /** Name of the route (mirrors RouteName.name). */
  routeName: Scalars['String']['output'];
  /** UUID of the route the slots map to. Null on dry-run summaries when this would be a freshly created route (no row exists yet); always set on commit summaries and on dry-run summaries for appended routes. */
  routeUuid?: Maybe<Scalars['String']['output']>;
  /** Per-stop detail for every stop attached in this run. Ordered by the slot ordinal used when attaching. */
  stops: Array<AutoCreateRoutesV2StopSummary>;
  /** Number of stops attached to this route during this run (newly appended slots). */
  stopsAttached: Scalars['Int']['output'];
  /** Outcome of truck-assignment for this route. Null when the company has `autoAssignTrucks` off. */
  truckFitNote?: Maybe<TruckFitNote>;
};

export type AutoCreateRoutesV2StopSummary = {
  __typename?: 'AutoCreateRoutesV2StopSummary';
  /** Address one-liner ("123 Main St, Brooklyn, NY 11201"). Null only when the stop has no resolved address. */
  addressOneLine?: Maybe<Scalars['String']['output']>;
  /** Customer / billing-party display name. Null when the parent order is unresolved. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** Order display name (HAWB / order number). Null when the stop has no parent Order in any of the four FK roles. */
  orderName?: Maybe<Scalars['String']['output']>;
  /** PICKUP or DELIVERY (null for legacy rows without a type). */
  stopType?: Maybe<StopType>;
  /** UUID of the stop being placed. */
  stopUuid: Scalars['String']['output'];
};

export type AutoCreateRoutesV2UnmatchedStop = {
  __typename?: 'AutoCreateRoutesV2UnmatchedStop';
  /** Address one-liner ("123 Main St, Brooklyn, NY 11201"). Null when the stop has no resolved address. */
  addressOneLine?: Maybe<Scalars['String']['output']>;
  /** Customer / billing-party display name. Null when unresolved. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** Human-readable summary of the matching keys tried for this stop (e.g. "ZIP 46201 / City Indianapolis"). Null for reasons that are not location-based (TARGET_ROUTE_LOCKED, STOP_ALREADY_ON_ROUTE). */
  matchAttempt?: Maybe<Scalars['String']['output']>;
  /** Order display name (HAWB / order number) of the stop. Null when the stop has no parent Order in any of the four FK roles. */
  orderName?: Maybe<Scalars['String']['output']>;
  reason: UnmatchedStopReason;
  /** PICKUP or DELIVERY (null for legacy rows without a type). */
  stopType?: Maybe<StopType>;
  /** UUID of the unmatched stop. */
  stopUuid: Scalars['String']['output'];
};

export type AvailablePeerCompanyEntity = {
  __typename?: 'AvailablePeerCompanyEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type AvailablePieceConnection = {
  __typename?: 'AvailablePieceConnection';
  edges: Array<AvailablePieceEdge>;
  pageInfo: PageInfo;
  /** Total count matching the filter; request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AvailablePieceEdge = {
  __typename?: 'AvailablePieceEdge';
  cursor: Scalars['String']['output'];
  node: AvailablePieceEntity;
};

export type AvailablePieceEntity = {
  __typename?: 'AvailablePieceEntity';
  additionalReferenceNumbers: Array<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  damagedNote?: Maybe<Scalars['String']['output']>;
  daysOverDwellThreshold?: Maybe<Scalars['Int']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  departedAt?: Maybe<Scalars['DateTime']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  discardedAt?: Maybe<Scalars['DateTime']['output']>;
  discardedByName?: Maybe<Scalars['String']['output']>;
  discardedReason?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  dwellStatus?: Maybe<DwellStatus>;
  effectiveDwellThresholdDays?: Maybe<Scalars['Int']['output']>;
  eta?: Maybe<Scalars['DateTime']['output']>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  isUnalertedFreight: Scalars['Boolean']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  mawb?: Maybe<Scalars['String']['output']>;
  measurementUnits?: Maybe<MeasurementUnits>;
  orderName?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  packageOrderName?: Maybe<Scalars['String']['output']>;
  packageOrderUuid?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['String']['output']>;
  packedPieceCount: Scalars['Int']['output'];
  podSignedBy?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  status: PieceStatus;
  terminalName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  totalPieces?: Maybe<Scalars['Int']['output']>;
  truckName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PackageType>;
  uuid: Scalars['String']['output'];
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
  warehouseLocationUuid?: Maybe<Scalars['String']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
  warehouseUuid?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<WeightUnits>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type AvailableSchedulingSlotEntity = {
  __typename?: 'AvailableSchedulingSlotEntity';
  /** Last moment this slot may still be taken, already walked back onto an operating day. */
  bookBy: Scalars['DateTime']['output'];
  /** When the slot ends. Later than midnight of the service day when the resource window crosses it. */
  endsAt: Scalars['DateTime']['output'];
  /** Pieces left on the day, or null when unlimited. */
  remainingPieces?: Maybe<Scalars['Int']['output']>;
  /** Stops left on the day across every booking, or null when the resource has no stop limit. Can read negative if a capacity was lowered below what is already booked. */
  remainingStops?: Maybe<Scalars['Int']['output']>;
  /** Weight left on the day, or null when unlimited. */
  remainingWeight?: Maybe<Scalars['Mass']['output']>;
  schedulingResourceId: Scalars['String']['output'];
  /** The resource offering the slot. Internal fleet label: several resources may cover one area on one weekday, and the name is the only thing distinguishing them. */
  schedulingResourceName: Scalars['String']['output'];
  /** The calendar day the resource window OPENS, as YYYY-MM-DD in the resource time zone. This is the day a capacity reservation for this slot must be dated by, and on an overnight resource it is NOT always the wall-clock day of startsAt. */
  serviceDateIso8601: Scalars['String']['output'];
  /** When the slot begins. */
  startsAt: Scalars['DateTime']['output'];
  /** Canonical IANA region zone startsAt and endsAt are meant to be read in. It is the RESOURCE time zone, which is not always the company one. */
  timeZone: Scalars['String']['output'];
};

/** The average days to pay report values for a contact */
export type AverageDaysToPayForContactEntity = {
  __typename?: 'AverageDaysToPayForContactEntity';
  averageDaysToPay90: Scalars['Float']['output'];
  averageDaysToPay180: Scalars['Float']['output'];
  averageDaysToPay270: Scalars['Float']['output'];
  averageDaysToPay360: Scalars['Float']['output'];
  averageDaysToPay720: Scalars['Float']['output'];
  averageDaysToPayAll: Scalars['Float']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

export type BackfillOrderTotalResult = {
  __typename?: 'BackfillOrderTotalResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
};

export type BackfillOrderTotalsOutput = {
  __typename?: 'BackfillOrderTotalsOutput';
  results: Array<BackfillOrderTotalResult>;
};

export type BatchAddShipmentsToInvoicePreview = {
  __typename?: 'BatchAddShipmentsToInvoicePreview';
  billingCycleDuration: BillingCycleDuration;
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  existingInvoiceAdds: Array<InvoiceAdd>;
  newInvoiceAdds: Array<InvoiceAdd>;
};

export type BatchAddShipmentsToInvoicesInput = {
  addToExistingInvoices: Scalars['Boolean']['input'];
  contactUuid: Scalars['String']['input'];
  /** @deprecated Backend will determine this value */
  invoiceTimePeriodSplit?: InputMaybe<TimePeriod>;
  /** @deprecated Backend will determine this value */
  numberOfOrdersPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  numberOfShipmentsPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  shipmentUuids: Array<Scalars['String']['input']>;
};

export type BatchAddShipmentsToInvoicesInputMultiple = {
  batchAddShipmentsToInvoicesInputs: Array<BatchAddShipmentsToInvoicesInput>;
};

export type BenchCompanyActorInput = {
  companyUuid: Scalars['String']['input'];
  /** A user of that company. Services that record a user of the order's company (markAsReceivedAtOrigin) act as this user. */
  userUuid: Scalars['String']['input'];
};

export type BenchCompanyUserOptionEntity = {
  __typename?: 'BenchCompanyUserOptionEntity';
  /** The name, or the email when unnamed. */
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type BenchCreatedOrdersEntity = {
  __typename?: 'BenchCreatedOrdersEntity';
  /** Why the call stopped before creating every order. The call stops at the first tender the inbound handler does not turn into a new order. */
  failure?: Maybe<Scalars['String']['output']>;
  /** The rated order whose shipper and consignee addresses and packages the tenders copied. Null when the bench found none and used its fixed addresses. */
  laneSourceOrderName?: Maybe<Scalars['String']['output']>;
  /** The orders the call created, in the order it created them. */
  orders: Array<BenchOrderOptionEntity>;
  /** The service names the created orders received. The inbound handler prefers a contact or company default service over the picked code. */
  receivedServiceNames: Array<Scalars['String']['output']>;
  /** What creating an order for this company and contact reaches besides Tenedi. Production refuses creation when any is listed. */
  sideEffects: Array<BenchSideEffectEntity>;
  /** Set when no order of the billing contact rated above $0, so the tenders used fixed addresses and may rate at $0, or when the orders got a service other than the picked service level. */
  warning?: Maybe<Scalars['String']['output']>;
};

export type BenchDriverOptionEntity = {
  __typename?: 'BenchDriverOptionEntity';
  /** The name, or the email when unnamed. */
  displayName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type BenchEdiPayloadEntity = {
  __typename?: 'BenchEdiPayloadEntity';
  /** True when the row's message records Tenedi's acceptance. */
  deliveredThroughTenedi: Scalars['Boolean']['output'];
  /** What the two payloads are and what the bench rebuilt. */
  note: Scalars['String']['output'];
  /** The body the TMS posted to Tenedi, rebuilt with the envelope the delivery adds. Null when nothing went out. */
  sentBody?: Maybe<Scalars['String']['output']>;
  /** The Tenedi path the TMS posted to. Null when nothing went out. */
  sentPath?: Maybe<Scalars['String']['output']>;
  /** edi_transactions.payload, pretty-printed: the body before the Tenedi envelope. */
  storedPayload: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type BenchEdiTransactionEntity = {
  __typename?: 'BenchEdiTransactionEntity';
  createdAt: Scalars['DateTime']['output'];
  edi214ShipmentStatus?: Maybe<Edi214ShipmentStatus>;
  edi990ActionCode?: Maybe<Edi990ActionCode>;
  message?: Maybe<Scalars['String']['output']>;
  receiverIsaId: Scalars['String']['output'];
  status: EdiTransactionStatus;
  tenediMessageId?: Maybe<Scalars['String']['output']>;
  tenediRunIds: Array<Scalars['String']['output']>;
  /** 990, 214 or 210. */
  transactionSet: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type BenchFireResultEntity = {
  __typename?: 'BenchFireResultEntity';
  ediTransactions: Array<BenchEdiTransactionEntity>;
  message: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  outcome: BenchStepOutcome;
  sideEffects: Array<BenchSideEffectEntity>;
};

export enum BenchFireTransactionSet {
  Edi_210 = 'EDI_210',
  Edi_214 = 'EDI_214',
  Edi_990 = 'EDI_990'
}

export enum BenchIntegrationType {
  Tenedi = 'TENEDI'
}

export type BenchOrderOptionEntity = {
  __typename?: 'BenchOrderOptionEntity';
  createdAt: Scalars['DateTime']['output'];
  /** standard_order_fields.shipper_bill_of_lading_number. */
  hawb?: Maybe<Scalars['String']['output']>;
  /** standard_order_fields.master_airway_bill_of_lading_number. */
  mawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: OrderStatus;
  uuid: Scalars['String']['output'];
};

export type BenchOrderReportEntity = {
  __typename?: 'BenchOrderReportEntity';
  billingContactName?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  ediTransactions: Array<BenchEdiTransactionEntity>;
  hawb?: Maybe<Scalars['String']['output']>;
  lastResult?: Maybe<BenchStepResultEntity>;
  nextStep?: Maybe<BenchPlannedStepEntity>;
  orderName?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  /** Why the bench will not touch this order in any environment. Empty when it may run. */
  refusals: Array<Scalars['String']['output']>;
  steps: Array<BenchPlannedStepEntity>;
};

/** Which orders a run covers. Explicit orderUuids win; otherwise the company and contact filters pick orders whose billing contact has a TENEDI partnership, newest first. */
export type BenchOrderSelectionInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BenchPartnershipOptionEntity = {
  __typename?: 'BenchPartnershipOptionEntity';
  autoAcceptOrders: Scalars['Boolean']['output'];
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  edi214ShipmentStatuses: Array<Edi214ShipmentStatus>;
  receiverIsaId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type BenchPlannedStepEntity = {
  __typename?: 'BenchPlannedStepEntity';
  expected214Statuses: Array<Edi214ShipmentStatus>;
  expects210: Scalars['Boolean']['output'];
  expects990: Scalars['Boolean']['output'];
  kind: BenchStepKind;
  manifestUuid?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  /** True when a side effect with no suppression option makes the bench refuse this step in production. */
  refusedInProduction: Scalars['Boolean']['output'];
  sideEffects: Array<BenchSideEffectEntity>;
  state: BenchStepState;
  stopRole?: Maybe<BenchStopRole>;
  stopUuid?: Maybe<Scalars['String']['output']>;
};

export type BenchRunReportEntity = {
  __typename?: 'BenchRunReportEntity';
  environment: Scalars['String']['output'];
  integrationType: BenchIntegrationType;
  orders: Array<BenchOrderReportEntity>;
  production: Scalars['Boolean']['output'];
};

/** A service level code mapped on the partnership; the only codes the EDI inbound handler resolves to a service. */
export type BenchServiceLevelOptionEntity = {
  __typename?: 'BenchServiceLevelOptionEntity';
  code: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
};

export type BenchSideEffectEntity = {
  __typename?: 'BenchSideEffectEntity';
  detail: Scalars['String']['output'];
  kind: BenchSideEffectKind;
  /** The service option the bench passes in production to stop it. */
  suppressedBy?: Maybe<Scalars['String']['output']>;
};

export enum BenchSideEffectKind {
  ApiUserWebhook = 'API_USER_WEBHOOK',
  ContactEmail = 'CONTACT_EMAIL',
  EfmStatus = 'EFM_STATUS',
  ExpeditorsStatus = 'EXPEDITORS_STATUS',
  OrderDelegation = 'ORDER_DELEGATION',
  OrderEventNotification = 'ORDER_EVENT_NOTIFICATION',
  OrderMirror = 'ORDER_MIRROR',
  OrderPostCreationHook = 'ORDER_POST_CREATION_HOOK',
  SettlementLines = 'SETTLEMENT_LINES',
  SftpPodUpload = 'SFTP_POD_UPLOAD',
  ShipmentSubscriberMessage = 'SHIPMENT_SUBSCRIBER_MESSAGE',
  UnverifiedSideEffects = 'UNVERIFIED_SIDE_EFFECTS'
}

export enum BenchStepKind {
  AcceptTender = 'ACCEPT_TENDER',
  AddToInvoice = 'ADD_TO_INVOICE',
  ArriveAtStop = 'ARRIVE_AT_STOP',
  CompleteStop = 'COMPLETE_STOP',
  ConfirmAppointment = 'CONFIRM_APPOINTMENT',
  DispatchStop = 'DISPATCH_STOP',
  FinalizeOrder = 'FINALIZE_ORDER',
  LineHaulArrive = 'LINE_HAUL_ARRIVE',
  LineHaulDepart = 'LINE_HAUL_DEPART',
  MarkOnHand = 'MARK_ON_HAND',
  PostInvoice = 'POST_INVOICE',
  ReceivedAtOrigin = 'RECEIVED_AT_ORIGIN',
  RouteStop = 'ROUTE_STOP',
  Send_210 = 'SEND_210',
  StartRoute = 'START_ROUTE'
}

export enum BenchStepOutcome {
  Blocked = 'BLOCKED',
  Executed = 'EXECUTED',
  Failed = 'FAILED',
  LifecycleComplete = 'LIFECYCLE_COMPLETE',
  Refused = 'REFUSED',
  Waiting = 'WAITING'
}

export type BenchStepResultEntity = {
  __typename?: 'BenchStepResultEntity';
  kind?: Maybe<BenchStepKind>;
  message: Scalars['String']['output'];
  outcome: BenchStepOutcome;
  startedAt: Scalars['DateTime']['output'];
  stopRole?: Maybe<BenchStopRole>;
};

/** One lifecycle step: its kind, and the stop role for a stop step. Leave the role empty for an order-level step. */
export type BenchStepSelectorInput = {
  kind: BenchStepKind;
  stopRole?: InputMaybe<BenchStopRole>;
};

export enum BenchStepState {
  Blocked = 'BLOCKED',
  Done = 'DONE',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export enum BenchStopRole {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export enum BenchTenderShape {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  PickupAndDelivery = 'PICKUP_AND_DELIVERY'
}

export enum BillingCycleDuration {
  Biweekly = 'BIWEEKLY',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Other = 'OTHER',
  Weekly = 'WEEKLY'
}

export enum BillingCycleType {
  AdHoc = 'AD_HOC',
  EveryFriday = 'EVERY_FRIDAY',
  EveryMonday = 'EVERY_MONDAY',
  EverySaturday = 'EVERY_SATURDAY',
  EverySunday = 'EVERY_SUNDAY',
  EveryThursday = 'EVERY_THURSDAY',
  EveryTuesday = 'EVERY_TUESDAY',
  EveryWednesday = 'EVERY_WEDNESDAY',
  EveryXDays = 'EVERY_X_DAYS'
}

export enum BillingShipmentStatus {
  Finalized = 'FINALIZED',
  HasIssue = 'HAS_ISSUE',
  Invoiced = 'INVOICED',
  Paid = 'PAID'
}

export type BlacklistStatsOutput = {
  __typename?: 'BlacklistStatsOutput';
  activeBlacklisted: Scalars['Int']['output'];
  expiredButNotCleaned: Scalars['Int']['output'];
  totalBlacklisted: Scalars['Int']['output'];
  userRevocations: Scalars['Int']['output'];
};

export type BlockCompanySchedulingDayInput = {
  /** Closes the day even though unreleased capacity claims sit on it. Without it, a day carrying claims writes NOTHING and answers with CompanySchedulingDayLiveClaimsOutput naming the resources and the claim total, so a client can show what is about to be closed over before asking again. A day carrying no claims is closed without it. Closing never cancels those claims either way: they stay on the day and still need releasing or rescheduling. Ignored on a day that is already closed, since re-stating a closure changes nothing about the freight on it. */
  confirmLiveClaims?: InputMaybe<Scalars['Boolean']['input']>;
  /** Calendar day to close for the whole company, as an ISO-8601 plain date (YYYY-MM-DD). Read in each resource own time zone, so a company closed on a date is closed on the day each of its resources calls that date. */
  dateIso8601: Scalars['String']['input'];
  /** Why the company is closed. Closing a day that is already closed replaces this and keeps the exemptions already granted. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type BlockSchedulingResourceDayInput = {
  /** Blocks the day even though unreleased capacity claims sit on it. Without it, a day carrying claims is refused with SchedulingResourceLiveClaimsOutput naming how many, so a client can show what is being closed over before asking again. Blocking never cancels those claims either way. Ignored on a day that is already blocked, since re-stating a block changes nothing about the freight on it. */
  confirmLiveClaims?: InputMaybe<Scalars['Boolean']['input']>;
  /** Calendar day to block, as an ISO-8601 plain date (YYYY-MM-DD). */
  dateIso8601: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  schedulingResourceId: Scalars['String']['input'];
};

export type BookCustomerAppointmentInput = {
  /** Access instructions for the driver -- gate codes, dock numbers, where to ring. Plain text, at most 500 characters. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The service day of the chosen window, as YYYY-MM-DD, exactly as the slot reported it. */
  serviceDateIso8601: Scalars['String']['input'];
  /** Start of the chosen window, exactly as the slot reported it. Matched against the live offer rather than trusted: a start that is no longer offered is refused, whatever the client sends. */
  startsAt: Scalars['DateTime']['input'];
  token: Scalars['String']['input'];
};

export type BookCustomerAppointmentOutput = BookCustomerAppointmentRefusedOutput | BookCustomerAppointmentSuccessOutput | MutationErrorOutput;

/** Why a customer booking or reschedule was refused. */
export enum BookCustomerAppointmentRefusalReason {
  AlreadyRouted = 'ALREADY_ROUTED',
  AlreadyScheduled = 'ALREADY_SCHEDULED',
  AwaitingOnHand = 'AWAITING_ON_HAND',
  NotBookable = 'NOT_BOOKABLE',
  PastChangeCutoff = 'PAST_CHANGE_CUTOFF',
  RescheduleLimitReached = 'RESCHEDULE_LIMIT_REACHED',
  SlotUnavailable = 'SLOT_UNAVAILABLE'
}

export type BookCustomerAppointmentRefusedOutput = {
  __typename?: 'BookCustomerAppointmentRefusedOutput';
  alternativeSlots: Array<CustomerAppointmentSlotEntity>;
  message: Scalars['String']['output'];
  reason: BookCustomerAppointmentRefusalReason;
};

export type BookCustomerAppointmentSuccessOutput = {
  __typename?: 'BookCustomerAppointmentSuccessOutput';
  bookedAppointment: CustomerBookedAppointmentEntity;
  /** Whether the customer may still move this appointment themselves. False once the single self-service reschedule is spent. */
  canReschedule: Scalars['Boolean']['output'];
  /** Confirmation copy to show the customer. */
  message: Scalars['String']['output'];
};

/** How the booked-stops view decided which resource a stop is on. */
export enum BookedStopAttribution {
  /** No claim; more than one resource could serve the stop. candidateResources lists them. */
  Ambiguous = 'AMBIGUOUS',
  /** The stop holds a live capacity claim, and the claimed resource decides. */
  Booking = 'BOOKING',
  /** No claim; exactly one resource covers the address, accepts the order and runs during the appointment. */
  Matched = 'MATCHED',
  /** No claim, and no resource could serve the stop. */
  None = 'NONE'
}

export type BookedStopEntity = {
  __typename?: 'BookedStopEntity';
  addressLine1: Scalars['String']['output'];
  appointmentTime: Scalars['DateTime']['output'];
  attribution: BookedStopAttribution;
  /** Every resource that could serve the stop, when attribution is AMBIGUOUS. Empty otherwise. */
  candidateResources: Array<BookedStopResourceEntity>;
  city: Scalars['String']['output'];
  /** The billing party. */
  customerName: Scalars['String']['output'];
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  houseAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the stop is already on a route. */
  isRouted: Scalars['Boolean']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  routeName?: Maybe<Scalars['String']['output']>;
  routeUuid?: Maybe<Scalars['String']['output']>;
  stopUuid: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type BookedStopGroupEntity = {
  __typename?: 'BookedStopGroupEntity';
  /** Every stop in the group. */
  bookedCount: Scalars['Int']['output'];
  /** Stops placed by a live ledger claim on the day (attribution BOOKING), which is what a customer booking leaves. Always 0 for AMBIGUOUS and NO_RESOURCE. */
  customerBookedCount: Scalars['Int']['output'];
  /** The resource's day uses more than its capacity on some axis, counting live booking claims and the appointments dispatchers set by hand that are attributed to this resource alone. Company-wide, whatever terminal the view is narrowed to. A live claim left on this day by a stop since moved to another day still counts here, even though the stop is listed under its new day. Always false for AMBIGUOUS and NO_RESOURCE. */
  isOverCapacity: Scalars['Boolean']['output'];
  kind: BookedStopGroupKind;
  routedCount: Scalars['Int']['output'];
  /** The resource, for a RESOURCE group. Null for the other two. */
  schedulingResource?: Maybe<BookedStopResourceEntity>;
  stops: Array<BookedStopEntity>;
};

/** What a booked-stops group collects. */
export enum BookedStopGroupKind {
  Ambiguous = 'AMBIGUOUS',
  NoResource = 'NO_RESOURCE',
  Resource = 'RESOURCE'
}

export type BookedStopResourceEntity = {
  __typename?: 'BookedStopResourceEntity';
  /** When the resource window closes, read in timeZone. Earlier than start when the window crosses midnight. */
  end: PlainTime;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** When the resource window opens, read in timeZone. */
  start: PlainTime;
  timeZone: Scalars['String']['output'];
};

export type BookedStopsByResourceOutput = {
  __typename?: 'BookedStopsByResourceOutput';
  /** One group per resource with stops on the day, ordered by when its window opens, then AMBIGUOUS, then NO_RESOURCE. Empty groups are omitted. */
  groups: Array<BookedStopGroupEntity>;
  /** More resources run on this weekday than attribution weighs, so a stop under AMBIGUOUS or NO_RESOURCE may belong to one that was not read. */
  isResourceSetTruncated: Scalars['Boolean']['output'];
  /** The day holds more appointment stops than the view reads, so some are missing from every group. */
  isTruncated: Scalars['Boolean']['output'];
  serviceDateIso8601: Scalars['String']['output'];
};

/** Represents the difference between 2 versions of a boolean field. Used in audit log entries */
export type BooleanFieldDifference = {
  __typename?: 'BooleanFieldDifference';
  newValue?: Maybe<Scalars['Boolean']['output']>;
  oldValue?: Maybe<Scalars['Boolean']['output']>;
};

export type BooleanFilter = {
  filterOperator?: InputMaybe<FilterOperator>;
  value: Scalars['Boolean']['input'];
};

/** A filter object that is used to filter a boolean field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type BooleanFilterV2 = {
  /** Filters for records where the relevant boolean field is equal to the provided boolean value */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant boolean field is not equal to the provided boolean value */
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkAccessorialUpdateInput = {
  accessorialToMappingInputs: Array<AccessorialToMappingInput>;
};

export type BulkActionEntityResults = {
  __typename?: 'BulkActionEntityResults';
  /** Number of entities that were eligible for the action */
  eligible: Scalars['Int']['output'];
  /** UUIDs of entities that are eligible for the action */
  eligibleItems: Array<Scalars['String']['output']>;
  /** Number of entities that failed during processing */
  failed: Scalars['Int']['output'];
  /** Details of failed items with error messages */
  failedItems: Array<BulkActionItemResult>;
  /** Number of entities that were ineligible for the action */
  ineligible: Scalars['Int']['output'];
  /** Details of ineligible items with reasons */
  ineligibleItems: Array<BulkActionItemResult>;
  /** Number of entities that were successfully processed */
  succeeded: Scalars['Int']['output'];
  /** Total number of entities submitted for the action */
  total: Scalars['Int']['output'];
};

export type BulkActionItemResult = {
  __typename?: 'BulkActionItemResult';
  reason: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type BulkChangeCallStatusArgs = {
  callStatus: AppointmentCallStatus;
  uuids: Array<Scalars['String']['input']>;
};

export type BulkConfirmAppointmentsArgs = {
  uuids: Array<Scalars['String']['input']>;
};

export type BulkCsvRouteNameInput = {
  csvRouteNameInputs: Array<CsvRouteNameInput>;
};

export type BulkDelegateOrdersInput = {
  /** Free-text note to the executing company, at most 500 chars. */
  offerNote?: InputMaybe<Scalars['String']['input']>;
  /** Orders to delegate in full to the peer, at most 400. */
  orderUuids: Array<Scalars['String']['input']>;
  /** Organization peer (originator-side row) to delegate to. */
  peerUuid: Scalars['String']['input'];
};

export type BulkDelegationBatchEntity = {
  __typename?: 'BulkDelegationBatchEntity';
  failed: Scalars['Int']['output'];
  /** True once no order is pending. */
  isComplete: Scalars['Boolean']['output'];
  /** In the order the user selected the orders. */
  items: Array<BulkDelegationItemEntity>;
  offered: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type BulkDelegationItemEntity = {
  __typename?: 'BulkDelegationItemEntity';
  orderUuid: Scalars['String']['output'];
  /** Why the order was not offered; set only when FAILED. */
  reason?: Maybe<Scalars['String']['output']>;
  status: BulkDelegationItemStatus;
};

/** Where one order of a bulk delegation stands: offered to the partner, still queued or retrying, or refused. */
export enum BulkDelegationItemStatus {
  Failed = 'FAILED',
  Offered = 'OFFERED',
  Pending = 'PENDING'
}

export type BulkDeletePiecesInput = {
  pieceUuids: Array<Scalars['String']['input']>;
};

export type BulkDiscardPiecesInput = {
  pieceUuids: Array<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type BulkEditOrdersInput = {
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  /** Array of documents to upload. Each document will be attached to all eligible orders. Supports uploading multiple documents with different document types in a single bulk operation. */
  documents?: InputMaybe<Array<BulkUploadDocumentInput>>;
  /** Driver UUID for ASSIGN_TO_DRIVER action */
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  /** Multiple order actions to execute */
  orderActions?: InputMaybe<Array<OrderAction>>;
  orderUuids: Array<Scalars['String']['input']>;
  orderUuidsForAction: Array<Scalars['String']['input']>;
  osdReason?: InputMaybe<Scalars['String']['input']>;
  piecesOnHand?: InputMaybe<Scalars['Float']['input']>;
  podName?: InputMaybe<Scalars['String']['input']>;
  referenceNumbersToAdd?: InputMaybe<Array<Scalars['String']['input']>>;
  refusedBy?: InputMaybe<Scalars['String']['input']>;
  /** Why the consignee refused the orders, for MARK_AS_REFUSED */
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  /** The structured refusal reason for MARK_AS_REFUSED, for outbound EDI */
  refusedReasonCode?: InputMaybe<OrderRefusalReason>;
  secondaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 format. This is used to update the service date for the orders. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  shipmentUuids: Array<Scalars['String']['input']>;
  /** Multiple stop actions to execute */
  stopActions?: InputMaybe<Array<StopAction>>;
  /** @deprecated Not used in the backend. Only used in the frontend to derive the stop uuids to update. */
  stopTypes?: InputMaybe<Array<PickupOrDelivery>>;
  stopUuidsForAction: Array<Scalars['String']['input']>;
  stopUuidsForServiceDate?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type BulkEditOrdersResponse = {
  __typename?: 'BulkEditOrdersResponse';
  /** Results for deadline date field updates */
  deadlineDateUpdate?: Maybe<BulkActionEntityResults>;
  /** Results for deadline type field updates */
  deadlineTypeUpdate?: Maybe<BulkActionEntityResults>;
  /** Results for Master Airway Bill (MAWB) field updates */
  mawbUpdate?: Maybe<BulkActionEntityResults>;
  /** Per-action results for order state actions */
  orderStateActions?: Maybe<Array<OrderActionResult>>;
  /** Results for secondary reference number field updates */
  secondaryRefNumberUpdate?: Maybe<BulkActionEntityResults>;
  /** Results for service date field updates */
  serviceDateUpdate?: Maybe<BulkActionEntityResults>;
  /** Per-action results for stop state actions */
  stopStateActions?: Maybe<Array<StopActionResult>>;
  /** Whether the overall operation completed without errors */
  success: Scalars['Boolean']['output'];
  /** Results for warehouse field updates */
  warehouseUpdate?: Maybe<BulkActionEntityResults>;
};

export type BulkInventoryCountResultOutput = {
  __typename?: 'BulkInventoryCountResultOutput';
  /** Number of confirmations that failed. */
  failureCount: Scalars['Int']['output'];
  /** Per-piece failure details (UUID + reason). Empty when the whole batch succeeded. */
  failures: Array<BulkActionItemResult>;
  /** Number of confirmations applied successfully. */
  successCount: Scalars['Int']['output'];
};

export type BulkPiecesActionOutput = {
  __typename?: 'BulkPiecesActionOutput';
  /** Number of pieces the action failed on. */
  failureCount: Scalars['Int']['output'];
  /** Per-piece failure details (UUID + reason). Empty when the whole batch succeeded. */
  failures: Array<BulkActionItemResult>;
  /** Number of pieces the action completed successfully. */
  successCount: Scalars['Int']['output'];
};

export type BulkRestorePiecesInput = {
  pieceUuids: Array<Scalars['String']['input']>;
};

export type BulkUnconfirmAppointmentsArgs = {
  uuids: Array<Scalars['String']['input']>;
};

export type BulkUpdateContactMapping = {
  /** The column name in the CSV file that corresponds to the field name in the import contact schema */
  columnName: Scalars['String']['input'];
  /** The field in the import contact schema that corresponds to the column name in the CSV file */
  field: ImportContactField;
};

export type BulkUploadDocumentInput = {
  /** The document type classification */
  documentType: DocumentType;
  /** The original file name */
  fileName: Scalars['String']['input'];
  /** The MIME type of the file */
  fileType: Scalars['String']['input'];
  /** The S3 key for the uploaded document */
  s3Key: Scalars['String']['input'];
};

export type BusinessDivisionEntity = {
  __typename?: 'BusinessDivisionEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type BusinessKpiSetEntity = {
  __typename?: 'BusinessKpiSetEntity';
  avgDaysToInvoice?: Maybe<Scalars['Float']['output']>;
  avgDaysToPayment?: Maybe<Scalars['Float']['output']>;
  driverCount?: Maybe<Scalars['Int']['output']>;
  invoicedOrderCount?: Maybe<Scalars['Int']['output']>;
  orderCount?: Maybe<Scalars['Int']['output']>;
  ordersPerDriver?: Maybe<Scalars['Float']['output']>;
  paidInvoiceCount?: Maybe<Scalars['Int']['output']>;
  revenueCents?: Maybe<Scalars['Float']['output']>;
  unassignedLineHaulCents?: Maybe<Scalars['Float']['output']>;
  unassignedNoTerminalCents?: Maybe<Scalars['Float']['output']>;
};

export type BusinessKpisEntity = {
  __typename?: 'BusinessKpisEntity';
  current: BusinessKpiSetEntity;
  lastYear: BusinessKpiSetEntity;
};

export type CachedStopBaseEntity = {
  __typename?: 'CachedStopBaseEntity';
  address?: Maybe<AddressForCachedStop>;
  appointmentDateTime?: Maybe<Scalars['DateTime']['output']>;
  appointmentRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the appointment has been confirmed either by the contact person or manually */
  appointmentScheduled?: Maybe<Scalars['Boolean']['output']>;
  /** The latest time the contact person was called with a prompt to select an appointment time */
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The latest time the contact person was texted with a prompt to select an appointment time */
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadlineDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  hasPreviousAttempt?: Maybe<Scalars['Boolean']['output']>;
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  serviceUuid?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  status: StopStatus;
  stopIntention?: Maybe<StopIntention>;
  stopType?: Maybe<StopType>;
  terminalName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  totalCharge?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type CachedStopConnection = {
  __typename?: 'CachedStopConnection';
  edges: Array<CachedStopEdge>;
  /** The requested page of group rows when `groupBy` asks for a level that is not yet expanded; null otherwise. */
  groupRows?: Maybe<Array<StopTableGroupRowEntity>>;
  /** Whether the level holds more group rows after this page. Null unless `groupRows` is set. */
  groupRowsHasMore?: Maybe<Scalars['Boolean']['output']>;
  pageInfo: PageInfo;
  /** If includeRecurringRunHeaders is true, this is set to the number of recurring runs present among the filtered stops before applying the limit. */
  recurringRunsCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of stops and, if includeRecurringRunHeaders is true, also the number of recurring runs. Not cheap to calculate, request with prudence. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CachedStopEdge = {
  __typename?: 'CachedStopEdge';
  cursor: Scalars['String']['output'];
  node: StopsListElement;
};

export type CachedStopEntity = {
  __typename?: 'CachedStopEntity';
  linkedEndStop?: Maybe<CachedStopBaseEntity>;
  order?: Maybe<OrderForCachedStop>;
  otherStop?: Maybe<CachedStopBaseEntity>;
  recurringRunUuid?: Maybe<Scalars['String']['output']>;
  stop: CachedStopBaseEntity;
  stopDetails?: Maybe<StopDetailsOutput>;
};

export type CallStopsInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type CalmCrossdockInstructionEntity = {
  __typename?: 'CalmCrossdockInstructionEntity';
  instruction: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
};

export type CalmFreightElsewhereEntity = {
  __typename?: 'CalmFreightElsewhereEntity';
  departed: Scalars['Int']['output'];
  loaded: Scalars['Int']['output'];
  onHand: Scalars['Int']['output'];
  terminalCode: Scalars['String']['output'];
};

export type CalmHawbSearchResultEntity = {
  __typename?: 'CalmHawbSearchResultEntity';
  hasMore: Scalars['Boolean']['output'];
  matches: Array<CalmOrderHawbMatchEntity>;
};

/** Where a shipment on a departing run comes from: originates here, rides through on the same truck, or cross-docks in from another truck. */
export enum CalmInboundSource {
  Origin = 'ORIGIN',
  Through = 'THROUGH',
  Xdock = 'XDOCK'
}

export type CalmLiveRunEntity = {
  __typename?: 'CalmLiveRunEntity';
  departedAt?: Maybe<Scalars['String']['output']>;
  dest: Scalars['String']['output'];
  driverName: Scalars['String']['output'];
  orig: Scalars['String']['output'];
  ref: Scalars['String']['output'];
  ships: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type CalmLoadOrdersInput = {
  manifestUuid: Scalars['String']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type CalmLoadPackageEntity = {
  __typename?: 'CalmLoadPackageEntity';
  awaitingInboundRef?: Maybe<Scalars['String']['output']>;
  cubeFt3: Scalars['Float']['output'];
  customer?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  destCode?: Maybe<Scalars['String']['output']>;
  elsewhere?: Maybe<CalmFreightElsewhereEntity>;
  expectedOnHandAt?: Maybe<Scalars['String']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  hazmat: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  inboundServiceDate?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  manifestUuid: Scalars['String']['output'];
  mawb?: Maybe<Scalars['String']['output']>;
  movement?: Maybe<StopType>;
  onHand: Scalars['Boolean']['output'];
  orderName: Scalars['String']['output'];
  orderUuid?: Maybe<Scalars['String']['output']>;
  originCode?: Maybe<Scalars['String']['output']>;
  outboundServiceDate?: Maybe<Scalars['String']['output']>;
  packageUuid: Scalars['String']['output'];
  pieces: Scalars['Int']['output'];
  piecesAtDestination: Scalars['Int']['output'];
  piecesDeparted: Scalars['Int']['output'];
  piecesLoaded: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
  unitDimensions: Array<CalmUnitDimensionsEntity>;
  warehouse?: Maybe<Scalars['String']['output']>;
  warehouseLocation?: Maybe<Scalars['String']['output']>;
  weightLbs?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type CalmLoadPlacementEntity = {
  __typename?: 'CalmLoadPlacementEntity';
  h: Scalars['Float']['output'];
  l: Scalars['Float']['output'];
  manifestUuid: Scalars['String']['output'];
  packageUuid: Scalars['String']['output'];
  pieceUuid?: Maybe<Scalars['String']['output']>;
  rotated: Scalars['Boolean']['output'];
  trailerEquipmentUuid?: Maybe<Scalars['String']['output']>;
  unitIndex: Scalars['Int']['output'];
  w: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

export type CalmManifestReadinessEntity = {
  __typename?: 'CalmManifestReadinessEntity';
  cubeOnHand: Scalars['Float']['output'];
  cubeTotal: Scalars['Float']['output'];
  manifestUuid: Scalars['String']['output'];
  orders: Scalars['Int']['output'];
  ordersNotOnHand: Scalars['Int']['output'];
  piecesAtDestination: Scalars['Int']['output'];
  piecesDeparted: Scalars['Int']['output'];
  piecesLoaded: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
  piecesTotal: Scalars['Int']['output'];
  weightOnHand: Scalars['Float']['output'];
  weightTotal: Scalars['Float']['output'];
};

export type CalmManifestSearchResultEntity = {
  __typename?: 'CalmManifestSearchResultEntity';
  departDate: Scalars['String']['output'];
  dest: Scalars['String']['output'];
  orig: Scalars['String']['output'];
  ref: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CalmOnHandPieceEntity = {
  __typename?: 'CalmOnHandPieceEntity';
  customer?: Maybe<Scalars['String']['output']>;
  destCode?: Maybe<Scalars['String']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  inboundServiceDate?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationUuid?: Maybe<Scalars['String']['output']>;
  markedOnHandAt?: Maybe<Scalars['String']['output']>;
  orderRef?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  outboundServiceDate?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['String']['output']>;
  pieceRef?: Maybe<Scalars['String']['output']>;
  pieceUuid: Scalars['String']['output'];
  warehouseName?: Maybe<Scalars['String']['output']>;
  warehouseUuid?: Maybe<Scalars['String']['output']>;
  weightLbs?: Maybe<Scalars['Float']['output']>;
};

/** Whether a shipment stays on the truck, cross-docks, holds, or delivers at the terminal. */
export enum CalmOnwardDisposition {
  Crossdock = 'CROSSDOCK',
  Deliver = 'DELIVER',
  Hold = 'HOLD',
  Stay = 'STAY'
}

export type CalmOrderCommitEntity = {
  __typename?: 'CalmOrderCommitEntity';
  commitBy?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
};

export type CalmOrderCubeEntity = {
  __typename?: 'CalmOrderCubeEntity';
  cubeFt3: Scalars['Float']['output'];
  orderUuid: Scalars['String']['output'];
  weightLbs: Scalars['Float']['output'];
};

export type CalmOrderHawbMatchEntity = {
  __typename?: 'CalmOrderHawbMatchEntity';
  hawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  status: OrderStatus;
};

export type CalmOrderLegEntity = {
  __typename?: 'CalmOrderLegEntity';
  assigned: Scalars['Boolean']['output'];
  departDate?: Maybe<Scalars['String']['output']>;
  endCode: Scalars['String']['output'];
  endUuid: Scalars['String']['output'];
  manifestRef?: Maybe<Scalars['String']['output']>;
  manifestUuid?: Maybe<Scalars['String']['output']>;
  ordinal: Scalars['Int']['output'];
  startCode: Scalars['String']['output'];
  startUuid: Scalars['String']['output'];
};

export type CalmOrderPackageEntity = {
  __typename?: 'CalmOrderPackageEntity';
  assignments: Array<CalmPackageAssignmentEntity>;
  commitBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  hazmat: Scalars['Boolean']['output'];
  onHand: Scalars['Boolean']['output'];
  pieces: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CalmOrderPackagesEntity = {
  __typename?: 'CalmOrderPackagesEntity';
  orderUuid: Scalars['String']['output'];
  packages: Array<CalmOrderPackageEntity>;
};

export type CalmOrderPieceEntity = {
  __typename?: 'CalmOrderPieceEntity';
  label?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['String']['output']>;
  status: PieceStatus;
  terminalCode?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<Scalars['String']['output']>;
};

export type CalmOrderSplitManifestEntity = {
  __typename?: 'CalmOrderSplitManifestEntity';
  departDate: Scalars['String']['output'];
  manifestRef: Scalars['String']['output'];
  manifestUuid: Scalars['String']['output'];
  units: Scalars['Int']['output'];
};

export type CalmOrderSplitSummaryEntity = {
  __typename?: 'CalmOrderSplitSummaryEntity';
  manifests: Array<CalmOrderSplitManifestEntity>;
  orderUuid: Scalars['String']['output'];
  totalUnits: Scalars['Int']['output'];
};

export type CalmOrderTagEntity = {
  __typename?: 'CalmOrderTagEntity';
  color?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type CalmOrderTagsEntity = {
  __typename?: 'CalmOrderTagsEntity';
  orderUuid: Scalars['String']['output'];
  tags: Array<CalmOrderTagEntity>;
};

export type CalmPackageAssignmentEntity = {
  __typename?: 'CalmPackageAssignmentEntity';
  departDate: Scalars['String']['output'];
  departed: Scalars['Boolean']['output'];
  leg: Scalars['String']['output'];
  manifestRef: Scalars['String']['output'];
  manifestUuid: Scalars['String']['output'];
};

export type CalmPlanOrderEntity = {
  __typename?: 'CalmPlanOrderEntity';
  destCode: Scalars['String']['output'];
  destUuid: Scalars['String']['output'];
  hawb?: Maybe<Scalars['String']['output']>;
  hazmat: Scalars['Boolean']['output'];
  inboundServiceDate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  originCode: Scalars['String']['output'];
  originUuid: Scalars['String']['output'];
  outboundServiceDate?: Maybe<Scalars['String']['output']>;
  packages: Scalars['Int']['output'];
  packagesOnHand: Scalars['Int']['output'];
  pieces: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
  ready: Scalars['Boolean']['output'];
  serviceDate?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
};

export type CalmPlanOrdersInput = {
  fromDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  toDate: Scalars['String']['input'];
};

export type CalmPndRouteEntity = {
  __typename?: 'CalmPndRouteEntity';
  deliveries: Scalars['Int']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  driverUuid?: Maybe<Scalars['String']['output']>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orderUuids: Array<Scalars['String']['output']>;
  pickups: Scalars['Int']['output'];
  routeUuid: Scalars['String']['output'];
  startAt?: Maybe<Scalars['String']['output']>;
  started: Scalars['Boolean']['output'];
  stops: Scalars['Int']['output'];
};

export type CalmPndRouteLoadEntity = {
  __typename?: 'CalmPndRouteLoadEntity';
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  packages: Array<CalmLoadPackageEntity>;
  routeUuid: Scalars['String']['output'];
  vehicleName?: Maybe<Scalars['String']['output']>;
  weightCapacity?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type CalmReroutePreviewEntity = {
  __typename?: 'CalmReroutePreviewEntity';
  freightAtTerminalCode?: Maybe<Scalars['String']['output']>;
  freightAtTerminalUuid?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  refusal?: Maybe<Scalars['String']['output']>;
  runsToLeave: Array<CalmRerouteRunToLeaveEntity>;
  travelledLegs: Array<CalmRerouteTravelledLegEntity>;
};

export type CalmRerouteRunToLeaveEntity = {
  __typename?: 'CalmRerouteRunToLeaveEntity';
  referenceNumber: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CalmRerouteTravelledLegEntity = {
  __typename?: 'CalmRerouteTravelledLegEntity';
  arrived: Scalars['Boolean']['output'];
  endCode: Scalars['String']['output'];
  runReference: Scalars['String']['output'];
  startCode: Scalars['String']['output'];
};

export type CalmReschedulableEntity = {
  __typename?: 'CalmReschedulableEntity';
  commitBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  packageUuid: Scalars['String']['output'];
  pieces: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
};

export type CalmRunInboundOrderEntity = {
  __typename?: 'CalmRunInboundOrderEntity';
  fromManifestRef?: Maybe<Scalars['String']['output']>;
  fromManifestUuid?: Maybe<Scalars['String']['output']>;
  fromTerminalCode?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  source: CalmInboundSource;
};

export type CalmRunInboundPlanEntity = {
  __typename?: 'CalmRunInboundPlanEntity';
  manifestUuid: Scalars['String']['output'];
  orders: Array<CalmRunInboundOrderEntity>;
};

export type CalmRunOnwardOrderEntity = {
  __typename?: 'CalmRunOnwardOrderEntity';
  disposition: CalmOnwardDisposition;
  nextTerminalCode?: Maybe<Scalars['String']['output']>;
  onwardManifestRef?: Maybe<Scalars['String']['output']>;
  onwardManifestUuid?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
};

export type CalmRunOnwardPlanEntity = {
  __typename?: 'CalmRunOnwardPlanEntity';
  manifestUuid: Scalars['String']['output'];
  orders: Array<CalmRunOnwardOrderEntity>;
};

export type CalmSavePlacementsResultEntity = {
  __typename?: 'CalmSavePlacementsResultEntity';
  dropped: Scalars['Int']['output'];
  placements: Array<CalmLoadPlacementEntity>;
  saved: Scalars['Int']['output'];
};

export type CalmUnitDimensionsEntity = {
  __typename?: 'CalmUnitDimensionsEntity';
  height: Scalars['Float']['output'];
  length: Scalars['Float']['output'];
  pieceUuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type CancelPackingPendencyInput = {
  uuid: Scalars['String']['input'];
};

export type CancelPackingPendencyOutput = {
  __typename?: 'CancelPackingPendencyOutput';
  /** The packing pendency that was cancelled */
  packingPendency: PackingPendencyEntity;
};

export type ChargeBreakdownReportInput = {
  /** This filters by the order billing party contact. */
  billingPartyContactUuid: Scalars['String']['input'];
  /** This filters by the order invoice date */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  /** This filters by the order service date */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
};

export type ChargeBreakdownReportPdfInput = {
  billingPartyContactUuid: Scalars['String']['input'];
  completedAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
};

export type ChargeBreakdownReportPdfOutput = {
  __typename?: 'ChargeBreakdownReportPdfOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fileName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** The accessorial columns of the EXCEL_CHARGE_MATRIX invoice layout, in sheet order. */
export enum ChargeMatrixColumn {
  Debris = 'DEBRIS',
  Hospital = 'HOSPITAL',
  Inside = 'INSIDE',
  Lg = 'LG',
  Unpack = 'UNPACK'
}

export type ChargesUnion = CustomChargeEntity | FreightChargeEntity;

export type CheckConsistencyOfInvoicesInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type ChooseAppointmentOptionInput = {
  date: PlainDateInput;
  endTime: PlainTimeInput;
  startTime: PlainTimeInput;
  stopUuid: Scalars['String']['input'];
};

export type ChooseAppointmentOptionOutput = ChooseAppointmentOptionSuccessOutput | MutationErrorOutput;

export type ChooseAppointmentOptionSuccessOutput = {
  __typename?: 'ChooseAppointmentOptionSuccessOutput';
  /** The date and time of the appointment in a human-readable format */
  appointmentDateTime?: Maybe<Scalars['String']['output']>;
};

export type CityAndStateOptionEntity = {
  __typename?: 'CityAndStateOptionEntity';
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export enum ClassifiedDocumentType {
  AirWaybill = 'AIR_WAYBILL',
  BillOfLading = 'BILL_OF_LADING',
  CommercialInvoice = 'COMMERCIAL_INVOICE',
  CustomsEntry = 'CUSTOMS_ENTRY',
  DeliveryOrder = 'DELIVERY_ORDER',
  PackingList = 'PACKING_LIST',
  PickupAlert = 'PICKUP_ALERT',
  ProofOfDelivery = 'PROOF_OF_DELIVERY',
  Quote = 'QUOTE',
  RateConfirmation = 'RATE_CONFIRMATION'
}

export type ClearCompanyContactsInput = {
  companyUuid: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ClearCompanyContactsOutput = {
  __typename?: 'ClearCompanyContactsOutput';
  status: Scalars['String']['output'];
};

export type ClearCompanyInput = {
  companyUuid: Scalars['String']['input'];
  /** If true, delete company documents that are not attached to any surviving entity. Does not remove the underlying S3 objects. */
  deleteDocuments?: Scalars['Boolean']['input'];
  /** If true, delete empty driver settlement bills with no stop driver maps or settlement bill line items */
  deleteDriverSettlementBills: Scalars['Boolean']['input'];
  /** If true, delete empty invoices with no orders */
  deleteInvoices: Scalars['Boolean']['input'];
  /** If true, allow deleting orders on invoices */
  deleteOrdersOnInvoices: Scalars['Boolean']['input'];
  /** If true, delete payments that are not applied to any orders */
  deletePayments: Scalars['Boolean']['input'];
  /** If true, delete the pieces attached to the deleted orders. Pieces have no company_id, so a piece whose only order links are deleted becomes unattributable — this deletes them up front instead of leaving them behind with a null orderId. Pieces that also link to an order outside the deletion set are kept. */
  deletePieces?: Scalars['Boolean']['input'];
  /** If true, delete legacy quotes and quote-agent quote records (order_quotes) that have no order */
  deleteQuotes: Scalars['Boolean']['input'];
  /** If true, delete empty routes with no stops */
  deleteRoutes: Scalars['Boolean']['input'];
  /** If true, delete scanned order results (and their documents and pages) that never produced an order and are not attached to an order as a POD. */
  deleteScannedOrderResults?: Scalars['Boolean']['input'];
  /** This keeps any orders with the provided HAWB aka shipperBillOfLadingNumber. */
  orderHawbsToKeep: Array<Scalars['String']['input']>;
  /** This filters by the order service date. If null or empty, will delete all orders across all service dates */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** This filters by the order source. If null or empty, will not delete any orders. */
  orderSourcesToDelete: Array<OrderSource>;
};

export type ClearDriverSettlementPayBoundInput = {
  driverUuid: Scalars['String']['input'];
  payType: DriverPayType;
};

export type ClearOrderExecutedByInput = {
  orderUuid: Scalars['String']['input'];
  parts: Array<OrderDelegationPart>;
};

export type ClientChallengeEntity = {
  __typename?: 'ClientChallengeEntity';
  name: Scalars['String']['output'];
  squareLogoUrl?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type CloneSavedFilterViewInput = {
  displayName: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type CloseInventoryCountInput = {
  inventoryCountUuid: Scalars['String']['input'];
};

export type CloseInventoryCountOutput = InventoryCountEntity | MutationErrorOutput;

export enum CompanyAccountType {
  Customer = 'CUSTOMER',
  Demo = 'DEMO',
  Internal = 'INTERNAL',
  Test = 'TEST'
}

export type CompanyConfigurationChangeActorEntity = {
  __typename?: 'CompanyConfigurationChangeActorEntity';
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type CompanyConfigurationChangeConnection = {
  __typename?: 'CompanyConfigurationChangeConnection';
  edges: Array<CompanyConfigurationChangeEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CompanyConfigurationChangeEdge = {
  __typename?: 'CompanyConfigurationChangeEdge';
  cursor: Scalars['String']['output'];
  node: CompanyConfigurationChangeEntity;
};

export type CompanyConfigurationChangeEntity = {
  __typename?: 'CompanyConfigurationChangeEntity';
  changedBy?: Maybe<CompanyConfigurationChangeActorEntity>;
  createdAt: Scalars['DateTime']['output'];
  /** The setting key as the registry names it. A `Company.configs` key, or a `Company` column name for settings written through `updateCompany`. */
  key: Scalars['String']['output'];
  /** The setting's label from the registry, or the key itself when the setting no longer exists. */
  label: Scalars['String']['output'];
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
  uuid: Scalars['String']['output'];
};

export type CompanyConfigurationEntity = {
  __typename?: 'CompanyConfigurationEntity';
  addOrdersToOpenInvoices: Scalars['Boolean']['output'];
  allCapsInOrderPage: Scalars['Boolean']['output'];
  allowDriverToSelectNextStop?: Maybe<Scalars['Boolean']['output']>;
  appointmentChangeCutoffHours: Scalars['Int']['output'];
  /** Which scheduling model owns this company appointment capacity. Null means undecided; nothing reads it yet. */
  appointmentSchedulerModel?: Maybe<AppointmentSchedulerModel>;
  appointmentSchedulingCutoffDays: Scalars['Int']['output'];
  appointmentSchedulingLeadingBufferHours: Scalars['Int']['output'];
  appointmentSchedulingSlotHours: Scalars['Int']['output'];
  /** How many times a customer may move their own appointment from the public booking link. Zero means they book once and anything further needs a human. */
  appointmentSelfRescheduleLimit: Scalars['Int']['output'];
  autoApplyWaitTimeMinutes: Scalars['Boolean']['output'];
  autoGroupStops: Scalars['Boolean']['output'];
  autoMatchEodDocumentsToOrders: Scalars['Boolean']['output'];
  company: CompanyEntity;
  companyOrdinalStart?: Maybe<Scalars['Int']['output']>;
  createRecurringOrdersInAdvanceHours: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customDriverSignableForms: Array<DriverSignableFormTemplateEntity>;
  defaultDimFactor?: Maybe<Scalars['Int']['output']>;
  defaultFuelSettlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  defaultFuelSurcharge?: Maybe<Scalars['Float']['output']>;
  defaultFuelSurchargeBillingMethod: FuelBillingMethod;
  defaultGenerateAppointmentDurationInMinutes: Scalars['Int']['output'];
  defaultGenerateAppointmentEarlyCushionInMinutes: Scalars['Int']['output'];
  defaultInvoiceDocumentsRequired: Array<DocumentType>;
  defaultPalletHeight?: Maybe<Scalars['Int']['output']>;
  defaultPalletLength?: Maybe<Scalars['Int']['output']>;
  defaultPalletWidth?: Maybe<Scalars['Int']['output']>;
  defaultRouteLoadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  defaultRouteStartTime?: Maybe<Scalars['DateTime']['output']>;
  defaultRouteUnloadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  defaultStandardStopType: StandardStopType;
  defaultToAccessorial: Scalars['Boolean']['output'];
  draftOrderCleanupDays: Scalars['Int']['output'];
  draftOrderCleanupSources: Array<OrderSource>;
  /** How many days before its expiry date a driver compliance item reads as EXPIRING. */
  driverComplianceExpiringSoonDays: Scalars['Int']['output'];
  driversShouldMarkFreightAsLoaded: Scalars['Boolean']['output'];
  enableConsolidatedOrders: Scalars['Boolean']['output'];
  enableDigitalSignatureFlow: Scalars['Boolean']['output'];
  enablePaymentMethod: Scalars['Boolean']['output'];
  /** External rating providers the company has enabled; drives which freight billing methods can be chosen. */
  enabledExternalRatingProviders: Array<ExternalRatingProvider>;
  fulfillmentTypeEnabled: Scalars['Boolean']['output'];
  getDriverLocationDataFromMobile: Scalars['Boolean']['output'];
  includeHyphensInInvoiceName: Scalars['Boolean']['output'];
  includeINVInInvoiceName: Scalars['Boolean']['output'];
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This setting no longer affects invoices and will be removed. */
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfLogoUrl?: Maybe<Scalars['String']['output']>;
  lineHaulBuildAheadDays: Scalars['Int']['output'];
  lineHaulEnabled: Scalars['Boolean']['output'];
  lineHaulMobileFutureWindowHours: Scalars['Int']['output'];
  lineHaulMobilePastWindowHours: Scalars['Int']['output'];
  lineHaulPlanningEnabled: Scalars['Boolean']['output'];
  logisticsSectionEnabled: Scalars['Boolean']['output'];
  markOnHandUponPickup: Scalars['Boolean']['output'];
  minDigitsInCompanyOrdinalOrderName?: Maybe<Scalars['Int']['output']>;
  mobilePollingIntervalInSeconds?: Maybe<Scalars['Float']['output']>;
  notificationsEnabled: Scalars['Boolean']['output'];
  orderIdentifierForCoverSheet: OrderIdentifier;
  orderLevelOsdEnabled: Scalars['Boolean']['output'];
  orderNamingScheme: OrderNamingScheme;
  packageWarehouseLocationsEnabled: Scalars['Boolean']['output'];
  pieceTransferableStatuses: Array<PieceStatus>;
  pointToPointTariffsEnabled: Scalars['Boolean']['output'];
  quoteAgentAutoSendMaxCents?: Maybe<Scalars['Int']['output']>;
  quoteAgentDailyModelBudgetCents: Scalars['Int']['output'];
  quoteAgentDefaultMode: QuoteAgentPolicyMode;
  quoteAgentEnabled: Scalars['Boolean']['output'];
  quoteAgentMinConfidence: Scalars['Int']['output'];
  quoteAgentValidityHours: Scalars['Int']['output'];
  /** The quote contribution ratio from which a quote shows as Marginal rather than Not profitable. */
  quoteContributionMarginalFromRatio: Scalars['Float']['output'];
  /** The quote contribution ratio from which a quote shows as Profitable. */
  quoteContributionProfitableFromRatio: Scalars['Float']['output'];
  recoveryTariffsEnabled: Scalars['Boolean']['output'];
  requireDimsToFinalizeCharges: Scalars['Boolean']['output'];
  requireDriverSignature: Scalars['Boolean']['output'];
  requireDriverToAcknowledgeRouteChange: Scalars['Boolean']['output'];
  requireDriverToConfirmStopCompletedAtTime: Scalars['Boolean']['output'];
  /** When true, a delivery cannot be self-scheduled until its order is marked on hand: every slot query answers empty for it, and the customer booking page says the shipment has not arrived yet. Pickups are not affected. */
  requireOnHandBeforeSelfScheduling: Scalars['Boolean']['output'];
  requirePODPhotoAndName: Scalars['Boolean']['output'];
  requirePODPhotoAndNameForPickups: Scalars['Boolean']['output'];
  requirePODPhotoForDeliveries: Scalars['Boolean']['output'];
  requirePODPhotoForPickups: Scalars['Boolean']['output'];
  requireReviewForEdiOrderCreation: Scalars['Boolean']['output'];
  requireSignedPodToCompleteStop: Scalars['Boolean']['output'];
  requireSigneeNameForDeliveries: Scalars['Boolean']['output'];
  requireSigneeNameForPickups: Scalars['Boolean']['output'];
  restrictEditingOrderName: Scalars['Boolean']['output'];
  reviewUrl?: Maybe<Scalars['String']['output']>;
  sameDayDispatchCellHeader: SameDayDispatchCellHeader;
  sendSignedPodEmailAfterLateSignature: Scalars['Boolean']['output'];
  sendSummaryEmailWithIncompleteRoutes: Scalars['Boolean']['output'];
  serviceLevelOptional: Scalars['Boolean']['output'];
  showAccessorialsToDrivers: Scalars['Boolean']['output'];
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showCompanyNameOnBillOfLadingDoc: Scalars['Boolean']['output'];
  showDriverSettlementInBilling: Scalars['Boolean']['output'];
  showHelpersColumnInDispatch?: Maybe<Scalars['Boolean']['output']>;
  showKilogramsAndCentimeters: Scalars['Boolean']['output'];
  showManuallyConfirmedByDefault?: Maybe<Scalars['Boolean']['output']>;
  showVehicleInDailyDispatch?: Maybe<Scalars['Boolean']['output']>;
  startingInvoiceOrdinalNumber?: Maybe<Scalars['Float']['output']>;
  t2tDelegationEnabled: Scalars['Boolean']['output'];
  t2tSyncEnabled: Scalars['Boolean']['output'];
  terminalsEnabled: Scalars['Boolean']['output'];
  textNextCustomerForAppointments: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  useDriverNumberForDispatch: Scalars['Boolean']['output'];
  useHawbForLotLabelBarcode: Scalars['Boolean']['output'];
  useJournalNumberForInvoice: Scalars['Boolean']['output'];
  useSeparateDigitalSignatureStep: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  wmsAutoMarkOnHand: Scalars['Boolean']['output'];
  /** @deprecated No longer in use. Present for backwards compatibility, will be removed in the future. */
  wmsBarcodeScannerEnabled: Scalars['Boolean']['output'];
  wmsEnabled: Scalars['Boolean']['output'];
  wmsShortTermStorageEnabled: Scalars['Boolean']['output'];
  wmsStorageOrdersEnabled: Scalars['Boolean']['output'];
};

export type CompanyEntity = {
  __typename?: 'CompanyEntity';
  accessorials: Array<AccessorialUnion>;
  /** What kind of tenant this is. Tenet broadcasts reach CUSTOMER and INTERNAL companies only. */
  accountType: CompanyAccountType;
  addresses: Array<AddressEntity>;
  airportInfos: Array<AirportInfoEntity>;
  alternateIsaId?: Maybe<Scalars['String']['output']>;
  alternateStandardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  blockSendingZeroDollarInvoices: Scalars['Boolean']['output'];
  companyLandscapeLogoUrl?: Maybe<Scalars['String']['output']>;
  companySquareLogoUrl?: Maybe<Scalars['String']['output']>;
  companyStatistics?: Maybe<CompanyStatsEntity>;
  configuration?: Maybe<CompanyConfigurationEntity>;
  createdAt: Scalars['DateTime']['output'];
  customDunningReportFooter?: Maybe<Scalars['String']['output']>;
  customDunningReportHeader?: Maybe<Scalars['String']['output']>;
  customerContacts: Array<CustomerContactEntity>;
  customerPortalConfiguration?: Maybe<CustomerPortalConfigurationEntity>;
  defaultAddress?: Maybe<AddressEntity>;
  defaultInboundEdiService?: Maybe<ServiceEntity>;
  defaultInboundOutboundEdiService?: Maybe<ServiceEntity>;
  defaultInvoiceEmailSubject?: Maybe<Scalars['String']['output']>;
  defaultLineHaulSettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultLineHaulTariffChain?: Maybe<TariffChainEntity>;
  defaultMeasurementUnits: MeasurementUnits;
  defaultNonCompanyDriverSettlementMode: SettlementMode;
  defaultOrdinarySettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultOrdinaryTariffChain?: Maybe<TariffChainEntity>;
  defaultOutboundEdiService?: Maybe<ServiceEntity>;
  defaultPointToPointSettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultPointToPointTariffChain?: Maybe<TariffChainEntity>;
  defaultRecoverySettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultRecoveryTariffChain?: Maybe<TariffChainEntity>;
  defaultTransferSettlementTariffChain?: Maybe<TariffChainEntity>;
  defaultTransferTariffChain?: Maybe<TariffChainEntity>;
  defaultWeightUnits: WeightUnits;
  drivers: Array<DriverEntity>;
  fourthAlternateIsaId?: Maybe<Scalars['String']['output']>;
  fourthAlternateScac?: Maybe<Scalars['String']['output']>;
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  freightSnapId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  invoiceEmail?: Maybe<Scalars['String']['output']>;
  isCourier?: Maybe<Scalars['Boolean']['output']>;
  isaId?: Maybe<Scalars['String']['output']>;
  lineHaulLanes: Array<LineHaulLaneEntity>;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderFormFields: OrderFormFieldsEntity;
  orderImportConfiguration?: Maybe<OrderImportConfigurationEntity>;
  orderNameOrdinal?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  productionCompany?: Maybe<ProductionCompany>;
  purchasedProductOfferings: Array<PalletProductOffering>;
  qbInvoiceNumberStart?: Maybe<Scalars['Float']['output']>;
  qboDefaultClassId?: Maybe<Scalars['String']['output']>;
  qboDefaultIncomeAccountId?: Maybe<Scalars['String']['output']>;
  qboDefaultTaxCodeId?: Maybe<Scalars['String']['output']>;
  qboFreightItemId?: Maybe<Scalars['String']['output']>;
  qboFuelItemId?: Maybe<Scalars['String']['output']>;
  qboLineHaulItemId?: Maybe<Scalars['String']['output']>;
  quickbooksAccessToken?: Maybe<QuickbooksOauthTokenEntity>;
  quickbooksCompanyId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopCompanyId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopDeliveryId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopFuelChargeId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopLineHaulId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopOrderChargeId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopPickupId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopRecoveryId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopTransferId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingAccessorialChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  secondAlternateIsaId?: Maybe<Scalars['String']['output']>;
  secondAlternateScac?: Maybe<Scalars['String']['output']>;
  segment: Segment;
  sendgridSenderId?: Maybe<Scalars['String']['output']>;
  services: Array<ServiceEntity>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  tags: Array<TagEntity>;
  terminals?: Maybe<Array<TerminalEntity>>;
  thirdAlternateIsaId?: Maybe<Scalars['String']['output']>;
  thirdAlternateScac?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  useSageBusinessWorks: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  warehouses?: Maybe<Array<WarehouseEntity>>;
};

export type CompanyPackageTypeConfigEntity = {
  __typename?: 'CompanyPackageTypeConfigEntity';
  id: Scalars['String']['output'];
  isSingleHandlingUnit: Scalars['Boolean']['output'];
  packageType: PackageType;
};

export type CompanySchedulingBlockedDayOutput = CompanySchedulingBlockedDaySuccessOutput | CompanySchedulingDayExemptionsAtRiskOutput | CompanySchedulingDayLiveClaimsOutput | MutationErrorOutput;

export type CompanySchedulingBlockedDaySuccessOutput = {
  __typename?: 'CompanySchedulingBlockedDaySuccessOutput';
  /** How many resources the closure lands on altogether. Exact and uncapped, unlike the list above, so a fleet larger than one page is still reported truthfully. */
  affectedSchedulingResourceCount: Scalars['Int']['output'];
  /** Live, non-exempt resources running on that weekday, soonest by name. A resource carrying a blocked day of its own is still listed: the company closure covers it too. CAPPED, so compare its length against affectedSchedulingResourceCount before reading it as the whole fleet. Empty after a day is reopened. */
  affectedSchedulingResources: Array<CompanySchedulingDayAffectedResourceOutput>;
  /** Total unreleased capacity claims on that day. Counts CLAIMS rather than resources, covers EVERY affected resource rather than only the ones named above, and is read after the write commits, so a reservation still in flight can be missing from it. */
  liveClaimCount: Scalars['Int']['output'];
  /** The closed day, or null when the day was just reopened. Reopening also drops the day exemptions, because they were opt-outs from a closure that no longer exists. */
  schedulingBlockedDay?: Maybe<SchedulingBlockedDayEntity>;
};

export type CompanySchedulingDayAffectedResourceOutput = {
  __typename?: 'CompanySchedulingDayAffectedResourceOutput';
  id: Scalars['String']['output'];
  /** Unreleased capacity claims this resource holds on the closed day. The claims are NOT cancelled by the closure: they stay on the day and keep consuming capacity, so they still need releasing or rescheduling. */
  liveClaimCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CompanySchedulingDayExemptionInput = {
  /** The closed company day, as an ISO-8601 plain date (YYYY-MM-DD). Must already be blocked for the company. */
  dateIso8601: Scalars['String']['input'];
  schedulingResourceId: Scalars['String']['input'];
};

export type CompanySchedulingDayExemptionsAtRiskOutput = {
  __typename?: 'CompanySchedulingDayExemptionsAtRiskOutput';
  /** How many scheduling resources would lose their exemption. Exact and uncapped, unlike the exemptSchedulingResourceIds a blocked day reports, which is one page. Always greater than zero: a day with no exemptions is reopened on the first call and never produces this arm. */
  exemptSchedulingResourceCount: Scalars['Int']['output'];
  /** Operator-facing explanation of what reopening the day would discard, and how to proceed. Safe to render verbatim. */
  message: Scalars['String']['output'];
};

export type CompanySchedulingDayLiveClaimsOutput = {
  __typename?: 'CompanySchedulingDayLiveClaimsOutput';
  /** How many resources the closure would land on altogether. Exact and uncapped, unlike the list above. */
  affectedSchedulingResourceCount: Scalars['Int']['output'];
  /** Live, non-exempt resources running on that weekday, by name. CAPPED, so compare its length against affectedSchedulingResourceCount before reading it as the whole fleet. */
  affectedSchedulingResources: Array<CompanySchedulingDayAffectedResourceOutput>;
  /** Total unreleased capacity claims that would be closed over. Counts CLAIMS rather than resources, and covers EVERY affected resource rather than only the ones named above. Always greater than zero: a day with no claims is closed on the first call and never produces this arm. */
  liveClaimCount: Scalars['Int']['output'];
  /** Operator-facing explanation of what closing the day would land on, and how to proceed. Safe to render verbatim. */
  message: Scalars['String']['output'];
};

export type CompanyStatsEntity = {
  __typename?: 'CompanyStatsEntity';
  numberOfOrdersDueInFuture: Scalars['Float']['output'];
  numberOfOrdersOneToThirty: Scalars['Float']['output'];
  numberOfOrdersPastNinetyOne: Scalars['Float']['output'];
  numberOfOrdersSixtyOneToNinety: Scalars['Float']['output'];
  numberOfOrdersThirtyOneToSixty: Scalars['Float']['output'];
  numberOfUninvoicedOrdersDueInFuture: Scalars['Float']['output'];
  numberOfUninvoicedOrdersOneToThirty: Scalars['Float']['output'];
  numberOfUninvoicedOrdersPastNinetyOne: Scalars['Float']['output'];
  numberOfUninvoicedOrdersSixtyOneToNinety: Scalars['Float']['output'];
  numberOfUninvoicedOrdersThirtyOneToSixty: Scalars['Float']['output'];
};

export type CompleteRebillInput = {
  newContactUuid: Scalars['String']['input'];
  originalInvoiceUuid: Scalars['String']['input'];
  originalOrderUuid: Scalars['String']['input'];
  rebillOrderUuid: Scalars['String']['input'];
};

export type CompleteRebillOutput = {
  __typename?: 'CompleteRebillOutput';
  invoiceForRebill: InvoiceEntity;
};

export type CompleteStopBulkInput = {
  /** Pass this in to save this at the same time as completing the stop */
  completeStopInputs?: InputMaybe<Array<CompleteStopInput>>;
};

export type CompleteStopEntity = {
  __typename?: 'CompleteStopEntity';
  appointmentCallStatus?: Maybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed: Scalars['Boolean']['output'];
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentTextStatus?: Maybe<AppointmentTextStatus>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  courierReadyOrDueDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerBookingNotes?: Maybe<Scalars['String']['output']>;
  deadlineTime?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  driverCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  etaFinishTime?: Maybe<Scalars['DateTime']['output']>;
  etaLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  expectedOutboundDate?: Maybe<Scalars['DateTime']['output']>;
  failureCount?: Maybe<Scalars['Float']['output']>;
  inboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  incomingCarrier?: Maybe<Scalars['String']['output']>;
  lastAppointmentTextTime?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundCarrier?: Maybe<Scalars['String']['output']>;
  outboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  paperworkMarkedComplete?: Maybe<Scalars['Boolean']['output']>;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeChangeAcknowledged: Scalars['Boolean']['output'];
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  showDriverModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  status: StopStatus;
  stopType: StopType;
  textResponses?: Maybe<Scalars['String']['output']>;
  twilioCallSid?: Maybe<Scalars['String']['output']>;
  twilioTextSid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type CompleteStopInput = {
  /** The date the stop was completed */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** If set to true, forces completion of the associated order regardless of any condition that may prevent that. */
  forceComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isFromWebApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the person who signed the delivery */
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  sentFromDriverMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pass this in to save this at the same time as completing the stop */
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  stopUuid: Scalars['String']['input'];
  /** UUID of the driver truck warehouse. On pickup completion, unscanned pieces receive this warehouseId. On delivery completion, warehouseId is cleared. */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteStopInvalidInputException = {
  __typename?: 'CompleteStopInvalidInputException';
  message: Scalars['String']['output'];
};

export type CompleteStopOutput = CompleteStopEntity | CompleteStopInvalidInputException;

export type CompleteWorkOrderLoadingInput = {
  /** The scanning mode the operator was working in. Used to drop pieces another device already scanned for this mode from `shortagePieceUuids`, so a concurrent scan is not recorded as a shortage. Omitting it keeps only the terminal-status filter. */
  mode?: InputMaybe<FreightScanningV2ScanMode>;
  /** Pieces the operator finished without scanning, flagged as shortages. UUIDs that are not on this work order, or that the server already shows as scanned for `mode`, are dropped. A malformed UUID rejects the whole mutation rather than being dropped, so a client bug fails loudly instead of silently under-recording shortages. */
  shortagePieceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  workOrderType: WorkOrderType;
  /** The UUID of the route or line haul manifest */
  workOrderUuid: Scalars['String']['input'];
};

export type CompleteWorkOrderLoadingOutput = {
  __typename?: 'CompleteWorkOrderLoadingOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CompletedAtSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type CompletionToPaymentDuration = {
  __typename?: 'CompletionToPaymentDuration';
  backwardOrders: Scalars['Int']['output'];
  countedOrders: Scalars['Int']['output'];
  meanSeconds?: Maybe<Scalars['Float']['output']>;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
  prior: CompletionToPaymentPriorDuration;
};

export type CompletionToPaymentFilterArgs = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  flag?: InputMaybe<CompletionToPaymentFlag>;
  runsBackward?: InputMaybe<CompletionToPaymentMeasure>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  waitingIn?: InputMaybe<CompletionToPaymentStage>;
};

export enum CompletionToPaymentFlag {
  OnHold = 'ON_HOLD',
  RatingErrors = 'RATING_ERRORS'
}

export type CompletionToPaymentFlags = {
  __typename?: 'CompletionToPaymentFlags';
  onHold: Scalars['Int']['output'];
  ratingErrors: Scalars['Int']['output'];
  ratingErrorsUnpaid: Scalars['Int']['output'];
};

export type CompletionToPaymentGroup = {
  __typename?: 'CompletionToPaymentGroup';
  name: Scalars['String']['output'];
  orders: Scalars['Int']['output'];
  postedOrders: Scalars['Int']['output'];
  postedToPaidCountedOrders: Scalars['Int']['output'];
  postedToPaidMedianSeconds?: Maybe<Scalars['Float']['output']>;
  settledOrders: Scalars['Int']['output'];
  toPostedCountedOrders: Scalars['Int']['output'];
  toPostedMedianSeconds?: Maybe<Scalars['Float']['output']>;
  unpaidOver30Days: Scalars['Int']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export enum CompletionToPaymentInterval {
  CompleteToFinalized = 'COMPLETE_TO_FINALIZED',
  FinalizedToOnInvoice = 'FINALIZED_TO_ON_INVOICE',
  OnInvoiceToPosted = 'ON_INVOICE_TO_POSTED',
  PostedToPaid = 'POSTED_TO_PAID'
}

export type CompletionToPaymentIntervalDuration = {
  __typename?: 'CompletionToPaymentIntervalDuration';
  backwardOrders: Scalars['Int']['output'];
  countedOrders: Scalars['Int']['output'];
  key: CompletionToPaymentInterval;
  meanSeconds?: Maybe<Scalars['Float']['output']>;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
  prior: CompletionToPaymentPriorDuration;
};

export type CompletionToPaymentLongestInterval = {
  __typename?: 'CompletionToPaymentLongestInterval';
  key: CompletionToPaymentInterval;
  seconds: Scalars['Float']['output'];
};

export enum CompletionToPaymentMeasure {
  CompleteToFinalized = 'COMPLETE_TO_FINALIZED',
  CompleteToPaid = 'COMPLETE_TO_PAID',
  CompleteToPosted = 'COMPLETE_TO_POSTED',
  FinalizedToOnInvoice = 'FINALIZED_TO_ON_INVOICE',
  OnInvoiceToPosted = 'ON_INVOICE_TO_POSTED',
  PostedToPaid = 'POSTED_TO_PAID'
}

export type CompletionToPaymentOutlierOrder = {
  __typename?: 'CompletionToPaymentOutlierOrder';
  customerName: Scalars['String']['output'];
  fromAt: Scalars['DateTime']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  seconds: Scalars['Float']['output'];
  toAt: Scalars['DateTime']['output'];
};

export type CompletionToPaymentOutliers = {
  __typename?: 'CompletionToPaymentOutliers';
  measure: CompletionToPaymentMeasure;
  orders: Array<CompletionToPaymentOutlierOrder>;
};

export type CompletionToPaymentPageArgs = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  flag?: InputMaybe<CompletionToPaymentFlag>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  runsBackward?: InputMaybe<CompletionToPaymentMeasure>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  waitingIn?: InputMaybe<CompletionToPaymentStage>;
};

export type CompletionToPaymentPriorDuration = {
  __typename?: 'CompletionToPaymentPriorDuration';
  countedOrders: Scalars['Int']['output'];
  medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type CompletionToPaymentReport = {
  __typename?: 'CompletionToPaymentReport';
  rows: Array<CompletionToPaymentRow>;
  timezone: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CompletionToPaymentRow = {
  __typename?: 'CompletionToPaymentRow';
  accountId?: Maybe<Scalars['String']['output']>;
  chargesFinalizedAt?: Maybe<Scalars['DateTime']['output']>;
  completeToFinalizedSeconds?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  customerName: Scalars['String']['output'];
  finalizedToOnInvoiceSeconds?: Maybe<Scalars['Float']['output']>;
  hasRatingErrors: Scalars['Boolean']['output'];
  hawb?: Maybe<Scalars['String']['output']>;
  invoicePaidAt?: Maybe<Scalars['DateTime']['output']>;
  invoicePostedAt?: Maybe<Scalars['DateTime']['output']>;
  onHold: Scalars['Boolean']['output'];
  onInvoiceAt?: Maybe<Scalars['DateTime']['output']>;
  onInvoiceToPostedSeconds?: Maybe<Scalars['Float']['output']>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  postedToPaidSeconds?: Maybe<Scalars['Float']['output']>;
};

export type CompletionToPaymentSlowOrder = {
  __typename?: 'CompletionToPaymentSlowOrder';
  customerName: Scalars['String']['output'];
  longestInterval?: Maybe<CompletionToPaymentLongestInterval>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  secondsToPosted: Scalars['Float']['output'];
  terminalCode?: Maybe<Scalars['String']['output']>;
};

export enum CompletionToPaymentStage {
  CompleteNotFinalized = 'COMPLETE_NOT_FINALIZED',
  FinalizedNotPosted = 'FINALIZED_NOT_POSTED',
  NotComplete = 'NOT_COMPLETE',
  PostedNotPaid = 'POSTED_NOT_PAID'
}

export type CompletionToPaymentSummary = {
  __typename?: 'CompletionToPaymentSummary';
  byCustomer: Array<CompletionToPaymentGroup>;
  byTerminal: Array<CompletionToPaymentGroup>;
  completeToPaid: CompletionToPaymentDuration;
  completeToPosted: CompletionToPaymentDuration;
  flags: CompletionToPaymentFlags;
  intervals: Array<CompletionToPaymentIntervalDuration>;
  oldestUnpaid: Array<CompletionToPaymentUnpaidOrder>;
  orders: Scalars['Int']['output'];
  outliers: Array<CompletionToPaymentOutliers>;
  postedOrders: Scalars['Int']['output'];
  settledOrders: Scalars['Int']['output'];
  slowestToBill: Array<CompletionToPaymentSlowOrder>;
  timezone: Scalars['String']['output'];
  trend: CompletionToPaymentTrend;
  waiting: Array<CompletionToPaymentWaitingStage>;
};

export type CompletionToPaymentTrend = {
  __typename?: 'CompletionToPaymentTrend';
  points: Array<CompletionToPaymentTrendPoint>;
  unit: KpiTrendBucketUnit;
};

export type CompletionToPaymentTrendPoint = {
  __typename?: 'CompletionToPaymentTrendPoint';
  bucketDate: Scalars['String']['output'];
  completedOrders: Scalars['Int']['output'];
  countedOrders: Scalars['Int']['output'];
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
};

export type CompletionToPaymentUnpaidOrder = {
  __typename?: 'CompletionToPaymentUnpaidOrder';
  ageSeconds: Scalars['Float']['output'];
  customerName: Scalars['String']['output'];
  invoiceName: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  postedAt: Scalars['DateTime']['output'];
};

export type CompletionToPaymentWaitingStage = {
  __typename?: 'CompletionToPaymentWaitingStage';
  medianAgeSeconds?: Maybe<Scalars['Float']['output']>;
  orders: Scalars['Int']['output'];
  over30Days: Scalars['Int']['output'];
  over60Days: Scalars['Int']['output'];
  stage: CompletionToPaymentStage;
};

export type ConditionalServiceExplainEntity = {
  __typename?: 'ConditionalServiceExplainEntity';
  serviceId?: Maybe<Scalars['String']['output']>;
  share?: Maybe<Scalars['Float']['output']>;
  support?: Maybe<Scalars['Int']['output']>;
  verdict: Scalars['String']['output'];
};

/** Named bundles of company configuration that can be migrated. */
export enum ConfigMigrationFeatureGroup {
  Accessorials = 'ACCESSORIALS',
  ApiUsers = 'API_USERS',
  CompanySettings = 'COMPANY_SETTINGS',
  Integrations = 'INTEGRATIONS',
  Tariffs = 'TARIFFS',
  WarehousesTerminals = 'WAREHOUSES_TERMINALS'
}

export type ConfigMigrationReportObject = {
  __typename?: 'ConfigMigrationReportObject';
  allMatch: Scalars['Boolean']['output'];
  companyUuid: Scalars['String']['output'];
  dryRun: Scalars['Boolean']['output'];
  preImageBundleKey?: Maybe<Scalars['String']['output']>;
  source: MigrationEnv;
  sourceBundleKey: Scalars['String']['output'];
  tables: Array<ConfigMigrationTableReportObject>;
  target: MigrationEnv;
};

export type ConfigMigrationStatusObject = {
  __typename?: 'ConfigMigrationStatusObject';
  jobId: Scalars['String']['output'];
  report?: Maybe<ConfigMigrationReportObject>;
  state: Scalars['String']['output'];
};

export type ConfigMigrationTableReportObject = {
  __typename?: 'ConfigMigrationTableReportObject';
  insertedUuids: Array<Scalars['String']['output']>;
  matches: Scalars['Boolean']['output'];
  skipReason?: Maybe<Scalars['String']['output']>;
  sourceCount: Scalars['Int']['output'];
  tableName: Scalars['String']['output'];
  targetCount: Scalars['Int']['output'];
  updatedUuids: Array<Scalars['String']['output']>;
};

export type ConfirmInventoryCountLinesInput = {
  confirmations: Array<InventoryCountConfirmationInput>;
  inventoryCountUuid: Scalars['String']['input'];
};

export type ConfirmInventoryCountLinesOutput = BulkInventoryCountResultOutput | InventoryCountClosedOutput | MutationErrorOutput;

export type ConfirmQuoteAcceptanceInput = {
  /** The current draft amount the operator accepts in place of the quoted one after a price mismatch hold */
  acknowledgedCurrentAmountCents?: InputMaybe<Scalars['Int']['input']>;
  orderQuoteUuid: Scalars['String']['input'];
};

export type ConfirmQuoteAcceptanceOutput = ConfirmQuoteAcceptanceSuccessOutput | MutationErrorOutput | QuoteAcceptanceHeldOutput;

export type ConfirmQuoteAcceptanceSuccessOutput = {
  __typename?: 'ConfirmQuoteAcceptanceSuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
  orderUuid?: Maybe<Scalars['String']['output']>;
  status: OrderQuoteStatus;
};

export type ConsigneePortalOrderEntity = {
  __typename?: 'ConsigneePortalOrderEntity';
  companyTimezone?: Maybe<Scalars['String']['output']>;
  detailedStatus?: Maybe<OrderDetailedStatus>;
  isRefused: Scalars['Boolean']['output'];
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  packages?: Maybe<Array<PackageEntity>>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  shipments: Array<ConsigneePortalShipmentEntity>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  uuid: Scalars['String']['output'];
};

export type ConsigneePortalShipmentEntity = {
  __typename?: 'ConsigneePortalShipmentEntity';
  address?: Maybe<AddressEntity>;
  addressUuid?: Maybe<Scalars['String']['output']>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAtLocal?: Maybe<PlainDateTime>;
  /** If completedAtLocal is set, this field provides the time zone that was used to determine the local date and time. */
  completedAtLocalTimeZone?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  driverPlaceInRoute?: Maybe<Scalars['Float']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  /** @deprecated Use stopType instead */
  pickupOrDelivery?: Maybe<PickupOrDelivery>;
  placeInRoute?: Maybe<Scalars['Float']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeIsToday?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<StopStatus>;
  stopType?: Maybe<StopType>;
  uuid: Scalars['String']['output'];
};

export type ConsolidatableOrdersOutput = {
  __typename?: 'ConsolidatableOrdersOutput';
  error?: Maybe<FindConsolidatableOrdersError>;
  orders: Array<OrderEntity>;
  /** Only returned for orders with multiple addresses (more than one pickup/delivery) */
  shipments?: Maybe<Array<ShipmentEntity>>;
};

export type ConsolidatedOrderCreateInput = {
  shipmentUuid: Scalars['String']['input'];
};

export type ContactAccessorialChargeDetailsEntity = {
  __typename?: 'ContactAccessorialChargeDetailsEntity';
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  shipmentsWithAccessorialCount: Scalars['Float']['output'];
  totalAccessorialCharge: Scalars['Float']['output'];
};

export type ContactAndServicesCombination = {
  contactUuid: Scalars['String']['input'];
  serviceUuids: Array<Scalars['String']['input']>;
};

export type ContactChargeMatrixColumnMappingEntity = {
  __typename?: 'ContactChargeMatrixColumnMappingEntity';
  accessorial: AccessorialInterface;
  column: ChargeMatrixColumn;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactChargeMatrixColumnMappingInput = {
  accessorialUuid: Scalars['String']['input'];
  column: ChargeMatrixColumn;
};

export type ContactCommentEntity = {
  __typename?: 'ContactCommentEntity';
  authorName: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactCommunicationConfigCreateInput = {
  active: Scalars['Boolean']['input'];
  contactUuid: Scalars['String']['input'];
  sendAtHours: Scalars['Int']['input'];
  sendAtMinutes: Scalars['Int']['input'];
  type: ContactCommunicationType;
};

export type ContactCommunicationConfigEntity = {
  __typename?: 'ContactCommunicationConfigEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  sendAtHours: Scalars['Int']['output'];
  sendAtMinutes: Scalars['Int']['output'];
  type: ContactCommunicationType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactCommunicationConfigUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sendAtHours?: InputMaybe<Scalars['Int']['input']>;
  sendAtMinutes?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ContactCommunicationType>;
  uuid: Scalars['String']['input'];
};

export enum ContactCommunicationType {
  DailyOrdersCompleted = 'DAILY_ORDERS_COMPLETED',
  DailyOrdersNotOnHand = 'DAILY_ORDERS_NOT_ON_HAND',
  DailyOrdersOnHand = 'DAILY_ORDERS_ON_HAND',
  DailyOrdersScheduled = 'DAILY_ORDERS_SCHEDULED',
  PerAppointmentDateChanged = 'PER_APPOINTMENT_DATE_CHANGED',
  PerOrderCompleted = 'PER_ORDER_COMPLETED',
  PerOrderDriverOnSite = 'PER_ORDER_DRIVER_ON_SITE',
  PerOrderOutForDelivery = 'PER_ORDER_OUT_FOR_DELIVERY',
  PerOrderScheduled = 'PER_ORDER_SCHEDULED'
}

export type ContactConnection = {
  __typename?: 'ContactConnection';
  edges: Array<ContactEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ContactEdge = {
  __typename?: 'ContactEdge';
  cursor: Scalars['String']['output'];
  node: ContactEntity;
};

export type ContactEmailCreateInput = {
  contactUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
  type: ContactEmailType;
};

export type ContactEmailEntity = {
  __typename?: 'ContactEmailEntity';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  type: ContactEmailType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ContactEmailType {
  Invoice = 'INVOICE',
  OrderUpdate = 'ORDER_UPDATE'
}

export type ContactEntity = {
  accessorialGroupId?: Maybe<Scalars['String']['output']>;
  addresses: Array<AddressEntity>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment: Scalars['Boolean']['output'];
  apiName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay90: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay180: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay270: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay360: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay720: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPayAll: Scalars['Float']['output'];
  /** The customer balance for the contact in dollars */
  balance: Scalars['Float']['output'];
  billingContactEmail?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: Maybe<Scalars['Float']['output']>;
  billingPeriodDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  billingRunStart: Scalars['DateTime']['output'];
  businessDivision?: Maybe<BusinessDivisionEntity>;
  calculateInboundFreightCharges: Scalars['Boolean']['output'];
  calculateLineHaulFreightCharges: Scalars['Boolean']['output'];
  calculateOutboundFreightCharges: Scalars['Boolean']['output'];
  chargeMatrixColumnMappings: Array<ContactChargeMatrixColumnMappingEntity>;
  company: CompanyEntity;
  /** Returns at most 100 most-recent contact comments. Callers needing full enumeration must use a paginated query (TODO: expose contactCommentsConnection). */
  contactComments: Array<ContactCommentEntity>;
  contactOpenInvoiceValue: Scalars['Float']['output'];
  contactOpenInvoiceValue0to30d: Scalars['Float']['output'];
  contactOpenInvoiceValue31to38d: Scalars['Float']['output'];
  contactOpenInvoiceValue39to45d: Scalars['Float']['output'];
  contactOpenInvoiceValue46to60d: Scalars['Float']['output'];
  contactOpenInvoiceValue61to75d: Scalars['Float']['output'];
  contactOpenInvoiceValueOver75d: Scalars['Float']['output'];
  contactPersons: Array<ContactPersonEntity>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactStations: Array<ContactStationEntity>;
  contactStatistics: ContactStatsEntity;
  creditsAppliedToContactInvoices: Scalars['Float']['output'];
  customDunningReportFooter?: Maybe<Scalars['String']['output']>;
  customerAccessorials: Array<AccessorialUnion>;
  customerTariffs: Array<TariffEntity>;
  debitsAppliedToContactInvoices: Scalars['Float']['output'];
  defaultAddress?: Maybe<AddressEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  defaultEfmHandlingStation?: Maybe<Scalars['String']['output']>;
  defaultInvoiceTerms?: Maybe<InvoiceTermEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['output'];
  dimFactor: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  ediPartnership?: Maybe<EdiPartnershipEntity>;
  ediPartnerships: Array<EdiPartnershipEntity>;
  /** The tariff chain rating uses for each tariff type, in the order Ordinary, Line haul, Transfer, Recovery, Point to point: the contact's own chain, else the company default. A type with neither has no entry, and Recovery has none while the company has recovery tariffs off. */
  effectiveTariffChains: Array<EffectiveTariffChainEntity>;
  /** The contact's addresses on a SendGrid suppression list (bounce, invalid email or spam report). Emails to them are skipped. */
  emailSuppressions: Array<EmailSuppressionEntity>;
  emitPieceLevelWebhooks: Scalars['Boolean']['output'];
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This field no longer affects invoices and will be removed. */
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfColumns: Array<PdfColumnEntity>;
  invoiceTimePeriodSplit?: Maybe<TimePeriod>;
  invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName;
  isActive: Scalars['Boolean']['output'];
  isEfm?: Maybe<Scalars['Boolean']['output']>;
  isOverCreditLimit: Scalars['Boolean']['output'];
  isPrepaidOnly: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<DocumentEntity>;
  logoType?: Maybe<DocumentEntity>;
  masterAccount?: Maybe<MasterAccountEntity>;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  /** Dollars of the contact credit memos taken up by debit memo offsets */
  offsetCredits: Scalars['Float']['output'];
  /** Dollars of the contact debit memos used to offset payments or credit memos */
  offsetDebits: Scalars['Float']['output'];
  /** Dollars of the contact payments taken up by debit memo offsets */
  offsetPayments: Scalars['Float']['output'];
  /** Returns at most 100 most-recent orders where this contact is the billing party. Callers needing full enumeration must use the paginated orders query (TODO: expose ordersConnection). */
  orders: Array<OrderEntity>;
  overdueInvoices: Array<InvoiceEntity>;
  paymentsAppliedToContactInvoices: Scalars['Float']['output'];
  /** Total closed balance across all posted invoices */
  postedInvoicesTotalClosedBalance: Scalars['Float']['output'];
  /** Total open balance across all posted invoices */
  postedInvoicesTotalOpenBalance: Scalars['Float']['output'];
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopContactId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingCustomerName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId?: Maybe<Scalars['String']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['output'];
  requireScanToAdvancePieceStatusAtStops: Scalars['Boolean']['output'];
  serviceGroupId?: Maybe<Scalars['String']['output']>;
  services: Array<ServiceEntity>;
  shortCode?: Maybe<Scalars['String']['output']>;
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  skipFuelCharge?: Maybe<Scalars['Boolean']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  tariffZones: Array<TariffZoneEntity>;
  /** @deprecated placeholder since the column was dropped from the table */
  thirdPartyContactType?: Maybe<ThirdPartyContactType>;
  totalCredits: Scalars['Float']['output'];
  totalDebits: Scalars['Float']['output'];
  totalInvoicesAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPostedInvoicesAmount: Scalars['Float']['output'];
  /** @deprecated Contact type is deprecated. The column has been dropped from the db */
  type: ContactType;
  unappliedCredits?: Maybe<Scalars['Float']['output']>;
  unappliedDebits: Scalars['Float']['output'];
  unappliedPayments: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};


export type ContactEntityContactOpenInvoiceValueArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue0to30dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue31to38dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue39to45dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue46to60dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValue61to75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ContactEntityContactOpenInvoiceValueOver75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};

export type ContactForContactReport = {
  __typename?: 'ContactForContactReport';
  active: Scalars['Boolean']['output'];
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressName?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<Scalars['String']['output']>;
  businessDivision?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  creditLimit?: Maybe<Scalars['Float']['output']>;
  defaultInvoiceTransmissionMethod?: Maybe<Scalars['String']['output']>;
  defaultInvoiceType: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enableCreditHold: Scalars['Boolean']['output'];
  invoiceTimePeriodSplit?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  shortcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ContactPersonCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPersonEntity = {
  __typename?: 'ContactPersonEntity';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ContactPersonUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ContactPersonUpsertInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ContactStationCreateInput = {
  contactUuid: Scalars['String']['input'];
  isArchived: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ContactStationCreateOutput = ContactStationCreateSuccessOutput | MutationErrorOutput;

export type ContactStationCreateSuccessOutput = {
  __typename?: 'ContactStationCreateSuccessOutput';
  contactStation: ContactStationEntity;
};

export type ContactStationEntity = {
  __typename?: 'ContactStationEntity';
  defaultPerson?: Maybe<PersonEntity>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ContactStationUpdateInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPersonId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type ContactStationUpdateOutput = ContactStationUpdateSuccessOutput | MutationErrorOutput;

export type ContactStationUpdateSuccessOutput = {
  __typename?: 'ContactStationUpdateSuccessOutput';
  contactStation: ContactStationEntity;
};

export type ContactStatsEntity = {
  __typename?: 'ContactStatsEntity';
  numberOfFinalizedOrders: Scalars['Float']['output'];
  numberOfOrdersWithIssues: Scalars['Float']['output'];
  numberOfTotalOrders?: Maybe<Scalars['Float']['output']>;
  numberOfUnfinalizedOrders: Scalars['Float']['output'];
};

export type ContactToServicesTariffGroupMappingEntity = {
  __typename?: 'ContactToServicesTariffGroupMappingEntity';
  contact: ContactEntity;
  services: Array<ServiceEntity>;
  uuid: Scalars['String']['output'];
};

export enum ContactType {
  Customer = 'CUSTOMER',
  ThirdParty = 'THIRD_PARTY'
}

export type CoordinatesForAddressEntity = {
  __typename?: 'CoordinatesForAddressEntity';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  quality: GeocodeQuality;
};

export enum CostBasis {
  Benchmark = 'BENCHMARK',
  CostInputs = 'COST_INPUTS',
  NotSetUp = 'NOT_SET_UP'
}

/** Origin of the cost rates used for a cost center statement row. */
export enum CostCenterProfileSource {
  Benchmark = 'BENCHMARK',
  CostInputs = 'COST_INPUTS'
}

export type CostCenterStatementArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CostCenterStatementReportEntity = {
  __typename?: 'CostCenterStatementReportEntity';
  billingCollectingCostUsd: Scalars['Float']['output'];
  breakevenRevenueUsd?: Maybe<Scalars['Float']['output']>;
  breakevenShipmentCount?: Maybe<Scalars['Int']['output']>;
  contributionDollarsUsd: Scalars['Float']['output'];
  contributionMarginPct?: Maybe<Scalars['Float']['output']>;
  contributionPerDayUsd?: Maybe<Scalars['Float']['output']>;
  contributionPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  costBasis: CostBasis;
  dockCostUsd: Scalars['Float']['output'];
  dockLaborCostUsd?: Maybe<Scalars['Float']['output']>;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  fixedCostPerDayUsd?: Maybe<Scalars['Float']['output']>;
  fixedOverheadCostUsd: Scalars['Float']['output'];
  incomeAfterNonFreightUsd?: Maybe<Scalars['Float']['output']>;
  insuranceClaimsCostUsd: Scalars['Float']['output'];
  linehaulCostUsd: Scalars['Float']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  netRevenuePerDayUsd?: Maybe<Scalars['Float']['output']>;
  netRevenueUsd?: Maybe<Scalars['Float']['output']>;
  nonFreightCostUsd?: Maybe<Scalars['Float']['output']>;
  operatingIncomeUsd: Scalars['Float']['output'];
  operatingRatio?: Maybe<Scalars['Float']['output']>;
  outsideCarriersCostUsd?: Maybe<Scalars['Float']['output']>;
  pdLaborCostUsd?: Maybe<Scalars['Float']['output']>;
  percentOfBreakeven?: Maybe<Scalars['Float']['output']>;
  pickupDeliveryCostUsd: Scalars['Float']['output'];
  revenuePerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  revenueSharedWithAgentsUsd?: Maybe<Scalars['Float']['output']>;
  revenueUsd: Scalars['Float']['output'];
  shipmentCount: Scalars['Int']['output'];
  status?: Maybe<CostCenterStatementStatus>;
  terminals: Array<CostCenterStatementRowEntity>;
  totalVariableCostUsd: Scalars['Float']['output'];
  truckCostUsd?: Maybe<Scalars['Float']['output']>;
  usesBenchmarkDefaults: Scalars['Boolean']['output'];
  variableCostPctOfRevenue?: Maybe<Scalars['Float']['output']>;
  variableCostPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  workdays?: Maybe<Scalars['Float']['output']>;
};

export type CostCenterStatementRowEntity = {
  __typename?: 'CostCenterStatementRowEntity';
  billingCollectingCostUsd: Scalars['Float']['output'];
  breakevenRevenueUsd?: Maybe<Scalars['Float']['output']>;
  contributionDollarsUsd: Scalars['Float']['output'];
  contributionMarginPct?: Maybe<Scalars['Float']['output']>;
  contributionPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  dockCostUsd: Scalars['Float']['output'];
  fixedOverheadCostUsd: Scalars['Float']['output'];
  insuranceClaimsCostUsd: Scalars['Float']['output'];
  linehaulCostUsd: Scalars['Float']['output'];
  operatingIncomeUsd: Scalars['Float']['output'];
  operatingRatio?: Maybe<Scalars['Float']['output']>;
  percentOfBreakeven?: Maybe<Scalars['Float']['output']>;
  pickupDeliveryCostUsd: Scalars['Float']['output'];
  profileSource: CostCenterProfileSource;
  revenuePerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  revenueUsd: Scalars['Float']['output'];
  shipmentCount: Scalars['Int']['output'];
  status?: Maybe<CostCenterStatementStatus>;
  terminalCode?: Maybe<Scalars['String']['output']>;
  terminalName: Scalars['String']['output'];
  terminalUuid?: Maybe<Scalars['String']['output']>;
  totalVariableCostUsd: Scalars['Float']['output'];
  variableCostPctOfRevenue?: Maybe<Scalars['Float']['output']>;
  variableCostPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
};

/** Where a terminal or the company sits relative to its breakeven revenue. */
export enum CostCenterStatementStatus {
  AboveBreakeven = 'ABOVE_BREAKEVEN',
  BelowBreakeven = 'BELOW_BREAKEVEN',
  NearBreakeven = 'NEAR_BREAKEVEN'
}

export enum CostInputCadence {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

export type CostInputDefinitionEntity = {
  __typename?: 'CostInputDefinitionEntity';
  cadence: CostInputCadence;
  field: CostInputField;
  group: CostInputGroup;
  howToFill: Scalars['String']['output'];
  label: Scalars['String']['output'];
  quickbooksMappable: Scalars['Boolean']['output'];
  sources: Array<CostInputSource>;
  unit: CostInputUnit;
  whereToFind: Scalars['String']['output'];
};

export type CostInputEntryInput = {
  field: CostInputField;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type CostInputEstimatedMonthEntity = {
  __typename?: 'CostInputEstimatedMonthEntity';
  items: Array<Scalars['String']['output']>;
  month: Scalars['String']['output'];
};

/** One cost of the Intelligence Board cost inputs. Labels, units and sources live in the cost inputs catalogue. */
export enum CostInputField {
  BreakdownsTowingAccidents = 'BREAKDOWNS_TOWING_ACCIDENTS',
  CargoInsurance = 'CARGO_INSURANCE',
  CombinedWages = 'COMBINED_WAGES',
  DamageClaimsPaid = 'DAMAGE_CLAIMS_PAID',
  Depreciation = 'DEPRECIATION',
  DockPaidHours = 'DOCK_PAID_HOURS',
  DockWages = 'DOCK_WAGES',
  DockWarehouseExpenses = 'DOCK_WAREHOUSE_EXPENSES',
  DriverMeetingHours = 'DRIVER_MEETING_HOURS',
  DrugScreensHiring = 'DRUG_SCREENS_HIRING',
  EmployerPayrollTaxes = 'EMPLOYER_PAYROLL_TAXES',
  Forklifts = 'FORKLIFTS',
  Fuel = 'FUEL',
  FuelTaxesIfta = 'FUEL_TAXES_IFTA',
  GeneralLiabilityInsurance = 'GENERAL_LIABILITY_INSURANCE',
  HealthInsurance = 'HEALTH_INSURANCE',
  HelperWages = 'HELPER_WAGES',
  LinehaulCarriers = 'LINEHAUL_CARRIERS',
  LocalCarriersAgents = 'LOCAL_CARRIERS_AGENTS',
  OfficeWages = 'OFFICE_WAGES',
  OtherOfficeAdmin = 'OTHER_OFFICE_ADMIN',
  PdDriverHoursOnDock = 'PD_DRIVER_HOURS_ON_DOCK',
  PdDriverHoursOnLinehaul = 'PD_DRIVER_HOURS_ON_LINEHAUL',
  PdDriverPaidHours = 'PD_DRIVER_PAID_HOURS',
  PdDriverWages = 'PD_DRIVER_WAGES',
  RegistrationsPermits = 'REGISTRATIONS_PERMITS',
  Rent = 'RENT',
  RepairsMaintenance = 'REPAIRS_MAINTENANCE',
  RetirementMatch = 'RETIREMENT_MATCH',
  RevenueSharedWithAgents = 'REVENUE_SHARED_WITH_AGENTS',
  ServiceFailureRefunds = 'SERVICE_FAILURE_REFUNDS',
  TelematicsSoftware = 'TELEMATICS_SOFTWARE',
  TempLabor = 'TEMP_LABOR',
  Tires = 'TIRES',
  Tolls = 'TOLLS',
  TotalMiles = 'TOTAL_MILES',
  TrailerLeaseRental = 'TRAILER_LEASE_RENTAL',
  TruckInsurance = 'TRUCK_INSURANCE',
  TruckLeaseRental = 'TRUCK_LEASE_RENTAL',
  Utilities = 'UTILITIES',
  Workdays = 'WORKDAYS',
  WorkersComp = 'WORKERS_COMP'
}

export enum CostInputGroup {
  Building = 'BUILDING',
  Calendar = 'CALENDAR',
  Carriers = 'CARRIERS',
  Insurance = 'INSURANCE',
  Labor = 'LABOR',
  NonFreight = 'NON_FREIGHT',
  Trucks = 'TRUCKS'
}

export type CostInputMonthArgs = {
  includeReports?: InputMaybe<Scalars['Boolean']['input']>;
  month: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CostInputMonthEntity = {
  __typename?: 'CostInputMonthEntity';
  isOpenMonth: Scalars['Boolean']['output'];
  month: Scalars['String']['output'];
  rates?: Maybe<CostInputRatesEntity>;
  reports: Array<CostInputReportReadinessEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  values: Array<CostInputValueEntity>;
};

export type CostInputQuickbooksAccountEntity = {
  __typename?: 'CostInputQuickbooksAccountEntity';
  accountName: Scalars['String']['output'];
  field?: Maybe<CostInputField>;
  isMapped: Scalars['Boolean']['output'];
  isParentAccount: Scalars['Boolean']['output'];
  quickbooksAccountId: Scalars['String']['output'];
  recentTotalUsd: Scalars['Float']['output'];
  sectionPath: Scalars['String']['output'];
};

export type CostInputQuickbooksMappingInput = {
  field?: InputMaybe<CostInputField>;
  quickbooksAccountId: Scalars['String']['input'];
};

export type CostInputRatesEntity = {
  __typename?: 'CostInputRatesEntity';
  breakevenContributionRatio?: Maybe<Scalars['Float']['output']>;
  dockCostPerHourUsd?: Maybe<Scalars['Float']['output']>;
  dockLaborUsd: Scalars['Float']['output'];
  fixedCostPerDayUsd?: Maybe<Scalars['Float']['output']>;
  fixedCostUsd: Scalars['Float']['output'];
  insuranceClaimsUsd: Scalars['Float']['output'];
  nonFreightCostUsd: Scalars['Float']['output'];
  operationsBenefitsSharePct?: Maybe<Scalars['Float']['output']>;
  outsideCarriersUsd: Scalars['Float']['output'];
  pdCostPerHourUsd?: Maybe<Scalars['Float']['output']>;
  pdLaborUsd: Scalars['Float']['output'];
  truckCostPerMileUsd?: Maybe<Scalars['Float']['output']>;
  truckCostUsd: Scalars['Float']['output'];
  variableCostPerDayUsd?: Maybe<Scalars['Float']['output']>;
  variableCostUsd: Scalars['Float']['output'];
};

export type CostInputReportReadinessEntity = {
  __typename?: 'CostInputReportReadinessEntity';
  hasCosts: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  missing: Array<Scalars['String']['output']>;
};

export enum CostInputSource {
  Quickbooks = 'QUICKBOOKS',
  Samsara = 'SAMSARA',
  Tenet = 'TENET',
  Typed = 'TYPED'
}

export type CostInputStatusEntity = {
  __typename?: 'CostInputStatusEntity';
  driverWageSplitPct?: Maybe<Scalars['Float']['output']>;
  quickbooksConnected: Scalars['Boolean']['output'];
  quickbooksLastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  quickbooksMatchedAccountCount: Scalars['Int']['output'];
  quickbooksUnmatchedAccountCount: Scalars['Int']['output'];
  truckLeasePerMilePct?: Maybe<Scalars['Float']['output']>;
};

export enum CostInputUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Miles = 'MILES',
  Usd = 'USD'
}

export type CostInputValueEntity = {
  __typename?: 'CostInputValueEntity';
  field: CostInputField;
  quickbooksValue?: Maybe<Scalars['Float']['output']>;
  samsaraValue?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<CostInputSource>;
  tenetValue?: Maybe<Scalars['Float']['output']>;
  typedAt?: Maybe<Scalars['DateTime']['output']>;
  typedByName?: Maybe<Scalars['String']['output']>;
  typedValue?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CoverSheetDocumentTypeSequenceCreateInput = {
  documentTypes: Array<DocumentType>;
  name: Scalars['String']['input'];
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  type: CoverSheetDocumentTypeSequenceType;
};

export type CoverSheetDocumentTypeSequenceEntity = {
  __typename?: 'CoverSheetDocumentTypeSequenceEntity';
  documentTypes: Array<DocumentType>;
  name: Scalars['String']['output'];
  type: CoverSheetDocumentTypeSequenceType;
  uuid: Scalars['String']['output'];
};

export enum CoverSheetDocumentTypeSequenceType {
  Record = 'RECORD',
  Template = 'TEMPLATE'
}

export type CoverSheetDocumentTypeSequenceUpdateInput = {
  documentTypes?: InputMaybe<Array<DocumentType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<CoverSheetDocumentTypeSequenceType>;
  uuid: Scalars['String']['input'];
};

export type CreateAccessorialContactInput = {
  accessorialUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
};

export type CreateAccessorialContactOutput = {
  __typename?: 'CreateAccessorialContactOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateAccessorialDateRangeConfigInput = {
  accessorialDateRangeConfigToCopyUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialRangeCreateInputs?: InputMaybe<Array<AccessorialRangeCreateInput>>;
  accessorialUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  /** Accepts rate as a $ float with two decimal places */
  rateUsd?: InputMaybe<Scalars['Float']['input']>;
  specialChargeGroupCreateInputs?: InputMaybe<Array<SpecialAccessorialChargeGroupCreateInput>>;
  specialMatrixItemsCreateInputs?: InputMaybe<Array<SpecialAccessorialMatrixItemCreateInput>>;
  startDate: Scalars['DateTime']['input'];
};

export type CreateAccessorialDateRangeConfigOutput = {
  __typename?: 'CreateAccessorialDateRangeConfigOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateAccessorialGroupInput = {
  /** UUIDs of the accessorials that make up this group. */
  accessorialUuids: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAccessorialInput = {
  accessorialCreateInput: AccessorialCreateInput;
};

export type CreateAccountingReportDocumentOutput = {
  __typename?: 'CreateAccountingReportDocumentOutput';
  document: DocumentEntity;
};

export type CreateAddressInput = {
  addressCreateInput: AddressCreateInput;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAirportInfoInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  iataCode?: InputMaybe<Scalars['String']['input']>;
  terminal: Scalars['String']['input'];
};

export type CreateApiUserInput = {
  apiUserCreateInput: ApiUserCreateInput;
};

export type CreateAutoApplyAccessorialConfigInput = {
  /** @deprecated Use accessorialUuids instead */
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  addresses?: InputMaybe<Array<AutoApplyAccessorialConfigAddressInput>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactsToExcludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactsToIncludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleType: AutoApplyAccessorialRuleType;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopType?: InputMaybe<PickupOrDelivery>;
  tagUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateBasicDocumentInput = {
  companyUuid: Scalars['String']['input'];
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBusinessDivisionInput = {
  name: Scalars['String']['input'];
};

export type CreateBusinessDivisionOutput = {
  __typename?: 'CreateBusinessDivisionOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateCompanyInput = {
  alternateIsaId?: InputMaybe<Scalars['String']['input']>;
  alternateStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  blockSendingZeroDollarInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  companyLandscapeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  companySquareLogoUrl?: InputMaybe<Scalars['String']['input']>;
  /** A JSON object that represents the set of configurations for the company */
  configs?: InputMaybe<Scalars['String']['input']>;
  customDunningReportFooter?: InputMaybe<Scalars['String']['input']>;
  customDunningReportHeader?: InputMaybe<Scalars['String']['input']>;
  defaultAddressCreateInput: AddressCreateInput;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultMeasurementUnits: MeasurementUnits;
  defaultNonCompanyDriverSettlementMode: SettlementMode;
  defaultOrdinarySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoverySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultWeightUnits: WeightUnits;
  ediPodFilenamePrefix?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateScac?: InputMaybe<Scalars['String']['input']>;
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  freightSnapId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  isCourier?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderNameOrdinal?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  purchasedProductOfferings?: InputMaybe<Array<PalletProductOffering>>;
  qbInvoiceNumberStart?: InputMaybe<Scalars['Float']['input']>;
  qboDefaultClassId?: InputMaybe<Scalars['String']['input']>;
  qboDefaultIncomeAccountId?: InputMaybe<Scalars['String']['input']>;
  qboDefaultTaxCodeId?: InputMaybe<Scalars['String']['input']>;
  qboFreightItemId?: InputMaybe<Scalars['String']['input']>;
  qboFuelItemId?: InputMaybe<Scalars['String']['input']>;
  qboLineHaulItemId?: InputMaybe<Scalars['String']['input']>;
  quickbooksCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccessorialId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopDeliveryId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopFuelChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopLineHaulId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopOrderChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopPickupId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopRecoveryId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopTransferId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingAccessorialChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  secondAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  secondAlternateScac?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated This field is being removed. Setting this will have no effect. */
  segment?: InputMaybe<Segment>;
  sendgridSenderId?: InputMaybe<Scalars['String']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateScac?: InputMaybe<Scalars['String']['input']>;
  timeZone: Scalars['String']['input'];
  useSageBusinessWorks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateConsolidatedOrderFromOrderInput = {
  orderUuid: Scalars['String']['input'];
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConsolidatedOrderInput = {
  consolidatedOrderCreateInput: ConsolidatedOrderCreateInput;
};

export type CreateContactCommentInput = {
  comment: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};

export type CreateContactCommunicationConfigInput = {
  contactCommunicationConfigCreateInput: ContactCommunicationConfigCreateInput;
};

export type CreateContactDocumentInput = {
  contactUuid: Scalars['String']['input'];
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactEmailInput = {
  contactEmailCreateInput: ContactEmailCreateInput;
};

export type CreateContactPersonInput = {
  contactPersonCreateInput: ContactPersonCreateInput;
  contactUuid: Scalars['String']['input'];
  stopUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactToServicesMappingInput = {
  contactUuid: Scalars['String']['input'];
  serviceUuids: Array<Scalars['String']['input']>;
};

export type CreateCsvOrderFieldMappingInput = {
  csvOrderMappingUuid: Scalars['String']['input'];
  sourceColumnName: Scalars['String']['input'];
  targetFieldType: CsvOrderMappingTargetFieldType;
};

export type CreateCsvOrderImportTransactionInput = {
  bucket: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  key: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  region: Scalars['String']['input'];
  /** The raw, comma-separated string contents of the CSV row */
  row: Scalars['String']['input'];
  rowNumber: Scalars['Int']['input'];
  status: CsvOrderImportTransactionStatus;
};

export type CreateCsvOrderMappingInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  csvOrderFieldMappingCreateInputs?: InputMaybe<Array<CreateCsvOrderFieldMappingInput>>;
  deadlineDateDefaultValue?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTypeDefaultValue?: InputMaybe<DeadlineType>;
  enableDynamicInboundOrOutboundStop: Scalars['Boolean']['input'];
  enableInboundStop: Scalars['Boolean']['input'];
  enableOutboundStop: Scalars['Boolean']['input'];
  freightBillingMethodDefaultValue?: InputMaybe<FreightBillingMethod>;
  name: Scalars['String']['input'];
  pickupOrDeliveryDefaultValue?: InputMaybe<PickupOrDelivery>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopImportType: StopImportType;
  stopTypeDefaultValue?: InputMaybe<StandardStopType>;
};

export type CreateCsvOrdersOrderInput = {
  billingPartyContactUuid: Scalars['String']['input'];
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  freightChargeRate?: InputMaybe<Scalars['Float']['input']>;
  freightChargeType?: InputMaybe<FreightBillingMethod>;
  fuelChargeType?: InputMaybe<FuelBillingMethod>;
  fuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  inboundStop?: InputMaybe<ParsedCsvOrderStopInput>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundStop?: InputMaybe<ParsedCsvOrderStopInput>;
  packages: Array<CreateCsvOrdersPackageInput>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
};

/** A package that is either parsed from a CSV file or from an order part of an order that was detected in a parsed CSV file */
export type CreateCsvOrdersPackageInput = {
  class?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  freightClass?: InputMaybe<FreightClass>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** A flag that is set to true if the parsed package is one that needs to be appended to the order packages */
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  nmfc?: InputMaybe<Scalars['String']['input']>;
  packageSpecId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  type?: InputMaybe<PackageType>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateCustomerContactInput = {
  customerContactCreateInput: CustomerContactCreateInput;
};

export type CreateCustomerContactsInput = {
  customerContactCreateInputs: Array<CustomerContactCreateInput>;
};

export type CreateCustomerContactsOutput = {
  __typename?: 'CreateCustomerContactsOutput';
  customerContacts: Array<CustomerContactEntity>;
};

export type CreateDocExtractionEvalRunInput = {
  config: Scalars['JSON']['input'];
  evalSetId: Scalars['String']['input'];
  executionMode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateDocExtractionEvalSetInput = {
  config: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
};

export type CreateDocumentInput = {
  documentCreateInput: DocumentCreateInput;
};

export type CreateDriverCredentialTypeInput = {
  kind: DriverCredentialKind;
  name: Scalars['String']['input'];
};

export type CreateDriverInput = {
  driverCreateInput: DriverCreateInput;
};

export type CreateDriverInsurancePolicyInput = {
  carrierName?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  /** YYYY-MM-DD */
  effectiveOn: Scalars['String']['input'];
  /** YYYY-MM-DD */
  expiresOn: Scalars['String']['input'];
  insuranceType: Scalars['String']['input'];
  insuredAmountUsd?: InputMaybe<Scalars['Float']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDriverSettlementBillInput = {
  driverSettlementBillCreateInput: DriverSettlementBillCreateInput;
};

export type CreateDriverSignableFormTemplateInput = {
  formText: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateDriverTrainingRecordInput = {
  /** YYYY-MM-DD */
  completedOn?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  /** YYYY-MM-DD */
  expiresOn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** A TRAINING credential type. */
  typeUuid: Scalars['String']['input'];
};

export type CreateDriversInput = {
  driverCreateInputs: Array<DriverCreateInput>;
};

export type CreateDriversOutput = {
  __typename?: 'CreateDriversOutput';
  drivers: Array<DriverEntity>;
};

export type CreateDuplicateOrderForRebillInput = {
  newContactUuid: Scalars['String']['input'];
  originalOrderUuid: Scalars['String']['input'];
};

export type CreateDuplicateOrderForRebillOutput = {
  __typename?: 'CreateDuplicateOrderForRebillOutput';
  duplicatedOrder: OrderEntity;
};

export type CreateDwellTimeAlertConfigInput = {
  /** Customer (contact) this override applies to. Null = all customers. */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Whether the config participates in alerting. Defaults to true. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The dwell-time limit, in calendar days, beyond which on-dock freight is flagged. */
  thresholdDays: Scalars['Int']['input'];
  /** Warehouse this override applies to. Null = all warehouses. */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEdiPartnershipInput = {
  allowEditingShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  alternateStediPartnerId?: InputMaybe<Scalars['String']['input']>;
  autoAcceptOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canCreateMultipleStops?: InputMaybe<Scalars['Boolean']['input']>;
  companyStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  edi214ShipmentStatuses?: InputMaybe<Array<Edi214ShipmentStatus>>;
  ediOutboundPayloadDestination?: InputMaybe<EdiOutboundPayloadDestination>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  excludeZeroChargeInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreCancellations?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreNonEdiOutbound?: InputMaybe<Scalars['Boolean']['input']>;
  includeItemizedChargesIn210?: InputMaybe<Scalars['Boolean']['input']>;
  includeOutboundFilenameReceiverIsaId?: InputMaybe<Scalars['Boolean']['input']>;
  mergeLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFilenameScacPrefix?: InputMaybe<Scalars['Boolean']['input']>;
  removeSpacesFrom214Bol?: InputMaybe<Scalars['Boolean']['input']>;
  requireGenerateEdi210Ids?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo204?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo211?: InputMaybe<Scalars['Boolean']['input']>;
  sendBackupDocs?: InputMaybe<Scalars['Boolean']['input']>;
  stedi210MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi210TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi214MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi214TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi990MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi990TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stediPartnershipId?: InputMaybe<Scalars['String']['input']>;
  tiffPodUpload?: InputMaybe<Scalars['Boolean']['input']>;
  timeOfPodUpload?: InputMaybe<TimeOfPodUpload>;
  useStediGenerateEdiFunction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateEdiPartnershipServiceMappingsInput = {
  ediPartnershipServiceMappingCreateInputs: Array<EdiPartnershipServiceMappingCreateInput>;
  ediPartnershipUuid: Scalars['String']['input'];
};

export type CreateEdiPartnershipServiceMappingsOutput = {
  __typename?: 'CreateEdiPartnershipServiceMappingsOutput';
  ediPartnershipServiceMappings: Array<EdiPartnershipServiceMappingEntity>;
  /** Service names in the input that match no service the partnership customer can use; those mappings were not written. */
  unmatchedServiceNames: Array<Scalars['String']['output']>;
};

export type CreateEdiTransactionInput = {
  code: EdiTransactionCode;
  edi210NetAmountDueCents?: InputMaybe<Scalars['Int']['input']>;
  edi214ShipmentStatus?: InputMaybe<Edi214ShipmentStatus>;
  edi990ActionCode?: InputMaybe<Edi990ActionCode>;
  ediPayloadId?: InputMaybe<Scalars['String']['input']>;
  hawb?: InputMaybe<Scalars['String']['input']>;
  ignoreInAudit?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  payload: Scalars['String']['input'];
  purposeCode?: InputMaybe<EdiTransactionPurposeCode>;
  receiverIsaId: Scalars['String']['input'];
  senderIsaId: Scalars['String']['input'];
};

export type CreateEdiTransactionOutput = {
  __typename?: 'CreateEdiTransactionOutput';
  ediTransaction: EdiTransactionEntity;
};

export type CreateEmailTransactionInput = {
  contactUuid: Scalars['String']['input'];
  documentUuid: Scalars['String']['input'];
  emailResponse?: InputMaybe<Scalars['String']['input']>;
  emailResponseStatus?: InputMaybe<Scalars['Int']['input']>;
  emails: Array<Scalars['String']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  sendgridMessageId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmailTransactionOutput = {
  __typename?: 'CreateEmailTransactionOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateEndOfDayDocumentProcessingJobInput = {
  companyUuid: Scalars['String']['input'];
  dateUploadedFor: Scalars['DateTime']['input'];
  status: EndOfDayDocumentsProcessingJobStatus;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadedFileName: Scalars['String']['input'];
};

export type CreateEodDocumentsInput = {
  /** A flag that determines whether the EOD documents should be automatched to the orders */
  autoMatchingEnabled: Scalars['Boolean']['input'];
  documentCreateInputs: Array<EodDocumentCreateInput>;
  /** The UUID of the job associated with the original EOD document that was uploaded. */
  endOfDayDocumentsProcessingJobUuid: Scalars['String']['input'];
};

export type CreateEquipmentInput = {
  /** Contains equipment details */
  equipmentCreateInput: EquipmentCreateInput;
};

export type CreateEquipmentLicenseInput = {
  equipmentLicenseCreateInput: EquipmentLicenseCreateInput;
  /** UUID of the equipment this license will be associated with */
  equipmentUuid: Scalars['String']['input'];
};

export type CreateEquipmentsInput = {
  equipmentCreateInputs: Array<EquipmentCreateInput>;
};

export type CreateEquipmentsOutput = {
  __typename?: 'CreateEquipmentsOutput';
  equipments: Array<EquipmentEntity>;
};

export type CreateFeatureFlagCompanyOverrideInput = {
  active: Scalars['Boolean']['input'];
  companyUuid: Scalars['String']['input'];
  featureFlagUuid: Scalars['String']['input'];
};

export type CreateFeatureFlagInput = {
  featureFlagCreateInput: FeatureFlagCreateInput;
};

export type CreateFeatureFlagUserOverrideInput = {
  active: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  featureFlagUuid: Scalars['String']['input'];
};

export type CreateFreightChargeInput = {
  freightChargeCreateInput: FreightChargeCreateInput;
  shipmentUuid: Scalars['String']['input'];
};

export type CreateFuelProfileDateRangeInput = {
  expirationDate: Scalars['DateTime']['input'];
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  fuelProfileUuid: Scalars['String']['input'];
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  startDate: Scalars['DateTime']['input'];
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateFuelProfileDateRangeOutput = {
  __typename?: 'CreateFuelProfileDateRangeOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateFuelProfileInput = {
  billingType: FuelBillingMethod;
  expirationDate: Scalars['DateTime']['input'];
  flatRateUsdCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  surchargeRate: Scalars['Float']['input'];
  type: FuelProfileType;
};

export type CreateGeneralLedgerCodeOutput = CreateGeneralLedgerCodeSuccessOutput | MutationErrorOutput;

export type CreateGeneralLedgerCodeSuccessOutput = {
  __typename?: 'CreateGeneralLedgerCodeSuccessOutput';
  generalLedgerCode: GeneralLedgerCodeEntity;
};

export type CreateIngestionTestUploadInput = {
  companyUuid: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
};

export type CreateInventoryItemsInput = {
  itemUuid: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  /** Dictates if a new storage unit should be created. if a storageUnitUuid is supplied it will take priority */
  shouldCreateStorageUnit?: InputMaybe<Scalars['Boolean']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  /** The storage unit to associate the inventory items with, if provided */
  storageUnitUuid?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure: UnitOfMeasure;
};

export type CreateInventoryItemsOutput = {
  __typename?: 'CreateInventoryItemsOutput';
  /** The number of inventory items that were created */
  quantity: Scalars['Int']['output'];
  /** The storage unit that the items were added to, if any */
  storageUnit?: Maybe<StorageUnitEntity>;
};

export type CreateInventoryPrimaryUnitOfMeasureInput = {
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInventorySecondaryUnitOfMeasureInput = {
  primaryUnitsPerSecondaryUOM?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoiceDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  invoiceUuid: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoiceDocumentsInput = {
  createInvoiceDocumentInputs: Array<CreateInvoiceDocumentInput>;
};

export type CreateInvoiceInput = {
  invoiceCreateInput: InvoiceCreateInput;
};

export type CreateInvoiceTermsForAllInput = {
  terms: Array<Scalars['String']['input']>;
};

export type CreateItemInput = {
  contactUuid: Scalars['String']['input'];
  createInventoryPrimaryUnitOfMeasureInput: CreateInventoryPrimaryUnitOfMeasureInput;
  createInventorySecondaryUnitOfMeasureInput?: InputMaybe<CreateInventorySecondaryUnitOfMeasureInput>;
  createItemStorageUnitConfigInput?: InputMaybe<CreateItemStorageUnitConfigInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  productCost?: InputMaybe<Scalars['Float']['input']>;
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
  sku: Scalars['String']['input'];
  status: ItemStatus;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateItemLocationInput = {
  name: Scalars['String']['input'];
};

export type CreateItemLocationOutput = {
  __typename?: 'CreateItemLocationOutput';
  /** The item location that was created. It is null in the case a location with a duplicate name w.r.t to the company is passed in */
  itemLocation?: Maybe<ItemLocationEntity>;
};

export type CreateItemOutput = {
  __typename?: 'CreateItemOutput';
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<ItemEntity>;
};

export type CreateItemStorageUnitConfigInput = {
  consolidationUnitUOM: UnitOfMeasure;
  dimensionsUOM: WarehouseMeasurementUnits;
  height: Scalars['Float']['input'];
  high: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  primaryUnitsPerConsolidationUnit: Scalars['Float']['input'];
  tie: Scalars['Float']['input'];
  type: MeasurementUnits;
  weight: Scalars['Float']['input'];
  weightUOM: WarehouseMeasurementUnits;
  width: Scalars['Float']['input'];
};

export type CreateLegDriverMapInput = {
  legDriverMapCreateInput: LegDriverMapCreateInput;
};

export type CreateLegInput = {
  legCreateInput: LegCreateInput;
  /** The order of this leg relative to other legs in the same shipment */
  ordinal: Scalars['Int']['input'];
  shipmentUuid: Scalars['String']['input'];
};

export type CreateLineHaulLaneInput = {
  lineHaulLaneCreateInput: LineHaulLaneCreateInput;
};

export type CreateLineHaulLaneOutput = {
  __typename?: 'CreateLineHaulLaneOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
};

export type CreateLineHaulManifestInput = {
  lineHaulManifestCreateInput: LineHaulManifestCreateInput;
};

export type CreateLineHaulManifestsInput = {
  /** The service day as a bare YYYY-MM-DD (its noon-UTC marker is also accepted). Not an arbitrary instant - a value carrying another time of day is read on its UTC date and will land on the wrong day for companies behind UTC. */
  departDate: Scalars['String']['input'];
  lanes: Array<CreateLineHaulManifestsLaneInput>;
};

export type CreateLineHaulManifestsLaneInput = {
  count: Scalars['Int']['input'];
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type CreateLineHaulManifestsOutput = CreateLineHaulManifestsSuccessOutput | MutationErrorOutput;

export type CreateLineHaulManifestsSuccessOutput = {
  __typename?: 'CreateLineHaulManifestsSuccessOutput';
  lineHaulManifests: Array<LineHaulManifestEntity>;
};

export type CreateLineHaulSegmentInput = {
  lineHaulSegmentCreateInput: LineHaulSegmentCreateInput;
};

export type CreateLineHaulSegmentOutput = {
  __typename?: 'CreateLineHaulSegmentOutput';
  segment: LineHaulSegmentEntity;
};

export type CreateMasterAccountInput = {
  name: Scalars['String']['input'];
};

export type CreateMasterAccountOutput = {
  __typename?: 'CreateMasterAccountOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateMirrorTargetInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique environment name, e.g. "staging", "release", "dev". */
  name: Scalars['String']['input'];
  subscribesToAllCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Base URL of the target backend, e.g. https://api.staging.example.com */
  url: Scalars['String']['input'];
};

export type CreateNotificationInput = {
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverMarkedAttemptedDriverUuid?: InputMaybe<Scalars['String']['input']>;
  driverMarkedAttemptedStopUuid?: InputMaybe<Scalars['String']['input']>;
  emailTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  sourceDriverUuid?: InputMaybe<Scalars['String']['input']>;
  targetAccessorialUuid?: InputMaybe<Scalars['String']['input']>;
  targetStopUuid?: InputMaybe<Scalars['String']['input']>;
  type: NotificationType;
};

export type CreateOptimizationRunDto = {
  optimizationType?: InputMaybe<Scalars['String']['input']>;
  pinnedSlotUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
  /** @deprecated infers start address from routeUuid now */
  startAddressId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrUpdateCsvOrdersInput = {
  /** The parsed CSV orders that have to be created */
  createOrders: Array<CreateCsvOrdersOrderInput>;
  /** The parsed CSV orders that have to be updated with new packages */
  updateOrders: Array<UpdateCsvOrdersOrderInput>;
};

export type CreateOrUpdateCsvOrdersOutput = CreateOrUpdateCsvOrdersSuccessOutput | MutationErrorOutput;

export type CreateOrUpdateCsvOrdersSuccessOutput = {
  __typename?: 'CreateOrUpdateCsvOrdersSuccessOutput';
  /** The orders that were either created or updated by the CSV file */
  orders: Array<OrderEntity>;
};

/** This is the graphql input for creating or updating a customer */
export type CreateOrUpdateCustomerInput = {
  accessorialGroupId?: InputMaybe<Scalars['String']['input']>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment?: InputMaybe<Scalars['Boolean']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  calculateInboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateLineHaulFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateOutboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  customerPortalChargesVisibleFrom?: InputMaybe<CustomerPortalChargesVisibility>;
  defaultAddressUuid?: InputMaybe<Scalars['String']['input']>;
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  defaultFreightBillingMethod?: InputMaybe<FreightBillingMethod>;
  defaultFreightClass?: InputMaybe<FreightClass>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultUseTariff: Scalars['Boolean']['input'];
  displayChargesInCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomerPortalInventory?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomerPortalOrderEntry: Scalars['Boolean']['input'];
  includeInExpeditorsScorecard?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceOrOrderIdentifier: Scalars['String']['input'];
  isPrepaidOnly: Scalars['Boolean']['input'];
  referenceNumberLabels: Array<Scalars['String']['input']>;
  serviceGroupId?: InputMaybe<Scalars['String']['input']>;
  serviceUuids: Array<Scalars['String']['input']>;
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['input'];
  useCustomVehicleTypes: Scalars['Boolean']['input'];
  vehicleTypeUuids: Array<Scalars['String']['input']>;
};

export type CreateOrUpdateSettlementAdjustmentOutput = CreateOrUpdateSettlementAdjustmentSuccessOutput | MutationErrorOutput;

export type CreateOrUpdateSettlementAdjustmentSuccessOutput = {
  __typename?: 'CreateOrUpdateSettlementAdjustmentSuccessOutput';
  settlementAdjustment: SettlementAdjustmentEntity;
};

export type CreateOrderCommentInput = {
  comment: Scalars['String']['input'];
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  showOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOrderDelegationRuleInput = {
  customerOrganizationUuid?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  offerWindowMinutes?: InputMaybe<Scalars['Int']['input']>;
  orderSources?: InputMaybe<Array<OrderSource>>;
  peerUuid: Scalars['String']['input'];
  pickupHandling?: InputMaybe<DelegatedPickupHandling>;
  priority: Scalars['Int']['input'];
  scope: OrderDelegationScope;
  shareEndCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  timing: OrderDelegationRuleTiming;
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateOrderDocumentDocumentInput = {
  companyUuid: Scalars['String']['input'];
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderDocumentDocumentOutput = {
  __typename?: 'CreateOrderDocumentDocumentOutput';
  document: DocumentEntity;
};

export type CreateOrderDocumentInput = {
  customDocumentName?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The expected input for generating a report from the orders table. */
export type CreateOrderTableReportInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /** Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact. */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filters?: InputMaybe<FindOrdersFiltersInput>;
  /** Filters for orders holding SMC3 freight that needs a rate. Currently only implemented for the flat orders view. */
  freightNeedsRateFilter?: InputMaybe<BooleanFilterV2>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the invoice name on the order table field (used when useJournalNumberForInvoice is false) */
  invoiceNameFilter?: InputMaybe<StringFilterV2>;
  /** An integer filter for the invoice journal number (used when useJournalNumberForInvoice is true) */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID filter for the line haul leg destination terminal. Matches orders that have a segment whose end terminal matches. */
  lineHaulLegDestinationTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg (segment). Matches orders assigned to the specified segment via OrderLineHaulSegment. */
  lineHaulLegFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg origin terminal. Matches orders that have a segment whose start terminal matches. */
  lineHaulLegOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A filter for the order's line-haul origin terminal (the order-level origin set for "out of inventory" orders, else the on-hand terminal derivation). Used by the line-haul Outbound tab so out-of-inventory orders are discoverable under their origin terminal. */
  lineHaulOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** The list of order table fields to fetch values for */
  orderTableFields: Array<OrderTableField>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  /** A UUID filter for terminals derived from piece warehouse locations on the order. Semantics across operators: `eq` / `in` match an order when at least one piece is in a warehouse location whose warehouse belongs to one of the requested terminals. `neq` / `nin` exclude an order when ANY piece is in a warehouse location whose warehouse belongs to one of the requested terminals, so a split order with pieces at multiple terminals is excluded if any of its terminals is in the list. `isBlank` matches orders with no piece-terminal assignment at all; `isNotBlank` matches orders with at least one piece-terminal assignment. */
  pieceTerminalFilter?: InputMaybe<UuidFilterV2>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** Restrict the report to these checked orders ("Export selected orders"), intersected with any view-scoping uuids. At most 500 entries; omit to export every order matching the filters. */
  selectedOrderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** True if ascending, False if descending, undefined if no sort */
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  /** A string filter for the email of the user who created the order. */
  sourceUserEmailFilter?: InputMaybe<StringFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). When provided, the backend uses this timezone to compute day boundaries for date filters so that results reflect the calendar date in the user's local time rather than UTC. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Version ID for the request */
  versionId?: InputMaybe<Scalars['Float']['input']>;
  /** A UUID filter for the warehouse derived from piece locations on the order. This filters by Warehouse UUID (not WarehouseLocation/bin). The warehouse is determined by the unanimous piece-level warehouseId across the order. */
  warehouseLocationFilter?: InputMaybe<UuidFilterV2>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

export type CreateOrderTableReportOutput = MutationErrorOutput | OrderTableReportDownloadOutput | OrderTableReportEmailToUserOutput;

/** This is the graphql input for creating an organization */
export type CreateOrganizationInput = {
  customerFields?: InputMaybe<CreateOrUpdateCustomerInput>;
  defaultContactPersonUuid?: InputMaybe<Scalars['String']['input']>;
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isaId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  peerCompanyUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  types: Array<OrganizationType>;
};

export type CreateOrganizationMessageInput = {
  audience: OrganizationMessageAudienceInput;
  body?: Scalars['String']['input'];
  /** When the message stops showing. Omitted uses the severity default (INFO 14 days, WARNING 3 days, CRITICAL never); null means never. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  link?: InputMaybe<OrganizationMessageLinkInput>;
  severity: OrganizationMessageSeverity;
  /** Optional; most messages need only the body. */
  title?: Scalars['String']['input'];
};

export type CreateOrganizationOutput = CreateOrganizationSuccessOutput | MutationErrorOutput;

export type CreateOrganizationPeerInput = {
  organizationUuid?: InputMaybe<Scalars['String']['input']>;
  peerCompanyUuid: Scalars['String']['input'];
};

export type CreateOrganizationSuccessOutput = {
  __typename?: 'CreateOrganizationSuccessOutput';
  /** The created organization */
  organization: OrganizationEntity;
};

/** Creates new orders for one TENEDI partnership by sending generated 204 tenders through the EDI inbound handler. In production it needs confirmProductionSend and confirmProductionOrderCreation, and refuses a company and contact whose new orders would reach anyone besides Tenedi. */
export type CreateOutboundBenchOrdersInput = {
  /** The second production opt-in, for creating orders. Required, and must be true, together with confirmProductionSend when the backend runs in production. Ignored elsewhere. */
  confirmProductionOrderCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** The bench production opt-in. Required, and must be true, together with confirmProductionOrderCreation when the backend runs in production. Ignored elsewhere. */
  confirmProductionSend?: InputMaybe<Scalars['Boolean']['input']>;
  /** 1 to 10. */
  count: Scalars['Int']['input'];
  /** HHmm, 24-hour, in the stop ZIP code time zone. The EDI inbound handler places the time on the day it processes the tender, not on the date above. */
  deliveryAppointmentEnd?: InputMaybe<Scalars['String']['input']>;
  /** HHmm, 24-hour, in the stop ZIP code time zone. The EDI inbound handler places the time on the day it processes the tender, not on the date above. */
  deliveryAppointmentStart?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD. The delivery service and appointment date. */
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  ediPartnershipUuid: Scalars['String']['input'];
  /** HHmm, 24-hour, in the stop ZIP code time zone. The EDI inbound handler places the time on the day it processes the tender, not on the date above. */
  pickupAppointmentEnd?: InputMaybe<Scalars['String']['input']>;
  /** HHmm, 24-hour, in the stop ZIP code time zone. The EDI inbound handler places the time on the day it processes the tender, not on the date above. */
  pickupAppointmentStart?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD. The pickup service and appointment date. */
  pickupDate?: InputMaybe<Scalars['String']['input']>;
  /** A service level code mapped on the partnership (outboundBenchServiceLevels). The tender's order.serviceLevel. */
  serviceLevelCode?: InputMaybe<Scalars['String']['input']>;
  /** Which stops each order gets. Defaults to PICKUP_AND_DELIVERY. */
  shape?: InputMaybe<BenchTenderShape>;
};

export type CreatePackageInput = {
  orderUuid: Scalars['String']['input'];
  packageCreateInput: PackageCreateInput;
  shipmentUuid: Scalars['String']['input'];
};

export type CreatePackageSpecInput = {
  freightClass?: InputMaybe<FreightClass>;
  height?: InputMaybe<Scalars['Length']['input']>;
  length?: InputMaybe<Scalars['Length']['input']>;
  name: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type CreatePackageSpecOutput = {
  __typename?: 'CreatePackageSpecOutput';
  packageSpec: PackageSpecEntity;
};

export type CreatePackingPendencyInput = {
  assignedWarehouseEmployeeUuid?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  kind: PackingPendencyKind;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  note?: InputMaybe<Scalars['String']['input']>;
  pieceUuids: Array<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePackingPendencyOutput = {
  __typename?: 'CreatePackingPendencyOutput';
  /** The packing pendency that was created */
  packingPendency: PackingPendencyEntity;
};

export type CreatePaymentInput = {
  amountInCents: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  contactUuid: Scalars['String']['input'];
  createPaymentToOrderMappingInputs: Array<CreatePaymentToOrderMappingInput>;
  creditTypeUuid?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  glTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  paymentRail?: InputMaybe<PaymentRail>;
  paymentType: PaymentType;
  referenceNumber: Scalars['String']['input'];
};

export type CreatePaymentToOrderMappingInput = {
  amountInCents: Scalars['Int']['input'];
  orderUuid: Scalars['String']['input'];
};

export type CreatePdfColumnInput = {
  contactUuid: Scalars['String']['input'];
  pdfColumnCreateInput: PdfColumnCreateInput;
};

export type CreatePermissionInput = {
  accessLevel: AccessLevel;
  permissionResource: PermissionResource;
  roleUuid: Scalars['String']['input'];
};

export type CreatePermissionOutput = {
  __typename?: 'CreatePermissionOutput';
  success: Scalars['Boolean']['output'];
};

export type CreatePersonInput = {
  contactStationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid: Scalars['String']['input'];
  defaultDeliveryAddress?: InputMaybe<AddressUpsertInput>;
  defaultPickupAddress?: InputMaybe<AddressUpsertInput>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultVehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePersonOutput = {
  __typename?: 'CreatePersonOutput';
  person: PersonEntity;
};

export type CreatePicklistInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** List of item groups with quantities to be added to picklist */
  itemGroups: Array<UpsertPickListItemGroup>;
  outboundReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePieceDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pieceUuid: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePieceInput = {
  additionalReferenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isMisrouted?: InputMaybe<Scalars['Boolean']['input']>;
  isOverage?: InputMaybe<Scalars['Boolean']['input']>;
  isShortage?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  orderUuid: Scalars['String']['input'];
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePieceReceiptInput = {
  /** Date the shipment arrived. Required. */
  arrivedAt: Scalars['DateTime']['input'];
  billOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the contact (customer) the receipt is created for */
  contactUuid: Scalars['String']['input'];
  expectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber: Scalars['String']['input'];
  sealNumber?: InputMaybe<Scalars['String']['input']>;
  /** Set by the mobile app so the receipt is stamped with source MOBILE. Absent or false stamps WEB. */
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  supplierCompanyName?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trailerNumber?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the warehouse. When omitted, the company default warehouse is used. */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePieceReceiptOutput = {
  __typename?: 'CreatePieceReceiptOutput';
  /** The piece receipt that was created */
  pieceReceipt: PieceReceiptEntity;
};

export type CreatePieceWithoutOrderInput = {
  barcode: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  pieces?: InputMaybe<Array<OrphanPieceSpecInput>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  terminalUuid: Scalars['String']['input'];
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePlaceInput = {
  placeCreateInput: PlaceCreateInput;
};

export type CreatePodReportDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePodReportDocumentOutput = {
  __typename?: 'CreatePodReportDocumentOutput';
  document: DocumentEntity;
};

export type CreateProratedConsolidatedOrderInput = {
  shipmentUuids: Array<Scalars['String']['input']>;
};

export type CreateProratedConsolidatedOrderOutput = {
  __typename?: 'CreateProratedConsolidatedOrderOutput';
  consolidatedOrderUuid?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderEntity>;
};

export type CreateQuickbooksHeaderFileMappingInput = {
  quickbooksHeaderFileMappingCreateInput: QuickbooksHeaderFileMappingCreateInput;
};

export type CreateQuoteAgentForwardingAddressOutput = CreateQuoteAgentForwardingAddressSuccessOutput | MutationErrorOutput;

export type CreateQuoteAgentForwardingAddressSuccessOutput = {
  __typename?: 'CreateQuoteAgentForwardingAddressSuccessOutput';
  connection: QuoteAgentConnection;
};

export type CreateQuoteInput = {
  quoteCreateInput: QuoteCreateInput;
};

export type CreateRecurringLineHaulManifestTemplateInput = {
  autoGenerate?: InputMaybe<Scalars['Boolean']['input']>;
  createAheadDays?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use createAheadDays. This field no longer affects generation. */
  createInAdvanceHours?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek: Array<DayOfWeekAll>;
  defaultDriverUuid?: InputMaybe<Scalars['String']['input']>;
  defaultEquipmentUuid?: InputMaybe<Scalars['String']['input']>;
  departTimeMinutes: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  manifestsPerOccurrence?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated No longer affects generation. Off-weeks are expressed as skipDates. */
  repeatFrequencyUnit?: InputMaybe<RepeatFrequencyUnit>;
  /** @deprecated No longer affects generation. Off-weeks are expressed as skipDates. */
  repeatInterval?: InputMaybe<Scalars['Int']['input']>;
  skipDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startDate: Scalars['DateTime']['input'];
  startTerminalUuid: Scalars['String']['input'];
  transitMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRecurringOrderFrequencyInput = {
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysOfWeek: Array<DayOfWeekAll>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  repeatFrequencyUnit?: InputMaybe<RepeatFrequencyUnit>;
  repeatInterval?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use repeatInterval instead */
  repeatIntervalWeeks?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type CreateRecurringTemplateTruckInput = {
  cutoffTime?: InputMaybe<Scalars['String']['input']>;
  daysOfWeek?: InputMaybe<Array<DayOfWeekAll>>;
  label: Scalars['String']['input'];
  powerUnitEquipmentUuid?: InputMaybe<Scalars['String']['input']>;
  recurringTemplateUuid: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  trailers: Array<RecurringTemplateTruckTrailerInput>;
};

export type CreateReverseOrderInput = {
  orderUuid: Scalars['String']['input'];
  pieceUuids: Array<Scalars['String']['input']>;
};

export type CreateRoleInput = {
  isInternalRole: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateRoleOutput = {
  __typename?: 'CreateRoleOutput';
  role: RoleEntity;
};

export type CreateRouteDriverInput = {
  routeDriverCreateInput: RouteDriverCreateInput;
};

export type CreateRouteFromRouteTemplateInput = {
  /** The date for which to create the route and its orders, defaults to the current date */
  date?: InputMaybe<PlainDateInput>;
  /** The UUID of a run (to be renamed to route template) */
  routeTemplateUuid: Scalars['String']['input'];
};

export type CreateRouteFromRouteTemplateOutput = CreateRouteFromRouteTemplateSuccessOutput | MutationErrorOutput;

export type CreateRouteFromRouteTemplateSuccessOutput = {
  __typename?: 'CreateRouteFromRouteTemplateSuccessOutput';
  /** The orders that were created and added to the route */
  orders: Array<OrderEntity>;
  /** The newly created route or an existing route that was updated */
  route: RouteEntity;
};

export type CreateRouteInput = {
  routeCreateInput: RouteCreateInput;
};

export type CreateRouteNameInput = {
  routeNameCreateInput: RouteNameCreateInput;
};

export type CreateRouteNameLocationInput = {
  routeNameLocationCreateInput: RouteNameLocationCreateInput;
  routeNameUuid: Scalars['String']['input'];
};

export type CreateRouteOptimizationInput = {
  routeOptimizationCreateInput: RouteOptimizationCreateInput;
};

export type CreateRouteSlotInput = {
  routeSlotCreateInput: RouteSlotCreateInput;
  routeUuid: Scalars['String']['input'];
};

export type CreateRoutesInput = {
  routeCreateInputs: Array<RouteCreateInput>;
};

export type CreateRunInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRunOutput = {
  __typename?: 'CreateRunOutput';
  run: RunEntity;
};

export type CreateSameDayDispatchConfigInput = {
  deliveryAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  deliveryWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
  isNextInRouteColorCode?: InputMaybe<Scalars['String']['input']>;
  isPastDeadlineColorCode?: InputMaybe<Scalars['String']['input']>;
  isSpecialColorCode?: InputMaybe<Scalars['String']['input']>;
  pickupAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  pickupWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSamsaraOauthTokenInput = {
  accessToken: Scalars['String']['input'];
  expiresAt: Scalars['DateTime']['input'];
  refreshToken: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  tokenType: Scalars['String']['input'];
};

export type CreateSandboxRouteForDriverInput = {
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreateSavedFilterViewInput = {
  /** The page's default tab the view is based on (e.g. a Billing Review tab). Null means the page's base tab. */
  baseTab?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  displayName: Scalars['String']['input'];
  filterModelJson: Scalars['String']['input'];
  filterModelJsonV2?: InputMaybe<Scalars['JSON']['input']>;
  /** Ordered list of OrderTableField values the orders grid groups by, outermost first. Omit or pass null for an ungrouped view. */
  groupModelJson?: InputMaybe<Scalars['JSON']['input']>;
  /** The line-haul dispatch board filters to restore with the view. Only accepted on LINE_HAUL_ORDERS views; null on update clears them. */
  lineHaulDispatchFilters?: InputMaybe<SavedLineHaulDispatchFiltersInput>;
  orderTableFields: Array<OrderTableField>;
  savedViewPageType: FilterViewPage;
  sortModelJson?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type CreateScannedOrdersFromAdminInput = {
  scannedOrderCreateInputs: Array<ScannedOrderFromAdminCreateInput>;
};

export type CreateScannedOrdersInput = {
  scannedOrderCreateInputs: Array<ScannedOrderCreateInput>;
};

export type CreateSchedulingRegionInput = {
  dailyCapacityPieces?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityStops?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityWeight?: InputMaybe<Scalars['Mass']['input']>;
  name: Scalars['String']['input'];
};

export type CreateSchedulingRegionOutput = CreateSchedulingRegionSuccessOutput | MutationErrorOutput;

export type CreateSchedulingRegionSuccessOutput = {
  __typename?: 'CreateSchedulingRegionSuccessOutput';
  schedulingRegion: SchedulingRegionEntity;
};

export type CreateSchedulingResourceInput = {
  /** Null means the resource has no piece limit. */
  capacityPieces?: InputMaybe<Scalars['Int']['input']>;
  /** Null means the resource has no stop limit. */
  capacityStops?: InputMaybe<Scalars['Int']['input']>;
  /** Null means the resource has no weight limit. */
  capacityWeight?: InputMaybe<Scalars['Mass']['input']>;
  dayOfWeek: DayOfWeekAll;
  /** Earlier than start is accepted and means the window crosses midnight: the end then belongs to the calendar day after dayOfWeek, read in this resource timeZone. Nothing else has to be sent to say so. Equal to start is rejected, so a 24-hour window is not representable: express it as 00:00 to 23:59. Both fields are required and the columns behind them are NOT NULL, so a resource with no window at all is not representable either. */
  end: PlainTimeInput;
  name: Scalars['String']['input'];
  /** UUIDs of the route names this resource covers. At least one is required. The capacity below is the total across all of them, not a per-route-name allowance. */
  routeNameUuids: Array<Scalars['String']['input']>;
  start: PlainTimeInput;
  /** Canonical IANA region time zone the start and end times are read in, for example America/New_York. Fixed offsets, abbreviations and Etc/* zones are rejected because they are blind to daylight saving. Defaults to the company time zone. */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSchedulingZoneInput = {
  availabilities?: InputMaybe<Array<SchedulingZoneAvailabilityUpsertInput>>;
  locations?: InputMaybe<Array<SchedulingZoneLocationUpsertInput>>;
  name: Scalars['String']['input'];
  schedulingRegionId: Scalars['String']['input'];
};

export type CreateSchedulingZoneOutput = CreateSchedulingZoneSuccessOutput | MutationErrorOutput;

export type CreateSchedulingZoneSuccessOutput = {
  __typename?: 'CreateSchedulingZoneSuccessOutput';
  schedulingZone: SchedulingZoneEntity;
};

export type CreateSchemaCompanyMappingInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSchemaDocumentInput = {
  schemaCompanyMappingUuid?: InputMaybe<Scalars['String']['input']>;
  schemaDocument: SchemaDocumentInput;
  schemaUuid: Scalars['String']['input'];
};

export type CreateSchemaInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  schema: SchemaInput;
};

export type CreateSchemaTestSnapshotInput = {
  uuid: Scalars['String']['input'];
};

export type CreateServiceGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** UUIDs of the services that make up this group. */
  serviceUuids: Array<Scalars['String']['input']>;
};

export type CreateServiceInput = {
  serviceCreateInput: ServiceCreateInput;
};

/** An object describing the service regions to create */
export type CreateServiceRegionsInput = {
  serviceRegions: Array<CreateServiceRegionsRegionInput>;
};

export type CreateServiceRegionsOutput = CreateServiceRegionsSuccessOutput | MutationErrorOutput;

/** An object describing the region operated in by a company or agent */
export type CreateServiceRegionsRegionInput = {
  name: Scalars['String']['input'];
};

export type CreateServiceRegionsSuccessOutput = {
  __typename?: 'CreateServiceRegionsSuccessOutput';
  /** All of the company's service regions, including the ones created  */
  serviceRegions: Array<ServiceRegionEntity>;
};

export type CreateSftpCredentialsInput = {
  bundleShipmentPhotosWithPod?: InputMaybe<Scalars['Boolean']['input']>;
  ediPartnershipUuid?: InputMaybe<Scalars['String']['input']>;
  host: Scalars['String']['input'];
  invoicePath?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  path: Scalars['String']['input'];
  podNamingConvention: PodNamingConvention;
  port: Scalars['Int']['input'];
  username: Scalars['String']['input'];
};

export type CreateSftpCredentialsOutput = {
  __typename?: 'CreateSftpCredentialsOutput';
  sftpCredentials: SftpCredentialsEntity;
};

export type CreateShipmentDocumentInput = {
  customDocumentName?: InputMaybe<Scalars['String']['input']>;
  documentType: DocumentType;
  driverFormTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  isNewlyCreatedShipment?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  shipmentUuid: Scalars['String']['input'];
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStandardOrderFieldsInput = {
  standardOrderFieldsCreateInput: StandardOrderFieldsCreateInput;
};

export type CreateStandardOrderInput = {
  orderCreateInput: StandardOrderCreateInput;
  timingData?: InputMaybe<CreateStandardOrderTimingData>;
};

export type CreateStandardOrderTimingData = {
  durationMs: Scalars['Float']['input'];
  endTimeUnix: Scalars['Float']['input'];
  startTimeUnix: Scalars['Float']['input'];
};

export type CreateStandardShipmentFieldInput = {
  standardShipmentFieldsCreateInput: StandardShipmentFieldsCreateInput;
};

export type CreateStorageOrderDocumentInput = {
  documentType: DocumentType;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStorageOrderDocumentOutput = {
  __typename?: 'CreateStorageOrderDocumentOutput';
  document: DocumentEntity;
};

export type CreateStorageOrderInput = {
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the contact for whom the storage order is being created */
  contactUuid: Scalars['String']['input'];
  expectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber: Scalars['String']['input'];
  sealNumber?: InputMaybe<Scalars['String']['input']>;
  supplierCompanyName?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trailerNumber?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStorageOrderOutput = {
  __typename?: 'CreateStorageOrderOutput';
  /** The storage order that was created */
  storageOrder: StorageOrderEntity;
};

export type CreateStorageUnitInput = {
  height?: InputMaybe<Scalars['Length']['input']>;
  length?: InputMaybe<Scalars['Length']['input']>;
  /** If a name is not passed in, it is autogenerated */
  name?: InputMaybe<Scalars['String']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  /** If a unit of measure is not passed in, the default contact unit of measure will be used */
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type CreateStorageUnitOutput = {
  __typename?: 'CreateStorageUnitOutput';
  storageUnit: StorageUnitEntity;
};

export type CreateStorageUnitWithInventoryItemsInput = {
  /** The UoM of the inventory items */
  itemUnitOfMeasure: UnitOfMeasure;
  /** The UUID of the item to create the inventory items for */
  itemUuid: Scalars['String']['input'];
  /** The name of the storage unit. If not supplied, will generate one based on contact reference ID */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The number of inventory items to create and associate with the storage unit */
  quantity: Scalars['Int']['input'];
  /** The UUID of the storage order to create the storage unit for */
  storageOrderUuid: Scalars['String']['input'];
  /** The UoM of the storage unit */
  unitOfMeasure: UnitOfMeasure;
};

export type CreateStorageUnitWithInventoryItemsOutput = {
  __typename?: 'CreateStorageUnitWithInventoryItemsOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateTagInput = {
  tagCreateInput: TagCreateInput;
};

export type CreateTariffChainInput = {
  name: Scalars['String']['input'];
  tariffGroupType: TariffGroupType;
  tariffGroupUuids: Array<Scalars['String']['input']>;
};

export type CreateTariffChainOutput = CreateTariffChainSuccessOutput | MutationErrorOutput;

export type CreateTariffChainSuccessOutput = {
  __typename?: 'CreateTariffChainSuccessOutput';
  /** The tariff chain that was created */
  tariffChain: TariffChainEntity;
};

export type CreateTariffGroupInput = {
  contactToServicesMappings: Array<CreateContactToServicesMappingInput>;
  contactUuids: Array<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentTariffGroupUuid?: InputMaybe<Scalars['String']['input']>;
  rateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  rateType: RateType;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tariffCreateInputs: Array<TariffCreateInput>;
  tariffGroupScope?: InputMaybe<TariffGroupScope>;
  tariffGroupType: TariffGroupType;
  tariffOverageRateCreates?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  tariffType: TariffType;
  tariffZoneCreateInputs: Array<TariffZoneCreateInput>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUpdateInputs: Array<TariffZoneUpdateInput>;
  terminalUuids: Array<Scalars['String']['input']>;
  useActualWeightInCalculation: Scalars['Boolean']['input'];
  useDeficitBilling?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneType: TariffZoneType;
};

export type CreateTariffInput = {
  /** Tariff Create Input */
  tariffCreateInput: TariffCreateInput;
  tariffGroupUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTariffLocationInput = {
  tariffLocationCreateInput: TariffLocationCreateInput;
  tariffZoneUuid: Scalars['String']['input'];
};

export type CreateTariffLocationOutput = {
  __typename?: 'CreateTariffLocationOutput';
  tariffLocation: TariffLocationEntity;
};

export type CreateTariffOutput = {
  __typename?: 'CreateTariffOutput';
  tariff: TariffEntity;
};

export type CreateTerminalInput = {
  terminalCreateInput: TerminalCreateInput;
};

/** An object describing the lanes to create between terminals. Each lane is a direct connection between two terminals. Specifying a start/end terminal combination that already exists has no effect. */
export type CreateTerminalLanesInput = {
  terminalLanes: Array<CreateTerminalLanesLaneInput>;
};

/** An object representing a lane between two terminals, meaning orders can be moved directly from the start to the end terminal. */
export type CreateTerminalLanesLaneInput = {
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type CreateTerminalLanesOutput = CreateTerminalLanesSuccessOutput | MutationErrorOutput;

export type CreateTerminalLanesSuccessOutput = {
  __typename?: 'CreateTerminalLanesSuccessOutput';
  /** All of the company’s terminal lanes, including the ones created */
  terminalLanes: Array<TerminalLaneEntity>;
};

export type CreateTerminalOutput = {
  __typename?: 'CreateTerminalOutput';
  terminal: TerminalEntity;
};

export type CreateTerminalServiceAreaInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  terminalUuid: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type CreateTerminalServiceAreaOutput = {
  __typename?: 'CreateTerminalServiceAreaOutput';
  city?: Maybe<Scalars['String']['output']>;
  createdServiceAreaUuid?: Maybe<Scalars['String']['output']>;
  nameOfTerminalContainingThisZipcode?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export type CreateTerminalServiceAreaV2Output = {
  __typename?: 'CreateTerminalServiceAreaV2Output';
  createdCount?: Maybe<Scalars['Int']['output']>;
};

export type CreateTerminalSuccessOutput = {
  __typename?: 'CreateTerminalSuccessOutput';
  /** The created terminal */
  terminal: TerminalEntity;
};

export type CreateTerminalV2Output = CreateTerminalSuccessOutput | MutationErrorOutput;

export type CreateTerminalsInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the terminals downloaded from Crown */
  terminalsUrl: Scalars['String']['input'];
};

export type CreateTestAbstainedScannedOrderInput = {
  candidateCount?: InputMaybe<Scalars['Int']['input']>;
  companyUuid: Scalars['String']['input'];
  snapshotCorrelationId?: InputMaybe<Scalars['String']['input']>;
  withoutUploader?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTestAbstainedScannedOrderOutput = {
  __typename?: 'CreateTestAbstainedScannedOrderOutput';
  candidateContactNames: Array<Scalars['String']['output']>;
  candidateContactUuids: Array<Scalars['String']['output']>;
  scannedOrderResultUuid: Scalars['String']['output'];
  scannedOrderUuid: Scalars['String']['output'];
};

export type CreateTestAccessorialInput = {
  companyUuid: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** Flat rate in US cents per unit. */
  rateUsdCents: Scalars['Int']['input'];
};

export type CreateTestAccessorialOutput = {
  __typename?: 'CreateTestAccessorialOutput';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CreateTestApiOrderInput = {
  billingContactUuid: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  destination?: InputMaybe<TestApiOrderDestinationStopInput>;
  emergencyResponseNumber?: InputMaybe<Scalars['String']['input']>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  hazmatClass?: InputMaybe<HazmatClass>;
  hazmatDescription?: InputMaybe<Scalars['String']['input']>;
  houseAirwayBillNumber: Scalars['String']['input'];
  isLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<TestApiOrderOriginStopInput>;
  packageGroup?: InputMaybe<PackageGroup>;
  packages: Array<TestApiOrderPackageInput>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  requiresPlacard?: InputMaybe<Scalars['Boolean']['input']>;
  serviceLevelUuid?: InputMaybe<Scalars['String']['input']>;
  unNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTestCompanyInput = {
  /** If set, overrides the default dim factor of 250 for the company */
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  /** If set to true, line haul configs are enabled */
  isLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, multi-terminal configs are enabled */
  isMultiTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, the logistics section (In Bond / Hazmat / Door to door) is enabled on the order form */
  logisticsSectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, requires POD photo and name */
  requirePODPhotoAndName?: InputMaybe<Scalars['Boolean']['input']>;
  segment: Segment;
  /** If set to true, enables the T2T master delegation gate (t2tDelegationEnabled) for this company */
  t2tDelegationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, enables the T2T sync sub-gate (t2tSyncEnabled) for this company. Has no effect unless t2tDelegationEnabled is also true. */
  t2tSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTestCompanyOutput = {
  __typename?: 'CreateTestCompanyOutput';
  company: CompanyEntity;
  inboundTerminal: TerminalEntity;
  outboundTerminal: TerminalEntity;
  users: Array<UserEntity>;
};

export type CreateTestContactInput = {
  companyUuid: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTestContactOutput = {
  __typename?: 'CreateTestContactOutput';
  contact: ContactEntity;
};

export type CreateTestDelegatableOrderInput = {
  companyUuid: Scalars['String']['input'];
};

export type CreateTestDelegatableOrderOutput = {
  __typename?: 'CreateTestDelegatableOrderOutput';
  uuid: Scalars['String']['output'];
};

export type CreateTestEdiOrderInput = {
  payload: Scalars['JSON']['input'];
};

export type CreateTestOrderCustomChargeInput = {
  customChargeUuid: Scalars['String']['input'];
  testOrderUuid: Scalars['String']['input'];
  total: Scalars['Float']['input'];
};

export type CreateTestOrderCustomChargeOutput = {
  __typename?: 'CreateTestOrderCustomChargeOutput';
  success: Scalars['Boolean']['output'];
};

export type CreateTestOrderDelegationInput = {
  autoAccept?: InputMaybe<Scalars['Boolean']['input']>;
  orderUuid: Scalars['String']['input'];
  originatorCompanyUuid: Scalars['String']['input'];
  parts: Array<OrderDelegationPart>;
  peerCompanyUuid: Scalars['String']['input'];
  pickupHandling?: InputMaybe<DelegatedPickupHandling>;
  shareEndCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTestOrderDelegationOutput = {
  __typename?: 'CreateTestOrderDelegationOutput';
  delegationUuid: Scalars['String']['output'];
  duplicateOrderUuid?: Maybe<Scalars['String']['output']>;
};

export type CreateTestOrderDeliveryAppointmentInput = {
  /** Overrides the delivery stop's city, to place it in a route name's service area. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Delivery day, YYYY-MM-DD. The appointment runs 09:00 to 11:00 in the company time zone. */
  serviceDateIso8601: Scalars['String']['input'];
  /** Overrides the delivery stop's zipcode. */
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTestOrderInput = {
  /** The delivery date and appointment window for the delivery stop. Only supported with stopType DELIVERY, and not together with deliveryAppointment. */
  appointment?: InputMaybe<TestOrderAppointmentInput>;
  companyUuid: Scalars['String']['input'];
  /** If set to true, it creates a freight charge and fuel charge for the inbound stop */
  createInboundStopFreightChargeAndFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, it creates a freight charge and fuel charge for the line haul */
  createLineHaulFreightChargeAndFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, it creates a freight charge and fuel charge for the outbound stop */
  createOutboundStopFreightChargeAndFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Creates the order with status DELIVERED, so billing review lists it as unfinalized. Stops keep their seeded status. */
  delivered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gives the delivery stop a delivery date and an appointment. Only valid with stopType DELIVERY, and not together with appointment. */
  deliveryAppointment?: InputMaybe<CreateTestOrderDeliveryAppointmentInput>;
  ratingErrorCode?: InputMaybe<ExternalRatingErrorCode>;
  /** Moves every freight charge the order creates to SMC3 billing. NEEDS_RATE stores it not yet rated; RATED stores a rated total with no SMC3 exchange behind it. */
  smc3FreightState?: InputMaybe<TestSmc3FreightState>;
  /** Gives every pickup or delivery stop a real US address and its terminal, the terminals US addresses, the order a line haul lane, and the order one 500 lb class 70 pallet, so SMC3 can rate the freight. */
  smc3RatableDetails?: InputMaybe<Scalars['Boolean']['input']>;
  /** The combination of inbound and outbound stops to create for the order */
  stopType: TestOrderStopType;
  /** If set to true, the order gets the company's first service and default dim factor, which the order form needs before it will rate the order */
  withRatingDefaults?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTestOrderOutput = {
  __typename?: 'CreateTestOrderOutput';
  order: OrderEntity;
};

export type CreateTestOrderQuoteInput = {
  attentionReasons?: InputMaybe<Array<QuoteAttentionReason>>;
  chargeTotalCents?: InputMaybe<Scalars['Int']['input']>;
  companyUuid: Scalars['String']['input'];
  draftReplyApproved?: InputMaybe<Scalars['Boolean']['input']>;
  draftReplyBody?: InputMaybe<Scalars['String']['input']>;
  draftReplyKind?: InputMaybe<QuoteDraftReplyKind>;
  earlierReplyBody?: InputMaybe<Scalars['String']['input']>;
  needsAttention?: InputMaybe<Scalars['Boolean']['input']>;
  quotedAmountCents?: InputMaybe<Scalars['Int']['input']>;
  senderAddress: Scalars['String']['input'];
  senderRecoveredFromForward?: InputMaybe<Scalars['Boolean']['input']>;
  status: OrderQuoteStatus;
  subject?: InputMaybe<Scalars['String']['input']>;
  withDraftOrder: Scalars['Boolean']['input'];
};

export type CreateTestOrderQuoteOutput = {
  __typename?: 'CreateTestOrderQuoteOutput';
  contactUuid?: Maybe<Scalars['String']['output']>;
  draftReplyUuid?: Maybe<Scalars['String']['output']>;
  orderQuoteUuid: Scalars['String']['output'];
  orderUuid?: Maybe<Scalars['String']['output']>;
};

export type CreateTestOrderRequest = {
  orderUuid: Scalars['String']['input'];
  totalCharge: Scalars['Float']['input'];
  totalFreightCharge: Scalars['Float']['input'];
  totalFuelCharge: Scalars['Float']['input'];
};

export type CreateTestOrderResponse = {
  __typename?: 'CreateTestOrderResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateTestOrganizationPeerInput = {
  companyUuid: Scalars['String']['input'];
  peerCompanyUuid: Scalars['String']['input'];
};

export type CreateTestOrganizationPeerOutput = {
  __typename?: 'CreateTestOrganizationPeerOutput';
  companyUuid: Scalars['String']['output'];
  peerCompanyUuid: Scalars['String']['output'];
  peerUuid: Scalars['String']['output'];
  reciprocalPeerUuid: Scalars['String']['output'];
};

export type CreateTestPiecesOnOrderInput = {
  count: Scalars['Int']['input'];
  linkToPackage?: InputMaybe<Scalars['Boolean']['input']>;
  orderUuid: Scalars['String']['input'];
  referenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  status: PieceStatus;
};

export type CreateTestPiecesOutput = {
  __typename?: 'CreateTestPiecesOutput';
  pieces: Array<TestPieceOutput>;
};

export type CreateTestReviewOrderInput = {
  companyUuid: Scalars['String']['input'];
  isDraftOrder: Scalars['Boolean']['input'];
  requireReviewForEdiOrderCreation?: InputMaybe<Scalars['Boolean']['input']>;
  source: OrderSource;
};

export type CreateTestReviewOrderOutput = {
  __typename?: 'CreateTestReviewOrderOutput';
  contactUuid: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
};

export type CreateTestTerminalLaneInput = {
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type CreateTestThirdPartyUserInput = {
  companyUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type CreateTestThirdPartyUserOutput = {
  __typename?: 'CreateTestThirdPartyUserOutput';
  contactUuid: Scalars['String']['output'];
  email: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CreateTruckRunsInput = {
  date: Scalars['String']['input'];
  recurringTemplateTruckUuids: Array<Scalars['String']['input']>;
};

export type CreateUserInput = {
  arrangeStopsAndRoutesVertically?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, the user is assigned an internal role that provides them with the master permission resource */
  assignInternalRole?: InputMaybe<Scalars['Boolean']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dispatchTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  email: Scalars['String']['input'];
  invoicesTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  lineHaulOrderTableFields?: InputMaybe<Array<OrderTableField>>;
  linehaulDispatchTableFields?: InputMaybe<Array<LinehaulDispatchTableField>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfStops?: InputMaybe<Scalars['Float']['input']>;
  orderTableFields?: InputMaybe<Array<OrderTableField>>;
  ordersTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The list of roles to assign to a user */
  roleUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardWidth?: InputMaybe<Scalars['Float']['input']>;
  sendAllInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  sendSummaryEmailWithIncompleteRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateUserOutput = ArchivedUserExistsOutput | CreateUserSuccessOutput | MutationErrorOutput;

export type CreateUserSuccessOutput = {
  __typename?: 'CreateUserSuccessOutput';
  user: UserEntity;
};

export type CreateWarehouseEmployeeInput = {
  active: Scalars['Boolean']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreateWarehouseEmployeeOutput = {
  __typename?: 'CreateWarehouseEmployeeOutput';
  /** The created warehouse employee. It is null if there is a duplicate phone number being used or a server-side error occurs. */
  warehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
};

export type CreateWarehouseInput = {
  addressCreateInput: AddressCreateInput;
  name: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWarehouseLocationInput = {
  location1?: InputMaybe<Scalars['String']['input']>;
  location2?: InputMaybe<Scalars['String']['input']>;
  location3?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWarehouseLocationOutput = {
  __typename?: 'CreateWarehouseLocationOutput';
  /** An array of error messages. This is null if there are no errors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The warehouse location that was created. This is null if there is a warehouse location with a duplicate name passed in or  */
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type CreditTypeCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreditTypeEntity = {
  __typename?: 'CreditTypeEntity';
  color?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  name: Scalars['String']['output'];
  systemKey?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type CreditTypeUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  generalLedgerCodeId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type CsvOrderFieldMappingEntity = {
  __typename?: 'CsvOrderFieldMappingEntity';
  createdAt: Scalars['DateTime']['output'];
  sourceColumnName: Scalars['String']['output'];
  targetFieldType: CsvOrderMappingTargetFieldType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum CsvOrderImportStatus {
  Accepted = 'ACCEPTED',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED'
}

export type CsvOrderImportTransactionEntity = {
  __typename?: 'CsvOrderImportTransactionEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  /** The raw, comma-separated string contents of the CSV row */
  row: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  status: CsvOrderImportTransactionStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum CsvOrderImportTransactionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type CsvOrderMappingEntity = {
  __typename?: 'CsvOrderMappingEntity';
  contact?: Maybe<ContactEntity>;
  createdAt: Scalars['DateTime']['output'];
  csvOrderFieldMappings: Array<CsvOrderFieldMappingEntity>;
  deadlineDateDefaultValue?: Maybe<Scalars['DateTime']['output']>;
  deadlineTypeDefaultValue?: Maybe<DeadlineType>;
  enableDynamicInboundOrOutboundStop: Scalars['Boolean']['output'];
  enableInboundStop: Scalars['Boolean']['output'];
  enableOutboundStop: Scalars['Boolean']['output'];
  freightBillingMethodDefaultValue?: Maybe<FreightBillingMethod>;
  name: Scalars['String']['output'];
  pickupOrDeliveryDefaultValue?: Maybe<PickupOrDelivery>;
  serviceLevelDefaultValue?: Maybe<ServiceEntity>;
  stopTypeDefaultValue?: Maybe<StandardStopType>;
  /** A flag that, if set, ensures that any imports with this mapping treats rows with duplicate HAWBs as updates to existing orders rather than duplicate entries to be skipped. */
  updateOrderOnDuplicateBolNumber?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type CsvOrderMappingQueryInput = {
  uuid: Scalars['String']['input'];
};

export enum CsvOrderMappingTargetFieldType {
  AddressCity = 'ADDRESS_CITY',
  AddressLine_1 = 'ADDRESS_LINE_1',
  AddressLine_2 = 'ADDRESS_LINE_2',
  AddressName = 'ADDRESS_NAME',
  AddressState = 'ADDRESS_STATE',
  AddressZip = 'ADDRESS_ZIP',
  AppointmentEndTime = 'APPOINTMENT_END_TIME',
  AppointmentRequired = 'APPOINTMENT_REQUIRED',
  AppointmentStartTime = 'APPOINTMENT_START_TIME',
  Contact = 'CONTACT',
  ContactPersonEmail = 'CONTACT_PERSON_EMAIL',
  ContactPersonFirstName = 'CONTACT_PERSON_FIRST_NAME',
  ContactPersonLastName = 'CONTACT_PERSON_LAST_NAME',
  ContactPersonPhone = 'CONTACT_PERSON_PHONE',
  CustomerReferenceNumber = 'CUSTOMER_REFERENCE_NUMBER',
  DeadlineDate = 'DEADLINE_DATE',
  DeadlineType = 'DEADLINE_TYPE',
  DriverName = 'DRIVER_NAME',
  DriverReferenceNumber = 'DRIVER_REFERENCE_NUMBER',
  FreightChargeRate = 'FREIGHT_CHARGE_RATE',
  Hawb = 'HAWB',
  InboundAddressCity = 'INBOUND_ADDRESS_CITY',
  InboundAddressLine_1 = 'INBOUND_ADDRESS_LINE_1',
  InboundAddressLine_2 = 'INBOUND_ADDRESS_LINE_2',
  InboundAddressName = 'INBOUND_ADDRESS_NAME',
  InboundAddressState = 'INBOUND_ADDRESS_STATE',
  InboundAddressZip = 'INBOUND_ADDRESS_ZIP',
  InboundAppointmentEndTime = 'INBOUND_APPOINTMENT_END_TIME',
  InboundAppointmentRequired = 'INBOUND_APPOINTMENT_REQUIRED',
  InboundAppointmentStartTime = 'INBOUND_APPOINTMENT_START_TIME',
  InboundContactPersonEmail = 'INBOUND_CONTACT_PERSON_EMAIL',
  InboundContactPersonFirstName = 'INBOUND_CONTACT_PERSON_FIRST_NAME',
  InboundContactPersonLastName = 'INBOUND_CONTACT_PERSON_LAST_NAME',
  InboundContactPersonName = 'INBOUND_CONTACT_PERSON_NAME',
  InboundContactPersonPhone = 'INBOUND_CONTACT_PERSON_PHONE',
  InboundDeadlineDate = 'INBOUND_DEADLINE_DATE',
  InboundDeadlineType = 'INBOUND_DEADLINE_TYPE',
  InboundDriverName = 'INBOUND_DRIVER_NAME',
  InboundDriverReferenceNumber = 'INBOUND_DRIVER_REFERENCE_NUMBER',
  InboundSpecialInstructions = 'INBOUND_SPECIAL_INSTRUCTIONS',
  InboundTerminalName = 'INBOUND_TERMINAL_NAME',
  Mawb = 'MAWB',
  Notes = 'NOTES',
  OutboundAddressCity = 'OUTBOUND_ADDRESS_CITY',
  OutboundAddressLine_1 = 'OUTBOUND_ADDRESS_LINE_1',
  OutboundAddressLine_2 = 'OUTBOUND_ADDRESS_LINE_2',
  OutboundAddressName = 'OUTBOUND_ADDRESS_NAME',
  OutboundAddressState = 'OUTBOUND_ADDRESS_STATE',
  OutboundAddressZip = 'OUTBOUND_ADDRESS_ZIP',
  OutboundAppointmentEndTime = 'OUTBOUND_APPOINTMENT_END_TIME',
  OutboundAppointmentRequired = 'OUTBOUND_APPOINTMENT_REQUIRED',
  OutboundAppointmentStartTime = 'OUTBOUND_APPOINTMENT_START_TIME',
  OutboundContactPersonEmail = 'OUTBOUND_CONTACT_PERSON_EMAIL',
  OutboundContactPersonFirstName = 'OUTBOUND_CONTACT_PERSON_FIRST_NAME',
  OutboundContactPersonLastName = 'OUTBOUND_CONTACT_PERSON_LAST_NAME',
  OutboundContactPersonName = 'OUTBOUND_CONTACT_PERSON_NAME',
  OutboundContactPersonPhone = 'OUTBOUND_CONTACT_PERSON_PHONE',
  OutboundDeadlineDate = 'OUTBOUND_DEADLINE_DATE',
  OutboundDeadlineType = 'OUTBOUND_DEADLINE_TYPE',
  OutboundDriverName = 'OUTBOUND_DRIVER_NAME',
  OutboundDriverReferenceNumber = 'OUTBOUND_DRIVER_REFERENCE_NUMBER',
  OutboundSpecialInstructions = 'OUTBOUND_SPECIAL_INSTRUCTIONS',
  OutboundTerminalName = 'OUTBOUND_TERMINAL_NAME',
  PackageClass = 'PACKAGE_CLASS',
  PackageDescription = 'PACKAGE_DESCRIPTION',
  PackageHeight = 'PACKAGE_HEIGHT',
  PackageLength = 'PACKAGE_LENGTH',
  PackageNmfc = 'PACKAGE_NMFC',
  PackageQuantity = 'PACKAGE_QUANTITY',
  PackageWeight = 'PACKAGE_WEIGHT',
  PackageWidth = 'PACKAGE_WIDTH',
  PickupOrDelivery = 'PICKUP_OR_DELIVERY',
  ReferenceNumber = 'REFERENCE_NUMBER',
  ServiceLevel = 'SERVICE_LEVEL',
  SpecialInstructions = 'SPECIAL_INSTRUCTIONS',
  StopType = 'STOP_TYPE',
  TerminalName = 'TERMINAL_NAME'
}

export type CsvOrderPreSignedPutUrlEntity = {
  __typename?: 'CsvOrderPreSignedPutUrlEntity';
  bucket: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filetype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CsvRouteNameInput = {
  city: Scalars['String']['input'];
  routeName: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type CustomChargeArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  customChargeCreateInput?: InputMaybe<CustomChargeCreateInput>;
  /** Pass this field in to update an array item */
  customChargeUpdateInput?: InputMaybe<CustomChargeUpdateInput>;
  /** Pass this field in to upsert an array item */
  customChargeUpsertInput?: InputMaybe<CustomChargeUpsertInput>;
};

export enum CustomChargeBillingMethod {
  Accessorial = 'ACCESSORIAL',
  AdHoc = 'AD_HOC'
}

export type CustomChargeCreateInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  isAutoApplied?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomChargeEntity = {
  __typename?: 'CustomChargeEntity';
  accessorialRange?: Maybe<AccessorialRangeEntity>;
  accessorialTemplate?: Maybe<AccessorialInterface>;
  authoCode?: Maybe<Scalars['String']['output']>;
  billingMethod: CustomChargeBillingMethod;
  description?: Maybe<Scalars['String']['output']>;
  /** This is saved as a percentage in the range [0, 1]. */
  fuelSurchargeRate?: Maybe<Scalars['Float']['output']>;
  isAutoApplied: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  /** This is a percentage out of 100 */
  postedFuelSurchargeRate?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  /** returns rate a double in a string for presentation */
  rate: Scalars['Float']['output'];
  settlementFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment?: Maybe<ShipmentEntity>;
  specialAccessorialChargeGroupUuid?: Maybe<Scalars['String']['output']>;
  specialAccessorialMatrixItem?: Maybe<SpecialAccessorialMatrixItemEntity>;
  specialAccessorialTariffZoneUuid?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  zoneBasedAccessorialChargeGroupUuid?: Maybe<Scalars['String']['output']>;
  zoneBasedAccessorialMatrixItem?: Maybe<ZoneBasedAccessorialMatrixItemEntity>;
  zoneBasedAccessorialZoneUuid?: Maybe<Scalars['String']['output']>;
};

export enum CustomChargeRatingWarning {
  PercentageZeroBase = 'PERCENTAGE_ZERO_BASE'
}

export type CustomChargeUpdateInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description: Scalars['String']['input'];
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  isAutoApplied?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomChargeUpsertInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  isAutoApplied?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomCostEntity = {
  __typename?: 'CustomCostEntity';
  accessorialRange?: Maybe<AccessorialRangeEntity>;
  accessorialTemplate?: Maybe<AccessorialInterface>;
  billingMethod?: Maybe<CustomChargeBillingMethod>;
  dependentSettlementBillingMethod?: Maybe<DependentSettlementBillingMethod>;
  description?: Maybe<Scalars['String']['output']>;
  /** The flat rate of the custom cost in dollars, if it exists */
  flatRateUsdDollars?: Maybe<Scalars['Float']['output']>;
  /** The fuel surcharge rate for the custom cost expressed as a percentage out of 100, if it exists */
  fuelSurchargeRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The percentage rate for the custom cost as a percentage out of 100 if it exists */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  quantity: Scalars['Float']['output'];
  /** The rate of the custom cost in dollars, if it exists */
  rateUsdDollars?: Maybe<Scalars['Float']['output']>;
  specialAccessorialMatrixItem?: Maybe<SpecialAccessorialMatrixItemEntity>;
  totalAmountUsdCents: Scalars['Float']['output'];
  /** The total cost for the custom cost in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars?: Maybe<Scalars['Float']['output']>;
  zoneBasedAccessorialMatrixItem?: Maybe<ZoneBasedAccessorialMatrixItemEntity>;
};

export type CustomDocumentNameEntity = {
  __typename?: 'CustomDocumentNameEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CustomerAppointmentAcknowledgementOutput = {
  __typename?: 'CustomerAppointmentAcknowledgementOutput';
  /** Copy confirming what was done and what happens next. */
  message: Scalars['String']['output'];
};

export type CustomerAppointmentAcknowledgementResult = CustomerAppointmentAcknowledgementOutput | MutationErrorOutput;

export type CustomerAppointmentInvitationEntity = {
  __typename?: 'CustomerAppointmentInvitationEntity';
  /** The appointment already booked, when there is one. */
  bookedAppointment?: Maybe<CustomerBookedAppointmentEntity>;
  /** Whether to offer the "send me a new link" button. True only for EXPIRED: a link is never reissued automatically, and a live link does not need replacing. */
  canRequestNewLink: Scalars['Boolean']['output'];
  /** The company the customer is dealing with, so every state of the page names the party handling the shipment. Null when the token named nothing, or when the company has no name recorded. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** A phone number for that company, so no state of the page is a dead end. Null when the token named nothing, or when no number is configured. */
  companyPhone?: Maybe<Scalars['String']['output']>;
  /** Copy to show the customer. Always present when the status is not BOOKABLE, and always ends with a way to reach a human, so no state of this page is ever a dead end. */
  message?: Maybe<Scalars['String']['output']>;
  /** Access notes the customer previously supplied, so a reschedule can prefill rather than silently discard them. PLAIN TEXT, never HTML. */
  notes?: Maybe<Scalars['String']['output']>;
  /** How many self-service changes are left on this invitation under the company allowance, so the page can name the number instead of hedging. An ALLOWANCE, not a permission: `status` is what says whether a change is possible right now. Null when the token named nothing. */
  selfReschedulesRemaining?: Maybe<Scalars['Int']['output']>;
  /** The address being serviced, on one line, so the customer can confirm the link is about the shipment they think it is. */
  serviceAddress?: Maybe<Scalars['String']['output']>;
  /** Bookable windows, read LIVE at request time rather than snapshotted when the link was sent. Empty is an ordinary answer, and means no time is currently offerable -- the customer is pointed at the exceptions path instead. */
  slots: Array<CustomerAppointmentSlotEntity>;
  status: CustomerAppointmentInvitationStatus;
  /** PICKUP or DELIVERY, for wording the page. Null when the stop has no type recorded. */
  stopType?: Maybe<Scalars['String']['output']>;
};

/** What a customer scheduling link currently permits. */
export enum CustomerAppointmentInvitationStatus {
  AwaitingOnHand = 'AWAITING_ON_HAND',
  Bookable = 'BOOKABLE',
  BookedFinal = 'BOOKED_FINAL',
  BookedReschedulable = 'BOOKED_RESCHEDULABLE',
  Expired = 'EXPIRED',
  NotBookable = 'NOT_BOOKABLE',
  NotFound = 'NOT_FOUND',
  Revoked = 'REVOKED'
}

export type CustomerAppointmentSlotEntity = {
  __typename?: 'CustomerAppointmentSlotEntity';
  /** When the appointment window ends. */
  endsAt: Scalars['DateTime']['output'];
  /** The service day this window belongs to, as YYYY-MM-DD. On an overnight window this is the day the window OPENS, which is not always the calendar day of startsAt. */
  serviceDateIso8601: Scalars['String']['output'];
  /** When the appointment window begins. */
  startsAt: Scalars['DateTime']['output'];
  /** IANA time zone the window should be displayed in. This is the SERVICING location time zone, which is not always the company one, and is what the customer expects to read their delivery window in. */
  timeZone: Scalars['String']['output'];
};

export type CustomerAppointmentTokenInput = {
  /** The opaque token from the scheduling link. Possession of it is the whole of the authorization on this surface. A token that is malformed, unknown, expired or revoked is answered identically, and never as a validation error. */
  token: Scalars['String']['input'];
};

export type CustomerBookedAppointmentEntity = {
  __typename?: 'CustomerBookedAppointmentEntity';
  endsAt: Scalars['DateTime']['output'];
  /** The booked service day, as YYYY-MM-DD. */
  serviceDateIso8601: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
  /** IANA time zone the window should be displayed in. */
  timeZone: Scalars['String']['output'];
};

export type CustomerContactCreateInput = {
  /** Accessorial group assigned to this customer. Members are unioned with the customer accessorial allow-list; customer-specific accessorials are never filtered by it. */
  accessorialGroupId?: InputMaybe<Scalars['String']['input']>;
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment?: InputMaybe<Scalars['Boolean']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  billingContactEmail: Scalars['String']['input'];
  billingCycle?: InputMaybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: InputMaybe<Scalars['Float']['input']>;
  billingRunStart: Scalars['DateTime']['input'];
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  calculateInboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateLineHaulFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateOutboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmailCreateInputs?: InputMaybe<Array<ContactEmailCreateInput>>;
  contactPersonCreateInputs?: InputMaybe<Array<ContactPersonCreateInput>>;
  contactReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  customDunningReportFooter?: InputMaybe<Scalars['String']['input']>;
  customerPortalChargesVisibleFrom?: InputMaybe<CustomerPortalChargesVisibility>;
  defaultAddressCreateInput?: InputMaybe<AddressCreateInput>;
  defaultContactPersonCreateInput?: InputMaybe<ContactPersonCreateInput>;
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  defaultFreightBillingMethod?: InputMaybe<FreightBillingMethod>;
  defaultFreightClass?: InputMaybe<FreightClass>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceTransmissionMethod?: InputMaybe<InvoiceTransmissionMethod>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['input'];
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultUseTariff?: InputMaybe<Scalars['Boolean']['input']>;
  dimensionalWeightFactorCreateInputs?: InputMaybe<Array<DimensionalWeightCreateInput>>;
  displayChargesInCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  displayName: Scalars['String']['input'];
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  enableCustomerPortalInventory?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomerPortalOrderEntry: Scalars['Boolean']['input'];
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  includeInExpeditorsScorecard?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This field no longer affects invoices and will be removed. */
  invoiceNotes?: InputMaybe<Scalars['String']['input']>;
  invoiceTimePeriodSplit?: InputMaybe<TimePeriod>;
  isActive: Scalars['Boolean']['input'];
  isPrepaidOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  numberOfOrdersPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  packageSpecIds?: InputMaybe<Array<Scalars['String']['input']>>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopContactId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingCustomerName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  referenceNumberLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['input'];
  /** Service group assigned to this customer. Its members are unioned with serviceUuids at read time; null resolves exactly as before groups existed. */
  serviceGroupId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated ServiceLevel is deprecated and unused. */
  serviceLevels?: InputMaybe<Array<ServiceLevel>>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated 12/03/24: Field is now deprecated, should be removed */
  shortCode?: InputMaybe<Scalars['String']['input']>;
  showEdiReferenceNumbersOnOrderPage?: InputMaybe<Scalars['Boolean']['input']>;
  skipFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  useCustomPackageSpecs?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomVehicleTypes?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomerContactEntity = ContactEntity & {
  __typename?: 'CustomerContactEntity';
  accessorialGroupId?: Maybe<Scalars['String']['output']>;
  addresses: Array<AddressEntity>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment: Scalars['Boolean']['output'];
  apiName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay90: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay180: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay270: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay360: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay720: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPayAll: Scalars['Float']['output'];
  /** The customer balance for the contact in dollars */
  balance: Scalars['Float']['output'];
  billingContactEmail?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: Maybe<Scalars['Float']['output']>;
  billingPeriodDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  billingRunStart: Scalars['DateTime']['output'];
  businessDivision?: Maybe<BusinessDivisionEntity>;
  calculateInboundFreightCharges: Scalars['Boolean']['output'];
  calculateLineHaulFreightCharges: Scalars['Boolean']['output'];
  calculateOutboundFreightCharges: Scalars['Boolean']['output'];
  chargeMatrixColumnMappings: Array<ContactChargeMatrixColumnMappingEntity>;
  company: CompanyEntity;
  /** Returns at most 100 most-recent contact comments. Callers needing full enumeration must use a paginated query (TODO: expose contactCommentsConnection). */
  contactComments: Array<ContactCommentEntity>;
  contactOpenInvoiceValue: Scalars['Float']['output'];
  contactOpenInvoiceValue0to30d: Scalars['Float']['output'];
  contactOpenInvoiceValue31to38d: Scalars['Float']['output'];
  contactOpenInvoiceValue39to45d: Scalars['Float']['output'];
  contactOpenInvoiceValue46to60d: Scalars['Float']['output'];
  contactOpenInvoiceValue61to75d: Scalars['Float']['output'];
  contactOpenInvoiceValueOver75d: Scalars['Float']['output'];
  contactPersons: Array<ContactPersonEntity>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactStations: Array<ContactStationEntity>;
  contactStatistics: ContactStatsEntity;
  creditHoldLimitInCents?: Maybe<Scalars['Float']['output']>;
  creditsAppliedToContactInvoices: Scalars['Float']['output'];
  customDunningReportFooter?: Maybe<Scalars['String']['output']>;
  customerAccessorials: Array<AccessorialUnion>;
  customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility;
  customerTariffs: Array<TariffEntity>;
  debitsAppliedToContactInvoices: Scalars['Float']['output'];
  defaultAddress?: Maybe<AddressEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  defaultDimFactor?: Maybe<Scalars['Float']['output']>;
  defaultEfmHandlingStation?: Maybe<Scalars['String']['output']>;
  defaultFreightBillingMethod?: Maybe<FreightBillingMethod>;
  defaultFreightClass?: Maybe<FreightClass>;
  defaultFuelSurcharge?: Maybe<Scalars['Float']['output']>;
  defaultInboundEdiService?: Maybe<ServiceEntity>;
  defaultInboundOutboundEdiService?: Maybe<ServiceEntity>;
  defaultInvoiceDocumentsRequired: Array<DocumentType>;
  defaultInvoiceDownloadDocuments: Array<DocumentType>;
  defaultInvoiceEmailSubject?: Maybe<Scalars['String']['output']>;
  defaultInvoiceTerms?: Maybe<InvoiceTermEntity>;
  defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod;
  defaultInvoiceType: InvoiceType;
  defaultLineHaulTariffChain?: Maybe<TariffChainEntity>;
  defaultOrdinaryTariffChain?: Maybe<TariffChainEntity>;
  defaultOutboundEdiService?: Maybe<ServiceEntity>;
  defaultPointToPointTariffChain?: Maybe<TariffChainEntity>;
  defaultRecoveryTariffChain?: Maybe<TariffChainEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['output'];
  defaultTransferTariffChain?: Maybe<TariffChainEntity>;
  defaultUseTariff?: Maybe<Scalars['Boolean']['output']>;
  defaultVehicleType?: Maybe<VehicleTypeEntity>;
  /** The delivery discount rate as a percentage out of 100 if it exists */
  deliveryDiscountRate?: Maybe<Scalars['Percent']['output']>;
  dimFactor: Scalars['Int']['output'];
  displayChargesInCustomerPortal: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  ediPartnership?: Maybe<EdiPartnershipEntity>;
  ediPartnerships: Array<EdiPartnershipEntity>;
  /** The tariff chain rating uses for each tariff type, in the order Ordinary, Line haul, Transfer, Recovery, Point to point: the contact's own chain, else the company default. A type with neither has no entry, and Recovery has none while the company has recovery tariffs off. */
  effectiveTariffChains: Array<EffectiveTariffChainEntity>;
  /** The contact's addresses on a SendGrid suppression list (bounce, invalid email or spam report). Emails to them are skipped. */
  emailSuppressions: Array<EmailSuppressionEntity>;
  emitPieceLevelWebhooks: Scalars['Boolean']['output'];
  enableCreditHold?: Maybe<Scalars['Boolean']['output']>;
  enableCustomerPortalInventory: Scalars['Boolean']['output'];
  enableCustomerPortalOrderEntry: Scalars['Boolean']['output'];
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  includeInExpeditorsScorecard: Scalars['Boolean']['output'];
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This field no longer affects invoices and will be removed. */
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfColumns: Array<PdfColumnEntity>;
  invoiceTimePeriodSplit?: Maybe<TimePeriod>;
  invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName;
  isActive: Scalars['Boolean']['output'];
  isEfm?: Maybe<Scalars['Boolean']['output']>;
  isOverCreditLimit: Scalars['Boolean']['output'];
  isPrepaidOnly: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  /** The line haul discount rate as a percentage out of 100 if it exists */
  lineHaulDiscountRate?: Maybe<Scalars['Percent']['output']>;
  logo?: Maybe<DocumentEntity>;
  logoType?: Maybe<DocumentEntity>;
  masterAccount?: Maybe<MasterAccountEntity>;
  maxDaysOutstanding?: Maybe<Scalars['Float']['output']>;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  /** Dollars of the contact credit memos taken up by debit memo offsets */
  offsetCredits: Scalars['Float']['output'];
  /** Dollars of the contact debit memos used to offset payments or credit memos */
  offsetDebits: Scalars['Float']['output'];
  /** Dollars of the contact payments taken up by debit memo offsets */
  offsetPayments: Scalars['Float']['output'];
  /** Returns at most 100 most-recent orders where this contact is the billing party. Callers needing full enumeration must use the paginated orders query (TODO: expose ordersConnection). */
  orders: Array<OrderEntity>;
  overdueInvoices: Array<InvoiceEntity>;
  packageSpecs: Array<PackageSpecEntity>;
  paymentsAppliedToContactInvoices: Scalars['Float']['output'];
  /** The pickup discount rate as a percentage out of 100 if it exists */
  pickupDiscountRate?: Maybe<Scalars['Percent']['output']>;
  /** Total closed balance across all posted invoices */
  postedInvoicesTotalClosedBalance: Scalars['Float']['output'];
  /** Total open balance across all posted invoices */
  postedInvoicesTotalOpenBalance: Scalars['Float']['output'];
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopContactId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingCustomerName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId?: Maybe<Scalars['String']['output']>;
  /** The recovery discount rate as a percentage out of 100 if it exists */
  recoveryDiscountRate?: Maybe<Scalars['Percent']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['output'];
  requireScanToAdvancePieceStatusAtStops: Scalars['Boolean']['output'];
  /** Billing method new freight charges for this customer default to: the stored method, else the legacy tariff flag, else FLAT_RATE. */
  resolvedFreightBillingMethod: FreightBillingMethod;
  serviceGroupId?: Maybe<Scalars['String']['output']>;
  services: Array<ServiceEntity>;
  shortCode?: Maybe<Scalars['String']['output']>;
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  skipFuelCharge?: Maybe<Scalars['Boolean']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  tariffZones: Array<TariffZoneEntity>;
  /** @deprecated placeholder since the column was dropped from the table */
  thirdPartyContactType?: Maybe<ThirdPartyContactType>;
  totalCredits: Scalars['Float']['output'];
  totalDebits: Scalars['Float']['output'];
  totalInvoicesAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPostedInvoicesAmount: Scalars['Float']['output'];
  /** The transfer discount rate as a percentage out of 100 if it exists */
  transferDiscountRate?: Maybe<Scalars['Percent']['output']>;
  /** @deprecated Contact type is deprecated. The column has been dropped from the db */
  type: ContactType;
  unappliedCredits?: Maybe<Scalars['Float']['output']>;
  unappliedDebits: Scalars['Float']['output'];
  unappliedPayments: Scalars['Float']['output'];
  /** Invoices QuickBooks has not accepted yet that bill to this contact. Changing the contact mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  useCustomPackageSpecs: Scalars['Boolean']['output'];
  useCustomVehicleTypes: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  vehicleTypes: Array<VehicleTypeEntity>;
};


export type CustomerContactEntityContactOpenInvoiceValueArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue0to30dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue31to38dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue39to45dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue46to60dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValue61to75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type CustomerContactEntityContactOpenInvoiceValueOver75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};

export type CustomerContactUpdateInput = {
  /** Accessorial group assigned to this customer. Members are unioned with the customer accessorial allow-list; customer-specific accessorials are never filtered by it. */
  accessorialGroupId?: InputMaybe<Scalars['String']['input']>;
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment?: InputMaybe<Scalars['Boolean']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  billingContactEmail?: InputMaybe<Scalars['String']['input']>;
  billingCycle?: InputMaybe<BillingCycleType>;
  billingCycleDuration?: InputMaybe<BillingCycleDuration>;
  billingPeriod?: InputMaybe<Scalars['Float']['input']>;
  billingRunStart?: InputMaybe<Scalars['DateTime']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  calculateInboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateLineHaulFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateOutboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  contactReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  creditHoldLimitInCents?: InputMaybe<Scalars['Float']['input']>;
  customDunningReportFooter?: InputMaybe<Scalars['String']['input']>;
  customerPortalChargesVisibleFrom?: InputMaybe<CustomerPortalChargesVisibility>;
  defaultAddressUuid?: InputMaybe<Scalars['String']['input']>;
  defaultContactPersonUuid?: InputMaybe<Scalars['String']['input']>;
  defaultDimFactor?: InputMaybe<Scalars['Float']['input']>;
  defaultFreightBillingMethod?: InputMaybe<FreightBillingMethod>;
  defaultFreightClass?: InputMaybe<FreightClass>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceDocumentsRequired?: InputMaybe<Array<DocumentType>>;
  defaultInvoiceDownloadDocuments?: InputMaybe<Array<DocumentType>>;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceTermUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceTransmissionMethod?: InputMaybe<InvoiceTransmissionMethod>;
  defaultInvoiceType?: InputMaybe<InvoiceType>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultServicePickupsDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultUseTariff?: InputMaybe<Scalars['Boolean']['input']>;
  /** The discount rate to apply to non-flat rate freight charges for delivery stop types. Note that this is a percentage out of 100 */
  deliveryDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  displayChargesInCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  enableCreditHold?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomerPortalInventory?: InputMaybe<Scalars['Boolean']['input']>;
  enableCustomerPortalOrderEntry?: InputMaybe<Scalars['Boolean']['input']>;
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  includeInExpeditorsScorecard?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This field no longer affects invoices and will be removed. */
  invoiceNotes?: InputMaybe<Scalars['String']['input']>;
  invoiceTimePeriodSplit?: InputMaybe<TimePeriod>;
  invoiceVendorDisplayName?: InputMaybe<OrganizationInvoiceVendorDisplayName>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPrepaidOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to apply to non-flat rate freight charges for line-haul. Note that this is a percentage out of 100 */
  lineHaulDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  logoDocumentUuid?: InputMaybe<Scalars['String']['input']>;
  logoTypeDocumentUuid?: InputMaybe<Scalars['String']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  maxDaysOutstanding?: InputMaybe<Scalars['Float']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  numberOfOrdersPerInvoice?: InputMaybe<Scalars['Float']['input']>;
  packageSpecIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The discount rate to apply to non-flat rate freight charges for pickup stop types. Note that this is a percentage out of 100 */
  pickupDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopContactId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingCustomerName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to apply to non-flat rate freight charges for recovery stop types. Note that this is a percentage out of 100 */
  recoveryDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  referenceNumberLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  requireDriverToCheckOffPackagesAtStop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Service group assigned to this customer. Its members are unioned with serviceUuids at read time; null resolves exactly as before groups existed. */
  serviceGroupId?: InputMaybe<Scalars['String']['input']>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated 12/03/24: Field is now deprecated, should be removed */
  shortCode?: InputMaybe<Scalars['String']['input']>;
  showChargesOnCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  showEdiReferenceNumbersOnOrderPage?: InputMaybe<Scalars['Boolean']['input']>;
  skipFuelCharge?: InputMaybe<Scalars['Boolean']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to apply to non-flat rate freight charges for transfer stop types. Note that this is a percentage out of 100 */
  transferDiscountRate?: InputMaybe<Scalars['Percent']['input']>;
  /** @deprecated 12/27/24: Field is now deprecated because the column is being dropped, should be removed */
  type?: InputMaybe<ContactType>;
  useCustomPackageSpecs?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomVehicleTypes?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomerFieldsEntity = {
  __typename?: 'CustomerFieldsEntity';
  accessorialGroupId?: Maybe<Scalars['String']['output']>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment: Scalars['Boolean']['output'];
  businessDivisionUuid?: Maybe<Scalars['String']['output']>;
  calculateInboundFreightCharges: Scalars['Boolean']['output'];
  calculateLineHaulFreightCharges: Scalars['Boolean']['output'];
  calculateOutboundFreightCharges: Scalars['Boolean']['output'];
  customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility;
  /** equivalent to the ContactVehicleType table */
  customerVehicleTypes: Array<CustomerVehicleTypeEntity>;
  defaultAddressUuid?: Maybe<Scalars['String']['output']>;
  defaultDimFactor?: Maybe<Scalars['Float']['output']>;
  defaultFreightBillingMethod?: Maybe<FreightBillingMethod>;
  defaultFreightClass?: Maybe<FreightClass>;
  defaultFuelSurcharge?: Maybe<Scalars['Float']['output']>;
  defaultInboundEdiServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultInboundOutboundEdiServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultLineHaulTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultOrdinaryTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultOutboundEdiServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultPointToPointTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultRecoveryTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultServiceUuid?: Maybe<Scalars['String']['output']>;
  defaultTransferTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultUseTariff: Scalars['Boolean']['output'];
  displayChargesInCustomerPortal: Scalars['Boolean']['output'];
  emitPieceLevelWebhooks: Scalars['Boolean']['output'];
  enableCustomerPortalInventory: Scalars['Boolean']['output'];
  enableCustomerPortalOrderEntry: Scalars['Boolean']['output'];
  includeInExpeditorsScorecard: Scalars['Boolean']['output'];
  invoiceOrOrderIdentifier?: Maybe<Scalars['String']['output']>;
  isPrepaidOnly: Scalars['Boolean']['output'];
  referenceNumberLabels: Array<CustomerReferenceNumberLabelEntity>;
  resolvedFreightBillingMethod: FreightBillingMethod;
  serviceGroupId?: Maybe<Scalars['String']['output']>;
  services: Array<CustomerServiceEntity>;
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  useCustomVehicleTypes: Scalars['Boolean']['output'];
};

export enum CustomerFilterMode {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export type CustomerNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** From which point in an order's life the customer portal shows its charges (TMS-2339). */
export enum CustomerPortalChargesVisibility {
  AfterCompletion = 'AFTER_COMPLETION',
  AfterFinalization = 'AFTER_FINALIZATION',
  AfterInvoicing = 'AFTER_INVOICING',
  Always = 'ALWAYS'
}

export type CustomerPortalConfigurationEntity = {
  __typename?: 'CustomerPortalConfigurationEntity';
  defaultDimFactor?: Maybe<Scalars['Int']['output']>;
  logisticsSectionEnabled: Scalars['Boolean']['output'];
  terminalsEnabled: Scalars['Boolean']['output'];
};

/** Review status of an order in the customer portal */
export enum CustomerPortalOrderReviewStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** A filter object that is used to filter the customer portal order review status. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type CustomerPortalOrderReviewStatusFilter = {
  /** Filters for records where the order review status matches the provided value */
  eq?: InputMaybe<CustomerPortalOrderReviewStatus>;
  /** Filters for records where the order review status is in the provided values */
  in?: InputMaybe<Array<CustomerPortalOrderReviewStatus>>;
  /** Filters for records where the order review status does not match the provided value */
  neq?: InputMaybe<CustomerPortalOrderReviewStatus>;
  /** Filters for records where the order review status is not in the provided values */
  nin?: InputMaybe<Array<CustomerPortalOrderReviewStatus>>;
};

export type CustomerPortalOrderStatusBucketInput = {
  /** The order is dispatched (assigned to a route dated today) */
  dispatched?: InputMaybe<Scalars['Boolean']['input']>;
  /** The order has one or more failed/attempted stops */
  hasFailures?: InputMaybe<Scalars['Boolean']['input']>;
  /** The order is planned (assigned to a future-dated route) */
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The order status must be one of these values */
  statusIn?: InputMaybe<Array<OrderStatus>>;
};

export type CustomerPortalPiecesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the company whose portal is being viewed. */
  companyUuid: Scalars['String']['input'];
  /** Narrow to a single customer the caller is linked to. Intersected with the caller's contacts server-side. */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Case-insensitive search across piece reference number, order name, customer (billing party) display name, and the linked order HAWB (house bill or shipper BOL) / MAWB. */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Sort order; first element has highest priority */
  sorts?: InputMaybe<Array<FindPiecesSort>>;
};

export type CustomerProfitabilityArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerProfitabilityBucketEntity = {
  __typename?: 'CustomerProfitabilityBucketEntity';
  actualContributionRatio?: Maybe<Scalars['Float']['output']>;
  customerName: Scalars['String']['output'];
  customerUuid: Scalars['String']['output'];
  revenueUsd: Scalars['Float']['output'];
  shipmentCount: Scalars['Int']['output'];
  status?: Maybe<ProfitabilityStatus>;
  totalMiles: Scalars['Float']['output'];
  totalWeightLbs: Scalars['Float']['output'];
  variableCostUsd?: Maybe<Scalars['Float']['output']>;
};

export type CustomerProfitabilityReportEntity = {
  __typename?: 'CustomerProfitabilityReportEntity';
  appliedRates?: Maybe<ProfitabilityCostAssumptionEntity>;
  breakevenContributionRatio?: Maybe<Scalars['Float']['output']>;
  costBasis: CostBasis;
  customers: Array<CustomerProfitabilityBucketEntity>;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  hasCostAssumptions: Scalars['Boolean']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  operatingRatio?: Maybe<Scalars['Float']['output']>;
  proratedFixedCostUsd?: Maybe<Scalars['Float']['output']>;
  proratedOverheadCostUsd?: Maybe<Scalars['Float']['output']>;
  totalRevenueUsd: Scalars['Float']['output'];
  totalVariableCostUsd?: Maybe<Scalars['Float']['output']>;
};

export type CustomerReferenceNumberLabelEntity = {
  __typename?: 'CustomerReferenceNumberLabelEntity';
  name: Scalars['String']['output'];
};

export type CustomerReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerReportBucketEntity = {
  __typename?: 'CustomerReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type CustomerServiceEntity = {
  __typename?: 'CustomerServiceEntity';
  uuid: Scalars['String']['output'];
};

export type CustomerVehicleTypeEntity = {
  __typename?: 'CustomerVehicleTypeEntity';
  id: Scalars['String']['output'];
  vehicleTypeUuid: Scalars['String']['output'];
};

export type DateFilter = {
  filterOperator?: InputMaybe<FilterOperator>;
  filterType: DateFilterType;
  value: Scalars['DateTime']['input'];
};

/** Enum of predefined options including static dates and relative options(today, tomorrow, yesterday, before today). */
export enum DateFilterOptionV2 {
  BeforeToday = 'BEFORE_TODAY',
  LastXDays = 'LAST_X_DAYS',
  Static = 'STATIC',
  Today = 'TODAY',
  Tomorrow = 'TOMORROW',
  Yesterday = 'YESTERDAY'
}

export type DateFilterStartEnd = {
  endFilterValue?: InputMaybe<Scalars['DateTime']['input']>;
  filterOperator?: InputMaybe<FilterOperator>;
  startFilterValue?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DateFilterType {
  IsAfter = 'IS_AFTER',
  IsBefore = 'IS_BEFORE'
}

/** A filter object that is used to filter a date field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type DateFilterV2 = {
  /** Filters for records where the relevant date field is between the provided date range */
  between?: InputMaybe<DateRangeFilterInput>;
  /**
   * Filters for records where the relevant date field is equal to the provided date value. Deprecated: Use eqV2 instead.
   * @deprecated Use eqV2 for more flexible date filtering
   */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is equal to a relative date value. eqV2 is to allow for smooth transition from only string dates to the new FilterDateInput system */
  eqV2?: InputMaybe<DateFilterValueInput>;
  /** Filters for records where the relevant date field is greater than the provided date value */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is greater than or equal to the provided date value */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is in the provided date values */
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** Filters for records where the relevant date field is blank */
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant date field is not blank */
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant date field is less than the provided date value */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is less than or equal to the provided date value */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is not equal to the provided date value */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters for records where the relevant date field is not in the provided date values */
  nin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Date filter fields for the findLineHaulManifestsV2 query */
export type DateFilterV2Simple = {
  /** Filters for records where the relevant date field is equal to the provided date value. Deprecated: Use eqV2 instead. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Object that represents the filtering input for either a static date option or a relative date option. Static dates are literal dates stored (e.g., "2024-03-15"). Relative dates are those stored as something akin to "today" or "yesterday". */
export type DateFilterValueInput = {
  /** Date value for STATIC options, null otherwise */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Enum of predefined options including static dates and relative options(today, tomorrow, yesterday, before today) */
  dateFilterOption?: InputMaybe<DateFilterOptionV2>;
  /** Number of days to offset the date. Only used for LAST_X_DAYS. */
  offsetDays: Scalars['Int']['input'];
};

export type DateMarkedOnHandSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** Object that represents the filtering input for a date range that is inclusive on both ends */
export type DateRangeFilterInput = {
  /** The end date of the inclusive date range */
  gte: Scalars['DateTime']['input'];
  /** The start date of the inclusive date range */
  lte: Scalars['DateTime']['input'];
};

export enum DayOfWeekAll {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeactivateTestTerminalInput = {
  terminalUuid: Scalars['String']['input'];
};

export enum DeadlineDateFilter {
  Overdue = 'OVERDUE',
  Today = 'TODAY',
  Tomorrow = 'TOMORROW'
}

export enum DeadlineType {
  DueBy = 'DUE_BY',
  DueOn = 'DUE_ON'
}

export type DeclineOrderDelegationInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type DeclineQuoteInput = {
  orderQuoteUuid: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type DeclineQuoteOutput = DeclineQuoteSuccessOutput | MutationErrorOutput;

export type DeclineQuoteSuccessOutput = {
  __typename?: 'DeclineQuoteSuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
  status: OrderQuoteStatus;
};

export type DefaultAppointmentTextOutput = {
  __typename?: 'DefaultAppointmentTextOutput';
  appointmentUuid: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type DelegatedOrderInboxItemConnection = {
  __typename?: 'DelegatedOrderInboxItemConnection';
  edges: Array<DelegatedOrderInboxItemEdge>;
  pageInfo: PageInfo;
};

export type DelegatedOrderInboxItemEdge = {
  __typename?: 'DelegatedOrderInboxItemEdge';
  cursor: Scalars['String']['output'];
  node: DelegatedOrderInboxItemEntity;
};

export type DelegatedOrderInboxItemEntity = {
  __typename?: 'DelegatedOrderInboxItemEntity';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  duplicateOrderUuid?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  offerSummary?: Maybe<DelegationOfferSummaryEntity>;
  originatorCompanyName: Scalars['String']['output'];
  originatorCompanyUuid: Scalars['String']['output'];
  pickupHandling?: Maybe<DelegatedPickupHandling>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  scope: OrderDelegationScope;
  status: OrderDelegationStatus;
  uuid: Scalars['String']['output'];
};

export type DelegatedOrdersInboxFilterInput = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
  originatorCompanyUuid?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<OrderDelegationScope>;
  status?: InputMaybe<OrderDelegationStatus>;
};

export type DelegatedOrdersOutboxFilterInput = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  executingCompanyUuid?: InputMaybe<Scalars['String']['input']>;
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<OrderDelegationScope>;
  status?: InputMaybe<OrderDelegationStatus>;
};

/** How the non-delegated leg of a partial delegation is handled. Only valid when scope is INBOUND_ONLY or OUTBOUND_ONLY (one part supplied). CARRIER_DROP_OFF: a carrier drops freight at the executor terminal. FROM_INVENTORY: freight is already in the executor's possession. RECOVERY: the executor performs a recovery to obtain the freight. PICKUP: the executor picks up the freight at the delegator's warehouse. */
export enum DelegatedPickupHandling {
  CarrierDropOff = 'CARRIER_DROP_OFF',
  FromInventory = 'FROM_INVENTORY',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY'
}

export type DelegationAccessorialProposalEntity = {
  __typename?: 'DelegationAccessorialProposalEntity';
  appliedCustomChargeUuid?: Maybe<Scalars['String']['output']>;
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  delegationUuid: Scalars['String']['output'];
  executingCompanyName: Scalars['String']['output'];
  mappedAccessorialName?: Maybe<Scalars['String']['output']>;
  mappedAccessorialType?: Maybe<AccessorialType>;
  mappedAccessorialUuid?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalChargesFinalized: Scalars['Boolean']['output'];
  quantity: Scalars['Int']['output'];
  status: DelegationAccessorialProposalStatus;
  suggestedZoneBasedMatrixItemUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** Where a partner accessorial proposal stands: waiting for the owner, applied to the original order, dismissed, or withdrawn because the partner removed it. */
export enum DelegationAccessorialProposalStatus {
  Applied = 'APPLIED',
  Dismissed = 'DISMISSED',
  Pending = 'PENDING',
  Withdrawn = 'WITHDRAWN'
}

export type DelegationEndCustomer = {
  __typename?: 'DelegationEndCustomer';
  address?: Maybe<DelegationEndCustomerAddress>;
  addressBook: Array<DelegationEndCustomerAddress>;
  addressBookTotalCount: Scalars['Int']['output'];
  billingEmails: Array<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  executorOrganization?: Maybe<DelegationEndCustomerExecutorOrganization>;
  name: Scalars['String']['output'];
  people: Array<DelegationEndCustomerPerson>;
  peopleTotalCount: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type DelegationEndCustomerAddress = {
  __typename?: 'DelegationEndCustomerAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type DelegationEndCustomerExecutorOrganization = {
  __typename?: 'DelegationEndCustomerExecutorOrganization';
  displayName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type DelegationEndCustomerMatchInput = {
  orderUuid: Scalars['String']['input'];
  peerUuid: Scalars['String']['input'];
};

export type DelegationEndCustomerPerson = {
  __typename?: 'DelegationEndCustomerPerson';
  emails: Array<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type DelegationOfferSummaryEntity = {
  __typename?: 'DelegationOfferSummaryEntity';
  deliveryLocation?: Maybe<OfferLocationEntity>;
  earliestServiceDate?: Maybe<Scalars['String']['output']>;
  hazmat: Scalars['Boolean']['output'];
  inBond: Scalars['Boolean']['output'];
  offerNote?: Maybe<Scalars['String']['output']>;
  packageCount: Scalars['Int']['output'];
  pickupLocation?: Maybe<OfferLocationEntity>;
  refNumbers: Array<Scalars['String']['output']>;
  scope: OrderDelegationScope;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  version: Scalars['Int']['output'];
  weightUnits?: Maybe<Scalars['String']['output']>;
};

export type DeleteAccessorialDateRangeConfigInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteContactCommentInput = {
  /** The UUID of the contact comment to be deleted */
  uuid: Scalars['String']['input'];
};

export type DeleteContactCommentOutput = DeleteContactCommentSuccessOutput | MutationErrorOutput;

export type DeleteContactCommentSuccessOutput = {
  __typename?: 'DeleteContactCommentSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteContactEmailInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteDriverCredentialTypeInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteEdiPartnershipServiceMappingsInput = {
  ediPartnershipUuid: Scalars['String']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type DeleteEdiPartnershipServiceMappingsOutput = {
  __typename?: 'DeleteEdiPartnershipServiceMappingsOutput';
  deletedUuids: Array<Scalars['String']['output']>;
};

export type DeleteEdiTypedReferenceMappingsInput = {
  ediPartnershipUuid: Scalars['String']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type DeleteEdiTypedReferenceMappingsOutput = {
  __typename?: 'DeleteEdiTypedReferenceMappingsOutput';
  deletedUuids: Array<Scalars['String']['output']>;
};

export type DeleteFeatureFlagCompanyOverrideInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteFeatureFlagUserOverrideInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteFuelProfileDateRangeInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteFuelProfileDateRangeOutput = {
  __typename?: 'DeleteFuelProfileDateRangeOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteGeneralLedgerCodeOutput = DeleteGeneralLedgerCodeSuccessOutput | MutationErrorOutput;

export type DeleteGeneralLedgerCodeSuccessOutput = {
  __typename?: 'DeleteGeneralLedgerCodeSuccessOutput';
  id: Scalars['String']['output'];
};

export type DeleteInventoryCountInput = {
  inventoryCountUuid: Scalars['String']['input'];
};

export type DeleteInventoryCountOutput = DeletedInventoryCountOutput | MutationErrorOutput;

export type DeleteInventoryItemsInput = {
  itemUuid: Scalars['String']['input'];
  /** The number of inventory items to be deleted for the specified storage order */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
};

export type DeleteInventoryItemsOutput = {
  __typename?: 'DeleteInventoryItemsOutput';
  /** The number of inventory items that were deleted */
  quantity: Scalars['Int']['output'];
};

export type DeleteOrderCommentInput = {
  /** The UUID of the order comment to be deleted */
  uuid: Scalars['String']['input'];
};

export type DeleteOrderCommentOutput = DeleteOrderCommentSuccessOutput | MutationErrorOutput;

export type DeleteOrderCommentSuccessOutput = {
  __typename?: 'DeleteOrderCommentSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteOrderDelegationRuleInput = {
  ruleUuid: Scalars['String']['input'];
};

export type DeletePermissionInput = {
  uuid: Scalars['String']['input'];
};

export type DeletePermissionOutput = {
  __typename?: 'DeletePermissionOutput';
  success: Scalars['Boolean']['output'];
};

export type DeletePieceReceiptInput = {
  /** UUID of the piece receipt to delete */
  uuid: Scalars['String']['input'];
};

export type DeletePieceReceiptOutput = {
  __typename?: 'DeletePieceReceiptOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteRoleInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteRoleOutput = {
  __typename?: 'DeleteRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteSchemaRunInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteSlotsFromRouteInput = {
  emitMultiplayerEvent?: InputMaybe<Scalars['Boolean']['input']>;
  routeSlotUuids: Array<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

/** The expected input for deleting a stop attempt */
export type DeleteStopAttemptInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteStopAttemptOutput = DeleteStopAttemptSuccessOutput | MutationErrorOutput;

/** The output of a successful stop attempt deletion */
export type DeleteStopAttemptSuccessOutput = {
  __typename?: 'DeleteStopAttemptSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteStorageOrderInput = {
  /** The UUID of the storage order to delete */
  uuid: Scalars['String']['input'];
};

export type DeleteStorageOrderOutput = {
  __typename?: 'DeleteStorageOrderOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteStorageOrdersInput = {
  /** The UUIDs of the storage order to delete */
  uuids: Array<Scalars['String']['input']>;
};

export type DeleteStorageOrdersOutput = {
  __typename?: 'DeleteStorageOrdersOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteStorageUnitInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteStorageUnitOutput = {
  __typename?: 'DeleteStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteTariffLocationInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteTariffLocationOutput = {
  __typename?: 'DeleteTariffLocationOutput';
  tariffLocation: TariffLocationEntity;
};

export type DeleteTerminalLanesInput = {
  /** The IDs of the TerminalLaneEntities to delete. */
  terminalLaneIds: Array<Scalars['String']['input']>;
};

export type DeleteTerminalLanesOutput = DeleteTerminalLanesSuccessOutput | MutationErrorOutput;

export type DeleteTerminalLanesSuccessOutput = {
  __typename?: 'DeleteTerminalLanesSuccessOutput';
  /** All of the company’s terminal lanes after deleting */
  terminalLanes: Array<TerminalLaneEntity>;
};

export type DeleteUserInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteWarehouseLocationImpact = {
  __typename?: 'DeleteWarehouseLocationImpact';
  inventoryItemsCount: Scalars['Int']['output'];
  itemGroupsCount: Scalars['Int']['output'];
  packagesCount: Scalars['Int']['output'];
  piecesCount: Scalars['Int']['output'];
  storageUnitsCount: Scalars['Int']['output'];
};

export type DeleteWarehouseLocationInput = {
  /** When true, confirms you understand deleting the location will clear any assigned locations from related entities. */
  confirmRemoveLocations?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the warehouse location to be deleted */
  uuid: Scalars['String']['input'];
};

export type DeleteWarehouseLocationOutput = {
  __typename?: 'DeleteWarehouseLocationOutput';
  /** Counts of entities currently referencing this location. These references will have their locations cleared on delete. */
  impact: DeleteWarehouseLocationImpact;
  /** True when the location cannot be deleted yet because a second confirmation is required. */
  requiresSecondConfirmation: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeletedInventoryCountOutput = {
  __typename?: 'DeletedInventoryCountOutput';
  uuid: Scalars['String']['output'];
};

export type DeletedPackageInput = {
  /** The top-level pieces the form loaded on this package. */
  loadedPieceUuids: Array<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type DeliveryFailureGroupRowEntity = {
  __typename?: 'DeliveryFailureGroupRowEntity';
  failedStops: Scalars['Int']['output'];
  failurePct?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  settledStops: Scalars['Int']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type DeliveryFailureKpiEntity = {
  __typename?: 'DeliveryFailureKpiEntity';
  bucketUnit: KpiTrendBucketUnit;
  customers: Array<DeliveryFailureGroupRowEntity>;
  deliveredLateDayStops: Scalars['Int']['output'];
  deliveredStops: Scalars['Int']['output'];
  drivers: Array<DeliveryFailureGroupRowEntity>;
  failedStops: Scalars['Int']['output'];
  failurePct?: Maybe<Scalars['Float']['output']>;
  forceMarkedCompleteStops: Scalars['Int']['output'];
  neverDeliveredStops: Scalars['Int']['output'];
  pendingStops: Scalars['Int']['output'];
  scheduledStops: Scalars['Int']['output'];
  settledStops: Scalars['Int']['output'];
  stops: Array<DeliveryFailureStopRowEntity>;
  terminals: Array<DeliveryFailureGroupRowEntity>;
  trend: Array<DeliveryFailureTrendBucketEntity>;
};

export type DeliveryFailureStopRowEntity = {
  __typename?: 'DeliveryFailureStopRowEntity';
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  customerName: Scalars['String']['output'];
  daysLate: Scalars['Int']['output'];
  driverNames: Array<Scalars['String']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  fileNo?: Maybe<Scalars['String']['output']>;
  fromDeadline: Scalars['Boolean']['output'];
  orderUuid: Scalars['String']['output'];
  outcome: KpiFailedDeliveryOutcome;
  promisedDate: Scalars['String']['output'];
  stopStatus: Scalars['String']['output'];
  stopTimeZone: Scalars['String']['output'];
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type DeliveryFailureStopsEntity = {
  __typename?: 'DeliveryFailureStopsEntity';
  facets: KpiRecordFacetsEntity;
  stops: Array<DeliveryFailureStopRowEntity>;
  totalStops: Scalars['Int']['output'];
};

export type DeliveryFailureTrendBucketEntity = {
  __typename?: 'DeliveryFailureTrendBucketEntity';
  bucketDate: Scalars['String']['output'];
  failedStops: Scalars['Int']['output'];
  failurePct?: Maybe<Scalars['Float']['output']>;
  settledStops: Scalars['Int']['output'];
};

export enum DependentSettlementBillingMethod {
  AutoCalculate = 'AUTO_CALCULATE',
  FlatRate = 'FLAT_RATE',
  Percentage = 'PERCENTAGE'
}

export type DestinationDetailsSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum DestinationStopType {
  Delivery = 'DELIVERY',
  PartnerPickup = 'PARTNER_PICKUP',
  Transfer = 'TRANSFER'
}

export type DestinationTerminalSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type DetachDocumentsFromShipmentsInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type DimWeightSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type DimensionalWeightCreateInput = {
  factor: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  type: DimensionalWeightFactorType;
};

export enum DimensionalWeightFactorType {
  CompanyLevel = 'COMPANY_LEVEL',
  ContactSpecific = 'CONTACT_SPECIFIC'
}

export type DismissDelegationAccessorialProposalInput = {
  uuid: Scalars['String']['input'];
};

export type DismissQuoteInput = {
  orderQuoteUuid: Scalars['String']['input'];
};

export type DismissQuoteOutput = DismissQuoteSuccessOutput | MutationErrorOutput;

export type DismissQuoteSuccessOutput = {
  __typename?: 'DismissQuoteSuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
  status: OrderQuoteStatus;
};

export type DispatchApplySuggestedManifestsInput = {
  targets: Array<DispatchSuggestedManifestTargetInput>;
};

export type DispatchApplySuggestedManifestsOutput = {
  __typename?: 'DispatchApplySuggestedManifestsOutput';
  results: Array<DispatchSuggestedManifestResult>;
};

export type DispatchAppointmentConnection = {
  __typename?: 'DispatchAppointmentConnection';
  edges: Array<DispatchAppointmentEdge>;
  pageInfo: PageInfo;
  /** Total rows matching the filters. Not cheap to calculate, request with prudence via includeCount. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum DispatchAppointmentContactChannel {
  HasContact = 'HAS_CONTACT',
  NoContact = 'NO_CONTACT'
}

export type DispatchAppointmentEdge = {
  __typename?: 'DispatchAppointmentEdge';
  cursor: Scalars['String']['output'];
  node: DispatchAppointmentEntity;
};

export type DispatchAppointmentEntity = {
  __typename?: 'DispatchAppointmentEntity';
  addressLine?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  committedWindowEnd?: Maybe<Scalars['DateTime']['output']>;
  committedWindowStart?: Maybe<Scalars['DateTime']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  customerBookingLinkOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  customerBookingLinkSentAt?: Maybe<Scalars['DateTime']['output']>;
  customerName: Scalars['String']['output'];
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  onRoute: Scalars['Boolean']['output'];
  orderName: Scalars['String']['output'];
  orderUuid?: Maybe<Scalars['String']['output']>;
  projectedArrival?: Maybe<Scalars['DateTime']['output']>;
  status: DispatchAppointmentStatus;
  stopType?: Maybe<StopType>;
  terminalName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export enum DispatchAppointmentPreset {
  All = 'ALL',
  AwaitingCustomerBooking = 'AWAITING_CUSTOMER_BOOKING',
  NoContact = 'NO_CONTACT',
  Oncoming = 'ONCOMING',
  Unconfirmed = 'UNCONFIRMED'
}

export enum DispatchAppointmentSortField {
  DeliveryDate = 'DELIVERY_DATE',
  OrderName = 'ORDER_NAME',
  ProjectedArrival = 'PROJECTED_ARRIVAL'
}

/** Appointment state shown on the board. CANCELLED is stored; the rest are derived from the legacy stop columns. DELAYED is absent on purpose: nothing records it. */
export enum DispatchAppointmentStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Executed = 'EXECUTED',
  RescheduleRequested = 'RESCHEDULE_REQUESTED',
  Scheduled = 'SCHEDULED'
}

export type DispatchAppointmentSummaryEntity = {
  __typename?: 'DispatchAppointmentSummaryEntity';
  all: Scalars['Int']['output'];
  awaitingCustomerBooking: Scalars['Int']['output'];
  noContact: Scalars['Int']['output'];
  oncoming: Scalars['Int']['output'];
  unconfirmed: Scalars['Int']['output'];
};

export type DispatchFormattedFieldValue = {
  __typename?: 'DispatchFormattedFieldValue';
  field: OrderTableField;
  value?: Maybe<Scalars['String']['output']>;
};

/** A dispatch-board column that leaf rows can be sorted by. Only columns whose displayed value is reproducible in SQL are offered. */
export enum DispatchLeafSortField {
  CurrentLocation = 'CURRENT_LOCATION',
  CustomerName = 'CUSTOMER_NAME',
  DimWeight = 'DIM_WEIGHT',
  FinalDestinationTerminal = 'FINAL_DESTINATION_TERMINAL',
  Hawb = 'HAWB',
  ManifestReference = 'MANIFEST_REFERENCE',
  Mawb = 'MAWB',
  NextLegTerminal = 'NEXT_LEG_TERMINAL',
  OrderName = 'ORDER_NAME',
  OriginTerminal = 'ORIGIN_TERMINAL',
  PieceCount = 'PIECE_COUNT',
  RoutingStatus = 'ROUTING_STATUS',
  ServiceDate = 'SERVICE_DATE',
  Weight = 'WEIGHT'
}

/** How far along the plan for one leg is, as the dispatch board's Routing status column reports it. */
export enum DispatchLegState {
  Arrived = 'ARRIVED',
  Departed = 'DEPARTED',
  DoorsClosed = 'DOORS_CLOSED',
  OnManifest = 'ON_MANIFEST',
  Proposed = 'PROPOSED',
  Routed = 'ROUTED'
}

export type DispatchLineHaulManifest = {
  __typename?: 'DispatchLineHaulManifest';
  completedAt?: Maybe<Scalars['String']['output']>;
  departDate?: Maybe<Scalars['String']['output']>;
  endTerminalCode: Scalars['String']['output'];
  estimatedArrival?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
  startTerminalCode: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type DispatchOrderRow = {
  __typename?: 'DispatchOrderRow';
  /** Alternative network paths, present only on a proposed row whose corridor has more than one viable route. */
  alternativeRoutes?: Maybe<Array<DispatchProposedRoute>>;
  billOfLadingNumber?: Maybe<Scalars['String']['output']>;
  /** Where the order's freight currently sits: the terminal its pieces are standing at (arrived, or loaded on a trailer that has not departed), else the last completed manifest's end terminal, else the inbound terminal once received at origin. */
  currentLocationCode?: Maybe<Scalars['String']['output']>;
  /** Whether currentLocationCode came from the freight itself rather than from a manifest-shaped fallback. Decides whether the Location cell reads "at" or "from"; see currentLocationIsLiveSql. */
  currentLocationIsLive: Scalars['Boolean']['output'];
  /** How many countable units are at currentLocationCode. Meaningful only when currentLocationIsLive; 0 otherwise. */
  currentLocationPieceCount: Scalars['Int']['output'];
  currentManifestDepartDate?: Maybe<Scalars['String']['output']>;
  currentManifestReferenceNumber?: Maybe<Scalars['String']['output']>;
  currentManifestStatus?: Maybe<Scalars['String']['output']>;
  currentManifestUuid?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  /** This segment's destination terminal (the lane's end / next stop). */
  destinationTerminalCode?: Maybe<Scalars['String']['output']>;
  dimWeight?: Maybe<Scalars['Float']['output']>;
  /** The order's final destination terminal (its outbound delivery terminal), which may differ from this segment's destination on a multi-leg order. */
  finalDestinationTerminalCode?: Maybe<Scalars['String']['output']>;
  /** The order's final destination terminal uuid, the same terminal finalDestinationTerminalCode names. A re-route has to end here. */
  finalDestinationTerminalUuid?: Maybe<Scalars['String']['output']>;
  formattedValues: Array<DispatchFormattedFieldValue>;
  /** True when the order's travelled legs already reach its final destination, so no part of its route is left to change. */
  isPathLocked: Scalars['Boolean']['output'];
  /** True when the leg is proposed (computed from the network) rather than committed to a segment. */
  isProposed: Scalars['Boolean']['output'];
  isSpecial: Scalars['Boolean']['output'];
  /** Lane this row belongs to (matches OrderLaneGroup.laneKey). */
  laneKey: Scalars['String']['output'];
  lineHaulManifests: Array<DispatchLineHaulManifest>;
  mawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The ORDER's line-haul origin terminal, the same on every leg of a multi-leg order. Order-level lineHaulOriginTerminal first, then the inbound stop's terminal; null when neither answers. */
  orderOriginTerminalCode?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  /** This segment's origin terminal (the lane's start). Differs from orderOriginTerminalCode on every leg after the first of a multi-leg order. */
  originTerminalCode?: Maybe<Scalars['String']['output']>;
  outboundServiceDate?: Maybe<Scalars['String']['output']>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
  pieceStatusLocations?: Maybe<Array<PieceStatusTerminalCount>>;
  pieceTerminalLocations?: Maybe<Scalars['String']['output']>;
  piecesAwayFromRunOrigin?: Maybe<PiecesAwayFromRunOrigin>;
  /** The terminal a re-route of this order has to start from: where its travelled legs end, or its origin while none has left the dock. */
  rerouteFromTerminalCode?: Maybe<Scalars['String']['output']>;
  /** The uuid of the terminal rerouteFromTerminalCode names, for the route mutation. */
  rerouteFromTerminalUuid?: Maybe<Scalars['String']['output']>;
  /** The legs the order is routed over, in chain order. Unlike consecutive pairs of routeNodeCodes, these are never invented across a gap in a broken route. Empty means fall back to the row's own lane. */
  routeLegs: Array<DispatchRouteLeg>;
  /** True when the order's committed route does not end at its current final destination. False when the order has no committed route. */
  routeMissesDestination: Scalars['Boolean']['output'];
  /** True when the order's committed route does not start at its current origin and none of the route has travelled yet. False when the order has no committed route. */
  routeMissesOrigin: Scalars['Boolean']['output'];
  /** The leg's full route chain in terminal codes, e.g. ATL > MIA > GSP. */
  routeNodeCodes: Array<Scalars['String']['output']>;
  /** The same chain as routeNodeCodes, in terminal uuids, index-aligned with it. Consecutive pairs are the route legs only when the route has no break; see routeLegs. */
  routeNodeTerminalUuids: Array<Scalars['String']['output']>;
  segmentEndTerminalUuid?: Maybe<Scalars['String']['output']>;
  segmentStartTerminalUuid?: Maybe<Scalars['String']['output']>;
  /** Row identity, and the AG Grid getRowId value. The OrderLineHaulSegment uuid on a committed leg; on a proposed leg (isProposed) there is no segment, so it is the synthetic id `proposed:<orderUuid>:<START>><END>` and must never be passed to a mutation that expects a segment uuid. */
  segmentUuid: Scalars['String']['output'];
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  /** How many countable units the order has in total, including any at no terminal. The denominator of the Location cell's fraction. */
  totalCountablePieceCount: Scalars['Int']['output'];
  weightLbs?: Maybe<Scalars['Float']['output']>;
};

export type DispatchProposedRoute = {
  __typename?: 'DispatchProposedRoute';
  /** Ordered terminal codes, e.g. ["ATL","MIA","GSP"]. */
  nodeCodes: Array<Scalars['String']['output']>;
  /** The same chain as terminal uuids; consecutive pairs are the route legs. */
  nodeTerminalUuids: Array<Scalars['String']['output']>;
};

export type DispatchRouteLeg = {
  __typename?: 'DispatchRouteLeg';
  endTerminalCode: Scalars['String']['output'];
  startTerminalCode: Scalars['String']['output'];
};

export type DispatchSuggestedManifestFailedOrder = {
  __typename?: 'DispatchSuggestedManifestFailedOrder';
  orderName: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export enum DispatchSuggestedManifestOutcome {
  Failed = 'FAILED',
  Loaded = 'LOADED'
}

export type DispatchSuggestedManifestResult = {
  __typename?: 'DispatchSuggestedManifestResult';
  created: Scalars['Boolean']['output'];
  failedOrders: Array<DispatchSuggestedManifestFailedOrder>;
  manifestReferenceNumber?: Maybe<Scalars['String']['output']>;
  manifestUuid?: Maybe<Scalars['String']['output']>;
  orderUuids: Array<Scalars['String']['output']>;
  outcome: DispatchSuggestedManifestOutcome;
  reason?: Maybe<Scalars['String']['output']>;
};

export type DispatchSuggestedManifestTargetInput = {
  departDate?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuids: Array<Scalars['String']['input']>;
  releaseFromBlockingManifest?: InputMaybe<Scalars['Boolean']['input']>;
  startTerminalUuid: Scalars['String']['input'];
};

export type DispatchTableColorEntity = {
  __typename?: 'DispatchTableColorEntity';
  active: Scalars['Boolean']['output'];
  appointmentEndWithinMinutes?: Maybe<Scalars['Int']['output']>;
  appointmentStartWithinMinutes?: Maybe<Scalars['Int']['output']>;
  color: Scalars['String']['output'];
  deadlineDateFilter?: Maybe<DeadlineDateFilter>;
  dispatchViewId?: Maybe<Scalars['String']['output']>;
  fields: Array<DispatchTableColorField>;
  hasAppointmentDate?: Maybe<Scalars['Boolean']['output']>;
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  service?: Maybe<ServiceEntity>;
  uuid: Scalars['String']['output'];
};

export enum DispatchTableColorField {
  AppointmentEndWithin = 'APPOINTMENT_END_WITHIN',
  AppointmentPassed = 'APPOINTMENT_PASSED',
  AppointmentStartWithin = 'APPOINTMENT_START_WITHIN',
  DeadlinePassed = 'DEADLINE_PASSED',
  DeadlineToday = 'DEADLINE_TODAY',
  DeadlineTomorrow = 'DEADLINE_TOMORROW',
  HasAppointmentDate = 'HAS_APPOINTMENT_DATE',
  IsSpecial = 'IS_SPECIAL',
  Service = 'SERVICE'
}

export type DispatchTableColorUpsertInput = {
  active: Scalars['Boolean']['input'];
  /** The number of minutes within the end of the appointment for the rule to apply */
  appointmentEndWithinMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The number of minutes within the start of the appointment for the rule to apply */
  appointmentStartWithinMinutes?: InputMaybe<Scalars['Int']['input']>;
  color: Scalars['String']['input'];
  /** @deprecated Use fields instead */
  deadlineDateFilter?: InputMaybe<DeadlineDateFilter>;
  dispatchViewId?: InputMaybe<Scalars['String']['input']>;
  /** The fields that are included in the rule, all joined in a conjunction (AND operator) when determining if a rule applies to a stop */
  fields?: InputMaybe<Array<DispatchTableColorField>>;
  hasAppointmentDate?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum DispatchTableField {
  Address = 'ADDRESS',
  AddressType = 'ADDRESS_TYPE',
  Appointment = 'APPOINTMENT',
  AppointmentDate = 'APPOINTMENT_DATE',
  AppointmentOptionsProposed = 'APPOINTMENT_OPTIONS_PROPOSED',
  AppointmentRequired = 'APPOINTMENT_REQUIRED',
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  AppointmentTime = 'APPOINTMENT_TIME',
  BusinessDivision = 'BUSINESS_DIVISION',
  CanDispatch = 'CAN_DISPATCH',
  City = 'CITY',
  Consignee = 'CONSIGNEE',
  Customer = 'CUSTOMER',
  Dims = 'DIMS',
  DueDate = 'DUE_DATE',
  Eta = 'ETA',
  HasAppointment = 'HAS_APPOINTMENT',
  InboundCity = 'INBOUND_CITY',
  InboundMethod = 'INBOUND_METHOD',
  InboundName = 'INBOUND_NAME',
  InboundPaperwork = 'INBOUND_PAPERWORK',
  InboundTerminal = 'INBOUND_TERMINAL',
  InboundZip = 'INBOUND_ZIP',
  Mawb = 'MAWB',
  OnHand = 'ON_HAND',
  OrderName = 'ORDER_NAME',
  OrderNotes = 'ORDER_NOTES',
  OrderNumber = 'ORDER_NUMBER',
  OrderStatus = 'ORDER_STATUS',
  OutboundCity = 'OUTBOUND_CITY',
  OutboundMethod = 'OUTBOUND_METHOD',
  OutboundName = 'OUTBOUND_NAME',
  OutboundPaperwork = 'OUTBOUND_PAPERWORK',
  OutboundTerminal = 'OUTBOUND_TERMINAL',
  OutboundZip = 'OUTBOUND_ZIP',
  PieceCount = 'PIECE_COUNT',
  PrimaryConsignee = 'PRIMARY_CONSIGNEE',
  Refused = 'REFUSED',
  RefNumber = 'REF_NUMBER',
  RouteName = 'ROUTE_NAME',
  ServiceDate = 'SERVICE_DATE',
  ServiceLevel = 'SERVICE_LEVEL',
  ServiceTime = 'SERVICE_TIME',
  Special = 'SPECIAL',
  SpecialInstructions = 'SPECIAL_INSTRUCTIONS',
  State = 'STATE',
  StopType = 'STOP_TYPE',
  Tags = 'TAGS',
  Terminal = 'TERMINAL',
  TotalCharges = 'TOTAL_CHARGES',
  VehicleTypeName = 'VEHICLE_TYPE_NAME',
  Weight = 'WEIGHT',
  ZipCode = 'ZIP_CODE'
}

export type DispatchTextDriverOutput = {
  __typename?: 'DispatchTextDriverOutput';
  driver: DriverEntity;
  textNotSentReason?: Maybe<Scalars['String']['output']>;
  textSent: Scalars['Boolean']['output'];
};

export type DispatchUnreachableCorridor = {
  __typename?: 'DispatchUnreachableCorridor';
  /** Terminal code of the corridor destination (the outbound terminal). */
  destinationTerminalCode: Scalars['String']['output'];
  /** Uuid of the destination terminal. */
  destinationTerminalUuid: Scalars['String']['output'];
  /** How many candidate orders move along this corridor and are therefore absent from the board. Never capped: it is the whole count, which the list below may not be. */
  orderCount: Scalars['Int']['output'];
  /** The stranded orders themselves, so the board can list them and open each one. Capped per corridor, and always a prefix of the corridor's orders in scan order, so orderCount minus this length is how many the cap dropped. A tenant with a healthy network reports no corridors at all, so this costs a normal board read nothing. */
  orders: Array<DispatchUnreachableOrder>;
  /** Terminal code of the corridor origin (the inbound terminal). */
  originTerminalCode: Scalars['String']['output'];
  /** Uuid of the origin terminal. This is the terminal whose outbound terminal lanes are missing, so it is the one to open to configure them. */
  originTerminalUuid: Scalars['String']['output'];
};

export type DispatchUnreachableOrder = {
  __typename?: 'DispatchUnreachableOrder';
  /** Terminal code the order is currently on hand at, when it is on hand anywhere. Null otherwise. */
  onHandTerminalCode?: Maybe<Scalars['String']['output']>;
  /** The order's display identifier (the same value the board's order rows show). */
  orderName: Scalars['String']['output'];
  /** Uuid of the stranded order. Opens the order form; it is not a segment uuid and addresses no row on the board, because this order produces no row. */
  orderUuid: Scalars['String']['output'];
  pieceCount?: Maybe<Scalars['Int']['output']>;
  weightLbs?: Maybe<Scalars['Float']['output']>;
};

export type DispatchViewCreateInput = {
  dispatchViewLayoutPositions?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  numberOfStops?: InputMaybe<Scalars['Int']['input']>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardStopTableFields?: InputMaybe<Array<DispatchTableField>>;
  routeCardWidth?: InputMaybe<Scalars['Int']['input']>;
  showCompleteStops?: InputMaybe<Scalars['Boolean']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchViewCreateOutput = DispatchViewCreateSuccessOutput | MutationErrorOutput;

export type DispatchViewCreateSuccessOutput = {
  __typename?: 'DispatchViewCreateSuccessOutput';
  dispatchView: DispatchViewEntity;
};

export type DispatchViewEntity = {
  __typename?: 'DispatchViewEntity';
  dispatchTableColors: Array<DispatchTableColorEntity>;
  dispatchViewLayoutPositions: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfStops: Scalars['Int']['output'];
  routeCardStopTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  routeCardStopTableFields: Array<DispatchTableField>;
  routeCardWidth: Scalars['Int']['output'];
  showCompleteStops: Scalars['Boolean']['output'];
  tabIndex: Scalars['Int']['output'];
  useMinimizedAppointmentTime: Scalars['Boolean']['output'];
};

export type DispatchViewUpdateInput = {
  dispatchViewLayoutPositions?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfStops?: InputMaybe<Scalars['Int']['input']>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardStopTableFields?: InputMaybe<Array<DispatchTableField>>;
  routeCardWidth?: InputMaybe<Scalars['Int']['input']>;
  showCompleteStops?: InputMaybe<Scalars['Boolean']['input']>;
  tabIndex?: InputMaybe<Scalars['Int']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchViewUpdateOutput = DispatchViewUpdateSuccessOutput | MutationErrorOutput;

export type DispatchViewUpdateSuccessOutput = {
  __typename?: 'DispatchViewUpdateSuccessOutput';
  dispatchView: DispatchViewEntity;
};

export type DispatchableAgentEntity = {
  __typename?: 'DispatchableAgentEntity';
  /** The default driver for this agent */
  defaultDriver: DriverEntity;
  name: Scalars['String']['output'];
  /** Non-default drivers that are dispatchable for this agent */
  nonDefaultDrivers: Array<DriverEntity>;
  uuid: Scalars['String']['output'];
};

export type DocExtractionCancelEvalRunResultEntity = {
  __typename?: 'DocExtractionCancelEvalRunResultEntity';
  cancelRequested: Scalars['Boolean']['output'];
  evalRunId: Scalars['String']['output'];
};

export type DocExtractionCreatedEvalSetEntity = {
  __typename?: 'DocExtractionCreatedEvalSetEntity';
  documentCount: Scalars['Int']['output'];
  evalSetId: Scalars['String']['output'];
  strata: Scalars['JSON']['output'];
};

export type DocExtractionEvalDocumentWordBoxesEntity = {
  __typename?: 'DocExtractionEvalDocumentWordBoxesEntity';
  pages: Array<DocExtractionEvalWordBoxPageEntity>;
};

export type DocExtractionEvalRunCostEstimateEntity = {
  __typename?: 'DocExtractionEvalRunCostEstimateEntity';
  inputTokens: Scalars['Float']['output'];
  outputTokens: Scalars['Float']['output'];
  pricingSource: Scalars['String']['output'];
  tokenProfileSource: Scalars['String']['output'];
  totalTokens: Scalars['Float']['output'];
  usd?: Maybe<Scalars['Float']['output']>;
};

export type DocExtractionEvalRunDocumentEntity = {
  __typename?: 'DocExtractionEvalRunDocumentEntity';
  companyUuid: Scalars['String']['output'];
  costUsd?: Maybe<Scalars['Float']['output']>;
  docScore?: Maybe<Scalars['JSON']['output']>;
  documentId: Scalars['String']['output'];
  errorDetail?: Maybe<Scalars['String']['output']>;
  errorKind?: Maybe<Scalars['String']['output']>;
  evalRunId: Scalars['String']['output'];
  extractedFields?: Maybe<Scalars['JSON']['output']>;
  inputTokens?: Maybe<Scalars['Float']['output']>;
  latencyMs?: Maybe<Scalars['Int']['output']>;
  outputTokens?: Maybe<Scalars['Float']['output']>;
  runMeta?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  verdicts?: Maybe<Scalars['JSON']['output']>;
};

export type DocExtractionEvalRunDocumentsPageEntity = {
  __typename?: 'DocExtractionEvalRunDocumentsPageEntity';
  documents: Array<DocExtractionEvalRunDocumentEntity>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type DocExtractionEvalRunEntity = {
  __typename?: 'DocExtractionEvalRunEntity';
  actualCostUsd?: Maybe<Scalars['Float']['output']>;
  actualInputTokens?: Maybe<Scalars['Float']['output']>;
  actualOutputTokens?: Maybe<Scalars['Float']['output']>;
  aggregates?: Maybe<Scalars['JSON']['output']>;
  bundleHash: Scalars['String']['output'];
  cancelRequestedAt?: Maybe<Scalars['String']['output']>;
  completedCount: Scalars['Int']['output'];
  config: Scalars['JSON']['output'];
  costEstimate?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  documentCount: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
  evalSetId: Scalars['String']['output'];
  executionMode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerBatchId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type DocExtractionEvalSetEntity = {
  __typename?: 'DocExtractionEvalSetEntity';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  documentCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  seed: Scalars['String']['output'];
  selectionConfig: Scalars['JSON']['output'];
  strataSummary: Scalars['JSON']['output'];
};

export type DocExtractionEvalSetPreviewEntity = {
  __typename?: 'DocExtractionEvalSetPreviewEntity';
  poolCutoffAt?: Maybe<Scalars['String']['output']>;
  sampleDocumentIds: Array<Scalars['String']['output']>;
  selectedCount: Scalars['Int']['output'];
  strata: Scalars['JSON']['output'];
  totalCandidates: Scalars['Int']['output'];
};

export type DocExtractionEvalWordBoxEntity = {
  __typename?: 'DocExtractionEvalWordBoxEntity';
  confidence: Scalars['Float']['output'];
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  top: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type DocExtractionEvalWordBoxPageEntity = {
  __typename?: 'DocExtractionEvalWordBoxPageEntity';
  pageNumber: Scalars['Int']['output'];
  textSource: Scalars['String']['output'];
  words: Array<DocExtractionEvalWordBoxEntity>;
};

export type DocExtractionLaunchEvalRunResultEntity = {
  __typename?: 'DocExtractionLaunchEvalRunResultEntity';
  bundleHash: Scalars['String']['output'];
  documentCount: Scalars['Int']['output'];
  evalRunId: Scalars['String']['output'];
};

export type DocScanVolumeByPipelineBucketEntity = {
  __typename?: 'DocScanVolumeByPipelineBucketEntity';
  endDate: Scalars['DateTime']['output'];
  pipeline: DocumentIngestionPipeline;
  startDate: Scalars['DateTime']['output'];
  totalCount: Scalars['Float']['output'];
};

export type DocScanVolumeByPipelineInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  period: ReportAggregationPeriod;
  startDate: Scalars['DateTime']['input'];
};

export type DockDoorAssignmentEntity = {
  __typename?: 'DockDoorAssignmentEntity';
  doorEventAt?: Maybe<Scalars['String']['output']>;
  doorPosition?: Maybe<Scalars['Int']['output']>;
  isReturnLeg: Scalars['Boolean']['output'];
  manifestUuid?: Maybe<Scalars['String']['output']>;
  routeUuid?: Maybe<Scalars['String']['output']>;
};

export type DockDoorAssignmentsInput = {
  manifestUuids: Array<Scalars['String']['input']>;
  routeUuids: Array<Scalars['String']['input']>;
  terminalUuid: Scalars['String']['input'];
};

export enum DockDoorDirection {
  Both = 'BOTH',
  In = 'IN',
  Out = 'OUT'
}

export type DockDoorEntity = {
  __typename?: 'DockDoorEntity';
  direction: DockDoorDirection;
  position: Scalars['Int']['output'];
  terminalUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type DockDoorInput = {
  direction: DockDoorDirection;
  position: Scalars['Int']['input'];
};

export type DockProductivityArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DockProductivityReportEntity = {
  __typename?: 'DockProductivityReportEntity';
  actualHoursAreProxy: Scalars['Boolean']['output'];
  appliedDockCostPerHourUsd?: Maybe<Scalars['Float']['output']>;
  costBasis: CostBasis;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  hasTimeAllowances: Scalars['Boolean']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  overallLaborEfficiencyPct?: Maybe<Scalars['Float']['output']>;
  terminals: Array<DockProductivityTerminalEntity>;
  timeAllowances: DockTimeAllowanceEntity;
  totalActualHours: Scalars['Float']['output'];
  totalAllowedHours: Scalars['Float']['output'];
  totalSavedCostUsd?: Maybe<Scalars['Float']['output']>;
  totalSavedHours: Scalars['Float']['output'];
};

/** Terminal dock standing relative to the labor-efficiency thresholds used by the Intelligence Board. */
export enum DockProductivityStatus {
  Efficient = 'EFFICIENT',
  Inefficient = 'INEFFICIENT',
  Moderate = 'MODERATE'
}

export type DockProductivityTerminalEntity = {
  __typename?: 'DockProductivityTerminalEntity';
  actualHours: Scalars['Float']['output'];
  allowedHours: Scalars['Float']['output'];
  inboundPieces: Scalars['Int']['output'];
  laborEfficiencyPct?: Maybe<Scalars['Float']['output']>;
  outboundPieces: Scalars['Int']['output'];
  savedCostUsd?: Maybe<Scalars['Float']['output']>;
  savedHours: Scalars['Float']['output'];
  status?: Maybe<DockProductivityStatus>;
  terminalCode: Scalars['String']['output'];
  terminalName: Scalars['String']['output'];
  terminalUuid: Scalars['String']['output'];
  totalWeightLbs: Scalars['Float']['output'];
};

export type DockReceivedKpiEntity = {
  __typename?: 'DockReceivedKpiEntity';
  arrivalScanCount: Scalars['Int']['output'];
  bucketUnit: KpiTrendBucketUnit;
  ordersReceivedCount: Scalars['Int']['output'];
  piecesReceivedCount: Scalars['Int']['output'];
  terminals: Array<DockReceivedTerminalRowEntity>;
  trend: Array<DockReceivedTrendBucketEntity>;
  unlinkedScanCount: Scalars['Int']['output'];
};

export type DockReceivedTerminalRowEntity = {
  __typename?: 'DockReceivedTerminalRowEntity';
  name?: Maybe<Scalars['String']['output']>;
  ordersReceivedCount: Scalars['Int']['output'];
  piecesReceivedCount: Scalars['Int']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type DockReceivedTrendBucketEntity = {
  __typename?: 'DockReceivedTrendBucketEntity';
  bucketDate: Scalars['String']['output'];
  piecesReceivedCount: Scalars['Int']['output'];
};

export type DockRunTimeEntity = {
  __typename?: 'DockRunTimeEntity';
  actualArriveAt?: Maybe<Scalars['String']['output']>;
  actualDepartAt?: Maybe<Scalars['String']['output']>;
  arriveAt?: Maybe<Scalars['String']['output']>;
  departAt?: Maybe<Scalars['String']['output']>;
  manifestUuid: Scalars['String']['output'];
};

export type DockRunTimesInput = {
  manifestUuids: Array<Scalars['String']['input']>;
};

export type DockScanReportInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use endDay, read in the report time zone */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Last calendar day of the report (YYYY-MM-DD), inclusive through 11:59:59 PM in the report time zone. Takes precedence over endDate. */
  endDay?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use startDay, read in the report time zone */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** First calendar day of the report (YYYY-MM-DD), starting at midnight in the report time zone. Takes precedence over startDate. */
  startDay?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DockScanReportOutput = {
  __typename?: 'DockScanReportOutput';
  rows: Array<DockScanReportRow>;
  /** IANA zone the date window was read in and times should be shown in: the terminal's ZIP zone when a terminal is filtered and its ZIP resolves, otherwise the company zone. */
  timeZone: Scalars['String']['output'];
};

export type DockScanReportRow = {
  __typename?: 'DockScanReportRow';
  barcode: Scalars['String']['output'];
  consigneeName?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  osdReason?: Maybe<Scalars['String']['output']>;
  packagesExpected: Scalars['Int']['output'];
  pieceMarkedOnHandOrdinal?: Maybe<Scalars['Int']['output']>;
  pieceName?: Maybe<Scalars['String']['output']>;
  piecesExpected: Scalars['Int']['output'];
  piecesOnHand: Scalars['Int']['output'];
  /** @deprecated Use scan.barcode instead */
  rawBarcode?: Maybe<Scalars['String']['output']>;
  /** When the server recorded the scan, the same clock the order audit log uses. */
  receivedAt: Scalars['DateTime']['output'];
  scan: ScanEntity;
  scanType: ScanType;
  scanUuid: Scalars['String']['output'];
  /** When the device reports the scan happened. */
  scannedAt: Scalars['DateTime']['output'];
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  terminalCode?: Maybe<Scalars['String']['output']>;
};

export type DockTimeAllowanceEntity = {
  __typename?: 'DockTimeAllowanceEntity';
  minutesPerHundredweight: Scalars['Float']['output'];
  minutesPerInboundPiece: Scalars['Float']['output'];
  minutesPerOutboundPiece: Scalars['Float']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type DocumentConnectInput = {
  uuid: Scalars['String']['input'];
};

export type DocumentCreateInput = {
  bucket: Scalars['String']['input'];
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  driverFormTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  freightSnapTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  shipmentUuid?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the storage order to attach the document to */
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
  /** A combination of the order billing party and ordinal separated by a hyphen. Used in the EOD flow */
  uniqueOrderIdentifier?: InputMaybe<Scalars['String']['input']>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentEntity = {
  __typename?: 'DocumentEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customDocumentName?: Maybe<Scalars['String']['output']>;
  dateUploadedFor?: Maybe<Scalars['DateTime']['output']>;
  driverFormTemplate?: Maybe<DriverSignableFormTemplateEntity>;
  expeditorsUploadFailedAt?: Maybe<Scalars['DateTime']['output']>;
  expeditorsUploadFailureReason?: Maybe<Scalars['String']['output']>;
  expeditorsUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  invoice?: Maybe<InvoiceEntity>;
  isDeleted: Scalars['Boolean']['output'];
  isPropagatedReference: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  preSignedGetUrl: Scalars['String']['output'];
  region: Scalars['String']['output'];
  shipment?: Maybe<OrderEntity>;
  signerName?: Maybe<Scalars['String']['output']>;
  thumbnailKey?: Maybe<Scalars['String']['output']>;
  type: DocumentType;
  updatedAt: Scalars['DateTime']['output'];
  uploadOrdinal?: Maybe<Scalars['Int']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type DocumentExtractionStatus = {
  __typename?: 'DocumentExtractionStatus';
  estimatedResumeAt?: Maybe<Scalars['DateTime']['output']>;
  parkedCount: Scalars['Int']['output'];
  paused: Scalars['Boolean']['output'];
  statusUnavailable: Scalars['Boolean']['output'];
};

export type DocumentForSigningInput = {
  documentUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
  signatureParty?: InputMaybe<SignatureParty>;
};

export type DocumentForSigningOutput = {
  __typename?: 'DocumentForSigningOutput';
  /** The document to download and stamp the signature onto. On a re-sign this is the root original, NOT the proof currently on the order, so a new signature is applied to unsigned bytes. Do NOT send this uuid back as attachMobileSignedDocumentToOrderAndReplaceOriginal.input.originalDocumentUuid -- that field takes the uuid of the document as it appears on the order. Sending this one names an already-superseded document, which the attach cannot tell apart from a retry: it answers with the copy already attached, so the signature just taken is lost. */
  document?: Maybe<DocumentEntity>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  pageDimensions: Array<DocumentPageDimensionsEntity>;
  /** Presigned GET for the PDF rendering to download and stamp when the original is an image. Null when the original is itself a PDF -- use document.preSignedGetUrl -- and null when signingUnavailableReason is set. Check this field BEFORE falling back to document.preSignedGetUrl: an image document's own bytes are not signable. */
  signablePdfPreSignedGetUrl?: Maybe<Scalars['String']['output']>;
  signingUnavailableReason?: Maybe<SigningUnavailableReason>;
  suggestedPlacement?: Maybe<SignaturePlacementSuggestionEntity>;
};

export enum DocumentIngestionPipeline {
  DocumentExtraction = 'DOCUMENT_EXTRACTION',
  Legacy = 'LEGACY'
}

export enum DocumentIngestionPipelineFilter {
  All = 'ALL',
  DocumentExtraction = 'DOCUMENT_EXTRACTION',
  Legacy = 'LEGACY'
}

export type DocumentPageDimensionsEntity = {
  __typename?: 'DocumentPageDimensionsEntity';
  heightPoints: Scalars['Float']['output'];
  pageNumber: Scalars['Int']['output'];
  widthPoints: Scalars['Float']['output'];
};

export type DocumentProvenanceEntity = {
  __typename?: 'DocumentProvenanceEntity';
  companyUuid: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  extractionRunId?: Maybe<Scalars['String']['output']>;
  fields: Array<ProvenanceFieldEntity>;
  modelVersion?: Maybe<Scalars['String']['output']>;
  taxonomyVersion?: Maybe<Scalars['String']['output']>;
};

export enum DocumentType {
  AbiNotes = 'ABI_NOTES',
  AccountingReport = 'ACCOUNTING_REPORT',
  Ace = 'ACE',
  ArrivalNotice = 'ARRIVAL_NOTICE',
  BackupEmail = 'BACKUP_EMAIL',
  BillOfLading = 'BILL_OF_LADING',
  CheckCopy = 'CHECK_COPY',
  CommercialInvoice = 'COMMERCIAL_INVOICE',
  CoverPage = 'COVER_PAGE',
  CustomsRelease = 'CUSTOMS_RELEASE',
  CustomDriverFormSignature = 'CUSTOM_DRIVER_FORM_SIGNATURE',
  DamageReport = 'DAMAGE_REPORT',
  DeliveryAlert = 'DELIVERY_ALERT',
  DeliveryOrder = 'DELIVERY_ORDER',
  DeliveryReceipt = 'DELIVERY_RECEIPT',
  DeliverySignature = 'DELIVERY_SIGNATURE',
  DigitalProofOfDelivery = 'DIGITAL_PROOF_OF_DELIVERY',
  DigitalProofOfPickup = 'DIGITAL_PROOF_OF_PICKUP',
  Document_7512 = 'DOCUMENT_7512',
  EndOfDayDocument = 'END_OF_DAY_DOCUMENT',
  Hawb = 'HAWB',
  Hazmat = 'HAZMAT',
  ItemizedTransportDocument = 'ITEMIZED_TRANSPORT_DOCUMENT',
  Labels = 'LABELS',
  Manifest = 'MANIFEST',
  Mawb = 'MAWB',
  OrderDocument = 'ORDER_DOCUMENT',
  OsdPhoto = 'OSD_PHOTO',
  Other = 'OTHER',
  OvernightSlip = 'OVERNIGHT_SLIP',
  PartnerDocument = 'PARTNER_DOCUMENT',
  PickupAlert = 'PICKUP_ALERT',
  PickupOrder = 'PICKUP_ORDER',
  PickupReceiptForEsign = 'PICKUP_RECEIPT_FOR_ESIGN',
  PickupSignature = 'PICKUP_SIGNATURE',
  PodBundle = 'POD_BUNDLE',
  PodReport = 'POD_REPORT',
  PrepaidReceipt = 'PREPAID_RECEIPT',
  ProofOfDelivery = 'PROOF_OF_DELIVERY',
  ProofOfDeliveryScanned = 'PROOF_OF_DELIVERY_SCANNED',
  RecoveryDocument = 'RECOVERY_DOCUMENT',
  Rejection = 'REJECTION',
  ShipmentPhoto = 'SHIPMENT_PHOTO',
  StorageUnitPhoto = 'STORAGE_UNIT_PHOTO',
  TransferManifest = 'TRANSFER_MANIFEST',
  TransportApprovalCertificate = 'TRANSPORT_APPROVAL_CERTIFICATE',
  VoidedCheck = 'VOIDED_CHECK'
}

export type DocumentUpdateInput = {
  bucket?: InputMaybe<Scalars['String']['input']>;
  customDocumentName?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  freightSnapTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  shipmentUuid?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DocumentType>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentUpsertInput = {
  bucket: Scalars['String']['input'];
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  signerName?: InputMaybe<Scalars['String']['input']>;
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type DocumentationItemCreateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  html: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  topicUuid: Scalars['String']['input'];
};

export type DocumentationItemEntity = {
  __typename?: 'DocumentationItemEntity';
  code?: Maybe<Scalars['String']['output']>;
  html: Scalars['String']['output'];
  htmlSizeBytes: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  status: DocumentationItemStatus;
  title: Scalars['String']['output'];
  topicUuid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum DocumentationItemStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type DocumentationItemSummaryEntity = {
  __typename?: 'DocumentationItemSummaryEntity';
  code?: Maybe<Scalars['String']['output']>;
  htmlSizeBytes: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  status: DocumentationItemStatus;
  title: Scalars['String']['output'];
  topicUuid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type DocumentationItemUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentationItemStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type DocumentationReorderInput = {
  topicUuid?: InputMaybe<Scalars['String']['input']>;
  uuids: Array<Scalars['String']['input']>;
};

export type DocumentationSearchInput = {
  query: Scalars['String']['input'];
};

export type DocumentationSearchResultEntity = {
  __typename?: 'DocumentationSearchResultEntity';
  code?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  snippet: Scalars['String']['output'];
  title: Scalars['String']['output'];
  topicTitle: Scalars['String']['output'];
  topicUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type DocumentationTopicCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type DocumentationTopicEntity = {
  __typename?: 'DocumentationTopicEntity';
  description?: Maybe<Scalars['String']['output']>;
  items: Array<DocumentationItemSummaryEntity>;
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type DocumentationTopicUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type DownloadInvoicesInput = {
  invoicesToDownload: Array<InvoiceToSend>;
};

export type DownloadInvoicesOutput = {
  __typename?: 'DownloadInvoicesOutput';
  combinedDocument?: Maybe<DocumentEntity>;
  documents: Array<DocumentEntity>;
  zipDocument?: Maybe<DocumentEntity>;
};

export type DriverCompletedStopsEntity = {
  __typename?: 'DriverCompletedStopsEntity';
  /** @deprecated Use arrivedAt in stopDriverMaps */
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use completedAt in stopDriverMaps */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use driver in stopDriverMaps */
  driverFirstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use driver in stopDriverMaps */
  driverLastName?: Maybe<Scalars['String']['output']>;
  stopDriverMaps: Array<StopDriverMapForCompletedStopsEntity>;
  /** @deprecated Use stopUuid in stopDriverMaps */
  stopUuid?: Maybe<Scalars['String']['output']>;
};

export type DriverComplianceDateInput = {
  /** YYYY-MM-DD */
  expiresOn?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** A COMPLIANCE credential type. */
  typeUuid: Scalars['String']['input'];
};

export type DriverComplianceDriverInput = {
  driverUuid: Scalars['String']['input'];
};

export type DriverComplianceEntity = {
  __typename?: 'DriverComplianceEntity';
  /** Compliance items (at most one per COMPLIANCE type, seeded types in Crown order), then training records grouped by type, oldest first. */
  credentials: Array<DriverCredentialEntity>;
  driverUuid: Scalars['String']['output'];
  /** Ordered by expiry date, soonest first. */
  insurancePolicies: Array<DriverInsurancePolicyEntity>;
  /** Always present; every field is empty for a driver whose profile was never saved. */
  profile: DriverComplianceProfileEntity;
};

export type DriverComplianceItemInput = {
  uuid: Scalars['String']['input'];
};

export type DriverComplianceProfileEntity = {
  __typename?: 'DriverComplianceProfileEntity';
  dateOfBirth?: Maybe<PlainDate>;
  hireDate?: Maybe<PlainDate>;
  /** Set by terminateDriver and cleared by rehireDriver. A terminated driver is always archived. */
  isTerminated: Scalars['Boolean']['output'];
  licenseClass?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  securityId?: Maybe<Scalars['String']['output']>;
  terminationComments?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<PlainDate>;
};

/** A driver compliance report file, returned in the response rather than stored: it holds license and policy numbers, and the documents bucket is publicly readable. */
export type DriverComplianceReportFileOutput = {
  __typename?: 'DriverComplianceReportFileOutput';
  /** The file contents, base64-encoded. */
  contentBase64: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type DriverComplianceReportInput = {
  /** Only credentials of these types. Null means every active type; an empty list means no credentials, so insurance can be reported alone. */
  credentialTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only these drivers. Null or empty means every driver. */
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Include archived and terminated drivers. Terminating a driver archives them, so the two cannot be told apart by this filter. */
  includeInactiveDrivers?: Scalars['Boolean']['input'];
  includeInsurancePolicies?: Scalars['Boolean']['input'];
  /** Only drivers assigned to these terminals. Null or empty means every driver, including those with no terminal. */
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Null lists every current item on file, whatever its expiry. A number lists only expired items and items expiring within that many days of the company's local day. Statuses always follow the company's expiring-soon setting, as on the status chips. */
  withinDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Expiry status in the company's local day. EXPIRING means within the company's expiring-soon window of the expiry date (`driverComplianceExpiringSoonDays`, 30 days by default); NOT_TRACKED means no expiry date is recorded. */
export enum DriverComplianceStatus {
  Current = 'CURRENT',
  Expired = 'EXPIRED',
  Expiring = 'EXPIRING',
  NotTracked = 'NOT_TRACKED'
}

export type DriverCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressUpsertInput>;
  defaultAccessorialSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  driverPayType?: InputMaybe<DriverPayType>;
  /** The IDs of the DriverQualifications the driver will have. This will replace any existing DriverQualifications. */
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  driverReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  driverType?: InputMaybe<DriverType>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  fuelCardNumber: Scalars['String']['input'];
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  lastName: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  perMileRate?: InputMaybe<Scalars['Float']['input']>;
  percentGrossRevenueRate?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber: Scalars['String']['input'];
  sendRouteUpdateEmails?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DriverCredentialEntity = {
  __typename?: 'DriverCredentialEntity';
  completedOn?: Maybe<PlainDate>;
  expiresOn?: Maybe<PlainDate>;
  notes?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: DriverComplianceStatus;
  type: DriverCredentialTypeEntity;
  uuid: Scalars['String']['output'];
};

export enum DriverCredentialKind {
  Compliance = 'COMPLIANCE',
  Training = 'TRAINING'
}

export enum DriverCredentialSystemKey {
  License = 'LICENSE',
  Mvr = 'MVR',
  Physical = 'PHYSICAL',
  Sta = 'STA',
  TsaTest = 'TSA_TEST',
  Violations = 'VIOLATIONS'
}

export type DriverCredentialTypeEntity = {
  __typename?: 'DriverCredentialTypeEntity';
  active: Scalars['Boolean']['output'];
  /** Whether any driver record uses the type. A type in use can be deactivated but not deleted. */
  inUse: Scalars['Boolean']['output'];
  kind: DriverCredentialKind;
  name: Scalars['String']['output'];
  /** Set on the six compliance types every company is seeded with. Stays fixed when the type is renamed. */
  systemKey?: Maybe<DriverCredentialSystemKey>;
  uuid: Scalars['String']['output'];
};

export type DriverDailyLogReportPdfInput = {
  completedStopsOnly: Scalars['Boolean']['input'];
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeLinehaulStops?: InputMaybe<Scalars['Boolean']['input']>;
  onlyEligibleForSettlement: Scalars['Boolean']['input'];
  serviceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  serviceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DriverEntity = {
  __typename?: 'DriverEntity';
  active: Scalars['Boolean']['output'];
  address?: Maybe<AddressEntity>;
  agent?: Maybe<AgentFieldsEntity>;
  agentId?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  /** The driver's worst compliance status, for badges: EXPIRED or EXPIRING when any tracked item is, NOT_TRACKED when nothing has an expiry date. Carries no dates or numbers, so unlike `driverCompliance` it needs no COMPANY_DRIVER_COMPLIANCE permission. Null only when the status could not be computed. */
  complianceStatus?: Maybe<DriverComplianceStatus>;
  currentLeg?: Maybe<LegEntity>;
  defaultAccessorialSettlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  defaultFuelSettlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  defaultLineHaulTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultOrdinaryTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultPointToPointTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultRecoveryTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultTransferTariffChainId?: Maybe<Scalars['String']['output']>;
  defaultVehicle?: Maybe<EquipmentEntity>;
  driverPayType?: Maybe<DriverPayType>;
  driverReferenceNumber?: Maybe<Scalars['String']['output']>;
  driverType?: Maybe<DriverType>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  expoPushTokens?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use user.name instead. For backwards compatibility, returns the first space-separated word of the user.name field. */
  firstName: Scalars['String']['output'];
  flatRate?: Maybe<Scalars['Float']['output']>;
  fuelCardNumber: Scalars['String']['output'];
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  lastCompletedLeg?: Maybe<LegEntity>;
  /** @deprecated Use user.name instead. For backwards compatibility, returns everything after the first space-separated word of the user.name field. */
  lastName: Scalars['String']['output'];
  legs: Array<LegEntity>;
  mobileCoordsLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  mobilePhoneLatitude?: Maybe<Scalars['Float']['output']>;
  mobilePhoneLongitude?: Maybe<Scalars['Float']['output']>;
  notes: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  perMileRate?: Maybe<Scalars['Float']['output']>;
  percentGrossRevenueRate?: Maybe<Scalars['Float']['output']>;
  phoneNumber: Scalars['String']['output'];
  qualifications: Array<DriverQualificationEntity>;
  route?: Maybe<RouteEntity>;
  sendRouteUpdateEmails: Scalars['Boolean']['output'];
  status: DriverStatus;
  terminal?: Maybe<TerminalEntity>;
  /** The identity of the user associated with the driver. All drivers have a user, which holds the driver's name and email. */
  user: UserActorEntity;
  uuid: Scalars['String']['output'];
};


export type DriverEntityLastCompletedLegArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type DriverEntityLegsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type DriverEntityRouteArgs = {
  date: Scalars['DateTime']['input'];
};

export type DriverEquipmentConstraintInput = {
  driverUuid: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  maxPieces?: InputMaybe<Scalars['Int']['input']>;
  maxVolume?: InputMaybe<Scalars['Volume']['input']>;
  maxWeight?: InputMaybe<Scalars['Mass']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DriverInsurancePolicyEntity = {
  __typename?: 'DriverInsurancePolicyEntity';
  carrierName?: Maybe<Scalars['String']['output']>;
  effectiveOn: PlainDate;
  expiresOn: PlainDate;
  insuranceType: Scalars['String']['output'];
  insuredAmountUsd?: Maybe<Scalars['Float']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  status: DriverComplianceStatus;
  uuid: Scalars['String']['output'];
};

export enum DriverLocationUpdateSource {
  MobileBackground = 'MOBILE_BACKGROUND',
  MobileForeground = 'MOBILE_FOREGROUND'
}

export type DriverOnRouteEntity = {
  __typename?: 'DriverOnRouteEntity';
  type: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type DriverOrdersInput = {
  driverUuid: Scalars['String']['input'];
  /** The route date to filter driver orders on */
  routeDate: Scalars['DateTime']['input'];
};

export type DriverOrdersOutput = {
  __typename?: 'DriverOrdersOutput';
  orders: Array<OrderEntity>;
};

export type DriverPayRateChangeActorEntity = {
  __typename?: 'DriverPayRateChangeActorEntity';
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type DriverPayRateChangeEventConnection = {
  __typename?: 'DriverPayRateChangeEventConnection';
  edges: Array<DriverPayRateChangeEventEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DriverPayRateChangeEventEdge = {
  __typename?: 'DriverPayRateChangeEventEdge';
  cursor: Scalars['String']['output'];
  node: DriverPayRateChangeEventEntity;
};

export type DriverPayRateChangeEventEntity = {
  __typename?: 'DriverPayRateChangeEventEntity';
  actor?: Maybe<DriverPayRateChangeActorEntity>;
  /** Null when no session made the change: an activation capture, an import, or another system write. */
  actorUserUuid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  driverSettlementBillUuid?: Maybe<Scalars['String']['output']>;
  driverUuid: Scalars['String']['output'];
  id: Scalars['String']['output'];
  next: Scalars['JSON']['output'];
  /** Null for DRIVER_DEFAULT_RATE, where the pay type is itself part of what can change and so appears inside previous/next. */
  payType?: Maybe<DriverPayType>;
  /** The value at this scope immediately before the change. Null when there was none, which is not the same as the first event ever: a pay bound that is deleted and later recreated records a null previous again. */
  previous?: Maybe<Scalars['JSON']['output']>;
  scope: DriverPayRateChangeScope;
  stopDriverMapPayTermsId?: Maybe<Scalars['String']['output']>;
  /** Null when the event is not about one unit of work, or when that work has since been deleted. */
  stopDriverMapUuid?: Maybe<Scalars['String']['output']>;
};

/** Which of a driver's three rate levels a history entry describes: the driver's own default configuration, a per-pay-type bound, or the terms frozen against one unit of work. */
export enum DriverPayRateChangeScope {
  DriverDefaultRate = 'DRIVER_DEFAULT_RATE',
  DriverPayBound = 'DRIVER_PAY_BOUND',
  StopDriverMapPayTerms = 'STOP_DRIVER_MAP_PAY_TERMS'
}

export enum DriverPayType {
  PercentGrossRevenue = 'PERCENT_GROSS_REVENUE',
  PerMile = 'PER_MILE'
}

export type DriverPhoneNumberAvailabilityOutput = {
  __typename?: 'DriverPhoneNumberAvailabilityOutput';
  available: Scalars['Boolean']['output'];
  sameCompanyDriverName?: Maybe<Scalars['String']['output']>;
  sameCompanyDriverUuid?: Maybe<Scalars['String']['output']>;
};

export type DriverPlannerArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DriverPlannerAssumptionEntity = {
  __typename?: 'DriverPlannerAssumptionEntity';
  standardShiftHours: Scalars['Float']['output'];
  targetMgt: Scalars['Float']['output'];
  targetUtilizationPct: Scalars['Float']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type DriverPlannerReportEntity = {
  __typename?: 'DriverPlannerReportEntity';
  actualUtilizationPct?: Maybe<Scalars['Float']['output']>;
  assumptions: DriverPlannerAssumptionEntity;
  avgNetHoursPerTrip?: Maybe<Scalars['Float']['output']>;
  avgProductiveHoursPerTrip?: Maybe<Scalars['Float']['output']>;
  costBasis: CostBasis;
  driverWageFringePerHourUsd?: Maybe<Scalars['Float']['output']>;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  excessCapacityLaborCostUsd?: Maybe<Scalars['Float']['output']>;
  excessCapacityPct?: Maybe<Scalars['Float']['output']>;
  excessTrips?: Maybe<Scalars['Float']['output']>;
  hasAssumptions: Scalars['Boolean']['output'];
  hasTimeAllowances: Scalars['Boolean']['output'];
  mgt?: Maybe<Scalars['Float']['output']>;
  missingCostInputs: Array<Scalars['String']['output']>;
  netHours: Scalars['Float']['output'];
  netHoursAreProxy: Scalars['Boolean']['output'];
  productiveHours: Scalars['Float']['output'];
  requiredTrips?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<DriverPlannerStatus>;
  targetProductiveHoursPerTrip: Scalars['Float']['output'];
  terminals: Array<DriverPlannerRowEntity>;
  tripsRun: Scalars['Int']['output'];
};

export type DriverPlannerRowEntity = {
  __typename?: 'DriverPlannerRowEntity';
  actualUtilizationPct?: Maybe<Scalars['Float']['output']>;
  avgNetHoursPerTrip?: Maybe<Scalars['Float']['output']>;
  avgProductiveHoursPerTrip?: Maybe<Scalars['Float']['output']>;
  excessCapacityLaborCostUsd?: Maybe<Scalars['Float']['output']>;
  excessCapacityPct?: Maybe<Scalars['Float']['output']>;
  excessTrips?: Maybe<Scalars['Float']['output']>;
  mgt?: Maybe<Scalars['Float']['output']>;
  netHours: Scalars['Float']['output'];
  productiveHours: Scalars['Float']['output'];
  requiredTrips?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<DriverPlannerStatus>;
  terminalCode: Scalars['String']['output'];
  terminalName: Scalars['String']['output'];
  terminalUuid: Scalars['String']['output'];
  tripsRun: Scalars['Int']['output'];
};

/** Terminal P&D capacity standing relative to the target MGT number used by the Intelligence Board. */
export enum DriverPlannerStatus {
  Balanced = 'BALANCED',
  ExcessCapacity = 'EXCESS_CAPACITY',
  UnderCapacity = 'UNDER_CAPACITY'
}

export type DriverQualificationEntity = {
  __typename?: 'DriverQualificationEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DriverReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type DriverReportBucketEntity = {
  __typename?: 'DriverReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  driverType?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lastName: Scalars['String']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type DriverSettlementBillConnection = {
  __typename?: 'DriverSettlementBillConnection';
  edges: Array<DriverSettlementBillEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DriverSettlementBillCreateInput = {
  billEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  billStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid: Scalars['String']['input'];
  finalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settlementDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  stopDriverMapUuidAdds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DriverSettlementBillEdge = {
  __typename?: 'DriverSettlementBillEdge';
  cursor: Scalars['String']['output'];
  node: DriverSettlementBillEntity;
};

export type DriverSettlementBillEntity = {
  __typename?: 'DriverSettlementBillEntity';
  billEndDate?: Maybe<Scalars['DateTime']['output']>;
  billStartDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  driver: DriverEntity;
  finalizedDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Use this for display instead of billStartDate and billEndDate */
  payPeriod: Scalars['String']['output'];
  paymentInformation: DriverSettlementPaymentEntity;
  settlementAdjustments: Array<SettlementAdjustmentEntity>;
  settlementBillLineItems: Array<SettlementBillLineItemEntity>;
  settlementDate?: Maybe<Scalars['DateTime']['output']>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductions: Array<SettlementDeductionEntity>;
  /** If valid settlement bill snapshot exists, returns snapshot JSON */
  snapshot?: Maybe<Scalars['JSON']['output']>;
  /** If valid settlement bill snapshot exists, returns true. Use this if you just need to verify snapshot existence to avoid fetching the entire snapshot. */
  snapshotExists: Scalars['Boolean']['output'];
  /** calculated by finding oldest completed stop in bill */
  totalDriverPayoutPreDeduction?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type DriverSettlementBillExportPdfInput = {
  /** The UUIDs of the driver settlement bills to include in the export. */
  driverSettlementBillUuids: Array<Scalars['String']['input']>;
  /** Whether to display the bill headers, including bill and company information. */
  includeHeaders: Scalars['Boolean']['input'];
  /** If true, return a detailed version of the bill. Otherwise, return a basic version. */
  includeLineItemDetails: Scalars['Boolean']['input'];
  /** Whether to display the line item totals aka driver pay. */
  includeLineItemTotals: Scalars['Boolean']['input'];
};

export type DriverSettlementBillForDownloadEntity = {
  __typename?: 'DriverSettlementBillForDownloadEntity';
  billEndDate?: Maybe<Scalars['DateTime']['output']>;
  billName?: Maybe<Scalars['String']['output']>;
  billStartDate?: Maybe<Scalars['DateTime']['output']>;
  billUuid: Scalars['String']['output'];
  driverFirstName?: Maybe<Scalars['String']['output']>;
  driverLastName?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  driverStationCode?: Maybe<Scalars['String']['output']>;
  finalizedDate?: Maybe<Scalars['DateTime']['output']>;
  settlementDate?: Maybe<Scalars['DateTime']['output']>;
  settlementDeductions?: Maybe<Array<SettlementDeductionForDownloadEntity>>;
  stopDriverMaps: Array<StopDriverMapForDownloadEntity>;
};

export type DriverSettlementBillUpdateInput = {
  /** @deprecated DO NOT USE, this is a field purely derived on the backend */
  billEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated DO NOT USE, this is a field purely derived on the backend */
  billStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  /** The date the bill was finalized. Only pass this in if bill is not finalized yet -- if it is already finalized, pass in undefined. */
  finalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settlementDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  stopDriverMapUuidAdds?: InputMaybe<Array<Scalars['String']['input']>>;
  stopDriverMapUuidDeletes?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type DriverSettlementPayBoundEntity = {
  __typename?: 'DriverSettlementPayBoundEntity';
  maxPayUsdCents?: Maybe<Scalars['Int']['output']>;
  minPayUsdCents?: Maybe<Scalars['Int']['output']>;
  payType: DriverPayType;
};

export type DriverSettlementPayBoundInput = {
  maxPayUsdCents?: InputMaybe<Scalars['Int']['input']>;
  minPayUsdCents?: InputMaybe<Scalars['Int']['input']>;
  payType: DriverPayType;
};

export type DriverSettlementPaymentEntity = {
  __typename?: 'DriverSettlementPaymentEntity';
  eligiblePay: Scalars['Currency']['output'];
  finalPay: Scalars['Currency']['output'];
  netAdjustments: Scalars['Currency']['output'];
  /** @deprecated During Robust Settlement Project. Use `netAdjustments` instead */
  totalDeductions?: Maybe<Scalars['Currency']['output']>;
};

export type DriverSettlementTotalAmountsOutput = {
  __typename?: 'DriverSettlementTotalAmountsOutput';
  payBasis: SettlementPayBasisOutput;
  totalChargesForSettlement: Scalars['Float']['output'];
  totalDriverPayout: Scalars['Float']['output'];
  totalEligibleAmountForStop: Scalars['Float']['output'];
};

export type DriverSignableFormTemplateEntity = {
  __typename?: 'DriverSignableFormTemplateEntity';
  createdAt: Scalars['DateTime']['output'];
  formText: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum DriverStatus {
  Assigned = 'ASSIGNED',
  Available = 'AVAILABLE'
}

export enum DriverType {
  CompanyDriver = 'COMPANY_DRIVER',
  Contractor = 'CONTRACTOR',
  OwnerOperator = 'OWNER_OPERATOR'
}

export type DriverUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressUpsertInput>;
  defaultAccessorialSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  driverPayType?: InputMaybe<DriverPayType>;
  /** The IDs of the DriverQualifications the driver will have. This will replace any existing DriverQualifications. */
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  driverReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  driverType?: InputMaybe<DriverType>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  fuelCardNumber?: InputMaybe<Scalars['String']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  perMileRate?: InputMaybe<Scalars['Float']['input']>;
  percentGrossRevenueRate?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sendRouteUpdateEmails?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type DunningReportInput = {
  contactUuid: Scalars['String']['input'];
  /** Optional free-text message rendered in the dunning report PDF above the footer. Applied to every recipient when sending in a batch. */
  customMessage?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateEdiPartnershipsInput = {
  destinationContactUuid: Scalars['String']['input'];
  replaceEdiPartnerships?: InputMaybe<Scalars['Boolean']['input']>;
  sourceContactUuid: Scalars['String']['input'];
};

export type DuplicateEdiPartnershipsOutput = {
  __typename?: 'DuplicateEdiPartnershipsOutput';
  contact?: Maybe<ContactEntity>;
  status: Scalars['String']['output'];
};

export type DuplicateTariffGroupInput = {
  uuid: Scalars['String']['input'];
};

export type DuplicateTariffGroupOutput = {
  __typename?: 'DuplicateTariffGroupOutput';
  tariffGroup: TariffGroupEntity;
};

export type DwellAlertFilterInput = {
  /** Dwell bands to include. Defaults to APPROACHING + OVER when omitted; including OK returns all on-dock freight. */
  statuses?: InputMaybe<Array<DwellStatus>>;
};

/** Dwell-time banding for on-dock freight relative to its effective threshold. */
export enum DwellStatus {
  Approaching = 'APPROACHING',
  Ok = 'OK',
  Over = 'OVER'
}

export type DwellTimeAlertConfigEntity = {
  __typename?: 'DwellTimeAlertConfigEntity';
  contact?: Maybe<ContactEntity>;
  createdAt: Scalars['DateTime']['output'];
  /** Whether this configuration row participates in alerting. */
  enabled: Scalars['Boolean']['output'];
  /** The dwell-time limit, in calendar days, beyond which on-dock freight is flagged. */
  thresholdDays: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse?: Maybe<WarehouseEntity>;
};

export enum Edi214Status {
  Af = 'AF',
  Av = 'AV',
  D1 = 'D1',
  I1 = 'I1',
  P1 = 'P1',
  X1 = 'X1',
  X3 = 'X3',
  X4 = 'X4',
  X6 = 'X6',
  X7 = 'X7'
}

export enum EdiTransactionCode {
  FunctionalAcknowledgement = 'FUNCTIONAL_ACKNOWLEDGEMENT',
  MotorCarrierBillOfLading = 'MOTOR_CARRIER_BILL_OF_LADING',
  MotorCarrierFreightDetailsAndInvoice = 'MOTOR_CARRIER_FREIGHT_DETAILS_AND_INVOICE',
  MotorCarrierLoadTender = 'MOTOR_CARRIER_LOAD_TENDER',
  ResponseToALoadTender = 'RESPONSE_TO_A_LOAD_TENDER',
  TransportationCarrierShipmentStatusMessage = 'TRANSPORTATION_CARRIER_SHIPMENT_STATUS_MESSAGE'
}

export enum EdiTransactionStatus {
  Failed = 'FAILED',
  Ignored = 'IGNORED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export enum EfmOutboundRequestStatusCode {
  Apt = 'APT',
  Arr = 'ARR',
  Atd = 'ATD',
  Cxl = 'CXL',
  Del = 'DEL',
  Dmg = 'DMG',
  Dsh = 'DSH',
  Lm = 'LM',
  Lm3 = 'LM3',
  Ofd = 'OFD',
  Osd = 'OSD',
  Pre = 'PRE',
  R2E = 'R2E',
  Rcd = 'RCD',
  Ref = 'REF'
}

export enum EfmOutboundRequestType {
  SubmitPodByShipperRefNo = 'SubmitPODByShipperRefNo',
  SubmitStatusByShipperRefNo = 'SubmitStatusByShipperRefNo',
  UpdateStatusByByShipperRefNo = 'UpdateStatusByByShipperRefNo',
  UploadPodDocumentByShipperRefNo = 'UploadPODDocumentByShipperRefNo'
}

export enum Edge {
  Bottom = 'BOTTOM',
  Left = 'LEFT',
  Right = 'RIGHT',
  Top = 'TOP'
}

export type EdgeAnchorEntity = {
  __typename?: 'EdgeAnchorEntity';
  blockId?: Maybe<Scalars['String']['output']>;
  edge: Edge;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  top: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type EdgeAnchorInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  edge: Edge;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  text: Scalars['String']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export enum Edi214ShipmentStatus {
  ContactAttempted = 'CONTACT_ATTEMPTED',
  DeliveryAppointmentCancelled = 'DELIVERY_APPOINTMENT_CANCELLED',
  DeliveryAppointmentConfirmed = 'DELIVERY_APPOINTMENT_CONFIRMED',
  DeliveryAppointmentRescheduled = 'DELIVERY_APPOINTMENT_RESCHEDULED',
  DeliveryArrived = 'DELIVERY_ARRIVED',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  DeliveryDispatched = 'DELIVERY_DISPATCHED',
  DeliveryOnHand = 'DELIVERY_ON_HAND',
  DeliveryRefused = 'DELIVERY_REFUSED',
  LineHaulArrivedAtDestination = 'LINE_HAUL_ARRIVED_AT_DESTINATION',
  LineHaulDeparted = 'LINE_HAUL_DEPARTED',
  LineHaulDepartedOrigin = 'LINE_HAUL_DEPARTED_ORIGIN',
  LineHaulReceived = 'LINE_HAUL_RECEIVED',
  OrderReceivedAtOrigin = 'ORDER_RECEIVED_AT_ORIGIN',
  PickupAppointmentCancelled = 'PICKUP_APPOINTMENT_CANCELLED',
  PickupAppointmentConfirmed = 'PICKUP_APPOINTMENT_CONFIRMED',
  PickupAppointmentRescheduled = 'PICKUP_APPOINTMENT_RESCHEDULED',
  PickupArrived = 'PICKUP_ARRIVED',
  PickupCompleted = 'PICKUP_COMPLETED',
  PickupDispatched = 'PICKUP_DISPATCHED',
  PickupRefused = 'PICKUP_REFUSED',
  PickupTransferred = 'PICKUP_TRANSFERRED',
  RecoveryCompleted = 'RECOVERY_COMPLETED'
}

export enum Edi990ActionCode {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED'
}

export enum EdiOutboundPayloadDestination {
  Boomi = 'BOOMI',
  Stedi = 'STEDI',
  Tenedi = 'TENEDI'
}

export type EdiPartnershipEntity = {
  __typename?: 'EdiPartnershipEntity';
  allowEditingShipperBillOfLadingNumber: Scalars['Boolean']['output'];
  alternateStediPartnerId?: Maybe<Scalars['String']['output']>;
  autoAcceptOrders: Scalars['Boolean']['output'];
  canCreateMultipleStops: Scalars['Boolean']['output'];
  companyStandardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  edi214ShipmentStatuses: Array<Edi214ShipmentStatus>;
  ediOutboundPayloadDestination: EdiOutboundPayloadDestination;
  enableStaging: Scalars['Boolean']['output'];
  enabled214Statuses: Array<Edi214Status>;
  excludeZeroChargeInvoices: Scalars['Boolean']['output'];
  ignoreCancellations: Scalars['Boolean']['output'];
  ignoreNonEdiOutbound: Scalars['Boolean']['output'];
  includeItemizedChargesIn210: Scalars['Boolean']['output'];
  includeOutboundFilenameReceiverIsaId: Scalars['Boolean']['output'];
  mergeLineHaul: Scalars['Boolean']['output'];
  outboundFilenameScacPrefix: Scalars['Boolean']['output'];
  removeSpacesFrom214Bol: Scalars['Boolean']['output'];
  requireGenerateEdi210Ids: Scalars['Boolean']['output'];
  send990InResponseTo204: Scalars['Boolean']['output'];
  send990InResponseTo211: Scalars['Boolean']['output'];
  sendBackupDocs: Scalars['Boolean']['output'];
  stedi210MappingId?: Maybe<Scalars['String']['output']>;
  stedi210TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stedi214MappingId?: Maybe<Scalars['String']['output']>;
  stedi214TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stedi990MappingId?: Maybe<Scalars['String']['output']>;
  stedi990TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stediPartnershipId?: Maybe<Scalars['String']['output']>;
  tiffPodUpload: Scalars['Boolean']['output'];
  timeOfPodUpload: TimeOfPodUpload;
  updatedAt: Scalars['DateTime']['output'];
  useStediGenerateEdiFunction: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type EdiPartnershipReferenceMappingEntity = {
  __typename?: 'EdiPartnershipReferenceMappingEntity';
  createdAt: Scalars['DateTime']['output'];
  label?: Maybe<Scalars['String']['output']>;
  qualifier: Scalars['String']['output'];
  target: EdiReferenceTarget;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type EdiPartnershipReferenceMappingUpsertInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  qualifier: Scalars['String']['input'];
  target: EdiReferenceTarget;
};

export type EdiPartnershipServiceMappingCreateInput = {
  ediValue: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
};

export type EdiPartnershipServiceMappingEntity = {
  __typename?: 'EdiPartnershipServiceMappingEntity';
  createdAt: Scalars['DateTime']['output'];
  ediValue: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  serviceUuid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type EdiReferenceEntity = {
  __typename?: 'EdiReferenceEntity';
  /** Display label from the partnership's reference mapping */
  label?: Maybe<Scalars['String']['output']>;
  /** X12 reference qualifier as received, e.g. BM, MB, ZZ */
  qualifier: Scalars['String']['output'];
  source: Scalars['String']['output'];
  /** Order field this reference filled; null when it filled none (unmapped, display-only, or lost to a dedicated value) */
  target?: Maybe<EdiReferenceTarget>;
  value: Scalars['String']['output'];
};

export enum EdiReferenceTarget {
  DisplayOnly = 'DISPLAY_ONLY',
  Hawb = 'HAWB',
  Mawb = 'MAWB',
  Po = 'PO',
  Quaternary = 'QUATERNARY',
  Quinary = 'QUINARY',
  RefNumbers = 'REF_NUMBERS',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export type EdiTransactionConnection = {
  __typename?: 'EdiTransactionConnection';
  edges: Array<EdiTransactionEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EdiTransactionEdge = {
  __typename?: 'EdiTransactionEdge';
  cursor: Scalars['String']['output'];
  node: EdiTransactionEntity;
};

export type EdiTransactionEntity = {
  __typename?: 'EdiTransactionEntity';
  code: EdiTransactionCode;
  createdAt: Scalars['DateTime']['output'];
  edi210NetAmountDueCents?: Maybe<Scalars['Int']['output']>;
  edi214ShipmentStatus?: Maybe<Edi214ShipmentStatus>;
  edi990ActionCode?: Maybe<Edi990ActionCode>;
  ediPayloadId?: Maybe<Scalars['String']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  ignoreInAudit: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  payload: Scalars['String']['output'];
  purposeCode?: Maybe<EdiTransactionPurposeCode>;
  receiverIsaId: Scalars['String']['output'];
  senderIsaId: Scalars['String']['output'];
  status: EdiTransactionStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum EdiTransactionPurposeCode {
  Cancellation = 'CANCELLATION',
  Change = 'CHANGE',
  Original = 'ORIGINAL'
}

export type EditContactsInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL with the contacts data to update */
  csvUrl: Scalars['String']['input'];
  /** The mappings between the CSV columns and the contact import fields. Should provide ContactIdentifier mapping. */
  mappings: Array<BulkUpdateContactMapping>;
};

export type EditContactsOutput = {
  __typename?: 'EditContactsOutput';
  failedContacts: Array<Scalars['String']['output']>;
  successfulContacts: Array<Scalars['String']['output']>;
};

export type EffectivePackageTypeConfigEntity = {
  __typename?: 'EffectivePackageTypeConfigEntity';
  isSingleHandlingUnit: Scalars['Boolean']['output'];
  packageType: PackageType;
};

export type EffectiveTariffChainEntity = {
  __typename?: 'EffectiveTariffChainEntity';
  source: TariffChainSource;
  tariffChain: TariffChainEntity;
  tariffGroupType: TariffGroupType;
};

export type EfmOutboundRequestEventEntity = {
  __typename?: 'EfmOutboundRequestEventEntity';
  clockworkStatusQueueId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  httpStatusCode?: Maybe<Scalars['Int']['output']>;
  requestType: EfmOutboundRequestType;
  statusCode?: Maybe<EfmOutboundRequestStatusCode>;
  uuid: Scalars['String']['output'];
};

export type EmailAccountingReportInput = {
  accountingReportDocumentUuid: Scalars['String']['input'];
  ccEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientEmail: Scalars['String']['input'];
  reportType: AccountingReportType;
  senderEmail?: InputMaybe<Scalars['String']['input']>;
};

export type EmailAccountingReportOutput = {
  __typename?: 'EmailAccountingReportOutput';
  status: EmailAccountingReportStatus;
};

export enum EmailAccountingReportStatus {
  NoAccountingReportUrl = 'NO_ACCOUNTING_REPORT_URL',
  NoRecipientEmail = 'NO_RECIPIENT_EMAIL',
  Other = 'OTHER',
  Success = 'SUCCESS'
}

export type EmailIngestionExcludedCustomerEntity = {
  __typename?: 'EmailIngestionExcludedCustomerEntity';
  displayName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type EmailIngestionExclusionsEntity = {
  __typename?: 'EmailIngestionExclusionsEntity';
  excludedCustomers: Array<EmailIngestionExcludedCustomerEntity>;
  excludedDocumentTypes: Array<ClassifiedDocumentType>;
};

export type EmailOrderDocumentInput = {
  ccEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  isQuote: Scalars['Boolean']['input'];
  orderDocumentDocumentUuid: Scalars['String']['input'];
  orderDocumentType: OrderDocumentType;
  orderIdentifier: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
  senderEmail?: InputMaybe<Scalars['String']['input']>;
};

export type EmailOrderDocumentOutput = {
  __typename?: 'EmailOrderDocumentOutput';
  status: EmailOrderDocumentStatus;
};

export enum EmailOrderDocumentStatus {
  NoOrderDocumentUrl = 'NO_ORDER_DOCUMENT_URL',
  NoRecipientEmail = 'NO_RECIPIENT_EMAIL',
  Other = 'OTHER',
  Success = 'SUCCESS'
}

export enum EmailSendStatus {
  Failed = 'FAILED',
  NotSent = 'NOT_SENT',
  PartiallySent = 'PARTIALLY_SENT',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type EmailSuppressionEntity = {
  __typename?: 'EmailSuppressionEntity';
  /** The address, lowercased. */
  email: Scalars['String']['output'];
  type: EmailSuppressionType;
};

export enum EmailSuppressionType {
  Bounce = 'BOUNCE',
  InvalidEmail = 'INVALID_EMAIL',
  SpamReport = 'SPAM_REPORT'
}

export type EmailTransactionConnection = {
  __typename?: 'EmailTransactionConnection';
  edges: Array<EmailTransactionEdge>;
  pageInfo: PageInfo;
};

export type EmailTransactionEdge = {
  __typename?: 'EmailTransactionEdge';
  cursor: Scalars['String']['output'];
  node: EmailTransactionEntity;
};

export type EmailTransactionEntity = {
  __typename?: 'EmailTransactionEntity';
  company: CompanyEntity;
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  document: DocumentEntity;
  emailResponse?: Maybe<Scalars['String']['output']>;
  emailResponseStatus?: Maybe<Scalars['Int']['output']>;
  emailTransactionLogs: Array<EmailTransactionLogEntity>;
  emailTransactionStatus: EmailTransactionStatus;
  emails: Array<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<InvoiceEntity>;
  pdfNotAttached: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type EmailTransactionLogCreateInput = {
  email: Scalars['String']['input'];
  emailTransactionUuid: Scalars['String']['input'];
  lastStatus?: InputMaybe<EmailTransactionLogStatus>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTransactionLogEntity = {
  __typename?: 'EmailTransactionLogEntity';
  email: Scalars['String']['output'];
  lastStatus?: Maybe<EmailTransactionLogStatus>;
  reason?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export enum EmailTransactionLogStatus {
  Blocked = 'BLOCKED',
  Bounced = 'BOUNCED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  Dropped = 'DROPPED',
  Processed = 'PROCESSED'
}

export type EmailTransactionLogUpdateInput = {
  email: Scalars['String']['input'];
  emailTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  lastStatus?: InputMaybe<EmailTransactionLogStatus>;
  reason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum EmailTransactionStatus {
  Failed = 'FAILED',
  PartiallySent = 'PARTIALLY_SENT',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type EndOfDayDocumentProcessingJobEntity = {
  __typename?: 'EndOfDayDocumentProcessingJobEntity';
  createdAt: Scalars['DateTime']['output'];
  dateUploadedFor: Scalars['DateTime']['output'];
  status: EndOfDayDocumentsProcessingJobStatus;
  updatedAt: Scalars['DateTime']['output'];
  uploadedFileName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum EndOfDayDocumentsProcessingJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type EodDocumentCreateInput = {
  bucket: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  signerName?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  thumbnailKey?: InputMaybe<Scalars['String']['input']>;
  type: DocumentType;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EquipmentCreateInput = {
  /** capacity of equipment */
  capacity?: InputMaybe<Scalars['Float']['input']>;
  /** equipment licenses to be created for this equipment */
  equipmentLicenseCreateInputs: Array<EquipmentLicenseCreateInput>;
  /** height of equipment */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** length of equipment */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** measurement system used for equipment data */
  measurementSystem: MeasurementSystem;
  /** name of equipment */
  name: Scalars['String']['input'];
  /** notes for equipment */
  notes?: InputMaybe<Scalars['String']['input']>;
  samsaraIsDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** special operating rules for equipment */
  specialRules?: InputMaybe<Scalars['String']['input']>;
  type: EquipmentType;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  /** weight of equipment */
  weight?: InputMaybe<Scalars['Float']['input']>;
  /** width of equipment */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type EquipmentEntity = {
  __typename?: 'EquipmentEntity';
  capacity?: Maybe<Scalars['Float']['output']>;
  equipmentLicenses: Array<EquipmentLicenseEntity>;
  height?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  /** Measurement system used. Defaults to Imperial */
  measurementSystem: MeasurementSystem;
  motiveIsDeactivated?: Maybe<Scalars['Boolean']['output']>;
  motiveVehicleId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  samsaraIsDeactivated?: Maybe<Scalars['Boolean']['output']>;
  samsaraVehicleId?: Maybe<Scalars['String']['output']>;
  specialRules?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  type: EquipmentType;
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type EquipmentLicenseArrayUpdateInput = {
  equipmentLicenseCreateInput?: InputMaybe<EquipmentLicenseCreateInput>;
  equipmentLicenseUpdateInput?: InputMaybe<EquipmentLicenseUpdateInput>;
};

export type EquipmentLicenseCreateInput = {
  /** Expiry date of the license */
  expiryDate: Scalars['DateTime']['input'];
  /** Issue date of the license */
  issueDate: Scalars['DateTime']['input'];
  /** Equipment license type */
  licenseType: Scalars['String']['input'];
  /** Licensing body which provided the license */
  licensingBody: Scalars['String']['input'];
  /** Equipment license Number (e.g. plate number) */
  number: Scalars['String']['input'];
};

export type EquipmentLicenseEntity = {
  __typename?: 'EquipmentLicenseEntity';
  /** Expiry date of the license */
  expiryDate: Scalars['DateTime']['output'];
  /** Issue date of the license */
  issueDate: Scalars['DateTime']['output'];
  /** Equipment license type */
  licenseType: Scalars['String']['output'];
  /** Licensing body which provided the license */
  licensingBody: Scalars['String']['output'];
  /** Equipment license Number (e.g. plate number) */
  number: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type EquipmentLicenseUpdateInput = {
  /** New expiry date */
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** New issue date */
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** New license type */
  licenseType?: InputMaybe<Scalars['String']['input']>;
  /** New licensing body */
  licensingBody?: InputMaybe<Scalars['String']['input']>;
  /** New license number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** uuid of equipment license to update */
  uuid: Scalars['String']['input'];
};

export enum EquipmentType {
  Chassis = 'CHASSIS',
  Trailer = 'TRAILER',
  Vehicle = 'VEHICLE'
}

export type EquipmentUpdateInput = {
  /** capacity of equipment */
  capacity?: InputMaybe<Scalars['Float']['input']>;
  /** update objects (union type) for equipment licenses */
  equipmentLicenseArrayUpdateInputs?: InputMaybe<Array<EquipmentLicenseArrayUpdateInput>>;
  /** height of equipment */
  height?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** length of equipment */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** measurement system used for equipment data */
  measurementSystem?: InputMaybe<MeasurementSystem>;
  /** name of equipment */
  name?: InputMaybe<Scalars['String']['input']>;
  /** notes for equipment */
  notes?: InputMaybe<Scalars['String']['input']>;
  samsaraIsDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** special operating rules for equipment */
  specialRules?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EquipmentType>;
  /** uuid of the equipment to be updated */
  uuid: Scalars['String']['input'];
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  /** weight of equipment */
  weight?: InputMaybe<Scalars['Float']['input']>;
  /** width of equipment */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type EstimateDocExtractionEvalRunInput = {
  config: Scalars['JSON']['input'];
  evalSetId: Scalars['String']['input'];
  executionMode?: InputMaybe<Scalars['String']['input']>;
};

export type EtaEntity = {
  __typename?: 'EtaEntity';
  arrivalTime: Scalars['DateTime']['output'];
  finishTime: Scalars['DateTime']['output'];
};

export type ExecutePackingPendencyInput = {
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  pendencyUuid: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PieceStatus>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type ExecutePackingPendencyOutput = {
  __typename?: 'ExecutePackingPendencyOutput';
  packingPendency: PackingPendencyEntity;
  piece?: Maybe<PieceEntity>;
  restoredPieceCount?: Maybe<Scalars['Int']['output']>;
  unpackedParentCount?: Maybe<Scalars['Int']['output']>;
};

export type ExistingInvoiceToUpdate = {
  __typename?: 'ExistingInvoiceToUpdate';
  invoiceUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ordersToAdd: Array<OrderToAddToInvoice>;
};

export type ExistingSettlementBillInput = {
  driverSettlementBillUuid: Scalars['String']['input'];
  settlementBillLineItemIds: Array<Scalars['String']['input']>;
};

export type ExpeditorsApiStatusEntity = {
  __typename?: 'ExpeditorsApiStatusEntity';
  connection: ExpeditorsConnectionHealth;
  generatedAt: Scalars['DateTime']['output'];
  timezone: Scalars['String']['output'];
  transmissions: Array<ExpeditorsTransmissionRow>;
  transmissionsTotal: Scalars['Int']['output'];
  windowEnd: Scalars['DateTime']['output'];
  windowStart: Scalars['DateTime']['output'];
};

export type ExpeditorsConnectionHealth = {
  __typename?: 'ExpeditorsConnectionHealth';
  avgAttempts?: Maybe<Scalars['Float']['output']>;
  degraded: Scalars['Boolean']['output'];
  failingSendsCount: Scalars['Int']['output'];
  heldCount: Scalars['Int']['output'];
  longestWaitMinutes?: Maybe<Scalars['Int']['output']>;
};

export type ExpeditorsOutboundRequestEventEntity = {
  __typename?: 'ExpeditorsOutboundRequestEventEntity';
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  httpStatusCode?: Maybe<Scalars['Int']['output']>;
  requestType: ExpeditorsOutboundRequestType;
  uuid: Scalars['String']['output'];
  workOrderNumber?: Maybe<Scalars['String']['output']>;
};

export enum ExpeditorsOutboundRequestType {
  AcceptWorkOrder = 'ACCEPT_WORK_ORDER',
  DownloadDocuments = 'DOWNLOAD_DOCUMENTS',
  GetAllWorkOrderByStatus = 'GET_ALL_WORK_ORDER_BY_STATUS',
  GetAvailableWorkOrders = 'GET_AVAILABLE_WORK_ORDERS',
  GetFreightDetails = 'GET_FREIGHT_DETAILS',
  GetWorkOrder = 'GET_WORK_ORDER',
  RejectWorkOrder = 'REJECT_WORK_ORDER',
  UpdateStatus = 'UPDATE_STATUS',
  UploadDocument = 'UPLOAD_DOCUMENT'
}

/** What one outbound call carried to Expeditors. */
export enum ExpeditorsTransmissionKind {
  Accepted = 'ACCEPTED',
  Arrived = 'ARRIVED',
  ArrivedPickup = 'ARRIVED_PICKUP',
  Delivered = 'DELIVERED',
  DeliveredWithPodImage = 'DELIVERED_WITH_POD_IMAGE',
  Other = 'OTHER',
  OtherDocument = 'OTHER_DOCUMENT',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  PickedUp = 'PICKED_UP',
  PickupAppointment = 'PICKUP_APPOINTMENT',
  PodImage = 'POD_IMAGE',
  Rejected = 'REJECTED'
}

/** Where a transmission to Expeditors ended up. */
export enum ExpeditorsTransmissionResult {
  AlreadyApplied = 'ALREADY_APPLIED',
  ConnectionError = 'CONNECTION_ERROR',
  Received = 'RECEIVED',
  RejectedByForwarder = 'REJECTED_BY_FORWARDER'
}

export type ExpeditorsTransmissionRow = {
  __typename?: 'ExpeditorsTransmissionRow';
  consigneeCity?: Maybe<Scalars['String']['output']>;
  consigneeName?: Maybe<Scalars['String']['output']>;
  consigneeState?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventUuid: Scalars['String']['output'];
  kind: ExpeditorsTransmissionKind;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  result: ExpeditorsTransmissionResult;
  retriedLater: Scalars['Boolean']['output'];
  transmittedAt: Scalars['DateTime']['output'];
};

export type ExpireQuoteAgentPreviousForwardingTokenOutput = ExpireQuoteAgentPreviousForwardingTokenSuccessOutput | MutationErrorOutput;

export type ExpireQuoteAgentPreviousForwardingTokenSuccessOutput = {
  __typename?: 'ExpireQuoteAgentPreviousForwardingTokenSuccessOutput';
  forwardingAddress: Scalars['String']['output'];
  /** False when no replaced address was still working, so nothing changed. */
  previousExpired: Scalars['Boolean']['output'];
};

export type ExpiredTariffGroupEntity = {
  __typename?: 'ExpiredTariffGroupEntity';
  /** Other tariff groups that also expired and would have rated this shipment, so a "+N more" affordance can name them. */
  additional: Array<ExpiredTariffGroupSummaryEntity>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tariffGroupScope?: Maybe<TariffGroupScope>;
  tariffGroupType?: Maybe<TariffGroupType>;
};

export type ExpiredTariffGroupSummaryEntity = {
  __typename?: 'ExpiredTariffGroupSummaryEntity';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ExportInvoicesToQuickbooksInput = {
  invoiceUuids: Array<Scalars['String']['input']>;
};

export type ExportQuickbooksResult = {
  __typename?: 'ExportQuickbooksResult';
  conductorUserFacingErrors: Array<Scalars['String']['output']>;
  duplicateInvoiceError?: Maybe<Scalars['String']['output']>;
  failedInvoiceUuid: Scalars['String']['output'];
  invoice: QuickbooksDesktopInvoiceEntity;
  missingAccessorialMappings: Array<Scalars['String']['output']>;
  missingCustomerName?: Maybe<Scalars['String']['output']>;
  missingCustomerUuid?: Maybe<Scalars['String']['output']>;
  missingFreightChargeMappings: Array<Scalars['String']['output']>;
  missingFuelChargeMappings: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ExternalFreightRatingStatus {
  NeedsRate = 'NEEDS_RATE',
  Rated = 'RATED',
  Stored = 'STORED'
}

export type ExternalRateQuoteDownloadEntity = {
  __typename?: 'ExternalRateQuoteDownloadEntity';
  attemptCount: Scalars['Int']['output'];
  attemptedAt: Scalars['DateTime']['output'];
  cacheHit: Scalars['Boolean']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  errorCode?: Maybe<ExternalRatingErrorCode>;
  /** 0, or 1 for the fallback after SMC3 code 32. */
  exchangeOrdinal: Scalars['Int']['output'];
  /** The reference ID shown with a rating error. */
  operationId: Scalars['String']['output'];
  provider: ExternalRatingProvider;
  providerCode?: Maybe<Scalars['String']['output']>;
  providerEnvironment: Scalars['String']['output'];
  providerFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  request: Scalars['JSON']['output'];
  /** Null when no answer arrived. */
  response?: Maybe<Scalars['JSON']['output']>;
  status: ExternalRateQuoteStatus;
  uuid: Scalars['String']['output'];
  wireRequest: Scalars['JSON']['output'];
};

export type ExternalRateQuoteEntity = {
  __typename?: 'ExternalRateQuoteEntity';
  billedWeightLbs?: Maybe<Scalars['Int']['output']>;
  deficitWeightLbs?: Maybe<Scalars['Int']['output']>;
  errorCode?: Maybe<ExternalRatingErrorCode>;
  finalCents?: Maybe<Scalars['Int']['output']>;
  grossTotalCents?: Maybe<Scalars['Int']['output']>;
  lines: Array<ExternalRatingLine>;
  minimumChargeCents?: Maybe<Scalars['Int']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  providerFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  ratingDate: PlainDate;
  ratingDateSource: RatingDateSource;
  status: ExternalRateQuoteStatus;
  tariffEffectiveDate: PlainDate;
  tariffName: Scalars['String']['output'];
  tariffResolutionReason: TariffResolutionReason;
  uuid: Scalars['String']['output'];
};

export enum ExternalRateQuoteStatus {
  ProviderError = 'PROVIDER_ERROR',
  Rated = 'RATED',
  RejectedResponse = 'REJECTED_RESPONSE',
  TransportError = 'TRANSPORT_ERROR'
}

export enum ExternalRatingErrorCode {
  AmountOutOfRange = 'AMOUNT_OUT_OF_RANGE',
  AuthFailed = 'AUTH_FAILED',
  InvalidPostalCode = 'INVALID_POSTAL_CODE',
  InvalidWeight = 'INVALID_WEIGHT',
  LicenseExpired = 'LICENSE_EXPIRED',
  MalformedResponse = 'MALFORMED_RESPONSE',
  MissingClass = 'MISSING_CLASS',
  MissingPackages = 'MISSING_PACKAGES',
  MissingTerminalAddress = 'MISSING_TERMINAL_ADDRESS',
  MissingWeight = 'MISSING_WEIGHT',
  NotYetRated = 'NOT_YET_RATED',
  NoTariffConfigured = 'NO_TARIFF_CONFIGURED',
  NoTariffVersion = 'NO_TARIFF_VERSION',
  PinnedVersionUnavailable = 'PINNED_VERSION_UNAVAILABLE',
  PointNotInTariff = 'POINT_NOT_IN_TARIFF',
  PointUnresolved = 'POINT_UNRESOLVED',
  PostalCodeRejected = 'POSTAL_CODE_REJECTED',
  ProviderErrorOther = 'PROVIDER_ERROR_OTHER',
  ProviderNotEnabled = 'PROVIDER_NOT_ENABLED',
  ProviderPaused = 'PROVIDER_PAUSED',
  ProviderRateLimited = 'PROVIDER_RATE_LIMITED',
  ProviderRequestRejected = 'PROVIDER_REQUEST_REJECTED',
  ProviderServerError = 'PROVIDER_SERVER_ERROR',
  ProviderTimeout = 'PROVIDER_TIMEOUT',
  ProviderUnreachable = 'PROVIDER_UNREACHABLE',
  TariffListUnavailable = 'TARIFF_LIST_UNAVAILABLE',
  TariffProblem = 'TARIFF_PROBLEM',
  TransactionLimit = 'TRANSACTION_LIMIT',
  UnreconciledResponse = 'UNRECONCILED_RESPONSE',
  UnsupportedCountry = 'UNSUPPORTED_COUNTRY',
  UnsupportedCurrency = 'UNSUPPORTED_CURRENCY',
  WeightOutOfRange = 'WEIGHT_OUT_OF_RANGE'
}

export type ExternalRatingFailure = {
  __typename?: 'ExternalRatingFailure';
  code: ExternalRatingErrorCode;
  message: Scalars['String']['output'];
  packageIndex?: Maybe<Scalars['Int']['output']>;
  /** The operation ID support searches in logs and exchanges */
  referenceId?: Maybe<Scalars['String']['output']>;
  retryAfter?: Maybe<Scalars['DateTime']['output']>;
  retryable: Scalars['Boolean']['output'];
};

export type ExternalRatingLine = {
  __typename?: 'ExternalRatingLine';
  amountCents: Scalars['Int']['output'];
  freightClass?: Maybe<Scalars['String']['output']>;
  isMinimumAdjustment: Scalars['Boolean']['output'];
  weightLbs?: Maybe<Scalars['Int']['output']>;
};

export enum ExternalRatingProvider {
  Smc3 = 'SMC3'
}

export type ExternalRatingResult = ExternalRatingFailure | ExternalRatingSuccess;

export type ExternalRatingSuccess = {
  __typename?: 'ExternalRatingSuccess';
  deficitWeightLbs: Scalars['Int']['output'];
  finalCents: Scalars['Int']['output'];
  lines: Array<ExternalRatingLine>;
  minimumAdjustmentCents: Scalars['Int']['output'];
  /** ISO date, YYYY-MM-DD */
  tariffEffectiveDate: Scalars['String']['output'];
  tariffName: Scalars['String']['output'];
};

export type ExtractedFieldEntity = {
  __typename?: 'ExtractedFieldEntity';
  field: FieldMapping;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ExtractedFieldInput = {
  field?: InputMaybe<FieldMapping>;
  value: Scalars['String']['input'];
};

export enum ExtractionType {
  Contact = 'CONTACT',
  Noop = 'NOOP',
  Regex = 'REGEX',
  SelectAll = 'SELECT_ALL',
  TrimLeft = 'TRIM_LEFT',
  TrimRight = 'TRIM_RIGHT'
}

export type FeatureFlagCompanyOverrideArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  featureFlagCompanyOverrideCreateInput?: InputMaybe<FeatureFlagCompanyOverrideCreateInput>;
  /** Pass this field in to update an array item */
  featureFlagCompanyOverrideUpdateInput?: InputMaybe<FeatureFlagCompanyOverrideUpdateInput>;
};

export type FeatureFlagCompanyOverrideCreateInput = {
  active: Scalars['Boolean']['input'];
  companyUuid: Scalars['String']['input'];
};

export type FeatureFlagCompanyOverrideEntity = {
  __typename?: 'FeatureFlagCompanyOverrideEntity';
  active: Scalars['Boolean']['output'];
  /** Convenience field for retool */
  companyName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FeatureFlagCompanyOverrideUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type FeatureFlagCreateInput = {
  active: Scalars['Boolean']['input'];
  featureFlagCompanyOverrideCreateInput?: InputMaybe<Array<FeatureFlagCompanyOverrideCreateInput>>;
  name: Scalars['String']['input'];
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlagEntity = {
  __typename?: 'FeatureFlagEntity';
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  versionId?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagInput = {
  name: Scalars['String']['input'];
};

export type FeatureFlagRemoveInput = {
  uuid: Scalars['String']['input'];
};

export type FeatureFlagUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  featureFlagCompanyOverrideArrayUpdateInput?: InputMaybe<Array<FeatureFlagCompanyOverrideArrayUpdateInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlagUserOverrideEntity = {
  __typename?: 'FeatureFlagUserOverrideEntity';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  featureFlagUuid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: UserActorEntity;
  /** Convenience field for retool  */
  userEmail: Scalars['String']['output'];
  userUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FieldExtractorEntity = {
  __typename?: 'FieldExtractorEntity';
  mapping: FieldMapping;
  type: ExtractionType;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FieldExtractorInput = {
  mapping: FieldMapping;
  type: ExtractionType;
  value: Scalars['String']['input'];
};

export enum FieldMapping {
  BillOfLadingNumber = 'BILL_OF_LADING_NUMBER',
  CodAmount = 'COD_AMOUNT',
  CodCurrency = 'COD_CURRENCY',
  ConsigneeAddressAll = 'CONSIGNEE_ADDRESS_ALL',
  ConsigneeAddressCity = 'CONSIGNEE_ADDRESS_CITY',
  ConsigneeAddressCountry = 'CONSIGNEE_ADDRESS_COUNTRY',
  ConsigneeAddressLine_1 = 'CONSIGNEE_ADDRESS_LINE_1',
  ConsigneeAddressLine_2 = 'CONSIGNEE_ADDRESS_LINE_2',
  ConsigneeAddressState = 'CONSIGNEE_ADDRESS_STATE',
  ConsigneeAddressZip = 'CONSIGNEE_ADDRESS_ZIP',
  ConsigneeContactFirstName = 'CONSIGNEE_CONTACT_FIRST_NAME',
  ConsigneeContactLastName = 'CONSIGNEE_CONTACT_LAST_NAME',
  ConsigneeName = 'CONSIGNEE_NAME',
  ConsigneePhone = 'CONSIGNEE_PHONE',
  Contact = 'CONTACT',
  CurrentPage = 'CURRENT_PAGE',
  DeadlineDate = 'DEADLINE_DATE',
  DeadlineDateStated = 'DEADLINE_DATE_STATED',
  DeadlineType = 'DEADLINE_TYPE',
  DeclaredValueAmount = 'DECLARED_VALUE_AMOUNT',
  DeclaredValueCurrency = 'DECLARED_VALUE_CURRENCY',
  Delivery = 'DELIVERY',
  DeliveryOrderNumber = 'DELIVERY_ORDER_NUMBER',
  DocumentDate = 'DOCUMENT_DATE',
  FreightChargeAmount = 'FREIGHT_CHARGE_AMOUNT',
  FreightChargeCurrency = 'FREIGHT_CHARGE_CURRENCY',
  HazmatClass = 'HAZMAT_CLASS',
  HazmatProperShippingName = 'HAZMAT_PROPER_SHIPPING_NAME',
  HazmatUnNumber = 'HAZMAT_UN_NUMBER',
  MasterAirwayBill = 'MASTER_AIRWAY_BILL',
  OrderNumber = 'ORDER_NUMBER',
  Package_0Description = 'PACKAGE_0_DESCRIPTION',
  Package_0DimensionUnit = 'PACKAGE_0_DIMENSION_UNIT',
  Package_0Height = 'PACKAGE_0_HEIGHT',
  Package_0Length = 'PACKAGE_0_LENGTH',
  Package_0Quantity = 'PACKAGE_0_QUANTITY',
  Package_0Weight = 'PACKAGE_0_WEIGHT',
  Package_0WeightUnit = 'PACKAGE_0_WEIGHT_UNIT',
  Package_0Width = 'PACKAGE_0_WIDTH',
  Package_1Description = 'PACKAGE_1_DESCRIPTION',
  Package_1DimensionUnit = 'PACKAGE_1_DIMENSION_UNIT',
  Package_1Height = 'PACKAGE_1_HEIGHT',
  Package_1Length = 'PACKAGE_1_LENGTH',
  Package_1Quantity = 'PACKAGE_1_QUANTITY',
  Package_1Weight = 'PACKAGE_1_WEIGHT',
  Package_1WeightUnit = 'PACKAGE_1_WEIGHT_UNIT',
  Package_1Width = 'PACKAGE_1_WIDTH',
  Package_2Description = 'PACKAGE_2_DESCRIPTION',
  Package_2DimensionUnit = 'PACKAGE_2_DIMENSION_UNIT',
  Package_2Height = 'PACKAGE_2_HEIGHT',
  Package_2Length = 'PACKAGE_2_LENGTH',
  Package_2Quantity = 'PACKAGE_2_QUANTITY',
  Package_2Weight = 'PACKAGE_2_WEIGHT',
  Package_2WeightUnit = 'PACKAGE_2_WEIGHT_UNIT',
  Package_2Width = 'PACKAGE_2_WIDTH',
  Package_3Description = 'PACKAGE_3_DESCRIPTION',
  Package_3DimensionUnit = 'PACKAGE_3_DIMENSION_UNIT',
  Package_3Height = 'PACKAGE_3_HEIGHT',
  Package_3Length = 'PACKAGE_3_LENGTH',
  Package_3Quantity = 'PACKAGE_3_QUANTITY',
  Package_3Weight = 'PACKAGE_3_WEIGHT',
  Package_3WeightUnit = 'PACKAGE_3_WEIGHT_UNIT',
  Package_3Width = 'PACKAGE_3_WIDTH',
  Package_4Description = 'PACKAGE_4_DESCRIPTION',
  Package_4DimensionUnit = 'PACKAGE_4_DIMENSION_UNIT',
  Package_4Height = 'PACKAGE_4_HEIGHT',
  Package_4Length = 'PACKAGE_4_LENGTH',
  Package_4Quantity = 'PACKAGE_4_QUANTITY',
  Package_4Weight = 'PACKAGE_4_WEIGHT',
  Package_4WeightUnit = 'PACKAGE_4_WEIGHT_UNIT',
  Package_4Width = 'PACKAGE_4_WIDTH',
  Package_5Description = 'PACKAGE_5_DESCRIPTION',
  Package_5DimensionUnit = 'PACKAGE_5_DIMENSION_UNIT',
  Package_5Height = 'PACKAGE_5_HEIGHT',
  Package_5Length = 'PACKAGE_5_LENGTH',
  Package_5Quantity = 'PACKAGE_5_QUANTITY',
  Package_5Weight = 'PACKAGE_5_WEIGHT',
  Package_5WeightUnit = 'PACKAGE_5_WEIGHT_UNIT',
  Package_5Width = 'PACKAGE_5_WIDTH',
  Package_6Description = 'PACKAGE_6_DESCRIPTION',
  Package_6DimensionUnit = 'PACKAGE_6_DIMENSION_UNIT',
  Package_6Height = 'PACKAGE_6_HEIGHT',
  Package_6Length = 'PACKAGE_6_LENGTH',
  Package_6Quantity = 'PACKAGE_6_QUANTITY',
  Package_6Weight = 'PACKAGE_6_WEIGHT',
  Package_6WeightUnit = 'PACKAGE_6_WEIGHT_UNIT',
  Package_6Width = 'PACKAGE_6_WIDTH',
  Package_7Description = 'PACKAGE_7_DESCRIPTION',
  Package_7DimensionUnit = 'PACKAGE_7_DIMENSION_UNIT',
  Package_7Height = 'PACKAGE_7_HEIGHT',
  Package_7Length = 'PACKAGE_7_LENGTH',
  Package_7Quantity = 'PACKAGE_7_QUANTITY',
  Package_7Weight = 'PACKAGE_7_WEIGHT',
  Package_7WeightUnit = 'PACKAGE_7_WEIGHT_UNIT',
  Package_7Width = 'PACKAGE_7_WIDTH',
  Package_8Description = 'PACKAGE_8_DESCRIPTION',
  Package_8DimensionUnit = 'PACKAGE_8_DIMENSION_UNIT',
  Package_8Height = 'PACKAGE_8_HEIGHT',
  Package_8Length = 'PACKAGE_8_LENGTH',
  Package_8Quantity = 'PACKAGE_8_QUANTITY',
  Package_8Weight = 'PACKAGE_8_WEIGHT',
  Package_8WeightUnit = 'PACKAGE_8_WEIGHT_UNIT',
  Package_8Width = 'PACKAGE_8_WIDTH',
  Package_9Description = 'PACKAGE_9_DESCRIPTION',
  Package_9DimensionUnit = 'PACKAGE_9_DIMENSION_UNIT',
  Package_9Height = 'PACKAGE_9_HEIGHT',
  Package_9Length = 'PACKAGE_9_LENGTH',
  Package_9Quantity = 'PACKAGE_9_QUANTITY',
  Package_9Weight = 'PACKAGE_9_WEIGHT',
  Package_9WeightUnit = 'PACKAGE_9_WEIGHT_UNIT',
  Package_9Width = 'PACKAGE_9_WIDTH',
  Package_10Description = 'PACKAGE_10_DESCRIPTION',
  Package_10DimensionUnit = 'PACKAGE_10_DIMENSION_UNIT',
  Package_10Height = 'PACKAGE_10_HEIGHT',
  Package_10Length = 'PACKAGE_10_LENGTH',
  Package_10Quantity = 'PACKAGE_10_QUANTITY',
  Package_10Weight = 'PACKAGE_10_WEIGHT',
  Package_10WeightUnit = 'PACKAGE_10_WEIGHT_UNIT',
  Package_10Width = 'PACKAGE_10_WIDTH',
  Pickup = 'PICKUP',
  PickupLocationAddressAll = 'PICKUP_LOCATION_ADDRESS_ALL',
  PickupLocationName = 'PICKUP_LOCATION_NAME',
  PickupNumber = 'PICKUP_NUMBER',
  PickupWindowEnd = 'PICKUP_WINDOW_END',
  PickupWindowStart = 'PICKUP_WINDOW_START',
  ProNumber = 'PRO_NUMBER',
  PurchaseOrderNumber = 'PURCHASE_ORDER_NUMBER',
  SecondaryReferenceNumber = 'SECONDARY_REFERENCE_NUMBER',
  ServiceLevel = 'SERVICE_LEVEL',
  ShipperAddressAll = 'SHIPPER_ADDRESS_ALL',
  ShipperAddressCity = 'SHIPPER_ADDRESS_CITY',
  ShipperAddressCountry = 'SHIPPER_ADDRESS_COUNTRY',
  ShipperAddressLine_1 = 'SHIPPER_ADDRESS_LINE_1',
  ShipperAddressLine_2 = 'SHIPPER_ADDRESS_LINE_2',
  ShipperAddressState = 'SHIPPER_ADDRESS_STATE',
  ShipperAddressZip = 'SHIPPER_ADDRESS_ZIP',
  ShipperContactFirstName = 'SHIPPER_CONTACT_FIRST_NAME',
  ShipperContactLastName = 'SHIPPER_CONTACT_LAST_NAME',
  ShipperName = 'SHIPPER_NAME',
  ShipperPhone = 'SHIPPER_PHONE',
  SpecialInstructions = 'SPECIAL_INSTRUCTIONS',
  TertiaryReferenceNumber = 'TERTIARY_REFERENCE_NUMBER',
  TotalChargesAmount = 'TOTAL_CHARGES_AMOUNT',
  TotalChargesCurrency = 'TOTAL_CHARGES_CURRENCY',
  TotalPages = 'TOTAL_PAGES',
  TotalWeight = 'TOTAL_WEIGHT',
  TotalWeightUnit = 'TOTAL_WEIGHT_UNIT',
  WarehouseReceiptNumber = 'WAREHOUSE_RECEIPT_NUMBER'
}

export type FieldMatcherEntity = {
  __typename?: 'FieldMatcherEntity';
  type: MatcherType;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FieldMatcherInput = {
  type: MatcherType;
  value: Scalars['String']['input'];
};

/** Filter fields for the findLineHaulManifestsV2 query */
export type Fields = {
  departDate?: InputMaybe<DateFilterV2Simple>;
  driverUuidFilter?: InputMaybe<UuidFilterV2Simple>;
  endTerminalUuidFilter?: InputMaybe<UuidFilterV2Simple>;
  startTerminalUuidFilter?: InputMaybe<UuidFilterV2Simple>;
  statusFilter?: InputMaybe<LineHaulManifestStatusFilter>;
};

export enum FilterOperator {
  And = 'AND',
  Or = 'OR'
}

export enum FilterViewPage {
  Appointments = 'APPOINTMENTS',
  CustomerPortalOrders = 'CUSTOMER_PORTAL_ORDERS',
  Dispatch = 'DISPATCH',
  Invoices = 'INVOICES',
  LineHaulOrders = 'LINE_HAUL_ORDERS',
  Orders = 'ORDERS',
  OrdersAudit = 'ORDERS_AUDIT',
  Quotes = 'QUOTES',
  StorageOrders = 'STORAGE_ORDERS',
  StorageUnits = 'STORAGE_UNITS'
}

export type FinalizeInvoicesInput = {
  /** The invoice date to assign all included invoices */
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids: Array<Scalars['String']['input']>;
};

export type FinalizeInvoicesOutput = {
  __typename?: 'FinalizeInvoicesOutput';
  count: Scalars['Int']['output'];
};

export type FinalizeOrdersInput = {
  /** The UUIDs of the orders to be finalized */
  uuids: Array<Scalars['String']['input']>;
};

export type FinalizeOrdersOutput = FinalizeOrdersSuccessOutput | MutationErrorOutput;

export type FinalizeOrdersSuccessOutput = {
  __typename?: 'FinalizeOrdersSuccessOutput';
  /** The list of order UUIDs that were not finalized */
  failedOrderUuids: Array<Scalars['String']['output']>;
  /** The list of order UUIDs that were successfully finalized */
  finalizedOrderUuids: Array<Scalars['String']['output']>;
};

export type FinalizeSettlementBillResult = {
  __typename?: 'FinalizeSettlementBillResult';
  bill: DriverSettlementBillEntity;
  /** User-facing error message if bill failed to finalize. Otherwise null. */
  error?: Maybe<Scalars['String']['output']>;
};

export type FinalizeSettlementBillsInput = {
  /** The UUIDs of the driver settlement bills to finalize */
  billUuids: Array<Scalars['String']['input']>;
};

export type FinalizeSettlementBillsOutput = FinalizeSettlementBillsSuccessOutput | MutationErrorOutput;

export type FinalizeSettlementBillsSuccessOutput = {
  __typename?: 'FinalizeSettlementBillsSuccessOutput';
  results: Array<FinalizeSettlementBillResult>;
};

export type FindAccessorialDateRangeConfigsInput = {
  /** The UUID of the accessorial to retrieve the date range configs for */
  accessorialUuid: Scalars['String']['input'];
};

export type FindAccessorialDateRangeConfigsOutput = {
  __typename?: 'FindAccessorialDateRangeConfigsOutput';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
};

export type FindAvailablePiecesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Filter to pieces matching this customer on either of two branches: the directly linked order's billing-party contact, or the customer named at receipt for freight that arrived without an order. A piece owned only through a package is NOT matched, even though the grid displays that package's order billing party as its customer. */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by piece height */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Search across every terminal instead of defaulting to the order's current terminal. Ignored when terminalUuid is set. */
  includeAllTerminals?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to pieces that arrived as unalerted freight (no linked order at scan time) */
  isUnalertedFreight?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by piece length */
  length?: InputMaybe<Scalars['Float']['input']>;
  /** The UUID of the order to link pieces to */
  orderUuid: Scalars['String']['input'];
  /** Reference numbers for auto-suggest matching */
  referenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search text to match against referenceNumber and additionalReferenceNumbers */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Filter by piece status (any of). When omitted, defaults to ARRIVED if the company's configuration allows linking ARRIVED pieces; otherwise defaults to every status the configuration allows linking. */
  statuses?: InputMaybe<Array<PieceStatus>>;
  /** Filter to pieces at this terminal. When set, replaces the default scope derived from the order's current terminal and takes precedence over includeAllTerminals. */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter to pieces in this warehouse location */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter to pieces in this warehouse */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter by piece width */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type FindAvailableSchedulingSlotsInput = {
  /** Most slots to return, between 1 and 50. Outside that range is a validation error rather than a clamp. Defaults to 50. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Earliest service day to consider, as YYYY-MM-DD. Defaults to today in the company time zone, and is never read as earlier than that. It moves the window, and is not a cursor: it cannot resume part-way through a service day whose slots were cut off by the result cap. */
  fromDateIso8601?: InputMaybe<Scalars['String']['input']>;
  /** The order the slots are being offered for. */
  orderUuid: Scalars['String']['input'];
  /** Latest service day to consider, as YYYY-MM-DD. Defaults to the company booking horizon, and is never read as later than it. */
  toDateIso8601?: InputMaybe<Scalars['String']['input']>;
};

export type FindBookedStopsByResourceInput = {
  /** The day to read, as YYYY-MM-DD in the company time zone, matched against each shipment's delivery date. */
  serviceDateIso8601: Scalars['String']['input'];
  /** Only stops at this terminal, plus stops with no terminal, as the dispatch stops grid narrows by the page's terminal selector. A terminal of another company matches nothing beyond those terminal-less stops. Omitted means every terminal. */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindBusinessDivisionsOutput = {
  __typename?: 'FindBusinessDivisionsOutput';
  businessDivisions: Array<BusinessDivisionEntity>;
};

export type FindClientQuotesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FindQuoteFiltersInput>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export enum FindCompanyDocumentStatusFilter {
  All = 'All',
  Matched = 'Matched',
  Processing = 'Processing',
  Unmatched = 'Unmatched'
}

export type FindCompanyOrdersInDateRangeInput = {
  companyUuid: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  excludeOrdersOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  requireOrderToBeOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['DateTime']['input'];
  statuses: Array<OrderStatus>;
};

export type FindCompanyOrdersInDateRangeOutput = {
  __typename?: 'FindCompanyOrdersInDateRangeOutput';
  orders: Array<OrderEntity>;
};

export type FindCompanyPackageTypeConfigsOutput = {
  __typename?: 'FindCompanyPackageTypeConfigsOutput';
  companyPackageTypeConfigs: Array<CompanyPackageTypeConfigEntity>;
};

export type FindCompanySchedulingBlockedDaysInput = {
  /** Earliest day to read, as an ISO-8601 plain date (YYYY-MM-DD). Defaults to today in the company time zone, so a company closed every Christmas does not drag its whole history into a list view. */
  fromDateIso8601?: InputMaybe<Scalars['String']['input']>;
  /** Latest day to read, as an ISO-8601 plain date (YYYY-MM-DD). Defaults to one year from the lower bound, because the read is capped in rows and an open window would silently return only a prefix of the closures. */
  toDateIso8601?: InputMaybe<Scalars['String']['input']>;
};

export enum FindConsolidatableOrdersError {
  AlreadyConsolidated = 'ALREADY_CONSOLIDATED',
  MultipleAddresses = 'MULTIPLE_ADDRESSES'
}

export type FindContactItemsInput = {
  /** The UUID of the contact to retrieve all the items for */
  contactUuid: Scalars['String']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindContactItemsOutput = {
  __typename?: 'FindContactItemsOutput';
  items: Array<ItemEntity>;
};

export type FindCustomerPortalQuotesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Filters for the customerPortalQuotes query. The source filter is ignored and always set to CUSTOMER_PORTAL. */
  filters?: InputMaybe<FindQuoteFiltersInput>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type FindEffectiveOrganizationPackageTypeConfigsOutput = {
  __typename?: 'FindEffectiveOrganizationPackageTypeConfigsOutput';
  effectivePackageTypeConfigs: Array<EffectivePackageTypeConfigEntity>;
};

export type FindEmailTransactionsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindEmailTransactionsOutput = {
  __typename?: 'FindEmailTransactionsOutput';
  /** A connection that represents paginated email transactions */
  emailTransactionConnection: EmailTransactionConnection;
};

export type FindFuelProfileDateRangesInput = {
  fuelProfileUuid: Scalars['String']['input'];
};

export type FindFuelProfileDateRangesOutput = {
  __typename?: 'FindFuelProfileDateRangesOutput';
  fuelProfileDateRanges: Array<FuelProfileDateRangeEntity>;
};

export type FindFuelProfileInput = {
  uuid: Scalars['String']['input'];
};

export type FindFuelProfileOutput = {
  __typename?: 'FindFuelProfileOutput';
  fuelProfile: FuelProfileEntity;
};

export type FindIngestedOutlookEmailAttachmentsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  statusFilter?: InputMaybe<IngestedOutlookEmailAttachmentProcessingStatus>;
};

export type FindIngestedOutlookEmailsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Search term for matching against messageId, subject, sender, or body */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FindInventoryCountInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Restrict the line connection to a single state. */
  state?: InputMaybe<InventoryCountLineState>;
  uuid: Scalars['String']['input'];
};

export type FindInventoryCountOutput = {
  __typename?: 'FindInventoryCountOutput';
  inventoryCount: InventoryCountEntity;
  lineConnection: InventoryCountLineConnection;
};

export type FindInventoryCountsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to counts started on or before this date. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Restrict to closed (true) or open (false) counts. Omitted returns both. */
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to counts started on or after this date. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindInventoryCountsOutput = {
  __typename?: 'FindInventoryCountsOutput';
  inventoryCountConnection: InventoryCountConnection;
};

export type FindInvoiceEdiTransactionsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the invoice to retrieve the EDI transactions for */
  invoiceUuid: Scalars['String']['input'];
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FindInvoiceEdiTransactionsOutput = {
  __typename?: 'FindInvoiceEdiTransactionsOutput';
  /** The paginated EDI transactions associated with the invoice. Currently, only 210 transaction sets are associated with invoices. */
  ediTransactionConnection: EdiTransactionConnection;
};

export type FindInvoiceEmailsApiLogsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  isFailedEmailTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  isSuccessfulEmailTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Ignored. The page size is always capped at 1000.
   * @deprecated Ignored; the page size is always capped at 1000.
   */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindInvoiceEmailsApiLogsOutput = {
  __typename?: 'FindInvoiceEmailsApiLogsOutput';
  apiLogConnection: ApiLogConnection;
};

export type FindInvoicesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  /** Should not be used outside of internal tooling and audits. */
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Should not be used outside of internal tooling and audits. */
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the list to the invoices under one group of the grouped invoice list: one entry per grouping level, outermost first, each carrying the group key the `invoiceGroups` query returned. Every other filter still applies. */
  groupPath?: InputMaybe<Array<InvoiceTableGroupPathEntryInput>>;
  /** If true, only return invoices whose last QuickBooks sync failed. If false, only return invoices with no recorded sync failure. If null, do not apply the filter. */
  hasQuickbooksSyncFailure?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return closed invoices with a zero non-null balanceCents. If false, only return open invoices with a non-zero non-null balanceCents. If null, do not apply any balance filter. Note that only posted invoices have a non-null balanceCents. */
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters by invoice number, matching either the per-contact ordinal or the company journal number. Combined with searchText via AND when both are present. in/nin accept at most 1000 values. */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return invoices with a non-null lastSyncedToQuickbooksAt. */
  isSyncedToQuickbooks?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return invoices with a non-sync syncedToQuickbooksDesktopAt. */
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restricts the result to invoices whose last QuickBooks sync failed with one of these failure codes. Combined with hasQuickbooksSyncFailure via AND when both are present. */
  quickbooksSyncFailureCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  removeLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FindInvoicesSort = {
  sortBy: FindInvoicesSortFields;
  sortDirection: SortDirection;
};

export enum FindInvoicesSortFields {
  CreatedAt = 'CreatedAt',
  Date = 'Date',
  DueDate = 'DueDate',
  InvoiceNameOrJournalNumber = 'InvoiceNameOrJournalNumber'
}

export type FindItemGroupsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billedFilter?: InputMaybe<BooleanFilter>;
  companyUuidFilter?: InputMaybe<StringFilter>;
  contactUuidFilter?: InputMaybe<StringFilter>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  markedOnHandAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  markedOsdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  pickedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  quantityFilter?: InputMaybe<ItemGroupQuantityFilter>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationUuidFilter?: InputMaybe<StringFilter>;
  warehouseUuidFilter?: InputMaybe<StringFilter>;
};

export type FindLaneFromOriginAndDestinationTerminalInput = {
  destinationTerminalUuid: Scalars['String']['input'];
  originTerminalUuid: Scalars['String']['input'];
};

export type FindLaneFromOriginAndDestinationTerminalOutput = {
  __typename?: 'FindLaneFromOriginAndDestinationTerminalOutput';
  lane?: Maybe<LineHaulLaneEntity>;
};

export type FindLineHaulManifestsOutput = {
  __typename?: 'FindLineHaulManifestsOutput';
  lineHaulManifests: Array<LineHaulManifestEntity>;
  unmanifestedSegments: Array<LineHaulSegmentEntity>;
};

/** Filters for the findLineHaulManifestsV2 query. Use either "and" or "or" filters, but not both simultaneously. Using both in the same query may lead to unexpected results. */
export type FindLineHaulManifestsV2FiltersInput = {
  and?: InputMaybe<Array<LineHaulManifestFilters>>;
  or?: InputMaybe<Array<LineHaulManifestFilters>>;
};

export type FindMasterAccountsOutput = {
  __typename?: 'FindMasterAccountsOutput';
  masterAccounts: Array<MasterAccountEntity>;
};

export type FindOpenInvoicesArgs = {
  hideCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FindOrderByShipperBillOfLadingNumberInput = {
  companyUuid: Scalars['String']['input'];
  shipperBillOfLadingNumber: Scalars['String']['input'];
};

export type FindOrderByShipperBillOfLadingNumberOutput = {
  __typename?: 'FindOrderByShipperBillOfLadingNumberOutput';
  /** The most recent order that has the specified shipper bill of lading number */
  order?: Maybe<OrderEntity>;
};

/** The filters, tab and search of an orders table view, for fetching the uuids of the orders in it. Sorting, paging and counting do not apply. */
export type FindOrderUuidsInViewInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /** Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact. */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filters?: InputMaybe<FindOrdersFiltersInput>;
  /** Filters for orders holding SMC3 freight that needs a rate. Currently only implemented for the flat orders view. */
  freightNeedsRateFilter?: InputMaybe<BooleanFilterV2>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the invoice name on the order table field (used when useJournalNumberForInvoice is false) */
  invoiceNameFilter?: InputMaybe<StringFilterV2>;
  /** An integer filter for the invoice journal number (used when useJournalNumberForInvoice is true) */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** At most this many uuids are returned; `hasMore` says whether the view holds more. */
  limit: Scalars['Int']['input'];
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID filter for the line haul leg destination terminal. Matches orders that have a segment whose end terminal matches. */
  lineHaulLegDestinationTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg (segment). Matches orders assigned to the specified segment via OrderLineHaulSegment. */
  lineHaulLegFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg origin terminal. Matches orders that have a segment whose start terminal matches. */
  lineHaulLegOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A filter for the order's line-haul origin terminal (the order-level origin set for "out of inventory" orders, else the on-hand terminal derivation). Used by the line-haul Outbound tab so out-of-inventory orders are discoverable under their origin terminal. */
  lineHaulOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  /** A UUID filter for terminals derived from piece warehouse locations on the order. Semantics across operators: `eq` / `in` match an order when at least one piece is in a warehouse location whose warehouse belongs to one of the requested terminals. `neq` / `nin` exclude an order when ANY piece is in a warehouse location whose warehouse belongs to one of the requested terminals, so a split order with pieces at multiple terminals is excluded if any of its terminals is in the list. `isBlank` matches orders with no piece-terminal assignment at all; `isNotBlank` matches orders with at least one piece-terminal assignment. */
  pieceTerminalFilter?: InputMaybe<UuidFilterV2>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter for the email of the user who created the order. */
  sourceUserEmailFilter?: InputMaybe<StringFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** Serve the uuids from the SQE (flat_orders.switchover), as the orders table does when its new-search toggle is on, so the selection matches the rows on screen. Requires FF_SQE_ORDERLIST_ENABLED for the company. */
  useSqeBackend?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). When provided, the backend uses this timezone to compute day boundaries for date filters so that results reflect the calendar date in the user's local time rather than UTC. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Version ID for the request */
  versionId?: InputMaybe<Scalars['Float']['input']>;
  /** A UUID filter for the warehouse derived from piece locations on the order. This filters by Warehouse UUID (not WarehouseLocation/bin). The warehouse is determined by the unanimous piece-level warehouseId across the order. */
  warehouseLocationFilter?: InputMaybe<UuidFilterV2>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

/** The uuids of the orders in an orders table view, for selecting the whole view. */
export type FindOrderUuidsInViewOutput = {
  __typename?: 'FindOrderUuidsInViewOutput';
  /** True when the view holds more than `limit` orders. */
  hasMore: Scalars['Boolean']['output'];
  /** Up to `limit` order uuids in the view, in no particular order. Incomplete when `hasMore` is true. */
  uuids: Array<Scalars['String']['output']>;
};

export type FindOrdersBaseInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /** Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact. */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filters?: InputMaybe<FindOrdersFiltersInput>;
  /** Filters for orders holding SMC3 freight that needs a rate. Currently only implemented for the flat orders view. */
  freightNeedsRateFilter?: InputMaybe<BooleanFilterV2>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the invoice name on the order table field (used when useJournalNumberForInvoice is false) */
  invoiceNameFilter?: InputMaybe<StringFilterV2>;
  /** An integer filter for the invoice journal number (used when useJournalNumberForInvoice is true) */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID filter for the line haul leg destination terminal. Matches orders that have a segment whose end terminal matches. */
  lineHaulLegDestinationTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg (segment). Matches orders assigned to the specified segment via OrderLineHaulSegment. */
  lineHaulLegFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg origin terminal. Matches orders that have a segment whose start terminal matches. */
  lineHaulLegOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A filter for the order's line-haul origin terminal (the order-level origin set for "out of inventory" orders, else the on-hand terminal derivation). Used by the line-haul Outbound tab so out-of-inventory orders are discoverable under their origin terminal. */
  lineHaulOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  /** A UUID filter for terminals derived from piece warehouse locations on the order. Semantics across operators: `eq` / `in` match an order when at least one piece is in a warehouse location whose warehouse belongs to one of the requested terminals. `neq` / `nin` exclude an order when ANY piece is in a warehouse location whose warehouse belongs to one of the requested terminals, so a split order with pieces at multiple terminals is excluded if any of its terminals is in the list. `isBlank` matches orders with no piece-terminal assignment at all; `isNotBlank` matches orders with at least one piece-terminal assignment. */
  pieceTerminalFilter?: InputMaybe<UuidFilterV2>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** True if ascending, False if descending, undefined if no sort */
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  /** A string filter for the email of the user who created the order. */
  sourceUserEmailFilter?: InputMaybe<StringFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). When provided, the backend uses this timezone to compute day boundaries for date filters so that results reflect the calendar date in the user's local time rather than UTC. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Version ID for the request */
  versionId?: InputMaybe<Scalars['Float']['input']>;
  /** A UUID filter for the warehouse derived from piece locations on the order. This filters by Warehouse UUID (not WarehouseLocation/bin). The warehouse is determined by the unanimous piece-level warehouseId across the order. */
  warehouseLocationFilter?: InputMaybe<UuidFilterV2>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

/** Input type for the orders query and the order table report that contains all filters. Excludes any pagination or sorting arguments. */
export type FindOrdersFiltersInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer activeTerminalFilter */
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  /** @deprecated Prefer orderCityFilter */
  addressCityFilter?: InputMaybe<StringFilter>;
  /** @deprecated Prefer orderZipFilter */
  addressZipFilter?: InputMaybe<StringFilter>;
  /** Filters to be combined using a logical AND */
  and?: InputMaybe<Array<FindOrdersFiltersInput>>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  /** @deprecated Prefer customerNameFilter */
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  /** @deprecated Use billingPartyContactUuidFilters instead */
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /**
   * Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact.
   * @deprecated Prefer customerUuidFilter
   */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer businessDivisionUuidFilterV2 */
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  /** @deprecated Prefer controllingTerminalUuidFilterV2 */
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  /** @deprecated Use billingPartyContactDisplayNameFilter instead */
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** @deprecated Prefer destinationTerminalUuidFilterV2 */
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer driverUuidFilterV2 */
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /**
   * Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All").
   * @deprecated Prefer driverUuidFilterV2
   */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  /** @deprecated Prefer outboundCityFilter */
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  /** Filters for orders holding SMC3 freight that needs a rate. Currently only implemented for the flat orders view. */
  freightNeedsRateFilter?: InputMaybe<BooleanFilterV2>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer hasFailuresFilter */
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer hasRouteFilter */
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer hideFromBillingFilter */
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer inboundDriverUuidFilter instead */
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  /** @deprecated Use inboundStopMethodFilterV2 instead */
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** @deprecated Prefer inboundNotArrivedFilter */
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the invoice name on the order table field (used when useJournalNumberForInvoice is false) */
  invoiceNameFilter?: InputMaybe<StringFilterV2>;
  /** An integer filter for the invoice journal number (used when useJournalNumberForInvoice is true) */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Prefer isCancelledFilter */
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isCollectOnDeliveryFilter */
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isFinalizedFilter */
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isHazmatFilter */
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isInBondFilter */
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isLineHaulFilter */
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isOsdFilter */
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isPickedFilter */
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isPickupOrDeliveryFilter */
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isRefusedFilter */
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer isSpecialFilter */
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID filter for the line haul leg destination terminal. Matches orders that have a segment whose end terminal matches. */
  lineHaulLegDestinationTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg (segment). Matches orders assigned to the specified segment via OrderLineHaulSegment. */
  lineHaulLegFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg origin terminal. Matches orders that have a segment whose start terminal matches. */
  lineHaulLegOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A filter for the order's line-haul origin terminal (the order-level origin set for "out of inventory" orders, else the on-hand terminal derivation). Used by the line-haul Outbound tab so out-of-inventory orders are discoverable under their origin terminal. */
  lineHaulOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Use terminalUuidsFilter instead by passing it an empty array */
  noTerminal?: InputMaybe<BooleanFilter>;
  /** @deprecated Prefer onHandFilter */
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer onInvoiceFilter */
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** Filters to be combined using a logical OR */
  or?: InputMaybe<Array<FindOrdersFiltersInput>>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer orderNameFilterV2 instead */
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** @deprecated Prefer orderSourceFilter instead */
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer originTerminalUuidFilterV2 */
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer outboundDriverUuidFilter instead */
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  /** @deprecated Use outboundStopMethodFilterV2 instead */
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer paperworkCompleteFilter */
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  /** A UUID filter for terminals derived from piece warehouse locations on the order. Semantics across operators: `eq` / `in` match an order when at least one piece is in a warehouse location whose warehouse belongs to one of the requested terminals. `neq` / `nin` exclude an order when ANY piece is in a warehouse location whose warehouse belongs to one of the requested terminals, so a split order with pieces at multiple terminals is excluded if any of its terminals is in the list. `isBlank` matches orders with no piece-terminal assignment at all; `isNotBlank` matches orders with at least one piece-terminal assignment. */
  pieceTerminalFilter?: InputMaybe<UuidFilterV2>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** @deprecated Prefer requiresRecoveryFilter */
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  /** @deprecated Prefer requiresRoutingFilter */
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  /** @deprecated Prefer serviceDateFilter instead */
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  /** @deprecated Prefer showConsolidatedOrdersFilter */
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter for the email of the user who created the order. */
  sourceUserEmailFilter?: InputMaybe<StringFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  /** @deprecated Prefer inboundCityFilter */
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  /** @deprecated Use tagUuidsFilter instead */
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  /** @deprecated Prefer terminalUuidFilterV2 */
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /**
   * Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All").
   * @deprecated Prefer terminalUuidFilterV2
   */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  /** @deprecated Prefer transferPendingFilter */
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  /** A UUID filter for the warehouse derived from piece locations on the order. This filters by Warehouse UUID (not WarehouseLocation/bin). The warehouse is determined by the unanimous piece-level warehouseId across the order. */
  warehouseLocationFilter?: InputMaybe<UuidFilterV2>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

export type FindOrdersOnInvoiceSort = {
  sortBy: FindOrdersOnInvoiceSortFields;
  sortDirection: SortDirection;
};

export enum FindOrdersOnInvoiceSortFields {
  Consignee = 'Consignee',
  MasterAirwayBillOfLadingNumber = 'MasterAirwayBillOfLadingNumber',
  ServiceDate = 'ServiceDate',
  ShipperBillOfLadingNumber = 'ShipperBillOfLadingNumber'
}

export type FindOrganizationInput = {
  uuid: Scalars['String']['input'];
};

export type FindOrganizationNotesInput = {
  organizationUuid: Scalars['String']['input'];
};

export type FindOrganizationPackageTypeConfigsOutput = {
  __typename?: 'FindOrganizationPackageTypeConfigsOutput';
  organizationPackageTypeConfigs: Array<OrganizationPackageTypeConfigEntity>;
};

export type FindOrphanPiecesByBarcodeOutput = {
  __typename?: 'FindOrphanPiecesByBarcodeOutput';
  hasMore: Scalars['Boolean']['output'];
  pieces: Array<PieceEntity>;
};

export type FindPackageSpecsOutput = {
  __typename?: 'FindPackageSpecsOutput';
  packageSpecs: Array<PackageSpecEntity>;
};

export type FindPackingPendenciesInput = {
  afterUuid?: InputMaybe<Scalars['String']['input']>;
  /** Page size. Defaults to and is capped at 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<PackingPendencyStatus>>;
  warehouseUuid: Scalars['String']['input'];
};

export type FindPackingPendenciesOutput = {
  __typename?: 'FindPackingPendenciesOutput';
  packingPendencies: Array<PackingPendencyEntity>;
};

export type FindPaginatedOrganizationPeersInput = {
  /** Forward pagination cursor; provide on subsequent queries. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Backward pagination cursor. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Forward pagination count; provide on initial query. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Backward pagination count. */
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OrganizationPeerStatus>;
};

export type FindPaginatedOrganizationsInput = {
  /** forwards pagination cursor, provide this on subsequent queries */
  after?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination cursor, provide this on subsequent queries */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** filter by active organizations. If not provided or undefined it returns all */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** forwards pagination cursor, provide this on subsequent queries */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** search on organization name and reference number */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type FindPaymentsV2Args = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  creditTypeUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** With contactUuid: also return payments received from every customer sharing this customer's master account, in the same company. Defaults to false (payments received from this customer only). */
  includeMasterAccountFamily?: InputMaybe<Scalars['Boolean']['input']>;
  /** With contactUuid: also return payments received from other customers that were applied to this customer's invoices. Defaults to false (payments received from this customer only). */
  includePaymentsAppliedToContactInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, only return payments where amountInCents = appliedAmountCents. If false, only return payments where amountInCents != appliedAmountCents. If null, return all payments. */
  isFullyApplied?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  paymentDateFilters?: InputMaybe<DateFilterStartEnd>;
  paymentRails?: InputMaybe<Array<PaymentRail>>;
  /** @deprecated Use paymentTypes instead */
  paymentType?: InputMaybe<PaymentType>;
  paymentTypes?: InputMaybe<Array<PaymentType>>;
  /** Filter on the payment reference number only (unlike searchText, which also matches comment, applied-order refs, and amount). String operator values must be at least 3 characters. */
  referenceNumber?: InputMaybe<StringFilterV2>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<PaymentSort>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter to payments with these uuids (company-scoped). An empty array matches nothing. */
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FindPersonsOutput = {
  __typename?: 'FindPersonsOutput';
  persons: Array<PersonEntity>;
  totalCount: Scalars['Float']['output'];
};

export type FindPieceReceiptInput = {
  /** UUID of the piece receipt to retrieve */
  uuid: Scalars['String']['input'];
};

export type FindPieceReceiptOutput = {
  __typename?: 'FindPieceReceiptOutput';
  pieceReceipt: PieceReceiptEntity;
};

export type FindPieceReceiptsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  arrivedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuidFilter?: InputMaybe<StringFilter>;
  expectedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Restricts results to receipts created from this client. */
  sourceFilter?: InputMaybe<PieceReceiptSource>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuidFilter?: InputMaybe<StringFilter>;
};

export type FindPieceReceiptsOutput = {
  __typename?: 'FindPieceReceiptsOutput';
  /** A connection that represents paginated piece receipts */
  pieceReceiptConnection: PieceReceiptConnection;
};

export type FindPiecesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Lifecycle bucket the client is rendering. Gates the inclusion of bucket-specific relations in the response. */
  bucket?: InputMaybe<PieceBucketKey>;
  /**
   * Filter by customer UUID (the linked order's billing-party contact).
   * @deprecated Use contactUuids instead
   */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter by customer UUIDs (the linked order's billing-party contact, any of). Applied in addition to `contactUuid` if both are provided. */
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restrict to pieces whose createdAt falls in this range. */
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** Restrict to on-dock pieces in the given dwell bands (overdue filter). */
  dwellAlertFilter?: InputMaybe<DwellAlertFilterInput>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** When true, restrict to parent pieces (those that have at least one child piece), regardless of package type. */
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Disable maximum page size limit */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by order UUID */
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive search across piece reference number, order name, customer (billing party) display name, and the linked order HAWB (house bill or shipper BOL) / MAWB. */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Sort order; first element has highest priority */
  sorts?: InputMaybe<Array<FindPiecesSort>>;
  /** Filter by piece status */
  status?: InputMaybe<PieceStatus>;
  /** Filter by piece status (any of). Applied in addition to `status` if both are provided. */
  statuses?: InputMaybe<Array<PieceStatus>>;
  /** Filter by terminal UUID */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter by piece (container) type */
  type?: InputMaybe<PackageType>;
  /** Restrict to pieces not associated to any order (orderId IS NULL). */
  unassociatedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by warehouse location UUID */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter by warehouse UUID */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindPiecesSort = {
  sortBy: FindPiecesSortFields;
  sortDirection: SortDirection;
};

export enum FindPiecesSortFields {
  CreatedAt = 'CreatedAt',
  Hawb = 'Hawb',
  MarkedOnHandAt = 'MarkedOnHandAt',
  Mawb = 'Mawb',
  OrderName = 'OrderName',
  ReferenceNumber = 'ReferenceNumber',
  Status = 'Status',
  TerminalName = 'TerminalName',
  WarehouseLocationName = 'WarehouseLocationName'
}

/** Input type for the quotesV2 query that contains all filters. Excludes any pagination or sorting arguments. */
export type FindQuoteFiltersInput = {
  contactUuidFilter?: InputMaybe<UuidFilterV2>;
  sourceFilter?: InputMaybe<QuoteSourceFilter>;
  statusFilter?: InputMaybe<QuoteStatusFilter>;
};

export enum FindReportSendJobBatchesFields {
  CreatedAtDate = 'CreatedAtDate'
}

export type FindReportSendJobBatchesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<Array<FindReportSendJobBatchesSort>>;
};

export type FindReportSendJobBatchesOutput = {
  __typename?: 'FindReportSendJobBatchesOutput';
  reportSendJobBatchConnection: ReportSendJobBatchConnection;
};

export type FindReportSendJobBatchesSort = {
  sortBy: FindReportSendJobBatchesFields;
  sortDirection: SortDirection;
};

export type FindReportSendJobsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  reportSendJobBatchId: Scalars['String']['input'];
  reportSendJobStatus?: InputMaybe<ReportSendJobStatus>;
};

export type FindReportSendJobsOutput = {
  __typename?: 'FindReportSendJobsOutput';
  reportSendJobConnection: ReportSendJobConnection;
};

export type FindRoleInput = {
  uuid: Scalars['String']['input'];
};

export type FindRoleOutput = {
  __typename?: 'FindRoleOutput';
  role: RoleEntity;
};

export type FindRolesInput = {
  includeInternalRoles: Scalars['Boolean']['input'];
};

export type FindRolesOutput = {
  __typename?: 'FindRolesOutput';
  roles: Array<RoleEntity>;
};

export type FindScannedOrdersInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FindSchedulingRegionsOutput = {
  __typename?: 'FindSchedulingRegionsOutput';
  schedulingRegions: Array<SchedulingRegionEntity>;
};

export type FindSchedulingResourcesByRouteNameInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query. Between 1 and 100; omitting both this and last reads the first 100 */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Include archived resources. Defaults to false. */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count. Between 1 and 100 */
  last?: InputMaybe<Scalars['Int']['input']>;
  routeNameUuid: Scalars['String']['input'];
};

export type FindSchedulingResourcesInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query. Between 1 and 100; omitting both this and last reads the first 100 */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Include archived resources. Defaults to false. */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count. Between 1 and 100 */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FindSchedulingResourcesOutput = {
  __typename?: 'FindSchedulingResourcesOutput';
  /** A connection that represents paginated scheduling resources */
  schedulingResourceConnection: SchedulingResourceConnection;
};

export type FindSegmentedLineHaulOrdersInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  sorts?: InputMaybe<Array<LineHaulOrderSort>>;
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindSegmentedLineHaulOrdersInputV2 = {
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Calculate and return the total count. Can be expensive, so use prudently */
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  sorts?: InputMaybe<Array<LineHaulOrderSort>>;
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindServicesForCustomerConfigurationInput = {
  organizationUuid: Scalars['String']['input'];
};

export type FindServicesForCustomerConfigurationOutput = FindServicesForCustomerConfigurationSuccessOutput | QueryErrorOutput;

export type FindServicesForCustomerConfigurationSuccessOutput = {
  __typename?: 'FindServicesForCustomerConfigurationSuccessOutput';
  /** The services available for customer configuration */
  services: Array<ServiceEntity>;
};

export type FindServicesForOrderInput = {
  organizationUuid: Scalars['String']['input'];
  /** The UUID of the currently selected service for the order, if one exists */
  selectedServiceUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindServicesForOrderOutput = FindServicesForOrderSuccessOutput | QueryErrorOutput;

export type FindServicesForOrderSuccessOutput = {
  __typename?: 'FindServicesForOrderSuccessOutput';
  /** The services available for order */
  services: Array<ServiceEntity>;
};

export type FindServicesForThirdPartyUserInput = {
  companyUuid: Scalars['String']['input'];
};

export type FindSettlementBillLineItemsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** The completed at date for the relevant stop that is tied to the settlement bill line item */
  completedDateFilter?: InputMaybe<DateFilterV2>;
  driverSettlementBillUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** We currently do not have a use case for showing line items on finalized driver settlement bills specifically. */
  driverSettlementFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  onDriverSettlementBill?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  settlementDateFilter?: InputMaybe<DateFilterV2>;
};

export type FindSftpUploadsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SftpUploadStatus>;
  type?: InputMaybe<SftpUploadType>;
};

export type FindStopsFiltersInput = {
  addressType?: InputMaybe<StandardStopType>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  canDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** Control whether all filters need to be satisfied or at least one. Default is AND. */
  filterOperator?: InputMaybe<FilterOperator>;
  /** Filter by whether a stop has either a start or end appointment time set */
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether a stop has an appointment date set */
  hasAppointmentDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** This is equivalent to checking if either appointmentSchedulingOptionsCalledAt or appointmentSchedulingOptionsTextedAt is non-null */
  hasAppointmentOptionsProposed?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, stops with a null serviceDate (unscheduled) are retained alongside the serviceDateFilters range instead of being excluded by it. Used by the dispatch board so windowing the default view never hides unscheduled work. */
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  onHandTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery>>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<StopStatus>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FindStorageOrderInput = {
  /** The UUID of the storage order to retrieve */
  uuid: Scalars['String']['input'];
};

export type FindStorageOrderOutput = {
  __typename?: 'FindStorageOrderOutput';
  storageOrder: StorageOrderEntity;
};

export type FindStorageOrderStorageUnitsInput = {
  storageOrderUuid: Scalars['String']['input'];
};

export type FindStorageOrderStorageUnitsOutput = {
  __typename?: 'FindStorageOrderStorageUnitsOutput';
  storageUnits: Array<StorageUnitEntity>;
};

export type FindStorageOrdersInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  arrivedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuidFilter?: InputMaybe<StringFilter>;
  expectedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuidFilter?: InputMaybe<StringFilter>;
};

export type FindStorageOrdersOutput = {
  __typename?: 'FindStorageOrdersOutput';
  /** A connection that represents paginated storage orders */
  storageOrderConnection: StorageOrderConnection;
};

export type FindStorageUnitInput = {
  uuid: Scalars['String']['input'];
};

export type FindStorageUnitOutput = {
  __typename?: 'FindStorageUnitOutput';
  storageUnit: StorageUnitEntity;
};

export type FindStorageUnitsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billedFilter?: InputMaybe<BooleanFilter>;
  contactUuidFilter?: InputMaybe<StringFilter>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  markedOnHandAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  markedOsdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  pickedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationUuidFilter?: InputMaybe<StringFilter>;
};

export type FindStorageUnitsOutput = {
  __typename?: 'FindStorageUnitsOutput';
  /** A connection that represents paginated storage units */
  storageUnitConnection: StorageUnitConnection;
};

export type FindTariffChainsInput = {
  isArchived: Scalars['Boolean']['input'];
};

export type FindTariffGroupsWithContactAndServicesCombinationOutput = {
  __typename?: 'FindTariffGroupsWithContactAndServicesCombinationOutput';
  /** the contact in that group that has a match */
  contactUuid: Scalars['String']['output'];
  /** the services in that group that has a match */
  matchingTariffGroups: Array<MatchingGroupsAlongWithMatchingServices>;
};

export type FindTariffZoneGroupsInput = {
  isArchived: Scalars['Boolean']['input'];
};

export type FindTerminalForAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type FindTerminalForAddressOutput = {
  __typename?: 'FindTerminalForAddressOutput';
  terminal?: Maybe<TerminalEntity>;
};

export type FindTerminalsForAddressOutput = {
  __typename?: 'FindTerminalsForAddressOutput';
  terminals?: Maybe<Array<TerminalEntity>>;
};

export type FindTerminalsForThirdPartyUserInput = {
  companyUuid: Scalars['String']['input'];
  /** Optionally filter by isActive, defaults to including all terminals */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FindTestOrderInput = {
  uuid: Scalars['String']['input'];
};

export type FindTestOrderOutput = {
  __typename?: 'FindTestOrderOutput';
  testOrder: TestOrderEntity;
};

export type FindTestOrdersOutput = {
  __typename?: 'FindTestOrdersOutput';
  testOrders: Array<TestOrderEntity>;
};

export type FindWarehouseEmployeesOutput = {
  __typename?: 'FindWarehouseEmployeesOutput';
  warehouseEmployees: Array<WarehouseEmployeeEntity>;
};

export type FindWarehouseLocationsOutput = {
  __typename?: 'FindWarehouseLocationsOutput';
  warehouseLocations: Array<WarehouseLocationEntity>;
};

export type FingerprintAnchorEntity = {
  __typename?: 'FingerprintAnchorEntity';
  blockId?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  required: Scalars['Boolean']['output'];
  substring?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  top: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type FingerprintAnchorInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  required: Scalars['Boolean']['input'];
  substring?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type FingerprintAnchorMatchEntity = {
  __typename?: 'FingerprintAnchorMatchEntity';
  substring?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FingerprintAnchorMatchInput = {
  substring?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type FireOutboundBenchTransactionInput = {
  /** The 990 action. Defaults to ACCEPTED. */
  action990?: InputMaybe<Edi990ActionCode>;
  /** Sends the 214 even when the order already has a successful 214 with that status. */
  allowDuplicate214?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required, and must be true, when the backend runs in production. Ignored elsewhere. */
  confirmProductionSend?: InputMaybe<Scalars['Boolean']['input']>;
  integrationType: BenchIntegrationType;
  orderUuid: Scalars['String']['input'];
  /** Required for a 214. Must be one of the partnership's edi214ShipmentStatuses. */
  status214?: InputMaybe<Edi214ShipmentStatus>;
  /** For CONTACT_ATTEMPTED only: which stop the contact attempt was for. Defaults to the delivery stop, or the pickup when the order has no delivery. */
  stopRole214?: InputMaybe<BenchStopRole>;
  transactionSet: BenchFireTransactionSet;
};

/** A filter object that is used to filter a float field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type FloatFilterV2 = {
  /** Filters for records where the relevant float field is equal to the provided float value */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is greater than the provided float value */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is greater than or equal to the provided float value */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is in the provided float values */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Filters for records where the relevant float field is less than the provided float value */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is less than or equal to the provided float value */
  lte?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is not equal to the provided float value */
  neq?: InputMaybe<Scalars['Float']['input']>;
  /** Filters for records where the relevant float field is not in the provided float values */
  nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FormatCsvResEntity = {
  __typename?: 'FormatCsvResEntity';
  csvItems: Array<Array<Scalars['String']['output']>>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  missingAccessorialMappings: Array<Scalars['String']['output']>;
  missingCustomerMappings: Array<Scalars['String']['output']>;
  missingFreightChargeMappings: Array<Scalars['String']['output']>;
  missingFuelChargeMappings: Array<Scalars['String']['output']>;
};

/** Encapsulates the paginated list of formatted orders, statistics, and metadata used in the output of order table field values retrieval queries. */
export type FormattedOrderConnection = {
  __typename?: 'FormattedOrderConnection';
  edges: Array<FormattedOrderEdge>;
  /** Not cheap to calculate, request with prudence.  Group UUID = invoice UUID */
  groupedCountsByInvoice?: Maybe<Array<GroupedCounts>>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Version ID for the response */
  versionId?: Maybe<Scalars['Float']['output']>;
};

export type FormattedOrderEdge = {
  __typename?: 'FormattedOrderEdge';
  cursor: Scalars['String']['output'];
  node: FormattedOrderEntity;
};

/** Represents a formatted order that is returned as part of an orders query */
export type FormattedOrderEntity = {
  __typename?: 'FormattedOrderEntity';
  /** The UUID of the organization associated with the order */
  contactUuid: Scalars['String']['output'];
  /** The list of formatted fields for the order. The fields whose values are returned are based on which order table fields are passed into the query input */
  formattedOrderFields: Array<FormattedOrderFieldEntity>;
  freightNeedsRate: Scalars['Boolean']['output'];
  /** Custom output for the "Total Charges with Itemized" column in the orders table. Null if the value is not requested in the query input */
  itemizedChargesField?: Maybe<OrderTableItemizedChargesFieldEntity>;
  /** Custom output for the "Line Haul Manifests" column in the orders table. Null if the value is not requested in the query input */
  lineHaulManifestsField?: Maybe<OrderTableLineHaulManifestsFieldEntity>;
  /** Custom output for the "Dims" column */
  packagesField?: Maybe<OrderTablePackagesFieldEntity>;
  /** Custom output for the "Paperwork Complete" column in the orders table. Null if the value is not requested in the query input */
  paperworkField?: Maybe<OrderTablePaperworkFieldEntity>;
  /** Custom output for the "Photos" column in the orders table. Null if the value is not requested in the query input */
  photosField?: Maybe<OrderTablePhotosFieldEntity>;
  pieceTerminalLocationsDisplay?: Maybe<Scalars['String']['output']>;
  /** Custom output for the "Primary Service" column in the orders table. Null if the value is not requested in the query input */
  serviceField?: Maybe<OrderTableServiceFieldEntity>;
  /** Custom output for the "Tags" column in the orders table. Null if the value is not requested in the query input */
  tagsField?: Maybe<OrderTableTagsFieldEntity>;
  /** The UUID of the corresponding order */
  uuid: Scalars['String']['output'];
};


/** Represents a formatted order that is returned as part of an orders query */
export type FormattedOrderEntityPieceTerminalLocationsDisplayArgs = {
  activeTerminalUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type FormattedOrderFieldEntity = {
  __typename?: 'FormattedOrderFieldEntity';
  orderTableField: OrderTableField;
  value: Scalars['String']['output'];
};

export type ForwarderBoardAcceptanceMissRow = {
  __typename?: 'ForwarderBoardAcceptanceMissRow';
  acceptanceLagMinutes?: Maybe<Scalars['Int']['output']>;
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  orderUuid: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderBoardAcceptanceQueueRow = {
  __typename?: 'ForwarderBoardAcceptanceQueueRow';
  orderUuid: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  waitingMinutes: Scalars['Int']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderBoardAgingQueueRow = {
  __typename?: 'ForwarderBoardAgingQueueRow';
  ageDays: Scalars['Int']['output'];
  orderUuid: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderBoardArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  forwarder: ForwarderBoardForwarder;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  window: ForwarderBoardWindow;
};

export type ForwarderBoardConnectionStats = {
  __typename?: 'ForwarderBoardConnectionStats';
  avgAttempts?: Maybe<Scalars['Float']['output']>;
  heldCount: Scalars['Int']['output'];
  longestWaitMinutes?: Maybe<Scalars['Int']['output']>;
};

export type ForwarderBoardEntity = {
  __typename?: 'ForwarderBoardEntity';
  acceptanceMisses: Array<ForwarderBoardAcceptanceMissRow>;
  acceptanceMissesTotal: Scalars['Int']['output'];
  acceptedWithin12h: ForwarderBoardRateTile;
  awaitingAcceptance: Array<ForwarderBoardAcceptanceQueueRow>;
  awaitingAcceptanceTotal: Scalars['Int']['output'];
  awaitingPod: Array<ForwarderBoardPodQueueRow>;
  awaitingPodTotal: Scalars['Int']['output'];
  completedWithin30OfArrival: ForwarderBoardRateTile;
  connection: ForwarderBoardConnectionStats;
  deliveryEventWithin30: ForwarderBoardRateTile;
  driverEntered: ForwarderBoardRateTile;
  electronicDispatchShare: ForwarderBoardRateTile;
  lateDeliveries: Array<ForwarderBoardLateDeliveryRow>;
  lateDeliveriesTotal: Scalars['Int']['output'];
  manualOrders: Array<ForwarderBoardManualOrderRow>;
  manualOrdersTotal: Scalars['Int']['output'];
  missingPods: Scalars['Int']['output'];
  podWithin30: ForwarderBoardRateTile;
  timezone: Scalars['String']['output'];
  undelivered: Array<ForwarderBoardAgingQueueRow>;
  undeliveredTotal: Scalars['Int']['output'];
  windowEnd: Scalars['DateTime']['output'];
  windowStart: Scalars['DateTime']['output'];
};

/** The forwarder a Forwarder Board describes. */
export enum ForwarderBoardForwarder {
  Expeditors = 'EXPEDITORS'
}

export type ForwarderBoardLateDeliveryRow = {
  __typename?: 'ForwarderBoardLateDeliveryRow';
  arrivalToCompletionMinutes?: Maybe<Scalars['Int']['output']>;
  deliveredAt: Scalars['DateTime']['output'];
  deliveryEventLagMinutes?: Maybe<Scalars['Int']['output']>;
  driverEntered: Scalars['Boolean']['output'];
  firstUploadAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  orderUuid: Scalars['String']['output'];
  podLagMinutes?: Maybe<Scalars['Int']['output']>;
  reachedForwarder: Scalars['Boolean']['output'];
  uploadAttempts: Scalars['Int']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderBoardManualOrderRow = {
  __typename?: 'ForwarderBoardManualOrderRow';
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
};

/** Why a delivered shipment has no POD with the forwarder yet. */
export enum ForwarderBoardPodCause {
  ConnectionError = 'CONNECTION_ERROR',
  Failed = 'FAILED',
  HeldByForwarder = 'HELD_BY_FORWARDER',
  NoPhoto = 'NO_PHOTO',
  OfficeEntered = 'OFFICE_ENTERED',
  Sending = 'SENDING'
}

export type ForwarderBoardPodQueueRow = {
  __typename?: 'ForwarderBoardPodQueueRow';
  cause: ForwarderBoardPodCause;
  deliveredAt: Scalars['DateTime']['output'];
  firstUploadAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  orderUuid: Scalars['String']['output'];
  uploadAttempts: Scalars['Int']['output'];
  waitingMinutes: Scalars['Int']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderBoardRateTile = {
  __typename?: 'ForwarderBoardRateTile';
  of: Scalars['Int']['output'];
  onTime: Scalars['Int']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Forwarder Board reporting window: the live partial day, 7/30 complete days ending yesterday, or a custom date range. */
export enum ForwarderBoardWindow {
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  TodayLive = 'TODAY_LIVE'
}

export type ForwarderScorecardArgs = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  forwarder: ForwarderBoardForwarder;
  reportDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ForwarderScorecardCustomer = {
  __typename?: 'ForwarderScorecardCustomer';
  displayName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type ForwarderScorecardCustomerNotIncluded = {
  __typename?: 'ForwarderScorecardCustomerNotIncluded';
  apiOrders: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type ForwarderScorecardDeliveryExceptionRow = {
  __typename?: 'ForwarderScorecardDeliveryExceptionRow';
  arrivedSentAt?: Maybe<Scalars['DateTime']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  consigneeCity: Scalars['String']['output'];
  consigneeName: Scalars['String']['output'];
  consigneeState: Scalars['String']['output'];
  deliveredAt: Scalars['DateTime']['output'];
  dlvLagMinutes?: Maybe<Scalars['Int']['output']>;
  dlvOperator: Scalars['String']['output'];
  dlvReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  ediDispatch: Scalars['Boolean']['output'];
  orderUuid: Scalars['String']['output'];
  outForDeliverySentAt?: Maybe<Scalars['DateTime']['output']>;
  pickedUpSentAt?: Maybe<Scalars['DateTime']['output']>;
  podLagMinutes?: Maybe<Scalars['Int']['output']>;
  podReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderScorecardDeliverySummaryRow = {
  __typename?: 'ForwarderScorecardDeliverySummaryRow';
  arrivedCount: Scalars['Int']['output'];
  dlvWithin30Pct?: Maybe<Scalars['Float']['output']>;
  endDate: Scalars['DateTime']['output'];
  freightPickedUp: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  missingPodCount: Scalars['Int']['output'];
  outForDelivery: Scalars['Int']['output'];
  podWithin30Pct?: Maybe<Scalars['Float']['output']>;
  shipmentsDispatched: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type ForwarderScorecardDeliveryTrendPoint = {
  __typename?: 'ForwarderScorecardDeliveryTrendPoint';
  day: Scalars['String']['output'];
  dlvPct?: Maybe<Scalars['Float']['output']>;
  podPct?: Maybe<Scalars['Float']['output']>;
};

export type ForwarderScorecardDispatchExceptionRow = {
  __typename?: 'ForwarderScorecardDispatchExceptionRow';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  consigneeCity: Scalars['String']['output'];
  consigneeName: Scalars['String']['output'];
  consigneeState: Scalars['String']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  minutesLate?: Maybe<Scalars['Int']['output']>;
  orderUuid: Scalars['String']['output'];
  receiptAt: Scalars['DateTime']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export type ForwarderScorecardDispatchSummaryRow = {
  __typename?: 'ForwarderScorecardDispatchSummaryRow';
  acceptedPct?: Maybe<Scalars['Float']['output']>;
  connectivityPct?: Maybe<Scalars['Float']['output']>;
  endDate: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  shipmentsDispatched: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type ForwarderScorecardDispatchTrendPoint = {
  __typename?: 'ForwarderScorecardDispatchTrendPoint';
  acceptedPct?: Maybe<Scalars['Float']['output']>;
  connectivityPct?: Maybe<Scalars['Float']['output']>;
  day: Scalars['String']['output'];
};

export type ForwarderScorecardEntity = {
  __typename?: 'ForwarderScorecardEntity';
  companyName: Scalars['String']['output'];
  customers: Array<ForwarderScorecardCustomer>;
  customersNotIncluded: Array<ForwarderScorecardCustomerNotIncluded>;
  dayRowLabel: Scalars['String']['output'];
  deliveryExceptions: Array<ForwarderScorecardDeliveryExceptionRow>;
  deliveryExceptionsTotal: Scalars['Int']['output'];
  deliverySummary: Array<ForwarderScorecardDeliverySummaryRow>;
  deliveryTrend: Array<ForwarderScorecardDeliveryTrendPoint>;
  dispatchExceptions: Array<ForwarderScorecardDispatchExceptionRow>;
  dispatchExceptionsTotal: Scalars['Int']['output'];
  dispatchSummary: Array<ForwarderScorecardDispatchSummaryRow>;
  dispatchTrend: Array<ForwarderScorecardDispatchTrendPoint>;
  generatedAt: Scalars['DateTime']['output'];
  reportDay: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  undelivered: Array<ForwarderScorecardUndeliveredRow>;
  undeliveredTotal: Scalars['Int']['output'];
};

export type ForwarderScorecardUndeliveredRow = {
  __typename?: 'ForwarderScorecardUndeliveredRow';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  consigneeCity: Scalars['String']['output'];
  consigneeName: Scalars['String']['output'];
  consigneeState: Scalars['String']['output'];
  dispatchedElectronically: Scalars['Boolean']['output'];
  dispatchedReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  dispatchedSentAt?: Maybe<Scalars['DateTime']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  freightAvailableAt?: Maybe<Scalars['DateTime']['output']>;
  orderUuid: Scalars['String']['output'];
  workOrderNumber: Scalars['String']['output'];
};

export enum FreightBillingMethod {
  FlatRate = 'FLAT_RATE',
  PerMile = 'PER_MILE',
  PerPiece = 'PER_PIECE',
  Smc3 = 'SMC3',
  Tariff = 'TARIFF',
  Weight = 'WEIGHT'
}

export type FreightChargeCreateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to be applied to the freight charge total. Note that this is a percentage out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  fuelChargeCreateInput?: InputMaybe<FuelChargeCreateInput>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate: Scalars['Float']['input'];
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
};

export type FreightChargeEntity = {
  __typename?: 'FreightChargeEntity';
  authoCode?: Maybe<Scalars['String']['output']>;
  billingMethod: FreightBillingMethod;
  description?: Maybe<Scalars['String']['output']>;
  /** The discount rate for the freight charge as a percentage out of 100 if it exists */
  discountRate?: Maybe<Scalars['Percent']['output']>;
  externalRateQuote?: Maybe<ExternalRateQuoteEntity>;
  externalRatingLines?: Maybe<Array<ExternalRatingLine>>;
  fuelCharge?: Maybe<FuelChargeEntity>;
  ignoreQuantityRegression: Scalars['Boolean']['output'];
  lastRatedExternalRateQuote?: Maybe<ExternalRateQuoteEntity>;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Float']['output'];
  rate: Scalars['Float']['output'];
  ratingErrorCode?: Maybe<ExternalRatingErrorCode>;
  ratingFailure?: Maybe<ExternalRatingFailure>;
  settlementFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment: ShipmentEntity;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  tariff?: Maybe<TariffEntity>;
  total: Scalars['Float']['output'];
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

/** the freight charge amount after prorating */
export type FreightChargeForProrating = {
  __typename?: 'FreightChargeForProrating';
  totalCents: Scalars['Float']['output'];
};

export type FreightChargeRerateResult = {
  __typename?: 'FreightChargeRerateResult';
  externalRating?: Maybe<ExternalRatingResult>;
  freightChargeUuid: Scalars['String']['output'];
  status: ExternalFreightRatingStatus;
};

export type FreightChargeUpdateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod?: InputMaybe<FreightBillingMethod>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to be applied to the freight charge total. Note that this is a percentage out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  fuelChargeUpdateInput?: InputMaybe<FuelChargeUpdateInput>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type FreightChargeUpsertInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The discount rate to be applied to the freight charge total. Note that this is a percentage out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  fuelChargeUpsertInput?: InputMaybe<FuelChargeUpsertInput>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rate: Scalars['Float']['input'];
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export enum FreightClass {
  Class_50 = 'CLASS_50',
  Class_55 = 'CLASS_55',
  Class_60 = 'CLASS_60',
  Class_65 = 'CLASS_65',
  Class_70 = 'CLASS_70',
  Class_77_5 = 'CLASS_77_5',
  Class_85 = 'CLASS_85',
  Class_92_5 = 'CLASS_92_5',
  Class_100 = 'CLASS_100',
  Class_110 = 'CLASS_110',
  Class_125 = 'CLASS_125',
  Class_150 = 'CLASS_150',
  Class_175 = 'CLASS_175',
  Class_200 = 'CLASS_200',
  Class_250 = 'CLASS_250',
  Class_300 = 'CLASS_300',
  Class_400 = 'CLASS_400',
  Class_500 = 'CLASS_500'
}

export type FreightCostEntity = {
  __typename?: 'FreightCostEntity';
  billingMethod?: Maybe<FreightBillingMethod>;
  dependentSettlementBillingMethod?: Maybe<DependentSettlementBillingMethod>;
  description?: Maybe<Scalars['String']['output']>;
  /** The discount rate for the freight cost as a percentage out of 100 if it exists */
  discountRate?: Maybe<Scalars['Percent']['output']>;
  /** The flat rate of the freight cost in dollars, if it exists */
  flatRateUsdDollars?: Maybe<Scalars['Float']['output']>;
  fuelCost?: Maybe<FuelCostEntity>;
  id: Scalars['String']['output'];
  /** The percentage rate for the freight cost as a percentage out of 100 if it exists */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The rate of the freight cost in dollars, if it exists */
  rateUsdDollars?: Maybe<Scalars['Float']['output']>;
  ratedMiles?: Maybe<Scalars['Float']['output']>;
  tariff?: Maybe<TariffEntity>;
  /** @deprecated Use totalAmountUsdDollars instead. This field will be removed in a future release. */
  totalAmountUsdCents: Scalars['Float']['output'];
  /** The total cost for the freight cost in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars?: Maybe<Scalars['Float']['output']>;
};

export enum FreightRatingWarning {
  ExpiredTariffAvailable = 'EXPIRED_TARIFF_AVAILABLE',
  MilesUnavailable = 'MILES_UNAVAILABLE'
}

export type FreightScanningV2AddressInfo = {
  __typename?: 'FreightScanningV2AddressInfo';
  city?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type FreightScanningV2BulkProcessPiecesInput = {
  /** Client-side ISO-8601 timestamp of when the user actually scanned the barcode. Used to preserve real scan time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  /** Optional manifest UUID. When present, the mutation rejects the entire batch with NOT_ON_MANIFEST if any piece belongs to an order not on the manifest, before any piece state mutates. */
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  mode: FreightScanningV2ScanMode;
  pieceUuids: Array<Scalars['String']['input']>;
  /** Optional stop UUID for DELIVERY and PICKUP modes. Used to associate the scan with a specific stop. */
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional warehouse UUID for warehouse-scoped modes (INBOUND, OUTBOUND). */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2BulkProcessPiecesOutput = {
  __typename?: 'FreightScanningV2BulkProcessPiecesOutput';
  processedCount: Scalars['Int']['output'];
  results: Array<FreightScanningV2ResponseSuccessOutput>;
  success: Scalars['Boolean']['output'];
};

export type FreightScanningV2CommitWorkOrderScanErrorOutput = {
  __typename?: 'FreightScanningV2CommitWorkOrderScanErrorOutput';
  code: FreightScanningV2ScanErrorCode;
  message: Scalars['String']['output'];
};

export type FreightScanningV2CommitWorkOrderScanInput = {
  /** Client-side ISO-8601 timestamp of when the user actually scanned the barcode. Used to preserve real scan time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  /** INBOUND (-> ARRIVED) or OUTBOUND (-> LOADED) only. MOVE/DELIVERY/PICKUP are rejected. */
  mode: FreightScanningV2ScanMode;
  pieceUuid: Scalars['String']['input'];
  /** Active warehouse the operator is scanning at. Resolves the terminal stamped on the piece + the ON_HAND/LOADED terminal event. Should mirror the terminal the work-order list was queried with so the scanned piece counts as complete on the screen. */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  /** Whether workOrderUuid is a ROUTE or a LINE_HAUL manifest. Selects which membership relation the piece is verified against. */
  workOrderType: WorkOrderType;
  /** UUID of the work order the piece is being scanned under. Resolves to a route (workOrderType=ROUTE) or line-haul manifest (workOrderType=LINE_HAUL). Used to scope the piece lookup so a piece from another work order is rejected. */
  workOrderUuid: Scalars['String']['input'];
};

export type FreightScanningV2CommitWorkOrderScanOutput = FreightScanningV2CommitWorkOrderScanErrorOutput | FreightScanningV2CommitWorkOrderScanSuccessOutput | MutationErrorOutput;

export type FreightScanningV2CommitWorkOrderScanPiece = {
  __typename?: 'FreightScanningV2CommitWorkOrderScanPiece';
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2CommitWorkOrderScanSuccessOutput = {
  __typename?: 'FreightScanningV2CommitWorkOrderScanSuccessOutput';
  piece: FreightScanningV2CommitWorkOrderScanPiece;
  success: Scalars['Boolean']['output'];
  wasRescan: Scalars['Boolean']['output'];
};

export type FreightScanningV2DestinationTerminalInfo = {
  __typename?: 'FreightScanningV2DestinationTerminalInfo';
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2DocumentInfo = {
  __typename?: 'FreightScanningV2DocumentInfo';
  bucket: Scalars['String']['output'];
  fileType?: Maybe<Scalars['String']['output']>;
  preSignedGetUrl?: Maybe<Scalars['String']['output']>;
  thumbnailKey?: Maybe<Scalars['String']['output']>;
  type: DocumentType;
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2LeanOrderHeader = {
  __typename?: 'FreightScanningV2LeanOrderHeader';
  billingPartyContactDisplayName?: Maybe<Scalars['String']['output']>;
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  expectedPieceCount: Scalars['Int']['output'];
  hawb?: Maybe<Scalars['String']['output']>;
  mawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  scannedPieceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2LeanPieceInfo = {
  __typename?: 'FreightScanningV2LeanPieceInfo';
  contactDisplayName?: Maybe<Scalars['String']['output']>;
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isPieceCompletedForMode: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2LeanScanError = {
  __typename?: 'FreightScanningV2LeanScanError';
  code: FreightScanningV2ScanErrorCode;
  message: Scalars['String']['output'];
};

export type FreightScanningV2LineHaulLaneInfo = {
  __typename?: 'FreightScanningV2LineHaulLaneInfo';
  destinationTerminal: FreightScanningV2DestinationTerminalInfo;
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2MatchingPiece = {
  __typename?: 'FreightScanningV2MatchingPiece';
  packageUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2MoveWarehouseLocationInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** Client-side ISO-8601 timestamp of when the user actually scanned the barcode. Used to preserve real scan time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  pieceUuids: Array<Scalars['String']['input']>;
  setStatusToArrived?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2MoveWarehouseLocationOutput = FreightScanningV2MoveWarehouseLocationSuccessOutput | MutationErrorOutput;

export type FreightScanningV2MoveWarehouseLocationSuccessOutput = {
  __typename?: 'FreightScanningV2MoveWarehouseLocationSuccessOutput';
  pieces: Array<FreightScanningV2PieceInfo>;
  terminalCode?: Maybe<Scalars['String']['output']>;
  warehouseLocation: FreightScanningV2WarehouseLocationInfo;
  warehouseName?: Maybe<Scalars['String']['output']>;
};

export type FreightScanningV2MutationOutput = FreightScanningV2ResponseSuccessOutput | MutationErrorOutput;

export type FreightScanningV2OrderInfo = {
  __typename?: 'FreightScanningV2OrderInfo';
  billingPartyContactDisplayName?: Maybe<Scalars['String']['output']>;
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  documents: Array<FreightScanningV2DocumentInfo>;
  finalDestinationAddress?: Maybe<FreightScanningV2AddressInfo>;
  hasMultipleWarehouseLocations: Scalars['Boolean']['output'];
  hasShortage: Scalars['Boolean']['output'];
  hawb?: Maybe<Scalars['String']['output']>;
  isLineHaul: Scalars['Boolean']['output'];
  lineHaulLane?: Maybe<FreightScanningV2LineHaulLaneInfo>;
  mawb?: Maybe<Scalars['String']['output']>;
  measurementUnits?: Maybe<MeasurementUnits>;
  name: Scalars['String']['output'];
  osAndD?: Maybe<Scalars['Boolean']['output']>;
  osdReason?: Maybe<Scalars['String']['output']>;
  packages: Array<FreightScanningV2PackageOption>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
  pieceCountFromPackages: Scalars['Int']['output'];
  piecesDelivered: FreightScanningV2PiecesDeliveredInfo;
  piecesPickedUp: FreightScanningV2PiecesPickedUpInfo;
  scanProgress?: Maybe<FreightScanningV2ScanProgress>;
  tags: Array<FreightScanningV2TagInfo>;
  uuid: Scalars['String']['output'];
  weightUnits?: Maybe<WeightUnits>;
};

export type FreightScanningV2OrderInfoInput = {
  mode: FreightScanningV2ScanMode;
  orderUuid: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2OrderOption = {
  __typename?: 'FreightScanningV2OrderOption';
  destination?: Maybe<Scalars['String']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  matchingPiece?: Maybe<FreightScanningV2MatchingPiece>;
  mawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  packageCount: Scalars['Int']['output'];
  packages: Array<FreightScanningV2PackageSummary>;
  totalPieces: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2PackageOption = {
  __typename?: 'FreightScanningV2PackageOption';
  description: Scalars['String']['output'];
  dimensions?: Maybe<Scalars['String']['output']>;
  onHand: Scalars['Int']['output'];
  pieces: Array<FreightScanningV2PieceInfo>;
  quantity: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  type?: Maybe<PackageType>;
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type FreightScanningV2PackageSummary = {
  __typename?: 'FreightScanningV2PackageSummary';
  description?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2PieceInfo = {
  __typename?: 'FreightScanningV2PieceInfo';
  contactDisplayName?: Maybe<Scalars['String']['output']>;
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  damagedNote?: Maybe<Scalars['String']['output']>;
  documents: Array<FreightScanningV2DocumentInfo>;
  height?: Maybe<Scalars['Float']['output']>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isPieceCompletedForMode: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  measurementUnits?: Maybe<MeasurementUnits>;
  name: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  terminal?: Maybe<FreightScanningV2TerminalInfo>;
  uuid?: Maybe<Scalars['String']['output']>;
  warehouse?: Maybe<FreightScanningV2WarehouseInfo>;
  warehouseLocation?: Maybe<FreightScanningV2WarehouseLocationInfo>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<WeightUnits>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type FreightScanningV2PieceInfoInput = {
  mode: FreightScanningV2ScanMode;
  pieceUuid: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2PiecesDeliveredInfo = {
  __typename?: 'FreightScanningV2PiecesDeliveredInfo';
  deliveryScansCount: Scalars['Int']['output'];
};

export type FreightScanningV2PiecesPickedUpInfo = {
  __typename?: 'FreightScanningV2PiecesPickedUpInfo';
  pickupScansCount: Scalars['Int']['output'];
};

export type FreightScanningV2ProcessBarcodeInput = {
  /** When true and the barcode resolves as a serialized lot label (pieceName is set), skip the NEEDS_PACKAGE_SELECTION gate and FIFO-assign + scan in one call. Use only from flows that have no post-NeedsPackageSelection FIFO-assign of their own (e.g. inbound scan-log). Other flows (useOrderPieceListScanning, useScannedOrderDetailsFlow) manage FIFO-assign themselves and must NOT set this flag. */
  autoAssignSerializedPiece?: InputMaybe<Scalars['Boolean']['input']>;
  barcode: Scalars['String']['input'];
  /** Client-side ISO-8601 timestamp of when the user actually scanned the barcode. Used to preserve real scan time across offline replays. Shifted by the device clock offset when the request carries the x-client-sent-at header; if the result is outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  mode: FreightScanningV2ScanMode;
  /** If provided, skips barcode lookup and resolves this specific order directly. Used after the user selects an order from the multi-order picker. */
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional stop UUID for DELIVERY and PICKUP modes. Used to associate the scan with a specific stop. */
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2ProcessBarcodeLeanOutput = FreightScanningV2ProcessBarcodeLeanSuccessOutput | MutationErrorOutput;

export type FreightScanningV2ProcessBarcodeLeanSuccessOutput = {
  __typename?: 'FreightScanningV2ProcessBarcodeLeanSuccessOutput';
  error?: Maybe<FreightScanningV2LeanScanError>;
  fuzzyMatchHints: Array<OrderFuzzyMatchHint>;
  fuzzyMatchedField?: Maybe<ScanMatchedField>;
  isFuzzyMatch: Scalars['Boolean']['output'];
  isSerializedBarcode?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<FreightScanningV2LeanOrderHeader>;
  orders?: Maybe<Array<FreightScanningV2OrderOption>>;
  orphanPieces?: Maybe<Array<FreightScanningV2PieceInfo>>;
  packages?: Maybe<Array<FreightScanningV2PackageOption>>;
  piece?: Maybe<FreightScanningV2LeanPieceInfo>;
  piecesCreated?: Maybe<Scalars['Int']['output']>;
  scanJobUuid?: Maybe<Scalars['String']['output']>;
  selectedPackageUuid?: Maybe<Scalars['String']['output']>;
  state: FreightScanningV2ScanSessionState;
  wasRescan?: Maybe<Scalars['Boolean']['output']>;
};

export type FreightScanningV2ResponseSuccessOutput = {
  __typename?: 'FreightScanningV2ResponseSuccessOutput';
  error?: Maybe<FreightScanningV2ScanError>;
  fuzzyMatchHints: Array<OrderFuzzyMatchHint>;
  fuzzyMatchedField?: Maybe<ScanMatchedField>;
  isFuzzyMatch: Scalars['Boolean']['output'];
  isSerializedBarcode?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<FreightScanningV2OrderInfo>;
  orders?: Maybe<Array<FreightScanningV2OrderOption>>;
  orphanPieces?: Maybe<Array<FreightScanningV2PieceInfo>>;
  piece?: Maybe<FreightScanningV2PieceInfo>;
  piecesCreated?: Maybe<Scalars['Int']['output']>;
  selectedPackageUuid?: Maybe<Scalars['String']['output']>;
  state: FreightScanningV2ScanSessionState;
  wasRescan?: Maybe<Scalars['Boolean']['output']>;
};

export type FreightScanningV2ScanError = {
  __typename?: 'FreightScanningV2ScanError';
  code: FreightScanningV2ScanErrorCode;
  message: Scalars['String']['output'];
  order?: Maybe<FreightScanningV2OrderInfo>;
};

/** Error codes for scanning operations */
export enum FreightScanningV2ScanErrorCode {
  BarcodeAmbiguous = 'BARCODE_AMBIGUOUS',
  BarcodeNotFound = 'BARCODE_NOT_FOUND',
  NotOnManifest = 'NOT_ON_MANIFEST',
  NotOnStop = 'NOT_ON_STOP',
  PackPending = 'PACK_PENDING'
}

/** Lifecycle status of a deferred scan post-processing job (derived from BullMQ job state). */
export enum FreightScanningV2ScanJobState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type FreightScanningV2ScanJobStatus = {
  __typename?: 'FreightScanningV2ScanJobStatus';
  errorMessage?: Maybe<Scalars['String']['output']>;
  status: FreightScanningV2ScanJobState;
  uuid: Scalars['String']['output'];
};

export type FreightScanningV2ScanJobStatusesInput = {
  uuids: Array<Scalars['String']['input']>;
};

/** The mode of the scanning operation */
export enum FreightScanningV2ScanMode {
  Delivery = 'DELIVERY',
  Inbound = 'INBOUND',
  Move = 'MOVE',
  Outbound = 'OUTBOUND',
  Pickup = 'PICKUP'
}

export type FreightScanningV2ScanProgress = {
  __typename?: 'FreightScanningV2ScanProgress';
  isFirstTerminal?: Maybe<Scalars['Boolean']['output']>;
  isLastTerminal?: Maybe<Scalars['Boolean']['output']>;
  manifestReferenceNumber?: Maybe<Scalars['String']['output']>;
  manifestUuid?: Maybe<Scalars['String']['output']>;
  scannedPieceCount: Scalars['Int']['output'];
};

/** The current state of the scanning session */
export enum FreightScanningV2ScanSessionState {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  NeedsFuzzyMatchConfirmation = 'NEEDS_FUZZY_MATCH_CONFIRMATION',
  NeedsOrderlessInboundConfirmation = 'NEEDS_ORDERLESS_INBOUND_CONFIRMATION',
  NeedsOrderSelection = 'NEEDS_ORDER_SELECTION',
  NeedsOrphanPieceSelection = 'NEEDS_ORPHAN_PIECE_SELECTION',
  NeedsPackageSelection = 'NEEDS_PACKAGE_SELECTION',
  NoAssignablePiece = 'NO_ASSIGNABLE_PIECE',
  OrderResolved = 'ORDER_RESOLVED',
  OrphanPieceResolved = 'ORPHAN_PIECE_RESOLVED'
}

export type FreightScanningV2SelectPackageInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  createNewPiece?: InputMaybe<Scalars['Boolean']['input']>;
  isSerializedBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional manifest UUID. When present, the mutation rejects scans whose order is not on the manifest with a NOT_ON_MANIFEST error before any piece state mutates. */
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  mode: FreightScanningV2ScanMode;
  orderUuid: Scalars['String']['input'];
  packageUuid: Scalars['String']['input'];
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  /** Optional stop UUID for DELIVERY and PICKUP modes. Used to associate the scan with a specific stop. */
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse location UUID for staging mode */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FreightScanningV2TagInfo = {
  __typename?: 'FreightScanningV2TagInfo';
  color?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FreightScanningV2TerminalInfo = {
  __typename?: 'FreightScanningV2TerminalInfo';
  code: Scalars['String']['output'];
};

export type FreightScanningV2WarehouseInfo = {
  __typename?: 'FreightScanningV2WarehouseInfo';
  name: Scalars['String']['output'];
};

export type FreightScanningV2WarehouseLocationInfo = {
  __typename?: 'FreightScanningV2WarehouseLocationInfo';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FreightSnapCreateInput = {
  freightSnapTransactionUuid: Scalars['String']['input'];
  proNum?: InputMaybe<Scalars['String']['input']>;
};

export enum FreightSnapFailureReason {
  EmptyFreightSnapDimensions = 'EMPTY_FREIGHT_SNAP_DIMENSIONS',
  NoMatch = 'NO_MATCH',
  NoShipmentsFoundForOrder = 'NO_SHIPMENTS_FOUND_FOR_ORDER',
  Unknown = 'UNKNOWN'
}

export type FreightSnapTransactionEntity = {
  __typename?: 'FreightSnapTransactionEntity';
  createdAt: Scalars['DateTime']['output'];
  ehdim?: Maybe<Scalars['String']['output']>;
  eldim?: Maybe<Scalars['String']['output']>;
  ewdim?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<FreightSnapFailureReason>;
  imgs: Array<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  proNum?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FreightSnapTransactionStatus>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['String']['output']>;
};

export enum FreightSnapTransactionStatus {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export enum FuelBillingMethod {
  AutoCalculate = 'AUTO_CALCULATE',
  FlatRate = 'FLAT_RATE',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

export type FuelChargeCreateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  autoCalculate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  surchargeRate: Scalars['Float']['input'];
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  type: FuelBillingMethod;
};

export type FuelChargeEntity = {
  __typename?: 'FuelChargeEntity';
  authoCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the AUTO_CALCULATE FuelBillingMethod value instead */
  autoCalculate: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  flatRate: Scalars['Float']['output'];
  freightCharge: FreightChargeEntity;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  settlementFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  surchargeRate: Scalars['Float']['output'];
  /** @deprecated this value is wrong!! use shipmentCharges.totalFuelCharge on shipment instead */
  total: Scalars['Float']['output'];
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  type: FuelBillingMethod;
  uuid: Scalars['String']['output'];
};

/** the fuel charge amount after prorating */
export type FuelChargeForProrating = {
  __typename?: 'FuelChargeForProrating';
  totalCents: Scalars['Float']['output'];
};

export type FuelChargeFuelProfileDateRangeInput = {
  /** The appointment date for the fuel charge's stop */
  appointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  contactUuid: Scalars['String']['input'];
  /** The service date for the fuel charge's stop */
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date the fuel charge's stop was completed */
  stopCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUID of the fuel profile attached to the tariff selected for the stop */
  tariffGroupFuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FuelChargeFuelProfileDateRangeOutput = {
  __typename?: 'FuelChargeFuelProfileDateRangeOutput';
  fuelProfileDateRange?: Maybe<FuelProfileDateRangeEntity>;
};

export type FuelChargeUpdateInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  autoCalculate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<FuelBillingMethod>;
  uuid: Scalars['String']['input'];
};

export type FuelChargeUpsertInput = {
  authoCode?: InputMaybe<Scalars['String']['input']>;
  autoCalculate?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  surchargeRate: Scalars['Float']['input'];
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  type: FuelBillingMethod;
  uuid: Scalars['String']['input'];
};

export type FuelCostEntity = {
  __typename?: 'FuelCostEntity';
  billingMethod?: Maybe<FuelBillingMethod>;
  dependentSettlementBillingMethod?: Maybe<DependentSettlementBillingMethod>;
  /** The flat rate of the fuel cost in dollars, if it exists */
  flatRateUsdDollars?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  /** The percentage rate for the fuel cost as a percentage out of 100 if it exists */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  /** The surcharge rate for the fuel cost as a percentage out of 100 if it exists */
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use totalAmountUsdDollars instead. This field will be removed in a future release. */
  totalAmountUsdCents: Scalars['Float']['output'];
  /** The total cost for the fuel cost in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars?: Maybe<Scalars['Float']['output']>;
};

export type FuelProfileDateRangeEntity = {
  __typename?: 'FuelProfileDateRangeEntity';
  createdAt: Scalars['DateTime']['output'];
  expirationDate: Scalars['DateTime']['output'];
  flatRateUsdCents?: Maybe<Scalars['Float']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['DateTime']['output'];
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type FuelProfileEntity = {
  __typename?: 'FuelProfileEntity';
  billingType: FuelBillingMethod;
  company: CompanyEntity;
  contacts?: Maybe<Array<ContactEntity>>;
  createdAt: Scalars['DateTime']['output'];
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  flatRateUsdCents?: Maybe<Scalars['Int']['output']>;
  fuelProfileDateRanges: Array<FuelProfileDateRangeEntity>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  surchargeRate: Scalars['Float']['output'];
  tariffGroups: Array<TariffGroupEntity>;
  type: FuelProfileType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum FuelProfileType {
  ContactSpecific = 'CONTACT_SPECIFIC',
  Global = 'GLOBAL'
}

export enum FuelRatingWarning {
  NoValidFuelProfile = 'NO_VALID_FUEL_PROFILE',
  UsedCurrentDateFallback = 'USED_CURRENT_DATE_FALLBACK'
}

export type FuelRatingWarningDetailsEntity = {
  __typename?: 'FuelRatingWarningDetailsEntity';
  /** True when the fuel profile has at least one date range and every range expired before the rating date. False when it has no ranges, or a range starts later or leaves a gap at that date. */
  fuelProfileExpired: Scalars['Boolean']['output'];
  fuelProfileName?: Maybe<Scalars['String']['output']>;
  /** Name of the tariff group the fuel profile is attached to. */
  tariffName?: Maybe<Scalars['String']['output']>;
};

export enum FulfillmentType {
  Dedicated = 'DEDICATED',
  MultiTrip = 'MULTI_TRIP'
}

export type FuzzySearchItemsBySkuNameInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};

export type FuzzySearchItemsBySkuNameOutput = {
  __typename?: 'FuzzySearchItemsBySkuNameOutput';
  /** The item whose SKU most closely matches the specified SKU */
  item?: Maybe<ItemEntity>;
};

export type FuzzySearchOrdersByShipperBillOfLadingNumberInput = {
  shipperBillOfLadingNumber: Scalars['String']['input'];
};

export type FuzzySearchOrdersByShipperBillOfLadingNumberOutput = {
  __typename?: 'FuzzySearchOrdersByShipperBillOfLadingNumberOutput';
  /** The candidate orders whose shipper BOLs meet the similarity threshold for the specified BOL */
  orders: Array<OrderEntity>;
};

export type FuzzySearchStorageOrdersInput = {
  searchText: Scalars['String']['input'];
};

export type FuzzySearchStorageOrdersOutput = {
  __typename?: 'FuzzySearchStorageOrdersOutput';
  storageOrders: Array<StorageOrderEntity>;
};

export type FuzzySearchStorageUnitsInput = {
  searchText: Scalars['String']['input'];
};

export type FuzzySearchStorageUnitsOutput = {
  __typename?: 'FuzzySearchStorageUnitsOutput';
  storageUnits: Array<StorageUnitEntity>;
};

export type GlCodeReportPdfInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GeneralLedgerCodeCreateInput = {
  code: Scalars['String']['input'];
  configurationId: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type GeneralLedgerCodeDeleteInput = {
  id: Scalars['String']['input'];
};

export type GeneralLedgerCodeEntity = {
  __typename?: 'GeneralLedgerCodeEntity';
  accessorials: Array<AccessorialUnion>;
  code: Scalars['String']['output'];
  creditTypes: Array<CreditTypeEntity>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type GeneralLedgerCodeUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  configurationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type GeneralLedgerConfigurationEntity = {
  __typename?: 'GeneralLedgerConfigurationEntity';
  accessorialFallbackCodeId?: Maybe<Scalars['String']['output']>;
  deliveryChargeCodeId?: Maybe<Scalars['String']['output']>;
  fuelChargeCodeId?: Maybe<Scalars['String']['output']>;
  generalLedgerCodes: Array<GeneralLedgerCodeEntity>;
  id: Scalars['String']['output'];
  lineHaulChargeCodeId?: Maybe<Scalars['String']['output']>;
  orderChargeCodeId?: Maybe<Scalars['String']['output']>;
  pickupChargeCodeId?: Maybe<Scalars['String']['output']>;
  recoveryChargeCodeId?: Maybe<Scalars['String']['output']>;
  transferChargeCodeId?: Maybe<Scalars['String']['output']>;
};

export type GeneralLedgerConfigurationUpdateInput = {
  accessorialFallbackCodeId?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lineHaulChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  orderChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  pickupChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  recoveryChargeCodeId?: InputMaybe<Scalars['String']['input']>;
  transferChargeCodeId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateAccountingReportPreSignedPutUrlInput = {
  companyUuid: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type GenerateClearCompanyContactsTokenInput = {
  companyUuid: Scalars['String']['input'];
};

export type GenerateClearCompanyContactsTokenOutput = {
  __typename?: 'GenerateClearCompanyContactsTokenOutput';
  token: Scalars['String']['output'];
};

export type GenerateContactPreSignedPutUrlInput = {
  contactUuid: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type GenerateCsvOrderPresignedPutUrlInput = {
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
};

export type GenerateCsvPresignedPutUrlForMappingPreviewInput = {
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
};

export type GenerateCsvPresignedPutUrlForMappingPreviewOutput = {
  __typename?: 'GenerateCsvPresignedPutUrlForMappingPreviewOutput';
  bucket: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filetype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GenerateDefaultAppointmentTextsArgs = {
  appointmentUuids: Array<Scalars['String']['input']>;
};

export type GenerateHistoricalInvoicesCsvInput = {
  companyUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenerateHistoricalInvoicesCsvOutput = {
  __typename?: 'GenerateHistoricalInvoicesCsvOutput';
  s3Url?: Maybe<Scalars['String']['output']>;
};

export type GenerateInvoicePreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  invoiceUuid: Scalars['String']['input'];
};

export type GenerateInvoicePreSignedPutUrlOutput = {
  __typename?: 'GenerateInvoicePreSignedPutUrlOutput';
  invoiceUuid: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GenerateInvoicePreSignedPutUrlsInput = {
  generateInvoicePreSignedPutUrlInputs: Array<GenerateInvoicePreSignedPutUrlInput>;
};

export type GenerateLabelInput = {
  /** The ZPL data to be used to generate the label */
  zplData: Scalars['String']['input'];
};

export type GenerateLineHaulRunsInput = {
  fromDate: Scalars['String']['input'];
  recurringTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  toDate: Scalars['String']['input'];
};

export type GenerateLineHaulRunsOutput = {
  __typename?: 'GenerateLineHaulRunsOutput';
  created: Scalars['Int']['output'];
  serviceDays: Scalars['Int']['output'];
};

export type GenerateOrderDocumentPreSignedPutUrlInput = {
  /** @deprecated Use CurrentUser instead */
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type GenerateOrderPreSignedGetAndPutUrlsInput = {
  /** The company the upload is for. Defaults to the session's company. */
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
};

export type GenerateOrderPreSignedGetAndPutUrlsOutput = {
  __typename?: 'GenerateOrderPreSignedGetAndPutUrlsOutput';
  getUrl: Scalars['String']['output'];
  putUrl: Scalars['String']['output'];
};

export type GenerateOrderPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type GeneratePiecePreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};

export type GeneratePodReportPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type GeneratePreSignedPutUrlOutput = {
  __typename?: 'GeneratePreSignedPutUrlOutput';
  url: Scalars['String']['output'];
};

export type GenerateResetCompanyTokenInput = {
  companyUuid: Scalars['String']['input'];
};

export type GenerateResetCompanyTokenOutput = {
  __typename?: 'GenerateResetCompanyTokenOutput';
  token: Scalars['String']['output'];
};

export type GenerateRoutesInput = {
  appointmentWindowType: AppointmentWindowType;
  driverEquipmentConstraints: Array<DriverEquipmentConstraintInput>;
  stopUuids: Array<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateRoutesOutput = {
  __typename?: 'GenerateRoutesOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  routes?: Maybe<Array<RouteGenerationPreviewEntity>>;
  unassignedStopUuids?: Maybe<Array<Scalars['String']['output']>>;
};

export type GenerateShipmentPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  shipmentUuid: Scalars['String']['input'];
};

export type GenerateStorageOrderPreSignedPutUrlInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  storageOrderUuid: Scalars['String']['input'];
};

export type GenerateStorageOrderPreSignedPutUrlOutput = {
  __typename?: 'GenerateStorageOrderPreSignedPutUrlOutput';
  preSignedPutUrl: Scalars['String']['output'];
};

export enum GeocodeQuality {
  Approximate = 'APPROXIMATE',
  Exact = 'EXACT',
  Unavailable = 'UNAVAILABLE',
  Unresolved = 'UNRESOLVED'
}

export type GetCityAndStateOptionsFromZipcodeInput = {
  zipcode: Scalars['String']['input'];
};

export type GetCityAndStateOptionsFromZipcodeOutput = {
  __typename?: 'GetCityAndStateOptionsFromZipcodeOutput';
  /** A list of city and state options that the zipcode could apply to */
  citiesAndStates: Array<CityAndStateOptionEntity>;
  /** The zipcode that was used to retrieve city and state options */
  zipcode: Scalars['String']['output'];
};

export type GetDispatchableDriversInput = {
  /** If provided, we will return all drivers that are assigned to this terminal or to an agent terminal in the same service region as that terminal */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GetDispatchableDriversOutput = {
  __typename?: 'GetDispatchableDriversOutput';
  /** Agents under the company that have drivers that are dispatchable given some inputs */
  agents: Array<DispatchableAgentEntity>;
  /** Non-agent drivers under the company that are dispatchable given some inputs */
  companyDrivers: Array<DriverEntity>;
};

export type GetDriverCredentialTypesInput = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetDriverSettlementPayBoundsInput = {
  driverUuid: Scalars['String']['input'];
};

export type GetFeatureFlagCompanyOverridesInput = {
  featureFlagUuid: Scalars['String']['input'];
};

export type GetFeatureFlagUserOverridesInput = {
  featureFlagUuid: Scalars['String']['input'];
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GetInvoiceCsvsInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type GetLineHaulProgressInput = {
  uuid: Scalars['String']['input'];
};

export type GetLineHaulProgressOutput = {
  __typename?: 'GetLineHaulProgressOutput';
  /** each terminal's status in the line haul */
  terminalStatuses: Array<LineHaulStatusByTerminal>;
};

export type GetOrderAuditLogEntriesInput = {
  orderUuid: Scalars['String']['input'];
};

export type GetOrderAuditLogEntriesOutput = {
  __typename?: 'GetOrderAuditLogEntriesOutput';
  auditLogEntries: Array<AuditLogEntry>;
};

export type GetOrderTableFieldHeadersOutput = {
  __typename?: 'GetOrderTableFieldHeadersOutput';
  /** The list of table headers for all order table fields */
  orderTableFieldHeaders: Array<OrderTableFieldHeaderEntity>;
};

export type GetOrderTableFieldValuesInput = {
  /** A UUID filter intended for the active terminal */
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order attempted date. Currently only implemented for the flat orders view. */
  attemptedDateFilter?: InputMaybe<DateFilterV2>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  /** Searches for orders with one of these contacts. Null represents no filter being applied at all (equivalent to "All"). An empty array should not be passed in since orders must always have a billing party contact. */
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the can dispatch boolean status. Currently only implemented for the flat orders view. */
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the completed at order table field */
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A date filter intended for the order created date. Currently only implemented for the flat orders view. */
  createdDateFilter?: InputMaybe<DateFilterV2>;
  customerFilter?: InputMaybe<StringFilter>;
  /** A string filter intended for the customer name field */
  customerNameFilter?: InputMaybe<StringFilterV2>;
  /** A filter for the customer portal order review status. */
  customerPortalOrderReviewStatusFilter?: InputMaybe<CustomerPortalOrderReviewStatusFilter>;
  /** A UUID filter for the customer */
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the order deadline date. Currently only implemented for the flat orders view. */
  deadlineDateFilter?: InputMaybe<DateFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the destination terminal */
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A float filter intended for the dim weight. Currently only implemented for the flat orders view. */
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  /** A string filter intended for the driver name flat order table field */
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these drivers. An empty values array represents orders with no driver (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the order external notes. Currently only implemented for the flat orders view. */
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filters?: InputMaybe<FindOrdersFiltersInput>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for orders holding SMC3 freight that needs a rate. Currently only implemented for the flat orders view. */
  freightNeedsRateFilter?: InputMaybe<BooleanFilterV2>;
  /** When set, the orders table is grouped. See OrderTableGroupByInput for how `fields` and `keys` decide whether group rows or orders come back. */
  groupBy?: InputMaybe<OrderTableGroupByInput>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasQuotesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the HAWB order table field */
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for filtering out shipments associated with a consolidated order in the old consolidated order flow. */
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the hold reason. Currently only implemented for the flat orders view. */
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the secondary reference number on the inbound address table field */
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for inbound address type. Currently only implemented for the flat orders view. */
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed inbound appointment. Currently only implemented for the flat orders view. */
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound appointment date. Currently only implemented for the flat orders view. */
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the inbound appointment required. Currently only implemented for the flat orders view. */
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the INBOUND_CITY_NAME order table field */
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the inbound completed date order table field */
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for inbound stop completion. Currently only implemented for the flat orders view. */
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the inbound contact name. Currently only implemented for the flat orders view. */
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound driver name flat order table field */
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the inbound route date. Currently only implemented for the flat orders view. */
  inboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the inbound route name. Currently only implemented for the flat orders view. */
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the inbound routing field. Currently only implemented for the flat orders view. */
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the INBOUND_SERVICE_DATE order table field */
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the inbound stop type filter. Currently only implemented for the flat orders view. */
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the inbound terminal name field */
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the inbound zipcode filter. Currently only implemented for the flat orders view. */
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  /** If set to true, includes the formatted orders with the requested field values as part of the output */
  includeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** A boolean filter intended to filter by whether order is part of a consolidated order. */
  includeOrdersPartOfV2ConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the order invoice date. Currently only implemented for the flat orders view. */
  invoiceDateFilter?: InputMaybe<DateFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the invoice name on the order table field (used when useJournalNumberForInvoice is false) */
  invoiceNameFilter?: InputMaybe<StringFilterV2>;
  /** An integer filter for the invoice journal number (used when useJournalNumberForInvoice is true) */
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isDraftOrderFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  /** A boolean filter intended for the orders that are reweighed. Currently only implemented for the flat orders view. */
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the IT number order table field */
  itNumberFilter?: InputMaybe<StringFilterV2>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** A UUID filter for the end terminal of the last line haul manifest that the order is on */
  lastLineHaulTerminalUuidFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul lane field. Currently only implemented for the flat orders view. */
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A UUID filter for the line haul leg destination terminal. Matches orders that have a segment whose end terminal matches. */
  lineHaulLegDestinationTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg (segment). Matches orders assigned to the specified segment via OrderLineHaulSegment. */
  lineHaulLegFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID filter for the line haul leg origin terminal. Matches orders that have a segment whose start terminal matches. */
  lineHaulLegOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A filter for the order's line-haul origin terminal (the order-level origin set for "out of inventory" orders, else the on-hand terminal derivation). Used by the line-haul Outbound tab so out-of-inventory orders are discoverable under their origin terminal. */
  lineHaulOriginTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A UUID list filter for the terminals that the line haul manifests include */
  lineHaulTerminalUuidsFilter?: InputMaybe<UuidListFilter>;
  /** A date filter intended for the date marked on hand. Currently only implemented for the flat orders view. */
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the MAWB order table field */
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pass as true to remove the limit. Use with caution! */
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  /** A filter intended for the on hand terminal. Currently only implemented for the flat orders view and is used in context of line haul orders. */
  onHandTerminalFilter?: InputMaybe<UuidFilterV2>;
  /** A boolean filter intended for on hold orders. Currently only implemented for the flat orders view. */
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the order city */
  orderCityFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order name order table field */
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the order notes. Currently only implemented for the flat orders view. */
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  /** A date filter intended for the order service date order table field */
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  /** An enum filter intended for the ORDER_SOURCE order table field */
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  /** A filter intended for the order status. Currently only implemented for the flat orders view. */
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  /** The list of order table fields to fetch values for */
  orderTableFields: Array<OrderTableField>;
  /** A string filter intended for the order zipcode */
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  /** A UUID filter intended for the origin terminal */
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the OSD reason. Currently only implemented for the flat orders view. */
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the secondary reference number on the outbound address table field */
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for outbound address type. Currently only implemented for the flat orders view. */
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  /** A boolean filter intended for a confirmed outbound appointment. Currently only implemented for the flat orders view. */
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  /** A date filter intended for the outbound appointment date. Currently only implemented for the flat orders view. */
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended for the outbound appointment required. Currently only implemented for the flat orders view. */
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the OUTBOUND_CITY_NAME order table field */
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound completed date order table field */
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  /** A boolean filter intended to filter for outbound stop completion. Currently only implemented for the flat orders view. */
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the outbound contact name. Currently only implemented for the flat orders view. */
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound destination airport. Currently only implemented for the flat orders view. */
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound driver name flat order table field */
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  /** A date filter intended for the outbound route date. Currently only implemented for the flat orders view. */
  outboundRouteDateFilter?: InputMaybe<DateFilterV2>;
  /** A string filter intended for the outbound route name. Currently only implemented for the flat orders view. */
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the outbound routing field. Currently only implemented for the flat orders view. */
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the outbound service date. Currently only implemented for the flat orders view. */
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  /** A filter intended for the outbound stop type filter. Currently only implemented for the flat orders view. */
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  /** A string filter intended for the outbound terminal name field */
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  /** A filter intended for the outbound zipcode filter. Currently only implemented for the flat orders view. */
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  /** A UUID filter for terminals derived from piece warehouse locations on the order. Semantics across operators: `eq` / `in` match an order when at least one piece is in a warehouse location whose warehouse belongs to one of the requested terminals. `neq` / `nin` exclude an order when ANY piece is in a warehouse location whose warehouse belongs to one of the requested terminals, so a split order with pieces at multiple terminals is excluded if any of its terminals is in the list. `isBlank` matches orders with no piece-terminal assignment at all; `isNotBlank` matches orders with at least one piece-terminal assignment. */
  pieceTerminalFilter?: InputMaybe<UuidFilterV2>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for the inbound or outbound proof of delivery name field */
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  /** A string filter intended for the proof of delivery signee. Currently only implemented for the flat orders view. */
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  /** A boolean filter intended for the received at origin boolean status. Currently only implemented for the flat orders view. */
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for routing location. Currently only implemented for the flat orders view. */
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** A string filter intended for the secondary reference number on the order table field */
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  /** A date filter intended for the ORDER_SERVICE_DATE order table field */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  /** A string filter intended for serviceLevel. Currently only implemented for the flat orders view. */
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  /** True if ascending, False if descending, undefined if no sort */
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  /** A string filter for the email of the user who created the order. */
  sourceUserEmailFilter?: InputMaybe<StringFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Searches for orders with one of these tags. An empty values array represents orders with no tags (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  /** A string filter intended for the order tags. Currently only implemented for the flat orders view. */
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  /** Searches for orders with one of these terminals on the startStop or endStop. An empty values array represents orders with no terminal on the startStop and endStop (equivalent to "None"). Null represents no filter being applied at all (equivalent to "All"). */
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  /** A float filter intended for the total amount in dollars. Currently only implemented for the flat orders view. */
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  /** request total number of records, request with prudence */
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  /** An int filter intended for the total pieces flat order table field only */
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  /** An int filter intended for the total skids. Currently implemented only for the flat orders view */
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  /** A float filter intended for the total weight flat order table field only */
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  /** A string filter intended for the UN number order table field */
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useFlatOrdersView?: InputMaybe<Scalars['Boolean']['input']>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** Spike toggle: when true, the orders-table query is served by the SQE (flat_orders.switchover) instead of Prisma's `flat_orders` view. Per-request flag; the frontend flips it from the orders-table toolbar. */
  useSqeBackend?: InputMaybe<Scalars['Boolean']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). When provided, the backend uses this timezone to compute day boundaries for date filters so that results reflect the calendar date in the user's local time rather than UTC. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Version ID for the request */
  versionId?: InputMaybe<Scalars['Float']['input']>;
  /** A UUID filter for the warehouse derived from piece locations on the order. This filters by Warehouse UUID (not WarehouseLocation/bin). The warehouse is determined by the unanimous piece-level warehouseId across the order. */
  warehouseLocationFilter?: InputMaybe<UuidFilterV2>;
  /** A string filter intended for the zipcode on inbound and outbound stops table field */
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};

/** The output of the query to retrieve the order table field values for a set of orders. */
export type GetOrderTableFieldValuesOutput = {
  __typename?: 'GetOrderTableFieldValuesOutput';
  /** The paginated list of formatted orders with the values for the order table fields specified in the input */
  formattedOrderConnection: FormattedOrderConnection;
  /** The group rows of the requested level when the input carries a `groupBy` whose `keys` are shorter than its `fields`. Null otherwise, including for the orders under a fully expanded group path, which arrive in `formattedOrderConnection`. */
  groupRows?: Maybe<Array<OrderTableGroupRowEntity>>;
  /** Whether more group rows exist past `groupRows` at the requested level. Null when `groupRows` is null. */
  groupRowsHasMore?: Maybe<Scalars['Boolean']['output']>;
  /** The list of table headers for the order table fields requested as part of the order retrieval query */
  orderTableFieldHeaders: Array<OrderTableFieldHeaderEntity>;
};

export type GetOutlookIntegrationsForInternalInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GetScannedOrderResultsForAdminArgs = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  failed?: InputMaybe<Scalars['Boolean']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  scannedOrderSource?: InputMaybe<ScannedOrderSource>;
  scannedOrderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetSchemaMatchDetailsInput = {
  bucket: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type GetServiceRegionsInput = {
  /** Filter for either archived or not archived service regions. Defaults to all. */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetServiceRegionsOutput = {
  __typename?: 'GetServiceRegionsOutput';
  /** All off the company's service regions. */
  serviceRegions: Array<ServiceRegionEntity>;
};

export type GetShipmentsInput = {
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetTerminalsInput = {
  /** @deprecated Use isActive = false instead */
  excludeNotActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally filter by isActive, defaults to including all terminals */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetTerminalsInternalInput = {
  companyUuid: Scalars['String']['input'];
  excludeNotActive: Scalars['Boolean']['input'];
};

export type GetUsersInput = {
  includeNotActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetXyTransformInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export type GetZipcodeOptionsFromCityAndStateInput = {
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type GetZipcodeOptionsFromCityAndStateOutput = {
  __typename?: 'GetZipcodeOptionsFromCityAndStateOutput';
  /** The city that was used to retrieve zipcode options */
  city: Scalars['String']['output'];
  /** The state that was used to retrieve zipcode options */
  state: Scalars['String']['output'];
  /** A list of zipcode options that the city and state could apply to */
  zipcodes: Array<ZipcodeOptionEntity>;
};

export enum GranteeType {
  Terminal = 'TERMINAL',
  User = 'USER'
}

export type GroupByStopEntity = {
  __typename?: 'GroupByStopEntity';
  ADDRESS: Scalars['String']['output'];
  ADDRESS_TYPE?: Maybe<Scalars['String']['output']>;
  APPOINTMENT?: Maybe<Scalars['DateTime']['output']>;
  APPOINTMENT_DATE?: Maybe<Scalars['DateTime']['output']>;
  APPOINTMENT_REQUIRED?: Maybe<Scalars['Boolean']['output']>;
  APPOINTMENT_SCHEDULED?: Maybe<Scalars['Boolean']['output']>;
  APPOINTMENT_TIME?: Maybe<Scalars['DateTime']['output']>;
  BUSINESS_DIVISION?: Maybe<Scalars['String']['output']>;
  CITY?: Maybe<Scalars['String']['output']>;
  CONSIGNEE?: Maybe<Scalars['String']['output']>;
  CUSTOMER?: Maybe<Scalars['String']['output']>;
  DIMS?: Maybe<Scalars['String']['output']>;
  DUE_DATE?: Maybe<Scalars['DateTime']['output']>;
  INBOUND_CITY?: Maybe<Scalars['String']['output']>;
  INBOUND_METHOD?: Maybe<InboundMethod>;
  INBOUND_NAME?: Maybe<Scalars['String']['output']>;
  INBOUND_TERMINAL?: Maybe<Scalars['String']['output']>;
  INBOUND_ZIP?: Maybe<Scalars['String']['output']>;
  MAWB?: Maybe<Scalars['String']['output']>;
  ORDER_NAME?: Maybe<Scalars['String']['output']>;
  ORDER_NOTES?: Maybe<Scalars['String']['output']>;
  ORDER_NUMBER: Scalars['String']['output'];
  ORDER_STATUS?: Maybe<Scalars['String']['output']>;
  OUTBOUND_CITY?: Maybe<Scalars['String']['output']>;
  OUTBOUND_METHOD?: Maybe<OutboundMethod>;
  OUTBOUND_NAME?: Maybe<Scalars['String']['output']>;
  OUTBOUND_TERMINAL?: Maybe<Scalars['String']['output']>;
  OUTBOUND_ZIP?: Maybe<Scalars['String']['output']>;
  PIECE_COUNT?: Maybe<Scalars['Float']['output']>;
  REF_NUMBER?: Maybe<Array<Scalars['String']['output']>>;
  ROUTE_NAME?: Maybe<Scalars['String']['output']>;
  SERVICE_DATE?: Maybe<Scalars['DateTime']['output']>;
  SERVICE_LEVEL?: Maybe<Scalars['String']['output']>;
  SERVICE_TIME?: Maybe<Scalars['DateTime']['output']>;
  SPECIAL?: Maybe<Scalars['Boolean']['output']>;
  SPECIAL_INSTRUCTIONS?: Maybe<Scalars['String']['output']>;
  STOP_TYPE?: Maybe<Scalars['String']['output']>;
  TAGS?: Maybe<Array<Scalars['String']['output']>>;
  TERMINAL?: Maybe<Scalars['String']['output']>;
  TOTAL_CHARGES?: Maybe<Scalars['Float']['output']>;
  VEHICLE_TYPE_NAME?: Maybe<Scalars['String']['output']>;
  WEIGHT?: Maybe<Scalars['Float']['output']>;
  ZIP_CODE?: Maybe<Scalars['String']['output']>;
  orderNumberCellColor?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  stopDetails?: Maybe<StopDetailsOutput>;
  uuid: Scalars['String']['output'];
};

export type GroupByStopRowUnion = GroupsOutput | StopOutput;

export enum GroupByStopsEnum {
  City = 'CITY',
  RouteName = 'ROUTE_NAME',
  ServiceLevel = 'SERVICE_LEVEL'
}

/** Filters with fields for the groupByStops query. Use either "and" or "or" or "filters", but not all simultaneously. Using all in the same query may lead to unexpected results. */
export type GroupByStopsFilters = {
  and?: InputMaybe<Array<GroupByStopsFilters>>;
  fields?: InputMaybe<GroupByStopsFiltersFields>;
  or?: InputMaybe<Array<GroupByStopsFilters>>;
};

/** Filter fields for the groupByStops query */
export type GroupByStopsFiltersFields = {
  /** The stop's full formatted address. */
  ADDRESS?: InputMaybe<StringFilterV2>;
  ADDRESS_TYPE?: InputMaybe<AddressTypeFilter>;
  /** The stop's appointment date, in the company's timezone. */
  APPOINTMENT_DATE?: InputMaybe<DateFilterV2>;
  APPOINTMENT_OPTIONS_PROPOSED?: InputMaybe<BooleanFilterV2>;
  APPOINTMENT_REQUIRED?: InputMaybe<BooleanFilterV2>;
  APPOINTMENT_SCHEDULED?: InputMaybe<BooleanFilterV2>;
  /** The order's business division name. */
  BUSINESS_DIVISION?: InputMaybe<StringFilterV2>;
  CAN_DISPATCH?: InputMaybe<BooleanFilterV2>;
  CITY?: InputMaybe<StringFilterV2>;
  /** The order's billing party (customer) organization uuid. */
  CUSTOMER?: InputMaybe<UuidFilterV2>;
  /** The stop's deadline date, in the company's timezone. */
  DUE_DATE?: InputMaybe<DateFilterV2>;
  HAS_APPOINTMENT?: InputMaybe<BooleanFilterV2>;
  /** The order's MAWB. */
  MAWB?: InputMaybe<StringFilterV2>;
  ON_HAND?: InputMaybe<BooleanFilterV2>;
  /** The order's HAWB (shipper bill of lading number). */
  ORDER_NAME?: InputMaybe<StringFilterV2>;
  /** The order's name. */
  ORDER_NUMBER?: InputMaybe<StringFilterV2>;
  /** The order's status. */
  ORDER_STATUS?: InputMaybe<OrderStatusFilter>;
  /** The order's piece count. */
  PIECE_COUNT?: InputMaybe<IntegerFilterV2>;
  REFUSED?: InputMaybe<BooleanFilterV2>;
  /** The stop address's route name uuid. */
  ROUTE_NAME?: InputMaybe<UuidFilterV2>;
  /** The order's service level uuid. */
  SERVICE_LEVEL?: InputMaybe<UuidFilterV2>;
  SPECIAL?: InputMaybe<BooleanFilterV2>;
  /** The stop address's state. */
  STATE?: InputMaybe<StringFilterV2>;
  STOP_TYPE?: InputMaybe<StopTypeFilter>;
  /** The order's tag uuids. */
  TAGS?: InputMaybe<UuidListFilter>;
  /** The stop's terminal uuid. */
  TERMINAL?: InputMaybe<UuidFilterV2>;
  /** The order's total package weight. */
  WEIGHT?: InputMaybe<FloatFilterV2>;
  /** The stop address's zip code. */
  ZIP_CODE?: InputMaybe<StringFilterV2>;
};

/** Filters for the groupByStops query. Use either "and" or "or" filters, but not both simultaneously. Using both in the same query may lead to unexpected results. */
export type GroupByStopsFiltersInput = {
  and?: InputMaybe<Array<GroupByStopsFilters>>;
  or?: InputMaybe<Array<GroupByStopsFilters>>;
};

/** Input for grouping stops */
export type GroupByStopsInput = {
  filters?: InputMaybe<GroupByStopsFiltersInput>;
  groupByFields: Array<GroupByStopsEnum>;
  groupByValues: Array<InputMaybe<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Top-level service date filter */
  serviceDate?: InputMaybe<DateFilterV2>;
  sort?: InputMaybe<Array<GroupByStopsSort>>;
  /** If provided, filter stops by terminal uuid. If null, return stops with NO terminal. If undefined, do not apply a terminal filter at all. */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type GroupByStopsOutput = {
  __typename?: 'GroupByStopsOutput';
  count?: Maybe<Scalars['Int']['output']>;
  rows: GroupByStopRowUnion;
};

export type GroupByStopsSort = {
  direction: GroupByStopsSortDirection;
  field: DispatchTableField;
};

export enum GroupByStopsSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Filters specific to the line-haul dispatch board */
export type GroupOrdersBoardFiltersInput = {
  /** Restricts rows to orders whose Status column reads as one of these. Empty or omitted applies no constraint. A refused order matches none of them -- its Status column reads 'Refused'; use baseFilters.isRefusedFilter for that. */
  detailedStatuses?: InputMaybe<Array<OrderDetailedStatus>>;
  /** Restricts rows to these leg plan states (the board's Routing status column). Empty or omitted applies no constraint. */
  legStates?: InputMaybe<Array<DispatchLegState>>;
  /** Restricts rows to orders holding at least one countable piece in these statuses. Empty or omitted applies no constraint. */
  pieceStatuses?: InputMaybe<Array<PieceStatus>>;
};

export enum GroupOrdersField {
  Lane = 'Lane',
  None = 'None'
}

export enum GroupOrdersForPaymentsBy {
  Hawb = 'HAWB',
  Invoice = 'INVOICE',
  Order = 'ORDER'
}

/** Input for the groupOrders query */
export type GroupOrdersInput = {
  /** Keyset pagination cursor for leaf rows: the segmentUuid of the last row of the previous page. Two forms are accepted, matching the two kinds of leaf row: a segment uuid, which resumes the committed half after that segment; or a proposed row id (`proposed:<orderUuid>:<START>><END>`), which means the lane's proposed half is behind us and the committed half starts at the beginning of the lane. Omit for the first page. Ignored when fetching group keys. */
  afterSegmentUuid?: InputMaybe<Scalars['String']['input']>;
  /** Same filter contract as the standard orders query. Saved views from the linehaul page apply as-is. */
  baseFilters: FindOrdersBaseInput;
  /** The dispatch board's own filters (leg plan state, piece status). ANDed with baseFilters and applied to the lane aggregates as well as to the rows, so a lane's count agrees with what drilling into it returns. Dispatch-board only. */
  boardFilters?: InputMaybe<GroupOrdersBoardFiltersInput>;
  /** The columns to group by. Exactly one entry is supported today. Pass [NONE] for an ungrouped list of leaf rows across every lane. */
  groupByFields: Array<GroupOrdersField>;
  /** The group-key path at the current tree level. Empty array requests the distinct group keys (root level); a single string drills into that group and returns its leaf segment rows. Must be empty when groupByFields is [NONE]. */
  groupByValues: Array<InputMaybe<Scalars['String']['input']>>;
  /** When true, each leaf row carries pieceStatusLocations: the order's countable pieces grouped by terminal and piece status, for the board's per-leg piece-status column. Rides on the same per-terminal piece query as includePiecesAwayFromRunOrigin rather than costing a second one, so it is free when either is already on. A request argument rather than an orderTableFields entry because the selection is board-local (localStorage) and is never persisted in a user preference or a saved view. */
  includePieceStatusLocations?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, each leaf row carries piecesAwayFromRunOrigin: how much of the freight on that order is not at the origin terminal of the run carrying this lane leg. Costs the per-terminal piece query, so it is opt-in and off by default. A request argument rather than an orderTableFields entry because the selection is board-local (localStorage) and is never persisted in a user preference or a saved view. */
  includePiecesAwayFromRunOrigin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional lane-scoped (segment-level) filter. Restricts which lanes appear and recomputes per-lane counts; ANDs with baseFilters. Dispatch-board only. */
  laneFilter?: InputMaybe<GroupOrdersLaneFilterInput>;
  /** How to order a lane's leaf rows. Omit for the default order (segment id ascending), which is what the keyset cursor pages by. Supplying it switches the leaf read to offset paging -- see the offset field. Only columns whose displayed value is reproducible in SQL can be sorted; see DispatchLeafSortField. Ignored when fetching group keys. */
  leafSort?: InputMaybe<GroupOrdersLeafSortInput>;
  /** Pagination limit for leaf rows. Ignored when fetching group keys. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Count of leaf rows already loaded before this page. With no leafSort it does NOT skip rows server-side (keyset paging via afterSegmentUuid does that) and is used only to compute the page-based totalCount. WITH a leafSort it becomes the paging mechanism (a keyset on the segment id cannot resume another ordering), and must then count only the COMMITTED rows already loaded for the lane -- the proposed block leads the first page and is not part of the scan it offsets into. Ignored when fetching group keys. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Order table fields to compute on each formatted leaf order. Mirrors the existing getOrderTableFieldValues input. */
  orderTableFields: Array<OrderTableField>;
};

/** Lane-scoped (segment-level) filter for the dispatch board. */
export type GroupOrdersLaneFilterInput = {
  /** Terminal uuids matched at EITHER end: keep lanes whose origin OR destination terminal is in this set (terminal-centric view). */
  anyEndTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Lane END terminal uuids: keep lanes whose destination terminal is in this set. */
  destinationTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exact lane keys to keep, each in the `START>END` terminal-code form (e.g. `DFW>LFT`). */
  laneKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Lane START terminal uuids: keep lanes whose origin terminal is in this set. */
  originTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GroupOrdersLeafSortInput = {
  direction: SortDirection;
  field: DispatchLeafSortField;
};

export type GroupOrdersOutput = {
  __typename?: 'GroupOrdersOutput';
  rows: GroupOrdersRowsUnion;
};

export type GroupOrdersRowsUnion = OrderLaneGroupsOutput | OrderSegmentLeavesOutput;

/** Used to track grouped counts (e.g. number of orders per invoice) */
export type GroupedCounts = {
  __typename?: 'GroupedCounts';
  /** Count of items in group */
  count: Scalars['Int']['output'];
  /** Unique group identifier / uuid */
  groupUuid: Scalars['String']['output'];
};

export type GroupsOutput = {
  __typename?: 'GroupsOutput';
  groupValues: Array<Maybe<Scalars['String']['output']>>;
};

export type HandleMultiple210OutboundInput = {
  invoiceUuids: Array<Scalars['String']['input']>;
};

export enum HazmatClass {
  Class1 = 'Class1',
  Class1_1 = 'Class1_1',
  Class1_2 = 'Class1_2',
  Class1_3 = 'Class1_3',
  Class1_4 = 'Class1_4',
  Class1_5 = 'Class1_5',
  Class1_6 = 'Class1_6',
  Class2 = 'Class2',
  Class2_1 = 'Class2_1',
  Class2_2 = 'Class2_2',
  Class2_3 = 'Class2_3',
  Class3 = 'Class3',
  Class4 = 'Class4',
  Class4_1 = 'Class4_1',
  Class4_2 = 'Class4_2',
  Class4_3 = 'Class4_3',
  Class5 = 'Class5',
  Class5_1 = 'Class5_1',
  Class5_2 = 'Class5_2',
  Class6 = 'Class6',
  Class6_1 = 'Class6_1',
  Class6_2 = 'Class6_2',
  Class7 = 'Class7',
  Class8 = 'Class8',
  Class9 = 'Class9'
}

export enum HeaderFileMappingType {
  CustomerName = 'CUSTOMER_NAME',
  InvoiceDate = 'INVOICE_DATE',
  InvoiceDueDate = 'INVOICE_DUE_DATE',
  InvoiceItemAmount = 'INVOICE_ITEM_AMOUNT',
  InvoiceItemName = 'INVOICE_ITEM_NAME',
  InvoiceItemQuantity = 'INVOICE_ITEM_QUANTITY',
  InvoiceItemRate = 'INVOICE_ITEM_RATE',
  InvoiceItemServiceDate = 'INVOICE_ITEM_SERVICE_DATE',
  InvoiceName = 'INVOICE_NAME',
  InvoiceTerms = 'INVOICE_TERMS',
  OneColumn = 'ONE_COLUMN',
  OrderReferenceNumber = 'ORDER_REFERENCE_NUMBER'
}

export type HoldReasonCreateInput = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type HoldReasonEntity = {
  __typename?: 'HoldReasonEntity';
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type HoldReasonUpdateInput = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** Valid field names in the import contact schema */
export enum ImportContactField {
  AccountsReceivableId = 'AccountsReceivableId',
  Action = 'Action',
  Active = 'Active',
  BillingContactEmail = 'BillingContactEmail',
  BillingContactPhone = 'BillingContactPhone',
  BillingCycleDuration = 'BillingCycleDuration',
  BillingFax = 'BillingFax',
  BusinessDivision = 'BusinessDivision',
  ContactIdentifier = 'ContactIdentifier',
  ContactReferenceNumber = 'ContactReferenceNumber',
  Country = 'Country',
  CreditHoldLimitInCents = 'CreditHoldLimitInCents',
  DefaultAddressCity = 'DefaultAddressCity',
  DefaultAddressDriverInstructions = 'DefaultAddressDriverInstructions',
  DefaultAddressLine1 = 'DefaultAddressLine1',
  DefaultAddressLine2 = 'DefaultAddressLine2',
  DefaultAddressState = 'DefaultAddressState',
  DefaultAddressZip = 'DefaultAddressZip',
  DefaultContactPersonName = 'DefaultContactPersonName',
  DefaultInvoiceTerms = 'DefaultInvoiceTerms',
  DefaultInvoiceTransmissionMethod = 'DefaultInvoiceTransmissionMethod',
  DefaultInvoiceType = 'DefaultInvoiceType',
  DefaultLineHaulTariffChain = 'DefaultLineHaulTariffChain',
  DefaultOrdinaryTariffChain = 'DefaultOrdinaryTariffChain',
  DefaultPointToPointTariffChain = 'DefaultPointToPointTariffChain',
  DefaultService = 'DefaultService',
  DefaultTransferTariffChain = 'DefaultTransferTariffChain',
  DimFactor = 'DimFactor',
  DisplayName = 'DisplayName',
  DocumentsInInvoice = 'DocumentsInInvoice',
  EnableCreditHold = 'EnableCreditHold',
  Inactive = 'Inactive',
  InvoiceTimePeriodSplit = 'InvoiceTimePeriodSplit',
  MasterAccount = 'MasterAccount',
  MaxDaysOutstanding = 'MaxDaysOutstanding',
  NumberOfOrdersPerInvoice = 'NumberOfOrdersPerInvoice',
  Prepaid = 'Prepaid',
  QuickbooksFileMappingCustomerName = 'QuickbooksFileMappingCustomerName',
  RequiredDocuments = 'RequiredDocuments',
  ServiceContactEmail = 'ServiceContactEmail',
  ServiceContactName = 'ServiceContactName',
  ServiceContactPhone = 'ServiceContactPhone',
  ServiceFax = 'ServiceFax',
  ShortCode = 'ShortCode'
}

export type ImportCrownAccessorialInput = {
  accessorialUrl: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  fuelSurchargePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  isZoneBased?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialType?: InputMaybe<SpecialAccessorialType>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use tariffZoneGroupId instead */
  useContactTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportCrownAccessorialOutput = {
  __typename?: 'ImportCrownAccessorialOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportCrownDriversInput = {
  driversUrl: Scalars['String']['input'];
};

export type ImportCrownDriversOutput = {
  __typename?: 'ImportCrownDriversOutput';
  error?: Maybe<Scalars['String']['output']>;
  failedDriverPhoneNumbers: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  successfulDriverPhoneNumbers: Array<Scalars['String']['output']>;
};

export type ImportCrownInvoicesInput = {
  /** The Pallet admin email for this company */
  adminEmail: Scalars['String']['input'];
  /** A publicly accessible URL of the charges breakdown report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  chargeBreakdownUrl: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the open invoices report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  openInvoicesUrl: Scalars['String']['input'];
  skipExisting?: Scalars['Boolean']['input'];
  skipImportCharges?: Scalars['Boolean']['input'];
};

export type ImportCrownInvoicesOutput = {
  __typename?: 'ImportCrownInvoicesOutput';
  chargesFailedCrownIDs: Array<Scalars['String']['output']>;
  chargesImportedCrownIDs: Array<Scalars['String']['output']>;
  chargesSkippedCrownIDs: Array<Scalars['String']['output']>;
  invoicesFailedJournalNumbers: Array<Scalars['String']['output']>;
  invoicesImportedJournalNumbers: Array<Scalars['String']['output']>;
  invoicesSkippedJournalNumbers: Array<Scalars['String']['output']>;
  numberOfCharges: Scalars['Int']['output'];
  numberOfInvoices: Scalars['Int']['output'];
  numberOfShipments: Scalars['Int']['output'];
  shipmentsFailedCrownIDs: Array<Scalars['String']['output']>;
  shipmentsImportedCrownIDs: Array<Scalars['String']['output']>;
  shipmentsSkippedCrownIDs: Array<Scalars['String']['output']>;
};

export type ImportCrownLanesInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the lanes downloaded from Crown */
  lanesUrl: Scalars['String']['input'];
};

export type ImportCrownLanesOutput = {
  __typename?: 'ImportCrownLanesOutput';
  success: Scalars['Boolean']['output'];
};

export type ImportCrownOrdersInput = {
  /** The UUID of the company whose orders are being imported. Must be the session company. */
  companyUuid: Scalars['String']['input'];
  /** Automatically finalize all imported orders */
  finalizeOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not apply any charges to imported orders */
  noCharges?: InputMaybe<Scalars['Boolean']['input']>;
  /** A publicly accessible URL of the orders for this company */
  ordersUrl: Scalars['String']['input'];
  /** Only include the provided ShipIDs */
  shipIDFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  skipExisting?: Scalars['Boolean']['input'];
  /**
   * Ignored. The imported orders are attributed to the session user.
   * @deprecated Ignored; the imported orders are attributed to the session user.
   */
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ImportCrownOrdersOutput = {
  __typename?: 'ImportCrownOrdersOutput';
  failedCrownIDs: Array<Scalars['String']['output']>;
  importedCrownIDs: Array<Scalars['String']['output']>;
  numberOfOrders: Scalars['Int']['output'];
  skippedCrownIDs: Array<Scalars['String']['output']>;
};

export type ImportCrownPaymentsInput = {
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the payment application report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  paymentApplicationUrl: Scalars['String']['input'];
  /** A publicly accessible URL of the unapplied payments report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  unappliedPaymentsUrl: Scalars['String']['input'];
};

export type ImportCrownPaymentsOutput = {
  __typename?: 'ImportCrownPaymentsOutput';
  failedPaymentIDs: Array<Scalars['String']['output']>;
  importedPaymentIDs: Array<Scalars['String']['output']>;
  numberOfPayments: Scalars['Int']['output'];
};

export type ImportCrownTariffInput = {
  autoSelectAllServices: Scalars['Boolean']['input'];
  autoSelectAllVehicleTypes: Scalars['Boolean']['input'];
  /** @deprecated Ignored unless it matches the session company; the session is authoritative. */
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use contactUuids instead */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When true, runs the import inside a transaction and rolls back, returning a preview of what would be created instead of committing. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rateType: RateType;
  /** Used to import a (global or contact) tariff for specific service levels. */
  serviceUuids: Array<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tariffGroupType: TariffGroupType;
  tariffType: TariffType;
  tariffUrl: Scalars['String']['input'];
  /** Zone group to use for zone-based tariffs. */
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneType: TariffZoneType;
  useActualWeight: Scalars['Boolean']['input'];
  /** Used to import a tariff for specific vehicle types. Only used when tariff chains are enabled for the given company. */
  vehicleTypeUuids: Array<Scalars['String']['input']>;
};

export type ImportCrownTariffOutput = {
  __typename?: 'ImportCrownTariffOutput';
  /** True when the result came from a dry-run (rolled back). */
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** Number of tariff ranges the import created (or would create). */
  rangesToCreate?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  /** Number of tariffs the import created (or would create). */
  tariffsToCreate?: Maybe<Scalars['Int']['output']>;
};

export type ImportCrownUsersInput = {
  usersUrl: Scalars['String']['input'];
};

export type ImportCrownUsersOutput = {
  __typename?: 'ImportCrownUsersOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportRecoveryTerminalInput = {
  companyUuid: Scalars['String']['input'];
  recoveryTerminalsUrl: Scalars['String']['input'];
};

export type ImportRecoveryTerminalOutput = {
  __typename?: 'ImportRecoveryTerminalOutput';
  success: Scalars['Boolean']['output'];
};

export type ImportStorageOrdersFromCsvInput = {
  contactUuid: Scalars['String']['input'];
  /**
   * CSV text of the import
   * @deprecated Deprecated. Pass the S3 URL instead.
   */
  csvText?: InputMaybe<Scalars['String']['input']>;
  /** S3 URL of the import */
  fileUrl: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ImportStorageOrdersFromCsvOutput = {
  __typename?: 'ImportStorageOrdersFromCsvOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  storageOrders: Array<StorageOrderEntity>;
};

export type ImportTerminalServiceAreasInput = {
  companyUuid: Scalars['String']['input'];
  csvDocumentUrl: Scalars['String']['input'];
  deleteExisting: Scalars['Boolean']['input'];
};

export type ImportTestSnapshotInput = {
  testSnapshot: TestSnapshotInput;
};

export type ImportWarehouseLocationsFromCsvInput = {
  csvText: Scalars['String']['input'];
};

export type ImportedOrderTypeMappingCreateInput = {
  defaultToInbound: Scalars['Boolean']['input'];
  defaultToOutbound: Scalars['Boolean']['input'];
  inboundStopType: StopType;
  lineHaul: Scalars['Boolean']['input'];
  moveType?: InputMaybe<Scalars['String']['input']>;
  orderImportConfigurationUuid: Scalars['String']['input'];
  outboundStopType: StopType;
  serviceLevel?: InputMaybe<Scalars['String']['input']>;
};

export type ImportedOrderTypeMappingEntity = {
  __typename?: 'ImportedOrderTypeMappingEntity';
  defaultToInbound: Scalars['Boolean']['output'];
  defaultToOutbound: Scalars['Boolean']['output'];
  inboundStopType: StopType;
  lineHaul: Scalars['Boolean']['output'];
  moveType?: Maybe<Scalars['String']['output']>;
  outboundStopType: StopType;
  serviceLevel?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ImportedOrderTypeMappingUpdateInput = {
  defaultToInbound: Scalars['Boolean']['input'];
  defaultToOutbound: Scalars['Boolean']['input'];
  inboundStopType: StopType;
  lineHaul: Scalars['Boolean']['input'];
  moveType?: InputMaybe<Scalars['String']['input']>;
  orderImportConfigurationUuid?: InputMaybe<Scalars['String']['input']>;
  outboundStopType: StopType;
  serviceLevel?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type InAppNotificationConnection = {
  __typename?: 'InAppNotificationConnection';
  edges: Array<InAppNotificationEdge>;
  pageInfo: PageInfo;
};

export type InAppNotificationEdge = {
  __typename?: 'InAppNotificationEdge';
  cursor: Scalars['String']['output'];
  node: InAppNotificationEntity;
};

export type InAppNotificationEntity = {
  __typename?: 'InAppNotificationEntity';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  eventType: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  subjectType?: Maybe<NotificationSubjectType>;
  title: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type InAppNotificationPreferenceEntity = {
  __typename?: 'InAppNotificationPreferenceEntity';
  enabled: Scalars['Boolean']['output'];
  eventType: NotificationEventType;
  /** Required for every user: always enabled and cannot be changed. */
  mandatory: Scalars['Boolean']['output'];
};

export type InAppNotificationPreferenceInput = {
  enabled: Scalars['Boolean']['input'];
  eventType: NotificationEventType;
};

export type InBondSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundAddressNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundAddressSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundCityNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundCompletedDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** SCALAR stages one control; GROUP moves as one unit, because adopting half of an address or a package list produces something the rest of the system cannot use. */
export enum InboundConflictKind {
  Group = 'GROUP',
  Scalar = 'SCALAR'
}

export type InboundDriverNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum InboundFieldSurface {
  Addresses = 'ADDRESSES',
  Charges = 'CHARGES',
  Header = 'HEADER',
  Packages = 'PACKAGES'
}

/** How the stored text turns back into a value a control can hold. DATE means the text is ISO-8601, JSON a structure written as one unit, TEXT a value no control will ever take. */
export enum InboundFieldValueType {
  Date = 'DATE',
  Json = 'JSON',
  Number = 'NUMBER',
  String = 'STRING',
  Text = 'TEXT'
}

export type InboundMessageConflictEntity = {
  __typename?: 'InboundMessageConflictEntity';
  /** True only where a control on the order form is wrapped in StagedField. The form demotes this further when the control is disabled, locked or not rendered. */
  adoptable: Scalars['Boolean']['output'];
  /** react-hook-form path on the order form. May contain the `%STOP%` token, which the form resolves against the stop that actually renders the control. */
  fieldPath: Scalars['String']['output'];
  /** The value the message carried, as text. */
  incomingValue: Scalars['String']['output'];
  /** What the order held when the message landed. Null when it held nothing. */
  keptValue?: Maybe<Scalars['String']['output']>;
  /** Stable id, unique within its message, and the key a decision is recorded against. The field path on its own for order- and stop-level fields; the path plus the package concerned when one message disagrees about several packages at once. */
  key: Scalars['String']['output'];
  kind: InboundConflictKind;
  label: Scalars['String']['output'];
  /** Why the value cannot be applied. Set whenever adoptable is false. */
  note?: Maybe<Scalars['String']['output']>;
  /** What the operator decided, once they have reviewed and saved. Null while the difference is still outstanding. */
  resolvedChoice?: Maybe<InboundReviewChoice>;
  /** Which part of the order form shows this field. Drives the per-tab markers, so the count on a tab and the count on the chip come from one list rather than two. */
  surface: InboundFieldSurface;
  /** The uuid of the package this difference is about, for the `packages.%PKG%.*` paths. The order form resolves the token to that package's current index — an index cannot be sent, because the list is reordered by every add and delete. Null for order- and stop-level fields, and for a package the order does not hold. */
  targetUuid?: Maybe<Scalars['String']['output']>;
  valueType: InboundFieldValueType;
};

export type InboundMessageEntity = {
  __typename?: 'InboundMessageEntity';
  /** When the message was merged. Null unless state is APPLIED. */
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  conflicts: Array<InboundMessageConflictEntity>;
  receivedAt: Scalars['DateTime']['output'];
  senderName?: Maybe<Scalars['String']['output']>;
  source: OrderSource;
  state: InboundMessageState;
  /** Identifies the message. This is the uuid of the order the merge absorbed, which is unique and outlives the row it named. */
  uuid: Scalars['String']['output'];
};

export enum InboundMessageState {
  Applied = 'APPLIED',
  Awaiting = 'AWAITING',
  Unmatched = 'UNMATCHED'
}

export type InboundMessagesForOrderInput = {
  /** The order whose inbound messages are being read. */
  orderUuid: Scalars['String']['input'];
};

export type InboundMessagesForOrderOutput = {
  __typename?: 'InboundMessagesForOrderOutput';
  messages: Array<InboundMessageEntity>;
};

export enum InboundMethod {
  InboundDelivery = 'INBOUND_DELIVERY',
  Other = 'OTHER',
  Recovery = 'RECOVERY'
}

/** What an operator chose for one field: ADOPTED took the message's value, KEPT left the order's own in place. */
export enum InboundReviewChoice {
  Adopted = 'ADOPTED',
  Kept = 'KEPT'
}

export type InboundReviewDecisionInput = {
  choice: InboundReviewChoice;
  /** The `key` of the difference this decision is about, as returned by `inboundMessagesForOrder`. Paired with `messageUuid` to address exactly one persisted difference. Omitted by clients that only want the audit-log entry. */
  differenceKey?: InputMaybe<Scalars['String']['input']>;
  /** The field as the operator saw it named on the form. */
  fieldLabel: Scalars['String']['input'];
  /** The value the inbound message carried, as it was shown. */
  incomingValue?: InputMaybe<Scalars['String']['input']>;
  /** The message this decision is about, as returned by `inboundMessagesForOrder`. Required to mark the persisted difference resolved; omitted by clients that only want the audit-log entry. */
  messageUuid?: InputMaybe<Scalars['String']['input']>;
  /** The value the order held before the review. */
  previousValue?: InputMaybe<Scalars['String']['input']>;
};

export type InboundRouteDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundRouteNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundServiceDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type InboundZipcodeSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type IncomeAnalysisReportArgs = {
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  includeContactsWithNoShipments: Scalars['Boolean']['input'];
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceStatuses: Array<InvoiceStatus>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type IncomeAnalysisReportOutput = {
  __typename?: 'IncomeAnalysisReportOutput';
  customers: Array<CustomerReportBucketEntity>;
  terminals: Array<IncomeAnalysisTerminalBucketEntity>;
};

export type IncomeAnalysisTerminalBucketEntity = {
  __typename?: 'IncomeAnalysisTerminalBucketEntity';
  kind: IncomeAnalysisTerminalBucketKind;
  label: Scalars['String']['output'];
  numberOfShipments: Scalars['Float']['output'];
  terminalUuid?: Maybe<Scalars['String']['output']>;
  totalRevenue: Scalars['Float']['output'];
};

export enum IncomeAnalysisTerminalBucketKind {
  LineHaul = 'LINE_HAUL',
  OrderCharges = 'ORDER_CHARGES',
  StopWithoutTerminal = 'STOP_WITHOUT_TERMINAL',
  Terminal = 'TERMINAL'
}

export type IncomingPeerAccessorialMappingEntity = {
  __typename?: 'IncomingPeerAccessorialMappingEntity';
  executorAccessorialName: Scalars['String']['output'];
  originatorAccessorialUuid?: Maybe<Scalars['String']['output']>;
  suggestedAccessorialUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type IncomingPeerServiceMappingEntity = {
  __typename?: 'IncomingPeerServiceMappingEntity';
  executorServiceUuid?: Maybe<Scalars['String']['output']>;
  originatorServiceName: Scalars['String']['output'];
  suggestedServiceUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type IndependentCustomCostCreateInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents: Scalars['Decimal']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type IndependentCustomCostUpsertInput = {
  accessorialTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The fuel surcharge rate expressed as a percentage out of 100 */
  fuelSurchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type IndependentFreightCostCreateInput = {
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Percent out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  independentFuelCostCreateInput?: InputMaybe<IndependentFuelCostCreateInput>;
  /** Is null when billing method is per mile or flat rate */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents: Scalars['Decimal']['input'];
};

export type IndependentFreightCostUpsertInput = {
  billingMethod: FreightBillingMethod;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Percent out of 100 */
  discountRate?: InputMaybe<Scalars['Percent']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  independentFuelCostUpsertInput?: InputMaybe<IndependentFuelCostUpsertInput>;
  /** Is null when billing method is per mile or flat rate */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
};

export type IndependentFuelCostCreateInput = {
  billingMethod: FuelBillingMethod;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  /** Percent in the range [0, 100] */
  surchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  totalAmountUsdCents: Scalars['Decimal']['input'];
};

export type IndependentFuelCostUpsertInput = {
  billingMethod: FuelBillingMethod;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  /** Percent in the range [0, 100] */
  surchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
};

export type IndependentSettlementBillLineItemCreateInput = {
  /** @deprecated No longer used. Agent settlement is implemented via drivers. */
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  independentCustomCostCreateInputs?: InputMaybe<Array<IndependentCustomCostCreateInput>>;
  independentFreightCostCreateInput?: InputMaybe<IndependentFreightCostCreateInput>;
  settlementMode: SettlementMode;
  totalAmountUsdCents: Scalars['Decimal']['input'];
};

export type IndependentSettlementBillLineItemUpsertInput = {
  /** @deprecated No longer used. Agent settlement is implemented via drivers. */
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  id: Scalars['String']['input'];
  independentCustomCostUpsertInputs?: InputMaybe<Array<IndependentCustomCostUpsertInput>>;
  independentFreightCostUpsertInput?: InputMaybe<IndependentFreightCostUpsertInput>;
  settlementMode: SettlementMode;
  /** The total amount of the settlement bill line item in USD. If undefined for an existing settlement bill line item, then the existing total amount will be kept. If undefined for a new settlement bill line item, then the total amount will be 0. */
  totalAmountUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
};

export type IngestedEmailDetailsEntity = {
  __typename?: 'IngestedEmailDetailsEntity';
  attachmentUuid?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  bodyPreview?: Maybe<Scalars['String']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  outlookIntegrationTerminal?: Maybe<TerminalEntity>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type IngestedOutlookEmailAttachmentConnection = {
  __typename?: 'IngestedOutlookEmailAttachmentConnection';
  edges: Array<IngestedOutlookEmailAttachmentEdge>;
  pageInfo: PageInfo;
};

export type IngestedOutlookEmailAttachmentEdge = {
  __typename?: 'IngestedOutlookEmailAttachmentEdge';
  cursor: Scalars['String']['output'];
  node: IngestedOutlookEmailAttachmentEntity;
};

export type IngestedOutlookEmailAttachmentEntity = {
  __typename?: 'IngestedOutlookEmailAttachmentEntity';
  attachmentFilename?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  ingestedEmailDetails: IngestedEmailDetailsEntity;
  outlookAttachmentId: Scalars['String']['output'];
  processingStatus: IngestedOutlookEmailAttachmentProcessingStatus;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  scannedOrder?: Maybe<ScannedOrderEntity>;
  uuid: Scalars['String']['output'];
};

export enum IngestedOutlookEmailAttachmentProcessingStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type IngestedOutlookEmailConnection = {
  __typename?: 'IngestedOutlookEmailConnection';
  edges: Array<IngestedOutlookEmailEdge>;
  pageInfo: PageInfo;
};

export type IngestedOutlookEmailEdge = {
  __typename?: 'IngestedOutlookEmailEdge';
  cursor: Scalars['String']['output'];
  node: IngestedOutlookEmailEntity;
};

export type IngestedOutlookEmailEntity = {
  __typename?: 'IngestedOutlookEmailEntity';
  attachments: Array<IngestedOutlookEmailAttachmentEntity>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  effectiveSenderAddress: Scalars['String']['output'];
  fromAddress?: Maybe<Scalars['String']['output']>;
  outlookMessageId: Scalars['String']['output'];
  outlookReceivedDateTime: Scalars['DateTime']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type IngestionTestRunAppliedResultEntity = {
  __typename?: 'IngestionTestRunAppliedResultEntity';
  applyPlan?: Maybe<Scalars['JSON']['output']>;
  duplicateOfOrderUuid?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  pageEnd: Scalars['Int']['output'];
  pageStart: Scalars['Int']['output'];
  resultUuid: Scalars['String']['output'];
  status: ScannedOrderResultStatus;
};

export type IngestionTestRunEntity = {
  __typename?: 'IngestionTestRunEntity';
  actorEmail: Scalars['String']['output'];
  appliedResults: Array<IngestionTestRunAppliedResultEntity>;
  applyPlan?: Maybe<Scalars['JSON']['output']>;
  companyUuid: Scalars['String']['output'];
  correlationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emailContext?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  exemplarMarker?: Maybe<Scalars['JSON']['output']>;
  extractedFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  mode: IngestionTestRunMode;
  state: IngestionTestRunState;
  updatedAt: Scalars['DateTime']['output'];
  usage?: Maybe<Scalars['JSON']['output']>;
};

/** The e2e test-run completion path: PREVIEW_E2E (side-effect-free, no order) or FULL_APPLY (authoritative apply, creates a real order). */
export enum IngestionTestRunMode {
  FullApply = 'FULL_APPLY',
  PreviewE2E = 'PREVIEW_E2E'
}

/** The e2e test-run lifecycle state, from UPLOADED through DISPATCHED/EXTRACTING to a terminal COMPLETED/FAILED (and CLEANED once purged). */
export enum IngestionTestRunState {
  Cleaned = 'CLEANED',
  Completed = 'COMPLETED',
  Dispatched = 'DISPATCHED',
  Extracting = 'EXTRACTING',
  Failed = 'FAILED',
  Uploaded = 'UPLOADED'
}

export type IngestionTestUploadEntity = {
  __typename?: 'IngestionTestUploadEntity';
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type InitiateDelegatedOrderReviewInput = {
  delegationUuid: Scalars['String']['input'];
};

export type InitiateDelegatedOrderReviewOutput = {
  __typename?: 'InitiateDelegatedOrderReviewOutput';
  draftOrderUuid: Scalars['String']['output'];
};

/** A filter object that is used to filter a integer field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type IntegerFilterV2 = {
  /** Filters for records where the relevant integer field is equal to the provided integer value */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is greater than the provided integer value */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is greater than or equal to the provided integer value */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is in the provided integer values */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters for records where the relevant integer field is less than the provided integer value */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is less than or equal to the provided integer value */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is not equal to the provided integer value */
  neq?: InputMaybe<Scalars['Int']['input']>;
  /** Filters for records where the relevant integer field is not in the provided integer values */
  nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** An error when forceOriginMismatch is true but the order does not have a single misrouted piece at the manifest start terminal. */
export type InvalidMisroutedOverrideError = {
  __typename?: 'InvalidMisroutedOverrideError';
  order: OrderEntity;
};

export type InventoryCountClosedOutput = {
  __typename?: 'InventoryCountClosedOutput';
  message: Scalars['String']['output'];
};

export type InventoryCountConfirmationInput = {
  /** Client-side ISO-8601 timestamp of when the operator actually scanned the piece. Used to preserve real scan time across offline replays. Outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  pieceUuid: Scalars['String']['input'];
  scannedBarcode?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryCountConnection = {
  __typename?: 'InventoryCountConnection';
  edges: Array<InventoryCountEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InventoryCountEdge = {
  __typename?: 'InventoryCountEdge';
  cursor: Scalars['String']['output'];
  node: InventoryCountEntity;
};

export type InventoryCountEntity = {
  __typename?: 'InventoryCountEntity';
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closedByUser?: Maybe<UserActorEntity>;
  closedByWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  confirmedCount: Scalars['Int']['output'];
  contact?: Maybe<ContactEntity>;
  departedCount: Scalars['Int']['output'];
  expectedCount: Scalars['Int']['output'];
  isClosed: Scalars['Boolean']['output'];
  noLocationOnly: Scalars['Boolean']['output'];
  overdueOnly: Scalars['Boolean']['output'];
  pendingCount: Scalars['Int']['output'];
  searchText?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  startedByUser?: Maybe<UserActorEntity>;
  startedByWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  statuses: Array<PieceStatus>;
  terminal?: Maybe<TerminalEntity>;
  unassociatedOnly: Scalars['Boolean']['output'];
  unexpectedCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  warehouse?: Maybe<WarehouseEntity>;
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type InventoryCountLineConnection = {
  __typename?: 'InventoryCountLineConnection';
  edges: Array<InventoryCountLineEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InventoryCountLineEdge = {
  __typename?: 'InventoryCountLineEdge';
  cursor: Scalars['String']['output'];
  node: InventoryCountLineEntity;
};

export type InventoryCountLineEntity = {
  __typename?: 'InventoryCountLineEntity';
  additionalReferenceNumbers: Array<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  orderHawb?: Maybe<Scalars['String']['output']>;
  orderName?: Maybe<Scalars['String']['output']>;
  pieceStatus?: Maybe<PieceStatus>;
  pieceStatusAtClose?: Maybe<PieceStatus>;
  pieceUuid?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  scannedAt?: Maybe<Scalars['DateTime']['output']>;
  scannedBarcode?: Maybe<Scalars['String']['output']>;
  scannedByUser?: Maybe<UserActorEntity>;
  scannedByWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  state: InventoryCountLineState;
  uuid: Scalars['String']['output'];
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
};

export enum InventoryCountLineState {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Unexpected = 'UNEXPECTED'
}

export type InventoryCountScopeTooLargeOutput = {
  __typename?: 'InventoryCountScopeTooLargeOutput';
  cap: Scalars['Int']['output'];
  pieceCount: Scalars['Int']['output'];
};

/** Deprecated, use ItemGroupEntity instead */
export type InventoryItemEntity = {
  __typename?: 'InventoryItemEntity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  item: ItemEntity;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  markedOsdAt?: Maybe<Scalars['DateTime']['output']>;
  pickedAt?: Maybe<Scalars['DateTime']['output']>;
  storageUnit?: Maybe<StorageUnitEntity>;
  unitOfMeasure: UnitOfMeasure;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type InventoryPrimaryUnitOfMeasureEntity = {
  __typename?: 'InventoryPrimaryUnitOfMeasureEntity';
  createdAt: Scalars['DateTime']['output'];
  unitOfMeasure: UnitOfMeasure;
  upcCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type InventorySecondaryUnitOfMeasureEntity = {
  __typename?: 'InventorySecondaryUnitOfMeasureEntity';
  createdAt: Scalars['DateTime']['output'];
  primaryUnitsPerSecondaryUOM?: Maybe<Scalars['Float']['output']>;
  unitOfMeasure: UnitOfMeasure;
  upcCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type InvoiceAdd = {
  __typename?: 'InvoiceAdd';
  name?: Maybe<Scalars['String']['output']>;
  shipmentUuids: Array<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAgingReportArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * If set to true, excludes any invoices that are closed
   * @deprecated Unused, need to deprecate after removing from frontend
   */
  hideCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of aging report to generate. SUMMARY shows one row per customer, DETAILED shows individual invoices. Defaults to DETAILED. */
  reportType?: InputMaybe<AgingReportType>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** If set to true, calculate aging from the invoice due date instead of the invoice date */
  useInvoiceDueDate?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InvoiceBillingSummaryDetailType {
  Aggregate = 'AGGREGATE',
  Detailed = 'DETAILED'
}

export enum InvoiceBillingSummaryGroupByType {
  Contact = 'CONTACT',
  Terminal = 'TERMINAL'
}

export type InvoiceBillingSummaryLineItemEntity = {
  __typename?: 'InvoiceBillingSummaryLineItemEntity';
  contactDisplayName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  inboundAddressName?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceName: Scalars['String']['output'];
  invoiceStatus: Scalars['String']['output'];
  orderLineHaulLane?: Maybe<OrderLineHaulLaneEntity>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  outboundAddressName?: Maybe<Scalars['String']['output']>;
  /** Sum of all package quantities on order */
  pieces: Scalars['Int']['output'];
  refNumbers?: Maybe<Array<Scalars['String']['output']>>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the line item as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  serviceLevel: Scalars['String']['output'];
  serviceName?: Maybe<Scalars['String']['output']>;
  shipmentsIncludedInLineItemRevenue: Array<ShipmentIncludedInRevenueEntity>;
  shipperBillOfLadingNumber: Scalars['String']['output'];
  totalCharge: Scalars['Float']['output'];
  /** Sum of all package weights on order */
  weight: Scalars['Float']['output'];
};

export type InvoiceBillingSummaryV2Group = {
  __typename?: 'InvoiceBillingSummaryV2Group';
  groupLabel: Scalars['String']['output'];
  groupTotal: Scalars['Float']['output'];
  specialGroupType?: Maybe<InvoiceBillingSummaryV2SpecialGroupType>;
  subgroups: Array<InvoiceBillingSummaryV2Subgroup>;
  totalLineItems: Scalars['Float']['output'];
};

export type InvoiceBillingSummaryV2Input = {
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated We don't support this option anymore and this field is not respected in the backend. */
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  onlyLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  reportDetailType?: InputMaybe<InvoiceBillingSummaryDetailType>;
  reportGroupByType: InvoiceBillingSummaryGroupByType;
  /** Filters the order records based on whether the "order service date" meets the filter conditions */
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceBillingSummaryV2Output = {
  __typename?: 'InvoiceBillingSummaryV2Output';
  groups: Array<InvoiceBillingSummaryV2Group>;
  total: Scalars['Float']['output'];
};

export type InvoiceBillingSummaryV2PdfOutput = {
  __typename?: 'InvoiceBillingSummaryV2PdfOutput';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum InvoiceBillingSummaryV2SpecialGroupType {
  LineHaul = 'LINE_HAUL',
  NoTerminal = 'NO_TERMINAL'
}

export type InvoiceBillingSummaryV2Subgroup = {
  __typename?: 'InvoiceBillingSummaryV2Subgroup';
  lineItems: Array<InvoiceBillingSummaryLineItemEntity>;
  subgroupLabel?: Maybe<Scalars['String']['output']>;
  subgroupTotal: Scalars['Float']['output'];
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceCreateInput = {
  associatedShipmentUuids: Array<Scalars['String']['input']>;
  billToAddressCreateInput?: InputMaybe<AddressCreateInput>;
  billToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  billToContactUuid: Scalars['String']['input'];
  customChargeCreateInputs: Array<CustomChargeCreateInput>;
  customJournalNumber?: InputMaybe<Scalars['Float']['input']>;
  customName?: InputMaybe<Scalars['String']['input']>;
  customOrdinal?: InputMaybe<Scalars['Float']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceTermsUuid?: InputMaybe<Scalars['String']['input']>;
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  remitToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InvoiceSource>;
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceEntity;
};

export type InvoiceEntity = {
  __typename?: 'InvoiceEntity';
  age: Scalars['Int']['output'];
  balanceCents?: Maybe<Scalars['Float']['output']>;
  balanceInCents: Scalars['Int']['output'];
  balanceInDollars: Scalars['Float']['output'];
  billTo?: Maybe<AddressEntity>;
  billToContact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  documents: Array<DocumentEntity>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  emailOptions: Array<Scalars['String']['output']>;
  emailSendStatus: EmailSendStatus;
  firstShipment?: Maybe<ShipmentEntity>;
  hasAppliedPayments: Scalars['Boolean']['output'];
  inConsolidatedInvoice: Scalars['Boolean']['output'];
  invoiceTerms?: Maybe<InvoiceTermEntity>;
  /** The invoice total charge in dollars as a string */
  invoiceTotal: Scalars['String']['output'];
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  journalNumber: Scalars['Float']['output'];
  lastSyncedFromQuickbooksAt?: Maybe<Scalars['DateTime']['output']>;
  lastSyncedToQuickbooksAt?: Maybe<Scalars['DateTime']['output']>;
  latest210EdiStatus?: Maybe<Latest210EdiStatusEntity>;
  latestEmailTransaction?: Maybe<EmailTransactionEntity>;
  manuallySyncedToQuickbooksDesktopAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderEntity>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  qbInvoiceNumber?: Maybe<Scalars['Float']['output']>;
  quickbooksInvoiceId?: Maybe<Scalars['String']['output']>;
  quickbooksLastSyncAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  quickbooksNextRetryAt?: Maybe<Scalars['DateTime']['output']>;
  quickbooksSyncFailureCode?: Maybe<Scalars['String']['output']>;
  quickbooksSyncFailureDetail?: Maybe<Scalars['String']['output']>;
  quickbooksSyncFailureElement?: Maybe<Scalars['String']['output']>;
  quickbooksSyncFailureRemediation?: Maybe<Scalars['String']['output']>;
  quickbooksSyncFailureTitle?: Maybe<Scalars['String']['output']>;
  quickbooksSyncFaultCode?: Maybe<Scalars['String']['output']>;
  quickbooksSyncRequestId?: Maybe<Scalars['String']['output']>;
  quickbooksSyncToken?: Maybe<Scalars['String']['output']>;
  remitTo?: Maybe<AddressEntity>;
  shipments: Array<ShipmentEntity>;
  source: InvoiceSource;
  status: InvoiceStatus;
  syncedToQuickbooksDesktopAt?: Maybe<Scalars['DateTime']['output']>;
  totalNumber: Scalars['Float']['output'];
  totalOpenAmount: Scalars['Float']['output'];
  transmissionSendStatus: EmailSendStatus;
  uuid: Scalars['String']['output'];
};

export type InvoiceExcelCustomChargeAmount = {
  __typename?: 'InvoiceExcelCustomChargeAmount';
  total: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type InvoiceExcelExportDataOutput = {
  __typename?: 'InvoiceExcelExportDataOutput';
  invoiceUuid: Scalars['String']['output'];
  shipments: Array<InvoiceExcelShipmentAmounts>;
};

export type InvoiceExcelShipmentAmounts = {
  __typename?: 'InvoiceExcelShipmentAmounts';
  customCharges: Array<InvoiceExcelCustomChargeAmount>;
  smc3FreightText?: Maybe<Scalars['String']['output']>;
  totalCharge: Scalars['Float']['output'];
  totalFreightCharge: Scalars['Float']['output'];
  totalFuelCharge: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

/** An invoice or unapplied payment and its fields returned as part of an invoice aging report */
export type InvoiceForAgingReportEntity = {
  __typename?: 'InvoiceForAgingReportEntity';
  age: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  journalNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  totalOpenAmount: Scalars['Float']['output'];
};

/** An invoice and its fields returned as part of an open invoice report */
export type InvoiceForOpenInvoiceReportEntity = {
  __typename?: 'InvoiceForOpenInvoiceReportEntity';
  billingPartyContactDisplayName: Scalars['String']['output'];
  billingPartyContactReferenceNumber?: Maybe<Scalars['String']['output']>;
  billingPartyContactUuid: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceBalanceCents: Scalars['Float']['output'];
  invoiceTotalCents: Scalars['Float']['output'];
  journalNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orders: Array<OrderForOpenInvoiceReportEntity>;
  status: InvoiceStatus;
  uuid: Scalars['String']['output'];
};

export type InvoiceNoteRuleConnection = {
  __typename?: 'InvoiceNoteRuleConnection';
  edges: Array<InvoiceNoteRuleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceNoteRuleEdge = {
  __typename?: 'InvoiceNoteRuleEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceNoteRuleEntity;
};

export type InvoiceNoteRuleEntity = {
  __typename?: 'InvoiceNoteRuleEntity';
  contactDisplayName?: Maybe<Scalars['String']['output']>;
  contactUuid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Also print the company-wide rule's note after this rule's note. */
  includeCompanyNote: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
  /** true: at least one order on the invoice is a rebill. false: none are. null: either. */
  rebilled?: Maybe<Scalars['Boolean']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceUuid?: Maybe<Scalars['String']['output']>;
  terminalName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type InvoiceNoteRuleInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Also print the company-wide rule's note after this rule's note. Not allowed on the company-wide rule itself. */
  includeCompanyNote?: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
  rebilled?: InputMaybe<Scalars['Boolean']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceRegisterReportInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * The upper bound for the date of invoices which will be included in the report.
   *     If not included, the report will include all invoices after invoiceStartDate.
   */
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The lower bound for the date of invoices which will be included in the report.
   *       If not included, the report will include all invoices before invoiceEndDate.
   */
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  statusFilter: InvoiceStatusFilter;
};

export type InvoiceSendJobBatchConnection = {
  __typename?: 'InvoiceSendJobBatchConnection';
  edges: Array<InvoiceSendJobBatchEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceSendJobBatchDocumentsEntity = {
  __typename?: 'InvoiceSendJobBatchDocumentsEntity';
  invoicesBackupDocument?: Maybe<DocumentEntity>;
  invoicesCombinedDocument?: Maybe<DocumentEntity>;
  invoicesZipDocument?: Maybe<DocumentEntity>;
};

export type InvoiceSendJobBatchEdge = {
  __typename?: 'InvoiceSendJobBatchEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceSendJobBatchEntity;
};

export type InvoiceSendJobBatchEntity = {
  __typename?: 'InvoiceSendJobBatchEntity';
  createdAt: Scalars['DateTime']['output'];
  invoiceBatchDocuments: InvoiceSendJobBatchDocumentsEntity;
  invoiceSendJobBatchDocumentCount: Scalars['Float']['output'];
  invoiceSendJobBatchProgress: InvoiceSendJobBatchProgressEntity;
  type: InvoiceSendJobBatchType;
  uuid: Scalars['String']['output'];
};

export type InvoiceSendJobBatchProgressEntity = {
  __typename?: 'InvoiceSendJobBatchProgressEntity';
  failCount: Scalars['Float']['output'];
  successCount: Scalars['Float']['output'];
  totalCount: Scalars['Float']['output'];
};

export enum InvoiceSendJobBatchType {
  Download = 'DOWNLOAD',
  PostAndSend = 'POST_AND_SEND',
  Send = 'SEND'
}

export type InvoiceSendJobConnection = {
  __typename?: 'InvoiceSendJobConnection';
  edges: Array<InvoiceSendJobEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceSendJobEdge = {
  __typename?: 'InvoiceSendJobEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceSendJobEntity;
};

export type InvoiceSendJobEntity = {
  __typename?: 'InvoiceSendJobEntity';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<DocumentEntity>;
  documentGenerationFailed?: Maybe<Scalars['Boolean']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  invoice: InvoiceEntity;
  invoiceAttachmentDocumentTypes: Array<DocumentType>;
  /** A base64-encoded string that represents the list of shipments and their charges sent on the PDF invoice */
  invoiceChargesObject?: Maybe<Scalars['String']['output']>;
  invoiceSendJobError?: Maybe<InvoiceSendJobError>;
  invoiceTransmissionMethod: InvoiceTransmissionMethod;
  note?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export enum InvoiceSendJobError {
  AllRecipientsOnSuppressionList = 'ALL_RECIPIENTS_ON_SUPPRESSION_LIST',
  DocumentGenerationFailed = 'DOCUMENT_GENERATION_FAILED',
  InvoiceHasNoShipments = 'INVOICE_HAS_NO_SHIPMENTS',
  InvoiceMissingSomeShipments = 'INVOICE_MISSING_SOME_SHIPMENTS',
  InvoiceRecentlySent = 'INVOICE_RECENTLY_SENT',
  InvoiceTotalIsZero = 'INVOICE_TOTAL_IS_ZERO'
}

export enum InvoiceSendJobStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type InvoiceShipmentUpdate = {
  customChargeArrayUpdateInputs?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  freightChargeArrayUpdateInputs?: InputMaybe<Array<FreightChargeCreateInput>>;
  shipmentUuid: Scalars['String']['input'];
};

export enum InvoiceSource {
  ManuallyCreated = 'MANUALLY_CREATED',
  Migrated = 'MIGRATED'
}

export enum InvoiceStatus {
  Invoiced = 'INVOICED',
  NotFinalized = 'NOT_FINALIZED',
  Paid = 'PAID',
  ReadyToInvoice = 'READY_TO_INVOICE',
  Void = 'VOID'
}

export enum InvoiceStatusFilter {
  All = 'ALL',
  NotPosted = 'NOT_POSTED',
  Posted = 'POSTED'
}

/** Groups the invoice list by one or more columns. `fields` is the ordered list of grouping levels; `keys` holds the group value for each level the client has already expanded, outermost first, and must be shorter than `fields`: the query answers with the group rows of the next level. The invoices under a fully expanded path come from the `invoices` query with a `groupPath`. */
export type InvoiceTableGroupByInput = {
  /** Order of the group rows by their value; ascending when omitted. */
  direction?: InputMaybe<SortDirection>;
  /** Grouping levels, outermost first. */
  fields: Array<InvoiceTableGroupField>;
  /** Group value for each expanded level, outermost first. Shorter than `fields`. */
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  /** Most group rows to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Group rows to skip within the requested level. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Invoice list columns the client may group by. */
export enum InvoiceTableGroupField {
  Customer = 'CUSTOMER',
  SendStatus = 'SEND_STATUS',
  Status = 'STATUS'
}

/** One expanded level of a grouped invoice list: the grouping field and the group key the client was given for it. A null key selects the invoices whose value is blank. */
export type InvoiceTableGroupPathEntryInput = {
  field: InvoiceTableGroupField;
  key?: InputMaybe<Scalars['String']['input']>;
};

/** One group of the invoice list at the level the request asked for: the value shared by its invoices, the text to show for it, and how many invoices it holds. */
export type InvoiceTableGroupRowEntity = {
  __typename?: 'InvoiceTableGroupRowEntity';
  /** Number of invoices in the group under the active filters. */
  count: Scalars['Int']['output'];
  /** The group value as the client must send it back in `groupBy.keys` or `groupPath` to expand this group. Null for the invoices whose value is blank. */
  key?: Maybe<Scalars['String']['output']>;
  /** Display text for the group. Null when the value is blank, so the client can render its own placeholder. */
  label?: Maybe<Scalars['String']['output']>;
};

/** One level of the grouped invoice list: the group rows at that level, and whether more follow the requested page. */
export type InvoiceTableGroupsOutput = {
  __typename?: 'InvoiceTableGroupsOutput';
  groupRows: Array<InvoiceTableGroupRowEntity>;
  /** Whether more group rows exist beyond `offset + limit`. */
  hasMore: Scalars['Boolean']['output'];
};

export type InvoiceTermEntity = {
  __typename?: 'InvoiceTermEntity';
  terms: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type InvoiceToSend = {
  attachments: Array<DocumentType>;
  /** The email subject. If not provided, a subject will be generated */
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceTransmissionMethod: InvoiceTransmissionMethod;
  invoiceType: InvoiceType;
  note?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum InvoiceTransmissionMethod {
  Download = 'DOWNLOAD',
  Edi = 'EDI',
  Email = 'EMAIL',
  EmailAndDownload = 'EMAIL_AND_DOWNLOAD',
  None = 'NONE'
}

export enum InvoiceType {
  ExcelChargeMatrix = 'EXCEL_CHARGE_MATRIX',
  ExcelItemized = 'EXCEL_ITEMIZED',
  ExcelSummarized = 'EXCEL_SUMMARIZED',
  PdfItemized = 'PDF_ITEMIZED',
  PdfSummarized = 'PDF_SUMMARIZED'
}

export type InvoiceUpdateInput = {
  associatedShipmentUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  billToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  billToContactUuid?: InputMaybe<Scalars['String']['input']>;
  customChargeArrayUpdate?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  documentUpsertInputs?: InputMaybe<Array<DocumentUpsertInput>>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  invoiceShipmentUpdate?: InputMaybe<InvoiceShipmentUpdate>;
  invoiceTermsUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newBillToAddress?: InputMaybe<AddressCreateInput>;
  newRemitToAddress?: InputMaybe<AddressCreateInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quickbooksInvoiceId?: InputMaybe<Scalars['String']['input']>;
  remitToAddressUuid?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  uuid: Scalars['String']['input'];
};

export type InvoiceUpdateLimitedInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceTermsUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type IsReweighedSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type ItemConnection = {
  __typename?: 'ItemConnection';
  edges: Array<ItemEdge>;
  pageInfo: PageInfo;
};

export type ItemEdge = {
  __typename?: 'ItemEdge';
  cursor: Scalars['String']['output'];
  node: ItemEntity;
};

export type ItemEntity = {
  __typename?: 'ItemEntity';
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  inventoryItems: Array<InventoryItemEntity>;
  itemStorageUnitConfig?: Maybe<ItemStorageUnitConfigEntity>;
  primaryUOM: InventoryPrimaryUnitOfMeasureEntity;
  productCost?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  secondaryUOM?: Maybe<InventorySecondaryUnitOfMeasureEntity>;
  sellPrice?: Maybe<Scalars['Float']['output']>;
  sku: Scalars['String']['output'];
  status: ItemStatus;
  storageOrders: Array<StorageOrderEntity>;
  storageUnitsCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
};

export type ItemForStorageOrder = {
  __typename?: 'ItemForStorageOrder';
  item: ItemEntity;
  /** The total count of inventory items of this item type */
  totalQuantity: Scalars['Int']['output'];
  /** The count of inventory items not assigned to a storage order */
  unassignedQuantity: Scalars['Int']['output'];
};

export type ItemForStorageUnit = {
  __typename?: 'ItemForStorageUnit';
  /** The count of inventory items of this item type assigned to this storage unit */
  assignedQuantity: Scalars['Int']['output'];
  item: ItemEntity;
};

export type ItemGroupConnection = {
  __typename?: 'ItemGroupConnection';
  edges: Array<ItemGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ItemGroupEdge = {
  __typename?: 'ItemGroupEdge';
  cursor: Scalars['String']['output'];
  node: ItemGroupEntity;
};

export type ItemGroupEntity = {
  __typename?: 'ItemGroupEntity';
  createdAt: Scalars['DateTime']['output'];
  item: ItemEntity;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  markedOsdAt?: Maybe<Scalars['DateTime']['output']>;
  pickedAt?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  storageOrder: StorageOrderEntity;
  storageUnit?: Maybe<StorageUnitEntity>;
  unitOfMeasure: UnitOfMeasure;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ItemGroupQuantityFilter = {
  /** UUIDs of itemGroups to query regardless of the filter type. Used to display picked itemGroups when editing a picklist */
  overrideUUIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  type: ItemGroupQuantityFilterType;
};

export enum ItemGroupQuantityFilterType {
  All = 'ALL',
  NotZero = 'NOT_ZERO',
  OnlyZero = 'ONLY_ZERO'
}

export type ItemLocationEntity = {
  __typename?: 'ItemLocationEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ItemStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ItemStorageUnitConfigEntity = {
  __typename?: 'ItemStorageUnitConfigEntity';
  consolidationUnitUOM: UnitOfMeasure;
  createdAt: Scalars['DateTime']['output'];
  dimensionsUOM: WarehouseMeasurementUnits;
  height: Scalars['Float']['output'];
  high: Scalars['Float']['output'];
  length: Scalars['Float']['output'];
  primaryUnitsPerConsolidationUnit: Scalars['Float']['output'];
  tie: Scalars['Float']['output'];
  type: MeasurementUnits;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
  weightUOM: WarehouseMeasurementUnits;
  width: Scalars['Float']['output'];
};

export type KpiComparisonSetEntity = {
  __typename?: 'KpiComparisonSetEntity';
  lastMonth: KpiReferenceValueEntity;
  priorPeriod: KpiReferenceValueEntity;
};

export type KpiComparisonsEntity = {
  __typename?: 'KpiComparisonsEntity';
  delivery?: Maybe<KpiComparisonSetEntity>;
  deliveryFailure?: Maybe<KpiComparisonSetEntity>;
  pickup?: Maybe<KpiComparisonSetEntity>;
  scan?: Maybe<KpiComparisonSetEntity>;
};

export type KpiDataStartEntity = {
  __typename?: 'KpiDataStartEntity';
  firstServiceDate?: Maybe<PlainDate>;
};

export type KpiDockReceiptRecordEntity = {
  __typename?: 'KpiDockReceiptRecordEntity';
  customerName?: Maybe<Scalars['String']['output']>;
  fileNo?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  pieceName: Scalars['String']['output'];
  receivedAt: Scalars['DateTime']['output'];
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type KpiDockReceiptRecordsEntity = {
  __typename?: 'KpiDockReceiptRecordsEntity';
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiDockReceiptRecordEntity>;
  totalRecords: Scalars['Int']['output'];
};

export type KpiDriverOrdersRecordEntity = {
  __typename?: 'KpiDriverOrdersRecordEntity';
  driverName?: Maybe<Scalars['String']['output']>;
  driverUuid: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  share?: Maybe<Scalars['Float']['output']>;
};

export type KpiDriverOrdersRecordsEntity = {
  __typename?: 'KpiDriverOrdersRecordsEntity';
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiDriverOrdersRecordEntity>;
  totalRecords: Scalars['Int']['output'];
};

/** How a delivery missed the day it was promised for. */
export enum KpiFailedDeliveryOutcome {
  DeliveredLateDay = 'DELIVERED_LATE_DAY',
  NotDelivered = 'NOT_DELIVERED'
}

export type KpiInvoicedOrderRecordEntity = {
  __typename?: 'KpiInvoicedOrderRecordEntity';
  createdAt: Scalars['DateTime']['output'];
  customerName: Scalars['String']['output'];
  days: Scalars['Float']['output'];
  fileNo?: Maybe<Scalars['String']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  invoicedAt: Scalars['DateTime']['output'];
  orderUuid: Scalars['String']['output'];
};

export type KpiInvoicedOrderRecordsEntity = {
  __typename?: 'KpiInvoicedOrderRecordsEntity';
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiInvoicedOrderRecordEntity>;
  totalRecords: Scalars['Int']['output'];
};

export type KpiLayoutEntity = {
  __typename?: 'KpiLayoutEntity';
  availableTiles: Array<KpiTileEntity>;
  customized: Scalars['Boolean']['output'];
  defaultTiles: Array<KpiTileEntity>;
  tiles: Array<KpiTileEntity>;
};

export type KpiOrderRecordEntity = {
  __typename?: 'KpiOrderRecordEntity';
  customerName: Scalars['String']['output'];
  driverNames: Array<Scalars['String']['output']>;
  fileNo?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  revenueCents?: Maybe<Scalars['Float']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type KpiOrderRecordsEntity = {
  __typename?: 'KpiOrderRecordsEntity';
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiOrderRecordEntity>;
  revenueVisible: Scalars['Boolean']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type KpiPaidInvoiceRecordEntity = {
  __typename?: 'KpiPaidInvoiceRecordEntity';
  amountCents?: Maybe<Scalars['Float']['output']>;
  customerName: Scalars['String']['output'];
  days: Scalars['Float']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  paidAt: Scalars['DateTime']['output'];
};

export type KpiPaidInvoiceRecordsEntity = {
  __typename?: 'KpiPaidInvoiceRecordsEntity';
  amountVisible: Scalars['Boolean']['output'];
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiPaidInvoiceRecordEntity>;
  totalRecords: Scalars['Int']['output'];
};

export type KpiPieceRecordEntity = {
  __typename?: 'KpiPieceRecordEntity';
  customerName: Scalars['String']['output'];
  fileNo?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  pieceName: Scalars['String']['output'];
  scanned: Scalars['Boolean']['output'];
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  terminalName?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<Scalars['String']['output']>;
};

export type KpiPieceRecordsEntity = {
  __typename?: 'KpiPieceRecordsEntity';
  facets?: Maybe<KpiRecordFacetsEntity>;
  records: Array<KpiPieceRecordEntity>;
  totalRecords: Scalars['Int']['output'];
};

/** Whether a delivered piece carried a delivery scan. */
export enum KpiPieceScanState {
  NotScanned = 'NOT_SCANNED',
  Scanned = 'SCANNED'
}

/** A column of an Owner's Breakfast record table. */
export enum KpiRecordColumn {
  Amount = 'AMOUNT',
  Created = 'CREATED',
  Customer = 'CUSTOMER',
  Days = 'DAYS',
  Driver = 'DRIVER',
  Invoice = 'INVOICE',
  Invoiced = 'INVOICED',
  InvoiceDate = 'INVOICE_DATE',
  Judged = 'JUDGED',
  Order = 'ORDER',
  Orders = 'ORDERS',
  Outcome = 'OUTCOME',
  Paid = 'PAID',
  Piece = 'PIECE',
  Promised = 'PROMISED',
  Received = 'RECEIVED',
  Revenue = 'REVENUE',
  Scan = 'SCAN',
  ServiceDate = 'SERVICE_DATE',
  Share = 'SHARE',
  Terminal = 'TERMINAL',
  Weight = 'WEIGHT'
}

export type KpiRecordDateRangeInput = {
  column: KpiRecordColumn;
  /** YYYY-MM-DD, inclusive */
  from: Scalars['String']['input'];
  /** YYYY-MM-DD, inclusive */
  to: Scalars['String']['input'];
};

/** The file a record table is downloaded as. */
export enum KpiRecordDownloadFormat {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type KpiRecordFacetOptionEntity = {
  __typename?: 'KpiRecordFacetOptionEntity';
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type KpiRecordFacetsEntity = {
  __typename?: 'KpiRecordFacetsEntity';
  customers: Array<KpiRecordFacetOptionEntity>;
  drivers: Array<KpiRecordFacetOptionEntity>;
  terminals: Array<KpiRecordFacetOptionEntity>;
};

export type KpiRecordFiltersInput = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRanges?: InputMaybe<Array<KpiRecordDateRangeInput>>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  outcomes?: InputMaybe<Array<KpiFailedDeliveryOutcome>>;
  referenceText?: InputMaybe<Scalars['String']['input']>;
  scanStates?: InputMaybe<Array<KpiPieceScanState>>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type KpiRecordPageInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type KpiRecordSortInput = {
  column: KpiRecordColumn;
  direction: SortDirection;
};

/** An Owner's Breakfast record table. */
export enum KpiRecordTable {
  DockReceipts = 'DOCK_RECEIPTS',
  DriverOrders = 'DRIVER_ORDERS',
  FailedDeliveries = 'FAILED_DELIVERIES',
  InvoicedOrders = 'INVOICED_ORDERS',
  OnTimeStops = 'ON_TIME_STOPS',
  Orders = 'ORDERS',
  PaidInvoices = 'PAID_INVOICES',
  Pieces = 'PIECES'
}

export type KpiRecordTableArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<KpiRecordFiltersInput>;
  metrics?: InputMaybe<Array<KpiTileMetric>>;
  page?: InputMaybe<KpiRecordPageInput>;
  sort?: InputMaybe<KpiRecordSortInput>;
  startDate: Scalars['DateTime']['input'];
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type KpiRecordTableDownloadArgs = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<KpiRecordFiltersInput>;
  format: KpiRecordDownloadFormat;
  metrics?: InputMaybe<Array<KpiTileMetric>>;
  sort?: InputMaybe<KpiRecordSortInput>;
  startDate: Scalars['DateTime']['input'];
  stopFilter?: InputMaybe<OnTimeStopFilter>;
  stopKind?: InputMaybe<KpiStopKind>;
  table: KpiRecordTable;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A record table built while the user waited, behind a presigned link that expires like every report link. */
export type KpiRecordTableDownloadFileOutput = {
  __typename?: 'KpiRecordTableDownloadFileOutput';
  fileName: Scalars['String']['output'];
  reportGenerationStatus: ReportGenerationStatus;
  url: Scalars['String']['output'];
};

export type KpiRecordTableDownloadOutput = KpiRecordTableDownloadFileOutput | KpiRecordTableEmailToUserOutput;

/** A record-table CSV with more rows than are built while the user waits: a background job builds it and emails a link. */
export type KpiRecordTableEmailToUserOutput = {
  __typename?: 'KpiRecordTableEmailToUserOutput';
  emailedTo: Scalars['String']['output'];
  reportGenerationStatus: ReportGenerationStatus;
  rowCount: Scalars['Int']['output'];
};

export type KpiReferenceValueEntity = {
  __typename?: 'KpiReferenceValueEntity';
  denominator: Scalars['Int']['output'];
  numerator: Scalars['Int']['output'];
  pct?: Maybe<Scalars['Float']['output']>;
};

export type KpiReportArgs = {
  endDate: Scalars['DateTime']['input'];
  metrics?: InputMaybe<Array<KpiTileMetric>>;
  startDate: Scalars['DateTime']['input'];
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Which side of the order an on-time KPI describes. */
export enum KpiStopKind {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type KpiTileEntity = {
  __typename?: 'KpiTileEntity';
  format: KpiTileFormat;
  metric: KpiTileMetric;
};

/** How an Owner's Breakfast Dashboard tile shows its metric. */
export enum KpiTileFormat {
  Breakdown = 'BREAKDOWN',
  Card = 'CARD',
  Commitment = 'COMMITMENT',
  FailureList = 'FAILURE_LIST',
  Trend = 'TREND'
}

export type KpiTileInput = {
  format: KpiTileFormat;
  metric: KpiTileMetric;
};

/** A figure the Owner's Breakfast Dashboard can show. */
export enum KpiTileMetric {
  DaysToInvoice = 'DAYS_TO_INVOICE',
  DaysToPayment = 'DAYS_TO_PAYMENT',
  DeliveryFailure = 'DELIVERY_FAILURE',
  DockReceived = 'DOCK_RECEIVED',
  OnTimeDelivery = 'ON_TIME_DELIVERY',
  OnTimePickup = 'ON_TIME_PICKUP',
  OrdersPerDriver = 'ORDERS_PER_DRIVER',
  OrderCount = 'ORDER_COUNT',
  PieceScan = 'PIECE_SCAN',
  Revenue = 'REVENUE'
}

/** Grain of a KPI dashboard trend series. */
export enum KpiTrendBucketUnit {
  Day = 'DAY',
  Week = 'WEEK'
}

export type LaneDefaultDoorEntity = {
  __typename?: 'LaneDefaultDoorEntity';
  destDoorPosition?: Maybe<Scalars['Int']['output']>;
  endTerminalUuid: Scalars['String']['output'];
  originDoorPosition?: Maybe<Scalars['Int']['output']>;
  startTerminalUuid: Scalars['String']['output'];
};

export type LateStop = {
  __typename?: 'LateStop';
  minutesLate: Scalars['Int']['output'];
  serviceStartsAt: Scalars['String']['output'];
  stopUuid: Scalars['String']['output'];
  windowEndsAt: Scalars['String']['output'];
};

export type Latest210EdiStatusEntity = {
  __typename?: 'Latest210EdiStatusEntity';
  errorSummary?: Maybe<Scalars['String']['output']>;
  status: EdiTransactionStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type LegCreateInput = {
  endStopCreateInput: StopCreateInput;
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** Manually initialize a leg's status */
  status?: InputMaybe<LegStatus>;
};

export type LegDriverMapCreateInput = {
  driverUuid: Scalars['String']['input'];
  legUuid: Scalars['String']['input'];
};

export type LegDriverMapEntity = {
  __typename?: 'LegDriverMapEntity';
  driver?: Maybe<DriverEntity>;
  uuid: Scalars['String']['output'];
};

export type LegDriverMapUpdateInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  legUuid?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type LegEntity = {
  __typename?: 'LegEntity';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  drivers: Array<DriverEntity>;
  endStop: StopEntity;
  flatRate?: Maybe<Scalars['Float']['output']>;
  legDriverMaps: Array<LegDriverMapEntity>;
  miles?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  previousStopAttempts: Array<StopEntity>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  shipment: ShipmentEntity;
  status: LegStatus;
  tags: Array<TagEntity>;
  uuid: Scalars['String']['output'];
};

export enum LegPdfColumnMapping {
  Miles = 'MILES'
}

export enum LegStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS'
}

export type LegUpdateInput = {
  endStopUpdateInput?: InputMaybe<StopUpdateInput>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** Manually update a leg's status. Only recommended if setting to COMPLETED */
  status?: InputMaybe<LegStatus>;
  uuid: Scalars['String']['input'];
};

export type LegUpsertInput = {
  endStopUpsertInput: StopUpsertInput;
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** Manually initialize a leg's status */
  status?: InputMaybe<LegStatus>;
  uuid: Scalars['String']['input'];
};

export type LineHaulDriverConflictInput = {
  driverUuid: Scalars['String']['input'];
  manifestUuid: Scalars['String']['input'];
};

export type LineHaulDriverConflictOutput = {
  __typename?: 'LineHaulDriverConflictOutput';
  conflictWarning?: Maybe<Scalars['String']['output']>;
};

export type LineHaulFuelChargeFuelProfileDateRangeInput = {
  contactUuid: Scalars['String']['input'];
  /** The date the line haul was completed. To be used to select the fuel profile date range selection if it exists */
  lineHaulCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUID of the fuel profile attached to the tariff selected for the stop */
  tariffGroupFuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
};

export type LineHaulFuelChargeFuelProfileDateRangeOutput = {
  __typename?: 'LineHaulFuelChargeFuelProfileDateRangeOutput';
  fuelProfileDateRange?: Maybe<FuelProfileDateRangeEntity>;
};

export type LineHaulLaneCreateInput = {
  destinationTerminalUuid: Scalars['String']['input'];
  intermediateTerminalUuids: Array<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  originTerminalUuid: Scalars['String']['input'];
};

export type LineHaulLaneEntity = {
  __typename?: 'LineHaulLaneEntity';
  destinationTerminal: TerminalEntity;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  originTerminal: TerminalEntity;
  segments: Array<LineHaulSegmentEntity>;
  uuid: Scalars['String']['output'];
};

export type LineHaulLaneUpdateInput = {
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  intermediateTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type LineHaulManifestCreateInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  departDate: Scalars['DateTime']['input'];
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LineHaulManifestEntity = {
  __typename?: 'LineHaulManifestEntity';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedByAgentAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  departDate: Scalars['DateTime']['output'];
  departTimeMinutes?: Maybe<Scalars['Int']['output']>;
  doorsClosedAt?: Maybe<Scalars['DateTime']['output']>;
  driver?: Maybe<DriverEntity>;
  endTerminal: TerminalEntity;
  equipment?: Maybe<EquipmentEntity>;
  estimatedArrival?: Maybe<Scalars['DateTime']['output']>;
  estimatedDeparture?: Maybe<Scalars['DateTime']['output']>;
  hasFreightArrivedWhileUndeparted: Scalars['Boolean']['output'];
  isRecurringGenerated: Scalars['Boolean']['output'];
  loadPosition?: Maybe<LoadPosition>;
  orderSegments: Array<OrderLineHaulSegmentEntity>;
  orders: Array<OrderEntity>;
  ordersOnManifest: Array<OrderOnLineHaulManifestEntity>;
  referenceNumber: Scalars['String']['output'];
  sentToAgentAt?: Maybe<Scalars['DateTime']['output']>;
  startTerminal: TerminalEntity;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: LineHaulManifestStatus;
  uuid: Scalars['String']['output'];
};

/** Filters with fields for the findLineHaulManifestsV2 query. Use either "and" or "or" or "filters", but not all simultaneously. Using all in the same query may lead to unexpected results. */
export type LineHaulManifestFilters = {
  and?: InputMaybe<Array<LineHaulManifestFilters>>;
  fields?: InputMaybe<Fields>;
  or?: InputMaybe<Array<LineHaulManifestFilters>>;
};

/** The status of the line haul manifest */
export enum LineHaulManifestStatus {
  Arrived = 'ARRIVED',
  Departed = 'DEPARTED',
  DoorsClosed = 'DOORS_CLOSED',
  Planning = 'PLANNING'
}

export type LineHaulManifestStatusFilter = {
  /** Filters for records where the relevant status field is equal to the provided status value */
  eq?: InputMaybe<LineHaulManifestStatus>;
  /** Filters for records where the relevant status field is in the provided status values */
  in?: InputMaybe<Array<LineHaulManifestStatus>>;
  /** Filters for records where the relevant status field is not equal to the provided status value */
  neq?: InputMaybe<LineHaulManifestStatus>;
  /** Filters for records where the relevant status field is not in the provided status values */
  nin?: InputMaybe<Array<LineHaulManifestStatus>>;
};

export type LineHaulManifestUpdateInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  departDate: Scalars['DateTime']['input'];
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type LineHaulManifestsCategoryGroupsOutput = {
  __typename?: 'LineHaulManifestsCategoryGroupsOutput';
  category: LineHaulManifestsGroupBy;
  groups: Array<ManifestGroup>;
};

/** Categories available for grouping line haul manifests */
export enum LineHaulManifestsGroupBy {
  Lane = 'LANE'
}

export type LineHaulManifestsGroupsInput = {
  filters?: InputMaybe<FindLineHaulManifestsV2FiltersInput>;
  groupBy: LineHaulManifestsGroupBy;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type LineHaulOrderSort = {
  sortBy: OrderLineHaulSegmentSortFields;
  sortDirection: SortDirection;
};

export type LineHaulRevenueReportInput = {
  /** End date for the report (filters order_events.created_at) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Output format for the report. ALLOCATION = current multi-sheet breakdown, SUMMARY = SSF-style 4-sheet summary. */
  outputFormat?: InputMaybe<RevenueReportOutputFormat>;
  /** Report rules for the report */
  rules?: InputMaybe<ReportRules>;
  /** Start date for the report (filters order_events.created_at) */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LineHaulRevenueReportOutput = {
  __typename?: 'LineHaulRevenueReportOutput';
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LineHaulRouteLegInput = {
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type LineHaulRunCargoUnitEntity = {
  __typename?: 'LineHaulRunCargoUnitEntity';
  equipmentUuid: Scalars['String']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export type LineHaulRunConfigEntity = {
  __typename?: 'LineHaulRunConfigEntity';
  cubeCapacity?: Maybe<Scalars['Float']['output']>;
  cutoffTime?: Maybe<Scalars['String']['output']>;
  manifestUuid: Scalars['String']['output'];
  powerUnitDetails?: Maybe<LineHaulRunCargoUnitEntity>;
  powerUnitName?: Maybe<Scalars['String']['output']>;
  recurringTemplateTruckUuid?: Maybe<Scalars['String']['output']>;
  trailerDetails: Array<RecurringTemplateTruckTrailerEntity>;
  trailers: Array<Scalars['String']['output']>;
  truckLabel?: Maybe<Scalars['String']['output']>;
  weightCapacity?: Maybe<Scalars['Float']['output']>;
};

export type LineHaulSegmentCreateInput = {
  endTerminalUuid: Scalars['String']['input'];
  laneUuid: Scalars['String']['input'];
  ordinal: Scalars['Float']['input'];
  startTerminalUuid: Scalars['String']['input'];
};

export type LineHaulSegmentEntity = {
  __typename?: 'LineHaulSegmentEntity';
  cutoffTime?: Maybe<Scalars['String']['output']>;
  endTerminal: TerminalEntity;
  ordinal: Scalars['Float']['output'];
  startTerminal: TerminalEntity;
  transitDays?: Maybe<Scalars['Int']['output']>;
  transitMinutes?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

export type LineHaulSegmentTimingEntity = {
  __typename?: 'LineHaulSegmentTimingEntity';
  cutoffTime?: Maybe<Scalars['String']['output']>;
  endTerminalCode: Scalars['String']['output'];
  endTerminalUuid: Scalars['String']['output'];
  startTerminalCode: Scalars['String']['output'];
  startTerminalUuid: Scalars['String']['output'];
  transitDays?: Maybe<Scalars['Int']['output']>;
  transitMinutes?: Maybe<Scalars['Int']['output']>;
};

export type LineHaulSegmentUpdateInput = {
  endTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  laneUuid?: InputMaybe<Scalars['String']['input']>;
  ordinal: Scalars['Float']['input'];
  startTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type LineHaulStatusByTerminal = {
  __typename?: 'LineHaulStatusByTerminal';
  arrivalScans: Array<ScanEntity>;
  departureScans: Array<ScanEntity>;
  manifestDepartingFromThisTerminal?: Maybe<LineHaulManifestEntity>;
  markedArrivedAt?: Maybe<Scalars['DateTime']['output']>;
  terminal: TerminalEntity;
};

export type LineHaulTrailerAssignmentEntity = {
  __typename?: 'LineHaulTrailerAssignmentEntity';
  cubeFt3: Scalars['Float']['output'];
  manifestUuid: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  trailerEquipmentUuid: Scalars['String']['output'];
  weightLbs: Scalars['Float']['output'];
};

export type LineHaulUtilizationArgs = {
  endDate: Scalars['DateTime']['input'];
  grain: LineHaulUtilizationGrain;
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type LineHaulUtilizationAssumptionEntity = {
  __typename?: 'LineHaulUtilizationAssumptionEntity';
  defaultTrailerCubeCapacityCubicFeet: Scalars['Float']['output'];
  defaultTrailerWeightCapacityLbs: Scalars['Float']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Grouping grain for the Intelligence Board linehaul utilization report. */
export enum LineHaulUtilizationGrain {
  Lane = 'LANE',
  Manifest = 'MANIFEST',
  Terminal = 'TERMINAL'
}

export type LineHaulUtilizationReportEntity = {
  __typename?: 'LineHaulUtilizationReportEntity';
  assumptions: LineHaulUtilizationAssumptionEntity;
  grain: LineHaulUtilizationGrain;
  hasAssumptions: Scalars['Boolean']['output'];
  overallWeightUtilizationPct?: Maybe<Scalars['Float']['output']>;
  rows: Array<LineHaulUtilizationRowEntity>;
  totalEquivalentEmptyTrailers: Scalars['Float']['output'];
  totalLoadedWeightLbs: Scalars['Float']['output'];
  totalManifests: Scalars['Int']['output'];
  totalTrailers: Scalars['Int']['output'];
  totalWeightCapacityLbs: Scalars['Float']['output'];
  usedDefaultCapacity: Scalars['Boolean']['output'];
};

export type LineHaulUtilizationRowEntity = {
  __typename?: 'LineHaulUtilizationRowEntity';
  cubeCapacityCubicFeet: Scalars['Float']['output'];
  cubeUtilizationPct?: Maybe<Scalars['Float']['output']>;
  equivalentEmptyTrailers: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  laneBalancePct?: Maybe<Scalars['Float']['output']>;
  loadedCubeCubicFeet: Scalars['Float']['output'];
  loadedWeightLbs: Scalars['Float']['output'];
  manifestCount: Scalars['Int']['output'];
  reverseLoadedWeightLbs?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<LineHaulUtilizationStatus>;
  trailerCount: Scalars['Int']['output'];
  utilizationPct?: Maybe<Scalars['Float']['output']>;
  weightCapacityLbs: Scalars['Float']['output'];
  weightUtilizationPct?: Maybe<Scalars['Float']['output']>;
};

/** Trailer utilization standing used by the Intelligence Board linehaul report. */
export enum LineHaulUtilizationStatus {
  PoorlyUtilized = 'POORLY_UTILIZED',
  Underutilized = 'UNDERUTILIZED',
  WellUtilized = 'WELL_UTILIZED'
}

export enum LinehaulDispatchTableField {
  CustomerName = 'CUSTOMER_NAME',
  DeadlineDate = 'DEADLINE_DATE',
  DimWeight = 'DIM_WEIGHT',
  Hawb = 'HAWB',
  InboundAddressName = 'INBOUND_ADDRESS_NAME',
  IsHazmat = 'IS_HAZMAT',
  IsSpecial = 'IS_SPECIAL',
  Lane = 'LANE',
  Mawb = 'MAWB',
  Name = 'NAME',
  NextSegment = 'NEXT_SEGMENT',
  OutboundAddressName = 'OUTBOUND_ADDRESS_NAME',
  PieceCount = 'PIECE_COUNT',
  Segment = 'SEGMENT',
  Service = 'SERVICE',
  ServiceDate = 'SERVICE_DATE',
  Tags = 'TAGS',
  Weight = 'WEIGHT'
}

export type LinkPieceError = {
  __typename?: 'LinkPieceError';
  pieceUuid: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type LinkPieceToOrderInput = {
  orderUuid: Scalars['String']['input'];
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid: Scalars['String']['input'];
};

export type LinkPieceToPackageInput = {
  packageUuid: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};

export type LinkPiecesToPackageInput = {
  packageUuid: Scalars['String']['input'];
  pieceUuids: Array<Scalars['String']['input']>;
};

export type LinkPiecesToPackageOutput = {
  __typename?: 'LinkPiecesToPackageOutput';
  errors: Array<LinkPieceError>;
  linkedPieces: Array<PieceEntity>;
  success: Scalars['Boolean']['output'];
};

export type LoadPlacementInput = {
  h: Scalars['Float']['input'];
  l: Scalars['Float']['input'];
  packageUuid: Scalars['String']['input'];
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  rotated: Scalars['Boolean']['input'];
  trailerEquipmentUuid?: InputMaybe<Scalars['String']['input']>;
  unitIndex?: InputMaybe<Scalars['Int']['input']>;
  w: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

export enum LoadPosition {
  Nose = 'NOSE',
  Tail = 'TAIL'
}

export type LocationSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type LogUnassignedScanInput = {
  barcode: Scalars['String']['input'];
  scanType?: InputMaybe<ScanType>;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type LoginInput = {
  clientUuid?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginOutput = {
  __typename?: 'LoginOutput';
  clientChallenge?: Maybe<Array<ClientChallengeEntity>>;
  driver?: Maybe<DriverEntity>;
  /** @deprecated Use kind to disambiguate instead */
  fullAccessUser?: Maybe<UserEntity>;
  kind?: Maybe<Scalars['String']['output']>;
  status: LoginStatus;
  /** @deprecated Use kind to disambiguate instead */
  thirdPartyUser?: Maybe<ThirdPartyUserEntity>;
};

export type LoginPhoneInput = {
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type LoginPhoneJwtInput = {
  jwt: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type LoginPhoneOutput = {
  __typename?: 'LoginPhoneOutput';
  driver?: Maybe<DriverEntity>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  status: LoginStatus;
  warehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
};

export enum LoginStatus {
  ClientChallenge = 'CLIENT_CHALLENGE',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  Success = 'SUCCESS',
  ThirdPartyUserNoOrganization = 'THIRD_PARTY_USER_NO_ORGANIZATION',
  Unauthorized = 'UNAUTHORIZED'
}

export type MakeAppointmentConfirmationDecisionInput = {
  accepted: Scalars['Boolean']['input'];
  stopUuid: Scalars['String']['input'];
};

export type MakeAppointmentConfirmationDecisionOutput = AppointmentConfirmationInfoOutput | MutationErrorOutput;

export type ManifestGroup = {
  __typename?: 'ManifestGroup';
  category: LineHaulManifestsGroupBy;
  manifests: Array<LineHaulManifestEntity>;
};

export type ManifestUuidsInput = {
  manifestUuids: Array<Scalars['String']['input']>;
};

export type ManualStandardStopTypeForAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type MapPeerAccessorialInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  mappingUuid: Scalars['String']['input'];
};

export type MapPeerServiceInput = {
  mappingUuid: Scalars['String']['input'];
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
};

export type MarkAsNotOnHandInput = {
  /** The UUID of the order to mark not on hand */
  uuid: Scalars['String']['input'];
};

export type MarkAsNotReceivedAtOriginInput = {
  /** The UUID of the order to mark not received at origin terminal */
  uuid: Scalars['String']['input'];
};

export type MarkAsOnHandInput = {
  pieceCount?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkAsOnHoldInput = {
  holdReasonUuid?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkAsReceivedAtOriginInput = {
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkConsolidatableOrdersAsBilledIndividuallyInput = {
  orderUuid: Scalars['String']['input'];
};

export type MarkManifestAsArrivedInput = {
  /** Set when the caller has confirmed arriving a run that never departed. Without it the mutation refuses, as it always has; the board sets it only after the dispatcher has been shown how much of the run was loaded and has accepted. */
  confirmedWithoutDeparture?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the manifest arrival is being marked from the line haul dispatch screen. Used as part of the business logic to determine if the manifest should be marked as on hand. */
  fromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkManifestAsArrivedOutput = {
  __typename?: 'MarkManifestAsArrivedOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type MarkManifestAsDepartedInput = {
  uuid: Scalars['String']['input'];
};

export type MarkManifestAsDepartedOutput = {
  __typename?: 'MarkManifestAsDepartedOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type MarkManifestAsDoorsClosedInput = {
  uuid: Scalars['String']['input'];
};

export type MarkManifestAsDoorsClosedOutput = {
  __typename?: 'MarkManifestAsDoorsClosedOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type MarkManifestAsPlanningInput = {
  uuid: Scalars['String']['input'];
};

export type MarkManifestAsPlanningOutput = {
  __typename?: 'MarkManifestAsPlanningOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulManifest?: Maybe<LineHaulManifestEntity>;
};

export type MarkNotOsdInput = {
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkNotificationReadInput = {
  uuid: Scalars['String']['input'];
};

export type MarkOrderAsCompleteForceInput = {
  refuseOrderInput?: InputMaybe<RefuseOrderInput>;
  uuid: Scalars['String']['input'];
};

export type MarkOrderAsPickedInput = {
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

/** The expected input to the mutation that marks an order as refused, records who it was refused by, and when it was refused */
export type MarkOrderAsRefusedInput = {
  /** The person that the order was refused by */
  refusedBy: Scalars['String']['input'];
  /** The date and time when the order was marked as refused */
  refusedDate: Scalars['DateTime']['input'];
  /** Why the consignee refused it, in the driver's words */
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  /** The structured reason the consignee refused it, for outbound EDI. The free-text refusedReason carries the detail. */
  refusedReasonCode?: InputMaybe<OrderRefusalReason>;
  /** The UUID of the order to mark as refused */
  uuid: Scalars['String']['input'];
};

export type MarkOrderAsRefusedOutput = MarkOrderAsRefusedSuccessOutput | MutationErrorOutput;

export type MarkOrderAsRefusedSuccessOutput = {
  __typename?: 'MarkOrderAsRefusedSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type MarkOsdInput = {
  /** @deprecated Use `osdReason` instead */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Include any notes provided on why the order was OSD */
  osdReason?: InputMaybe<Scalars['String']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkPieceDamagedInput = {
  osdReason?: InputMaybe<Scalars['String']['input']>;
  pieceUuid: Scalars['String']['input'];
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarkQuoteSentInput = {
  orderQuoteUuid: Scalars['String']['input'];
};

export type MarkQuoteSentOutput = MarkQuoteSentSuccessOutput | MutationErrorOutput;

export type MarkQuoteSentSuccessOutput = {
  __typename?: 'MarkQuoteSentSuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
  /** The charge-row sum pinned at send */
  quotedAmountCents: Scalars['Int']['output'];
  sentAt: Scalars['DateTime']['output'];
  status: OrderQuoteStatus;
  validUntil: Scalars['DateTime']['output'];
};

export type MarkStopAsFailedV2Input = {
  attemptedAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitAsBilledInput = {
  /** The UUID of the storage unit to mark as billed */
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitAsBilledOutput = {
  __typename?: 'MarkStorageUnitAsBilledOutput';
  success: Scalars['Boolean']['output'];
};

export type MarkStorageUnitAsOsdInput = {
  osdReason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitAsOsdOutput = {
  __typename?: 'MarkStorageUnitAsOsdOutput';
  success: Scalars['Boolean']['output'];
};

export type MarkStorageUnitOnHandInput = {
  uuid: Scalars['String']['input'];
};

export type MarkStorageUnitOnHandOutput = {
  __typename?: 'MarkStorageUnitOnHandOutput';
  success: Scalars['Boolean']['output'];
};

export type MarkTestOrderForEdiReviewInput = {
  orderUuid: Scalars['String']['input'];
};

export type MasterAccountEntity = {
  __typename?: 'MasterAccountEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum MatcherType {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  NotContains = 'NOT_CONTAINS',
  NotEndsWith = 'NOT_ENDS_WITH',
  NotStartsWith = 'NOT_STARTS_WITH',
  Regex = 'REGEX',
  RegexNoMatch = 'REGEX_NO_MATCH',
  StartsWith = 'STARTS_WITH'
}

export type MatchingGroupsAlongWithMatchingServices = {
  __typename?: 'MatchingGroupsAlongWithMatchingServices';
  /** the services in that group that has a match */
  serviceUuids: Array<Scalars['String']['output']>;
  /** the tariff group that has this combination */
  tariffGroupName?: Maybe<Scalars['String']['output']>;
  /** the tariff group uuid that has this combination */
  tariffGroupUuid: Scalars['String']['output'];
};

export type MawbSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum MeasurementSystem {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC'
}

export enum MeasurementUnits {
  Centimeters = 'CENTIMETERS',
  Inches = 'INCHES'
}

export type MergeEdiOrderInput = {
  existingOrderUuid: Scalars['String']['input'];
  incomingEdiOrderUuid: Scalars['String']['input'];
};

export type MergeEdiOrderOutput = {
  __typename?: 'MergeEdiOrderOutput';
  uuid: Scalars['String']['output'];
};

export type MergeScannedOrderResultIntoPossibleDuplicateInput = {
  scannedOrderResultUuid: Scalars['String']['input'];
};

export type MetricTagInput = {
  tag: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum MetricType {
  Count = 'COUNT',
  Distribution = 'DISTRIBUTION',
  Gauge = 'GAUGE'
}

export type MigratableCompanyObject = {
  __typename?: 'MigratableCompanyObject';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** Environments the config-migration tool can read from or write to. */
export enum MigrationEnv {
  Demo = 'DEMO',
  Development = 'DEVELOPMENT',
  Localdev = 'LOCALDEV',
  Production = 'PRODUCTION',
  Release = 'RELEASE',
  Staging = 'STAGING'
}

export type MirrorSyncRequestEntity = {
  __typename?: 'MirrorSyncRequestEntity';
  companyUuids: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Orders the target newly created, out of those sent. */
  createdCount?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /** Orders the target already had (idempotent re-sync skips). */
  existedCount?: Maybe<Scalars['Int']['output']>;
  fromDateTime: Scalars['DateTime']['output'];
  /** Orders sent to the target (attempted). */
  matchedCount?: Maybe<Scalars['Int']['output']>;
  scope: Scalars['String']['output'];
  status: Scalars['String']['output'];
  toDateTime: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type MirrorSyncableCompanyEntity = {
  __typename?: 'MirrorSyncableCompanyEntity';
  companyUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MirrorTargetCompanyEntity = {
  __typename?: 'MirrorTargetCompanyEntity';
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type MirrorTargetEntity = {
  __typename?: 'MirrorTargetEntity';
  batchSize: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  /** Number of companies this target mirrors via the live cron. */
  mirroredCompanyCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subscribesToAllCompanies: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type MissingOrderForInvoiceMoveEntity = {
  __typename?: 'MissingOrderForInvoiceMoveEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum MobileRole {
  Driver = 'DRIVER',
  WarehouseEmployee = 'WAREHOUSE_EMPLOYEE'
}

export type MotiveIntegrationEntity = {
  __typename?: 'MotiveIntegrationEntity';
  /** Whether the company has a stored Motive API key. */
  connected: Scalars['Boolean']['output'];
};

export type MoveBetweenRunsInput = {
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  packageUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceManifestUuid: Scalars['String']['input'];
  targetManifestUuid: Scalars['String']['input'];
};

export type MoveShipmentsBetweenInvoicesIncompleteOperationOutput = {
  __typename?: 'MoveShipmentsBetweenInvoicesIncompleteOperationOutput';
  /** The list of shipment UUIDs that need to also be moved for the operation to be completed successfully. For example we want to move all shipments of a consolidated order even though we only specified some in the input. */
  additionalShipmentUuidsToMove: Array<Scalars['String']['output']>;
  /** The list of shipment UUIDs that were specified in the input. */
  inputShipmentUuids: Array<Scalars['String']['output']>;
  /** The list of orders that are missing for the operation to be completed successfully. For example we want to move all shipments of a consolidated order even though we only specified some in the input. */
  missingOrders: Array<MissingOrderForInvoiceMoveEntity>;
};

/** The input to move shipments to a new invoice */
export type MoveShipmentsBetweenInvoicesInput = {
  /** The uuid of the invoice that we want to move the shipments from. */
  invoiceMovingFromUuid: Scalars['String']['input'];
  /** The uuid of the new invoice that we want to move the shipments to. If null, the shipments will be moved to a newly created invoice. */
  invoiceMovingToUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentUuids: Array<Scalars['String']['input']>;
};

export type MoveShipmentsBetweenInvoicesOutput = MoveShipmentsBetweenInvoicesIncompleteOperationOutput | MoveShipmentsBetweenInvoicesSuccessOutput | MutationErrorOutput;

export type MoveShipmentsBetweenInvoicesSuccessOutput = {
  __typename?: 'MoveShipmentsBetweenInvoicesSuccessOutput';
  /** The list of shipment UUIDs that were successfully moved to the new invoice */
  movedShipmentUuids: Array<Scalars['String']['output']>;
  /** The uuid of the new invoice that we moved the shipments to */
  newInvoiceUuid: Scalars['String']['output'];
};

export type MoveShipmentsToInvoiceInput = {
  invoiceUuid: Scalars['String']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type MoveShipmentsToInvoiceOutput = {
  __typename?: 'MoveShipmentsToInvoiceOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * UUID of target invoice
   * @deprecated Added for backwards compatibility
   */
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptCustomerPortalOrder: AcceptCustomerPortalOrderOutput;
  acceptEdiOrApiOrder: AcceptEdiOrApiOrderOutput;
  /** Accept an Expeditors work order and notify their API */
  acceptExpeditorsWorkOrder: Scalars['Boolean']['output'];
  acceptOrderDelegation: DelegatedOrderInboxItemEntity;
  acceptOrganizationPeer: OrganizationPeerEntity;
  acknowledgeFailedInvoiceSendJobs: InvoiceSendJobBatchEntity;
  /** Acknowledge changes to all stops for the current driver */
  acknowledgeMyRouteChanges: Scalars['Int']['output'];
  /** Acknowledge changes to a specific stop for the current driver */
  acknowledgeMyStopChange: AcknowledgeMyStopChangeOutput;
  acknowledgeNotification: NotificationEntity;
  acknowledgeNotifications: Array<NotificationEntity>;
  acknowledgeQuoteAttention: AcknowledgeQuoteAttentionOutput;
  addApiUserContactMapping: ApiUserEntity;
  addDriverExpoPushToken?: Maybe<DriverEntity>;
  addDriversToRoute: Array<RouteDriverEntity>;
  /** Given lists of settlement bill line items, will create new settlement bill line items and update existing ones */
  addLineItemsToSettlementBills: AddLineItemsToSettlementBillsOutput;
  addNextRouteSlotForRoute: RouteEntity;
  addOrdersToInvoices: AddOrdersToInvoicesOutput;
  addOrdersToManifest: AddOrdersToManifestOutput;
  addOrdersToManifestV2: AddOrdersToManifestV2Output;
  /** Adds pieces to a receipt by creating new pieces and/or linking existing ones. Used by both web and mobile. */
  addPiecesToPieceReceipt: AddPiecesToPieceReceiptOutput;
  addQuickbooksDesktopCustomer: QuickbooksDesktopResultEntity;
  addQuickbooksDesktopCustomers: Array<QuickbooksDesktopResultEntity>;
  addQuickbooksDesktopItem: QuickbooksDesktopResultEntity;
  addRouteStop: StopEntity;
  addServiceToContact: ServiceEntity;
  /** Finds existing contact-to-services mappings and adds the specified services */
  addServicesToTariffGroupMappings: Array<ContactToServicesTariffGroupMappingEntity>;
  addTagToLeg: TagEntity;
  addTagToOrder: TagEntity;
  addTestAccessorialCharge: AddTestAccessorialChargeOutput;
  addThirdPartyUserToContact: ThirdPartyUserEntity;
  addUserToRole: AddUserToRoleOutput;
  adminSyncInvoicesToQuickbooks: SyncInvoicesToQuickbooksOutput;
  adoptDriverSettlementPayTerms: Array<AdoptDriverSettlementPayTermsResult>;
  advanceOutboundBenchOrders: BenchRunReportEntity;
  apiKeyAdminConnectOrgs: ApiKeyAdminDetailEntity;
  apiKeyAdminCreate: ApiKeyAdminEntity;
  apiKeyAdminDelete: Scalars['Boolean']['output'];
  apiKeyAdminDisconnectOrg: ApiKeyAdminDetailEntity;
  apiKeyAdminImportCsv: ApiKeyAdminCsvImportReport;
  apiKeyAdminSetMappingTemplate: ApiKeyAdminWebhookShapeConfigEntity;
  apiKeyAdminSetStatusMappings: Array<ApiKeyAdminStatusMappingEntity>;
  apiKeyAdminUpdate: ApiKeyAdminEntity;
  applyDebitToPayment: PaymentToPaymentMappingEntity;
  applyDelegationAccessorialProposal: DelegationAccessorialProposalEntity;
  applyRouteOptimization: Scalars['Int']['output'];
  approveQuote: QuoteEntity;
  approveQuoteReply: ApproveQuoteReplyOutput;
  archiveAirportInfo: AirportInfoUpdateOutput;
  archiveContactStation: ContactStationUpdateOutput;
  archiveDriver: UpdateDriverOutput;
  archiveOrganization: ArchiveOrganizationOutput;
  archivePackageSpec: UpdatePackageSpecOutput;
  archivePerson: UpdatePersonOutput;
  archiveSchedulingRegion: UpdateSchedulingRegionOutput;
  archiveSchedulingResource: SchedulingResourceOutput;
  archiveTariffChain: ArchiveTariffChainOutput;
  archiveTariffZoneGroup: TariffZoneGroupArchiveOutput;
  archiveVehicleType: VehicleTypeUpdateOutput;
  /** Archive a warehouse employee (TMS-1562): the employee can no longer log in and their phone number is released for reuse by a new employee. Their existing mobile sessions are revoked. */
  archiveWarehouseEmployee: UpdateWarehouseEmployeeOutput;
  arriveAtStop: StopEntity;
  arriveAtStops: ArriveAtStopsOutput;
  assignDockDoor: Array<DockDoorEntity>;
  assignHelperToRoute: Array<DriverOnRouteEntity>;
  assignInventoryItemsToStorageUnit: AssignInventoryItemsToStorageUnitOutput;
  assignOrderToLineHaulTrailer: Scalars['Boolean']['output'];
  assignOutboundReferenceNumbersToStorageUnits: AssignOutboundReferenceNumberToStorageUnitsOutput;
  attachMobileSignedDocumentToOrderAndReplaceOriginal: UploadMobileSignedDocumentOutput;
  /** Runs the v2 auto-routing pipeline for the calling company. dryRun controls whether the transaction commits. */
  autoCreateRoutesV2: AutoCreateRoutesV2Output;
  backfillContactCommunicationConfigs: Scalars['String']['output'];
  backfillFuelProfileDateRangeRates?: Maybe<Scalars['Float']['output']>;
  backfillItemGroups: Scalars['Boolean']['output'];
  /** Backfill order totals for orders that do not have a total amount stored. */
  backfillOrderTotals: BackfillOrderTotalsOutput;
  backfillSettlementDate: Scalars['Float']['output'];
  backfillTariffZoneGroups: Scalars['String']['output'];
  backfillTariffZoneGroupsForCompany: Scalars['String']['output'];
  batchAddShipmentsToInvoicesMultiple: Array<InvoiceEntity>;
  /** Closes one calendar day for every scheduling resource in the company except those exempted from it. TWO-PHASE when the day carries booked capacity: without confirmLiveClaims the call writes NOTHING and returns CompanySchedulingDayLiveClaimsOutput naming what would be closed over, and sending the same input again with confirmLiveClaims applies it. A day carrying no claims is closed on the first call. The claims are neither cancelled nor moved either way. Closing a day that is already closed replaces its reason, keeps the exemptions already granted, and needs no confirmation. */
  blockCompanySchedulingDay: CompanySchedulingBlockedDayOutput;
  blockSchedulingResourceDay: SchedulingResourceOutput;
  /** Book the chosen appointment window, or move an existing booking onto it. Idempotent under double submission. A window that filled while the customer was choosing is refused with a fresh list of alternatives rather than an error. */
  bookCustomerAppointment: BookCustomerAppointmentOutput;
  bulkChangeCallStatus: Scalars['Float']['output'];
  bulkConfirmAppointments: Scalars['Float']['output'];
  /** Queues one full delegation offer per order to a partner and returns the batch to poll with bulkDelegationBatch. */
  bulkDelegateOrders: BulkDelegationBatchEntity;
  bulkDeletePieces: BulkPiecesActionOutput;
  bulkDiscardPieces: BulkPiecesActionOutput;
  bulkEditOrders: BulkEditOrdersResponse;
  bulkRestorePieces: BulkPiecesActionOutput;
  bulkUnconfirmAppointments: Scalars['Int']['output'];
  bulkUpdateAccessorialMappings: Array<AccessorialUnion>;
  bulkUpdateContactQuickbooksIds: Array<CustomerContactEntity>;
  bulkUploadRouteNames: Array<RouteNameEntity>;
  calculateRouteEtas: Array<EtaEntity>;
  callStops: Array<StopEntity>;
  calmAddStopToRoute: Scalars['Boolean']['output'];
  calmAssignLineHaulRoute: AssignLineHaulRouteOutput;
  calmAssignPackagesToManifest: Scalars['Boolean']['output'];
  calmLoadOrdersOnManifest: Scalars['Boolean']['output'];
  calmMoveOrderBetweenRuns: Scalars['Boolean']['output'];
  calmRemovePackagesFromManifest: Scalars['Boolean']['output'];
  calmRepointOrderFreight: RepointOrderFreightEntity;
  calmSaveManifestPlacements: CalmSavePlacementsResultEntity;
  calmSetCrossdockInstruction: Scalars['Boolean']['output'];
  calmSetPndRouteDriver: Scalars['Boolean']['output'];
  cancelDocExtractionEvalRun: DocExtractionCancelEvalRunResultEntity;
  cancelPackingPendency: CancelPackingPendencyOutput;
  chooseAppointmentOption: ChooseAppointmentOptionOutput;
  /** Clears a company. Only intended to be called via this Relay Workflow: https://run.relay.app/workflows/cm2dz61pm03eo0qlx5tb43i1q/edit. Accordingly, returns early to avoid Relay timing out. */
  clearCompany: Scalars['Int']['output'];
  clearCompanyContacts: ClearCompanyContactsOutput;
  clearDriverSettlementPayBound: Array<DriverSettlementPayBoundEntity>;
  clearOrderExecutedBy: Scalars['Boolean']['output'];
  clearOrderMirrorOutbox: Scalars['Int']['output'];
  cloneSavedFilterView: SavedFilterViewEntity;
  closeInventoryCount: CloseInventoryCountOutput;
  completeRebill: CompleteRebillOutput;
  completeStopBulk: Array<StopEntity>;
  completeStopV2: CompleteStopOutput;
  completeWorkOrderLoading: CompleteWorkOrderLoadingOutput;
  confirmInventoryCountLines: ConfirmInventoryCountLinesOutput;
  confirmQuoteAcceptance: ConfirmQuoteAcceptanceOutput;
  connectToQuickbooksDesktop: Scalars['String']['output'];
  createAccessorial: AccessorialUnion;
  createAccessorialContact: CreateAccessorialContactOutput;
  createAccessorialDateRangeConfig: CreateAccessorialDateRangeConfigOutput;
  createAccessorialGroup: AccessorialGroupEntity;
  createAccessorialToQuickbooksMapping: AccessorialToQuickbooksMappingEntity;
  createAccountingReportDocument: CreateAccountingReportDocumentOutput;
  createAddress: AddressEntity;
  createAdjustmentStopDriverMap?: Maybe<StopDriverMapEntity>;
  createAirportInfo: AirportInfoEntity;
  createApiUser: ApiUserEntity;
  createAppointmentsForRoute: RouteEntity;
  createAutoApplyAccessorialConfig: AutoApplyAccessorialConfigEntity;
  createBusinessDivision: CreateBusinessDivisionOutput;
  createCompany: CompanyEntity;
  createConsolidatedOrder: OrderEntity;
  createConsolidatedOrderFromOrder: OrderEntity;
  createContactComment: ContactCommentEntity;
  /** @deprecated Use updateContactEmails instead. */
  createContactCommunicationConfig: ContactCommunicationConfigEntity;
  createContactDocument: DocumentEntity;
  /** @deprecated Should be used only for invoice subscriptions. Use updateContactEmails for order update subscriptions. */
  createContactEmail?: Maybe<ContactEmailEntity>;
  createContactPerson: ContactPersonEntity;
  createContactStation: ContactStationCreateOutput;
  createCoverSheetDocumentTypeSequence: CoverSheetDocumentTypeSequenceEntity;
  createCreditType: CreditTypeEntity;
  createCsvOrderFieldMapping: CsvOrderFieldMappingEntity;
  createCsvOrderImportTransaction: CsvOrderImportTransactionEntity;
  createCsvOrderMapping: CsvOrderMappingEntity;
  createCustomerContact: CustomerContactEntity;
  createCustomerContacts: CreateCustomerContactsOutput;
  createDispatchView: DispatchViewCreateOutput;
  createDocExtractionEvalRun: DocExtractionLaunchEvalRunResultEntity;
  createDocExtractionEvalSet: DocExtractionCreatedEvalSetEntity;
  createDocument: DocumentEntity;
  createDriver?: Maybe<DriverEntity>;
  createDriverCredentialType: DriverCredentialTypeEntity;
  createDriverInsurancePolicy: DriverComplianceEntity;
  createDriverSettlementBill: DriverSettlementBillEntity;
  createDriverSignableFormTemplate: DriverSignableFormTemplateEntity;
  createDriverTrainingRecord: DriverComplianceEntity;
  createDrivers: CreateDriversOutput;
  createDuplicateOrderForRebill: CreateDuplicateOrderForRebillOutput;
  createDwellTimeAlertConfig: DwellTimeAlertConfigEntity;
  createEODDocuments: Array<DocumentEntity>;
  createEdiPartnership: EdiPartnershipEntity;
  createEdiPartnershipServiceMappings: CreateEdiPartnershipServiceMappingsOutput;
  /** Use sparingly, not meant for regular use */
  createEdiTransaction: CreateEdiTransactionOutput;
  createEmailTransaction: CreateEmailTransactionOutput;
  createEmailTransactionLog: EmailTransactionLogEntity;
  createEndOfDayDocumentProcessingJob: EndOfDayDocumentProcessingJobEntity;
  createEquipment: EquipmentEntity;
  createEquipmentLicense: EquipmentLicenseEntity;
  createEquipments: CreateEquipmentsOutput;
  createFeatureFlag: FeatureFlagEntity;
  createFeatureFlagCompanyOverride: FeatureFlagCompanyOverrideEntity;
  createFeatureFlagUserOverride?: Maybe<FeatureFlagUserOverrideEntity>;
  createFreightCharge: FreightChargeEntity;
  createFuelProfile?: Maybe<FuelProfileEntity>;
  createFuelProfileDateRange: CreateFuelProfileDateRangeOutput;
  createGeneralLedgerCode: CreateGeneralLedgerCodeOutput;
  createGeneralLedgerConfiguration: GeneralLedgerConfigurationEntity;
  createHoldReason: HoldReasonEntity;
  createImportedOrderTypeMapping: ImportedOrderTypeMappingEntity;
  createImportedOrderTypeMappings: Array<ImportedOrderTypeMappingEntity>;
  createIngestionTestUpload: IngestionTestUploadEntity;
  /** @deprecated Deprecated. Use upsertItemGroup instead */
  createInventoryItems: CreateInventoryItemsOutput;
  createInventoryPrimaryUnitOfMeasure: InventoryPrimaryUnitOfMeasureEntity;
  createInventorySecondaryUnitOfMeasure: InventorySecondaryUnitOfMeasureEntity;
  createInvoice: InvoiceEntity;
  createInvoiceDocument: DocumentEntity;
  createInvoiceDocuments: Array<DocumentEntity>;
  createInvoiceNoteRule: InvoiceNoteRuleEntity;
  createInvoiceTerms: InvoiceTermEntity;
  createInvoiceTermsForAll: Scalars['Boolean']['output'];
  createItem: CreateItemOutput;
  createItemLocation: CreateItemLocationOutput;
  createLeg: LegEntity;
  /** This is probably not the method you want to use */
  createLegDriverMap: LegDriverMapEntity;
  createLineHaulLane: CreateLineHaulLaneOutput;
  createLineHaulManifest: LineHaulManifestEntity;
  createLineHaulManifests: CreateLineHaulManifestsOutput;
  createLineHaulSegment: CreateLineHaulSegmentOutput;
  createLineHaulTruckRuns: Scalars['Int']['output'];
  createManyReferenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  createMasterAccount: CreateMasterAccountOutput;
  createMirrorTarget: MirrorTargetEntity;
  createNotification: NotificationEntity;
  createOrUpdateCsvOrders: CreateOrUpdateCsvOrdersOutput;
  createOrderComment: OrderCommentEntity;
  createOrderDelegationRule: OrderDelegationRuleEntity;
  createOrderDocument: DocumentEntity;
  createOrderDocumentDocument: CreateOrderDocumentDocumentOutput;
  createOrderImportConfiguration: OrderImportConfigurationEntity;
  createOrderLineHaulSegment: OrderLineHaulSegmentEntity;
  createOrderSnapshot?: Maybe<OrderEventEntity>;
  createOrderTableReport: CreateOrderTableReportOutput;
  createOrdersFromRecurringTemplates: Array<OrderEntity>;
  createOrganization: CreateOrganizationOutput;
  createOrganizationMessage: OrganizationMessageEntity;
  createOrganizationPeer: OrganizationPeerEntity;
  createOutboundBenchOrders: BenchCreatedOrdersEntity;
  createOutlookIntegration: OutlookIntegrationEntity;
  createPODReportDocument: CreatePodReportDocumentOutput;
  /** @deprecated Do not create packages directly */
  createPackage: PackageEntity;
  createPackageSpec: CreatePackageSpecOutput;
  createPackingPendency: CreatePackingPendencyOutput;
  createPayment: PaymentEntity;
  createPdfColumn: PdfColumnEntity;
  createPermission: CreatePermissionOutput;
  createPerson: CreatePersonOutput;
  /** @deprecated Use upsertPicklist instead */
  createPicklist: UpsertPicklistOutput;
  createPiece: PieceEntity;
  createPieceDocument: DocumentEntity;
  createPieceReceipt: CreatePieceReceiptOutput;
  /** Creates one or more orphan pieces (no parent order) under the same barcode. Returns the created pieces in order. */
  createPieceWithoutOrder: Array<PieceEntity>;
  createPlace: PlaceEntity;
  createProratedConsolidatedOrder: CreateProratedConsolidatedOrderOutput;
  createQuickbooksHeaderFileMapping: QuickbooksHeaderFileMappingEntity;
  createQuote: QuoteEntity;
  createQuoteAgentForwardingAddress: CreateQuoteAgentForwardingAddressOutput;
  createRecurringLineHaulManifestTemplate: RecurringLineHaulManifestTemplateEntity;
  createRecurringOrderFrequency: RecurringOrderFrequencyEntity;
  createRecurringOrdersFromTemplates: Scalars['Boolean']['output'];
  createRecurringTemplateTruck: RecurringTemplateTruckEntity;
  createReportGroupConfiguration: ReportGroupConfigurationEntity;
  createReverseOrder: OrderEntity;
  createRole: CreateRoleOutput;
  createRoute: RouteEntity;
  /** This is probably not the API you want to use */
  createRouteDriver: RouteDriverEntity;
  createRouteFromRouteTemplate: CreateRouteFromRouteTemplateOutput;
  createRouteName: RouteNameEntity;
  createRouteNameLocation: RouteNameLocationEntity;
  createRouteOptimization: RouteOptimizationEntity;
  createRoutePaths: Array<Maybe<RoutePathEntity>>;
  createRouteSlot: Array<Maybe<RouteSlotEntity>>;
  createRoutes: Array<RouteEntity>;
  createRun: CreateRunOutput;
  createSameDayDispatchConfig: SameDayDispatchConfigEntity;
  createSamsaraOauthToken: SamsaraOauthTokenEntity;
  /** Development-only route for creating sandbox routes for a driver */
  createSandboxRouteForDriver?: Maybe<Scalars['Boolean']['output']>;
  createSavedFilterView: SavedFilterViewEntity;
  createScannedOrders: Array<Scalars['String']['output']>;
  createScannedOrdersFromAdmin: Array<ScannedOrderFromAdminCreateOutput>;
  createSchedulingRegion: CreateSchedulingRegionOutput;
  createSchedulingResource: SchedulingResourceOutput;
  createSchedulingZone: CreateSchedulingZoneOutput;
  createSchema: Scalars['String']['output'];
  createSchemaCompanyMapping: Scalars['String']['output'];
  createSchemaDocument: SchemaDocumentEntity;
  createSchemaTestSnapshot: Scalars['String']['output'];
  createService: ServiceEntity;
  createServiceGroup: ServiceGroupEntity;
  /** Creates new service regions for the current company. Automatically removes duplicate regions with the same name from the input. Existing regions remain unchanged. */
  createServiceRegions: CreateServiceRegionsOutput;
  createSettlementAdjustment: CreateOrUpdateSettlementAdjustmentOutput;
  /** @deprecated Deprecated during Robust Settlement Project. Use `createSettlementAdjustment` instead */
  createSettlementDeduction: SettlementDeductionEntity;
  createSettlementDeductionType: SettlementDeductionTypeEntity;
  createSftpCredentials: CreateSftpCredentialsOutput;
  createShipmentDocument: DocumentEntity;
  createStandardOrder: StandardOrderEntity;
  createStandardOrderFields: StandardOrderFieldsEntity;
  createStandardOrderWithDuplicateResolution: StandardOrderEntity;
  createStandardShipmentFields: StandardShipmentFieldsEntity;
  createStorageOrder: CreateStorageOrderOutput;
  createStorageOrderDocument: CreateStorageOrderDocumentOutput;
  createStorageUnit: CreateStorageUnitOutput;
  /** @deprecated Deprecated. Use createStorageUnit instead */
  createStorageUnitWithInventoryItems: CreateStorageUnitWithInventoryItemsOutput;
  createTag: TagEntity;
  createTariff: CreateTariffOutput;
  createTariffChain: CreateTariffChainOutput;
  createTariffGroup: TariffGroupEntity;
  createTariffLocation: CreateTariffLocationOutput;
  createTariffZone: TariffZoneEntity;
  createTariffZoneGroup: TariffZoneGroupCreateOutput;
  /** @deprecated Use createTerminalV2 instead */
  createTerminal: CreateTerminalOutput;
  createTerminalLanes: CreateTerminalLanesOutput;
  /** @deprecated Deprecating because we are removing zip+city uniqueness constraint and this is not used by the frontend. Use createTerminalServiceAreasV2 instead */
  createTerminalServiceArea: TerminalServiceAreaEntity;
  /** @deprecated Deprecating because we are removing zip+city uniqueness constraint. Use createTerminalServiceAreasV2 instead */
  createTerminalServiceAreas: Array<CreateTerminalServiceAreaOutput>;
  createTerminalServiceAreasV2: CreateTerminalServiceAreaV2Output;
  createTerminalV2: CreateTerminalV2Output;
  createTerminals: Scalars['Int']['output'];
  createTestAbstainedScannedOrder: CreateTestAbstainedScannedOrderOutput;
  createTestAccessorial: CreateTestAccessorialOutput;
  createTestApiOrder: TestApiOrderResult;
  createTestCompany: CreateTestCompanyOutput;
  createTestContact: CreateTestContactOutput;
  createTestDelegatableOrder: CreateTestDelegatableOrderOutput;
  createTestEdiOrder: TestEdiOrderResult;
  createTestOrder: CreateTestOrderOutput;
  createTestOrderCustomCharge: CreateTestOrderCustomChargeOutput;
  createTestOrderDelegation: CreateTestOrderDelegationOutput;
  createTestOrderQuote: CreateTestOrderQuoteOutput;
  createTestOrderV2: CreateTestOrderResponse;
  createTestOrganizationPeer: CreateTestOrganizationPeerOutput;
  createTestPiecesOnOrder: CreateTestPiecesOutput;
  createTestReviewOrder: CreateTestReviewOrderOutput;
  createTestTerminalLane: Scalars['Boolean']['output'];
  createTestThirdPartyUser: CreateTestThirdPartyUserOutput;
  createTestUser?: Maybe<UserEntity>;
  createThirdPartyBroker: ThirdPartyBrokerEntity;
  createUser?: Maybe<UserEntity>;
  createUserV2: CreateUserOutput;
  createVehicleType: VehicleTypeEntity;
  createWarehouse: WarehouseEntity;
  createWarehouseEmployee: CreateWarehouseEmployeeOutput;
  createWarehouseLocation: CreateWarehouseLocationOutput;
  deactivateTestTerminal: Scalars['Boolean']['output'];
  /** Tell the carrier that none of the offered times work, which hands the shipment to the scheduling team. When an appointment was already booked through this link, this cancels it: the capacity is released and the access notes are cleared. */
  declineCustomerAppointmentOptions: CustomerAppointmentAcknowledgementResult;
  declineOrderDelegation: DelegatedOrderInboxItemEntity;
  declineQuote: DeclineQuoteOutput;
  delete: CsvOrderImportTransactionEntity;
  deleteAccessorialDateRangeConfig: AccessorialDateRangeConfigEntity;
  deleteAccessorialGroup: Scalars['Boolean']['output'];
  deleteAccessorialRange: AccessorialRangeEntity;
  deleteAutoApplyAccessorialConfig: Scalars['Boolean']['output'];
  deleteContactComment: DeleteContactCommentOutput;
  deleteContactEmail: ContactEmailEntity;
  deleteCsvOrderFieldMapping: CsvOrderFieldMappingEntity;
  deleteCustomDocumentName: CustomDocumentNameEntity;
  deleteDocument?: Maybe<DocumentEntity>;
  deleteDrayageShipmentFields: StandardShipmentFieldsEntity;
  /** Deletes a custom type no driver record uses. Built-in types cannot be deleted, and a type in use can only be deactivated. */
  deleteDriverCredentialType: Scalars['Boolean']['output'];
  deleteDriverInsurancePolicy: DriverComplianceEntity;
  deleteDriverSignableFormTemplate: DriverSignableFormTemplateEntity;
  deleteDriverTrainingRecord: DriverComplianceEntity;
  deleteDwellTimeAlertConfig: Scalars['Boolean']['output'];
  deleteEdiPartnershipReferenceMappings: DeleteEdiTypedReferenceMappingsOutput;
  deleteEdiPartnershipServiceMappings: DeleteEdiPartnershipServiceMappingsOutput;
  deleteEquipment: EquipmentEntity;
  deleteFeatureFlagCompanyOverride: FeatureFlagCompanyOverrideEntity;
  deleteFeatureFlagUserOverride: FeatureFlagUserOverrideEntity;
  deleteFreightCharge: FreightChargeEntity;
  deleteFuelProfileDateRange: DeleteFuelProfileDateRangeOutput;
  deleteGeneralLedgerCode: DeleteGeneralLedgerCodeOutput;
  deleteInventoryCount: DeleteInventoryCountOutput;
  /** @deprecated Deprecated. Use upsertItemGroup instead */
  deleteInventoryItems: DeleteInventoryItemsOutput;
  deleteInvoiceNoteRule: InvoiceNoteRuleEntity;
  /** This is probably not the method you want to use */
  deleteLegDriverMap: LegDriverMapEntity;
  deleteMirrorTarget: Scalars['Boolean']['output'];
  deleteOrder?: Maybe<OrderEntity>;
  deleteOrderComment: DeleteOrderCommentOutput;
  deleteOrderDelegationRule: Scalars['Boolean']['output'];
  deleteOrphanPiece: PieceEntity;
  deletePackage: PackageEntity;
  deletePayment: PaymentEntity;
  deletePermission: DeletePermissionOutput;
  deletePieceReceipt: DeletePieceReceiptOutput;
  deleteQuickbooksHeaderFileMapping: QuickbooksHeaderFileMappingEntity;
  deleteQuote?: Maybe<QuoteEntity>;
  deleteRecurringLineHaulManifestTemplate: Scalars['String']['output'];
  deleteRecurringTemplateTruck: Scalars['String']['output'];
  deleteReportGroupConfiguration: ReportGroupConfigurationEntity;
  deleteRole: DeleteRoleOutput;
  deleteRouteNameLocation: RouteNameLocationEntity;
  deleteSameDayDispatchConfig: SameDayDispatchConfigEntity;
  deleteSavedFilterView: SavedFilterViewEntity;
  deleteSchema?: Maybe<Scalars['String']['output']>;
  deleteSchemaCompanyMapping: Scalars['String']['output'];
  deleteSchemaDocument?: Maybe<Scalars['String']['output']>;
  deleteSchemaRun: Scalars['String']['output'];
  deleteServiceGroup: Scalars['Boolean']['output'];
  deleteSlotsFromRoute?: Maybe<Scalars['Int']['output']>;
  deleteStandardOrder?: Maybe<StandardOrderEntity>;
  deleteStandardOrderFields: StandardOrderFieldsEntity;
  deleteStopAttempt: DeleteStopAttemptOutput;
  deleteStopDriverMap: StopDriverMapEntity;
  deleteStorageOrder: DeleteStorageOrderOutput;
  /** Deletes storage orders and all associated entities such as audit log entries, storage units, and pick ticket items */
  deleteStorageOrders: DeleteStorageOrdersOutput;
  deleteStorageUnit: DeleteStorageUnitOutput;
  deleteStuckSendingEmailTransactions?: Maybe<Scalars['Float']['output']>;
  deleteTag: TagEntity;
  deleteTariff: TariffEntity;
  deleteTariffGroup: TariffGroupEntity;
  deleteTariffLocation: DeleteTariffLocationOutput;
  deleteTariffRange: TariffRangeEntity;
  deleteTariffZone: TariffZoneEntity;
  deleteTariffZones: Scalars['String']['output'];
  deleteTariffs: Array<TariffEntity>;
  deleteTerminalLanes: DeleteTerminalLanesOutput;
  /** Deletes all warehouse locations for a company that are not associated with a storage unit, inventory item, package, piece, or item group. */
  deleteUnusedWarehouseLocations: Scalars['Int']['output'];
  deleteUser?: Maybe<UserEntity>;
  deleteWarehouse: WarehouseEntity;
  deleteWarehouseLocation: DeleteWarehouseLocationOutput;
  deselectRole?: Maybe<LoginPhoneOutput>;
  detachDocumentFromShipment: DocumentEntity;
  detachDocumentsFromShipments: Array<DocumentEntity>;
  disconnectQuickbooks: Scalars['Boolean']['output'];
  dismissCompletedScannedOrderResults: Scalars['Int']['output'];
  dismissDelegationAccessorialProposal: DelegationAccessorialProposalEntity;
  dismissOrganizationMessage: Scalars['Boolean']['output'];
  dismissQuote: DismissQuoteOutput;
  dismissScannedOrderResult: ScannedOrderResultEntity;
  dispatchApplySuggestedManifests: DispatchApplySuggestedManifestsOutput;
  dispatchTextDriver: DispatchTextDriverOutput;
  documentationAdminCreateItem: DocumentationItemEntity;
  documentationAdminCreateTopic: DocumentationTopicEntity;
  documentationAdminDeleteItem: Scalars['Boolean']['output'];
  documentationAdminDeleteTopic: Scalars['Boolean']['output'];
  documentationAdminReorder: Scalars['Boolean']['output'];
  documentationAdminUpdateItem: DocumentationItemEntity;
  documentationAdminUpdateTopic: DocumentationTopicEntity;
  downloadInvoices: DownloadInvoicesOutput;
  driverSettlementBillExportPdf: ReportFileOutput;
  driverSettlementBillExportZip: ReportFileOutput;
  duplicateEdiPartnerships: DuplicateEdiPartnershipsOutput;
  duplicateTariffGroup: DuplicateTariffGroupOutput;
  editContacts: EditContactsOutput;
  emailAccountingReport: EmailAccountingReportOutput;
  emailOrderDocument: EmailOrderDocumentOutput;
  estimateDocExtractionEvalRun: DocExtractionEvalRunCostEstimateEntity;
  /** Executes an OPEN packing pendency by packing or unpacking its covered pieces (via packPieces / unpackPieces). Allowed when the pendency is unassigned or assigned to the acting warehouse employee. `warehouseUuid` must match the pendency's warehouse, but it is a consistency check on the caller's context rather than an authorization boundary: warehouse employees have no warehouse membership relation, so any employee in the tenant can satisfy it. */
  executePackingPendency: ExecutePackingPendencyOutput;
  /** Lets one scheduling resource keep running on a day the company is closed. Waives the COMPANY closure only: a resource that also carries a blocked day of its own for that date stays closed. Refused when the company has not blocked the day. */
  exemptSchedulingResourceFromCompanyBlockedDay: CompanySchedulingBlockedDayOutput;
  expireQuoteAgentPreviousForwardingToken: ExpireQuoteAgentPreviousForwardingTokenOutput;
  exportInvoicesToQuickbooksDesktop: Array<ExportQuickbooksResult>;
  /** Do not use for FF_ROBUST_SETTLEMENT. Use finalizeSettlementBills instead. */
  finalizeDriverSettlementBills: Scalars['Float']['output'];
  finalizeInvoices: FinalizeInvoicesOutput;
  finalizeOrder: OrderEntity;
  finalizeOrders: FinalizeOrdersOutput;
  /** If FF_ROBUST_SETTLEMENT is enabled, will create a snapshot for each bill and finalize the bill. */
  finalizeSettlementBills: FinalizeSettlementBillsOutput;
  fireOutboundBenchTransaction: BenchFireResultEntity;
  flipIsArchived: AccessorialUnion;
  generateAccountingReportPreSignedPutUrl: Scalars['String']['output'];
  generateClearCompanyContactsToken: GenerateClearCompanyContactsTokenOutput;
  generateContactPreSignedPutUrl: GeneratePreSignedPutUrlOutput;
  generateHistoricalInvoicesCsv: GenerateHistoricalInvoicesCsvOutput;
  generateInvoicePreSignedPutUrl: Scalars['String']['output'];
  generateInvoicePreSignedPutUrls: Array<GenerateInvoicePreSignedPutUrlOutput>;
  generateLabel: Scalars['String']['output'];
  generateLineHaulRuns: GenerateLineHaulRunsOutput;
  generateMobileSignedDocumentPreSignedPutUrl: Scalars['String']['output'];
  generateOrderDocumentPreSignedPutUrl: Scalars['String']['output'];
  generateOrderPreSignedGetAndPutUrls: GenerateOrderPreSignedGetAndPutUrlsOutput;
  generateOrderPreSignedPutUrl: Scalars['String']['output'];
  generatePiecePreSignedPutUrl: Scalars['String']['output'];
  generatePodReportPreSignedPutUrl: Scalars['String']['output'];
  generatePreSignedPutUrl: Scalars['String']['output'];
  generateReferenceIds: Array<Scalars['String']['output']>;
  generateResetCompanyToken: GenerateResetCompanyTokenOutput;
  generateShipmentPreSignedPutUrl: Scalars['String']['output'];
  generateStorageOrderPreSignedPutUrl: GenerateStorageOrderPreSignedPutUrlOutput;
  handleMultipleInvoices210Outbound: Scalars['Boolean']['output'];
  importCrownAccessorial: ImportCrownAccessorialOutput;
  /** Calls importCrownContactsV3 */
  importCrownContactsV2: Array<Scalars['String']['output']>;
  importCrownDrivers: ImportCrownDriversOutput;
  importCrownInvoices: ImportCrownInvoicesOutput;
  importCrownLanes: ImportCrownLanesOutput;
  importCrownOrders: ImportCrownOrdersOutput;
  importCrownPayments: ImportCrownPaymentsOutput;
  importCrownTariff: ImportCrownTariffOutput;
  importCrownUsers: ImportCrownUsersOutput;
  importCustomerDefaultAddresses: Array<Scalars['String']['output']>;
  importQuickbooksDesktopMappings: Array<Scalars['String']['output']>;
  importRecoveryTerminal: ImportRecoveryTerminalOutput;
  importStorageOrdersFromCSV: ImportStorageOrdersFromCsvOutput;
  importTerminalServiceAreas: Scalars['Int']['output'];
  importTestSnapshot: Scalars['String']['output'];
  importThirdPartyPortalAccountEmails: Array<Scalars['String']['output']>;
  importWarehouseLocationsFromCsv: Scalars['Int']['output'];
  initiateDelegatedOrderReview: InitiateDelegatedOrderReviewOutput;
  kpiRecordTableDownload: KpiRecordTableDownloadOutput;
  /** @deprecated Use linkPieceToOrderWithRole instead */
  linkPieceToOrder: PieceEntity;
  linkPieceToOrderWithRole: PieceEntity;
  linkPieceToPackage: PackageHasPieceEntity;
  linkPiecesToPackage: LinkPiecesToPackageOutput;
  logUnassignedScan: ScanEntity;
  login?: Maybe<LoginOutput>;
  loginInternal?: Maybe<LoginOutput>;
  loginPhone?: Maybe<LoginPhoneOutput>;
  /** @deprecated use loginPhoneJwtV2 instead */
  loginPhoneJwt?: Maybe<LoginPhoneOutput>;
  loginPhoneJwtV2?: Maybe<LoginPhoneOutput>;
  loginPhoneV2?: Maybe<LoginPhoneOutput>;
  logout: Scalars['Boolean']['output'];
  /** Make a decision to confirm an appointment or to request it to be rescheduled */
  makeAppointmentConfirmationDecision: MakeAppointmentConfirmationDecisionOutput;
  manuallySetInvoicesQbSyncStatus: Scalars['Boolean']['output'];
  mapPeerAccessorial: IncomingPeerAccessorialMappingEntity;
  mapPeerService: IncomingPeerServiceMappingEntity;
  markAllInAppNotificationsRead: Scalars['Int']['output'];
  markAsCancelled: OrderEntity;
  markAsOnHold: OrderEntity;
  /** Mark an attempted stop as complete */
  markAttemptedStopAsComplete: StopEntity;
  markConsolidatableOrdersAsBilledIndividually: Array<OrderEntity>;
  markManifestAsArrived: MarkManifestAsArrivedOutput;
  markManifestAsDeparted: MarkManifestAsDepartedOutput;
  markManifestAsDoorsClosed: MarkManifestAsDoorsClosedOutput;
  markManifestAsPlanning: MarkManifestAsPlanningOutput;
  /** @deprecated Deprecated. Use piece-level damage and automatic issue flags instead. */
  markNotOsd: OrderEntity;
  markNotificationRead: Scalars['Boolean']['output'];
  markOrderAsCompleteForce: OrderEntity;
  markOrderAsHasBillingIssue: OrderEntity;
  markOrderAsNotComplete: OrderEntity;
  markOrderAsNotOnHand: OrderEntity;
  markOrderAsNotReadyToInvoice: OrderEntity;
  markOrderAsNotReceivedAtOrigin: OrderEntity;
  markOrderAsOnHand: OrderEntity;
  markOrderAsPicked: OrderEntity;
  markOrderAsReadyToInvoice: OrderEntity;
  /** @deprecated This marks an order as complete, not finalized. Use markOrderAsCompleteForce instead */
  markOrderAsReadyToInvoiceForce: OrderEntity;
  markOrderAsReceivedAtOrigin: OrderEntity;
  markOrderAsRefused: MarkOrderAsRefusedOutput;
  /** @deprecated Deprecated. Use piece-level damage and automatic issue flags instead. */
  markOsd: OrderEntity;
  markPieceDamaged: PieceEntity;
  markQuoteSent: MarkQuoteSentOutput;
  markStopAsFailed: StopEntity;
  markStopAsFailedV2: StopEntity;
  markStopAsIncomplete: StopEntity;
  markStorageUnitAsBilled: MarkStorageUnitAsBilledOutput;
  markStorageUnitAsOsd: MarkStorageUnitAsOsdOutput;
  markStorageUnitOnHand: MarkStorageUnitOnHandOutput;
  markTestOrderForEdiReview: Scalars['Boolean']['output'];
  markTutorialSeen: Array<TutorialId>;
  markWarehouseAsDefault: WarehouseEntity;
  matchFreightSnap?: Maybe<FreightSnapTransactionEntity>;
  matchSignedPODs: Scalars['Boolean']['output'];
  mergeEdiOrder: MergeEdiOrderOutput;
  mergeScannedOrderResultIntoPossibleDuplicate: ScannedOrderResultEntity;
  migrateToAccessorialContacts: Scalars['Boolean']['output'];
  moveShipmentsBetweenInvoices: MoveShipmentsBetweenInvoicesOutput;
  moveShipmentsToInvoice: MoveShipmentsToInvoiceOutput;
  normalizeDocument: Scalars['String']['output'];
  offboardCompanyFromQuoteAgent: OffboardCompanyFromQuoteAgentOutput;
  openMessageInOutlook: OpenMessageInOutlookOutput;
  optimizeRouteSequence: OptimizeRouteSequenceResult;
  optimizeRoutesTogether: OptimizationPending;
  /** Nests the selected pieces under a newly created parent piece of the given type (pack/unpack v2). All selected pieces must belong to the same order or all be orderless. */
  packPieces: PieceEntity;
  parseCsvOrders: ParseCsvOrdersOutput;
  pickQuoteCustomer: PickQuoteCustomerOutput;
  pickStorageUnit: PickStorageUnitOutput;
  previewDocExtractionEvalSet: DocExtractionEvalSetPreviewEntity;
  prorateOrders: ProrateOrdersOutput;
  publishOrganizationMessage: OrganizationMessageEntity;
  queueAppointmentSchedulingProposals: QueueAppointmentSchedulingProposalsOutput;
  /** Queue appointment texts for all stops according to the UUIDs provided */
  queueAppointmentTexts: QueueAppointmentTextsOutput;
  reactivateUser: UserEntity;
  reanalyzePage: Scalars['Boolean']['output'];
  reanalyzeSchemaFile: Scalars['Boolean']['output'];
  reassignRouteSlot?: Maybe<Array<RouteEntity>>;
  reconfigureDriverSettlementPayTerms: ReconfigureDriverSettlementPayTermsOutput;
  recordContactAttempted: Scalars['Int']['output'];
  recordInboundReviewDecisions: Scalars['Boolean']['output'];
  recordInventoryCountUnexpected: RecordInventoryCountUnexpectedOutput;
  recreateScannedOrderForEmailAttachment: Scalars['Boolean']['output'];
  refreshAuthToken: RefreshAuthTokenOutput;
  refreshEtasForRoute: Array<EtaEntity>;
  /** Restores a terminated driver, clears the termination and sets the new hire date. */
  rehireDriver: DriverComplianceEntity;
  rejectCustomerPortalOrder: RejectCustomerPortalOrderOutput;
  rejectDelegationEndCustomerLink: OrderDelegationEntity;
  rejectEdiOrder: RejectEdiOrderOutput;
  rejectEdiOrders: RejectEdiOrdersOutput;
  /** Reject an Expeditors work order and notify their API */
  rejectExpeditorsWorkOrder: Scalars['Boolean']['output'];
  rejectQuoteReply: RejectQuoteReplyOutput;
  removeAccessorial: AccessorialUnion;
  removeAddress: AddressEntity;
  removeApiUserContactMapping: ApiUserEntity;
  removeBusinessDivision: BusinessDivisionEntity;
  removeCompany: CompanyEntity;
  removeContact?: Maybe<ContactEntity>;
  removeContactPerson: ContactPersonEntity;
  removeContacts: RemoveContactsOutput;
  removeCoverSheetDocumentTypeSequence: CoverSheetDocumentTypeSequenceEntity;
  removeCreditType: CreditTypeEntity;
  removeDispatchView: DispatchViewEntity;
  removeDriver: DriverEntity;
  removeDriverSettlementBill: DriverSettlementBillEntity;
  removeDriversFromRoute: Scalars['Int']['output'];
  removeEmailTransactionLog: EmailTransactionLogEntity;
  removeFeatureFlag: FeatureFlagEntity;
  removeFuelProfile: FuelProfileEntity;
  removeGeneralLedgerCode: GeneralLedgerCodeEntity;
  removeGeneralLedgerConfiguration: GeneralLedgerConfigurationEntity;
  removeHelperFromRoute: Scalars['String']['output'];
  removeHoldReason: HoldReasonEntity;
  removeImportedOrderTypeMapping: ImportedOrderTypeMappingEntity;
  removeInvoice: InvoiceEntity;
  removeInvoiceTerms: InvoiceTermEntity;
  removeLineHaulLane: LineHaulLaneEntity;
  removeLineHaulManifest: Scalars['String']['output'];
  removeLineHaulSegment: LineHaulSegmentEntity;
  /** Given lists of settlement bill line items, will disconnect them from the bills they are associated with and trigger any side effects */
  removeLineItemsFromSettlementBill: RemoveLineItemsFromSettlementBillOutput;
  removeMasterAccount: MasterAccountEntity;
  /** Removes the stored company Motive API key. */
  removeMotiveApiKey: MotiveIntegrationEntity;
  removeOrderHold: OrderEntity;
  removeOrderLineHaulSegment: OrderLineHaulSegmentEntity;
  /** @deprecated Use removeOrdersFromManifestV2 instead */
  removeOrdersFromManifest: AddOrdersToManifestOutput;
  removeOrdersFromManifestV2: RemoveOrdersFromManifestV2Output;
  removePaymentOffset: PaymentToPaymentMappingEntity;
  removePiecesFromPieceReceipt: RemovePiecesFromPieceReceiptOutput;
  removeRoute: RouteEntity;
  /** This is probably not the API you want to use */
  removeRouteDriver: RouteDriverEntity;
  /** Puts an exempted scheduling resource back under a company closure, which CLOSES that day for it again. Removing an exemption that was never granted succeeds and changes nothing. */
  removeSchedulingResourceCompanyBlockedDayExemption: CompanySchedulingBlockedDayOutput;
  removeService: ServiceEntity;
  removeServiceToContact: ServiceEntity;
  removeSettlementAdjustment: SettlementAdjustmentEntity;
  /** @deprecated Deprecated during Robust Settlement Project. Use `removeSettlementAdjustment` instead */
  removeSettlementDeduction: SettlementDeductionEntity;
  removeSettlementDeductionType: SettlementDeductionTypeEntity;
  removeShipmentsFromInvoice: Array<Maybe<ShipmentEntity>>;
  removeSpecialAccessorial: AccessorialUnion;
  removeStopsFromRoutes: Array<Scalars['String']['output']>;
  removeStorageUnitOnHand: RemoveStorageUnitOnHandOutput;
  removeStorageUnitOsd: RemoveStorageUnitOsdOutput;
  removeSubscriberFromShipment: ShipmentSubscriberEntity;
  removeTagFromLeg: TagEntity;
  removeTagFromOrder: TagEntity;
  removeTerminal: TerminalEntity;
  removeTerminalServiceArea: TerminalServiceAreaEntity;
  removeThirdPartyBroker: ThirdPartyBrokerEntity;
  removeThirdPartyUserFromContact: ThirdPartyUserEntity;
  removeUserFromRole: RemoveUserFromRoleOutput;
  /** @deprecated Use archive/restore instead of deleting */
  removeVehicleType: VehicleTypeEntity;
  removeZoneBasedAccessorial: AccessorialUnion;
  replayOutboundEdi: Scalars['Boolean']['output'];
  reportADocScanIssue: ReportADocScanIssueOutput;
  /** Send a fresh scheduling link to the phone number on file, for a link that has expired. The new token is NOT returned here: it is delivered out of band, so holding an expired link is not enough to keep renewing it. */
  requestCustomerAppointmentLink: CustomerAppointmentAcknowledgementResult;
  requestOrderMirrorSync: RequestOrderMirrorSyncOutput;
  requestQuoteReprice: RequestQuoteRepriceOutput;
  requoteQuoteAtCurrentPrice: RequoteQuoteAtCurrentPriceOutput;
  rerateOrderFreight: RerateOrderFreightOutput;
  rerateQuoteFreight: RerateQuoteFreightOutput;
  rescheduleOrganizationMessage: OrganizationMessageEntity;
  resendExternalTransmission: Scalars['Boolean']['output'];
  resendQuoteAgentCatalogSnapshot: Scalars['Boolean']['output'];
  resetCompany: ResetCompanyOutput;
  resolveOrganizationMessage: OrganizationMessageEntity;
  resolveQuoteReplySend: ResolveQuoteReplySendOutput;
  resolveScannedOrderBillingParty: ScannedOrderResultEntity;
  restoreAirportInfo: AirportInfoUpdateOutput;
  restoreContactStation: ContactStationUpdateOutput;
  restoreDriver: UpdateDriverOutput;
  restoreOrganization: RestoreOrganizationOutput;
  restorePackageSpec: UpdatePackageSpecOutput;
  /** Restore a person to the active status (un-archive) */
  restorePerson: UpdatePersonOutput;
  restoreSchedulingRegion: RestoreSchedulingRegionOutput;
  restoreSchedulingResource: SchedulingResourceOutput;
  restoreSchedulingZone: RestoreSchedulingZoneOutput;
  restoreTariffChain: RestoreTariffChainOutput;
  restoreTariffZoneGroup: TariffZoneGroupRestoreOutput;
  restoreVehicleType: VehicleTypeUpdateOutput;
  /** Restore an archived warehouse employee to the active status (un-archive). Fails with a conflict when the phone number has been reused by another live employee. */
  restoreWarehouseEmployee: UpdateWarehouseEmployeeOutput;
  retryAllFailedInvoice210OutboundsForCompany: RetryInvoice210OutboundResult;
  retryFailedInvoice210Outbound: RetryInvoice210OutboundResult;
  retryInvoiceSendJobBatches: InvoiceSendJobBatchEntity;
  retrySftpUploads: RetrySftpUploadsOutput;
  reuploadPods: Scalars['Boolean']['output'];
  revokeOrganizationPeer: OrganizationPeerEntity;
  rotateDocument: Scalars['String']['output'];
  rotateQuoteAgentForwardingToken: RotateQuoteAgentForwardingTokenOutput;
  runOptimization: RouteOptimizationEntity;
  runTestAccessorialDetection: Scalars['Boolean']['output'];
  samsaraDiscoveryRemoveToken: SamsaraDiscoveryStatusEntity;
  samsaraDiscoveryRunImport: SamsaraDiscoveryStatusEntity;
  /** Validates the token with Samsara, stores it encrypted and starts an import. */
  samsaraDiscoverySetToken: SamsaraDiscoveryStatusEntity;
  saveCostInputQuickbooksMappings: Array<CostInputQuickbooksAccountEntity>;
  saveCostInputSetup: CostInputStatusEntity;
  saveCostInputs: CostInputMonthEntity;
  savePointToPointLanes: SavePointToPointLanesOutput;
  /** Saves the SMC3 connection after SMC3 accepts it; a refusal saves nothing. */
  saveSmc3Settings: Smc3SettingsSaveResultEntity;
  saveTenediPartnership: TenediPartnershipSaveResultEntity;
  /** Used when the uuid of an order is known */
  scanOrder: OrderEntity;
  /** Scan an order barcode. If one result is found, will perform scan logic on the order. If multiple results are found, will return the results. If no results are found, will log an unassigned scan. */
  scanOrderBarcode: ScanOrderBarcodeOutput;
  /** @deprecated Use scanOrderBarcode or scanOrder */
  scanPiece: PieceEntity;
  scanWarehouseLocation: ScanWarehouseLocationOutput;
  /** Bulk-process pieces through the same scan path as selectPackage. Skips already-processed pieces (idempotent). */
  scanningV2__bulkProcessPieces: FreightScanningV2BulkProcessPiecesOutput;
  /** Slim piece-targeted commit for bounded work-order scanning (Inbound -> ARRIVED, Loading -> LOADED). Verifies work-order membership + transitions the piece + writes the Scan row synchronously, then defers the order/manifest/on-hand rollup to a background job. Idempotent (rescan / already-terminal no-ops). Rejects MOVE/DELIVERY/PICKUP. */
  scanningV2__commitWorkOrderScan: FreightScanningV2CommitWorkOrderScanOutput;
  /** Move multiple pieces to a warehouse location. Used after ORDER_RESOLVED state in MOVE mode. */
  scanningV2__moveWarehouseLocation: FreightScanningV2MoveWarehouseLocationOutput;
  /** Process a barcode scan. Returns order/package selection options or completes the scan. */
  scanningV2__processBarcode: FreightScanningV2MutationOutput;
  /** Lean barcode scan: records the scan synchronously and defers order rollup to a background job. Returns a scanJobUuid to poll via scanningV2__scanJobStatuses. */
  scanningV2__processBarcodeLean: FreightScanningV2ProcessBarcodeLeanOutput;
  /** Select a package and optionally specify piece count. Completes the scan. */
  scanningV2__selectPackage: FreightScanningV2MutationOutput;
  scheduleOrganizationMessage: OrganizationMessageEntity;
  selectRole?: Maybe<LoginPhoneOutput>;
  sendAccountingReports: SendAccountingReportsOutput;
  sendDeliveryCompleted: Scalars['Boolean']['output'];
  sendInvoices: InvoiceSendJobBatchEntity;
  sendMetric: Scalars['Boolean']['output'];
  sendRouteToAgent: SendRouteToAgentOutput;
  sendStopToAgent: SendStopToAgentOutput;
  setAccessorialQboItemMapping: AccessorialUnion;
  setCompanyAccountType: CompanyEntity;
  /** Replaces every charge matrix column assignment of the contact with the given set. */
  setContactChargeMatrixColumnMappings: Array<ContactChargeMatrixColumnMappingEntity>;
  setDockDoors: Array<DockDoorEntity>;
  setDriverComplianceDates: DriverComplianceEntity;
  setDriverSettlementPayBounds: Array<DriverSettlementPayBoundEntity>;
  setLaneDefaultDoor: Array<LaneDefaultDoorEntity>;
  setLineHaulManifestDepartTime: LineHaulManifestEntity;
  setLineHaulManifestLoadPosition: SetLineHaulManifestLoadPositionOutput;
  setLineHaulManifestOrderLoadPosition: SetLineHaulManifestLoadPositionOutput;
  setLineHaulManifestTrailers: SetManifestTrailersOutput;
  setLineHaulManifestTruck: SetManifestTruckOutput;
  setLineHaulSegmentTiming: SetLineHaulSegmentTimingOutput;
  setMirrorTargetCompanies: Scalars['Boolean']['output'];
  /** Validates and stores the company Motive API key. */
  setMotiveApiKey: MotiveIntegrationEntity;
  setNotificationCutoverMode: NotificationCutoverConfigEntity;
  setOrderExecutedBy: OrderDelegationEntity;
  setOrderMirrorCaptureConfig: OrderMirrorCaptureConfigEntity;
  setOrganizationEmitPieceLevelWebhooks: OrganizationEntity;
  setOrganizationRequireScanToAdvancePieceStatusAtStops: OrganizationEntity;
  setPeerAccessorialShares: Array<Scalars['String']['output']>;
  setPeerServiceShares: Array<PeerServiceShareEntity>;
  /** Replaces the supplied dimensions of a scheduling resource eligibility rule set, and returns the resource so the new rules can be selected back in the same request. Every subject is named by UUID and must belong to the calling company; an unknown subject and one belonging to another company are reported identically. */
  setSchedulingResourceEligibilityRules: SchedulingResourceOutput;
  setStorageOrderItemQuantity: StorageOrderEntity;
  shareSavedFilterView: SavedFilterViewEntity;
  signUpForThirdPartyUserAccount: SignUpForThirdPartyUserAccountOutput;
  splitAndProcessOrderDocuments: Scalars['Boolean']['output'];
  startConfigMigration: Scalars['String']['output'];
  startInventoryCount: StartInventoryCountOutput;
  startPieceBackfillRun: PieceBackfillRunView;
  startRoute: RouteEntity;
  syncFinancialSnapshots: Scalars['Boolean']['output'];
  syncInvoiceStatusWithQuickbooks: InvoiceEntity;
  syncInvoicesToQuickbooks: SyncInvoicesToQuickbooksOutput;
  syncVehiclesWithSamsara: Array<EquipmentEntity>;
  /** Archives the driver and records the termination. Reverse it with rehireDriver. */
  terminateDriver: DriverComplianceEntity;
  testAllSnapshots: Scalars['String']['output'];
  testOneSnapshot: Scalars['String']['output'];
  testSchema?: Maybe<Scalars['String']['output']>;
  /** Checks the stored SMC3 connection, enabled or not. */
  testSmc3Connection: Smc3ConnectionTestResultEntity;
  /** Rates one class and weight with the stored SMC3 connection. */
  testSmc3Rate: Smc3TestRateResultEntity;
  testSubmitPODByShipperRefNo: Scalars['String']['output'];
  testSubmitStatusByShipperRefNo: Scalars['String']['output'];
  testUpdateStatusByShipperRefNo: Scalars['String']['output'];
  /** @deprecated Use dispatchTextDriver, which also reports whether the text went out. */
  textDriver: DriverEntity;
  textractSchemaFile: Scalars['Boolean']['output'];
  textractSchemaTestFile: Scalars['Boolean']['output'];
  throwGraphQLError: Scalars['String']['output'];
  throwPrismaError: Scalars['String']['output'];
  transferPieceToOrder: PieceEntity;
  transferPieceToOutboundOrder: PieceEntity;
  /** Confirm, reschedule or cancel one stop appointment, recording the transition in its status history. */
  transitionAppointment: TransitionAppointmentOutput;
  triggerAdhocPreview: AdhocPreviewTriggerEntity;
  triggerAdhocPreviewBatch: AdhocPreviewBatchEntity;
  triggerIngestionTestRun: IngestionTestRunEntity;
  unassignInventoryItems: UnassignInventoryItemsOutput;
  unassignLegFromDriver: LegEntity;
  unassignOrderFromLineHaulTrailer: Scalars['Boolean']['output'];
  /** Reopens a calendar day the whole company was closed on. DROPS the day exemptions with it, because they were opt-outs from a closure that no longer exists: closing the same day again starts from nobody exempt. TWO-PHASE for that reason: without confirmDiscardsExemptions a day carrying exemptions writes NOTHING and returns CompanySchedulingDayExemptionsAtRiskOutput naming how many resources would lose theirs, and sending the same input again with confirmDiscardsExemptions applies it. A day carrying no exemptions is reopened on the first call. Each resource own blocked days are untouched. */
  unblockCompanySchedulingDay: CompanySchedulingBlockedDayOutput;
  unblockSchedulingResourceDay: SchedulingResourceOutput;
  uncancelOrder: OrderEntity;
  unconsolidateOrder: Array<ShipmentEntity>;
  unfinalizeOrder: OrderEntity;
  unfinalizeOrders: UnfinalizeOrdersOutput;
  unlinkPieceFromOrder: PieceEntity;
  unlinkPieceFromPackage: Scalars['Boolean']['output'];
  unmarkPieceDamaged: PieceEntity;
  /** Unpacks the selected child pieces from their bundles (partial unpack): each is restored to a top-level piece; a parent whose last child is removed is deleted, otherwise it keeps its remaining children. */
  unpackPieces: UnpackPiecesOutput;
  unpickOrder: OrderEntity;
  unpickStorageUnit: UnpickStorageUnitOutput;
  unpostInvoice: UnpostInvoiceOutput;
  unpostInvoices: UnpostInvoicesOutput;
  update: EquipmentLicenseEntity;
  updateAccessorial: AccessorialUnion;
  updateAccessorialContact: UpdateAccessorialContactOutput;
  updateAccessorialDateRangeConfig: UpdateAccessorialDateRangeConfigOutput;
  updateAccessorialGroup: AccessorialGroupEntity;
  updateAccessorialRangesForAccessorial: Array<AccessorialRangeEntity>;
  updateAccessorialToQuickbooksMapping: AccessorialToQuickbooksMappingEntity;
  updateAddress: AddressEntity;
  updateAirportInfo: AirportInfoEntity;
  updateApiUser: ApiUserEntity;
  updateAutoApplyAccessorialConfig: AutoApplyAccessorialConfigEntity;
  updateBusinessDivision: UpdateBusinessDivisionOutput;
  updateCompany: CompanyEntity;
  updateCompanyConfiguration: CompanyConfigurationEntity;
  updateContactComment: UpdateContactCommentOutput;
  /** @deprecated Use updateContactEmails instead. */
  updateContactCommunicationConfig: ContactCommunicationConfigEntity;
  /** Update all ContactEmailEntities and ContactCommunicationConfigEntities that have to do with orders for a contact */
  updateContactEmails: UpdateContactEmailsOutput;
  updateContactPerson: ContactPersonEntity;
  updateContactStation: ContactStationUpdateOutput;
  updateContactToServicesTariffGroupMappings: Array<ContactToServicesTariffGroupMappingEntity>;
  updateCoverSheetDocumentTypeSequence: CoverSheetDocumentTypeSequenceEntity;
  updateCreditType: CreditTypeEntity;
  updateCsvOrderFieldMapping: CsvOrderFieldMappingEntity;
  updateCsvOrderImportTransaction: CsvOrderImportTransactionEntity;
  updateCsvOrderMapping: CsvOrderMappingEntity;
  updateCustomerContact: CustomerContactEntity;
  updateCustomerContactPackageSpecs: UpdateCustomerContactOutput;
  updateCustomerContactVehicleTypes: UpdateCustomerContactOutput;
  updateDefaultTariffChainsForCompany: UpdateDefaultTariffChainsForCompany;
  updateDispatchTableColors: UpdateDispatchTableColorsOutput;
  updateDispatchView: DispatchViewUpdateOutput;
  updateDocument: DocumentEntity;
  updateDocuments: Array<DocumentEntity>;
  updateDriver: DriverEntity;
  updateDriverComplianceProfile: DriverComplianceEntity;
  updateDriverCredentialType: DriverCredentialTypeEntity;
  updateDriverInsurancePolicy: DriverComplianceEntity;
  updateDriverLocation?: Maybe<DriverEntity>;
  updateDriverQualifications: UpdateDriverQualificationsOutput;
  updateDriverSettlementBill: DriverSettlementBillEntity;
  updateDriverSignableFormTemplate: DriverSignableFormTemplateEntity;
  updateDriverTrainingRecord: DriverComplianceEntity;
  updateDwellTimeAlertConfig: DwellTimeAlertConfigEntity;
  updateEdiPartnership: UpdateEdiPartnershipOutput;
  updateEmailIngestionExclusions: EmailIngestionExclusionsEntity;
  updateEmailTransaction: UpdateEmailTransactionOutput;
  updateEmailTransactionLog: EmailTransactionLogEntity;
  updateEndOfDayDocumentProcessingJob: EndOfDayDocumentProcessingJobEntity;
  updateEquipment: EquipmentEntity;
  updateFeatureFlag?: Maybe<FeatureFlagEntity>;
  updateFeatureFlagCompanyOverride: FeatureFlagCompanyOverrideEntity;
  updateFeatureFlagUserOverride: FeatureFlagUserOverrideEntity;
  updateFreightCharge: FreightChargeEntity;
  updateFuelProfile?: Maybe<FuelProfileEntity>;
  updateFuelProfileDateRange: UpdateFuelProfileDateRangeOutput;
  updateGeneralLedgerCode: UpdateGeneralLedgerCodeOutput;
  updateGeneralLedgerConfiguration: UpdateGeneralLedgerConfigurationOutput;
  updateHoldReason: HoldReasonEntity;
  updateImportedOrderTypeMapping: ImportedOrderTypeMappingEntity;
  /** Upserts the given in-app notification opt-in choices for the current user; event types omitted from the payload are left unchanged. */
  updateInAppNotificationPreferences: Array<InAppNotificationPreferenceEntity>;
  /** @deprecated Deprecated. Use upsertItemGroup instead */
  updateInventoryItems: UpdateInventoryItemsOutput;
  /** @deprecated Use updateInvoiceLimited instead */
  updateInvoice: InvoiceEntity;
  updateInvoiceEmail: CompanyEntity;
  /** Updates the date, name, and terms of an invoice. Think carefully before adding more fields for this mutation to update */
  updateInvoiceLimited: InvoiceEntity;
  /** Replaces the rule's criteria and note. */
  updateInvoiceNoteRule: InvoiceNoteRuleEntity;
  updateItem: ItemEntity;
  updateItemLocation: UpdateItemLocationOutput;
  updateKpiDashboardLayout: KpiLayoutEntity;
  /** This is probably not the method you want to use */
  updateLegDriverMap: LegDriverMapEntity;
  updateLineHaulLane: UpdateLineHaulLaneOutput;
  updateLineHaulManifest: LineHaulManifestEntity;
  updateLineHaulSegment: LineHaulSegmentEntity;
  updateManifestDriver: LineHaulManifestEntity;
  updateManifestVehicle: LineHaulManifestEntity;
  updateManifestsStatus: UpdateManifestsStatusOutput;
  updateMasterAccount: UpdateMasterAccountOutput;
  updateMirrorTarget: MirrorTargetEntity;
  /** Record notes or the proof-of-delivery signee on a stop of the current driver */
  updateMyStop: StopEntity;
  updateOrderComment: OrderCommentEntity;
  updateOrderDelegationRule: OrderDelegationRuleEntity;
  /** Update (replacing) all subscriptions for a contact */
  updateOrderEventNotificationSubscriptions: UpdateOrderEventNotificationSubscriptionsOutput;
  updateOrderFormFields: OrderFormFieldsEntity;
  updateOrderImportConfiguration: OrderImportConfigurationEntity;
  updateOrderLineHaulSegment: OrderLineHaulSegmentEntity;
  updateOrderLoadedStatus: OrderEntity;
  updateOrganization: UpdateOrganizationOutput;
  updateOrganizationMessage: OrganizationMessageEntity;
  updateOrganizationPeersSettings: Array<OrganizationPeerEntity>;
  updateOutlookIntegration: OutlookIntegrationEntity;
  updatePackage: PackageEntity;
  updatePackageArray: Array<PackageEntity>;
  updatePackageSpec: UpdatePackageSpecOutput;
  updatePackageWarehouseLocation: UpdatePackageWarehouseLocationOutput;
  updatePaperworkCompletedForStops: Array<StopEntity>;
  updatePayment: PaymentEntity;
  updatePaymentOffset: PaymentToPaymentMappingEntity;
  updatePermission: UpdatePermissionOutput;
  updatePermissionAccessLevel: UpdatePermissionAccessLevelOutput;
  updatePerson: UpdatePersonOutput;
  updatePiece: PieceEntity;
  updatePieceCount: OrderEntity;
  updatePieceDimensions: PieceEntity;
  updatePieceReceipt: UpdatePieceReceiptOutput;
  /** Edits an attached piece's dimensions, weight, container type, and location. markedOnHandAt is read-only. */
  updatePieceReceiptPiece: UpdatePieceReceiptPieceOutput;
  updatePiecesPicked: OrderEntity;
  updatePlace: PlaceEntity;
  updateQuickAddAccessorials: UpdateQuickAddAccessorialsOutput;
  updateQuickbooksHeaderFileMapping: QuickbooksHeaderFileMappingEntity;
  updateQuote: QuoteEntity;
  updateQuoteAgentStaffSettings: CompanyConfigurationEntity;
  updateRecurringLineHaulManifestTemplate: RecurringLineHaulManifestTemplateEntity;
  updateRecurringOrderFrequency: RecurringOrderFrequencyEntity;
  updateRecurringTemplateTruck: RecurringTemplateTruckEntity;
  updateReportGroupConfiguration: ReportGroupConfigurationEntity;
  updateReportsEmail: UserEntity;
  updateRole: UpdateRoleOutput;
  updateRoute: RouteEntity;
  updateRouteDrivers: RouteEntity;
  updateRouteNameLocation: RouteNameLocationEntity;
  updateRouteOptimization: RouteOptimizationEntity;
  updateRouteSlot: RouteSlotEntity;
  updateRouteSlots?: Maybe<RouteEntity>;
  updateRun: UpdateRunOutput;
  updateSameDayDispatchConfig: SameDayDispatchConfigEntity;
  updateSavedFilterView: SavedFilterViewEntity;
  /** Send the update of an ingested order scan. This will create an order on success. Not used for general CRUD updates  */
  updateScannedOrder: Scalars['String']['output'];
  updateScannedOrderResultStatus: ScannedOrderResultEntity;
  updateSchedulingRegion: UpdateSchedulingRegionOutput;
  updateSchedulingResource: SchedulingResourceOutput;
  updateSchedulingZone: UpdateSchedulingZoneOutput;
  updateSchema: Scalars['String']['output'];
  updateSchemaCompanyMapping: Scalars['String']['output'];
  updateSchemaDocument: SchemaDocumentEntity;
  updateService: ServiceEntity;
  updateServiceDateForAssignedStops: Array<RouteEntity>;
  updateServiceGroup: ServiceGroupEntity;
  /** Updates a service region by id. Returns the updated service region. The update will fail if attempting to update a service region as archived that has terminals associated with it that are active. */
  updateServiceRegion: UpdateServiceRegionOutput;
  updateSettlementAdjustment: CreateOrUpdateSettlementAdjustmentOutput;
  /** @deprecated Deprecated during Robust Settlement Project. Use `updateSettlementAdjustment` instead */
  updateSettlementDeduction: SettlementDeductionEntity;
  updateSettlementDeductionType: SettlementDeductionTypeEntity;
  updateSftpCredentials: CreateSftpCredentialsOutput;
  updateShipment: ShipmentEntity;
  updateShipmentStandardAccessorials: ShipmentEntity;
  /** Send the update of an ingested signed pod scan. This will create an document on success attached to the existing order shipment. Not used for general CRUD updates  */
  updateSignedPOD: ScannedOrderEntity;
  updateStandaloneStop: StopEntity;
  updateStandardOrder: StandardOrderEntity;
  updateStandardShipmentFields: StandardShipmentFieldsEntity;
  updateStop: StopEntity;
  updateStopDriverMap: StopDriverMapEntity;
  updateStops: Array<StopEntity>;
  updateStorageOrder: UpdateStorageOrderOutput;
  updateStorageUnit: UpdateStorageUnitOutput;
  updateTag: TagEntity;
  updateTariffChain: UpdateTariffChainOutput;
  updateTariffGroup: TariffGroupEntity;
  updateTariffRangesForTariff: Array<TariffRangeEntity>;
  updateTariffZone: TariffZoneEntity;
  updateTariffZoneGroup: TariffZoneGroupUpdateOutput;
  updateTemplateAndRecordAddresses: Array<AddressEntity>;
  updateTenediCarrierIdentity: TenediCarrierIdentitySaveResultEntity;
  updateTenediCustomerIdentity: TenediCustomerIdentitySaveResultEntity;
  /** @deprecated Use updateTerminalV2 instead */
  updateTerminal: UpdateTerminalOutput;
  updateTerminalServiceArea: TerminalServiceAreaEntity;
  updateTerminalV2: UpdateTerminalV2Output;
  updateTestOrder: UpdateTestOrderOutput;
  updateTestPieceStatus: Scalars['Boolean']['output'];
  updateThirdPartyBroker: ThirdPartyBrokerEntity;
  updateUser: UserEntity;
  updateVehicleForRoute: RouteEntity;
  updateVehicleType: VehicleTypeEntity;
  updateWarehouse: WarehouseEntity;
  updateWarehouseEmployee: UpdateWarehouseEmployeeOutput;
  updateWarehouseLocation: UpdateWarehouseLocationOutput;
  /** Upload a POD document to Expeditors for an Expeditors work order */
  uploadDocumentToExpeditors: Scalars['Boolean']['output'];
  upsertAddress: AddressEntity;
  upsertCompanyPackageTypeConfig: UpsertCompanyPackageTypeConfigOutput;
  upsertContactPerson: ContactPersonEntity;
  upsertDockTimeAllowances: DockTimeAllowanceEntity;
  upsertDriverPlannerAssumptions: DriverPlannerAssumptionEntity;
  upsertEdiPartnershipReferenceMappings: Array<EdiPartnershipReferenceMappingEntity>;
  upsertFreightCharge: FreightChargeEntity;
  upsertItemGroup?: Maybe<ItemGroupEntity>;
  upsertLineHaulUtilizationAssumptions: LineHaulUtilizationAssumptionEntity;
  upsertOrganizationPackageTypeConfig: UpsertOrganizationPackageTypeConfigOutput;
  upsertPackage: PackageEntity;
  upsertPicklist: UpsertPicklistOutput;
  upsertProductivityTimeAllowances: ProductivityTimeAllowanceEntity;
  /** Persists the calling company's v2 route-automation settings. Validates that referenced services / tags belong to the company. */
  upsertRouteAutomationSettings: RouteAutomationSettingsEntity;
  upsertSamsaraOauthToken: SamsaraOauthTokenEntity;
  /** Internal resolver to upsert a shipment subscriber. Directly calls the upsert service function. */
  upsertShipmentSubscriber: ShipmentSubscriberEntity;
  /** Public endpoint to allow any viewer to make a phone number a subscriber to shipment updates, given that they provide the correct company UUID and the correct shipment UUID */
  upsertShipmentSubscriberForCompany: ShipmentSubscriberEntity;
  upsertStructuredExtractionSchemaOverride: StructuredExtractionSchemaOverrideEntity;
  upsertUserContactNotificationSubscription: UserContactNotificationSubscriptionEntity;
  userSessionsAdminRevokeSessions: RevokeCompanyUserSessionsResult;
  validateCrownChargesFromCSV: ValidateCrownChargesOutput;
  validateCrownChargesFromPDF: ValidateCrownChargesOutput;
  validateImportedCrownInvoices: ValidateImportedCrownInvoicesOutput;
  verifyInventoryForStorageUnit: VerifyInventoryForStorageUnitOutput;
  withdrawOrganizationMessage: OrganizationMessageEntity;
};


export type MutationAcceptCustomerPortalOrderArgs = {
  acceptCustomerPortalOrderInput: AcceptCustomerPortalOrderInput;
};


export type MutationAcceptEdiOrApiOrderArgs = {
  acceptEdiOrApiOrderInput: AcceptEdiOrApiOrderInput;
};


export type MutationAcceptExpeditorsWorkOrderArgs = {
  orderUuid: Scalars['String']['input'];
};


export type MutationAcceptOrderDelegationArgs = {
  input: AcceptOrderDelegationInput;
};


export type MutationAcceptOrganizationPeerArgs = {
  input: AcceptOrganizationPeerInput;
};


export type MutationAcknowledgeFailedInvoiceSendJobsArgs = {
  invoiceSendJobBatchUuid: Scalars['String']['input'];
};


export type MutationAcknowledgeMyRouteChangesArgs = {
  acknowledgeRouteChangesInput: AcknowledgeRouteChangesInput;
};


export type MutationAcknowledgeMyStopChangeArgs = {
  input: AcknowledgeMyStopChangeInput;
};


export type MutationAcknowledgeNotificationArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationAcknowledgeNotificationsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationAcknowledgeQuoteAttentionArgs = {
  acknowledgeQuoteAttentionInput: AcknowledgeQuoteAttentionInput;
};


export type MutationAddApiUserContactMappingArgs = {
  addApiUserContactMappingInput: AddApiUserContactMappingInput;
};


export type MutationAddDriverExpoPushTokenArgs = {
  newExpoPushToken: Scalars['String']['input'];
};


export type MutationAddDriversToRouteArgs = {
  addDriversToRouteInput: AddDriversToRouteInput;
};


export type MutationAddLineItemsToSettlementBillsArgs = {
  addLineItemsToSettlementBillsInput: AddLineItemsToSettlementBillsInput;
};


export type MutationAddNextRouteSlotForRouteArgs = {
  nextRouteSlotUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};


export type MutationAddOrdersToInvoicesArgs = {
  input: AddOrdersToInvoicesInput;
};


export type MutationAddOrdersToManifestArgs = {
  addOrdersToManifestInput: AddOrdersToManifestInput;
};


export type MutationAddOrdersToManifestV2Args = {
  input: AddOrdersToManifestV2Input;
};


export type MutationAddPiecesToPieceReceiptArgs = {
  addPiecesToPieceReceiptInput: AddPiecesToPieceReceiptInput;
};


export type MutationAddQuickbooksDesktopCustomerArgs = {
  contactUuid: Scalars['String']['input'];
};


export type MutationAddQuickbooksDesktopCustomersArgs = {
  contactUuids: Array<Scalars['String']['input']>;
};


export type MutationAddQuickbooksDesktopItemArgs = {
  accountRefName: Scalars['String']['input'];
  itemName: Scalars['String']['input'];
};


export type MutationAddRouteStopArgs = {
  addRouteStopInput: AddRouteStopInput;
};


export type MutationAddServiceToContactArgs = {
  addServiceToContactInput: AddServiceToContactInput;
};


export type MutationAddServicesToTariffGroupMappingsArgs = {
  serviceUuids: Array<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationAddTagToLegArgs = {
  addTagToLegInput: AddTagToLegInput;
};


export type MutationAddTagToOrderArgs = {
  addTagToOrderInput: AddTagToOrderInput;
};


export type MutationAddTestAccessorialChargeArgs = {
  addTestAccessorialChargeInput: AddTestAccessorialChargeInput;
};


export type MutationAddThirdPartyUserToContactArgs = {
  addThirdPartyUserToContactInput: AddThirdPartyUserToContactInput;
};


export type MutationAddUserToRoleArgs = {
  addUserToRoleInput: AddUserToRoleInput;
};


export type MutationAdminSyncInvoicesToQuickbooksArgs = {
  input: AdminSyncInvoicesToQuickbooksInput;
};


export type MutationAdoptDriverSettlementPayTermsArgs = {
  input: AdoptDriverSettlementPayTermsInput;
};


export type MutationAdvanceOutboundBenchOrdersArgs = {
  input: AdvanceOutboundBenchOrdersInput;
};


export type MutationApiKeyAdminConnectOrgsArgs = {
  input: ApiKeyAdminConnectOrgsInput;
};


export type MutationApiKeyAdminCreateArgs = {
  input: ApiKeyAdminCreateInput;
};


export type MutationApiKeyAdminDeleteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationApiKeyAdminDisconnectOrgArgs = {
  input: ApiKeyAdminDisconnectOrgInput;
};


export type MutationApiKeyAdminImportCsvArgs = {
  input: ApiKeyAdminImportCsvInput;
};


export type MutationApiKeyAdminSetMappingTemplateArgs = {
  input: ApiKeyAdminSetMappingTemplateInput;
};


export type MutationApiKeyAdminSetStatusMappingsArgs = {
  input: ApiKeyAdminSetStatusMappingsInput;
};


export type MutationApiKeyAdminUpdateArgs = {
  input: ApiKeyAdminUpdateInput;
};


export type MutationApplyDebitToPaymentArgs = {
  input: ApplyDebitToPaymentInput;
};


export type MutationApplyDelegationAccessorialProposalArgs = {
  input: ApplyDelegationAccessorialProposalInput;
};


export type MutationApplyRouteOptimizationArgs = {
  input: ApplyRouteOptimizationInput;
};


export type MutationApproveQuoteArgs = {
  approveQuoteInput: ApproveQuoteInput;
};


export type MutationApproveQuoteReplyArgs = {
  approveQuoteReplyInput: ApproveQuoteReplyInput;
};


export type MutationArchiveAirportInfoArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationArchiveContactStationArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationArchiveOrganizationArgs = {
  input: ArchiveOrganizationInput;
};


export type MutationArchivePackageSpecArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchivePersonArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveSchedulingRegionArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveSchedulingResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveTariffChainArgs = {
  archiveTariffChainInput: ArchiveTariffChainInput;
};


export type MutationArchiveTariffZoneGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationArchiveWarehouseEmployeeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationArriveAtStopArgs = {
  arriveAtStopInput: ArriveAtStopInput;
};


export type MutationArriveAtStopsArgs = {
  arriveAtStopsInput: ArriveAtStopsInput;
};


export type MutationAssignDockDoorArgs = {
  input: AssignDockDoorInput;
};


export type MutationAssignHelperToRouteArgs = {
  helperUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};


export type MutationAssignInventoryItemsToStorageUnitArgs = {
  assignInventoryItemsToStorageUnitInput: AssignInventoryItemsToStorageUnitInput;
};


export type MutationAssignOrderToLineHaulTrailerArgs = {
  input: AssignOrderToTrailerInput;
};


export type MutationAssignOutboundReferenceNumbersToStorageUnitsArgs = {
  assignOutboundReferenceNumbersToStorageUnitsInput: AssignOutboundReferenceNumberToStorageUnitsInput;
};


export type MutationAttachMobileSignedDocumentToOrderAndReplaceOriginalArgs = {
  input: UploadMobileSignedDocumentInput;
  placement?: InputMaybe<SignaturePlacementInput>;
};


export type MutationAutoCreateRoutesV2Args = {
  input: AutoCreateRoutesV2Input;
};


export type MutationBackfillOrderTotalsArgs = {
  pageSize: Scalars['Float']['input'];
};


export type MutationBackfillTariffZoneGroupsForCompanyArgs = {
  companyUuid: Scalars['String']['input'];
};


export type MutationBatchAddShipmentsToInvoicesMultipleArgs = {
  batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple;
};


export type MutationBlockCompanySchedulingDayArgs = {
  input: BlockCompanySchedulingDayInput;
};


export type MutationBlockSchedulingResourceDayArgs = {
  input: BlockSchedulingResourceDayInput;
};


export type MutationBookCustomerAppointmentArgs = {
  input: BookCustomerAppointmentInput;
};


export type MutationBulkChangeCallStatusArgs = {
  changeCallStatusArgs: BulkChangeCallStatusArgs;
};


export type MutationBulkConfirmAppointmentsArgs = {
  bulkConfirmAppointmentsArgs: BulkConfirmAppointmentsArgs;
};


export type MutationBulkDelegateOrdersArgs = {
  input: BulkDelegateOrdersInput;
};


export type MutationBulkDeletePiecesArgs = {
  input: BulkDeletePiecesInput;
};


export type MutationBulkDiscardPiecesArgs = {
  input: BulkDiscardPiecesInput;
};


export type MutationBulkEditOrdersArgs = {
  bulkEditOrdersInput: BulkEditOrdersInput;
};


export type MutationBulkRestorePiecesArgs = {
  input: BulkRestorePiecesInput;
};


export type MutationBulkUnconfirmAppointmentsArgs = {
  bulkUnconfirmAppointmentsArgs: BulkUnconfirmAppointmentsArgs;
};


export type MutationBulkUpdateAccessorialMappingsArgs = {
  bulkAccessorialUpdateInput: BulkAccessorialUpdateInput;
};


export type MutationBulkUpdateContactQuickbooksIdsArgs = {
  bulkUpdateContactQuickbooksId: UpdateContactQuickbooksIdsInput;
};


export type MutationBulkUploadRouteNamesArgs = {
  bulkCsvRouteNameInput: BulkCsvRouteNameInput;
};


export type MutationCalculateRouteEtasArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationCallStopsArgs = {
  callStopsInput: CallStopsInput;
};


export type MutationCalmAddStopToRouteArgs = {
  input: AddStopToRouteInput;
};


export type MutationCalmAssignLineHaulRouteArgs = {
  input: AssignLineHaulRouteInput;
};


export type MutationCalmAssignPackagesToManifestArgs = {
  input: AssignPackagesToManifestInput;
};


export type MutationCalmLoadOrdersOnManifestArgs = {
  input: CalmLoadOrdersInput;
};


export type MutationCalmMoveOrderBetweenRunsArgs = {
  input: MoveBetweenRunsInput;
};


export type MutationCalmRemovePackagesFromManifestArgs = {
  input: AssignPackagesToManifestInput;
};


export type MutationCalmRepointOrderFreightArgs = {
  input: RepointOrderFreightInput;
};


export type MutationCalmSaveManifestPlacementsArgs = {
  input: SaveManifestPlacementsInput;
};


export type MutationCalmSetCrossdockInstructionArgs = {
  input: SetCrossdockInstructionInput;
};


export type MutationCalmSetPndRouteDriverArgs = {
  input: SetPndRouteDriverInput;
};


export type MutationCancelDocExtractionEvalRunArgs = {
  runId: Scalars['String']['input'];
};


export type MutationCancelPackingPendencyArgs = {
  input: CancelPackingPendencyInput;
};


export type MutationChooseAppointmentOptionArgs = {
  input: ChooseAppointmentOptionInput;
};


export type MutationClearCompanyArgs = {
  input: ClearCompanyInput;
};


export type MutationClearCompanyContactsArgs = {
  clearCompanyContactsInput: ClearCompanyContactsInput;
};


export type MutationClearDriverSettlementPayBoundArgs = {
  input: ClearDriverSettlementPayBoundInput;
};


export type MutationClearOrderExecutedByArgs = {
  input: ClearOrderExecutedByInput;
};


export type MutationCloneSavedFilterViewArgs = {
  cloneSavedFilterViewInput: CloneSavedFilterViewInput;
};


export type MutationCloseInventoryCountArgs = {
  closeInventoryCountInput: CloseInventoryCountInput;
};


export type MutationCompleteRebillArgs = {
  completeRebillInput: CompleteRebillInput;
};


export type MutationCompleteStopBulkArgs = {
  completeStopBulkInput: CompleteStopBulkInput;
};


export type MutationCompleteStopV2Args = {
  completeStopInput: CompleteStopInput;
};


export type MutationCompleteWorkOrderLoadingArgs = {
  input: CompleteWorkOrderLoadingInput;
};


export type MutationConfirmInventoryCountLinesArgs = {
  confirmInventoryCountLinesInput: ConfirmInventoryCountLinesInput;
};


export type MutationConfirmQuoteAcceptanceArgs = {
  confirmQuoteAcceptanceInput: ConfirmQuoteAcceptanceInput;
};


export type MutationConnectToQuickbooksDesktopArgs = {
  qbUserEmail: Scalars['String']['input'];
};


export type MutationCreateAccessorialArgs = {
  createAccessorialInput: CreateAccessorialInput;
};


export type MutationCreateAccessorialContactArgs = {
  accessorialContactCreateInput: CreateAccessorialContactInput;
};


export type MutationCreateAccessorialDateRangeConfigArgs = {
  createAccessorialDateRangeConfigInput: CreateAccessorialDateRangeConfigInput;
};


export type MutationCreateAccessorialGroupArgs = {
  input: CreateAccessorialGroupInput;
};


export type MutationCreateAccessorialToQuickbooksMappingArgs = {
  accessorialToQuickbooksMappingCreateInput: AccessorialToQuickbooksMappingCreateInput;
};


export type MutationCreateAccountingReportDocumentArgs = {
  createAccountingReportDocumentInput: CreateBasicDocumentInput;
};


export type MutationCreateAddressArgs = {
  createAddressInput: CreateAddressInput;
};


export type MutationCreateAdjustmentStopDriverMapArgs = {
  adjustmentStopDriverMapCreateInput: AdjustmentStopDriverMapCreateInput;
};


export type MutationCreateAirportInfoArgs = {
  createAirportInfoInput: CreateAirportInfoInput;
};


export type MutationCreateApiUserArgs = {
  createApiUserInput: CreateApiUserInput;
};


export type MutationCreateAppointmentsForRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationCreateAutoApplyAccessorialConfigArgs = {
  createAutoApplyAccessorialConfigInput: CreateAutoApplyAccessorialConfigInput;
};


export type MutationCreateBusinessDivisionArgs = {
  createBusinessDivisionInput: CreateBusinessDivisionInput;
};


export type MutationCreateCompanyArgs = {
  createCompanyInput: CreateCompanyInput;
};


export type MutationCreateConsolidatedOrderArgs = {
  createConsolidatedOrderInput: CreateConsolidatedOrderInput;
};


export type MutationCreateConsolidatedOrderFromOrderArgs = {
  createConsolidatedOrderFromOrderInput: CreateConsolidatedOrderFromOrderInput;
};


export type MutationCreateContactCommentArgs = {
  createContactCommentInput: CreateContactCommentInput;
};


export type MutationCreateContactCommunicationConfigArgs = {
  createContactCommunicationConfigInput: CreateContactCommunicationConfigInput;
};


export type MutationCreateContactDocumentArgs = {
  createContactDocumentInput: CreateContactDocumentInput;
};


export type MutationCreateContactEmailArgs = {
  createContactEmailInput: CreateContactEmailInput;
};


export type MutationCreateContactPersonArgs = {
  createContactPersonInput: CreateContactPersonInput;
};


export type MutationCreateContactStationArgs = {
  contactStationCreateInput: ContactStationCreateInput;
};


export type MutationCreateCoverSheetDocumentTypeSequenceArgs = {
  coverSheetDocumentTypeSequenceCreateInput: CoverSheetDocumentTypeSequenceCreateInput;
};


export type MutationCreateCreditTypeArgs = {
  creditTypeCreateInput: CreditTypeCreateInput;
};


export type MutationCreateCsvOrderFieldMappingArgs = {
  createCsvOrderFieldMappingInput: CreateCsvOrderFieldMappingInput;
};


export type MutationCreateCsvOrderImportTransactionArgs = {
  createCsvOrderImportTransactionInput: CreateCsvOrderImportTransactionInput;
};


export type MutationCreateCsvOrderMappingArgs = {
  createCsvOrderMappingInput: CreateCsvOrderMappingInput;
};


export type MutationCreateCustomerContactArgs = {
  createCustomerContactInput: CreateCustomerContactInput;
};


export type MutationCreateCustomerContactsArgs = {
  createCustomerContactsInput: CreateCustomerContactsInput;
};


export type MutationCreateDispatchViewArgs = {
  dispatchViewCreateInput: DispatchViewCreateInput;
};


export type MutationCreateDocExtractionEvalRunArgs = {
  input: CreateDocExtractionEvalRunInput;
};


export type MutationCreateDocExtractionEvalSetArgs = {
  input: CreateDocExtractionEvalSetInput;
};


export type MutationCreateDocumentArgs = {
  createDocumentInput: CreateDocumentInput;
};


export type MutationCreateDriverArgs = {
  createDriverInput: CreateDriverInput;
};


export type MutationCreateDriverCredentialTypeArgs = {
  input: CreateDriverCredentialTypeInput;
};


export type MutationCreateDriverInsurancePolicyArgs = {
  input: CreateDriverInsurancePolicyInput;
};


export type MutationCreateDriverSettlementBillArgs = {
  createDriverSettlementBillInput: CreateDriverSettlementBillInput;
};


export type MutationCreateDriverSignableFormTemplateArgs = {
  createDriverSignableFormTemplateInput: CreateDriverSignableFormTemplateInput;
};


export type MutationCreateDriverTrainingRecordArgs = {
  input: CreateDriverTrainingRecordInput;
};


export type MutationCreateDriversArgs = {
  createDriversInput: CreateDriversInput;
};


export type MutationCreateDuplicateOrderForRebillArgs = {
  createDuplicateOrderForRebillInput: CreateDuplicateOrderForRebillInput;
};


export type MutationCreateDwellTimeAlertConfigArgs = {
  createDwellTimeAlertConfigInput: CreateDwellTimeAlertConfigInput;
};


export type MutationCreateEodDocumentsArgs = {
  createEodDocumentsInput: CreateEodDocumentsInput;
};


export type MutationCreateEdiPartnershipArgs = {
  createEdiPartnershipInput: CreateEdiPartnershipInput;
};


export type MutationCreateEdiPartnershipServiceMappingsArgs = {
  createEdiPartnershipServiceMappingsInput: CreateEdiPartnershipServiceMappingsInput;
};


export type MutationCreateEdiTransactionArgs = {
  createEdiTransactionInput: CreateEdiTransactionInput;
};


export type MutationCreateEmailTransactionArgs = {
  createEmailTransactionInput: CreateEmailTransactionInput;
};


export type MutationCreateEmailTransactionLogArgs = {
  emailTransactionLogCreateInput: EmailTransactionLogCreateInput;
};


export type MutationCreateEndOfDayDocumentProcessingJobArgs = {
  createEndOfDayDocumentProcessingJobInput: CreateEndOfDayDocumentProcessingJobInput;
};


export type MutationCreateEquipmentArgs = {
  createEquipmentInput: CreateEquipmentInput;
};


export type MutationCreateEquipmentLicenseArgs = {
  createEquipmentLicenseInput: CreateEquipmentLicenseInput;
};


export type MutationCreateEquipmentsArgs = {
  createEquipmentsInput: CreateEquipmentsInput;
};


export type MutationCreateFeatureFlagArgs = {
  createFeatureFlagInput: CreateFeatureFlagInput;
};


export type MutationCreateFeatureFlagCompanyOverrideArgs = {
  createFeatureFlagCompanyOverrideInput: CreateFeatureFlagCompanyOverrideInput;
};


export type MutationCreateFeatureFlagUserOverrideArgs = {
  createFeatureFlagUserOverrideInput: CreateFeatureFlagUserOverrideInput;
};


export type MutationCreateFreightChargeArgs = {
  createFreightChargeInput: CreateFreightChargeInput;
};


export type MutationCreateFuelProfileArgs = {
  createFuelProfileInput: CreateFuelProfileInput;
};


export type MutationCreateFuelProfileDateRangeArgs = {
  createFuelProfileDateRangeInput: CreateFuelProfileDateRangeInput;
};


export type MutationCreateGeneralLedgerCodeArgs = {
  input: GeneralLedgerCodeCreateInput;
};


export type MutationCreateHoldReasonArgs = {
  holdReasonCreateInput: HoldReasonCreateInput;
};


export type MutationCreateImportedOrderTypeMappingArgs = {
  importedOrderTypeMappingCreateInput: ImportedOrderTypeMappingCreateInput;
};


export type MutationCreateImportedOrderTypeMappingsArgs = {
  importedOrderTypeMappingCreateInputs: Array<ImportedOrderTypeMappingCreateInput>;
};


export type MutationCreateIngestionTestUploadArgs = {
  input: CreateIngestionTestUploadInput;
};


export type MutationCreateInventoryItemsArgs = {
  createInventoryItemsInput: CreateInventoryItemsInput;
};


export type MutationCreateInventoryPrimaryUnitOfMeasureArgs = {
  createInventoryPrimaryUnitOfMeasureInput: CreateInventoryPrimaryUnitOfMeasureInput;
};


export type MutationCreateInventorySecondaryUnitOfMeasureArgs = {
  createInventorySecondaryUnitOfMeasureInput: CreateInventorySecondaryUnitOfMeasureInput;
};


export type MutationCreateInvoiceArgs = {
  createInvoiceInput: CreateInvoiceInput;
};


export type MutationCreateInvoiceDocumentArgs = {
  createInvoiceDocumentInput: CreateInvoiceDocumentInput;
};


export type MutationCreateInvoiceDocumentsArgs = {
  createInvoiceDocumentsInput: CreateInvoiceDocumentsInput;
};


export type MutationCreateInvoiceNoteRuleArgs = {
  invoiceNoteRuleInput: InvoiceNoteRuleInput;
};


export type MutationCreateInvoiceTermsArgs = {
  terms: Scalars['String']['input'];
};


export type MutationCreateInvoiceTermsForAllArgs = {
  createInvoiceTermsForAllInput: CreateInvoiceTermsForAllInput;
};


export type MutationCreateItemArgs = {
  createItemInput: CreateItemInput;
};


export type MutationCreateItemLocationArgs = {
  createItemLocationInput: CreateItemLocationInput;
};


export type MutationCreateLegArgs = {
  createLegInput: CreateLegInput;
};


export type MutationCreateLegDriverMapArgs = {
  createLegDriverMapInput: CreateLegDriverMapInput;
};


export type MutationCreateLineHaulLaneArgs = {
  createLineHaulLaneInput: CreateLineHaulLaneInput;
};


export type MutationCreateLineHaulManifestArgs = {
  createLineHaulManifestInput: CreateLineHaulManifestInput;
};


export type MutationCreateLineHaulManifestsArgs = {
  input: CreateLineHaulManifestsInput;
};


export type MutationCreateLineHaulSegmentArgs = {
  createLineHaulSegmentInput: CreateLineHaulSegmentInput;
};


export type MutationCreateLineHaulTruckRunsArgs = {
  input: CreateTruckRunsInput;
};


export type MutationCreateManyReferenceNumberLabelsArgs = {
  referenceNumberLabels: Array<Scalars['String']['input']>;
};


export type MutationCreateMasterAccountArgs = {
  createMasterAccountInput: CreateMasterAccountInput;
};


export type MutationCreateMirrorTargetArgs = {
  input: CreateMirrorTargetInput;
};


export type MutationCreateNotificationArgs = {
  createNotificationInput: CreateNotificationInput;
};


export type MutationCreateOrUpdateCsvOrdersArgs = {
  createOrUpdateCsvOrdersInput: CreateOrUpdateCsvOrdersInput;
};


export type MutationCreateOrderCommentArgs = {
  createOrderCommentInput: CreateOrderCommentInput;
};


export type MutationCreateOrderDelegationRuleArgs = {
  input: CreateOrderDelegationRuleInput;
};


export type MutationCreateOrderDocumentArgs = {
  createOrderDocumentInput: CreateOrderDocumentInput;
};


export type MutationCreateOrderDocumentDocumentArgs = {
  createOrderDocumentDocumentInput: CreateOrderDocumentDocumentInput;
};


export type MutationCreateOrderImportConfigurationArgs = {
  orderImportConfigurationCreateInput: OrderImportConfigurationCreateInput;
};


export type MutationCreateOrderLineHaulSegmentArgs = {
  orderLineHaulSegmentCreateInput: OrderLineHaulSegmentCreateInput;
};


export type MutationCreateOrderSnapshotArgs = {
  orderEventSnapshotCreateInput: OrderEventSnapshotCreateInput;
};


export type MutationCreateOrderTableReportArgs = {
  createOrderTableReportInput: CreateOrderTableReportInput;
};


export type MutationCreateOrdersFromRecurringTemplatesArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationMessageArgs = {
  input: CreateOrganizationMessageInput;
};


export type MutationCreateOrganizationPeerArgs = {
  input: CreateOrganizationPeerInput;
};


export type MutationCreateOutboundBenchOrdersArgs = {
  input: CreateOutboundBenchOrdersInput;
};


export type MutationCreateOutlookIntegrationArgs = {
  outlookIntegrationCreateInput: OutlookIntegrationCreateInput;
};


export type MutationCreatePodReportDocumentArgs = {
  createPodReportDocumentInput: CreatePodReportDocumentInput;
};


export type MutationCreatePackageArgs = {
  createPackageInput: CreatePackageInput;
};


export type MutationCreatePackageSpecArgs = {
  createPackageSpecInput: CreatePackageSpecInput;
};


export type MutationCreatePackingPendencyArgs = {
  input: CreatePackingPendencyInput;
};


export type MutationCreatePaymentArgs = {
  createPaymentInput: CreatePaymentInput;
};


export type MutationCreatePdfColumnArgs = {
  createPdfColumnInput: CreatePdfColumnInput;
};


export type MutationCreatePermissionArgs = {
  createPermissionInput: CreatePermissionInput;
};


export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationCreatePicklistArgs = {
  createPicklistInput: CreatePicklistInput;
};


export type MutationCreatePieceArgs = {
  createPieceInput: CreatePieceInput;
};


export type MutationCreatePieceDocumentArgs = {
  createPieceDocumentInput: CreatePieceDocumentInput;
};


export type MutationCreatePieceReceiptArgs = {
  createPieceReceiptInput: CreatePieceReceiptInput;
};


export type MutationCreatePieceWithoutOrderArgs = {
  input: CreatePieceWithoutOrderInput;
};


export type MutationCreatePlaceArgs = {
  createPlaceInput: CreatePlaceInput;
};


export type MutationCreateProratedConsolidatedOrderArgs = {
  createProratedConsolidatedOrderInput: CreateProratedConsolidatedOrderInput;
};


export type MutationCreateQuickbooksHeaderFileMappingArgs = {
  createQuickbooksHeaderFileMappingInput: CreateQuickbooksHeaderFileMappingInput;
};


export type MutationCreateQuoteArgs = {
  createQuoteInput: CreateQuoteInput;
};


export type MutationCreateRecurringLineHaulManifestTemplateArgs = {
  input: CreateRecurringLineHaulManifestTemplateInput;
};


export type MutationCreateRecurringOrderFrequencyArgs = {
  createRecurringOrderFrequencyInput: CreateRecurringOrderFrequencyInput;
};


export type MutationCreateRecurringTemplateTruckArgs = {
  input: CreateRecurringTemplateTruckInput;
};


export type MutationCreateReportGroupConfigurationArgs = {
  createReportGroupConfigurationInput: ReportGroupConfigurationCreateInput;
};


export type MutationCreateReverseOrderArgs = {
  createReverseOrderInput: CreateReverseOrderInput;
};


export type MutationCreateRoleArgs = {
  createRoleInput: CreateRoleInput;
};


export type MutationCreateRouteArgs = {
  createRouteInput: CreateRouteInput;
};


export type MutationCreateRouteDriverArgs = {
  createRouteDriverInput: CreateRouteDriverInput;
};


export type MutationCreateRouteFromRouteTemplateArgs = {
  input: CreateRouteFromRouteTemplateInput;
};


export type MutationCreateRouteNameArgs = {
  createRouteNameInput: CreateRouteNameInput;
};


export type MutationCreateRouteNameLocationArgs = {
  createRouteNameLocationInput: CreateRouteNameLocationInput;
  routeNameUuid: Scalars['String']['input'];
};


export type MutationCreateRouteOptimizationArgs = {
  createRouteOptimizationInput: CreateRouteOptimizationInput;
};


export type MutationCreateRoutePathsArgs = {
  routePathsCreateInput: RoutePathsCreateInput;
};


export type MutationCreateRouteSlotArgs = {
  createRouteSlotInput: CreateRouteSlotInput;
};


export type MutationCreateRoutesArgs = {
  createRoutesInput: CreateRoutesInput;
};


export type MutationCreateRunArgs = {
  createRunInput: CreateRunInput;
};


export type MutationCreateSameDayDispatchConfigArgs = {
  createSameDayDispatchConfigInput: CreateSameDayDispatchConfigInput;
};


export type MutationCreateSamsaraOauthTokenArgs = {
  createSamsaraOauthTokenInput: CreateSamsaraOauthTokenInput;
};


export type MutationCreateSandboxRouteForDriverArgs = {
  createSandboxRouteForDriverInput: CreateSandboxRouteForDriverInput;
};


export type MutationCreateSavedFilterViewArgs = {
  createSavedFilterViewInput: CreateSavedFilterViewInput;
};


export type MutationCreateScannedOrdersArgs = {
  createScannedOrdersInput: CreateScannedOrdersInput;
};


export type MutationCreateScannedOrdersFromAdminArgs = {
  createScannedOrdersFromAdminInput: CreateScannedOrdersFromAdminInput;
};


export type MutationCreateSchedulingRegionArgs = {
  input: CreateSchedulingRegionInput;
};


export type MutationCreateSchedulingResourceArgs = {
  input: CreateSchedulingResourceInput;
};


export type MutationCreateSchedulingZoneArgs = {
  input: CreateSchedulingZoneInput;
};


export type MutationCreateSchemaArgs = {
  createSchemaInput: CreateSchemaInput;
};


export type MutationCreateSchemaCompanyMappingArgs = {
  createSchemaCompanyMappingInput: CreateSchemaCompanyMappingInput;
};


export type MutationCreateSchemaDocumentArgs = {
  createSchemaDocumentInput: CreateSchemaDocumentInput;
};


export type MutationCreateSchemaTestSnapshotArgs = {
  createSchemaTestSnapshotInput: CreateSchemaTestSnapshotInput;
};


export type MutationCreateServiceArgs = {
  createServiceInput: CreateServiceInput;
};


export type MutationCreateServiceGroupArgs = {
  input: CreateServiceGroupInput;
};


export type MutationCreateServiceRegionsArgs = {
  input: CreateServiceRegionsInput;
};


export type MutationCreateSettlementAdjustmentArgs = {
  settlementAdjustmentCreateInput: SettlementAdjustmentCreateInput;
};


export type MutationCreateSettlementDeductionArgs = {
  settlementDeductionCreateInput: SettlementDeductionCreateInput;
};


export type MutationCreateSettlementDeductionTypeArgs = {
  settlementDeductionTypeCreateInput: SettlementDeductionTypeCreateInput;
};


export type MutationCreateSftpCredentialsArgs = {
  createSftpCredentialsInput: CreateSftpCredentialsInput;
};


export type MutationCreateShipmentDocumentArgs = {
  createShipmentDocumentInput: CreateShipmentDocumentInput;
};


export type MutationCreateStandardOrderArgs = {
  createStandardOrderInput: CreateStandardOrderInput;
};


export type MutationCreateStandardOrderFieldsArgs = {
  createStandardOrderFieldsInput: CreateStandardOrderFieldsInput;
};


export type MutationCreateStandardOrderWithDuplicateResolutionArgs = {
  createStandardOrderInput: CreateStandardOrderInput;
};


export type MutationCreateStandardShipmentFieldsArgs = {
  createStandardShipmentFieldsInput: CreateStandardShipmentFieldInput;
};


export type MutationCreateStorageOrderArgs = {
  createStorageOrderInput: CreateStorageOrderInput;
};


export type MutationCreateStorageOrderDocumentArgs = {
  createStorageOrderDocumentInput: CreateStorageOrderDocumentInput;
};


export type MutationCreateStorageUnitArgs = {
  createStorageUnitInput: CreateStorageUnitInput;
};


export type MutationCreateStorageUnitWithInventoryItemsArgs = {
  createStorageUnitWithInventoryItemsInput: CreateStorageUnitWithInventoryItemsInput;
};


export type MutationCreateTagArgs = {
  createTagInput: CreateTagInput;
};


export type MutationCreateTariffArgs = {
  createTariffInput: CreateTariffInput;
};


export type MutationCreateTariffChainArgs = {
  createTariffChainInput: CreateTariffChainInput;
};


export type MutationCreateTariffGroupArgs = {
  createTariffGroupInput: CreateTariffGroupInput;
};


export type MutationCreateTariffLocationArgs = {
  createTariffLocationInput: CreateTariffLocationInput;
};


export type MutationCreateTariffZoneArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneCreateInput: TariffZoneCreateInput;
};


export type MutationCreateTariffZoneGroupArgs = {
  tariffZoneGroupCreateInput: TariffZoneGroupCreateInput;
};


export type MutationCreateTerminalArgs = {
  createTerminalInput: CreateTerminalInput;
};


export type MutationCreateTerminalLanesArgs = {
  input: CreateTerminalLanesInput;
};


export type MutationCreateTerminalServiceAreaArgs = {
  createTerminalServiceAreaInput: CreateTerminalServiceAreaInput;
};


export type MutationCreateTerminalServiceAreasArgs = {
  createTerminalServiceAreaInputs: Array<CreateTerminalServiceAreaInput>;
};


export type MutationCreateTerminalServiceAreasV2Args = {
  createTerminalServiceAreaInputs: Array<CreateTerminalServiceAreaInput>;
};


export type MutationCreateTerminalV2Args = {
  input: TerminalCreateInput;
};


export type MutationCreateTerminalsArgs = {
  createTerminalsInput: CreateTerminalsInput;
};


export type MutationCreateTestAbstainedScannedOrderArgs = {
  createTestAbstainedScannedOrderInput: CreateTestAbstainedScannedOrderInput;
};


export type MutationCreateTestAccessorialArgs = {
  createTestAccessorialInput: CreateTestAccessorialInput;
};


export type MutationCreateTestApiOrderArgs = {
  input: CreateTestApiOrderInput;
};


export type MutationCreateTestCompanyArgs = {
  createTestCompanyInput: CreateTestCompanyInput;
};


export type MutationCreateTestContactArgs = {
  createTestContactInput: CreateTestContactInput;
};


export type MutationCreateTestDelegatableOrderArgs = {
  createTestDelegatableOrderInput: CreateTestDelegatableOrderInput;
};


export type MutationCreateTestEdiOrderArgs = {
  input: CreateTestEdiOrderInput;
};


export type MutationCreateTestOrderArgs = {
  createTestOrderInput: CreateTestOrderInput;
};


export type MutationCreateTestOrderCustomChargeArgs = {
  createTestOrderCustomChargeInput: CreateTestOrderCustomChargeInput;
};


export type MutationCreateTestOrderDelegationArgs = {
  createTestOrderDelegationInput: CreateTestOrderDelegationInput;
};


export type MutationCreateTestOrderQuoteArgs = {
  createTestOrderQuoteInput: CreateTestOrderQuoteInput;
};


export type MutationCreateTestOrderV2Args = {
  createTestOrderRequest: CreateTestOrderRequest;
};


export type MutationCreateTestOrganizationPeerArgs = {
  createTestOrganizationPeerInput: CreateTestOrganizationPeerInput;
};


export type MutationCreateTestPiecesOnOrderArgs = {
  input: CreateTestPiecesOnOrderInput;
};


export type MutationCreateTestReviewOrderArgs = {
  createTestReviewOrderInput: CreateTestReviewOrderInput;
};


export type MutationCreateTestTerminalLaneArgs = {
  input: CreateTestTerminalLaneInput;
};


export type MutationCreateTestThirdPartyUserArgs = {
  input: CreateTestThirdPartyUserInput;
};


export type MutationCreateTestUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationCreateThirdPartyBrokerArgs = {
  thirdPartyBrokerCreateInput: ThirdPartyBrokerCreateInput;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationCreateUserV2Args = {
  createUserInput: CreateUserInput;
};


export type MutationCreateVehicleTypeArgs = {
  vehicleTypeCreateInput: VehicleTypeCreateInput;
};


export type MutationCreateWarehouseArgs = {
  createWarehouseInput: CreateWarehouseInput;
};


export type MutationCreateWarehouseEmployeeArgs = {
  createWarehouseEmployeeInput: CreateWarehouseEmployeeInput;
};


export type MutationCreateWarehouseLocationArgs = {
  createWarehouseLocationInput: CreateWarehouseLocationInput;
};


export type MutationDeactivateTestTerminalArgs = {
  input: DeactivateTestTerminalInput;
};


export type MutationDeclineCustomerAppointmentOptionsArgs = {
  input: CustomerAppointmentTokenInput;
};


export type MutationDeclineOrderDelegationArgs = {
  input: DeclineOrderDelegationInput;
};


export type MutationDeclineQuoteArgs = {
  declineQuoteInput: DeclineQuoteInput;
};


export type MutationDeleteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteAccessorialDateRangeConfigArgs = {
  deleteAccessorialDateRangeConfigInput: DeleteAccessorialDateRangeConfigInput;
};


export type MutationDeleteAccessorialGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAccessorialRangeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteAutoApplyAccessorialConfigArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteContactCommentArgs = {
  deleteContactCommentInput: DeleteContactCommentInput;
};


export type MutationDeleteContactEmailArgs = {
  deleteContactEmailInput: DeleteContactEmailInput;
};


export type MutationDeleteCsvOrderFieldMappingArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteCustomDocumentNameArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteDrayageShipmentFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteDriverCredentialTypeArgs = {
  input: DeleteDriverCredentialTypeInput;
};


export type MutationDeleteDriverInsurancePolicyArgs = {
  input: DriverComplianceItemInput;
};


export type MutationDeleteDriverSignableFormTemplateArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteDriverTrainingRecordArgs = {
  input: DriverComplianceItemInput;
};


export type MutationDeleteDwellTimeAlertConfigArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteEdiPartnershipReferenceMappingsArgs = {
  deleteEdiPartnershipReferenceMappingsInput: DeleteEdiTypedReferenceMappingsInput;
};


export type MutationDeleteEdiPartnershipServiceMappingsArgs = {
  deleteEdiPartnershipServiceMappingsInput: DeleteEdiPartnershipServiceMappingsInput;
};


export type MutationDeleteEquipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteFeatureFlagCompanyOverrideArgs = {
  deleteFeatureFlagCompanyOverrideInput: DeleteFeatureFlagCompanyOverrideInput;
};


export type MutationDeleteFeatureFlagUserOverrideArgs = {
  deleteFeatureFlagUserOverrideInput: DeleteFeatureFlagUserOverrideInput;
};


export type MutationDeleteFreightChargeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteFuelProfileDateRangeArgs = {
  deleteFuelProfileDateRangeInput: DeleteFuelProfileDateRangeInput;
};


export type MutationDeleteGeneralLedgerCodeArgs = {
  input: GeneralLedgerCodeDeleteInput;
};


export type MutationDeleteInventoryCountArgs = {
  deleteInventoryCountInput: DeleteInventoryCountInput;
};


export type MutationDeleteInventoryItemsArgs = {
  deleteInventoryItemsInput: DeleteInventoryItemsInput;
};


export type MutationDeleteInvoiceNoteRuleArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteLegDriverMapArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteMirrorTargetArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteOrderCommentArgs = {
  deleteOrderCommentInput: DeleteOrderCommentInput;
};


export type MutationDeleteOrderDelegationRuleArgs = {
  input: DeleteOrderDelegationRuleInput;
};


export type MutationDeleteOrphanPieceArgs = {
  pieceUuid: Scalars['String']['input'];
};


export type MutationDeletePackageArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeletePaymentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeletePermissionArgs = {
  deletePermissionInput: DeletePermissionInput;
};


export type MutationDeletePieceReceiptArgs = {
  deletePieceReceiptInput: DeletePieceReceiptInput;
};


export type MutationDeleteQuickbooksHeaderFileMappingArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteQuoteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteRecurringLineHaulManifestTemplateArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteRecurringTemplateTruckArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteReportGroupConfigurationArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteRoleArgs = {
  deleteRoleInput: DeleteRoleInput;
};


export type MutationDeleteRouteNameLocationArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSameDayDispatchConfigArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSavedFilterViewArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSchemaArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSchemaCompanyMappingArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSchemaDocumentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteSchemaRunArgs = {
  deleteSchemaRunInput: DeleteSchemaRunInput;
};


export type MutationDeleteServiceGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSlotsFromRouteArgs = {
  deleteSlotsFromRouteInput: DeleteSlotsFromRouteInput;
};


export type MutationDeleteStandardOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteStandardOrderFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteStopAttemptArgs = {
  deleteStopAttemptInput: DeleteStopAttemptInput;
};


export type MutationDeleteStopDriverMapArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteStorageOrderArgs = {
  deleteStorageOrderInput: DeleteStorageOrderInput;
};


export type MutationDeleteStorageOrdersArgs = {
  deleteStorageOrdersInput: DeleteStorageOrdersInput;
};


export type MutationDeleteStorageUnitArgs = {
  deleteStorageUnitInput: DeleteStorageUnitInput;
};


export type MutationDeleteTagArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffGroupArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffLocationArgs = {
  deleteTariffLocationInput: DeleteTariffLocationInput;
};


export type MutationDeleteTariffRangeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffZoneArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteTariffZonesArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type MutationDeleteTariffsArgs = {
  tariffsDeleteInput: TariffsDeleteInput;
};


export type MutationDeleteTerminalLanesArgs = {
  input: DeleteTerminalLanesInput;
};


export type MutationDeleteUserArgs = {
  deleteUserInput: DeleteUserInput;
};


export type MutationDeleteWarehouseArgs = {
  warehouseUuid: Scalars['String']['input'];
};


export type MutationDeleteWarehouseLocationArgs = {
  deleteWarehouseLocationInput: DeleteWarehouseLocationInput;
};


export type MutationDetachDocumentFromShipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDetachDocumentsFromShipmentsArgs = {
  detachDocumentsFromShipmentsInput: DetachDocumentsFromShipmentsInput;
};


export type MutationDismissDelegationAccessorialProposalArgs = {
  input: DismissDelegationAccessorialProposalInput;
};


export type MutationDismissOrganizationMessageArgs = {
  input: OrganizationMessageUuidInput;
};


export type MutationDismissQuoteArgs = {
  dismissQuoteInput: DismissQuoteInput;
};


export type MutationDismissScannedOrderResultArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDispatchApplySuggestedManifestsArgs = {
  input: DispatchApplySuggestedManifestsInput;
};


export type MutationDispatchTextDriverArgs = {
  textDriverInput: TextDriverInput;
};


export type MutationDocumentationAdminCreateItemArgs = {
  input: DocumentationItemCreateInput;
};


export type MutationDocumentationAdminCreateTopicArgs = {
  input: DocumentationTopicCreateInput;
};


export type MutationDocumentationAdminDeleteItemArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDocumentationAdminDeleteTopicArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDocumentationAdminReorderArgs = {
  input: DocumentationReorderInput;
};


export type MutationDocumentationAdminUpdateItemArgs = {
  input: DocumentationItemUpdateInput;
};


export type MutationDocumentationAdminUpdateTopicArgs = {
  input: DocumentationTopicUpdateInput;
};


export type MutationDownloadInvoicesArgs = {
  downloadInvoicesInput: DownloadInvoicesInput;
};


export type MutationDriverSettlementBillExportPdfArgs = {
  driverSettlementBillExportPdfInput: DriverSettlementBillExportPdfInput;
};


export type MutationDriverSettlementBillExportZipArgs = {
  input: DriverSettlementBillExportPdfInput;
};


export type MutationDuplicateEdiPartnershipsArgs = {
  duplicateEdiPartnershipsInput: DuplicateEdiPartnershipsInput;
};


export type MutationDuplicateTariffGroupArgs = {
  duplicateTariffGroupInput: DuplicateTariffGroupInput;
};


export type MutationEditContactsArgs = {
  editContactsInput: EditContactsInput;
};


export type MutationEmailAccountingReportArgs = {
  emailAccountingReportInput: EmailAccountingReportInput;
};


export type MutationEmailOrderDocumentArgs = {
  emailOrderDocumentInput: EmailOrderDocumentInput;
};


export type MutationEstimateDocExtractionEvalRunArgs = {
  input: EstimateDocExtractionEvalRunInput;
};


export type MutationExecutePackingPendencyArgs = {
  input: ExecutePackingPendencyInput;
};


export type MutationExemptSchedulingResourceFromCompanyBlockedDayArgs = {
  input: CompanySchedulingDayExemptionInput;
};


export type MutationExportInvoicesToQuickbooksDesktopArgs = {
  exportInvoicesToQuickbooksInput: ExportInvoicesToQuickbooksInput;
};


export type MutationFinalizeDriverSettlementBillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationFinalizeInvoicesArgs = {
  finalizeInvoicesInput: FinalizeInvoicesInput;
};


export type MutationFinalizeOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationFinalizeOrdersArgs = {
  finalizeOrdersInput: FinalizeOrdersInput;
};


export type MutationFinalizeSettlementBillsArgs = {
  finalizeSettlementBillsInput: FinalizeSettlementBillsInput;
};


export type MutationFireOutboundBenchTransactionArgs = {
  input: FireOutboundBenchTransactionInput;
};


export type MutationFlipIsArchivedArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationGenerateAccountingReportPreSignedPutUrlArgs = {
  generateAccountingReportPreSignedPutUrlInput: GenerateAccountingReportPreSignedPutUrlInput;
};


export type MutationGenerateClearCompanyContactsTokenArgs = {
  generateClearCompanyContactsTokenInput: GenerateClearCompanyContactsTokenInput;
};


export type MutationGenerateContactPreSignedPutUrlArgs = {
  generateContactPreSignedPutUrlInput: GenerateContactPreSignedPutUrlInput;
};


export type MutationGenerateHistoricalInvoicesCsvArgs = {
  generateHistoricalInvoicesCsvInput: GenerateHistoricalInvoicesCsvInput;
};


export type MutationGenerateInvoicePreSignedPutUrlArgs = {
  generateInvoicePreSignedPutUrlInput: GenerateInvoicePreSignedPutUrlInput;
};


export type MutationGenerateInvoicePreSignedPutUrlsArgs = {
  generateInvoicePreSignedPutUrlsInput: GenerateInvoicePreSignedPutUrlsInput;
};


export type MutationGenerateLabelArgs = {
  generateLabelInput: GenerateLabelInput;
};


export type MutationGenerateLineHaulRunsArgs = {
  input: GenerateLineHaulRunsInput;
};


export type MutationGenerateMobileSignedDocumentPreSignedPutUrlArgs = {
  input: UploadMobileSignedDocumentInput;
};


export type MutationGenerateOrderDocumentPreSignedPutUrlArgs = {
  generateOrderDocumentPreSignedPutUrlInput: GenerateOrderDocumentPreSignedPutUrlInput;
};


export type MutationGenerateOrderPreSignedGetAndPutUrlsArgs = {
  generateOrderPreSignedGetAndPutUrlsInput: GenerateOrderPreSignedGetAndPutUrlsInput;
};


export type MutationGenerateOrderPreSignedPutUrlArgs = {
  generateOrderPreSignedPutUrlInput: GenerateOrderPreSignedPutUrlInput;
};


export type MutationGeneratePiecePreSignedPutUrlArgs = {
  generatePiecePreSignedPutUrlInput: GeneratePiecePreSignedPutUrlInput;
};


export type MutationGeneratePodReportPreSignedPutUrlArgs = {
  generatePodReportPreSignedPutUrlInput: GeneratePodReportPreSignedPutUrlInput;
};


export type MutationGeneratePreSignedPutUrlArgs = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};


export type MutationGenerateResetCompanyTokenArgs = {
  generateResetCompanyTokenInput: GenerateResetCompanyTokenInput;
};


export type MutationGenerateShipmentPreSignedPutUrlArgs = {
  generateShipmentPreSignedPutUrlInput: GenerateShipmentPreSignedPutUrlInput;
};


export type MutationGenerateStorageOrderPreSignedPutUrlArgs = {
  generateStorageOrderPreSignedPutUrlInput: GenerateStorageOrderPreSignedPutUrlInput;
};


export type MutationHandleMultipleInvoices210OutboundArgs = {
  handleMultiple210OutboundInput: HandleMultiple210OutboundInput;
};


export type MutationImportCrownAccessorialArgs = {
  importCrownAccessorialInput: ImportCrownAccessorialInput;
};


export type MutationImportCrownContactsV2Args = {
  companyUuid: Scalars['String']['input'];
  csvUrl: Scalars['String']['input'];
  useNewImporter?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportCrownDriversArgs = {
  importCrownDriversInput: ImportCrownDriversInput;
};


export type MutationImportCrownInvoicesArgs = {
  importCrownInvoicesInput: ImportCrownInvoicesInput;
};


export type MutationImportCrownLanesArgs = {
  importCrownLanesInput: ImportCrownLanesInput;
};


export type MutationImportCrownOrdersArgs = {
  importCrownOrdersInput: ImportCrownOrdersInput;
};


export type MutationImportCrownPaymentsArgs = {
  importCrownPaymentsInput: ImportCrownPaymentsInput;
};


export type MutationImportCrownTariffArgs = {
  importCrownTariffInput: ImportCrownTariffInput;
};


export type MutationImportCrownUsersArgs = {
  importCrownUsersInput: ImportCrownUsersInput;
};


export type MutationImportCustomerDefaultAddressesArgs = {
  companyUuid: Scalars['String']['input'];
  csvUrl: Scalars['String']['input'];
};


export type MutationImportQuickbooksDesktopMappingsArgs = {
  companyUuid: Scalars['String']['input'];
  qbDesktopMappingsUrl: Scalars['String']['input'];
};


export type MutationImportRecoveryTerminalArgs = {
  importRecoveryTerminalInput: ImportRecoveryTerminalInput;
};


export type MutationImportStorageOrdersFromCsvArgs = {
  importStorageOrdersFromCsvInput: ImportStorageOrdersFromCsvInput;
};


export type MutationImportTerminalServiceAreasArgs = {
  importTerminalServiceAreasInput: ImportTerminalServiceAreasInput;
};


export type MutationImportTestSnapshotArgs = {
  importTestSnapshotInput: ImportTestSnapshotInput;
};


export type MutationImportThirdPartyPortalAccountEmailsArgs = {
  companyUuid: Scalars['String']['input'];
  csvUrl: Scalars['String']['input'];
};


export type MutationImportWarehouseLocationsFromCsvArgs = {
  importWarehouseLocationsFromCsvInput: ImportWarehouseLocationsFromCsvInput;
};


export type MutationInitiateDelegatedOrderReviewArgs = {
  input: InitiateDelegatedOrderReviewInput;
};


export type MutationKpiRecordTableDownloadArgs = {
  args: KpiRecordTableDownloadArgs;
};


export type MutationLinkPieceToOrderArgs = {
  orderUuid: Scalars['String']['input'];
  packageUuid: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};


export type MutationLinkPieceToOrderWithRoleArgs = {
  input: LinkPieceToOrderInput;
};


export type MutationLinkPieceToPackageArgs = {
  linkPieceToPackageInput: LinkPieceToPackageInput;
};


export type MutationLinkPiecesToPackageArgs = {
  linkPiecesToPackageInput: LinkPiecesToPackageInput;
};


export type MutationLogUnassignedScanArgs = {
  logUnassignedScanInput: LogUnassignedScanInput;
};


export type MutationLoginArgs = {
  loginInputData: LoginInput;
};


export type MutationLoginInternalArgs = {
  loginInputData: LoginInput;
};


export type MutationLoginPhoneArgs = {
  loginPhoneInput: LoginPhoneInput;
};


export type MutationLoginPhoneJwtArgs = {
  loginPhoneJwtInput: LoginPhoneJwtInput;
};


export type MutationLoginPhoneJwtV2Args = {
  loginPhoneJwtInput: LoginPhoneJwtInput;
};


export type MutationLoginPhoneV2Args = {
  loginPhoneInput: LoginPhoneInput;
};


export type MutationMakeAppointmentConfirmationDecisionArgs = {
  input: MakeAppointmentConfirmationDecisionInput;
};


export type MutationManuallySetInvoicesQbSyncStatusArgs = {
  invoiceUuids: Array<Scalars['String']['input']>;
  synced: Scalars['Boolean']['input'];
};


export type MutationMapPeerAccessorialArgs = {
  input: MapPeerAccessorialInput;
};


export type MutationMapPeerServiceArgs = {
  input: MapPeerServiceInput;
};


export type MutationMarkAsCancelledArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkAsOnHoldArgs = {
  markAsOnHoldInput: MarkAsOnHoldInput;
};


export type MutationMarkAttemptedStopAsCompleteArgs = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stopUuid: Scalars['String']['input'];
};


export type MutationMarkConsolidatableOrdersAsBilledIndividuallyArgs = {
  markConsolidatableOrdersAsBilledIndividuallyInput: MarkConsolidatableOrdersAsBilledIndividuallyInput;
};


export type MutationMarkManifestAsArrivedArgs = {
  markManifestAsArrivedInput: MarkManifestAsArrivedInput;
};


export type MutationMarkManifestAsDepartedArgs = {
  markManifestAsDepartedInput: MarkManifestAsDepartedInput;
};


export type MutationMarkManifestAsDoorsClosedArgs = {
  markManifestAsDoorsClosedInput: MarkManifestAsDoorsClosedInput;
};


export type MutationMarkManifestAsPlanningArgs = {
  markManifestAsPlanningInput: MarkManifestAsPlanningInput;
};


export type MutationMarkNotOsdArgs = {
  markAsNotOsd: MarkNotOsdInput;
};


export type MutationMarkNotificationReadArgs = {
  input: MarkNotificationReadInput;
};


export type MutationMarkOrderAsCompleteForceArgs = {
  markOrderAsCompleteForceInput: MarkOrderAsCompleteForceInput;
};


export type MutationMarkOrderAsHasBillingIssueArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsNotCompleteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsNotOnHandArgs = {
  markAsNotOnHandInput: MarkAsNotOnHandInput;
};


export type MutationMarkOrderAsNotReadyToInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsNotReceivedAtOriginArgs = {
  markAsNotReceivedAtOriginInput: MarkAsNotReceivedAtOriginInput;
};


export type MutationMarkOrderAsOnHandArgs = {
  markAsOnHandInput: MarkAsOnHandInput;
};


export type MutationMarkOrderAsPickedArgs = {
  markOrderAsPickedInput: MarkOrderAsPickedInput;
};


export type MutationMarkOrderAsReadyToInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsReadyToInvoiceForceArgs = {
  refuseOrderInput?: InputMaybe<RefuseOrderInput>;
  uuid: Scalars['String']['input'];
};


export type MutationMarkOrderAsReceivedAtOriginArgs = {
  markAsReceivedAtOriginInput: MarkAsReceivedAtOriginInput;
};


export type MutationMarkOrderAsRefusedArgs = {
  markOrderAsRefusedInput: MarkOrderAsRefusedInput;
};


export type MutationMarkOsdArgs = {
  markOsdInput: MarkOsdInput;
};


export type MutationMarkPieceDamagedArgs = {
  markPieceDamagedInput: MarkPieceDamagedInput;
};


export type MutationMarkQuoteSentArgs = {
  markQuoteSentInput: MarkQuoteSentInput;
};


export type MutationMarkStopAsFailedArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkStopAsFailedV2Args = {
  markStopAsFailedV2Input: MarkStopAsFailedV2Input;
};


export type MutationMarkStopAsIncompleteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationMarkStorageUnitAsBilledArgs = {
  markStorageUnitAsBilledInput: MarkStorageUnitAsBilledInput;
};


export type MutationMarkStorageUnitAsOsdArgs = {
  markStorageUnitAsOsdInput: MarkStorageUnitAsOsdInput;
};


export type MutationMarkStorageUnitOnHandArgs = {
  markStorageUnitOnHandInput: MarkStorageUnitOnHandInput;
};


export type MutationMarkTestOrderForEdiReviewArgs = {
  markTestOrderForEdiReviewInput: MarkTestOrderForEdiReviewInput;
};


export type MutationMarkTutorialSeenArgs = {
  tutorialId: TutorialId;
};


export type MutationMarkWarehouseAsDefaultArgs = {
  warehouseUuid: Scalars['String']['input'];
};


export type MutationMatchFreightSnapArgs = {
  freightSnapCreateInput: FreightSnapCreateInput;
};


export type MutationMatchSignedPoDsArgs = {
  matchSignedPODsInput: CreateScannedOrdersInput;
};


export type MutationMergeEdiOrderArgs = {
  mergeEdiOrderInput: MergeEdiOrderInput;
};


export type MutationMergeScannedOrderResultIntoPossibleDuplicateArgs = {
  input: MergeScannedOrderResultIntoPossibleDuplicateInput;
};


export type MutationMoveShipmentsBetweenInvoicesArgs = {
  moveShipmentsBetweenInvoicesInput: MoveShipmentsBetweenInvoicesInput;
};


export type MutationMoveShipmentsToInvoiceArgs = {
  moveShipmentsToInvoiceInput: MoveShipmentsToInvoiceInput;
};


export type MutationNormalizeDocumentArgs = {
  normalizeDocumentInput: NormalizeDocumentInput;
};


export type MutationOffboardCompanyFromQuoteAgentArgs = {
  input: OffboardCompanyFromQuoteAgentInput;
};


export type MutationOpenMessageInOutlookArgs = {
  openMessageInOutlookInput: OpenMessageInOutlookInput;
};


export type MutationOptimizeRouteSequenceArgs = {
  input: OptimizeRouteSequenceInput;
};


export type MutationOptimizeRoutesTogetherArgs = {
  input: OptimizeRoutesTogetherInput;
};


export type MutationPackPiecesArgs = {
  input: PackPiecesInput;
};


export type MutationParseCsvOrdersArgs = {
  input: ParseCsvOrdersInput;
};


export type MutationPickQuoteCustomerArgs = {
  pickQuoteCustomerInput: PickQuoteCustomerInput;
};


export type MutationPickStorageUnitArgs = {
  pickStorageUnitInput: PickStorageUnitInput;
};


export type MutationPreviewDocExtractionEvalSetArgs = {
  config: Scalars['JSON']['input'];
};


export type MutationProrateOrdersArgs = {
  prorateOrdersInput: ProrateOrdersInput;
};


export type MutationPublishOrganizationMessageArgs = {
  input: PublishOrganizationMessageInput;
};


export type MutationQueueAppointmentSchedulingProposalsArgs = {
  input: QueueAppointmentSchedulingProposalsInput;
};


export type MutationQueueAppointmentTextsArgs = {
  queueAppointmentTextsArgs: QueueAppointmentTextsArgs;
};


export type MutationReactivateUserArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationReanalyzePageArgs = {
  reanalyzePageInput: ReanalyzePageInput;
};


export type MutationReanalyzeSchemaFileArgs = {
  reanalyzeSchemaFileInput: ReanalyzeSchemaFileInput;
};


export type MutationReassignRouteSlotArgs = {
  routeSlotReassignInput: RouteSlotReassignInput;
};


export type MutationReconfigureDriverSettlementPayTermsArgs = {
  input: ReconfigureDriverSettlementPayTermsInput;
};


export type MutationRecordContactAttemptedArgs = {
  recordContactAttemptedArgs: RecordContactAttemptedArgs;
};


export type MutationRecordInboundReviewDecisionsArgs = {
  input: RecordInboundReviewDecisionsInput;
};


export type MutationRecordInventoryCountUnexpectedArgs = {
  recordInventoryCountUnexpectedInput: RecordInventoryCountUnexpectedInput;
};


export type MutationRecreateScannedOrderForEmailAttachmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRefreshAuthTokenArgs = {
  refreshAuthTokenInput: RefreshAuthTokenInput;
};


export type MutationRefreshEtasForRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRehireDriverArgs = {
  input: RehireDriverInput;
};


export type MutationRejectCustomerPortalOrderArgs = {
  rejectCustomerPortalOrderInput: RejectCustomerPortalOrderInput;
};


export type MutationRejectDelegationEndCustomerLinkArgs = {
  input: RejectDelegationEndCustomerLinkInput;
};


export type MutationRejectEdiOrderArgs = {
  rejectEdiOrderInput: RejectEdiOrderInput;
};


export type MutationRejectEdiOrdersArgs = {
  rejectEdiOrdersInput: RejectEdiOrdersInput;
};


export type MutationRejectExpeditorsWorkOrderArgs = {
  orderUuid: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectQuoteReplyArgs = {
  rejectQuoteReplyInput: RejectQuoteReplyInput;
};


export type MutationRemoveAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveAddressArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveApiUserContactMappingArgs = {
  removeApiUserContactMappingInput: RemoveApiUserContactMappingInput;
};


export type MutationRemoveBusinessDivisionArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveContactArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveContactPersonArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveContactsArgs = {
  removeContactsInput: RemoveContactsInput;
};


export type MutationRemoveCoverSheetDocumentTypeSequenceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveCreditTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveDispatchViewArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveDriverSettlementBillArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveDriversFromRouteArgs = {
  removeDriversFromRouteInput: RemoveDriversFromRouteInput;
};


export type MutationRemoveEmailTransactionLogArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveFeatureFlagArgs = {
  removeFeatureFlagInput: FeatureFlagRemoveInput;
};


export type MutationRemoveFuelProfileArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveGeneralLedgerCodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveGeneralLedgerConfigurationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveHelperFromRouteArgs = {
  helperUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};


export type MutationRemoveHoldReasonArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveImportedOrderTypeMappingArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveInvoiceTermsArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineHaulLaneArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineHaulManifestArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineHaulSegmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveLineItemsFromSettlementBillArgs = {
  removeLineItemsFromSettlementBillInput: RemoveLineItemsFromSettlementBillInput;
};


export type MutationRemoveMasterAccountArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveOrderHoldArgs = {
  removeOrderHoldInput: RemoveOrderHoldInput;
};


export type MutationRemoveOrderLineHaulSegmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveOrdersFromManifestArgs = {
  removeOrdersFromManifestInput: RemoveOrdersFromManifestInput;
};


export type MutationRemoveOrdersFromManifestV2Args = {
  input: RemoveOrdersFromManifestV2Input;
};


export type MutationRemovePaymentOffsetArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemovePiecesFromPieceReceiptArgs = {
  removePiecesFromPieceReceiptInput: RemovePiecesFromPieceReceiptInput;
};


export type MutationRemoveRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveRouteDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveSchedulingResourceCompanyBlockedDayExemptionArgs = {
  input: CompanySchedulingDayExemptionInput;
};


export type MutationRemoveServiceArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveServiceToContactArgs = {
  removeServiceFromContactInput: RemoveServiceFromContactInput;
};


export type MutationRemoveSettlementAdjustmentArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveSettlementDeductionArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveSettlementDeductionTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveShipmentsFromInvoiceArgs = {
  removeShipmentsFromInvoiceInput: RemoveShipmentsFromInvoiceInput;
};


export type MutationRemoveSpecialAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveStopsFromRoutesArgs = {
  removeStopsFromRoutesInput: RemoveStopsFromRoutesInputType;
};


export type MutationRemoveStorageUnitOnHandArgs = {
  removeStorageUnitOnHandInput: RemoveStorageUnitOnHandInput;
};


export type MutationRemoveStorageUnitOsdArgs = {
  removeStorageUnitOsdInput: RemoveStorageUnitOsdInput;
};


export type MutationRemoveSubscriberFromShipmentArgs = {
  removeSubscriberInput: RemoveSubscriberInput;
};


export type MutationRemoveTagFromLegArgs = {
  removeTagFromLegInput: RemoveTagFromLegInput;
};


export type MutationRemoveTagFromOrderArgs = {
  removeTagFromOrderInput: RemoveTagFromOrderInput;
};


export type MutationRemoveTerminalArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveTerminalServiceAreaArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveThirdPartyBrokerArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveThirdPartyUserFromContactArgs = {
  removeThirdPartyUserFromContactInput: RemoveThirdPartyUserFromContactInput;
};


export type MutationRemoveUserFromRoleArgs = {
  removeUserFromRoleInput: RemoveUserFromRoleInput;
};


export type MutationRemoveVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveZoneBasedAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationReplayOutboundEdiArgs = {
  replayOutboundEdiInput: ReplayOutboundEdiInput;
};


export type MutationReportADocScanIssueArgs = {
  reportADocScanIssueInput: ReportADocScanIssueInput;
};


export type MutationRequestCustomerAppointmentLinkArgs = {
  input: CustomerAppointmentTokenInput;
};


export type MutationRequestOrderMirrorSyncArgs = {
  input: RequestOrderMirrorSyncInput;
};


export type MutationRequestQuoteRepriceArgs = {
  requestQuoteRepriceInput: RequestQuoteRepriceInput;
};


export type MutationRequoteQuoteAtCurrentPriceArgs = {
  requoteQuoteAtCurrentPriceInput: RequoteQuoteAtCurrentPriceInput;
};


export type MutationRerateOrderFreightArgs = {
  orderUuid: Scalars['String']['input'];
};


export type MutationRerateQuoteFreightArgs = {
  quoteUuid: Scalars['String']['input'];
};


export type MutationRescheduleOrganizationMessageArgs = {
  input: ScheduleOrganizationMessageInput;
};


export type MutationResendExternalTransmissionArgs = {
  input: ResendExternalTransmissionInput;
};


export type MutationResetCompanyArgs = {
  resetCompanyInput: ResetCompanyInput;
};


export type MutationResolveOrganizationMessageArgs = {
  input: ResolveOrganizationMessageInput;
};


export type MutationResolveQuoteReplySendArgs = {
  resolveQuoteReplySendInput: ResolveQuoteReplySendInput;
};


export type MutationResolveScannedOrderBillingPartyArgs = {
  resolveScannedOrderBillingPartyInput: ResolveScannedOrderBillingPartyInput;
};


export type MutationRestoreAirportInfoArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRestoreContactStationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRestoreOrganizationArgs = {
  input: RestoreOrganizationInput;
};


export type MutationRestorePackageSpecArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestorePersonArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreSchedulingRegionArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreSchedulingResourceArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreSchedulingZoneArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreTariffChainArgs = {
  restoreTariffChainInput: RestoreTariffChainInput;
};


export type MutationRestoreTariffZoneGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationRestoreVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRestoreWarehouseEmployeeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRetryFailedInvoice210OutboundArgs = {
  invoiceUuid: Scalars['String']['input'];
};


export type MutationRetryInvoiceSendJobBatchesArgs = {
  invoiceSendJobBatchUuids: Array<Scalars['String']['input']>;
  skipFailures: Scalars['Boolean']['input'];
};


export type MutationRetrySftpUploadsArgs = {
  retrySftpUploadsInput: RetrySftpUploadsInput;
};


export type MutationReuploadPodsArgs = {
  reuploadPodsInput: ReuploadPodsInput;
};


export type MutationRevokeOrganizationPeerArgs = {
  input: RevokeOrganizationPeerInput;
};


export type MutationRotateDocumentArgs = {
  rotateDocumentInput: RotateDocumentInput;
};


export type MutationRotateQuoteAgentForwardingTokenArgs = {
  connectionUuid: Scalars['String']['input'];
};


export type MutationRunOptimizationArgs = {
  createOptimizationRunInput: CreateOptimizationRunDto;
};


export type MutationRunTestAccessorialDetectionArgs = {
  runTestAccessorialDetectionInput: RunTestAccessorialDetectionInput;
};


export type MutationSamsaraDiscoverySetTokenArgs = {
  input: SamsaraDiscoverySetTokenInput;
};


export type MutationSaveCostInputQuickbooksMappingsArgs = {
  input: SaveCostInputQuickbooksMappingsInput;
};


export type MutationSaveCostInputSetupArgs = {
  input: SaveCostInputSetupInput;
};


export type MutationSaveCostInputsArgs = {
  input: SaveCostInputsInput;
};


export type MutationSavePointToPointLanesArgs = {
  input: SavePointToPointLanesInput;
};


export type MutationSaveSmc3SettingsArgs = {
  input: SaveSmc3SettingsInput;
};


export type MutationSaveTenediPartnershipArgs = {
  input: SaveTenediPartnershipInput;
};


export type MutationScanOrderArgs = {
  scanOrderInput: ScanOrderInput;
};


export type MutationScanOrderBarcodeArgs = {
  scanOrderBarcodeInput: ScanOrderBarcodeInput;
};


export type MutationScanPieceArgs = {
  scanPieceInput: ScanPieceInput;
};


export type MutationScanWarehouseLocationArgs = {
  scanWarehouseLocationInput: ScanWarehouseLocationInput;
};


export type MutationScanningV2__BulkProcessPiecesArgs = {
  input: FreightScanningV2BulkProcessPiecesInput;
};


export type MutationScanningV2__CommitWorkOrderScanArgs = {
  input: FreightScanningV2CommitWorkOrderScanInput;
};


export type MutationScanningV2__MoveWarehouseLocationArgs = {
  input: FreightScanningV2MoveWarehouseLocationInput;
};


export type MutationScanningV2__ProcessBarcodeArgs = {
  input: FreightScanningV2ProcessBarcodeInput;
};


export type MutationScanningV2__ProcessBarcodeLeanArgs = {
  input: FreightScanningV2ProcessBarcodeInput;
};


export type MutationScanningV2__SelectPackageArgs = {
  input: FreightScanningV2SelectPackageInput;
};


export type MutationScheduleOrganizationMessageArgs = {
  input: ScheduleOrganizationMessageInput;
};


export type MutationSelectRoleArgs = {
  selectRoleInput: SelectRoleInput;
};


export type MutationSendAccountingReportsArgs = {
  sendAccountingReportsInput: SendAccountingReportsInput;
};


export type MutationSendDeliveryCompletedArgs = {
  sendDeliveryCompletedInput: SendDeliveryCompletedInput;
};


export type MutationSendInvoicesArgs = {
  sendInvoicesInput: SendInvoicesInput;
};


export type MutationSendMetricArgs = {
  sendMetricInput: SendMetricInput;
};


export type MutationSendRouteToAgentArgs = {
  input: SendRouteToAgentInput;
};


export type MutationSendStopToAgentArgs = {
  input: SendStopToAgentInput;
};


export type MutationSetAccessorialQboItemMappingArgs = {
  input: SetAccessorialQboItemMappingInput;
};


export type MutationSetCompanyAccountTypeArgs = {
  input: SetCompanyAccountTypeInput;
};


export type MutationSetContactChargeMatrixColumnMappingsArgs = {
  setContactChargeMatrixColumnMappingsInput: SetContactChargeMatrixColumnMappingsInput;
};


export type MutationSetDockDoorsArgs = {
  input: SetDockDoorsInput;
};


export type MutationSetDriverComplianceDatesArgs = {
  input: SetDriverComplianceDatesInput;
};


export type MutationSetDriverSettlementPayBoundsArgs = {
  input: SetDriverSettlementPayBoundsInput;
};


export type MutationSetLaneDefaultDoorArgs = {
  input: SetLaneDefaultDoorInput;
};


export type MutationSetLineHaulManifestDepartTimeArgs = {
  input: SetManifestDepartTimeInput;
};


export type MutationSetLineHaulManifestLoadPositionArgs = {
  input: SetLineHaulManifestLoadPositionInput;
};


export type MutationSetLineHaulManifestOrderLoadPositionArgs = {
  input: SetLineHaulManifestOrderLoadPositionInput;
};


export type MutationSetLineHaulManifestTrailersArgs = {
  input: SetManifestTrailersInput;
};


export type MutationSetLineHaulManifestTruckArgs = {
  input: SetManifestTruckInput;
};


export type MutationSetLineHaulSegmentTimingArgs = {
  input: SetLineHaulSegmentTimingInput;
};


export type MutationSetMirrorTargetCompaniesArgs = {
  input: SetMirrorTargetCompaniesInput;
};


export type MutationSetMotiveApiKeyArgs = {
  input: SetMotiveApiKeyInput;
};


export type MutationSetNotificationCutoverModeArgs = {
  input: SetNotificationCutoverModeInput;
};


export type MutationSetOrderExecutedByArgs = {
  input: SetOrderExecutedByInput;
};


export type MutationSetOrderMirrorCaptureConfigArgs = {
  input: SetOrderMirrorCaptureConfigInput;
};


export type MutationSetOrganizationEmitPieceLevelWebhooksArgs = {
  enabled: Scalars['Boolean']['input'];
  organizationUuid: Scalars['String']['input'];
};


export type MutationSetOrganizationRequireScanToAdvancePieceStatusAtStopsArgs = {
  enabled: Scalars['Boolean']['input'];
  organizationUuid: Scalars['String']['input'];
};


export type MutationSetPeerAccessorialSharesArgs = {
  input: SetPeerAccessorialSharesInput;
};


export type MutationSetPeerServiceSharesArgs = {
  input: SetPeerServiceSharesInput;
};


export type MutationSetSchedulingResourceEligibilityRulesArgs = {
  input: SetSchedulingResourceEligibilityRulesInput;
};


export type MutationSetStorageOrderItemQuantityArgs = {
  setStorageOrderItemQuantityInput: SetStorageOrderItemQuantityInput;
};


export type MutationShareSavedFilterViewArgs = {
  shareSavedFilterViewInput: ShareSavedFilterViewInput;
};


export type MutationSignUpForThirdPartyUserAccountArgs = {
  signUpForThirdPartyUserAccountInput: SignUpForThirdPartyUserAccountInput;
};


export type MutationSplitAndProcessOrderDocumentsArgs = {
  splitAndProcessOrderDocumentsInput: SplitAndProcessOrderDocumentsInput;
};


export type MutationStartConfigMigrationArgs = {
  input: StartConfigMigrationInput;
};


export type MutationStartInventoryCountArgs = {
  startInventoryCountInput: StartInventoryCountInput;
};


export type MutationStartPieceBackfillRunArgs = {
  input: StartPieceBackfillRunInput;
};


export type MutationStartRouteArgs = {
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};


export type MutationSyncInvoiceStatusWithQuickbooksArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationSyncInvoicesToQuickbooksArgs = {
  options?: InputMaybe<QuickbooksSyncOptionsInput>;
  uuids: Array<Scalars['String']['input']>;
};


export type MutationTerminateDriverArgs = {
  input: TerminateDriverInput;
};


export type MutationTestOneSnapshotArgs = {
  testOneSnapshotInput: TestOneSnapshotInput;
};


export type MutationTestSchemaArgs = {
  testSchemaInput: TestSchemaInput;
};


export type MutationTestSmc3RateArgs = {
  input: TestSmc3RateInput;
};


export type MutationTextDriverArgs = {
  textDriverInput: TextDriverInput;
};


export type MutationTextractSchemaFileArgs = {
  textractSchemaFileInput: TextractSchemaFileInput;
};


export type MutationTextractSchemaTestFileArgs = {
  textractSchemaTestFileInput: TextractSchemaTestFileInput;
};


export type MutationTransferPieceToOrderArgs = {
  input: TransferPieceToOrderInput;
};


export type MutationTransferPieceToOutboundOrderArgs = {
  input: TransferPieceToOutboundOrderInput;
};


export type MutationTransitionAppointmentArgs = {
  transitionAppointmentInput: TransitionAppointmentInput;
};


export type MutationTriggerAdhocPreviewArgs = {
  input: TriggerAdhocPreviewInput;
};


export type MutationTriggerAdhocPreviewBatchArgs = {
  input: TriggerAdhocPreviewBatchInput;
};


export type MutationTriggerIngestionTestRunArgs = {
  input: TriggerIngestionTestRunInput;
};


export type MutationUnassignInventoryItemsArgs = {
  unassignInventoryItemsInput: UnassignInventoryItemsInput;
};


export type MutationUnassignLegFromDriverArgs = {
  unassignLegFromDriver: UnassignLegFromDriverInput;
};


export type MutationUnassignOrderFromLineHaulTrailerArgs = {
  input: UnassignOrderFromTrailerInput;
};


export type MutationUnblockCompanySchedulingDayArgs = {
  input: UnblockCompanySchedulingDayInput;
};


export type MutationUnblockSchedulingResourceDayArgs = {
  input: UnblockSchedulingResourceDayInput;
};


export type MutationUncancelOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationUnconsolidateOrderArgs = {
  unconsolidateOrderInput: UnconsolidateOrderInput;
};


export type MutationUnfinalizeOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationUnfinalizeOrdersArgs = {
  unfinalizeOrdersInput: UnfinalizeOrdersInput;
};


export type MutationUnlinkPieceFromOrderArgs = {
  input: UnlinkPieceFromOrderInput;
};


export type MutationUnlinkPieceFromPackageArgs = {
  unlinkPieceFromPackageInput: UnlinkPieceFromPackageInput;
};


export type MutationUnmarkPieceDamagedArgs = {
  pieceUuid: Scalars['String']['input'];
};


export type MutationUnpackPiecesArgs = {
  input: UnpackPiecesInput;
};


export type MutationUnpickOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationUnpickStorageUnitArgs = {
  unpickStorageUnitInput: UnpickStorageUnitInput;
};


export type MutationUnpostInvoiceArgs = {
  unpostInvoiceInput: UnpostInvoiceInput;
};


export type MutationUnpostInvoicesArgs = {
  unpostInvoicesInput: UnpostInvoicesInput;
};


export type MutationUpdateArgs = {
  updateEquipmentLicenseInput: UpdateEquipmentLicenseInput;
};


export type MutationUpdateAccessorialArgs = {
  updateAccessorialInput: UpdateAccessorialInput;
};


export type MutationUpdateAccessorialContactArgs = {
  accessorialContactInput: UpdateAccessorialContactInput;
};


export type MutationUpdateAccessorialDateRangeConfigArgs = {
  updateAccessorialDateRangeConfigInput: UpdateAccessorialDateRangeConfigInput;
};


export type MutationUpdateAccessorialGroupArgs = {
  input: UpdateAccessorialGroupInput;
};


export type MutationUpdateAccessorialRangesForAccessorialArgs = {
  accessorialRangeUpdatesInput: AccessorialRangeUpdatesInput;
};


export type MutationUpdateAccessorialToQuickbooksMappingArgs = {
  accessorialToQuickbooksMappingUpdateInput: AccessorialToQuickbooksMappingUpdateInput;
};


export type MutationUpdateAddressArgs = {
  updateAddressInput: UpdateAddressInput;
};


export type MutationUpdateAirportInfoArgs = {
  updateAirportInfoInput: UpdateAirportInfoInput;
};


export type MutationUpdateApiUserArgs = {
  updateApiUserInput: UpdateApiUserInput;
};


export type MutationUpdateAutoApplyAccessorialConfigArgs = {
  updateAutoApplyAccessorialConfigInput: UpdateAutoApplyAccessorialConfigInput;
};


export type MutationUpdateBusinessDivisionArgs = {
  updateBusinessDivisionInput: UpdateBusinessDivisionInput;
};


export type MutationUpdateCompanyArgs = {
  updateCompanyInput: UpdateCompanyInput;
};


export type MutationUpdateCompanyConfigurationArgs = {
  updateCompanyConfigurationInput: UpdateCompanyConfigurationInput;
};


export type MutationUpdateContactCommentArgs = {
  updateContactCommentInput: UpdateContactCommentInput;
};


export type MutationUpdateContactCommunicationConfigArgs = {
  updateContactCommunicationConfigInput: UpdateContactCommunicationConfigInput;
};


export type MutationUpdateContactEmailsArgs = {
  input: UpdateContactEmailsInput;
};


export type MutationUpdateContactPersonArgs = {
  updateContactPersonInput: UpdateContactPersonInput;
};


export type MutationUpdateContactStationArgs = {
  contactStationUpdateInput: ContactStationUpdateInput;
};


export type MutationUpdateContactToServicesTariffGroupMappingsArgs = {
  contactToServicesMappings: Array<CreateContactToServicesMappingInput>;
  uuid: Scalars['String']['input'];
};


export type MutationUpdateCoverSheetDocumentTypeSequenceArgs = {
  coverSheetDocumentTypeSequenceUpdateInput: CoverSheetDocumentTypeSequenceUpdateInput;
};


export type MutationUpdateCreditTypeArgs = {
  creditTypeUpdateInput: CreditTypeUpdateInput;
};


export type MutationUpdateCsvOrderFieldMappingArgs = {
  updateCsvOrderFieldMappingInput: UpdateCsvOrderFieldMappingInput;
};


export type MutationUpdateCsvOrderImportTransactionArgs = {
  updateCsvOrderImportTransactionInput: UpdateCsvOrderImportTransactionInput;
};


export type MutationUpdateCsvOrderMappingArgs = {
  updateCsvOrderMappingInput: UpdateCsvOrderMappingInput;
};


export type MutationUpdateCustomerContactArgs = {
  updateCustomerContactInput: UpdateCustomerContactInput;
};


export type MutationUpdateCustomerContactPackageSpecsArgs = {
  input: UpdateCustomerContactPackageSpecsInput;
};


export type MutationUpdateCustomerContactVehicleTypesArgs = {
  input: UpdateCustomerContactVehicleTypesInput;
};


export type MutationUpdateDefaultTariffChainsForCompanyArgs = {
  updateDefaultTariffChainsForCompanyInput: UpdateDefaultTariffChainsForCompanyInput;
};


export type MutationUpdateDispatchTableColorsArgs = {
  input: UpdateDispatchTableColorsInput;
};


export type MutationUpdateDispatchViewArgs = {
  dispatchViewUpdateInput: DispatchViewUpdateInput;
};


export type MutationUpdateDocumentArgs = {
  updateDocumentInput: UpdateDocumentInput;
};


export type MutationUpdateDocumentsArgs = {
  updateDocumentsInput: UpdateDocumentsInput;
};


export type MutationUpdateDriverArgs = {
  updateDriverInput: UpdateDriverInput;
};


export type MutationUpdateDriverComplianceProfileArgs = {
  input: UpdateDriverComplianceProfileInput;
};


export type MutationUpdateDriverCredentialTypeArgs = {
  input: UpdateDriverCredentialTypeInput;
};


export type MutationUpdateDriverInsurancePolicyArgs = {
  input: UpdateDriverInsurancePolicyInput;
};


export type MutationUpdateDriverLocationArgs = {
  updateDriverLocationInput: UpdateDriverLocationInput;
};


export type MutationUpdateDriverQualificationsArgs = {
  input: UpdateDriverQualificationsInput;
};


export type MutationUpdateDriverSettlementBillArgs = {
  updateDriverSettlementBillInput: UpdateDriverSettlementBillInput;
};


export type MutationUpdateDriverSignableFormTemplateArgs = {
  updateDriverSignableFormTemplateInput: UpdateDriverSignableFormTemplateInput;
};


export type MutationUpdateDriverTrainingRecordArgs = {
  input: UpdateDriverTrainingRecordInput;
};


export type MutationUpdateDwellTimeAlertConfigArgs = {
  updateDwellTimeAlertConfigInput: UpdateDwellTimeAlertConfigInput;
};


export type MutationUpdateEdiPartnershipArgs = {
  updateEdiPartnershipInput: UpdateEdiPartnershipInput;
};


export type MutationUpdateEmailIngestionExclusionsArgs = {
  updateEmailIngestionExclusionsInput: UpdateEmailIngestionExclusionsInput;
};


export type MutationUpdateEmailTransactionArgs = {
  updateEmailTransactionInput: UpdateEmailTransactionInput;
};


export type MutationUpdateEmailTransactionLogArgs = {
  emailTransactionLogInput: EmailTransactionLogUpdateInput;
};


export type MutationUpdateEndOfDayDocumentProcessingJobArgs = {
  updateEndOfDayDocumentProcessingJobInput: UpdateEndOfDayDocumentProcessingJobInput;
};


export type MutationUpdateEquipmentArgs = {
  updateEquipmentInput: UpdateEquipmentInput;
};


export type MutationUpdateFeatureFlagArgs = {
  updateFeatureFlagInput: UpdateFeatureFlagInput;
};


export type MutationUpdateFeatureFlagCompanyOverrideArgs = {
  updateFeatureFlagCompanyOverrideInput: UpdateFeatureFlagCompanyOverrideInput;
};


export type MutationUpdateFeatureFlagUserOverrideArgs = {
  updateFeatureFlagUserOverrideInput: UpdateFeatureFlagUserOverrideInput;
};


export type MutationUpdateFreightChargeArgs = {
  updateFreightChargeInput: UpdateFreightChargeInput;
};


export type MutationUpdateFuelProfileArgs = {
  updateFuelProfileInput: UpdateFuelProfileInput;
};


export type MutationUpdateFuelProfileDateRangeArgs = {
  updateFuelProfileDateRangeInput: UpdateFuelProfileDateRangeInput;
};


export type MutationUpdateGeneralLedgerCodeArgs = {
  input: GeneralLedgerCodeUpdateInput;
};


export type MutationUpdateGeneralLedgerConfigurationArgs = {
  input: GeneralLedgerConfigurationUpdateInput;
};


export type MutationUpdateHoldReasonArgs = {
  holdReasonUpdateInput: HoldReasonUpdateInput;
};


export type MutationUpdateImportedOrderTypeMappingArgs = {
  importedOrderTypeMappingInput: ImportedOrderTypeMappingUpdateInput;
};


export type MutationUpdateInAppNotificationPreferencesArgs = {
  input: UpdateInAppNotificationPreferencesInput;
};


export type MutationUpdateInventoryItemsArgs = {
  updateInventoryItemsInput: UpdateInventoryItemsInput;
};


export type MutationUpdateInvoiceArgs = {
  updateInvoiceInput: UpdateInvoiceInput;
};


export type MutationUpdateInvoiceEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateInvoiceLimitedArgs = {
  updateInvoiceLimitedInput: InvoiceUpdateLimitedInput;
};


export type MutationUpdateInvoiceNoteRuleArgs = {
  updateInvoiceNoteRuleInput: UpdateInvoiceNoteRuleInput;
};


export type MutationUpdateItemArgs = {
  updateItemInput: UpdateItemInput;
};


export type MutationUpdateItemLocationArgs = {
  updateItemLocationInput: UpdateItemLocationInput;
};


export type MutationUpdateKpiDashboardLayoutArgs = {
  input: UpdateKpiLayoutInput;
};


export type MutationUpdateLegDriverMapArgs = {
  updateLegDriverMapInput: UpdateLegDriverMapInput;
};


export type MutationUpdateLineHaulLaneArgs = {
  updateLineHaulLaneInput: UpdateLineHaulLaneInput;
};


export type MutationUpdateLineHaulManifestArgs = {
  updateLineHaulManifestInput: UpdateLineHaulManifestInput;
};


export type MutationUpdateLineHaulSegmentArgs = {
  updateLineHaulSegmentInput: UpdateLineHaulSegmentInput;
};


export type MutationUpdateManifestDriverArgs = {
  updateManifestDriverInput: UpdateManifestDriverInput;
};


export type MutationUpdateManifestVehicleArgs = {
  updateManifestVehicleInput: UpdateManifestVehicleInput;
};


export type MutationUpdateManifestsStatusArgs = {
  input: UpdateManifestsStatusInput;
};


export type MutationUpdateMasterAccountArgs = {
  updateMasterAccountInput: UpdateMasterAccountInput;
};


export type MutationUpdateMirrorTargetArgs = {
  input: UpdateMirrorTargetInput;
};


export type MutationUpdateMyStopArgs = {
  input: UpdateMyStopInput;
};


export type MutationUpdateOrderCommentArgs = {
  updateOrderCommentInput: UpdateOrderCommentInput;
};


export type MutationUpdateOrderDelegationRuleArgs = {
  input: UpdateOrderDelegationRuleInput;
};


export type MutationUpdateOrderEventNotificationSubscriptionsArgs = {
  input: UpdateOrderEventNotificationSubscriptionsInput;
};


export type MutationUpdateOrderFormFieldsArgs = {
  updateOrderFormFieldsInput: UpdateOrderFormFieldsInput;
};


export type MutationUpdateOrderImportConfigurationArgs = {
  orderImportConfigurationUpdateInput: OrderImportConfigurationUpdateInput;
};


export type MutationUpdateOrderLineHaulSegmentArgs = {
  orderLineHaulSegmentInput: OrderLineHaulSegmentUpdateInput;
};


export type MutationUpdateOrderLoadedStatusArgs = {
  updateOrderLoadedStatusInput: UpdateOrderLoadedStatusInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationMessageArgs = {
  input: UpdateOrganizationMessageInput;
};


export type MutationUpdateOrganizationPeersSettingsArgs = {
  input: UpdateOrganizationPeersSettingsInput;
};


export type MutationUpdateOutlookIntegrationArgs = {
  outlookIntegrationUpdateInput: OutlookIntegrationUpdateInput;
};


export type MutationUpdatePackageArgs = {
  updatePackageInput: UpdatePackageInput;
};


export type MutationUpdatePackageArrayArgs = {
  updatePackageArrayInput: UpdatePackageArrayInput;
};


export type MutationUpdatePackageSpecArgs = {
  updatePackageSpecInput: UpdatePackageSpecInput;
};


export type MutationUpdatePackageWarehouseLocationArgs = {
  updatePackageWarehouseLocationInput: UpdatePackageWarehouseLocationInput;
};


export type MutationUpdatePaperworkCompletedForStopsArgs = {
  updatePaperworkCompleteInput: UpdatePaperworkCompleteInput;
};


export type MutationUpdatePaymentArgs = {
  updatePaymentInput: UpdatePaymentInput;
};


export type MutationUpdatePaymentOffsetArgs = {
  input: UpdatePaymentOffsetInput;
};


export type MutationUpdatePermissionArgs = {
  updatePermissionInput: UpdatePermissionInput;
};


export type MutationUpdatePermissionAccessLevelArgs = {
  updatePermissionAccessLevelInput: UpdatePermissionAccessLevelInput;
};


export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationUpdatePieceArgs = {
  updatePieceInput: UpdatePieceInput;
};


export type MutationUpdatePieceCountArgs = {
  updatePieceCountInput: UpdatePieceCountInput;
};


export type MutationUpdatePieceDimensionsArgs = {
  input: UpdatePieceDimensionsInput;
};


export type MutationUpdatePieceReceiptArgs = {
  updatePieceReceiptInput: UpdatePieceReceiptInput;
};


export type MutationUpdatePieceReceiptPieceArgs = {
  updatePieceReceiptPieceInput: UpdatePieceReceiptPieceInput;
};


export type MutationUpdatePiecesPickedArgs = {
  updatePiecesPickedInput: UpdatePiecesPickedInput;
};


export type MutationUpdatePlaceArgs = {
  updatePlaceInput: UpdatePlaceInput;
};


export type MutationUpdateQuickAddAccessorialsArgs = {
  input: UpdateQuickAddAccessorialsInput;
};


export type MutationUpdateQuickbooksHeaderFileMappingArgs = {
  updateQuickbooksHeaderFileMappingInput: UpdateQuickbooksHeaderFileMappingInput;
};


export type MutationUpdateQuoteArgs = {
  updateQuoteInput: UpdateQuoteInput;
};


export type MutationUpdateQuoteAgentStaffSettingsArgs = {
  input: UpdateQuoteAgentStaffSettingsInput;
};


export type MutationUpdateRecurringLineHaulManifestTemplateArgs = {
  input: UpdateRecurringLineHaulManifestTemplateInput;
};


export type MutationUpdateRecurringOrderFrequencyArgs = {
  updateRecurringOrderFrequencyInput: UpdateRecurringOrderFrequencyInput;
};


export type MutationUpdateRecurringTemplateTruckArgs = {
  input: UpdateRecurringTemplateTruckInput;
};


export type MutationUpdateReportGroupConfigurationArgs = {
  updateReportGroupConfigurationInput: ReportGroupConfigurationUpdateInput;
};


export type MutationUpdateReportsEmailArgs = {
  email: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};


export type MutationUpdateRoleArgs = {
  updateRoleInput: UpdateRoleInput;
};


export type MutationUpdateRouteArgs = {
  updateRouteInput: UpdateRouteInput;
};


export type MutationUpdateRouteDriversArgs = {
  updateRouteDriversInput: UpdateRouteDriversInput;
};


export type MutationUpdateRouteNameLocationArgs = {
  updateRouteNameLocationInput: UpdateRouteNameLocationInput;
};


export type MutationUpdateRouteOptimizationArgs = {
  updateRouteOptimizationInput: UpdateRouteOptimizationInput;
};


export type MutationUpdateRouteSlotArgs = {
  updateRouteSlotInput: UpdateRouteSlotInput;
};


export type MutationUpdateRouteSlotsArgs = {
  updateRouteSlotsInput: UpdateRouteSlotsInput;
};


export type MutationUpdateRunArgs = {
  updateRunInput: UpdateRunInput;
};


export type MutationUpdateSameDayDispatchConfigArgs = {
  updateSameDayDispatchConfigInput: UpdateSameDayDispatchConfigInput;
};


export type MutationUpdateSavedFilterViewArgs = {
  updateSavedFilterViewInput: UpdateSavedFilterViewInput;
};


export type MutationUpdateScannedOrderArgs = {
  updateScannedOrderInput: UpdateScannedOrderInput;
};


export type MutationUpdateScannedOrderResultStatusArgs = {
  updateScannedOrderResultStatusInput: UpdateScannedOrderResultStatusInput;
};


export type MutationUpdateSchedulingRegionArgs = {
  input: UpdateSchedulingRegionInput;
};


export type MutationUpdateSchedulingResourceArgs = {
  input: UpdateSchedulingResourceInput;
};


export type MutationUpdateSchedulingZoneArgs = {
  input: UpdateSchedulingZoneInput;
};


export type MutationUpdateSchemaArgs = {
  updateSchemaInput: UpdateSchemaInput;
};


export type MutationUpdateSchemaCompanyMappingArgs = {
  updateSchemaCompanyMappingInput: UpdateSchemaCompanyMappingInput;
};


export type MutationUpdateSchemaDocumentArgs = {
  updateSchemaDocumentInput: UpdateSchemaDocumentInput;
};


export type MutationUpdateServiceArgs = {
  updateServiceInput: UpdateServiceInput;
};


export type MutationUpdateServiceDateForAssignedStopsArgs = {
  updateServiceDateForAssignedStopsInput: UpdateServiceDateForAssignedStopsInput;
};


export type MutationUpdateServiceGroupArgs = {
  input: UpdateServiceGroupInput;
};


export type MutationUpdateServiceRegionArgs = {
  input: UpdateServiceRegionInput;
};


export type MutationUpdateSettlementAdjustmentArgs = {
  settlementAdjustmentUpdateInput: SettlementAdjustmentUpdateInput;
};


export type MutationUpdateSettlementDeductionArgs = {
  settlementDeductionUpdateInput: SettlementDeductionUpdateInput;
};


export type MutationUpdateSettlementDeductionTypeArgs = {
  settlementDeductionTypeInput: SettlementDeductionTypeUpdateInput;
};


export type MutationUpdateSftpCredentialsArgs = {
  updateSftpCredentialsInput: UpdateSftpCredentialsInput;
};


export type MutationUpdateShipmentArgs = {
  updateShipmentInput: UpdateShipmentInput;
};


export type MutationUpdateShipmentStandardAccessorialsArgs = {
  updateShipmentStandardAccessorialsInput: UpdateShipmentStandardAccessorialsInput;
};


export type MutationUpdateSignedPodArgs = {
  updateSignedPODInput: UpdateScannedOrderInput;
};


export type MutationUpdateStandaloneStopArgs = {
  updateStandaloneStopInput: UpdateStandaloneStopInput;
};


export type MutationUpdateStandardOrderArgs = {
  updateStandardOrderInput: UpdateStandardOrderInput;
};


export type MutationUpdateStandardShipmentFieldsArgs = {
  updateStandardShipmentFieldsInput: UpdateStandardShipmentFieldInput;
};


export type MutationUpdateStopArgs = {
  updateStopInput: UpdateStopInput;
};


export type MutationUpdateStopDriverMapArgs = {
  updateStopDriverMapInput: UpdateStopDriverMapInput;
};


export type MutationUpdateStopsArgs = {
  updateStopsInput: UpdateStopsInput;
};


export type MutationUpdateStorageOrderArgs = {
  updateStorageOrderInput: UpdateStorageOrderInput;
};


export type MutationUpdateStorageUnitArgs = {
  updateStorageUnitInput: UpdateStorageUnitInput;
};


export type MutationUpdateTagArgs = {
  updateTagInput: UpdateTagInput;
};


export type MutationUpdateTariffChainArgs = {
  updateTariffChainInput: UpdateTariffChainInput;
};


export type MutationUpdateTariffGroupArgs = {
  updateTariffGroupInput: UpdateTariffGroupInput;
};


export type MutationUpdateTariffRangesForTariffArgs = {
  tariffRangeUpdatesInput: TariffRangeUpdatesInput;
};


export type MutationUpdateTariffZoneArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUpdateInput: TariffZoneUpdateInput;
};


export type MutationUpdateTariffZoneGroupArgs = {
  tariffZoneGroupUpdateInput: TariffZoneGroupUpdateInput;
};


export type MutationUpdateTemplateAndRecordAddressesArgs = {
  updateAddressInput: UpdateAddressInput;
};


export type MutationUpdateTenediCarrierIdentityArgs = {
  input: UpdateTenediCarrierIdentityInput;
};


export type MutationUpdateTenediCustomerIdentityArgs = {
  input: UpdateTenediCustomerIdentityInput;
};


export type MutationUpdateTerminalArgs = {
  updateTerminalInput: UpdateTerminalInput;
};


export type MutationUpdateTerminalServiceAreaArgs = {
  terminalServiceAreaInput: TerminalServiceAreaUpdateInput;
};


export type MutationUpdateTerminalV2Args = {
  input: TerminalUpdateInput;
};


export type MutationUpdateTestOrderArgs = {
  updateTestOrderInput: UpdateTestOrderInput;
};


export type MutationUpdateTestPieceStatusArgs = {
  input: UpdateTestPieceStatusInput;
};


export type MutationUpdateThirdPartyBrokerArgs = {
  thirdPartyBrokerUpdateInput: ThirdPartyBrokerUpdateInput;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateVehicleForRouteArgs = {
  routeUuid: Scalars['String']['input'];
  vehicleUuid: Scalars['String']['input'];
};


export type MutationUpdateVehicleTypeArgs = {
  vehicleTypeUpdateInput: VehicleTypeUpdateInput;
};


export type MutationUpdateWarehouseArgs = {
  updateWarehouseInput: UpdateWarehouseInput;
};


export type MutationUpdateWarehouseEmployeeArgs = {
  updateWarehouseEmployeeInput: UpdateWarehouseEmployeeInput;
};


export type MutationUpdateWarehouseLocationArgs = {
  updateWarehouseLocationInput: UpdateWarehouseLocationInput;
};


export type MutationUploadDocumentToExpeditorsArgs = {
  documentUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};


export type MutationUpsertAddressArgs = {
  upsertAddressInput: UpsertAddressInput;
};


export type MutationUpsertCompanyPackageTypeConfigArgs = {
  input: UpsertCompanyPackageTypeConfigInput;
};


export type MutationUpsertContactPersonArgs = {
  upsertContactPersonInput: UpsertContactPersonInput;
};


export type MutationUpsertDockTimeAllowancesArgs = {
  input: UpsertDockTimeAllowanceInput;
};


export type MutationUpsertDriverPlannerAssumptionsArgs = {
  input: UpsertDriverPlannerAssumptionsInput;
};


export type MutationUpsertEdiPartnershipReferenceMappingsArgs = {
  upsertEdiPartnershipReferenceMappingsInput: UpsertEdiPartnershipReferenceMappingsInput;
};


export type MutationUpsertFreightChargeArgs = {
  upsertFreightChargeInput: UpsertFreightChargeInput;
};


export type MutationUpsertItemGroupArgs = {
  upsertItemGroupInput: UpsertItemGroupInput;
};


export type MutationUpsertLineHaulUtilizationAssumptionsArgs = {
  input: UpsertLineHaulUtilizationAssumptionInput;
};


export type MutationUpsertOrganizationPackageTypeConfigArgs = {
  input: UpsertOrganizationPackageTypeConfigInput;
};


export type MutationUpsertPackageArgs = {
  upsertPackageInput: UpsertPackageInput;
};


export type MutationUpsertPicklistArgs = {
  upsertPicklistInput: UpsertPicklistInput;
};


export type MutationUpsertProductivityTimeAllowancesArgs = {
  input: UpsertTimeAllowanceInput;
};


export type MutationUpsertRouteAutomationSettingsArgs = {
  input: RouteAutomationSettingsInput;
};


export type MutationUpsertSamsaraOauthTokenArgs = {
  upsertSamsaraOauthTokenInput: UpsertSamsaraOauthTokenInput;
};


export type MutationUpsertShipmentSubscriberArgs = {
  upsertShipmentSubscriberInput: UpsertShipmentSubscriberInput;
};


export type MutationUpsertShipmentSubscriberForCompanyArgs = {
  companyUuid: Scalars['String']['input'];
  upsertShipmentSubscriberInput: UpsertShipmentSubscriberInput;
};


export type MutationUpsertStructuredExtractionSchemaOverrideArgs = {
  upsertStructuredExtractionSchemaOverrideInput: StructuredExtractionSchemaOverrideInput;
};


export type MutationUpsertUserContactNotificationSubscriptionArgs = {
  userContactNotificationSubscriptionUpsertInput: UserContactNotificationSubscriptionUpsertInput;
};


export type MutationUserSessionsAdminRevokeSessionsArgs = {
  input: RevokeCompanyUserSessionsInput;
};


export type MutationValidateCrownChargesFromCsvArgs = {
  validateCrownChargesInput: ValidateCrownChargesInput;
};


export type MutationValidateCrownChargesFromPdfArgs = {
  validateCrownChargesInput: ValidateCrownChargesInput;
};


export type MutationValidateImportedCrownInvoicesArgs = {
  validateImportedCrownInvoicesInput: ValidateImportedCrownInvoicesInput;
};


export type MutationVerifyInventoryForStorageUnitArgs = {
  verifyInventoryForStorageUnitInput: VerifyInventoryForStorageUnitInput;
};


export type MutationWithdrawOrganizationMessageArgs = {
  input: OrganizationMessageUuidInput;
};

export type MutationErrorOutput = {
  __typename?: 'MutationErrorOutput';
  message: Scalars['String']['output'];
};

export type NameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type NetSalesSummaryReportInput = {
  /** The UUIDs of the customers (contacts) to include in the report. If not included, the report will include net sales data for all customers. */
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type NetSalesSummaryReportOutput = {
  __typename?: 'NetSalesSummaryReportOutput';
  contactRows: Array<NetSalesSummaryReportOutputRow>;
  reportTotal: NetSalesSummaryReportOutputRow;
};

export type NetSalesSummaryReportOutputRow = {
  __typename?: 'NetSalesSummaryReportOutputRow';
  /** Total of credits and debits on open invoices */
  adjustmentsInCents: Scalars['Float']['output'];
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  dimWeight: Scalars['Float']['output'];
  /** openInvoiesTotal - adjustments */
  netSalesInCents: Scalars['Float']['output'];
  openInvoiesTotalInCents: Scalars['Float']['output'];
  pieces: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
};

export type NewInvoiceToCreate = {
  __typename?: 'NewInvoiceToCreate';
  name?: Maybe<Scalars['String']['output']>;
  ordersToAdd: Array<OrderToAddToInvoice>;
};

export type NewSettlementBillInput = {
  driverUuid: Scalars['String']['input'];
  settlementBillLineItemIds: Array<Scalars['String']['input']>;
};

export type NormalizeDocumentInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export enum NotificationChannel {
  Edi = 'EDI',
  Email = 'EMAIL',
  InApp = 'IN_APP',
  OutboundApi = 'OUTBOUND_API',
  Push = 'PUSH',
  TextMessage = 'TEXT_MESSAGE'
}

export type NotificationCutoverConfigEntity = {
  __typename?: 'NotificationCutoverConfigEntity';
  /** The channels of this event a shadow run cannot compare, even when the event is comparable on another channel. */
  engineOnlyChannels: Array<NotificationChannel>;
  /** The notification event type this row controls. */
  eventType: NotificationEventType;
  /** The ticket blocking FULL, or null when FULL is available. The write path names this same ticket when it refuses a FULL. */
  fullBlockedBy?: Maybe<Scalars['String']['output']>;
  /** Whether a configured FULL is honoured for this event type. When false, FULL is downgraded to SHADOW at resolve time (the engine runs in parallel instead of delivering), so a row can report mode FULL while no cutover is in effect. Render the two together so an operator is not left believing a cutover happened. */
  fullEligible: Scalars['Boolean']['output'];
  /** Why FULL is safe for this event, or null when FULL is not available. */
  fullEligibleBecause?: Maybe<Scalars['String']['output']>;
  /** The static description of what this event is and who it reaches. */
  metadata: NotificationEventMetadataEntity;
  /** The cutover mode currently configured for the event type. */
  mode: NotificationEngineMode;
  /** The event that must already be FULL before this one may go FULL, or null when it stands alone. Setting a raised notification to FULL without the event that clears it leaves notifications that never go away. */
  requiredPartnerEvent?: Maybe<NotificationEventType>;
  /** Whether a SHADOW run can be compared against a legacy send on any channel this event delivers on. False when every deliverable channel is engine-only, so the event can never earn FULL by observation. Read it with engineOnlyChannels, which names the channels that cannot be compared. */
  shadowComparable: Scalars['Boolean']['output'];
  /** The business domain the event comes from. */
  source: Scalars['String']['output'];
};

/** Whether an event results in a real delivery today: DELIVERING (a legacy path is sending, whatever this row says), DORMANT_UNTIL_FULL (the engine is the only sender and would send the moment this row is set to Full), REACHES_NOBODY (nothing lands even at Full). */
export enum NotificationDeliveryState {
  Delivering = 'DELIVERING',
  DormantUntilFull = 'DORMANT_UNTIL_FULL',
  ReachesNobody = 'REACHES_NOBODY'
}

/** Cutover mode for a notification event: OFF (legacy path only), SHADOW (engine computes without sending, for comparison), FULL (engine delivers). */
export enum NotificationEngineMode {
  Full = 'FULL',
  Off = 'OFF',
  Shadow = 'SHADOW'
}

export type NotificationEntity = {
  __typename?: 'NotificationEntity';
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  driverMarkedAttemptedDriver?: Maybe<DriverEntity>;
  driverMarkedAttemptedStop?: Maybe<StopEntity>;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  order?: Maybe<OrderEntity>;
  partnerCompanyName?: Maybe<Scalars['String']['output']>;
  sourceDriver?: Maybe<DriverEntity>;
  targetAccessorial?: Maybe<AccessorialUnion>;
  targetStop?: Maybe<StopEntity>;
  type: NotificationType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type NotificationEventConfigurationPointEntity = {
  __typename?: 'NotificationEventConfigurationPointEntity';
  /** Where a human clicks to change it. Null when the setting has no screen at all and is only reachable through an API mutation or SQL. */
  clickPath?: Maybe<Scalars['String']['output']>;
  /** The setting, named as it exists in the system. */
  setting: Scalars['String']['output'];
};

export type NotificationEventMetadataEntity = {
  __typename?: 'NotificationEventMetadataEntity';
  /** The channels the engine's recipient resolvers can emit for this event. Static capability, not observed traffic: a channel here means a resolver would produce a target on it, not that a message went out on it. */
  channels: Array<NotificationChannel>;
  /** Every switch governing whether this event actually sends, including the cutover mode itself. */
  configuredIn: Array<NotificationEventConfigurationPointEntity>;
  /** Whether a real delivery happens today, independent of this row. DELIVERING with mode OFF is the normal state of a not-yet-migrated event, where the legacy path is sending. */
  deliveryState: NotificationDeliveryState;
  /** Why that delivery state holds. */
  deliveryStateReason: Scalars['String']['output'];
  /** What the event means, in plain sentences. */
  description: Scalars['String']['output'];
  /** The service class that raises this event, or null when no call site raises it anywhere yet. Derived from a source scan in a spec, so it cannot outlive the emitter landing. */
  emittedBy?: Maybe<Scalars['String']['output']>;
  /** Who the engine resolves for this event: the audience a Full flip on this row starts delivering to. */
  engineTargets: Array<NotificationEventTargetEntity>;
  /** Who a legacy imperative path reaches for the same business moment today, whatever this row's mode is. Empty when no legacy path exists. Not an audience this row controls. */
  legacyTargets: Array<NotificationEventTargetEntity>;
  /** The domain moment that fires the event. Says nothing about whether a call site exists; emittedBy carries that. */
  trigger: Scalars['String']['output'];
};

export type NotificationEventTargetEntity = {
  __typename?: 'NotificationEventTargetEntity';
  /** Plain-language definition of the audience. */
  definition: Scalars['String']['output'];
  /** The NotificationRecipientKind a dispatch job for this audience carries, as stamped on every job. Null when no dispatch job ever carries it: the audience notifies nobody, or only a legacy imperative path reaches it. */
  recipientKind?: Maybe<Scalars['String']['output']>;
  /** The audience this event is addressed to. */
  target: NotificationTarget;
};

/** A domain event the notification engine can handle. */
export enum NotificationEventType {
  AppointmentCancelled = 'APPOINTMENT_CANCELLED',
  AppointmentConfirmed = 'APPOINTMENT_CONFIRMED',
  AppointmentDateChanged = 'APPOINTMENT_DATE_CHANGED',
  ContactAttempted = 'CONTACT_ATTEMPTED',
  DeliveryDispatched = 'DELIVERY_DISPATCHED',
  LoadedOnTruck = 'LOADED_ON_TRUCK',
  OrderOnHand = 'ORDER_ON_HAND',
  OrderRefused = 'ORDER_REFUSED',
  OrganizationMessagePublished = 'ORGANIZATION_MESSAGE_PUBLISHED',
  QuoteHeldForReview = 'QUOTE_HELD_FOR_REVIEW',
  SchedulingExceptionCleared = 'SCHEDULING_EXCEPTION_CLEARED',
  SchedulingExceptionRaised = 'SCHEDULING_EXCEPTION_RAISED',
  SchedulingInvitationSent = 'SCHEDULING_INVITATION_SENT',
  SchedulingSlotBooked = 'SCHEDULING_SLOT_BOOKED',
  SchedulingSlotRescheduled = 'SCHEDULING_SLOT_RESCHEDULED'
}

export type NotificationShadowComparisonEntity = {
  __typename?: 'NotificationShadowComparisonEntity';
  /** The delivery channel this comparison is for. */
  channel: NotificationChannel;
  /** The owning company UUID. */
  companyUuid: Scalars['String']['output'];
  /** When the row was first created. */
  createdAt: Scalars['DateTime']['output'];
  /** The notification event type this comparison is for. */
  eventType: Scalars['String']['output'];
  /** Whether the engine recorded content for this delivery. */
  hasEngineContent: Scalars['Boolean']['output'];
  /** Whether the legacy path recorded content for this delivery. */
  hasLegacyContent: Scalars['Boolean']['output'];
  /** Names of the semantic fields that diverged (set on MISMATCH; empty otherwise). */
  mismatchedFields: Array<Scalars['String']['output']>;
  /** The aggregate reference (e.g. a stop UUID) the event is about. */
  sourceRef: Scalars['String']['output'];
  /** The comparison row resolution status. */
  status: NotificationShadowStatus;
  /** When the row was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The comparison row UUID. */
  uuid: Scalars['String']['output'];
};

export type NotificationShadowComparisonFilterInput = {
  /** Restrict to rows delivered over this channel. */
  channel?: InputMaybe<NotificationChannel>;
  /** Restrict to rows belonging to this company. */
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to rows for this notification event type. */
  eventType?: InputMaybe<NotificationEventType>;
  /** Maximum rows to return from the list query (default 200, max 500). Ignored by the summary query. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Restrict to rows with this resolution status. */
  status?: InputMaybe<NotificationShadowStatus>;
};

export type NotificationShadowComparisonStatusCountEntity = {
  __typename?: 'NotificationShadowComparisonStatusCountEntity';
  count: Scalars['Int']['output'];
  status: NotificationShadowStatus;
};

/** Resolution state of a shadow-mode comparison row (TMS-1660/1661). A MATCH is never persisted as a status: matching rows self-prune (deleted, only a metric is kept), so only PENDING, MISMATCH, and ORPHAN rows are ever stored. */
export enum NotificationShadowStatus {
  Mismatch = 'MISMATCH',
  Orphan = 'ORPHAN',
  Pending = 'PENDING'
}

export enum NotificationSubjectType {
  OrganizationMessage = 'ORGANIZATION_MESSAGE'
}

export enum NotificationSubscriberType {
  DynamicOrderContact = 'DYNAMIC_ORDER_CONTACT',
  DynamicOrderInboundContact = 'DYNAMIC_ORDER_INBOUND_CONTACT',
  DynamicOrderOutboundContact = 'DYNAMIC_ORDER_OUTBOUND_CONTACT'
}

/** Who a notification event is addressed to, in customer-facing words. Refines NotificationRecipientKind: several targets share one kind (three distinct human contacts are all external contacts), which the dispatch job does not need to tell apart but an operator does. NONE means the event notifies nobody. */
export enum NotificationTarget {
  DeliveryContact = 'DELIVERY_CONTACT',
  EdiPartner = 'EDI_PARTNER',
  EfmAgentPortal = 'EFM_AGENT_PORTAL',
  InternalUser = 'INTERNAL_USER',
  None = 'NONE',
  OrderContact = 'ORDER_CONTACT',
  OrderSubscribers = 'ORDER_SUBSCRIBERS',
  PickupContact = 'PICKUP_CONTACT',
  StopContact = 'STOP_CONTACT',
  WebhookSubscriber = 'WEBHOOK_SUBSCRIBER'
}

export enum NotificationType {
  ContactCreditLimitReached = 'CONTACT_CREDIT_LIMIT_REACHED',
  DriverAddedAccessorialToStop = 'DRIVER_ADDED_ACCESSORIAL_TO_STOP',
  DriverMarkedStopAsAttempted = 'DRIVER_MARKED_STOP_AS_ATTEMPTED',
  EmailingInvoice = 'EMAILING_INVOICE',
  OrderAwaitingApproval = 'ORDER_AWAITING_APPROVAL',
  PartnershipRevoked = 'PARTNERSHIP_REVOKED'
}

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

/** Represents the difference between 2 versions of a numerical field. Used in audit log entries */
export type NumberFieldDifference = {
  __typename?: 'NumberFieldDifference';
  newValue?: Maybe<Scalars['Float']['output']>;
  oldValue?: Maybe<Scalars['Float']['output']>;
};

export enum NumberOfConsignees {
  Multiple = 'MULTIPLE',
  One = 'ONE'
}

export enum NumberOfShippers {
  Multiple = 'MULTIPLE',
  One = 'ONE'
}

export type OffboardCompanyFromQuoteAgentInput = {
  companyUuid: Scalars['String']['input'];
};

export type OffboardCompanyFromQuoteAgentOutput = {
  __typename?: 'OffboardCompanyFromQuoteAgentOutput';
  companyUuid: Scalars['String']['output'];
  status: QuoteAgentOffboardingRequestStatus;
};

export type OfferLocationEntity = {
  __typename?: 'OfferLocationEntity';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OnTimeCommitmentSplitEntity = {
  __typename?: 'OnTimeCommitmentSplitEntity';
  measurableStops: Scalars['Int']['output'];
  onTimePct?: Maybe<Scalars['Float']['output']>;
  onTimeStops: Scalars['Int']['output'];
};

export type OnTimeCustomerRowEntity = {
  __typename?: 'OnTimeCustomerRowEntity';
  customerName: Scalars['String']['output'];
  customerUuid: Scalars['String']['output'];
  lateStops: Scalars['Int']['output'];
  measurableStops: Scalars['Int']['output'];
  onTimePct?: Maybe<Scalars['Float']['output']>;
};

export type OnTimeGroupRowEntity = {
  __typename?: 'OnTimeGroupRowEntity';
  lateStops: Scalars['Int']['output'];
  measurableStops: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  onTimePct?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type OnTimeKpiArgs = {
  endDate: Scalars['DateTime']['input'];
  metrics?: InputMaybe<Array<KpiTileMetric>>;
  startDate: Scalars['DateTime']['input'];
  stopKind: KpiStopKind;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OnTimeKpiEntity = {
  __typename?: 'OnTimeKpiEntity';
  bucketUnit: KpiTrendBucketUnit;
  completedStops: Scalars['Int']['output'];
  customerAppointment: OnTimeCommitmentSplitEntity;
  customers: Array<OnTimeCustomerRowEntity>;
  drivers: Array<OnTimeGroupRowEntity>;
  excludedNoPromiseStops: Scalars['Int']['output'];
  fallbackJudgedStops: Scalars['Int']['output'];
  forwarderDate: OnTimeCommitmentSplitEntity;
  lateStops: Scalars['Int']['output'];
  measurableStops: Scalars['Int']['output'];
  onTimePct?: Maybe<Scalars['Float']['output']>;
  onTimeStops: Scalars['Int']['output'];
  terminals: Array<OnTimeGroupRowEntity>;
  trend: Array<OnTimeTrendBucketEntity>;
};

export type OnTimeKpiStopsArgs = {
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  filter: OnTimeStopFilter;
  filters?: InputMaybe<KpiRecordFiltersInput>;
  metrics?: InputMaybe<Array<KpiTileMetric>>;
  page?: InputMaybe<KpiRecordPageInput>;
  sort?: InputMaybe<KpiRecordSortInput>;
  startDate: Scalars['DateTime']['input'];
  stopKind: KpiStopKind;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OnTimeKpiStopsEntity = {
  __typename?: 'OnTimeKpiStopsEntity';
  facets: KpiRecordFacetsEntity;
  stops: Array<OnTimeStopRowEntity>;
  totalStops: Scalars['Int']['output'];
};

export enum OnTimePerformanceReportDetailType {
  Aggregate = 'AGGREGATE',
  Detailed = 'DETAILED'
}

export type OnTimePerformanceReportInput = {
  /** The UUIDs of the business divisions to include in the report. If not included, the report will include stops for all business divisions. */
  businessDivisionUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The UUIDs of the customers to include in the report. If not included, the report will include stops for all customers. */
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  reportDetailType?: InputMaybe<OnTimePerformanceReportDetailType>;
  /** The UUIDs of the services to include in the report. If not included, the report will include stops for all services. */
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The upper bound for the date of stops which will be included in the report.
   *     If not included, the report will include all stops after stopStartDate.
   */
  stopEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The lower bound for the date of stops which will be included in the report.
   *     If not included, the report will include all stops before stopEndDate.
   */
  stopStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUIDs of the terminals to include in the report. If not included, the report will include stops for all terminals. */
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Which stops behind an on-time number to list. */
export enum OnTimeStopFilter {
  Excluded = 'EXCLUDED',
  FallbackJudged = 'FALLBACK_JUDGED',
  Late = 'LATE',
  OnTime = 'ON_TIME'
}

export type OnTimeStopRowEntity = {
  __typename?: 'OnTimeStopRowEntity';
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  customerName: Scalars['String']['output'];
  driverNames: Array<Scalars['String']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  fileNo?: Maybe<Scalars['String']['output']>;
  judgedAt?: Maybe<Scalars['DateTime']['output']>;
  judgedEvent?: Maybe<Scalars['String']['output']>;
  orderUuid: Scalars['String']['output'];
  promiseSource?: Maybe<Scalars['String']['output']>;
  promisedAt?: Maybe<Scalars['DateTime']['output']>;
  stopTimeZone: Scalars['String']['output'];
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type OnTimeTrendBucketEntity = {
  __typename?: 'OnTimeTrendBucketEntity';
  bucketDate: Scalars['String']['output'];
  measurableStops: Scalars['Int']['output'];
  onTimePct?: Maybe<Scalars['Float']['output']>;
  onTimeStops: Scalars['Int']['output'];
};

export type OpenInvoiceReportArgs = {
  findInvoicesArgs: FindInvoicesInput;
};

export type OpenMessageInOutlookInput = {
  orderUuid: Scalars['String']['input'];
};

export type OpenMessageInOutlookOutput = {
  __typename?: 'OpenMessageInOutlookOutput';
  linkToOpen: Scalars['String']['output'];
};

export type OperationalEfficiencyArgs = {
  dimension: OperationalEfficiencyDimension;
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Grouping dimension for the Intelligence Board operational efficiency report. */
export enum OperationalEfficiencyDimension {
  AssetType = 'ASSET_TYPE',
  Service = 'SERVICE'
}

export type OperationalEfficiencyReportEntity = {
  __typename?: 'OperationalEfficiencyReportEntity';
  avgShipmentPriceUsd?: Maybe<Scalars['Float']['output']>;
  dimension: OperationalEfficiencyDimension;
  milesCoveragePct: Scalars['Float']['output'];
  revenuePerMileUsd?: Maybe<Scalars['Float']['output']>;
  rows: Array<OperationalEfficiencyRowEntity>;
  shipmentsWithMiles: Scalars['Int']['output'];
  totalMiles: Scalars['Float']['output'];
  totalRevenueUsd: Scalars['Float']['output'];
  totalShipments: Scalars['Int']['output'];
};

export type OperationalEfficiencyRowEntity = {
  __typename?: 'OperationalEfficiencyRowEntity';
  avgShipmentPriceUsd: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  milesCoveragePct: Scalars['Float']['output'];
  revenuePerMileUsd?: Maybe<Scalars['Float']['output']>;
  revenueUsd: Scalars['Float']['output'];
  shipmentCount: Scalars['Int']['output'];
  shipmentsWithMiles: Scalars['Int']['output'];
  status: OperationalEfficiencyStatus;
  totalMiles: Scalars['Float']['output'];
};

/** Coverage band for a row of the operational efficiency report: how much of the group's mileage is recorded, not how it performed. */
export enum OperationalEfficiencyStatus {
  Measured = 'MEASURED',
  NotMeasured = 'NOT_MEASURED',
  PartiallyMeasured = 'PARTIALLY_MEASURED'
}

export type OperationsPerformanceDuration = {
  __typename?: 'OperationsPerformanceDuration';
  backwardOrders: Scalars['Int']['output'];
  countedOrders: Scalars['Int']['output'];
  meanSeconds?: Maybe<Scalars['Float']['output']>;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
  prior: OperationsPerformancePriorDuration;
};

export type OperationsPerformanceFilterArgs = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  runsBackward?: InputMaybe<OperationsPerformanceMeasure>;
  sortBy?: InputMaybe<OperationsPerformanceInterval>;
  sortDirection?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OperationsPerformanceGroup = {
  __typename?: 'OperationsPerformanceGroup';
  deliveredOrders: Scalars['Int']['output'];
  intervals: Array<OperationsPerformanceGroupInterval>;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  orders: Scalars['Int']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type OperationsPerformanceGroupInterval = {
  __typename?: 'OperationsPerformanceGroupInterval';
  countedOrders: Scalars['Int']['output'];
  key: OperationsPerformanceInterval;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export enum OperationsPerformanceInterval {
  CreatedToInboundDispatch = 'CREATED_TO_INBOUND_DISPATCH',
  InboundCompletionToOutboundDispatch = 'INBOUND_COMPLETION_TO_OUTBOUND_DISPATCH',
  InboundDispatchToCompletion = 'INBOUND_DISPATCH_TO_COMPLETION',
  OutboundDispatchToCompletion = 'OUTBOUND_DISPATCH_TO_COMPLETION'
}

export type OperationsPerformanceIntervalDuration = {
  __typename?: 'OperationsPerformanceIntervalDuration';
  backwardOrders: Scalars['Int']['output'];
  countedOrders: Scalars['Int']['output'];
  key: OperationsPerformanceInterval;
  meanSeconds?: Maybe<Scalars['Float']['output']>;
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
  prior: OperationsPerformancePriorDuration;
};

export type OperationsPerformanceLongestInterval = {
  __typename?: 'OperationsPerformanceLongestInterval';
  key: OperationsPerformanceInterval;
  seconds: Scalars['Float']['output'];
};

export enum OperationsPerformanceMeasure {
  CreatedToInboundDispatch = 'CREATED_TO_INBOUND_DISPATCH',
  InboundCompletionToOutboundDispatch = 'INBOUND_COMPLETION_TO_OUTBOUND_DISPATCH',
  InboundDispatchToCompletion = 'INBOUND_DISPATCH_TO_COMPLETION',
  OrderToDelivered = 'ORDER_TO_DELIVERED',
  OutboundDispatchToCompletion = 'OUTBOUND_DISPATCH_TO_COMPLETION'
}

export type OperationsPerformanceOutlierOrder = {
  __typename?: 'OperationsPerformanceOutlierOrder';
  customerName: Scalars['String']['output'];
  fromAt: Scalars['DateTime']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  seconds: Scalars['Float']['output'];
  toAt: Scalars['DateTime']['output'];
};

export type OperationsPerformanceOutliers = {
  __typename?: 'OperationsPerformanceOutliers';
  measure: OperationsPerformanceMeasure;
  orders: Array<OperationsPerformanceOutlierOrder>;
};

export type OperationsPerformancePageArgs = {
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  runsBackward?: InputMaybe<OperationsPerformanceMeasure>;
  sortBy?: InputMaybe<OperationsPerformanceInterval>;
  sortDirection?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OperationsPerformancePriorDuration = {
  __typename?: 'OperationsPerformancePriorDuration';
  countedOrders: Scalars['Int']['output'];
  medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type OperationsPerformanceReport = {
  __typename?: 'OperationsPerformanceReport';
  rows: Array<OperationsPerformanceRow>;
  timezone: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type OperationsPerformanceRow = {
  __typename?: 'OperationsPerformanceRow';
  accountId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdToInboundDispatchSeconds?: Maybe<Scalars['Float']['output']>;
  customerName: Scalars['String']['output'];
  hawb?: Maybe<Scalars['String']['output']>;
  inboundCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  inboundCompletionToOutboundDispatchSeconds?: Maybe<Scalars['Float']['output']>;
  inboundDispatchToCompletionSeconds?: Maybe<Scalars['Float']['output']>;
  inboundDispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  inboundName?: Maybe<Scalars['String']['output']>;
  inboundScannedPieceCount?: Maybe<Scalars['Int']['output']>;
  lastCustomerUpdateAt?: Maybe<Scalars['DateTime']['output']>;
  lastCustomerUpdateMethod?: Maybe<OperationsPerformanceUpdateMethod>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  outboundCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  outboundDispatchToCompletionSeconds?: Maybe<Scalars['Float']['output']>;
  outboundDispatchedAt?: Maybe<Scalars['DateTime']['output']>;
  outboundName?: Maybe<Scalars['String']['output']>;
  outboundScannedPieceCount?: Maybe<Scalars['Int']['output']>;
  pieceCount: Scalars['Int']['output'];
  source: OrderSource;
  sourceIsEmail: Scalars['Boolean']['output'];
};

export type OperationsPerformanceSignals = {
  __typename?: 'OperationsPerformanceSignals';
  byMethod: Array<OperationsPerformanceUpdateMethodCount>;
  inboundPieces: Scalars['Int']['output'];
  inboundScannedPieces: Scalars['Int']['output'];
  outboundPieces: Scalars['Int']['output'];
  outboundScannedPieces: Scalars['Int']['output'];
  updatedOrders: Scalars['Int']['output'];
};

export type OperationsPerformanceSlowOrder = {
  __typename?: 'OperationsPerformanceSlowOrder';
  customerName: Scalars['String']['output'];
  longestInterval?: Maybe<OperationsPerformanceLongestInterval>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  terminalCode?: Maybe<Scalars['String']['output']>;
  totalSeconds: Scalars['Float']['output'];
};

export type OperationsPerformanceSummary = {
  __typename?: 'OperationsPerformanceSummary';
  byCustomer: Array<OperationsPerformanceGroup>;
  byTerminal: Array<OperationsPerformanceGroup>;
  intervals: Array<OperationsPerformanceIntervalDuration>;
  orderToDelivered: OperationsPerformanceDuration;
  orders: Scalars['Int']['output'];
  outliers: Array<OperationsPerformanceOutliers>;
  signals: OperationsPerformanceSignals;
  slowestOrders: Array<OperationsPerformanceSlowOrder>;
  timezone: Scalars['String']['output'];
  trend: OperationsPerformanceTrend;
};

export type OperationsPerformanceTrend = {
  __typename?: 'OperationsPerformanceTrend';
  points: Array<OperationsPerformanceTrendPoint>;
  unit: KpiTrendBucketUnit;
};

export type OperationsPerformanceTrendPoint = {
  __typename?: 'OperationsPerformanceTrendPoint';
  backwardOrders: Scalars['Int']['output'];
  bucketDate: Scalars['String']['output'];
  countedOrders: Scalars['Int']['output'];
  medianSeconds?: Maybe<Scalars['Float']['output']>;
  p90Seconds?: Maybe<Scalars['Float']['output']>;
};

export enum OperationsPerformanceUpdateMethod {
  Api = 'API',
  Edi_214 = 'EDI_214',
  Email = 'EMAIL',
  Sftp = 'SFTP',
  Text = 'TEXT'
}

export type OperationsPerformanceUpdateMethodCount = {
  __typename?: 'OperationsPerformanceUpdateMethodCount';
  method: OperationsPerformanceUpdateMethod;
  orders: Scalars['Int']['output'];
};

export type OptimizationCompleted = {
  __typename?: 'OptimizationCompleted';
  proposedRoutes: Array<ProposedRouteSequence>;
  summary: RouteOptimizationSummary;
  unplacedStopCount?: Maybe<Scalars['Int']['output']>;
};

export type OptimizationFailed = {
  __typename?: 'OptimizationFailed';
  message: Scalars['String']['output'];
};

export type OptimizationPending = {
  __typename?: 'OptimizationPending';
  jobUuid: Scalars['String']['output'];
};

export type OptimizationResultsOutput = {
  __typename?: 'OptimizationResultsOutput';
  error?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Array<Scalars['String']['output']>>;
};

export type OptimizationStatusResult = OptimizationCompleted | OptimizationFailed | OptimizationPending;

/** Endpoint-pinning strategy for route sequence optimization. PINNED_BOTH (default) keeps current first/last stops. PINNED_START frees the final stop. ROUND_TRIP optimizes a loop. FREE lets the solver pick both endpoints (approximate). RETURN_TO_TERMINAL starts and ends at the route terminal (or the company's default warehouse). */
export enum OptimizeEndpointMode {
  Free = 'FREE',
  PinnedBoth = 'PINNED_BOTH',
  PinnedStart = 'PINNED_START',
  ReturnToTerminal = 'RETURN_TO_TERMINAL',
  RoundTrip = 'ROUND_TRIP'
}

export type OptimizeRouteSequenceConstraintsInput = {
  respectDriverCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  respectTimeWindows?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OptimizeRouteSequenceInput = {
  constraints?: InputMaybe<OptimizeRouteSequenceConstraintsInput>;
  endpointMode?: InputMaybe<OptimizeEndpointMode>;
  profile?: InputMaybe<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
  rules?: InputMaybe<Array<OptimizeSequencingRuleInput>>;
};

export type OptimizeRouteSequenceResult = OptimizationCompleted | OptimizationPending;

export type OptimizeRoutesTogetherInput = {
  constraints?: InputMaybe<OptimizeRouteSequenceConstraintsInput>;
  endpointMode?: InputMaybe<OptimizeEndpointMode>;
  routeUuids: Array<Scalars['String']['input']>;
  rules?: InputMaybe<Array<OptimizeSequencingRuleInput>>;
};

export type OptimizeSequencingRuleInput = {
  deliveryUuid?: InputMaybe<Scalars['String']['input']>;
  kind: OptimizeSequencingRuleKind;
  otherStopUuid?: InputMaybe<Scalars['String']['input']>;
  pickupUuid?: InputMaybe<Scalars['String']['input']>;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Constraint kind applied during route sequence optimization. Single-stop kinds (FIRST/LAST) use `stopUuid`. Pairwise kinds (BEFORE/AFTER) use `stopUuid` plus `otherStopUuid`. Pickup/delivery kinds use `pickupUuid` plus `deliveryUuid`. */
export enum OptimizeSequencingRuleKind {
  After = 'AFTER',
  Before = 'BEFORE',
  First = 'FIRST',
  Last = 'LAST',
  PickupBeforeDelivery = 'PICKUP_BEFORE_DELIVERY'
}

export enum OrderAction {
  AddReferenceNumbers = 'ADD_REFERENCE_NUMBERS',
  Delete = 'DELETE',
  MarkAllPiecesPicked = 'MARK_ALL_PIECES_PICKED',
  MarkAsCancelled = 'MARK_AS_CANCELLED',
  MarkAsOnHand = 'MARK_AS_ON_HAND',
  MarkAsOnHold = 'MARK_AS_ON_HOLD',
  MarkAsRefused = 'MARK_AS_REFUSED',
  MarkNotOnHand = 'MARK_NOT_ON_HAND',
  MarkOsd = 'MARK_OSD',
  RemoveHold = 'REMOVE_HOLD',
  Uncancel = 'UNCANCEL',
  UpdatePiecesOnHand = 'UPDATE_PIECES_ON_HAND',
  UploadDocuments = 'UPLOAD_DOCUMENTS'
}

export type OrderActionResult = {
  __typename?: 'OrderActionResult';
  action: OrderAction;
  results: BulkActionEntityResults;
};

export type OrderAddedToInvoice = {
  __typename?: 'OrderAddedToInvoice';
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
};

export enum OrderBillingStatus {
  HasIssues = 'HAS_ISSUES',
  NotReadyToInvoice = 'NOT_READY_TO_INVOICE',
  ReadyToInvoice = 'READY_TO_INVOICE'
}

export type OrderCommentEntity = {
  __typename?: 'OrderCommentEntity';
  authorName: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  piece?: Maybe<PieceEntity>;
  showOnInvoice?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<UserActorEntity>;
  uuid: Scalars['String']['output'];
};

export type OrderCommentForCachedStop = {
  __typename?: 'OrderCommentForCachedStop';
  comment: Scalars['String']['output'];
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  edges: Array<OrderEdge>;
  /** Not cheap to calculate, request with prudence. groupUuid = invoice UUID when groupOrdersBy=INVOICE, HAWB (shipperBillOfLadingNumber) when groupOrdersBy=HAWB. */
  groupedCountsByInvoice?: Maybe<Array<GroupedCounts>>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Version ID for the response */
  versionId?: Maybe<Scalars['Float']['output']>;
};

export type OrderConsigneeSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** Methods for order consolidation */
export enum OrderConsolidationMethod {
  BaseOrder = 'BASE_ORDER',
  ByWeight = 'BY_WEIGHT',
  EvenDistribution = 'EVEN_DISTRIBUTION'
}

export enum OrderConsolidationType {
  Consolidated = 'CONSOLIDATED',
  Standard = 'STANDARD'
}

export type OrderDelegationConnection = {
  __typename?: 'OrderDelegationConnection';
  edges: Array<OrderDelegationEdge>;
  pageInfo: PageInfo;
};

export type OrderDelegationEdge = {
  __typename?: 'OrderDelegationEdge';
  cursor: Scalars['String']['output'];
  node: OrderDelegationEntity;
};

export type OrderDelegationEntity = {
  __typename?: 'OrderDelegationEntity';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  duplicateOrderUuid?: Maybe<Scalars['String']['output']>;
  endCustomer?: Maybe<DelegationEndCustomer>;
  executingCompanyName: Scalars['String']['output'];
  executingCompanyUuid: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  organizationPeerUuid: Scalars['String']['output'];
  originalOrderName?: Maybe<Scalars['String']['output']>;
  originalOrderUuid: Scalars['String']['output'];
  originatorCompanyName: Scalars['String']['output'];
  originatorCompanyUuid: Scalars['String']['output'];
  originatorProgressStatus?: Maybe<OrderDetailedStatus>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  scope: OrderDelegationScope;
  sharesEndCustomer: Scalars['Boolean']['output'];
  status: OrderDelegationStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** The part of an order to delegate. Supply both INBOUND and OUTBOUND with the same peer in one call to create a single FULL delegation. */
export enum OrderDelegationPart {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type OrderDelegationRuleEntity = {
  __typename?: 'OrderDelegationRuleEntity';
  createdAt: Scalars['DateTime']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  customerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  offerWindowMinutes?: Maybe<Scalars['Int']['output']>;
  orderSources: Array<OrderSource>;
  organizationPeerUuid: Scalars['String']['output'];
  peerCompanyName: Scalars['String']['output'];
  pickupHandling?: Maybe<DelegatedPickupHandling>;
  priority: Scalars['Int']['output'];
  scope: OrderDelegationScope;
  shareEndCustomer: Scalars['Boolean']['output'];
  terminals: Array<OrderDelegationRuleTerminalEntity>;
  timing: OrderDelegationRuleTiming;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zipCodes: Array<Scalars['String']['output']>;
};

export type OrderDelegationRuleTerminalEntity = {
  __typename?: 'OrderDelegationRuleTerminalEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** When a rule evaluates an order. ON_RECEIPT: as soon as the order is created, draft or live. WHEN_LIVE: when the order leaves draft. */
export enum OrderDelegationRuleTiming {
  OnReceipt = 'ON_RECEIPT',
  WhenLive = 'WHEN_LIVE'
}

/** The scope of work delegated: inbound only, outbound only, or the full order. */
export enum OrderDelegationScope {
  Full = 'FULL',
  InboundOnly = 'INBOUND_ONLY',
  OutboundOnly = 'OUTBOUND_ONLY'
}

/** Lifecycle state of an OrderDelegation row. */
export enum OrderDelegationStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  PendingAck = 'PENDING_ACK',
  Revoked = 'REVOKED'
}

export enum OrderDetailedStatus {
  Arrived = 'ARRIVED',
  Attempted = 'ATTEMPTED',
  BillingIssues = 'BILLING_ISSUES',
  Cancelled = 'CANCELLED',
  ChargesFinalized = 'CHARGES_FINALIZED',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Creating = 'CREATING',
  Delivered = 'DELIVERED',
  DeliveryScheduled = 'DELIVERY_SCHEDULED',
  InvoicePosted = 'INVOICE_POSTED',
  InProgress = 'IN_PROGRESS',
  InTransit = 'IN_TRANSIT',
  Loaded = 'LOADED',
  OnHand = 'ON_HAND',
  OnHold = 'ON_HOLD',
  OnInvoice = 'ON_INVOICE',
  Osd = 'OSD',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  OutForPickup = 'OUT_FOR_PICKUP',
  OutForRecovery = 'OUT_FOR_RECOVERY',
  OutForTransfer = 'OUT_FOR_TRANSFER',
  PartiallyDelivered = 'PARTIALLY_DELIVERED',
  PartiallyInTransit = 'PARTIALLY_IN_TRANSIT',
  PartiallyLoaded = 'PARTIALLY_LOADED',
  PartiallyOnHand = 'PARTIALLY_ON_HAND',
  PartiallyOutForDelivery = 'PARTIALLY_OUT_FOR_DELIVERY',
  PartiallyPicked = 'PARTIALLY_PICKED',
  PartiallyPlanned = 'PARTIALLY_PLANNED',
  Picked = 'PICKED',
  PickupScheduled = 'PICKUP_SCHEDULED',
  Planned = 'PLANNED',
  Received = 'RECEIVED',
  ReceivedAtOrigin = 'RECEIVED_AT_ORIGIN',
  RecoveryScheduled = 'RECOVERY_SCHEDULED',
  TransferScheduled = 'TRANSFER_SCHEDULED'
}

export type OrderDocumentInput = {
  bucket: Scalars['String']['input'];
  endOfDayDocumentsProcessingJobUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadOrdinal?: InputMaybe<Scalars['Int']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OrderDocumentType {
  AirWaybill = 'AirWaybill',
  ArrivalNotice = 'ArrivalNotice',
  AuthoSheet = 'AuthoSheet',
  PodReport = 'PodReport'
}

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['String']['output'];
  node: OrderEntity;
};

export type OrderEntity = {
  appliedAmount: Scalars['Float']['output'];
  balanceInCents: Scalars['Int']['output'];
  billingPartyContact: CustomerContactEntity;
  billingPartyContactStation?: Maybe<ContactStationEntity>;
  /** @deprecated Use personName */
  callerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personPhoneNumber */
  callerPhoneNumber?: Maybe<Scalars['String']['output']>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  /** The chargeable weight is an optional weight value (measured in cubic meters) that can be used in billing calculations for the order. */
  chargeableWeightCubicMeters?: Maybe<Scalars['Volume']['output']>;
  codCheckAmountCents?: Maybe<Scalars['Int']['output']>;
  codCheckNumber?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  consolidatableOrders: ConsolidatableOrdersOutput;
  consolidatedOrders?: Maybe<Array<OrderEntity>>;
  consolidatedShipmentString?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  coverSheetDocumentTypeSequence?: Maybe<CoverSheetDocumentTypeSequenceEntity>;
  createdAt: Scalars['DateTime']['output'];
  createdFromOrderTemplate?: Maybe<OrderEntity>;
  csvOrderImportStatus?: Maybe<CsvOrderImportStatus>;
  /** Total custom charge (accessorial charge) for the order in dollars */
  customChargeRevenue: Scalars['Float']['output'];
  /** Each custom charge (accessorial charge) itemized */
  customCharges: Array<CustomChargeEntity>;
  customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility;
  customerPortalChargesVisibleFromOverride?: Maybe<CustomerPortalChargesVisibility>;
  dateMarkedLoaded?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedReceivedAtOrigin?: Maybe<Scalars['DateTime']['output']>;
  delegationAsDuplicate?: Maybe<OrderDelegationEntity>;
  delegations: Array<OrderDelegationEntity>;
  deletedAutoAppliedAccessorials: Array<AccessorialUnion>;
  detailedStatus?: Maybe<Scalars['String']['output']>;
  detailedStatusV2?: Maybe<OrderDetailedStatus>;
  dimWeight: Scalars['Float']['output'];
  displayChargesInCustomerPortalOverride?: Maybe<Scalars['Boolean']['output']>;
  documents: Array<DocumentEntity>;
  driverQualifications: Array<DriverQualificationEntity>;
  driverSettlementTotal: Scalars['Float']['output'];
  ediReceivedScac?: Maybe<Scalars['String']['output']>;
  ediReferences?: Maybe<Array<EdiReferenceEntity>>;
  ediServiceLevelCode?: Maybe<Scalars['String']['output']>;
  ediTransactions: Array<EdiTransactionEntity>;
  emergencyResponseNumber?: Maybe<Scalars['String']['output']>;
  enableLineHaul: Scalars['Boolean']['output'];
  endStop?: Maybe<StopEntity>;
  externalNotes?: Maybe<Scalars['String']['output']>;
  fields: StandardOrderFieldsEntity;
  /** Total freight charge for the order in dollars */
  freightChargeRevenue: Scalars['Float']['output'];
  freightNeedsRate: Scalars['Boolean']['output'];
  /** Total fuel charge for the order in dollars */
  fuelChargeRevenue: Scalars['Float']['output'];
  fulfillmentType?: Maybe<FulfillmentType>;
  hasDamage: Scalars['Boolean']['output'];
  hasDriverPod: Scalars['Boolean']['output'];
  hasDriverUploadedDocument: Scalars['Boolean']['output'];
  hasEdiCancellation: Scalars['Boolean']['output'];
  hasIssues: Scalars['Boolean']['output'];
  hasNoneOrCompletedInboundStop: Scalars['Boolean']['output'];
  hasShortage: Scalars['Boolean']['output'];
  hasUncollectedInboundStop: Scalars['Boolean']['output'];
  hazmat: Scalars['Boolean']['output'];
  hazmatClass?: Maybe<HazmatClass>;
  hazmatDescription?: Maybe<Scalars['String']['output']>;
  holdReason?: Maybe<HoldReasonEntity>;
  inBond: Scalars['Boolean']['output'];
  inboundPaperwork: OrderPaperworkEntity;
  inboundShipment?: Maybe<ShipmentEntity>;
  inboundStopIntention?: Maybe<StopIntention>;
  invoice?: Maybe<InvoiceEntity>;
  isCollectOnDelivery: Scalars['Boolean']['output'];
  isCrossDock?: Maybe<Scalars['Boolean']['output']>;
  isDoorToDoor?: Maybe<Scalars['Boolean']['output']>;
  /** Filters out draft and template orders */
  isDraftOrder: Scalars['Boolean']['output'];
  isOnHand: Scalars['Boolean']['output'];
  isOverdue: Scalars['Boolean']['output'];
  isReturnOrder: Scalars['Boolean']['output'];
  isReverse: Scalars['Boolean']['output'];
  isReweighed: Scalars['Boolean']['output'];
  issueReason?: Maybe<Scalars['String']['output']>;
  itTeIssueDate?: Maybe<Scalars['DateTime']['output']>;
  itTeNumber?: Maybe<Scalars['String']['output']>;
  lastCompletedLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  lastUpdatedByUser?: Maybe<UserActorEntity>;
  lineHaulCompletedDate: Scalars['DateTime']['output'];
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  lineHaulOriginTerminal?: Maybe<TerminalEntity>;
  lineHaulServiceDisplayString: Scalars['String']['output'];
  lineHaulShipment?: Maybe<ShipmentEntity>;
  /** The line haul events associated with an order, such as every stop at a terminal. This is the order’s own timeline, not an audit log of user actions or changes. */
  lineHaulTimeline: Array<OrderLineHaulTimelineEventEntity>;
  lockSecondaryRefNumber: Scalars['Boolean']['output'];
  /** @deprecated Use paperwork.missingDocuments instead */
  missingDocuments: Array<DocumentType>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  numPackagesOnHand: Scalars['Float']['output'];
  onHand?: Maybe<Scalars['Boolean']['output']>;
  onHold: Scalars['Boolean']['output'];
  orderChargesShipment?: Maybe<ShipmentEntity>;
  orderComments: Array<OrderCommentEntity>;
  orderConsolidationType: OrderConsolidationType;
  orderEvents: Array<OrderEventEntity>;
  orderInvoiceByDate?: Maybe<Scalars['DateTime']['output']>;
  orderPaymentMappings: Array<PaymentToOrderMappingEntity>;
  orderSegmentType: OrderSegmentType;
  /** Orders that were prorated with (but not including) this order */
  ordersProratedWith?: Maybe<Array<OrderEntity>>;
  ordersWithSameBillOfLadingNumber: Array<OrderEntity>;
  ordersWithSameBillOfLadingNumberForReviewOrders?: Maybe<Array<StandardOrderEntity>>;
  ordinal: Scalars['Int']['output'];
  /** Packaging as received on this order's original transmission, captured when the order is created and never rewritten. Empty for orders created before the snapshot existed, and for orders created without packages. */
  originalTransmissionPackages: Array<PackageEntity>;
  /** @deprecated Deprecated. Use hasIssues and hasDamage instead. */
  osAndD: Scalars['Boolean']['output'];
  osd?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated. Use hasIssues and hasDamage instead. */
  osdReason?: Maybe<Scalars['String']['output']>;
  outboundPaperwork: OrderPaperworkEntity;
  /** The scans out of the last terminal (if multi-terminal and line haul), or simply departure scans corresponding to outbound delivery */
  outboundScans: Array<ScanEntity>;
  outboundShipment?: Maybe<ShipmentEntity>;
  outboundStopIntention?: Maybe<StopIntention>;
  packageCount: Scalars['Float']['output'];
  packageGroup?: Maybe<PackageGroup>;
  packages: Array<PackageEntity>;
  paperwork: OrderPaperworkEntity;
  paymentMethod?: Maybe<PaymentMethod>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personPhoneNumber?: Maybe<Scalars['String']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
  pieceCountFromPackages: Scalars['Float']['output'];
  pieces: Array<PieceEntity>;
  piecesDelivered: PiecesDeliveredEntity;
  piecesLoaded?: Maybe<Scalars['Int']['output']>;
  piecesPicked?: Maybe<Scalars['Int']['output']>;
  piecesPickedUp: PiecesPickedUpEntity;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  quaternaryRefNumber?: Maybe<Scalars['String']['output']>;
  quinaryRefNumber?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<QuoteEntity>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  recurringOrderFrequency?: Maybe<RecurringOrderFrequencyEntity>;
  refNumbers: Array<Scalars['String']['output']>;
  refusedBy?: Maybe<Scalars['String']['output']>;
  refusedDate?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  refusedReasonCode?: Maybe<OrderRefusalReason>;
  requiresPlacard?: Maybe<Scalars['Boolean']['output']>;
  reversalCounterpart?: Maybe<ReversalCounterpartOrder>;
  run?: Maybe<RunEntity>;
  scannedOrderResult?: Maybe<ScannedOrderResultEntity>;
  /** A field that represents a concatenation of all fields on the order that we want to search by. */
  searchText?: Maybe<Scalars['String']['output']>;
  secondaryRefNumber?: Maybe<Scalars['String']['output']>;
  service?: Maybe<ServiceEntity>;
  shipments: Array<ShipmentEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  shouldDisplayChargesInCustomerPortal: Scalars['Boolean']['output'];
  source: OrderSource;
  standardOrderFields: StandardOrderFieldsEntity;
  startStop?: Maybe<StopEntity>;
  status: OrderStatus;
  tags: Array<TagEntity>;
  tertiaryRefNumber?: Maybe<Scalars['String']['output']>;
  thirdPartyBrokers: Array<ThirdPartyBrokerEntity>;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the order in dollars */
  totalCharge: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  totalSkids?: Maybe<Scalars['Int']['output']>;
  unNumber?: Maybe<Scalars['String']['output']>;
  upcomingLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
  warehouse?: Maybe<WarehouseEntity>;
  weight: Scalars['Float']['output'];
};

export type OrderEventEntity = {
  __typename?: 'OrderEventEntity';
  createdAt: Scalars['DateTime']['output'];
  eventType: OrderEventType;
  ignoreSnapshot: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  mirroredFromPartner: Scalars['Boolean']['output'];
  order?: Maybe<OrderEntity>;
  snapshot?: Maybe<Scalars['String']['output']>;
  sourceDriver?: Maybe<DriverEntity>;
  sourceEdiTransaction?: Maybe<EdiTransactionEntity>;
  sourceEfmOutboundRequestEvent?: Maybe<EfmOutboundRequestEventEntity>;
  sourceExpeditorsOutboundRequestEvent?: Maybe<ExpeditorsOutboundRequestEventEntity>;
  sourceOutboundWebhookEvent?: Maybe<OutboundWebhookEventEntity>;
  sourcePicklist?: Maybe<PicklistEntity>;
  sourceSftpUpload?: Maybe<SftpUploadEntity>;
  sourceType: OrderEventSourceType;
  sourceUser?: Maybe<UserActorEntity>;
  sourceWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  targetContactPerson?: Maybe<ContactPersonEntity>;
  targetDocument?: Maybe<DocumentEntity>;
  targetDriver?: Maybe<DriverEntity>;
  targetEmail?: Maybe<Scalars['String']['output']>;
  targetInvoice?: Maybe<InvoiceEntity>;
  targetOrderTotalAfterConsolidation?: Maybe<Scalars['Float']['output']>;
  targetOrderTotalBeforeConsolidation?: Maybe<Scalars['Float']['output']>;
  targetPhoneNumber?: Maybe<Scalars['String']['output']>;
  targetPiece?: Maybe<PieceEntity>;
  targetRoute?: Maybe<RouteEntity>;
  targetSettlementBill?: Maybe<DriverSettlementBillEntity>;
  targetShipment?: Maybe<ShipmentEntity>;
  targetShipmentSubscriber?: Maybe<ShipmentSubscriberEntity>;
  targetStop?: Maybe<StopEntity>;
  targetType: OrderEventTargetType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type OrderEventNotificationSubscriptionEntity = {
  __typename?: 'OrderEventNotificationSubscriptionEntity';
  channel: NotificationChannel;
  eventType: OrderEventNotificationType;
  id: Scalars['String']['output'];
  subscriberType: NotificationSubscriberType;
};

export type OrderEventNotificationSubscriptionInput = {
  channel: NotificationChannel;
  eventType: OrderEventNotificationType;
  subscriberType: NotificationSubscriberType;
};

export enum OrderEventNotificationType {
  AppointmentCancelled = 'APPOINTMENT_CANCELLED',
  AppointmentConfirmed = 'APPOINTMENT_CONFIRMED',
  AppointmentDateChanged = 'APPOINTMENT_DATE_CHANGED',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  DeliveryNextStop = 'DELIVERY_NEXT_STOP',
  LoadedOnTruck = 'LOADED_ON_TRUCK',
  OnHand = 'ON_HAND',
  OrderCreated = 'ORDER_CREATED',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  PickupCompleted = 'PICKUP_COMPLETED',
  PickupNextStop = 'PICKUP_NEXT_STOP',
  SchedulingInvitationSent = 'SCHEDULING_INVITATION_SENT',
  SchedulingSlotBooked = 'SCHEDULING_SLOT_BOOKED',
  SchedulingSlotRescheduled = 'SCHEDULING_SLOT_RESCHEDULED'
}

export type OrderEventSnapshotCreateInput = {
  orderUuid: Scalars['String']['input'];
  previousSnapshot?: InputMaybe<Scalars['String']['input']>;
  snapshot: Scalars['String']['input'];
};

export enum OrderEventSourceType {
  Api = 'API',
  Driver = 'DRIVER',
  EdiTransaction = 'EDI_TRANSACTION',
  Picklist = 'PICKLIST',
  SftpUpload = 'SFTP_UPLOAD',
  System = 'SYSTEM',
  ThirdPartyUser = 'THIRD_PARTY_USER',
  User = 'USER',
  WarehouseEmployee = 'WAREHOUSE_EMPLOYEE'
}

export enum OrderEventTargetType {
  ContactPerson = 'CONTACT_PERSON',
  CustomerContact = 'CUSTOMER_CONTACT',
  Document = 'DOCUMENT',
  Driver = 'DRIVER',
  Invoice = 'INVOICE',
  Order = 'ORDER',
  Piece = 'PIECE',
  PieceReceipt = 'PIECE_RECEIPT',
  ShipmentAndInvoice = 'SHIPMENT_AND_INVOICE',
  ShipmentSubscriber = 'SHIPMENT_SUBSCRIBER',
  Stop = 'STOP',
  StopAndRoute = 'STOP_AND_ROUTE',
  StorageOrder = 'STORAGE_ORDER'
}

export enum OrderEventType {
  ApiOrderApproved = 'API_ORDER_APPROVED',
  Call = 'CALL',
  CustomerPortalOrderApproved = 'CUSTOMER_PORTAL_ORDER_APPROVED',
  CustomerPortalOrderRejected = 'CUSTOMER_PORTAL_ORDER_REJECTED',
  DelegatedDocumentPropagated = 'DELEGATED_DOCUMENT_PROPAGATED',
  DelegatedDocumentPropagationRevoked = 'DELEGATED_DOCUMENT_PROPAGATION_REVOKED',
  DocumentScanningOrderApproved = 'DOCUMENT_SCANNING_ORDER_APPROVED',
  DocumentScanningOrderRejected = 'DOCUMENT_SCANNING_ORDER_REJECTED',
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  Edi = 'EDI',
  EdiOrderApproved = 'EDI_ORDER_APPROVED',
  ExternalApiTransmission = 'EXTERNAL_API_TRANSMISSION',
  NextStopPendingNotificationEmail = 'NEXT_STOP_PENDING_NOTIFICATION_EMAIL',
  NextStopPendingNotificationText = 'NEXT_STOP_PENDING_NOTIFICATION_TEXT',
  OrderCancelled = 'ORDER_CANCELLED',
  OrderCompleted = 'ORDER_COMPLETED',
  OrderConsolidated = 'ORDER_CONSOLIDATED',
  OrderCreated = 'ORDER_CREATED',
  OrderCreatedNotificationEmail = 'ORDER_CREATED_NOTIFICATION_EMAIL',
  OrderCreatedNotificationText = 'ORDER_CREATED_NOTIFICATION_TEXT',
  OrderDelegationAccepted = 'ORDER_DELEGATION_ACCEPTED',
  OrderDelegationCompleted = 'ORDER_DELEGATION_COMPLETED',
  OrderDelegationDeclined = 'ORDER_DELEGATION_DECLINED',
  OrderDelegationExpired = 'ORDER_DELEGATION_EXPIRED',
  OrderDelegationFieldsChangedByExecutor = 'ORDER_DELEGATION_FIELDS_CHANGED_BY_EXECUTOR',
  OrderDelegationOffered = 'ORDER_DELEGATION_OFFERED',
  OrderDelegationRevoked = 'ORDER_DELEGATION_REVOKED',
  OrderDuplicateDiscarded = 'ORDER_DUPLICATE_DISCARDED',
  OrderFinalized = 'ORDER_FINALIZED',
  OrderHasIssue = 'ORDER_HAS_ISSUE',
  OrderHasShortage = 'ORDER_HAS_SHORTAGE',
  OrderHoldRemoved = 'ORDER_HOLD_REMOVED',
  OrderInboundReviewDecided = 'ORDER_INBOUND_REVIEW_DECIDED',
  OrderLineHaulManifestRepointed = 'ORDER_LINE_HAUL_MANIFEST_REPOINTED',
  OrderLoaded = 'ORDER_LOADED',
  OrderMarkedNotCompleted = 'ORDER_MARKED_NOT_COMPLETED',
  OrderMarkedNotOnHand = 'ORDER_MARKED_NOT_ON_HAND',
  OrderMarkedNotOsd = 'ORDER_MARKED_NOT_OSD',
  OrderMarkedNotReceivedAtOrigin = 'ORDER_MARKED_NOT_RECEIVED_AT_ORIGIN',
  OrderMarkedOnHold = 'ORDER_MARKED_ON_HOLD',
  OrderMarkedOsd = 'ORDER_MARKED_OSD',
  OrderMatchedInboundDocument = 'ORDER_MATCHED_INBOUND_DOCUMENT',
  OrderMergedFromInbound = 'ORDER_MERGED_FROM_INBOUND',
  OrderNotReadyToInvoice = 'ORDER_NOT_READY_TO_INVOICE',
  OrderOnHand = 'ORDER_ON_HAND',
  OrderPicked = 'ORDER_PICKED',
  OrderPiecesLoadedUpdated = 'ORDER_PIECES_LOADED_UPDATED',
  OrderPiecesPickedUpdated = 'ORDER_PIECES_PICKED_UPDATED',
  OrderPieceCountUpdated = 'ORDER_PIECE_COUNT_UPDATED',
  OrderReceivedAtOrigin = 'ORDER_RECEIVED_AT_ORIGIN',
  OrderRefused = 'ORDER_REFUSED',
  OrderScanned = 'ORDER_SCANNED',
  OrderSnapshot = 'ORDER_SNAPSHOT',
  OrderUncancelled = 'ORDER_UNCANCELLED',
  OrderUnloaded = 'ORDER_UNLOADED',
  OrderUpdated = 'ORDER_UPDATED',
  OrderUpdateEmailSent = 'ORDER_UPDATE_EMAIL_SENT',
  PartnerDeliveryPodPending = 'PARTNER_DELIVERY_POD_PENDING',
  PartnerDeliverySent = 'PARTNER_DELIVERY_SENT',
  PieceCreated = 'PIECE_CREATED',
  PieceDamaged = 'PIECE_DAMAGED',
  PieceDamageCleared = 'PIECE_DAMAGE_CLEARED',
  PieceDeleted = 'PIECE_DELETED',
  PieceLinkedToPackage = 'PIECE_LINKED_TO_PACKAGE',
  PieceLocationChanged = 'PIECE_LOCATION_CHANGED',
  PieceMarkedMisrouted = 'PIECE_MARKED_MISROUTED',
  PieceMarkedOverage = 'PIECE_MARKED_OVERAGE',
  PieceMarkedShortage = 'PIECE_MARKED_SHORTAGE',
  PieceMisroutedCleared = 'PIECE_MISROUTED_CLEARED',
  PieceOnHandEventRemoved = 'PIECE_ON_HAND_EVENT_REMOVED',
  PieceOverageCleared = 'PIECE_OVERAGE_CLEARED',
  PieceReceiptCreated = 'PIECE_RECEIPT_CREATED',
  PieceReceiptPiecesAdded = 'PIECE_RECEIPT_PIECES_ADDED',
  PieceReceiptPiecesRemoved = 'PIECE_RECEIPT_PIECES_REMOVED',
  PieceReceiptPieceUpdated = 'PIECE_RECEIPT_PIECE_UPDATED',
  PieceRefused = 'PIECE_REFUSED',
  PieceScanned = 'PIECE_SCANNED',
  PieceShortageCleared = 'PIECE_SHORTAGE_CLEARED',
  PieceStatusChanged = 'PIECE_STATUS_CHANGED',
  PieceUnlinkedFromPackage = 'PIECE_UNLINKED_FROM_PACKAGE',
  PieceUpdated = 'PIECE_UPDATED',
  QuoteApproved = 'QUOTE_APPROVED',
  QuoteAutoSent = 'QUOTE_AUTO_SENT',
  QuoteCustomerAccepted = 'QUOTE_CUSTOMER_ACCEPTED',
  QuoteDeclined = 'QUOTE_DECLINED',
  QuoteExpired = 'QUOTE_EXPIRED',
  QuoteSent = 'QUOTE_SENT',
  ReceiptCreated = 'RECEIPT_CREATED',
  SettlementBillFinalized = 'SETTLEMENT_BILL_FINALIZED',
  SettlementBillLineItemAdded = 'SETTLEMENT_BILL_LINE_ITEM_ADDED',
  SettlementBillLineItemAddedToBill = 'SETTLEMENT_BILL_LINE_ITEM_ADDED_TO_BILL',
  SettlementBillLineItemRemoved = 'SETTLEMENT_BILL_LINE_ITEM_REMOVED',
  SettlementBillLineItemRemovedFromBill = 'SETTLEMENT_BILL_LINE_ITEM_REMOVED_FROM_BILL',
  SettlementBillUnfinalized = 'SETTLEMENT_BILL_UNFINALIZED',
  SetPackageLocation = 'SET_PACKAGE_LOCATION',
  SftpDocumentUploaded = 'SFTP_DOCUMENT_UPLOADED',
  ShipmentAddedToInvoice = 'SHIPMENT_ADDED_TO_INVOICE',
  SignedPodEmailSent = 'SIGNED_POD_EMAIL_SENT',
  StopAddedToRoute = 'STOP_ADDED_TO_ROUTE',
  StopAppointmentConfirmed = 'STOP_APPOINTMENT_CONFIRMED',
  StopAppointmentRescheduled = 'STOP_APPOINTMENT_RESCHEDULED',
  StopAppointmentSchedulingOptionsCall = 'STOP_APPOINTMENT_SCHEDULING_OPTIONS_CALL',
  StopAppointmentSchedulingOptionsTextMessage = 'STOP_APPOINTMENT_SCHEDULING_OPTIONS_TEXT_MESSAGE',
  StopAppointmentUnconfirmed = 'STOP_APPOINTMENT_UNCONFIRMED',
  StopArrived = 'STOP_ARRIVED',
  StopAttempted = 'STOP_ATTEMPTED',
  StopAttemptRemoved = 'STOP_ATTEMPT_REMOVED',
  StopCompleted = 'STOP_COMPLETED',
  StopCompletedNotificationEmail = 'STOP_COMPLETED_NOTIFICATION_EMAIL',
  StopCompletedNotificationText = 'STOP_COMPLETED_NOTIFICATION_TEXT',
  StopPaperworkMarkedComplete = 'STOP_PAPERWORK_MARKED_COMPLETE',
  StopPaperworkMarkedIncomplete = 'STOP_PAPERWORK_MARKED_INCOMPLETE',
  StopProofOfDeliverySigneeChanged = 'STOP_PROOF_OF_DELIVERY_SIGNEE_CHANGED',
  StopRemovedFromRoute = 'STOP_REMOVED_FROM_ROUTE',
  StorageOrderInventoryDeduction = 'STORAGE_ORDER_INVENTORY_DEDUCTION',
  TextMessage = 'TEXT_MESSAGE'
}

export type OrderForCachedStop = {
  __typename?: 'OrderForCachedStop';
  businessDivisionName?: Maybe<Scalars['String']['output']>;
  businessDivisionUuid?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personName */
  callerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personPhoneNumber */
  callerPhoneNumber?: Maybe<Scalars['String']['output']>;
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  detailedStatusV2?: Maybe<OrderDetailedStatus>;
  fulfillmentType?: Maybe<FulfillmentType>;
  inboundCity?: Maybe<Scalars['String']['output']>;
  inboundName?: Maybe<Scalars['String']['output']>;
  /** Contains inbound documents grouped by type */
  inboundPaperwork?: Maybe<OrderPaperworkEntity>;
  inboundStopType?: Maybe<PickupOrDelivery>;
  inboundZip?: Maybe<Scalars['String']['output']>;
  isDoorToDoor?: Maybe<Scalars['Boolean']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderComments: Array<OrderCommentForCachedStop>;
  orderSegmentType: OrderSegmentType;
  outboundCity?: Maybe<Scalars['String']['output']>;
  outboundName?: Maybe<Scalars['String']['output']>;
  /** Contains outbound documents grouped by type */
  outboundPaperwork?: Maybe<OrderPaperworkEntity>;
  outboundStopType?: Maybe<PickupOrDelivery>;
  outboundZip?: Maybe<Scalars['String']['output']>;
  packages: Array<PackageForCachedStop>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personPhoneNumber?: Maybe<Scalars['String']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  refNumbers: Array<Scalars['String']['output']>;
  refusedBy?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceUuid?: Maybe<Scalars['String']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  tags: Array<TagEntity>;
  uuid: Scalars['String']['output'];
  vehicleTypeName?: Maybe<Scalars['String']['output']>;
  warehouseUuid?: Maybe<Scalars['String']['output']>;
};

/** An order and its fields returned as part of an invoice in the open invoice report */
export type OrderForOpenInvoiceReportEntity = {
  __typename?: 'OrderForOpenInvoiceReportEntity';
  addressName?: Maybe<Scalars['String']['output']>;
  destinationTerminalCode?: Maybe<Scalars['String']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  orderBalanceCents: Scalars['Float']['output'];
  orderName: Scalars['String']['output'];
  orderTotalCents: Scalars['Float']['output'];
  orderUuid: Scalars['String']['output'];
  originTerminalCode?: Maybe<Scalars['String']['output']>;
  pieces: Scalars['Float']['output'];
  refNumbers?: Maybe<Array<Scalars['String']['output']>>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  serviceDateV2?: Maybe<PlainDate>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
};

export type OrderForPaymentApplicationReportEntity = {
  __typename?: 'OrderForPaymentApplicationReportEntity';
  /** The amount applied to this order by this payment in dollars */
  appliedAmount: Scalars['Float']['output'];
  inboundAddressName?: Maybe<Scalars['String']['output']>;
  /** The invoice total in cents */
  invoiceBalance?: Maybe<Scalars['Float']['output']>;
  invoiceContactDisplayName?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceJournalNumber?: Maybe<Scalars['Float']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  /** The invoice total in dollars */
  invoiceTotal?: Maybe<Scalars['Float']['output']>;
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  orderBalance: Scalars['Float']['output'];
  orderName: Scalars['String']['output'];
  orderTotal: Scalars['Float']['output'];
  orderUuid: Scalars['String']['output'];
  outboundAddressName?: Maybe<Scalars['String']['output']>;
  pieces: Scalars['Float']['output'];
  refNumbers?: Maybe<Array<Scalars['String']['output']>>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
};

export type OrderForPaymentJournalReportEntity = {
  __typename?: 'OrderForPaymentJournalReportEntity';
  /** The amount applied to this order by this payment in dollars */
  appliedAmountDollars: Scalars['Float']['output'];
  invoiceCustomerName?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceJournalNumber?: Maybe<Scalars['Float']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
};

export type OrderFormFieldsEntity = {
  __typename?: 'OrderFormFieldsEntity';
  onePackageRequired: Scalars['Boolean']['output'];
  onePackageWeightRequired: Scalars['Boolean']['output'];
  packagePiecesRequired: Scalars['Boolean']['output'];
  packageWeightRequired: Scalars['Boolean']['output'];
};

export type OrderFuzzyMatchHint = {
  __typename?: 'OrderFuzzyMatchHint';
  matchedField: ScanMatchedField;
  orderUuid: Scalars['String']['output'];
};

export enum OrderIdentifier {
  OrderName = 'ORDER_NAME',
  ShipperBillOfLadingNumber = 'SHIPPER_BILL_OF_LADING_NUMBER'
}

export type OrderImportConfigurationCreateInput = {
  alwaysCreateDummyOrderCharge: Scalars['Boolean']['input'];
};

export type OrderImportConfigurationEntity = {
  __typename?: 'OrderImportConfigurationEntity';
  alwaysCreateDummyOrderCharge: Scalars['Boolean']['output'];
  importedOrderTypeMappings: Array<ImportedOrderTypeMappingEntity>;
  uuid: Scalars['String']['output'];
};

export type OrderImportConfigurationUpdateInput = {
  alwaysCreateDummyOrderCharge: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type OrderLaneGroup = {
  __typename?: 'OrderLaneGroup';
  endTerminalCode: Scalars['String']['output'];
  laneKey: Scalars['String']['output'];
  /** Total piece count of orders that traverse this lane. */
  pieceCount: Scalars['Int']['output'];
  /** Number of OrderLineHaulSegment rows in this lane after filters are applied. */
  segmentCount: Scalars['Int']['output'];
  startTerminalCode: Scalars['String']['output'];
  /** Total weight in pounds of orders that traverse this lane. */
  weightLbs?: Maybe<Scalars['Float']['output']>;
};

export type OrderLaneGroupsOutput = {
  __typename?: 'OrderLaneGroupsOutput';
  groups: Array<OrderLaneGroup>;
  /** How many further unreachable corridors exist beyond the ones listed above, dropped by the report cap. 0 when the list is complete, which is the normal case. */
  omittedUnreachableCorridorCount: Scalars['Int']['output'];
  /** Total distinct lanes matching the filter set. */
  totalCount: Scalars['Int']['output'];
  /** Corridors on which orders exist but no terminal-lane path connects the endpoints, so those orders produce no row in any lane group above. A lane-configuration gap, reported here because it is otherwise invisible. Capped: see omittedUnreachableCorridorCount. Empty for companies without line-haul networks. Root branch only: a drilled-in lane has no use for it. */
  unreachableCorridors?: Maybe<Array<DispatchUnreachableCorridor>>;
};

export type OrderLineHaulLaneEntity = {
  __typename?: 'OrderLineHaulLaneEntity';
  destinationTerminalCode: Scalars['String']['output'];
  laneUuid?: Maybe<Scalars['String']['output']>;
  originTerminalCode: Scalars['String']['output'];
};

export type OrderLineHaulSegmentConnection = {
  __typename?: 'OrderLineHaulSegmentConnection';
  edges: Array<OrderLineHaulSegmentEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderLineHaulSegmentCreateInput = {
  lineHaulSegmentUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type OrderLineHaulSegmentEdge = {
  __typename?: 'OrderLineHaulSegmentEdge';
  cursor: Scalars['String']['output'];
  node: OrderLineHaulSegmentEntity;
};

export type OrderLineHaulSegmentEntity = {
  __typename?: 'OrderLineHaulSegmentEntity';
  arrivalScans: Array<ScanEntity>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  departureScans: Array<ScanEntity>;
  order: OrderEntity;
  priorOrderLineHaulSegment?: Maybe<OrderLineHaulSegmentEntity>;
  segment: LineHaulSegmentEntity;
  uuid: Scalars['String']['output'];
};

export type OrderLineHaulSegmentOutput = {
  __typename?: 'OrderLineHaulSegmentOutput';
  edges: Array<OrderLineHaulSegmentEntity>;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum OrderLineHaulSegmentSortFields {
  CustomerName = 'CUSTOMER_NAME',
  ServiceDate = 'SERVICE_DATE'
}

export type OrderLineHaulSegmentUpdateInput = {
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lineHaulSegmentUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** An event in the line haul timeline of an order. */
export type OrderLineHaulTimelineEventEntity = {
  __typename?: 'OrderLineHaulTimelineEventEntity';
  arrivalScans: Array<ScanEntity>;
  departingManifest?: Maybe<LineHaulManifestEntity>;
  departureScans: Array<ScanEntity>;
  markedArrivedAt?: Maybe<Scalars['DateTime']['output']>;
  terminal: TerminalEntity;
};

export type OrderMirrorCaptureCompanyEntity = {
  __typename?: 'OrderMirrorCaptureCompanyEntity';
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
};

export type OrderMirrorCaptureConfigEntity = {
  __typename?: 'OrderMirrorCaptureConfigEntity';
  companies: Array<OrderMirrorCaptureCompanyEntity>;
  /** 'NONE', 'ALL', or 'COMPANIES'. */
  mode: Scalars['String']['output'];
};

export enum OrderNamingScheme {
  CompanyOrdinal = 'COMPANY_ORDINAL',
  ContactOrdinal = 'CONTACT_ORDINAL'
}

export type OrderOnLineHaulManifestEntity = {
  __typename?: 'OrderOnLineHaulManifestEntity';
  loadPosition?: Maybe<LoadPosition>;
  orderUuid: Scalars['String']['output'];
  ordinal?: Maybe<Scalars['Int']['output']>;
  piecesAwayFromRunOrigin?: Maybe<PiecesAwayFromRunOrigin>;
};

export enum OrderPdfColumnMapping {
  ClientReferenceNumber = 'CLIENT_REFERENCE_NUMBER'
}

/** Data about an order's paperwork, e.g. whether all required documents are attached */
export type OrderPaperworkEntity = {
  __typename?: 'OrderPaperworkEntity';
  alerts?: Maybe<Array<DocumentType>>;
  /** All documents uploaded to the order */
  attachedDocuments?: Maybe<Array<DocumentType>>;
  /** Document types missing from the order, required by the company's or contact's defaultInvoiceDocumentsRequired */
  missingDocuments?: Maybe<Array<DocumentType>>;
  other?: Maybe<Array<DocumentType>>;
  /**
   * Whether all documents required for a contact are attached.
   *       Can be manually overridden (see paperworkMarkedCompleteOverride).
   *       If no documents are required, this is false until overridden.
   */
  paperworkComplete: Scalars['Boolean']['output'];
  /** Whether this order's paperwork has been manually marked complete/incomplete. Null if not overridden */
  paperworkMarkedCompleteOverride?: Maybe<Scalars['Boolean']['output']>;
  photos?: Maybe<Array<DocumentType>>;
  proofOfDeliveryOrPickupReadyToSign?: Maybe<Array<DocumentType>>;
  proofOfDeliveryOrPickupSigned?: Maybe<Array<DocumentType>>;
};

/** One version of a quote the quote agent prepared from an inbound email, as the review list shows it */
export type OrderQuote = {
  __typename?: 'OrderQuote';
  attentionReasons: Array<QuoteAttentionReason>;
  conversationUuid: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<OrderQuoteCustomer>;
  customerCandidates: Array<OrderQuoteCustomerCandidate>;
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  draftReplyApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  draftReplyBody?: Maybe<Scalars['String']['output']>;
  draftReplyKind?: Maybe<QuoteDraftReplyKind>;
  draftReplyUuid?: Maybe<Scalars['String']['output']>;
  /** What the agent read from the email: null when the extraction outcome is anything other than EXTRACTED (model refused, skipped for budget or rate limit, or pipeline failed) or on a row returned degraded because its stored snapshot is unreadable; orderQuoteForOrder and the pickQuoteCustomer and requestQuoteReprice results error on an unreadable snapshot instead */
  extractedRequest?: Maybe<OrderQuoteExtractedRequest>;
  /** This quote's uuid, or for a superseded version the uuid of the version that replaced it last */
  latestVersionUuid: Scalars['String']['output'];
  /** Fields the request left out that the draft order still lacks; every field the request left out when there is no draft order yet */
  missingFields: Array<Scalars['String']['output']>;
  needsAttentionAt?: Maybe<Scalars['DateTime']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderQuoteOrderSummary>;
  /** PRICED, UNPRICEABLE or NOT_ATTEMPTED */
  pricingState: Scalars['String']['output'];
  queueGroup: OrderQuoteQueueGroup;
  quotedAmountCents?: Maybe<Scalars['Int']['output']>;
  senderAddress: Scalars['String']['output'];
  senderDisplayName?: Maybe<Scalars['String']['output']>;
  senderRecoveredFromForward: Scalars['Boolean']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: OrderQuoteStatus;
  /** The email subject of the request this quote answers; null for quotes stored before it was recorded */
  subject?: Maybe<Scalars['String']['output']>;
  turnSeq: Scalars['Int']['output'];
  unpriceableReasons: Array<Scalars['String']['output']>;
  /** The approved reply of an earlier version whose send is unconfirmed, while this version carries the earlier-send flag */
  unsettledEarlierReply?: Maybe<OrderQuoteEarlierReply>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['Int']['output'];
};

export type OrderQuoteConnection = {
  __typename?: 'OrderQuoteConnection';
  edges: Array<OrderQuoteEdge>;
  /** Rows in the Needs you group; set only with scope OPEN and includeCount */
  needsYouCount?: Maybe<Scalars['Int']['output']>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrderQuoteCustomer = {
  __typename?: 'OrderQuoteCustomer';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type OrderQuoteCustomerCandidate = {
  __typename?: 'OrderQuoteCustomerCandidate';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  /** How the candidate was found: LEARNED_MAPPING, ADDRESS_BOOK, SENDER_HISTORY or DOMAIN */
  matchedBy?: Maybe<Scalars['String']['output']>;
};

/** An approved reply drafted for an earlier version of the quote whose send is not confirmed */
export type OrderQuoteEarlierReply = {
  __typename?: 'OrderQuoteEarlierReply';
  draftReplyApprovedAt: Scalars['DateTime']['output'];
  draftReplyBody: Scalars['String']['output'];
  draftReplyKind: QuoteDraftReplyKind;
  draftReplyUuid: Scalars['String']['output'];
  orderQuoteUuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type OrderQuoteEdge = {
  __typename?: 'OrderQuoteEdge';
  cursor: Scalars['String']['output'];
  node: OrderQuote;
};

export type OrderQuoteExtractedPackage = {
  __typename?: 'OrderQuoteExtractedPackage';
  /** The goods description */
  commodity?: Maybe<Scalars['String']['output']>;
  /** PER_UNIT, PER_SET or UNKNOWN */
  dimensionBasis: Scalars['String']['output'];
  /** IN, CM or UNKNOWN */
  dimensionUnit: Scalars['String']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  /** PALLET, SKID, BOX, PIECE or UNKNOWN */
  packaging: Scalars['String']['output'];
  piecesPerUnit?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  /** EACH, TOTAL or UNKNOWN */
  weightBasis: Scalars['String']['output'];
  /** LB, KG or UNKNOWN */
  weightUnit: Scalars['String']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export type OrderQuoteExtractedParty = {
  __typename?: 'OrderQuoteExtractedParty';
  contact?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** What the quote agent read from the email, as the sender wrote it */
export type OrderQuoteExtractedRequest = {
  __typename?: 'OrderQuoteExtractedRequest';
  /** The sender's wording */
  accessorials: Array<Scalars['String']['output']>;
  consignee: OrderQuoteExtractedParty;
  /** The agent's outbound stop */
  delivery: OrderQuoteExtractedStop;
  /** YES, NO or UNKNOWN */
  hazmat: Scalars['String']['output'];
  packages: Array<OrderQuoteExtractedPackage>;
  /** The agent's inbound stop */
  pickup: OrderQuoteExtractedStop;
  readyTime?: Maybe<Scalars['String']['output']>;
  serviceWording?: Maybe<Scalars['String']['output']>;
  shipDate?: Maybe<Scalars['String']['output']>;
  shipper: OrderQuoteExtractedParty;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  /** What the agent dropped past its caps: packages, accessorial_picks, references, clarification_needed, stops.inbound.airlines, stops.outbound.airlines */
  truncatedFields: Array<Scalars['String']['output']>;
};

export type OrderQuoteExtractedStop = {
  __typename?: 'OrderQuoteExtractedStop';
  airlines: Array<Scalars['String']['output']>;
  airportCode?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** ADDRESS, AIRPORT, TERMINAL, ZIP_ONLY, CARRIER_FACILITY or UNKNOWN */
  kind: Scalars['String']['output'];
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  readyWindow?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OrderQuoteOrderSummary = {
  __typename?: 'OrderQuoteOrderSummary';
  name: Scalars['String']['output'];
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
};

/** Where a quote sits in the queue: NEEDS_YOU (an operator must act or it is flagged), WAITING_ON_CUSTOMER (sent, nothing flagged) or CLOSED */
export enum OrderQuoteQueueGroup {
  Closed = 'CLOSED',
  NeedsYou = 'NEEDS_YOU',
  WaitingOnCustomer = 'WAITING_ON_CUSTOMER'
}

/** OPEN lists the quotes that need an operator, then the quotes waiting on the customer. CLOSED lists accepted, declined, expired and dismissed quotes that are not flagged. */
export enum OrderQuoteQueueScope {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

/** The status of a quote prepared by the quote agent */
export enum OrderQuoteStatus {
  Accepted = 'ACCEPTED',
  CustomerAccepted = 'CUSTOMER_ACCEPTED',
  CustomerReplied = 'CUSTOMER_REPLIED',
  Declined = 'DECLINED',
  Dismissed = 'DISMISSED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Requested = 'REQUESTED',
  Sent = 'SENT',
  Superseded = 'SUPERSEDED',
  Unpriceable = 'UNPRICEABLE'
}

/** A filter object that is used to filter the order quote status enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type OrderQuoteStatusFilter = {
  /** Filters for records where the relevant order quote status field is equal to the provided order quote status value */
  eq?: InputMaybe<OrderQuoteStatus>;
  /** Filters for records where the relevant order quote status field is in the provided order quote status values */
  in?: InputMaybe<Array<OrderQuoteStatus>>;
  /** Filters for records where the relevant order quote status field is not equal to the provided order quote status value */
  neq?: InputMaybe<OrderQuoteStatus>;
  /** Filters for records where the relevant order quote status field is not in the provided order quote status values */
  nin?: InputMaybe<Array<OrderQuoteStatus>>;
};

export enum OrderRefusalReason {
  ConsigneeClosed = 'CONSIGNEE_CLOSED',
  Damaged = 'DAMAGED',
  NotOrdered = 'NOT_ORDERED',
  NoSpace = 'NO_SPACE',
  Other = 'OTHER',
  WrongItem = 'WRONG_ITEM'
}

export type OrderReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportAggregationPeriod: ReportAggregationPeriod;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OrderReportBucketEntity = {
  __typename?: 'OrderReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
};

export type OrderRevenueReportInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  isLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyCompletedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  /** @deprecated Deprecated. Use serviceDateFilter instead */
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OrderSegmentLeavesOutput = {
  __typename?: 'OrderSegmentLeavesOutput';
  rows: Array<DispatchOrderRow>;
  /** Total segment-level rows in the lane matching the filter set. */
  totalCount: Scalars['Int']['output'];
};

export enum OrderSegmentType {
  Cartage = 'CARTAGE',
  Courier = 'COURIER'
}

export type OrderServiceDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OrderSort = {
  sortBy: OrderTableField;
  sortDirection: OrderSortDirection;
};

export enum OrderSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OrderSortV2 = {
  completedAtSortInput?: InputMaybe<CompletedAtSortInput>;
  customerNameSortInput?: InputMaybe<CustomerNameSortInput>;
  dateMarkedOnHandSortInput?: InputMaybe<DateMarkedOnHandSortInput>;
  destinationDetailsSortInput?: InputMaybe<DestinationDetailsSortInput>;
  destinationTerminalSortInput?: InputMaybe<DestinationTerminalSortInput>;
  dimWeightSortInput?: InputMaybe<DimWeightSortInput>;
  fieldName: OrderTableField;
  inBondSortInput?: InputMaybe<InBondSortInput>;
  inboundAddressNameSortInput?: InputMaybe<InboundAddressNameSortInput>;
  inboundAddressSortInput?: InputMaybe<InboundAddressSortInput>;
  inboundCityNameSortInput?: InputMaybe<InboundCityNameSortInput>;
  inboundCompletedDateSortInput?: InputMaybe<InboundCompletedDateSortInput>;
  inboundDriverNameSortInput?: InputMaybe<InboundDriverNameSortInput>;
  inboundRouteDateSortInput?: InputMaybe<InboundRouteDateSortInput>;
  inboundRouteNameSortInput?: InputMaybe<InboundRouteNameSortInput>;
  inboundServiceDateSortInput?: InputMaybe<InboundServiceDateSortInput>;
  inboundZipcodeSortInput?: InputMaybe<InboundZipcodeSortInput>;
  isReweighedSortInput?: InputMaybe<IsReweighedSortInput>;
  locationSortInput?: InputMaybe<LocationSortInput>;
  mawbSortInput?: InputMaybe<MawbSortInput>;
  nameSortInput?: InputMaybe<NameSortInput>;
  orderConsigneeSortInput?: InputMaybe<OrderConsigneeSortInput>;
  orderServiceDateSortInput?: InputMaybe<OrderServiceDateSortInput>;
  orderSourceSortInput?: InputMaybe<OrderSourceSortInput>;
  originTerminalSortInput?: InputMaybe<OriginTerminalSortInput>;
  outboundAddressNameSortInput?: InputMaybe<OutboundAddressNameSortInput>;
  outboundAddressSortInput?: InputMaybe<OutboundAddressSortInput>;
  outboundCityNameSortInput?: InputMaybe<OutboundCityNameSortInput>;
  outboundCompletedDateSortInput?: InputMaybe<OutboundCompletedDateSortInput>;
  outboundDriverNameSortInput?: InputMaybe<OutboundDriverNameSortInput>;
  outboundMethodSortInput?: InputMaybe<OutboundMethodSortInput>;
  outboundRouteDateSortInput?: InputMaybe<OutboundRouteDateSortInput>;
  outboundRouteNameSortInput?: InputMaybe<OutboundRouteNameSortInput>;
  outboundServiceDateSortInput?: InputMaybe<OutboundServiceDateSortInput>;
  outboundZipcodeSortInput?: InputMaybe<OutboundZipcodeSortInput>;
  pieceCountSortInput?: InputMaybe<PieceCountSortInput>;
  secondaryRefNumberSortInput?: InputMaybe<SecondaryRefNumberSortInput>;
  shipperBillOfLadingNumberSortInput?: InputMaybe<ShipperBillOfLadingNumberSortInput>;
  totalPackageWeightSortInput?: InputMaybe<TotalPackageWeightSortInput>;
  totalSkidsSortInput?: InputMaybe<TotalSkidsSortInput>;
};

export enum OrderSource {
  Api = 'API',
  Consolidation = 'CONSOLIDATION',
  CsvImport = 'CSV_IMPORT',
  Cuda = 'CUDA',
  CustomerPortal = 'CUSTOMER_PORTAL',
  Delegated = 'DELEGATED',
  DocumentScanning = 'DOCUMENT_SCANNING',
  Edi = 'EDI',
  EmailQuote = 'EMAIL_QUOTE',
  Expeditors = 'EXPEDITORS',
  FiveString = 'FIVE_STRING',
  FromTemplate = 'FROM_TEMPLATE',
  IsTemplate = 'IS_TEMPLATE',
  ManuallyEntered = 'MANUALLY_ENTERED',
  Migrated = 'MIGRATED',
  Mirror = 'MIRROR',
  Quote = 'QUOTE',
  Rebilled = 'REBILLED'
}

/** A filter object that is used to filter the order source enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type OrderSourceFilter = {
  /** Filters for records where the relevant order source field is equal to the provided order source value */
  eq?: InputMaybe<OrderSource>;
  /** Filters for records where the relevant order source field is in the provided order source values */
  in?: InputMaybe<Array<OrderSource>>;
  /** Filters for records where the relevant order source field is not equal to the provided order source value */
  neq?: InputMaybe<OrderSource>;
  /** Filters for records where the relevant order source field is not in the provided order source values */
  nin?: InputMaybe<Array<OrderSource>>;
};

export type OrderSourceSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OrderSplitSummaryInput = {
  orderUuids: Array<Scalars['String']['input']>;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Finalized = 'FINALIZED',
  HasIssue = 'HAS_ISSUE',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  OnHold = 'ON_HOLD'
}

/** A filter object that is used to filter the order status enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type OrderStatusFilter = {
  /** Filters for records where the relevant order status field is equal to the provided order status value */
  eq?: InputMaybe<OrderStatus>;
  /** Filters for records where the relevant order status field is in the provided order status values */
  in?: InputMaybe<Array<OrderStatus>>;
  /** Filters for records where the relevant order status field is not equal to the provided order status value */
  neq?: InputMaybe<OrderStatus>;
  /** Filters for records where the relevant order status field is not in the provided order status values */
  nin?: InputMaybe<Array<OrderStatus>>;
};

export enum OrderStatusFilterType {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS'
}

export type OrderTableCustomChargeFieldEntity = {
  __typename?: 'OrderTableCustomChargeFieldEntity';
  /** The billing method of the custom charge. */
  billingMethod: CustomChargeBillingMethod;
  /** The name of the custom charge. */
  name: Scalars['String']['output'];
  /** The total for the custom charge in dollars */
  total: Scalars['Float']['output'];
};

export enum OrderTableField {
  AdditionalCharges = 'ADDITIONAL_CHARGES',
  Attempted = 'ATTEMPTED',
  BillingReviewStatus = 'BILLING_REVIEW_STATUS',
  BillOfLadingNumber = 'BILL_OF_LADING_NUMBER',
  BusinessDivision = 'BUSINESS_DIVISION',
  Charges = 'CHARGES',
  CityName = 'CITY_NAME',
  Company = 'COMPANY',
  CompletedAt = 'COMPLETED_AT',
  ContactInformation = 'CONTACT_INFORMATION',
  ContactName = 'CONTACT_NAME',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CustomerName = 'CUSTOMER_NAME',
  DestinationDetails = 'DESTINATION_DETAILS',
  DestinationTerminal = 'DESTINATION_TERMINAL',
  Dims = 'DIMS',
  DimWeight = 'DIM_WEIGHT',
  DriverName = 'DRIVER_NAME',
  DriverSettlement = 'DRIVER_SETTLEMENT',
  ExternalNotes = 'EXTERNAL_NOTES',
  HasDriverPod = 'HAS_DRIVER_POD',
  HoldReason = 'HOLD_REASON',
  InboundAddress = 'INBOUND_ADDRESS',
  InboundAddressName = 'INBOUND_ADDRESS_NAME',
  InboundAddressType = 'INBOUND_ADDRESS_TYPE',
  InboundAppointment = 'INBOUND_APPOINTMENT',
  InboundAppointmentConfirmed = 'INBOUND_APPOINTMENT_CONFIRMED',
  InboundAppointmentDate = 'INBOUND_APPOINTMENT_DATE',
  InboundAppointmentTime = 'INBOUND_APPOINTMENT_TIME',
  InboundCharges = 'INBOUND_CHARGES',
  InboundCityName = 'INBOUND_CITY_NAME',
  InboundCompletedDate = 'INBOUND_COMPLETED_DATE',
  InboundContactName = 'INBOUND_CONTACT_NAME',
  InboundDriverName = 'INBOUND_DRIVER_NAME',
  InboundMethod = 'INBOUND_METHOD',
  InboundOnTimePerformanceStatus = 'INBOUND_ON_TIME_PERFORMANCE_STATUS',
  InboundPaperwork = 'INBOUND_PAPERWORK',
  InboundRouteDate = 'INBOUND_ROUTE_DATE',
  InboundRouteName = 'INBOUND_ROUTE_NAME',
  InboundRouting = 'INBOUND_ROUTING',
  InboundServiceDate = 'INBOUND_SERVICE_DATE',
  InboundStopTotalTime = 'INBOUND_STOP_TOTAL_TIME',
  InboundStopType = 'INBOUND_STOP_TYPE',
  InboundStopWaitTime = 'INBOUND_STOP_WAIT_TIME',
  InboundZipcode = 'INBOUND_ZIPCODE',
  InvoiceName = 'INVOICE_NAME',
  InBond = 'IN_BOND',
  IsLinehaul = 'IS_LINEHAUL',
  IsReweighed = 'IS_REWEIGHED',
  ItTeNumber = 'IT_TE_NUMBER',
  LineHaulCharges = 'LINE_HAUL_CHARGES',
  LineHaulManifests = 'LINE_HAUL_MANIFESTS',
  Location = 'LOCATION',
  Mawb = 'MAWB',
  Name = 'NAME',
  NextAddress = 'NEXT_ADDRESS',
  NextAppointment = 'NEXT_APPOINTMENT',
  NextConsignee = 'NEXT_CONSIGNEE',
  NextDeadline = 'NEXT_DEADLINE',
  Notes = 'NOTES',
  OnHold = 'ON_HOLD',
  OrderConsignee = 'ORDER_CONSIGNEE',
  OrderLevelIssues = 'ORDER_LEVEL_ISSUES',
  OrderServiceDate = 'ORDER_SERVICE_DATE',
  OrderType = 'ORDER_TYPE',
  OriginTerminal = 'ORIGIN_TERMINAL',
  OsdReason = 'OSD_REASON',
  OutboundAddress = 'OUTBOUND_ADDRESS',
  OutboundAddressName = 'OUTBOUND_ADDRESS_NAME',
  OutboundAddressType = 'OUTBOUND_ADDRESS_TYPE',
  OutboundAppointment = 'OUTBOUND_APPOINTMENT',
  OutboundAppointmentConfirmed = 'OUTBOUND_APPOINTMENT_CONFIRMED',
  OutboundAppointmentDate = 'OUTBOUND_APPOINTMENT_DATE',
  OutboundAppointmentTime = 'OUTBOUND_APPOINTMENT_TIME',
  OutboundCharges = 'OUTBOUND_CHARGES',
  OutboundCityName = 'OUTBOUND_CITY_NAME',
  OutboundCompletedDate = 'OUTBOUND_COMPLETED_DATE',
  OutboundContactName = 'OUTBOUND_CONTACT_NAME',
  OutboundDriverName = 'OUTBOUND_DRIVER_NAME',
  OutboundMethod = 'OUTBOUND_METHOD',
  OutboundOnTimePerformanceStatus = 'OUTBOUND_ON_TIME_PERFORMANCE_STATUS',
  OutboundPaperwork = 'OUTBOUND_PAPERWORK',
  OutboundRouteDate = 'OUTBOUND_ROUTE_DATE',
  OutboundRouteName = 'OUTBOUND_ROUTE_NAME',
  OutboundRouting = 'OUTBOUND_ROUTING',
  OutboundServiceDate = 'OUTBOUND_SERVICE_DATE',
  OutboundStopTotalTime = 'OUTBOUND_STOP_TOTAL_TIME',
  OutboundStopType = 'OUTBOUND_STOP_TYPE',
  OutboundStopWaitTime = 'OUTBOUND_STOP_WAIT_TIME',
  OutboundZipcode = 'OUTBOUND_ZIPCODE',
  PaperworkComplete = 'PAPERWORK_COMPLETE',
  Photos = 'PHOTOS',
  PieceCount = 'PIECE_COUNT',
  PieceTerminalLocations = 'PIECE_TERMINAL_LOCATIONS',
  PodName = 'POD_NAME',
  PrimaryAddress = 'PRIMARY_ADDRESS',
  PrimaryAddressType = 'PRIMARY_ADDRESS_TYPE',
  PrimaryAppointment = 'PRIMARY_APPOINTMENT',
  PrimaryConsignee = 'PRIMARY_CONSIGNEE',
  PrimaryContactName = 'PRIMARY_CONTACT_NAME',
  PrimaryDeadline = 'PRIMARY_DEADLINE',
  PrimaryServiceDate = 'PRIMARY_SERVICE_DATE',
  PrimaryServiceLevel = 'PRIMARY_SERVICE_LEVEL',
  ReceivedAt = 'RECEIVED_AT',
  RouteName = 'ROUTE_NAME',
  RoutingLocation = 'ROUTING_LOCATION',
  SecondaryRefNumber = 'SECONDARY_REF_NUMBER',
  ShipmentType = 'SHIPMENT_TYPE',
  Source = 'SOURCE',
  Special = 'SPECIAL',
  Status = 'STATUS',
  StopTypes = 'STOP_TYPES',
  Tags = 'TAGS',
  TotalChargesWithItemized = 'TOTAL_CHARGES_WITH_ITEMIZED',
  TotalSkids = 'TOTAL_SKIDS',
  UnNumber = 'UN_NUMBER',
  Weight = 'WEIGHT',
  Zipcode = 'ZIPCODE'
}

/** Represents a table or column header for an order table field that is requested as part of an order retrieval for the orders table */
export type OrderTableFieldHeaderEntity = {
  __typename?: 'OrderTableFieldHeaderEntity';
  header: Scalars['String']['output'];
  /** Whether the orders table can be grouped by this field. Decided server-side from the columns the flat orders view carries, so the client never offers a grouping the query would refuse. */
  isGroupable: Scalars['Boolean']['output'];
  /** Whether the orders table can be grouped by this field while the new search serves it. A subset of isGroupable: only fields whose groups on the new search match the classic ones. */
  isGroupableOnNewSearch: Scalars['Boolean']['output'];
  orderTableField: OrderTableField;
};

/** Groups the orders table by one or more columns. `fields` is the ordered list of grouping levels; `keys` holds the group value for each level the client has already expanded, outermost first. When `keys` is shorter than `fields` the query answers with the group rows of the next level; when the two are the same length it answers with the orders under that path. A null key selects the orders whose value is blank. */
export type OrderTableGroupByInput = {
  /** Order of the group rows by their value; ascending when omitted. A blank value sorts as the largest, so it comes last ascending and first descending. */
  direction?: InputMaybe<SortDirection>;
  /** Grouping levels, outermost first. */
  fields: Array<OrderTableField>;
  /** Group value for each expanded level, outermost first. Never longer than `fields`. */
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  /** Most group rows to return. Ignored for a fully expanded path, where `first` bounds the orders page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Rows to skip within the requested level, for group rows and for the orders under a fully expanded path alike. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** One group of the orders table at the level the request asked for: the value shared by its orders, the text to show for it, and how many orders it holds. */
export type OrderTableGroupRowEntity = {
  __typename?: 'OrderTableGroupRowEntity';
  /** Number of orders in the group under the active filters. */
  count: Scalars['Int']['output'];
  /** The group value as the client must send it back in `groupBy.keys` to expand this group. Null for the orders whose value is blank. */
  key?: Maybe<Scalars['String']['output']>;
  /** Display text for the group. Null when the value is blank, so the client can render its own placeholder. */
  label?: Maybe<Scalars['String']['output']>;
};

export type OrderTableItemizedChargesFieldEntity = {
  __typename?: 'OrderTableItemizedChargesFieldEntity';
  /** @deprecated Now uses charges for more granular viewing */
  customCharges: Array<OrderTableCustomChargeFieldEntity>;
  /** @deprecated Now uses charges for more granular viewing */
  freightChargeTotal: Scalars['Float']['output'];
  /** @deprecated Now uses charges for more granular viewing */
  fuelChargeTotal: Scalars['Float']['output'];
  orderTableField: OrderTableField;
  /** The result of rating the order. If null, order rating was skipped as part of retrieving the itemized charges field */
  rateOrderOutput?: Maybe<RateOrderOutput>;
  shipmentCharges: Array<OrderTableItemizedChargesFieldShipmentEntity>;
};

export type OrderTableItemizedChargesFieldShipmentEntity = {
  __typename?: 'OrderTableItemizedChargesFieldShipmentEntity';
  customCharges: Array<OrderTableCustomChargeFieldEntity>;
  freightBillingMethod?: Maybe<FreightBillingMethod>;
  freightQuantity?: Maybe<Scalars['Float']['output']>;
  freightRate?: Maybe<Scalars['Currency']['output']>;
  freightTotalAmount?: Maybe<Scalars['Currency']['output']>;
  fuelBillingMethod?: Maybe<FuelBillingMethod>;
  fuelFlatRate?: Maybe<Scalars['Currency']['output']>;
  fuelSurchargeRate?: Maybe<Scalars['Percent']['output']>;
  fuelTotalAmount?: Maybe<Scalars['Currency']['output']>;
  /** @deprecated Use stopType instead */
  pickupOrDelivery?: Maybe<PickupOrDelivery>;
  shipmentType: ShipmentType;
  stopType?: Maybe<StopType>;
  tariff?: Maybe<TariffEntity>;
};

/** Represents a single line haul manifest that an order is on. Returned as part of a formatted line haul manifests order table field */
export type OrderTableLineHaulManifestEntity = {
  __typename?: 'OrderTableLineHaulManifestEntity';
  endTerminal: TerminalEntity;
  startTerminal: TerminalEntity;
  status: LineHaulManifestStatus;
};

export type OrderTableLineHaulManifestsFieldEntity = {
  __typename?: 'OrderTableLineHaulManifestsFieldEntity';
  /** The current terminal that the order is in. Null if the order is not on a line haul manifest */
  currentTerminal?: Maybe<TerminalEntity>;
  /** The end terminal of the order. */
  endTerminal: TerminalEntity;
  lineHaulManifests: Array<OrderTableLineHaulManifestEntity>;
  orderTableField: OrderTableField;
  /** The start terminal of the order. */
  startTerminal: TerminalEntity;
};

export type OrderTablePackageEntity = {
  __typename?: 'OrderTablePackageEntity';
  height?: Maybe<Scalars['Length']['output']>;
  length?: Maybe<Scalars['Length']['output']>;
  quantity: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Mass']['output']>;
  width?: Maybe<Scalars['Length']['output']>;
};

/** Represents the custom value for the "Dims" order table field that is returned as part of a retrieval query */
export type OrderTablePackagesFieldEntity = {
  __typename?: 'OrderTablePackagesFieldEntity';
  orderTableField: OrderTableField;
  orderTablePackages: Array<OrderTablePackageEntity>;
};

export type OrderTablePaperworkFieldEntity = {
  __typename?: 'OrderTablePaperworkFieldEntity';
  /** Contains inbound documents grouped by type */
  inboundPaperwork?: Maybe<OrderPaperworkEntity>;
  orderTableField: OrderTableField;
  /** Contains outbound documents grouped by type */
  outboundPaperwork?: Maybe<OrderPaperworkEntity>;
  paperwork: OrderPaperworkEntity;
};

export type OrderTablePhotoEntity = {
  __typename?: 'OrderTablePhotoEntity';
  fileName: Scalars['String']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  shipmentPickupOrDelivery: PickupOrDelivery;
  shipmentUuid: Scalars['String']['output'];
  stopType: StopType;
  type: DocumentType;
};

export type OrderTablePhotosFieldEntity = {
  __typename?: 'OrderTablePhotosFieldEntity';
  orderTableField: OrderTableField;
  orderTablePhotos: Array<OrderTablePhotoEntity>;
};

/** The output shape of the order table report when the number of orders is below the threshold and is generated and downloaded synchronously */
export type OrderTableReportDownloadOutput = {
  __typename?: 'OrderTableReportDownloadOutput';
  reportGenerationStatus: ReportGenerationStatus;
  reportUrl: Scalars['String']['output'];
};

/** The output shape of the order table report when the number of orders is above the threshold and is generated asynchronously and is emailed to the user */
export type OrderTableReportEmailToUserOutput = {
  __typename?: 'OrderTableReportEmailToUserOutput';
  reportGenerationStatus: ReportGenerationStatus;
};

export type OrderTableServiceEntity = {
  __typename?: 'OrderTableServiceEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type OrderTableServiceFieldEntity = {
  __typename?: 'OrderTableServiceFieldEntity';
  orderTableField: OrderTableField;
  service?: Maybe<OrderTableServiceEntity>;
};

export type OrderTableTagEntity = {
  __typename?: 'OrderTableTagEntity';
  color?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type OrderTableTagsFieldEntity = {
  __typename?: 'OrderTableTagsFieldEntity';
  orderTableField: OrderTableField;
  orderTableTags: Array<OrderTableTagEntity>;
};

export type OrderToAddToInvoice = {
  __typename?: 'OrderToAddToInvoice';
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  shipmentUuids: Array<Scalars['String']['output']>;
};

export type OrderToChargeEntity = {
  __typename?: 'OrderToChargeEntity';
  /** Amount to apply to this order */
  amountInCents: Scalars['Int']['output'];
  billToContactDisplayName?: Maybe<Scalars['String']['output']>;
  /** UUID of the customer the order is invoiced to (the invoice bill-to), so the client can total a payment by customer when it spans several. */
  billToContactUuid?: Maybe<Scalars['String']['output']>;
  /** Current order balance (before applying new payment) */
  currentBalanceInCents: Scalars['Int']['output'];
  /** Order's HAWB (shipperBillOfLadingNumber), or null when the order has none. Lets the client group/count preview rows by HAWB without re-fetching from the paginated order list. */
  hawb?: Maybe<Scalars['String']['output']>;
  invoiceUuid?: Maybe<Scalars['String']['output']>;
  /** New order balance after applying specified amountInCents */
  lineBalanceInCents: Scalars['Int']['output'];
  /** Order total charge */
  orderTotalInCents: Scalars['Int']['output'];
  orderUuid: Scalars['String']['output'];
};

export type OrderUuidsInput = {
  orderUuids: Array<Scalars['String']['input']>;
};

export type OrderVolumeByCompanyInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeByContactInput = {
  companyUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeByDateRangeInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  period: ReportAggregationPeriod;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  startDate: Scalars['DateTime']['input'];
};

export type OrderVolumeBySchemaInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeByUserInput = {
  companyUuid: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  pipeline?: InputMaybe<DocumentIngestionPipelineFilter>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderVolumeCompanyBucketEntity = {
  __typename?: 'OrderVolumeCompanyBucketEntity';
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
};

export type OrderVolumeContactBucketEntity = {
  __typename?: 'OrderVolumeContactBucketEntity';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
};

/** The open invoice value for a contact within the specified day range */
export type OrderVolumeDateRangeBucketEntity = {
  __typename?: 'OrderVolumeDateRangeBucketEntity';
  contactUuid?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
  startDate: Scalars['DateTime']['output'];
};

export type OrderVolumeSchemaBucketEntity = {
  __typename?: 'OrderVolumeSchemaBucketEntity';
  schemaName: Scalars['String']['output'];
  schemaUuid?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
};

export type OrderVolumeSourceBucketEntity = {
  __typename?: 'OrderVolumeSourceBucketEntity';
  scannedOrderSource?: Maybe<ScannedOrderSource>;
  source: OrderSource;
  totalCount: Scalars['Float']['output'];
};

export type OrderVolumeUserBucketEntity = {
  __typename?: 'OrderVolumeUserBucketEntity';
  name?: Maybe<Scalars['String']['output']>;
  sourceAmounts: Array<OrderVolumeSourceBucketEntity>;
  userEmail: Scalars['String']['output'];
  userTerminalName?: Maybe<Scalars['String']['output']>;
  userUuid: Scalars['String']['output'];
};

export type OrderWithPieceNameEntity = {
  __typename?: 'OrderWithPieceNameEntity';
  order: OrderEntity;
  /** The unique piece ID associated with this scanned order */
  pieceName?: Maybe<Scalars['String']['output']>;
};

export type OrdersByHawbInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
  hawb: Scalars['String']['input'];
};

export type OrdersForPaymentsSort = {
  sortBy: OrdersForPaymentsSortField;
  sortDirection: SortDirection;
};

export enum OrdersForPaymentsSortField {
  Customer = 'Customer',
  /** The posted invoice balance; unposted invoices sort last in both directions */
  InvoiceBalance = 'InvoiceBalance',
  /** The invoice journal number when the company uses journal numbers for invoices, otherwise the invoice name */
  InvoiceName = 'InvoiceName',
  /** The posted invoice amount; unposted invoices sort last in both directions */
  InvoiceTotal = 'InvoiceTotal',
  MasterAirwayBillOfLadingNumber = 'MasterAirwayBillOfLadingNumber',
  /** The order total minus the payments applied to it */
  OrderBalance = 'OrderBalance',
  OrderName = 'OrderName',
  /** The posted order amount, falling back to the order total */
  OrderTotal = 'OrderTotal',
  SecondaryRefNumber = 'SecondaryRefNumber',
  ShipperBillOfLadingNumber = 'ShipperBillOfLadingNumber'
}

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationEntity;
};

/** This entity represents the fields that an organization will always have regardless of the type */
export type OrganizationEntity = {
  __typename?: 'OrganizationEntity';
  addresses: Array<AddressEntity>;
  agentFields?: Maybe<AgentFieldsEntity>;
  contactPersons: Array<ContactPersonEntity>;
  createdAt: Scalars['DateTime']['output'];
  customerFields?: Maybe<CustomerFieldsEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  types: Array<OrganizationType>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum OrganizationInvoiceVendorDisplayName {
  BusinessDivisionName = 'BUSINESS_DIVISION_NAME',
  CompanyName = 'COMPANY_NAME',
  CompanyNameAndBusinessDivisionName = 'COMPANY_NAME_AND_BUSINESS_DIVISION_NAME'
}

export type OrganizationMessageAudienceInput = {
  /** Every company that receives broadcasts (CUSTOMER and INTERNAL). `companyUuids` must then be empty. */
  allCompanies: Scalars['Boolean']['input'];
  companyUuids?: Array<Scalars['String']['input']>;
};

export type OrganizationMessageBannerEntity = {
  __typename?: 'OrganizationMessageBannerEntity';
  body: Scalars['String']['output'];
  /** Whether dismissing is saved for the user (WARNING). A CRITICAL banner can only be hidden on screen and returns on reload. */
  dismissible: Scalars['Boolean']['output'];
  linkLabel?: Maybe<Scalars['String']['output']>;
  linkTarget?: Maybe<Scalars['String']['output']>;
  linkType?: Maybe<OrganizationMessageLinkType>;
  severity: OrganizationMessageSeverity;
  title: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type OrganizationMessageBannersEntity = {
  __typename?: 'OrganizationMessageBannersEntity';
  /** CRITICAL first, then WARNING, newest first. */
  banners: Array<OrganizationMessageBannerEntity>;
  /** The next time this set changes on its own (an expiry or a scheduled start); refetch then. */
  nextChangeAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationMessageCompanyEntity = {
  __typename?: 'OrganizationMessageCompanyEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type OrganizationMessageConnection = {
  __typename?: 'OrganizationMessageConnection';
  edges: Array<OrganizationMessageEdge>;
  pageInfo: PageInfo;
};

export type OrganizationMessageContentInput = {
  body?: Scalars['String']['input'];
  /** When the message stops showing. Omitted uses the severity default (INFO 14 days, WARNING 3 days, CRITICAL never); null means never. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  link?: InputMaybe<OrganizationMessageLinkInput>;
  severity: OrganizationMessageSeverity;
  /** Optional; most messages need only the body. */
  title?: Scalars['String']['input'];
};

export type OrganizationMessageCountsEntity = {
  __typename?: 'OrganizationMessageCountsEntity';
  drafts: Scalars['Int']['output'];
  ended: Scalars['Int']['output'];
  live: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
};

export type OrganizationMessageEdge = {
  __typename?: 'OrganizationMessageEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationMessageEntity;
};

export type OrganizationMessageEntity = {
  __typename?: 'OrganizationMessageEntity';
  /** Sent to every company that receives broadcasts; otherwise to `companies`. */
  allCompanies: Scalars['Boolean']['output'];
  body: Scalars['String']['output'];
  /** The addressed companies by name; empty when sent to all. */
  companies: Array<OrganizationMessageCompanyEntity>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserUuid: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  followsMessageUuid?: Maybe<Scalars['String']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  linkTarget?: Maybe<Scalars['String']['output']>;
  linkType?: Maybe<OrganizationMessageLinkType>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  severity: OrganizationMessageSeverity;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: OrganizationMessageStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The expiry is the severity default, counted from when the message starts showing. */
  usesDefaultExpiry: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
  withdrawnAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrganizationMessageEventAction {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Edited = 'EDITED',
  Published = 'PUBLISHED',
  Rescheduled = 'RESCHEDULED',
  Resolved = 'RESOLVED',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED',
  Withdrawn = 'WITHDRAWN'
}

export type OrganizationMessageEventEntity = {
  __typename?: 'OrganizationMessageEventEntity';
  action: OrganizationMessageEventAction;
  /** The staff member who acted; null when the user is gone. */
  actorName?: Maybe<Scalars['String']['output']>;
  actorUserUuid: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The message as it stood after the action. */
  snapshot: Scalars['JSON']['output'];
};

export type OrganizationMessageLinkInput = {
  label: Scalars['String']['input'];
  /** A published documentation slug, an internal app path starting with "/", or an https URL, matching `type`. */
  target: Scalars['String']['input'];
  type: OrganizationMessageLinkType;
};

export enum OrganizationMessageLinkType {
  Documentation = 'DOCUMENTATION',
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type OrganizationMessageReachEntity = {
  __typename?: 'OrganizationMessageReachEntity';
  /** Companies with the engine notification bell enabled. Banners show everywhere; the bell entry only here. */
  bellEnabledCompanyCount: Scalars['Int']['output'];
  companyCount: Scalars['Int']['output'];
  /** Active internal users of those companies. */
  userCount: Scalars['Int']['output'];
};

export enum OrganizationMessageSeverity {
  Critical = 'CRITICAL',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type OrganizationMessageStatsEntity = {
  __typename?: 'OrganizationMessageStatsEntity';
  asOf: Scalars['DateTime']['output'];
  /** Companies the message was sent to. */
  companyCount: Scalars['Int']['output'];
  /** Bell rows written. */
  deliveredCount: Scalars['Int']['output'];
  dismissedCount: Scalars['Int']['output'];
  /** Companies whose delivery failed for good. */
  failedCompanyCount: Scalars['Int']['output'];
  /** Companies whose delivery has not run yet. */
  pendingCompanyCount: Scalars['Int']['output'];
  readCount: Scalars['Int']['output'];
};

export enum OrganizationMessageStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Resolved = 'RESOLVED',
  Scheduled = 'SCHEDULED',
  Withdrawn = 'WITHDRAWN'
}

export type OrganizationMessageUuidInput = {
  uuid: Scalars['String']['input'];
};

export enum OrganizationMessageView {
  Drafts = 'DRAFTS',
  Ended = 'ENDED',
  Live = 'LIVE',
  Scheduled = 'SCHEDULED'
}

export type OrganizationPackageTypeConfigEntity = {
  __typename?: 'OrganizationPackageTypeConfigEntity';
  id: Scalars['String']['output'];
  isSingleHandlingUnit: Scalars['Boolean']['output'];
  packageType: PackageType;
};

export type OrganizationPeerConnection = {
  __typename?: 'OrganizationPeerConnection';
  edges: Array<OrganizationPeerEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationPeerEdge = {
  __typename?: 'OrganizationPeerEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationPeerEntity;
};

export type OrganizationPeerEntity = {
  __typename?: 'OrganizationPeerEntity';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  autoAcceptOffers: Scalars['Boolean']['output'];
  autoApplyPeerAccessorials: Scalars['Boolean']['output'];
  companyName: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  organizationUuid?: Maybe<Scalars['String']['output']>;
  peerCompanyName: Scalars['String']['output'];
  peerCompanyUuid: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  shareProgressWithPeer: Scalars['Boolean']['output'];
  status: OrganizationPeerStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type OrganizationPeerSettingsChangeInput = {
  autoAcceptOffers?: InputMaybe<Scalars['Boolean']['input']>;
  autoApplyPeerAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  peerCompanyUuid: Scalars['String']['input'];
  shareProgressWithPeer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Lifecycle state of a directed organization-to-organization peer relationship. */
export enum OrganizationPeerStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

/** The type of organization */
export enum OrganizationType {
  Agent = 'AGENT',
  Customer = 'CUSTOMER'
}

export enum OriginStopType {
  PartnerDropoff = 'PARTNER_DROPOFF',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY'
}

export type OriginTerminalMismatchError = {
  __typename?: 'OriginTerminalMismatchError';
  order: OrderEntity;
};

export type OriginTerminalSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OrphanPieceSpecInput = {
  damagedNote?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isDamaged?: InputMaybe<Scalars['Boolean']['input']>;
  isMisrouted?: InputMaybe<Scalars['Boolean']['input']>;
  isOverage?: InputMaybe<Scalars['Boolean']['input']>;
  isShortage?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  note?: InputMaybe<Scalars['String']['input']>;
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type OutboundAddressNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundAddressSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

/** Searches one TENEDI partnership's orders for the page's order picker, newest first. */
export type OutboundBenchOrderSearchInput = {
  ediPartnershipUuid: Scalars['String']['input'];
  /** 1 to 25. Defaults to 25. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  /** Matched, ignoring case, against the order name, HAWB and MAWB. Leave it empty for the newest orders. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundCityNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundCompletedDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundDriverNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum OutboundMethod {
  AirportTransfer = 'AIRPORT_TRANSFER',
  LocalDelivery = 'LOCAL_DELIVERY',
  Other = 'OTHER'
}

export type OutboundMethodSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundRouteDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundRouteNameSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundServiceDateSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutboundWebhookEventEntity = {
  __typename?: 'OutboundWebhookEventEntity';
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  httpStatusCode?: Maybe<Scalars['Int']['output']>;
  type: OutboundWebhookEventType;
  uuid: Scalars['String']['output'];
};

export enum OutboundWebhookEventType {
  DeliveryAppointmentCancelled = 'DELIVERY_APPOINTMENT_CANCELLED',
  DeliveryAppointmentConfirmed = 'DELIVERY_APPOINTMENT_CONFIRMED',
  DeliveryCompleted = 'DELIVERY_COMPLETED',
  InvoicePosted = 'INVOICE_POSTED',
  MasterOrderAllFulfilled = 'MASTER_ORDER_ALL_FULFILLED',
  OrderOnHand = 'ORDER_ON_HAND',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  OutForPickup = 'OUT_FOR_PICKUP',
  PickupAppointmentCancelled = 'PICKUP_APPOINTMENT_CANCELLED',
  PickupAppointmentConfirmed = 'PICKUP_APPOINTMENT_CONFIRMED',
  PickupCompleted = 'PICKUP_COMPLETED',
  PieceStatusChanged = 'PIECE_STATUS_CHANGED',
  PodDocumentAvailable = 'POD_DOCUMENT_AVAILABLE',
  RecoveryCompleted = 'RECOVERY_COMPLETED',
  StopAppointmentScheduled = 'STOP_APPOINTMENT_SCHEDULED',
  StopAttempted = 'STOP_ATTEMPTED',
  StopCompleted = 'STOP_COMPLETED',
  StopOutForDelivery = 'STOP_OUT_FOR_DELIVERY',
  TransferCompleted = 'TRANSFER_COMPLETED'
}

export type OutboundZipcodeSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type OutlookIntegrationCreateInput = {
  companyUuid: Scalars['String']['input'];
  emailCreatedAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  entraTenantId: Scalars['String']['input'];
  entraUserId: Scalars['String']['input'];
  outboundEmailDomains: Array<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type OutlookIntegrationEntity = {
  __typename?: 'OutlookIntegrationEntity';
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  emailCreatedAtStartDate?: Maybe<Scalars['DateTime']['output']>;
  entraTenantId: Scalars['String']['output'];
  entraUserId: Scalars['String']['output'];
  outboundEmailDomains: Array<Scalars['String']['output']>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserActorEntity;
  uuid: Scalars['String']['output'];
};

export type OutlookIntegrationUpdateInput = {
  emailCreatedAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundEmailDomains: Array<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type PackPiecesInput = {
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  pieceUuids: Array<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PieceStatus>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type: PackageType;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageArrayUpdateInput = {
  packageUpsertInput: PackageUpsertInput;
};

export type PackageCreateInput = {
  class?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  freightClass?: InputMaybe<FreightClass>;
  freightSnapTransactionUuid?: InputMaybe<Scalars['String']['input']>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  nmfc?: InputMaybe<Scalars['String']['input']>;
  packageSpecId?: InputMaybe<Scalars['String']['input']>;
  /** UUIDs of existing pieces to link to this package via the PackageHasPiece join table. */
  pieceUuidsToLink?: InputMaybe<Array<Scalars['String']['input']>>;
  pieces?: InputMaybe<Array<PackagePieceCreateInput>>;
  quantity: Scalars['Int']['input'];
  quantityCompletedAtStop?: InputMaybe<Scalars['Int']['input']>;
  reasonUncompletedAtStop?: InputMaybe<Scalars['String']['input']>;
  skuNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  /** Represents the warehouse location assigned to the package if it is turned on for the customer */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageEntity = {
  __typename?: 'PackageEntity';
  class?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  freightClass?: Maybe<FreightClass>;
  hazmat?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  nmfc?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderEntity>;
  /** All PackageHasPiece links for the package. */
  packageHasPieces?: Maybe<Array<PackageHasPieceEntity>>;
  packageSpec?: Maybe<PackageSpecEntity>;
  /**
   * The first piece associated with the package
   * @deprecated Use pieces instead as packages now have multiple pieces
   */
  piece?: Maybe<PieceEntity>;
  /** All pieces associated with the package */
  pieces?: Maybe<Array<PieceEntity>>;
  quantity: Scalars['Int']['output'];
  quantityCompletedAtStop?: Maybe<Scalars['Int']['output']>;
  reasonUncompletedAtStop?: Maybe<Scalars['String']['output']>;
  skuNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PackageType>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum PackageField {
  Description = 'DESCRIPTION',
  Height = 'HEIGHT',
  Length = 'LENGTH',
  Quantity = 'QUANTITY',
  Weight = 'WEIGHT',
  Width = 'WIDTH'
}

export type PackageForCachedStop = {
  __typename?: 'PackageForCachedStop';
  description?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum PackageGroup {
  I = 'I',
  Ii = 'II',
  Iii = 'III'
}

export type PackageHasPieceEntity = {
  __typename?: 'PackageHasPieceEntity';
  createdAt: Scalars['DateTime']['output'];
  package: PackageEntity;
  piece: PieceEntity;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type PackagePieceCreateInput = {
  additionalReferenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Where the form loaded this piece. Present for a piece the form read from the server, absent for a new one. */
  baseline?: InputMaybe<PieceBaselineInput>;
  children?: InputMaybe<Array<PackagePieceCreateInput>>;
  damagedAt?: InputMaybe<Scalars['DateTime']['input']>;
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  /** Fields of this piece the form filled in for the user: each is written only while the stored column is still empty, and a save carrying nothing else for the piece does not count as an edit of it. */
  fillIfEmptyFields?: InputMaybe<Array<PieceFillIfEmptyField>>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isMisrouted?: InputMaybe<Scalars['Boolean']['input']>;
  isOverage?: InputMaybe<Scalars['Boolean']['input']>;
  isShortage?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  refusedAt?: InputMaybe<Scalars['DateTime']['input']>;
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PieceStatus>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  uuid: Scalars['String']['input'];
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageSpecEntity = {
  __typename?: 'PackageSpecEntity';
  freightClass?: Maybe<FreightClass>;
  height?: Maybe<Scalars['Length']['output']>;
  id: Scalars['String']['output'];
  length?: Maybe<Scalars['Length']['output']>;
  name: Scalars['String']['output'];
  status: PackageSpecStatus;
  weight?: Maybe<Scalars['Mass']['output']>;
  width?: Maybe<Scalars['Length']['output']>;
};

export enum PackageSpecStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type PackageTableColumnEntity = {
  __typename?: 'PackageTableColumnEntity';
  columnIndex: Scalars['Int']['output'];
  header: Scalars['String']['output'];
  packageField?: Maybe<PackageField>;
  required: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type PackageTableColumnInput = {
  columnIndex: Scalars['Int']['input'];
  header: Scalars['String']['input'];
  packageField?: InputMaybe<PackageField>;
  required: Scalars['Boolean']['input'];
};

export type PackageTableEntity = {
  __typename?: 'PackageTableEntity';
  blockId: Scalars['String']['output'];
  headerRowIndex: Scalars['Int']['output'];
  packageTableColumns: Array<PackageTableColumnEntity>;
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type PackageTableInput = {
  blockId: Scalars['String']['input'];
  headerRowIndex: Scalars['Int']['input'];
  packageTableColumns: Array<PackageTableColumnInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum PackageType {
  Box = 'BOX',
  Bundle = 'BUNDLE',
  Container = 'CONTAINER',
  Crate = 'CRATE',
  Other = 'OTHER',
  Pallet = 'PALLET',
  Piece = 'PIECE',
  Skid = 'SKID'
}

export type PackageUpdateInput = {
  class?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  freightClass?: InputMaybe<FreightClass>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  nmfc?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityCompletedAtStop?: InputMaybe<Scalars['Int']['input']>;
  reasonUncompletedAtStop?: InputMaybe<Scalars['String']['input']>;
  skuNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  uuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageUpsertInput = {
  /** The stored quantity the form loaded; quantity is then applied as a change on the stored value. */
  baselineQuantity?: InputMaybe<Scalars['Int']['input']>;
  class?: InputMaybe<Scalars['Float']['input']>;
  /** Omitted or null leaves the stored description alone; required to create a package. */
  description?: InputMaybe<Scalars['String']['input']>;
  freightClass?: InputMaybe<FreightClass>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  nmfc?: InputMaybe<Scalars['String']['input']>;
  packageSpecId?: InputMaybe<Scalars['String']['input']>;
  /** UUIDs of existing pieces to link to this package via the PackageHasPiece join table. */
  pieceUuidsToLink?: InputMaybe<Array<Scalars['String']['input']>>;
  pieces?: InputMaybe<Array<PackagePieceCreateInput>>;
  quantity: Scalars['Int']['input'];
  quantityCompletedAtStop?: InputMaybe<Scalars['Int']['input']>;
  reasonUncompletedAtStop?: InputMaybe<Scalars['String']['input']>;
  /** Sending this list puts the package in delta mode: the loaded top-level pieces the user deleted from the order. */
  removedPieceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  skuNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  uuid: Scalars['String']['input'];
  /** Represents the warehouse location assigned to the package if it is turned on for the customer */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackingPendencyEntity = {
  __typename?: 'PackingPendencyEntity';
  /** Null when the pendency is open to any operator on its warehouse. */
  assignedWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  /** When an operator claimed this pendency. Set while IN_PROGRESS, retained after DONE. */
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  executedByWarehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
  height?: Maybe<Scalars['Float']['output']>;
  kind: PackingPendencyKind;
  length?: Maybe<Scalars['Float']['output']>;
  measurementUnits?: Maybe<MeasurementUnits>;
  note?: Maybe<Scalars['String']['output']>;
  /** The shared order of the covered pieces, when they have one. Powers the "N pieces · ORDER" secondary label. */
  order?: Maybe<PackingPendencyOrderEntity>;
  pieces: Array<PieceEntity>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  resultingPiece?: Maybe<PieceEntity>;
  status: PackingPendencyStatus;
  type?: Maybe<PackageType>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
  /** Where the sender staged the packed bundle. Null when left to the floor; used as the default the operator confirms. */
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<WeightUnits>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum PackingPendencyKind {
  Pack = 'PACK',
  Unpack = 'UNPACK'
}

export type PackingPendencyOrderEntity = {
  __typename?: 'PackingPendencyOrderEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum PackingPendencyStatus {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN'
}

export type PackingPieceByBarcodeInput = {
  barcode: Scalars['String']['input'];
  preferOrderUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PackingPiecesInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PackingPiecesOutput = {
  __typename?: 'PackingPiecesOutput';
  hasMorePackages: Scalars['Boolean']['output'];
  pieces: Array<PieceListEntity>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PalletProductOffering {
  EmailIngestion = 'EMAIL_INGESTION',
  Tms = 'TMS',
  Wms = 'WMS'
}

export type ParseCsvOrderRowErrorEntity = {
  __typename?: 'ParseCsvOrderRowErrorEntity';
  message: Scalars['String']['output'];
  /** The row where the error occurred. Note that this is NOT 0-indexed */
  row: Scalars['Int']['output'];
};

export type ParseCsvOrdersInput = {
  bucket: Scalars['String']['input'];
  csvOrderMappingUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type ParseCsvOrdersOutput = MutationErrorOutput | ParseCsvOrdersSuccessOutput;

export type ParseCsvOrdersSuccessOutput = {
  __typename?: 'ParseCsvOrdersSuccessOutput';
  enableInboundStop: Scalars['Boolean']['output'];
  enableOutboundStop: Scalars['Boolean']['output'];
  errors: Array<ParseCsvOrderRowErrorEntity>;
  parsedOrderUpdates: Array<ParsedCsvOrderUpdateEntity>;
  parsedOrders: Array<ParsedCsvOrderEntity>;
};

export type ParsedCsvOrderEntity = {
  __typename?: 'ParsedCsvOrderEntity';
  billingPartyContact: ContactEntity;
  customerReferenceNumber?: Maybe<Scalars['String']['output']>;
  dimFactor?: Maybe<Scalars['Int']['output']>;
  freightChargeRate?: Maybe<Scalars['Float']['output']>;
  freightChargeType?: Maybe<FreightBillingMethod>;
  fuelChargeType?: Maybe<FuelBillingMethod>;
  fuelSurcharge?: Maybe<Scalars['Float']['output']>;
  inboundStop?: Maybe<ParsedCsvOrderStopEntity>;
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundStop?: Maybe<ParsedCsvOrderStopEntity>;
  packages: Array<ParsedCsvOrderPackageEntity>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  serviceLevel?: Maybe<ServiceEntity>;
  shipperBillOfLadingNumber: Scalars['String']['output'];
};

/** A package that is either parsed from a CSV file or from an order part of an order that was detected in a parsed CSV file */
export type ParsedCsvOrderPackageEntity = {
  __typename?: 'ParsedCsvOrderPackageEntity';
  class?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  freightClass?: Maybe<FreightClass>;
  height?: Maybe<Scalars['Float']['output']>;
  /** A flag that is set to true if the parsed package is one that needs to be appended to the order packages */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  nmfc?: Maybe<Scalars['String']['output']>;
  packageSpec?: Maybe<PackageSpecEntity>;
  quantity: Scalars['Int']['output'];
  type?: Maybe<PackageType>;
  /** Either the UUID of an existing package, or a new UUID for the new package */
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type ParsedCsvOrderStopEntity = {
  __typename?: 'ParsedCsvOrderStopEntity';
  addressCity: Scalars['String']['output'];
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressName: Scalars['String']['output'];
  addressState: Scalars['String']['output'];
  addressZip: Scalars['String']['output'];
  appointmentEndTime?: Maybe<PlainTime>;
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentStartTime?: Maybe<PlainTime>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonFirstName?: Maybe<Scalars['String']['output']>;
  contactPersonLastName?: Maybe<Scalars['String']['output']>;
  contactPersonPhone?: Maybe<Scalars['String']['output']>;
  deadlineDate?: Maybe<Scalars['DateTime']['output']>;
  deadlineType?: Maybe<DeadlineType>;
  driver?: Maybe<DriverEntity>;
  driverName?: Maybe<Scalars['String']['output']>;
  driverReferenceNumber?: Maybe<Scalars['String']['output']>;
  pickupOrDelivery: PickupOrDelivery;
  serviceDate: Scalars['DateTime']['output'];
  /** The service date of the parsed stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2: PlainDate;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  terminal?: Maybe<TerminalEntity>;
  terminalName?: Maybe<Scalars['String']['output']>;
};

export type ParsedCsvOrderStopInput = {
  addressCity: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressName: Scalars['String']['input'];
  addressState: Scalars['String']['input'];
  addressZip: Scalars['String']['input'];
  appointmentEndTime?: InputMaybe<PlainTimeInput>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentStartTime?: InputMaybe<PlainTimeInput>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonFirstName?: InputMaybe<Scalars['String']['input']>;
  contactPersonLastName?: InputMaybe<Scalars['String']['input']>;
  contactPersonPhone?: InputMaybe<Scalars['String']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  pickupOrDelivery: PickupOrDelivery;
  serviceDate: Scalars['DateTime']['input'];
  /** The service date, in ISO 8601 date format. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ParsedCsvOrderUpdateEntity = {
  __typename?: 'ParsedCsvOrderUpdateEntity';
  billingPartyContact: ContactEntity;
  packages: Array<ParsedCsvOrderPackageEntity>;
  shipperBillOfLadingNumber: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  edges: Array<PaymentEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Not cheap to calculate, request with prudence */
  uuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Version ID for the response */
  versionId?: Maybe<Scalars['Float']['output']>;
};

export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  cursor: Scalars['String']['output'];
  node: PaymentEntity;
};

export type PaymentEntity = {
  __typename?: 'PaymentEntity';
  amountInCents: Scalars['Int']['output'];
  appliedAmountInCents: Scalars['Float']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  creditNumber?: Maybe<Scalars['Float']['output']>;
  creditType?: Maybe<CreditTypeEntity>;
  date: Scalars['DateTime']['output'];
  glTerminal?: Maybe<TerminalEntity>;
  invoicesAppliedTo: Array<InvoiceEntity>;
  offsetAmountInCents: Scalars['Int']['output'];
  paymentOffsets: Array<PaymentToPaymentMappingEntity>;
  paymentRail?: Maybe<PaymentRail>;
  paymentToOrderMappings: Array<PaymentToOrderMappingEntity>;
  paymentType: PaymentType;
  quickbooksPaymentId?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
  unappliedAmountInCents: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type PaymentForCheckRegisterReportEntity = {
  __typename?: 'PaymentForCheckRegisterReportEntity';
  amountInCents?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  contactDisplayName?: Maybe<Scalars['String']['output']>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentUuid: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  terminalCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type PaymentForPaymentApplicationReportEntity = {
  __typename?: 'PaymentForPaymentApplicationReportEntity';
  comment?: Maybe<Scalars['String']['output']>;
  contactDisplayName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  masterAccountName?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderForPaymentApplicationReportEntity>;
  paymentDate: Scalars['DateTime']['output'];
  paymentRail?: Maybe<PaymentRail>;
  paymentType: PaymentType;
  paymentUuid: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  /** The total amount of the payment in dollars */
  totalAmount: Scalars['Float']['output'];
  /** The amount not applied yet in dollars */
  unappliedAmount: Scalars['Float']['output'];
};

export type PaymentForPaymentJournalReportEntity = {
  __typename?: 'PaymentForPaymentJournalReportEntity';
  comment?: Maybe<Scalars['String']['output']>;
  contactDisplayName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  creditNumber?: Maybe<Scalars['Float']['output']>;
  creditTypeName?: Maybe<Scalars['String']['output']>;
  glTerminalName?: Maybe<Scalars['String']['output']>;
  orders: Array<OrderForPaymentJournalReportEntity>;
  paymentDate: Scalars['DateTime']['output'];
  paymentRail?: Maybe<PaymentRail>;
  paymentType: PaymentType;
  paymentUuid: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  /** The total amount of the payment in dollars */
  totalAmount: Scalars['Float']['output'];
  /** The amount not applied yet in dollars */
  unappliedAmountDollars: Scalars['Float']['output'];
};

export enum PaymentMethod {
  Collect = 'COLLECT',
  PrepaidBySeller = 'PREPAID_BY_SELLER',
  ServiceFreightNoCharges = 'SERVICE_FREIGHT_NO_CHARGES',
  ThirdPartyPay = 'THIRD_PARTY_PAY'
}

export enum PaymentRail {
  Ach = 'ACH',
  Check = 'CHECK'
}

export type PaymentSort = {
  sortBy: PaymentTableField;
  sortDirection: SortDirection;
};

export enum PaymentTableField {
  Amount = 'amount',
  Date = 'date'
}

export type PaymentToOrderMappingEntity = {
  __typename?: 'PaymentToOrderMappingEntity';
  amountInCents: Scalars['Int']['output'];
  order: OrderEntity;
  payment: PaymentEntity;
  uuid: Scalars['String']['output'];
};

export type PaymentToPaymentMappingEntity = {
  __typename?: 'PaymentToPaymentMappingEntity';
  amountInCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  sourcePayment: PaymentEntity;
  targetPayment: PaymentEntity;
  uuid: Scalars['String']['output'];
};

export enum PaymentType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Payment = 'PAYMENT'
}

export type PdProductivityArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PdProductivityDriverEntity = {
  __typename?: 'PdProductivityDriverEntity';
  actualHours: Scalars['Float']['output'];
  allowedHours: Scalars['Float']['output'];
  driverName: Scalars['String']['output'];
  driverUuid: Scalars['String']['output'];
  inefficiencyCostUsd?: Maybe<Scalars['Float']['output']>;
  inefficiencyHours: Scalars['Float']['output'];
  pieceCount: Scalars['Int']['output'];
  productivityRatio?: Maybe<Scalars['Float']['output']>;
  routeCount: Scalars['Int']['output'];
  status?: Maybe<ProductivityStatus>;
  stopCount: Scalars['Int']['output'];
  totalMiles: Scalars['Float']['output'];
  totalWeightLbs: Scalars['Float']['output'];
};

export type PdProductivityReportEntity = {
  __typename?: 'PdProductivityReportEntity';
  appliedDriverCostPerHourUsd?: Maybe<Scalars['Float']['output']>;
  costBasis: CostBasis;
  costPerStopUsd?: Maybe<Scalars['Float']['output']>;
  drivers: Array<PdProductivityDriverEntity>;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  hasTimeAllowances: Scalars['Boolean']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  overallProductivityRatio?: Maybe<Scalars['Float']['output']>;
  pdCostUsd?: Maybe<Scalars['Float']['output']>;
  routesMissingTimestamps: Scalars['Int']['output'];
  timeAllowances: ProductivityTimeAllowanceEntity;
  totalActualHours: Scalars['Float']['output'];
  totalAllowedHours: Scalars['Float']['output'];
  totalInefficiencyCostUsd?: Maybe<Scalars['Float']['output']>;
  totalInefficiencyHours: Scalars['Float']['output'];
  truckCostPerMileUsd?: Maybe<Scalars['Float']['output']>;
};

export type PdfColumnCreateInput = {
  legPDFColumnMapping?: InputMaybe<LegPdfColumnMapping>;
  orderColumnMapping?: InputMaybe<OrderPdfColumnMapping>;
  shipmentPDFColumnMapping?: InputMaybe<ShipmentPdfColumnMapping>;
  stopPDFColumnMapping?: InputMaybe<StopPdfColumnMapping>;
};

export type PdfColumnEntity = {
  __typename?: 'PdfColumnEntity';
  createdAt: Scalars['DateTime']['output'];
  legPDFColumnMapping?: Maybe<LegPdfColumnMapping>;
  orderColumnMapping?: Maybe<OrderPdfColumnMapping>;
  shipmentPDFColumnMapping?: Maybe<ShipmentPdfColumnMapping>;
  stopPDFColumnMapping?: Maybe<StopPdfColumnMapping>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type PeerServiceShareEntity = {
  __typename?: 'PeerServiceShareEntity';
  isActive: Scalars['Boolean']['output'];
  serviceName: Scalars['String']['output'];
  serviceUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type PercentageAccessorialCreateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageBasis: AccessorialPercentageBasis;
  /** Percentage rate out of 100, e.g. 1.75 means 1.75% */
  rate: Scalars['Float']['input'];
};

export type PercentageAccessorialEntity = AccessorialInterface & {
  __typename?: 'PercentageAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  percentageBasis?: Maybe<AccessorialPercentageBasis>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  /** Percentage rate out of 100 */
  rate: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type PercentageAccessorialUpdateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  percentageBasis?: InputMaybe<AccessorialPercentageBasis>;
  /** Percentage rate out of 100, e.g. 1.75 means 1.75% */
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type PermissionEntity = {
  __typename?: 'PermissionEntity';
  accessLevel: AccessLevel;
  permissionResource: PermissionResource;
  uuid: Scalars['String']['output'];
};

export enum PermissionResource {
  AccountingReports = 'ACCOUNTING_REPORTS',
  Appointments = 'APPOINTMENTS',
  BillingReview = 'BILLING_REVIEW',
  CompanyAccessorials = 'COMPANY_ACCESSORIALS',
  CompanyBilling = 'COMPANY_BILLING',
  CompanyBusinessDivisions = 'COMPANY_BUSINESS_DIVISIONS',
  CompanyCustomForms = 'COMPANY_CUSTOM_FORMS',
  CompanyDrivers = 'COMPANY_DRIVERS',
  CompanyDriverCompliance = 'COMPANY_DRIVER_COMPLIANCE',
  CompanyEquipment = 'COMPANY_EQUIPMENT',
  CompanyFuelProfiles = 'COMPANY_FUEL_PROFILES',
  CompanyHoldReasons = 'COMPANY_HOLD_REASONS',
  CompanyLineHaul = 'COMPANY_LINE_HAUL',
  CompanyRecoveryTerminals = 'COMPANY_RECOVERY_TERMINALS',
  CompanyRecurringOrders = 'COMPANY_RECURRING_ORDERS',
  CompanyRouteNames = 'COMPANY_ROUTE_NAMES',
  CompanyScheduling = 'COMPANY_SCHEDULING',
  CompanyServices = 'COMPANY_SERVICES',
  CompanyTariffs = 'COMPANY_TARIFFS',
  CompanyTerminals = 'COMPANY_TERMINALS',
  CompanyThirdPartyBrokers = 'COMPANY_THIRD_PARTY_BROKERS',
  CompanyUsers = 'COMPANY_USERS',
  CompanyWarehouseEmployees = 'COMPANY_WAREHOUSE_EMPLOYEES',
  Contacts = 'CONTACTS',
  Customers = 'CUSTOMERS',
  CustomerPortalOrders = 'CUSTOMER_PORTAL_ORDERS',
  DailyControlCenter = 'DAILY_CONTROL_CENTER',
  DelegatedOrders = 'DELEGATED_ORDERS',
  DelegatedOrdersAccept = 'DELEGATED_ORDERS_ACCEPT',
  DeleteOrders = 'DELETE_ORDERS',
  DeletePieces = 'DELETE_PIECES',
  DriverSettlements = 'DRIVER_SETTLEMENTS',
  EdiApiOrders = 'EDI_API_ORDERS',
  EmailOrders = 'EMAIL_ORDERS',
  EmailQuotes = 'EMAIL_QUOTES',
  EndOfDay = 'END_OF_DAY',
  ExpeditorsApiStatus = 'EXPEDITORS_API_STATUS',
  FinalizeChargesOrders = 'FINALIZE_CHARGES_ORDERS',
  FinalizeChargesOrdersPaperworkIncomplete = 'FINALIZE_CHARGES_ORDERS_PAPERWORK_INCOMPLETE',
  ForwarderBoard = 'FORWARDER_BOARD',
  IntelligenceBoard = 'INTELLIGENCE_BOARD',
  InternalTools = 'INTERNAL_TOOLS',
  Invoices = 'INVOICES',
  LineHaulDispatch = 'LINE_HAUL_DISPATCH',
  Master = 'MASTER',
  MobileDriverApp = 'MOBILE_DRIVER_APP',
  MobileWarehouseScanning = 'MOBILE_WAREHOUSE_SCANNING',
  Orders = 'ORDERS',
  OrderDelegationGrant = 'ORDER_DELEGATION_GRANT',
  OwnersBreakfastDashboard = 'OWNERS_BREAKFAST_DASHBOARD',
  OwnersBreakfastDaysToInvoice = 'OWNERS_BREAKFAST_DAYS_TO_INVOICE',
  OwnersBreakfastDaysToPayment = 'OWNERS_BREAKFAST_DAYS_TO_PAYMENT',
  OwnersBreakfastDeliveryFailure = 'OWNERS_BREAKFAST_DELIVERY_FAILURE',
  OwnersBreakfastDockReceived = 'OWNERS_BREAKFAST_DOCK_RECEIVED',
  OwnersBreakfastOnTimeDelivery = 'OWNERS_BREAKFAST_ON_TIME_DELIVERY',
  OwnersBreakfastOnTimePickup = 'OWNERS_BREAKFAST_ON_TIME_PICKUP',
  OwnersBreakfastOrdersPerDriver = 'OWNERS_BREAKFAST_ORDERS_PER_DRIVER',
  OwnersBreakfastOrderCount = 'OWNERS_BREAKFAST_ORDER_COUNT',
  OwnersBreakfastPieceScan = 'OWNERS_BREAKFAST_PIECE_SCAN',
  OwnersBreakfastRevenue = 'OWNERS_BREAKFAST_REVENUE',
  Quote = 'QUOTE',
  Reports = 'REPORTS',
  Routes = 'ROUTES',
  SavedViews = 'SAVED_VIEWS',
  ScannedOrders = 'SCANNED_ORDERS',
  SendFinalizedToBilling = 'SEND_FINALIZED_TO_BILLING',
  SettingsAutoApplyAccessorialRules = 'SETTINGS_AUTO_APPLY_ACCESSORIAL_RULES',
  SettingsDispatch = 'SETTINGS_DISPATCH',
  SettingsGeneral = 'SETTINGS_GENERAL',
  SettingsMotive = 'SETTINGS_MOTIVE',
  SettingsOrders = 'SETTINGS_ORDERS',
  SettingsQuickbooks = 'SETTINGS_QUICKBOOKS',
  SettingsQuickbooksDesktop = 'SETTINGS_QUICKBOOKS_DESKTOP',
  SettingsQuickbooksOnline = 'SETTINGS_QUICKBOOKS_ONLINE',
  SettingsRoles = 'SETTINGS_ROLES',
  SettingsSamsara = 'SETTINGS_SAMSARA',
  SettingsSmc3 = 'SETTINGS_SMC3',
  SettingsTags = 'SETTINGS_TAGS',
  T2TPeerCompanies = 'T2T_PEER_COMPANIES',
  UnpostInvoices = 'UNPOST_INVOICES',
  ViewAllScannedDocuments = 'VIEW_ALL_SCANNED_DOCUMENTS',
  Warehouses = 'WAREHOUSES'
}

export type PersonEntity = {
  __typename?: 'PersonEntity';
  defaultDeliveryAddress?: Maybe<AddressEntity>;
  defaultForContactStations?: Maybe<Array<ContactStationEntity>>;
  defaultPickupAddress?: Maybe<AddressEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultVehicleType?: Maybe<VehicleTypeEntity>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  status: PersonStatus;
};

export enum PersonStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type PickQuoteCustomerInput = {
  contactUuid: Scalars['String']['input'];
  orderQuoteUuid: Scalars['String']['input'];
};

export type PickQuoteCustomerOutput = MutationErrorOutput | PickQuoteCustomerSuccessOutput;

export type PickQuoteCustomerSuccessOutput = {
  __typename?: 'PickQuoteCustomerSuccessOutput';
  /** The quote after the draft was created and priced */
  orderQuote: OrderQuote;
};

export type PickStorageUnitInput = {
  /** The number of inventory items to pick in that storage unit  */
  quantity: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type PickStorageUnitOutput = {
  __typename?: 'PickStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export enum PickedStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type PicklistConnection = {
  __typename?: 'PicklistConnection';
  edges: Array<PicklistEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PicklistEdge = {
  __typename?: 'PicklistEdge';
  cursor: Scalars['String']['output'];
  node: PicklistEntity;
};

export type PicklistEntity = {
  __typename?: 'PicklistEntity';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  outboundReferenceNumber?: Maybe<Scalars['String']['output']>;
  picklistItemGroups: Array<PicklistItemGroupEntity>;
  updatedAt: Scalars['DateTime']['output'];
};


export type PicklistEntityPicklistItemGroupsArgs = {
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Mapping that specifies which ItemGroups are on a Picklist */
export type PicklistItemGroupEntity = {
  __typename?: 'PicklistItemGroupEntity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  itemGroup: ItemGroupEntity;
  pickedQuantity: Scalars['Int']['output'];
  pickedStatus: PickedStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PicklistsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** UUID of company to filter by */
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  /** UUID of contact to filter by */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** UUID of warehouse to filter by */
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum PickupOrDelivery {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY',
  Transfer = 'TRANSFER'
}

/** DRY_RUN plans the backfill without writing; EXECUTE plans and applies it. */
export enum PieceBackfillRunMode {
  DryRun = 'DRY_RUN',
  Execute = 'EXECUTE'
}

/** Lifecycle of a backfill run: PENDING once enqueued, RUNNING while the worker holds it, then COMPLETED or FAILED. */
export enum PieceBackfillRunStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type PieceBackfillRunView = {
  __typename?: 'PieceBackfillRunView';
  companyUuid: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  joinsCreated: Scalars['Int']['output'];
  mode: PieceBackfillRunMode;
  packagesProcessed: Scalars['Int']['output'];
  packagesSkipped: Scalars['Int']['output'];
  packagesTotal: Scalars['Int']['output'];
  params: Scalars['JSON']['output'];
  piecesCreated: Scalars['Int']['output'];
  piecesUpdated: Scalars['Int']['output'];
  report?: Maybe<Scalars['JSON']['output']>;
  requestedByEmail: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: PieceBackfillRunStatus;
  uuid: Scalars['String']['output'];
};

export type PieceBackfillRunsInput = {
  companyUuid: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PieceBackfillSurvey = {
  __typename?: 'PieceBackfillSurvey';
  billingParties: Array<PieceBackfillSurveyRow>;
  companyUuid: Scalars['String']['output'];
  cutoffDate: Scalars['DateTime']['output'];
  totalExistingPieceCount: Scalars['Int']['output'];
  totalMissingPieceCount: Scalars['Int']['output'];
  totalPackageCount: Scalars['Int']['output'];
  totalPackageQuantity: Scalars['Int']['output'];
};

export type PieceBackfillSurveyInput = {
  companyUuid: Scalars['String']['input'];
  cutoffDate: Scalars['DateTime']['input'];
};

export type PieceBackfillSurveyRow = {
  __typename?: 'PieceBackfillSurveyRow';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  existingPieceCount: Scalars['Int']['output'];
  missingPieceCount: Scalars['Int']['output'];
  packageCount: Scalars['Int']['output'];
  totalPackageQuantity: Scalars['Int']['output'];
};

export type PieceBaselineInput = {
  /** The package the form loaded this piece on, as a top-level piece. */
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  /** The bundle the form loaded this piece in, as a child. */
  parentPieceUuid?: InputMaybe<Scalars['String']['input']>;
};

export enum PieceBucketKey {
  Delivered = 'DELIVERED',
  Discarded = 'DISCARDED',
  Inbound = 'INBOUND',
  Inventory = 'INVENTORY',
  InTransit = 'IN_TRANSIT'
}

export type PieceBucketMetric = {
  __typename?: 'PieceBucketMetric';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  unit: PieceBucketMetricUnit;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum PieceBucketMetricUnit {
  Count = 'COUNT',
  DurationDays = 'DURATION_DAYS',
  Percent = 'PERCENT',
  Weight = 'WEIGHT'
}

export type PieceBucketMetricsInput = {
  bucket: PieceBucketKey;
  searchText?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<PieceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PieceBucketMetricsOutput = {
  __typename?: 'PieceBucketMetricsOutput';
  metrics: Array<PieceBucketMetric>;
};

export type PieceConnection = {
  __typename?: 'PieceConnection';
  edges: Array<PieceEdge>;
  pageInfo: PageInfo;
  /** Total count matching the filter; request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PieceCountSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum PieceDimsSyncAction {
  SplitToNewPackage = 'SPLIT_TO_NEW_PACKAGE',
  UpdateAllPieces = 'UPDATE_ALL_PIECES',
  UpdatePackageOnly = 'UPDATE_PACKAGE_ONLY'
}

export type PieceEdge = {
  __typename?: 'PieceEdge';
  cursor: Scalars['String']['output'];
  node: PieceListEntity;
};

export type PieceEntity = {
  __typename?: 'PieceEntity';
  additionalReferenceNumbers: Array<Scalars['String']['output']>;
  children: Array<PieceEntity>;
  /** Customer named when the piece was received without an order, kept as the arrival record even after the piece is linked. This is not the effective customer: once the piece has an order, that order's billing party is. Null when the piece did not arrive through orderless inbound, or arrived with no customer identified. */
  contact?: Maybe<ContactEntity>;
  createdAt: Scalars['DateTime']['output'];
  /** The customer the piece is shown under: the billing party of the order that owns it, or, for freight received without an order, the customer named at receipt. Null when neither is known — the case the pieces grid flags as "Unknown customer". */
  customer?: Maybe<ContactEntity>;
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  damagedNote?: Maybe<Scalars['String']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  dimWeight?: Maybe<Scalars['Float']['output']>;
  discardedAt?: Maybe<Scalars['DateTime']['output']>;
  discardedReason?: Maybe<Scalars['String']['output']>;
  documents: Array<DocumentEntity>;
  firstOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  /** HAWB of the order that owns the piece (its direct order, else the order owning its package): the house air waybill number when set, otherwise the shipper BOL (the order form's HAWB field). Null when the piece has no order or both are blank. */
  hawb?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  isUnalertedFreight: Scalars['Boolean']['output'];
  length?: Maybe<Scalars['Float']['output']>;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  measurementUnits?: Maybe<MeasurementUnits>;
  name: Scalars['String']['output'];
  /** @deprecated Use packageHasPieces to resolve orders for a piece */
  order?: Maybe<OrderEntity>;
  package?: Maybe<PackageEntity>;
  /** All PackageHasPiece links for the piece. */
  packageHasPieces?: Maybe<Array<PackageHasPieceEntity>>;
  packedPieceCount: Scalars['Int']['output'];
  pickedUpAt?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  status: PieceStatus;
  terminal?: Maybe<TerminalEntity>;
  type?: Maybe<PackageType>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse?: Maybe<WarehouseEntity>;
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<WeightUnits>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum PieceFillIfEmptyField {
  Height = 'HEIGHT',
  Length = 'LENGTH',
  MeasurementUnits = 'MEASUREMENT_UNITS',
  Type = 'TYPE',
  Weight = 'WEIGHT',
  WeightUnits = 'WEIGHT_UNITS',
  Width = 'WIDTH'
}

export type PieceGroupEntity = {
  __typename?: 'PieceGroupEntity';
  pieceCount: Scalars['Int']['output'];
  pieces: Array<PieceEntity>;
  status: PieceStatus;
  /** Terminal where the pieces are located. This field is only populated when all pieces have arrived or departed from a terminal on a line haul lane. It is null if the status is awaiting or delivered, or if the order is not on a line haul lane. */
  terminal?: Maybe<TerminalEntity>;
};

export type PieceListEntity = {
  __typename?: 'PieceListEntity';
  carrier?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  damagedNote?: Maybe<Scalars['String']['output']>;
  daysOverDwellThreshold?: Maybe<Scalars['Int']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  departedAt?: Maybe<Scalars['DateTime']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  discardedAt?: Maybe<Scalars['DateTime']['output']>;
  discardedByName?: Maybe<Scalars['String']['output']>;
  discardedReason?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  dwellStatus?: Maybe<DwellStatus>;
  effectiveDwellThresholdDays?: Maybe<Scalars['Int']['output']>;
  eta?: Maybe<Scalars['DateTime']['output']>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  hawb?: Maybe<Scalars['String']['output']>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  isUnalertedFreight: Scalars['Boolean']['output'];
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  mawb?: Maybe<Scalars['String']['output']>;
  orderName?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  packageOrderName?: Maybe<Scalars['String']['output']>;
  packageOrderUuid?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['String']['output']>;
  packedPieceCount: Scalars['Int']['output'];
  podSignedBy?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  status: PieceStatus;
  terminalName?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  totalPieces?: Maybe<Scalars['Int']['output']>;
  truckName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  warehouseLocationName?: Maybe<Scalars['String']['output']>;
  warehouseLocationUuid?: Maybe<Scalars['String']['output']>;
  warehouseName?: Maybe<Scalars['String']['output']>;
  warehouseUuid?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightUnits?: Maybe<WeightUnits>;
};

export type PieceReceiptConnection = {
  __typename?: 'PieceReceiptConnection';
  edges: Array<PieceReceiptEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PieceReceiptEdge = {
  __typename?: 'PieceReceiptEdge';
  cursor: Scalars['String']['output'];
  node: PieceReceiptEntity;
};

export type PieceReceiptEntity = {
  __typename?: 'PieceReceiptEntity';
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  billOfLadingNumber?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  consigneeName?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  expectedAt?: Maybe<Scalars['DateTime']['output']>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pickupDate?: Maybe<Scalars['DateTime']['output']>;
  pieces: Array<PieceEntity>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
  sealNumber?: Maybe<Scalars['String']['output']>;
  source: PieceReceiptSource;
  supplierCompanyName?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trailerNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
};

export type PieceReceiptExistingPieceInput = {
  /** UUID of the existing piece to add to the receipt */
  pieceUuid: Scalars['String']['input'];
  /** Optional warehouse location to move the piece to */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PieceReceiptNewPieceInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  /** Number of identical pieces to create. Defaults to 1. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Reference number / barcode for the new piece(s) */
  referenceNumber: Scalars['String']['input'];
  /** Package kind for the piece (box, pallet, etc.). Optional and independent of whether the piece holds nested children. */
  type?: InputMaybe<PackageType>;
  /** Client-minted piece UUID used as an idempotency key; honored only when quantity is 1. */
  uuid?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the warehouse location the piece(s) are received into. Optional; a piece may be received without a location set. */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export enum PieceReceiptSource {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type PieceScanCustomerRowEntity = {
  __typename?: 'PieceScanCustomerRowEntity';
  customerName: Scalars['String']['output'];
  customerUuid: Scalars['String']['output'];
  piecesDeliveredCount: Scalars['Int']['output'];
  piecesUnscannedCount: Scalars['Int']['output'];
  scanRatePct?: Maybe<Scalars['Float']['output']>;
};

export type PieceScanGroupRowEntity = {
  __typename?: 'PieceScanGroupRowEntity';
  name?: Maybe<Scalars['String']['output']>;
  piecesDeliveredCount: Scalars['Int']['output'];
  piecesUnscannedCount: Scalars['Int']['output'];
  scanRatePct?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type PieceScanKpiEntity = {
  __typename?: 'PieceScanKpiEntity';
  bucketUnit: KpiTrendBucketUnit;
  customers: Array<PieceScanCustomerRowEntity>;
  drivers: Array<PieceScanGroupRowEntity>;
  piecesDeliveredCount: Scalars['Int']['output'];
  piecesDeliveredWithScanCount: Scalars['Int']['output'];
  piecesUnscannedCount: Scalars['Int']['output'];
  scanRatePct?: Maybe<Scalars['Float']['output']>;
  terminals: Array<PieceScanGroupRowEntity>;
  trend: Array<PieceScanTrendBucketEntity>;
};

export type PieceScanTrendBucketEntity = {
  __typename?: 'PieceScanTrendBucketEntity';
  bucketDate: Scalars['String']['output'];
  piecesDeliveredCount: Scalars['Int']['output'];
  piecesDeliveredWithScanCount: Scalars['Int']['output'];
  scanRatePct?: Maybe<Scalars['Float']['output']>;
};

export enum PieceStatus {
  Arrived = 'ARRIVED',
  ArrivedAtDestination = 'ARRIVED_AT_DESTINATION',
  Awaiting = 'AWAITING',
  Delivered = 'DELIVERED',
  Departed = 'DEPARTED',
  Loaded = 'LOADED',
  PickedUp = 'PICKED_UP',
  Planned = 'PLANNED'
}

export type PieceStatusTerminalCount = {
  __typename?: 'PieceStatusTerminalCount';
  pieceCount: Scalars['Int']['output'];
  status: PieceStatus;
  terminalCode: Scalars['String']['output'];
};

export type PiecesAwayFromRunOrigin = {
  __typename?: 'PiecesAwayFromRunOrigin';
  awayFromOriginPieceCount: Scalars['Int']['output'];
  runOriginTerminalCode: Scalars['String']['output'];
  terminalCounts: Array<TerminalPieceCount>;
  totalPieceCount: Scalars['Int']['output'];
  unaccountedPieceCount: Scalars['Int']['output'];
};

export type PiecesDeliveredEntity = {
  __typename?: 'PiecesDeliveredEntity';
  deliveryScansCount: Scalars['Int']['output'];
};

export type PiecesGroupedByStatusInput = {
  orderUuid: Scalars['String']['input'];
};

export type PiecesGroupedByStatusOutput = {
  __typename?: 'PiecesGroupedByStatusOutput';
  pieceGroups: Array<PieceGroupEntity>;
};

export type PiecesPickedUpEntity = {
  __typename?: 'PiecesPickedUpEntity';
  pickupScansCount: Scalars['Int']['output'];
};

export type PlaceCreateInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes: Scalars['String']['input'];
};

export type PlaceEntity = {
  __typename?: 'PlaceEntity';
  address: AddressEntity;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  notes: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type PlaceUpdateInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** A calendar date without a time zone. See https://tc39.es/proposal-temporal/docs/plaindate.html */
export type PlainDate = {
  __typename?: 'PlainDate';
  /** A day of the month, from 1 through 31. */
  day: Scalars['Int']['output'];
  /** The plain date in ISO 8601 format. */
  iso8601: Scalars['String']['output'];
  /** A month number, from 1 through 12. 1 is January. */
  month: Scalars['Int']['output'];
  /** The year of the date */
  year: Scalars['Int']['output'];
};

export type PlainDateInput = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type PlainDateTime = {
  __typename?: 'PlainDateTime';
  date: PlainDate;
  time: PlainTime;
};

export type PlainDateTimeInput = {
  date: PlainDateInput;
  time: PlainTimeInput;
};

export type PlainTime = {
  __typename?: 'PlainTime';
  /** A 24-hour clock hour, from 0 through 23 */
  hour: Scalars['Int']['output'];
  /** A minute, from 0 through 59 */
  minute: Scalars['Int']['output'];
};

export type PlainTimeInput = {
  hour: Scalars['Int']['input'];
  minute: Scalars['Int']['input'];
};

export type PlanOutboundBenchRunInput = {
  companyActors?: InputMaybe<Array<BenchCompanyActorInput>>;
  /** An active driver of the orders' company. ROUTE_STOP assigns the route it creates to this driver; without one, ROUTE_STOP and START_ROUTE block. */
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  integrationType: BenchIntegrationType;
  selection: BenchOrderSelectionInput;
  /** Send the 990 ACCEPTED for an order that arrived live. A live order has no draft to approve, so ACCEPT_TENDER sends the 990 itself, once, when the partnership does not auto-accept. Omitted or false leaves live orders without a 990. */
  send990ForLiveOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Steps to leave out of this run. The plan reports them SKIPPED, and the run moves on to the next step. Empty or omitted runs every step. */
  skippedSteps?: InputMaybe<Array<BenchStepSelectorInput>>;
};

export enum PodNamingConvention {
  Blume = 'BLUME',
  Btx = 'BTX',
  Data_2Logistics = 'DATA_2_LOGISTICS',
  Flexport = 'FLEXPORT',
  ForwardAirTiff = 'FORWARD_AIR_TIFF',
  SimpleTiff = 'SIMPLE_TIFF',
  SimpleTiffMawb = 'SIMPLE_TIFF_MAWB',
  Stg = 'STG'
}

/** One band of a point-to-point lane: a range row of the lane tariff. A lane may hold fewer bands than its group, so match bands to group ceilings by lessThanOrEqualToValue. */
export type PointToPointLaneBand = {
  __typename?: 'PointToPointLaneBand';
  /** Same as TariffRangeEntity */
  lessThanOrEqualToValue: Scalars['Int']['output'];
  /** Rate in USD cents, same unit as TariffRangeEntity.rateUsdCents. The editor saves a blank cell as 0. */
  rateUsdCents: Scalars['Float']['output'];
};

export type PointToPointLaneBandInput = {
  /** Same as TariffRangeEntity */
  lessThanOrEqualToValue: Scalars['Int']['input'];
  /** Rate in USD cents, same unit as TariffRangeEntity */
  rateUsdCents: Scalars['Float']['input'];
};

export type PointToPointLaneConnection = {
  __typename?: 'PointToPointLaneConnection';
  edges: Array<PointToPointLaneEdge>;
  pageInfo: PageInfo;
  /** Lanes in the group across all pages */
  totalCount: Scalars['Int']['output'];
};

export type PointToPointLaneEdge = {
  __typename?: 'PointToPointLaneEdge';
  cursor: Scalars['String']['output'];
  node: PointToPointLaneEntity;
};

/** One lane of a point-to-point tariff group, flattened for the lane editor. Units match TariffEntity and TariffRangeEntity. */
export type PointToPointLaneEntity = {
  __typename?: 'PointToPointLaneEntity';
  /** The lane range rows, in ascending ceiling order */
  bands: Array<PointToPointLaneBand>;
  /** Origin zone. Null for a legacy lane whose zone is not a zone pair. */
  inboundZoneUuid?: Maybe<Scalars['String']['output']>;
  /** False when the lane is disabled: it keeps its rates, rating never selects it, and the order falls through to the next tariff group in the chain. */
  isActive: Scalars['Boolean']['output'];
  /** Maximum amount assessed, in USD cents */
  maximumUsdCents?: Maybe<Scalars['Int']['output']>;
  /** Minimum amount assessed, in USD cents */
  minimumUsdCents?: Maybe<Scalars['Int']['output']>;
  /** Destination zone. Null for a legacy lane whose zone is not a zone pair. */
  outboundZoneUuid?: Maybe<Scalars['String']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  tariffOverageRates: Array<TariffOverageRateEntity>;
  tariffUuid: Scalars['String']['output'];
  /** The tariff's updatedAt. A lane save sends it back so the server can refuse a write over a newer change. */
  version: Scalars['DateTime']['output'];
};

export type PointToPointLaneInput = {
  /** The lane's bands, lowest ceiling first. Replaces every stored band. */
  bands: Array<PointToPointLaneBandInput>;
  /** Origin zone, a zone group member */
  inboundZoneUuid: Scalars['String']['input'];
  /** False disables the lane: it keeps its rates and never rates */
  isActive: Scalars['Boolean']['input'];
  /** USD cents */
  maximumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  /** USD cents */
  minimumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  /** Destination zone, a zone group member */
  outboundZoneUuid: Scalars['String']['input'];
  /** Replaces the lane overage rates. Omit or send null to keep the stored ones; a new lane then gets none. */
  overageRates?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  /** The saved lane tariff, from pointToPointLanes. Omit, with version, for a lane the group does not price yet. */
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
  /** The version pointToPointLanes returned for tariffUuid. The save refuses the lane when the tariff changed since. */
  version?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PointToPointLaneRemovalInput = {
  tariffUuid: Scalars['String']['input'];
  /** The version pointToPointLanes returned for tariffUuid */
  version: Scalars['DateTime']['input'];
};

export type PopulationCriteriaInput = {
  dueDateSource?: InputMaybe<RouteAutomationDueDateSource>;
  /** Override list of Tag uuids a stop must NOT carry. Empty array means "no exclude filter". */
  excludeTagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Override list of Tag uuids a stop must carry. Empty array means "no include filter". */
  includeTagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupOrDelivery?: InputMaybe<RouteAutomationDirection>;
  /** Override list of Service uuids that qualify. Empty array means "match all services" for this run. */
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PostalResultEntity = {
  __typename?: 'PostalResultEntity';
  component: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Represents an order with a discrepancy between posted and current amounts */
export type PostedVsActualDiscrepancyEntity = {
  __typename?: 'PostedVsActualDiscrepancyEntity';
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  currentAmountCents?: Maybe<Scalars['Float']['output']>;
  customerName: Scalars['String']['output'];
  customerReferenceNumber?: Maybe<Scalars['String']['output']>;
  discrepancyCents: Scalars['Float']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceJournalNumber?: Maybe<Scalars['Float']['output']>;
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  orderName: Scalars['String']['output'];
  orderUuid: Scalars['String']['output'];
  postedAmountCents?: Maybe<Scalars['Float']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PreSignedPutUrlEntity = {
  __typename?: 'PreSignedPutUrlEntity';
  bucket: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filetype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PreSignedUrlRequestInput = {
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
};

export type PrefillBillingPartyCandidateEntity = {
  __typename?: 'PrefillBillingPartyCandidateEntity';
  displayName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type PrefillInspectionEntity = {
  __typename?: 'PrefillInspectionEntity';
  candidates: Array<PrefillBillingPartyCandidateEntity>;
  conditionalService?: Maybe<ConditionalServiceExplainEntity>;
  senderBillingParty?: Maybe<SenderBillingPartyExplainEntity>;
};

export type PrefillInspectionOutput = PrefillInspectionEntity | QueryErrorOutput;

export type PreviewAddOrdersToInvoicesForContactOutput = {
  __typename?: 'PreviewAddOrdersToInvoicesForContactOutput';
  contactName: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  existingInvoicesToUpdate: Array<ExistingInvoiceToUpdate>;
  newInvoicesToCreate: Array<NewInvoiceToCreate>;
};

export type PreviewAddOrdersToInvoicesInput = {
  addToExistingInvoices: Scalars['Boolean']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type PreviewAddOrdersToInvoicesOutput = {
  __typename?: 'PreviewAddOrdersToInvoicesOutput';
  invoicesToAddToByContact: Array<PreviewAddOrdersToInvoicesForContactOutput>;
};

export type PreviewInventoryCountScopeInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to on-hand pieces with a warehouse but no warehouse location assigned. */
  noLocationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to on-dock pieces flagged overdue by dwell time. */
  overdueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Piece statuses in scope. Defaults to the web Inventory bucket (ARRIVED, PLANNED) when omitted. */
  statuses?: InputMaybe<Array<PieceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to pieces not associated to any order. */
  unassociatedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PreviewInventoryCountScopeOutput = {
  __typename?: 'PreviewInventoryCountScopeOutput';
  cap: Scalars['Int']['output'];
  isOverCap: Scalars['Boolean']['output'];
  pieceCount: Scalars['Int']['output'];
};

export type PreviewLineHaulReroutesInput = {
  routes: Array<AssignLineHaulRouteInput>;
};

export type PreviewParseCsvOrdersInput = {
  bucket: Scalars['String']['input'];
  csvOrderMappingUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type PreviewParseCsvOrdersOutput = PreviewParseCsvOrdersSuccessOutput | QueryErrorOutput;

export type PreviewParseCsvOrdersSuccessOutput = {
  __typename?: 'PreviewParseCsvOrdersSuccessOutput';
  errors: Array<ParseCsvOrderRowErrorEntity>;
  parsedOrders: Array<ParsedCsvOrderEntity>;
};

export type PreviewProratedConsolidationInput = {
  shipmentUuids: Array<Scalars['String']['input']>;
};

/** the output of the API is a list of orders along with information about charges after prorating */
export type PreviewProratedConsolidationOutput = {
  __typename?: 'PreviewProratedConsolidationOutput';
  proratedOrders: Array<ProratedOrderInformation>;
};

export type PreviewProratedConsolidationV2Input = {
  consolidationMethod?: InputMaybe<OrderConsolidationMethod>;
  ordersToConsolidateWithUuids: Array<Scalars['String']['input']>;
  primaryOrderUuid: Scalars['String']['input'];
  shouldProrateInbound: Scalars['Boolean']['input'];
  shouldProrateOutbound: Scalars['Boolean']['input'];
};

export type PreviewProratedConsolidationV2Output = PreviewProratedConsolidationV2SuccessOutput | QueryErrorOutput;

export type PreviewProratedConsolidationV2SuccessOutput = {
  __typename?: 'PreviewProratedConsolidationV2SuccessOutput';
  consolidationMethod: OrderConsolidationMethod;
  proratedOrders: Array<ProratedOrder>;
  proratedOverview: ProratedOverview;
  totalAfterProrating: Scalars['Float']['output'];
  /** The sum of the weights of the orders that were consolidated */
  totalWeightConsolidated: Scalars['Float']['output'];
};

export type PreviousManifestError = {
  __typename?: 'PreviousManifestError';
  manifest: LineHaulManifestEntity;
  order: OrderEntity;
};

export enum ProductionCompany {
  Intellifreight = 'INTELLIFREIGHT',
  WiseChoice = 'WISE_CHOICE'
}

/** Driver standing relative to the P&D time-allowance thresholds used by the Intelligence Board. */
export enum ProductivityStatus {
  Efficient = 'EFFICIENT',
  Inefficient = 'INEFFICIENT',
  Moderate = 'MODERATE'
}

export type ProductivityTimeAllowanceEntity = {
  __typename?: 'ProductivityTimeAllowanceEntity';
  minutesPerHundredweight: Scalars['Float']['output'];
  minutesPerMile: Scalars['Float']['output'];
  minutesPerPiece: Scalars['Float']['output'];
  minutesPerStop: Scalars['Float']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ProfitabilityCostAssumptionEntity = {
  __typename?: 'ProfitabilityCostAssumptionEntity';
  monthlyFixedCostUsd: Scalars['Float']['output'];
  monthlyOverheadCostUsd: Scalars['Float']['output'];
  variableCostPerHundredweightUsd: Scalars['Float']['output'];
  variableCostPerMileUsd: Scalars['Float']['output'];
  variableCostPerShipmentUsd: Scalars['Float']['output'];
};

/** Customer standing relative to the contribution-ratio thresholds used by the Intelligence Board. */
export enum ProfitabilityStatus {
  BelowVariableCost = 'BELOW_VARIABLE_COST',
  Contributing = 'CONTRIBUTING',
  Profitable = 'PROFITABLE'
}

export type ProposedRouteSequence = {
  __typename?: 'ProposedRouteSequence';
  lateStops?: Maybe<Array<LateStop>>;
  routeUuid: Scalars['String']['output'];
  stopOrder: Array<Scalars['String']['output']>;
};

export type ProposedRouteSequenceInput = {
  routeUuid: Scalars['String']['input'];
  stopOrder: Array<Scalars['String']['input']>;
};

export type ProrateOrdersInput = {
  consolidationMethod?: InputMaybe<OrderConsolidationMethod>;
  ordersToConsolidateWithUuids: Array<Scalars['String']['input']>;
  primaryOrderUuid: Scalars['String']['input'];
  shouldProrateInbound: Scalars['Boolean']['input'];
  shouldProrateOutbound: Scalars['Boolean']['input'];
};

export type ProrateOrdersOutput = MutationErrorOutput | ProrateOrdersSuccessOutput;

export type ProrateOrdersSuccessOutput = {
  __typename?: 'ProrateOrdersSuccessOutput';
  orderUuids: Array<Scalars['String']['output']>;
};

/** the custom charge amount before and after prorating along with which orders the custom charge was present in before prorating (since after prorating it is split across orders) */
export type ProratedCustomCharge = {
  __typename?: 'ProratedCustomCharge';
  accessorialUuid?: Maybe<Scalars['String']['output']>;
  /** before prorating, which orders was this custom charge in. This helps us tell whether it was split or combined and split. */
  initialOrderUuidsPresentIn: Array<Scalars['String']['output']>;
  initialTotalCents?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  proratedTotalCents: Scalars['Float']['output'];
};

/** the custom charge amount before and after prorating along with which orders the custom charge was present in before prorating (since after prorating it is split across orders) */
export type ProratedCustomChargeV2 = {
  __typename?: 'ProratedCustomChargeV2';
  /** the total of the custom charge before prorating. It is null if this custom charge was not on this order before. */
  initialTotal?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  proratedTotal: Scalars['Float']['output'];
};

export type ProratedOrder = {
  __typename?: 'ProratedOrder';
  hawb?: Maybe<Scalars['String']['output']>;
  inboundShipment?: Maybe<ProratedShipment>;
  /** The initial line haul charges before prorating. It can just be a number because we are not prorating line haul yet */
  lineHaulInitialTotal?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** The initial order charges before prorating. It can just be a number because we are not prorating order charges yet */
  orderChargesInitialTotal?: Maybe<Scalars['Float']['output']>;
  outboundShipment?: Maybe<ProratedShipment>;
  proportionForConsolidation?: Maybe<Scalars['Float']['output']>;
  /** @deprecated This field is deprecated as we are introducing proportions for consolidation besides weight. Use proportionForConsolidation instead.  */
  proportionOfTotalWeight: Scalars['Float']['output'];
  /** The total after prorating including shipments that were not prorated */
  totalAfterProrating: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  /** The weight of the order */
  weight: Scalars['Float']['output'];
};

export type ProratedOrderInformation = {
  __typename?: 'ProratedOrderInformation';
  inboundShipment?: Maybe<ProratedShipmentInformation>;
  order: OrderEntity;
  outboundShipment?: Maybe<ProratedShipmentInformation>;
};

export type ProratedOverview = {
  __typename?: 'ProratedOverview';
  customCharges?: Maybe<Array<SimpleCustomCharge>>;
  inboundFreightCharge?: Maybe<SimpleFreightCharge>;
  inboundFuelCharge?: Maybe<SimpleFuelCharge>;
  outboundFreightCharge?: Maybe<SimpleFreightCharge>;
  outboundFuelCharge?: Maybe<SimpleFuelCharge>;
};

export type ProratedShipment = {
  __typename?: 'ProratedShipment';
  customCharges: Array<ProratedCustomChargeV2>;
  /** The total of the freight charge in dollars before prorating. If it is null, the shipment did not have a freight charge */
  initialFreightChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** The total of the fuel charge in dollars before prorating. If it is null, the shipment did not have a fuel charge */
  initialFuelChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** The total of the freight charge in dollars after prorating. If the shipment is not prorated this will equal the initial total */
  proratedFreightChargeTotal?: Maybe<Scalars['Float']['output']>;
  /** The total of the fuel charge in dollars after prorating. If the shipment is not prorated this will equal the initial total */
  proratedFuelChargeTotal?: Maybe<Scalars['Float']['output']>;
};

export type ProratedShipmentInformation = {
  __typename?: 'ProratedShipmentInformation';
  customCharges: Array<ProratedCustomCharge>;
  freightAndFuelProrateMultiplier: Scalars['Float']['output'];
  initialFreightCharge?: Maybe<FreightChargeForProrating>;
  initialFuelCharge?: Maybe<FuelChargeForProrating>;
  isProrated: Scalars['Boolean']['output'];
  proratedFreightCharge?: Maybe<FreightChargeForProrating>;
  proratedFuelCharge?: Maybe<FuelChargeForProrating>;
  shipment: ShipmentEntity;
};

export type ProvenanceBboxEntity = {
  __typename?: 'ProvenanceBboxEntity';
  h: Scalars['Float']['output'];
  l: Scalars['Float']['output'];
  t: Scalars['Float']['output'];
  w: Scalars['Float']['output'];
};

export type ProvenanceFieldEntity = {
  __typename?: 'ProvenanceFieldEntity';
  confidence?: Maybe<Scalars['Float']['output']>;
  contributingNeighbors: Array<Scalars['String']['output']>;
  contributingNotes: Array<Scalars['String']['output']>;
  derivationTag?: Maybe<Scalars['String']['output']>;
  fieldKey: Scalars['String']['output'];
  fieldStatus: Scalars['String']['output'];
  pageHash?: Maybe<Scalars['String']['output']>;
  sourceBboxes: Array<ProvenanceBboxEntity>;
  sourceKind?: Maybe<Scalars['String']['output']>;
  sourcePage?: Maybe<Scalars['Int']['output']>;
  sourceS3Key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProvenanceNeighborEntity = {
  __typename?: 'ProvenanceNeighborEntity';
  companyUuid: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  extractionRunId?: Maybe<Scalars['String']['output']>;
  fields: Array<ProvenanceFieldEntity>;
  modelVersion?: Maybe<Scalars['String']['output']>;
  taxonomyVersion?: Maybe<Scalars['String']['output']>;
};

export type PublishOrganizationMessageInput = {
  /** Required as "SEND" when the message addresses every company. */
  confirmation?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum QboSyncElement {
  Account = 'ACCOUNT',
  Connection = 'CONNECTION',
  Currency = 'CURRENCY',
  Customer = 'CUSTOMER',
  Invoice = 'INVOICE',
  Item = 'ITEM',
  Tax = 'TAX',
  Terms = 'TERMS'
}

export enum QboSyncFixLocation {
  Either = 'EITHER',
  NoneRetry = 'NONE_RETRY',
  Quickbooks = 'QUICKBOOKS',
  Support = 'SUPPORT',
  Tenet = 'TENET'
}

export enum QboSyncNoticeKind {
  BillWithParent = 'BILL_WITH_PARENT',
  CreatedCustomer = 'CREATED_CUSTOMER',
  CreatedItem = 'CREATED_ITEM',
  MatchedByNormalizedName = 'MATCHED_BY_NORMALIZED_NAME',
  NearDuplicateCustomer = 'NEAR_DUPLICATE_CUSTOMER',
  RelinkedCustomer = 'RELINKED_CUSTOMER',
  UpdatedExistingInvoice = 'UPDATED_EXISTING_INVOICE'
}

export type Query = {
  __typename?: 'Query';
  ablyToken: AblyTokenOutput;
  accessorial: AccessorialUnion;
  accessorialChargeDetailsReport: Array<AccessorialChargeDetailsEntity>;
  accessorialDateRangeConfigByUuid: AccessorialDateRangeConfigEntity;
  accessorialDateRangeConfigs: FindAccessorialDateRangeConfigsOutput;
  accessorialGroup: AccessorialGroupEntity;
  accessorialGroups: Array<AccessorialGroupEntity>;
  accessorialToQuickbooksMappingByContact: Array<AccessorialToQuickbooksMappingEntity>;
  accessorials: Array<AccessorialUnion>;
  accessorialsByBillingContact: Array<AccessorialUnion>;
  accountingReportFilters: AccountingReportFiltersOutput;
  accountsReceivableReport: Array<AccountsReceivableReportDataForContactEntity>;
  activeAgents: Array<AgentFieldsEntity>;
  activeOrganizationMessageBanners: OrganizationMessageBannersEntity;
  adhocPreviewBatch: AdhocPreviewBatchEntity;
  adhocPreviewResult: AdhocPreviewResultEntity;
  adhocPreviewWordBoxes: DocExtractionEvalDocumentWordBoxesEntity;
  agingReport: Array<AgingReportForContactEntity>;
  agingReportPdf: AgingReportFileOutput;
  airportInfo: AirportInfoEntity;
  airportInfos: Array<AirportInfoEntity>;
  allScannedDocuments: Array<Scalars['String']['output']>;
  apiKeyAdminEventTypeCatalog: Array<ApiKeyAdminEventTypeCatalogShapeEntity>;
  apiKeyAdminExamplePayload: Scalars['String']['output'];
  apiKeyAdminExportCsv: Scalars['String']['output'];
  apiKeyAdminGet: ApiKeyAdminDetailEntity;
  apiKeyAdminList: ApiKeyAdminListResult;
  apiKeyAdminPreviewMapping: Scalars['String']['output'];
  apiKeyAdminSearchOrganizations: Array<ApiKeyAdminOrgSearchResult>;
  apiKeyAdminStatusMappings: Array<ApiKeyAdminStatusMappingEntity>;
  apiKeyAdminWebhookShapeConfig?: Maybe<ApiKeyAdminWebhookShapeConfigEntity>;
  apiLog: ApiLogEntity;
  apiLogs: ApiLogConnection;
  /** Public resolver to get appointment confirmation info for this stop */
  appointmentConfirmationInfo: AppointmentConfirmationInfoOutput;
  appointmentOptions: AppointmentOptions;
  /** One page of a stop appointment's status transitions, newest first. */
  appointmentStatusHistory: AppointmentStatusHistoryConnection;
  /** get stops, filtered by appointment time, for the appointment scheduling page */
  appointments: Array<StopEntity>;
  auditQuickbooksDesktopInvoiceTotals: Array<Scalars['String']['output']>;
  auditReport: Array<AuditReportBucketEntity>;
  auditShipmentOnInvoiceButOtherShipmentsNot?: Maybe<Scalars['String']['output']>;
  autoApplyAccessorialConfig?: Maybe<AutoApplyAccessorialConfigEntity>;
  autoApplyAccessorialConfigs?: Maybe<Array<AutoApplyAccessorialConfigEntity>>;
  availablePeerCompanies: Array<AvailablePeerCompanyEntity>;
  availablePiecesForLinking: AvailablePieceConnection;
  /** Bookable slots for an order, earliest first, capped at 50. An empty list is an ordinary answer, and is also what a delivery held until its order is marked on hand (requireOnHandBeforeSelfScheduling) returns. NOT PAGINATED: the date bounds move the window rather than resume one, so a service day the cap cut off part-way cannot be continued, only re-read with a larger first. */
  availableSchedulingSlotsForOrder: Array<AvailableSchedulingSlotEntity>;
  averageDaysToPayReport: Array<AverageDaysToPayForContactEntity>;
  billOfLadingPdfUrl?: Maybe<Scalars['String']['output']>;
  /** Appointment stops for one delivery day, grouped by the scheduling resource each belongs to. A live booking claim decides the resource; otherwise it is computed from area, eligibility, weekday and appointment hours. Read only: nothing is assigned to a route. */
  bookedStopsByResource: BookedStopsByResourceOutput;
  /** Progress of a bulk delegation batch of the caller company. */
  bulkDelegationBatch: BulkDelegationBatchEntity;
  businessDivisions: FindBusinessDivisionsOutput;
  businessKpiInvoicedOrders: KpiInvoicedOrderRecordsEntity;
  businessKpiOrders: KpiOrderRecordsEntity;
  businessKpiOrdersPerDriver: KpiDriverOrdersRecordsEntity;
  businessKpiPaidInvoices: KpiPaidInvoiceRecordsEntity;
  businessKpis: BusinessKpisEntity;
  calmCommitDatesByOrderUuids: Array<CalmOrderCommitEntity>;
  calmCrossdockInstructions: Array<CalmCrossdockInstructionEntity>;
  calmLineHaulOrdersToPlan: Array<CalmPlanOrderEntity>;
  calmLiveRuns: Array<CalmLiveRunEntity>;
  calmManifestLoadPackages: Array<CalmLoadPackageEntity>;
  calmManifestPlacements: Array<CalmLoadPlacementEntity>;
  calmManifestReadiness: Array<CalmManifestReadinessEntity>;
  calmManifestReschedulables: Array<CalmReschedulableEntity>;
  calmManifestSearch: Array<CalmManifestSearchResultEntity>;
  calmOrderCubeByOrderUuids: Array<CalmOrderCubeEntity>;
  calmOrderLineHaulRoute: Array<CalmOrderLegEntity>;
  calmOrderPackages: Array<CalmOrderPackageEntity>;
  calmOrderPackagesByOrderUuids: Array<CalmOrderPackagesEntity>;
  calmOrderPieces: Array<CalmOrderPieceEntity>;
  calmOrderSplitSummary: Array<CalmOrderSplitSummaryEntity>;
  calmOrderTags: Array<CalmOrderTagsEntity>;
  calmOrdersByHawb: CalmHawbSearchResultEntity;
  calmPndRouteLoad: CalmPndRouteLoadEntity;
  calmPreviewLineHaulReroutes: Array<CalmReroutePreviewEntity>;
  calmRunInboundPlan: Array<CalmRunInboundPlanEntity>;
  calmRunOnwardPlan: Array<CalmRunOnwardPlanEntity>;
  calmTerminalOnHand: Array<CalmOnHandPieceEntity>;
  calmTerminalPnd: Array<CalmPndRouteEntity>;
  chargeBreakdownReportCsv: ReportFileOutput;
  chargeBreakdownReportPdf: ChargeBreakdownReportPdfOutput;
  checkConsistencyOfInvoices: Array<Scalars['Boolean']['output']>;
  checkRegisterReport: Array<PaymentForCheckRegisterReportEntity>;
  /** Returns quotes for a client that belong to the specified company and meet the specified filter conditions. Used in the Pallet TMS quotes page. */
  clientQuotes: QuoteConnection;
  closestWarehouseToAddress?: Maybe<WarehouseEntity>;
  companies: Array<CompanyEntity>;
  company: CompanyEntity;
  companyByUuid?: Maybe<CompanyEntity>;
  companyConfiguration?: Maybe<CompanyConfigurationEntity>;
  companyConfigurationByCompanyUuid?: Maybe<CompanyConfigurationEntity>;
  companyConfigurationChanges: CompanyConfigurationChangeConnection;
  companyContacts: Array<ContactEntity>;
  companyDockDoors: Array<DockDoorEntity>;
  companyDocuments: Array<DocumentEntity>;
  companyPackageTypeConfigs: FindCompanyPackageTypeConfigsOutput;
  /** Calendar days the whole company is closed for scheduling, soonest first. Defaults to today onward, read in the company time zone. A day listed here closes every resource that runs on that weekday except the ones named in its exemptions, and composes with each resource own blocked days rather than replacing them. */
  companySchedulingBlockedDays: Array<SchedulingBlockedDayEntity>;
  companySchemas: Array<SchemaWithAnchorsEntity>;
  completedStopsNotOnRoutes: Array<StopEntity>;
  completionToPaymentReport: CompletionToPaymentReport;
  completionToPaymentReportCsv: ReportFileOutput;
  completionToPaymentSummary: CompletionToPaymentSummary;
  configMigrationCompanies: Array<MigratableCompanyObject>;
  configMigrationFeatureGroups: Array<ConfigMigrationFeatureGroup>;
  configMigrationStatus?: Maybe<ConfigMigrationStatusObject>;
  consigneePortalOrder: ConsigneePortalOrderEntity;
  contact: ContactEntity;
  contactChargeMatrixColumnMappings: Array<ContactChargeMatrixColumnMappingEntity>;
  contactCommunicationConfigs?: Maybe<Array<ContactCommunicationConfigEntity>>;
  contactEmails?: Maybe<Array<ContactEmailEntity>>;
  /** An unpaginated query for all items belonging to a contact. */
  contactItems: FindContactItemsOutput;
  contactOrderStatisticsForDateRange: ContactStatsEntity;
  contactPersons: Array<ContactPersonEntity>;
  contactServices: Array<ServiceEntity>;
  /** Get all stations for a specific contact */
  contactStations: Array<ContactStationEntity>;
  contacts: Array<ContactEntity>;
  contactsByUuids: Array<ContactEntity>;
  contactsReport: Array<ContactForContactReport>;
  coordinatesForAddress: CoordinatesForAddressEntity;
  costCenterStatementReport: CostCenterStatementReportEntity;
  costInputCatalogue: Array<CostInputDefinitionEntity>;
  costInputMonth: CostInputMonthEntity;
  costInputQuickbooksAccounts: Array<CostInputQuickbooksAccountEntity>;
  costInputStatus: CostInputStatusEntity;
  coverSheetDocumentTypeSequences: Array<CoverSheetDocumentTypeSequenceEntity>;
  creditTypes: Array<CreditTypeEntity>;
  csvOrderImportTransactions: CsvOrderImportTransactionEntity;
  csvOrderMapping: CsvOrderMappingEntity;
  csvOrderMappings: Array<CsvOrderMappingEntity>;
  currentBillingPeriodInvoice: Array<InvoiceEntity>;
  customDocumentNames: Array<CustomDocumentNameEntity>;
  customDriverForm?: Maybe<DriverSignableFormTemplateEntity>;
  customDriverForms?: Maybe<Array<DriverSignableFormTemplateEntity>>;
  /** What a customer scheduling link currently permits, plus the appointment windows available RIGHT NOW. Slots are read live on every call, never snapshotted when the link was sent. A token that is unknown, expired or revoked is an ordinary answer with a status, not an error. */
  customerAppointmentInvitation: CustomerAppointmentInvitationEntity;
  customerPortalOrders: OrderConnection;
  /** Paginated inventory list for a customer-portal (third-party) user. Restricted to pieces billed to one of the caller's own linked contacts with the portal Inventory tab enabled, within the requested company, resolved through any of the order paths a piece can be owned by (direct order link, package link, or legacy direct package link). The lifecycle bucket and piece statuses are forced server-side, and a client-supplied contactUuid is intersected with the caller's contacts, so no input can widen the visible set. Returns an empty connection for a caller that is not a portal user. */
  customerPortalPieces: PieceConnection;
  /** Returns quotes for a customer portal that the third party user has access to and meet the specified filter conditions. Used in the Pallet Customer Portal. */
  customerPortalQuotes: QuoteConnection;
  customerProfitabilityReport: CustomerProfitabilityReportEntity;
  customerReport: Array<CustomerReportBucketEntity>;
  defaultGlobalSpecialAccessorials: Array<AccessorialUnion>;
  delegatedOrdersInbox: DelegatedOrderInboxItemConnection;
  delegatedOrdersOutbox: OrderDelegationConnection;
  delegationAccessorialProposals: Array<DelegationAccessorialProposalEntity>;
  delegationEndCustomerMatch: Scalars['Boolean']['output'];
  deliveryFailureKpi: DeliveryFailureKpiEntity;
  deliveryFailureStops: DeliveryFailureStopsEntity;
  digitallySignableDocuments: Array<DocumentEntity>;
  /** Preset-tab counts for the Dispatch appointments board, scoped by tenant and delivery-date range only. */
  dispatchAppointmentSummary: DispatchAppointmentSummaryEntity;
  /** Paginated appointments for the Dispatch appointments board. The date axis is the shipment deliveryDate, not Stop.appointmentTime. */
  dispatchAppointments: DispatchAppointmentConnection;
  /** All DispatchTableColorEntities sorted ascending by position */
  dispatchTableColors: Array<DispatchTableColorEntity>;
  dispatchViews: Array<DispatchViewEntity>;
  dispatchableDrivers: GetDispatchableDriversOutput;
  docExtractionEvalDocumentWordBoxes: DocExtractionEvalDocumentWordBoxesEntity;
  docExtractionEvalRun: DocExtractionEvalRunEntity;
  docExtractionEvalRunDocuments: DocExtractionEvalRunDocumentsPageEntity;
  docExtractionEvalRuns: Array<DocExtractionEvalRunEntity>;
  docExtractionEvalSet: DocExtractionEvalSetEntity;
  docExtractionEvalSets: Array<DocExtractionEvalSetEntity>;
  docScanVolumeByPipelineReport: Array<DocScanVolumeByPipelineBucketEntity>;
  dockDoorAssignments: Array<DockDoorAssignmentEntity>;
  dockDoors: Array<DockDoorEntity>;
  dockProductivityReport: DockProductivityReportEntity;
  dockReceivedKpi: DockReceivedKpiEntity;
  dockReceivedKpiReceipts: KpiDockReceiptRecordsEntity;
  dockRunTimes: Array<DockRunTimeEntity>;
  dockScanReport: DockScanReportOutput;
  dockTimeAllowances: DockTimeAllowanceEntity;
  document: DocumentEntity;
  documentExtractionStatus: DocumentExtractionStatus;
  documentForSigning: DocumentForSigningOutput;
  documentationAdminItem: DocumentationItemEntity;
  documentationAdminTopics: Array<DocumentationTopicEntity>;
  documentationItem: DocumentationItemEntity;
  documentationSearch: Array<DocumentationSearchResultEntity>;
  documentationTopics: Array<DocumentationTopicEntity>;
  documents: Array<DocumentEntity>;
  /** One stored SMC3 exchange with its request, body sent and redacted response. */
  downloadExternalRateQuote: ExternalRateQuoteDownloadEntity;
  downloadFinancialSnapshotsCsv: Array<Array<Scalars['String']['output']>>;
  driver: DriverEntity;
  driverCompletedStopsLog: DriverCompletedStopsEntity;
  driverCompliance: DriverComplianceEntity;
  driverComplianceReportCsv: DriverComplianceReportFileOutput;
  driverComplianceReportPdf: DriverComplianceReportFileOutput;
  driverCredentialTypes: Array<DriverCredentialTypeEntity>;
  driverDailyLogReportCsv: ReportFileOutput;
  driverDailyLogReportPdf: ReportPdfOutput;
  driverOrders: DriverOrdersOutput;
  driverPayRateChangeEvents: DriverPayRateChangeEventConnection;
  driverPhoneNumberAvailability: DriverPhoneNumberAvailabilityOutput;
  driverPlannerAssumptions: DriverPlannerAssumptionEntity;
  driverPlannerReport: DriverPlannerReportEntity;
  driverQualifications: Array<DriverQualificationEntity>;
  driverReport: Array<DriverReportBucketEntity>;
  driverSettlementBill: DriverSettlementBillEntity;
  /** Recomputes one finalized bill against its current inputs and reports whether the frozen calculation still matches. Records a DRIFT_DETECTED flag when it does not. Expensive: it re-rates the whole bill, so call it for a single bill on demand, never per row of a list. */
  driverSettlementBillDrift: SettlementBillDriftEntity;
  driverSettlementBills: DriverSettlementBillConnection;
  driverSettlementBillsCountForCompany: Scalars['Float']['output'];
  driverSettlementBillsForDownload: Array<DriverSettlementBillForDownloadEntity>;
  driverSettlementPayBounds: Array<DriverSettlementPayBoundEntity>;
  drivers: Array<DriverEntity>;
  dummyQuery: Scalars['String']['output'];
  dunningReportPdf: ReportPdfOutput;
  duplicateMergeCandidates: Array<OrderEntity>;
  dwellTimeAlertConfigs: Array<DwellTimeAlertConfigEntity>;
  ediAndApiOrdersForReview: OrderConnection;
  ediPartnershipReferenceMappings: Array<EdiPartnershipReferenceMappingEntity>;
  ediPartnershipServiceMappings: Array<EdiPartnershipServiceMappingEntity>;
  ediTransactionPayloadByUuid: Scalars['String']['output'];
  ediTransactions: EdiTransactionConnection;
  ediTransactionsByCompany: EdiTransactionConnection;
  emailIngestionExclusions: EmailIngestionExclusionsEntity;
  emailTransactions: FindEmailTransactionsOutput;
  endOfDayDocumentProcessingJobs: Array<EndOfDayDocumentProcessingJobEntity>;
  equipment: EquipmentEntity;
  equipmentLicenses: Array<EquipmentLicenseEntity>;
  equipments: Array<EquipmentEntity>;
  etaForCustomerPortal?: Maybe<EtaEntity>;
  expeditorsApiStatus: ExpeditorsApiStatusEntity;
  externalApiTransmissionPayloadByOrderEventUuid: Scalars['String']['output'];
  featureFlag?: Maybe<FeatureFlagEntity>;
  featureFlagCompanyOverrides: Array<FeatureFlagCompanyOverrideEntity>;
  featureFlagUserOverrides: Array<FeatureFlagUserOverrideEntity>;
  featureFlags: Array<FeatureFlagEntity>;
  featureFlagsForCompanyGivenUuid: Array<FeatureFlagEntity>;
  findByOrderUuid: EdiTransactionEntity;
  findCompanyOrdersInDateRange: FindCompanyOrdersInDateRangeOutput;
  findDefaultRecoveryTariffGroupForCompany?: Maybe<TariffGroupEntity>;
  findDefaultTariffGroupForCompany?: Maybe<TariffGroupEntity>;
  findDefaultTransferTariffGroupForCompany?: Maybe<TariffGroupEntity>;
  /** Returns orphan pieces whose reference numbers match any reference number on the given order. */
  findMatchingOrphanPiecesForOrder: Array<PieceEntity>;
  findOrderByShipperBillOfLadingNumber: FindOrderByShipperBillOfLadingNumberOutput;
  /** Returns orphan pieces (no parent order) matching the given barcode within the current company. Optionally filter by terminal. `pieces` is capped at 50 rows; `hasMore` is true when additional matches exist beyond the cap, so clients can display "at least N" instead of a misleading exact count. */
  findOrphanPiecesByBarcode: FindOrphanPiecesByBarcodeOutput;
  findOutboundRequest: Scalars['String']['output'];
  findServicesForCustomerConfiguration: FindServicesForCustomerConfigurationOutput;
  findTariffGroups: Array<ContactToServicesTariffGroupMappingEntity>;
  findTariffGroupsWithContactAndServiceCombination: Array<FindTariffGroupsWithContactAndServicesCombinationOutput>;
  findTariffZoneByUuid: TariffZoneEntity;
  findTariffZoneByUuidOrThrow: TariffZoneEntity;
  firstScannedOrderResultInReview?: Maybe<ScannedOrderResultEntity>;
  forwarderBoard: ForwarderBoardEntity;
  forwarderScorecard: ForwarderScorecardEntity;
  freightCost: FreightCostEntity;
  /** Tries to find a fuel profile date range for the fuel charge that the specified date to use falls within. */
  fuelChargeFuelProfileDateRange: FuelChargeFuelProfileDateRangeOutput;
  fuelCost: FuelCostEntity;
  fuelProfile: FindFuelProfileOutput;
  fuelProfileDateRanges: FindFuelProfileDateRangesOutput;
  fuelProfiles: Array<FuelProfileEntity>;
  fuzzySearchItemsBySkuName: FuzzySearchItemsBySkuNameOutput;
  /** Returns the most recently created order that meets the required similarity threshold */
  fuzzySearchOrdersByShippingBillOfLadingNumber: FuzzySearchOrdersByShipperBillOfLadingNumberOutput;
  fuzzySearchStorageOrders: FuzzySearchStorageOrdersOutput;
  fuzzySearchStorageUnits: FuzzySearchStorageUnitsOutput;
  generalLedgerCodes: Array<GeneralLedgerCodeEntity>;
  generalLedgerConfiguration?: Maybe<GeneralLedgerConfigurationEntity>;
  generateCsvOrderPreSignedPutUrls: Array<CsvOrderPreSignedPutUrlEntity>;
  generateCsvPresignedPutUrlForMappingPreview: GenerateCsvPresignedPutUrlForMappingPreviewOutput;
  generateDefaultAppointmentTexts: Array<DefaultAppointmentTextOutput>;
  generateRoutes: GenerateRoutesOutput;
  generateScannedOrderPreSignedPutUrls: Array<PreSignedPutUrlEntity>;
  getBlacklistStats: BlacklistStatsOutput;
  /** Given a zipcode, returns the city and state options it denotes. More than one is returned when a zipcode legitimately serves several places, so the caller can ask rather than guess; an empty list means the zipcode is not in the reference data. */
  getCityAndStateOptionsFromZipcode: GetCityAndStateOptionsFromZipcodeOutput;
  getFreightCharge: FreightChargeEntity;
  getInvoiceCsvs?: Maybe<FormatCsvResEntity>;
  getJsonSchemaWithOverride: Scalars['String']['output'];
  /** This is probably not the method you want to use */
  getLegDriverMap: LegDriverMapEntity;
  getLineHaulProgress: GetLineHaulProgressOutput;
  getNexusShipments: Scalars['String']['output'];
  getOptimizationResults?: Maybe<OptimizationResultsOutput>;
  getOrderTableFieldValues: GetOrderTableFieldValuesOutput;
  getPackage: PackageEntity;
  getQuickbooksConnectionStatus?: Maybe<QuickbooksOauthTokenEntity>;
  getSavedFilterViews: Array<SavedFilterViewEntity>;
  getSchemaMatchDetails: Scalars['String']['output'];
  getSftpCredentials?: Maybe<SftpCredentialsEntity>;
  getStandardOrderFields: StandardOrderFieldsEntity;
  getStandardShipmentFields: StandardShipmentFieldsEntity;
  getStructuredExtractionSchemaOverride?: Maybe<StructuredExtractionSchemaOverrideEntity>;
  getTag: TagEntity;
  getTags: Array<TagEntity>;
  getXYTransform: XyTransformEntity;
  /** Given a city and state, invokes the Smarty US Zipcode API and returns a list of possible zipcodes for that city and state */
  getZipcodeOptionsFromCityAndState: GetZipcodeOptionsFromCityAndStateOutput;
  glCodeReportPdf: ReportPdfOutput;
  groupByStops: GroupByStopsOutput;
  groupOrders: GroupOrdersOutput;
  /** The dispatch table fields the stops grid can group by (`stops(groupBy:)`), so the grid never offers a field the query refuses. */
  groupableDispatchTableFields: Array<DispatchTableField>;
  holdReasons: Array<HoldReasonEntity>;
  /** The notification event types deliverable to the in-app bell and configurable on the in-app preferences screen, sorted. Internal users only. */
  inAppEligibleNotificationEventTypes: Array<NotificationEventType>;
  inAppNotifications: InAppNotificationConnection;
  inboundMessagesForOrder: InboundMessagesForOrderOutput;
  /** @deprecated Use incomeAnalysisReportV2, which adds terminal totals */
  incomeAnalysisReport: Array<CustomerReportBucketEntity>;
  incomeAnalysisReportV2: IncomeAnalysisReportOutput;
  incomingOrganizationPeers: OrganizationPeerConnection;
  incomingPeerAccessorialMappings: Array<IncomingPeerAccessorialMappingEntity>;
  incomingPeerServiceMappings: Array<IncomingPeerServiceMappingEntity>;
  incompleteLegsWithAttempts: Array<LegEntity>;
  ingestedOutlookEmail: IngestedOutlookEmailEntity;
  ingestedOutlookEmailAttachments: IngestedOutlookEmailAttachmentConnection;
  ingestedOutlookEmails: IngestedOutlookEmailConnection;
  ingestionTestRun: IngestionTestRunEntity;
  internalOnly_featureFlagsGlobal: Array<FeatureFlagEntity>;
  inventoryCount: FindInventoryCountOutput;
  inventoryCounts: FindInventoryCountsOutput;
  invoice?: Maybe<InvoiceEntity>;
  invoiceBillingSummaryReportV2: InvoiceBillingSummaryV2Output;
  invoiceBillingSummaryReportV2Pdf: InvoiceBillingSummaryV2PdfOutput;
  invoiceBillingSummaryReportV2PdfUrl: Scalars['String']['output'];
  invoiceDocuments: Array<DocumentEntity>;
  /** Given an invoice, retrieves all the EDI transactions associated with that invoice */
  invoiceEdiTransactions: FindInvoiceEdiTransactionsOutput;
  invoiceEmailsApiLogs: FindInvoiceEmailsApiLogsOutput;
  invoiceExcelExportData: Array<InvoiceExcelExportDataOutput>;
  invoiceGroups: InvoiceTableGroupsOutput;
  invoiceNoteRules: InvoiceNoteRuleConnection;
  invoiceRegisterReportCsv: ReportFileOutput;
  invoiceRegisterReportPdf: ReportPdfOutput;
  invoiceSendJobBatches: InvoiceSendJobBatchConnection;
  invoiceSendJobs: InvoiceSendJobConnection;
  invoiceTerms: Array<InvoiceTermEntity>;
  invoices: InvoiceConnection;
  invoicesByUuids: Array<InvoiceEntity>;
  item: ItemEntity;
  itemGroups: ItemGroupConnection;
  itemLocations: Array<ItemLocationEntity>;
  items: ItemConnection;
  itemsBySkuName: Array<ItemEntity>;
  kpiComparisons: KpiComparisonsEntity;
  kpiDashboardLayout: KpiLayoutEntity;
  kpiDataStart: KpiDataStartEntity;
  laneDefaultDoors: Array<LaneDefaultDoorEntity>;
  laneFromOriginAndDestinationTerminal: FindLaneFromOriginAndDestinationTerminalOutput;
  leg?: Maybe<LegEntity>;
  legs: Array<LegEntity>;
  lineHaulDriverConflict: LineHaulDriverConflictOutput;
  /** Tries to find a line haul fuel profile date range for the fuel charge that the specified date to use falls within. */
  lineHaulFuelChargeFuelProfileDateRange: LineHaulFuelChargeFuelProfileDateRangeOutput;
  lineHaulLane: LineHaulLaneEntity;
  lineHaulLanes: Array<LineHaulLaneEntity>;
  lineHaulLanesForTerminals: Array<LineHaulLaneEntity>;
  lineHaulManifest: LineHaulManifestEntity;
  lineHaulManifests: FindLineHaulManifestsOutput;
  lineHaulManifestsGroups: LineHaulManifestsCategoryGroupsOutput;
  lineHaulRunConfigs: Array<LineHaulRunConfigEntity>;
  lineHaulSegment: LineHaulSegmentEntity;
  lineHaulSegmentTimings: Array<LineHaulSegmentTimingEntity>;
  lineHaulSegments: Array<LineHaulSegmentEntity>;
  lineHaulTrailerAssignments: Array<LineHaulTrailerAssignmentEntity>;
  lineHaulUtilizationAssumptions: LineHaulUtilizationAssumptionEntity;
  lineHaulUtilizationReport: LineHaulUtilizationReportEntity;
  linehaulRevenueReport: LineHaulRevenueReportOutput;
  /** The Business/Residence most recently picked by hand for this street address in the caller company, or null when nobody has picked one */
  manualStandardStopTypeForAddress?: Maybe<StandardStopType>;
  mapboxDirections: Scalars['Boolean']['output'];
  mapboxMatrix: Scalars['Boolean']['output'];
  masterAccounts: FindMasterAccountsOutput;
  me?: Maybe<UserEntity>;
  meAsThirdPartyUser?: Maybe<ThirdPartyUserEntity>;
  meDriver: DriverEntity;
  mirrorTargetCompanies: Array<MirrorTargetCompanyEntity>;
  mirrorTargets: Array<MirrorTargetEntity>;
  mobileFeatureFlag?: Maybe<FeatureFlagEntity>;
  mobileForceUpdateRequired: Scalars['Boolean']['output'];
  /** Returns the calling company's Motive connection state. */
  motiveIntegration: MotiveIntegrationEntity;
  myGroupedStopUuids: Array<Array<Scalars['String']['output']>>;
  /** The current user's effective in-app notification preferences: one entry per in-app-eligible event type with its resolved enabled state (the user's explicit choice, or the type's default). */
  myInAppNotificationPreferences: Array<InAppNotificationPreferenceEntity>;
  myLineHaulManifest?: Maybe<LineHaulManifestEntity>;
  myLineHaulManifests: Array<LineHaulManifestEntity>;
  /** Return today's stops for the current driver */
  myRoute?: Maybe<RouteEntity>;
  /** Return routes for the current driver */
  myRoutes?: Maybe<RouteConnection>;
  /** Return today's stops for the current driver */
  myStops: Array<StopEntity>;
  /** Return stops for the current driver by the UUIDs */
  myStopsByUuids: Array<StopEntity>;
  netSalesSummaryReport: NetSalesSummaryReportOutput;
  notificationCutoverConfigs: Array<NotificationCutoverConfigEntity>;
  notificationShadowComparisonSummary: Array<NotificationShadowComparisonStatusCountEntity>;
  notificationShadowComparisons: Array<NotificationShadowComparisonEntity>;
  notifications: Array<NotificationEntity>;
  numberOfEdiAndApiOrdersForReviewForCurrentCompany: Scalars['Int']['output'];
  /** @deprecated Prefer orderTableFieldValues with totalCount set to true instead */
  numberOfOrders: Scalars['Float']['output'];
  numberOfScannedOrderResultDuplicates: Scalars['Int']['output'];
  numberOfScannedOrderResultsApproved: Scalars['Int']['output'];
  numberOfScannedOrderResultsFailed: Scalars['Int']['output'];
  numberOfScannedOrderResultsInProgress: Scalars['Int']['output'];
  numberOfScannedOrderResultsInReview: Scalars['Int']['output'];
  numberOfScannedOrderResultsRejected: Scalars['Int']['output'];
  numberOfStops: Scalars['Float']['output'];
  onTimeKpi: OnTimeKpiEntity;
  onTimeKpiStops: OnTimeKpiStopsEntity;
  onTimePerformanceReportCsv: ReportFileOutput;
  onTimePerformanceReportPdf: ReportFileOutput;
  openInvoiceReport: Array<InvoiceForOpenInvoiceReportEntity>;
  operationalEfficiencyReport: OperationalEfficiencyReportEntity;
  operationsPerformanceReport: OperationsPerformanceReport;
  operationsPerformanceReportCsv: ReportFileOutput;
  operationsPerformanceSummary: OperationsPerformanceSummary;
  optimizationStatus: OptimizationStatusResult;
  order?: Maybe<OrderEntity>;
  /** Given a payment amount and a HAWB, preview applying payment to all orders sharing that HAWB for the customer (or every customer when contactUuid is omitted). Returns amount applied and new+current balances. */
  orderAmountsToPayForHawb: Array<OrderToChargeEntity>;
  /** Given a payment amount and invoices, preview applying payment to orders across invoices. Return amount applied and new+current balances. */
  orderAmountsToPayForInvoice: Array<OrderToChargeEntity>;
  orderAuditLogEntries?: Maybe<GetOrderAuditLogEntriesOutput>;
  /** Comments for an order or a specific piece */
  orderComments: Array<OrderCommentEntity>;
  orderDelegationRules: Array<OrderDelegationRuleEntity>;
  orderEventNotificationSubscriptions: Array<OrderEventNotificationSubscriptionEntity>;
  orderEvents?: Maybe<Array<OrderEventEntity>>;
  orderFormFields: OrderFormFieldsEntity;
  orderImportConfiguration: OrderImportConfigurationEntity;
  orderMirrorCaptureConfig: OrderMirrorCaptureConfigEntity;
  orderMirrorOutboxCount: Scalars['Int']['output'];
  orderMirrorSyncRequests: Array<MirrorSyncRequestEntity>;
  orderMirrorSyncableCompanies: Array<MirrorSyncableCompanyEntity>;
  orderName: Scalars['String']['output'];
  orderQuote?: Maybe<OrderQuote>;
  orderQuoteForOrder?: Maybe<OrderQuote>;
  orderQuotes: OrderQuoteConnection;
  orderQuotesNeedingActionCount: Scalars['Int']['output'];
  orderReport: Array<OrderReportBucketEntity>;
  orderReportByReportGroup: Array<OrderReportBucketEntity>;
  orderRevenueReport: RevenueReportOrderConnection;
  orderTableFieldHeaders: GetOrderTableFieldHeadersOutput;
  /** The uuids of the orders in an orders table view, up to a limit, for selecting the whole view. Requires ORDERS read access. */
  orderUuidsInView: FindOrderUuidsInViewOutput;
  orderVolumeByCompanyReport: Array<OrderVolumeCompanyBucketEntity>;
  orderVolumeByContactReport: Array<OrderVolumeContactBucketEntity>;
  orderVolumeByDateRangeReport: Array<OrderVolumeDateRangeBucketEntity>;
  orderVolumeBySchemaReport: Array<OrderVolumeSchemaBucketEntity>;
  orderVolumeByUserReport: Array<OrderVolumeUserBucketEntity>;
  orders: OrderConnection;
  ordersByMasterAirwayBillOfLadingNumber: Array<OrderEntity>;
  ordersBySecondaryRefNumber: Array<OrderEntity>;
  ordersByShipperBillOfLadingNumber: Array<OrderEntity>;
  ordersByUuids: Array<OrderEntity>;
  ordersForPayments: OrderConnection;
  organization: OrganizationEntity;
  organizationEffectivePackageTypeConfigs: FindEffectiveOrganizationPackageTypeConfigsOutput;
  organizationMessage: OrganizationMessageEntity;
  organizationMessageCounts: OrganizationMessageCountsEntity;
  organizationMessageHistory: Array<OrganizationMessageEventEntity>;
  organizationMessageReach: OrganizationMessageReachEntity;
  organizationMessageStats: OrganizationMessageStatsEntity;
  organizationMessages: OrganizationMessageConnection;
  organizationNotes: Array<ContactCommentEntity>;
  organizationPackageTypeConfigs: FindOrganizationPackageTypeConfigsOutput;
  organizationPeers: OrganizationPeerConnection;
  organizations: Array<OrganizationEntity>;
  outboundBenchCompanyUsers: Array<BenchCompanyUserOptionEntity>;
  outboundBenchDrivers: Array<BenchDriverOptionEntity>;
  outboundBenchEdiPayload: BenchEdiPayloadEntity;
  outboundBenchOrders: Array<BenchOrderOptionEntity>;
  outboundBenchPartnerships: Array<BenchPartnershipOptionEntity>;
  outboundBenchServiceLevels: Array<BenchServiceLevelOptionEntity>;
  outlookIntegrations: Array<OutlookIntegrationEntity>;
  outlookIntegrationsForInternal: Array<OutlookIntegrationEntity>;
  outstandingInvoicesForCustomer?: Maybe<Array<InvoiceEntity>>;
  outstandingOrdersForReview: OrderConnection;
  outstandingShipments: ShipmentConnection;
  overdueInvoices: Array<InvoiceEntity>;
  packageHasPiece: PackageHasPieceEntity;
  packageSpec: PackageSpecEntity;
  packageSpecs: FindPackageSpecsOutput;
  packingPendencies: FindPackingPendenciesOutput;
  /** Resolves one scanned barcode to a packable piece for the mobile packing screen. Matches the piece reference number and its alternates, exactly as freight scanning does. The open order and the scanning facility rank the matches rather than filter them, so a piece with no assigned facility still resolves. Returns null when no packable piece matches. */
  packingPieceByBarcode?: Maybe<PieceListEntity>;
  /** Lists pieces for the warehouse packing page, paginated by package so whole packages are returned (never split at a piece boundary). */
  packingPieces: PackingPiecesOutput;
  paginatedContacts: ContactConnection;
  paginatedOrdersByInvoice: OrderConnection;
  paginatedOrganizations: OrganizationConnection;
  paginatedRoutes: RouteConnection;
  parseAddress: Array<PostalResultEntity>;
  paymentApplicationReport: Array<PaymentForPaymentApplicationReportEntity>;
  paymentByUuid?: Maybe<PaymentEntity>;
  /** Uuids of the customers the payment dialog lists when filtered on this customer: the customer and every customer sharing its master account, inactive ones included. */
  paymentCustomerScope: Array<Scalars['String']['output']>;
  paymentJournalReport: Array<PaymentForPaymentJournalReportEntity>;
  paymentsByInvoiceUuid: Array<PaymentEntity>;
  paymentsV2: PaymentConnection;
  pdProductivityReport: PdProductivityReportEntity;
  pdfColumn: PdfColumnEntity;
  peerAccessorialShares: Array<Scalars['String']['output']>;
  peerServiceShares: Array<PeerServiceShareEntity>;
  pendingOrderDelegationsCount: Scalars['Int']['output'];
  person: PersonEntity;
  /** Find all persons for the specified contact. Returns an empty result when contactUuid is omitted. */
  persons: FindPersonsOutput;
  picklists: PicklistConnection;
  piece: PieceEntity;
  pieceBackfillRun: PieceBackfillRunView;
  pieceBackfillRuns: Array<PieceBackfillRunView>;
  pieceBackfillSurvey: PieceBackfillSurvey;
  pieceBucketMetrics: PieceBucketMetricsOutput;
  pieceReceipt: FindPieceReceiptOutput;
  /** Fetch a single piece for the receipt detail panel. Receipt-scoped: resolves only when the piece is attached to the given receipt (which is tenant-checked first). */
  pieceReceiptPiece: PieceEntity;
  pieceReceipts: FindPieceReceiptsOutput;
  pieceScanKpi: PieceScanKpiEntity;
  pieceScanKpiPieces: KpiPieceRecordsEntity;
  /** Paginated list of pieces for the current company. */
  pieces: PieceConnection;
  /** Fetch multiple pieces by UUID, scoped to the current company. */
  piecesByUuids: Array<PieceEntity>;
  piecesGroupedByStatus: PiecesGroupedByStatusOutput;
  ping: Scalars['String']['output'];
  place: PlaceEntity;
  planOutboundBenchRun: BenchRunReportEntity;
  planQuickbooksSync: QuickbooksSyncPlan;
  pointToPointLanes: PointToPointLaneConnection;
  postedVsActualReport: Array<PostedVsActualDiscrepancyEntity>;
  prefillInspection: PrefillInspectionOutput;
  previewAddOrdersToInvoices: PreviewAddOrdersToInvoicesOutput;
  previewBatchAddShipmentsToInvoices: BatchAddShipmentsToInvoicePreview;
  previewBatchAddShipmentsToInvoicesMultiple: Array<BatchAddShipmentsToInvoicePreview>;
  previewInventoryCountScope: PreviewInventoryCountScopeOutput;
  previewParseCsvOrders: PreviewParseCsvOrdersOutput;
  previewProratedConsolidation: PreviewProratedConsolidationOutput;
  previewProratedConsolidationV2: PreviewProratedConsolidationV2Output;
  productivityTimeAllowances: ProductivityTimeAllowanceEntity;
  queryQuickbooksDesktopAccounts: QuickbooksDesktopResultEntity;
  queryQuickbooksDesktopCustomers: QuickbooksDesktopResultEntity;
  queryQuickbooksDesktopInvoices: Array<QuickbooksDesktopInvoiceEntity>;
  queryQuickbooksDesktopItems: QuickbooksDesktopResultEntity;
  quickbooksClasses?: Maybe<Array<QuickbooksClassEntity>>;
  quickbooksCustomers?: Maybe<Array<QuickbooksCustomerEntity>>;
  quickbooksHeaderFileMappings: Array<QuickbooksHeaderFileMappingEntity>;
  quickbooksIncomeAccounts?: Maybe<Array<QuickbooksAccountEntity>>;
  quickbooksItems?: Maybe<Array<QuickbooksItemEntity>>;
  quickbooksOAuthUrl: Scalars['String']['output'];
  quickbooksTaxCodes?: Maybe<Array<QuickbooksTaxCodeEntity>>;
  quote: QuoteEntity;
  quoteAgentConnections: QuoteAgentConnectionsResult;
  quoteAgentInboundRejections: QuoteAgentInboundRejectionsResult;
  quoteContributionRatio?: Maybe<QuoteContributionRatioEntity>;
  quoteConversation?: Maybe<QuoteConversationEntity>;
  quoteName: Scalars['String']['output'];
  quotes: QuoteConnection;
  rateAutoAppliedAccessorials: RateAutoAppliedAccessorialsOutput;
  rateOrderByUuid: RateOrderOutput;
  rateOrderContents: RateOrderOutput;
  receiptItemStorageUnits: Array<StorageUnitEntity>;
  recurringLineHaulManifestTemplate: RecurringLineHaulManifestTemplateEntity;
  recurringLineHaulManifestTemplates: Array<RecurringLineHaulManifestTemplateEntity>;
  recurringOrderFrequency: RecurringOrderFrequencyEntity;
  recurringOrderTemplates: Array<OrderEntity>;
  recurringRuns: Array<RunEntity>;
  recurringTemplateTrucks: Array<RecurringTemplateTruckEntity>;
  referenceNumberFormatConfigs?: Maybe<Array<ReferenceNumberFormatConfigEntity>>;
  remainingAmountOfInvoices: Scalars['Float']['output'];
  renderServices: Array<RenderServiceWithDeploysEntity>;
  reportGroupConfigurations: Array<ReportGroupConfigurationEntity>;
  reportSendJobBatches: FindReportSendJobBatchesOutput;
  reportSendJobs: FindReportSendJobsOutput;
  reportsEmailSenderIsVerified?: Maybe<Scalars['Boolean']['output']>;
  resolveProvenanceNeighbor?: Maybe<ProvenanceNeighborEntity>;
  role: FindRoleOutput;
  roles: FindRolesOutput;
  route: RouteEntity;
  /** Returns the calling company's v2 route-automation settings. Creates a default row on first read. */
  routeAutomationSettings: RouteAutomationSettingsEntity;
  routeName?: Maybe<RouteNameEntity>;
  routeNames: Array<RouteNameEntity>;
  routes: Array<RouteEntity>;
  routesSamsaraVehicleLocations: RoutesSamsaraVehicleLocationsOutput;
  sageBusinessWorksInvoiceExportCsv: ReportFileOutput;
  salesVarianceReportCsv: ReportFileOutput;
  /** Get the Samsara OAuth authorize URL */
  samaraOAuthAuthorizeUrl: Scalars['String']['output'];
  sameDayDispatchConfig?: Maybe<SameDayDispatchConfigEntity>;
  samsaraDiscoveryCatalogue: SamsaraDiscoveryCatalogueEntity;
  /** The filtered dataset as CSV or JSON text. */
  samsaraDiscoveryExport: Scalars['String']['output'];
  samsaraDiscoveryMonthlyOverview: Array<SamsaraDiscoveryMonthEntity>;
  samsaraDiscoveryRows: SamsaraDiscoveryRowsPageEntity;
  samsaraDiscoveryStatus: SamsaraDiscoveryStatusEntity;
  samsaraDriverVehicleAssignments?: Maybe<Scalars['String']['output']>;
  samsaraDrivers?: Maybe<SamsaraDriversEntity>;
  samsaraOAuthToken?: Maybe<SamsaraOauthTokenEntity>;
  samsaraVehicleStatsFeed?: Maybe<SamsaraVehicleStatsFeedEntity>;
  samsaraVehicles?: Maybe<SamsaraVehiclesEntity>;
  scannedOrder?: Maybe<ScannedOrderEntity>;
  scannedOrderProvenance?: Maybe<DocumentProvenanceEntity>;
  scannedOrderResult?: Maybe<ScannedOrderResultEntity>;
  scannedOrderResultByOrderUuid?: Maybe<ScannedOrderResultEntity>;
  scannedOrderResultForAdmin?: Maybe<ScannedOrderResultEntity>;
  scannedOrderResults: ScannedOrderResultConnection;
  scannedOrderResultsForAdmin: ScannedOrderResultConnection;
  scannedOrders: ScannedOrderConnection;
  scannedOrdersByUuids: Array<ScannedOrderEntity>;
  /** On-demand full order info for the lean scan flow drill-in. Loads the heavy order graph only when the operator opens an order. */
  scanningV2__orderInfo?: Maybe<FreightScanningV2OrderInfo>;
  /** On-demand single-piece info for the lean scan flow drill-in. Loads an orderless (orphan) piece that cannot be resolved via scanningV2__orderInfo. */
  scanningV2__pieceInfo?: Maybe<FreightScanningV2PieceInfo>;
  /** Batched status lookup for deferred scan post-processing jobs. Powers the client polling loop. Reads BullMQ job state directly (jobId = scanUuid); no database row is involved. Tenant-scoped by the session company. */
  scanningV2__scanJobStatuses: Array<FreightScanningV2ScanJobStatus>;
  schedulingRegion: SchedulingRegionEntity;
  schedulingRegions: FindSchedulingRegionsOutput;
  schedulingResource: SchedulingResourceEntity;
  schedulingResources: FindSchedulingResourcesOutput;
  schedulingResourcesByRouteName: FindSchedulingResourcesOutput;
  schemaCompanyMappings: Array<SchemaCompanyMappingEntity>;
  schemaDocumentsBySchemaCompanyMapping: Array<SchemaDocumentEntity>;
  schemaFilePutUrl: Scalars['String']['output'];
  schemaRun?: Maybe<SchemaRunEntity>;
  schemaRunTestList: SchemaRunTestListEntity;
  schemaRunTestSnapshots: Array<SchemaRunEntity>;
  schemaTestFilePutUrl: Scalars['String']['output'];
  schemas: Array<SchemaWithAnchorsEntity>;
  searchSchemas: Array<SchemaEntity>;
  segmentedLineHaulOrders: OrderLineHaulSegmentConnection;
  segmentedLineHaulOrdersV2: OrderLineHaulSegmentOutput;
  selectSpecialAccessorial: SelectSpecialAccessorialOutput;
  senderIsVerified?: Maybe<Scalars['String']['output']>;
  serviceGroup: ServiceGroupEntity;
  serviceGroups: Array<ServiceGroupEntity>;
  serviceLevelReport: Array<ServiceLevelReportBucketEntity>;
  serviceRegion: ServiceRegionEntity;
  serviceRegions: GetServiceRegionsOutput;
  services: Array<ServiceEntity>;
  servicesForOrder: FindServicesForOrderOutput;
  servicesForThirdPartyUser: Array<ServiceEntity>;
  /** Changes recorded against one bill whose pay calculation is already frozen, newest first. */
  settlementBillChangeFlags: Array<SettlementBillChangeFlagEntity>;
  settlementBillLineItem: SettlementBillLineItemEntity;
  /** Pulls line items that are settled or settle-able (aka associated with completed stops) */
  settlementBillLineItems: SettlementBillLineItemConnection;
  settlementDeductionTypes: Array<SettlementDeductionTypeEntity>;
  sftpUploads: SftpUploadConnection;
  shipment: ShipmentEntity;
  shipmentV2?: Maybe<ShipmentEntity>;
  shipments: Array<ShipmentEntity>;
  shipmentsByContactUuid?: Maybe<Array<ShipmentEntity>>;
  shipmentsByPhoneOrReferenceNumber: Array<ShipmentEntity>;
  /** The tariffs and effective dates SMC3 lists for the company. */
  smc3AvailableTariffs: Smc3AvailableTariffsResultEntity;
  /** The calling company's SMC3 connection, without secrets. */
  smc3Settings: Smc3SettingsEntity;
  smsConsentAdminList: SmsConsentAdminConnection;
  standardAccessorials: Array<StandardAccessorialEntity>;
  standardOrder: StandardOrderEntity;
  standardOrderForReview?: Maybe<StandardOrderEntity>;
  stationReport: Array<StationReportBucketEntity>;
  stop: StopEntity;
  stopDriverMaps: StopDriverMapConnection;
  /** The uuids of the stops in one group of the grouped dispatch stops grid, under the same filters as `stops`, for assigning the whole group to a route. `groupBy.keys` names the group, at any depth. */
  stopUuidsInGroup: StopUuidsInGroupOutput;
  /** Get stops for a company. Recurring run headers are included only when there are stops loaded in the cache. */
  stops: CachedStopConnection;
  stopsBySearchText: Array<StopEntity>;
  stopsOnRoutesBySearchText: Array<StopEntity>;
  storageOrder: FindStorageOrderOutput;
  storageOrderStorageUnits: FindStorageOrderStorageUnitsOutput;
  storageOrders: FindStorageOrdersOutput;
  storageUnit: FindStorageUnitOutput;
  storageUnitByName?: Maybe<StorageUnitEntity>;
  storageUnits: FindStorageUnitsOutput;
  structuredExtractionRunByScannedOrder?: Maybe<StructuredExtractionRunEntity>;
  tableFields?: Maybe<TableFieldsEntity>;
  tariff: TariffEntity;
  tariffChains: Array<TariffChainEntity>;
  tariffGroup: TariffGroupEntity;
  tariffGroups: Array<TariffGroupEntity>;
  tariffGroupsPaginated: TariffGroupConnection;
  tariffZoneGroup: TariffZoneGroupEntity;
  tariffZoneGroups: Array<TariffZoneGroupEntity>;
  tariffZones: Array<TariffZoneEntity>;
  tariffsByContact: Array<TariffEntity>;
  templateAddresses: Array<AddressEntity>;
  tenediConnection: TenediConnectionEntity;
  tenediConnectionCustomers: Array<TenediConnectionCustomerOptionEntity>;
  terminal: TerminalEntity;
  terminalEfficiencyReport: TerminalEfficiencyReportEntity;
  terminalForAddress: FindTerminalForAddressOutput;
  terminalReport: Array<TerminalReportBucketEntity>;
  terminals: Array<TerminalEntity>;
  terminalsForAddress: FindTerminalsForAddressOutput;
  terminalsForInternal: Array<TerminalEntity>;
  terminalsForThirdPartyUser: Array<TerminalEntity>;
  testJsonSchemaOnDocumentsForSchema: TestJsonSchemaOnDocumentsForSchemaOutput;
  testOrder: FindTestOrderOutput;
  testOrders: FindTestOrdersOutput;
  thirdPartyBrokers: Array<ThirdPartyBrokerEntity>;
  thirdPartyUser?: Maybe<ThirdPartyUserEntity>;
  thirdPartyUserByUuid?: Maybe<ThirdPartyUserEntity>;
  thirdPartyUsersByContact: Array<ThirdPartyUserEntity>;
  throwError: Scalars['Boolean']['output'];
  unappliedPaymentReportCsv: ReportFileOutput;
  /** @deprecated Use individual unified queries instead */
  unifiedSearch: UnifiedSearchEntity;
  unifiedSearchInvoices: InvoiceConnection;
  unifiedSearchOrders: OrderConnection;
  unifiedSearchQuotes: QuoteConnection;
  unifiedSearchUnacceptedEdiAndApiOrders: OrderConnection;
  unifiedSearchUnacceptedEmailOrders: ScannedOrderResultConnection;
  unreadInAppNotificationsCount: Scalars['Int']['output'];
  userContactNotificationSubscription?: Maybe<UserContactNotificationSubscriptionEntity>;
  userOptions: Array<UserOptionEntity>;
  userRoles: Array<RoleEntity>;
  userSessionsAdminCompanyUsers: UserSessionsAdminCompanyUsersResult;
  userSessionsAdminSearchCompanies: Array<UserSessionsAdminCompanyEntity>;
  users: Array<UserEntity>;
  usersEditingOrder?: Maybe<Array<UserActorEntity>>;
  /** Validates bulk edit input and returns affected counts without executing actions */
  validateBulkEditOrders: BulkEditOrdersResponse;
  vehicleType: VehicleTypeEntity;
  vehicleTypes: Array<VehicleTypeEntity>;
  verifySchemaDocumentMatchesForCompany: Scalars['String']['output'];
  warehouse?: Maybe<WarehouseEntity>;
  /** @deprecated Changing naming to more accurately represent purpose of api, see startingAddressForRoute */
  warehouseAddressOfFirstRouteSlot?: Maybe<AddressEntity>;
  warehouseEmployees: FindWarehouseEmployeesOutput;
  warehouseLocations: FindWarehouseLocationsOutput;
  warehouses?: Maybe<Array<WarehouseEntity>>;
  weightBreakReport: WeightBreakReportEntity;
  whiteLabelCompany?: Maybe<WhiteLabelCompanyEntity>;
  /** returns all contacts with storage orders associated with them to enable ease of filtering by WMS contacts. If called by the customer portal, only returns contacts that the user has access to */
  wmsContacts: Array<ContactEntity>;
  workOrderCount: Scalars['Int']['output'];
  workOrders: Array<WorkOrderListItem>;
};


export type QueryAccessorialArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryAccessorialChargeDetailsReportArgs = {
  args: AccessorialChargeDetailsReportArgs;
};


export type QueryAccessorialDateRangeConfigByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryAccessorialDateRangeConfigsArgs = {
  findAccessorialDateRangeConfigsInput: FindAccessorialDateRangeConfigsInput;
};


export type QueryAccessorialGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccessorialToQuickbooksMappingByContactArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryAccessorialsArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAccessorialsByBillingContactArgs = {
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAccountingReportFiltersArgs = {
  accountingReportFiltersInput: AccountingReportFilterTypesInput;
};


export type QueryAccountsReceivableReportArgs = {
  args: AccountsReceivableReportArgs;
};


export type QueryAdhocPreviewBatchArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdhocPreviewResultArgs = {
  id: Scalars['String']['input'];
};


export type QueryAdhocPreviewWordBoxesArgs = {
  id: Scalars['String']['input'];
};


export type QueryAgingReportArgs = {
  args: InvoiceAgingReportArgs;
};


export type QueryAgingReportPdfArgs = {
  args: InvoiceAgingReportArgs;
};


export type QueryAirportInfoArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryApiKeyAdminExamplePayloadArgs = {
  sendCompanyLocalTimestamps?: Scalars['Boolean']['input'];
  shape: WebhookPayloadShape;
};


export type QueryApiKeyAdminExportCsvArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryApiKeyAdminGetArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryApiKeyAdminListArgs = {
  input: ApiKeyAdminListInput;
};


export type QueryApiKeyAdminPreviewMappingArgs = {
  input: ApiKeyAdminPreviewMappingInput;
};


export type QueryApiKeyAdminSearchOrganizationsArgs = {
  input: ApiKeyAdminOrgSearchInput;
};


export type QueryApiKeyAdminStatusMappingsArgs = {
  apiKeyUuid: Scalars['String']['input'];
};


export type QueryApiKeyAdminWebhookShapeConfigArgs = {
  apiKeyUuid: Scalars['String']['input'];
  shape: WebhookPayloadShape;
};


export type QueryApiLogArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryApiLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<Array<DateFilter>>;
  emailTransactionStatus?: InputMaybe<EmailTransactionStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freightSnapFailureReason?: InputMaybe<FreightSnapFailureReason>;
  freightSnapTransactionStatus?: InputMaybe<FreightSnapTransactionStatus>;
  invoiceFailed?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isFreightSnap?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoiceEmails?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppointmentConfirmationInfoArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryAppointmentOptionsArgs = {
  input: AppointmentOptionsInput;
};


export type QueryAppointmentStatusHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stopUuid: Scalars['String']['input'];
};


export type QueryAppointmentsArgs = {
  deliveryDate: Scalars['DateTime']['input'];
};


export type QueryAuditQuickbooksDesktopInvoiceTotalsArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryAuditReportArgs = {
  args: AuditReportArgs;
};


export type QueryAuditShipmentOnInvoiceButOtherShipmentsNotArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryAutoApplyAccessorialConfigArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryAvailablePiecesForLinkingArgs = {
  findAvailablePiecesInput: FindAvailablePiecesInput;
};


export type QueryAvailableSchedulingSlotsForOrderArgs = {
  input: FindAvailableSchedulingSlotsInput;
};


export type QueryBillOfLadingPdfUrlArgs = {
  orderUuid: Scalars['ID']['input'];
};


export type QueryBookedStopsByResourceArgs = {
  input: FindBookedStopsByResourceInput;
};


export type QueryBulkDelegationBatchArgs = {
  batchUuid: Scalars['String']['input'];
};


export type QueryBusinessKpiInvoicedOrdersArgs = {
  args: KpiRecordTableArgs;
};


export type QueryBusinessKpiOrdersArgs = {
  args: KpiRecordTableArgs;
};


export type QueryBusinessKpiOrdersPerDriverArgs = {
  args: KpiRecordTableArgs;
};


export type QueryBusinessKpiPaidInvoicesArgs = {
  args: KpiRecordTableArgs;
};


export type QueryBusinessKpisArgs = {
  args: KpiReportArgs;
};


export type QueryCalmCommitDatesByOrderUuidsArgs = {
  input: OrderUuidsInput;
};


export type QueryCalmCrossdockInstructionsArgs = {
  terminalUuid: Scalars['String']['input'];
};


export type QueryCalmLineHaulOrdersToPlanArgs = {
  input: CalmPlanOrdersInput;
};


export type QueryCalmLiveRunsArgs = {
  date: Scalars['String']['input'];
};


export type QueryCalmManifestLoadPackagesArgs = {
  input: ManifestUuidsInput;
};


export type QueryCalmManifestPlacementsArgs = {
  input: ManifestUuidsInput;
};


export type QueryCalmManifestReadinessArgs = {
  input: ManifestUuidsInput;
};


export type QueryCalmManifestReschedulablesArgs = {
  manifestUuid: Scalars['String']['input'];
};


export type QueryCalmManifestSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryCalmOrderCubeByOrderUuidsArgs = {
  input: OrderUuidsInput;
};


export type QueryCalmOrderLineHaulRouteArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryCalmOrderPackagesArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryCalmOrderPackagesByOrderUuidsArgs = {
  input: OrderUuidsInput;
};


export type QueryCalmOrderPiecesArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryCalmOrderSplitSummaryArgs = {
  input: OrderSplitSummaryInput;
};


export type QueryCalmOrderTagsArgs = {
  input: OrderUuidsInput;
};


export type QueryCalmOrdersByHawbArgs = {
  input: OrdersByHawbInput;
};


export type QueryCalmPndRouteLoadArgs = {
  routeUuid: Scalars['String']['input'];
};


export type QueryCalmPreviewLineHaulReroutesArgs = {
  input: PreviewLineHaulReroutesInput;
};


export type QueryCalmRunInboundPlanArgs = {
  input: ManifestUuidsInput;
};


export type QueryCalmRunOnwardPlanArgs = {
  input: ManifestUuidsInput;
};


export type QueryCalmTerminalOnHandArgs = {
  terminalUuid: Scalars['String']['input'];
};


export type QueryCalmTerminalPndArgs = {
  date: Scalars['String']['input'];
  terminalUuid: Scalars['String']['input'];
};


export type QueryChargeBreakdownReportCsvArgs = {
  chargeBreakdownReportInput?: InputMaybe<ChargeBreakdownReportPdfInput>;
  input?: InputMaybe<ChargeBreakdownReportInput>;
};


export type QueryChargeBreakdownReportPdfArgs = {
  chargeBreakdownReportPdfInput?: InputMaybe<ChargeBreakdownReportPdfInput>;
  input?: InputMaybe<ChargeBreakdownReportInput>;
};


export type QueryCheckConsistencyOfInvoicesArgs = {
  checkConsistencyOfInvoicesInput: CheckConsistencyOfInvoicesInput;
};


export type QueryCheckRegisterReportArgs = {
  args: FindPaymentsV2Args;
};


export type QueryClientQuotesArgs = {
  findClientQuotesInput: FindClientQuotesInput;
};


export type QueryClosestWarehouseToAddressArgs = {
  addressLatitude: Scalars['Float']['input'];
  addressLongitude: Scalars['Float']['input'];
};


export type QueryCompanyByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCompanyConfigurationByCompanyUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCompanyConfigurationChangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyContactsArgs = {
  companyUuid: Scalars['String']['input'];
  excludeNonActiveContacts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompanyDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  date: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  statusFilter: FindCompanyDocumentStatusFilter;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompanySchedulingBlockedDaysArgs = {
  input?: InputMaybe<FindCompanySchedulingBlockedDaysInput>;
};


export type QueryCompletedStopsNotOnRoutesArgs = {
  date: Scalars['DateTime']['input'];
};


export type QueryCompletionToPaymentReportArgs = {
  args: CompletionToPaymentPageArgs;
};


export type QueryCompletionToPaymentReportCsvArgs = {
  args: CompletionToPaymentFilterArgs;
};


export type QueryCompletionToPaymentSummaryArgs = {
  args: CompletionToPaymentFilterArgs;
};


export type QueryConfigMigrationCompaniesArgs = {
  env: MigrationEnv;
};


export type QueryConfigMigrationStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryConsigneePortalOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryContactArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryContactChargeMatrixColumnMappingsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactCommunicationConfigsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactEmailsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactItemsArgs = {
  findContactItemsInput: FindContactItemsInput;
};


export type QueryContactOrderStatisticsForDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};


export type QueryContactServicesArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactStationsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  checkHasTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  checkHasTariffs?: InputMaybe<Scalars['Boolean']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByContactName?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberDescending?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryContactsByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryCoordinatesForAddressArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCostCenterStatementReportArgs = {
  args: CostCenterStatementArgs;
};


export type QueryCostInputMonthArgs = {
  args: CostInputMonthArgs;
};


export type QueryCsvOrderImportTransactionsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryCsvOrderMappingArgs = {
  input: CsvOrderMappingQueryInput;
};


export type QueryCurrentBillingPeriodInvoiceArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryCustomDriverFormArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryCustomerAppointmentInvitationArgs = {
  input: CustomerAppointmentTokenInput;
};


export type QueryCustomerPortalOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyFilter?: InputMaybe<Scalars['String']['input']>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  contactFilter?: InputMaybe<Scalars['String']['input']>;
  contactsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  dispatched?: InputMaybe<BooleanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ofdOfp?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  orderStatusBuckets?: InputMaybe<Array<CustomerPortalOrderStatusBucketInput>>;
  plannedDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  thirdPartyUserUuid?: InputMaybe<Scalars['String']['input']>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomerPortalPiecesArgs = {
  customerPortalPiecesInput: CustomerPortalPiecesInput;
};


export type QueryCustomerPortalQuotesArgs = {
  findCustomerPortalQuotesInput: FindCustomerPortalQuotesInput;
};


export type QueryCustomerProfitabilityReportArgs = {
  args: CustomerProfitabilityArgs;
};


export type QueryCustomerReportArgs = {
  args: CustomerReportArgs;
};


export type QueryDelegatedOrdersInboxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DelegatedOrdersInboxFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDelegatedOrdersOutboxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DelegatedOrdersOutboxFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDelegationAccessorialProposalsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryDelegationEndCustomerMatchArgs = {
  input: DelegationEndCustomerMatchInput;
};


export type QueryDeliveryFailureKpiArgs = {
  args: KpiReportArgs;
};


export type QueryDeliveryFailureStopsArgs = {
  args: KpiRecordTableArgs;
};


export type QueryDigitallySignableDocumentsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryDispatchAppointmentSummaryArgs = {
  deliveryDateFilter?: InputMaybe<DateFilterStartEnd>;
  oncomingWindow?: InputMaybe<DateFilterStartEnd>;
};


export type QueryDispatchAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  contactChannel?: InputMaybe<DispatchAppointmentContactChannel>;
  deliveryDateFilter?: InputMaybe<DateFilterStartEnd>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  oncomingWindow?: InputMaybe<DateFilterStartEnd>;
  preset?: InputMaybe<DispatchAppointmentPreset>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DispatchAppointmentSortField>;
  sortDirection?: InputMaybe<SortDirection>;
  statuses?: InputMaybe<Array<DispatchAppointmentStatus>>;
  stopTypes?: InputMaybe<Array<StopType>>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDispatchableDriversArgs = {
  getDispatchableDriversInput: GetDispatchableDriversInput;
};


export type QueryDocExtractionEvalDocumentWordBoxesArgs = {
  documentId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
};


export type QueryDocExtractionEvalRunArgs = {
  id: Scalars['String']['input'];
};


export type QueryDocExtractionEvalRunDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  runId: Scalars['String']['input'];
};


export type QueryDocExtractionEvalRunsArgs = {
  evalSetId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocExtractionEvalSetArgs = {
  id: Scalars['String']['input'];
};


export type QueryDocExtractionEvalSetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocScanVolumeByPipelineReportArgs = {
  docScanVolumeByPipelineInput: DocScanVolumeByPipelineInput;
};


export type QueryDockDoorAssignmentsArgs = {
  input: DockDoorAssignmentsInput;
};


export type QueryDockDoorsArgs = {
  terminalUuid: Scalars['String']['input'];
};


export type QueryDockProductivityReportArgs = {
  args: DockProductivityArgs;
};


export type QueryDockReceivedKpiArgs = {
  args: KpiReportArgs;
};


export type QueryDockReceivedKpiReceiptsArgs = {
  args: KpiRecordTableArgs;
};


export type QueryDockRunTimesArgs = {
  input: DockRunTimesInput;
};


export type QueryDockScanReportArgs = {
  dockScanReportInput: DockScanReportInput;
};


export type QueryDocumentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDocumentForSigningArgs = {
  documentForSigningInput: DocumentForSigningInput;
};


export type QueryDocumentationAdminItemArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDocumentationItemArgs = {
  slug: Scalars['String']['input'];
};


export type QueryDocumentationSearchArgs = {
  input: DocumentationSearchInput;
};


export type QueryDocumentsArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryDownloadExternalRateQuoteArgs = {
  quoteUuid: Scalars['String']['input'];
};


export type QueryDriverArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDriverCompletedStopsLogArgs = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryDriverComplianceArgs = {
  input: DriverComplianceDriverInput;
};


export type QueryDriverComplianceReportCsvArgs = {
  driverComplianceReportInput: DriverComplianceReportInput;
};


export type QueryDriverComplianceReportPdfArgs = {
  driverComplianceReportInput: DriverComplianceReportInput;
};


export type QueryDriverCredentialTypesArgs = {
  input?: InputMaybe<GetDriverCredentialTypesInput>;
};


export type QueryDriverDailyLogReportCsvArgs = {
  driverDailyLogReportCsvInput: DriverDailyLogReportPdfInput;
};


export type QueryDriverDailyLogReportPdfArgs = {
  driverDailyLogReportPdfInput: DriverDailyLogReportPdfInput;
};


export type QueryDriverOrdersArgs = {
  driverOrdersInput: DriverOrdersInput;
};


export type QueryDriverPayRateChangeEventsArgs = {
  actorUserUuid?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateRangeFilterInput>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  scopes?: InputMaybe<Array<DriverPayRateChangeScope>>;
  stopDriverMapUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDriverPhoneNumberAvailabilityArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryDriverPlannerReportArgs = {
  args: DriverPlannerArgs;
};


export type QueryDriverReportArgs = {
  args: DriverReportArgs;
};


export type QueryDriverSettlementBillArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDriverSettlementBillDriftArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryDriverSettlementBillsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDriverSettlementBillsForDownloadArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDriverSettlementPayBoundsArgs = {
  input: GetDriverSettlementPayBoundsInput;
};


export type QueryDriversArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDunningReportPdfArgs = {
  dunningReportInput: DunningReportInput;
};


export type QueryDuplicateMergeCandidatesArgs = {
  billingPartyContactUuid: Scalars['String']['input'];
  excludeOrderUuid?: InputMaybe<Scalars['String']['input']>;
  shipperBillOfLadingNumber: Scalars['String']['input'];
};


export type QueryEdiAndApiOrdersForReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEdiPartnershipReferenceMappingsArgs = {
  ediPartnershipUuid: Scalars['String']['input'];
};


export type QueryEdiPartnershipServiceMappingsArgs = {
  ediPartnershipUuid: Scalars['String']['input'];
};


export type QueryEdiTransactionPayloadByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryEdiTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerms?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryEdiTransactionsByCompanyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailTransactionsArgs = {
  findEmailTransactionsInput: FindEmailTransactionsInput;
};


export type QueryEndOfDayDocumentProcessingJobsArgs = {
  companyUuid: Scalars['String']['input'];
  dateUploadedFor: Scalars['DateTime']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEquipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryEquipmentLicensesArgs = {
  equipmentUuid: Scalars['String']['input'];
};


export type QueryEquipmentsArgs = {
  includeNotActive?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<EquipmentType>>;
};


export type QueryEtaForCustomerPortalArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryExternalApiTransmissionPayloadByOrderEventUuidArgs = {
  orderEventUuid: Scalars['String']['input'];
};


export type QueryFeatureFlagArgs = {
  featureFlagInput: FeatureFlagInput;
};


export type QueryFeatureFlagCompanyOverridesArgs = {
  getFeatureFlagCompanyOverridesInput: GetFeatureFlagCompanyOverridesInput;
};


export type QueryFeatureFlagUserOverridesArgs = {
  getFeatureFlagUserOverridesInput: GetFeatureFlagUserOverridesInput;
};


export type QueryFeatureFlagsForCompanyGivenUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryFindByOrderUuidArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryFindCompanyOrdersInDateRangeArgs = {
  findCompanyOrdersInDateRangeInput: FindCompanyOrdersInDateRangeInput;
};


export type QueryFindMatchingOrphanPiecesForOrderArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryFindOrderByShipperBillOfLadingNumberArgs = {
  findOrderByShipperBillOfLadingNumberInput: FindOrderByShipperBillOfLadingNumberInput;
};


export type QueryFindOrphanPiecesByBarcodeArgs = {
  barcode: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindServicesForCustomerConfigurationArgs = {
  findServicesForCustomerConfigurationInput: FindServicesForCustomerConfigurationInput;
};


export type QueryFindTariffGroupsWithContactAndServiceCombinationArgs = {
  mappingsList: Array<ContactAndServicesCombination>;
};


export type QueryFindTariffZoneByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryFindTariffZoneByUuidOrThrowArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryFirstScannedOrderResultInReviewArgs = {
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryForwarderBoardArgs = {
  args: ForwarderBoardArgs;
};


export type QueryForwarderScorecardArgs = {
  args: ForwarderScorecardArgs;
};


export type QueryFreightCostArgs = {
  id: Scalars['String']['input'];
};


export type QueryFuelChargeFuelProfileDateRangeArgs = {
  fuelChargeFuelProfileDateRangeInput: FuelChargeFuelProfileDateRangeInput;
};


export type QueryFuelCostArgs = {
  id: Scalars['String']['input'];
};


export type QueryFuelProfileArgs = {
  findFuelProfileInput: FindFuelProfileInput;
};


export type QueryFuelProfileDateRangesArgs = {
  findFuelProfileDateRangesInput: FindFuelProfileDateRangesInput;
};


export type QueryFuelProfilesArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  excludeContactUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FuelProfileType>;
};


export type QueryFuzzySearchItemsBySkuNameArgs = {
  fuzzySearchItemsBySkuNameInput: FuzzySearchItemsBySkuNameInput;
};


export type QueryFuzzySearchOrdersByShippingBillOfLadingNumberArgs = {
  fuzzySearchOrdersByShipperBillOfLadingNumberInput: FuzzySearchOrdersByShipperBillOfLadingNumberInput;
};


export type QueryFuzzySearchStorageOrdersArgs = {
  fuzzySearchStorageOrdersInput: FuzzySearchStorageOrdersInput;
};


export type QueryFuzzySearchStorageUnitsArgs = {
  fuzzySearchStorageUnitsInput: FuzzySearchStorageUnitsInput;
};


export type QueryGenerateCsvOrderPreSignedPutUrlsArgs = {
  generateCsvOrderPresignedPutUrlInputs: Array<GenerateCsvOrderPresignedPutUrlInput>;
};


export type QueryGenerateCsvPresignedPutUrlForMappingPreviewArgs = {
  input: GenerateCsvPresignedPutUrlForMappingPreviewInput;
};


export type QueryGenerateDefaultAppointmentTextsArgs = {
  generateDefaultAppointmentTextsArgs: GenerateDefaultAppointmentTextsArgs;
};


export type QueryGenerateRoutesArgs = {
  generateRoutesInput: GenerateRoutesInput;
};


export type QueryGenerateScannedOrderPreSignedPutUrlsArgs = {
  preSignedUrlRequests: Array<PreSignedUrlRequestInput>;
};


export type QueryGetCityAndStateOptionsFromZipcodeArgs = {
  getCityAndStateOptionsFromZipcodeInput: GetCityAndStateOptionsFromZipcodeInput;
};


export type QueryGetFreightChargeArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetInvoiceCsvsArgs = {
  getInvoiceCsvsInput: GetInvoiceCsvsInput;
};


export type QueryGetJsonSchemaWithOverrideArgs = {
  schemaUuid: Scalars['String']['input'];
};


export type QueryGetLegDriverMapArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetLineHaulProgressArgs = {
  getLineHaulProgressInput: GetLineHaulProgressInput;
};


export type QueryGetOptimizationResultsArgs = {
  routeOptimizationUuid: Scalars['String']['input'];
};


export type QueryGetOrderTableFieldValuesArgs = {
  getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput;
};


export type QueryGetPackageArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetSavedFilterViewsArgs = {
  pageType: Scalars['String']['input'];
};


export type QueryGetSchemaMatchDetailsArgs = {
  getSchemaMatchDetailsInput: GetSchemaMatchDetailsInput;
};


export type QueryGetSftpCredentialsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetStandardOrderFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetStandardShipmentFieldsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetStructuredExtractionSchemaOverrideArgs = {
  schemaUuid: Scalars['String']['input'];
};


export type QueryGetTagArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryGetXyTransformArgs = {
  getXyTransformInput: GetXyTransformInput;
};


export type QueryGetZipcodeOptionsFromCityAndStateArgs = {
  getZipcodeOptionsFromCityAndStateInput: GetZipcodeOptionsFromCityAndStateInput;
};


export type QueryGlCodeReportPdfArgs = {
  glCodeReportPdfInput: GlCodeReportPdfInput;
};


export type QueryGroupByStopsArgs = {
  groupByStopsInput: GroupByStopsInput;
};


export type QueryGroupOrdersArgs = {
  input: GroupOrdersInput;
};


export type QueryHoldReasonsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInAppNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInboundMessagesForOrderArgs = {
  input: InboundMessagesForOrderInput;
};


export type QueryIncomeAnalysisReportArgs = {
  args: IncomeAnalysisReportArgs;
};


export type QueryIncomeAnalysisReportV2Args = {
  args: IncomeAnalysisReportArgs;
};


export type QueryIncomingOrganizationPeersArgs = {
  input: FindPaginatedOrganizationPeersInput;
};


export type QueryIncomingPeerAccessorialMappingsArgs = {
  peerUuid: Scalars['String']['input'];
};


export type QueryIncomingPeerServiceMappingsArgs = {
  peerUuid: Scalars['String']['input'];
};


export type QueryIngestedOutlookEmailArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryIngestedOutlookEmailAttachmentsArgs = {
  findIngestedOutlookEmailAttachmentsInput: FindIngestedOutlookEmailAttachmentsInput;
};


export type QueryIngestedOutlookEmailsArgs = {
  findIngestedOutlookEmailsInput: FindIngestedOutlookEmailsInput;
};


export type QueryIngestionTestRunArgs = {
  id: Scalars['String']['input'];
};


export type QueryInventoryCountArgs = {
  findInventoryCountInput: FindInventoryCountInput;
};


export type QueryInventoryCountsArgs = {
  findInventoryCountsInput: FindInventoryCountsInput;
};


export type QueryInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryInvoiceBillingSummaryReportV2Args = {
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
};


export type QueryInvoiceBillingSummaryReportV2PdfArgs = {
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
};


export type QueryInvoiceBillingSummaryReportV2PdfUrlArgs = {
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
};


export type QueryInvoiceDocumentsArgs = {
  invoiceUuid: Scalars['String']['input'];
};


export type QueryInvoiceEdiTransactionsArgs = {
  findInvoiceEdiTransactionsInput: FindInvoiceEdiTransactionsInput;
};


export type QueryInvoiceEmailsApiLogsArgs = {
  findInvoiceEmailsApiLogsInput: FindInvoiceEmailsApiLogsInput;
};


export type QueryInvoiceExcelExportDataArgs = {
  invoiceUuids: Array<Scalars['String']['input']>;
};


export type QueryInvoiceGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy: InvoiceTableGroupByInput;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  groupPath?: InputMaybe<Array<InvoiceTableGroupPathEntryInput>>;
  hasQuickbooksSyncFailure?: InputMaybe<Scalars['Boolean']['input']>;
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooks?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  quickbooksSyncFailureCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  removeLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInvoiceNoteRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvoiceRegisterReportCsvArgs = {
  invoiceRegisterReportInput: InvoiceRegisterReportInput;
};


export type QueryInvoiceRegisterReportPdfArgs = {
  invoiceRegisterReportInput: InvoiceRegisterReportInput;
};


export type QueryInvoiceSendJobBatchesArgs = {
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<Array<DateFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasFailures?: InputMaybe<Scalars['Boolean']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortByCreatedAtAsc?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<InvoiceSendJobBatchType>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInvoiceSendJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceSendJobBatchUuid: Scalars['String']['input'];
  invoiceSendJobStatus?: InputMaybe<InvoiceSendJobStatus>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  groupPath?: InputMaybe<Array<InvoiceTableGroupPathEntryInput>>;
  hasQuickbooksSyncFailure?: InputMaybe<Scalars['Boolean']['input']>;
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooks?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  quickbooksSyncFailureCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  removeLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  statuses?: InputMaybe<Array<InvoiceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInvoicesByUuidsArgs = {
  includeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  uuids: Array<Scalars['String']['input']>;
};


export type QueryItemArgs = {
  itemUuid: Scalars['String']['input'];
};


export type QueryItemGroupsArgs = {
  findItemGroupsInput: FindItemGroupsInput;
};


export type QueryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryItemsBySkuNameArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};


export type QueryKpiComparisonsArgs = {
  args: KpiReportArgs;
};


export type QueryLaneFromOriginAndDestinationTerminalArgs = {
  findLaneFromOriginAndDestinationTerminalInput: FindLaneFromOriginAndDestinationTerminalInput;
};


export type QueryLegArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryLegsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxOneUnassignedPerShipment?: InputMaybe<Scalars['Boolean']['input']>;
  shipHasArrived?: InputMaybe<Scalars['Boolean']['input']>;
  showUnscheduled?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<LegStatus>>;
};


export type QueryLineHaulDriverConflictArgs = {
  input: LineHaulDriverConflictInput;
};


export type QueryLineHaulFuelChargeFuelProfileDateRangeArgs = {
  lineHaulFuelChargeFuelProfileDateRangeInput: LineHaulFuelChargeFuelProfileDateRangeInput;
};


export type QueryLineHaulLaneArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryLineHaulManifestArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryLineHaulManifestsArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryLineHaulManifestsGroupsArgs = {
  input: LineHaulManifestsGroupsInput;
};


export type QueryLineHaulRunConfigsArgs = {
  manifestUuids: Array<Scalars['String']['input']>;
};


export type QueryLineHaulSegmentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryLineHaulTrailerAssignmentsArgs = {
  manifestUuids: Array<Scalars['String']['input']>;
};


export type QueryLineHaulUtilizationReportArgs = {
  args: LineHaulUtilizationArgs;
};


export type QueryLinehaulRevenueReportArgs = {
  LineHaulRevenueReportInput: LineHaulRevenueReportInput;
};


export type QueryManualStandardStopTypeForAddressArgs = {
  input: ManualStandardStopTypeForAddressInput;
};


export type QueryMirrorTargetCompaniesArgs = {
  targetUuid: Scalars['String']['input'];
};


export type QueryMobileFeatureFlagArgs = {
  featureFlagInput: FeatureFlagInput;
};


export type QueryMyGroupedStopUuidsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyLineHaulManifestArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryMyRouteArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maximumTake?: InputMaybe<Scalars['Int']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyStopsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMyStopsByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryNetSalesSummaryReportArgs = {
  netSalesSummaryReportInput: NetSalesSummaryReportInput;
};


export type QueryNotificationShadowComparisonSummaryArgs = {
  filter?: InputMaybe<NotificationShadowComparisonFilterInput>;
};


export type QueryNotificationShadowComparisonsArgs = {
  filter?: InputMaybe<NotificationShadowComparisonFilterInput>;
};


export type QueryNumberOfOrdersArgs = {
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  customerFilter?: InputMaybe<StringFilter>;
  customerNameFilter?: InputMaybe<StringFilterV2>;
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filterOutOldFlowConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  includeOrdersPartOfV2ConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  itNumberFilter?: InputMaybe<StringFilterV2>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  orderCityFilter?: InputMaybe<StringFilterV2>;
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  versionId?: InputMaybe<Scalars['Float']['input']>;
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};


export type QueryNumberOfScannedOrderResultDuplicatesArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfScannedOrderResultsApprovedArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfScannedOrderResultsFailedArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfScannedOrderResultsInProgressArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfScannedOrderResultsInReviewArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfScannedOrderResultsRejectedArgs = {
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNumberOfStopsArgs = {
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput>>;
  groupFilters?: InputMaybe<GroupByStopsFiltersInput>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  onHandTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery>>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  standardStopTypes?: InputMaybe<Array<StandardStopType>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<StopStatus>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOnTimeKpiArgs = {
  args: OnTimeKpiArgs;
};


export type QueryOnTimeKpiStopsArgs = {
  args: OnTimeKpiStopsArgs;
};


export type QueryOnTimePerformanceReportCsvArgs = {
  onTimePerformanceReportInput: OnTimePerformanceReportInput;
};


export type QueryOnTimePerformanceReportPdfArgs = {
  onTimePerformanceReportInput: OnTimePerformanceReportInput;
};


export type QueryOpenInvoiceReportArgs = {
  openInvoiceReportArgs: OpenInvoiceReportArgs;
};


export type QueryOperationalEfficiencyReportArgs = {
  args: OperationalEfficiencyArgs;
};


export type QueryOperationsPerformanceReportArgs = {
  args: OperationsPerformancePageArgs;
};


export type QueryOperationsPerformanceReportCsvArgs = {
  args: OperationsPerformanceFilterArgs;
};


export type QueryOperationsPerformanceSummaryArgs = {
  args: OperationsPerformanceFilterArgs;
};


export type QueryOptimizationStatusArgs = {
  jobUuid: Scalars['String']['input'];
};


export type QueryOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrderAmountsToPayForHawbArgs = {
  amountInCents: Scalars['Float']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  hawb: Scalars['String']['input'];
};


export type QueryOrderAmountsToPayForInvoiceArgs = {
  amountInCents: Scalars['Float']['input'];
  invoiceUuids: Array<Scalars['String']['input']>;
};


export type QueryOrderAuditLogEntriesArgs = {
  getOrderAuditLogEntriesInput: GetOrderAuditLogEntriesInput;
};


export type QueryOrderCommentsArgs = {
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderEventNotificationSubscriptionsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryOrderEventsArgs = {
  eventType?: InputMaybe<OrderEventType>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pieceReceiptUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtAsc?: InputMaybe<Scalars['Boolean']['input']>;
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderNameArgs = {
  billingPartyContactUuid: Scalars['String']['input'];
};


export type QueryOrderQuoteArgs = {
  orderQuoteUuid: Scalars['String']['input'];
};


export type QueryOrderQuoteForOrderArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryOrderQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtFilter?: InputMaybe<DateFilterV2>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  needsActionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  needsAttentionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<OrderQuoteQueueScope>;
  statusFilter?: InputMaybe<OrderQuoteStatusFilter>;
};


export type QueryOrderReportArgs = {
  args: OrderReportArgs;
};


export type QueryOrderReportByReportGroupArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrderRevenueReportArgs = {
  orderRevenueReportInput: OrderRevenueReportInput;
};


export type QueryOrderUuidsInViewArgs = {
  findOrderUuidsInViewInput: FindOrderUuidsInViewInput;
};


export type QueryOrderVolumeByCompanyReportArgs = {
  orderVolumeByCompanyInput: OrderVolumeByCompanyInput;
};


export type QueryOrderVolumeByContactReportArgs = {
  orderVolumeByContactInput: OrderVolumeByContactInput;
};


export type QueryOrderVolumeByDateRangeReportArgs = {
  orderVolumeByDateRangeInput: OrderVolumeByDateRangeInput;
};


export type QueryOrderVolumeBySchemaReportArgs = {
  orderVolumeBySchemaInput: OrderVolumeBySchemaInput;
};


export type QueryOrderVolumeByUserReportArgs = {
  orderVolumeByUserInput: OrderVolumeByUserInput;
};


export type QueryOrdersArgs = {
  activeTerminalFilter?: InputMaybe<StringFilterV2>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  appointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  businessDivisionNameFilter?: InputMaybe<StringFilterV2>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilterV2?: InputMaybe<StringFilterV2>;
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  completedAtDateFilter?: InputMaybe<DateFilterV2>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  consigneeFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilter?: InputMaybe<StringFilter>;
  controllingTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  customerFilter?: InputMaybe<StringFilter>;
  customerNameFilter?: InputMaybe<StringFilterV2>;
  customerUuidFilter?: InputMaybe<StringFilterV2>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  destinationTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  dimWeightFilter?: InputMaybe<FloatFilterV2>;
  driverNameFilter?: InputMaybe<StringFilterV2>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilterV2?: InputMaybe<StringFilterV2>;
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  endStopFilter?: InputMaybe<StringFilter>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  externalNotesFilter?: InputMaybe<StringFilterV2>;
  filterOutOldFlowConsolidatedOrders?: InputMaybe<BooleanFilterV2>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  hasAppointmentScheduledFilter?: InputMaybe<BooleanFilterV2>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasContactInformationFilter?: InputMaybe<BooleanFilterV2>;
  hasDamageFilter?: InputMaybe<BooleanFilterV2>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasFailuresFilter?: InputMaybe<BooleanFilterV2>;
  hasIssuesFilter?: InputMaybe<BooleanFilterV2>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hasRouteFilter?: InputMaybe<BooleanFilterV2>;
  hasShortageFilter?: InputMaybe<BooleanFilterV2>;
  hawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  hideFromBillingFilter?: InputMaybe<BooleanFilterV2>;
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  holdReasonFilter?: InputMaybe<StringFilterV2>;
  inboundAddressFilter?: InputMaybe<StringFilterV2>;
  inboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  inboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  inboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  inboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  inboundCityFilter?: InputMaybe<StringFilterV2>;
  inboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  inboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  inboundContactNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  inboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  inboundMethodFilter?: InputMaybe<StopType>;
  inboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  inboundNotArrivedFilter?: InputMaybe<BooleanFilterV2>;
  inboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  inboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  inboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  inboundTerminalFilter?: InputMaybe<StringFilterV2>;
  inboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  includeOrdersPartOfV2ConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isCancelledFilter?: InputMaybe<BooleanFilterV2>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCollectOnDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isFinalizedFilter?: InputMaybe<BooleanFilterV2>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isHazmatFilter?: InputMaybe<BooleanFilterV2>;
  isInBond?: InputMaybe<BooleanFilter>;
  isInBondFilter?: InputMaybe<BooleanFilterV2>;
  isLineHaul?: InputMaybe<BooleanFilter>;
  isLineHaulFilter?: InputMaybe<BooleanFilterV2>;
  isOsd?: InputMaybe<BooleanFilter>;
  isOsdFilter?: InputMaybe<BooleanFilterV2>;
  isPicked?: InputMaybe<BooleanFilter>;
  isPickedFilter?: InputMaybe<BooleanFilterV2>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  isPickupOrDeliveryFilter?: InputMaybe<BooleanFilterV2>;
  isRefused?: InputMaybe<BooleanFilter>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isReweighedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<BooleanFilter>;
  isSpecialFilter?: InputMaybe<BooleanFilterV2>;
  itNumberFilter?: InputMaybe<StringFilterV2>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lineHaulLaneFilter?: InputMaybe<UuidFilterV2>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  markedOnHandDateFilter?: InputMaybe<DateFilterV2>;
  mawbFilter?: InputMaybe<StringFilterV2>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  noTerminal?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onHandFilter?: InputMaybe<BooleanFilterV2>;
  onHoldFilter?: InputMaybe<BooleanFilterV2>;
  onInvoice?: InputMaybe<BooleanFilter>;
  onInvoiceFilter?: InputMaybe<BooleanFilterV2>;
  orderCityFilter?: InputMaybe<StringFilterV2>;
  orderNameFilterV2?: InputMaybe<StringFilterV2>;
  orderNotesFilter?: InputMaybe<StringFilterV2>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  orderServiceDateFilter?: InputMaybe<DateFilterV2>;
  orderSource?: InputMaybe<OrderSource>;
  orderSourceFilter?: InputMaybe<OrderSourceFilter>;
  orderStatusFilter?: InputMaybe<OrderStatusFilter>;
  orderZipFilter?: InputMaybe<StringFilterV2>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  originTerminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  osdReasonFilter?: InputMaybe<StringFilterV2>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilterV2?: InputMaybe<BooleanFilterV2>;
  outboundAddressFilter?: InputMaybe<StringFilterV2>;
  outboundAddressTypeFilter?: InputMaybe<StandardStopTypeFilter>;
  outboundAppointmentConfirmedFilter?: InputMaybe<BooleanFilterV2>;
  outboundAppointmentDateFilter?: InputMaybe<DateFilterV2>;
  outboundAppointmentRequiredFilter?: InputMaybe<BooleanFilterV2>;
  outboundCityFilter?: InputMaybe<StringFilterV2>;
  outboundCompletedDateFilter?: InputMaybe<DateFilterV2>;
  outboundCompletedFilter?: InputMaybe<BooleanFilterV2>;
  outboundContactNameFilter?: InputMaybe<StringFilterV2>;
  outboundDestinationAirportFilter?: InputMaybe<StringFilterV2>;
  outboundDriverNameFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidFilter?: InputMaybe<StringFilterV2>;
  outboundDriverUuidsFilter?: InputMaybe<StringsFilter>;
  outboundMethodFilter?: InputMaybe<StopType>;
  outboundMethodFilterV2?: InputMaybe<StopTypesV2Filter>;
  outboundRouteNameFilter?: InputMaybe<StringFilterV2>;
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  outboundServiceDateFilter?: InputMaybe<DateFilterV2>;
  outboundStopTypeFilter?: InputMaybe<StopTypeFilter>;
  outboundTerminalFilter?: InputMaybe<StringFilterV2>;
  outboundZipcodeFilter?: InputMaybe<StringFilterV2>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  paperworkCompleteFilter?: InputMaybe<BooleanFilterV2>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  proofOfDeliveryNameFilter?: InputMaybe<StringFilterV2>;
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
  receivedAtOriginFilter?: InputMaybe<BooleanFilterV2>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  requiresRecoveryFilter?: InputMaybe<BooleanFilterV2>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRoutingFilter?: InputMaybe<BooleanFilterV2>;
  routingLocationFilter?: InputMaybe<StringFilterV2>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  scheduledFilterV2?: InputMaybe<BooleanFilterV2>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  secondaryReferenceNumberFilter?: InputMaybe<StringFilterV2>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelFilter?: InputMaybe<StringFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter>>;
  shipperFilter?: InputMaybe<StringFilter>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  showConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  sortsV2?: InputMaybe<Array<OrderSortV2>>;
  standardStopType?: InputMaybe<StandardStopType>;
  startStopFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter>>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  tagsFilter?: InputMaybe<StringFilterV2>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilterV2?: InputMaybe<StringFilterV2>;
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  totalAmountDollarsFilter?: InputMaybe<FloatFilterV2>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  totalPiecesFilter?: InputMaybe<IntegerFilterV2>;
  totalSkidsFilter?: InputMaybe<IntegerFilterV2>;
  totalWeightFilter?: InputMaybe<FloatFilterV2>;
  transferPending?: InputMaybe<BooleanFilter>;
  transferPendingFilter?: InputMaybe<BooleanFilterV2>;
  unNumberFilter?: InputMaybe<StringFilterV2>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  versionId?: InputMaybe<Scalars['Float']['input']>;
  zipcodeFilter?: InputMaybe<StringFilterV2>;
};


export type QueryOrdersByMasterAirwayBillOfLadingNumberArgs = {
  masterAirwayBillOfLadingNumber: Scalars['String']['input'];
};


export type QueryOrdersBySecondaryRefNumberArgs = {
  secondaryRefNumber: Scalars['String']['input'];
};


export type QueryOrdersByShipperBillOfLadingNumberArgs = {
  includeInReviewEdiOrders?: InputMaybe<Scalars['Boolean']['input']>;
  includeInReviewScannedOrdersFromEmail?: InputMaybe<Scalars['Boolean']['input']>;
  includeTemplateOrders?: InputMaybe<Scalars['Boolean']['input']>;
  shipperBillOfLadingNumber: Scalars['String']['input'];
};


export type QueryOrdersByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryOrdersForPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  currentPaymentUuid?: InputMaybe<Scalars['String']['input']>;
  filterOutZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupOrdersBy?: GroupOrdersForPaymentsBy;
  includeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeTotalCountsByInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<OrdersForPaymentsSort>>;
};


export type QueryOrganizationArgs = {
  input: FindOrganizationInput;
};


export type QueryOrganizationEffectivePackageTypeConfigsArgs = {
  organizationUuid: Scalars['String']['input'];
};


export type QueryOrganizationMessageArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrganizationMessageHistoryArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrganizationMessageReachArgs = {
  audience: OrganizationMessageAudienceInput;
};


export type QueryOrganizationMessageStatsArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrganizationMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  view?: InputMaybe<OrganizationMessageView>;
};


export type QueryOrganizationNotesArgs = {
  findOrganizationNotesInput: FindOrganizationNotesInput;
};


export type QueryOrganizationPackageTypeConfigsArgs = {
  organizationUuid: Scalars['String']['input'];
};


export type QueryOrganizationPeersArgs = {
  input: FindPaginatedOrganizationPeersInput;
};


export type QueryOutboundBenchCompanyUsersArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryOutboundBenchDriversArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryOutboundBenchEdiPayloadArgs = {
  ediTransactionUuid: Scalars['String']['input'];
};


export type QueryOutboundBenchOrdersArgs = {
  input: OutboundBenchOrderSearchInput;
};


export type QueryOutboundBenchServiceLevelsArgs = {
  partnershipUuid: Scalars['String']['input'];
};


export type QueryOutlookIntegrationsForInternalArgs = {
  getOutlookIntegrationsForInternalInput: GetOutlookIntegrationsForInternalInput;
};


export type QueryOutstandingInvoicesForCustomerArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryOutstandingOrdersForReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  includeUuids?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  isUnfinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']>>;
  orderCompletionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderCompletionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<OrderSort>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids: Array<Scalars['String']['input']>;
};


export type QueryOutstandingShipmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactDisplayName?: InputMaybe<StringFilter>;
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  isUnfinalized?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  orderUuids: Array<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopCompletionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopCompletionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryOverdueInvoicesArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryPackageHasPieceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPackageSpecArgs = {
  id: Scalars['String']['input'];
};


export type QueryPackingPendenciesArgs = {
  input: FindPackingPendenciesInput;
};


export type QueryPackingPieceByBarcodeArgs = {
  input: PackingPieceByBarcodeInput;
};


export type QueryPackingPiecesArgs = {
  input: PackingPiecesInput;
};


export type QueryPaginatedContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  checkHasTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  checkHasTariffs?: InputMaybe<Scalars['Boolean']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByContactName?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByOrderNumberDescending?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaginatedOrdersByInvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoiceUuid: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByShipperBillOfLadingNumberAsc?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindOrdersOnInvoiceSort>>;
};


export type QueryPaginatedOrganizationsArgs = {
  findPaginatedOrganizationsInput: FindPaginatedOrganizationsInput;
};


export type QueryPaginatedRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maximumTake?: InputMaybe<Scalars['Int']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  routeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryParseAddressArgs = {
  address: Scalars['String']['input'];
};


export type QueryPaymentApplicationReportArgs = {
  args: FindPaymentsV2Args;
};


export type QueryPaymentByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPaymentCustomerScopeArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryPaymentJournalReportArgs = {
  args: FindPaymentsV2Args;
};


export type QueryPaymentsByInvoiceUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPaymentsV2Args = {
  args: FindPaymentsV2Args;
};


export type QueryPdProductivityReportArgs = {
  args: PdProductivityArgs;
};


export type QueryPdfColumnArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPeerAccessorialSharesArgs = {
  peerUuid: Scalars['String']['input'];
};


export type QueryPeerServiceSharesArgs = {
  peerUuid: Scalars['String']['input'];
};


export type QueryPersonArgs = {
  id: Scalars['String']['input'];
};


export type QueryPersonsArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPicklistsArgs = {
  picklistsInput: PicklistsInput;
};


export type QueryPieceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPieceBackfillRunArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPieceBackfillRunsArgs = {
  input: PieceBackfillRunsInput;
};


export type QueryPieceBackfillSurveyArgs = {
  input: PieceBackfillSurveyInput;
};


export type QueryPieceBucketMetricsArgs = {
  input: PieceBucketMetricsInput;
};


export type QueryPieceReceiptArgs = {
  findPieceReceiptInput: FindPieceReceiptInput;
};


export type QueryPieceReceiptPieceArgs = {
  pieceReceiptUuid: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};


export type QueryPieceReceiptsArgs = {
  findPieceReceiptsInput: FindPieceReceiptsInput;
};


export type QueryPieceScanKpiArgs = {
  args: KpiReportArgs;
};


export type QueryPieceScanKpiPiecesArgs = {
  args: KpiRecordTableArgs;
};


export type QueryPiecesArgs = {
  findPiecesInput: FindPiecesInput;
};


export type QueryPiecesByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryPiecesGroupedByStatusArgs = {
  piecesGroupedByStatusInput: PiecesGroupedByStatusInput;
};


export type QueryPlaceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryPlanOutboundBenchRunArgs = {
  input: PlanOutboundBenchRunInput;
};


export type QueryPlanQuickbooksSyncArgs = {
  options?: InputMaybe<QuickbooksSyncOptionsInput>;
  uuids: Array<Scalars['String']['input']>;
};


export type QueryPointToPointLanesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  tariffGroupUuid: Scalars['String']['input'];
};


export type QueryPrefillInspectionArgs = {
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  senderAddress?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewAddOrdersToInvoicesArgs = {
  previewAddOrdersToInvoicesInput: PreviewAddOrdersToInvoicesInput;
};


export type QueryPreviewBatchAddShipmentsToInvoicesArgs = {
  batchAddShipmentsToInvoicesInput: BatchAddShipmentsToInvoicesInput;
};


export type QueryPreviewBatchAddShipmentsToInvoicesMultipleArgs = {
  batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple;
};


export type QueryPreviewInventoryCountScopeArgs = {
  previewInventoryCountScopeInput: PreviewInventoryCountScopeInput;
};


export type QueryPreviewParseCsvOrdersArgs = {
  input: PreviewParseCsvOrdersInput;
};


export type QueryPreviewProratedConsolidationArgs = {
  previewProratedConsolidationInput: PreviewProratedConsolidationInput;
};


export type QueryPreviewProratedConsolidationV2Args = {
  previewProratedConsolidationV2Input: PreviewProratedConsolidationV2Input;
};


export type QueryQuoteArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryQuoteContributionRatioArgs = {
  input: QuoteContributionRatioInput;
  rateOrderInput: RateOrderInput;
};


export type QueryQuoteConversationArgs = {
  orderQuoteUuid: Scalars['String']['input'];
};


export type QueryQuoteNameArgs = {
  billingPartyContactUuid: Scalars['String']['input'];
};


export type QueryQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  quoteStatus?: InputMaybe<QuoteStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRateAutoAppliedAccessorialsArgs = {
  rateAutoAppliedAccessorialsInput: RateAutoAppliedAccessorialsInput;
};


export type QueryRateOrderByUuidArgs = {
  persist: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
  withholdExpiredTariffFallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRateOrderContentsArgs = {
  rateOrderInput: RateOrderInput;
  withholdExpiredTariffFallback?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryReceiptItemStorageUnitsArgs = {
  itemUuid: Scalars['String']['input'];
  receiptUuid: Scalars['String']['input'];
};


export type QueryRecurringLineHaulManifestTemplateArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRecurringOrderFrequencyArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRecurringOrderTemplatesArgs = {
  runUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecurringTemplateTrucksArgs = {
  recurringTemplateUuid: Scalars['String']['input'];
};


export type QueryReferenceNumberFormatConfigsArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryRemainingAmountOfInvoicesArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryReportSendJobBatchesArgs = {
  findReportSendJobBatchesInput: FindReportSendJobBatchesInput;
};


export type QueryReportSendJobsArgs = {
  findReportSendJobsInput: FindReportSendJobsInput;
};


export type QueryReportsEmailSenderIsVerifiedArgs = {
  userUuid: Scalars['String']['input'];
};


export type QueryResolveProvenanceNeighborArgs = {
  neighborUuid: Scalars['String']['input'];
  scannedOrderUuid: Scalars['String']['input'];
};


export type QueryRoleArgs = {
  findRoleInput: FindRoleInput;
};


export type QueryRolesArgs = {
  findRolesInput?: InputMaybe<FindRolesInput>;
};


export type QueryRouteArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRouteNameArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryRoutesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maximumTake?: InputMaybe<Scalars['Int']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  routeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  versionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoutesSamsaraVehicleLocationsArgs = {
  routeUuids: Array<Scalars['String']['input']>;
};


export type QuerySageBusinessWorksInvoiceExportCsvArgs = {
  invoiceUuids: Array<Scalars['String']['input']>;
};


export type QuerySalesVarianceReportCsvArgs = {
  salesVarianceReportInput: SalesVarianceReportInput;
};


export type QuerySamsaraDiscoveryExportArgs = {
  input: SamsaraDiscoveryExportInput;
};


export type QuerySamsaraDiscoveryMonthlyOverviewArgs = {
  input: SamsaraDiscoveryMonthlyOverviewInput;
};


export type QuerySamsaraDiscoveryRowsArgs = {
  input: SamsaraDiscoveryRowsInput;
};


export type QuerySamsaraDriversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySamsaraVehicleStatsFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  samsaraVehicleIds: Array<Scalars['String']['input']>;
};


export type QuerySamsaraVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScannedOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScannedOrderProvenanceArgs = {
  scannedOrderUuid: Scalars['String']['input'];
};


export type QueryScannedOrderResultArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScannedOrderResultByOrderUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScannedOrderResultForAdminArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryScannedOrderResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  approvedAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  failureReasonFilter?: InputMaybe<ScannedOrderFailureReason>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  rejectedAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  signedPodMatchStatuses?: InputMaybe<Array<SignedPodMatchStatus>>;
  sourceFilter?: ScannedOrderResultSourceFilter;
  status?: InputMaybe<ScannedOrderResultStatus>;
  statuses?: InputMaybe<Array<ScannedOrderResultStatus>>;
  type: ScannedOrderResultType;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryScannedOrderResultsForAdminArgs = {
  args: GetScannedOrderResultsForAdminArgs;
};


export type QueryScannedOrdersArgs = {
  findScannedOrdersInput: FindScannedOrdersInput;
};


export type QueryScannedOrdersByUuidsArgs = {
  uuids: Array<Scalars['String']['input']>;
};


export type QueryScanningV2__OrderInfoArgs = {
  input: FreightScanningV2OrderInfoInput;
};


export type QueryScanningV2__PieceInfoArgs = {
  input: FreightScanningV2PieceInfoInput;
};


export type QueryScanningV2__ScanJobStatusesArgs = {
  input: FreightScanningV2ScanJobStatusesInput;
};


export type QuerySchedulingRegionArgs = {
  id: Scalars['String']['input'];
};


export type QuerySchedulingResourceArgs = {
  id: Scalars['String']['input'];
};


export type QuerySchedulingResourcesArgs = {
  input?: InputMaybe<FindSchedulingResourcesInput>;
};


export type QuerySchedulingResourcesByRouteNameArgs = {
  input: FindSchedulingResourcesByRouteNameInput;
};


export type QuerySchemaCompanyMappingsArgs = {
  schemaUuid: Scalars['String']['input'];
};


export type QuerySchemaDocumentsBySchemaCompanyMappingArgs = {
  schemaCompanyMappingId: Scalars['String']['input'];
};


export type QuerySchemaFilePutUrlArgs = {
  schemaFilePutUrlInput: SchemaFilePutUrlInput;
};


export type QuerySchemaRunArgs = {
  uuid: Scalars['String']['input'];
};


export type QuerySchemaRunTestListArgs = {
  schemaRunTestListInput: SchemaRunTestListInput;
};


export type QuerySchemaTestFilePutUrlArgs = {
  schemaTestFilePutUrlInput: SchemaTestFilePutUrlInput;
};


export type QuerySearchSchemasArgs = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySegmentedLineHaulOrdersArgs = {
  findSegmentedLineHaulOrdersInput: FindSegmentedLineHaulOrdersInput;
};


export type QuerySegmentedLineHaulOrdersV2Args = {
  findSegmentedLineHaulOrdersInputV2: FindSegmentedLineHaulOrdersInputV2;
};


export type QuerySelectSpecialAccessorialArgs = {
  selectSpecialAccessorialInput: SelectSpecialAccessorialInput;
};


export type QueryServiceGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryServiceLevelReportArgs = {
  args: ServiceLevelReportArgs;
};


export type QueryServiceRegionArgs = {
  id: Scalars['String']['input'];
};


export type QueryServiceRegionsArgs = {
  input: GetServiceRegionsInput;
};


export type QueryServicesForOrderArgs = {
  findServicesForOrderInput: FindServicesForOrderInput;
};


export type QueryServicesForThirdPartyUserArgs = {
  findServicesForThirdPartyUserInput: FindServicesForThirdPartyUserInput;
};


export type QuerySettlementBillChangeFlagsArgs = {
  uuid: Scalars['String']['input'];
};


export type QuerySettlementBillLineItemArgs = {
  id: Scalars['String']['input'];
};


export type QuerySettlementBillLineItemsArgs = {
  findSettlementBillLineItemInput: FindSettlementBillLineItemsInput;
};


export type QuerySftpUploadsArgs = {
  findSftpUploadsInput: FindSftpUploadsInput;
};


export type QueryShipmentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryShipmentV2Args = {
  uuid: Scalars['String']['input'];
};


export type QueryShipmentsArgs = {
  getShipmentsInput?: InputMaybe<GetShipmentsInput>;
};


export type QueryShipmentsByContactUuidArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  endCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  startCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryShipmentsByPhoneOrReferenceNumberArgs = {
  companyUuid: Scalars['String']['input'];
  searchText: Scalars['String']['input'];
};


export type QuerySmsConsentAdminListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SmsConsentAdminFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStandardOrderArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryStandardOrderForReviewArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryStationReportArgs = {
  args: StationReportArgs;
};


export type QueryStopArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryStopDriverMapsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chargesFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  completedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  completionStatus?: InputMaybe<StopCompletionStatus>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverSettlementFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  excludeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceStatuses?: InputMaybe<Array<InvoiceStatus>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  onDriverSettlementBill?: InputMaybe<Scalars['Boolean']['input']>;
  onInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  settlementEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortByCompletedDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  stopTypes?: InputMaybe<Array<StopType>>;
};


export type QueryStopUuidsInGroupArgs = {
  addressType?: InputMaybe<StandardStopType>;
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  cacheStartIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<StopTableGroupByInput>;
  groupFilters?: InputMaybe<GroupByStopsFiltersInput>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeRecurringRunHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  onHandTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery>>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<StopSort>;
  sorts?: InputMaybe<Array<StopSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<StopStatus>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStopsArgs = {
  addressType?: InputMaybe<StandardStopType>;
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  before?: InputMaybe<Scalars['String']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  cacheStartIndex?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<StopTableGroupByInput>;
  groupFilters?: InputMaybe<GroupByStopsFiltersInput>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeRecurringRunHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  onHandTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery>>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<StopSort>;
  sorts?: InputMaybe<Array<StopSort>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<StopStatus>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStopsBySearchTextArgs = {
  searchText: Scalars['String']['input'];
};


export type QueryStopsOnRoutesBySearchTextArgs = {
  searchText: Scalars['String']['input'];
};


export type QueryStorageOrderArgs = {
  findStorageOrderInput: FindStorageOrderInput;
};


export type QueryStorageOrderStorageUnitsArgs = {
  findStorageOrderStorageUnitsInput: FindStorageOrderStorageUnitsInput;
};


export type QueryStorageOrdersArgs = {
  findStorageOrdersInput: FindStorageOrdersInput;
};


export type QueryStorageUnitArgs = {
  findStorageUnitInput: FindStorageUnitInput;
};


export type QueryStorageUnitByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryStorageUnitsArgs = {
  findStorageUnitsInput: FindStorageUnitsInput;
};


export type QueryStructuredExtractionRunByScannedOrderArgs = {
  scannedOrderUuid: Scalars['String']['input'];
};


export type QueryTariffArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTariffChainsArgs = {
  findTariffChainsInput: FindTariffChainsInput;
};


export type QueryTariffGroupArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTariffGroupsArgs = {
  excludeDefault?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTariffGroupsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  excludeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  tariffGroupType?: InputMaybe<TariffGroupType>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTariffZoneGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryTariffZoneGroupsArgs = {
  findTariffZoneGroupsInput: FindTariffZoneGroupsInput;
};


export type QueryTariffZonesArgs = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  defaultToGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  excludeLineHaulTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  excludeMileBasedTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  tariffZoneLocationType?: InputMaybe<TariffZoneLocationType>;
  tariffZoneType?: InputMaybe<TariffZoneType>;
};


export type QueryTariffsByContactArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryTemplateAddressesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenediConnectionArgs = {
  input: TenediConnectionInput;
};


export type QueryTenediConnectionCustomersArgs = {
  input: TenediConnectionCustomersInput;
};


export type QueryTerminalArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTerminalEfficiencyReportArgs = {
  args: TerminalEfficiencyArgs;
};


export type QueryTerminalForAddressArgs = {
  findTerminalForAddressInput: FindTerminalForAddressInput;
};


export type QueryTerminalReportArgs = {
  args: TerminalReportArgs;
};


export type QueryTerminalsArgs = {
  getTerminalsInput?: InputMaybe<GetTerminalsInput>;
};


export type QueryTerminalsForAddressArgs = {
  findTerminalForAddressInput: FindTerminalForAddressInput;
};


export type QueryTerminalsForInternalArgs = {
  getTerminalsInternalInput: GetTerminalsInternalInput;
};


export type QueryTerminalsForThirdPartyUserArgs = {
  findTerminalsForThirdPartyUserInput: FindTerminalsForThirdPartyUserInput;
};


export type QueryTestJsonSchemaOnDocumentsForSchemaArgs = {
  testJsonSchemaOnDocumentsForSchemaInput: TestJsonSchemaOnDocumentsForSchemaInput;
};


export type QueryTestOrderArgs = {
  findTestOrderInput: FindTestOrderInput;
};


export type QueryThirdPartyUserArgs = {
  email: Scalars['String']['input'];
};


export type QueryThirdPartyUserByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryThirdPartyUsersByContactArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryUnappliedPaymentReportCsvArgs = {
  unappliedPaymentReportCsvInput: UnappliedPaymentReportCsvInput;
};


export type QueryUnifiedSearchArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchInvoicesArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchOrdersArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchQuotesArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchUnacceptedEdiAndApiOrdersArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUnifiedSearchUnacceptedEmailOrdersArgs = {
  unifiedSearchInput: UnifiedSearchInput;
};


export type QueryUserContactNotificationSubscriptionArgs = {
  contactUuid: Scalars['String']['input'];
};


export type QueryUserOptionsArgs = {
  getUsersInput?: InputMaybe<GetUsersInput>;
};


export type QueryUserSessionsAdminCompanyUsersArgs = {
  companyUuid: Scalars['String']['input'];
};


export type QueryUserSessionsAdminSearchCompaniesArgs = {
  input: UserSessionsAdminCompanySearchInput;
};


export type QueryUsersArgs = {
  getUsersInput?: InputMaybe<GetUsersInput>;
};


export type QueryUsersEditingOrderArgs = {
  orderUuid: Scalars['String']['input'];
};


export type QueryValidateBulkEditOrdersArgs = {
  bulkEditOrdersInput: BulkEditOrdersInput;
};


export type QueryVehicleTypeArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryVerifySchemaDocumentMatchesForCompanyArgs = {
  companyUuid: Scalars['String']['input'];
  schemaDocumentUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWarehouseArgs = {
  warehouseUuid: Scalars['String']['input'];
};


export type QueryWarehouseAddressOfFirstRouteSlotArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryWarehouseLocationsArgs = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWarehousesArgs = {
  warehousesInput?: InputMaybe<WarehousesInput>;
};


export type QueryWeightBreakReportArgs = {
  args: WeightBreakArgs;
};


export type QueryWhiteLabelCompanyArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryWmsContactsArgs = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkOrderCountArgs = {
  input: WorkOrderListInput;
};


export type QueryWorkOrdersArgs = {
  input: WorkOrderListInput;
};

export type QueryErrorOutput = {
  __typename?: 'QueryErrorOutput';
  message: Scalars['String']['output'];
};

export type QueueAppointmentSchedulingProposalsInput = {
  enableCall: Scalars['Boolean']['input'];
  enableText: Scalars['Boolean']['input'];
  stopUuids: Array<Scalars['String']['input']>;
};

export type QueueAppointmentSchedulingProposalsOutput = MutationErrorOutput | QueueAppointmentSchedulingProposalsSuccessOutput;

export type QueueAppointmentSchedulingProposalsSuccessOutput = {
  __typename?: 'QueueAppointmentSchedulingProposalsSuccessOutput';
  /** User-facing messages for errors encountered processing stops */
  errorMessages: Array<Scalars['String']['output']>;
  /** The UUIDs of the stops for which proposals were enqueued */
  stopUuids: Array<Scalars['String']['output']>;
};

export type QueueAppointmentTextsArgs = {
  appointmentUuids: Array<Scalars['String']['input']>;
};

export type QueueAppointmentTextsOutput = {
  __typename?: 'QueueAppointmentTextsOutput';
  /** Stops where a message was attempted but Twilio did not accept it */
  failedCount: Scalars['Int']['output'];
  /** Stops whose text was accepted by Twilio and recorded as sent */
  sentCount: Scalars['Int']['output'];
  /** Stops passed over because the contact number cannot receive a text: a landline (per Twilio Lookup), a toll-free number, a number outside the 50 US states and Canada, or a number whose texts have repeatedly failed to deliver. The field keeps its original name for compatibility. Twilio was not asked to send these. */
  skippedLandlineCount: Scalars['Int']['output'];
  /** Stops passed over because they have no order or no appointment date or time to compose a message from. No message was attempted for these. */
  skippedMissingDetailsCount: Scalars['Int']['output'];
  /** Stops passed over because they have no contact person, or a contact person with no phone number. No message was attempted for these. */
  skippedNoContactCount: Scalars['Int']['output'];
  /** Stops whose text the notification delivery guard held back on purpose, as it does outside production. Twilio was not called for these. */
  suppressedCount: Scalars['Int']['output'];
};

export type QuickbooksAccountEntity = {
  __typename?: 'QuickbooksAccountEntity';
  accountType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum QuickbooksAuthStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export type QuickbooksClassEntity = {
  __typename?: 'QuickbooksClassEntity';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickbooksCustomerEntity = {
  __typename?: 'QuickbooksCustomerEntity';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quickbooksBillToId?: Maybe<Scalars['String']['output']>;
  quickbooksRemitToId?: Maybe<Scalars['String']['output']>;
};

export type QuickbooksDesktopInvoiceEntity = {
  __typename?: 'QuickbooksDesktopInvoiceEntity';
  amount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickbooksDesktopObjectEntity = {
  __typename?: 'QuickbooksDesktopObjectEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickbooksDesktopResultEntity = {
  __typename?: 'QuickbooksDesktopResultEntity';
  error?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopObjects?: Maybe<Array<QuickbooksDesktopObjectEntity>>;
};

export type QuickbooksHeaderFileMappingCreateInput = {
  cellNumber: Scalars['Float']['input'];
  headerType: HeaderFileMappingType;
  name: Scalars['String']['input'];
};

export type QuickbooksHeaderFileMappingEntity = {
  __typename?: 'QuickbooksHeaderFileMappingEntity';
  cellNumber: Scalars['Float']['output'];
  headerType: HeaderFileMappingType;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type QuickbooksHeaderFileMappingUpdateInput = {
  cellNumber?: InputMaybe<Scalars['Float']['input']>;
  headerType?: InputMaybe<HeaderFileMappingType>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type QuickbooksItemEntity = {
  __typename?: 'QuickbooksItemEntity';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickbooksOauthTokenEntity = {
  __typename?: 'QuickbooksOauthTokenEntity';
  authStatus: QuickbooksAuthStatus;
  expiresAt: Scalars['DateTime']['output'];
  lastAuthError?: Maybe<Scalars['DateTime']['output']>;
  refreshTokenExpiresAt: Scalars['DateTime']['output'];
  tokenType: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type QuickbooksSyncInvoicePlan = {
  __typename?: 'QuickbooksSyncInvoicePlan';
  billToContactName: Scalars['String']['output'];
  billToContactUuid: Scalars['String']['output'];
  failures: Array<SyncInvoiceToQuickbooksFailure>;
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  notices: Array<SyncInvoiceToQuickbooksNotice>;
  plannedCreates: Array<QuickbooksSyncPlannedCreate>;
  status: QuickbooksSyncPlanStatus;
  warnings: Array<SyncInvoiceToQuickbooksFailure>;
};

export type QuickbooksSyncOptionsInput = {
  allowAutoCreate?: Scalars['Boolean']['input'];
  allowRelink?: Scalars['Boolean']['input'];
};

export type QuickbooksSyncPlan = {
  __typename?: 'QuickbooksSyncPlan';
  blocked: Array<QuickbooksSyncInvoicePlan>;
  clean: Array<QuickbooksSyncInvoicePlan>;
  connection: QuickbooksSyncPlanConnection;
  needsReview: Array<QuickbooksSyncInvoicePlan>;
  notFoundUuids: Array<Scalars['String']['output']>;
  plannedCreates: Array<QuickbooksSyncPlannedCreate>;
  plannedInvoiceCount: Scalars['Int']['output'];
};

export type QuickbooksSyncPlanConnection = {
  __typename?: 'QuickbooksSyncPlanConnection';
  automatedSalesTaxEnabled: Scalars['Boolean']['output'];
  bookCloseDate?: Maybe<Scalars['String']['output']>;
  connected: Scalars['Boolean']['output'];
  element: QboSyncElement;
  quickbooksCompanyName?: Maybe<Scalars['String']['output']>;
  realmId?: Maybe<Scalars['String']['output']>;
};

export enum QuickbooksSyncPlanStatus {
  Blocked = 'BLOCKED',
  Clean = 'CLEAN',
  NeedsReview = 'NEEDS_REVIEW'
}

export type QuickbooksSyncPlannedCreate = {
  __typename?: 'QuickbooksSyncPlannedCreate';
  kind: QuickbooksSyncPlannedCreateKind;
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  tenetRecordName?: Maybe<Scalars['String']['output']>;
  tenetRecordUuid?: Maybe<Scalars['String']['output']>;
  tenetUrl?: Maybe<Scalars['String']['output']>;
};

export enum QuickbooksSyncPlannedCreateKind {
  Customer = 'CUSTOMER',
  Item = 'ITEM'
}

export type QuickbooksTaxCodeEntity = {
  __typename?: 'QuickbooksTaxCodeEntity';
  active: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuoteAcceptanceHeldOutput = {
  __typename?: 'QuoteAcceptanceHeldOutput';
  /** The draft charge-row sum; null when the draft is not completely priced */
  currentAmountCents?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  orderQuoteUuid: Scalars['String']['output'];
  quotedAmountCents?: Maybe<Scalars['Int']['output']>;
  reason: QuoteAcceptanceHoldReason;
};

/** Why a quote acceptance was held instead of creating the order */
export enum QuoteAcceptanceHoldReason {
  Expired = 'EXPIRED',
  NotPriced = 'NOT_PRICED',
  PriceMismatch = 'PRICE_MISMATCH',
  SupersededVersion = 'SUPERSEDED_VERSION'
}

export type QuoteAgentConnection = {
  __typename?: 'QuoteAgentConnection';
  address: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  kind: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type QuoteAgentConnectionsResult = {
  __typename?: 'QuoteAgentConnectionsResult';
  /** False when the quote agent is off for the company, unconfigured or unreachable; connections is then empty. */
  available: Scalars['Boolean']['output'];
  connections: Array<QuoteAgentConnection>;
};

export type QuoteAgentInboundRejection = {
  __typename?: 'QuoteAgentInboundRejection';
  fromAddress?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  receiptUuid: Scalars['String']['output'];
  rejectedAt: Scalars['DateTime']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type QuoteAgentInboundRejectionsResult = {
  __typename?: 'QuoteAgentInboundRejectionsResult';
  /** False when the quote agent is off for the company, unconfigured or unreachable; rejections is then empty. */
  available: Scalars['Boolean']['output'];
  rejections: Array<QuoteAgentInboundRejection>;
};

/** ALREADY_QUEUED: an offboarding job for the company is still waiting, delayed or running, so no second one was added. */
export enum QuoteAgentOffboardingRequestStatus {
  AlreadyQueued = 'ALREADY_QUEUED',
  Queued = 'QUEUED'
}

export enum QuoteAgentPolicyMode {
  AutoSend = 'AUTO_SEND',
  AutoSendBelow = 'AUTO_SEND_BELOW',
  ReviewAll = 'REVIEW_ALL'
}

/** Why a quote prepared by the quote agent needs an operator */
export enum QuoteAttentionReason {
  AmountAboveAutoSendMax = 'AMOUNT_ABOVE_AUTO_SEND_MAX',
  AmountCheckFailed = 'AMOUNT_CHECK_FAILED',
  ConfidenceBelowMin = 'CONFIDENCE_BELOW_MIN',
  CustomerAccepted = 'CUSTOMER_ACCEPTED',
  CustomerChanged = 'CUSTOMER_CHANGED',
  CustomerDeclined = 'CUSTOMER_DECLINED',
  CustomerQuestion = 'CUSTOMER_QUESTION',
  CustomerReplyUnclear = 'CUSTOMER_REPLY_UNCLEAR',
  EarlierReplySendUncertain = 'EARLIER_REPLY_SEND_UNCERTAIN',
  ExtractionModelRefused = 'EXTRACTION_MODEL_REFUSED',
  ExtractionPipelineFailed = 'EXTRACTION_PIPELINE_FAILED',
  ExtractionSkippedBudget = 'EXTRACTION_SKIPPED_BUDGET',
  ExtractionSkippedRateLimited = 'EXTRACTION_SKIPPED_RATE_LIMITED',
  Hazmat = 'HAZMAT',
  IncompleteRequest = 'INCOMPLETE_REQUEST',
  ModelBudgetExceeded = 'MODEL_BUDGET_EXCEEDED',
  NeedsOperator = 'NEEDS_OPERATOR',
  NewRequestInThread = 'NEW_REQUEST_IN_THREAD',
  NoCustomer = 'NO_CUSTOMER',
  PolicyReviewAll = 'POLICY_REVIEW_ALL',
  PrecisionBelowMin = 'PRECISION_BELOW_MIN',
  PrecisionUnknown = 'PRECISION_UNKNOWN',
  PriceMismatch = 'PRICE_MISMATCH',
  ReplyNotFromCustomer = 'REPLY_NOT_FROM_CUSTOMER',
  ReplyRejected = 'REPLY_REJECTED',
  ReplySendFailed = 'REPLY_SEND_FAILED',
  ReplySendUncertain = 'REPLY_SEND_UNCERTAIN',
  ReplyToExpiredQuote = 'REPLY_TO_EXPIRED_QUOTE',
  ReplyToSupersededVersion = 'REPLY_TO_SUPERSEDED_VERSION',
  ReplyVersionInferred = 'REPLY_VERSION_INFERRED',
  SenderDailyCap = 'SENDER_DAILY_CAP',
  SenderRecoveredFromForward = 'SENDER_RECOVERED_FROM_FORWARD',
  Unpriced = 'UNPRICED'
}

export type QuoteConnection = {
  __typename?: 'QuoteConnection';
  edges: Array<QuoteEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum QuoteContributionBenchmarkLeg {
  Inbound = 'INBOUND',
  LineHaul = 'LINE_HAUL',
  OrderCharges = 'ORDER_CHARGES',
  Outbound = 'OUTBOUND'
}

export type QuoteContributionBenchmarkLegEntity = {
  __typename?: 'QuoteContributionBenchmarkLegEntity';
  hasTariff: Scalars['Boolean']['output'];
  leg: QuoteContributionBenchmarkLeg;
  tariffGroupName?: Maybe<Scalars['String']['output']>;
  totalUsd: Scalars['Float']['output'];
};

export type QuoteContributionRatioEntity = {
  __typename?: 'QuoteContributionRatioEntity';
  actualWeightLb: Scalars['Float']['output'];
  benchmarkLegs: Array<QuoteContributionBenchmarkLegEntity>;
  benchmarkUsd?: Maybe<Scalars['Float']['output']>;
  contributionUsd?: Maybe<Scalars['Float']['output']>;
  driverSettlementUsd?: Maybe<Scalars['Float']['output']>;
  marginalFromRatio: Scalars['Float']['output'];
  profitableFromRatio: Scalars['Float']['output'];
  ratio?: Maybe<Scalars['Float']['output']>;
  revenueUsd: Scalars['Float']['output'];
  status: QuoteContributionStatus;
  storedDriverSettlementUsdCents?: Maybe<Scalars['Int']['output']>;
};

export type QuoteContributionRatioInput = {
  driverSettlementUsdCents?: InputMaybe<Scalars['Int']['input']>;
  quoteUuid?: InputMaybe<Scalars['String']['input']>;
  revenueUsdCents: Scalars['Int']['input'];
};

/** Where a quote's contribution ratio falls against the company's two cutoffs, or why it has none: no tariff prices the quote, or the driver pay has not been entered. */
export enum QuoteContributionStatus {
  DriverPayRequired = 'DRIVER_PAY_REQUIRED',
  Loss = 'LOSS',
  Marginal = 'MARGINAL',
  NotProfitable = 'NOT_PROFITABLE',
  Profitable = 'PROFITABLE',
  Unavailable = 'UNAVAILABLE'
}

export type QuoteConversationAttachmentEntity = {
  __typename?: 'QuoteConversationAttachmentEntity';
  contentType?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type QuoteConversationEntity = {
  __typename?: 'QuoteConversationEntity';
  createdAt: Scalars['DateTime']['output'];
  lastInboundAt?: Maybe<Scalars['DateTime']['output']>;
  lastOutboundAt?: Maybe<Scalars['DateTime']['output']>;
  messageCount: Scalars['Int']['output'];
  messages: Array<QuoteConversationMessageEntity>;
  messagesTruncated: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type QuoteConversationMessageEntity = {
  __typename?: 'QuoteConversationMessageEntity';
  attachments: Array<QuoteConversationAttachmentEntity>;
  bodyState: Scalars['String']['output'];
  bodyText?: Maybe<Scalars['String']['output']>;
  bodyTruncated: Scalars['Boolean']['output'];
  cc: Array<Scalars['String']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  from: QuoteConversationPartyEntity;
  originalSender?: Maybe<QuoteConversationPartyEntity>;
  receivedAt: Scalars['DateTime']['output'];
  senderRecoveredFromForward: Scalars['Boolean']['output'];
  subject: Scalars['String']['output'];
  to: Array<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type QuoteConversationPartyEntity = {
  __typename?: 'QuoteConversationPartyEntity';
  address: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type QuoteCreateInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid: Scalars['String']['input'];
  deletedAutoAppliedAccessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  dimFactor?: InputMaybe<Scalars['Float']['input']>;
  driverSettlementUsdCents?: InputMaybe<Scalars['Int']['input']>;
  enableLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulOriginTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  number: Scalars['String']['input'];
  packageCreateInputs: Array<PackageCreateInput>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentCreateInputs: Array<ShipmentCreateInput>;
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
};

/** Whether a drafted reply answers the request or asks a question */
export enum QuoteDraftReplyKind {
  Clarification = 'CLARIFICATION',
  Reply = 'REPLY'
}

export type QuoteEdge = {
  __typename?: 'QuoteEdge';
  cursor: Scalars['String']['output'];
  node: QuoteEntity;
};

export type QuoteEntity = {
  __typename?: 'QuoteEntity';
  billingPartyContact: ContactEntity;
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  deletedAutoAppliedAccessorials: Array<AccessorialUnion>;
  dimFactor?: Maybe<Scalars['Float']['output']>;
  enableLineHaul: Scalars['Boolean']['output'];
  freightNeedsRate: Scalars['Boolean']['output'];
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  lineHaulOriginTerminal?: Maybe<TerminalEntity>;
  measurementUnits?: Maybe<MeasurementUnits>;
  number: Scalars['String']['output'];
  order?: Maybe<OrderEntity>;
  packages: Array<PackageEntity>;
  service?: Maybe<ServiceEntity>;
  shipments: Array<ShipmentEntity>;
  source: QuoteSource;
  status: QuoteStatus;
  totalCharge: Scalars['Currency']['output'];
  totalSkids?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  weightUnits?: Maybe<WeightUnits>;
};

/** Why an operator action on a drafted quote reply was refused */
export enum QuoteReplyRefusalReason {
  AlreadyApproved = 'ALREADY_APPROVED',
  NotReviewable = 'NOT_REVIEWABLE',
  PriceChanged = 'PRICE_CHANGED',
  RecipientNotConfirmed = 'RECIPIENT_NOT_CONFIRMED',
  ReplySendPending = 'REPLY_SEND_PENDING',
  SendNotUncertain = 'SEND_NOT_UNCERTAIN',
  SendUncertainUnresolved = 'SEND_UNCERTAIN_UNRESOLVED',
  StaleDraft = 'STALE_DRAFT'
}

export type QuoteReplyRefusedOutput = {
  __typename?: 'QuoteReplyRefusedOutput';
  /** The draft charge-row sum; null when the draft is not completely priced */
  currentAmountCents?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  orderQuoteUuid: Scalars['String']['output'];
  quotedAmountCents?: Maybe<Scalars['Int']['output']>;
  reason: QuoteReplyRefusalReason;
};

/** What the operator decided about a reply whose send the agent could not confirm */
export enum QuoteReplySendOutcome {
  Discard = 'DISCARD',
  MarkSent = 'MARK_SENT',
  Resend = 'RESEND'
}

/** The source of a quote */
export enum QuoteSource {
  Api = 'API',
  CustomerPortal = 'CUSTOMER_PORTAL',
  ManuallyCreated = 'MANUALLY_CREATED'
}

/** A filter object that is used to filter the quote source enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type QuoteSourceFilter = {
  /** Filters for records where the relevant quote source field is equal to the provided quote source value */
  eq?: InputMaybe<QuoteSource>;
  /** Filters for records where the relevant quote source field is in the provided quote source values */
  in?: InputMaybe<Array<QuoteSource>>;
  /** Filters for records where the relevant quote source field is not equal to the provided quote source value */
  neq?: InputMaybe<QuoteSource>;
  /** Filters for records where the relevant quote source field is not in the provided quote source values */
  nin?: InputMaybe<Array<QuoteSource>>;
};

/** The status of a quote */
export enum QuoteStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  PendingContactApproval = 'PENDING_CONTACT_APPROVAL',
  Rejected = 'REJECTED'
}

/** A filter object that is used to filter the quote status enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type QuoteStatusFilter = {
  /** Filters for records where the relevant quote status field is equal to the provided quote status value */
  eq?: InputMaybe<QuoteStatus>;
  /** Filters for records where the relevant quote status field is in the provided quote status values */
  in?: InputMaybe<Array<QuoteStatus>>;
  /** Filters for records where the relevant quote status field is not equal to the provided quote status value */
  neq?: InputMaybe<QuoteStatus>;
  /** Filters for records where the relevant quote status field is not in the provided quote status values */
  nin?: InputMaybe<Array<QuoteStatus>>;
};

export type QuoteUpdateInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  deletedAutoAppliedAccessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  dimFactor?: InputMaybe<Scalars['Float']['input']>;
  driverSettlementUsdCents?: InputMaybe<Scalars['Int']['input']>;
  enableLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulOriginTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  number?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentArrayUpdateInputs?: InputMaybe<Array<ShipmentArrayUpdateInput>>;
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
};

/** Custom charge for the rate auto applied accessorials query */
export type RateAutoAppliedAccessorialsCustomChargeInput = {
  /** This is required - filter out custom charges that arent based on an accessorial */
  accessorialUuid: Scalars['String']['input'];
  isAutoApplied: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type RateAutoAppliedAccessorialsCustomChargeToAddOutput = {
  __typename?: 'RateAutoAppliedAccessorialsCustomChargeToAddOutput';
  accessorialUuid: Scalars['String']['output'];
  chargeGroupUuid?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rate: Scalars['Currency']['output'];
  zoneUuid?: Maybe<Scalars['String']['output']>;
};

export type RateAutoAppliedAccessorialsInput = {
  contactUuid: Scalars['String']['input'];
  inboundShipment?: InputMaybe<RateAutoAppliedAccessorialsShipmentInput>;
  isHazmat: Scalars['Boolean']['input'];
  isInBond: Scalars['Boolean']['input'];
  orderChargesShipment?: InputMaybe<RateAutoAppliedAccessorialsOrderChargesShipmentInput>;
  outboundShipment?: InputMaybe<RateAutoAppliedAccessorialsShipmentInput>;
  serviceUuid: Scalars['String']['input'];
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The order charges shipment for the rate auto applied accessorials query */
export type RateAutoAppliedAccessorialsOrderChargesShipmentInput = {
  customCharges: Array<RateAutoAppliedAccessorialsCustomChargeInput>;
};

export type RateAutoAppliedAccessorialsOutput = {
  __typename?: 'RateAutoAppliedAccessorialsOutput';
  /** The set of auto applied accessorials to add to / remove from the inbound shipment */
  inboundShipment?: Maybe<RateAutoAppliedAccessorialsShipmentOutput>;
  /** The set of auto applied accessorials to add to / remove from the inbound shipment */
  orderChargesShipment?: Maybe<RateAutoAppliedAccessorialsShipmentOutput>;
  /** The set of auto applied accessorials to add to / remove from the inbound shipment */
  outboundShipment?: Maybe<RateAutoAppliedAccessorialsShipmentOutput>;
};

/** Inbound or outbound shipment input for the rate auto applied accessorials query */
export type RateAutoAppliedAccessorialsShipmentInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  customCharges: Array<RateAutoAppliedAccessorialsCustomChargeInput>;
  standardStopType: StandardStopType;
  stopType: StopType;
  terminalUuid: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type RateAutoAppliedAccessorialsShipmentOutput = {
  __typename?: 'RateAutoAppliedAccessorialsShipmentOutput';
  /** The set of accessorials to auto-apply */
  customChargesToAdd: Array<RateAutoAppliedAccessorialsCustomChargeToAddOutput>;
  /** The set of custom charges to remove. These represent auto-applied accessorials that should no longer be auto-applied */
  customChargesToRemove: Array<Scalars['String']['output']>;
};

export type RateCustomChargeOutput = {
  __typename?: 'RateCustomChargeOutput';
  errorMessage?: Maybe<Scalars['Float']['output']>;
  existingCustomChargeUuid?: Maybe<Scalars['String']['output']>;
  fuelSurchargePercentageRate?: Maybe<Scalars['Float']['output']>;
  rateDollars?: Maybe<Scalars['Currency']['output']>;
  settlementFlatRate?: Maybe<Scalars['Currency']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  totalDollars?: Maybe<Scalars['Currency']['output']>;
  warning?: Maybe<CustomChargeRatingWarning>;
};

export type RateCustomCostOutput = {
  __typename?: 'RateCustomCostOutput';
  errorMessage?: Maybe<Scalars['Float']['output']>;
  existingCustomCostId?: Maybe<Scalars['String']['output']>;
  fuelSurchargePercentageRate?: Maybe<Scalars['Float']['output']>;
  rateDollars?: Maybe<Scalars['Currency']['output']>;
  totalDollars?: Maybe<Scalars['Currency']['output']>;
};

export type RateDependentFreightCostSuccessOutput = {
  __typename?: 'RateDependentFreightCostSuccessOutput';
  flatRateUsdDollars?: Maybe<Scalars['Currency']['output']>;
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateDependentFuelCostSuccessOutput = {
  __typename?: 'RateDependentFuelCostSuccessOutput';
  /** The flat rate for the fuel cost. Null if the dependent billing method is not FLAT_RATE */
  flatRateUsdDollars?: Maybe<Scalars['Currency']['output']>;
  /** The percentage rate for the fuel cost. Null if the dependent billing method is not PERCENTAGE or AUTO-CALCULATE */
  percentageRate?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateDependentSettlementBillLineItemSuccessOutput = {
  __typename?: 'RateDependentSettlementBillLineItemSuccessOutput';
  customCostTotal: Scalars['Currency']['output'];
  customCosts: Array<RateCustomCostOutput>;
  freightCost?: Maybe<RateDependentFreightCostSuccessOutput>;
  fuelCost?: Maybe<RateDependentFuelCostSuccessOutput>;
  success: Scalars['Boolean']['output'];
  total: Scalars['Currency']['output'];
};

export type RateFreightChargeSuccessOutput = {
  __typename?: 'RateFreightChargeSuccessOutput';
  discountRate?: Maybe<Scalars['Percent']['output']>;
  /** Which expired tariff an EXPIRED_TARIFF_AVAILABLE warning is about, so the user knows what to renew. Null for every other warning and whenever tariffWarning is null. */
  expiredTariffGroup?: Maybe<ExpiredTariffGroupEntity>;
  miles?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  /** The rate of the freight charge. $ / lb, $ / mi, or total $ in the flat rate case */
  rateDollars: Scalars['Currency']['output'];
  settlementFlatRate?: Maybe<Scalars['Currency']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  tariffUuid?: Maybe<Scalars['String']['output']>;
  /** Why tariff rating produced a $0 freight charge, when the cause is actionable: no tariff was selected (EXPIRED_TARIFF_AVAILABLE) or a per-mile tariff had no distance to bill on (MILES_UNAVAILABLE). Null otherwise, including when nothing was configured at all. */
  tariffWarning?: Maybe<FreightRatingWarning>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateFuelChargeSuccessOutput = {
  __typename?: 'RateFuelChargeSuccessOutput';
  flatRateUsdDollars?: Maybe<Scalars['Currency']['output']>;
  fuelProfileName?: Maybe<Scalars['String']['output']>;
  settlementFlatRate?: Maybe<Scalars['Currency']['output']>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  /** The surcharge rate for the fuel charge. Null if the fuel charge billing method is not PERCENTAGE (or isn't set to auto-calculate. */
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  surchargeRatePercentage?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
  /** Warning surfaced when fuel profile selection fell back to current date or found no profile at all. */
  warning?: Maybe<FuelRatingWarning>;
  /** Which tariff fuel profile a NO_VALID_FUEL_PROFILE warning is about. Null for every other warning, and when the rated tariff has no fuel profile. */
  warningDetails?: Maybe<FuelRatingWarningDetailsEntity>;
};

export type RateIndependentFreightCostSuccessOutput = {
  __typename?: 'RateIndependentFreightCostSuccessOutput';
  /** Percentage out of 100 */
  discountRate?: Maybe<Scalars['Percent']['output']>;
  miles?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  /** The rate of the freight charge. $ / lb, $ / mi, or total $ in the flat rate case */
  rateDollars: Scalars['Currency']['output'];
  tariffUuid?: Maybe<Scalars['String']['output']>;
  totalDollars: Scalars['Currency']['output'];
};

export type RateIndependentFuelCostSuccessOutput = {
  __typename?: 'RateIndependentFuelCostSuccessOutput';
  flatRateUsdDollars?: Maybe<Scalars['Currency']['output']>;
  /** The surcharge rate for the fuel cost. Null if the fuel cost billing method is not PERCENTAGE (or isn't set to auto-calculate. */
  surchargeRate?: Maybe<Scalars['Float']['output']>;
  surchargeRatePercentage?: Maybe<Scalars['Percent']['output']>;
  totalDollars: Scalars['Currency']['output'];
  /** Warning surfaced when fuel profile selection fell back to current date or found no profile at all. */
  warning?: Maybe<FuelRatingWarning>;
  /** Which tariff fuel profile a NO_VALID_FUEL_PROFILE warning is about. Null for every other warning, and when the rated tariff has no fuel profile. */
  warningDetails?: Maybe<FuelRatingWarningDetailsEntity>;
};

export type RateIndependentSettlementBillLineItemSuccessOutput = {
  __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput';
  customCostTotal: Scalars['Currency']['output'];
  customCosts: Array<RateCustomCostOutput>;
  freightCost?: Maybe<RateIndependentFreightCostSuccessOutput>;
  fuelCost?: Maybe<RateIndependentFuelCostSuccessOutput>;
  success: Scalars['Boolean']['output'];
  /** The total amount of the line item in USD */
  total: Scalars['Currency']['output'];
};

export type RateOrderAddressInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type RateOrderChargesInput = {
  customCharges: Array<RateOrderCustomChargeInput>;
  freightCharge?: InputMaybe<RateOrderFreightChargeInput>;
  fuelCharge?: InputMaybe<RateOrderFuelChargeInput>;
};

export type RateOrderCustomChargeInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  existingCustomChargeUuid?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargeRate?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  rateUsdDecimalCents?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialChargeGroupUuid?: InputMaybe<Scalars['String']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  useAccessorialRate: Scalars['Boolean']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderDependentCustomCostInput = {
  customCharge: RateOrderCustomChargeInput;
  dependentSettlementBillingMethod: DependentSettlementBillingMethod;
  existingCustomCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  percentageRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RateOrderDependentFreightCostInput = {
  dependentSettlementBillingMethod: DependentSettlementBillingMethod;
  existingFreightCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  freightCharge: RateOrderFreightChargeInput;
  percentageRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RateOrderDependentFuelCostInput = {
  dependentSettlementBillingMethod: DependentSettlementBillingMethod;
  existingCustomCostId?: InputMaybe<Scalars['String']['input']>;
  existingFuelCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  fuelCharge: RateOrderFuelChargeInput;
  percentageRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type RateOrderDependentSettlementBillLineItemInput = {
  /** @deprecated No longer used. Agent settlement is implemented via drivers. */
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  customCosts: Array<RateOrderDependentCustomCostInput>;
  driverUuid: Scalars['String']['input'];
  /** The id of the settlement bill line item that is being rated. Set the id to null if the order is currently being created */
  existingId?: InputMaybe<Scalars['String']['input']>;
  freightCost?: InputMaybe<RateOrderDependentFreightCostInput>;
  fuelCost?: InputMaybe<RateOrderDependentFuelCostInput>;
  settlementBillFinalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  settlementMode: SettlementMode;
};

export type RateOrderErrorOutput = {
  __typename?: 'RateOrderErrorOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RateOrderFreightChargeInput = {
  billingMethod: FreightBillingMethod;
  existingFreightChargeUuid?: InputMaybe<Scalars['String']['input']>;
  quantityInHundreds?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use `rateUsdDecimalCents` instead. */
  rateUsdCents?: InputMaybe<Scalars['Int']['input']>;
  /** Represents the freight charge rate in cents. Currently only implemented on the API layer and not stored in the database. */
  rateUsdDecimalCents?: InputMaybe<Scalars['Decimal']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderFuelChargeInput = {
  existingFuelChargeUuid?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  settlementFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  /** The percentage rate from [0,1] of the fuel charge. Will be zero if fuel billing method is FLAT_RATE */
  surchargeRate: Scalars['Float']['input'];
  type: FuelBillingMethod;
};

export type RateOrderIndependentCustomCostInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  billingMethod: CustomChargeBillingMethod;
  existingCustomCostId?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargeRate?: InputMaybe<Scalars['Decimal']['input']>;
  quantity: Scalars['Float']['input'];
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  specialAccessorialChargeGroupUuid?: InputMaybe<Scalars['String']['input']>;
  specialAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
  useAccessorialRate: Scalars['Boolean']['input'];
  zoneBasedAccessorialMatrixItemUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderIndependentFreightCostInput = {
  billingMethod?: InputMaybe<FreightBillingMethod>;
  existingFreightCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  tariffUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderIndependentFuelCostInput = {
  billingMethod: FuelBillingMethod;
  existingFuelCostId?: InputMaybe<Scalars['String']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Decimal']['input']>;
  /** The percentage rate from [0,1] of the fuel cost */
  surchargeRate: Scalars['Decimal']['input'];
};

export type RateOrderIndependentSettlementBillLineItemInput = {
  /** @deprecated No longer used. Agent settlement is implemented via drivers. */
  agentUuid?: InputMaybe<Scalars['String']['input']>;
  customCosts: Array<RateOrderIndependentCustomCostInput>;
  driverUuid: Scalars['String']['input'];
  /** The id of the settlement bill line item that is being rated. Set the id to null if the order is currently being created */
  existingId?: InputMaybe<Scalars['String']['input']>;
  freightCost?: InputMaybe<RateOrderIndependentFreightCostInput>;
  fuelCost?: InputMaybe<RateOrderIndependentFuelCostInput>;
  settlementBillFinalizedDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  settlementMode: SettlementMode;
};

export type RateOrderInput = {
  companyUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
  detailedStatus: OrderDetailedStatus;
  dimFactor: Scalars['Float']['input'];
  existingOrderUuid?: InputMaybe<Scalars['String']['input']>;
  inboundShipment?: InputMaybe<RateOrderRegularShipmentAndChargesInput>;
  lineHaul?: InputMaybe<RateOrderLineHaulShipmentAndChargesInput>;
  orderCharges?: InputMaybe<RateOrderOrderChargesShipmentAndChargesInput>;
  outboundShipment?: InputMaybe<RateOrderRegularShipmentAndChargesInput>;
  packages: Array<RateOrderPackageInput>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  totalAmountCents?: InputMaybe<Scalars['Float']['input']>;
  totalSkids?: InputMaybe<Scalars['Float']['input']>;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderLineHaulShipmentAndChargesInput = {
  charges: RateOrderChargesInput;
  /** Currently nullable so older clients don't break */
  dependentSettlementBillLineItems?: InputMaybe<Array<RateOrderDependentSettlementBillLineItemInput>>;
  /** Currently nullable so older clients don't break */
  independentSettlementBillLineItems?: InputMaybe<Array<RateOrderIndependentSettlementBillLineItemInput>>;
  shipmentDetails: RateOrderLineHaulShipmentInput;
};

export type RateOrderLineHaulShipmentInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the shipment that is being rated. Set the UUID to null if the order is currently being created */
  existingShipmentUuid?: InputMaybe<Scalars['String']['input']>;
  laneUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The updated service date, as an ISO 8601 formatted date string. If not provided, this field will not be updated. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  shipmentType: ShipmentType;
};

export type RateOrderOrderChargesShipmentAndChargesInput = {
  charges: RateOrderChargesInput;
  /** Currently nullable so older clients don't break */
  dependentSettlementBillLineItems?: InputMaybe<Array<RateOrderDependentSettlementBillLineItemInput>>;
  /** Currently nullable so older clients don't break */
  independentSettlementBillLineItems?: InputMaybe<Array<RateOrderIndependentSettlementBillLineItemInput>>;
  shipmentDetails: RateOrderOrderChargesShipmentInput;
};

export type RateOrderOrderChargesShipmentInput = {
  /** The UUID of the shipment that is being rated. Set the UUID to null if the order is currently being created */
  existingShipmentUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentType: ShipmentType;
};

export type RateOrderOutput = RateOrderErrorOutput | RateOrderSuccessOutput;

export type RateOrderPackageInput = {
  freightClass?: InputMaybe<FreightClass>;
  /** height in inches */
  height?: InputMaybe<Scalars['Float']['input']>;
  /** length in inches */
  length?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** weight in pounds */
  weight?: InputMaybe<Scalars['Float']['input']>;
  /** width in inches */
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type RateOrderRegularShipmentAndChargesInput = {
  charges: RateOrderChargesInput;
  /** Currently nullable so older clients don't break */
  dependentSettlementBillLineItems?: InputMaybe<Array<RateOrderDependentSettlementBillLineItemInput>>;
  /** Currently nullable so older clients don't break */
  independentSettlementBillLineItems?: InputMaybe<Array<RateOrderIndependentSettlementBillLineItemInput>>;
  shipmentDetails: RateOrderRegularShipmentInput;
};

export type RateOrderRegularShipmentInput = {
  /** The UUID of the shipment that is being rated. Set the UUID to null if the order is currently being created */
  existingShipmentUuid?: InputMaybe<Scalars['String']['input']>;
  overridePackageWeight: Scalars['Boolean']['input'];
  shipmentType: ShipmentType;
  stop: RateOrderStopInput;
};

export type RateOrderStopInput = {
  /** The stop's address to use for tariff selection if applicable. Null if the stop address does not exist */
  address?: InputMaybe<RateOrderAddressInput>;
  appointmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  miles?: InputMaybe<Scalars['Float']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The stop's service date in ISO 8601 format. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  stopType: StopType;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RateOrderSuccessOutput = {
  __typename?: 'RateOrderSuccessOutput';
  inboundShipmentCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  lineHaulCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  orderCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  outboundShipmentCharges?: Maybe<RateShipmentForOrderSuccessOutput>;
  success: Scalars['Boolean']['output'];
  totalDollars?: Maybe<Scalars['Currency']['output']>;
};

export type RateShipmentForOrderSuccessOutput = {
  __typename?: 'RateShipmentForOrderSuccessOutput';
  customChargeTotal: Scalars['Currency']['output'];
  customCharges: Array<RateCustomChargeOutput>;
  dependentSettlementBillLineItems: Array<RateDependentSettlementBillLineItemSuccessOutput>;
  externalRating?: Maybe<ExternalRatingResult>;
  freightCharge?: Maybe<RateFreightChargeSuccessOutput>;
  fuelCharge?: Maybe<RateFuelChargeSuccessOutput>;
  independentSettlementBillLineItems: Array<RateIndependentSettlementBillLineItemSuccessOutput>;
  success: Scalars['Boolean']['output'];
  total: Scalars['Currency']['output'];
};

export enum RateType {
  Flat = 'FLAT',
  QuantityBased = 'QUANTITY_BASED'
}

export enum RatingDateSource {
  CompanyToday = 'COMPANY_TODAY',
  ServiceDate = 'SERVICE_DATE'
}

export type ReanalyzePageInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export type ReanalyzeSchemaFileInput = {
  pngFilename: Scalars['String']['input'];
  textractType: TextractType;
};

export type ReconfigureDriverSettlementPayTermsInput = {
  expectedRevision: Scalars['Float']['input'];
  rate: ReconfigureSettlementPayRateInput;
  stopDriverMapUuid: Scalars['String']['input'];
};

export type ReconfigureDriverSettlementPayTermsOutput = {
  __typename?: 'ReconfigureDriverSettlementPayTermsOutput';
  created: Scalars['Boolean']['output'];
  terms: StopDriverMapPayTermsEntity;
};

export type ReconfigureSettlementPayRateInput = {
  flatPayUsdCents?: InputMaybe<Scalars['Float']['input']>;
  percentageOutOf100?: InputMaybe<Scalars['Float']['input']>;
  source: SettlementPayRateSource;
};

export type RecordContactAttemptedArgs = {
  /** Report an attempt the dispatcher made by hand, even though this stop’s automated call was already reported. */
  reportAdditionalAttempt?: Scalars['Boolean']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type RecordInboundReviewDecisionsInput = {
  decisions: Array<InboundReviewDecisionInput>;
  orderUuid: Scalars['String']['input'];
  /** Who sent the inbound message the operator was reviewing. Omitted when the message cannot be identified. */
  senderLabel?: InputMaybe<Scalars['String']['input']>;
};

export type RecordInventoryCountUnexpectedInput = {
  barcode: Scalars['String']['input'];
  /** Client-side ISO-8601 timestamp of when the operator actually scanned the barcode. Used to preserve real scan time across offline replays. Outside the past 48 hours (or absent), the server records its own time instead. */
  clientScannedAt?: InputMaybe<Scalars['String']['input']>;
  inventoryCountUuid: Scalars['String']['input'];
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RecordInventoryCountUnexpectedOutput = InventoryCountLineEntity | MutationErrorOutput;

export type RecurringLineHaulManifestTemplateEntity = {
  __typename?: 'RecurringLineHaulManifestTemplateEntity';
  autoGenerate: Scalars['Boolean']['output'];
  createAheadDays?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use createAheadDays. This field no longer affects generation. */
  createInAdvanceHours: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  daysOfWeek: Array<DayOfWeekAll>;
  defaultDriverUuid?: Maybe<Scalars['String']['output']>;
  defaultEquipmentUuid?: Maybe<Scalars['String']['output']>;
  departTimeMinutes: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endTerminalUuid: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastProcessedAt?: Maybe<Scalars['DateTime']['output']>;
  manifestsPerOccurrence: Scalars['Int']['output'];
  /** @deprecated No longer affects generation. Off-weeks are expressed as skipDates. */
  repeatFrequencyUnit: RepeatFrequencyUnit;
  /** @deprecated No longer affects generation. Off-weeks are expressed as skipDates. */
  repeatInterval: Scalars['Int']['output'];
  skipDates: Array<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
  startTerminalUuid: Scalars['String']['output'];
  transitMinutes: Scalars['Int']['output'];
  truckCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type RecurringOrderFrequencyEntity = {
  __typename?: 'RecurringOrderFrequencyEntity';
  daysOfMonth: Array<Scalars['Int']['output']>;
  daysOfWeek: Array<DayOfWeekAll>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  repeatFrequencyUnit: RepeatFrequencyUnit;
  repeatInterval: Scalars['Int']['output'];
  /** @deprecated Use repeatInterval instead */
  repeatIntervalWeeks?: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type RecurringRunHeaderEntity = {
  __typename?: 'RecurringRunHeaderEntity';
  createdAt: Scalars['DateTime']['output'];
  driver?: Maybe<DriverEntity>;
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  recurringOrderTemplates: Array<OrderEntity>;
  tags: Array<TagEntity>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
};

export type RecurringTemplateTruckEntity = {
  __typename?: 'RecurringTemplateTruckEntity';
  cutoffTime?: Maybe<Scalars['String']['output']>;
  daysOfWeek: Array<DayOfWeekAll>;
  label: Scalars['String']['output'];
  powerUnitEquipmentUuid?: Maybe<Scalars['String']['output']>;
  powerUnitName?: Maybe<Scalars['String']['output']>;
  recurringTemplateUuid: Scalars['String']['output'];
  trailers: Array<RecurringTemplateTruckTrailerEntity>;
  uuid: Scalars['String']['output'];
};

export type RecurringTemplateTruckTrailerEntity = {
  __typename?: 'RecurringTemplateTruckTrailerEntity';
  capacity?: Maybe<Scalars['Float']['output']>;
  equipmentUuid: Scalars['String']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type RecurringTemplateTruckTrailerInput = {
  trailerEquipmentUuid: Scalars['String']['input'];
};

export type ReferenceNumberFormatCheckEntity = {
  __typename?: 'ReferenceNumberFormatCheckEntity';
  createdAt: Scalars['DateTime']['output'];
  lengthOperand?: Maybe<Scalars['Int']['output']>;
  operator?: Maybe<ReferenceNumberFormatCheckOperator>;
  startsWithOperands: Array<Scalars['String']['output']>;
  type: ReferenceNumberFormatCheckType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ReferenceNumberFormatCheckOperator {
  And = 'AND',
  Or = 'OR'
}

export enum ReferenceNumberFormatCheckType {
  Length = 'LENGTH',
  StartsWith = 'STARTS_WITH'
}

export type ReferenceNumberFormatConfigEntity = {
  __typename?: 'ReferenceNumberFormatConfigEntity';
  checks: Array<ReferenceNumberFormatCheckEntity>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ReferenceNumberLabelEntity = {
  __typename?: 'ReferenceNumberLabelEntity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RefreshAuthTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type RefreshAuthTokenOutput = {
  __typename?: 'RefreshAuthTokenOutput';
  expiresAt: Scalars['DateTime']['output'];
  jwt: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type RefuseOrderInput = {
  refusedBy: Scalars['String']['input'];
  refusedDate: Scalars['DateTime']['input'];
  /** Why the consignee refused it */
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  /** The structured reason the consignee refused it, for outbound EDI. The free-text refusedReason carries the detail. */
  refusedReasonCode?: InputMaybe<OrderRefusalReason>;
  uuid: Scalars['String']['input'];
};

export type RehireDriverInput = {
  driverUuid: Scalars['String']['input'];
  /** YYYY-MM-DD */
  hireDate: Scalars['String']['input'];
};

export type RejectCustomerPortalOrderInput = {
  orderUuid: Scalars['String']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
};

export type RejectCustomerPortalOrderOutput = MutationErrorOutput | RejectCustomerPortalOrderSuccessOutput;

export type RejectCustomerPortalOrderSuccessOutput = {
  __typename?: 'RejectCustomerPortalOrderSuccessOutput';
  orderUuid: Scalars['String']['output'];
  rejectedAt: Scalars['DateTime']['output'];
};

export type RejectDelegationEndCustomerLinkInput = {
  delegationUuid: Scalars['String']['input'];
};

export type RejectEdiOrderInput = {
  uuid: Scalars['String']['input'];
};

export type RejectEdiOrderOutput = {
  __typename?: 'RejectEdiOrderOutput';
  uuid: Scalars['String']['output'];
};

export type RejectEdiOrdersInput = {
  orderUuids: Array<Scalars['String']['input']>;
};

export type RejectEdiOrdersOutput = MutationErrorOutput | RejectEdiOrdersSuccess;

export type RejectEdiOrdersSuccess = {
  __typename?: 'RejectEdiOrdersSuccess';
  successfulOrderUuids: Array<Scalars['String']['output']>;
};

export type RejectQuoteReplyInput = {
  draftReplyUuid: Scalars['String']['input'];
  orderQuoteUuid: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RejectQuoteReplyOutput = MutationErrorOutput | QuoteReplyRefusedOutput | RejectQuoteReplySuccessOutput;

export type RejectQuoteReplySuccessOutput = {
  __typename?: 'RejectQuoteReplySuccessOutput';
  orderQuoteUuid: Scalars['String']['output'];
};

export type RemoveApiUserContactMappingInput = {
  apiUserUuid: Scalars['String']['input'];
  contactUuid: Scalars['String']['input'];
};

export type RemoveContactsInput = {
  deleteOrders: Scalars['Boolean']['input'];
  uuids: Array<Scalars['String']['input']>;
};

export type RemoveContactsOutput = {
  __typename?: 'RemoveContactsOutput';
  uuids: Array<Scalars['String']['output']>;
};

export type RemoveDriversFromRouteInput = {
  driverUuids: Array<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

export type RemoveLineItemsFromSettlementBillInput = {
  /** The IDs of the settlement bill line items to disconnect from the driver settlement bill. Will validate that these are all on the provided bill. */
  settlementBillLineItemIds: Array<Scalars['String']['input']>;
  /** The UUID of the driver settlement bill to remove line items from */
  settlementBillUuid: Scalars['String']['input'];
};

export type RemoveLineItemsFromSettlementBillOutput = MutationErrorOutput | RemoveLineItemsFromSettlementBillSuccessOutput;

export type RemoveLineItemsFromSettlementBillSuccessOutput = {
  __typename?: 'RemoveLineItemsFromSettlementBillSuccessOutput';
  settlementBillLineItemsCount: Scalars['Float']['output'];
};

export type RemoveOrderHoldInput = {
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type RemoveOrdersFromManifestInput = {
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type RemoveOrdersFromManifestV2Input = {
  manifestUuid: Scalars['String']['input'];
  orderUuids: Array<Scalars['String']['input']>;
};

export type RemoveOrdersFromManifestV2Output = MutationErrorOutput | RemoveOrdersFromManifestV2SuccessOutput;

/** The output of removing orders from a line haul manifest successfully */
export type RemoveOrdersFromManifestV2SuccessOutput = {
  __typename?: 'RemoveOrdersFromManifestV2SuccessOutput';
  /** The updated line haul manifest */
  lineHaulManifest: LineHaulManifestEntity;
};

export type RemovePiecesFromPieceReceiptInput = {
  /** UUID of the piece receipt to remove pieces from */
  pieceReceiptUuid: Scalars['String']['input'];
  /** UUIDs of the pieces to detach from the receipt */
  pieceUuids: Array<Scalars['String']['input']>;
};

export type RemovePiecesFromPieceReceiptOutput = {
  __typename?: 'RemovePiecesFromPieceReceiptOutput';
  /** The piece receipt the pieces were removed from */
  pieceReceipt: PieceReceiptEntity;
  /** Number of pieces detached from the receipt */
  removedCount: Scalars['Int']['output'];
};

export type RemoveServiceFromContactInput = {
  contactUuid: Scalars['String']['input'];
  serviceUuid: Scalars['String']['input'];
};

export type RemoveShipmentsFromInvoiceInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type RemoveStopsFromRoutesInputType = {
  uuids: Array<Scalars['String']['input']>;
};

export type RemoveStorageUnitOnHandInput = {
  uuid: Scalars['String']['input'];
};

export type RemoveStorageUnitOnHandOutput = {
  __typename?: 'RemoveStorageUnitOnHandOutput';
  success: Scalars['Boolean']['output'];
};

export type RemoveStorageUnitOsdInput = {
  uuid: Scalars['String']['input'];
};

export type RemoveStorageUnitOsdOutput = {
  __typename?: 'RemoveStorageUnitOsdOutput';
  success: Scalars['Boolean']['output'];
};

export type RemoveSubscriberInput = {
  shipmentUuid: Scalars['String']['input'];
  subscriberUuid: Scalars['String']['input'];
};

export type RemoveTagFromLegInput = {
  legUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type RemoveTagFromOrderInput = {
  orderUuid: Scalars['String']['input'];
  tagUuid: Scalars['String']['input'];
};

export type RemoveThirdPartyUserFromContactInput = {
  contactUuid: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};

export type RemoveUserFromRoleInput = {
  userUuid: Scalars['String']['input'];
  /** The UUID of the role to remove the user from */
  uuid: Scalars['String']['input'];
};

export type RemoveUserFromRoleOutput = {
  __typename?: 'RemoveUserFromRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type RenderDeployEntity = {
  __typename?: 'RenderDeployEntity';
  commitHash: Scalars['String']['output'];
  commitMessage: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['Float']['output']>;
};

export type RenderServiceWithDeploysEntity = {
  __typename?: 'RenderServiceWithDeploysEntity';
  branch: Scalars['String']['output'];
  deploys: Array<RenderDeployEntity>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Float']['output'];
};

export enum RepeatFrequencyUnit {
  Month = 'MONTH',
  Week = 'WEEK'
}

export type ReplayOutboundEdiInput = {
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  replay214s?: InputMaybe<Scalars['Boolean']['input']>;
  replay990s?: InputMaybe<Scalars['Boolean']['input']>;
  replayPods?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RepointOrderFreightEntity = {
  __typename?: 'RepointOrderFreightEntity';
  packagesLeftPartiallyShort: Scalars['Int']['output'];
  unitsLeftBehind: Scalars['Int']['output'];
  unitsMarkedShort: Scalars['Int']['output'];
  unitsMoved: Scalars['Int']['output'];
};

export type RepointOrderFreightInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['String']['input'];
  reason: RepointReason;
  sourceManifestUuid: Scalars['String']['input'];
  targetManifestUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Why a shipment was moved off a line-haul run. */
export enum RepointReason {
  LoadedInError = 'LOADED_IN_ERROR',
  Misrouted = 'MISROUTED',
  Other = 'OTHER',
  PaperworkOnly = 'PAPERWORK_ONLY',
  RolledToNextRun = 'ROLLED_TO_NEXT_RUN',
  ShortShipped = 'SHORT_SHIPPED'
}

export type ReportADocScanIssueInput = {
  message: Scalars['String']['input'];
  orderStateJsonBlob?: InputMaybe<Scalars['String']['input']>;
  scannedOrderResultUuid: Scalars['String']['input'];
};

export type ReportADocScanIssueOutput = {
  __typename?: 'ReportADocScanIssueOutput';
  success: Scalars['Boolean']['output'];
};

export enum ReportAggregationPeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/**
 * The standard output type for a report file (generally PDF or CSV)
 *   which has been generated on the backend and uploaded to S3. This type can be
 *   returned directly from reports or extended to add
 *   additional report-specific fields.
 */
export type ReportFileOutput = {
  __typename?: 'ReportFileOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fileName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ReportFilterType {
  ContactUuidFilter = 'CONTACT_UUID_FILTER',
  InvoiceDateFilter = 'INVOICE_DATE_FILTER',
  InvoiceIsClosedFilter = 'INVOICE_IS_CLOSED_FILTER',
  InvoiceSourcesFilter = 'INVOICE_SOURCES_FILTER'
}

/** An input object that represents a superset of all possible filters that can be used for report generation */
export type ReportFiltersInput = {
  /** When present, filters the report by billing party UUID. Otherwise, no filtering of billing party contact occurs. */
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A date range filter that is used for the 'date' field on the invoice */
  invoiceDateFilter?: InputMaybe<DateFilterStartEnd>;
  /** A date range filter that is used for the 'dueDate' field on the invoice */
  invoiceDueDateFilter?: InputMaybe<DateFilterStartEnd>;
  /** A boolean filter that is used for the 'isClosed' field on the invoice */
  invoiceIsClosedFilter?: InputMaybe<BooleanFilter>;
  /** An enum list filter that is used for the 'source' field on the invoice */
  invoiceSourcesFilter?: InputMaybe<Array<InvoiceSource>>;
};

export enum ReportGenerationStatus {
  Available = 'AVAILABLE',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  NotStarted = 'NOT_STARTED',
  Uploading = 'UPLOADING'
}

export type ReportGroupConfigurationCreateInput = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultReportType: ReportType;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderStatuses: Array<OrderStatus>;
  reportAggregationPeriod: ReportAggregationPeriod;
  reportRevenueType: ReportRevenueType;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ReportGroupConfigurationEntity = {
  __typename?: 'ReportGroupConfigurationEntity';
  businessDivision?: Maybe<BusinessDivisionEntity>;
  contact?: Maybe<ContactEntity>;
  contacts?: Maybe<Array<ContactEntity>>;
  createdAt: Scalars['DateTime']['output'];
  defaultReportType: ReportType;
  driver?: Maybe<DriverEntity>;
  drivers?: Maybe<Array<DriverEntity>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  lastNumberOfDays?: Maybe<Scalars['Int']['output']>;
  lastNumberOfMonths?: Maybe<Scalars['Int']['output']>;
  lastNumberOfWeeks?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  orderStatuses: Array<OrderStatus>;
  reportAggregationPeriod: ReportAggregationPeriod;
  reportRevenueType: ReportRevenueType;
  reportStatistics: Array<ReportStatistic>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  stopTypes: Array<PickupOrDelivery>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ReportGroupConfigurationUpdateInput = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultReportType?: InputMaybe<ReportType>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Int']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  reportAggregationPeriod?: InputMaybe<ReportAggregationPeriod>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics?: InputMaybe<Array<ReportStatistic>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes?: InputMaybe<Array<PickupOrDelivery>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ReportPdfOutput = {
  __typename?: 'ReportPdfOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fileName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ReportRevenueType {
  Earned = 'EARNED',
  Projected = 'PROJECTED'
}

export type ReportRules = {
  /** How to route additional charges */
  additionalChargesRouting: Array<AdditionalChargesRoutingRule>;
  /** Fallback for empty customer names */
  emptyCustomerFallback: Scalars['String']['input'];
  /** Default terminal for linehaul charges. Empty = attribute to inbound terminal */
  linehaulDefaultTerminal: Scalars['String']['input'];
  /** Terminal overrides for linehaul */
  linehaulTerminalOverrides: Array<Scalars['String']['input']>;
  /** Swap to posted values when total ≠ sum-of-charges */
  usePostedWhenMismatch: Scalars['Boolean']['input'];
};

export type ReportSendJobBatchConnection = {
  __typename?: 'ReportSendJobBatchConnection';
  edges: Array<ReportSendJobBatchEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ReportSendJobBatchEdge = {
  __typename?: 'ReportSendJobBatchEdge';
  cursor: Scalars['String']['output'];
  node: ReportSendJobBatchEntity;
};

export type ReportSendJobBatchEntity = {
  __typename?: 'ReportSendJobBatchEntity';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  reportSendJobBatchProgress: ReportSendJobBatchProgressEntity;
  reportSendJobs: Array<ReportSendJobEntity>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReportSendJobBatchProgressEntity = {
  __typename?: 'ReportSendJobBatchProgressEntity';
  failCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ReportSendJobConnection = {
  __typename?: 'ReportSendJobConnection';
  edges: Array<ReportSendJobEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ReportSendJobEdge = {
  __typename?: 'ReportSendJobEdge';
  cursor: Scalars['String']['output'];
  node: ReportSendJobEntity;
};

export type ReportSendJobEntity = {
  __typename?: 'ReportSendJobEntity';
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<DocumentEntity>;
  emailTransaction?: Maybe<EmailTransactionEntity>;
  id: Scalars['String']['output'];
  reportSendJobBatch: ReportSendJobBatchEntity;
  reportSendJobBatchId: Scalars['String']['output'];
  reportSendJobError?: Maybe<ReportSendJobError>;
  reportType: AccountingReportTypeV2;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ReportSendJobError {
  DocumentGenerationFailed = 'DOCUMENT_GENERATION_FAILED'
}

export enum ReportSendJobStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export enum ReportStatistic {
  CustomChargeRevenue = 'CUSTOM_CHARGE_REVENUE',
  DeliveryRevenue = 'DELIVERY_REVENUE',
  FreightRevenue = 'FREIGHT_REVENUE',
  FuelRevenue = 'FUEL_REVENUE',
  NumberOfOrders = 'NUMBER_OF_ORDERS',
  NumberOfPackages = 'NUMBER_OF_PACKAGES',
  PickupRevenue = 'PICKUP_REVENUE',
  RecoveryRevenue = 'RECOVERY_REVENUE',
  TotalRevenue = 'TOTAL_REVENUE',
  TotalWeight = 'TOTAL_WEIGHT',
  TransferRevenue = 'TRANSFER_REVENUE'
}

export enum ReportType {
  Customer = 'CUSTOMER',
  Driver = 'DRIVER',
  Order = 'ORDER',
  ServiceLevel = 'SERVICE_LEVEL',
  Station = 'STATION',
  Terminal = 'TERMINAL'
}

export type RequestOrderMirrorSyncInput = {
  companyUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Window start (ISO 8601 datetime). */
  fromDateTime: Scalars['String']['input'];
  /** 'ALL' or 'COMPANIES'. */
  scope: Scalars['String']['input'];
  /** Window end (ISO 8601 datetime). */
  toDateTime: Scalars['String']['input'];
};

export type RequestOrderMirrorSyncOutput = {
  __typename?: 'RequestOrderMirrorSyncOutput';
  requestUuid: Scalars['String']['output'];
};

export type RequestQuoteRepriceInput = {
  orderQuoteUuid: Scalars['String']['input'];
};

export type RequestQuoteRepriceOutput = MutationErrorOutput | RequestQuoteRepriceSuccessOutput;

export type RequestQuoteRepriceSuccessOutput = {
  __typename?: 'RequestQuoteRepriceSuccessOutput';
  /** The quote after its draft was priced again */
  orderQuote: OrderQuote;
};

export type RequoteQuoteAtCurrentPriceInput = {
  orderQuoteUuid: Scalars['String']['input'];
};

export type RequoteQuoteAtCurrentPriceOutput = MutationErrorOutput | QuoteReplyRefusedOutput | RequoteQuoteAtCurrentPriceSuccessOutput;

export type RequoteQuoteAtCurrentPriceSuccessOutput = {
  __typename?: 'RequoteQuoteAtCurrentPriceSuccessOutput';
  /** The new version */
  orderQuoteUuid: Scalars['String']['output'];
  supersededOrderQuoteUuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type RerateOrderFreightOutput = {
  __typename?: 'RerateOrderFreightOutput';
  externalRatings: Array<FreightChargeRerateResult>;
  order: OrderEntity;
};

export type RerateQuoteFreightOutput = {
  __typename?: 'RerateQuoteFreightOutput';
  externalRatings: Array<FreightChargeRerateResult>;
  quote: QuoteEntity;
};

export type ResendExternalTransmissionInput = {
  orderEventUuid: Scalars['String']['input'];
};

export type ResetCompanyInput = {
  companyUuid: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResetCompanyOutput = {
  __typename?: 'ResetCompanyOutput';
  status: Scalars['String']['output'];
};

export type ResolveOrganizationMessageInput = {
  /** Required as "SEND" when a follow-up goes to every company. */
  confirmation?: InputMaybe<Scalars['String']['input']>;
  /** A follow-up message published to the same audience as the resolved one, in the same step. */
  followUp?: InputMaybe<OrganizationMessageContentInput>;
  uuid: Scalars['String']['input'];
};

export type ResolveQuoteReplySendInput = {
  draftReplyUuid: Scalars['String']['input'];
  orderQuoteUuid: Scalars['String']['input'];
  outcome: QuoteReplySendOutcome;
};

export type ResolveQuoteReplySendOutput = MutationErrorOutput | QuoteReplyRefusedOutput | ResolveQuoteReplySendSuccessOutput;

export type ResolveQuoteReplySendSuccessOutput = {
  __typename?: 'ResolveQuoteReplySendSuccessOutput';
  draftReplyUuid: Scalars['String']['output'];
  orderQuoteUuid: Scalars['String']['output'];
  outcome: QuoteReplySendOutcome;
};

export type ResolveScannedOrderBillingPartyInput = {
  contactUuid: Scalars['String']['input'];
  scannedOrderResultUuid: Scalars['String']['input'];
};

/** This is the graphql input for restoring an organization */
export type RestoreOrganizationInput = {
  uuid: Scalars['String']['input'];
};

export type RestoreOrganizationOutput = MutationErrorOutput | RestoreOrganizationSuccessOutput;

export type RestoreOrganizationSuccessOutput = {
  __typename?: 'RestoreOrganizationSuccessOutput';
  /** The restored org */
  organization: OrganizationEntity;
};

export type RestoreSchedulingRegionNameConflictOutput = {
  __typename?: 'RestoreSchedulingRegionNameConflictOutput';
  conflictingSchedulingRegionId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type RestoreSchedulingRegionOutput = MutationErrorOutput | RestoreSchedulingRegionNameConflictOutput | UpdateSchedulingRegionSuccessOutput;

export type RestoreSchedulingZoneNameConflictOutput = {
  __typename?: 'RestoreSchedulingZoneNameConflictOutput';
  conflictingSchedulingZoneId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type RestoreSchedulingZoneOutput = MutationErrorOutput | RestoreSchedulingZoneNameConflictOutput | UpdateSchedulingZoneSuccessOutput;

export type RestoreTariffChainInput = {
  id: Scalars['String']['input'];
};

export type RestoreTariffChainOutput = MutationErrorOutput | RestoreTariffChainSuccessOutput;

export type RestoreTariffChainSuccessOutput = {
  __typename?: 'RestoreTariffChainSuccessOutput';
  /** The tariff chain that was restored */
  tariffChain: TariffChainEntity;
};

export type RetryInvoice210OutboundResult = {
  __typename?: 'RetryInvoice210OutboundResult';
  queuedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type RetrySftpUploadsInput = {
  sftpUploadUuid: Scalars['String']['input'];
};

export type RetrySftpUploadsOutput = {
  __typename?: 'RetrySftpUploadsOutput';
  sftpUpload?: Maybe<SftpUploadEntity>;
};

export type ReuploadPodsInput = {
  contactUuids: Array<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type RevenueReportOrderConnection = {
  __typename?: 'RevenueReportOrderConnection';
  edges: Array<RevenueReportOrderEdge>;
  pageInfo: PageInfo;
};

export type RevenueReportOrderEdge = {
  __typename?: 'RevenueReportOrderEdge';
  cursor: Scalars['String']['output'];
  node: RevenueReportOrderEntity;
};

export type RevenueReportOrderEntity = {
  __typename?: 'RevenueReportOrderEntity';
  contactName: Scalars['String']['output'];
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  controllingTerminalCode?: Maybe<Scalars['String']['output']>;
  deliveryRevenue: Scalars['Float']['output'];
  detailedStatusV2?: Maybe<OrderDetailedStatus>;
  inboundAddressString?: Maybe<Scalars['String']['output']>;
  inboundStopType?: Maybe<OriginStopType>;
  lineHaulRevenue: Scalars['Float']['output'];
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  outboundAddressString?: Maybe<Scalars['String']['output']>;
  outboundStopType?: Maybe<DestinationStopType>;
  packageQuantity: Scalars['Float']['output'];
  packageWeight: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  podUploaded: Scalars['Boolean']['output'];
  /** Single service date for the order from the order's endStop */
  serviceDates: Array<Scalars['DateTime']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  stopTypes: Array<StopType>;
  totalCharge: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export enum RevenueReportOutputFormat {
  Allocation = 'ALLOCATION',
  Summary = 'SUMMARY'
}

export type ReversalCounterpartOrder = {
  __typename?: 'ReversalCounterpartOrder';
  isReturnOrder: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type RevokeCompanyUserSessionsInput = {
  archiveUsers: Scalars['Boolean']['input'];
  companyUuid: Scalars['String']['input'];
  userUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RevokeCompanyUserSessionsResult = {
  __typename?: 'RevokeCompanyUserSessionsResult';
  archivedCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  revokedCount: Scalars['Int']['output'];
  skippedNoEmailCount: Scalars['Int']['output'];
  targetedUsers: Array<UserSessionsAdminUserEntity>;
};

export type RevokeOrganizationPeerInput = {
  peerUuid: Scalars['String']['input'];
};

export type RoleEntity = {
  __typename?: 'RoleEntity';
  isInternalRole: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<PermissionEntity>;
  users: Array<UserEntity>;
  uuid: Scalars['String']['output'];
};

export type RotateDocumentInput = {
  degrees: Scalars['Float']['input'];
  documentName: Scalars['String']['input'];
  textractType: TextractType;
};

export type RotateQuoteAgentForwardingTokenOutput = MutationErrorOutput | RotateQuoteAgentForwardingTokenSuccessOutput;

export type RotateQuoteAgentForwardingTokenSuccessOutput = {
  __typename?: 'RotateQuoteAgentForwardingTokenSuccessOutput';
  connectionUuid: Scalars['String']['output'];
  forwardingAddress: Scalars['String']['output'];
  /** When the replaced address stops receiving mail. */
  previousValidUntil: Scalars['DateTime']['output'];
};

/** Direction filter applied during auto-route eligibility evaluation. BOTH includes pickups and deliveries; PICKUP / DELIVERY restrict by Stop.stopType. */
export enum RouteAutomationDirection {
  Both = 'BOTH',
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

/** Which date field auto-routing uses to decide a stop is "due" on a given planning date. SERVICE_DATE filters by Stop.serviceDateIso8601; DUE_BY filters by Stop.deadlineTime. */
export enum RouteAutomationDueDateSource {
  DueBy = 'DUE_BY',
  ServiceDate = 'SERVICE_DATE'
}

export type RouteAutomationSettingsEntity = {
  __typename?: 'RouteAutomationSettingsEntity';
  /** When true, auto-populate also picks a fitting Equipment per route. Vehicle-fit logic itself ships in TMS-1460 PR5. */
  autoAssignTrucks: Scalars['Boolean']['output'];
  /** Master switch. When false, the v2 toolbar button is hidden and `autoCreateRoutesV2` rejects calls with BadRequestException. */
  autoCreateRoutes: Scalars['Boolean']['output'];
  /** When true, auto-create also fills routes with eligible open stops. Has no effect when autoCreateRoutes is false. */
  autoPopulateRoutes: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  dueDateSource: RouteAutomationDueDateSource;
  excludeTagIds: Array<Scalars['String']['output']>;
  excludeTagUuids: Array<Scalars['String']['output']>;
  includeTagIds: Array<Scalars['String']['output']>;
  includeTagUuids: Array<Scalars['String']['output']>;
  pickupOrDelivery: RouteAutomationDirection;
  serviceIds: Array<Scalars['String']['output']>;
  serviceUuids: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Stable UUID for the settings row (unique per company). */
  uuid: Scalars['String']['output'];
};

export type RouteAutomationSettingsInput = {
  autoAssignTrucks: Scalars['Boolean']['input'];
  autoCreateRoutes: Scalars['Boolean']['input'];
  autoPopulateRoutes: Scalars['Boolean']['input'];
  dueDateSource: RouteAutomationDueDateSource;
  /** Tag uuids a stop must NOT carry. Empty array = no exclude filter. */
  excludeTagUuids: Array<Scalars['String']['input']>;
  /** Tag uuids a stop must carry to qualify. Empty array = no include filter. */
  includeTagUuids: Array<Scalars['String']['input']>;
  pickupOrDelivery: RouteAutomationDirection;
  /** Service uuids that qualify. Empty array = match all services. */
  serviceUuids: Array<Scalars['String']['input']>;
};

export type RouteConnection = {
  __typename?: 'RouteConnection';
  edges: Array<RouteEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  versionId?: Maybe<Scalars['String']['output']>;
};

export type RouteCoordinatesEntity = {
  __typename?: 'RouteCoordinatesEntity';
  /** Direction of travel in degrees clockwise from north. Only vehicle trackers report it. */
  headingDegrees?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  /** The vehicle tracker's place description, e.g. 'San Jose, CA'. */
  placeLabel?: Maybe<Scalars['String']['output']>;
  routeUuid: Scalars['String']['output'];
  /** Speed in miles per hour. Only vehicle trackers report it. */
  speedMph?: Maybe<Scalars['Float']['output']>;
  /** When this position was recorded: the driver app's last update, or the vehicle tracker's GPS time. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RouteCreateInput = {
  date: Scalars['DateTime']['input'];
  defaultStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  loadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  stopUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  unloadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
};

/** An error when the run departs a terminal the order is routed through but arrives somewhere the order is not routed to. */
export type RouteDestinationMismatchError = {
  __typename?: 'RouteDestinationMismatchError';
  manifest: LineHaulManifestEntity;
  order: OrderEntity;
};

export type RouteDriverCreateInput = {
  driverUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};

export type RouteDriverEntity = {
  __typename?: 'RouteDriverEntity';
  uuid: Scalars['String']['output'];
};

export type RouteEdge = {
  __typename?: 'RouteEdge';
  cursor: Scalars['String']['output'];
  node: RouteEntity;
};

export type RouteEntity = {
  __typename?: 'RouteEntity';
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  currentDriverMobilePhoneLocation?: Maybe<RouteCoordinatesEntity>;
  date: Scalars['DateTime']['output'];
  defaultStartTime?: Maybe<Scalars['DateTime']['output']>;
  driver?: Maybe<DriverEntity>;
  /** @deprecated Use driver instead. There can never be more than one driver per route */
  drivers: Array<DriverEntity>;
  endLoadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  equipments: Array<EquipmentEntity>;
  etas: Array<EtaEntity>;
  /** Return stops on this route grouped by address, status and customer. Two stops at one address for different customers are not grouped. Slightly expensive to calculate, use with care */
  groupedStopUuids: Array<Array<Scalars['String']['output']>>;
  helpers: Array<DriverEntity>;
  lastDispatched?: Maybe<Scalars['DateTime']['output']>;
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameManuallyChanged: Scalars['Boolean']['output'];
  nextRouteSlot?: Maybe<RouteSlotEntity>;
  numberOfRescheduled?: Maybe<Scalars['Float']['output']>;
  productivity?: Maybe<RouteProductivityEntity>;
  routeInfo: RouteInfo;
  routePath?: Maybe<RoutePathEntity>;
  routePathUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  routeSlotsUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  slots: Array<RouteSlotEntity>;
  startLoadTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  tags: Array<TagEntity>;
  terminal?: Maybe<TerminalEntity>;
  totalDistanceInMeters?: Maybe<Scalars['Float']['output']>;
  totalTimeInSeconds?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type RouteGenerationPreviewEntity = {
  __typename?: 'RouteGenerationPreviewEntity';
  driver: DriverEntity;
  equipment?: Maybe<EquipmentEntity>;
  stops: Array<StopPreviewForRouteGenerationEntity>;
};

export type RouteInfo = {
  __typename?: 'RouteInfo';
  pieceCount: Scalars['Float']['output'];
  status: RouteStatus;
  totalOrdersRefused: Scalars['Float']['output'];
  totalStops: Scalars['Float']['output'];
  totalStopsArrived: Scalars['Float']['output'];
  totalStopsCancelled: Scalars['Float']['output'];
  totalStopsCompleted: Scalars['Float']['output'];
  totalStopsConfirmedByAgent: Scalars['Float']['output'];
  totalStopsFailed: Scalars['Float']['output'];
  totalStopsNotArrived: Scalars['Float']['output'];
  totalStopsSentToAgent: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
};

export type RouteNameCreateInput = {
  name: Scalars['String']['input'];
  routeNameLocationCreateInputs: Array<RouteNameLocationCreateInput>;
};

export type RouteNameEntity = {
  __typename?: 'RouteNameEntity';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  routeNameLocations: Array<RouteNameLocationEntity>;
  uuid: Scalars['String']['output'];
};

export type RouteNameLocationCreateInput = {
  city: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type RouteNameLocationEntity = {
  __typename?: 'RouteNameLocationEntity';
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type RouteNameLocationUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type RouteOptimizationCreateInput = {
  mapboxId: Scalars['String']['input'];
  pinnedSlotUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

export type RouteOptimizationEntity = {
  __typename?: 'RouteOptimizationEntity';
  createdAt: Scalars['DateTime']['output'];
  excludedStopUuids?: Maybe<Array<Scalars['String']['output']>>;
  mapboxId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type RouteOptimizationSummary = {
  __typename?: 'RouteOptimizationSummary';
  currentDistanceMiles: Scalars['Float']['output'];
  currentDurationSeconds: Scalars['Float']['output'];
  deltaDistanceMiles: Scalars['Float']['output'];
  deltaDurationSeconds: Scalars['Float']['output'];
  proposedDistanceMiles: Scalars['Float']['output'];
  proposedDurationSeconds: Scalars['Float']['output'];
};

export type RouteOptimizationUpdateInput = {
  mapboxId?: InputMaybe<Scalars['String']['input']>;
  pinnedSlotUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type RoutePathEntity = {
  __typename?: 'RoutePathEntity';
  coordinates?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  inputCoordinates?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  route: RouteEntity;
  uuid: Scalars['String']['output'];
};

export type RoutePathsCreateInput = {
  routeUuids: Array<Scalars['String']['input']>;
};

export type RouteProductivityEntity = {
  __typename?: 'RouteProductivityEntity';
  actualHours?: Maybe<Scalars['Float']['output']>;
  actualHoursAreProxy: Scalars['Boolean']['output'];
  allowedHours?: Maybe<Scalars['Float']['output']>;
  hasTimeAllowances: Scalars['Boolean']['output'];
  productivityRatio?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<ProductivityStatus>;
};

export type RouteSlotArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  routeSlotCreateInput?: InputMaybe<RouteSlotCreateInput>;
  /** Pass this field in to update an array item */
  routeSlotUpdateInput?: InputMaybe<RouteSlotUpdateInput>;
};

export type RouteSlotCreateInput = {
  /** The uuids of the stops to add to create route slots from. No relation to anything drayage */
  drayageStopUuids: Array<Scalars['String']['input']>;
  emitMultiplayerEvent?: InputMaybe<Scalars['Boolean']['input']>;
  groupBy?: InputMaybe<GroupByStopsInput>;
  placeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RouteSlotEntity = {
  __typename?: 'RouteSlotEntity';
  ordinal: Scalars['Int']['output'];
  places: Array<PlaceEntity>;
  previousSlotDistanceMeters?: Maybe<Scalars['Float']['output']>;
  previousSlotDurationSeconds?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<RouteEntity>;
  stops: Array<StopEntity>;
  uuid: Scalars['String']['output'];
};

export type RouteSlotReassignInput = {
  endIndex?: InputMaybe<Scalars['Float']['input']>;
  routeUuid: Scalars['String']['input'];
  slotUuid: Scalars['String']['input'];
};

export type RouteSlotUpdateInput = {
  drayageStopUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  placeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type RouteSort = {
  sortBy: RouteSortBy;
  sortDirection: SortDirection;
};

export enum RouteSortBy {
  CreatedTime = 'CREATED_TIME',
  Driver = 'DRIVER',
  Name = 'NAME',
  NumberStopsComplete = 'NUMBER_STOPS_COMPLETE',
  NumberStopsIncomplete = 'NUMBER_STOPS_INCOMPLETE',
  RouteDate = 'ROUTE_DATE',
  Status = 'STATUS'
}

export enum RouteStatus {
  AwaitingAgentConfirmation = 'AWAITING_AGENT_CONFIRMATION',
  AwaitingSendToAgent = 'AWAITING_SEND_TO_AGENT',
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type RouteUpdateInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  defaultStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  endLoadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  equipmentUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  lastDispatched?: InputMaybe<Scalars['DateTime']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameManuallyChanged?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfRescheduled?: InputMaybe<Scalars['Float']['input']>;
  routeSlotsUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startLoadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid: Scalars['String']['input'];
};

export type RoutesSamsaraVehicleLocationsOutput = {
  __typename?: 'RoutesSamsaraVehicleLocationsOutput';
  routeCoordinates: Array<RouteCoordinatesEntity>;
};

export type RunEntity = {
  __typename?: 'RunEntity';
  createdAt: Scalars['DateTime']['output'];
  driver?: Maybe<DriverEntity>;
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  recurringOrderTemplates: Array<OrderEntity>;
  tags: Array<TagEntity>;
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
};

export type RunTestAccessorialDetectionInput = {
  delegationUuid: Scalars['String']['input'];
};

export type SalesVarianceReportInput = {
  /** List of customer uuids to include in the report. If not provided, all customers will be included. */
  customerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Order service date filter for the first sales period that is being compared */
  serviceDateFilterPeriod1: DateFilterV2;
  /** Order service date filter for the second sales period that is being compared */
  serviceDateFilterPeriod2: DateFilterV2;
};

export enum SameDayDispatchCellHeader {
  BillOfLadingNumber = 'BILL_OF_LADING_NUMBER',
  ServiceLevel = 'SERVICE_LEVEL'
}

export type SameDayDispatchConfigEntity = {
  __typename?: 'SameDayDispatchConfigEntity';
  createdAt: Scalars['DateTime']['output'];
  deliveryAppointmentTimeThreshold: Scalars['Int']['output'];
  deliveryWithinTimeWindowColorCode: Scalars['String']['output'];
  isNextInRouteColorCode: Scalars['String']['output'];
  isPastDeadlineColorCode: Scalars['String']['output'];
  isSpecialColorCode: Scalars['String']['output'];
  pickupAppointmentTimeThreshold: Scalars['Int']['output'];
  pickupWithinTimeWindowColorCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum SamsaraDatasetGroup {
  Activity = 'ACTIVITY',
  Costs = 'COSTS',
  Fleet = 'FLEET',
  Other = 'OTHER'
}

export type SamsaraDiscoveryAbsentEndpointEntity = {
  __typename?: 'SamsaraDiscoveryAbsentEndpointEntity';
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type SamsaraDiscoveryCatalogueEntity = {
  __typename?: 'SamsaraDiscoveryCatalogueEntity';
  absentEndpoints: Array<SamsaraDiscoveryAbsentEndpointEntity>;
  datasets: Array<SamsaraDiscoveryDatasetEntity>;
};

export type SamsaraDiscoveryDatasetEntity = {
  __typename?: 'SamsaraDiscoveryDatasetEntity';
  dated: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  group: SamsaraDatasetGroup;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  rowCount: Scalars['Int']['output'];
};

export enum SamsaraDiscoveryExportFormat {
  Csv = 'CSV',
  Json = 'JSON'
}

export type SamsaraDiscoveryExportInput = {
  /** When true, every field the API returned as a flattened column instead of the curated columns. */
  allFields?: Scalars['Boolean']['input'];
  /** A dataset key from the catalogue. */
  dataset: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  format: SamsaraDiscoveryExportFormat;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SamsaraDiscoveryMonthEntity = {
  __typename?: 'SamsaraDiscoveryMonthEntity';
  driveHours?: Maybe<Scalars['Float']['output']>;
  estFuelUsd?: Maybe<Scalars['Float']['output']>;
  gallons?: Maybe<Scalars['Float']['output']>;
  idleHours?: Maybe<Scalars['Float']['output']>;
  iftaGallonsBought?: Maybe<Scalars['Float']['output']>;
  iftaMiles?: Maybe<Scalars['Float']['output']>;
  laborUsd?: Maybe<Scalars['Float']['output']>;
  miles?: Maybe<Scalars['Float']['output']>;
  /** YYYY-MM */
  month: Scalars['String']['output'];
  onDutyHours?: Maybe<Scalars['Float']['output']>;
  partLinesUsd?: Maybe<Scalars['Float']['output']>;
  taskPartsCostUsd?: Maybe<Scalars['Float']['output']>;
  vehicles?: Maybe<Scalars['Int']['output']>;
  workOrdersCompleted?: Maybe<Scalars['Int']['output']>;
};

export type SamsaraDiscoveryMonthlyOverviewInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type SamsaraDiscoveryRowsInput = {
  /** When true, every field the API returned as a flattened column instead of the curated columns. */
  allFields?: Scalars['Boolean']['input'];
  /** A dataset key from the catalogue. */
  dataset: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Zero-based page index. */
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SamsaraDiscoveryRowsPageEntity = {
  __typename?: 'SamsaraDiscoveryRowsPageEntity';
  headers: Array<Scalars['String']['output']>;
  rows: Array<Array<Scalars['String']['output']>>;
  /** Rows matching the filter across all pages. */
  total: Scalars['Int']['output'];
};

export type SamsaraDiscoveryRunEntity = {
  __typename?: 'SamsaraDiscoveryRunEntity';
  currentDatasetLabel?: Maybe<Scalars['String']['output']>;
  /** Datasets finished so far in this run. */
  datasetsDone: Scalars['Int']['output'];
  datasetsTotal: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  fromDate?: Maybe<Scalars['DateTime']['output']>;
  /** Rows written by this run so far. */
  rowsWritten: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: SamsaraImportRunStatus;
  toDate?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type SamsaraDiscoverySetTokenInput = {
  /** The read-only Samsara API token. */
  apiToken: Scalars['String']['input'];
};

export type SamsaraDiscoveryStatusEntity = {
  __typename?: 'SamsaraDiscoveryStatusEntity';
  connected: Scalars['Boolean']['output'];
  hasData: Scalars['Boolean']['output'];
  latestRun?: Maybe<SamsaraDiscoveryRunEntity>;
  samsaraOrgName?: Maybe<Scalars['String']['output']>;
  /** Rows stored for the company across all datasets. While an import is queued or running this is the rows that run has written so far, which keeps polling cheap. */
  totalRows: Scalars['Int']['output'];
};

export type SamsaraDriverEntity = {
  __typename?: 'SamsaraDriverEntity';
  createdAtTime: Scalars['String']['output'];
  driverActivationStatus: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAtTime: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SamsaraDriversEntity = {
  __typename?: 'SamsaraDriversEntity';
  data: Array<SamsaraDriverEntity>;
  pagination: SamsaraPaginationEntity;
};

export type SamsaraGpsPingEntity = {
  __typename?: 'SamsaraGpsPingEntity';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  time: Scalars['String']['output'];
};

export enum SamsaraImportRunStatus {
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

export type SamsaraOauthTokenEntity = {
  __typename?: 'SamsaraOauthTokenEntity';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  scope: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SamsaraPaginationEntity = {
  __typename?: 'SamsaraPaginationEntity';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
};

export type SamsaraVehicleEntity = {
  __typename?: 'SamsaraVehicleEntity';
  createdAtTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  updatedAtTime: Scalars['String']['output'];
  vin: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type SamsaraVehicleStatsEntity = {
  __typename?: 'SamsaraVehicleStatsEntity';
  gps?: Maybe<Array<SamsaraGpsPingEntity>>;
  /** Vehicle ID */
  id: Scalars['String']['output'];
};

export type SamsaraVehicleStatsFeedEntity = {
  __typename?: 'SamsaraVehicleStatsFeedEntity';
  data: Array<SamsaraVehicleStatsEntity>;
  pagination: SamsaraPaginationEntity;
};

export type SamsaraVehiclesEntity = {
  __typename?: 'SamsaraVehiclesEntity';
  data: Array<SamsaraVehicleEntity>;
  pagination: SamsaraPaginationEntity;
};

export type SaveCostInputQuickbooksMappingsInput = {
  mappings: Array<CostInputQuickbooksMappingInput>;
};

export type SaveCostInputSetupInput = {
  driverWageSplitPct?: InputMaybe<Scalars['Float']['input']>;
  truckLeasePerMilePct?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveCostInputsInput = {
  entries: Array<CostInputEntryInput>;
  month: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type SaveManifestPlacementsInput = {
  manifestUuid: Scalars['String']['input'];
  placements: Array<LoadPlacementInput>;
};

/** Changed lanes of one point-to-point group. Group-level fields stay on updateTariffGroup; tariffType, rateType and maximumIncludesFuel apply to every lane this save writes, and useActualWeightInCalculation comes from the group row. Each request commits whole or not at all; a client splits a large book across requests and sends upserts before removals. */
export type SavePointToPointLanesInput = {
  /** Saved lanes to take off the group, at most 1000. The tariff stays, because freight charges point at it. */
  laneRemovals: Array<PointToPointLaneRemovalInput>;
  /** Lanes to create or update, at most 1000 */
  laneUpserts: Array<PointToPointLaneInput>;
  /** Same as TariffUpsertInput.maximumIncludesFuel */
  maximumIncludesFuel: Scalars['Boolean']['input'];
  rateType: RateType;
  tariffGroupUuid: Scalars['String']['input'];
  tariffType: TariffType;
};

export type SavePointToPointLanesOutput = {
  __typename?: 'SavePointToPointLanesOutput';
  /** Every upserted lane, in request order */
  lanes: Array<SavedPointToPointLane>;
};

export type SaveSmc3SettingsInput = {
  defaultTariffName?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Smc3Environment>;
  expectedVersion?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  licenseKey?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pinnedTariffEffectiveDate?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Creates a partnership between a carrier and one of its customers, or, with partnershipUuid, updates that partnership. Every setting is required, so a save always states the whole partnership. */
export type SaveTenediPartnershipInput = {
  allowEditingShipperBillOfLadingNumber: Scalars['Boolean']['input'];
  alternateStediPartnerId?: InputMaybe<Scalars['String']['input']>;
  autoAcceptOrders: Scalars['Boolean']['input'];
  canCreateMultipleStops: Scalars['Boolean']['input'];
  /** One of the carrier's SCACs. */
  companyStandardCarrierAlphaCode: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  /** Required as true to change an existing partnership's destination. The change takes effect on the next message. */
  confirmCutover?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required as true when the backend runs in production. The page sends it only after the operator types prod. */
  confirmProduction?: InputMaybe<Scalars['Boolean']['input']>;
  edi214ShipmentStatuses: Array<Edi214ShipmentStatus>;
  ediOutboundPayloadDestination: EdiOutboundPayloadDestination;
  enableStaging: Scalars['Boolean']['input'];
  excludeZeroChargeInvoices: Scalars['Boolean']['input'];
  ignoreCancellations: Scalars['Boolean']['input'];
  ignoreNonEdiOutbound: Scalars['Boolean']['input'];
  organizationUuid: Scalars['String']['input'];
  /** Omit to create a partnership. */
  partnershipUuid?: InputMaybe<Scalars['String']['input']>;
  removeSpacesFrom214Bol: Scalars['Boolean']['input'];
  send990InResponseTo204: Scalars['Boolean']['input'];
  send990InResponseTo211: Scalars['Boolean']['input'];
  sendBackupDocs: Scalars['Boolean']['input'];
  useStediGenerateEdiFunction: Scalars['Boolean']['input'];
};

export type SavedFilterViewEntity = {
  __typename?: 'SavedFilterViewEntity';
  baseTab?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dispatchTableFields: Array<DispatchTableField>;
  displayName: Scalars['String']['output'];
  filterModelJson: Scalars['String']['output'];
  filterModelJsonV2?: Maybe<Scalars['JSON']['output']>;
  grants: Array<SavedFilterViewGrantEntity>;
  /** Ordered list of OrderTableField values the orders grid groups by, outermost first. Null or empty means the view is ungrouped. */
  groupModelJson?: Maybe<Scalars['JSON']['output']>;
  isPublicToCompany: Scalars['Boolean']['output'];
  isShared: Scalars['Boolean']['output'];
  lineHaulDispatchFilters?: Maybe<SavedLineHaulDispatchFiltersEntity>;
  myPermission: ViewPermission;
  orderTableFields: Array<OrderTableField>;
  savedViewPageType: FilterViewPage;
  sortModelJson?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserActorEntity;
  uuid: Scalars['String']['output'];
};

export type SavedFilterViewGrantEntity = {
  __typename?: 'SavedFilterViewGrantEntity';
  createdAt: Scalars['DateTime']['output'];
  granteeName: Scalars['String']['output'];
  granteeType: GranteeType;
  granteeUuid: Scalars['String']['output'];
  permission: ViewPermission;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SavedFilterViewGrantInput = {
  granteeType: GranteeType;
  granteeUuid: Scalars['String']['input'];
  permission: ViewPermission;
};

export type SavedLineHaulDispatchBoardFiltersEntity = {
  __typename?: 'SavedLineHaulDispatchBoardFiltersEntity';
  detailedStatuses: Array<OrderDetailedStatus>;
  legStates: Array<DispatchLegState>;
  pieceStatuses: Array<PieceStatus>;
};

/** The line-haul dispatch board filters a saved view restores. An empty array applies no constraint on that dimension. */
export type SavedLineHaulDispatchFiltersEntity = {
  __typename?: 'SavedLineHaulDispatchFiltersEntity';
  boardFilters: SavedLineHaulDispatchBoardFiltersEntity;
  laneFilter: SavedLineHaulDispatchLaneFilterEntity;
};

/** The line-haul dispatch board filters a saved view restores. Only accepted on LINE_HAUL_ORDERS views. */
export type SavedLineHaulDispatchFiltersInput = {
  boardFilters: GroupOrdersBoardFiltersInput;
  laneFilter: SavedLineHaulDispatchLaneFilterInput;
};

export type SavedLineHaulDispatchLaneFilterEntity = {
  __typename?: 'SavedLineHaulDispatchLaneFilterEntity';
  destinationTerminalUuids: Array<Scalars['String']['output']>;
  originTerminalUuids: Array<Scalars['String']['output']>;
};

/** The lane filter a line-haul dispatch saved view restores: origin and destination terminal uuids. */
export type SavedLineHaulDispatchLaneFilterInput = {
  /** Lane END terminal uuids. Empty applies no constraint. Terminals outside the company are dropped. */
  destinationTerminalUuids: Array<Scalars['String']['input']>;
  /** Lane START terminal uuids. Empty applies no constraint. Terminals outside the company are dropped. */
  originTerminalUuids: Array<Scalars['String']['input']>;
};

/** One lane a savePointToPointLanes request wrote. The next save of the lane sends tariffUuid and version back. */
export type SavedPointToPointLane = {
  __typename?: 'SavedPointToPointLane';
  inboundZoneUuid: Scalars['String']['output'];
  outboundZoneUuid: Scalars['String']['output'];
  tariffUuid: Scalars['String']['output'];
  version: Scalars['DateTime']['output'];
};

export type ScanEntity = {
  __typename?: 'ScanEntity';
  barcode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  isNewPiece: Scalars['Boolean']['output'];
  order?: Maybe<OrderEntity>;
  orderLineHaulSegmentArrival?: Maybe<OrderLineHaulSegmentEntity>;
  orderLineHaulSegmentDeparture?: Maybe<OrderLineHaulSegmentEntity>;
  orderMarkedOnHandByScan: Scalars['Boolean']['output'];
  orderMarkedReceivedAtOriginByScan: Scalars['Boolean']['output'];
  piece?: Maybe<PieceEntity>;
  /** @deprecated Deprecated in favor of Piece.barcode. Needed for backwards compatibility */
  rawBarcode: Scalars['String']['output'];
  scanType: ScanType;
  scannedAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** Which field produced a contains-match hit in the scan fallback. */
export enum ScanMatchedField {
  HouseAirwayBillOfLadingNumber = 'HOUSE_AIRWAY_BILL_OF_LADING_NUMBER',
  MasterAirwayBillOfLadingNumber = 'MASTER_AIRWAY_BILL_OF_LADING_NUMBER',
  OrderName = 'ORDER_NAME',
  OrderRefNumbers = 'ORDER_REF_NUMBERS',
  PieceReferenceNumber = 'PIECE_REFERENCE_NUMBER',
  ShipperBillOfLadingNumber = 'SHIPPER_BILL_OF_LADING_NUMBER'
}

export type ScanOrderBarcodeInput = {
  barcode: Scalars['String']['input'];
  manifestUuid?: InputMaybe<Scalars['String']['input']>;
  scanType?: InputMaybe<ScanType>;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ScanOrderBarcodeOrderResultEntity = {
  __typename?: 'ScanOrderBarcodeOrderResultEntity';
  order: OrderEntity;
  /** Whether the piece was parsed from a serialized barcode. This will always be true if piece is not null, but may also be true if a recognized serialzed barcode format was scanned */
  parsedFromSerializedBarcode: Scalars['Boolean']['output'];
  piece?: Maybe<PieceEntity>;
  /**
   * The unique piece ID associated with this scanned order
   * @deprecated Use parsedFromSerializedBarcode instead to determine if piece was parsed from a serialized barcode because some piece-specific barcodes may not have a distinct pieceName
   */
  pieceName?: Maybe<Scalars['String']['output']>;
};

export type ScanOrderBarcodeOutput = {
  __typename?: 'ScanOrderBarcodeOutput';
  /** The orders and associated info found by the barcode scan. If one result is found, scan logic will be performed on the order. If multiple results are found, the results will be returned. If no results are found, an unassigned scan will be logged. */
  orderResults: Array<ScanOrderBarcodeOrderResultEntity>;
  /**
   * The orders matching a barcode scan. If only one match is found, scan logic will be performed on the order.
   * @deprecated Use orderResults instead
   */
  orders: Array<OrderEntity>;
  /**
   * The orders matching a barcode scan and the piece names associated with each result. If only one match is found, scan logic will be performed on the order.
   * @deprecated Use orderResults instead
   */
  ordersWithPieceNames: Array<OrderWithPieceNameEntity>;
  /** The scan event if one or zero orders are found */
  scan?: Maybe<ScanEntity>;
  /** The result of the barcode scan */
  scanBarcodeResultType?: Maybe<ScanOrderBarcodeResultType>;
};

export enum ScanOrderBarcodeResultType {
  Error = 'ERROR',
  MoreThanOneValidOrder = 'MORE_THAN_ONE_VALID_ORDER',
  NotOnManifest = 'NOT_ON_MANIFEST',
  NotOnStop = 'NOT_ON_STOP',
  PieceAlreadyScanned = 'PIECE_ALREADY_SCANNED',
  Success = 'SUCCESS'
}

export type ScanOrderInput = {
  barcode: Scalars['String']['input'];
  /** Indicates if the barcode is a serialized barcode. This should be true if pieceUuid is provided, or if the barcode is unique to a piece */
  isSerializedBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Deprecated. Mark on hand logic is determined by backend logic */
  markOnHand?: InputMaybe<Scalars['Boolean']['input']>;
  orderUuid: Scalars['String']['input'];
  /** @deprecated Use isSerializedBarcode (and pieceUuid if the piece is known) instead to indicate if a piece-specific barcode is being scanned */
  pieceName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of a scanned piece if we already know what it is */
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Previously used for client-side parsing. Deprecated in favor of barcode */
  rawBarcode?: InputMaybe<Scalars['String']['input']>;
  scanType?: InputMaybe<ScanType>;
  /** The UUID of the stop the driver is currently at */
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ScanPieceInput = {
  markOnHand?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export enum ScanType {
  Arrival = 'ARRIVAL',
  Delivery = 'DELIVERY',
  Departure = 'DEPARTURE'
}

export type ScanWarehouseLocationInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ScanWarehouseLocationOutput = {
  __typename?: 'ScanWarehouseLocationOutput';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  order?: Maybe<OrderEntity>;
  package?: Maybe<PackageEntity>;
  piece?: Maybe<PieceEntity>;
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export enum ScannedDocumentType {
  DeliveryAlert = 'DELIVERY_ALERT',
  DeliveryReceipt = 'DELIVERY_RECEIPT',
  None = 'NONE',
  PickupAlert = 'PICKUP_ALERT'
}

export type ScannedOrderConnection = {
  __typename?: 'ScannedOrderConnection';
  edges: Array<ScannedOrderEdge>;
  pageInfo: PageInfo;
};

export type ScannedOrderCreateInput = {
  bucket: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
  signedPodMatchStatus?: InputMaybe<SignedPodMatchStatus>;
};

export type ScannedOrderEdge = {
  __typename?: 'ScannedOrderEdge';
  cursor: Scalars['String']['output'];
  node: ScannedOrderEntity;
};

export type ScannedOrderEntity = {
  __typename?: 'ScannedOrderEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentIngestionPipeline: DocumentIngestionPipeline;
  failureReason?: Maybe<ScannedOrderFailureReason>;
  filename: Scalars['String']['output'];
  ingestedOutlookEmailDetails: IngestedEmailDetailsEntity;
  key: Scalars['String']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
  s3Url: Scalars['String']['output'];
  scannedOrderResults: Array<ScannedOrderResultEntity>;
  source: ScannedOrderSource;
  status: ScannedOrderStatus;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum ScannedOrderFailureReason {
  CustomerExcluded = 'CUSTOMER_EXCLUDED',
  DocumentTypeExcluded = 'DOCUMENT_TYPE_EXCLUDED',
  EmptyExtraction = 'EMPTY_EXTRACTION',
  InvalidFiletype = 'INVALID_FILETYPE',
  InvalidPageSize = 'INVALID_PAGE_SIZE',
  InvalidPageSizeA0 = 'INVALID_PAGE_SIZE_A0',
  InvalidPageSizeA1 = 'INVALID_PAGE_SIZE_A1',
  InvalidPageSizeA2 = 'INVALID_PAGE_SIZE_A2',
  InvalidPageSizeA3 = 'INVALID_PAGE_SIZE_A3',
  InvalidPageSizeA4 = 'INVALID_PAGE_SIZE_A4',
  InvalidPageSizeA5 = 'INVALID_PAGE_SIZE_A5',
  InvalidPageSizeA6 = 'INVALID_PAGE_SIZE_A6',
  InvalidPageSizeA7 = 'INVALID_PAGE_SIZE_A7',
  InvalidPageSizeA8 = 'INVALID_PAGE_SIZE_A8',
  InvalidPageSizeA9 = 'INVALID_PAGE_SIZE_A9',
  InvalidPageSizeA10 = 'INVALID_PAGE_SIZE_A10',
  InvalidPageSizeB0 = 'INVALID_PAGE_SIZE_B0',
  InvalidPageSizeB1 = 'INVALID_PAGE_SIZE_B1',
  InvalidPageSizeB2 = 'INVALID_PAGE_SIZE_B2',
  InvalidPageSizeB3 = 'INVALID_PAGE_SIZE_B3',
  InvalidPageSizeB4 = 'INVALID_PAGE_SIZE_B4',
  InvalidPageSizeB5 = 'INVALID_PAGE_SIZE_B5',
  InvalidPageSizeB6 = 'INVALID_PAGE_SIZE_B6',
  InvalidPageSizeB7 = 'INVALID_PAGE_SIZE_B7',
  InvalidPageSizeB8 = 'INVALID_PAGE_SIZE_B8',
  InvalidPageSizeB9 = 'INVALID_PAGE_SIZE_B9',
  InvalidPageSizeB10 = 'INVALID_PAGE_SIZE_B10',
  InvalidPageSizeC0 = 'INVALID_PAGE_SIZE_C0',
  InvalidPageSizeC1 = 'INVALID_PAGE_SIZE_C1',
  InvalidPageSizeC2 = 'INVALID_PAGE_SIZE_C2',
  InvalidPageSizeC3 = 'INVALID_PAGE_SIZE_C3',
  InvalidPageSizeC4 = 'INVALID_PAGE_SIZE_C4',
  InvalidPageSizeC5 = 'INVALID_PAGE_SIZE_C5',
  InvalidPageSizeC6 = 'INVALID_PAGE_SIZE_C6',
  InvalidPageSizeC7 = 'INVALID_PAGE_SIZE_C7',
  InvalidPageSizeC8 = 'INVALID_PAGE_SIZE_C8',
  InvalidPageSizeC9 = 'INVALID_PAGE_SIZE_C9',
  InvalidPageSizeC10 = 'INVALID_PAGE_SIZE_C10',
  InvalidPageSizeJuniorLegal = 'INVALID_PAGE_SIZE_JUNIOR_LEGAL',
  InvalidPageSizeLegal = 'INVALID_PAGE_SIZE_LEGAL',
  InvalidPageSizeLetter = 'INVALID_PAGE_SIZE_LETTER',
  InvalidPageSizeTabloid = 'INVALID_PAGE_SIZE_TABLOID',
  LlmProviderError = 'LLM_PROVIDER_ERROR',
  LowDocumentQuality = 'LOW_DOCUMENT_QUALITY',
  NeedsManualSplit = 'NEEDS_MANUAL_SPLIT',
  NonOrderDocument = 'NON_ORDER_DOCUMENT',
  NoBillingParty = 'NO_BILLING_PARTY',
  NoHawbExtracted = 'NO_HAWB_EXTRACTED',
  TooManyPages = 'TOO_MANY_PAGES',
  Unknown = 'UNKNOWN',
  UnrecognizedDocument = 'UNRECOGNIZED_DOCUMENT'
}

export type ScannedOrderFromAdminCreateInput = {
  bucket: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  filetype: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type ScannedOrderFromAdminCreateOutput = {
  __typename?: 'ScannedOrderFromAdminCreateOutput';
  error?: Maybe<Scalars['String']['output']>;
  scannedOrderEntity?: Maybe<ScannedOrderEntity>;
};

export type ScannedOrderResultBillingPartyCandidate = {
  __typename?: 'ScannedOrderResultBillingPartyCandidate';
  contactName?: Maybe<Scalars['String']['output']>;
  contactUuid: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  share?: Maybe<Scalars['Float']['output']>;
  votes?: Maybe<Scalars['Int']['output']>;
};

export type ScannedOrderResultConnection = {
  __typename?: 'ScannedOrderResultConnection';
  edges: Array<ScannedOrderResultEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Float']['output']>;
};

export type ScannedOrderResultCreateInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  documentCreateInput: DocumentCreateInput;
  extractedFields: Array<ExtractedFieldInput>;
  failureReason?: InputMaybe<ScannedOrderFailureReason>;
  pageEnd: Scalars['Int']['input'];
  pageStart: Scalars['Int']['input'];
  scannedDocumentType: ScannedDocumentType;
  scannedOrderResultPageInputs: Array<ScannedOrderResultPageInput>;
  schemaUuid?: InputMaybe<Scalars['String']['input']>;
  signedPodMatchStatus?: InputMaybe<SignedPodMatchStatus>;
  status: ScannedOrderResultStatus;
};

export type ScannedOrderResultDocumentEntity = {
  __typename?: 'ScannedOrderResultDocumentEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  scannedDocumentType: ScannedDocumentType;
  scannedOrderResultDocumentPages: Array<ScannedOrderResultDocumentPageEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScannedOrderResultDocumentPageEntity = {
  __typename?: 'ScannedOrderResultDocumentPageEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScannedOrderResultEdge = {
  __typename?: 'ScannedOrderResultEdge';
  cursor: Scalars['String']['output'];
  node: ScannedOrderResultEntity;
};

export type ScannedOrderResultEntity = {
  __typename?: 'ScannedOrderResultEntity';
  applyPlan?: Maybe<AdhocApplyPlanEntity>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  billingPartyCandidates?: Maybe<Array<ScannedOrderResultBillingPartyCandidate>>;
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  dismissed: Scalars['Boolean']['output'];
  duplicateOrder?: Maybe<OrderEntity>;
  duplicateScannedOrderResultOrder?: Maybe<OrderEntity>;
  exemplars: Array<ScannedOrderResultExemplar>;
  extractionDetail?: Maybe<ScannedOrderResultExtractionDetail>;
  failureReason?: Maybe<ScannedOrderFailureReason>;
  filename: Scalars['String']['output'];
  mergedAwayOrder?: Maybe<OrderEntity>;
  /** Return the next youngest scanned order result to review. Scanned order results are processed in descending order by creation date */
  nextScannedOrderResultInReview?: Maybe<ScannedOrderResultEntity>;
  order?: Maybe<OrderEntity>;
  pageEnd: Scalars['Int']['output'];
  pageStart: Scalars['Int']['output'];
  podOrder?: Maybe<OrderEntity>;
  possibleDuplicateOrder?: Maybe<OrderEntity>;
  preSignedGetUrl?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  scannedOrder: ScannedOrderEntity;
  scannedOrderResultDocuments: Array<ScannedOrderResultDocumentEntity>;
  scannedOrderResultPages: Array<ScannedOrderResultPageEntity>;
  schemaUuid?: Maybe<Scalars['String']['output']>;
  serviceSelection?: Maybe<ScannedOrderResultServiceSelection>;
  signedPodMatchStatus?: Maybe<SignedPodMatchStatus>;
  status: ScannedOrderResultStatus;
  type: ScannedOrderResultType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};


export type ScannedOrderResultEntityNextScannedOrderResultInReviewArgs = {
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScannedOrderResultExemplar = {
  __typename?: 'ScannedOrderResultExemplar';
  cosineSimilarity: Scalars['Float']['output'];
  documentId: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  preSignedGetUrl?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

export type ScannedOrderResultExtractionDetail = {
  __typename?: 'ScannedOrderResultExtractionDetail';
  correlationId?: Maybe<Scalars['String']['output']>;
  exemplarMarker?: Maybe<Scalars['JSON']['output']>;
  extractedFields?: Maybe<Scalars['JSON']['output']>;
  pipelineVersion?: Maybe<Scalars['String']['output']>;
  taxonomyVersion?: Maybe<Scalars['String']['output']>;
  usage?: Maybe<Scalars['JSON']['output']>;
};

export type ScannedOrderResultPageEntity = {
  __typename?: 'ScannedOrderResultPageEntity';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  preSignedGetUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type ScannedOrderResultPageInput = {
  bucket: Scalars['String']['input'];
  key: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};

export type ScannedOrderResultServiceSelection = {
  __typename?: 'ScannedOrderResultServiceSelection';
  extractedText?: Maybe<Scalars['String']['output']>;
  source?: Maybe<ScannedOrderResultServiceSource>;
  suggestedServiceSource?: Maybe<ScannedOrderResultServiceSource>;
  suggestedServiceUuid?: Maybe<Scalars['String']['output']>;
};

/** Where the auto-apply took the pre-filled service from: the extracted service level (exact name or learned mapping), the billing party default, or past orders on the same lane or billing party. */
export enum ScannedOrderResultServiceSource {
  ContactDefault = 'CONTACT_DEFAULT',
  ExtractedExact = 'EXTRACTED_EXACT',
  ExtractedLearned = 'EXTRACTED_LEARNED',
  LocalityHistory = 'LOCALITY_HISTORY'
}

export enum ScannedOrderResultSourceFilter {
  All = 'ALL',
  EmailIntegration = 'EMAIL_INTEGRATION',
  UploadedPdf = 'UPLOADED_PDF'
}

export enum ScannedOrderResultStatus {
  Approved = 'APPROVED',
  Attached = 'ATTACHED',
  Duplicate = 'DUPLICATE',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  ManuallyEntered = 'MANUALLY_ENTERED',
  Rejected = 'REJECTED'
}

export enum ScannedOrderResultType {
  Order = 'ORDER',
  SignedPod = 'SIGNED_POD'
}

export enum ScannedOrderSource {
  EmailIntegration = 'EMAIL_INTEGRATION',
  UploadedDocument = 'UPLOADED_DOCUMENT'
}

export enum ScannedOrderStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  Queued = 'QUEUED',
  Rejected = 'REJECTED'
}

export type ScannedOrderUpdateInput = {
  companyUuid: Scalars['String']['input'];
  /** Included if the entire scanned order request failed */
  failureReason?: InputMaybe<ScannedOrderFailureReason>;
  outlookIntegrationUuid?: InputMaybe<Scalars['String']['input']>;
  outlookMessageId?: InputMaybe<Scalars['String']['input']>;
  scannedOrderResults: Array<ScannedOrderResultCreateInput>;
  source?: InputMaybe<ScannedOrderSource>;
  status: ScannedOrderStatus;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ScheduleOrganizationMessageInput = {
  /** Required as "SEND" when scheduling a message to every company. */
  confirmation?: InputMaybe<Scalars['String']['input']>;
  /** When delivery starts. Must be in the future. */
  startsAt: Scalars['DateTime']['input'];
  uuid: Scalars['String']['input'];
};

export type SchedulingBlockedDayEntity = {
  __typename?: 'SchedulingBlockedDayEntity';
  date: PlainDate;
  /** Scheduling resources that still run on this day. An exemption waives THIS company closure only: a resource that also carries a blocked day of its own for the date stays closed. Capped per day, in id order. */
  exemptSchedulingResourceIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type SchedulingRegionEntity = {
  __typename?: 'SchedulingRegionEntity';
  dailyCapacityPieces?: Maybe<Scalars['Int']['output']>;
  dailyCapacityStops?: Maybe<Scalars['Int']['output']>;
  dailyCapacityWeight?: Maybe<Scalars['Mass']['output']>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  zones: Array<SchedulingZoneEntity>;
};

export type SchedulingResourceBlockedDayEntity = {
  __typename?: 'SchedulingResourceBlockedDayEntity';
  date: PlainDate;
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type SchedulingResourceConnection = {
  __typename?: 'SchedulingResourceConnection';
  edges: Array<SchedulingResourceEdge>;
  pageInfo: PageInfo;
};

export type SchedulingResourceCustomerEligibilityRulesInput = {
  /** Customer ids, ANY ONE of which an order's billing party may be. One party per order, so this list widens the resource as it grows, like the service levels above and unlike the tags. The customer is the order's billing party specifically, never the consignee on a stop. Master accounts do NOT cascade and cannot be named here at all: a rule names one organization and reaches that organization alone, so covering a master account means naming each of its organizations, and one onboarded later is covered when someone adds it. */
  allow: Array<Scalars['String']['input']>;
  /** Customer ids that refuse an order whose billing party is ANY ONE of them. Deny wins over allow. Master accounts do not cascade here either: banning an organization does not ban its siblings under the same master account. */
  deny: Array<Scalars['String']['input']>;
};

export type SchedulingResourceCustomerEligibilityRulesOutput = {
  __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput';
  /** Customer ids, ANY ONE of which an order's billing party may be. One party per order, so this list widens the resource as it grows. The billing party specifically, never the consignee on a stop. Master accounts do not cascade and cannot be named: each organization is named on its own. */
  allow: Array<Scalars['String']['output']>;
  /** Customer ids that refuse an order whose billing party is ANY ONE of them. Deny wins over allow, and banning an organization does not ban its siblings under the same master account. */
  deny: Array<Scalars['String']['output']>;
  /** DERIVED and READ-ONLY. True when the last write to the customer dimension left a non-empty allow list, and it is not settable: no input field maps to it. It exists to tell "this dimension was never configured" from "it was configured and everything it named has since been deleted", which are the same zero rows in the database and opposite states in the business. True with an EMPTY allow list is the damaged state a cascading subject delete leaves behind: the resource then matches nothing and refuses every order, rather than silently reopening to all of them. A UI should explain that state and offer to clear the dimension, which is what sending two empty lists does. */
  restricted: Scalars['Boolean']['output'];
};

export type SchedulingResourceEdge = {
  __typename?: 'SchedulingResourceEdge';
  cursor: Scalars['String']['output'];
  node: SchedulingResourceEntity;
};

/** The eligibility rules configured on a scheduling resource: which orders may book it. An order must clear ALL THREE dimensions. The three do NOT match the same way, so read each field: a tag allow list means an order must carry ALL of those tags, while the service level and customer allow lists mean ANY ONE of them. Within a dimension the deny list wins, and an empty allow list means unrestricted unless that dimension reports restricted. */
export type SchedulingResourceEligibilityRulesOutput = {
  __typename?: 'SchedulingResourceEligibilityRulesOutput';
  customers: SchedulingResourceCustomerEligibilityRulesOutput;
  services: SchedulingResourceServiceEligibilityRulesOutput;
  tags: SchedulingResourceTagEligibilityRulesOutput;
};

export type SchedulingResourceEntity = {
  __typename?: 'SchedulingResourceEntity';
  /** Blocked days in the requested window, soonest first, capped at 100 per resource. Defaults to today onward, read in the resource time zone. Narrow the window to reach days past the cap. */
  blockedDays: Array<SchedulingResourceBlockedDayEntity>;
  /** Number of blocked days in the requested window. Defaults to today onward, read in the resource time zone. Exact, unlike the length of blockedDays, which is capped per resource. */
  blockedDaysCount: Scalars['Int']['output'];
  /** Null means the resource has no piece limit. */
  capacityPieces?: Maybe<Scalars['Int']['output']>;
  /** Null means the resource has no stop limit. */
  capacityStops?: Maybe<Scalars['Int']['output']>;
  capacityWeight?: Maybe<Scalars['Mass']['output']>;
  dayOfWeek: DayOfWeekAll;
  /** Which orders may book this resource. An order must clear all three dimensions, and the three do not match the same way: read the field descriptions rather than assuming the lists behave alike. A resource nobody has configured reports three empty, unrestricted dimensions. NULL means the rules for this one resource could not be read, because it stopped being visible to this session between the read of the resource and the read of its rules; it never means the resource has no rules, and must not be shown as unrestricted. The accompanying GraphQL error names the field. */
  eligibilityRules?: Maybe<SchedulingResourceEligibilityRulesOutput>;
  end: PlainTime;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  routeNames: Array<RouteNameEntity>;
  start: PlainTime;
  /** Canonical IANA region time zone the start and end wall-clock times are read in. Blocked-day dates are read in it too. */
  timeZone: Scalars['String']['output'];
};


export type SchedulingResourceEntityBlockedDaysArgs = {
  fromDateIso8601?: InputMaybe<Scalars['String']['input']>;
  toDateIso8601?: InputMaybe<Scalars['String']['input']>;
};


export type SchedulingResourceEntityBlockedDaysCountArgs = {
  fromDateIso8601?: InputMaybe<Scalars['String']['input']>;
  toDateIso8601?: InputMaybe<Scalars['String']['input']>;
};

export type SchedulingResourceLiveClaimsOutput = {
  __typename?: 'SchedulingResourceLiveClaimsOutput';
  /** How many unreleased capacity claims block the edit. Exact, and counts CLAIMS rather than days: several claims may sit on one day. */
  liveClaimCount: Scalars['Int']['output'];
  /** The distinct days carrying those claims, as YYYY-MM-DD read in the time zone of the resource, earliest first. Capped for a refused weekday move, so it can be shorter than the claim count implies even after de-duplication; liveClaimCount is the complete figure. A refused block reports the single day it was closing. */
  liveClaimDatesIso8601: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SchedulingResourceNameConflictOutput = {
  __typename?: 'SchedulingResourceNameConflictOutput';
  /** Id of the live resource already holding this name. It is NOT the resource the request named: rename this one, then retry. */
  conflictingSchedulingResourceId: Scalars['String']['output'];
  /** Name both resources hold, already trimmed. Equal to the requested name by construction, and repeated here so a client can render the conflict without a second read. */
  conflictingSchedulingResourceName: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type SchedulingResourceOutput = MutationErrorOutput | SchedulingResourceLiveClaimsOutput | SchedulingResourceNameConflictOutput | SchedulingResourceSuccessOutput;

export type SchedulingResourceServiceEligibilityRulesInput = {
  /** Service level ids, ANY ONE of which an order may hold to book this resource. An order holds at most one service level, so this list widens the resource as it grows, the opposite of the tag allow list above. An order holding NO service level at all is refused by any service restriction, this list and the deny list alike: an order that cannot state its service level cannot prove it belongs on a restricted resource. */
  allow: Array<Scalars['String']['input']>;
  /** Service level ids that refuse an order holding ANY ONE of them. Deny wins over allow. A deny list alone still refuses an order with no service level at all. */
  deny: Array<Scalars['String']['input']>;
};

export type SchedulingResourceServiceEligibilityRulesOutput = {
  __typename?: 'SchedulingResourceServiceEligibilityRulesOutput';
  /** Service level ids, ANY ONE of which an order may hold. An order holds at most one, so this list widens the resource as it grows, unlike the tag allow list. An order with NO service level is refused by any service restriction, this list and the deny list alike. */
  allow: Array<Scalars['String']['output']>;
  /** Service level ids that refuse an order holding ANY ONE of them. Deny wins over allow, and a deny list alone still refuses an order with no service level at all. */
  deny: Array<Scalars['String']['output']>;
  /** DERIVED and READ-ONLY. True when the last write to the service level dimension left a non-empty allow list, and it is not settable: no input field maps to it. It exists to tell "this dimension was never configured" from "it was configured and everything it named has since been deleted", which are the same zero rows in the database and opposite states in the business. True with an EMPTY allow list is the damaged state a cascading subject delete leaves behind: the resource then matches nothing and refuses every order, rather than silently reopening to all of them. A UI should explain that state and offer to clear the dimension, which is what sending two empty lists does. */
  restricted: Scalars['Boolean']['output'];
};

export type SchedulingResourceSuccessOutput = {
  __typename?: 'SchedulingResourceSuccessOutput';
  schedulingResource: SchedulingResourceEntity;
};

export type SchedulingResourceTagEligibilityRulesInput = {
  /** Tag ids an order must carry ALL of. This is a DEDICATION rule, not a capability rule: [LIFTGATE] means the resource takes ONLY liftgate freight, so an order carrying no tags is refused rather than accepted. Every tag added narrows what the resource accepts; none of them widens it. Two tags mean an order must carry both, never either. Label this in a UI as "orders must carry all of these", never as capabilities or equipment, which reads exactly backwards. */
  allow: Array<Scalars['String']['input']>;
  /** Tag ids that refuse an order carrying ANY ONE of them. Deny wins over allow, so a tag on both lists refuses. */
  deny: Array<Scalars['String']['input']>;
};

export type SchedulingResourceTagEligibilityRulesOutput = {
  __typename?: 'SchedulingResourceTagEligibilityRulesOutput';
  /** Tag ids an order must carry ALL of. A DEDICATION rule, not a capability rule: [LIFTGATE] means the resource takes ONLY liftgate freight, so an untagged order is refused. Every tag listed narrows what the resource accepts; none widens it. */
  allow: Array<Scalars['String']['output']>;
  /** Tag ids that refuse an order carrying ANY ONE of them. Deny wins over allow. */
  deny: Array<Scalars['String']['output']>;
  /** DERIVED and READ-ONLY. True when the last write to the tag dimension left a non-empty allow list, and it is not settable: no input field maps to it. It exists to tell "this dimension was never configured" from "it was configured and everything it named has since been deleted", which are the same zero rows in the database and opposite states in the business. True with an EMPTY allow list is the damaged state a cascading subject delete leaves behind: the resource then matches nothing and refuses every order, rather than silently reopening to all of them. A UI should explain that state and offer to clear the dimension, which is what sending two empty lists does. */
  restricted: Scalars['Boolean']['output'];
};

export type SchedulingZoneAvailabilityEntity = {
  __typename?: 'SchedulingZoneAvailabilityEntity';
  dayOfWeek: DayOfWeekAll;
  end: PlainTime;
  id: Scalars['String']['output'];
  start: PlainTime;
};

export type SchedulingZoneAvailabilityUpsertInput = {
  dayOfWeek: DayOfWeekAll;
  end: PlainTimeInput;
  id: Scalars['String']['input'];
  start: PlainTimeInput;
};

export type SchedulingZoneEntity = {
  __typename?: 'SchedulingZoneEntity';
  availabilities: Array<SchedulingZoneAvailabilityEntity>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  locations: Array<SchedulingZoneLocationEntity>;
  name: Scalars['String']['output'];
};

export type SchedulingZoneLocationEntity = {
  __typename?: 'SchedulingZoneLocationEntity';
  city: Scalars['String']['output'];
  id: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type SchedulingZoneLocationUpsertInput = {
  city: Scalars['String']['input'];
  id: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type SchemaCompanyMappingEntity = {
  __typename?: 'SchemaCompanyMappingEntity';
  companyUuid: Scalars['String']['output'];
  contactUuid: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  schemaDocuments: Array<SchemaDocumentEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
};

export type SchemaDocumentEntity = {
  __typename?: 'SchemaDocumentEntity';
  bucket: Scalars['String']['output'];
  company?: Maybe<CompanyEntity>;
  companyUuid?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  labelledValues?: Maybe<Scalars['String']['output']>;
  preSignedGetUrl: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SchemaDocumentInput = {
  bucket: Scalars['String']['input'];
  key: Scalars['String']['input'];
  labelledValues?: InputMaybe<Scalars['String']['input']>;
};

export type SchemaEntity = {
  __typename?: 'SchemaEntity';
  companyMappingsCount: Scalars['Float']['output'];
  companyUuid?: Maybe<Scalars['String']['output']>;
  contactUuid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  firstTestSchemaDocument?: Maybe<SchemaDocumentEntity>;
  isActive: Scalars['Boolean']['output'];
  isMultiPage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  scannedDocumentType: ScannedDocumentType;
  testDocumentCount?: Maybe<Scalars['Float']['output']>;
  textractType: TextractType;
  updatedAt: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SchemaFieldEntity = {
  __typename?: 'SchemaFieldEntity';
  bottomEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  concatenateX: Scalars['Boolean']['output'];
  fieldExtractors: Array<FieldExtractorEntity>;
  fieldMatchers: Array<FieldMatcherEntity>;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  leftEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  rightEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  top: Scalars['Float']['output'];
  topEdgeAnchor?: Maybe<EdgeAnchorEntity>;
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type SchemaFieldInput = {
  bottomEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  concatenateX: Scalars['Boolean']['input'];
  fieldExtractors: Array<FieldExtractorInput>;
  fieldMatchers: Array<FieldMatcherInput>;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  leftEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  rightEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  top: Scalars['Float']['input'];
  topEdgeAnchor?: InputMaybe<EdgeAnchorInput>;
  width: Scalars['Float']['input'];
};

export type SchemaFilePutUrlInput = {
  filename: Scalars['String']['input'];
};

export type SchemaInput = {
  fingerprintAnchors: Array<FingerprintAnchorInput>;
  isMultiPage: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  originalFilename: Scalars['String']['input'];
  packageTables: Array<PackageTableInput>;
  scannedDocumentType: ScannedDocumentType;
  schemaFields: Array<SchemaFieldInput>;
  textractType: TextractType;
  transformAnchors: Array<TransformAnchorInput>;
};

export type SchemaRunEntity = {
  __typename?: 'SchemaRunEntity';
  bucket: Scalars['String']['output'];
  extractedFields: Array<ExtractedFieldEntity>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchEntity>;
  key: Scalars['String']['output'];
  schema: SchemaWithAnchorsEntity;
  schemaRunPages: Array<SchemaRunPageEntity>;
  schemaRunTestSnapshot?: Maybe<SchemaRunEntity>;
  schemaRunTestStatus?: Maybe<SchemaRunTestStatus>;
  transformAnchorMatches: Array<TransformAnchorMatchEntity>;
  type: SchemaRunType;
  uuid: Scalars['String']['output'];
};

export type SchemaRunPageEntity = {
  __typename?: 'SchemaRunPageEntity';
  bucket: Scalars['String']['output'];
  extractedFields: Array<ExtractedFieldEntity>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchEntity>;
  key: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  transformAnchorMatches: Array<TransformAnchorMatchEntity>;
  uuid: Scalars['String']['output'];
};

export type SchemaRunPageInput = {
  bucket: Scalars['String']['input'];
  extractedFields: Array<ExtractedFieldInput>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchInput>;
  key: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  transformAnchorMatches: Array<TransformAnchorMatchInput>;
};

export type SchemaRunTestListEntity = {
  __typename?: 'SchemaRunTestListEntity';
  createdAt: Scalars['DateTime']['output'];
  schemaRunTestStatus: SchemaRunTestStatus;
  schemaRuns: Array<SchemaRunEntity>;
  uuid: Scalars['String']['output'];
};

export type SchemaRunTestListInput = {
  schemaRunTestListUuid: Scalars['String']['input'];
};

export enum SchemaRunTestStatus {
  Error = 'ERROR',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Passed = 'PASSED'
}

export enum SchemaRunType {
  ManualRun = 'MANUAL_RUN',
  TestRun = 'TEST_RUN',
  TestSnapshot = 'TEST_SNAPSHOT'
}

export type SchemaTestFilePutUrlInput = {
  filename: Scalars['String']['input'];
};

export type SchemaWithAnchorsEntity = {
  __typename?: 'SchemaWithAnchorsEntity';
  companyUuid?: Maybe<Scalars['String']['output']>;
  contactUuid?: Maybe<Scalars['String']['output']>;
  fingerprintAnchors: Array<FingerprintAnchorEntity>;
  isActive: Scalars['Boolean']['output'];
  isMultiPage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  packageTables: Array<PackageTableEntity>;
  scannedDocumentType: ScannedDocumentType;
  schemaDocuments: Array<SchemaDocumentEntity>;
  schemaFields: Array<SchemaFieldEntity>;
  structuredExtractionSchemaOverride?: Maybe<StructuredExtractionSchemaOverrideEntity>;
  textractType: TextractType;
  transformAnchors: Array<TransformAnchorEntity>;
  uuid: Scalars['String']['output'];
};

export type SecondaryRefNumberSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export enum Segment {
  Cartage = 'CARTAGE',
  Standard = 'STANDARD'
}

export type SelectRoleInput = {
  role: MobileRole;
};

export type SelectSpecialAccessorialInput = {
  accessorialForContactUuid?: InputMaybe<Scalars['String']['input']>;
  /** City of the stop address */
  city?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated We no longer use contactUuid */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Country of the stop address */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The end appointment time that is set for the stop */
  endAppointment: Scalars['DateTime']['input'];
  /** Street name/house number of the stop address */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** The distance to be traveled in miles for the stop */
  miles?: InputMaybe<Scalars['Float']['input']>;
  /** The stop's service date */
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The selected service level for the order */
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  /** The start appointment time that is set for the stop */
  startAppointment: Scalars['DateTime']['input'];
  /** State of the stop address */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The selected terminal for the stop. Is optional for companies without terminals enabled */
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** ZIP of the stop address */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type SelectSpecialAccessorialOutput = {
  __typename?: 'SelectSpecialAccessorialOutput';
  /** The selected special accessorial name based on the provided parameters. The value is null when there is no special accessorial found that matches the provided parameters */
  accessorialName?: Maybe<Scalars['String']['output']>;
  /** The selected special accessorial UUID based on the provided parameters. The value is null when there is no special accessorial found that matches the provided parameters */
  accessorialUuid?: Maybe<Scalars['String']['output']>;
  /** The selected charge group based on the provided parameters. The value is null when there is no charge group found that matches the provided parameters */
  chargeGroupUuid?: Maybe<Scalars['String']['output']>;
  /** The selected matrix item based on the provided parameters. The value is null when there is no matrix item found that matches the provided parameters */
  matrixItemUuid?: Maybe<Scalars['String']['output']>;
  /** The selected tariff zone based on the provided parameters. The value is null when there is no tariff zone found that matches the provided parameters */
  tariffZoneUuid?: Maybe<Scalars['String']['output']>;
};

export type SendAccountingReportsInput = {
  /** The UUIDs of the contacts to which we email the report. If an empty list is provided, we will email the report to all contacts for the company. For the dunning report, if the user chooses to send to all, we will only send the report to contacts with outstanding invoices */
  contactUuids: Array<Scalars['String']['input']>;
  /** Optional free-text message applied to every recipient of this batch. For the dunning report it is rendered in the PDF (above the footer) and the email body. */
  customMessage?: InputMaybe<Scalars['String']['input']>;
  /** The list of report filters used to generate the accounting report */
  reportFilters: ReportFiltersInput;
  /** The type of accounting report to be generated and emailed */
  reportType: AccountingReportTypeV2;
};

export type SendAccountingReportsOutput = MutationErrorOutput | SendAccountingReportsSuccessOutput;

export type SendAccountingReportsSuccessOutput = {
  __typename?: 'SendAccountingReportsSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type SendDeliveryCompletedInput = {
  hawbs?: InputMaybe<Array<Scalars['String']['input']>>;
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SendInvoicesInput = {
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceSendJobBatchType: InvoiceSendJobBatchType;
  invoicesToSend: Array<InvoiceToSend>;
  /** @deprecated Invoice backups are now always created */
  shouldPrintBackups?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendMetricInput = {
  metricName: Scalars['String']['input'];
  tags: Array<MetricTagInput>;
  type: MetricType;
  value: Scalars['Int']['input'];
};

export type SendRouteToAgentInput = {
  agentId: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};

export type SendRouteToAgentOutput = MutationErrorOutput | SendRouteToAgentSuccessOutput;

export type SendRouteToAgentSuccessOutput = {
  __typename?: 'SendRouteToAgentSuccessOutput';
  route: RouteEntity;
};

export type SendStopToAgentInput = {
  agentId: Scalars['String']['input'];
  stopUuid: Scalars['String']['input'];
};

export type SendStopToAgentOutput = MutationErrorOutput | SendStopToAgentSuccessOutput;

export type SendStopToAgentSuccessOutput = {
  __typename?: 'SendStopToAgentSuccessOutput';
  stop: StopEntity;
};

export type SenderBillingPartyExplainEntity = {
  __typename?: 'SenderBillingPartyExplainEntity';
  contactUuid?: Maybe<Scalars['String']['output']>;
  distinctParties?: Maybe<Scalars['Int']['output']>;
  support?: Maybe<Scalars['Int']['output']>;
  verdict: Scalars['String']['output'];
};

export type ServiceAvailabilityDateEntity = {
  __typename?: 'ServiceAvailabilityDateEntity';
  /** @deprecated Use end instead */
  availableEndTime: Scalars['DateTime']['output'];
  /** @deprecated Use start instead */
  availableStartTime: Scalars['DateTime']['output'];
  dayCategory: SpecialDayOfWeek;
  enabled: Scalars['Boolean']['output'];
  end: PlainTime;
  id: Scalars['String']['output'];
  start: PlainTime;
};

export type ServiceCreateInput = {
  calculateInboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateLineHaulFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateOutboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAppointmentEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultAppointmentStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultDeliveryPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultFulfillmentType?: InputMaybe<FulfillmentType>;
  defaultInboundStopType?: InputMaybe<StopType>;
  defaultIsLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  defaultOutboundStopType?: InputMaybe<StopType>;
  defaultPickupPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultStartNow?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTotalDuration?: InputMaybe<Scalars['Duration']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isExposedToCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  markOrdersAsSpecial: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  serviceAvailabilityDates?: InputMaybe<Array<UpsertServiceAvailabilityDateInput>>;
  timeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  useApptInRouteOptimization: Scalars['Boolean']['input'];
};

export type ServiceEntity = {
  __typename?: 'ServiceEntity';
  calculateInboundFreightCharges: Scalars['Boolean']['output'];
  calculateLineHaulFreightCharges: Scalars['Boolean']['output'];
  calculateOutboundFreightCharges: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultAppointmentEndTime?: Maybe<Scalars['DateTime']['output']>;
  defaultAppointmentStartTime?: Maybe<Scalars['DateTime']['output']>;
  defaultDeliveryPadding?: Maybe<Scalars['Duration']['output']>;
  defaultFulfillmentType?: Maybe<FulfillmentType>;
  defaultInboundStopType?: Maybe<StopType>;
  defaultIsLineHaul: Scalars['Boolean']['output'];
  defaultOutboundStopType?: Maybe<StopType>;
  defaultPickupPadding?: Maybe<Scalars['Duration']['output']>;
  defaultStartNow: Scalars['Boolean']['output'];
  defaultTotalDuration?: Maybe<Scalars['Duration']['output']>;
  isActive: Scalars['Boolean']['output'];
  isExposedToCustomers: Scalars['Boolean']['output'];
  markOrdersAsSpecial: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serviceAvailabilityDates: Array<ServiceAvailabilityDateEntity>;
  timeInMinutes?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  useApptInRouteOptimization: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type ServiceGroupEntity = {
  __typename?: 'ServiceGroupEntity';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  services: Array<ServiceEntity>;
};

export enum ServiceLevel {
  AirDrop = 'AIR_DROP',
  AmazonLockerCore = 'AMAZON_LOCKER_CORE',
  AmazonLockerPremiere = 'AMAZON_LOCKER_PREMIERE',
  Amerigas = 'AMERIGAS',
  AtmInstall = 'ATM_INSTALL',
  AtmSwap = 'ATM_SWAP',
  BasicDelivery = 'BASIC_DELIVERY',
  BasicPickup = 'BASIC_PICKUP',
  Coinstar = 'COINSTAR',
  CostcoTruckManifest = 'COSTCO_TRUCK_MANIFEST',
  Ct = 'CT',
  CustomerPickup = 'CUSTOMER_PICKUP',
  DebrisRemoval = 'DEBRIS_REMOVAL',
  DeliveryExpedited = 'DELIVERY_EXPEDITED',
  DicksDropTrailer = 'DICKS_DROP_TRAILER',
  Dock = 'DOCK',
  Drop = 'DROP',
  DumpRun = 'DUMP_RUN',
  Expedited = 'EXPEDITED',
  ExpeditedPickup = 'EXPEDITED_PICKUP',
  Fn = 'FN',
  FourManDelivery = 'FOUR_MAN_DELIVERY',
  Freeosk = 'FREEOSK',
  Fs = 'FS',
  Ge_2Man = 'GE_2_MAN',
  Ge_3Man = 'GE_3_MAN',
  Ge_4Man = 'GE_4_MAN',
  Ge_5Man = 'GE_5_MAN',
  Hiseq = 'HISEQ',
  HotShot = 'HOT_SHOT',
  Inbound = 'INBOUND',
  Iscan = 'ISCAN',
  Keyme = 'KEYME',
  L2IdLs = 'L2_ID_LS',
  LiftgateCurbside = 'LIFTGATE_CURBSIDE',
  LiftgateInside = 'LIFTGATE_INSIDE',
  LinehaulTruck = 'LINEHAUL_TRUCK',
  LocalNextDay = 'LOCAL_NEXT_DAY',
  LocalSameDay = 'LOCAL_SAME_DAY',
  MedicalDevice = 'MEDICAL_DEVICE',
  Miseq = 'MISEQ',
  NextseqNovaseq = 'NEXTSEQ_NOVASEQ',
  NextDay = 'NEXT_DAY',
  OneManPlus = 'ONE_MAN_PLUS',
  OneManWg = 'ONE_MAN_WG',
  PlWd = 'PL_WD',
  RackAssist = 'RACK_ASSIST',
  RackAssist_2Man = 'RACK_ASSIST_2_MAN',
  Recovery = 'RECOVERY',
  RecoverySameDay = 'RECOVERY_SAME_DAY',
  RecoverySameDayExpedited = 'RECOVERY_SAME_DAY_EXPEDITED',
  Redbox = 'REDBOX',
  RoomOfChoice = 'ROOM_OF_CHOICE',
  Rtn = 'RTN',
  SameDay = 'SAME_DAY',
  SamsClubReturnCenter = 'SAMS_CLUB_RETURN_CENTER',
  SignatureDelivery = 'SIGNATURE_DELIVERY',
  SiteSurvey = 'SITE_SURVEY',
  SpecialProducts = 'SPECIAL_PRODUCTS',
  Standard = 'STANDARD',
  Storage = 'STORAGE',
  SvRc = 'SV_RC',
  Tcr = 'TCR',
  Td = 'TD',
  Threshold = 'THRESHOLD',
  ThresholdPlus = 'THRESHOLD_PLUS',
  Transfer = 'TRANSFER',
  TwoManDelivery = 'TWO_MAN_DELIVERY',
  TwoManPickup = 'TWO_MAN_PICKUP',
  TwoManPlus = 'TWO_MAN_PLUS',
  TwoManWg = 'TWO_MAN_WG',
  WaWga = 'WA_WGA',
  WhiteGlove = 'WHITE_GLOVE'
}

export type ServiceLevelReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLevelReportBucketEntity = {
  __typename?: 'ServiceLevelReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

/** An object describing the region and terminals operated in by a service company */
export type ServiceRegionEntity = {
  __typename?: 'ServiceRegionEntity';
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The terminals that are part of this service region */
  terminals: Array<TerminalEntity>;
};

export type ServiceUpdateInput = {
  calculateInboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateLineHaulFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  calculateOutboundFreightCharges?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAppointmentEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultAppointmentStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  defaultDeliveryPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultFulfillmentType?: InputMaybe<FulfillmentType>;
  defaultInboundStopType?: InputMaybe<StopType>;
  defaultIsLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  defaultOutboundStopType?: InputMaybe<StopType>;
  defaultPickupPadding?: InputMaybe<Scalars['Duration']['input']>;
  defaultStartNow?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTotalDuration?: InputMaybe<Scalars['Duration']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isExposedToCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  markOrdersAsSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  serviceAvailabilityDates?: InputMaybe<Array<UpsertServiceAvailabilityDateInput>>;
  timeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  useApptInRouteOptimization?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type SetAccessorialQboItemMappingInput = {
  qboItemId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type SetCompanyAccountTypeInput = {
  accountType: CompanyAccountType;
  companyUuid: Scalars['String']['input'];
};

export type SetContactChargeMatrixColumnMappingsInput = {
  contactUuid: Scalars['String']['input'];
  mappings: Array<ContactChargeMatrixColumnMappingInput>;
};

export type SetCrossdockInstructionInput = {
  instruction: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
  terminalUuid: Scalars['String']['input'];
};

export type SetDockDoorsInput = {
  doors: Array<DockDoorInput>;
  terminalUuid: Scalars['String']['input'];
};

export type SetDriverComplianceDatesInput = {
  driverUuid: Scalars['String']['input'];
  items: Array<DriverComplianceDateInput>;
};

export type SetDriverSettlementPayBoundsInput = {
  bounds: Array<DriverSettlementPayBoundInput>;
  driverUuid: Scalars['String']['input'];
};

export type SetLaneDefaultDoorInput = {
  destDoorPosition?: InputMaybe<Scalars['Int']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  originDoorPosition?: InputMaybe<Scalars['Int']['input']>;
  startTerminalUuid: Scalars['String']['input'];
};

export type SetLineHaulManifestLoadPositionInput = {
  loadPosition?: InputMaybe<LoadPosition>;
  uuid: Scalars['String']['input'];
};

export type SetLineHaulManifestLoadPositionOutput = MutationErrorOutput | SetLineHaulManifestLoadPositionSuccessOutput;

export type SetLineHaulManifestLoadPositionSuccessOutput = {
  __typename?: 'SetLineHaulManifestLoadPositionSuccessOutput';
  lineHaulManifest: LineHaulManifestEntity;
};

export type SetLineHaulManifestOrderLoadPositionInput = {
  lineHaulManifestUuid: Scalars['String']['input'];
  loadPosition?: InputMaybe<LoadPosition>;
  orderUuid: Scalars['String']['input'];
};

export type SetLineHaulSegmentTimingInput = {
  cutoffTime?: InputMaybe<Scalars['String']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  startTerminalUuid: Scalars['String']['input'];
  transitDays?: InputMaybe<Scalars['Int']['input']>;
  transitMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type SetLineHaulSegmentTimingOutput = {
  __typename?: 'SetLineHaulSegmentTimingOutput';
  timing?: Maybe<LineHaulSegmentTimingEntity>;
  updatedCount: Scalars['Int']['output'];
};

export type SetManifestDepartTimeInput = {
  /** Minutes after company-local midnight this run departs, or null to go back to following the template. */
  departTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  manifestUuid: Scalars['String']['input'];
};

export type SetManifestTrailersInput = {
  manifestUuid: Scalars['String']['input'];
  /** The trailer equipment UUIDs this run should carry, in load order. Empty clears the run to no trailers. */
  trailerEquipmentUuids: Array<Scalars['String']['input']>;
};

export type SetManifestTrailersOutput = {
  __typename?: 'SetManifestTrailersOutput';
  conflictWarning?: Maybe<Scalars['String']['output']>;
};

export type SetManifestTruckInput = {
  manifestUuid: Scalars['String']['input'];
  recurringTemplateTruckUuid?: InputMaybe<Scalars['String']['input']>;
};

export type SetManifestTruckOutput = {
  __typename?: 'SetManifestTruckOutput';
  conflictWarning?: Maybe<Scalars['String']['output']>;
};

export type SetMirrorTargetCompaniesInput = {
  /** Producer-side company UUIDs this target mirrors via the cron. */
  companyUuids: Array<Scalars['String']['input']>;
  targetUuid: Scalars['String']['input'];
};

export type SetMotiveApiKeyInput = {
  /** The Motive API key to store. */
  apiKey: Scalars['String']['input'];
};

export type SetNotificationCutoverModeInput = {
  /** The event type to configure. */
  eventType: NotificationEventType;
  /** The mode to set for the event type. */
  mode: NotificationEngineMode;
};

export type SetOrderExecutedByInput = {
  offerNote?: InputMaybe<Scalars['String']['input']>;
  orderUuid: Scalars['String']['input'];
  parts: Array<OrderDelegationPart>;
  peerUuid: Scalars['String']['input'];
  pickupHandling?: InputMaybe<DelegatedPickupHandling>;
  shareEndCustomer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetOrderMirrorCaptureConfigInput = {
  /** Company UUIDs to capture. Required (non-empty) when mode=COMPANIES; ignored otherwise. */
  companyUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 'NONE', 'ALL', or 'COMPANIES'. */
  mode: Scalars['String']['input'];
};

export type SetPeerAccessorialSharesInput = {
  accessorialUuids: Array<Scalars['String']['input']>;
  peerUuid: Scalars['String']['input'];
};

export type SetPeerServiceSharesInput = {
  peerUuid: Scalars['String']['input'];
  serviceUuids: Array<Scalars['String']['input']>;
};

export type SetPndRouteDriverInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuid: Scalars['String']['input'];
};

/** Replaces the supplied dimensions of one scheduling resource eligibility rule set. A dimension omitted, or sent as null, keeps its stored rules; the two are identical. A dimension supplied replaces BOTH of its lists, so a request changing only a deny list still sends the allow list it wants to keep; supplying both empty clears that dimension and makes it unrestricted, which is refused without confirmRestrictionRemoval when that dimension restricts the resource today. The three dimensions do not match the same way: read each list field. */
export type SetSchedulingResourceEligibilityRulesInput = {
  /** Write-time confirmation that emptying an allow list currently in force was meant, and the only way one request may lift a restriction. It is validated and discarded, never stored: the stored rules already say what the resource accepts. Needed only when a SUPPLIED dimension whose stored allow list names at least one subject arrives with an empty allow list, because the restriction marker is derived as allow.length > 0, so such a write turns a dedicated resource into one that takes all freight. A dimension whose stored allow list is ALREADY empty needs no confirmation even when its marker is set: that resource refuses every order today, and emptying its allow list is the documented repair. Never inferred, so an unconfirmed removal is refused rather than guessed at. Defaults to false. */
  confirmRestrictionRemoval?: InputMaybe<Scalars['Boolean']['input']>;
  /** Omit this field, or send null, to leave the customer rules exactly as they are; the two mean the same thing. Supplying it replaces BOTH of its lists, and two empty lists clear the dimension. */
  customers?: InputMaybe<SchedulingResourceCustomerEligibilityRulesInput>;
  schedulingResourceId: Scalars['String']['input'];
  /** Omit this field, or send null, to leave the service level rules exactly as they are; the two mean the same thing. Supplying it replaces BOTH of its lists, and two empty lists clear the dimension. */
  services?: InputMaybe<SchedulingResourceServiceEligibilityRulesInput>;
  /** Omit this field, or send null, to leave the tag rules exactly as they are; the two mean the same thing. Supplying it replaces BOTH of its lists, and two empty lists clear the dimension. */
  tags?: InputMaybe<SchedulingResourceTagEligibilityRulesInput>;
};

export type SetStorageOrderItemQuantityInput = {
  itemUuid: Scalars['String']['input'];
  /** The updated total quantity for the specified item. */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
};

export type SettlementAdjustmentCreateInput = {
  adjustmentType: SettlementAdjustmentType;
  driverSettlementBillUuid: Scalars['String']['input'];
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SettlementAdjustmentEntity = {
  __typename?: 'SettlementAdjustmentEntity';
  adjustmentType: SettlementAdjustmentType;
  flatRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentageDecimalRate?: Maybe<Scalars['Float']['output']>;
  totalDollars: Scalars['Currency']['output'];
  uuid: Scalars['String']['output'];
};

/** Type of Adjustment for Settlements. Deductions are negative. Adjustments are positive. */
export enum SettlementAdjustmentType {
  Adjustment = 'ADJUSTMENT',
  Deduction = 'DEDUCTION'
}

export type SettlementAdjustmentUpdateInput = {
  adjustmentType?: InputMaybe<SettlementAdjustmentType>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type SettlementBillChangeFlagEntity = {
  __typename?: 'SettlementBillChangeFlagEntity';
  actorUserUuid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  detail: Scalars['JSON']['output'];
  /** The frozen snapshot's final cents. Populated by DRIFT_DETECTED only. */
  frozenCents?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  /** The cents a recomputation against current inputs produced. Populated by DRIFT_DETECTED only. */
  observedCents?: Maybe<Scalars['Float']['output']>;
  resolutionNote?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedByUserUuid?: Maybe<Scalars['String']['output']>;
  settlementBillLineItemId?: Maybe<Scalars['String']['output']>;
  shipmentUuid?: Maybe<Scalars['String']['output']>;
  source: SettlementBillChangeFlagSource;
};

/** Why a finalized settlement bill was flagged. Each value names the write that reached a bill whose pay calculation is already frozen. */
export enum SettlementBillChangeFlagSource {
  DriftDetected = 'DRIFT_DETECTED',
  LegacyUnfinalizeAttempt = 'LEGACY_UNFINALIZE_ATTEMPT',
  LineItemReplacement = 'LINE_ITEM_REPLACEMENT',
  MapDelete = 'MAP_DELETE',
  MapMembershipWrite = 'MAP_MEMBERSHIP_WRITE',
  PayTermsWrite = 'PAY_TERMS_WRITE'
}

export type SettlementBillDriftEntity = {
  __typename?: 'SettlementBillDriftEntity';
  /** True when recomputing the bill against its current inputs produces a different total than the frozen calculation. */
  drifted: Scalars['Boolean']['output'];
  driverSettlementBillUuid: Scalars['String']['output'];
  /** Final cents recorded by the frozen calculation. */
  frozenCents?: Maybe<Scalars['Float']['output']>;
  /** False when the bill has never been finalized, in which case there is nothing frozen to drift from. */
  hasFrozenCalculation: Scalars['Boolean']['output'];
  /** Final cents a recomputation against the bill's current inputs produces. */
  observedCents?: Maybe<Scalars['Float']['output']>;
};

export type SettlementBillLineItemConnection = {
  __typename?: 'SettlementBillLineItemConnection';
  edges: Array<SettlementBillLineItemEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SettlementBillLineItemEdge = {
  __typename?: 'SettlementBillLineItemEdge';
  cursor: Scalars['String']['output'];
  node: SettlementBillLineItemEntity;
};

/** A line item on a settlement bill. Used to track costs associated with a shipment and driver. */
export type SettlementBillLineItemEntity = {
  __typename?: 'SettlementBillLineItemEntity';
  customCosts: Array<CustomCostEntity>;
  driver: DriverEntity;
  driverSettlementBill?: Maybe<DriverSettlementBillEntity>;
  freightCost?: Maybe<FreightCostEntity>;
  id: Scalars['String']['output'];
  /** The the revenue flat rate in dollars if it exists. Meant for presentation */
  revenueFlatRate?: Maybe<Scalars['Float']['output']>;
  /** The percentage rate as a percentage out of 100, if it exists */
  revenuePercentageRate?: Maybe<Scalars['Percent']['output']>;
  settlementMode: SettlementMode;
  shipment: ShipmentEntity;
  /** The total cost for the settlement bill line item in dollars if it exists. Meant for presentation */
  totalAmountUsdDollars: Scalars['Float']['output'];
};

export type SettlementChargeBreakdownLineOutput = {
  __typename?: 'SettlementChargeBreakdownLineOutput';
  eligibleAmount: Scalars['Float']['output'];
  flatRate?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
  lineType: SettlementChargeBreakdownLineType;
  percentageRate?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export enum SettlementChargeBreakdownLineType {
  Accessorial = 'ACCESSORIAL',
  AccessorialAdjustment = 'ACCESSORIAL_ADJUSTMENT',
  Deduction = 'DEDUCTION',
  Freight = 'FREIGHT',
  Fuel = 'FUEL'
}

export type SettlementDeductionCreateInput = {
  driverSettlementBillUuid: Scalars['String']['input'];
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SettlementDeductionEntity = {
  __typename?: 'SettlementDeductionEntity';
  adjustmentType?: Maybe<SettlementAdjustmentType>;
  flatRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentageDecimalRate?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type SettlementDeductionForDownloadEntity = {
  __typename?: 'SettlementDeductionForDownloadEntity';
  flatRate?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentageDecimalRate?: Maybe<Scalars['Float']['output']>;
};

export type SettlementDeductionTypeCreateInput = {
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageRate?: InputMaybe<Scalars['Float']['input']>;
};

export type SettlementDeductionTypeEntity = {
  __typename?: 'SettlementDeductionTypeEntity';
  flatRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentageRate?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type SettlementDeductionTypeUpdateInput = {
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type SettlementDeductionUpdateInput = {
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  flatRate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  percentageDecimalRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export enum SettlementMode {
  Dependent = 'DEPENDENT',
  Independent = 'INDEPENDENT'
}

export type SettlementPayBasisOutput = {
  __typename?: 'SettlementPayBasisOutput';
  basisType: SettlementPayBasisType;
  flatAmount?: Maybe<Scalars['Float']['output']>;
  isBounded: Scalars['Boolean']['output'];
  maxPay?: Maybe<Scalars['Float']['output']>;
  miles?: Maybe<Scalars['Float']['output']>;
  minPay?: Maybe<Scalars['Float']['output']>;
  perMileRate?: Maybe<Scalars['Float']['output']>;
  percentageOutOf100?: Maybe<Scalars['Float']['output']>;
};

export enum SettlementPayBasisType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE',
  PerMile = 'PER_MILE'
}

export enum SettlementPayCaptureReason {
  DraftAdoption = 'DRAFT_ADOPTION',
  ExplicitReconfiguration = 'EXPLICIT_RECONFIGURATION',
  PayableActivation = 'PAYABLE_ACTIVATION'
}

export enum SettlementPayRateSource {
  DriverDefault = 'DRIVER_DEFAULT',
  MapFlatOverride = 'MAP_FLAT_OVERRIDE',
  MapPercentageOverride = 'MAP_PERCENTAGE_OVERRIDE'
}

export enum SettlementPayTermsCaptureState {
  Captured = 'CAPTURED',
  LegacyUnknown = 'LEGACY_UNKNOWN',
  Uncaptured = 'UNCAPTURED'
}

export type SettlementStopChargeBreakdownOutput = {
  __typename?: 'SettlementStopChargeBreakdownOutput';
  driverPayout: Scalars['Float']['output'];
  lines: Array<SettlementChargeBreakdownLineOutput>;
  payBasis: SettlementPayBasisOutput;
  totalEligibleAmount: Scalars['Float']['output'];
};

export type SftpCredentialsEntity = {
  __typename?: 'SftpCredentialsEntity';
  bundleShipmentPhotosWithPod: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  host: Scalars['String']['output'];
  invoicePath?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  podNamingConvention?: Maybe<PodNamingConvention>;
  port: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SftpUploadConnection = {
  __typename?: 'SftpUploadConnection';
  edges: Array<SftpUploadEdge>;
  pageInfo: PageInfo;
};

export type SftpUploadEdge = {
  __typename?: 'SftpUploadEdge';
  cursor: Scalars['String']['output'];
  node: SftpUploadEntity;
};

export type SftpUploadEntity = {
  __typename?: 'SftpUploadEntity';
  company: CompanyEntity;
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<OrderEntity>;
  order?: Maybe<OrderEntity>;
  path?: Maybe<Scalars['String']['output']>;
  status: SftpUploadStatus;
  type: SftpUploadType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum SftpUploadStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Retried = 'RETRIED'
}

export enum SftpUploadType {
  Invoice = 'INVOICE',
  KuehneNagelXml = 'KUEHNE_NAGEL_XML',
  Pod = 'POD'
}

export type ShareSavedFilterViewInput = {
  grants: Array<SavedFilterViewGrantInput>;
  isPublicToCompany: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type ShipmentArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  shipmentCreateInput?: InputMaybe<ShipmentCreateInput>;
  /** Pass this field in to update an array item */
  shipmentUpdateInput?: InputMaybe<ShipmentUpdateInput>;
};

export type ShipmentChargeEntity = {
  __typename?: 'ShipmentChargeEntity';
  totalCharge: Scalars['Float']['output'];
  totalCustomCharge: Scalars['Float']['output'];
  totalFreightCharge: Scalars['Float']['output'];
  totalFuelCharge: Scalars['Float']['output'];
};

export type ShipmentConnection = {
  __typename?: 'ShipmentConnection';
  edges: Array<ShipmentEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ShipmentConsolidationType {
  ConsolidatedIn = 'CONSOLIDATED_IN',
  Standard = 'STANDARD'
}

export type ShipmentCreateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customChargeCreateInputs?: InputMaybe<Array<CustomChargeCreateInput>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  documentConnectInputs?: InputMaybe<Array<DocumentConnectInput>>;
  documentCreateInputs?: InputMaybe<Array<DocumentCreateInput>>;
  freightChargeCreateInput?: InputMaybe<FreightChargeCreateInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemCreateInputs?: InputMaybe<Array<IndependentSettlementBillLineItemCreateInput>>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  legCreateInputs?: InputMaybe<Array<LegCreateInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageCreateInputs?: InputMaybe<Array<PackageCreateInput>>;
  shipmentSubscriberUpsertInputs?: InputMaybe<Array<ShipmentSubscriberUpsertInput>>;
  shipmentType?: InputMaybe<ShipmentType>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsCreateInput?: InputMaybe<StandardShipmentFieldsCreateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type ShipmentEdge = {
  __typename?: 'ShipmentEdge';
  cursor: Scalars['String']['output'];
  node: ShipmentEntity;
};

export type ShipmentEntity = {
  airline?: Maybe<Scalars['String']['output']>;
  airportInfo?: Maybe<AirportInfoEntity>;
  billingShipmentStatus?: Maybe<BillingShipmentStatus>;
  charges: Array<ChargesUnion>;
  consigneeAddress?: Maybe<AddressEntity>;
  consolidatableShipment?: Maybe<ShipmentEntity>;
  consolidatableShipments?: Maybe<Array<ShipmentEntity>>;
  customCharges: Array<CustomChargeEntity>;
  dateAddedToInvoice?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedFinalized?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOfd?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  documents: Array<DocumentEntity>;
  failureCount: Scalars['Float']['output'];
  fields?: Maybe<StandardShipmentFieldsEntity>;
  freightCharge?: Maybe<FreightChargeEntity>;
  freightNeedsRate: Scalars['Boolean']['output'];
  hasBillingIssues?: Maybe<Scalars['DateTime']['output']>;
  hasFailedStop: Scalars['Boolean']['output'];
  hasSignedPOD: Scalars['Boolean']['output'];
  hideFromBilling: Scalars['Boolean']['output'];
  independentSettlementBillLineItems: Array<SettlementBillLineItemEntity>;
  inputForConsolidatedOrder?: Maybe<OrderEntity>;
  invoice?: Maybe<InvoiceEntity>;
  legs: Array<LegEntity>;
  name: Scalars['String']['output'];
  order?: Maybe<OrderEntity>;
  ordinal: Scalars['Float']['output'];
  overridePackageWeight: Scalars['Boolean']['output'];
  packages: Array<PackageEntity>;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  settlementBillLineItems: Array<SettlementBillLineItemEntity>;
  /** The shipment total charge, freight charge total, fuel charge total, and custom charge total in dollars */
  shipmentCharges: ShipmentChargeEntity;
  shipmentConsolidationType: ShipmentConsolidationType;
  shipmentSubscribers: Array<ShipmentSubscriberEntity>;
  shipmentType: ShipmentType;
  shipperAddress?: Maybe<AddressEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  shouldUseDimWeight: Scalars['Boolean']['output'];
  standardShipmentFields?: Maybe<StandardShipmentFieldsEntity>;
  status: ShipmentStatus;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the shipment in dollars */
  totalChargesAmount: Scalars['Float']['output'];
  totalChargesForDriverSettlement: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type ShipmentIncludedInRevenueEntity = {
  __typename?: 'ShipmentIncludedInRevenueEntity';
  shipmentTypeForCharge: ShipmentTypeForCharge;
  shipmentUuid: Scalars['String']['output'];
  terminalCode?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
};

export enum ShipmentPdfColumnMapping {
  DeliveryDate = 'DELIVERY_DATE',
  PickupOrDelivery = 'PICKUP_OR_DELIVERY',
  ServiceLevel = 'SERVICE_LEVEL',
  TotalChargeAmount = 'TOTAL_CHARGE_AMOUNT'
}

export enum ShipmentStatus {
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Finalized = 'FINALIZED',
  HasIssue = 'HAS_ISSUE',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Paid = 'PAID'
}

export type ShipmentStatusFilter = {
  filterType: ShipmentStatusFilterType;
  status: ShipmentStatus;
};

export enum ShipmentStatusFilterType {
  Equals = 'EQUALS',
  NotEquals = 'NOT_EQUALS'
}

export enum ShipmentStatusWithoutBilling {
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  InProgress = 'IN_PROGRESS',
  OutForDelivery = 'OUT_FOR_DELIVERY'
}

export type ShipmentSubscriberEntity = {
  __typename?: 'ShipmentSubscriberEntity';
  email?: Maybe<Scalars['String']['output']>;
  /** Subscriber phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Subscriber uuid */
  uuid: Scalars['String']['output'];
};

export type ShipmentSubscriberUpsertInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  /** Subscriber phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Subscriber uuid */
  uuid: Scalars['String']['input'];
};

export enum ShipmentType {
  LineHaul = 'LINE_HAUL',
  OrderCharges = 'ORDER_CHARGES',
  Regular = 'REGULAR'
}

export enum ShipmentTypeForCharge {
  Delivery = 'DELIVERY',
  LineHaul = 'LINE_HAUL',
  OrderCharge = 'ORDER_CHARGE',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY',
  Transfer = 'TRANSFER'
}

export type ShipmentUpdateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  customChargeArrayUpdateInputs?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  /** When sent, the custom charge save stops replacing the whole set and deletes only the charges listed here. Only updateStandardOrder accepts it; other operations refuse a non-null list. */
  deletedCustomChargeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  freightChargeUpsertInput?: InputMaybe<FreightChargeUpsertInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemUpsertInputs?: InputMaybe<Array<IndependentSettlementBillLineItemUpsertInput>>;
  legUpdateInput?: InputMaybe<LegUpdateInput>;
  /** @deprecated Prefer legUpdateInput - array update with upserts is problematic */
  legUpsertInputs?: InputMaybe<Array<LegUpsertInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsUpdateInput?: InputMaybe<StandardShipmentFieldsUpdateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type ShipperBillOfLadingNumberSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type SignUpForThirdPartyUserAccountInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignUpForThirdPartyUserAccountOutput = {
  __typename?: 'SignUpForThirdPartyUserAccountOutput';
  status: SignUpForThirdPartyUserAccountStatus;
  thirdPartyUser?: Maybe<ThirdPartyUserEntity>;
};

export enum SignUpForThirdPartyUserAccountStatus {
  EmailAlreadyExists = 'EMAIL_ALREADY_EXISTS',
  Success = 'SUCCESS'
}

/** Which party's signature a placement belongs to. */
export enum SignatureParty {
  Consignee = 'CONSIGNEE',
  Driver = 'DRIVER',
  Shipper = 'SHIPPER'
}

export type SignaturePlacementInput = {
  party?: InputMaybe<SignatureParty>;
  rect?: InputMaybe<SignaturePlacementRectInput>;
  suggestedRect?: InputMaybe<SignaturePlacementRectInput>;
  suggestedSource?: InputMaybe<SignaturePlacementSource>;
  suggestedTargetPage?: InputMaybe<Scalars['Int']['input']>;
  targetPage: Scalars['Int']['input'];
};

export type SignaturePlacementRectInput = {
  h: Scalars['Float']['input'];
  l: Scalars['Float']['input'];
  t: Scalars['Float']['input'];
  w: Scalars['Float']['input'];
};

export enum SignaturePlacementSource {
  AnchorDetected = 'ANCHOR_DETECTED',
  Ml = 'ML',
  Operator = 'OPERATOR'
}

export type SignaturePlacementSuggestionEntity = {
  __typename?: 'SignaturePlacementSuggestionEntity';
  pageImageUrl?: Maybe<Scalars['String']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  rect?: Maybe<SignatureRectEntity>;
  source: SignaturePlacementSource;
  targetPage: Scalars['Int']['output'];
};

export type SignatureRectEntity = {
  __typename?: 'SignatureRectEntity';
  h: Scalars['Float']['output'];
  l: Scalars['Float']['output'];
  t: Scalars['Float']['output'];
  w: Scalars['Float']['output'];
};

export enum SignedPodMatchStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Matched = 'MATCHED',
  Unmatched = 'UNMATCHED'
}

/** Why a document cannot currently be offered for e-signature. */
export enum SigningUnavailableReason {
  ConversionFailed = 'CONVERSION_FAILED',
  UnsupportedFileType = 'UNSUPPORTED_FILE_TYPE'
}

export type SimpleCustomCharge = {
  __typename?: 'SimpleCustomCharge';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type SimpleFreightCharge = {
  __typename?: 'SimpleFreightCharge';
  amount: Scalars['Float']['output'];
  billingMethod: FreightBillingMethod;
  quantity: Scalars['Float']['output'];
  rate: Scalars['String']['output'];
};

export type SimpleFuelCharge = {
  __typename?: 'SimpleFuelCharge';
  amount: Scalars['Float']['output'];
  billingMethod: FuelBillingMethod;
  quantity: Scalars['Float']['output'];
};

export type SkidBasedAccessorialCreateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  ratePerSkid: Scalars['Float']['input'];
};

export type SkidBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'SkidBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  ratePerSkid: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type SkidBasedAccessorialUpdateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratePerSkid?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type Smc3AvailableTariffsResultEntity = {
  __typename?: 'Smc3AvailableTariffsResultEntity';
  failure?: Maybe<Smc3ConnectionFailureEntity>;
  tariffs: Array<Smc3TariffEntity>;
};

export type Smc3ConnectionFailureEntity = {
  __typename?: 'Smc3ConnectionFailureEntity';
  code: ExternalRatingErrorCode;
  providerCode?: Maybe<Scalars['String']['output']>;
  providerMessage?: Maybe<Scalars['String']['output']>;
  retryAfter?: Maybe<Scalars['DateTime']['output']>;
  retryable: Scalars['Boolean']['output'];
};

export type Smc3ConnectionTestResultEntity = {
  __typename?: 'Smc3ConnectionTestResultEntity';
  connected: Scalars['Boolean']['output'];
  failure?: Maybe<Smc3ConnectionFailureEntity>;
};

export type Smc3DiagnosticsEntity = {
  __typename?: 'Smc3DiagnosticsEntity';
  lastErrorAt?: Maybe<Scalars['DateTime']['output']>;
  lastErrorCode?: Maybe<ExternalRatingErrorCode>;
  lastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum Smc3Environment {
  Production = 'PRODUCTION',
  Trial = 'TRIAL'
}

export type Smc3SettingsEntity = {
  __typename?: 'Smc3SettingsEntity';
  defaultTariffName?: Maybe<Scalars['String']['output']>;
  /** Null when the diagnostics store cannot be read. */
  diagnostics?: Maybe<Smc3DiagnosticsEntity>;
  environment?: Maybe<Smc3Environment>;
  hasCredentials: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  pinnedTariffEffectiveDate?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Smc3SettingsSaveResultEntity = {
  __typename?: 'Smc3SettingsSaveResultEntity';
  /** Set when SMC3 refused the connection; nothing was saved. */
  failure?: Maybe<Smc3ConnectionFailureEntity>;
  settings: Smc3SettingsEntity;
};

export type Smc3TariffEntity = {
  __typename?: 'Smc3TariffEntity';
  /** Listed effective dates, newest first. */
  effectiveDates: Array<Scalars['String']['output']>;
  tariffName: Scalars['String']['output'];
};

export type Smc3TestRateResultEntity = {
  __typename?: 'Smc3TestRateResultEntity';
  failure?: Maybe<Smc3ConnectionFailureEntity>;
  finalCents?: Maybe<Scalars['Int']['output']>;
  tariffEffectiveDate?: Maybe<Scalars['String']['output']>;
  tariffName?: Maybe<Scalars['String']['output']>;
};

export type SmsConsentAdminConnection = {
  __typename?: 'SmsConsentAdminConnection';
  edges: Array<SmsConsentAdminEdge>;
  pageInfo: PageInfo;
};

export type SmsConsentAdminEdge = {
  __typename?: 'SmsConsentAdminEdge';
  cursor: Scalars['String']['output'];
  node: SmsConsentAdminEntity;
};

export type SmsConsentAdminEntity = {
  __typename?: 'SmsConsentAdminEntity';
  basis: SmsConsentBasis;
  consecutiveFailures: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  events: Array<SmsConsentAdminEventEntity>;
  historyTruncated: Scalars['Boolean']['output'];
  landline?: Maybe<Scalars['Boolean']['output']>;
  lastFailureAt?: Maybe<Scalars['DateTime']['output']>;
  lastFailureCode?: Maybe<Scalars['Int']['output']>;
  lineTypeCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  maskedPhoneNumber: Scalars['String']['output'];
  optedInAt?: Maybe<Scalars['DateTime']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  status: SmsConsentStatus;
  undeliverableUntil?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type SmsConsentAdminEventEntity = {
  __typename?: 'SmsConsentAdminEventEntity';
  action: SmsConsentEventAction;
  occurredAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SmsConsentAdminFilterInput = {
  landline?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SmsConsentStatus>;
};

/** How the number reached us: CARRIER_PROVIDED on a delivery order, or WEB_FORM on the public opt-in page. */
export enum SmsConsentBasis {
  CarrierProvided = 'CARRIER_PROVIDED',
  WebForm = 'WEB_FORM'
}

/** One recorded change to a consent row. */
export enum SmsConsentEventAction {
  CarrierGranted = 'CARRIER_GRANTED',
  Confirmed = 'CONFIRMED',
  Requested = 'REQUESTED',
  Resumed = 'RESUMED',
  Revoked = 'REVOKED'
}

/** PENDING is a web-form request not yet confirmed from the handset; GRANTED may be texted; REVOKED has opted out. */
export enum SmsConsentStatus {
  Granted = 'GRANTED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

/** Represents the difference between 2 versions of an address. Used in audit log entries */
export type SnapshotAddressDifferences = {
  __typename?: 'SnapshotAddressDifferences';
  city?: Maybe<StringFieldDifference>;
  line1?: Maybe<StringFieldDifference>;
  name?: Maybe<StringFieldDifference>;
  state?: Maybe<StringFieldDifference>;
  zip?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of a custom charge. Used in audit log entries */
export type SnapshotCustomChargeDifferences = {
  __typename?: 'SnapshotCustomChargeDifferences';
  name?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

/** Represents the difference between 2 versions of a custom cost */
export type SnapshotCustomCostDifferences = {
  __typename?: 'SnapshotCustomCostDifferences';
  name?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

/** Represents the difference between 2 versions of a freight charge. Used in audit log entries */
export type SnapshotFreightChargeDifferences = {
  __typename?: 'SnapshotFreightChargeDifferences';
  billingMethod?: Maybe<StringFieldDifference>;
  externalRating?: Maybe<StringFieldDifference>;
  fuelCharge?: Maybe<SnapshotFuelChargeDifferences>;
  tariff?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
};

/** Represents the difference between 2 versions of a freight cost */
export type SnapshotFreightCostDifferences = {
  __typename?: 'SnapshotFreightCostDifferences';
  billingMethod?: Maybe<StringFieldDifference>;
  fuelCost?: Maybe<SnapshotFuelCostDifferences>;
  tariff?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
};

/** Represents the difference between 2 versions of a fuel charge. Used in audit log entries */
export type SnapshotFuelChargeDifferences = {
  __typename?: 'SnapshotFuelChargeDifferences';
  surchargeRate?: Maybe<NumberFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  type?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of a fuel cost */
export type SnapshotFuelCostDifferences = {
  __typename?: 'SnapshotFuelCostDifferences';
  billingMethod?: Maybe<StringFieldDifference>;
  surchargeRate?: Maybe<NumberFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  type?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of an independent settlement bill line item */
export type SnapshotIndependentSettlementBillLineItemDifferences = {
  __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences';
  customCosts?: Maybe<Array<SnapshotCustomCostDifferences>>;
  driverName?: Maybe<StringFieldDifference>;
  freightCost?: Maybe<SnapshotFreightCostDifferences>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

/** Represents the difference between 2 versions of an order. Used in audit log entries */
export type SnapshotOrderDifferences = {
  __typename?: 'SnapshotOrderDifferences';
  billingPartyName?: Maybe<StringFieldDifference>;
  hawb?: Maybe<StringFieldDifference>;
  mawb?: Maybe<StringFieldDifference>;
  packages?: Maybe<Array<SnapshotPackageDifferences>>;
  refNumbers?: Maybe<StringArrayFieldDifference>;
  serviceLevel?: Maybe<StringFieldDifference>;
  totalAmountCents?: Maybe<NumberFieldDifference>;
  vehicleType?: Maybe<StringFieldDifference>;
};

/** Represents the difference between 2 versions of a package. Used in audit log entries */
export type SnapshotPackageDifferences = {
  __typename?: 'SnapshotPackageDifferences';
  description?: Maybe<StringFieldDifference>;
  height?: Maybe<NumberFieldDifference>;
  length?: Maybe<NumberFieldDifference>;
  quantity?: Maybe<NumberFieldDifference>;
  type?: Maybe<StringFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
  weight?: Maybe<NumberFieldDifference>;
  width?: Maybe<NumberFieldDifference>;
};

/** Represents the difference between 2 versions of a stop. Used in audit log entries */
export type SnapshotStopDifferences = {
  __typename?: 'SnapshotStopDifferences';
  address?: Maybe<SnapshotAddressDifferences>;
  appointmentManuallyConfirmed?: Maybe<BooleanFieldDifference>;
  appointmentRequired?: Maybe<BooleanFieldDifference>;
  customCharges?: Maybe<Array<SnapshotCustomChargeDifferences>>;
  driverName?: Maybe<StringFieldDifference>;
  freightCharge?: Maybe<SnapshotFreightChargeDifferences>;
  independentSettlementBillLineItems?: Maybe<Array<SnapshotIndependentSettlementBillLineItemDifferences>>;
  isSpecial?: Maybe<BooleanFieldDifference>;
  serviceDate?: Maybe<StringFieldDifference>;
  serviceDateIso8601?: Maybe<StringFieldDifference>;
  stopType?: Maybe<StringFieldDifference>;
  terminal?: Maybe<StringFieldDifference>;
  wasAdded: Scalars['Boolean']['output'];
  wasDeleted: Scalars['Boolean']['output'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpecialAccessorialChargeGroupArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  specialAccessorialChargeGroupCreateInput?: InputMaybe<SpecialAccessorialChargeGroupCreateInput>;
  /** Pass this field in to update an array item */
  specialAccessorialChargeGroupUpdateInput?: InputMaybe<SpecialAccessorialChargeGroupUpdateInput>;
};

export type SpecialAccessorialChargeGroupCreateInput = {
  dayOfWeek: SpecialDayOfWeek;
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type SpecialAccessorialChargeGroupEntity = {
  __typename?: 'SpecialAccessorialChargeGroupEntity';
  dayOfWeek: SpecialDayOfWeek;
  endTime: Scalars['DateTime']['output'];
  startTime: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type SpecialAccessorialChargeGroupUpdateInput = {
  dayOfWeek?: InputMaybe<SpecialDayOfWeek>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type SpecialAccessorialCreateInput = {
  name: Scalars['String']['input'];
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  specialAccessorialType?: InputMaybe<SpecialAccessorialType>;
  specialChargeGroups: Array<SpecialAccessorialChargeGroupCreateInput>;
  specialMatrixItems: Array<SpecialAccessorialMatrixItemCreateInput>;
  specialMileRanges?: InputMaybe<Array<SpecialAccessorialMileRangeCreateInput>>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialAccessorialEntity = AccessorialInterface & {
  __typename?: 'SpecialAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  chargeGroups: Array<SpecialAccessorialChargeGroupEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  /** @deprecated Prefer the isSpecial field on the accessorial charge's corresponding stop */
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  matrixItems: Array<SpecialAccessorialMatrixItemEntity>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  serviceLevel?: Maybe<ServiceEntity>;
  specialAccessorialType?: Maybe<SpecialAccessorialType>;
  tariffZoneGroup?: Maybe<TariffZoneGroupEntity>;
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  zones: Array<TariffZoneEntity>;
};


export type SpecialAccessorialEntityChargeGroupsArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type SpecialAccessorialEntityMatrixItemsArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SpecialAccessorialMatrixItemArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  matrixItemCreateInput?: InputMaybe<SpecialAccessorialMatrixItemCreateInput>;
  /** Pass this field in to update an array item */
  matrixItemUpdateInput?: InputMaybe<SpecialAccessorialMatrixItemUpdateInput>;
};

export type SpecialAccessorialMatrixItemCreateInput = {
  chargeGroupDayOfWeek: SpecialDayOfWeek;
  chargeGroupEndTime: Scalars['DateTime']['input'];
  chargeGroupStartTime: Scalars['DateTime']['input'];
  chargeGroupUuid?: InputMaybe<Scalars['String']['input']>;
  /** Accepts rate as a $ float with two decimal places */
  rate: Scalars['Float']['input'];
  tariffZoneUuid: Scalars['String']['input'];
};

export type SpecialAccessorialMatrixItemEntity = {
  __typename?: 'SpecialAccessorialMatrixItemEntity';
  chargeGroupUuid: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  tariffZone: TariffZoneEntity;
  uuid: Scalars['String']['output'];
  zoneUuid: Scalars['String']['output'];
};

export type SpecialAccessorialMatrixItemUpdateInput = {
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type SpecialAccessorialMileRangeCreateInput = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
  /** UUIDs are generated on the frontend so that we can link matrix items to mile ranges on the frontend without first creating the mile ranges */
  uuid: Scalars['String']['input'];
};

export enum SpecialAccessorialType {
  MileageBased = 'MILEAGE_BASED',
  ZoneBased = 'ZONE_BASED'
}

export type SpecialAccessorialUpdateInput = {
  chargeGroupUpdates?: InputMaybe<Array<SpecialAccessorialChargeGroupArrayUpdateInput>>;
  matrixItemsArrayUpdateInput?: InputMaybe<Array<SpecialAccessorialMatrixItemArrayUpdateInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export enum SpecialDayOfWeek {
  Holiday = 'HOLIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Weekday = 'WEEKDAY'
}

export type SplitAndProcessOrderDocumentsInput = {
  /** A flag that determines whether the EOD documents should be automatched to the orders */
  autoMatchingEnabled: Scalars['Boolean']['input'];
  /** The UUID of the company the EOD documents are being matched for */
  companyUuid: Scalars['String']['input'];
  /** The day the EOD documents are being matched for */
  currentDate: Scalars['DateTime']['input'];
  orderDocuments: Array<OrderDocumentInput>;
};

export type StandardAccessorialCreateInput = {
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** Accepts rate as a $ float with two decimal places */
  rate: Scalars['Float']['input'];
};

export type StandardAccessorialEntity = AccessorialInterface & {
  __typename?: 'StandardAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  rate: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type StandardAccessorialUpdateInput = {
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  /** Rate in $, will be truncated to two decimal places */
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type StandardOrderCreateInput = {
  apiReceivedReference?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactStationId?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid: Scalars['String']['input'];
  callerName?: InputMaybe<Scalars['String']['input']>;
  callerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  chargeableWeightCubicMeters?: InputMaybe<Scalars['Volume']['input']>;
  codCheckAmountCents?: InputMaybe<Scalars['Int']['input']>;
  codCheckNumber?: InputMaybe<Scalars['String']['input']>;
  createdFromOrderTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  csvOrderImportStatus?: InputMaybe<CsvOrderImportStatus>;
  customerPortalChargesVisibleFromOverride?: InputMaybe<CustomerPortalChargesVisibility>;
  dateMarkedOnHand?: InputMaybe<Scalars['DateTime']['input']>;
  dateMarkedReceivedAtOrigin?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAutoAppliedAccessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  displayChargesInCustomerPortalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  documentCreateInputs?: InputMaybe<Array<DocumentCreateInput>>;
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ediConsigneeAddressCreateInput?: InputMaybe<AddressCreateInput>;
  ediConsigneeContactPersonCreateInput?: InputMaybe<ContactPersonCreateInput>;
  ediEquipmentType?: InputMaybe<Scalars['String']['input']>;
  ediReceivedScac?: InputMaybe<Scalars['String']['input']>;
  ediShipperAddressCreateInput?: InputMaybe<AddressCreateInput>;
  ediShipperContactPersonCreateInput?: InputMaybe<ContactPersonCreateInput>;
  efmServiceLevelCode?: InputMaybe<Scalars['String']['input']>;
  emergencyResponseNumber?: InputMaybe<Scalars['String']['input']>;
  enableLinehaul?: InputMaybe<Scalars['Boolean']['input']>;
  externalNotes?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  hazmatClass?: InputMaybe<HazmatClass>;
  hazmatDescription?: InputMaybe<Scalars['String']['input']>;
  holdReasonUuid?: InputMaybe<Scalars['String']['input']>;
  inBond?: InputMaybe<Scalars['Boolean']['input']>;
  inboundShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  inboundStopIntention?: InputMaybe<StopIntention>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCrossDock?: InputMaybe<Scalars['Boolean']['input']>;
  isDoorToDoor?: InputMaybe<Scalars['Boolean']['input']>;
  isDraftOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isReweighed?: InputMaybe<Scalars['Boolean']['input']>;
  issueReason?: InputMaybe<Scalars['String']['input']>;
  itTeIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  itTeNumber?: InputMaybe<Scalars['String']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulOriginTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  lockSecondaryRefNumber?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  onHold?: InputMaybe<Scalars['DateTime']['input']>;
  orderChargesShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  orderCommentCreateInputs?: InputMaybe<Array<CreateOrderCommentInput>>;
  orderConsolidationType?: InputMaybe<OrderConsolidationType>;
  orderSegmentType?: InputMaybe<OrderSegmentType>;
  outboundShipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  outboundStopIntention?: InputMaybe<StopIntention>;
  packageCreateInputs?: InputMaybe<Array<PackageCreateInput>>;
  packageGroup?: InputMaybe<PackageGroup>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  personEmail?: InputMaybe<Scalars['String']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  personPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickedDate?: InputMaybe<Scalars['DateTime']['input']>;
  pieceCount?: InputMaybe<Scalars['Float']['input']>;
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  quaternaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  quinaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  /** If false, the charges for the order will not be recalculated. This should only be used on manual order creation when client-side order rating has already been done. */
  recalculateCharges?: InputMaybe<Scalars['Boolean']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  recurringOrderFrequencyCreateInput?: InputMaybe<CreateRecurringOrderFrequencyInput>;
  refNumbers: Array<Scalars['String']['input']>;
  refusedBy?: InputMaybe<Scalars['String']['input']>;
  requiresPlacard?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentCreateInputs?: InputMaybe<Array<StandardShipmentCreateInput>>;
  source: OrderSource;
  standardOrderFieldsCreateInput?: InputMaybe<StandardOrderFieldsCreateInput>;
  status?: InputMaybe<OrderStatus>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tertiaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  thirdPartyBrokerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  /** Defaults to the order piece count (the sum of package quantities) when omitted. */
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  unNumber?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type StandardOrderEntity = OrderEntity & {
  __typename?: 'StandardOrderEntity';
  appliedAmount: Scalars['Float']['output'];
  balanceInCents: Scalars['Int']['output'];
  billingPartyContact: CustomerContactEntity;
  billingPartyContactStation?: Maybe<ContactStationEntity>;
  /** @deprecated Use personName */
  callerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use personPhoneNumber */
  callerPhoneNumber?: Maybe<Scalars['String']['output']>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  /** The chargeable weight is an optional weight value (measured in cubic meters) that can be used in billing calculations for the order. */
  chargeableWeightCubicMeters?: Maybe<Scalars['Volume']['output']>;
  codCheckAmountCents?: Maybe<Scalars['Int']['output']>;
  codCheckNumber?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  consolidatableOrders: ConsolidatableOrdersOutput;
  consolidatedOrders?: Maybe<Array<OrderEntity>>;
  consolidatedShipmentString?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  coverSheetDocumentTypeSequence?: Maybe<CoverSheetDocumentTypeSequenceEntity>;
  createdAt: Scalars['DateTime']['output'];
  createdFromOrderTemplate?: Maybe<OrderEntity>;
  csvOrderImportStatus?: Maybe<CsvOrderImportStatus>;
  /** Total custom charge (accessorial charge) for the order in dollars */
  customChargeRevenue: Scalars['Float']['output'];
  /** Each custom charge (accessorial charge) itemized */
  customCharges: Array<CustomChargeEntity>;
  customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility;
  customerPortalChargesVisibleFromOverride?: Maybe<CustomerPortalChargesVisibility>;
  dateMarkedLoaded?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOnHand?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedReceivedAtOrigin?: Maybe<Scalars['DateTime']['output']>;
  delegationAsDuplicate?: Maybe<OrderDelegationEntity>;
  delegations: Array<OrderDelegationEntity>;
  deletedAutoAppliedAccessorials: Array<AccessorialUnion>;
  detailedStatus?: Maybe<Scalars['String']['output']>;
  detailedStatusV2?: Maybe<OrderDetailedStatus>;
  dimWeight: Scalars['Float']['output'];
  displayChargesInCustomerPortalOverride?: Maybe<Scalars['Boolean']['output']>;
  documents: Array<DocumentEntity>;
  driverQualifications: Array<DriverQualificationEntity>;
  driverSettlementTotal: Scalars['Float']['output'];
  ediReceivedScac?: Maybe<Scalars['String']['output']>;
  ediReferences?: Maybe<Array<EdiReferenceEntity>>;
  ediServiceLevelCode?: Maybe<Scalars['String']['output']>;
  ediTransactions: Array<EdiTransactionEntity>;
  emergencyResponseNumber?: Maybe<Scalars['String']['output']>;
  enableLineHaul: Scalars['Boolean']['output'];
  endStop?: Maybe<StopEntity>;
  externalNotes?: Maybe<Scalars['String']['output']>;
  fields: StandardOrderFieldsEntity;
  /** Total freight charge for the order in dollars */
  freightChargeRevenue: Scalars['Float']['output'];
  freightNeedsRate: Scalars['Boolean']['output'];
  /** Total fuel charge for the order in dollars */
  fuelChargeRevenue: Scalars['Float']['output'];
  fulfillmentType?: Maybe<FulfillmentType>;
  hasDamage: Scalars['Boolean']['output'];
  hasDriverPod: Scalars['Boolean']['output'];
  hasDriverUploadedDocument: Scalars['Boolean']['output'];
  hasEdiCancellation: Scalars['Boolean']['output'];
  hasIssues: Scalars['Boolean']['output'];
  hasNoneOrCompletedInboundStop: Scalars['Boolean']['output'];
  hasShortage: Scalars['Boolean']['output'];
  hasUncollectedInboundStop: Scalars['Boolean']['output'];
  hazmat: Scalars['Boolean']['output'];
  hazmatClass?: Maybe<HazmatClass>;
  hazmatDescription?: Maybe<Scalars['String']['output']>;
  holdReason?: Maybe<HoldReasonEntity>;
  inBond: Scalars['Boolean']['output'];
  inboundPaperwork: OrderPaperworkEntity;
  inboundShipment?: Maybe<ShipmentEntity>;
  inboundStopIntention?: Maybe<StopIntention>;
  invoice?: Maybe<InvoiceEntity>;
  isCollectOnDelivery: Scalars['Boolean']['output'];
  isCrossDock?: Maybe<Scalars['Boolean']['output']>;
  isDoorToDoor?: Maybe<Scalars['Boolean']['output']>;
  /** Filters out draft and template orders */
  isDraftOrder: Scalars['Boolean']['output'];
  isOnHand: Scalars['Boolean']['output'];
  isOverdue: Scalars['Boolean']['output'];
  isReturnOrder: Scalars['Boolean']['output'];
  isReverse: Scalars['Boolean']['output'];
  isReweighed: Scalars['Boolean']['output'];
  issueReason?: Maybe<Scalars['String']['output']>;
  itTeIssueDate?: Maybe<Scalars['DateTime']['output']>;
  itTeNumber?: Maybe<Scalars['String']['output']>;
  lastCompletedLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  lastUpdatedByUser?: Maybe<UserActorEntity>;
  lineHaulCompletedDate: Scalars['DateTime']['output'];
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  lineHaulOriginTerminal?: Maybe<TerminalEntity>;
  lineHaulServiceDisplayString: Scalars['String']['output'];
  lineHaulShipment?: Maybe<ShipmentEntity>;
  /** The line haul events associated with an order, such as every stop at a terminal. This is the order’s own timeline, not an audit log of user actions or changes. */
  lineHaulTimeline: Array<OrderLineHaulTimelineEventEntity>;
  lockSecondaryRefNumber: Scalars['Boolean']['output'];
  /** @deprecated Use paperwork.missingDocuments instead */
  missingDocuments: Array<DocumentType>;
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  numPackagesOnHand: Scalars['Float']['output'];
  onHand?: Maybe<Scalars['Boolean']['output']>;
  onHold: Scalars['Boolean']['output'];
  orderChargesShipment?: Maybe<ShipmentEntity>;
  orderComments: Array<OrderCommentEntity>;
  orderConsolidationType: OrderConsolidationType;
  orderEvents: Array<OrderEventEntity>;
  orderInvoiceByDate?: Maybe<Scalars['DateTime']['output']>;
  orderPaymentMappings: Array<PaymentToOrderMappingEntity>;
  orderSegmentType: OrderSegmentType;
  /** Orders that were prorated with (but not including) this order */
  ordersProratedWith?: Maybe<Array<OrderEntity>>;
  ordersWithSameBillOfLadingNumber: Array<OrderEntity>;
  ordersWithSameBillOfLadingNumberForReviewOrders?: Maybe<Array<StandardOrderEntity>>;
  ordinal: Scalars['Int']['output'];
  /** Packaging as received on this order's original transmission, captured when the order is created and never rewritten. Empty for orders created before the snapshot existed, and for orders created without packages. */
  originalTransmissionPackages: Array<PackageEntity>;
  /** @deprecated Deprecated. Use hasIssues and hasDamage instead. */
  osAndD: Scalars['Boolean']['output'];
  osd?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated. Use hasIssues and hasDamage instead. */
  osdReason?: Maybe<Scalars['String']['output']>;
  outboundPaperwork: OrderPaperworkEntity;
  /** The scans out of the last terminal (if multi-terminal and line haul), or simply departure scans corresponding to outbound delivery */
  outboundScans: Array<ScanEntity>;
  outboundShipment?: Maybe<ShipmentEntity>;
  outboundStopIntention?: Maybe<StopIntention>;
  packageCount: Scalars['Float']['output'];
  packageGroup?: Maybe<PackageGroup>;
  packages: Array<PackageEntity>;
  paperwork: OrderPaperworkEntity;
  paymentMethod?: Maybe<PaymentMethod>;
  personEmail?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  personPhoneNumber?: Maybe<Scalars['String']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  pieceCount?: Maybe<Scalars['Int']['output']>;
  pieceCountFromPackages: Scalars['Float']['output'];
  pieces: Array<PieceEntity>;
  piecesDelivered: PiecesDeliveredEntity;
  piecesLoaded?: Maybe<Scalars['Int']['output']>;
  piecesPicked?: Maybe<Scalars['Int']['output']>;
  piecesPickedUp: PiecesPickedUpEntity;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  quaternaryRefNumber?: Maybe<Scalars['String']['output']>;
  quinaryRefNumber?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<QuoteEntity>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  recurringOrderFrequency?: Maybe<RecurringOrderFrequencyEntity>;
  refNumbers: Array<Scalars['String']['output']>;
  refusedBy?: Maybe<Scalars['String']['output']>;
  refusedDate?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  refusedReasonCode?: Maybe<OrderRefusalReason>;
  requiresPlacard?: Maybe<Scalars['Boolean']['output']>;
  reversalCounterpart?: Maybe<ReversalCounterpartOrder>;
  run?: Maybe<RunEntity>;
  scannedOrderResult?: Maybe<ScannedOrderResultEntity>;
  /** A field that represents a concatenation of all fields on the order that we want to search by. */
  searchText?: Maybe<Scalars['String']['output']>;
  secondaryRefNumber?: Maybe<Scalars['String']['output']>;
  service?: Maybe<ServiceEntity>;
  shipments: Array<ShipmentEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  shouldDisplayChargesInCustomerPortal: Scalars['Boolean']['output'];
  source: OrderSource;
  standardOrderFields: StandardOrderFieldsEntity;
  startStop?: Maybe<StopEntity>;
  status: OrderStatus;
  tags: Array<TagEntity>;
  tertiaryRefNumber?: Maybe<Scalars['String']['output']>;
  thirdPartyBrokers: Array<ThirdPartyBrokerEntity>;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the order in dollars */
  totalCharge: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  totalSkids?: Maybe<Scalars['Int']['output']>;
  unNumber?: Maybe<Scalars['String']['output']>;
  upcomingLineHaulSegment?: Maybe<LineHaulSegmentEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  vehicleType?: Maybe<VehicleTypeEntity>;
  warehouse?: Maybe<WarehouseEntity>;
  weight: Scalars['Float']['output'];
};

export type StandardOrderFieldsCreateInput = {
  defaultConsigneeStopCreateInput?: InputMaybe<StopCreateInput>;
  defaultShipperStopCreateInput?: InputMaybe<StopCreateInput>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  driversNeededInVehicle?: InputMaybe<Scalars['Int']['input']>;
  houseAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  lockShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  numberOfConsignees: NumberOfConsignees;
  numberOfShippers: NumberOfShippers;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
};

export type StandardOrderFieldsEntity = {
  __typename?: 'StandardOrderFieldsEntity';
  createdAt: Scalars['DateTime']['output'];
  defaultConsigneeStop?: Maybe<StandardStopEntity>;
  defaultShipperStop?: Maybe<StandardStopEntity>;
  dimFactor?: Maybe<Scalars['Int']['output']>;
  driversNeededInVehicle?: Maybe<Scalars['Int']['output']>;
  /** The HAWB: houseAirwayBillOfLadingNumber when set, otherwise shipperBillOfLadingNumber (the order form's HAWB field). Null when both are blank. */
  hawb?: Maybe<Scalars['String']['output']>;
  houseAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  lockShipperBillOfLadingNumber: Scalars['Boolean']['output'];
  masterAirwayBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  measurementUnits: MeasurementUnits;
  numberOfConsignees: NumberOfConsignees;
  numberOfShippers: NumberOfShippers;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weightUnits: WeightUnits;
};

export type StandardOrderFieldsUpdateInput = {
  /** @deprecated This field is unused and ignored. */
  defaultConsigneeStopUpsertInput?: InputMaybe<StandardStopUpsertInput>;
  /** @deprecated This field is unused and ignored. */
  defaultShipperStopUpsertInput?: InputMaybe<StandardStopUpsertInput>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  driversNeededInVehicle?: InputMaybe<Scalars['Int']['input']>;
  houseAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  lockShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  masterAirwayBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  numberOfConsignees?: InputMaybe<NumberOfConsignees>;
  numberOfShippers?: InputMaybe<NumberOfShippers>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  shipperBillOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  weightUnits?: InputMaybe<WeightUnits>;
};

export type StandardOrderUpdateInput = {
  billingPartyContactStationId?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  billingStatus?: InputMaybe<OrderBillingStatus>;
  /** @deprecated Use personName */
  callerName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use personPhoneNumber */
  callerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  chargeableWeightCubicMeters?: InputMaybe<Scalars['Volume']['input']>;
  codCheckAmountCents?: InputMaybe<Scalars['Int']['input']>;
  codCheckNumber?: InputMaybe<Scalars['String']['input']>;
  createdFromOrderTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  customerPortalChargesVisibleFromOverride?: InputMaybe<CustomerPortalChargesVisibility>;
  dateMarkedReceivedAtOrigin?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAutoAppliedAccessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Loaded packages the user deleted, with the pieces the form loaded on them. When sent, only these packages are deleted. */
  deletedPackages?: InputMaybe<Array<DeletedPackageInput>>;
  displayChargesInCustomerPortalOverride?: InputMaybe<Scalars['Boolean']['input']>;
  documentUpsertInputs?: InputMaybe<Array<DocumentUpsertInput>>;
  driverQualificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emergencyResponseNumber?: InputMaybe<Scalars['String']['input']>;
  /** Enables line haul features for the order */
  enableLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  externalNotes?: InputMaybe<Scalars['String']['input']>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  hasDamage?: InputMaybe<Scalars['Boolean']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  hasShortage?: InputMaybe<Scalars['Boolean']['input']>;
  hazmat?: InputMaybe<Scalars['Boolean']['input']>;
  hazmatClass?: InputMaybe<HazmatClass>;
  hazmatDescription?: InputMaybe<Scalars['String']['input']>;
  holdReasonUuid?: InputMaybe<Scalars['String']['input']>;
  inBond?: InputMaybe<Scalars['Boolean']['input']>;
  inboundStopIntention?: InputMaybe<StopIntention>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isCrossDock?: InputMaybe<Scalars['Boolean']['input']>;
  isDoorToDoor?: InputMaybe<Scalars['Boolean']['input']>;
  isDraftOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isReweighed?: InputMaybe<Scalars['Boolean']['input']>;
  issueReason?: InputMaybe<Scalars['String']['input']>;
  itTeIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  itTeNumber?: InputMaybe<Scalars['String']['input']>;
  lineHaulChargeSetByOperator?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulLaneUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulOriginTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  lineHaulRemovedByOperator?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  orderCommentCreateInputs?: InputMaybe<Array<CreateOrderCommentInput>>;
  osd?: InputMaybe<Scalars['Boolean']['input']>;
  outboundStopIntention?: InputMaybe<StopIntention>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  packageGroup?: InputMaybe<PackageGroup>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  personEmail?: InputMaybe<Scalars['String']['input']>;
  personName?: InputMaybe<Scalars['String']['input']>;
  personPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pickedDate?: InputMaybe<Scalars['DateTime']['input']>;
  pieceCount?: InputMaybe<Scalars['Int']['input']>;
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  recalculateTotals?: InputMaybe<Scalars['Boolean']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  recurringOrderFrequencyUpdateInput?: InputMaybe<UpdateRecurringOrderFrequencyInput>;
  refNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  refusedBy?: InputMaybe<Scalars['String']['input']>;
  refusedDate?: InputMaybe<Scalars['DateTime']['input']>;
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  requiresPlacard?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  shipmentArrayUpdateInputs?: InputMaybe<Array<StandardShipmentArrayUpdateInput>>;
  standardOrderFieldsUpdateInput?: InputMaybe<StandardOrderFieldsUpdateInput>;
  status?: InputMaybe<OrderStatus>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  tertiaryRefNumber?: InputMaybe<Scalars['String']['input']>;
  thirdPartyBrokerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  totalSkids?: InputMaybe<Scalars['Int']['input']>;
  unNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type StandardShipmentArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  shipmentCreateInput?: InputMaybe<StandardShipmentCreateInput>;
  /** Pass this field in to update an array item */
  shipmentUpdateInput?: InputMaybe<StandardShipmentUpdateInput>;
};

export type StandardShipmentCreateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customChargeCreateInputs?: InputMaybe<Array<CustomChargeCreateInput>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  documentConnectInputs?: InputMaybe<Array<DocumentConnectInput>>;
  documentCreateInputs?: InputMaybe<Array<DocumentCreateInput>>;
  freightChargeCreateInput?: InputMaybe<FreightChargeCreateInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemCreateInputs?: InputMaybe<Array<IndependentSettlementBillLineItemCreateInput>>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  legCreateInputs?: InputMaybe<Array<LegCreateInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageCreateInputs?: InputMaybe<Array<PackageCreateInput>>;
  shipmentSubscriberUpsertInputs?: InputMaybe<Array<ShipmentSubscriberUpsertInput>>;
  shipmentType?: InputMaybe<ShipmentType>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsCreateInput?: InputMaybe<StandardShipmentFieldsCreateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type StandardShipmentEntity = ShipmentEntity & {
  __typename?: 'StandardShipmentEntity';
  airline?: Maybe<Scalars['String']['output']>;
  airportInfo?: Maybe<AirportInfoEntity>;
  billingShipmentStatus?: Maybe<BillingShipmentStatus>;
  charges: Array<ChargesUnion>;
  consigneeAddress?: Maybe<AddressEntity>;
  consolidatableShipment?: Maybe<ShipmentEntity>;
  consolidatableShipments?: Maybe<Array<ShipmentEntity>>;
  customCharges: Array<CustomChargeEntity>;
  dateAddedToInvoice?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedFinalized?: Maybe<Scalars['DateTime']['output']>;
  dateMarkedOfd?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  documents: Array<DocumentEntity>;
  failureCount: Scalars['Float']['output'];
  fields?: Maybe<StandardShipmentFieldsEntity>;
  freightCharge?: Maybe<FreightChargeEntity>;
  freightNeedsRate: Scalars['Boolean']['output'];
  hasBillingIssues?: Maybe<Scalars['DateTime']['output']>;
  hasFailedStop: Scalars['Boolean']['output'];
  hasSignedPOD: Scalars['Boolean']['output'];
  hideFromBilling: Scalars['Boolean']['output'];
  independentSettlementBillLineItems: Array<SettlementBillLineItemEntity>;
  inputForConsolidatedOrder?: Maybe<OrderEntity>;
  invoice?: Maybe<InvoiceEntity>;
  legs: Array<LegEntity>;
  name: Scalars['String']['output'];
  order?: Maybe<OrderEntity>;
  ordinal: Scalars['Float']['output'];
  overridePackageWeight: Scalars['Boolean']['output'];
  packages: Array<PackageEntity>;
  postedAmountCents?: Maybe<Scalars['Int']['output']>;
  settlementBillLineItems: Array<SettlementBillLineItemEntity>;
  /** The shipment total charge, freight charge total, fuel charge total, and custom charge total in dollars */
  shipmentCharges: ShipmentChargeEntity;
  shipmentConsolidationType: ShipmentConsolidationType;
  shipmentSubscribers: Array<ShipmentSubscriberEntity>;
  shipmentType: ShipmentType;
  shipperAddress?: Maybe<AddressEntity>;
  shouldBillIndividually: Scalars['Boolean']['output'];
  shouldUseDimWeight: Scalars['Boolean']['output'];
  standardShipmentFields: StandardShipmentFieldsEntity;
  status: ShipmentStatus;
  totalAmountCents?: Maybe<Scalars['Int']['output']>;
  /** The total charges for the shipment in dollars */
  totalChargesAmount: Scalars['Float']['output'];
  totalChargesForDriverSettlement: Scalars['Float']['output'];
  totalCustomChargesAmount: Scalars['Float']['output'];
  totalFreightChargesAmount: Scalars['Float']['output'];
  totalFuelChargesAmount: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type StandardShipmentFieldsCreateInput = {
  cargoDescription?: InputMaybe<Scalars['String']['input']>;
  cargoPieces?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  pickupOrDelivery: PickupOrDelivery;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  type: StandardShipmentType;
  weightUnits?: InputMaybe<WeightUnits>;
};

export type StandardShipmentFieldsEntity = {
  __typename?: 'StandardShipmentFieldsEntity';
  cargoDescription?: Maybe<Scalars['String']['output']>;
  cargoPieces?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deadlineDate?: Maybe<Scalars['DateTime']['output']>;
  deadlineType?: Maybe<DeadlineType>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  dimFactor: Scalars['Int']['output'];
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  measurementUnits: MeasurementUnits;
  outboundMethod?: Maybe<OutboundMethod>;
  pickupOrDelivery: PickupOrDelivery;
  service?: Maybe<ServiceEntity>;
  serviceLevel?: Maybe<ServiceLevel>;
  type: StandardShipmentType;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
  weightUnits: WeightUnits;
};

export type StandardShipmentFieldsUpdateInput = {
  cargoDescription?: InputMaybe<Scalars['String']['input']>;
  cargoPieces?: InputMaybe<Scalars['Int']['input']>;
  deadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineType?: InputMaybe<DeadlineType>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  name?: InputMaybe<Scalars['String']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  standardShipmentFieldsCreateInput?: InputMaybe<StandardShipmentFieldsCreateInput>;
  type?: InputMaybe<StandardShipmentType>;
  uuid: Scalars['String']['input'];
  weightUnits?: InputMaybe<WeightUnits>;
};

export enum StandardShipmentType {
  SingleStop = 'SINGLE_STOP'
}

export type StandardShipmentUpdateInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  airportInfoUuid?: InputMaybe<Scalars['String']['input']>;
  customChargeArrayUpdateInputs?: InputMaybe<Array<CustomChargeArrayUpdateInput>>;
  /** When sent, the custom charge save stops replacing the whole set and deletes only the charges listed here. Only updateStandardOrder accepts it; other operations refuse a non-null list. */
  deletedCustomChargeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  freightChargeUpsertInput?: InputMaybe<FreightChargeUpsertInput>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  independentSettlementBillLineItemUpsertInputs?: InputMaybe<Array<IndependentSettlementBillLineItemUpsertInput>>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  legUpdateInput?: InputMaybe<LegUpdateInput>;
  /** @deprecated Prefer legUpdateInput - array update with upserts is problematic */
  legUpsertInputs?: InputMaybe<Array<LegUpsertInput>>;
  overridePackageWeight?: InputMaybe<Scalars['Boolean']['input']>;
  packageArrayUpdateInputs?: InputMaybe<Array<PackageArrayUpdateInput>>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shouldUseDimWeight?: InputMaybe<Scalars['Boolean']['input']>;
  standardShipmentFieldsUpdateInput?: InputMaybe<StandardShipmentFieldsUpdateInput>;
  status?: InputMaybe<ShipmentStatusWithoutBilling>;
  /** The total charge in dollars */
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type StandardStopEntity = StopEntity & {
  __typename?: 'StandardStopEntity';
  address: AddressEntity;
  appointmentCallStatus?: Maybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed: Scalars['Boolean']['output'];
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The STORED appointment status. Only CANCELLED is ever stored; null means the status is derived from the confirmation columns, not that there is none. */
  appointmentStatus?: Maybe<AppointmentStatus>;
  appointmentTextStatus?: Maybe<AppointmentTextStatus>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  cachedEta?: Maybe<EtaEntity>;
  canMarkAttemptComplete?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedByAgentAt?: Maybe<Scalars['DateTime']['output']>;
  consigneeAddress?: Maybe<AddressEntity>;
  consigneeContactPerson?: Maybe<ContactPersonEntity>;
  /** True when this stop's current automated call has already been reported as a contact attempt. Reporting it again needs reportAdditionalAttempt. */
  contactAttemptReportedForCurrentCall: Scalars['Boolean']['output'];
  contactPerson?: Maybe<ContactPersonEntity>;
  courierReadyOrDueDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerBookingNotes?: Maybe<Scalars['String']['output']>;
  deadlineTime?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  driverCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  equipment?: Maybe<EquipmentEntity>;
  eta?: Maybe<EtaEntity>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  etaFinishTime?: Maybe<Scalars['DateTime']['output']>;
  etaLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  expectedOutboundDate?: Maybe<Scalars['DateTime']['output']>;
  failureCount?: Maybe<Scalars['Float']['output']>;
  formattedCallMessage?: Maybe<Scalars['String']['output']>;
  /** returns if a stop has a previous attempt */
  hasPreviousAttempt: Scalars['Boolean']['output'];
  hideFromDispatch?: Maybe<Scalars['Boolean']['output']>;
  inboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  incomingCarrier?: Maybe<Scalars['String']['output']>;
  /** returns if a stop is an attempt */
  isAttempt: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  lastAppointmentTextTime?: Maybe<Scalars['DateTime']['output']>;
  leg?: Maybe<LegEntity>;
  linkedEndStop?: Maybe<StopEntity>;
  /** The local time zone of the stop, based on the address. Defaults to company time zone. */
  localTimeZone?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundCarrier?: Maybe<Scalars['String']['output']>;
  outboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  paperworkMarkedComplete?: Maybe<Scalars['Boolean']['output']>;
  pickupOrDelivery: StopPickupOrDelivery;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeChangeAcknowledged: Scalars['Boolean']['output'];
  routeName?: Maybe<RouteNameEntity>;
  routeSlot?: Maybe<RouteSlotEntity>;
  sentToAgentAt?: Maybe<Scalars['DateTime']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment?: Maybe<ShipmentEntity>;
  /** shipment consignee address- the address for the endStop of the last leg in the shipment that this stop's leg belongs to */
  shipmentConsigneeAddress: AddressEntity;
  /** Total volume of all packages associated with this stop's shipment */
  shipmentTotalVolume: Scalars['Float']['output'];
  /** Total weight of all packages associated with this stop's shipment */
  shipmentTotalWeight: Scalars['Float']['output'];
  shipperAddress?: Maybe<AddressEntity>;
  shipperContactPerson?: Maybe<ContactPersonEntity>;
  showDriverModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  startOrEnd: StartOrEnd;
  status: StopStatus;
  stopDetails?: Maybe<StopDetailsOutput>;
  stopDriverMaps: Array<StopDriverMapEntity>;
  stopIntention?: Maybe<StopIntention>;
  stopType?: Maybe<StopType>;
  terminal?: Maybe<TerminalEntity>;
  textResponses?: Maybe<Scalars['String']['output']>;
  transferAddress?: Maybe<AddressEntity>;
  twilioCallSid?: Maybe<Scalars['String']['output']>;
  twilioTextSid?: Maybe<Scalars['String']['output']>;
  /** Convenience field, not strongly typed. Recommended for display only, use the other fields if you need to do something programmatically with it */
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum StandardStopType {
  Commercial = 'COMMERCIAL',
  Dummy = 'DUMMY',
  Residential = 'RESIDENTIAL'
}

/** A filter object that is used to filter the standard stop type enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type StandardStopTypeFilter = {
  /** Filters for records where the relevant standard stop type field is equal to the provided standard stop type value */
  eq?: InputMaybe<StandardStopType>;
  /** Filters for records where the relevant standard stop type field is in the provided standard stop type values */
  in?: InputMaybe<Array<StandardStopType>>;
  /** Filters for records where the relevant standard stop type field is not equal to the provided standard stop type value */
  neq?: InputMaybe<StandardStopType>;
  /** Filters for records where the relevant standard stop type field is not in the provided standard stop type values */
  nin?: InputMaybe<Array<StandardStopType>>;
};

export type StandardStopUpsertInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentCallStatus?: InputMaybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  courierReadyOrDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  lastAppointmentTextTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  removedDriver?: InputMaybe<Scalars['Boolean']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. If null or unspecified, the stop's service date will not be updated. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287?pvs=4. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopIntention?: InputMaybe<StopIntention>;
  stopType?: InputMaybe<StopType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  transferAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  twilioCallSid?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  upsertStopDriverMapInputs?: InputMaybe<Array<UpsertStopDriverMapInput>>;
  uuid: Scalars['String']['input'];
};

export type StartConfigMigrationInput = {
  companyUuid: Scalars['String']['input'];
  confirmProductionTarget?: InputMaybe<Scalars['Boolean']['input']>;
  dryRun: Scalars['Boolean']['input'];
  groups: Array<ConfigMigrationFeatureGroup>;
  source: MigrationEnv;
  target: MigrationEnv;
};

export type StartInventoryCountInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to on-hand pieces with a warehouse but no warehouse location assigned. */
  noLocationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to on-dock pieces flagged overdue by dwell time. */
  overdueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Piece statuses in scope. Defaults to the web Inventory bucket (ARRIVED, PLANNED) when omitted. */
  statuses?: InputMaybe<Array<PieceStatus>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to pieces not associated to any order. */
  unassociatedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type StartInventoryCountOutput = InventoryCountEntity | InventoryCountScopeTooLargeOutput;

export enum StartOrEnd {
  End = 'END',
  Start = 'START'
}

export type StartPieceBackfillRunInput = {
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  companyUuid: Scalars['String']['input'];
  confirmExecute?: InputMaybe<Scalars['Boolean']['input']>;
  cutoffDate: Scalars['DateTime']['input'];
  mode: PieceBackfillRunMode;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type StationReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid: Scalars['String']['input'];
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type StationReportBucketEntity = {
  __typename?: 'StationReportBucketEntity';
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  stationId?: Maybe<Scalars['String']['output']>;
  stationName?: Maybe<Scalars['String']['output']>;
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
};

export type StatusFilter = {
  filterType: OrderStatusFilterType;
  status: OrderStatus;
};

export enum StatusMappingCategory {
  OrderStatus = 'ORDER_STATUS',
  OrderStatusDescription = 'ORDER_STATUS_DESCRIPTION',
  PieceStatus = 'PIECE_STATUS'
}

export enum StopAction {
  AssignToDriver = 'ASSIGN_TO_DRIVER',
  MarkArrived = 'MARK_ARRIVED',
  MarkAttempted = 'MARK_ATTEMPTED',
  MarkComplete = 'MARK_COMPLETE',
  MarkIncomplete = 'MARK_INCOMPLETE',
  MarkPaperworkComplete = 'MARK_PAPERWORK_COMPLETE',
  SetAppointmentConfirmed = 'SET_APPOINTMENT_CONFIRMED',
  SetAppointmentRequired = 'SET_APPOINTMENT_REQUIRED',
  SetAppointmentTime = 'SET_APPOINTMENT_TIME',
  UnassignFromRoute = 'UNASSIGN_FROM_ROUTE'
}

export type StopActionResult = {
  __typename?: 'StopActionResult';
  action: StopAction;
  results: BulkActionEntityResults;
};

/** Filter for the stops list by completion state. COMPLETED = completedAt set, UNCOMPLETED = completedAt null, ALL = no constraint. */
export enum StopCompletionStatus {
  All = 'ALL',
  Completed = 'COMPLETED',
  Uncompleted = 'UNCOMPLETED'
}

export type StopCreateInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentCallStatus?: InputMaybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  consigneeAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  consigneeContactPersonUpsertInput?: InputMaybe<ContactPersonUpdateInput>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpdateInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  podSignee?: InputMaybe<Scalars['String']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  removedDriver?: InputMaybe<Scalars['Boolean']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. If null or unspecified, the stop's service date will not be updated. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287?pvs=4 for details. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  shipperAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  shipperContactPersonUpsertInput?: InputMaybe<ContactPersonUpdateInput>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopIntention?: InputMaybe<StopIntention>;
  stopType?: InputMaybe<StopType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  transferAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  twilioCallSid?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  upsertStopDriverMapInputs?: InputMaybe<Array<UpsertStopDriverMapInput>>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type StopDetailsOutput = {
  __typename?: 'StopDetailsOutput';
  message?: Maybe<Scalars['String']['output']>;
  stopDetailsStatus: StopDetailsStatus;
};

export enum StopDetailsStatus {
  AwaitingAgentConfirmation = 'AWAITING_AGENT_CONFIRMATION',
  AwaitingSendToAgent = 'AWAITING_SEND_TO_AGENT',
  InboundRequired = 'INBOUND_REQUIRED',
  Loaded = 'LOADED',
  OnHand = 'ON_HAND',
  OnRoute = 'ON_ROUTE',
  PartiallyOnHand = 'PARTIALLY_ON_HAND'
}

export type StopDriverMapAddressForDownloadEntity = {
  __typename?: 'StopDriverMapAddressForDownloadEntity';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type StopDriverMapConnection = {
  __typename?: 'StopDriverMapConnection';
  edges: Array<StopDriverMapEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StopDriverMapEdge = {
  __typename?: 'StopDriverMapEdge';
  cursor: Scalars['String']['output'];
  node: StopDriverMapEntity;
};

export type StopDriverMapEntity = {
  __typename?: 'StopDriverMapEntity';
  driver: DriverEntity;
  driverPayoutFinalized: Scalars['Boolean']['output'];
  driverSettlementBill?: Maybe<DriverSettlementBillEntity>;
  driverSettlementTotalAmounts: DriverSettlementTotalAmountsOutput;
  enableDriverSettlement?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revenueFlatRate?: Maybe<Scalars['Float']['output']>;
  revenuePercentageRate?: Maybe<Scalars['Float']['output']>;
  stop: StopEntity;
  totalChargesForSettlement?: Maybe<Scalars['Float']['output']>;
  totalDriverPayoutForStop?: Maybe<Scalars['Float']['output']>;
  totalEligibleAmountForStop?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type StopDriverMapForCompletedStopsEntity = {
  __typename?: 'StopDriverMapForCompletedStopsEntity';
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  driver: DriverEntity;
  isLineHaul?: Maybe<Scalars['Boolean']['output']>;
  linehaulEndTerminal?: Maybe<TerminalEntity>;
  linehaulStartTerminal?: Maybe<TerminalEntity>;
  order?: Maybe<OrderEntity>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  serviceDateV2?: Maybe<PlainDate>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  stopType?: Maybe<StopType>;
  stopUuid?: Maybe<Scalars['String']['output']>;
};

export type StopDriverMapForDownloadEntity = {
  __typename?: 'StopDriverMapForDownloadEntity';
  address?: Maybe<StopDriverMapAddressForDownloadEntity>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  billingPartyContactName?: Maybe<Scalars['String']['output']>;
  chargeBreakdown: SettlementStopChargeBreakdownOutput;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  driverSettlementTotalAmounts: DriverSettlementTotalAmountsOutput;
  isAttempt: Scalars['Boolean']['output'];
  order?: Maybe<OrderEntity>;
  orderName?: Maybe<Scalars['String']['output']>;
  otherDriversOnStop: Array<StopDriverMapOtherDriverForDownloadEntity>;
  packages: Array<PackageEntity>;
  serviceName?: Maybe<Scalars['String']['output']>;
  shipperBillOfLadingNumber?: Maybe<Scalars['String']['output']>;
  stopType?: Maybe<StopType>;
  stopUuid: Scalars['String']['output'];
};

export type StopDriverMapOtherDriverForDownloadEntity = {
  __typename?: 'StopDriverMapOtherDriverForDownloadEntity';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type StopDriverMapPayTermsEntity = {
  __typename?: 'StopDriverMapPayTermsEntity';
  calculationVersion: Scalars['Int']['output'];
  captureReason: SettlementPayCaptureReason;
  driverUuid: Scalars['String']['output'];
  flatPayUsdCents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  maxPayUsdCents?: Maybe<Scalars['Int']['output']>;
  minPayUsdCents?: Maybe<Scalars['Int']['output']>;
  payType: DriverPayType;
  perMileRateUsdMillicents?: Maybe<Scalars['Int']['output']>;
  percentageOutOf100?: Maybe<Scalars['Float']['output']>;
  rateSource: SettlementPayRateSource;
  revision: Scalars['Int']['output'];
  stopUuid: Scalars['String']['output'];
};

export type StopDriverMapUpdateInput = {
  driverPayoutFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  enableDriverSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type StopDriverMapUpsertInput = {
  driverPayoutFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  enableDriverSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revenueFlatRate?: InputMaybe<Scalars['Float']['input']>;
  revenuePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  stopUuid: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type StopEntity = {
  address: AddressEntity;
  appointmentCallStatus?: Maybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed: Scalars['Boolean']['output'];
  appointmentRequired: Scalars['Boolean']['output'];
  appointmentSchedulingOptionsCalledAt?: Maybe<Scalars['DateTime']['output']>;
  appointmentSchedulingOptionsTextedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The STORED appointment status. Only CANCELLED is ever stored; null means the status is derived from the confirmation columns, not that there is none. */
  appointmentStatus?: Maybe<AppointmentStatus>;
  appointmentTextStatus?: Maybe<AppointmentTextStatus>;
  appointmentTime?: Maybe<Scalars['DateTime']['output']>;
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  cachedEta?: Maybe<EtaEntity>;
  canMarkAttemptComplete?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedByAgentAt?: Maybe<Scalars['DateTime']['output']>;
  consigneeAddress?: Maybe<AddressEntity>;
  consigneeContactPerson?: Maybe<ContactPersonEntity>;
  /** True when this stop's current automated call has already been reported as a contact attempt. Reporting it again needs reportAdditionalAttempt. */
  contactAttemptReportedForCurrentCall: Scalars['Boolean']['output'];
  contactPerson?: Maybe<ContactPersonEntity>;
  courierReadyOrDueDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerBookingNotes?: Maybe<Scalars['String']['output']>;
  deadlineTime?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<Scalars['String']['output']>;
  driverCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  endAppointmentTime?: Maybe<Scalars['DateTime']['output']>;
  equipment?: Maybe<EquipmentEntity>;
  eta?: Maybe<EtaEntity>;
  etaArrivalTime?: Maybe<Scalars['DateTime']['output']>;
  etaFinishTime?: Maybe<Scalars['DateTime']['output']>;
  etaLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  expectedInboundArrivalDate?: Maybe<Scalars['DateTime']['output']>;
  expectedOutboundDate?: Maybe<Scalars['DateTime']['output']>;
  failureCount?: Maybe<Scalars['Float']['output']>;
  formattedCallMessage?: Maybe<Scalars['String']['output']>;
  /** returns if a stop has a previous attempt */
  hasPreviousAttempt: Scalars['Boolean']['output'];
  hideFromDispatch?: Maybe<Scalars['Boolean']['output']>;
  inboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  inboundMethod?: Maybe<InboundMethod>;
  incomingCarrier?: Maybe<Scalars['String']['output']>;
  /** returns if a stop is an attempt */
  isAttempt: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  lastAppointmentTextTime?: Maybe<Scalars['DateTime']['output']>;
  leg?: Maybe<LegEntity>;
  linkedEndStop?: Maybe<StopEntity>;
  /** The local time zone of the stop, based on the address. Defaults to company time zone. */
  localTimeZone?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundCarrier?: Maybe<Scalars['String']['output']>;
  outboundDeadlineDate?: Maybe<Scalars['DateTime']['output']>;
  outboundMethod?: Maybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: Maybe<Scalars['Float']['output']>;
  paperworkMarkedComplete?: Maybe<Scalars['Boolean']['output']>;
  pickupOrDelivery: StopPickupOrDelivery;
  postedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  proofOfDeliverySignee?: Maybe<Scalars['String']['output']>;
  routeChangeAcknowledged: Scalars['Boolean']['output'];
  routeName?: Maybe<RouteNameEntity>;
  routeSlot?: Maybe<RouteSlotEntity>;
  sentToAgentAt?: Maybe<Scalars['DateTime']['output']>;
  serviceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The service date of the stop as a PlainDate. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287 for details. */
  serviceDateV2?: Maybe<PlainDate>;
  settlementDeductionFlatRate?: Maybe<Scalars['Float']['output']>;
  settlementDeductionName?: Maybe<Scalars['String']['output']>;
  settlementDeductionPercentageRate?: Maybe<Scalars['Float']['output']>;
  shipment?: Maybe<ShipmentEntity>;
  /** shipment consignee address- the address for the endStop of the last leg in the shipment that this stop's leg belongs to */
  shipmentConsigneeAddress: AddressEntity;
  /** Total volume of all packages associated with this stop's shipment */
  shipmentTotalVolume: Scalars['Float']['output'];
  /** Total weight of all packages associated with this stop's shipment */
  shipmentTotalWeight: Scalars['Float']['output'];
  shipperAddress?: Maybe<AddressEntity>;
  shipperContactPerson?: Maybe<ContactPersonEntity>;
  showDriverModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  snapshottedAmountUsdCents?: Maybe<Scalars['Int']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  standardStopType?: Maybe<StandardStopType>;
  startOrEnd: StartOrEnd;
  status: StopStatus;
  stopDetails?: Maybe<StopDetailsOutput>;
  stopDriverMaps: Array<StopDriverMapEntity>;
  stopIntention?: Maybe<StopIntention>;
  stopType?: Maybe<StopType>;
  terminal?: Maybe<TerminalEntity>;
  textResponses?: Maybe<Scalars['String']['output']>;
  transferAddress?: Maybe<AddressEntity>;
  twilioCallSid?: Maybe<Scalars['String']['output']>;
  twilioTextSid?: Maybe<Scalars['String']['output']>;
  /** Convenience field, not strongly typed. Recommended for display only, use the other fields if you need to do something programmatically with it */
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum StopImportType {
  Both = 'BOTH',
  DynamicInboundOrOutbound = 'DYNAMIC_INBOUND_OR_OUTBOUND',
  InboundOnly = 'INBOUND_ONLY',
  OutboundOnly = 'OUTBOUND_ONLY'
}

export enum StopIntention {
  None = 'NONE',
  Pending = 'PENDING'
}

export type StopOutput = {
  __typename?: 'StopOutput';
  stopValues: Array<Maybe<GroupByStopEntity>>;
};

export enum StopPdfColumnMapping {
  Address = 'ADDRESS',
  CompletedAtDate = 'COMPLETED_AT_DATE'
}

export enum StopPickupOrDelivery {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type StopPreviewForRouteGenerationEntity = {
  __typename?: 'StopPreviewForRouteGenerationEntity';
  eta: Scalars['DateTime']['output'];
  odometer: Scalars['Float']['output'];
  stop: StopEntity;
};

export type StopSort = {
  sortBy: DispatchTableField;
  sortDirection: StopSortDirection;
};

export enum StopSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum StopStatus {
  Arrived = 'ARRIVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NotArrived = 'NOT_ARRIVED'
}

/** Groups the dispatch stops grid by one or more columns. `fields` is the ordered list of grouping levels; `keys` holds the group value for each level the client has already expanded, outermost first. When `keys` is shorter than `fields` the query answers with the group rows of the next level; when the two are the same length it answers with the stops under that path. A null key selects the stops whose value is blank. */
export type StopTableGroupByInput = {
  /** Order of the group rows by their value; ascending when omitted. A blank value sorts as the largest, so it comes last ascending and first descending. */
  direction?: InputMaybe<SortDirection>;
  /** Grouping levels, outermost first. */
  fields: Array<DispatchTableField>;
  /** Group value for each expanded level, outermost first. Never longer than `fields`. */
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  /** Most group rows to return. Ignored for a fully expanded path, where `first` bounds the stops page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Rows to skip within the requested level, for group rows and for the stops under a fully expanded path alike. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** One group of the dispatch stops grid at the level the request asked for: the value shared by its stops, the text to show for it, and how many stops it holds. */
export type StopTableGroupRowEntity = {
  __typename?: 'StopTableGroupRowEntity';
  /** Number of stops in the group under the active filters. */
  count: Scalars['Int']['output'];
  /** The group value as the client must send it back in `groupBy.keys` to expand this group. Null for the stops whose value is blank. */
  key?: Maybe<Scalars['String']['output']>;
  /** Display text for the group. Null when the value is blank, so the client can render its own placeholder. */
  label?: Maybe<Scalars['String']['output']>;
};

export enum StopType {
  Delivery = 'DELIVERY',
  None = 'NONE',
  PartnerCarrierDropoff = 'PARTNER_CARRIER_DROPOFF',
  PartnerCarrierPickup = 'PARTNER_CARRIER_PICKUP',
  Pickup = 'PICKUP',
  Recovery = 'RECOVERY',
  Standalone = 'STANDALONE',
  Transfer = 'TRANSFER'
}

/** A filter object that is used to filter the stop type enum field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type StopTypeFilter = {
  /** Filters for records where the relevant stop type field is equal to the provided stop type value */
  eq?: InputMaybe<StopType>;
  /** Filters for records where the relevant stop type field is in the provided stop type values */
  in?: InputMaybe<Array<StopType>>;
  /** Filters for records where the relevant stop type field is not equal to the provided stop type value */
  neq?: InputMaybe<StopType>;
  /** Filters for records where the relevant stop type field is not in the provided stop type values */
  nin?: InputMaybe<Array<StopType>>;
};

export type StopTypesFilter = {
  fieldLevelFilterOperator: FilterOperator;
  filterOperator?: InputMaybe<FilterOperator>;
  stopTypes: Array<PickupOrDelivery>;
};

export type StopTypesV2Filter = {
  filterOperator?: InputMaybe<FilterOperator>;
  stopType?: InputMaybe<StopType>;
};

export type StopUpdateInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  courierReadyOrDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  customerBookingNotes?: InputMaybe<Scalars['String']['input']>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  etaArrivalTime?: InputMaybe<Scalars['DateTime']['input']>;
  etaFinishTime?: InputMaybe<Scalars['DateTime']['input']>;
  etaLastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  failureCount?: InputMaybe<Scalars['Float']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  lastAppointmentTextTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderAdditionalStopForUuid?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  postedAmountUsdCents?: InputMaybe<Scalars['Int']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  snapshottedAmountUsdCents?: InputMaybe<Scalars['Int']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopIntention?: InputMaybe<StopIntention>;
  stopType?: InputMaybe<StopType>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type StopUpsertInput = {
  addressUpsertInput: AddressUpsertInput;
  appointmentCallStatus?: InputMaybe<AppointmentCallStatus>;
  appointmentManuallyConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentSchedulingOptionsCalledAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentSchedulingOptionsTextedAt?: InputMaybe<Scalars['DateTime']['input']>;
  appointmentTextStatus?: InputMaybe<AppointmentTextStatus>;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedByAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
  contactPersonUpsertInputs?: InputMaybe<Array<ContactPersonUpsertInput>>;
  courierReadyOrDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationAirport?: InputMaybe<Scalars['String']['input']>;
  driverCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  equipmentUuid?: InputMaybe<Scalars['String']['input']>;
  expectedInboundArrivalDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutboundDate?: InputMaybe<Scalars['DateTime']['input']>;
  hideFromDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  inboundMethod?: InputMaybe<InboundMethod>;
  incomingCarrier?: InputMaybe<Scalars['String']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  lastAppointmentTextTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundCarrier?: InputMaybe<Scalars['String']['input']>;
  outboundDeadlineDate?: InputMaybe<Scalars['DateTime']['input']>;
  outboundMethod?: InputMaybe<OutboundMethod>;
  overrideServiceTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  paperworkMarkedComplete?: InputMaybe<Scalars['Boolean']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  removedDriver?: InputMaybe<Scalars['Boolean']['input']>;
  routeSlotUuid?: InputMaybe<Scalars['String']['input']>;
  sentToAgentAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The service date in ISO 8601 date format. If null or unspecified, the stop's service date will not be updated. See https://www.notion.so/Service-Date-dc8ae149b6a54bb69404aecf92176287?pvs=4. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionFlatRate?: InputMaybe<Scalars['Float']['input']>;
  settlementDeductionName?: InputMaybe<Scalars['String']['input']>;
  settlementDeductionPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  standardStopType?: InputMaybe<StandardStopType>;
  status?: InputMaybe<StopStatus>;
  stopIntention?: InputMaybe<StopIntention>;
  stopType?: InputMaybe<StopType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  textResponses?: InputMaybe<Scalars['String']['input']>;
  transferAddressUpsertInput?: InputMaybe<AddressUpsertInput>;
  twilioCallSid?: InputMaybe<Scalars['String']['input']>;
  twilioTextSid?: InputMaybe<Scalars['String']['input']>;
  upsertStopDriverMapInputs?: InputMaybe<Array<UpsertStopDriverMapInput>>;
  uuid: Scalars['String']['input'];
};

/** The stops of one group of the dispatch stops grid, for assigning the whole group to a route. */
export type StopUuidsInGroupOutput = {
  __typename?: 'StopUuidsInGroupOutput';
  /** True when the group holds more stops than one request may assign; `uuids` is then empty. */
  exceedsCap: Scalars['Boolean']['output'];
  /** The uuids of the stops in the group, up to the limit. Empty when the group exceeds it. */
  uuids: Array<Scalars['String']['output']>;
};

export type StopsListElement = CachedStopEntity | RecurringRunHeaderEntity;

export type StorageDaysAccessorialCreateInput = {
  /** Pallet-count-based ranges. lessThanOrEqualToValue = pallet count, rate = per-day charge. */
  accessorialRangeCreateInputs: Array<AccessorialRangeCreateInput>;
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  storageDaysExcludeWeekends: Scalars['Boolean']['input'];
  storageDaysFreeDays: Scalars['Int']['input'];
};

export type StorageDaysAccessorialEntity = AccessorialInterface & {
  __typename?: 'StorageDaysAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  accessorialRanges?: Maybe<Array<AccessorialRangeEntity>>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  storageDaysExcludeWeekends?: Maybe<Scalars['Boolean']['output']>;
  storageDaysFreeDays?: Maybe<Scalars['Int']['output']>;
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type StorageDaysAccessorialUpdateInput = {
  accessorialRangeUpdateInputs?: InputMaybe<Array<AccessorialRangeUpdateInput>>;
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  storageDaysExcludeWeekends?: InputMaybe<Scalars['Boolean']['input']>;
  storageDaysFreeDays?: InputMaybe<Scalars['Int']['input']>;
  uuid: Scalars['String']['input'];
};

export type StorageOrderConnection = {
  __typename?: 'StorageOrderConnection';
  edges: Array<StorageOrderEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StorageOrderEdge = {
  __typename?: 'StorageOrderEdge';
  cursor: Scalars['String']['output'];
  node: StorageOrderEntity;
};

export type StorageOrderEntity = {
  __typename?: 'StorageOrderEntity';
  arrivedAt?: Maybe<Scalars['DateTime']['output']>;
  billOfLadingNumber?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  company: CompanyEntity;
  consigneeName?: Maybe<Scalars['String']['output']>;
  contact: ContactEntity;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<DocumentEntity>;
  expectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Deprecated. Use items.item instead */
  inventoryItems: Array<InventoryItemEntity>;
  isOSD: Scalars['Boolean']['output'];
  items: Array<ItemForStorageOrder>;
  lotNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pickupDate?: Maybe<Scalars['DateTime']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  referenceNumber: Scalars['String']['output'];
  sealNumber?: Maybe<Scalars['String']['output']>;
  storageUnits: Array<StorageUnitEntity>;
  supplierCompanyName?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trailerNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
};


export type StorageOrderEntityStorageUnitsArgs = {
  storageUnitsInput?: InputMaybe<StorageUnitsInput>;
};

export type StorageUnitConnection = {
  __typename?: 'StorageUnitConnection';
  edges: Array<StorageUnitEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StorageUnitEdge = {
  __typename?: 'StorageUnitEdge';
  cursor: Scalars['String']['output'];
  node: StorageUnitEntity;
};

export type StorageUnitEntity = {
  __typename?: 'StorageUnitEntity';
  billed?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The number of billable days in the current billing cycle. Assumes that customer is billed everytime inventory is verified */
  currentBillableDays: Scalars['Int']['output'];
  height?: Maybe<Scalars['Length']['output']>;
  /** @deprecated Use items.item instead */
  inventoryItems: Array<InventoryItemEntity>;
  inventoryLastVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Represents the description of the SKU that a storage unit is comprised of. Note that this should only be used for single-SKU storage units */
  itemDescription?: Maybe<Scalars['String']['output']>;
  /** Note that this should only be used for single-SKU storage units */
  itemUOM?: Maybe<UnitOfMeasure>;
  items: Array<ItemForStorageUnit>;
  length?: Maybe<Scalars['Length']['output']>;
  markedOnHandAt?: Maybe<Scalars['DateTime']['output']>;
  markedOsdAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** The number of days the storage unit spent in the warehouse */
  numberOfDaysInStorage: Scalars['Int']['output'];
  /**
   * The number of inventory items currently in the storage unit. An inventory item is in the storage unit if it is on hand and has not been picked yet
   * @deprecated Use items quantities instead
   */
  numberOfInventoryItems: Scalars['Int']['output'];
  osdReason?: Maybe<Scalars['String']['output']>;
  outboundReferenceNumber?: Maybe<Scalars['String']['output']>;
  pickedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Represents the SKU that a storage unit is comprised of. Note that this should only be used for single-SKU storage units */
  sku?: Maybe<Scalars['String']['output']>;
  storageOrder?: Maybe<StorageOrderEntity>;
  /**
   * The number of inventory items associated with the storage unit
   * @deprecated Use items quantities instead
   */
  totalNumberOfInventoryItems: Scalars['Int']['output'];
  unitOfMeasure: UnitOfMeasure;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
  weight?: Maybe<Scalars['Mass']['output']>;
  width?: Maybe<Scalars['Length']['output']>;
};

export type StorageUnitsInput = {
  pickedFilter?: InputMaybe<StorageUnitsPickedFilterType>;
};

export enum StorageUnitsPickedFilterType {
  All = 'ALL',
  Available = 'AVAILABLE',
  Picked = 'PICKED'
}

/** Represents the difference between 2 versions of a string list. Used in audit log entries */
export type StringArrayFieldDifference = {
  __typename?: 'StringArrayFieldDifference';
  newValue?: Maybe<Array<Scalars['String']['output']>>;
  oldValue?: Maybe<Array<Scalars['String']['output']>>;
};

/** Represents the difference between 2 versions of a string field. Used in audit log entries */
export type StringFieldDifference = {
  __typename?: 'StringFieldDifference';
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export type StringFilter = {
  filterOperator?: InputMaybe<FilterOperator>;
  filterType: StringFilterType;
  value: Scalars['String']['input'];
};

export type StringFilterNullable = {
  filterOperator?: InputMaybe<FilterOperator>;
  filterType: StringFilterType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum StringFilterType {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  NotContains = 'NOT_CONTAINS',
  StartsWith = 'STARTS_WITH'
}

/** A filter object that is used to filter a string field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type StringFilterV2 = {
  /** Filters for records where the relevant string field contains the provided string value */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field contains (case insensitive) the provided string value */
  containsIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field ends with the provided string value */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field ends with (case insensitive) the provided string value */
  endsWithIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is equal to the provided string value */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is equal to (case insensitive) the provided string value */
  eqIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is in the provided array of string values */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant string field is blank */
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant string field is not blank */
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant string field is not equal to the provided string value */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is not equal to (case insensitive) the provided string value */
  neqIgnoreCase?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field is not in the provided array of string values */
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant string field starts with the provided string value */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant string field starts with (case insensitive) the provided string value */
  startsWithIgnoreCase?: InputMaybe<Scalars['String']['input']>;
};

export type StringsFilter = {
  /** Operator to apply across the array of values. Only supports equality. */
  fieldLevelFilterOperator: FilterOperator;
  values: Array<Scalars['String']['input']>;
};

export type StructuredExtractionRunEntity = {
  __typename?: 'StructuredExtractionRunEntity';
  createdAt: Scalars['DateTime']['output'];
  hasError?: Maybe<Scalars['Boolean']['output']>;
  rawResult?: Maybe<Scalars['String']['output']>;
  scannedOrderUuid: Scalars['String']['output'];
  schemaName?: Maybe<Scalars['String']['output']>;
  schemaUuid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type StructuredExtractionSchemaOverrideEntity = {
  __typename?: 'StructuredExtractionSchemaOverrideEntity';
  deadlineDateKeys?: Maybe<Array<Scalars['String']['output']>>;
  schemaExclusions?: Maybe<Scalars['String']['output']>;
  schemaOverride?: Maybe<Scalars['String']['output']>;
  specialInstructionsKeys?: Maybe<Array<Scalars['String']['output']>>;
  uuid: Scalars['String']['output'];
};

export type StructuredExtractionSchemaOverrideInput = {
  deadlineDateKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  schemaExclusions?: InputMaybe<Scalars['String']['input']>;
  schemaOverride: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
  specialInstructionsKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SyncInvoiceToQuickbooksFailure = {
  __typename?: 'SyncInvoiceToQuickbooksFailure';
  affectedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  code: SyncInvoiceToQuickbooksFailureCode;
  detail: Scalars['String']['output'];
  element: QboSyncElement;
  fixIn: QboSyncFixLocation;
  invoiceName: Scalars['String']['output'];
  invoiceUuid: Scalars['String']['output'];
  quickbooksCustomerId?: Maybe<Scalars['String']['output']>;
  quickbooksCustomerName?: Maybe<Scalars['String']['output']>;
  quickbooksFaultCode?: Maybe<Scalars['String']['output']>;
  quickbooksItemId?: Maybe<Scalars['String']['output']>;
  quickbooksItemName?: Maybe<Scalars['String']['output']>;
  quickbooksRequestId?: Maybe<Scalars['String']['output']>;
  quickbooksSaid?: Maybe<Scalars['String']['output']>;
  quickbooksUrl?: Maybe<Scalars['String']['output']>;
  remediation: Scalars['String']['output'];
  retryable: Scalars['Boolean']['output'];
  tenetRecordName?: Maybe<Scalars['String']['output']>;
  tenetUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum SyncInvoiceToQuickbooksFailureCode {
  AccessForbidden = 'ACCESS_FORBIDDEN',
  AuthenticationFailed = 'AUTHENTICATION_FAILED',
  ClassOrLocationRequired = 'CLASS_OR_LOCATION_REQUIRED',
  ClosedPeriod = 'CLOSED_PERIOD',
  ConfigurationMissing = 'CONFIGURATION_MISSING',
  CurrencyMismatch = 'CURRENCY_MISMATCH',
  CustomerAmbiguous = 'CUSTOMER_AMBIGUOUS',
  CustomerInactiveOrDeleted = 'CUSTOMER_INACTIVE_OR_DELETED',
  CustomerNameDuplicate = 'CUSTOMER_NAME_DUPLICATE',
  CustomerNotResolved = 'CUSTOMER_NOT_RESOLVED',
  DuplicateDocumentNumber = 'DUPLICATE_DOCUMENT_NUMBER',
  DuplicateName = 'DUPLICATE_NAME',
  FieldTooLong = 'FIELD_TOO_LONG',
  IncomeAccountMissing = 'INCOME_ACCOUNT_MISSING',
  InvalidCharacter = 'INVALID_CHARACTER',
  InvalidProperty = 'INVALID_PROPERTY',
  InvalidReference = 'INVALID_REFERENCE',
  InvoiceChangedDuringSync = 'INVOICE_CHANGED_DURING_SYNC',
  ItemAmbiguous = 'ITEM_AMBIGUOUS',
  ItemInactive = 'ITEM_INACTIVE',
  ItemIsCategory = 'ITEM_IS_CATEGORY',
  ItemIsInventory = 'ITEM_IS_INVENTORY',
  ItemNameDuplicate = 'ITEM_NAME_DUPLICATE',
  ItemNotFound = 'ITEM_NOT_FOUND',
  NegativeTotal = 'NEGATIVE_TOTAL',
  NotConnected = 'NOT_CONNECTED',
  NoBillableLines = 'NO_BILLABLE_LINES',
  PaymentApplied = 'PAYMENT_APPLIED',
  QboInvoiceConflict = 'QBO_INVOICE_CONFLICT',
  QboInvoiceDeleted = 'QBO_INVOICE_DELETED',
  QuickbooksUnavailable = 'QUICKBOOKS_UNAVAILABLE',
  RateLimited = 'RATE_LIMITED',
  RealmMismatch = 'REALM_MISMATCH',
  SyncInProgress = 'SYNC_IN_PROGRESS',
  TaxCodeRequired = 'TAX_CODE_REQUIRED',
  TermsNotFound = 'TERMS_NOT_FOUND',
  Unknown = 'UNKNOWN'
}

export type SyncInvoiceToQuickbooksNotice = {
  __typename?: 'SyncInvoiceToQuickbooksNotice';
  detail: Scalars['String']['output'];
  element: QboSyncElement;
  kind: QboSyncNoticeKind;
  quickbooksRecordId?: Maybe<Scalars['String']['output']>;
  quickbooksRecordName?: Maybe<Scalars['String']['output']>;
  quickbooksUrl?: Maybe<Scalars['String']['output']>;
  tenetRecordName?: Maybe<Scalars['String']['output']>;
  tenetUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SyncInvoicesToQuickbooksOutput = {
  __typename?: 'SyncInvoicesToQuickbooksOutput';
  failed: Array<SyncInvoiceToQuickbooksFailure>;
  synced: Array<InvoiceEntity>;
  syncedWithNotices: Array<SyncedInvoiceWithNotices>;
};

export type SyncedInvoiceWithNotices = {
  __typename?: 'SyncedInvoiceWithNotices';
  invoice: InvoiceEntity;
  notices: Array<SyncInvoiceToQuickbooksNotice>;
};

export type TableColumnWidthEntity = {
  __typename?: 'TableColumnWidthEntity';
  colId: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type TableFieldsEntity = {
  __typename?: 'TableFieldsEntity';
  billingReviewOrderTableFields: Array<OrderTableField>;
  dispatchTableColumnWidths?: Maybe<Array<TableColumnWidthEntity>>;
  dispatchTableFields: Array<DispatchTableField>;
  invoicesTableColumnWidths?: Maybe<Array<TableColumnWidthEntity>>;
  lineHaulOrderTableFields: Array<OrderTableField>;
  linehaulDispatchTableFields: Array<LinehaulDispatchTableField>;
  orderTableFields: Array<OrderTableField>;
  ordersTableColumnWidths?: Maybe<Array<TableColumnWidthEntity>>;
  routeCardStopTableColumnWidths?: Maybe<Array<TableColumnWidthEntity>>;
  routeCardStopTableFields: Array<DispatchTableField>;
};

export type TagCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type TagEntity = {
  __typename?: 'TagEntity';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  legs: Array<LegEntity>;
  orders: Array<OrderEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TagUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TariffChainEntity = {
  __typename?: 'TariffChainEntity';
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tariffGroupType: TariffGroupType;
  /** This is an ORDERED list of tariff groups on this tariff chain. */
  tariffGroups: Array<TariffGroupEntity>;
};

/** Where rating found a tariff chain: the contact's own default, or the company default it falls back to. */
export enum TariffChainSource {
  Company = 'COMPANY',
  Contact = 'CONTACT'
}

export type TariffCreateInput = {
  /** UUID of billing party contact for custom tariffs */
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  /** False creates the lane disabled: it keeps its rates and rating skips it. Point-to-point tariff groups only (TMS-2756). Defaults to true. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, reaching the maximum suppresses the fuel charge: the maximum already includes fuel (TMS-1631). Defaults to false. */
  maximumIncludesFuel?: InputMaybe<Scalars['Boolean']['input']>;
  maximumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  minimumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  rateType: RateType;
  serviceLevel?: InputMaybe<ServiceLevel>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  tariffOverageRateCreateInputs?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  /** tariff ranges to be created for this tariff */
  tariffRangeCreateInputs: Array<TariffRangeCreateInput>;
  tariffType: TariffType;
  tariffZoneUuid: Scalars['String']['input'];
  useActualWeightInCalculation: Scalars['Boolean']['input'];
  visibilityLevel?: InputMaybe<TariffVisibilityLevel>;
};

export type TariffEntity = {
  __typename?: 'TariffEntity';
  billingPartyContactUuid?: Maybe<Scalars['String']['output']>;
  /** False when the lane is disabled: it keeps its rates and rating never selects it. With tariff chains on, the order falls through to the next group in the chain; without them it behaves like a blank lane. Only point-to-point tariff groups disable lanes. */
  isActive: Scalars['Boolean']['output'];
  /** When true, the maximum is all-inclusive: reaching it suppresses the fuel charge, because the maximum already accounts for fuel. Inert when no maximum is set. */
  maximumIncludesFuel: Scalars['Boolean']['output'];
  /** Maximum amount assessed, in USD cents */
  maximumUsdCents?: Maybe<Scalars['Int']['output']>;
  /** Minimum amount assessed, in USD cents */
  minimumUsdCents?: Maybe<Scalars['Int']['output']>;
  rateType: RateType;
  service?: Maybe<ServiceEntity>;
  settlementPercentageRate?: Maybe<Scalars['Percent']['output']>;
  tariffGroup?: Maybe<TariffGroupEntity>;
  tariffOverageRates: Array<TariffOverageRateEntity>;
  tariffRanges: Array<TariffRangeEntity>;
  /** Tariff Type */
  tariffType: TariffType;
  tariffZone: TariffZoneEntity;
  useActualWeight?: Maybe<Scalars['Boolean']['output']>;
  useActualWeightInCalculation: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type TariffGroupConnection = {
  __typename?: 'TariffGroupConnection';
  edges: Array<TariffGroupEdge>;
  pageInfo: PageInfo;
  /** Not cheap to calculate, request with prudence */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TariffGroupCustomerPreviewEntity = {
  __typename?: 'TariffGroupCustomerPreviewEntity';
  displayName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** Customers who rate through a tariff group by way of a tariff chain. */
export type TariffGroupCustomerUsageEntity = {
  __typename?: 'TariffGroupCustomerUsageEntity';
  /** Null when none of the company default chains contains the group. Otherwise the customers with no chain of their own for the type that default chain covers. */
  companyDefaultCustomerCount?: Maybe<Scalars['Int']['output']>;
  /** Up to two customers whose own chain contains the group, ordered by display name. */
  previewCustomers: Array<TariffGroupCustomerPreviewEntity>;
  /** Customers whose own chain of any type contains the group, archived chains included. */
  totalDirectCustomers: Scalars['Int']['output'];
};

export type TariffGroupEdge = {
  __typename?: 'TariffGroupEdge';
  cursor: Scalars['String']['output'];
  node: TariffGroupEntity;
};

export type TariffGroupEntity = {
  __typename?: 'TariffGroupEntity';
  contactToServicesMappings: Array<ContactToServicesTariffGroupMappingEntity>;
  customerUsage: TariffGroupCustomerUsageEntity;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  firstTariff?: Maybe<TariffEntity>;
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentTariffGroup?: Maybe<TariffGroupEntity>;
  rateMultiplier?: Maybe<Scalars['Float']['output']>;
  services: Array<ServiceEntity>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Tariff chains that contain this group, archived chains included. The group cannot be deleted while this is non-empty. */
  tariffChains: Array<TariffChainEntity>;
  tariffGroupScope?: Maybe<TariffGroupScope>;
  tariffGroupType: TariffGroupType;
  tariffZoneGroup?: Maybe<TariffZoneGroupEntity>;
  tariffs: Array<TariffEntity>;
  terminals: Array<TerminalEntity>;
  totalContactsToServicesMappings: Scalars['Int']['output'];
  useActualWeightInCalculation: Scalars['Boolean']['output'];
  useDeficitBilling?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['String']['output'];
  vehicleTypes: Array<VehicleTypeEntity>;
};


export type TariffGroupEntityContactToServicesMappingsArgs = {
  first?: InputMaybe<Scalars['Float']['input']>;
};

export enum TariffGroupScope {
  Combination = 'COMBINATION',
  Contact = 'CONTACT',
  Default = 'DEFAULT'
}

export enum TariffGroupType {
  LineHaul = 'LINE_HAUL',
  Ordinary = 'ORDINARY',
  PointToPoint = 'POINT_TO_POINT',
  Recovery = 'RECOVERY',
  Transfer = 'TRANSFER'
}

export type TariffLocationCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type TariffLocationEntity = {
  __typename?: 'TariffLocationEntity';
  city?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type TariffOverageRateCreateInput = {
  applicableAboveAmount: Scalars['Float']['input'];
  /** When true, applies the overage rate to the full amount rather than just the overage. Defaults to false for backwards compatibility. */
  applyRateToFullAmount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flat rate in USD cents. Made nullable outside the entity to be backwards compatible with the old frontends. */
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  rateUsdCents: Scalars['Float']['input'];
  type: TariffOverageRateType;
};

export type TariffOverageRateEntity = {
  __typename?: 'TariffOverageRateEntity';
  applicableAboveAmount: Scalars['Float']['output'];
  applyRateToFullAmount: Scalars['Boolean']['output'];
  flatRateUsdCents: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  rateUsdCents: Scalars['Float']['output'];
  type: TariffOverageRateType;
  uuid: Scalars['String']['output'];
};

export enum TariffOverageRateType {
  Miles = 'MILES',
  Pieces = 'PIECES',
  Weight = 'WEIGHT'
}

export type TariffRangeCreateInput = {
  lessThanOrEqualToValue: Scalars['Int']['input'];
  rateUsdCents: Scalars['Float']['input'];
};

export type TariffRangeEntity = {
  __typename?: 'TariffRangeEntity';
  lessThanOrEqualToValue: Scalars['Int']['output'];
  rateUsdCents: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type TariffRangeUpdateInput = {
  lessThanOrEqualToValue: Scalars['Int']['input'];
  rateUsdCents: Scalars['Float']['input'];
  uuid: Scalars['String']['input'];
};

export type TariffRangeUpdatesInput = {
  tariffRangeUpdateInputs: Array<TariffRangeUpdateInput>;
  tariffUuid: Scalars['String']['input'];
};

export enum TariffResolutionReason {
  Code_32Fallback = 'CODE_32_FALLBACK',
  GreatestOnOrBefore = 'GREATEST_ON_OR_BEFORE',
  Pinned = 'PINNED'
}

export enum TariffType {
  NoUnits = 'NO_UNITS',
  PerCubicFoot = 'PER_CUBIC_FOOT',
  PerHundredPounds = 'PER_HUNDRED_POUNDS',
  PerMile = 'PER_MILE',
  PerPiece = 'PER_PIECE'
}

export type TariffUpsertInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  /** False disables the lane: it keeps its rates and rating skips it. Point-to-point tariff groups only (TMS-2756). Omitted on update means keep the current value; a new tariff defaults to true. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, reaching the maximum suppresses the fuel charge: the maximum already includes fuel (TMS-1631). Omitted on update means keep the current value. */
  maximumIncludesFuel?: InputMaybe<Scalars['Boolean']['input']>;
  maximumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  minimumUsdCents?: InputMaybe<Scalars['Int']['input']>;
  rateType?: InputMaybe<RateType>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  tariffOverageRateCreateInputs?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  tariffRangeUpdateInputs?: InputMaybe<Array<TariffRangeUpdateInput>>;
  tariffType: TariffType;
  tariffZoneUuid: Scalars['String']['input'];
  useActualWeightInCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export enum TariffVisibilityLevel {
  Customer = 'CUSTOMER',
  Global = 'GLOBAL'
}

export type TariffZoneCreateInput = {
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  inboundZoneUuid?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<TariffLocationCreateInput>>;
  mileRangeEnd?: InputMaybe<Scalars['Float']['input']>;
  mileRangeStart?: InputMaybe<Scalars['Float']['input']>;
  /** Name of tariff */
  name: Scalars['String']['input'];
  outboundZoneUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneLocationType?: InputMaybe<TariffZoneLocationType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type: TariffZoneType;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TariffZoneEntity = {
  __typename?: 'TariffZoneEntity';
  billingPartyContactId?: Maybe<Scalars['Int']['output']>;
  billingPartyContactUuid?: Maybe<Scalars['String']['output']>;
  destinationTerminal?: Maybe<TerminalEntity>;
  inboundZone?: Maybe<TariffZoneEntity>;
  lineHaulLane?: Maybe<LineHaulLaneEntity>;
  locations: Array<TariffLocationEntity>;
  mileRangeEnd?: Maybe<Scalars['Float']['output']>;
  mileRangeStart?: Maybe<Scalars['Float']['output']>;
  /** Name of tariff */
  name: Scalars['String']['output'];
  outboundZone?: Maybe<TariffZoneEntity>;
  tariffZoneGroupId?: Maybe<Scalars['String']['output']>;
  tariffZoneLocationType?: Maybe<TariffZoneLocationType>;
  terminal?: Maybe<TerminalEntity>;
  type: TariffZoneType;
  uuid: Scalars['String']['output'];
};

export type TariffZoneGroupArchiveOutput = MutationErrorOutput | TariffZoneGroupArchiveSuccessOutput;

export type TariffZoneGroupArchiveSuccessOutput = {
  __typename?: 'TariffZoneGroupArchiveSuccessOutput';
  /** The archived tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export type TariffZoneGroupCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TariffZoneGroupCreateOutput = MutationErrorOutput | TariffZoneGroupCreateSuccessOutput;

export type TariffZoneGroupCreateSuccessOutput = {
  __typename?: 'TariffZoneGroupCreateSuccessOutput';
  /** The created tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export type TariffZoneGroupEntity = {
  __typename?: 'TariffZoneGroupEntity';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tariffZones: Array<TariffZoneEntity>;
};

export type TariffZoneGroupRestoreOutput = MutationErrorOutput | TariffZoneGroupRestoreSuccessOutput;

export type TariffZoneGroupRestoreSuccessOutput = {
  __typename?: 'TariffZoneGroupRestoreSuccessOutput';
  /** The restored tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export type TariffZoneGroupUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type TariffZoneGroupUpdateOutput = MutationErrorOutput | TariffZoneGroupUpdateSuccessOutput;

export type TariffZoneGroupUpdateSuccessOutput = {
  __typename?: 'TariffZoneGroupUpdateSuccessOutput';
  /** The updated tariff zone group */
  tariffZoneGroup: TariffZoneGroupEntity;
};

export enum TariffZoneLocationType {
  LineHaulLane = 'LINE_HAUL_LANE',
  Terminal = 'TERMINAL',
  Zipcode = 'ZIPCODE'
}

export enum TariffZoneType {
  Location = 'LOCATION',
  Miles = 'MILES',
  Universal = 'UNIVERSAL',
  Zipcode = 'ZIPCODE',
  ZonePair = 'ZONE_PAIR'
}

export type TariffZoneUpdateInput = {
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  inboundZoneUuid?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<TariffLocationCreateInput>>;
  mileRangeEnd?: InputMaybe<Scalars['Float']['input']>;
  mileRangeStart?: InputMaybe<Scalars['Float']['input']>;
  /** Name of tariff */
  name?: InputMaybe<Scalars['String']['input']>;
  outboundZoneUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneLocationType?: InputMaybe<TariffZoneLocationType>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TariffZoneType>;
  uuid: Scalars['String']['input'];
};

export type TariffsDeleteInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type TenediCarrierIdentityEntity = {
  __typename?: 'TenediCarrierIdentityEntity';
  alternateIsaId?: Maybe<Scalars['String']['output']>;
  alternateStandardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  fourthAlternateIsaId?: Maybe<Scalars['String']['output']>;
  fourthAlternateScac?: Maybe<Scalars['String']['output']>;
  isaId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The carrier's SCACs that are set, primary first. A partnership must use one. */
  scacs: Array<Scalars['String']['output']>;
  secondAlternateIsaId?: Maybe<Scalars['String']['output']>;
  secondAlternateScac?: Maybe<Scalars['String']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  thirdAlternateIsaId?: Maybe<Scalars['String']['output']>;
  thirdAlternateScac?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type TenediCarrierIdentitySaveResultEntity = {
  __typename?: 'TenediCarrierIdentitySaveResultEntity';
  carrier: TenediCarrierIdentityEntity;
  changes: Array<TenediFieldChangeEntity>;
};

/** One of the carrier's customers, for the picker. */
export type TenediConnectionCustomerOptionEntity = {
  __typename?: 'TenediConnectionCustomerOptionEntity';
  displayName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  /** Partnerships between this customer and the carrier. */
  partnershipCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

/** Searches one carrier's customers for the Tenedi connections page, by name or customer EDI ID. */
export type TenediConnectionCustomersInput = {
  companyUuid: Scalars['String']['input'];
  /** 1 to 25. Defaults to 25. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type TenediConnectionEntity = {
  __typename?: 'TenediConnectionEntity';
  carrier: TenediCarrierIdentityEntity;
  customer: TenediCustomerIdentityEntity;
  /** The backend's APP_ENV. */
  environment: Scalars['String']['output'];
  partnerships: Array<TenediPartnershipEntity>;
  production: Scalars['Boolean']['output'];
  readiness: Array<TenediReadinessItemEntity>;
  /** True when no readiness item blocks. */
  ready: Scalars['Boolean']['output'];
};

export type TenediConnectionInput = {
  companyUuid: Scalars['String']['input'];
  organizationUuid: Scalars['String']['input'];
};

export type TenediCustomerIdentityEntity = {
  __typename?: 'TenediCustomerIdentityEntity';
  defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod;
  displayName: Scalars['String']['output'];
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type TenediCustomerIdentitySaveResultEntity = {
  __typename?: 'TenediCustomerIdentitySaveResultEntity';
  changes: Array<TenediFieldChangeEntity>;
  customer: TenediCustomerIdentityEntity;
};

/** One field a save changed, read back from the database. Lists join with ", ". */
export type TenediFieldChangeEntity = {
  __typename?: 'TenediFieldChangeEntity';
  after?: Maybe<Scalars['String']['output']>;
  before?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
};

export type TenediPartnershipEntity = {
  __typename?: 'TenediPartnershipEntity';
  allowEditingShipperBillOfLadingNumber: Scalars['Boolean']['output'];
  alternateStediPartnerId?: Maybe<Scalars['String']['output']>;
  autoAcceptOrders: Scalars['Boolean']['output'];
  canCreateMultipleStops: Scalars['Boolean']['output'];
  companyStandardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  edi214ShipmentStatuses: Array<Edi214ShipmentStatus>;
  ediOutboundPayloadDestination: EdiOutboundPayloadDestination;
  enableStaging: Scalars['Boolean']['output'];
  excludeZeroChargeInvoices: Scalars['Boolean']['output'];
  ignoreCancellations: Scalars['Boolean']['output'];
  ignoreNonEdiOutbound: Scalars['Boolean']['output'];
  removeSpacesFrom214Bol: Scalars['Boolean']['output'];
  send990InResponseTo204: Scalars['Boolean']['output'];
  send990InResponseTo211: Scalars['Boolean']['output'];
  sendBackupDocs: Scalars['Boolean']['output'];
  stedi210MappingId?: Maybe<Scalars['String']['output']>;
  stedi210TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stedi214MappingId?: Maybe<Scalars['String']['output']>;
  stedi214TransactionSettingId?: Maybe<Scalars['String']['output']>;
  stedi990MappingId?: Maybe<Scalars['String']['output']>;
  stedi990TransactionSettingId?: Maybe<Scalars['String']['output']>;
  /** Read only on this page. */
  stediPartnershipId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  useStediGenerateEdiFunction: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type TenediPartnershipSaveResultEntity = {
  __typename?: 'TenediPartnershipSaveResultEntity';
  changes: Array<TenediFieldChangeEntity>;
  created: Scalars['Boolean']['output'];
  partnership: TenediPartnershipEntity;
};

export enum TenediReadinessCheck {
  CarrierIsaId = 'CARRIER_ISA_ID',
  CarrierScac = 'CARRIER_SCAC',
  CarrierStediPartnerId = 'CARRIER_STEDI_PARTNER_ID',
  CustomerInvoiceMethod = 'CUSTOMER_INVOICE_METHOD',
  CustomerIsaId = 'CUSTOMER_ISA_ID',
  CustomerStediPartnerId = 'CUSTOMER_STEDI_PARTNER_ID',
  EdiIdsUpperCase = 'EDI_IDS_UPPER_CASE',
  NoBlankScacPartnership = 'NO_BLANK_SCAC_PARTNERSHIP',
  NoXmlPartnership = 'NO_XML_PARTNERSHIP',
  PartnershipsSendToTenedi = 'PARTNERSHIPS_SEND_TO_TENEDI',
  PartnershipExists = 'PARTNERSHIP_EXISTS',
  Replies_990 = 'REPLIES_990',
  Statuses_214Selected = 'STATUSES_214_SELECTED',
  TenediDeliveryConfigured = 'TENEDI_DELIVERY_CONFIGURED',
  TenediSide = 'TENEDI_SIDE',
  UniqueInboundSender = 'UNIQUE_INBOUND_SENDER',
  WorkerSettings = 'WORKER_SETTINGS'
}

export type TenediReadinessItemEntity = {
  __typename?: 'TenediReadinessItemEntity';
  check: TenediReadinessCheck;
  fixIn: TenediReadinessSection;
  message: Scalars['String']['output'];
  status: TenediReadinessStatus;
};

export enum TenediReadinessSection {
  Carrier = 'CARRIER',
  Customer = 'CUSTOMER',
  Environment = 'ENVIRONMENT',
  Partnership = 'PARTNERSHIP',
  Tenedi = 'TENEDI'
}

export enum TenediReadinessStatus {
  Blocking = 'BLOCKING',
  Info = 'INFO',
  Ready = 'READY',
  Warning = 'WARNING'
}

export type TerminalAccessorialChargeDetailsEntity = {
  __typename?: 'TerminalAccessorialChargeDetailsEntity';
  chargeDetailsByContact: Array<ContactAccessorialChargeDetailsEntity>;
  terminalCode?: Maybe<Scalars['String']['output']>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
};

export type TerminalCreateInput = {
  addressUuid: Scalars['String']['input'];
  /** Required if the terminal being created is an agent terminal */
  agentId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Required if and only if the line_haul_networks feature flag is enabled */
  serviceRegionId?: InputMaybe<Scalars['String']['input']>;
};

export type TerminalEfficiencyArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type TerminalEfficiencyReportEntity = {
  __typename?: 'TerminalEfficiencyReportEntity';
  actualHoursAreProxy: Scalars['Boolean']['output'];
  costBasis: CostBasis;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  hasDockAllowances: Scalars['Boolean']['output'];
  hasPdAllowances: Scalars['Boolean']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  overallEfficiencyPct?: Maybe<Scalars['Float']['output']>;
  terminals: Array<TerminalEfficiencyRowEntity>;
  totalActualHours: Scalars['Float']['output'];
  totalAllowedHours: Scalars['Float']['output'];
};

export type TerminalEfficiencyRowEntity = {
  __typename?: 'TerminalEfficiencyRowEntity';
  dockActualHours: Scalars['Float']['output'];
  dockAllowedHours: Scalars['Float']['output'];
  efficiencyPct?: Maybe<Scalars['Float']['output']>;
  pdActualHours: Scalars['Float']['output'];
  pdAllowedHours: Scalars['Float']['output'];
  status?: Maybe<TerminalEfficiencyStatus>;
  terminalCode: Scalars['String']['output'];
  terminalName: Scalars['String']['output'];
  terminalUuid: Scalars['String']['output'];
  totalActualHours: Scalars['Float']['output'];
  totalAllowedHours: Scalars['Float']['output'];
};

/** Combined P&D + dock terminal efficiency standing used by the Intelligence Board. */
export enum TerminalEfficiencyStatus {
  Efficient = 'EFFICIENT',
  Inefficient = 'INEFFICIENT',
  Moderate = 'MODERATE'
}

export type TerminalEntity = {
  __typename?: 'TerminalEntity';
  address: AddressEntity;
  agent?: Maybe<AgentFieldsEntity>;
  code: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serviceAreas: Array<TerminalServiceAreaEntity>;
  serviceRegion?: Maybe<ServiceRegionEntity>;
  serviceRegionId?: Maybe<Scalars['String']['output']>;
  startForTerminalLanes: Array<TerminalLaneEntity>;
  uuid: Scalars['String']['output'];
};

/** An object representing a lane between two terminals, meaning orders can be moved directly from the start to the end terminal. */
export type TerminalLaneEntity = {
  __typename?: 'TerminalLaneEntity';
  endTerminal: TerminalEntity;
  id: Scalars['String']['output'];
  startTerminal: TerminalEntity;
};

export type TerminalPieceCount = {
  __typename?: 'TerminalPieceCount';
  pieceCount: Scalars['Int']['output'];
  terminalCode: Scalars['String']['output'];
};

export type TerminalReportArgs = {
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludeMigratedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  lastNumberOfDays?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfMonths?: InputMaybe<Scalars['Float']['input']>;
  lastNumberOfWeeks?: InputMaybe<Scalars['Float']['input']>;
  orderStatuses: Array<OrderStatus>;
  reportRevenueType?: InputMaybe<ReportRevenueType>;
  reportStatistics: Array<ReportStatistic>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopTypes: Array<PickupOrDelivery>;
};

export type TerminalReportBucketEntity = {
  __typename?: 'TerminalReportBucketEntity';
  code: Scalars['String']['output'];
  customChargeRevenue: Scalars['Float']['output'];
  deliveryRevenue: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  freightRevenue: Scalars['Float']['output'];
  fuelRevenue: Scalars['Float']['output'];
  lineHaulRevenue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  numberOfOrders: Scalars['Float']['output'];
  numberOfPackages: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  recoveryRevenue: Scalars['Float']['output'];
  specialRevenue: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  surchargeRevenue: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalWeight: Scalars['Float']['output'];
  transferRevenue: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type TerminalServiceAreaEntity = {
  __typename?: 'TerminalServiceAreaEntity';
  city?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type TerminalServiceAreaUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type TerminalUpdateInput = {
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** All of the UUIDs of the terminals to which there is a lane starting at the terminal being edited, replacing the existing terminal lanes */
  laneEndTerminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Required if and only if the line_haul_networks feature flag is enabled */
  serviceRegionId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type TerminateDriverInput = {
  driverUuid: Scalars['String']['input'];
  terminationComments?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  terminationDate: Scalars['String']['input'];
};

export type TestApiOrderAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<ApiAddressLocationType>;
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type TestApiOrderContactPersonInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type TestApiOrderDestinationStopInput = {
  address: TestApiOrderAddressInput;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<TestApiOrderContactPersonInput>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  destinationStopType: DestinationStopType;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  startAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestApiOrderOriginStopInput = {
  address: TestApiOrderAddressInput;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<TestApiOrderContactPersonInput>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  hasTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  originStopType: OriginStopType;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  startAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestApiOrderPackageInput = {
  barcodes?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Int']['input'];
  type?: InputMaybe<PackageType>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type TestApiOrderResult = {
  __typename?: 'TestApiOrderResult';
  inboundApiRequestUuid: Scalars['String']['output'];
  merged: Scalars['Boolean']['output'];
  mergedIntoOrderName?: Maybe<Scalars['String']['output']>;
  mergedIntoOrderUuid?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  orderName?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
};

export type TestEdiOrderResult = {
  __typename?: 'TestEdiOrderResult';
  ediTransactionId?: Maybe<Scalars['String']['output']>;
  merged: Scalars['Boolean']['output'];
  mergedIntoOrderName?: Maybe<Scalars['String']['output']>;
  mergedIntoOrderUuid?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  orderName?: Maybe<Scalars['String']['output']>;
  orderUuid?: Maybe<Scalars['String']['output']>;
  schemaWarning?: Maybe<Scalars['String']['output']>;
};

export type TestJsonSchemaOnDocumentsForSchemaInput = {
  deadlineDateKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  schemaExclusions?: InputMaybe<Scalars['String']['input']>;
  schemaOverride?: InputMaybe<Scalars['String']['input']>;
  schemaUuid: Scalars['String']['input'];
};

export type TestJsonSchemaOnDocumentsForSchemaOutput = {
  __typename?: 'TestJsonSchemaOnDocumentsForSchemaOutput';
  differencesMap: Scalars['String']['output'];
  normalizedGptResults: Scalars['String']['output'];
  rawGptResults: Scalars['String']['output'];
};

export type TestOneSnapshotInput = {
  schemaRunUuid: Scalars['String']['input'];
};

export type TestOrderAppointmentInput = {
  appointmentTime: Scalars['DateTime']['input'];
  deliveryDate: Scalars['DateTime']['input'];
  endAppointmentTime: Scalars['DateTime']['input'];
};

export type TestOrderCustomChargeEntity = {
  __typename?: 'TestOrderCustomChargeEntity';
  createdAt: Scalars['DateTime']['output'];
  customCharge: CustomChargeEntity;
  total: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type TestOrderEntity = {
  __typename?: 'TestOrderEntity';
  createdAt: Scalars['DateTime']['output'];
  order: StandardOrderEntity;
  testOrderCustomCharges: Array<TestOrderCustomChargeEntity>;
  totalCharge: Scalars['Float']['output'];
  totalFreightCharge: Scalars['Float']['output'];
  totalFuelCharge: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export enum TestOrderStopType {
  Delivery = 'DELIVERY',
  PartnerCarrierDropoffAndDelivery = 'PARTNER_CARRIER_DROPOFF_AND_DELIVERY',
  PartnerCarrierDropoffLineHaulDelivery = 'PARTNER_CARRIER_DROPOFF_LINE_HAUL_DELIVERY',
  Pickup = 'PICKUP',
  PickupAndDelivery = 'PICKUP_AND_DELIVERY',
  PickupAndTransfer = 'PICKUP_AND_TRANSFER',
  PickupLineHaulDelivery = 'PICKUP_LINE_HAUL_DELIVERY',
  PickupLineHaulTransfer = 'PICKUP_LINE_HAUL_TRANSFER',
  PickupPartnerCarrierLineHaulPickup = 'PICKUP_PARTNER_CARRIER_LINE_HAUL_PICKUP',
  PickupPartnerCarrierPickup = 'PICKUP_PARTNER_CARRIER_PICKUP',
  RecoveryAndDelivery = 'RECOVERY_AND_DELIVERY',
  RecoveryLineHaulDelivery = 'RECOVERY_LINE_HAUL_DELIVERY'
}

export type TestPieceOutput = {
  __typename?: 'TestPieceOutput';
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: PieceStatus;
  uuid: Scalars['String']['output'];
};

export type TestSchemaInput = {
  documentName: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export enum TestSmc3FreightState {
  NeedsRate = 'NEEDS_RATE',
  Rated = 'RATED'
}

export type TestSmc3RateInput = {
  destinationPostalCode: Scalars['String']['input'];
  freightClass: FreightClass;
  originPostalCode: Scalars['String']['input'];
  shipDate?: InputMaybe<Scalars['String']['input']>;
  weightPounds: Scalars['Int']['input'];
};

export type TestSnapshotInput = {
  bucket: Scalars['String']['input'];
  extractedFields: Array<ExtractedFieldInput>;
  fingerprintAnchorMatches: Array<FingerprintAnchorMatchInput>;
  key: Scalars['String']['input'];
  schemaName: Scalars['String']['input'];
  schemaRunPages: Array<SchemaRunPageInput>;
  transformAnchorMatches: Array<TransformAnchorMatchInput>;
};

export type TextDriverInput = {
  dispatchedDate: Scalars['DateTime']['input'];
  driverUuid: Scalars['String']['input'];
  messageContents: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
};

export type TextractSchemaFileInput = {
  filename: Scalars['String']['input'];
  textractType: TextractType;
};

export type TextractSchemaTestFileInput = {
  filename: Scalars['String']['input'];
  schemaUuid: Scalars['String']['input'];
};

export enum TextractType {
  AnalyzeDocument = 'ANALYZE_DOCUMENT',
  DetectDocumentText = 'DETECT_DOCUMENT_TEXT'
}

export type ThirdPartyBrokerCreateInput = {
  name: Scalars['String']['input'];
};

export type ThirdPartyBrokerEntity = {
  __typename?: 'ThirdPartyBrokerEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ThirdPartyBrokerUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ThirdPartyContactEntity = ContactEntity & {
  __typename?: 'ThirdPartyContactEntity';
  accessorialGroupId?: Maybe<Scalars['String']['output']>;
  addresses: Array<AddressEntity>;
  allowDriverToCompleteStopAfterAttemptWithoutReassignment: Scalars['Boolean']['output'];
  apiName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay90: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay180: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay270: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay360: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPay720: Scalars['Float']['output'];
  /** @deprecated Use getAverageDaysToPayReport in ReportsService instead */
  averageDaysToPayAll: Scalars['Float']['output'];
  /** The customer balance for the contact in dollars */
  balance: Scalars['Float']['output'];
  billingContactEmail?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<BillingCycleType>;
  billingCycleDuration: BillingCycleDuration;
  billingPeriod?: Maybe<Scalars['Float']['output']>;
  billingPeriodDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  billingRunStart: Scalars['DateTime']['output'];
  businessDivision?: Maybe<BusinessDivisionEntity>;
  calculateInboundFreightCharges: Scalars['Boolean']['output'];
  calculateLineHaulFreightCharges: Scalars['Boolean']['output'];
  calculateOutboundFreightCharges: Scalars['Boolean']['output'];
  chargeMatrixColumnMappings: Array<ContactChargeMatrixColumnMappingEntity>;
  company: CompanyEntity;
  /** Returns at most 100 most-recent contact comments. Callers needing full enumeration must use a paginated query (TODO: expose contactCommentsConnection). */
  contactComments: Array<ContactCommentEntity>;
  contactOpenInvoiceValue: Scalars['Float']['output'];
  contactOpenInvoiceValue0to30d: Scalars['Float']['output'];
  contactOpenInvoiceValue31to38d: Scalars['Float']['output'];
  contactOpenInvoiceValue39to45d: Scalars['Float']['output'];
  contactOpenInvoiceValue46to60d: Scalars['Float']['output'];
  contactOpenInvoiceValue61to75d: Scalars['Float']['output'];
  contactOpenInvoiceValueOver75d: Scalars['Float']['output'];
  contactPersons: Array<ContactPersonEntity>;
  contactReferenceNumber?: Maybe<Scalars['String']['output']>;
  contactStations: Array<ContactStationEntity>;
  contactStatistics: ContactStatsEntity;
  creditsAppliedToContactInvoices: Scalars['Float']['output'];
  customDunningReportFooter?: Maybe<Scalars['String']['output']>;
  customerAccessorials: Array<AccessorialUnion>;
  customerTariffs: Array<TariffEntity>;
  debitsAppliedToContactInvoices: Scalars['Float']['output'];
  defaultAddress?: Maybe<AddressEntity>;
  defaultContactPerson?: Maybe<ContactPersonEntity>;
  defaultEfmHandlingStation?: Maybe<Scalars['String']['output']>;
  defaultInvoiceTerms?: Maybe<InvoiceTermEntity>;
  defaultService?: Maybe<ServiceEntity>;
  defaultServicePickupsDeliveries: Scalars['Boolean']['output'];
  dimFactor: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  ediApplicationId?: Maybe<Scalars['String']['output']>;
  ediContactCode?: Maybe<Scalars['String']['output']>;
  ediPartnership?: Maybe<EdiPartnershipEntity>;
  ediPartnerships: Array<EdiPartnershipEntity>;
  /** The tariff chain rating uses for each tariff type, in the order Ordinary, Line haul, Transfer, Recovery, Point to point: the contact's own chain, else the company default. A type with neither has no entry, and Recovery has none while the company has recovery tariffs off. */
  effectiveTariffChains: Array<EffectiveTariffChainEntity>;
  /** The contact's addresses on a SendGrid suppression list (bounce, invalid email or spam report). Emails to them are skipped. */
  emailSuppressions: Array<EmailSuppressionEntity>;
  emitPieceLevelWebhooks: Scalars['Boolean']['output'];
  freightChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  fuelChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This field no longer affects invoices and will be removed. */
  invoiceNotes?: Maybe<Scalars['String']['output']>;
  invoicePdfColumns: Array<PdfColumnEntity>;
  invoiceTimePeriodSplit?: Maybe<TimePeriod>;
  invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName;
  isActive: Scalars['Boolean']['output'];
  isEfm?: Maybe<Scalars['Boolean']['output']>;
  isOverCreditLimit: Scalars['Boolean']['output'];
  isPrepaidOnly: Scalars['Boolean']['output'];
  isaId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<DocumentEntity>;
  logoType?: Maybe<DocumentEntity>;
  masterAccount?: Maybe<MasterAccountEntity>;
  miscCustomChargeQuickbooksMappingId?: Maybe<Scalars['String']['output']>;
  numberOfOrdersPerInvoice?: Maybe<Scalars['Float']['output']>;
  /** Dollars of the contact credit memos taken up by debit memo offsets */
  offsetCredits: Scalars['Float']['output'];
  /** Dollars of the contact debit memos used to offset payments or credit memos */
  offsetDebits: Scalars['Float']['output'];
  /** Dollars of the contact payments taken up by debit memo offsets */
  offsetPayments: Scalars['Float']['output'];
  /** Returns at most 100 most-recent orders where this contact is the billing party. Callers needing full enumeration must use the paginated orders query (TODO: expose ordersConnection). */
  orders: Array<OrderEntity>;
  overdueInvoices: Array<InvoiceEntity>;
  paymentsAppliedToContactInvoices: Scalars['Float']['output'];
  /** Total closed balance across all posted invoices */
  postedInvoicesTotalClosedBalance: Scalars['Float']['output'];
  /** Total open balance across all posted invoices */
  postedInvoicesTotalOpenBalance: Scalars['Float']['output'];
  quickbooksDesktopAccountsReceivableId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopContactId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingCustomerName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFreightChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingFuelChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingPickupChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId?: Maybe<Scalars['String']['output']>;
  referenceNumberLabels: Array<ReferenceNumberLabelEntity>;
  requireDriverToCheckOffPackagesAtStop: Scalars['Boolean']['output'];
  requireScanToAdvancePieceStatusAtStops: Scalars['Boolean']['output'];
  serviceGroupId?: Maybe<Scalars['String']['output']>;
  services: Array<ServiceEntity>;
  shortCode?: Maybe<Scalars['String']['output']>;
  showChargesOnCustomerPortal: Scalars['Boolean']['output'];
  showEdiReferenceNumbersOnOrderPage: Scalars['Boolean']['output'];
  skipFuelCharge?: Maybe<Scalars['Boolean']['output']>;
  standardCarrierAlphaCode?: Maybe<Scalars['String']['output']>;
  stediPartnerId?: Maybe<Scalars['String']['output']>;
  tariffZones: Array<TariffZoneEntity>;
  /** @deprecated this field is a placeholder since the column was dropped from the table */
  thirdPartyContactType: ThirdPartyContactType;
  totalCredits: Scalars['Float']['output'];
  totalDebits: Scalars['Float']['output'];
  totalInvoicesAmount: Scalars['Float']['output'];
  totalPayments: Scalars['Float']['output'];
  totalPostedInvoicesAmount: Scalars['Float']['output'];
  /** @deprecated Contact type is deprecated. The column has been dropped from the db */
  type: ContactType;
  unappliedCredits?: Maybe<Scalars['Float']['output']>;
  unappliedDebits: Scalars['Float']['output'];
  unappliedPayments: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};


export type ThirdPartyContactEntityContactOpenInvoiceValueArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue0to30dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue31to38dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue39to45dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue46to60dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValue61to75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};


export type ThirdPartyContactEntityContactOpenInvoiceValueOver75dArgs = {
  findOpenInvoicesArgs?: InputMaybe<FindOpenInvoicesArgs>;
};

export enum ThirdPartyContactType {
  OtherFacility = 'OTHER_FACILITY',
  Receiver = 'RECEIVER',
  Shipper = 'SHIPPER'
}

export type ThirdPartyUserEntity = {
  __typename?: 'ThirdPartyUserEntity';
  contacts: Array<ContactEntity>;
  email: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export enum TimeOfPodUpload {
  DoNotSend = 'DO_NOT_SEND',
  InvoiceSent = 'INVOICE_SENT',
  StopCompletion = 'STOP_COMPLETION'
}

export enum TimePeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type TotalPackageWeightSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type TotalSkidsSortInput = {
  direction: SortOrder;
  nulls: NullsOrder;
};

export type TransferPieceToOrderInput = {
  newOrderUuid: Scalars['String']['input'];
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid: Scalars['String']['input'];
};

export type TransferPieceToOutboundOrderInput = {
  newOutboundOrderUuid: Scalars['String']['input'];
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  pieceUuid: Scalars['String']['input'];
};

export type TransformAnchorEntity = {
  __typename?: 'TransformAnchorEntity';
  blockId?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  text: Scalars['String']['output'];
  top: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  width: Scalars['Float']['output'];
};

export type TransformAnchorInput = {
  blockId?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  text: Scalars['String']['input'];
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type TransformAnchorMatchEntity = {
  __typename?: 'TransformAnchorMatchEntity';
  text: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type TransformAnchorMatchInput = {
  text: Scalars['String']['input'];
};

export type TransitionAppointmentInput = {
  action: AppointmentTransitionAction;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  stopUuid: Scalars['String']['input'];
};

export type TransitionAppointmentOutput = MutationErrorOutput | TransitionAppointmentSuccessOutput;

export type TransitionAppointmentSuccessOutput = {
  __typename?: 'TransitionAppointmentSuccessOutput';
  status: AppointmentStatus;
  stopUuid: Scalars['String']['output'];
};

export type TriggerAdhocPreviewBatchInput = {
  companyUuid: Scalars['String']['input'];
  emailSimulation?: InputMaybe<AdhocEmailSimulationInput>;
  idempotencyKey: Scalars['String']['input'];
  uploadIds: Array<Scalars['ID']['input']>;
};

export type TriggerAdhocPreviewInput = {
  companyUuid: Scalars['String']['input'];
  emailSimulation?: InputMaybe<AdhocEmailSimulationInput>;
  idempotencyKey: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};

export type TriggerIngestionTestRunInput = {
  companyUuid: Scalars['String']['input'];
  confirmFullApply?: InputMaybe<Scalars['Boolean']['input']>;
  emailSimulation?: InputMaybe<AdhocEmailSimulationInput>;
  idempotencyKey: Scalars['String']['input'];
  mode: IngestionTestRunMode;
  uploadId: Scalars['String']['input'];
};

/** Outcome of truck-assignment for a route when the company's settings request auto-assign. */
export enum TruckFitNote {
  Assigned = 'ASSIGNED',
  NoTruckFit = 'NO_TRUCK_FIT',
  PreviewTentative = 'PREVIEW_TENTATIVE'
}

export enum TutorialId {
  AccountingDriverSettlement = 'accountingDriverSettlement',
  AccountingInvoices = 'accountingInvoices',
  AccountingSettlement = 'accountingSettlement',
  AllOrders = 'allOrders',
  AppointmentsBoard = 'appointmentsBoard',
  CompanySetup = 'companySetup',
  Customers = 'customers',
  DailyControlCenter = 'dailyControlCenter',
  DelegatedOrders = 'delegatedOrders',
  DeliveryNotifications = 'deliveryNotifications',
  Directory = 'directory',
  DispatchRoutes = 'dispatchRoutes',
  EmailIngestionConfigure = 'emailIngestionConfigure',
  EmailIngestionReview = 'emailIngestionReview',
  EmailOrders = 'emailOrders',
  EndOfDay = 'endOfDay',
  ExpeditorsApiStatus = 'expeditorsApiStatus',
  ExpeditorsScorecard = 'expeditorsScorecard',
  IbCostCenterStatement = 'ibCostCenterStatement',
  IbCostInputs = 'ibCostInputs',
  IbCustomerProfitability = 'ibCustomerProfitability',
  IbDockProductivity = 'ibDockProductivity',
  IbDriverPlanner = 'ibDriverPlanner',
  IbLineHaulUtilization = 'ibLineHaulUtilization',
  IbOperationalEfficiency = 'ibOperationalEfficiency',
  IbPdProductivity = 'ibPdProductivity',
  IbTerminalEfficiency = 'ibTerminalEfficiency',
  IbWeightBreak = 'ibWeightBreak',
  LineHaulDispatch = 'lineHaulDispatch',
  LinehaulCalmBoard = 'linehaulCalmBoard',
  LinehaulSchedule = 'linehaulSchedule',
  LoadPlanning3d = 'loadPlanning3d',
  OrderRequests = 'orderRequests',
  OwnersBreakfastDashboard = 'ownersBreakfastDashboard',
  PieceReceipts = 'pieceReceipts',
  Quotes = 'quotes',
  Reports = 'reports',
  ReservationSystem = 'reservationSystem',
  ScannedOrders = 'scannedOrders',
  Settings = 'settings',
  VirtualDock = 'virtualDock',
  WarehouseInventory = 'warehouseInventory',
  WarehousePacking = 'warehousePacking',
  WarehousePieces = 'warehousePieces',
  WarehouseReceipts = 'warehouseReceipts',
  WarehouseReports = 'warehouseReports',
  WarehouseSettings = 'warehouseSettings'
}

/** A filter object that is used to filter a UUID field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operator */
export type UuidFilterV2 = {
  /** Filters for records where the relevant UUID is equal to the provided UUID */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is in the provided array of UUIDs */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant UUID field is null */
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant UUID field is not null */
  isNotBlank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant UUID is not equal to the provided UUID */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is not in the provided array of UUIDs */
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UnappliedPaymentReportCsvInput = {
  /** The list of filters that can be used to generate the unapplied payments report. */
  reportFilters: ReportFiltersInput;
};

export type UnassignInventoryItemsInput = {
  /** The UUID of the item whose inventory items need to be unassigned from the storage unit */
  itemUuid: Scalars['String']['input'];
  /** The UUID of the storage unit to unassign the inventory items from */
  uuid: Scalars['String']['input'];
};

export type UnassignInventoryItemsOutput = {
  __typename?: 'UnassignInventoryItemsOutput';
  success: Scalars['Boolean']['output'];
};

export type UnassignLegFromDriverInput = {
  driverUuid: Scalars['String']['input'];
  legUuid: Scalars['String']['input'];
};

export type UnassignOrderFromTrailerInput = {
  manifestUuid: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
};

export type UnblockCompanySchedulingDayInput = {
  /** Reopens the day even though reopening DISCARDS the exemptions granted against it. Without it, a day carrying exemptions writes NOTHING and answers with CompanySchedulingDayExemptionsAtRiskOutput naming how many resources would lose theirs. A day carrying no exemptions is reopened without it. The exemptions cannot be recovered afterwards: closing the same day again starts from nobody exempt. */
  confirmDiscardsExemptions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Calendar day to reopen, as an ISO-8601 plain date (YYYY-MM-DD). */
  dateIso8601: Scalars['String']['input'];
};

export type UnblockSchedulingResourceDayInput = {
  /** Calendar day to unblock, as an ISO-8601 plain date (YYYY-MM-DD). */
  dateIso8601: Scalars['String']['input'];
  schedulingResourceId: Scalars['String']['input'];
};

export type UnconsolidateOrderInput = {
  orderUuid: Scalars['String']['input'];
};

export type UnfinalizeOrdersInput = {
  /** The UUIDs of the orders to be unfinalized */
  uuids: Array<Scalars['String']['input']>;
};

export type UnfinalizeOrdersOutput = MutationErrorOutput | UnfinalizeOrdersSuccessOutput;

export type UnfinalizeOrdersSuccessOutput = {
  __typename?: 'UnfinalizeOrdersSuccessOutput';
  /** The list of order UUIDs that failed to unfinalize */
  failedOrderUuids: Array<Scalars['String']['output']>;
  /** The list of order UUIDs skipped because they are on an invoice — unpost the invoice first */
  skippedOnInvoiceOrderUuids: Array<Scalars['String']['output']>;
  /** The list of order UUIDs that were successfully unfinalized */
  unfinalizedOrderUuids: Array<Scalars['String']['output']>;
};

export type UnifiedSearchConnectionArgsInput = {
  /** forwards pagination cursor */
  after?: InputMaybe<Scalars['String']['input']>;
  /** backwards pagination cursor */
  before?: InputMaybe<Scalars['String']['input']>;
  /** forwards pagination count, provide this on initial query */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** backwards pagination count */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UnifiedSearchEntity = {
  __typename?: 'UnifiedSearchEntity';
  invoices: InvoiceConnection;
  orders: OrderConnection;
  quotes: QuoteConnection;
  unacceptedEdiAndApiOrders: OrderConnection;
  unacceptedEmailOrders: ScannedOrderResultConnection;
};

export type UnifiedSearchInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  invoicesConnectionArgs?: InputMaybe<UnifiedSearchConnectionArgsInput>;
  ordersConnectionArgs: UnifiedSearchConnectionArgsInput;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  quotesConnectionArgs: UnifiedSearchConnectionArgsInput;
  searchText: Scalars['String']['input'];
  unacceptedEdiAndApiOrdersConnectionArgs: UnifiedSearchConnectionArgsInput;
  unacceptedEmailOrdersConnectionArgs: UnifiedSearchConnectionArgsInput;
};

export type UnitBasedAccessorialCreateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  ratePerUnit: Scalars['Float']['input'];
};

export type UnitBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'UnitBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  ratePerUnit: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type UnitBasedAccessorialUpdateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratePerUnit?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export enum UnitOfMeasure {
  Box = 'BOX',
  Carton = 'CARTON',
  Crate = 'CRATE',
  Each = 'EACH',
  Pallet = 'PALLET',
  Skid = 'SKID',
  Unit = 'UNIT'
}

export type UnlinkPieceFromOrderInput = {
  orderUuid: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};

export type UnlinkPieceFromPackageInput = {
  packageUuid: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
};

/** Reason a candidate stop did not land on an auto-created route during a given run. */
export enum UnmatchedStopReason {
  AddressMissingLocation = 'ADDRESS_MISSING_LOCATION',
  NoRouteNameMatch = 'NO_ROUTE_NAME_MATCH',
  StopAlreadyOnRoute = 'STOP_ALREADY_ON_ROUTE',
  TargetRouteLocked = 'TARGET_ROUTE_LOCKED'
}

export type UnpackPiecesInput = {
  pieceUuids: Array<Scalars['String']['input']>;
};

export type UnpackPiecesOutput = {
  __typename?: 'UnpackPiecesOutput';
  restoredPieceCount: Scalars['Int']['output'];
  unpackedParentCount: Scalars['Int']['output'];
};

export type UnpickStorageUnitInput = {
  uuid: Scalars['String']['input'];
};

export type UnpickStorageUnitOutput = {
  __typename?: 'UnpickStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export type UnpostInvoiceInput = {
  uuid: Scalars['String']['input'];
};

export type UnpostInvoiceOutput = {
  __typename?: 'UnpostInvoiceOutput';
  success: Scalars['Boolean']['output'];
};

export type UnpostInvoicesInput = {
  uuids: Array<Scalars['String']['input']>;
};

export type UnpostInvoicesOutput = MutationErrorOutput | UnpostInvoicesSuccessOutput;

export type UnpostInvoicesSuccessOutput = {
  __typename?: 'UnpostInvoicesSuccessOutput';
  /** UUIDs of invoices that failed to unpost due to an error */
  failedUuids: Array<Scalars['String']['output']>;
  /** UUIDs of invoices skipped because they have payments applied — remove the payment first */
  skippedWithPaymentsUuids: Array<Scalars['String']['output']>;
  /** UUIDs of invoices that were successfully unposted */
  unpostedUuids: Array<Scalars['String']['output']>;
};

export type UpdateAccessorialContactInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateAccessorialContactOutput = {
  __typename?: 'UpdateAccessorialContactOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateAccessorialDateRangeConfigInput = {
  accessorialDateRangeConfigToCopyUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialRangeCreateInputs?: InputMaybe<Array<AccessorialRangeCreateInput>>;
  accessorialRangeUpdateInputs?: InputMaybe<Array<AccessorialRangeUpdateInput>>;
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  fuelSurchargePercentageRate?: InputMaybe<Scalars['Float']['input']>;
  percentForSettlement?: InputMaybe<Scalars['Float']['input']>;
  rateUsd?: InputMaybe<Scalars['Float']['input']>;
  specialAccessorialChargeGroupUpdateInputs?: InputMaybe<Array<SpecialAccessorialChargeGroupUpdateInput>>;
  specialAccessorialMatrixItemUpdateInputs?: InputMaybe<Array<SpecialAccessorialMatrixItemUpdateInput>>;
  specialChargeGroupCreateInputs?: InputMaybe<Array<SpecialAccessorialChargeGroupCreateInput>>;
  specialMatrixItemsCreateInputs?: InputMaybe<Array<SpecialAccessorialMatrixItemCreateInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateAccessorialDateRangeConfigOutput = {
  __typename?: 'UpdateAccessorialDateRangeConfigOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateAccessorialGroupInput = {
  /** When provided, replaces the group membership wholesale. Omit to leave membership unchanged. */
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccessorialInput = {
  accessorialUpdateInput: AccessorialUpdateInput;
};

export type UpdateAddressInput = {
  addressUpdateInput: AddressUpdateInput;
  contactPersonUpsertInput?: InputMaybe<ContactPersonUpsertInput>;
};

export type UpdateAirportInfoInput = {
  addressUpsertInput?: InputMaybe<AddressUpsertInput>;
  addressUuid?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  iataCode?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateApiUserInput = {
  apiUserUpdateInput: ApiUserUpdateInput;
};

export type UpdateAutoApplyAccessorialConfigInput = {
  accessorialUuid?: InputMaybe<Scalars['String']['input']>;
  accessorialUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  addresses?: InputMaybe<Array<AutoApplyAccessorialConfigAddressInput>>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactsToExcludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  contactsToIncludeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleType?: InputMaybe<AutoApplyAccessorialRuleType>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopType?: InputMaybe<PickupOrDelivery>;
  tagUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateBusinessDivisionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateBusinessDivisionOutput = {
  __typename?: 'UpdateBusinessDivisionOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateCompanyConfigurationInput = {
  addOrdersToOpenInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  allCapsInOrderPage?: InputMaybe<Scalars['Boolean']['input']>;
  allowDriverToSelectNextStop?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentChangeCutoffHours?: InputMaybe<Scalars['Int']['input']>;
  /** Which scheduling model owns this company appointment capacity. Nothing reads it yet. */
  appointmentSchedulerModel?: InputMaybe<AppointmentSchedulerModel>;
  appointmentSchedulingCutoffDays?: InputMaybe<Scalars['Int']['input']>;
  appointmentSchedulingLeadingBufferHours?: InputMaybe<Scalars['Int']['input']>;
  appointmentSchedulingSlotHours?: InputMaybe<Scalars['Int']['input']>;
  appointmentSelfRescheduleLimit?: InputMaybe<Scalars['Int']['input']>;
  autoApplyWaitTimeMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  autoGroupStops?: InputMaybe<Scalars['Boolean']['input']>;
  autoMatchEodDocumentsToOrders?: InputMaybe<Scalars['Boolean']['input']>;
  companyOrdinalStart?: InputMaybe<Scalars['Int']['input']>;
  createRecurringOrdersInAdvanceHours?: InputMaybe<Scalars['Int']['input']>;
  debounceAccessorialSearch?: InputMaybe<Scalars['Boolean']['input']>;
  debounceContactSearch?: InputMaybe<Scalars['Boolean']['input']>;
  defaultDimFactor?: InputMaybe<Scalars['Int']['input']>;
  defaultFuelSettlementPercentageRate?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSurcharge?: InputMaybe<Scalars['Float']['input']>;
  defaultFuelSurchargeBillingMethod?: InputMaybe<FuelBillingMethod>;
  defaultGenerateAppointmentDurationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  defaultGenerateAppointmentEarlyCushionInMinutes?: InputMaybe<Scalars['Int']['input']>;
  defaultInvoiceDocumentsRequired?: InputMaybe<Array<DocumentType>>;
  defaultPalletHeight?: InputMaybe<Scalars['Int']['input']>;
  defaultPalletLength?: InputMaybe<Scalars['Int']['input']>;
  defaultPalletWidth?: InputMaybe<Scalars['Int']['input']>;
  defaultRouteLoadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  defaultRouteStartTime?: InputMaybe<Scalars['String']['input']>;
  defaultRouteUnloadTimeInMinutes?: InputMaybe<Scalars['Float']['input']>;
  defaultStandardStopType?: InputMaybe<StandardStopType>;
  defaultToAccessorial?: InputMaybe<Scalars['Boolean']['input']>;
  draftOrderCleanupDays?: InputMaybe<Scalars['Int']['input']>;
  draftOrderCleanupSources?: InputMaybe<Array<OrderSource>>;
  driverComplianceExpiringSoonDays?: InputMaybe<Scalars['Int']['input']>;
  driversShouldMarkFreightAsLoaded?: InputMaybe<Scalars['Boolean']['input']>;
  enableConsolidatedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  enableDigitalSignatureFlow?: InputMaybe<Scalars['Boolean']['input']>;
  enablePaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  fulfillmentTypeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  getDriverLocationDataFromMobile?: InputMaybe<Scalars['Boolean']['input']>;
  includeHyphensInInvoiceName?: InputMaybe<Scalars['Boolean']['input']>;
  includeINVInInvoiceName?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Invoice notes are now invoice note rules (invoiceNoteRules). This setting no longer affects invoices and will be removed. */
  invoiceNotes?: InputMaybe<Scalars['String']['input']>;
  invoicePdfLogoUrl?: InputMaybe<Scalars['String']['input']>;
  lineHaulBuildAheadDays?: InputMaybe<Scalars['Int']['input']>;
  lineHaulEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulMobileFutureWindowHours?: InputMaybe<Scalars['Int']['input']>;
  lineHaulMobilePastWindowHours?: InputMaybe<Scalars['Int']['input']>;
  lineHaulPlanningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logisticsSectionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  markOnHandUponPickup?: InputMaybe<Scalars['Boolean']['input']>;
  minDigitsInCompanyOrdinalOrderName?: InputMaybe<Scalars['Int']['input']>;
  mobilePollingIntervalInSeconds?: InputMaybe<Scalars['Float']['input']>;
  notificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderIdentifierForCoverSheet?: InputMaybe<OrderIdentifier>;
  orderLevelOsdEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderNamingScheme?: InputMaybe<OrderNamingScheme>;
  packageWarehouseLocationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pieceTransferableStatuses?: InputMaybe<Array<PieceStatus>>;
  pointToPointTariffsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  quoteAgentAutoSendMaxCents?: InputMaybe<Scalars['Int']['input']>;
  quoteAgentDailyModelBudgetCents?: InputMaybe<Scalars['Int']['input']>;
  quoteAgentDefaultMode?: InputMaybe<QuoteAgentPolicyMode>;
  quoteAgentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  quoteAgentMinConfidence?: InputMaybe<Scalars['Int']['input']>;
  quoteAgentValidityHours?: InputMaybe<Scalars['Int']['input']>;
  quoteContributionMarginalFromRatio?: InputMaybe<Scalars['Float']['input']>;
  quoteContributionProfitableFromRatio?: InputMaybe<Scalars['Float']['input']>;
  recoveryTariffsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  requireDimsToFinalizeCharges?: InputMaybe<Scalars['Boolean']['input']>;
  requireDriverSignature?: InputMaybe<Scalars['Boolean']['input']>;
  requireDriverToAcknowledgeRouteChange?: InputMaybe<Scalars['Boolean']['input']>;
  requireDriverToConfirmStopCompletedAtTime?: InputMaybe<Scalars['Boolean']['input']>;
  requireOnHandBeforeSelfScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use requirePODPhotoForDeliveries or requireSigneeNameForDeliveries */
  requirePODPhotoAndName?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use requirePODPhotoForPickups or requireSigneeNameForPickups */
  requirePODPhotoAndNameForPickups?: InputMaybe<Scalars['Boolean']['input']>;
  requirePODPhotoForDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  requirePODPhotoForPickups?: InputMaybe<Scalars['Boolean']['input']>;
  requireReviewForEdiOrderCreation?: InputMaybe<Scalars['Boolean']['input']>;
  requireSignedPodToCompleteStop?: InputMaybe<Scalars['Boolean']['input']>;
  requireSigneeNameForDeliveries?: InputMaybe<Scalars['Boolean']['input']>;
  requireSigneeNameForPickups?: InputMaybe<Scalars['Boolean']['input']>;
  restrictEditingOrderName?: InputMaybe<Scalars['Boolean']['input']>;
  reviewUrl?: InputMaybe<Scalars['String']['input']>;
  sameDayDispatchCellHeader?: InputMaybe<SameDayDispatchCellHeader>;
  sendSignedPodEmailAfterLateSignature?: InputMaybe<Scalars['Boolean']['input']>;
  sendSummaryEmailWithIncompleteRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  serviceLevelOptional?: InputMaybe<Scalars['Boolean']['input']>;
  showAccessorialsToDrivers?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Not relevant anymore */
  showChargesOnCustomerPortal?: InputMaybe<Scalars['Boolean']['input']>;
  showCompanyNameOnBillOfLadingDoc?: InputMaybe<Scalars['Boolean']['input']>;
  showDriverSettlementInBilling?: InputMaybe<Scalars['Boolean']['input']>;
  showHelpersColumnInDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  showKilogramsAndCentimeters?: InputMaybe<Scalars['Boolean']['input']>;
  showManuallyConfirmedByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  showVehicleInDailyDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  startingInvoiceOrdinalNumber?: InputMaybe<Scalars['Float']['input']>;
  t2tDelegationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  t2tSyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  terminalsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  textNextCustomerForAppointments?: InputMaybe<Scalars['Boolean']['input']>;
  useDriverNumberForDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  useHawbForLotLabelBarcode?: InputMaybe<Scalars['Boolean']['input']>;
  useJournalNumberForInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  useSeparateDigitalSignatureStep?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  wmsAutoMarkOnHand?: InputMaybe<Scalars['Boolean']['input']>;
  wmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wmsShortTermStorageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  wmsStorageOrdersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCompanyInput = {
  alternateIsaId?: InputMaybe<Scalars['String']['input']>;
  alternateStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  apiName?: InputMaybe<Scalars['String']['input']>;
  blockSendingZeroDollarInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  companyLandscapeLogoUrl?: InputMaybe<Scalars['String']['input']>;
  companySquareLogoUrl?: InputMaybe<Scalars['String']['input']>;
  /** A JSON object that represents the set of configurations for the company */
  configs?: InputMaybe<Scalars['String']['input']>;
  customDunningReportFooter?: InputMaybe<Scalars['String']['input']>;
  customDunningReportHeader?: InputMaybe<Scalars['String']['input']>;
  defaultAddressCreateInput?: InputMaybe<AddressCreateInput>;
  defaultAddressUpdateInput?: InputMaybe<AddressUpdateInput>;
  defaultInboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInboundOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultInvoiceEmailSubject?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultMeasurementUnits?: InputMaybe<MeasurementUnits>;
  defaultNonCompanyDriverSettlementMode?: InputMaybe<SettlementMode>;
  defaultOrdinarySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOutboundEdiServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoverySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultWeightUnits?: InputMaybe<WeightUnits>;
  ediPodFilenamePrefix?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateScac?: InputMaybe<Scalars['String']['input']>;
  freightChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  freightSnapId?: InputMaybe<Scalars['String']['input']>;
  fuelChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  isCourier?: InputMaybe<Scalars['Boolean']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  miscCustomChargeQuickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderNameOrdinal?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  purchasedProductOfferings?: InputMaybe<Array<PalletProductOffering>>;
  qbInvoiceNumberStart?: InputMaybe<Scalars['Float']['input']>;
  qboDefaultClassId?: InputMaybe<Scalars['String']['input']>;
  qboDefaultIncomeAccountId?: InputMaybe<Scalars['String']['input']>;
  qboDefaultTaxCodeId?: InputMaybe<Scalars['String']['input']>;
  qboFreightItemId?: InputMaybe<Scalars['String']['input']>;
  qboFuelItemId?: InputMaybe<Scalars['String']['input']>;
  qboLineHaulItemId?: InputMaybe<Scalars['String']['input']>;
  quickbooksCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccessorialId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopAccountsReceivableId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopCompanyId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopDeliveryId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopFuelChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopLineHaulId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopOrderChargeId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopPickupId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopRecoveryId?: InputMaybe<Scalars['String']['input']>;
  quickbooksDesktopTransferId?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingAccessorialChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFreightChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingFuelChargeName?: InputMaybe<Scalars['String']['input']>;
  quickbooksFileMappingPickupChargeName?: InputMaybe<Scalars['String']['input']>;
  secondAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  secondAlternateScac?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Segment>;
  sendgridSenderId?: InputMaybe<Scalars['String']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateScac?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  useSageBusinessWorks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContactCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the contact comment to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdateContactCommentOutput = MutationErrorOutput | UpdateContactCommentSuccessOutput;

export type UpdateContactCommentSuccessOutput = {
  __typename?: 'UpdateContactCommentSuccessOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateContactCommunicationConfigInput = {
  updateContactCommunicationConfigInput: ContactCommunicationConfigUpdateInput;
};

export type UpdateContactEmailsInput = {
  communicationTypes: Array<ContactCommunicationType>;
  contactUuid: Scalars['String']['input'];
  orderUpdateEmails: Array<Scalars['String']['input']>;
};

export type UpdateContactEmailsOutput = MutationErrorOutput | UpdateContactEmailsSuccessOutput;

export type UpdateContactEmailsSuccessOutput = {
  __typename?: 'UpdateContactEmailsSuccessOutput';
  contactCommunicationConfigs: Array<ContactCommunicationConfigEntity>;
  contactEmails: Array<ContactEmailEntity>;
  contactUuid: Scalars['String']['output'];
};

export type UpdateContactPersonInput = {
  contactPersonUpdateInput: ContactPersonUpdateInput;
  stopUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactQuickbooksIdInput = {
  quickbooksContactId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateContactQuickbooksIdsInput = {
  updateQuickbooksIdInputs: Array<UpdateContactQuickbooksIdInput>;
};

export type UpdateCsvOrderFieldMappingInput = {
  sourceColumnName?: InputMaybe<Scalars['String']['input']>;
  targetFieldType?: InputMaybe<CsvOrderMappingTargetFieldType>;
  uuid: Scalars['String']['input'];
};

export type UpdateCsvOrderImportTransactionInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  status: CsvOrderImportTransactionStatus;
  uuid: Scalars['String']['input'];
};

export type UpdateCsvOrderMappingInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  csvOrderFieldMappingCreateInputs?: InputMaybe<Array<CreateCsvOrderFieldMappingInput>>;
  deadlineDateDefaultValue?: InputMaybe<Scalars['DateTime']['input']>;
  deadlineTypeDefaultValue?: InputMaybe<DeadlineType>;
  enableDynamicInboundOrOutboundStop?: InputMaybe<Scalars['Boolean']['input']>;
  enableInboundStop?: InputMaybe<Scalars['Boolean']['input']>;
  enableOutboundStop?: InputMaybe<Scalars['Boolean']['input']>;
  freightBillingMethodDefaultValue?: InputMaybe<FreightBillingMethod>;
  name?: InputMaybe<Scalars['String']['input']>;
  pickupOrDeliveryDefaultValue?: InputMaybe<PickupOrDelivery>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  stopImportType?: InputMaybe<StopImportType>;
  stopTypeDefaultValue?: InputMaybe<StandardStopType>;
  uuid: Scalars['String']['input'];
};

export type UpdateCsvOrdersOrderInput = {
  packages: Array<CreateCsvOrdersPackageInput>;
  uuid: Scalars['String']['input'];
};

export type UpdateCustomerContactInput = {
  customerContactUpdateInput: CustomerContactUpdateInput;
};

export type UpdateCustomerContactOutput = {
  __typename?: 'UpdateCustomerContactOutput';
  customerContact: CustomerContactEntity;
};

export type UpdateCustomerContactPackageSpecsInput = {
  packageSpecIds: Array<Scalars['String']['input']>;
  useCustomPackageSpecs: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateCustomerContactVehicleTypesInput = {
  useCustomVehicleTypes: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
  vehicleTypeUuids: Array<Scalars['String']['input']>;
};

export type UpdateDefaultTariffChainsForCompany = MutationErrorOutput | UpdateDefaultTariffChainsForCompanySuccessOutput;

export type UpdateDefaultTariffChainsForCompanyInput = {
  defaultLineHaulTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinarySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultOrdinaryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultPointToPointTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoverySettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultRecoveryTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferSettlementTariffChainId?: InputMaybe<Scalars['String']['input']>;
  defaultTransferTariffChainId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultTariffChainsForCompanySuccessOutput = {
  __typename?: 'UpdateDefaultTariffChainsForCompanySuccessOutput';
  company: CompanyEntity;
};

export type UpdateDispatchTableColorsInput = {
  /** The new list of colors with the position in the array determining the precedence for selecting a color on the frontend */
  dispatchTableColors: Array<DispatchTableColorUpsertInput>;
};

export type UpdateDispatchTableColorsOutput = MutationErrorOutput | UpdateDispatchTableColorsSuccessOutput;

export type UpdateDispatchTableColorsSuccessOutput = {
  __typename?: 'UpdateDispatchTableColorsSuccessOutput';
  /** All of the dispatch table colors for the company in the configured order of precedence */
  dispatchTableColors: Array<DispatchTableColorEntity>;
};

export type UpdateDocumentInput = {
  documentUpdateInput: DocumentUpdateInput;
};

export type UpdateDocumentsInput = {
  documentUpdateInputs: Array<DocumentUpdateInput>;
};

export type UpdateDriverComplianceProfileInput = {
  /** YYYY-MM-DD */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  driverUuid: Scalars['String']['input'];
  /** YYYY-MM-DD */
  hireDate?: InputMaybe<Scalars['String']['input']>;
  licenseClass?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  licenseState?: InputMaybe<Scalars['String']['input']>;
  securityId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDriverCredentialTypeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateDriverInput = {
  driverUpdateInput: DriverUpdateInput;
};

export type UpdateDriverInsurancePolicyInput = {
  carrierName?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  effectiveOn?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  expiresOn?: InputMaybe<Scalars['String']['input']>;
  insuranceType?: InputMaybe<Scalars['String']['input']>;
  insuredAmountUsd?: InputMaybe<Scalars['Float']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateDriverLocationInput = {
  forceUpdateLocation?: InputMaybe<Scalars['Boolean']['input']>;
  mobilePhoneLatitude: Scalars['Float']['input'];
  mobilePhoneLongitude: Scalars['Float']['input'];
  source?: InputMaybe<DriverLocationUpdateSource>;
};

export type UpdateDriverOutput = {
  __typename?: 'UpdateDriverOutput';
  driver: DriverEntity;
};

export type UpdateDriverQualificationsElementInput = {
  /** The ID of a driver qualification to update, or a new ID to create a new qualification. This must be a UUID. */
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateDriverQualificationsInput = {
  driverQualifications: Array<UpdateDriverQualificationsElementInput>;
};

export type UpdateDriverQualificationsOutput = {
  __typename?: 'UpdateDriverQualificationsOutput';
  driverQualifications: Array<DriverQualificationEntity>;
};

export type UpdateDriverSettlementBillInput = {
  driverSettlementBillUpdateInput: DriverSettlementBillUpdateInput;
};

export type UpdateDriverSignableFormTemplateInput = {
  formText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateDriverTrainingRecordInput = {
  /** YYYY-MM-DD */
  completedOn?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  expiresOn?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  typeUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateDwellTimeAlertConfigInput = {
  /** Whether the config participates in alerting. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The dwell-time limit, in calendar days, beyond which on-dock freight is flagged. */
  thresholdDays: Scalars['Int']['input'];
  /** UUID of the config row to update. */
  uuid: Scalars['String']['input'];
};

export type UpdateEdiPartnershipInput = {
  allowEditingShipperBillOfLadingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  alternateStediPartnerId?: InputMaybe<Scalars['String']['input']>;
  autoAcceptOrders?: InputMaybe<Scalars['Boolean']['input']>;
  canCreateMultipleStops?: InputMaybe<Scalars['Boolean']['input']>;
  companyStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  edi214ShipmentStatuses?: InputMaybe<Array<Edi214ShipmentStatus>>;
  ediOutboundPayloadDestination?: InputMaybe<EdiOutboundPayloadDestination>;
  enableStaging?: InputMaybe<Scalars['Boolean']['input']>;
  excludeZeroChargeInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreCancellations?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreNonEdiOutbound?: InputMaybe<Scalars['Boolean']['input']>;
  includeItemizedChargesIn210?: InputMaybe<Scalars['Boolean']['input']>;
  includeOutboundFilenameReceiverIsaId?: InputMaybe<Scalars['Boolean']['input']>;
  mergeLineHaul?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFilenameScacPrefix?: InputMaybe<Scalars['Boolean']['input']>;
  removeSpacesFrom214Bol?: InputMaybe<Scalars['Boolean']['input']>;
  requireGenerateEdi210Ids?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo204?: InputMaybe<Scalars['Boolean']['input']>;
  send990InResponseTo211?: InputMaybe<Scalars['Boolean']['input']>;
  sendBackupDocs?: InputMaybe<Scalars['Boolean']['input']>;
  stedi210MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi210TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi214MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi214TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stedi990MappingId?: InputMaybe<Scalars['String']['input']>;
  stedi990TransactionSettingId?: InputMaybe<Scalars['String']['input']>;
  stediPartnershipId?: InputMaybe<Scalars['String']['input']>;
  tiffPodUpload?: InputMaybe<Scalars['Boolean']['input']>;
  timeOfPodUpload?: InputMaybe<TimeOfPodUpload>;
  useStediGenerateEdiFunction?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateEdiPartnershipOutput = {
  __typename?: 'UpdateEdiPartnershipOutput';
  ediPartnership?: Maybe<EdiPartnershipEntity>;
};

export type UpdateEmailIngestionExclusionsInput = {
  excludedCustomerUuids: Array<Scalars['String']['input']>;
  excludedDocumentTypes: Array<ClassifiedDocumentType>;
};

export type UpdateEmailTransactionInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  documentUuid?: InputMaybe<Scalars['String']['input']>;
  emailResponse?: InputMaybe<Scalars['String']['input']>;
  emailResponseStatus?: InputMaybe<Scalars['Int']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  sendgridMessageId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateEmailTransactionOutput = {
  __typename?: 'UpdateEmailTransactionOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateEndOfDayDocumentProcessingJobInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor?: InputMaybe<Scalars['DateTime']['input']>;
  status: EndOfDayDocumentsProcessingJobStatus;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uploadedFileName?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateEquipmentInput = {
  equipmentUpdateInput: EquipmentUpdateInput;
};

export type UpdateEquipmentLicenseInput = {
  equipmentLicenseUpdateInput: EquipmentLicenseUpdateInput;
};

export type UpdateFeatureFlagCompanyOverrideInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateFeatureFlagInput = {
  featureFlagUpdateInput: FeatureFlagUpdateInput;
};

export type UpdateFeatureFlagUserOverrideInput = {
  active: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateFreightChargeInput = {
  freightChargeUpdateInput: FreightChargeUpdateInput;
};

export type UpdateFuelProfileDateRangeInput = {
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Float']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  settlementPercentageRate?: InputMaybe<Scalars['Percent']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateFuelProfileDateRangeOutput = {
  __typename?: 'UpdateFuelProfileDateRangeOutput';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateFuelProfileInput = {
  billingType?: InputMaybe<FuelBillingMethod>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  flatRateUsdCents?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  surchargeRate?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<FuelProfileType>;
  unappliedContactUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateGeneralLedgerCodeOutput = MutationErrorOutput | UpdateGeneralLedgerCodeSuccessOutput;

export type UpdateGeneralLedgerCodeSuccessOutput = {
  __typename?: 'UpdateGeneralLedgerCodeSuccessOutput';
  generalLedgerCode: GeneralLedgerCodeEntity;
};

export type UpdateGeneralLedgerConfigurationOutput = MutationErrorOutput | UpdateGeneralLedgerConfigurationSuccessOutput;

export type UpdateGeneralLedgerConfigurationSuccessOutput = {
  __typename?: 'UpdateGeneralLedgerConfigurationSuccessOutput';
  generalLedgerConfiguration: GeneralLedgerConfigurationEntity;
};

export type UpdateInAppNotificationPreferencesInput = {
  preferences: Array<InAppNotificationPreferenceInput>;
};

export type UpdateInventoryItemsInput = {
  itemUuid: Scalars['String']['input'];
  /** The updated number of inventory items for the specified item and storage order */
  quantity: Scalars['Int']['input'];
  storageOrderUuid: Scalars['String']['input'];
  unitOfMeasure: UnitOfMeasure;
};

export type UpdateInventoryItemsOutput = {
  __typename?: 'UpdateInventoryItemsOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateInvoiceInput = {
  invoiceUpdateInput: InvoiceUpdateInput;
};

export type UpdateInvoiceNoteRuleInput = {
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  /** Also print the company-wide rule's note after this rule's note. Not allowed on the company-wide rule itself. */
  includeCompanyNote?: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
  rebilled?: InputMaybe<Scalars['Boolean']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  productCost?: InputMaybe<Scalars['Float']['input']>;
  sellPrice?: InputMaybe<Scalars['Float']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ItemStatus>;
  upsertInventoryPrimaryUnitOfMeasureInput?: InputMaybe<UpsertInventoryPrimaryUnitOfMeasureInput>;
  upsertInventorySecondaryUnitOfMeasureInput?: InputMaybe<UpsertInventorySecondaryUnitOfMeasureInput>;
  upsertItemStorageUnitConfigInput?: InputMaybe<UpsertItemStorageUnitConfigInput>;
  uuid: Scalars['String']['input'];
};

export type UpdateItemLocationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the item location to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdateItemLocationOutput = {
  __typename?: 'UpdateItemLocationOutput';
  /** The item location that was created. It is null in the case a location with a duplicate name w.r.t to the company is passed in */
  itemLocation?: Maybe<ItemLocationEntity>;
};

export type UpdateKpiLayoutInput = {
  tiles?: InputMaybe<Array<KpiTileInput>>;
};

export type UpdateLegDriverMapInput = {
  legDriverMapUpdateInput: LegDriverMapUpdateInput;
};

export type UpdateLineHaulLaneInput = {
  lineHaulLaneUpdateInput: LineHaulLaneUpdateInput;
};

export type UpdateLineHaulLaneOutput = {
  __typename?: 'UpdateLineHaulLaneOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  lineHaulLane: LineHaulLaneEntity;
};

export type UpdateLineHaulManifestInput = {
  lineHaulManifestUpdateInput: LineHaulManifestUpdateInput;
};

export type UpdateLineHaulSegmentInput = {
  lineHaulSegmentUpdateInput: LineHaulSegmentUpdateInput;
};

export type UpdateManifestDriverInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateManifestVehicleInput = {
  equipmentUuid: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateManifestsStatusInput = {
  manifestUuids: Array<Scalars['String']['input']>;
  status: LineHaulManifestStatus;
};

export type UpdateManifestsStatusOutput = MutationErrorOutput | UpdateManifestsStatusSuccessOutput;

export type UpdateManifestsStatusSuccessOutput = {
  __typename?: 'UpdateManifestsStatusSuccessOutput';
  lineHaulManifests: Array<LineHaulManifestEntity>;
};

export type UpdateMasterAccountInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateMasterAccountOutput = {
  __typename?: 'UpdateMasterAccountOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateMirrorTargetInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subscribesToAllCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateMyStopInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  proofOfDeliverySignee?: InputMaybe<Scalars['String']['input']>;
  stopUuid: Scalars['String']['input'];
};

export type UpdateOrderCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  showOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the order comment to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdateOrderDelegationRuleInput = {
  customerOrganizationUuid?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerWindowMinutes?: InputMaybe<Scalars['Int']['input']>;
  orderSources?: InputMaybe<Array<OrderSource>>;
  peerUuid?: InputMaybe<Scalars['String']['input']>;
  pickupHandling?: InputMaybe<DelegatedPickupHandling>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  ruleUuid: Scalars['String']['input'];
  scope?: InputMaybe<OrderDelegationScope>;
  shareEndCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  timing?: InputMaybe<OrderDelegationRuleTiming>;
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateOrderEventNotificationSubscriptionsInput = {
  contactUuid: Scalars['String']['input'];
  subscriptions: Array<OrderEventNotificationSubscriptionInput>;
};

export type UpdateOrderEventNotificationSubscriptionsOutput = MutationErrorOutput | UpdateOrderEventNotificationSubscriptionsSuccessOutput;

export type UpdateOrderEventNotificationSubscriptionsSuccessOutput = {
  __typename?: 'UpdateOrderEventNotificationSubscriptionsSuccessOutput';
  contactUuid: Scalars['String']['output'];
  subscriptions: Array<OrderEventNotificationSubscriptionEntity>;
};

export type UpdateOrderFormFieldsInput = {
  onePackageRequired: Scalars['Boolean']['input'];
  onePackageWeightRequired: Scalars['Boolean']['input'];
  /** @deprecated This field is no longer needed. Will be removed once the frontend stops using it. */
  packagePiecesRequired?: Scalars['Boolean']['input'];
  /** @deprecated This field is no longer needed. Will be removed once the frontend stops using it. */
  packageWeightRequired?: Scalars['Boolean']['input'];
};

export type UpdateOrderLoadedStatusInput = {
  loaded: Scalars['Boolean']['input'];
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

/** This is the graphql input for editing an organization. Identical to create input except we pass in uuid */
export type UpdateOrganizationInput = {
  customerFields?: InputMaybe<CreateOrUpdateCustomerInput>;
  defaultContactPersonUuid?: InputMaybe<Scalars['String']['input']>;
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isaId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  peerCompanyUuid?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  types: Array<OrganizationType>;
  uuid: Scalars['String']['input'];
};

export type UpdateOrganizationMessageInput = {
  /** A new audience. Only a draft can change who it reaches. */
  audience?: InputMaybe<OrganizationMessageAudienceInput>;
  body?: Scalars['String']['input'];
  /** When the message stops showing. Omitted uses the severity default (INFO 14 days, WARNING 3 days, CRITICAL never); null means never. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  link?: InputMaybe<OrganizationMessageLinkInput>;
  severity: OrganizationMessageSeverity;
  /** Optional; most messages need only the body. */
  title?: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateOrganizationOutput = MutationErrorOutput | UpdateOrganizationSuccessOutput;

export type UpdateOrganizationPeersSettingsInput = {
  peers: Array<OrganizationPeerSettingsChangeInput>;
};

export type UpdateOrganizationSuccessOutput = {
  __typename?: 'UpdateOrganizationSuccessOutput';
  /** The updated organization */
  organization: OrganizationEntity;
};

export type UpdatePackageArrayInput = {
  orderUuid: Scalars['String']['input'];
  packageArrayUpdateInputs: Array<PackageArrayUpdateInput>;
  shipmentUuid: Scalars['String']['input'];
};

export type UpdatePackageInput = {
  packageUpdateInput: PackageUpdateInput;
};

export type UpdatePackageSpecInput = {
  freightClass?: InputMaybe<FreightClass>;
  height?: InputMaybe<Scalars['Length']['input']>;
  id: Scalars['String']['input'];
  length?: InputMaybe<Scalars['Length']['input']>;
  name: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type UpdatePackageSpecOutput = {
  __typename?: 'UpdatePackageSpecOutput';
  packageSpec: PackageSpecEntity;
};

export type UpdatePackageWarehouseLocationInput = {
  uuid: Scalars['String']['input'];
  /** The UUID of the new warehouse location that the package is being moved to */
  warehouseLocationUuid: Scalars['String']['input'];
};

export type UpdatePackageWarehouseLocationOutput = {
  __typename?: 'UpdatePackageWarehouseLocationOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdatePaperworkCompleteInput = {
  paperworkCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdatePaymentInput = {
  amountInCents?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  creditTypeUuid?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  glTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  paymentRail?: InputMaybe<PaymentRail>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  updatePaymentToOrderMappingInput: Array<UpdatePaymentOrderMappingInput>;
  uuid: Scalars['String']['input'];
};

export type UpdatePaymentOffsetInput = {
  amountInCents: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdatePaymentOrderMappingInput = {
  amountInCents: Scalars['Int']['input'];
  orderUuid: Scalars['String']['input'];
};

export type UpdatePermissionAccessLevelInput = {
  accessLevel: AccessLevel;
  uuid: Scalars['String']['input'];
};

export type UpdatePermissionAccessLevelOutput = {
  __typename?: 'UpdatePermissionAccessLevelOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdatePermissionInput = {
  accessLevel?: InputMaybe<AccessLevel>;
  permissionResource?: InputMaybe<PermissionResource>;
  roleUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdatePermissionOutput = {
  __typename?: 'UpdatePermissionOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdatePersonInput = {
  contactStationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  contactUuid: Scalars['String']['input'];
  defaultDeliveryAddress?: InputMaybe<AddressUpsertInput>;
  defaultPickupAddress?: InputMaybe<AddressUpsertInput>;
  defaultServiceUuid?: InputMaybe<Scalars['String']['input']>;
  defaultVehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonOutput = {
  __typename?: 'UpdatePersonOutput';
  person: PersonEntity;
};

export type UpdatePieceCountInput = {
  pieceCount?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the order whose piece count is to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdatePieceDimensionsInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  packageUuid?: InputMaybe<Scalars['String']['input']>;
  syncAction?: InputMaybe<PieceDimsSyncAction>;
  uuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePieceInput = {
  additionalReferenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  damagedNote?: InputMaybe<Scalars['String']['input']>;
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isMisrouted?: InputMaybe<Scalars['Boolean']['input']>;
  isOverage?: InputMaybe<Scalars['Boolean']['input']>;
  isShortage?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  refusedAt?: InputMaybe<Scalars['DateTime']['input']>;
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePieceReceiptInput = {
  /** Date the shipment arrived. Required. */
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the contact (customer) the receipt is created for */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  expectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  sealNumber?: InputMaybe<Scalars['String']['input']>;
  supplierCompanyName?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trailerNumber?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the piece receipt being updated */
  uuid: Scalars['String']['input'];
};

export type UpdatePieceReceiptOutput = {
  __typename?: 'UpdatePieceReceiptOutput';
  /** The piece receipt that was updated */
  pieceReceipt: PieceReceiptEntity;
};

export type UpdatePieceReceiptPieceInput = {
  dimWeight?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  measurementUnits?: InputMaybe<MeasurementUnits>;
  /** UUID of the receipt the piece must be attached to */
  pieceReceiptUuid: Scalars['String']['input'];
  /** UUID of the piece to update */
  pieceUuid: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PackageType>;
  /** UUID of the warehouse location to move the piece to */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightUnits?: InputMaybe<WeightUnits>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePieceReceiptPieceOutput = {
  __typename?: 'UpdatePieceReceiptPieceOutput';
  /** The updated piece */
  piece: PieceEntity;
};

export type UpdatePiecesPickedInput = {
  piecesPicked?: InputMaybe<Scalars['Int']['input']>;
  sentFromMobileApplication?: InputMaybe<Scalars['Boolean']['input']>;
  /** The UUID of the order whose pieces picked is to be updated */
  uuid: Scalars['String']['input'];
};

export type UpdatePlaceInput = {
  placeUpdateInput: PlaceUpdateInput;
};

export type UpdateQuickAddAccessorialsInput = {
  quickAddAccessorialUuids: Array<Scalars['String']['input']>;
};

export type UpdateQuickAddAccessorialsOutput = {
  __typename?: 'UpdateQuickAddAccessorialsOutput';
  quickAddAccessorials: Array<AccessorialUnion>;
};

export type UpdateQuickbooksHeaderFileMappingInput = {
  quickbooksHeaderFileMappingUpdateInput: QuickbooksHeaderFileMappingUpdateInput;
};

export type UpdateQuoteAgentStaffSettingsInput = {
  companyUuid: Scalars['String']['input'];
  quoteAgentDailyModelBudgetCents?: InputMaybe<Scalars['Int']['input']>;
  quoteAgentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateQuoteInput = {
  quoteUpdateInput: QuoteUpdateInput;
  uuid: Scalars['String']['input'];
};

export type UpdateRecurringLineHaulManifestTemplateInput = {
  autoGenerate?: InputMaybe<Scalars['Boolean']['input']>;
  createAheadDays?: InputMaybe<Scalars['Int']['input']>;
  createInAdvanceHours?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek: Array<DayOfWeekAll>;
  defaultDriverUuid?: InputMaybe<Scalars['String']['input']>;
  defaultEquipmentUuid?: InputMaybe<Scalars['String']['input']>;
  departTimeMinutes: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTerminalUuid: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  manifestsPerOccurrence?: InputMaybe<Scalars['Int']['input']>;
  repeatFrequencyUnit?: InputMaybe<RepeatFrequencyUnit>;
  repeatInterval?: InputMaybe<Scalars['Int']['input']>;
  skipDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startDate: Scalars['DateTime']['input'];
  startTerminalUuid: Scalars['String']['input'];
  transitMinutes?: InputMaybe<Scalars['Int']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRecurringOrderFrequencyInput = {
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysOfWeek?: InputMaybe<Array<DayOfWeekAll>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  repeatFrequencyUnit?: InputMaybe<RepeatFrequencyUnit>;
  repeatInterval?: InputMaybe<Scalars['Int']['input']>;
  repeatIntervalWeeks?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRecurringTemplateTruckInput = {
  cutoffTime?: InputMaybe<Scalars['String']['input']>;
  daysOfWeek?: InputMaybe<Array<DayOfWeekAll>>;
  label: Scalars['String']['input'];
  powerUnitEquipmentUuid?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  trailers: Array<RecurringTemplateTruckTrailerInput>;
  uuid: Scalars['String']['input'];
};

export type UpdateRoleInput = {
  isInternalRole?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRoleOutput = {
  __typename?: 'UpdateRoleOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateRouteDriversInput = {
  driverUuids: Array<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRouteInput = {
  routeUpdateInput: RouteUpdateInput;
};

export type UpdateRouteNameLocationInput = {
  routeNameLocationCreateInput?: InputMaybe<RouteNameLocationCreateInput>;
  routeNameLocationUpdateInput: RouteNameLocationUpdateInput;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRouteOptimizationInput = {
  routeOptimizationUpdateInput: RouteOptimizationUpdateInput;
  uuid: Scalars['String']['input'];
};

export type UpdateRouteSlotInput = {
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  routeSlotUpdateInput: RouteSlotUpdateInput;
};

export type UpdateRouteSlotsInput = {
  routeSlotArrayUpdateInputs: Array<RouteSlotArrayUpdateInput>;
  routeSlotsUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateRunInput = {
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Because name cannot be cleared out, passing in an empty string, null, or undefined will have no effect */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The UUIDs of the orders to be included under the run. Passing in null or undefined value will have no effect. */
  orderUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The UUIDs of the tags to be associated with this run. Passing in null or undefined value will have no effect. */
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRunOutput = {
  __typename?: 'UpdateRunOutput';
  run: RunEntity;
};

export type UpdateSameDayDispatchConfigInput = {
  deliveryAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  deliveryWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
  isNextInRouteColorCode?: InputMaybe<Scalars['String']['input']>;
  isPastDeadlineColorCode?: InputMaybe<Scalars['String']['input']>;
  isSpecialColorCode?: InputMaybe<Scalars['String']['input']>;
  pickupAppointmentTimeThreshold?: InputMaybe<Scalars['Int']['input']>;
  pickupWithinTimeWindowColorCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSavedFilterViewInput = {
  /** The page's default tab the view is based on (e.g. a Billing Review tab). Null means the page's base tab. */
  baseTab?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  filterModelJson?: InputMaybe<Scalars['String']['input']>;
  filterModelJsonV2?: InputMaybe<Scalars['JSON']['input']>;
  /** Ordered list of OrderTableField values the orders grid groups by, outermost first. Omit or pass null for an ungrouped view. */
  groupModelJson?: InputMaybe<Scalars['JSON']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  /** The line-haul dispatch board filters to restore with the view. Only accepted on LINE_HAUL_ORDERS views; null on update clears them. */
  lineHaulDispatchFilters?: InputMaybe<SavedLineHaulDispatchFiltersInput>;
  /** The new set of order columns to display for the saved filter view. If null, then the current set of order columns is maintained for the view */
  orderTableFields?: InputMaybe<Array<OrderTableField>>;
  savedViewPageType?: InputMaybe<FilterViewPage>;
  sortModelJson?: InputMaybe<Array<Scalars['JSON']['input']>>;
  uuid: Scalars['String']['input'];
};

export type UpdateScannedOrderInput = {
  companyUuid: Scalars['String']['input'];
  scannedOrderUpdateInput: ScannedOrderUpdateInput;
};

export type UpdateScannedOrderResultStatusInput = {
  /** Associate the result with this uuid. Used when an order is manually entered */
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  scannedOrderResultUuid: Scalars['String']['input'];
  status: ScannedOrderResultStatus;
};

export type UpdateSchedulingRegionInput = {
  dailyCapacityPieces?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityStops?: InputMaybe<Scalars['Int']['input']>;
  dailyCapacityWeight?: InputMaybe<Scalars['Mass']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchedulingRegionOutput = MutationErrorOutput | UpdateSchedulingRegionSuccessOutput;

export type UpdateSchedulingRegionSuccessOutput = {
  __typename?: 'UpdateSchedulingRegionSuccessOutput';
  schedulingRegion: SchedulingRegionEntity;
};

export type UpdateSchedulingResourceInput = {
  /** Null means the resource has no piece limit. */
  capacityPieces?: InputMaybe<Scalars['Int']['input']>;
  /** Null means the resource has no stop limit. */
  capacityStops?: InputMaybe<Scalars['Int']['input']>;
  /** Null means the resource has no weight limit. */
  capacityWeight?: InputMaybe<Scalars['Mass']['input']>;
  dayOfWeek?: InputMaybe<DayOfWeekAll>;
  /** Earlier than start is accepted and means the window crosses midnight: the end then belongs to the calendar day after dayOfWeek, read in this resource timeZone. Nothing else has to be sent to say so. Equal to start is rejected, so a 24-hour window is not representable: express it as 00:00 to 23:59. Both fields are required and the columns behind them are NOT NULL, so a resource with no window at all is not representable either. */
  end?: InputMaybe<PlainTimeInput>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** UUIDs of the route names this resource covers. At least one is required. The capacity below is the total across all of them, not a per-route-name allowance. */
  routeNameUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  start?: InputMaybe<PlainTimeInput>;
  /** Canonical IANA region time zone the start and end times are read in, for example America/New_York. Fixed offsets, abbreviations and Etc/* zones are rejected because they are blind to daylight saving. Defaults to the company time zone. */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchedulingZoneInput = {
  availabilities?: InputMaybe<Array<SchedulingZoneAvailabilityUpsertInput>>;
  id: Scalars['String']['input'];
  locations?: InputMaybe<Array<SchedulingZoneLocationUpsertInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedulingRegionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchedulingZoneOutput = MutationErrorOutput | UpdateSchedulingZoneSuccessOutput;

export type UpdateSchedulingZoneSuccessOutput = {
  __typename?: 'UpdateSchedulingZoneSuccessOutput';
  schedulingZone: SchedulingZoneEntity;
};

export type UpdateSchemaCompanyMappingInput = {
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSchemaDocumentInput = {
  schemaDocument: SchemaDocumentInput;
  uuid: Scalars['String']['input'];
};

export type UpdateSchemaInput = {
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  schema: SchemaInput;
  uuid: Scalars['String']['input'];
};

export type UpdateServiceDateForAssignedStopsInput = {
  serviceDate: Scalars['DateTime']['input'];
  /** The service date to set the stop sto, as an ISO 8601 formatted date string. */
  serviceDateIso8601?: InputMaybe<Scalars['String']['input']>;
  stopUuids: Array<Scalars['String']['input']>;
};

export type UpdateServiceGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** When provided, replaces the group membership wholesale. Omit to leave membership unchanged. */
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateServiceInput = {
  serviceCreateInput?: InputMaybe<ServiceCreateInput>;
  serviceUpdateInput: ServiceUpdateInput;
};

export type UpdateServiceRegionInput = {
  id: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceRegionOutput = MutationErrorOutput | UpdateServiceRegionSuccessOutput;

export type UpdateServiceRegionSuccessOutput = {
  __typename?: 'UpdateServiceRegionSuccessOutput';
  /** The updated service region */
  serviceRegion: ServiceRegionEntity;
};

export type UpdateSftpCredentialsInput = {
  bundleShipmentPhotosWithPod?: InputMaybe<Scalars['Boolean']['input']>;
  ediPartnershipUuid?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  invoicePath?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  podNamingConvention?: InputMaybe<PodNamingConvention>;
  port?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateShipmentInput = {
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  shipmentUpdateInput: ShipmentUpdateInput;
};

export type UpdateShipmentStandardAccessorialsInput = {
  /** Accessorial uuids to keep. Any uuids excluded are removed */
  accessorialUuids: Array<Scalars['String']['input']>;
  shipmentUuid: Scalars['String']['input'];
};

export type UpdateStandaloneStopInput = {
  address: AddressUpsertInput;
  appointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  endAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  serviceTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  stopUuid: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStandardOrderInput = {
  orderUpdateInput: StandardOrderUpdateInput;
  /** The last known updatedAt timestamp from the client-side application. Used for validating concurrent updates to ensure data consistency. */
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateStandardShipmentFieldInput = {
  standardShipmentFieldsUpdateInput: StandardShipmentFieldsUpdateInput;
};

export type UpdateStopDriverMapInput = {
  stopDriverMapUpdateInput: StopDriverMapUpdateInput;
};

export type UpdateStopInput = {
  stopUpdateInput: StopUpdateInput;
};

export type UpdateStopsInput = {
  stopUpdateInputs: Array<StopUpdateInput>;
};

export type UpdateStorageOrderInput = {
  arrivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  billOfLadingNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  consigneeName?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the contact for whom the storage order is being created */
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  documentUpsertInputs?: InputMaybe<Array<DocumentUpsertInput>>;
  expectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupDate?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  sealNumber?: InputMaybe<Scalars['String']['input']>;
  supplierCompanyName?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trailerNumber?: InputMaybe<Scalars['String']['input']>;
  /** The UUID of the storage order being updated */
  uuid: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStorageOrderOutput = {
  __typename?: 'UpdateStorageOrderOutput';
  /** The storage order that was updated */
  storageOrder: StorageOrderEntity;
};

export type UpdateStorageUnitInput = {
  billed?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Length']['input']>;
  inventoryLastVerifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  length?: InputMaybe<Scalars['Length']['input']>;
  markedOnHandAt?: InputMaybe<Scalars['DateTime']['input']>;
  markedOsdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  osdReason?: InputMaybe<Scalars['String']['input']>;
  outboundReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  pickedAt?: InputMaybe<Scalars['DateTime']['input']>;
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
  uuid: Scalars['String']['input'];
  /** The UUID of the newly assigned warehouse location for the storage unit. */
  warehouseLocationUuid?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Mass']['input']>;
  width?: InputMaybe<Scalars['Length']['input']>;
};

export type UpdateStorageUnitOutput = {
  __typename?: 'UpdateStorageUnitOutput';
  storageUnit: StorageUnitEntity;
};

export type UpdateTagInput = {
  tagUpdateInput: TagUpdateInput;
};

export type UpdateTariffChainInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tariffGroupUuids: Array<Scalars['String']['input']>;
};

export type UpdateTariffChainOutput = MutationErrorOutput | UpdateTariffChainSuccessOutput;

export type UpdateTariffChainSuccessOutput = {
  __typename?: 'UpdateTariffChainSuccessOutput';
  /** The tariff chain that was updated */
  tariffChain: TariffChainEntity;
};

export type UpdateTariffGroupInput = {
  contactToServicesMappings?: InputMaybe<Array<CreateContactToServicesMappingInput>>;
  contactUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fuelProfileUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentTariffGroupUuid?: InputMaybe<Scalars['String']['input']>;
  rateMultiplier?: InputMaybe<Scalars['Float']['input']>;
  rateType?: InputMaybe<RateType>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tariffCreateInputs?: InputMaybe<Array<TariffCreateInput>>;
  tariffGroupScope?: InputMaybe<TariffGroupScope>;
  tariffGroupType?: InputMaybe<TariffGroupType>;
  tariffOverageRateCreates?: InputMaybe<Array<TariffOverageRateCreateInput>>;
  tariffType?: InputMaybe<TariffType>;
  /** The tariffs the group keeps. An array, empty included, upserts each one and disconnects every saved tariff it leaves out. Null leaves the tariffs alone; a point-to-point editor then saves lanes through savePointToPointLanes, and zone changes or tariffOverageRateCreates alongside a null list are refused. */
  tariffUpsertInputs?: InputMaybe<Array<TariffUpsertInput>>;
  tariffZoneCreateInputs?: InputMaybe<Array<TariffZoneCreateInput>>;
  tariffZoneDeletes: Array<Scalars['String']['input']>;
  tariffZoneGroupId?: InputMaybe<Scalars['String']['input']>;
  tariffZoneUpdateInputs?: InputMaybe<Array<TariffZoneUpdateInput>>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  useActualWeightInCalculation?: InputMaybe<Scalars['Boolean']['input']>;
  useDeficitBilling?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
  vehicleTypeUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneType?: InputMaybe<TariffZoneType>;
};

/** The carrier's EDI identity. Omit a field to keep it; send null or blank to clear it. */
export type UpdateTenediCarrierIdentityInput = {
  alternateIsaId?: InputMaybe<Scalars['String']['input']>;
  alternateStandardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  companyUuid: Scalars['String']['input'];
  /** Required as true when the backend runs in production. The page sends it only after the operator types prod. */
  confirmProduction?: InputMaybe<Scalars['Boolean']['input']>;
  fourthAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  fourthAlternateScac?: InputMaybe<Scalars['String']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  secondAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  secondAlternateScac?: InputMaybe<Scalars['String']['input']>;
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateIsaId?: InputMaybe<Scalars['String']['input']>;
  thirdAlternateScac?: InputMaybe<Scalars['String']['input']>;
};

/** The customer's EDI identity. Omit a field to keep it; send null or blank to clear it. */
export type UpdateTenediCustomerIdentityInput = {
  companyUuid: Scalars['String']['input'];
  /** Required as true when the backend runs in production. The page sends it only after the operator types prod. */
  confirmProduction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Omit to keep. Cannot be cleared. */
  defaultInvoiceTransmissionMethod?: InputMaybe<InvoiceTransmissionMethod>;
  ediApplicationId?: InputMaybe<Scalars['String']['input']>;
  ediContactCode?: InputMaybe<Scalars['String']['input']>;
  isaId?: InputMaybe<Scalars['String']['input']>;
  organizationUuid: Scalars['String']['input'];
  standardCarrierAlphaCode?: InputMaybe<Scalars['String']['input']>;
  stediPartnerId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTerminalInput = {
  terminalUpdateInput: TerminalUpdateInput;
};

export type UpdateTerminalOutput = {
  __typename?: 'UpdateTerminalOutput';
  terminal: TerminalEntity;
};

export type UpdateTerminalSuccessOutput = {
  __typename?: 'UpdateTerminalSuccessOutput';
  /** The updated terminal */
  terminal: TerminalEntity;
};

export type UpdateTerminalV2Output = MutationErrorOutput | UpdateTerminalSuccessOutput;

export type UpdateTestOrderInput = {
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  totalCharge?: InputMaybe<Scalars['Float']['input']>;
  totalFreightCharge?: InputMaybe<Scalars['Float']['input']>;
  totalFuelCharge?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateTestOrderOutput = {
  __typename?: 'UpdateTestOrderOutput';
  success: Scalars['Boolean']['output'];
};

export type UpdateTestPieceStatusInput = {
  pieceUuids: Array<Scalars['String']['input']>;
  status: PieceStatus;
};

export type UpdateUserInput = {
  arrangeStopsAndRoutesVertically?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, the user is assigned an internal role that provides them with the master permission resource */
  assignInternalRole?: InputMaybe<Scalars['Boolean']['input']>;
  billingReviewOrderTableFields?: InputMaybe<Array<OrderTableField>>;
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  dispatchTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  dispatchTableFields?: InputMaybe<Array<DispatchTableField>>;
  email?: InputMaybe<Scalars['String']['input']>;
  invoicesTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lineHaulOrderTableFields?: InputMaybe<Array<OrderTableField>>;
  linehaulDispatchTableFields?: InputMaybe<Array<LinehaulDispatchTableField>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfStops?: InputMaybe<Scalars['Float']['input']>;
  orderTableFields?: InputMaybe<Array<OrderTableField>>;
  ordersTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  redirectIsAlertedOnFirstSave?: InputMaybe<Scalars['Boolean']['input']>;
  redirectIsAlertedOnOpenOrder?: InputMaybe<Scalars['Boolean']['input']>;
  reportsEmail?: InputMaybe<Scalars['String']['input']>;
  /** The list of roles to assign to a user */
  roleUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  routeCardStopTableColumnWidths?: InputMaybe<Scalars['JSON']['input']>;
  routeCardStopTableFields?: InputMaybe<Array<DispatchTableField>>;
  routeCardWidth?: InputMaybe<Scalars['Float']['input']>;
  sendAllInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  sendSummaryEmailWithIncompleteRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  useMinimizedAppointmentTime?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateWarehouseEmployeeInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateWarehouseEmployeeOutput = {
  __typename?: 'UpdateWarehouseEmployeeOutput';
  /** The affected warehouse employee. Shared by the update, archive, and restore mutations. It is null when the operation could not be applied — for example the employee was not found within the caller's company, the phone number is already used by a live employee, or a server-side error occurred. (Restore surfaces a phone-number conflict as a ConflictException rather than null.) */
  warehouseEmployee?: Maybe<WarehouseEmployeeEntity>;
};

export type UpdateWarehouseInput = {
  addressUpdateInput: AddressUpdateInput;
  name: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateWarehouseLocationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  location1?: InputMaybe<Scalars['String']['input']>;
  location2?: InputMaybe<Scalars['String']['input']>;
  location3?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The UUID of the warehouse location to be updated */
  uuid: Scalars['String']['input'];
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWarehouseLocationOutput = {
  __typename?: 'UpdateWarehouseLocationOutput';
  /** An array of error messages. This is null if there are no errors. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The warehouse location that was updated. This is null if there is a warehouse location with a duplicate name passed in or  */
  warehouseLocation?: Maybe<WarehouseLocationEntity>;
};

export type UploadMobileSignedDocumentInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  orderUuid: Scalars['String']['input'];
  originalDocumentUuid: Scalars['String']['input'];
  signerName?: InputMaybe<Scalars['String']['input']>;
};

export type UploadMobileSignedDocumentOutput = {
  __typename?: 'UploadMobileSignedDocumentOutput';
  document?: Maybe<DocumentEntity>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type UpsertAddressInput = {
  addressUpsertInput: AddressUpsertInput;
  contactUuid: Scalars['String']['input'];
};

export type UpsertCompanyPackageTypeConfigInput = {
  isSingleHandlingUnit: Scalars['Boolean']['input'];
  packageType: PackageType;
};

export type UpsertCompanyPackageTypeConfigOutput = {
  __typename?: 'UpsertCompanyPackageTypeConfigOutput';
  companyPackageTypeConfig: CompanyPackageTypeConfigEntity;
};

export type UpsertContactPersonInput = {
  contactPersonUpsertInput: ContactPersonUpsertInput;
  contactUuid: Scalars['String']['input'];
  stopUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDockTimeAllowanceInput = {
  minutesPerHundredweight: Scalars['Float']['input'];
  minutesPerInboundPiece: Scalars['Float']['input'];
  minutesPerOutboundPiece: Scalars['Float']['input'];
};

export type UpsertDriverPlannerAssumptionsInput = {
  standardShiftHours: Scalars['Float']['input'];
  targetMgt: Scalars['Float']['input'];
  targetUtilizationPct: Scalars['Float']['input'];
};

export type UpsertEdiPartnershipReferenceMappingsInput = {
  ediPartnershipReferenceMappingUpsertInputs: Array<EdiPartnershipReferenceMappingUpsertInput>;
  ediPartnershipUuid: Scalars['String']['input'];
};

export type UpsertFreightChargeInput = {
  freightChargeUpsertInput: FreightChargeUpsertInput;
  shipmentUuid: Scalars['String']['input'];
};

export type UpsertInventoryPrimaryUnitOfMeasureInput = {
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpsertInventorySecondaryUnitOfMeasureInput = {
  primaryUnitsPerSecondaryUOM?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasure: UnitOfMeasure;
  upcCode?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpsertItemGroupInput = {
  /** Increments the quantity of the item group. */
  incrementQuantityBy?: InputMaybe<Scalars['Int']['input']>;
  itemUuid: Scalars['String']['input'];
  /** Sets the quantity of the item group. Takes precedence over incrementQuantityBy. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Dictates if a new storage unit should be created. if a storageUnitUuid is supplied it will take priority */
  shouldCreateStorageUnit?: InputMaybe<Scalars['Boolean']['input']>;
  storageOrderUuid: Scalars['String']['input'];
  storageUnitUuid?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
};

export type UpsertItemStorageUnitConfigInput = {
  consolidationUnitUOM: UnitOfMeasure;
  dimensionsUOM: WarehouseMeasurementUnits;
  height: Scalars['Float']['input'];
  high: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  primaryUnitsPerConsolidationUnit: Scalars['Float']['input'];
  tie: Scalars['Float']['input'];
  type: MeasurementUnits;
  uuid: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
  weightUOM: WarehouseMeasurementUnits;
  width: Scalars['Float']['input'];
};

export type UpsertLineHaulUtilizationAssumptionInput = {
  defaultTrailerCubeCapacityCubicFeet: Scalars['Float']['input'];
  defaultTrailerWeightCapacityLbs: Scalars['Float']['input'];
};

export type UpsertOrganizationPackageTypeConfigInput = {
  isSingleHandlingUnit: Scalars['Boolean']['input'];
  organizationUuid: Scalars['String']['input'];
  packageType: PackageType;
};

export type UpsertOrganizationPackageTypeConfigOutput = {
  __typename?: 'UpsertOrganizationPackageTypeConfigOutput';
  organizationPackageTypeConfig: OrganizationPackageTypeConfigEntity;
};

export type UpsertPackageInput = {
  orderUuid: Scalars['String']['input'];
  packageUpsertInput: PackageUpsertInput;
  shipmentUuid: Scalars['String']['input'];
};

export type UpsertPickListItemGroup = {
  itemGroupUuid: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type UpsertPicklistInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** List of item groups with quantities to be added to picklist */
  itemGroups: Array<UpsertPickListItemGroup>;
  outboundReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertPicklistOutput = {
  __typename?: 'UpsertPicklistOutput';
  error?: Maybe<Scalars['String']['output']>;
  picklist?: Maybe<PicklistEntity>;
};

export type UpsertSamsaraOauthTokenInput = {
  accessToken: Scalars['String']['input'];
  expiresAt: Scalars['DateTime']['input'];
  refreshToken: Scalars['String']['input'];
  scope: Scalars['String']['input'];
  tokenType: Scalars['String']['input'];
};

export type UpsertServiceAvailabilityDateInput = {
  /** @deprecated Use end instead */
  availableEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Use start instead */
  availableStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** The category or type of day. This uniquely identifies the ServiceAvailabilityDateEntity for the service. */
  dayCategory: SpecialDayOfWeek;
  enabled: Scalars['Boolean']['input'];
  end?: InputMaybe<PlainTimeInput>;
  start?: InputMaybe<PlainTimeInput>;
};

export type UpsertShipmentSubscriberInput = {
  shipmentSubscriberUpsertInput: ShipmentSubscriberUpsertInput;
  shipmentUuid: Scalars['String']['input'];
};

export type UpsertStopDriverMapInput = {
  stopDriverMapUpsertInput: StopDriverMapUpsertInput;
};

export type UpsertTimeAllowanceInput = {
  minutesPerHundredweight: Scalars['Float']['input'];
  minutesPerMile: Scalars['Float']['input'];
  minutesPerPiece: Scalars['Float']['input'];
  minutesPerStop: Scalars['Float']['input'];
};

export type UserActorEntity = {
  __typename?: 'UserActorEntity';
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type UserContactNotificationSubscriptionEntity = {
  __typename?: 'UserContactNotificationSubscriptionEntity';
  approveOrderNotification?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['String']['output'];
};

export type UserContactNotificationSubscriptionUpsertInput = {
  approveOrderNotification?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type UserEntity = {
  __typename?: 'UserEntity';
  arrangeStopsAndRoutesVertically: Scalars['Boolean']['output'];
  billingReviewOrderTableFields: Array<OrderTableField>;
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  dispatchTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  dispatchTableFields: Array<DispatchTableField>;
  driver?: Maybe<DriverEntity>;
  /** The email address of the user, or an empty string if it is null. The frontend is migrating towards accepting a nullable user.email, but we need this field to return a string until all clients are updated to accept nullable emails */
  email: Scalars['String']['output'];
  holdsPrivilegedRole: Scalars['Boolean']['output'];
  invoicesTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  isActive: Scalars['Boolean']['output'];
  lineHaulOrderTableFields: Array<OrderTableField>;
  linehaulDispatchTableFields: Array<LinehaulDispatchTableField>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfStops: Scalars['Float']['output'];
  orderTableFields: Array<OrderTableField>;
  ordersTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  redirectIsAlertedOnFirstSave?: Maybe<Scalars['Boolean']['output']>;
  redirectIsAlertedOnOpenOrder?: Maybe<Scalars['Boolean']['output']>;
  reportsEmail?: Maybe<Scalars['String']['output']>;
  reportsEmailSendgridSenderId?: Maybe<Scalars['String']['output']>;
  roles: Array<RoleEntity>;
  routeCardStopTableColumnWidths?: Maybe<Scalars['JSON']['output']>;
  routeCardStopTableFields: Array<DispatchTableField>;
  routeCardWidth: Scalars['Float']['output'];
  seenTutorials?: Maybe<Array<TutorialId>>;
  sendAllInvoices?: Maybe<Scalars['Boolean']['output']>;
  sendSummaryEmailWithIncompleteRoutes: Scalars['Boolean']['output'];
  terminal?: Maybe<TerminalEntity>;
  useMinimizedAppointmentTime: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type UserOptionEntity = {
  __typename?: 'UserOptionEntity';
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type UserSessionsAdminCompanyEntity = {
  __typename?: 'UserSessionsAdminCompanyEntity';
  activeUserCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type UserSessionsAdminCompanySearchInput = {
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type UserSessionsAdminCompanyUsersResult = {
  __typename?: 'UserSessionsAdminCompanyUsersResult';
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  users: Array<UserSessionsAdminUserEntity>;
};

export type UserSessionsAdminUserEntity = {
  __typename?: 'UserSessionsAdminUserEntity';
  canRevokeSessions: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** UUID filter fields for the findLineHaulManifestsV2 query */
export type UuidFilterV2Simple = {
  /** Filters for records where the relevant UUID is equal to the provided UUID */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is in the provided array of UUIDs */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters for records where the relevant UUID is not equal to the provided UUID */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant UUID is not in the provided array of UUIDs */
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A filter object that is used to filter a UUID list field. Each field in the filter object represents an operator. If there is more than one non-null field passed into the filter object, the condition will be a conjunction of the non-null field operators. */
export type UuidListFilter = {
  /** Filters for records where the relevant list contains the provided UUID */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Filters for records where the relevant list is empty (or null) */
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant list is not empty */
  isNotEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters for records where the relevant list does not contain the provided UUID */
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateCrownChargesInput = {
  /** The UUID of the company whose orders are being imported */
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of invoices with charges (CSV) */
  invoicesUrl?: InputMaybe<Scalars['String']['input']>;
  /** A publicly accessible URL of order charges (CSV) */
  ordersUrl: Scalars['String']['input'];
};

export type ValidateCrownChargesOutput = {
  __typename?: 'ValidateCrownChargesOutput';
  correctCrownIDs: Array<Scalars['String']['output']>;
  /** A 2D array of the CSV results of the rate validation */
  csvResults: Array<Array<Scalars['String']['output']>>;
  /** A publicly accessible URL of the rate validation results */
  resultsUrl: Scalars['String']['output'];
  wrongCrownIDs: Array<Scalars['String']['output']>;
};

export type ValidateImportedCrownInvoicesInput = {
  /** A publicly accessible URL of the charges breakdown report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  chargeBreakdownUrl: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
  /** A publicly accessible URL of the open invoices report exported from Crown. Assumes all data has been sanitized (in plaintext format with no spaces in header names). */
  openInvoicesUrl: Scalars['String']['input'];
};

export type ValidateImportedCrownInvoicesOutput = {
  __typename?: 'ValidateImportedCrownInvoicesOutput';
  correctCrownIDs: Array<Scalars['String']['output']>;
  correctInvoiceIDs: Array<Scalars['String']['output']>;
  /** A 2D array of the CSV results of the invoice import validation */
  invoiceCsvResults: Array<Array<Scalars['String']['output']>>;
  /** A publicly accessible URL of the invoice import validation results */
  invoiceResultsUrl: Scalars['String']['output'];
  /** A 2D array of the CSV results of the invoice order import validation */
  orderCsvResults: Array<Array<Scalars['String']['output']>>;
  /** A publicly accessible URL of the invoice order import validation results */
  orderResultsUrl: Scalars['String']['output'];
  wrongCrownIDs: Array<Scalars['String']['output']>;
  wrongInvoiceIDs: Array<Scalars['String']['output']>;
};

export type VehicleTypeCreateInput = {
  capacityNotes?: InputMaybe<Scalars['String']['input']>;
  doorHeight?: InputMaybe<Scalars['Length']['input']>;
  interiorHeightIn?: InputMaybe<Scalars['Float']['input']>;
  interiorLengthIn?: InputMaybe<Scalars['Float']['input']>;
  interiorWidthIn?: InputMaybe<Scalars['Float']['input']>;
  maxHeight?: InputMaybe<Scalars['Length']['input']>;
  maxLength?: InputMaybe<Scalars['Length']['input']>;
  maxVolume?: InputMaybe<Scalars['Volume']['input']>;
  maxWeight?: InputMaybe<Scalars['Mass']['input']>;
  maxWidth?: InputMaybe<Scalars['Length']['input']>;
  name: Scalars['String']['input'];
  packageSpecs?: InputMaybe<Array<VehicleTypePackageSpecUpsertInput>>;
  specialRules?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleTypeEntity = {
  __typename?: 'VehicleTypeEntity';
  capacityNotes?: Maybe<Scalars['String']['output']>;
  doorHeight?: Maybe<Scalars['Length']['output']>;
  interiorHeightIn?: Maybe<Scalars['Float']['output']>;
  interiorLengthIn?: Maybe<Scalars['Float']['output']>;
  interiorWidthIn?: Maybe<Scalars['Float']['output']>;
  maxHeight?: Maybe<Scalars['Length']['output']>;
  maxLength?: Maybe<Scalars['Length']['output']>;
  maxVolume?: Maybe<Scalars['Volume']['output']>;
  maxWeight?: Maybe<Scalars['Mass']['output']>;
  maxWidth?: Maybe<Scalars['Length']['output']>;
  name: Scalars['String']['output'];
  specialRules?: Maybe<Scalars['String']['output']>;
  status: VehicleTypeStatus;
  uuid: Scalars['String']['output'];
  vehicleTypePackageSpecs: Array<VehicleTypePackageSpecEntity>;
};

export type VehicleTypePackageSpecEntity = {
  __typename?: 'VehicleTypePackageSpecEntity';
  /** The ID of the VehicleTypePackageSpecEntity, not VehicleTypeEntity */
  id: Scalars['String']['output'];
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  packageSpec: PackageSpecEntity;
};

export type VehicleTypePackageSpecUpsertInput = {
  /** The number of packages of this spec that the vehicle can carry */
  maxQuantity?: InputMaybe<Scalars['Int']['input']>;
  packageSpecId: Scalars['String']['input'];
};

export enum VehicleTypeStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type VehicleTypeUpdateInput = {
  capacityNotes?: InputMaybe<Scalars['String']['input']>;
  doorHeight?: InputMaybe<Scalars['Length']['input']>;
  interiorHeightIn?: InputMaybe<Scalars['Float']['input']>;
  interiorLengthIn?: InputMaybe<Scalars['Float']['input']>;
  interiorWidthIn?: InputMaybe<Scalars['Float']['input']>;
  maxHeight?: InputMaybe<Scalars['Length']['input']>;
  maxLength?: InputMaybe<Scalars['Length']['input']>;
  maxVolume?: InputMaybe<Scalars['Volume']['input']>;
  maxWeight?: InputMaybe<Scalars['Mass']['input']>;
  maxWidth?: InputMaybe<Scalars['Length']['input']>;
  name: Scalars['String']['input'];
  packageSpecs?: InputMaybe<Array<VehicleTypePackageSpecUpsertInput>>;
  specialRules?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type VehicleTypeUpdateOutput = {
  __typename?: 'VehicleTypeUpdateOutput';
  vehicleType: VehicleTypeEntity;
};

export type VerifyInventoryForStorageUnitInput = {
  /** The UUID of the storage unit to verify inventory for */
  uuid: Scalars['String']['input'];
};

export type VerifyInventoryForStorageUnitOutput = {
  __typename?: 'VerifyInventoryForStorageUnitOutput';
  success: Scalars['Boolean']['output'];
};

export enum ViewPermission {
  Admin = 'ADMIN',
  Edit = 'EDIT',
  View = 'VIEW'
}

export type WaitTimeAccessorialCreateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  waitTimeChargePeriod: Scalars['Float']['input'];
  waitTimeFreeMinutes: Scalars['Float']['input'];
};

export type WaitTimeAccessorialEntity = AccessorialInterface & {
  __typename?: 'WaitTimeAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  /** Rate in dollars */
  rate: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  waitTimeChargePeriod?: Maybe<Scalars['Float']['output']>;
  waitTimeFreeMinutes?: Maybe<Scalars['Float']['output']>;
};

export type WaitTimeAccessorialUpdateInput = {
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
  waitTimeChargePeriod?: InputMaybe<Scalars['Float']['input']>;
  waitTimeFreeMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type WarehouseEmployeeEntity = {
  __typename?: 'WarehouseEmployeeEntity';
  active: Scalars['Boolean']['output'];
  company: CompanyEntity;
  createdAt: Scalars['DateTime']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type WarehouseEntity = {
  __typename?: 'WarehouseEntity';
  address: AddressEntity;
  createdAt: Scalars['DateTime']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  terminal?: Maybe<TerminalEntity>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type WarehouseLocationEntity = {
  __typename?: 'WarehouseLocationEntity';
  createdAt: Scalars['DateTime']['output'];
  location1?: Maybe<Scalars['String']['output']>;
  location2?: Maybe<Scalars['String']['output']>;
  location3?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  warehouse: WarehouseEntity;
};

export enum WarehouseMeasurementUnits {
  Centimeters = 'CENTIMETERS',
  CubicFeet = 'CUBIC_FEET',
  CubicInches = 'CUBIC_INCHES',
  Feet = 'FEET',
  Inches = 'INCHES',
  Kilograms = 'KILOGRAMS',
  Liters = 'LITERS',
  Meters = 'METERS',
  Milliliters = 'MILLILITERS',
  Ounces = 'OUNCES',
  Pounds = 'POUNDS',
  SquareFeet = 'SQUARE_FEET',
  Tonnes = 'TONNES'
}

export type WarehousesInput = {
  companyUuidFilter?: InputMaybe<Scalars['String']['input']>;
};

export enum WebhookPayloadShape {
  Appointment = 'APPOINTMENT',
  InvoicePosted = 'INVOICE_POSTED',
  InvoicePostedPerOrder = 'INVOICE_POSTED_PER_ORDER',
  MasterOrder = 'MASTER_ORDER',
  OrderStatusChange = 'ORDER_STATUS_CHANGE',
  PieceStatus = 'PIECE_STATUS',
  PodDocument = 'POD_DOCUMENT'
}

export enum WebhookTimestampMode {
  StopLocal = 'STOP_LOCAL',
  Utc = 'UTC'
}

export type WeightBasedAccessorialCreateInput = {
  /** accessorial ranges to be created for this accessorial */
  accessorialRangeCreateInputs: Array<AccessorialRangeCreateInput>;
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  ratePerHundredWeight: Scalars['Float']['input'];
};

export type WeightBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'WeightBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  accessorialRanges?: Maybe<Array<AccessorialRangeEntity>>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  maximumCharge?: Maybe<Scalars['Float']['output']>;
  minimumCharge?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  ratePerHundredWeight: Scalars['Float']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type WeightBasedAccessorialUpdateInput = {
  accessorialRangeUpdateInputs?: InputMaybe<Array<AccessorialRangeUpdateInput>>;
  maximumCharge?: InputMaybe<Scalars['Float']['input']>;
  minimumCharge?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  ratePerHundredWeight?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type WeightBreakArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
};

export type WeightBreakBracketEntity = {
  __typename?: 'WeightBreakBracketEntity';
  contributionDollarsUsd?: Maybe<Scalars['Float']['output']>;
  contributionPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  contributionRatio?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
  maxLbs?: Maybe<Scalars['Int']['output']>;
  minLbs: Scalars['Int']['output'];
  revenuePerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  revenueUsd: Scalars['Float']['output'];
  shipmentCount: Scalars['Int']['output'];
  status?: Maybe<WeightBreakStatus>;
  varCostPctOfRevenue?: Maybe<Scalars['Float']['output']>;
  variableCostPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  variableCostUsd?: Maybe<Scalars['Float']['output']>;
};

export type WeightBreakReportEntity = {
  __typename?: 'WeightBreakReportEntity';
  brackets: Array<WeightBreakBracketEntity>;
  costBasis: CostBasis;
  estimatedCostInputs: Array<CostInputEstimatedMonthEntity>;
  hasCostAssumptions: Scalars['Boolean']['output'];
  missingCostInputs: Array<Scalars['String']['output']>;
  overallContributionPerShipmentUsd?: Maybe<Scalars['Float']['output']>;
  overallContributionRatio?: Maybe<Scalars['Float']['output']>;
  overallVarCostPctOfRevenue?: Maybe<Scalars['Float']['output']>;
  sweetSpotLabel?: Maybe<Scalars['String']['output']>;
  totalContributionDollarsUsd?: Maybe<Scalars['Float']['output']>;
  totalRevenueUsd: Scalars['Float']['output'];
  totalShipmentCount: Scalars['Int']['output'];
  totalVariableCostUsd?: Maybe<Scalars['Float']['output']>;
  upsideDownFromLabel?: Maybe<Scalars['String']['output']>;
};

/** Weight bracket standing relative to the carrier average variable cost percent used by the Intelligence Board. */
export enum WeightBreakStatus {
  Losing = 'LOSING',
  SweetSpot = 'SWEET_SPOT',
  UpsideDown = 'UPSIDE_DOWN'
}

export enum WeightUnits {
  Kilograms = 'KILOGRAMS',
  Pounds = 'POUNDS'
}

export type WhiteLabelCompanyEntity = {
  __typename?: 'WhiteLabelCompanyEntity';
  companyLandscapeLogoUrl?: Maybe<Scalars['String']['output']>;
  companySquareLogoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type WorkOrderEquipment = {
  __typename?: 'WorkOrderEquipment';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type WorkOrderListInput = {
  date: Scalars['DateTime']['input'];
  mode: FreightScanningV2ScanMode;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone identifier of the requesting user (e.g. "America/New_York"). When provided, the backend uses this timezone to compute day boundaries for date filters so that results reflect the calendar date in the user's local time rather than UTC. */
  userTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type WorkOrderListItem = {
  __typename?: 'WorkOrderListItem';
  doorsClosedAt?: Maybe<Scalars['DateTime']['output']>;
  equipment?: Maybe<WorkOrderEquipment>;
  name: Scalars['String']['output'];
  orders: Array<WorkOrderOrder>;
  progress: WorkOrderProgress;
  runTimes: WorkOrderRunTimes;
  scheduledTime?: Maybe<Scalars['DateTime']['output']>;
  type: WorkOrderType;
  uuid: Scalars['String']['output'];
};

export type WorkOrderOrder = {
  __typename?: 'WorkOrderOrder';
  billingPartyContactDisplayName?: Maybe<Scalars['String']['output']>;
  destinationTerminalCode?: Maybe<Scalars['String']['output']>;
  finalDestinationAddress?: Maybe<FreightScanningV2AddressInfo>;
  hawb?: Maybe<Scalars['String']['output']>;
  loadSequence?: Maybe<Scalars['Int']['output']>;
  mawb?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originTerminalCode?: Maybe<Scalars['String']['output']>;
  packages: Array<WorkOrderPackage>;
  progress: WorkOrderProgress;
  tags: Array<TagEntity>;
  uuid: Scalars['String']['output'];
};

export type WorkOrderPackage = {
  __typename?: 'WorkOrderPackage';
  description?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<Scalars['String']['output']>;
  pieces: Array<WorkOrderPiece>;
  quantity: Scalars['Int']['output'];
  type?: Maybe<PackageType>;
  uuid: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type WorkOrderPiece = {
  __typename?: 'WorkOrderPiece';
  damagedAt?: Maybe<Scalars['DateTime']['output']>;
  damagedNote?: Maybe<Scalars['String']['output']>;
  documents: Array<FreightScanningV2DocumentInfo>;
  isMisrouted: Scalars['Boolean']['output'];
  isOverage: Scalars['Boolean']['output'];
  isPieceCompletedForMode: Scalars['Boolean']['output'];
  isShortage: Scalars['Boolean']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  refusedAt?: Maybe<Scalars['DateTime']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  scannedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  terminal?: Maybe<FreightScanningV2TerminalInfo>;
  uuid?: Maybe<Scalars['String']['output']>;
  warehouse?: Maybe<FreightScanningV2WarehouseInfo>;
  warehouseLocation?: Maybe<FreightScanningV2WarehouseLocationInfo>;
};

export type WorkOrderProgress = {
  __typename?: 'WorkOrderProgress';
  current: Scalars['Int']['output'];
  expected: Scalars['Int']['output'];
};

export type WorkOrderRunTimes = {
  __typename?: 'WorkOrderRunTimes';
  destinationArrivalActual?: Maybe<Scalars['DateTime']['output']>;
  destinationArrivalEstimated?: Maybe<Scalars['DateTime']['output']>;
  destinationArrivalEstimatedAsOf?: Maybe<Scalars['DateTime']['output']>;
  originDepartureActual?: Maybe<Scalars['DateTime']['output']>;
  originDepartureEstimated?: Maybe<Scalars['DateTime']['output']>;
  originDepartureInferred?: Maybe<Scalars['DateTime']['output']>;
};

/** Type of work order - either a delivery route or line haul manifest */
export enum WorkOrderType {
  LineHaul = 'LINE_HAUL',
  Route = 'ROUTE'
}

export type XyTransformEntity = {
  __typename?: 'XyTransformEntity';
  rotation: Scalars['Float']['output'];
  xMin: Scalars['Float']['output'];
  xScale: Scalars['Float']['output'];
  xTranslation: Scalars['Float']['output'];
  yMin: Scalars['Float']['output'];
  yScale: Scalars['Float']['output'];
  yTranslation: Scalars['Float']['output'];
};

export type ZipcodeOptionEntity = {
  __typename?: 'ZipcodeOptionEntity';
  zipcode: Scalars['String']['output'];
};

export type ZoneBasedAccessorialChargeGroupArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  zoneBasedAccessorialChargeGroupCreateInput?: InputMaybe<ZoneBasedAccessorialChargeGroupCreateInput>;
  /** Pass this field in to update an array item */
  zoneBasedAccessorialChargeGroupUpdateInput?: InputMaybe<ZoneBasedAccessorialChargeGroupUpdateInput>;
};

export type ZoneBasedAccessorialChargeGroupCreateInput = {
  name: Scalars['String']['input'];
};

export type ZoneBasedAccessorialChargeGroupEntity = {
  __typename?: 'ZoneBasedAccessorialChargeGroupEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ZoneBasedAccessorialChargeGroupUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ZoneBasedAccessorialCreateInput = {
  name: Scalars['String']['input'];
  zoneBasedChargeGroups: Array<ZoneBasedAccessorialChargeGroupCreateInput>;
  zoneBasedMatrixItems: Array<ZoneBasedAccessorialMatrixItemCreateInput>;
  zones: Array<ZoneBasedAccessorialZoneCreateInput>;
};

export type ZoneBasedAccessorialEntity = AccessorialInterface & {
  __typename?: 'ZoneBasedAccessorialEntity';
  accessorialDateRangeConfigs: Array<AccessorialDateRangeConfigEntity>;
  chargeGroups: Array<ZoneBasedAccessorialChargeGroupEntity>;
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<ContactEntity>;
  contacts: Array<ContactEntity>;
  ediCode?: Maybe<Scalars['String']['output']>;
  enableQuickAdd: Scalars['Boolean']['output'];
  fuelProfile?: Maybe<FuelProfileEntity>;
  fuelProfileUuid?: Maybe<Scalars['String']['output']>;
  generalLedgerCode?: Maybe<GeneralLedgerCodeEntity>;
  invoiceDisplayName?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAuthoCodeRequired: Scalars['Boolean']['output'];
  isDefaultGlobalSpecial: Scalars['Boolean']['output'];
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  matchingCustomerAccessorials?: Maybe<Array<AccessorialUnion>>;
  matchingGlobalAccessorial?: Maybe<AccessorialUnion>;
  matrixItems: Array<ZoneBasedAccessorialMatrixItemEntity>;
  name: Scalars['String']['output'];
  percentForSettlement?: Maybe<Scalars['Float']['output']>;
  qboItemId?: Maybe<Scalars['String']['output']>;
  quickbooksDesktopAccessorialId?: Maybe<Scalars['String']['output']>;
  quickbooksFileMappingChargeName?: Maybe<Scalars['String']['output']>;
  quickbooksMappingId: Scalars['String']['output'];
  terminal?: Maybe<TerminalEntity>;
  terminalUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccessorialType>;
  /** Invoices QuickBooks has not accepted yet that carry a charge from this accessorial. Changing the mapping affects these and no others. */
  unsyncedInvoiceCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  zones: Array<ZoneBasedAccessorialZoneEntity>;
};

export type ZoneBasedAccessorialMatrixItemArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  matrixItemCreateInput?: InputMaybe<ZoneBasedAccessorialMatrixItemCreateInput>;
  /** Pass this field in to update an array item */
  matrixItemUpdateInput?: InputMaybe<ZoneBasedAccessorialMatrixItemUpdateInput>;
};

export type ZoneBasedAccessorialMatrixItemCreateInput = {
  chargeGroupName: Scalars['String']['input'];
  /** Accepts rate as a $ float with two decimal places */
  rate: Scalars['Float']['input'];
  zoneName: Scalars['String']['input'];
};

export type ZoneBasedAccessorialMatrixItemEntity = {
  __typename?: 'ZoneBasedAccessorialMatrixItemEntity';
  chargeGroupUuid: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
  zoneUuid: Scalars['String']['output'];
};

export type ZoneBasedAccessorialMatrixItemUpdateInput = {
  rate?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['String']['input'];
};

export type ZoneBasedAccessorialUpdateInput = {
  chargeGroupUpdates?: InputMaybe<Array<ZoneBasedAccessorialChargeGroupArrayUpdateInput>>;
  matrixItemsArrayUpdateInput?: InputMaybe<Array<ZoneBasedAccessorialMatrixItemArrayUpdateInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  quickbooksMappingId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  zoneArrayUpdates?: InputMaybe<Array<ZoneBasedAccessorialZoneArrayUpdateInput>>;
};

export type ZoneBasedAccessorialZoneArrayUpdateInput = {
  /** Pass this field in to create a new array item */
  zoneBasedAccessorialZoneCreateInput?: InputMaybe<ZoneBasedAccessorialZoneCreateInput>;
  /** Pass this field in to update an array item */
  zoneBasedAccessorialZoneUpdateInput?: InputMaybe<ZoneBasedAccessorialZoneUpdateInput>;
};

export type ZoneBasedAccessorialZoneCreateInput = {
  name: Scalars['String']['input'];
};

export type ZoneBasedAccessorialZoneEntity = {
  __typename?: 'ZoneBasedAccessorialZoneEntity';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ZoneBasedAccessorialZoneUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type AblyTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type AblyTokenQuery = { __typename?: 'Query', ablyToken: { __typename?: 'AblyTokenOutput', token?: string | null } };

export type ActiveAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAgentsQuery = { __typename?: 'Query', activeAgents: Array<{ __typename?: 'AgentFieldsEntity', uuid: string, name: string }> };

export type CompanyFragment = { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, qboFreightItemId?: string | null, qboFuelItemId?: string | null, qboLineHaulItemId?: string | null, qboDefaultIncomeAccountId?: string | null, qboDefaultTaxCodeId?: string | null, qboDefaultClassId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopRecoveryId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, enabledExternalRatingProviders: Array<ExternalRatingProvider>, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, quoteAgentEnabled: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, showAccessorialsToDrivers: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, pieceTransferableStatuses: Array<PieceStatus>, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } };

export type ContactForAutocompleteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactForAutocompleteQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', isPrepaidOnly: boolean, displayName: string, uuid: string, isActive: boolean, isOverCreditLimit: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string, isActive: boolean, isOverCreditLimit: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean } };

export type ContactPackageSpecsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactPackageSpecsQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', useCustomPackageSpecs: boolean, defaultFreightClass?: FreightClass | null, uuid: string, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, freightClass?: FreightClass | null }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string } };

export type ContactsForAutocompleteQueryVariables = Exact<{
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactsForAutocompleteQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', isPrepaidOnly: boolean, displayName: string, uuid: string, isActive: boolean } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string, isActive: boolean }> };

export type DispatchableDriversQueryVariables = Exact<{
  getDispatchableDriversInput: GetDispatchableDriversInput;
  canReadIntelligenceBoard?: Scalars['Boolean']['input'];
}>;


export type DispatchableDriversQuery = { __typename?: 'Query', dispatchableDrivers: { __typename?: 'GetDispatchableDriversOutput', companyDrivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null, driverType?: DriverType | null, driverPayType?: DriverPayType | null, perMileRate?: number | null, percentGrossRevenueRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, terminal?: { __typename?: 'TerminalEntity', name: string } | null }>, agents: Array<{ __typename?: 'DispatchableAgentEntity', uuid: string, name: string, defaultDriver: { __typename?: 'DriverEntity', uuid: string, driverType?: DriverType | null } }> } };

export type DriverMinimalQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
  canReadIntelligenceBoard?: Scalars['Boolean']['input'];
}>;


export type DriverMinimalQuery = { __typename?: 'Query', driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverType?: DriverType | null, driverPayType?: DriverPayType | null, perMileRate?: number | null, percentGrossRevenueRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', name: string } | null } };

export type LoginMutationVariables = Exact<{
  loginInputData: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginOutput', status: LoginStatus, kind?: string | null, fullAccessUser?: { __typename?: 'UserEntity', uuid: string, company: { __typename?: 'CompanyEntity', purchasedProductOfferings: Array<PalletProductOffering> } } | null, thirdPartyUser?: { __typename?: 'ThirdPartyUserEntity', uuid: string } | null, clientChallenge?: Array<{ __typename?: 'ClientChallengeEntity', uuid: string, name: string, squareLogoUrl?: string | null }> | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type MeAsThirdPartyUserForAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type MeAsThirdPartyUserForAuthQuery = { __typename?: 'Query', meAsThirdPartyUser?: { __typename?: 'ThirdPartyUserEntity', email: string, uuid: string, contacts: Array<{ __typename?: 'CustomerContactEntity', company: { __typename?: 'CompanyEntity', uuid: string, name: string } } | { __typename?: 'ThirdPartyContactEntity', company: { __typename?: 'CompanyEntity', uuid: string, name: string } }> } | null };

export type MeAsThirdPartyUserQueryVariables = Exact<{ [key: string]: never; }>;


export type MeAsThirdPartyUserQuery = { __typename?: 'Query', meAsThirdPartyUser?: { __typename?: 'ThirdPartyUserEntity', email: string, uuid: string, contacts: Array<{ __typename?: 'CustomerContactEntity', enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, uuid: string, displayName: string, showChargesOnCustomerPortal: boolean, isPrepaidOnly: boolean, company: { __typename?: 'CompanyEntity', uuid: string, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, isCourier?: boolean | null, defaultMeasurementUnits: MeasurementUnits, productionCompany?: ProductionCompany | null, name: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerPortalConfiguration?: { __typename?: 'CustomerPortalConfigurationEntity', defaultDimFactor?: number | null, terminalsEnabled: boolean, logisticsSectionEnabled: boolean } | null } } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, showChargesOnCustomerPortal: boolean, isPrepaidOnly: boolean, company: { __typename?: 'CompanyEntity', uuid: string, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, isCourier?: boolean | null, defaultMeasurementUnits: MeasurementUnits, productionCompany?: ProductionCompany | null, name: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerPortalConfiguration?: { __typename?: 'CustomerPortalConfigurationEntity', defaultDimFactor?: number | null, terminalsEnabled: boolean, logisticsSectionEnabled: boolean } | null } }> } | null };

export type MeForAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type MeForAuthQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', email: string, uuid: string, company: { __typename?: 'CompanyEntity', uuid: string, name: string } } | null };

export type MarkTutorialSeenMutationVariables = Exact<{
  tutorialId: TutorialId;
}>;


export type MarkTutorialSeenMutation = { __typename?: 'Mutation', markTutorialSeen: Array<TutorialId> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', email: string, phoneNumber?: string | null, name?: string | null, uuid: string, createdAt: any, reportsEmail?: string | null, useMinimizedAppointmentTime: boolean, routeCardWidth: number, numberOfStops: number, redirectIsAlertedOnFirstSave?: boolean | null, redirectIsAlertedOnOpenOrder?: boolean | null, arrangeStopsAndRoutesVertically: boolean, seenTutorials?: Array<TutorialId> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } | null, company: { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, qboFreightItemId?: string | null, qboFuelItemId?: string | null, qboLineHaulItemId?: string | null, qboDefaultIncomeAccountId?: string | null, qboDefaultTaxCodeId?: string | null, qboDefaultClassId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopRecoveryId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, enabledExternalRatingProviders: Array<ExternalRatingProvider>, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, quoteAgentEnabled: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, showAccessorialsToDrivers: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, pieceTransferableStatuses: Array<PieceStatus>, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } } } | null };

export type MeRolePermissionFragment = { __typename?: 'PermissionEntity', permissionResource: PermissionResource, accessLevel: AccessLevel };

export type MeRoleFragment = { __typename?: 'RoleEntity', uuid: string, name: string, permissions: Array<{ __typename?: 'PermissionEntity', permissionResource: PermissionResource, accessLevel: AccessLevel }> };

export type MeFragment = { __typename?: 'UserEntity', email: string, phoneNumber?: string | null, name?: string | null, uuid: string, createdAt: any, reportsEmail?: string | null, useMinimizedAppointmentTime: boolean, routeCardWidth: number, numberOfStops: number, redirectIsAlertedOnFirstSave?: boolean | null, redirectIsAlertedOnOpenOrder?: boolean | null, arrangeStopsAndRoutesVertically: boolean, seenTutorials?: Array<TutorialId> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } | null, company: { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, qboFreightItemId?: string | null, qboFuelItemId?: string | null, qboLineHaulItemId?: string | null, qboDefaultIncomeAccountId?: string | null, qboDefaultTaxCodeId?: string | null, qboDefaultClassId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopRecoveryId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, enabledExternalRatingProviders: Array<ExternalRatingProvider>, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, quoteAgentEnabled: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, showAccessorialsToDrivers: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, pieceTransferableStatuses: Array<PieceStatus>, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } } };

export type OrderFormFieldsFragment = { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean };

export type UserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRolesQuery = { __typename?: 'Query', userRoles: Array<{ __typename?: 'RoleEntity', uuid: string, name: string, permissions: Array<{ __typename?: 'PermissionEntity', permissionResource: PermissionResource, accessLevel: AccessLevel }> }> };

export type TableFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type TableFieldsQuery = { __typename?: 'Query', tableFields?: { __typename?: 'TableFieldsEntity', orderTableFields: Array<OrderTableField>, billingReviewOrderTableFields: Array<OrderTableField>, linehaulDispatchTableFields: Array<LinehaulDispatchTableField>, dispatchTableFields: Array<DispatchTableField>, routeCardStopTableFields: Array<DispatchTableField>, dispatchTableColumnWidths?: Array<{ __typename?: 'TableColumnWidthEntity', colId: string, width: number }> | null, ordersTableColumnWidths?: Array<{ __typename?: 'TableColumnWidthEntity', colId: string, width: number }> | null, invoicesTableColumnWidths?: Array<{ __typename?: 'TableColumnWidthEntity', colId: string, width: number }> | null, routeCardStopTableColumnWidths?: Array<{ __typename?: 'TableColumnWidthEntity', colId: string, width: number }> | null } | null };

export type TariffChainFragment = { __typename?: 'TariffChainEntity', id: string, name: string, tariffGroupType: TariffGroupType };

export type TariffChainsQueryVariables = Exact<{
  findTariffChainsInput: FindTariffChainsInput;
}>;


export type TariffChainsQuery = { __typename?: 'Query', tariffChains: Array<{ __typename?: 'TariffChainEntity', id: string, name: string, tariffGroupType: TariffGroupType }> };

export type TemplateAddressesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type TemplateAddressesQuery = { __typename?: 'Query', templateAddresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, preventCoordRecompute?: boolean | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null, iataCode?: string | null, associatedContact?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null }> };

export type WhiteLabelCompanyQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type WhiteLabelCompanyQuery = { __typename?: 'Query', whiteLabelCompany?: { __typename?: 'WhiteLabelCompanyEntity', uuid: string, companyLandscapeLogoUrl?: string | null, companySquareLogoUrl?: string | null, name: string } | null };

export type AccessorialRangeFragment = { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number };

export type AutoApplyAccessorialConfigFragment = { __typename?: 'AutoApplyAccessorialConfigEntity', uuid: string, ruleType: AutoApplyAccessorialRuleType, stopType?: PickupOrDelivery | null, zipCodes: Array<string>, accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'PercentageAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, percentageBasis?: AccessorialPercentageBasis | null, minimumCharge?: number | null, maximumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StorageDaysAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, maximumCharge?: number | null, minimumCharge?: number | null, storageDaysFreeDays?: number | null, storageDaysExcludeWeekends?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }>, addresses: Array<{ __typename?: 'AutoApplyAccessorialConfigAddressEntity', uuid: string, name?: string | null, line1: string, line2?: string | null, city: string, state: string, zip: string, country?: string | null }>, tariffZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string, tariffZoneGroupId?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string, name: string, tariffZones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }> }> } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, tag?: { __typename?: 'TagEntity', uuid: string, value: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contactsToExcludeFromRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, contactsToIncludeWithRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null };

export type AutoApplyAccessorialConfigQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
  specialWindowsDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type AutoApplyAccessorialConfigQuery = { __typename?: 'Query', autoApplyAccessorialConfig?: { __typename?: 'AutoApplyAccessorialConfigEntity', uuid: string, ruleType: AutoApplyAccessorialRuleType, stopType?: PickupOrDelivery | null, zipCodes: Array<string>, accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'PercentageAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, percentageBasis?: AccessorialPercentageBasis | null, minimumCharge?: number | null, maximumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StorageDaysAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, maximumCharge?: number | null, minimumCharge?: number | null, storageDaysFreeDays?: number | null, storageDaysExcludeWeekends?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }>, addresses: Array<{ __typename?: 'AutoApplyAccessorialConfigAddressEntity', uuid: string, name?: string | null, line1: string, line2?: string | null, city: string, state: string, zip: string, country?: string | null }>, tariffZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string, tariffZoneGroupId?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string, name: string, tariffZones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }> }> } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, tag?: { __typename?: 'TagEntity', uuid: string, value: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contactsToExcludeFromRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, contactsToIncludeWithRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null } | null };

export type AutoApplyAccessorialConfigsQueryVariables = Exact<{
  specialWindowsDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type AutoApplyAccessorialConfigsQuery = { __typename?: 'Query', autoApplyAccessorialConfigs?: Array<{ __typename?: 'AutoApplyAccessorialConfigEntity', uuid: string, ruleType: AutoApplyAccessorialRuleType, stopType?: PickupOrDelivery | null, zipCodes: Array<string>, accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'PercentageAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, percentageBasis?: AccessorialPercentageBasis | null, minimumCharge?: number | null, maximumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StorageDaysAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, maximumCharge?: number | null, minimumCharge?: number | null, storageDaysFreeDays?: number | null, storageDaysExcludeWeekends?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }>, addresses: Array<{ __typename?: 'AutoApplyAccessorialConfigAddressEntity', uuid: string, name?: string | null, line1: string, line2?: string | null, city: string, state: string, zip: string, country?: string | null }>, tariffZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string, tariffZoneGroupId?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string, name: string, tariffZones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }> }> } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, tag?: { __typename?: 'TagEntity', uuid: string, value: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contactsToExcludeFromRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, contactsToIncludeWithRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null }> | null };

export type CreateAutoApplyAccessorialConfigMutationVariables = Exact<{
  createAutoApplyAccessorialConfigInput: CreateAutoApplyAccessorialConfigInput;
  specialWindowsDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CreateAutoApplyAccessorialConfigMutation = { __typename?: 'Mutation', createAutoApplyAccessorialConfig: { __typename?: 'AutoApplyAccessorialConfigEntity', uuid: string, ruleType: AutoApplyAccessorialRuleType, stopType?: PickupOrDelivery | null, zipCodes: Array<string>, accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'PercentageAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, percentageBasis?: AccessorialPercentageBasis | null, minimumCharge?: number | null, maximumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StorageDaysAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, maximumCharge?: number | null, minimumCharge?: number | null, storageDaysFreeDays?: number | null, storageDaysExcludeWeekends?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }>, addresses: Array<{ __typename?: 'AutoApplyAccessorialConfigAddressEntity', uuid: string, name?: string | null, line1: string, line2?: string | null, city: string, state: string, zip: string, country?: string | null }>, tariffZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string, tariffZoneGroupId?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string, name: string, tariffZones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }> }> } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, tag?: { __typename?: 'TagEntity', uuid: string, value: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contactsToExcludeFromRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, contactsToIncludeWithRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null } };

export type DeleteAutoApplyAccessorialConfigMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteAutoApplyAccessorialConfigMutation = { __typename?: 'Mutation', deleteAutoApplyAccessorialConfig: boolean };

export type SelectSpecialAccessorialQueryVariables = Exact<{
  selectSpecialAccessorialInput: SelectSpecialAccessorialInput;
}>;


export type SelectSpecialAccessorialQuery = { __typename?: 'Query', selectSpecialAccessorial: { __typename?: 'SelectSpecialAccessorialOutput', accessorialUuid?: string | null, accessorialName?: string | null, tariffZoneUuid?: string | null, chargeGroupUuid?: string | null, matrixItemUuid?: string | null } };

export type UpdateAutoApplyAccessorialConfigMutationVariables = Exact<{
  updateAutoApplyAccessorialConfigInput: UpdateAutoApplyAccessorialConfigInput;
  specialWindowsDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateAutoApplyAccessorialConfigMutation = { __typename?: 'Mutation', updateAutoApplyAccessorialConfig: { __typename?: 'AutoApplyAccessorialConfigEntity', uuid: string, ruleType: AutoApplyAccessorialRuleType, stopType?: PickupOrDelivery | null, zipCodes: Array<string>, accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'PercentageAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, percentageBasis?: AccessorialPercentageBasis | null, minimumCharge?: number | null, maximumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StorageDaysAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, maximumCharge?: number | null, minimumCharge?: number | null, storageDaysFreeDays?: number | null, storageDaysExcludeWeekends?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }>, addresses: Array<{ __typename?: 'AutoApplyAccessorialConfigAddressEntity', uuid: string, name?: string | null, line1: string, line2?: string | null, city: string, state: string, zip: string, country?: string | null }>, tariffZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string, tariffZoneGroupId?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string, name: string, tariffZones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }> }> } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, tag?: { __typename?: 'TagEntity', uuid: string, value: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contactsToExcludeFromRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, contactsToIncludeWithRule?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null } };

export type AddressWithContactFragment = { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, preventCoordRecompute?: boolean | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null, iataCode?: string | null, associatedContact?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null };

export type AddressFragment = { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null };

export type CoordinatesForAddressQueryVariables = Exact<{
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
}>;


export type CoordinatesForAddressQuery = { __typename?: 'Query', coordinatesForAddress: { __typename?: 'CoordinatesForAddressEntity', latitude?: number | null, longitude?: number | null, quality: GeocodeQuality } };

export type GetCityAndStateOptionsFromZipcodeFragment = { __typename?: 'CityAndStateOptionEntity', city: string, state: string };

export type GetCityAndStateOptionsFromZipcodeQueryVariables = Exact<{
  getCityAndStateFromZipcodeInput: GetCityAndStateOptionsFromZipcodeInput;
}>;


export type GetCityAndStateOptionsFromZipcodeQuery = { __typename?: 'Query', getCityAndStateOptionsFromZipcode: { __typename?: 'GetCityAndStateOptionsFromZipcodeOutput', zipcode: string, citiesAndStates: Array<{ __typename?: 'CityAndStateOptionEntity', city: string, state: string }> } };

export type GetZipcodeOptionsFromCityAndStateQueryVariables = Exact<{
  getZipcodeFromCityAndStateInput: GetZipcodeOptionsFromCityAndStateInput;
}>;


export type GetZipcodeOptionsFromCityAndStateQuery = { __typename?: 'Query', getZipcodeOptionsFromCityAndState: { __typename?: 'GetZipcodeOptionsFromCityAndStateOutput', city: string, state: string, zipcodes: Array<{ __typename?: 'ZipcodeOptionEntity', zipcode: string }> } };

export type GetZipcodeOptionsFromCityAndStateFragment = { __typename?: 'ZipcodeOptionEntity', zipcode: string };

export type ManualStandardStopTypeForAddressQueryVariables = Exact<{
  input: ManualStandardStopTypeForAddressInput;
}>;


export type ManualStandardStopTypeForAddressQuery = { __typename?: 'Query', manualStandardStopTypeForAddress?: StandardStopType | null };

export type AirportInfoQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AirportInfoQuery = { __typename?: 'Query', airportInfo: { __typename?: 'AirportInfoEntity', uuid: string, iataCode?: string | null, terminal: string, isArchived: boolean, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } };

export type AppointmentStatusHistoryQueryVariables = Exact<{
  stopUuid: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AppointmentStatusHistoryQuery = { __typename?: 'Query', appointmentStatusHistory: { __typename?: 'AppointmentStatusHistoryConnection', edges: Array<{ __typename?: 'AppointmentStatusHistoryEdge', cursor: string, node: { __typename?: 'AppointmentStatusHistoryEntity', createdAt: any, fromStatus?: AppointmentStatus | null, toStatus: AppointmentStatus, actor: AppointmentActor, userUuid?: string | null, userDisplayName?: string | null, reason?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type DispatchAppointmentSummaryQueryVariables = Exact<{
  deliveryDateFilter?: InputMaybe<DateFilterStartEnd>;
  oncomingWindow?: InputMaybe<DateFilterStartEnd>;
}>;


export type DispatchAppointmentSummaryQuery = { __typename?: 'Query', dispatchAppointmentSummary: { __typename?: 'DispatchAppointmentSummaryEntity', all: number, unconfirmed: number, oncoming: number, noContact: number, awaitingCustomerBooking: number } };

export type DispatchAppointmentFragment = { __typename?: 'DispatchAppointmentEntity', uuid: string, orderUuid?: string | null, orderName: string, hawb?: string | null, customerName: string, stopType?: StopType | null, status: DispatchAppointmentStatus, committedWindowStart?: any | null, committedWindowEnd?: any | null, deliveryDate?: any | null, projectedArrival?: any | null, onRoute: boolean, addressLine?: string | null, city?: string | null, zip?: string | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, terminalName?: string | null, terminalUuid?: string | null, customerBookingLinkSentAt?: any | null, customerBookingLinkOpenedAt?: any | null };

export type DispatchAppointmentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDateFilter?: InputMaybe<DateFilterStartEnd>;
  oncomingWindow?: InputMaybe<DateFilterStartEnd>;
  preset?: InputMaybe<DispatchAppointmentPreset>;
  statuses?: InputMaybe<Array<DispatchAppointmentStatus> | DispatchAppointmentStatus>;
  stopTypes?: InputMaybe<Array<StopType> | StopType>;
  contactChannel?: InputMaybe<DispatchAppointmentContactChannel>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<DispatchAppointmentSortField>;
  sortDirection?: InputMaybe<SortDirection>;
}>;


export type DispatchAppointmentsQuery = { __typename?: 'Query', dispatchAppointments: { __typename?: 'DispatchAppointmentConnection', totalCount?: number | null, edges: Array<{ __typename?: 'DispatchAppointmentEdge', cursor: string, node: { __typename?: 'DispatchAppointmentEntity', uuid: string, orderUuid?: string | null, orderName: string, hawb?: string | null, customerName: string, stopType?: StopType | null, status: DispatchAppointmentStatus, committedWindowStart?: any | null, committedWindowEnd?: any | null, deliveryDate?: any | null, projectedArrival?: any | null, onRoute: boolean, addressLine?: string | null, city?: string | null, zip?: string | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, terminalName?: string | null, terminalUuid?: string | null, customerBookingLinkSentAt?: any | null, customerBookingLinkOpenedAt?: any | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type TransitionAppointmentMutationVariables = Exact<{
  transitionAppointmentInput: TransitionAppointmentInput;
}>;


export type TransitionAppointmentMutation = { __typename?: 'Mutation', transitionAppointment: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'TransitionAppointmentSuccessOutput', stopUuid: string, status: AppointmentStatus } };

export type AppointmentConfirmationInfoQueryVariables = Exact<{
  stopUuid: Scalars['String']['input'];
}>;


export type AppointmentConfirmationInfoQuery = { __typename?: 'Query', appointmentConfirmationInfo: { __typename?: 'AppointmentConfirmationInfoOutput', appointmentDateTime: string, appointmentConfirmed: boolean, rescheduleRequested: boolean, stopType?: StopType | null } };

export type AppointmentFragment = { __typename?: 'StandardStopEntity', uuid: string, standardStopType?: StandardStopType | null, appointmentRequired: boolean, textResponses?: string | null, appointmentTime?: any | null, appointmentManuallyConfirmed: boolean, formattedCallMessage?: string | null, endAppointmentTime?: any | null, shipmentTotalWeight: number, shipmentTotalVolume: number, lastAppointmentTextTime?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentCallStatus?: AppointmentCallStatus | null, contactAttemptReportedForCurrentCall: boolean, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, phone?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null, address: { __typename?: 'AddressEntity', line1: string, city: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, shipmentConsigneeAddress: { __typename?: 'AddressEntity', name: string }, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } } } | null };

export type GetAppointmentsQueryVariables = Exact<{
  deliveryDate: Scalars['DateTime']['input'];
}>;


export type GetAppointmentsQuery = { __typename?: 'Query', appointments: Array<{ __typename?: 'StandardStopEntity', uuid: string, standardStopType?: StandardStopType | null, appointmentRequired: boolean, textResponses?: string | null, appointmentTime?: any | null, appointmentManuallyConfirmed: boolean, formattedCallMessage?: string | null, endAppointmentTime?: any | null, shipmentTotalWeight: number, shipmentTotalVolume: number, lastAppointmentTextTime?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentCallStatus?: AppointmentCallStatus | null, contactAttemptReportedForCurrentCall: boolean, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, phone?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null, address: { __typename?: 'AddressEntity', line1: string, city: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, shipmentConsigneeAddress: { __typename?: 'AddressEntity', name: string }, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } } } | null }> };

export type BulkConfirmAppointmentsMutationVariables = Exact<{
  bulkConfirmAppointmentsArgs: BulkConfirmAppointmentsArgs;
}>;


export type BulkConfirmAppointmentsMutation = { __typename?: 'Mutation', bulkConfirmAppointments: number };

export type BulkChangeCallStatusMutationVariables = Exact<{
  changeCallStatusArgs: BulkChangeCallStatusArgs;
}>;


export type BulkChangeCallStatusMutation = { __typename?: 'Mutation', bulkChangeCallStatus: number };

export type BulkUnconfirmAppointmentsMutationVariables = Exact<{
  bulkUnconfirmAppointmentsArgs: BulkUnconfirmAppointmentsArgs;
}>;


export type BulkUnconfirmAppointmentsMutation = { __typename?: 'Mutation', bulkUnconfirmAppointments: number };

export type CallStopsMutationVariables = Exact<{
  callStopsInput: CallStopsInput;
}>;


export type CallStopsMutation = { __typename?: 'Mutation', callStops: Array<{ __typename?: 'StandardStopEntity', uuid: string }> };

export type GetDefaultTextsQueryVariables = Exact<{
  generateDefaultAppointmentTextsArgs: GenerateDefaultAppointmentTextsArgs;
}>;


export type GetDefaultTextsQuery = { __typename?: 'Query', generateDefaultAppointmentTexts: Array<{ __typename?: 'DefaultAppointmentTextOutput', appointmentUuid: string, message?: string | null }> };

export type MakeAppointmentConfirmationDecisionMutationVariables = Exact<{
  input: MakeAppointmentConfirmationDecisionInput;
}>;


export type MakeAppointmentConfirmationDecisionMutation = { __typename?: 'Mutation', makeAppointmentConfirmationDecision: { __typename: 'AppointmentConfirmationInfoOutput', appointmentDateTime: string, appointmentConfirmed: boolean, rescheduleRequested: boolean } | { __typename: 'MutationErrorOutput', message: string } };

export type QueueAppointmentTextsMutationVariables = Exact<{
  queueAppointmentTextsArgs: QueueAppointmentTextsArgs;
}>;


export type QueueAppointmentTextsMutation = { __typename?: 'Mutation', queueAppointmentTexts: { __typename?: 'QueueAppointmentTextsOutput', sentCount: number, skippedNoContactCount: number, skippedMissingDetailsCount: number, skippedLandlineCount: number, suppressedCount: number, failedCount: number } };

export type RecordContactAttemptedMutationVariables = Exact<{
  recordContactAttemptedArgs: RecordContactAttemptedArgs;
}>;


export type RecordContactAttemptedMutation = { __typename?: 'Mutation', recordContactAttempted: number };

export type RemoveStopsFromRoutesMutationVariables = Exact<{
  removeStopsFromRoutesInput: RemoveStopsFromRoutesInputType;
}>;


export type RemoveStopsFromRoutesMutation = { __typename?: 'Mutation', removeStopsFromRoutes: Array<string> };

export type AuditReportBucketFragment = { __typename?: 'AuditReportBucketEntity', startDate: any, endDate: any, contactUuid?: string | null, daysPastDue?: number | null, noAction: Array<string>, onHand: Array<string>, assigned: Array<string>, partiallyComplete: Array<string>, attempted: Array<string>, onHold: Array<string>, unfinalized: Array<string>, cancelledUnfinalized: Array<string>, billingIssues: Array<string>, cancelledFinalized: Array<string>, noChargeFinalized: Array<string>, onInvoiceUnposted: Array<string>, onInvoicePosted: Array<string> };

export type AuditReportQueryVariables = Exact<{
  args: AuditReportArgs;
}>;


export type AuditReportQuery = { __typename?: 'Query', auditReport: Array<{ __typename?: 'AuditReportBucketEntity', startDate: any, endDate: any, contactUuid?: string | null, daysPastDue?: number | null, noAction: Array<string>, onHand: Array<string>, assigned: Array<string>, partiallyComplete: Array<string>, attempted: Array<string>, onHold: Array<string>, unfinalized: Array<string>, cancelledUnfinalized: Array<string>, billingIssues: Array<string>, cancelledFinalized: Array<string>, noChargeFinalized: Array<string>, onInvoiceUnposted: Array<string>, onInvoicePosted: Array<string> }> };

export type CompanyConfigurationFragment = { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, enabledExternalRatingProviders: Array<ExternalRatingProvider>, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, quoteAgentEnabled: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, showAccessorialsToDrivers: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, pieceTransferableStatuses: Array<PieceStatus>, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean };

export type CompanyConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyConfigurationQuery = { __typename?: 'Query', companyConfiguration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, enabledExternalRatingProviders: Array<ExternalRatingProvider>, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, quoteAgentEnabled: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, showAccessorialsToDrivers: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, pieceTransferableStatuses: Array<PieceStatus>, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean } | null };

export type CompletionToPaymentReportCsvQueryVariables = Exact<{
  args: CompletionToPaymentFilterArgs;
}>;


export type CompletionToPaymentReportCsvQuery = { __typename?: 'Query', completionToPaymentReportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type CompletionToPaymentDurationFieldsFragment = { __typename?: 'CompletionToPaymentDuration', meanSeconds?: number | null, medianSeconds?: number | null, p90Seconds?: number | null, countedOrders: number, backwardOrders: number, prior: { __typename?: 'CompletionToPaymentPriorDuration', medianSeconds?: number | null, countedOrders: number } };

export type CompletionToPaymentSummaryQueryVariables = Exact<{
  args: CompletionToPaymentFilterArgs;
}>;


export type CompletionToPaymentSummaryQuery = { __typename?: 'Query', completionToPaymentSummary: { __typename?: 'CompletionToPaymentSummary', orders: number, postedOrders: number, settledOrders: number, timezone: string, completeToPosted: { __typename?: 'CompletionToPaymentDuration', meanSeconds?: number | null, medianSeconds?: number | null, p90Seconds?: number | null, countedOrders: number, backwardOrders: number, prior: { __typename?: 'CompletionToPaymentPriorDuration', medianSeconds?: number | null, countedOrders: number } }, completeToPaid: { __typename?: 'CompletionToPaymentDuration', meanSeconds?: number | null, medianSeconds?: number | null, p90Seconds?: number | null, countedOrders: number, backwardOrders: number, prior: { __typename?: 'CompletionToPaymentPriorDuration', medianSeconds?: number | null, countedOrders: number } }, intervals: Array<{ __typename?: 'CompletionToPaymentIntervalDuration', key: CompletionToPaymentInterval, meanSeconds?: number | null, medianSeconds?: number | null, p90Seconds?: number | null, countedOrders: number, backwardOrders: number, prior: { __typename?: 'CompletionToPaymentPriorDuration', medianSeconds?: number | null, countedOrders: number } }>, waiting: Array<{ __typename?: 'CompletionToPaymentWaitingStage', stage: CompletionToPaymentStage, orders: number, medianAgeSeconds?: number | null, over30Days: number, over60Days: number }>, flags: { __typename?: 'CompletionToPaymentFlags', onHold: number, ratingErrors: number, ratingErrorsUnpaid: number }, trend: { __typename?: 'CompletionToPaymentTrend', unit: KpiTrendBucketUnit, points: Array<{ __typename?: 'CompletionToPaymentTrendPoint', bucketDate: string, medianSeconds?: number | null, p90Seconds?: number | null, countedOrders: number, completedOrders: number }> }, byCustomer: Array<{ __typename?: 'CompletionToPaymentGroup', uuid?: string | null, name: string, orders: number, postedOrders: number, settledOrders: number, toPostedMedianSeconds?: number | null, toPostedCountedOrders: number, postedToPaidMedianSeconds?: number | null, postedToPaidCountedOrders: number, unpaidOver30Days: number }>, byTerminal: Array<{ __typename?: 'CompletionToPaymentGroup', uuid?: string | null, name: string, orders: number, postedOrders: number, settledOrders: number, toPostedMedianSeconds?: number | null, toPostedCountedOrders: number, postedToPaidMedianSeconds?: number | null, postedToPaidCountedOrders: number, unpaidOver30Days: number }>, oldestUnpaid: Array<{ __typename?: 'CompletionToPaymentUnpaidOrder', orderUuid: string, orderName: string, customerName: string, invoiceName: string, postedAt: any, ageSeconds: number }>, slowestToBill: Array<{ __typename?: 'CompletionToPaymentSlowOrder', orderUuid: string, orderName: string, customerName: string, terminalCode?: string | null, secondsToPosted: number, longestInterval?: { __typename?: 'CompletionToPaymentLongestInterval', key: CompletionToPaymentInterval, seconds: number } | null }>, outliers: Array<{ __typename?: 'CompletionToPaymentOutliers', measure: CompletionToPaymentMeasure, orders: Array<{ __typename?: 'CompletionToPaymentOutlierOrder', orderUuid: string, orderName: string, customerName: string, fromAt: any, toAt: any, seconds: number }> }> } };

export type CompletionToPaymentReportQueryVariables = Exact<{
  args: CompletionToPaymentPageArgs;
}>;


export type CompletionToPaymentReportQuery = { __typename?: 'Query', completionToPaymentReport: { __typename?: 'CompletionToPaymentReport', totalCount: number, timezone: string, rows: Array<{ __typename?: 'CompletionToPaymentRow', orderUuid: string, orderName: string, customerName: string, accountId?: string | null, hawb?: string | null, onHold: boolean, hasRatingErrors: boolean, completedAt?: any | null, chargesFinalizedAt?: any | null, onInvoiceAt?: any | null, invoicePostedAt?: any | null, invoicePaidAt?: any | null, completeToFinalizedSeconds?: number | null, finalizedToOnInvoiceSeconds?: number | null, onInvoiceToPostedSeconds?: number | null, postedToPaidSeconds?: number | null }> } };

export type AllContactPersonFieldsFragment = { __typename?: 'ContactPersonEntity', email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, uuid: string };

export type ContactPersonFragment = { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any };

export type ContactPersonsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactPersonsQuery = { __typename?: 'Query', contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }> };

export type ArchiveContactStationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveContactStationMutation = { __typename?: 'Mutation', archiveContactStation: { __typename: 'ContactStationUpdateSuccessOutput', contactStation: { __typename?: 'ContactStationEntity', id: string, isArchived: boolean } } | { __typename: 'MutationErrorOutput', message: string } };

export type ArchivePersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchivePersonMutation = { __typename?: 'Mutation', archivePerson: { __typename?: 'UpdatePersonOutput', person: { __typename?: 'PersonEntity', id: string, status: PersonStatus } } };

export type ContactChargeMatrixColumnMappingsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactChargeMatrixColumnMappingsQuery = { __typename?: 'Query', contactChargeMatrixColumnMappings: Array<{ __typename?: 'ContactChargeMatrixColumnMappingEntity', uuid: string, column: ChargeMatrixColumn, accessorial: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string } }> };

export type CreateContactCommentMutationVariables = Exact<{
  createContactCommentInput: CreateContactCommentInput;
}>;


export type CreateContactCommentMutation = { __typename?: 'Mutation', createContactComment: { __typename?: 'ContactCommentEntity', uuid: string } };

export type DeleteContactCommentMutationVariables = Exact<{
  deleteContactCommentInput: DeleteContactCommentInput;
}>;


export type DeleteContactCommentMutation = { __typename?: 'Mutation', deleteContactComment: { __typename?: 'DeleteContactCommentSuccessOutput', success: boolean } | { __typename?: 'MutationErrorOutput', message: string } };

export type UpdateContactCommentMutationVariables = Exact<{
  updateContactCommentInput: UpdateContactCommentInput;
}>;


export type UpdateContactCommentMutation = { __typename?: 'Mutation', updateContactComment: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'UpdateContactCommentSuccessOutput', success: boolean } };

export type ContactCommunicationConfigFragment = { __typename?: 'ContactCommunicationConfigEntity', uuid: string, active: boolean, type: ContactCommunicationType };

export type ContactCommunicationConfigsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactCommunicationConfigsQuery = { __typename?: 'Query', contactCommunicationConfigs?: Array<{ __typename?: 'ContactCommunicationConfigEntity', uuid: string, active: boolean, type: ContactCommunicationType }> | null };

export type ContactDefaultSurchargeQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactDefaultSurchargeQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } };

export type ContactEmailSuppressionsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactEmailSuppressionsQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', uuid: string, emailSuppressions: Array<{ __typename?: 'EmailSuppressionEntity', email: string, type: EmailSuppressionType }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, emailSuppressions: Array<{ __typename?: 'EmailSuppressionEntity', email: string, type: EmailSuppressionType }> } };

export type ContactEmailsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactEmailsQuery = { __typename?: 'Query', contactEmails?: Array<{ __typename?: 'ContactEmailEntity', uuid: string, email: string, type: ContactEmailType }> | null };

type ContactForQuickbooks_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', unsyncedInvoiceCount: number, uuid: string, displayName: string, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksMappingId?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null };

type ContactForQuickbooks_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksMappingId?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null };

export type ContactForQuickbooksFragment = ContactForQuickbooks_CustomerContactEntity_Fragment | ContactForQuickbooks_ThirdPartyContactEntity_Fragment;

export type ContactIsOverCreditLimitByOrderUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactIsOverCreditLimitByOrderUuidQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, contact: { __typename?: 'CustomerContactEntity', isOverCreditLimit: boolean } | { __typename?: 'ThirdPartyContactEntity', isOverCreditLimit: boolean } } | null };

export type ContactIsOverCreditLimitQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactIsOverCreditLimitQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', isOverCreditLimit: boolean } | { __typename?: 'ThirdPartyContactEntity', isOverCreditLimit: boolean } };

export type ContactLogosQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactLogosQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', uuid: string, logo?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null, logoType?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, logo?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null, logoType?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null } };

export type ContactQueryForBluebirdQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactQueryForBluebirdQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } };

export type ContactServicesQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactServicesQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', uuid: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } };

export type ContactStationsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ContactStationsQuery = { __typename?: 'Query', contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> };

export type ContactTariffChainFragment = { __typename?: 'TariffChainEntity', id: string, name: string, tariffGroupType: TariffGroupType, tariffGroups: Array<{ __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupType: TariffGroupType, startDate?: any | null, endDate?: any | null, firstTariff?: { __typename?: 'TariffEntity', tariffType: TariffType, rateType: RateType, tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType } } | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> };

export type ContactTariffChainsQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactTariffChainsQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', uuid: string, effectiveTariffChains: Array<{ __typename?: 'EffectiveTariffChainEntity', tariffGroupType: TariffGroupType, source: TariffChainSource, tariffChain: { __typename?: 'TariffChainEntity', id: string, name: string, tariffGroupType: TariffGroupType, tariffGroups: Array<{ __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupType: TariffGroupType, startDate?: any | null, endDate?: any | null, firstTariff?: { __typename?: 'TariffEntity', tariffType: TariffType, rateType: RateType, tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType } } | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, effectiveTariffChains: Array<{ __typename?: 'EffectiveTariffChainEntity', tariffGroupType: TariffGroupType, source: TariffChainSource, tariffChain: { __typename?: 'TariffChainEntity', id: string, name: string, tariffGroupType: TariffGroupType, tariffGroups: Array<{ __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupType: TariffGroupType, startDate?: any | null, endDate?: any | null, firstTariff?: { __typename?: 'TariffEntity', tariffType: TariffType, rateType: RateType, tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType } } | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } }> } };

export type ContactTariffGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  tariffGroupType?: InputMaybe<TariffGroupType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  excludeDefault?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactTariffGroupsQuery = { __typename?: 'Query', tariffGroupsPaginated: { __typename?: 'TariffGroupConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TariffGroupEdge', node: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, startDate?: any | null, endDate?: any | null, rateMultiplier?: number | null, totalContactsToServicesMappings: number, firstTariff?: { __typename?: 'TariffEntity', tariffType: TariffType, rateType: RateType, tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType } } | null, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type ContactQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, recoveryDiscountRate?: any | null, lineHaulDiscountRate?: any | null, defaultDimFactor?: number | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, includeInExpeditorsScorecard: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultRecoveryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } };

export type ContactsForInvoicingQueryVariables = Exact<{
  invoiceUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ContactsForInvoicingQuery = { __typename?: 'Query', contacts: Array<{ __typename: 'CustomerContactEntity', numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceDownloadDocuments: Array<DocumentType>, enableCreditHold?: boolean | null, defaultInvoiceEmailSubject?: string | null, uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null } | { __typename: 'ThirdPartyContactEntity', uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null }> };

export type ContactsForQuickbooksQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactsForQuickbooksQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', unsyncedInvoiceCount: number, uuid: string, displayName: string, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksMappingId?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksMappingId?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null }> };

export type ContactsPageListingQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactsPageListingQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', uuid: string, contactReferenceNumber?: string | null, displayName: string, isActive: boolean, type: ContactType } | { __typename?: 'ThirdPartyContactEntity', uuid: string, contactReferenceNumber?: string | null, displayName: string, isActive: boolean, type: ContactType }> };

export type ContactsReportQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactsReportQuery = { __typename?: 'Query', contactsReport: Array<{ __typename?: 'ContactForContactReport', name: string, email?: string | null, shortcode?: string | null, active: boolean, addressName?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, businessDivision?: string | null, type: string, referenceNumber?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: string | null, enableCreditHold: boolean, creditLimit?: number | null, billingCycle?: string | null, defaultInvoiceTransmissionMethod?: string | null, defaultInvoiceType: string }> };

export type ContactsSimpleQueryVariables = Exact<{
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactsSimpleQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null, isOverCreditLimit: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null, isOverCreditLimit: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null }> };

export type ContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, recoveryDiscountRate?: any | null, lineHaulDiscountRate?: any | null, defaultDimFactor?: number | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, includeInExpeditorsScorecard: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultRecoveryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }> };

export type CreateAddressMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type CreateAddressMutation = { __typename?: 'Mutation', createAddress: { __typename?: 'AddressEntity', uuid: string } };

export type CreateContactEmailMutationVariables = Exact<{
  createContactEmailInput: CreateContactEmailInput;
}>;


export type CreateContactEmailMutation = { __typename?: 'Mutation', createContactEmail?: { __typename?: 'ContactEmailEntity', uuid: string } | null };

export type CreateContactStationMutationVariables = Exact<{
  input: ContactStationCreateInput;
}>;


export type CreateContactStationMutation = { __typename?: 'Mutation', createContactStation: { __typename: 'ContactStationCreateSuccessOutput', contactStation: { __typename?: 'ContactStationEntity', id: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type CreateCustomerContactMutationVariables = Exact<{
  input: CreateCustomerContactInput;
}>;


export type CreateCustomerContactMutation = { __typename?: 'Mutation', createCustomerContact: { __typename?: 'CustomerContactEntity', uuid: string } };

export type CreatePersonMutationVariables = Exact<{
  input: CreatePersonInput;
}>;


export type CreatePersonMutation = { __typename?: 'Mutation', createPerson: { __typename?: 'CreatePersonOutput', person: { __typename?: 'PersonEntity', id: string } } };

export type FindServicesForCustomerConfigurationQueryVariables = Exact<{
  findServicesForCustomerConfigurationInput: FindServicesForCustomerConfigurationInput;
}>;


export type FindServicesForCustomerConfigurationQuery = { __typename?: 'Query', findServicesForCustomerConfiguration: { __typename: 'FindServicesForCustomerConfigurationSuccessOutput', services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, isActive: boolean }> } | { __typename: 'QueryErrorOutput', message: string } };

export type DeleteContactEmailMutationVariables = Exact<{
  deleteContactEmailInput: DeleteContactEmailInput;
}>;


export type DeleteContactEmailMutation = { __typename?: 'Mutation', deleteContactEmail: { __typename?: 'ContactEmailEntity', uuid: string } };

export type InvoiceTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type InvoiceTermsQuery = { __typename?: 'Query', invoiceTerms: Array<{ __typename?: 'InvoiceTermEntity', uuid: string, terms: string }> };

export type OrderEventNotificationSubscriptionsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type OrderEventNotificationSubscriptionsQuery = { __typename?: 'Query', orderEventNotificationSubscriptions: Array<{ __typename?: 'OrderEventNotificationSubscriptionEntity', id: string, eventType: OrderEventNotificationType, channel: NotificationChannel, subscriberType: NotificationSubscriberType }> };

export type OrganizationEffectivePackageTypeConfigsQueryVariables = Exact<{
  organizationUuid: Scalars['String']['input'];
}>;


export type OrganizationEffectivePackageTypeConfigsQuery = { __typename?: 'Query', organizationEffectivePackageTypeConfigs: { __typename?: 'FindEffectiveOrganizationPackageTypeConfigsOutput', effectivePackageTypeConfigs: Array<{ __typename: 'EffectivePackageTypeConfigEntity', packageType: PackageType, isSingleHandlingUnit: boolean }> } };

export type OrganizationPackageTypeConfigFragment = { __typename: 'OrganizationPackageTypeConfigEntity', id: string, packageType: PackageType, isSingleHandlingUnit: boolean };

export type PaginatedContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByContactName?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PaginatedContactsQuery = { __typename?: 'Query', paginatedContacts: { __typename?: 'ContactConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ContactEdge', node: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type PersonsQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type PersonsQuery = { __typename?: 'Query', persons: { __typename?: 'FindPersonsOutput', persons: Array<{ __typename?: 'PersonEntity', id: string, status: PersonStatus, firstName: string, lastName: string, phone?: string | null, email?: string | null, defaultPickupAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, specialInstructions?: string | null } | null, defaultDeliveryAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, specialInstructions?: string | null } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultVehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, defaultForContactStations?: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean }> | null }> } };

export type QueryQuickbooksDesktopAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryQuickbooksDesktopAccountsQuery = { __typename?: 'Query', queryQuickbooksDesktopAccounts: { __typename?: 'QuickbooksDesktopResultEntity', error?: string | null, quickbooksDesktopObjects?: Array<{ __typename?: 'QuickbooksDesktopObjectEntity', id: string, name: string }> | null } };

export type QueryQuickbooksDesktopCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryQuickbooksDesktopCustomersQuery = { __typename?: 'Query', queryQuickbooksDesktopCustomers: { __typename?: 'QuickbooksDesktopResultEntity', error?: string | null, quickbooksDesktopObjects?: Array<{ __typename?: 'QuickbooksDesktopObjectEntity', id: string, name: string }> | null } };

export type RemoveAddressMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveAddressMutation = { __typename?: 'Mutation', removeAddress: { __typename?: 'AddressEntity', uuid: string } };

export type RestoreContactStationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreContactStationMutation = { __typename?: 'Mutation', restoreContactStation: { __typename: 'ContactStationUpdateSuccessOutput', contactStation: { __typename?: 'ContactStationEntity', id: string, isArchived: boolean } } | { __typename: 'MutationErrorOutput', message: string } };

export type RestorePersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestorePersonMutation = { __typename?: 'Mutation', restorePerson: { __typename?: 'UpdatePersonOutput', person: { __typename?: 'PersonEntity', id: string, status: PersonStatus } } };

export type SetContactChargeMatrixColumnMappingsMutationVariables = Exact<{
  setContactChargeMatrixColumnMappingsInput: SetContactChargeMatrixColumnMappingsInput;
}>;


export type SetContactChargeMatrixColumnMappingsMutation = { __typename?: 'Mutation', setContactChargeMatrixColumnMappings: Array<{ __typename?: 'ContactChargeMatrixColumnMappingEntity', uuid: string, column: ChargeMatrixColumn, accessorial: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string } }> };

export type ShallowContactQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ShallowContactQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, resolvedFreightBillingMethod: FreightBillingMethod, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, useCustomPackageSpecs: boolean, displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }>, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, freightClass?: FreightClass | null }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> } | { __typename?: 'ThirdPartyContactEntity', displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> } };

export type ShallowContactsByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ShallowContactsByUuidsQuery = { __typename?: 'Query', contactsByUuids: Array<{ __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, resolvedFreightBillingMethod: FreightBillingMethod, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, useCustomPackageSpecs: boolean, displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }>, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, freightClass?: FreightClass | null }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> } | { __typename?: 'ThirdPartyContactEntity', displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> }> };

export type ShallowContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShallowContactsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, resolvedFreightBillingMethod: FreightBillingMethod, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, useCustomPackageSpecs: boolean, displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }>, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, freightClass?: FreightClass | null }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> } | { __typename?: 'ThirdPartyContactEntity', displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> }> };

export type TariffGroupForContactChainTableFragment = { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupType: TariffGroupType, startDate?: any | null, endDate?: any | null, firstTariff?: { __typename?: 'TariffEntity', tariffType: TariffType, rateType: RateType, tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType } } | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> };

export type TariffGroupForContactsTableFragment = { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, startDate?: any | null, endDate?: any | null, rateMultiplier?: number | null, totalContactsToServicesMappings: number, firstTariff?: { __typename?: 'TariffEntity', tariffType: TariffType, rateType: RateType, tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType } } | null, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> };

export type ThirdPartyUserByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ThirdPartyUserByUuidQuery = { __typename?: 'Query', thirdPartyUserByUuid?: { __typename?: 'ThirdPartyUserEntity', uuid: string, email: string, contacts: Array<{ __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }> } | null };

export type ThirdPartyUsersByContactQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ThirdPartyUsersByContactQuery = { __typename?: 'Query', thirdPartyUsersByContact: Array<{ __typename?: 'ThirdPartyUserEntity', uuid: string, email: string }> };

export type UpdateAddressMutationVariables = Exact<{
  input: UpdateAddressInput;
}>;


export type UpdateAddressMutation = { __typename?: 'Mutation', updateAddress: { __typename?: 'AddressEntity', uuid: string } };

export type UpdateContactCommunicationConfigMutationVariables = Exact<{
  updateContactCommunicationConfigInput: UpdateContactCommunicationConfigInput;
}>;


export type UpdateContactCommunicationConfigMutation = { __typename?: 'Mutation', updateContactCommunicationConfig: { __typename?: 'ContactCommunicationConfigEntity', uuid: string } };

export type UpdateContactEmailsMutationVariables = Exact<{
  input: UpdateContactEmailsInput;
}>;


export type UpdateContactEmailsMutation = { __typename?: 'Mutation', updateContactEmails: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateContactEmailsSuccessOutput', contactUuid: string, contactCommunicationConfigs: Array<{ __typename?: 'ContactCommunicationConfigEntity', uuid: string, type: ContactCommunicationType, active: boolean }>, contactEmails: Array<{ __typename?: 'ContactEmailEntity', uuid: string, email: string, type: ContactEmailType }> } };

export type UpdateContactStationMutationVariables = Exact<{
  input: ContactStationUpdateInput;
}>;


export type UpdateContactStationMutation = { __typename?: 'Mutation', updateContactStation: { __typename: 'ContactStationUpdateSuccessOutput', contactStation: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } } | { __typename: 'MutationErrorOutput', message: string } };

export type UpdateCustomerContactMutationVariables = Exact<{
  input: UpdateCustomerContactInput;
}>;


export type UpdateCustomerContactMutation = { __typename?: 'Mutation', updateCustomerContact: { __typename?: 'CustomerContactEntity', uuid: string, quickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null } };

export type UpdateOrderEventNotificationSubscriptionsMutationVariables = Exact<{
  input: UpdateOrderEventNotificationSubscriptionsInput;
}>;


export type UpdateOrderEventNotificationSubscriptionsMutation = { __typename?: 'Mutation', updateOrderEventNotificationSubscriptions: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateOrderEventNotificationSubscriptionsSuccessOutput', contactUuid: string, subscriptions: Array<{ __typename?: 'OrderEventNotificationSubscriptionEntity', id: string, eventType: OrderEventNotificationType, channel: NotificationChannel, subscriberType: NotificationSubscriberType }> } };

export type UpdatePersonMutationVariables = Exact<{
  input: UpdatePersonInput;
}>;


export type UpdatePersonMutation = { __typename?: 'Mutation', updatePerson: { __typename?: 'UpdatePersonOutput', person: { __typename?: 'PersonEntity', id: string, status: PersonStatus, firstName: string, lastName: string, phone?: string | null, email?: string | null, defaultPickupAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, specialInstructions?: string | null } | null, defaultDeliveryAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, specialInstructions?: string | null } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultVehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null } } };

export type UpsertAddressMutationVariables = Exact<{
  upsertAddressInput: UpsertAddressInput;
}>;


export type UpsertAddressMutation = { __typename?: 'Mutation', upsertAddress: { __typename?: 'AddressEntity', uuid: string } };

export type UpsertOrganizationPackageTypeConfigMutationVariables = Exact<{
  input: UpsertOrganizationPackageTypeConfigInput;
}>;


export type UpsertOrganizationPackageTypeConfigMutation = { __typename?: 'Mutation', upsertOrganizationPackageTypeConfig: { __typename?: 'UpsertOrganizationPackageTypeConfigOutput', organizationPackageTypeConfig: { __typename: 'OrganizationPackageTypeConfigEntity', id: string, packageType: PackageType, isSingleHandlingUnit: boolean } } };

export type UpsertUserContactNotificationSubscriptionMutationVariables = Exact<{
  input: UserContactNotificationSubscriptionUpsertInput;
}>;


export type UpsertUserContactNotificationSubscriptionMutation = { __typename?: 'Mutation', upsertUserContactNotificationSubscription: { __typename?: 'UserContactNotificationSubscriptionEntity', uuid: string, approveOrderNotification?: boolean | null } };

export type UserContactNotificationSubscriptionFragment = { __typename?: 'UserContactNotificationSubscriptionEntity', uuid: string, approveOrderNotification?: boolean | null };

export type UserContactNotificationSubscriptionQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type UserContactNotificationSubscriptionQuery = { __typename?: 'Query', userContactNotificationSubscription?: { __typename?: 'UserContactNotificationSubscriptionEntity', uuid: string, approveOrderNotification?: boolean | null } | null };

export type BookCustomerAppointmentMutationVariables = Exact<{
  input: BookCustomerAppointmentInput;
}>;


export type BookCustomerAppointmentMutation = { __typename?: 'Mutation', bookCustomerAppointment: { __typename: 'BookCustomerAppointmentRefusedOutput', reason: BookCustomerAppointmentRefusalReason, message: string, alternativeSlots: Array<{ __typename?: 'CustomerAppointmentSlotEntity', serviceDateIso8601: string, startsAt: any, endsAt: any, timeZone: string }> } | { __typename: 'BookCustomerAppointmentSuccessOutput', message: string, canReschedule: boolean, bookedAppointment: { __typename?: 'CustomerBookedAppointmentEntity', serviceDateIso8601: string, startsAt: any, endsAt: any, timeZone: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type CustomerAppointmentInvitationQueryVariables = Exact<{
  input: CustomerAppointmentTokenInput;
}>;


export type CustomerAppointmentInvitationQuery = { __typename?: 'Query', customerAppointmentInvitation: { __typename?: 'CustomerAppointmentInvitationEntity', status: CustomerAppointmentInvitationStatus, message?: string | null, canRequestNewLink: boolean, companyName?: string | null, companyPhone?: string | null, stopType?: string | null, serviceAddress?: string | null, notes?: string | null, selfReschedulesRemaining?: number | null, bookedAppointment?: { __typename?: 'CustomerBookedAppointmentEntity', serviceDateIso8601: string, startsAt: any, endsAt: any, timeZone: string } | null, slots: Array<{ __typename?: 'CustomerAppointmentSlotEntity', serviceDateIso8601: string, startsAt: any, endsAt: any, timeZone: string }> } };

export type DeclineCustomerAppointmentOptionsMutationVariables = Exact<{
  input: CustomerAppointmentTokenInput;
}>;


export type DeclineCustomerAppointmentOptionsMutation = { __typename?: 'Mutation', declineCustomerAppointmentOptions: { __typename: 'CustomerAppointmentAcknowledgementOutput', message: string } | { __typename: 'MutationErrorOutput', message: string } };

export type RequestCustomerAppointmentLinkMutationVariables = Exact<{
  input: CustomerAppointmentTokenInput;
}>;


export type RequestCustomerAppointmentLinkMutation = { __typename?: 'Mutation', requestCustomerAppointmentLink: { __typename: 'CustomerAppointmentAcknowledgementOutput', message: string } | { __typename: 'MutationErrorOutput', message: string } };

export type CustomerPortalQuoteContactQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CustomerPortalQuoteContactQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', uuid: string, defaultDimFactor?: number | null, defaultFreightClass?: FreightClass | null, displayChargesInCustomerPortal: boolean, resolvedFreightBillingMethod: FreightBillingMethod } | { __typename?: 'ThirdPartyContactEntity' } };

export type RateCustomerPortalSmc3QuoteQueryVariables = Exact<{
  rateOrderInput: RateOrderInput;
}>;


export type RateCustomerPortalSmc3QuoteQuery = { __typename?: 'Query', rateOrderContents: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', externalRating?: { __typename: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, packageIndex?: number | null, retryable: boolean } | { __typename: 'ExternalRatingSuccess', tariffName: string, tariffEffectiveDate: string, minimumAdjustmentCents: number, deficitWeightLbs: number, finalCents: number, lines: Array<{ __typename?: 'ExternalRatingLine', freightClass?: string | null, weightLbs?: number | null, amountCents: number, isMinimumAdjustment: boolean }> } | null } | null } };

export type AddThirdPartyUserToContactMutationVariables = Exact<{
  addThirdPartyUserToContactInput: AddThirdPartyUserToContactInput;
}>;


export type AddThirdPartyUserToContactMutation = { __typename?: 'Mutation', addThirdPartyUserToContact: { __typename?: 'ThirdPartyUserEntity', uuid: string } };

export type ConsigneePortalOrderFragment = { __typename?: 'ConsigneePortalOrderEntity', uuid: string, name: string, receivedDate?: any | null, status: OrderStatus, notes?: string | null, companyTimezone?: string | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, detailedStatus?: OrderDetailedStatus | null, isRefused: boolean, packages?: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }> | null, shipments: Array<{ __typename?: 'ConsigneePortalShipmentEntity', uuid: string, deliveryDate?: any | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status?: StopStatus | null, proofOfDeliverySignee?: string | null, addressUuid?: string | null, completedAtLocalTimeZone?: string | null, placeInRoute?: number | null, contactPhone?: string | null, outboundMethod?: OutboundMethod | null, driverPlaceInRoute?: number | null, routeIsToday?: boolean | null, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, completedAtLocal?: { __typename?: 'PlainDateTime', date: { __typename?: 'PlainDate', year: number, month: number, day: number }, time: { __typename?: 'PlainTime', hour: number, minute: number } } | null, address?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }> };

export type ConsigneePortalOrderQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ConsigneePortalOrderQuery = { __typename?: 'Query', consigneePortalOrder: { __typename?: 'ConsigneePortalOrderEntity', uuid: string, name: string, receivedDate?: any | null, status: OrderStatus, notes?: string | null, companyTimezone?: string | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, detailedStatus?: OrderDetailedStatus | null, isRefused: boolean, packages?: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }> | null, shipments: Array<{ __typename?: 'ConsigneePortalShipmentEntity', uuid: string, deliveryDate?: any | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status?: StopStatus | null, proofOfDeliverySignee?: string | null, addressUuid?: string | null, completedAtLocalTimeZone?: string | null, placeInRoute?: number | null, contactPhone?: string | null, outboundMethod?: OutboundMethod | null, driverPlaceInRoute?: number | null, routeIsToday?: boolean | null, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, completedAtLocal?: { __typename?: 'PlainDateTime', date: { __typename?: 'PlainDate', year: number, month: number, day: number }, time: { __typename?: 'PlainTime', hour: number, minute: number } } | null, address?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }> } };

export type CustomerPortalOrderShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, name: string, status: ShipmentStatus, hideFromBilling: boolean, totalChargesAmount: number, freightNeedsRate: boolean, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, total: number, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffType: TariffType, maximumIncludesFuel: boolean, rateType: RateType, useActualWeightInCalculation: boolean, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> } } | null, externalRatingLines?: Array<{ __typename?: 'ExternalRatingLine', amountCents: number, freightClass?: string | null, isMinimumAdjustment: boolean, weightLbs?: number | null }> | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, legs: Array<{ __typename?: 'LegEntity', uuid: string, status: LegStatus, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, localTimeZone?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', ordinal: number, route?: { __typename?: 'RouteEntity', date: any, slots: Array<{ __typename?: 'RouteSlotEntity', ordinal: number, stops: Array<{ __typename?: 'StandardStopEntity', status: StopStatus, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', status: ShipmentStatus } } | null }> }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null };

export type CustomerPortalMeQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerPortalMeQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', company: { __typename?: 'CompanyEntity', uuid: string, name: string } } | null };

export type CustomerPortalOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, status: OrderStatus, osd?: boolean | null, notes: string, externalNotes?: string | null, totalCharge: number, freightNeedsRate: boolean, shouldDisplayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, company: { __typename?: 'CompanyEntity', uuid: string, segment: Segment, timeZone: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, name: string, status: ShipmentStatus, hideFromBilling: boolean, totalChargesAmount: number, freightNeedsRate: boolean, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, total: number, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffType: TariffType, maximumIncludesFuel: boolean, rateType: RateType, useActualWeightInCalculation: boolean, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> } } | null, externalRatingLines?: Array<{ __typename?: 'ExternalRatingLine', amountCents: number, freightClass?: string | null, isMinimumAdjustment: boolean, weightLbs?: number | null }> | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, legs: Array<{ __typename?: 'LegEntity', uuid: string, status: LegStatus, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, localTimeZone?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', ordinal: number, route?: { __typename?: 'RouteEntity', date: any, slots: Array<{ __typename?: 'RouteSlotEntity', ordinal: number, stops: Array<{ __typename?: 'StandardStopEntity', status: StopStatus, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', status: ShipmentStatus } } | null }> }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, invoice?: { __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus } | null };

export type CustomerPortalOrderQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CustomerPortalOrderQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, status: OrderStatus, osd?: boolean | null, notes: string, externalNotes?: string | null, totalCharge: number, freightNeedsRate: boolean, shouldDisplayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, company: { __typename?: 'CompanyEntity', uuid: string, segment: Segment, timeZone: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, name: string, status: ShipmentStatus, hideFromBilling: boolean, totalChargesAmount: number, freightNeedsRate: boolean, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, total: number, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffType: TariffType, maximumIncludesFuel: boolean, rateType: RateType, useActualWeightInCalculation: boolean, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> } } | null, externalRatingLines?: Array<{ __typename?: 'ExternalRatingLine', amountCents: number, freightClass?: string | null, isMinimumAdjustment: boolean, weightLbs?: number | null }> | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, legs: Array<{ __typename?: 'LegEntity', uuid: string, status: LegStatus, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, localTimeZone?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', ordinal: number, route?: { __typename?: 'RouteEntity', date: any, slots: Array<{ __typename?: 'RouteSlotEntity', ordinal: number, stops: Array<{ __typename?: 'StandardStopEntity', status: StopStatus, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', status: ShipmentStatus } } | null }> }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, invoice?: { __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus } | null } | null };

export type CustomerPortalPiecesQueryVariables = Exact<{
  customerPortalPiecesInput: CustomerPortalPiecesInput;
}>;


export type CustomerPortalPiecesQuery = { __typename?: 'Query', customerPortalPieces: { __typename?: 'PieceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PieceEdge', cursor: string, node: { __typename?: 'PieceListEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, markedOnHandAt?: any | null, createdAt: any, orderUuid?: string | null, orderName?: string | null, packageUuid?: string | null, packageName?: string | null, packageOrderUuid?: string | null, packageOrderName?: string | null, packedPieceCount: number, hawb?: string | null, mawb?: string | null, terminalUuid?: string | null, terminalName?: string | null, warehouseLocationUuid?: string | null, warehouseLocationName?: string | null, warehouseUuid?: string | null, warehouseName?: string | null, customerUuid?: string | null, customerName?: string | null, isUnalertedFreight: boolean, dwellStatus?: DwellStatus | null, effectiveDwellThresholdDays?: number | null, daysOverDwellThreshold?: number | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CustomerPortalQuotesQueryVariables = Exact<{
  findCustomerPortalQuotesInput: FindCustomerPortalQuotesInput;
}>;


export type CustomerPortalQuotesQuery = { __typename?: 'Query', customerPortalQuotes: { __typename?: 'QuoteConnection', totalCount?: number | null, edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'QuoteEntity', uuid: string, createdAt: any, source: QuoteSource, number: string, status: QuoteStatus, company: { __typename?: 'CompanyEntity', name: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean } } };

export type CustomerPortalQuoteFragment = { __typename?: 'QuoteEntity', uuid: string, createdAt: any, source: QuoteSource, number: string, status: QuoteStatus, company: { __typename?: 'CompanyEntity', name: string } };

export type CustomerPortalShipmentForTableFragment = { __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', date: any, uuid: string } | null } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null };

export type CustomerPortalOrderForTableFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, osd?: boolean | null, onHold: boolean, isOnHand: boolean, receivedDate?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', date: any, uuid: string } | null } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }>, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type CustomerPortalOrdersFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, name: string, status: ShipmentStatus, hideFromBilling: boolean, totalChargesAmount: number, freightNeedsRate: boolean, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', measurementUnits: MeasurementUnits, weightUnits: WeightUnits } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, total: number, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffType: TariffType, maximumIncludesFuel: boolean, rateType: RateType, useActualWeightInCalculation: boolean, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> } } | null, externalRatingLines?: Array<{ __typename?: 'ExternalRatingLine', amountCents: number, freightClass?: string | null, isMinimumAdjustment: boolean, weightLbs?: number | null }> | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, legs: Array<{ __typename?: 'LegEntity', uuid: string, status: LegStatus, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, localTimeZone?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', ordinal: number, route?: { __typename?: 'RouteEntity', date: any, slots: Array<{ __typename?: 'RouteSlotEntity', ordinal: number, stops: Array<{ __typename?: 'StandardStopEntity', status: StopStatus, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', status: ShipmentStatus } } | null }> }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }>, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type CustomerPortalOrdersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  appointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  plannedDateFilters?: InputMaybe<DateFilterStartEnd>;
  dispatched?: InputMaybe<BooleanFilter>;
  ofdOfp?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  companyFilter?: InputMaybe<Scalars['String']['input']>;
  contactFilter?: InputMaybe<Scalars['String']['input']>;
  orderStatusBuckets?: InputMaybe<Array<CustomerPortalOrderStatusBucketInput> | CustomerPortalOrderStatusBucketInput>;
}>;


export type CustomerPortalOrdersQuery = { __typename?: 'Query', customerPortalOrders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, osd?: boolean | null, onHold: boolean, isOnHand: boolean, receivedDate?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', date: any, uuid: string } | null } | null } }>, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }>, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type EtaForCustomerPortalQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type EtaForCustomerPortalQuery = { __typename?: 'Query', etaForCustomerPortal?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null };

export type LoadCustomChargeFragment = { __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null };

export type LoadFreightChargeFragment = { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, total: number, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffType: TariffType, maximumIncludesFuel: boolean, rateType: RateType, useActualWeightInCalculation: boolean, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> } } | null, externalRatingLines?: Array<{ __typename?: 'ExternalRatingLine', amountCents: number, freightClass?: string | null, isMinimumAdjustment: boolean, weightLbs?: number | null }> | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null };

export type PublicUpsertShipmentSubscriberMutationVariables = Exact<{
  upsertShipmentSubscriberInput: UpsertShipmentSubscriberInput;
  companyUuid: Scalars['String']['input'];
}>;


export type PublicUpsertShipmentSubscriberMutation = { __typename?: 'Mutation', upsertShipmentSubscriberForCompany: { __typename?: 'ShipmentSubscriberEntity', phoneNumber?: string | null, uuid: string } };

export type RemoveThirdPartyUserFromContactMutationVariables = Exact<{
  removeThirdPartyUserFromContactInput: RemoveThirdPartyUserFromContactInput;
}>;


export type RemoveThirdPartyUserFromContactMutation = { __typename?: 'Mutation', removeThirdPartyUserFromContact: { __typename?: 'ThirdPartyUserEntity', uuid: string } };

export type SignUpForThirdPartyUserAccountMutationVariables = Exact<{
  signUpForThirdPartyUserAccountInput: SignUpForThirdPartyUserAccountInput;
}>;


export type SignUpForThirdPartyUserAccountMutation = { __typename?: 'Mutation', signUpForThirdPartyUserAccount: { __typename?: 'SignUpForThirdPartyUserAccountOutput', status: SignUpForThirdPartyUserAccountStatus } };

export type CalculateRouteEtasMutationVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CalculateRouteEtasMutation = { __typename?: 'Mutation', calculateRouteEtas: Array<{ __typename?: 'EtaEntity', arrivalTime: any, finishTime: any }> };

export type SameDayDispatchRouteDriverCoordsFragment = { __typename?: 'RouteEntity', uuid: string, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, mobilePhoneLatitude?: number | null, mobilePhoneLongitude?: number | null, mobileCoordsLastUpdatedAt?: any | null }> };

export type SameDayDispatchRoutesWithDriverCoordsQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type SameDayDispatchRoutesWithDriverCoordsQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, mobilePhoneLatitude?: number | null, mobilePhoneLongitude?: number | null, mobileCoordsLastUpdatedAt?: any | null }> }> };

export type DispatchDriversQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type DispatchDriversQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', uuid: string, status: DriverStatus, firstName: string, lastName: string, driverReferenceNumber?: string | null, lastCompletedLeg?: { __typename?: 'LegEntity', uuid: string, completedAt?: any | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string } } } | null, currentLeg?: { __typename?: 'LegEntity', uuid: string, name: string, completedAt?: any | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string } } } | null, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string, name: string } | null }> };

export type EquipmentsByTypeQueryVariables = Exact<{
  equipmentType?: InputMaybe<Array<EquipmentType> | EquipmentType>;
}>;


export type EquipmentsByTypeQuery = { __typename?: 'Query', equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, type: EquipmentType, name: string }> };

export type LegQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type LegQuery = { __typename?: 'Query', leg?: { __typename?: 'LegEntity', uuid: string, completedAt?: any | null, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', uuid: string, notes?: string | null, completedAt?: any | null, canMarkAttemptComplete?: boolean | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } }> }>, shipment: { __typename?: 'StandardShipmentEntity', uuid: string } } | null };

export type LegsQueryVariables = Exact<{
  statuses?: InputMaybe<Array<LegStatus> | LegStatus>;
  maxOneUnassignedPerShipment: Scalars['Boolean']['input'];
}>;


export type LegsQuery = { __typename?: 'Query', legs: Array<{ __typename?: 'LegEntity', uuid: string, name: string, status: LegStatus, completedAt?: any | null, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, status: DriverStatus }>, endStop: { __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, address: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null } } }> };

export type RefreshEtasForRouteMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RefreshEtasForRouteMutation = { __typename?: 'Mutation', refreshEtasForRoute: Array<{ __typename?: 'EtaEntity', arrivalTime: any, finishTime: any }> };

export type UnassignLegFromDriverMutationVariables = Exact<{
  unassignLegFromDriver: UnassignLegFromDriverInput;
}>;


export type UnassignLegFromDriverMutation = { __typename?: 'Mutation', unassignLegFromDriver: { __typename?: 'LegEntity', uuid: string } };

export type SameDayDispatchConfigFragment = { __typename?: 'SameDayDispatchConfigEntity', pickupAppointmentTimeThreshold: number, deliveryAppointmentTimeThreshold: number, isSpecialColorCode: string, isNextInRouteColorCode: string, isPastDeadlineColorCode: string, pickupWithinTimeWindowColorCode: string, deliveryWithinTimeWindowColorCode: string };

export type SameDayDispatchConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type SameDayDispatchConfigQuery = { __typename?: 'Query', sameDayDispatchConfig?: { __typename?: 'SameDayDispatchConfigEntity', pickupAppointmentTimeThreshold: number, deliveryAppointmentTimeThreshold: number, isSpecialColorCode: string, isNextInRouteColorCode: string, isPastDeadlineColorCode: string, pickupWithinTimeWindowColorCode: string, deliveryWithinTimeWindowColorCode: string } | null };

export type UpdateSameDayDispatchConfigMutationVariables = Exact<{
  updateSameDayDispatchConfigInput: UpdateSameDayDispatchConfigInput;
}>;


export type UpdateSameDayDispatchConfigMutation = { __typename?: 'Mutation', updateSameDayDispatchConfig: { __typename?: 'SameDayDispatchConfigEntity', uuid: string } };

export type UpdateShipmentMutationVariables = Exact<{
  updateShipmentInput: UpdateShipmentInput;
}>;


export type UpdateShipmentMutation = { __typename?: 'Mutation', updateShipment: { __typename?: 'StandardShipmentEntity', uuid: string } };

export type AcceptOrderDelegationMutationVariables = Exact<{
  input: AcceptOrderDelegationInput;
}>;


export type AcceptOrderDelegationMutation = { __typename?: 'Mutation', acceptOrderDelegation: { __typename: 'DelegatedOrderInboxItemEntity', uuid: string, status: OrderDelegationStatus, duplicateOrderUuid?: string | null, acceptedAt?: any | null } };

export type DeclineOrderDelegationMutationVariables = Exact<{
  input: DeclineOrderDelegationInput;
}>;


export type DeclineOrderDelegationMutation = { __typename?: 'Mutation', declineOrderDelegation: { __typename: 'DelegatedOrderInboxItemEntity', uuid: string, status: OrderDelegationStatus, declinedAt?: any | null } };

export type DelegatedOrdersInboxQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DelegatedOrdersInboxFilterInput>;
}>;


export type DelegatedOrdersInboxQuery = { __typename?: 'Query', delegatedOrdersInbox: { __typename?: 'DelegatedOrderInboxItemConnection', edges: Array<{ __typename?: 'DelegatedOrderInboxItemEdge', cursor: string, node: { __typename: 'DelegatedOrderInboxItemEntity', uuid: string, createdAt: any, acceptedAt?: any | null, declinedAt?: any | null, expiredAt?: any | null, expiresAt?: any | null, revokedAt?: any | null, duplicateOrderUuid?: string | null, originatorCompanyName: string, originatorCompanyUuid: string, scope: OrderDelegationScope, status: OrderDelegationStatus, pickupHandling?: DelegatedPickupHandling | null, offerSummary?: { __typename: 'DelegationOfferSummaryEntity', version: number, scope: OrderDelegationScope, refNumbers: Array<string>, earliestServiceDate?: string | null, packageCount: number, totalWeight?: number | null, weightUnits?: string | null, hazmat: boolean, inBond: boolean, offerNote?: string | null, pickupLocation?: { __typename: 'OfferLocationEntity', city?: string | null, state?: string | null, zip?: string | null } | null, deliveryLocation?: { __typename: 'OfferLocationEntity', city?: string | null, state?: string | null, zip?: string | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type DelegatedOrdersOutboxQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DelegatedOrdersOutboxFilterInput>;
}>;


export type DelegatedOrdersOutboxQuery = { __typename?: 'Query', delegatedOrdersOutbox: { __typename?: 'OrderDelegationConnection', edges: Array<{ __typename?: 'OrderDelegationEdge', cursor: string, node: { __typename: 'OrderDelegationEntity', uuid: string, originalOrderUuid: string, originalOrderName?: string | null, duplicateOrderUuid?: string | null, organizationPeerUuid: string, originatorCompanyUuid: string, originatorCompanyName: string, executingCompanyUuid: string, executingCompanyName: string, scope: OrderDelegationScope, status: OrderDelegationStatus, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, revokedAt?: any | null, expiredAt?: any | null, completedAt?: any | null, expiresAt?: any | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type InitiateDelegatedOrderReviewMutationVariables = Exact<{
  input: InitiateDelegatedOrderReviewInput;
}>;


export type InitiateDelegatedOrderReviewMutation = { __typename?: 'Mutation', initiateDelegatedOrderReview: { __typename: 'InitiateDelegatedOrderReviewOutput', draftOrderUuid: string } };

export type OrderEndCustomerSharingQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderEndCustomerSharingQuery = { __typename?: 'Query', standardOrder: { __typename: 'StandardOrderEntity', uuid: string, delegations: Array<{ __typename: 'OrderDelegationEntity', uuid: string, sharesEndCustomer: boolean }>, delegationAsDuplicate?: { __typename: 'OrderDelegationEntity', uuid: string, sharesEndCustomer: boolean, endCustomer?: { __typename?: 'DelegationEndCustomer', name: string, contactName?: string | null, emails: Array<string>, phone?: string | null, billingEmails: Array<string>, addressBookTotalCount: number, peopleTotalCount: number, address?: { __typename?: 'DelegationEndCustomerAddress', name?: string | null, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null, addressBook: Array<{ __typename?: 'DelegationEndCustomerAddress', name?: string | null, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string }>, people: Array<{ __typename?: 'DelegationEndCustomerPerson', name?: string | null, emails: Array<string>, phone?: string | null }>, executorOrganization?: { __typename?: 'DelegationEndCustomerExecutorOrganization', uuid: string, displayName: string } | null } | null } | null } };

export type PendingOrderDelegationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingOrderDelegationsCountQuery = { __typename?: 'Query', pendingOrderDelegationsCount: number };

export type RejectDelegationEndCustomerLinkMutationVariables = Exact<{
  input: RejectDelegationEndCustomerLinkInput;
}>;


export type RejectDelegationEndCustomerLinkMutation = { __typename?: 'Mutation', rejectDelegationEndCustomerLink: { __typename: 'OrderDelegationEntity', uuid: string } };

export type CreateOrderDelegationRuleMutationVariables = Exact<{
  input: CreateOrderDelegationRuleInput;
}>;


export type CreateOrderDelegationRuleMutation = { __typename?: 'Mutation', createOrderDelegationRule: { __typename?: 'OrderDelegationRuleEntity', uuid: string, name: string, priority: number, isActive: boolean, timing: OrderDelegationRuleTiming, scope: OrderDelegationScope, pickupHandling?: DelegatedPickupHandling | null, shareEndCustomer: boolean, offerWindowMinutes?: number | null, organizationPeerUuid: string, peerCompanyName: string, customerOrganizationUuid?: string | null, customerName?: string | null, zipCodes: Array<string>, orderSources: Array<OrderSource>, createdAt: any, updatedAt: any, terminals: Array<{ __typename?: 'OrderDelegationRuleTerminalEntity', uuid: string, name: string }> } };

export type DeleteOrderDelegationRuleMutationVariables = Exact<{
  input: DeleteOrderDelegationRuleInput;
}>;


export type DeleteOrderDelegationRuleMutation = { __typename?: 'Mutation', deleteOrderDelegationRule: boolean };

export type OrderDelegationRuleFieldsFragment = { __typename?: 'OrderDelegationRuleEntity', uuid: string, name: string, priority: number, isActive: boolean, timing: OrderDelegationRuleTiming, scope: OrderDelegationScope, pickupHandling?: DelegatedPickupHandling | null, shareEndCustomer: boolean, offerWindowMinutes?: number | null, organizationPeerUuid: string, peerCompanyName: string, customerOrganizationUuid?: string | null, customerName?: string | null, zipCodes: Array<string>, orderSources: Array<OrderSource>, createdAt: any, updatedAt: any, terminals: Array<{ __typename?: 'OrderDelegationRuleTerminalEntity', uuid: string, name: string }> };

export type OrderDelegationRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderDelegationRulesQuery = { __typename?: 'Query', orderDelegationRules: Array<{ __typename?: 'OrderDelegationRuleEntity', uuid: string, name: string, priority: number, isActive: boolean, timing: OrderDelegationRuleTiming, scope: OrderDelegationScope, pickupHandling?: DelegatedPickupHandling | null, shareEndCustomer: boolean, offerWindowMinutes?: number | null, organizationPeerUuid: string, peerCompanyName: string, customerOrganizationUuid?: string | null, customerName?: string | null, zipCodes: Array<string>, orderSources: Array<OrderSource>, createdAt: any, updatedAt: any, terminals: Array<{ __typename?: 'OrderDelegationRuleTerminalEntity', uuid: string, name: string }> }> };

export type UpdateOrderDelegationRuleMutationVariables = Exact<{
  input: UpdateOrderDelegationRuleInput;
}>;


export type UpdateOrderDelegationRuleMutation = { __typename?: 'Mutation', updateOrderDelegationRule: { __typename?: 'OrderDelegationRuleEntity', uuid: string, name: string, priority: number, isActive: boolean, timing: OrderDelegationRuleTiming, scope: OrderDelegationScope, pickupHandling?: DelegatedPickupHandling | null, shareEndCustomer: boolean, offerWindowMinutes?: number | null, organizationPeerUuid: string, peerCompanyName: string, customerOrganizationUuid?: string | null, customerName?: string | null, zipCodes: Array<string>, orderSources: Array<OrderSource>, createdAt: any, updatedAt: any, terminals: Array<{ __typename?: 'OrderDelegationRuleTerminalEntity', uuid: string, name: string }> } };

export type AcceptOrganizationPeerMutationVariables = Exact<{
  input: AcceptOrganizationPeerInput;
}>;


export type AcceptOrganizationPeerMutation = { __typename?: 'Mutation', acceptOrganizationPeer: { __typename: 'OrganizationPeerEntity', uuid: string, status: OrganizationPeerStatus, peerCompanyUuid: string, peerCompanyName: string, organizationUuid?: string | null, acceptedAt?: any | null, createdAt: any } };

export type ArchiveOrganizationMutationVariables = Exact<{
  input: ArchiveOrganizationInput;
}>;


export type ArchiveOrganizationMutation = { __typename?: 'Mutation', archiveOrganization: { __typename?: 'ArchiveOrganizationSuccessOutput', organization: { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultRecoveryTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, includeInExpeditorsScorecard: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, emitPieceLevelWebhooks: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null } } | { __typename?: 'MutationErrorOutput', message: string } };

export type AvailablePeerCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailablePeerCompaniesQuery = { __typename?: 'Query', availablePeerCompanies: Array<{ __typename: 'AvailablePeerCompanyEntity', uuid: string, name: string }> };

export type CreateOrganizationPeerMutationVariables = Exact<{
  input: CreateOrganizationPeerInput;
}>;


export type CreateOrganizationPeerMutation = { __typename?: 'Mutation', createOrganizationPeer: { __typename: 'OrganizationPeerEntity', uuid: string, status: OrganizationPeerStatus, peerCompanyUuid: string, peerCompanyName: string, organizationUuid?: string | null, createdAt: any } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'CreateOrganizationSuccessOutput', organization: { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultRecoveryTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, includeInExpeditorsScorecard: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, emitPieceLevelWebhooks: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null } } | { __typename?: 'MutationErrorOutput', message: string } };

export type IncomingOrganizationPeersQueryVariables = Exact<{
  input: FindPaginatedOrganizationPeersInput;
}>;


export type IncomingOrganizationPeersQuery = { __typename?: 'Query', incomingOrganizationPeers: { __typename?: 'OrganizationPeerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrganizationPeerEdge', node: { __typename: 'OrganizationPeerEntity', uuid: string, status: OrganizationPeerStatus, companyUuid: string, companyName: string, peerCompanyUuid: string, peerCompanyName: string, organizationUuid?: string | null, acceptedAt?: any | null, revokedAt?: any | null, createdAt: any } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type OrganizationAddressFragment = { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, driverInstructions?: string | null };

export type OrganizationAgentTerminalFragment = { __typename?: 'TerminalEntity', uuid: string, name: string, code: string, serviceRegion?: { __typename?: 'ServiceRegionEntity', id: string, name: string } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, driverInstructions?: string | null } };

export type OrganizationForAddressBookQueryVariables = Exact<{
  input: FindOrganizationInput;
}>;


export type OrganizationForAddressBookQuery = { __typename?: 'Query', organization: { __typename?: 'OrganizationEntity', addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, driverInstructions?: string | null }>, agentFields?: { __typename?: 'AgentFieldsEntity', activeTerminals: Array<{ __typename?: 'TerminalEntity', uuid: string, name: string, code: string, serviceRegion?: { __typename?: 'ServiceRegionEntity', id: string, name: string } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, driverInstructions?: string | null } }> } | null } };

export type OrganizationForFrontendHookQueryVariables = Exact<{
  input: FindOrganizationInput;
}>;


export type OrganizationForFrontendHookQuery = { __typename?: 'Query', organization: { __typename?: 'OrganizationEntity', uuid: string, isActive: boolean, types: Array<OrganizationType>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, line1: string, city: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null }>, customerFields?: { __typename?: 'CustomerFieldsEntity', emitPieceLevelWebhooks: boolean } | null } };

export type AddressForOrganizationFragment = { __typename?: 'AddressEntity', uuid: string, line1: string, city: string };

export type ContactPersonForOrganizationFragment = { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null };

export type OrganizationNotesQueryVariables = Exact<{
  findOrganizationNotesInput: FindOrganizationNotesInput;
}>;


export type OrganizationNotesQuery = { __typename?: 'Query', organizationNotes: Array<{ __typename?: 'ContactCommentEntity', uuid: string, createdAt: any, updatedAt: any, comment: string, authorName: string }> };

export type OrganizationPeersQueryVariables = Exact<{
  input: FindPaginatedOrganizationPeersInput;
}>;


export type OrganizationPeersQuery = { __typename?: 'Query', organizationPeers: { __typename?: 'OrganizationPeerConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrganizationPeerEdge', node: { __typename: 'OrganizationPeerEntity', uuid: string, status: OrganizationPeerStatus, companyUuid: string, companyName: string, peerCompanyUuid: string, peerCompanyName: string, organizationUuid?: string | null, acceptedAt?: any | null, revokedAt?: any | null, createdAt: any, autoAcceptOffers: boolean, shareProgressWithPeer: boolean, autoApplyPeerAccessorials: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type OrganizationFragment = { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultRecoveryTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, includeInExpeditorsScorecard: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, emitPieceLevelWebhooks: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null };

export type OrganizationQueryVariables = Exact<{
  input: FindOrganizationInput;
}>;


export type OrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultRecoveryTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, includeInExpeditorsScorecard: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, emitPieceLevelWebhooks: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null } };

export type PaginatedOrganizationFragment = { __typename?: 'OrganizationEntity', name: string, uuid: string, referenceNumber?: string | null, types: Array<OrganizationType> };

export type PaginatedOrganizationsQueryVariables = Exact<{
  findPaginatedOrganizationsInput: FindPaginatedOrganizationsInput;
}>;


export type PaginatedOrganizationsQuery = { __typename?: 'Query', paginatedOrganizations: { __typename?: 'OrganizationConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrganizationEdge', node: { __typename?: 'OrganizationEntity', name: string, uuid: string, referenceNumber?: string | null, types: Array<OrganizationType> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type RestoreOrganizationMutationVariables = Exact<{
  input: RestoreOrganizationInput;
}>;


export type RestoreOrganizationMutation = { __typename?: 'Mutation', restoreOrganization: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'RestoreOrganizationSuccessOutput', organization: { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultRecoveryTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, includeInExpeditorsScorecard: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, emitPieceLevelWebhooks: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null } } };

export type RevokeOrganizationPeerMutationVariables = Exact<{
  input: RevokeOrganizationPeerInput;
}>;


export type RevokeOrganizationPeerMutation = { __typename?: 'Mutation', revokeOrganizationPeer: { __typename: 'OrganizationPeerEntity', uuid: string, status: OrganizationPeerStatus, peerCompanyUuid: string, peerCompanyName: string, organizationUuid?: string | null, revokedAt?: any | null, createdAt: any } };

export type SetOrganizationEmitPieceLevelWebhooksMutationVariables = Exact<{
  organizationUuid: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetOrganizationEmitPieceLevelWebhooksMutation = { __typename?: 'Mutation', setOrganizationEmitPieceLevelWebhooks: { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultRecoveryTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, includeInExpeditorsScorecard: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, emitPieceLevelWebhooks: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null } };

export type UpdateOrganizationPeersSettingsMutationVariables = Exact<{
  input: UpdateOrganizationPeersSettingsInput;
}>;


export type UpdateOrganizationPeersSettingsMutation = { __typename?: 'Mutation', updateOrganizationPeersSettings: Array<{ __typename: 'OrganizationPeerEntity', uuid: string, autoAcceptOffers: boolean, shareProgressWithPeer: boolean, autoApplyPeerAccessorials: boolean }> };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'UpdateOrganizationSuccessOutput', organization: { __typename?: 'OrganizationEntity', isActive: boolean, uuid: string, name: string, types: Array<OrganizationType>, referenceNumber?: string | null, email?: string | null, isaId?: string | null, ediApplicationId?: string | null, ediContactCode?: string | null, stediPartnerId?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string } | null, customerFields?: { __typename?: 'CustomerFieldsEntity', defaultAddressUuid?: string | null, businessDivisionUuid?: string | null, invoiceOrOrderIdentifier?: string | null, defaultInboundEdiServiceUuid?: string | null, defaultOutboundEdiServiceUuid?: string | null, defaultInboundOutboundEdiServiceUuid?: string | null, defaultServiceUuid?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, showEdiReferenceNumbersOnOrderPage: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, defaultOrdinaryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultRecoveryTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, defaultFuelSurcharge?: number | null, defaultDimFactor?: number | null, defaultUseTariff: boolean, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, includeInExpeditorsScorecard: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, emitPieceLevelWebhooks: boolean, services: Array<{ __typename?: 'CustomerServiceEntity', uuid: string }>, customerVehicleTypes: Array<{ __typename?: 'CustomerVehicleTypeEntity', id: string, vehicleTypeUuid: string }>, referenceNumberLabels: Array<{ __typename?: 'CustomerReferenceNumberLabelEntity', name: string }> } | null } } };

export type IncomingPeerAccessorialMappingsQueryVariables = Exact<{
  peerUuid: Scalars['String']['input'];
}>;


export type IncomingPeerAccessorialMappingsQuery = { __typename?: 'Query', incomingPeerAccessorialMappings: Array<{ __typename: 'IncomingPeerAccessorialMappingEntity', uuid: string, executorAccessorialName: string, originatorAccessorialUuid?: string | null, suggestedAccessorialUuid?: string | null }> };

export type MapPeerAccessorialMutationVariables = Exact<{
  input: MapPeerAccessorialInput;
}>;


export type MapPeerAccessorialMutation = { __typename?: 'Mutation', mapPeerAccessorial: { __typename: 'IncomingPeerAccessorialMappingEntity', uuid: string, executorAccessorialName: string, originatorAccessorialUuid?: string | null, suggestedAccessorialUuid?: string | null } };

export type MappableAccessorialsQueryVariables = Exact<{ [key: string]: never; }>;


export type MappableAccessorialsQuery = { __typename?: 'Query', accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string }> }> };

export type PeerAccessorialSharesQueryVariables = Exact<{
  peerUuid: Scalars['String']['input'];
}>;


export type PeerAccessorialSharesQuery = { __typename?: 'Query', peerAccessorialShares: Array<string> };

export type SetPeerAccessorialSharesMutationVariables = Exact<{
  input: SetPeerAccessorialSharesInput;
}>;


export type SetPeerAccessorialSharesMutation = { __typename?: 'Mutation', setPeerAccessorialShares: Array<string> };

export type ShareableAccessorialsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShareableAccessorialsQuery = { __typename?: 'Query', accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null }> };

export type IncomingPeerServiceMappingsQueryVariables = Exact<{
  peerUuid: Scalars['String']['input'];
}>;


export type IncomingPeerServiceMappingsQuery = { __typename?: 'Query', incomingPeerServiceMappings: Array<{ __typename: 'IncomingPeerServiceMappingEntity', uuid: string, originatorServiceName: string, executorServiceUuid?: string | null, suggestedServiceUuid?: string | null }> };

export type MapPeerServiceMutationVariables = Exact<{
  input: MapPeerServiceInput;
}>;


export type MapPeerServiceMutation = { __typename?: 'Mutation', mapPeerService: { __typename: 'IncomingPeerServiceMappingEntity', uuid: string, originatorServiceName: string, executorServiceUuid?: string | null, suggestedServiceUuid?: string | null } };

export type PeerServiceSharesQueryVariables = Exact<{
  peerUuid: Scalars['String']['input'];
}>;


export type PeerServiceSharesQuery = { __typename?: 'Query', peerServiceShares: Array<{ __typename: 'PeerServiceShareEntity', uuid: string, serviceUuid: string, serviceName: string, isActive: boolean }> };

export type SetPeerServiceSharesMutationVariables = Exact<{
  input: SetPeerServiceSharesInput;
}>;


export type SetPeerServiceSharesMutation = { __typename?: 'Mutation', setPeerServiceShares: Array<{ __typename: 'PeerServiceShareEntity', uuid: string, serviceUuid: string, serviceName: string, isActive: boolean }> };

export type AutoCreateRoutesV2MutationVariables = Exact<{
  input: AutoCreateRoutesV2Input;
}>;


export type AutoCreateRoutesV2Mutation = { __typename?: 'Mutation', autoCreateRoutesV2: { __typename?: 'AutoCreateRoutesV2Output', dryRun: boolean, replayed: boolean, eligibleStopCount: number, matchedStopCount: number, unmatchedStopCount: number, routesCreated: number, routesAppended: number, routeSummaries: Array<{ __typename?: 'AutoCreateRoutesV2RouteSummary', routeUuid?: string | null, routeName: string, created: boolean, stopsAttached: number, equipmentUuid?: string | null, equipmentName?: string | null, truckFitNote?: TruckFitNote | null, stops: Array<{ __typename?: 'AutoCreateRoutesV2StopSummary', stopUuid: string, stopType?: StopType | null, orderName?: string | null, customerName?: string | null, addressOneLine?: string | null }> }>, unmatchedStops: Array<{ __typename?: 'AutoCreateRoutesV2UnmatchedStop', stopUuid: string, reason: UnmatchedStopReason, stopType?: StopType | null, orderName?: string | null, customerName?: string | null, addressOneLine?: string | null, matchAttempt?: string | null }> } };

export type BookedStopResourceFragment = { __typename?: 'BookedStopResourceEntity', id: string, name: string, timeZone: string, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } };

export type BookedStopsByResourceQueryVariables = Exact<{
  input: FindBookedStopsByResourceInput;
}>;


export type BookedStopsByResourceQuery = { __typename?: 'Query', bookedStopsByResource: { __typename?: 'BookedStopsByResourceOutput', serviceDateIso8601: string, isTruncated: boolean, isResourceSetTruncated: boolean, groups: Array<{ __typename?: 'BookedStopGroupEntity', kind: BookedStopGroupKind, bookedCount: number, customerBookedCount: number, routedCount: number, isOverCapacity: boolean, schedulingResource?: { __typename?: 'BookedStopResourceEntity', id: string, name: string, timeZone: string, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } } | null, stops: Array<{ __typename?: 'BookedStopEntity', stopUuid: string, orderUuid: string, orderName: string, houseAirwayBillOfLadingNumber?: string | null, customerName: string, addressLine1: string, city: string, zipcode: string, appointmentTime: any, endAppointmentTime?: any | null, attribution: BookedStopAttribution, isRouted: boolean, routeUuid?: string | null, routeName?: string | null, candidateResources: Array<{ __typename?: 'BookedStopResourceEntity', id: string, name: string, timeZone: string, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }> }> } };

export type CreateDispatchViewMutationVariables = Exact<{
  input: DispatchViewCreateInput;
}>;


export type CreateDispatchViewMutation = { __typename?: 'Mutation', createDispatchView: { __typename: 'DispatchViewCreateSuccessOutput', dispatchView: { __typename?: 'DispatchViewEntity', id: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type DispatchViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type DispatchViewsQuery = { __typename?: 'Query', dispatchViews: Array<{ __typename?: 'DispatchViewEntity', id: string, name: string, tabIndex: number, useMinimizedAppointmentTime: boolean, numberOfStops: number, showCompleteStops: boolean, routeCardStopTableColumnWidths?: any | null, routeCardWidth: number, routeCardStopTableFields: Array<DispatchTableField>, dispatchTableColors: Array<{ __typename?: 'DispatchTableColorEntity', uuid: string, fields: Array<DispatchTableColorField>, appointmentStartWithinMinutes?: number | null, appointmentEndWithinMinutes?: number | null, deadlineDateFilter?: DeadlineDateFilter | null, hasAppointmentDate?: boolean | null, isSpecial?: boolean | null, color: string, active: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null }> }> };

export type RemoveDispatchViewMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveDispatchViewMutation = { __typename?: 'Mutation', removeDispatchView: { __typename?: 'DispatchViewEntity', id: string } };

export type UpdateDispatchViewMutationVariables = Exact<{
  input: DispatchViewUpdateInput;
}>;


export type UpdateDispatchViewMutation = { __typename?: 'Mutation', updateDispatchView: { __typename: 'DispatchViewUpdateSuccessOutput', dispatchView: { __typename?: 'DispatchViewEntity', id: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type DriversForSelectionQueryVariables = Exact<{ [key: string]: never; }>;


export type DriversForSelectionQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, active: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string, name: string, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, maxVolume?: any | null, maxWeight?: any | null } | null } | null }> };

export type GenerateRoutesPreviewRouteFragment = { __typename?: 'RouteGenerationPreviewEntity', stops: Array<{ __typename?: 'StopPreviewForRouteGenerationEntity', odometer: number, eta: any, stop: { __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, status: StopStatus, stopType?: StopType | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, weight: number, service?: { __typename?: 'ServiceEntity', uuid: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } | null, address: { __typename?: 'AddressEntity', name: string, line1: string, city: string, zip: string, latitude?: number | null, longitude?: number | null } } }>, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, vehicleType?: { __typename?: 'VehicleTypeEntity', name: string } | null } | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverReferenceNumber?: string | null } };

export type GenerateRoutesQueryVariables = Exact<{
  generateRoutesInput: GenerateRoutesInput;
}>;


export type GenerateRoutesQuery = { __typename?: 'Query', generateRoutes: { __typename?: 'GenerateRoutesOutput', unassignedStopUuids?: Array<string> | null, errorMessage?: string | null, routes?: Array<{ __typename?: 'RouteGenerationPreviewEntity', stops: Array<{ __typename?: 'StopPreviewForRouteGenerationEntity', odometer: number, eta: any, stop: { __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, status: StopStatus, stopType?: StopType | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, weight: number, service?: { __typename?: 'ServiceEntity', uuid: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } | null, address: { __typename?: 'AddressEntity', name: string, line1: string, city: string, zip: string, latitude?: number | null, longitude?: number | null } } }>, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, vehicleType?: { __typename?: 'VehicleTypeEntity', name: string } | null } | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverReferenceNumber?: string | null } }> | null } };

export type DispatchTableColorFragment = { __typename?: 'DispatchTableColorEntity', uuid: string, fields: Array<DispatchTableColorField>, appointmentStartWithinMinutes?: number | null, appointmentEndWithinMinutes?: number | null, deadlineDateFilter?: DeadlineDateFilter | null, hasAppointmentDate?: boolean | null, isSpecial?: boolean | null, color: string, active: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null };

export type DispatchTableColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type DispatchTableColorsQuery = { __typename?: 'Query', dispatchTableColors: Array<{ __typename?: 'DispatchTableColorEntity', uuid: string, fields: Array<DispatchTableColorField>, appointmentStartWithinMinutes?: number | null, appointmentEndWithinMinutes?: number | null, deadlineDateFilter?: DeadlineDateFilter | null, hasAppointmentDate?: boolean | null, isSpecial?: boolean | null, color: string, active: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null }> };

export type UpdateDispatchTableColorsMutationVariables = Exact<{
  input: UpdateDispatchTableColorsInput;
}>;


export type UpdateDispatchTableColorsMutation = { __typename?: 'Mutation', updateDispatchTableColors: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateDispatchTableColorsSuccessOutput' } };

export type CreateRouteSlotMutationVariables = Exact<{
  routeSlotCreateInput: RouteSlotCreateInput;
  routeUuid: Scalars['String']['input'];
}>;


export type CreateRouteSlotMutation = { __typename?: 'Mutation', createRouteSlot: Array<{ __typename?: 'RouteSlotEntity', uuid: string } | null> };

export type DriverFragment = { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> };

export type DriversQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DriversQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }> };

export type DriversWithRoutesQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type DriversWithRoutesQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, route?: { __typename?: 'RouteEntity', uuid: string } | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }> };

export type GetOptimizationResultsQueryVariables = Exact<{
  routeOptimizationUuid: Scalars['String']['input'];
}>;


export type GetOptimizationResultsQuery = { __typename?: 'Query', getOptimizationResults?: { __typename?: 'OptimizationResultsOutput', slots?: Array<string> | null, error?: string | null } | null };

export type GroupByStopsQueryVariables = Exact<{
  groupByStopsInput: GroupByStopsInput;
}>;


export type GroupByStopsQuery = { __typename?: 'Query', groupByStops: { __typename: 'GroupByStopsOutput', count?: number | null, rows: { __typename: 'GroupsOutput', groupValues: Array<string | null> } | { __typename: 'StopOutput', stopValues: Array<{ __typename?: 'GroupByStopEntity', ADDRESS: string, ADDRESS_TYPE?: string | null, APPOINTMENT?: any | null, APPOINTMENT_SCHEDULED?: boolean | null, APPOINTMENT_DATE?: any | null, APPOINTMENT_REQUIRED?: boolean | null, APPOINTMENT_TIME?: any | null, BUSINESS_DIVISION?: string | null, CITY?: string | null, CONSIGNEE?: string | null, CUSTOMER?: string | null, DIMS?: string | null, DUE_DATE?: any | null, INBOUND_NAME?: string | null, INBOUND_CITY?: string | null, INBOUND_METHOD?: InboundMethod | null, INBOUND_TERMINAL?: string | null, INBOUND_ZIP?: string | null, MAWB?: string | null, ORDER_NAME?: string | null, ORDER_NOTES?: string | null, ORDER_NUMBER: string, SERVICE_LEVEL?: string | null, orderUuid: string, OUTBOUND_NAME?: string | null, OUTBOUND_CITY?: string | null, OUTBOUND_METHOD?: OutboundMethod | null, OUTBOUND_TERMINAL?: string | null, OUTBOUND_ZIP?: string | null, PIECE_COUNT?: number | null, REF_NUMBER?: Array<string> | null, ROUTE_NAME?: string | null, SERVICE_DATE?: any | null, SERVICE_TIME?: any | null, SPECIAL?: boolean | null, SPECIAL_INSTRUCTIONS?: string | null, ORDER_STATUS?: string | null, STOP_TYPE?: string | null, TAGS?: Array<string> | null, TERMINAL?: string | null, TOTAL_CHARGES?: number | null, uuid: string, VEHICLE_TYPE_NAME?: string | null, WEIGHT?: number | null, ZIP_CODE?: string | null, orderNumberCellColor?: string | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null } | null> } } };

export type NumberOfStopsQueryVariables = Exact<{
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  standardStopTypes?: InputMaybe<Array<StandardStopType> | StandardStopType>;
  statuses?: InputMaybe<Array<StopStatus> | StopStatus>;
  orderStatuses?: InputMaybe<Array<OrderStatus> | OrderStatus>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery> | PickupOrDelivery>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput> | FindStopsFiltersInput>;
  groupFilters?: InputMaybe<GroupByStopsFiltersInput>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NumberOfStopsQuery = { __typename?: 'Query', numberOfStops: number };

export type RouteEtaQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RouteEtaQuery = { __typename?: 'Query', route: { __typename?: 'RouteEntity', uuid: string, etas: Array<{ __typename?: 'EtaEntity', arrivalTime: any, finishTime: any }> } };

export type AddRouteStopMutationVariables = Exact<{
  addRouteStopInput: AddRouteStopInput;
}>;


export type AddRouteStopMutation = { __typename?: 'Mutation', addRouteStop: { __typename?: 'StandardStopEntity', uuid: string, stopType?: StopType | null, status: StopStatus } };

export type ApplyRouteOptimizationMutationVariables = Exact<{
  input: ApplyRouteOptimizationInput;
}>;


export type ApplyRouteOptimizationMutation = { __typename?: 'Mutation', applyRouteOptimization: number };

export type AssignHelperToRouteMutationVariables = Exact<{
  helperUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
}>;


export type AssignHelperToRouteMutation = { __typename?: 'Mutation', assignHelperToRoute: Array<{ __typename?: 'DriverOnRouteEntity', uuid: string }> };

export type CreateAppointmentsForRouteMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  canReadIntelligenceBoard?: Scalars['Boolean']['input'];
}>;


export type CreateAppointmentsForRouteMutation = { __typename?: 'Mutation', createAppointmentsForRoute: { __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, startTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, routePathUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, driverPayType?: DriverPayType | null, perMileRate?: number | null, percentGrossRevenueRate?: number | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> } };

export type CreateRoutePathsMutationVariables = Exact<{
  routePathsCreateInput: RoutePathsCreateInput;
}>;


export type CreateRoutePathsMutation = { __typename?: 'Mutation', createRoutePaths: Array<{ __typename?: 'RoutePathEntity', uuid: string, coordinates?: Array<Array<number>> | null, route: { __typename?: 'RouteEntity', uuid: string } } | null> };

export type CreateRoutesMutationVariables = Exact<{
  createRoutesInput: CreateRoutesInput;
  canReadIntelligenceBoard?: Scalars['Boolean']['input'];
}>;


export type CreateRoutesMutation = { __typename?: 'Mutation', createRoutes: Array<{ __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, startTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, routePathUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, driverPayType?: DriverPayType | null, perMileRate?: number | null, percentGrossRevenueRate?: number | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> }> };

export type DeleteSlotsFromRouteMutationVariables = Exact<{
  deleteSlotsFromRouteInput: DeleteSlotsFromRouteInput;
}>;


export type DeleteSlotsFromRouteMutation = { __typename?: 'Mutation', deleteSlotsFromRoute?: number | null };

export type DriversForHelpersQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type DriversForHelpersQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, route?: { __typename?: 'RouteEntity', uuid: string } | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }> };

export type OptimizationCompletedFieldsFragment = { __typename?: 'OptimizationCompleted', unplacedStopCount?: number | null, proposedRoutes: Array<{ __typename?: 'ProposedRouteSequence', routeUuid: string, stopOrder: Array<string>, lateStops?: Array<{ __typename?: 'LateStop', stopUuid: string, minutesLate: number, serviceStartsAt: string, windowEndsAt: string }> | null }>, summary: { __typename?: 'RouteOptimizationSummary', proposedDistanceMiles: number, proposedDurationSeconds: number, currentDistanceMiles: number, currentDurationSeconds: number, deltaDistanceMiles: number, deltaDurationSeconds: number } };

export type OptimizationStatusQueryVariables = Exact<{
  jobUuid: Scalars['String']['input'];
}>;


export type OptimizationStatusQuery = { __typename?: 'Query', optimizationStatus: { __typename: 'OptimizationCompleted', unplacedStopCount?: number | null, proposedRoutes: Array<{ __typename?: 'ProposedRouteSequence', routeUuid: string, stopOrder: Array<string>, lateStops?: Array<{ __typename?: 'LateStop', stopUuid: string, minutesLate: number, serviceStartsAt: string, windowEndsAt: string }> | null }>, summary: { __typename?: 'RouteOptimizationSummary', proposedDistanceMiles: number, proposedDurationSeconds: number, currentDistanceMiles: number, currentDurationSeconds: number, deltaDistanceMiles: number, deltaDurationSeconds: number } } | { __typename: 'OptimizationFailed', message: string } | { __typename: 'OptimizationPending', jobUuid: string } };

export type OptimizeRouteSequenceMutationVariables = Exact<{
  input: OptimizeRouteSequenceInput;
}>;


export type OptimizeRouteSequenceMutation = { __typename?: 'Mutation', optimizeRouteSequence: { __typename: 'OptimizationCompleted', unplacedStopCount?: number | null, proposedRoutes: Array<{ __typename?: 'ProposedRouteSequence', routeUuid: string, stopOrder: Array<string>, lateStops?: Array<{ __typename?: 'LateStop', stopUuid: string, minutesLate: number, serviceStartsAt: string, windowEndsAt: string }> | null }>, summary: { __typename?: 'RouteOptimizationSummary', proposedDistanceMiles: number, proposedDurationSeconds: number, currentDistanceMiles: number, currentDurationSeconds: number, deltaDistanceMiles: number, deltaDurationSeconds: number } } | { __typename: 'OptimizationPending', jobUuid: string } };

export type RunOptimizationMutationVariables = Exact<{
  createOptimizationRunInput: CreateOptimizationRunDto;
}>;


export type RunOptimizationMutation = { __typename?: 'Mutation', runOptimization: { __typename?: 'RouteOptimizationEntity', uuid: string } };

export type OptimizeRoutesTogetherMutationVariables = Exact<{
  input: OptimizeRoutesTogetherInput;
}>;


export type OptimizeRoutesTogetherMutation = { __typename?: 'Mutation', optimizeRoutesTogether: { __typename: 'OptimizationPending', jobUuid: string } };

export type ReassignRouteSlotMutationVariables = Exact<{
  routeSlotReassignInput: RouteSlotReassignInput;
  canReadIntelligenceBoard?: Scalars['Boolean']['input'];
}>;


export type ReassignRouteSlotMutation = { __typename?: 'Mutation', reassignRouteSlot?: Array<{ __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, startTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, routePathUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, driverPayType?: DriverPayType | null, perMileRate?: number | null, percentGrossRevenueRate?: number | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> }> | null };

export type RemoveHelperFromRouteMutationVariables = Exact<{
  helperUuid: Scalars['String']['input'];
  routeUuid: Scalars['String']['input'];
}>;


export type RemoveHelperFromRouteMutation = { __typename?: 'Mutation', removeHelperFromRoute: string };

export type RemoveRouteMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveRouteMutation = { __typename?: 'Mutation', removeRoute: { __typename?: 'RouteEntity', uuid: string } };

export type RouteInfoFragment = { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number };

export type RouteListItemFragment = { __typename: 'RouteEntity', uuid: string, name: string, startTime?: any | null, defaultStartTime?: any | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, totalDistanceInMeters?: number | null, totalTimeInSeconds?: number | null, routeSlotsUpdatedAt?: any | null, routePathUpdatedAt?: any | null, locked: boolean, date: any, productivity?: { __typename?: 'RouteProductivityEntity', status?: ProductivityStatus | null, hasTimeAllowances: boolean, productivityRatio?: number | null } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, agentId?: string | null, phoneNumber: string, driverPayType?: DriverPayType | null, perMileRate?: number | null, percentGrossRevenueRate?: number | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, measurementSystem: MeasurementSystem, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, maxWeight?: any | null, maxVolume?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', uuid: string, status: StopStatus, stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, specialInstructions?: string | null, serviceDate?: any | null, completedAt?: any | null, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, overrideServiceTimeInMinutes?: number | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null }, shipment?: { __typename: 'StandardShipmentEntity', uuid: string, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refNumbers: Array<string>, refusedBy?: string | null, hazmat: boolean, hazmatClass?: HazmatClass | null, unNumber?: string | null, hasDamage: boolean, hasIssues: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }> } | null } | null }> }> };

export type RoutePathByRouteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RoutePathByRouteQuery = { __typename?: 'Query', route: { __typename?: 'RouteEntity', routePath?: { __typename?: 'RoutePathEntity', uuid: string, coordinates?: Array<Array<number>> | null, route: { __typename?: 'RouteEntity', uuid: string } } | null } };

export type RoutePathFragment = { __typename?: 'RoutePathEntity', uuid: string, coordinates?: Array<Array<number>> | null, route: { __typename?: 'RouteEntity', uuid: string } };

export type RoutePathsQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type RoutePathsQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', routePath?: { __typename?: 'RoutePathEntity', uuid: string, coordinates?: Array<Array<number>> | null, route: { __typename?: 'RouteEntity', uuid: string } } | null }> };

export type RouteFragment = { __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, startTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, routePathUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, driverPayType?: DriverPayType | null, perMileRate?: number | null, percentGrossRevenueRate?: number | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> };

export type RoutesForDispatchV2QueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  versionId?: InputMaybe<Scalars['String']['input']>;
  canReadIntelligenceBoard: Scalars['Boolean']['input'];
}>;


export type RoutesForDispatchV2Query = { __typename?: 'Query', paginatedRoutes: { __typename?: 'RouteConnection', totalCount: number, versionId?: string | null, edges: Array<{ __typename?: 'RouteEdge', node: { __typename: 'RouteEntity', uuid: string, name: string, startTime?: any | null, defaultStartTime?: any | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, totalDistanceInMeters?: number | null, totalTimeInSeconds?: number | null, routeSlotsUpdatedAt?: any | null, routePathUpdatedAt?: any | null, locked: boolean, date: any, productivity?: { __typename?: 'RouteProductivityEntity', status?: ProductivityStatus | null, hasTimeAllowances: boolean, productivityRatio?: number | null } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, agentId?: string | null, phoneNumber: string, driverPayType?: DriverPayType | null, perMileRate?: number | null, percentGrossRevenueRate?: number | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, measurementSystem: MeasurementSystem, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, maxWeight?: any | null, maxVolume?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', uuid: string, status: StopStatus, stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, specialInstructions?: string | null, serviceDate?: any | null, completedAt?: any | null, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, overrideServiceTimeInMinutes?: number | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null }, shipment?: { __typename: 'StandardShipmentEntity', uuid: string, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refNumbers: Array<string>, refusedBy?: string | null, hazmat: boolean, hazmatClass?: HazmatClass | null, unNumber?: string | null, hasDamage: boolean, hasIssues: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }> } | null } | null }> }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type RoutesQueryVariables = Exact<{
  date?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  canReadIntelligenceBoard?: Scalars['Boolean']['input'];
}>;


export type RoutesQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, startTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, routePathUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, driverPayType?: DriverPayType | null, perMileRate?: number | null, percentGrossRevenueRate?: number | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> }> };

export type RoutesSamsaraVehicleLocationsQueryVariables = Exact<{
  routeUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RoutesSamsaraVehicleLocationsQuery = { __typename?: 'Query', routesSamsaraVehicleLocations: { __typename?: 'RoutesSamsaraVehicleLocationsOutput', routeCoordinates: Array<{ __typename?: 'RouteCoordinatesEntity', routeUuid: string, latitude: number, longitude: number, updatedAt?: any | null, headingDegrees?: number | null, speedMph?: number | null, placeLabel?: string | null }> } };

export type RoutesWithDriverMobilePhoneCoordinatesQueryVariables = Exact<{
  routeUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RoutesWithDriverMobilePhoneCoordinatesQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, currentDriverMobilePhoneLocation?: { __typename?: 'RouteCoordinatesEntity', latitude: number, longitude: number, updatedAt?: any | null } | null }> };

export type RoutesWithEtaQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type RoutesWithEtaQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, date: any, totalTimeInSeconds?: number | null, nameManuallyChanged: boolean, locked: boolean, defaultStartTime?: any | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, lastDispatched?: any | null, etas: Array<{ __typename?: 'EtaEntity', arrivalTime: any, finishTime: any }>, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string }>, equipments: Array<{ __typename?: 'EquipmentEntity', name: string, type: EquipmentType, uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, phoneNumber: string, uuid: string, defaultVehicle?: { __typename?: 'EquipmentEntity', name: string, uuid: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> }> };

export type PaginatedRoutesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  routeUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  routeSort?: InputMaybe<RouteSort>;
  versionId?: InputMaybe<Scalars['String']['input']>;
  canReadIntelligenceBoard?: Scalars['Boolean']['input'];
}>;


export type PaginatedRoutesQuery = { __typename?: 'Query', paginatedRoutes: { __typename?: 'RouteConnection', totalCount: number, versionId?: string | null, edges: Array<{ __typename?: 'RouteEdge', node: { __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, startTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, routePathUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, driverPayType?: DriverPayType | null, perMileRate?: number | null, percentGrossRevenueRate?: number | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type StopOnRouteDetailQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StopOnRouteDetailQuery = { __typename?: 'Query', stop: { __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null } };

export type StopOnRouteListItemFragment = { __typename: 'StandardStopEntity', uuid: string, status: StopStatus, stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, specialInstructions?: string | null, serviceDate?: any | null, completedAt?: any | null, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, overrideServiceTimeInMinutes?: number | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null }, shipment?: { __typename: 'StandardShipmentEntity', uuid: string, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refNumbers: Array<string>, refusedBy?: string | null, hazmat: boolean, hazmatClass?: HazmatClass | null, unNumber?: string | null, hasDamage: boolean, hasIssues: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }> } | null } | null };

export type StopOnRouteFragment = { __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null };

export type OrderForStopOnRouteFragment = { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } };

export type UpdateRouteMutationVariables = Exact<{
  updateRouteInput: UpdateRouteInput;
}>;


export type UpdateRouteMutation = { __typename?: 'Mutation', updateRoute: { __typename?: 'RouteEntity', uuid: string } };

export type UpdateStandaloneStopMutationVariables = Exact<{
  updateStandaloneStopInput: UpdateStandaloneStopInput;
}>;


export type UpdateStandaloneStopMutation = { __typename?: 'Mutation', updateStandaloneStop: { __typename: 'StandardStopEntity', uuid: string, status: StopStatus, stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, specialInstructions?: string | null, serviceDate?: any | null, completedAt?: any | null, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, overrideServiceTimeInMinutes?: number | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null }, shipment?: { __typename: 'StandardShipmentEntity', uuid: string, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refNumbers: Array<string>, refusedBy?: string | null, hazmat: boolean, hazmatClass?: HazmatClass | null, unNumber?: string | null, hasDamage: boolean, hasIssues: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }> } | null } | null } };

export type UpdateVehicleForRouteMutationVariables = Exact<{
  routeUuid: Scalars['String']['input'];
  vehicleUuid: Scalars['String']['input'];
}>;


export type UpdateVehicleForRouteMutation = { __typename?: 'Mutation', updateVehicleForRoute: { __typename?: 'RouteEntity', uuid: string } };

export type SameDayDispatchRouteSlotFragment = { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, previousSlotDistanceMeters?: number | null, previousSlotDurationSeconds?: number | null, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, endAppointmentTime?: any | null, notes?: string | null, isSpecial?: boolean | null, stopType?: StopType | null, status: StopStatus, routeChangeAcknowledged: boolean, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, leg?: { __typename?: 'LegEntity', uuid: string, shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, name: string, pickedDate?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }> } } | null }> };

export type SameDayDispatchRouteFragment = { __typename?: 'RouteEntity', uuid: string, nameManuallyChanged: boolean, name: string, company: { __typename?: 'CompanyEntity', uuid: string }, equipments: Array<{ __typename?: 'EquipmentEntity', type: EquipmentType, name: string, uuid: string, samsaraVehicleId?: string | null, samsaraIsDeactivated?: boolean | null }>, nextRouteSlot?: { __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string }> } | null, helpers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, mobilePhoneLatitude?: number | null, mobilePhoneLongitude?: number | null, mobileCoordsLastUpdatedAt?: any | null, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string, samsaraVehicleId?: string | null, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, previousSlotDistanceMeters?: number | null, previousSlotDurationSeconds?: number | null, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, endAppointmentTime?: any | null, notes?: string | null, isSpecial?: boolean | null, stopType?: StopType | null, status: StopStatus, routeChangeAcknowledged: boolean, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, leg?: { __typename?: 'LegEntity', uuid: string, shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, name: string, pickedDate?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }> } } | null }> }> };

export type SameDayDispatchRoutesQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type SameDayDispatchRoutesQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, nameManuallyChanged: boolean, name: string, company: { __typename?: 'CompanyEntity', uuid: string }, equipments: Array<{ __typename?: 'EquipmentEntity', type: EquipmentType, name: string, uuid: string, samsaraVehicleId?: string | null, samsaraIsDeactivated?: boolean | null }>, nextRouteSlot?: { __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string }> } | null, helpers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, mobilePhoneLatitude?: number | null, mobilePhoneLongitude?: number | null, mobileCoordsLastUpdatedAt?: any | null, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string, samsaraVehicleId?: string | null, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, previousSlotDistanceMeters?: number | null, previousSlotDurationSeconds?: number | null, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, endAppointmentTime?: any | null, notes?: string | null, isSpecial?: boolean | null, stopType?: StopType | null, status: StopStatus, routeChangeAcknowledged: boolean, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, leg?: { __typename?: 'LegEntity', uuid: string, shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, name: string, pickedDate?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }> } } | null }> }> }> };

export type SamsaraVehicleStatsFeedQueryVariables = Exact<{
  samsaraVehicleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SamsaraVehicleStatsFeedQuery = { __typename?: 'Query', samsaraVehicleStatsFeed?: { __typename?: 'SamsaraVehicleStatsFeedEntity', data: Array<{ __typename?: 'SamsaraVehicleStatsEntity', id: string, gps?: Array<{ __typename?: 'SamsaraGpsPingEntity', latitude: number, longitude: number, time: string }> | null }>, pagination: { __typename?: 'SamsaraPaginationEntity', hasNextPage: boolean, endCursor: string } } | null };

export type SendRouteToAgentMutationVariables = Exact<{
  sendRouteToAgentInput: SendRouteToAgentInput;
}>;


export type SendRouteToAgentMutation = { __typename?: 'Mutation', sendRouteToAgent: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'SendRouteToAgentSuccessOutput', route: { __typename?: 'RouteEntity', uuid: string } } };

export type StopBySearchTextFragment = { __typename?: 'StandardStopEntity', uuid: string, status: StopStatus, completedAt?: any | null, isAttempt: boolean, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, detailedStatus?: string | null, refusedBy?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, enableDriverSettlement?: boolean | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null }> };

export type StopOnRouteBySearchTextFragment = { __typename?: 'StandardStopEntity', appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, completedAt?: any | null, stopType?: StopType | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any } | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any, terminal?: { __typename?: 'TerminalEntity', code: string } | null } | null } | null };

export type StopsBySearchTextQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type StopsBySearchTextQuery = { __typename?: 'Query', stopsBySearchText: Array<{ __typename?: 'StandardStopEntity', uuid: string, status: StopStatus, completedAt?: any | null, isAttempt: boolean, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, detailedStatus?: string | null, refusedBy?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, enableDriverSettlement?: boolean | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null }> }> };

export type StopsOnRoutesBySearchTextQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
}>;


export type StopsOnRoutesBySearchTextQuery = { __typename?: 'Query', stopsOnRoutesBySearchText: Array<{ __typename?: 'StandardStopEntity', appointmentTime?: any | null, endAppointmentTime?: any | null, status: StopStatus, completedAt?: any | null, stopType?: StopType | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any } | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any, terminal?: { __typename?: 'TerminalEntity', code: string } | null } | null } | null }> };

export type GroupableDispatchTableFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GroupableDispatchTableFieldsQuery = { __typename?: 'Query', groupableDispatchTableFields: Array<DispatchTableField> };

export type RecurringRunHeaderFragment = { __typename?: 'RecurringRunHeaderEntity', uuid: string, name: string, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null };

export type StopBaseFragment = { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, stopIntention?: StopIntention | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null };

export type StopQueryForOverrideMinutesQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StopQueryForOverrideMinutesQuery = { __typename?: 'Query', stop: { __typename?: 'StandardStopEntity', uuid: string, overrideServiceTimeInMinutes?: number | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', uuid: string } | null } | null } };

export type StopTableGroupRowFragment = { __typename?: 'StopTableGroupRowEntity', key?: string | null, label?: string | null, count: number };

export type StopUuidsInGroupQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<StopSort>;
  sorts?: InputMaybe<Array<StopSort> | StopSort>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  cacheStartIndex?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  addressType?: InputMaybe<StandardStopType>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  statuses?: InputMaybe<Array<StopStatus> | StopStatus>;
  orderStatuses?: InputMaybe<Array<OrderStatus> | OrderStatus>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery> | PickupOrDelivery>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  onHandTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  includeRecurringRunHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput> | FindStopsFiltersInput>;
  groupFilters?: InputMaybe<GroupByStopsFiltersInput>;
  groupBy?: InputMaybe<StopTableGroupByInput>;
}>;


export type StopUuidsInGroupQuery = { __typename?: 'Query', stopUuidsInGroup: { __typename?: 'StopUuidsInGroupOutput', uuids: Array<string>, exceedsCap: boolean } };

export type StopFragment = { __typename: 'CachedStopEntity', recurringRunUuid?: string | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, order?: { __typename?: 'OrderForCachedStop', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, warehouseUuid?: string | null, businessDivisionName?: string | null, contactUuid: string, contactName: string, serviceUuid?: string | null, serviceName?: string | null, name: string, vehicleTypeName?: string | null, refNumbers: Array<string>, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, receivedDate?: any | null, pickedDate?: any | null, inboundStopType?: PickupOrDelivery | null, outboundStopType?: PickupOrDelivery | null, inboundName?: string | null, outboundName?: string | null, inboundZip?: string | null, outboundZip?: string | null, inboundCity?: string | null, outboundCity?: string | null, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, orderComments: Array<{ __typename?: 'OrderCommentForCachedStop', comment: string }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, packages: Array<{ __typename?: 'PackageForCachedStop', weight?: number | null, length?: number | null, width?: number | null, height?: number | null, quantity: number, description?: string | null }> } | null, stop: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, stopIntention?: StopIntention | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null }, linkedEndStop?: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, stopIntention?: StopIntention | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null } | null, otherStop?: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, stopIntention?: StopIntention | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null } | null };

export type StopsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<StopSort>;
  sorts?: InputMaybe<Array<StopSort> | StopSort>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  cacheStartIndex?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  addressType?: InputMaybe<StandardStopType>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  statuses?: InputMaybe<Array<StopStatus> | StopStatus>;
  orderStatuses?: InputMaybe<Array<OrderStatus> | OrderStatus>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery> | PickupOrDelivery>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  onHandTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  includeRecurringRunHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput> | FindStopsFiltersInput>;
  groupFilters?: InputMaybe<GroupByStopsFiltersInput>;
  groupBy?: InputMaybe<StopTableGroupByInput>;
}>;


export type StopsQuery = { __typename?: 'Query', stops: { __typename?: 'CachedStopConnection', totalCount?: number | null, recurringRunsCount?: number | null, groupRowsHasMore?: boolean | null, groupRows?: Array<{ __typename?: 'StopTableGroupRowEntity', key?: string | null, label?: string | null, count: number }> | null, edges: Array<{ __typename?: 'CachedStopEdge', node: { __typename: 'CachedStopEntity', recurringRunUuid?: string | null, stopDetails?: { __typename?: 'StopDetailsOutput', message?: string | null, stopDetailsStatus: StopDetailsStatus } | null, order?: { __typename?: 'OrderForCachedStop', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, warehouseUuid?: string | null, businessDivisionName?: string | null, contactUuid: string, contactName: string, serviceUuid?: string | null, serviceName?: string | null, name: string, vehicleTypeName?: string | null, refNumbers: Array<string>, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, receivedDate?: any | null, pickedDate?: any | null, inboundStopType?: PickupOrDelivery | null, outboundStopType?: PickupOrDelivery | null, inboundName?: string | null, outboundName?: string | null, inboundZip?: string | null, outboundZip?: string | null, inboundCity?: string | null, outboundCity?: string | null, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, orderComments: Array<{ __typename?: 'OrderCommentForCachedStop', comment: string }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, packages: Array<{ __typename?: 'PackageForCachedStop', weight?: number | null, length?: number | null, width?: number | null, height?: number | null, quantity: number, description?: string | null }> } | null, stop: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, stopIntention?: StopIntention | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null }, linkedEndStop?: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, stopIntention?: StopIntention | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null } | null, otherStop?: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, stopIntention?: StopIntention | null, hasPreviousAttempt?: boolean | null, isSpecial?: boolean | null, specialInstructions?: string | null, serviceDate?: any | null, serviceTimeInMinutes?: number | null, terminalUuid?: string | null, terminalName?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentScheduled?: boolean | null, appointmentRequired?: boolean | null, deadlineDate?: any | null, deliveryDate?: any | null, createdAt: any, standardStopType?: StandardStopType | null, totalCharge?: number | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, line2?: string | null, city: string, zip: string, state: string, routeName?: string | null, routeNameUuid?: string | null, latitude?: number | null, longitude?: number | null } | null } | null } | { __typename: 'RecurringRunHeaderEntity', uuid: string, name: string, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type UnassignedStopPinsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<StopSort>;
  sorts?: InputMaybe<Array<StopSort> | StopSort>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
  cacheStartIndex?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  addressType?: InputMaybe<StandardStopType>;
  appointmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  previouslyAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  businessDivisionUuid?: InputMaybe<Scalars['String']['input']>;
  serviceLevelUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  onHand?: InputMaybe<Scalars['Boolean']['input']>;
  isPicked?: InputMaybe<Scalars['Boolean']['input']>;
  isRefusedFilter?: InputMaybe<BooleanFilterV2>;
  statuses?: InputMaybe<Array<StopStatus> | StopStatus>;
  orderStatuses?: InputMaybe<Array<OrderStatus> | OrderStatus>;
  customerUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  includeUnscheduledStops?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTimeFilters?: InputMaybe<DateFilterStartEnd>;
  transferPending?: InputMaybe<Scalars['Boolean']['input']>;
  pickupOrDeliveryTypes?: InputMaybe<Array<PickupOrDelivery> | PickupOrDelivery>;
  requiresRecovery?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  onHandTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  hideOnHold?: InputMaybe<Scalars['Boolean']['input']>;
  hideStopsWithoutAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  routeNameUuid?: InputMaybe<Scalars['String']['input']>;
  includeRecurringRunHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Array<FindStopsFiltersInput> | FindStopsFiltersInput>;
}>;


export type UnassignedStopPinsQuery = { __typename?: 'Query', stops: { __typename?: 'CachedStopConnection', totalCount?: number | null, edges: Array<{ __typename?: 'CachedStopEdge', node: { __typename: 'CachedStopEntity', stop: { __typename?: 'CachedStopBaseEntity', uuid: string, stopType?: StopType | null, serviceDate?: any | null, appointmentTime?: any | null, endAppointmentTime?: any | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address?: { __typename?: 'AddressForCachedStop', name: string, line1: string, city: string, state: string, zip: string, latitude?: number | null, longitude?: number | null } | null }, order?: { __typename?: 'OrderForCachedStop', uuid: string, name: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, contactName: string, serviceName?: string | null } | null } | { __typename: 'RecurringRunHeaderEntity' } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type DispatchTextDriverMutationVariables = Exact<{
  textDriverInput: TextDriverInput;
}>;


export type DispatchTextDriverMutation = { __typename?: 'Mutation', dispatchTextDriver: { __typename?: 'DispatchTextDriverOutput', textSent: boolean, textNotSentReason?: string | null, driver: { __typename?: 'DriverEntity', uuid: string } } };

export type UpdateRouteDriversMutationVariables = Exact<{
  updateRouteDriversInput: UpdateRouteDriversInput;
}>;


export type UpdateRouteDriversMutation = { __typename?: 'Mutation', updateRouteDrivers: { __typename?: 'RouteEntity', uuid: string } };

export type UpdateRouteSlotsMutationVariables = Exact<{
  updateRouteSlotsInput: UpdateRouteSlotsInput;
}>;


export type UpdateRouteSlotsMutation = { __typename?: 'Mutation', updateRouteSlots?: { __typename?: 'RouteEntity', uuid: string } | null };

export type DocumentationItemQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type DocumentationItemQuery = { __typename?: 'Query', documentationItem: { __typename?: 'DocumentationItemEntity', uuid: string, slug: string, title: string, code?: string | null, html: string, updatedAt: any } };

export type DocumentationSearchQueryVariables = Exact<{
  input: DocumentationSearchInput;
}>;


export type DocumentationSearchQuery = { __typename?: 'Query', documentationSearch: Array<{ __typename?: 'DocumentationSearchResultEntity', uuid: string, slug: string, title: string, code?: string | null, topicUuid: string, topicTitle: string, snippet: string }> };

export type DocumentationTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentationTopicsQuery = { __typename?: 'Query', documentationTopics: Array<{ __typename?: 'DocumentationTopicEntity', uuid: string, title: string, description?: string | null, items: Array<{ __typename?: 'DocumentationItemSummaryEntity', uuid: string, title: string, slug: string, code?: string | null }> }> };

export type CompanyDocumentsQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  statusFilter: FindCompanyDocumentStatusFilter;
  searchText?: InputMaybe<Scalars['String']['input']>;
  uploadDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompanyDocumentsQuery = { __typename?: 'Query', companyDocuments: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> };

export type CompanySchemasQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanySchemasQuery = { __typename?: 'Query', companySchemas: Array<{ __typename?: 'SchemaWithAnchorsEntity', uuid: string, companyUuid?: string | null, contactUuid?: string | null, isMultiPage: boolean, name: string, originalFilename: string, scannedDocumentType: ScannedDocumentType }> };

export type CustomDocumentNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomDocumentNamesQuery = { __typename?: 'Query', customDocumentNames: Array<{ __typename?: 'CustomDocumentNameEntity', uuid: string, name: string }> };

export type CustomDriverFormFragment = { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string };

export type DeleteCustomDocumentNameMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteCustomDocumentNameMutation = { __typename?: 'Mutation', deleteCustomDocumentName: { __typename?: 'CustomDocumentNameEntity', uuid: string } };

export type DocumentFragment = { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null };

export type SplitAndProcessOrderDocumentsMutationVariables = Exact<{
  splitAndProcessOrderDocumentsInput: SplitAndProcessOrderDocumentsInput;
}>;


export type SplitAndProcessOrderDocumentsMutation = { __typename?: 'Mutation', splitAndProcessOrderDocuments: boolean };

export type UpdateDocumentsMutationVariables = Exact<{
  updateDocumentsInput: UpdateDocumentsInput;
}>;


export type UpdateDocumentsMutation = { __typename?: 'Mutation', updateDocuments: Array<{ __typename?: 'DocumentEntity', uuid: string }> };

export type CreateAdjustmentStopDriverMapMutationVariables = Exact<{
  input: AdjustmentStopDriverMapCreateInput;
}>;


export type CreateAdjustmentStopDriverMapMutation = { __typename?: 'Mutation', createAdjustmentStopDriverMap?: { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } } | null };

export type CreateDriverSettlementBillMutationVariables = Exact<{
  createDriverSettlementBillInput: CreateDriverSettlementBillInput;
}>;


export type CreateDriverSettlementBillMutation = { __typename?: 'Mutation', createDriverSettlementBill: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, settlementDeductions: Array<{ __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null }> } };

export type DeleteStopDriverMapMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteStopDriverMapMutation = { __typename?: 'Mutation', deleteStopDriverMap: { __typename?: 'StopDriverMapEntity', uuid: string } };

export type DriverCompletedStopsFragment = { __typename?: 'DriverCompletedStopsEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapForCompletedStopsEntity', serviceDate?: any | null, stopType?: StopType | null, isLineHaul?: boolean | null, driver: { __typename?: 'DriverEntity', uuid: string }, linehaulStartTerminal?: { __typename?: 'TerminalEntity', code: string } | null, linehaulEndTerminal?: { __typename?: 'TerminalEntity', code: string } | null, order?: { __typename?: 'StandardOrderEntity', name: string, pieceCount?: number | null, weight: number, totalCharge: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, service?: { __typename?: 'ServiceEntity', name: string } | null, startStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null } | null }> };

export type StopDriverMapForDriverCompletedStopsFragment = { __typename?: 'StopDriverMapForCompletedStopsEntity', serviceDate?: any | null, stopType?: StopType | null, isLineHaul?: boolean | null, driver: { __typename?: 'DriverEntity', uuid: string }, linehaulStartTerminal?: { __typename?: 'TerminalEntity', code: string } | null, linehaulEndTerminal?: { __typename?: 'TerminalEntity', code: string } | null, order?: { __typename?: 'StandardOrderEntity', name: string, pieceCount?: number | null, weight: number, totalCharge: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, service?: { __typename?: 'ServiceEntity', name: string } | null, startStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null } | null };

export type DriverCompletedStopsLogQueryVariables = Exact<{
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type DriverCompletedStopsLogQuery = { __typename?: 'Query', driverCompletedStopsLog: { __typename?: 'DriverCompletedStopsEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapForCompletedStopsEntity', serviceDate?: any | null, stopType?: StopType | null, isLineHaul?: boolean | null, driver: { __typename?: 'DriverEntity', uuid: string }, linehaulStartTerminal?: { __typename?: 'TerminalEntity', code: string } | null, linehaulEndTerminal?: { __typename?: 'TerminalEntity', code: string } | null, order?: { __typename?: 'StandardOrderEntity', name: string, pieceCount?: number | null, weight: number, totalCharge: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, service?: { __typename?: 'ServiceEntity', name: string } | null, startStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null } | null }> } };

export type DriverSettlementBillByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DriverSettlementBillByUuidQuery = { __typename?: 'Query', driverSettlementBill: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, settlementDeductions: Array<{ __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null }> } };

export type DriverSettlementBillForDownloadFragment = { __typename?: 'DriverSettlementBillForDownloadEntity', billUuid: string, billName?: string | null, billStartDate?: any | null, billEndDate?: any | null, settlementDate?: any | null, finalizedDate?: any | null, driverFirstName?: string | null, driverLastName?: string | null, driverStationCode?: string | null, settlementDeductions?: Array<{ __typename?: 'SettlementDeductionForDownloadEntity', name?: string | null, flatRate?: number | null, percentageDecimalRate?: number | null }> | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapForDownloadEntity', stopUuid: string, arrivedAt?: any | null, completedAt?: any | null, stopType?: StopType | null, serviceName?: string | null, shipperBillOfLadingNumber?: string | null, orderName?: string | null, billingPartyContactName?: string | null, isAttempt: boolean, address?: { __typename?: 'StopDriverMapAddressForDownloadEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number }, chargeBreakdown: { __typename?: 'SettlementStopChargeBreakdownOutput', totalEligibleAmount: number, driverPayout: number, lines: Array<{ __typename?: 'SettlementChargeBreakdownLineOutput', lineType: SettlementChargeBreakdownLineType, label: string, total?: number | null, flatRate?: number | null, percentageRate?: number | null, eligibleAmount: number }>, payBasis: { __typename?: 'SettlementPayBasisOutput', basisType: SettlementPayBasisType, percentageOutOf100?: number | null, flatAmount?: number | null, perMileRate?: number | null, miles?: number | null, minPay?: number | null, maxPay?: number | null, isBounded: boolean } }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, weight?: number | null }>, otherDriversOnStop: Array<{ __typename?: 'StopDriverMapOtherDriverForDownloadEntity', uuid: string, firstName: string, lastName: string }>, order?: { __typename?: 'StandardOrderEntity', totalCharge: number } | null }> };

export type StopDriverMapForDownloadFragment = { __typename?: 'StopDriverMapForDownloadEntity', stopUuid: string, arrivedAt?: any | null, completedAt?: any | null, stopType?: StopType | null, serviceName?: string | null, shipperBillOfLadingNumber?: string | null, orderName?: string | null, billingPartyContactName?: string | null, isAttempt: boolean, address?: { __typename?: 'StopDriverMapAddressForDownloadEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number }, chargeBreakdown: { __typename?: 'SettlementStopChargeBreakdownOutput', totalEligibleAmount: number, driverPayout: number, lines: Array<{ __typename?: 'SettlementChargeBreakdownLineOutput', lineType: SettlementChargeBreakdownLineType, label: string, total?: number | null, flatRate?: number | null, percentageRate?: number | null, eligibleAmount: number }>, payBasis: { __typename?: 'SettlementPayBasisOutput', basisType: SettlementPayBasisType, percentageOutOf100?: number | null, flatAmount?: number | null, perMileRate?: number | null, miles?: number | null, minPay?: number | null, maxPay?: number | null, isBounded: boolean } }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, weight?: number | null }>, otherDriversOnStop: Array<{ __typename?: 'StopDriverMapOtherDriverForDownloadEntity', uuid: string, firstName: string, lastName: string }>, order?: { __typename?: 'StandardOrderEntity', totalCharge: number } | null };

export type StopDriverMapAddressForDownloadFragment = { __typename?: 'StopDriverMapAddressForDownloadEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string };

export type DriverSettlementBillFragment = { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, settlementDeductions: Array<{ __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null }> };

export type DriverSettlementBillsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type DriverSettlementBillsCountQuery = { __typename?: 'Query', driverSettlementBillsCountForCompany: number };

export type DriverSettlementBillsForDownloadQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DriverSettlementBillsForDownloadQuery = { __typename?: 'Query', driverSettlementBillsForDownload: Array<{ __typename?: 'DriverSettlementBillForDownloadEntity', billUuid: string, billName?: string | null, billStartDate?: any | null, billEndDate?: any | null, settlementDate?: any | null, finalizedDate?: any | null, driverFirstName?: string | null, driverLastName?: string | null, driverStationCode?: string | null, settlementDeductions?: Array<{ __typename?: 'SettlementDeductionForDownloadEntity', name?: string | null, flatRate?: number | null, percentageDecimalRate?: number | null }> | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapForDownloadEntity', stopUuid: string, arrivedAt?: any | null, completedAt?: any | null, stopType?: StopType | null, serviceName?: string | null, shipperBillOfLadingNumber?: string | null, orderName?: string | null, billingPartyContactName?: string | null, isAttempt: boolean, address?: { __typename?: 'StopDriverMapAddressForDownloadEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number }, chargeBreakdown: { __typename?: 'SettlementStopChargeBreakdownOutput', totalEligibleAmount: number, driverPayout: number, lines: Array<{ __typename?: 'SettlementChargeBreakdownLineOutput', lineType: SettlementChargeBreakdownLineType, label: string, total?: number | null, flatRate?: number | null, percentageRate?: number | null, eligibleAmount: number }>, payBasis: { __typename?: 'SettlementPayBasisOutput', basisType: SettlementPayBasisType, percentageOutOf100?: number | null, flatAmount?: number | null, perMileRate?: number | null, miles?: number | null, minPay?: number | null, maxPay?: number | null, isBounded: boolean } }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, weight?: number | null }>, otherDriversOnStop: Array<{ __typename?: 'StopDriverMapOtherDriverForDownloadEntity', uuid: string, firstName: string, lastName: string }>, order?: { __typename?: 'StandardOrderEntity', totalCharge: number } | null }> }> };

export type DriverSettlementBillsV2QueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type DriverSettlementBillsV2Query = { __typename?: 'Query', driverSettlementBills: { __typename?: 'DriverSettlementBillConnection', totalCount?: number | null, edges: Array<{ __typename?: 'DriverSettlementBillEdge', node: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, payPeriod: string, settlementDate?: any | null, finalizedDate?: any | null, snapshotExists: boolean, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, paymentInformation: { __typename?: 'DriverSettlementPaymentEntity', eligiblePay: any, netAdjustments: any, finalPay: any } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type DriverSettlementBillsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortByBillStartDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type DriverSettlementBillsQuery = { __typename?: 'Query', driverSettlementBills: { __typename?: 'DriverSettlementBillConnection', totalCount?: number | null, edges: Array<{ __typename?: 'DriverSettlementBillEdge', node: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, settlementDeductions: Array<{ __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type FinalizeDriverSettlementBillsMutationVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FinalizeDriverSettlementBillsMutation = { __typename?: 'Mutation', finalizeDriverSettlementBills: number };

export type InvoiceShipmentByStopUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceShipmentByStopUuidQuery = { __typename?: 'Query', stop: { __typename?: 'StandardStopEntity', shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, shipmentType: ShipmentType, status: ShipmentStatus, name: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFreightCharge: number, totalFuelCharge: number, totalCharge: number }, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, paperworkMarkedComplete?: boolean | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, quantity: number, description?: string | null, rate: number, total: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, postedFuelSurchargeRate?: number | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffType: TariffType, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null }> } | null } };

export type RemoveDriverSettlementBillMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveDriverSettlementBillMutation = { __typename?: 'Mutation', removeDriverSettlementBill: { __typename?: 'DriverSettlementBillEntity', uuid: string } };

export type CreateSettlementDeductionMutationVariables = Exact<{
  settlementDeductionCreateInput: SettlementDeductionCreateInput;
}>;


export type CreateSettlementDeductionMutation = { __typename?: 'Mutation', createSettlementDeduction: { __typename?: 'SettlementDeductionEntity', uuid: string } };

export type RemoveSettlementDeductionMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveSettlementDeductionMutation = { __typename?: 'Mutation', removeSettlementDeduction: { __typename?: 'SettlementDeductionEntity', uuid: string } };

export type SettlementDeductionFragment = { __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null };

export type UpdateSettlementDeductionMutationVariables = Exact<{
  settlementDeductionUpdateInput: SettlementDeductionUpdateInput;
}>;


export type UpdateSettlementDeductionMutation = { __typename?: 'Mutation', updateSettlementDeduction: { __typename?: 'SettlementDeductionEntity', uuid: string } };

export type StopDriverMapSummaryFragment = { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null }, stop: { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, arrivedAt?: any | null, completedAt?: any | null, shipment?: { __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery } } | null, address: { __typename?: 'AddressEntity', name: string } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null, settlementDate?: any | null } | null, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number, payBasis: { __typename?: 'SettlementPayBasisOutput', minPay?: number | null, maxPay?: number | null, isBounded: boolean } } };

export type StopDriverMapWithDriverSettlementTotalAmountsFragment = { __typename?: 'StopDriverMapEntity', driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number, payBasis: { __typename?: 'SettlementPayBasisOutput', minPay?: number | null, maxPay?: number | null, isBounded: boolean } } };

export type StopDriverMapFragment = { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null }, stop: { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, arrivedAt?: any | null, completedAt?: any | null, shipment?: { __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', name: string } | null }, packages: Array<{ __typename?: 'PackageEntity', quantity: number, weight?: number | null }> } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } }, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null } | null };

export type StopDriverMapsSummaryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  completedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  completionStatus?: InputMaybe<StopCompletionStatus>;
  settlementStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  settlementEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  sortByCompletedDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  sortBySettlementDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  onDriverSettlementBill?: InputMaybe<Scalars['Boolean']['input']>;
  driverSettlementFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  onInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  chargesFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceStatuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stopTypes?: InputMaybe<Array<StopType> | StopType>;
  includeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  excludeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeTotalAmounts: Scalars['Boolean']['input'];
}>;


export type StopDriverMapsSummaryQuery = { __typename?: 'Query', stopDriverMaps: { __typename?: 'StopDriverMapConnection', totalCount?: number | null, edges: Array<{ __typename?: 'StopDriverMapEdge', node: { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null }, stop: { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, arrivedAt?: any | null, completedAt?: any | null, shipment?: { __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery } } | null, address: { __typename?: 'AddressEntity', name: string } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null, settlementDate?: any | null } | null, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number, payBasis: { __typename?: 'SettlementPayBasisOutput', minPay?: number | null, maxPay?: number | null, isBounded: boolean } } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type StopDriverMapsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  completedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  completionStatus?: InputMaybe<StopCompletionStatus>;
  sortByCompletedDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  onDriverSettlementBill?: InputMaybe<Scalars['Boolean']['input']>;
  driverSettlementFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  onInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  chargesFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceStatuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  driverSettlementBillUuid?: InputMaybe<Scalars['String']['input']>;
  driverUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stopTypes?: InputMaybe<Array<StopType> | StopType>;
  includeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  excludeStopDriverMapUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type StopDriverMapsQuery = { __typename?: 'Query', stopDriverMaps: { __typename?: 'StopDriverMapConnection', totalCount?: number | null, edges: Array<{ __typename?: 'StopDriverMapEdge', node: { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null }, stop: { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, arrivedAt?: any | null, completedAt?: any | null, shipment?: { __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, service?: { __typename?: 'ServiceEntity', name: string } | null }, packages: Array<{ __typename?: 'PackageEntity', quantity: number, weight?: number | null }> } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } }, driverSettlementTotalAmounts: { __typename?: 'DriverSettlementTotalAmountsOutput', totalChargesForSettlement: number, totalEligibleAmountForStop: number, totalDriverPayout: number }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', name?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type UpdateDriverSettlementBillMutationVariables = Exact<{
  updateDriverSettlementBillInput: UpdateDriverSettlementBillInput;
}>;


export type UpdateDriverSettlementBillMutation = { __typename?: 'Mutation', updateDriverSettlementBill: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, settlementDeductions: Array<{ __typename?: 'SettlementDeductionEntity', uuid: string, adjustmentType?: SettlementAdjustmentType | null, name: string, flatRate?: number | null, percentageDecimalRate?: number | null }> } };

export type UpdateStopDriverMapMutationVariables = Exact<{
  input: UpdateStopDriverMapInput;
}>;


export type UpdateStopDriverMapMutation = { __typename?: 'Mutation', updateStopDriverMap: { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } } };

export type CreateCsvOrderMappingMutationVariables = Exact<{
  createCsvOrderMappingInput: CreateCsvOrderMappingInput;
}>;


export type CreateCsvOrderMappingMutation = { __typename?: 'Mutation', createCsvOrderMapping: { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, enableDynamicInboundOrOutboundStop: boolean, enableInboundStop: boolean, enableOutboundStop: boolean, pickupOrDeliveryDefaultValue?: PickupOrDelivery | null, deadlineDateDefaultValue?: any | null, deadlineTypeDefaultValue?: DeadlineType | null, stopTypeDefaultValue?: StandardStopType | null, freightBillingMethodDefaultValue?: FreightBillingMethod | null, updateOrderOnDuplicateBolNumber?: boolean | null, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', sourceColumnName: string, targetFieldType: CsvOrderMappingTargetFieldType }>, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, serviceLevelDefaultValue?: { __typename?: 'ServiceEntity', uuid: string } | null } };

export type CsvOrderFieldMappingDetailedFragment = { __typename?: 'CsvOrderFieldMappingEntity', sourceColumnName: string, targetFieldType: CsvOrderMappingTargetFieldType };

export type CsvOrderMappingDetailedFragment = { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, enableDynamicInboundOrOutboundStop: boolean, enableInboundStop: boolean, enableOutboundStop: boolean, pickupOrDeliveryDefaultValue?: PickupOrDelivery | null, deadlineDateDefaultValue?: any | null, deadlineTypeDefaultValue?: DeadlineType | null, stopTypeDefaultValue?: StandardStopType | null, freightBillingMethodDefaultValue?: FreightBillingMethod | null, updateOrderOnDuplicateBolNumber?: boolean | null, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', sourceColumnName: string, targetFieldType: CsvOrderMappingTargetFieldType }>, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, serviceLevelDefaultValue?: { __typename?: 'ServiceEntity', uuid: string } | null };

export type CsvOrderMappingQueryVariables = Exact<{
  input: CsvOrderMappingQueryInput;
}>;


export type CsvOrderMappingQuery = { __typename?: 'Query', csvOrderMapping: { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, enableDynamicInboundOrOutboundStop: boolean, enableInboundStop: boolean, enableOutboundStop: boolean, pickupOrDeliveryDefaultValue?: PickupOrDelivery | null, deadlineDateDefaultValue?: any | null, deadlineTypeDefaultValue?: DeadlineType | null, stopTypeDefaultValue?: StandardStopType | null, freightBillingMethodDefaultValue?: FreightBillingMethod | null, updateOrderOnDuplicateBolNumber?: boolean | null, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', sourceColumnName: string, targetFieldType: CsvOrderMappingTargetFieldType }>, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, serviceLevelDefaultValue?: { __typename?: 'ServiceEntity', uuid: string } | null } };

export type CsvOrderMappingShallowFragment = { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', uuid: string }> };

export type CsvOrderMappingsForEmailToolQueryVariables = Exact<{ [key: string]: never; }>;


export type CsvOrderMappingsForEmailToolQuery = { __typename?: 'Query', csvOrderMappings: Array<{ __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', uuid: string }> }> };

export type UpdateCsvOrderMappingMutationVariables = Exact<{
  updateCsvOrderMappingInput: UpdateCsvOrderMappingInput;
}>;


export type UpdateCsvOrderMappingMutation = { __typename?: 'Mutation', updateCsvOrderMapping: { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string, enableDynamicInboundOrOutboundStop: boolean, enableInboundStop: boolean, enableOutboundStop: boolean, pickupOrDeliveryDefaultValue?: PickupOrDelivery | null, deadlineDateDefaultValue?: any | null, deadlineTypeDefaultValue?: DeadlineType | null, stopTypeDefaultValue?: StandardStopType | null, freightBillingMethodDefaultValue?: FreightBillingMethod | null, updateOrderOnDuplicateBolNumber?: boolean | null, csvOrderFieldMappings: Array<{ __typename?: 'CsvOrderFieldMappingEntity', sourceColumnName: string, targetFieldType: CsvOrderMappingTargetFieldType }>, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, serviceLevelDefaultValue?: { __typename?: 'ServiceEntity', uuid: string } | null } };

export type CreateEndOfDayDocumentProcessingJobMutationVariables = Exact<{
  createEndOfDayDocumentProcessingJobInput: CreateEndOfDayDocumentProcessingJobInput;
}>;


export type CreateEndOfDayDocumentProcessingJobMutation = { __typename?: 'Mutation', createEndOfDayDocumentProcessingJob: { __typename?: 'EndOfDayDocumentProcessingJobEntity', uuid: string } };

export type DetachDocumentsFromShipmentsMutationVariables = Exact<{
  detachDocumentsFromShipmentsInput: DetachDocumentsFromShipmentsInput;
}>;


export type DetachDocumentsFromShipmentsMutation = { __typename?: 'Mutation', detachDocumentsFromShipments: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, type: DocumentType, fileType: string }> };

export type DetachDocumentFromShipmentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DetachDocumentFromShipmentMutation = { __typename?: 'Mutation', detachDocumentFromShipment: { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, type: DocumentType, fileType: string } };

export type DocumentsByShipmentQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DocumentsByShipmentQuery = { __typename?: 'Query', shipmentV2?: { __typename?: 'StandardShipmentEntity', documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } | null };

export type EndOfDocumentsProcessingJobFragment = { __typename?: 'EndOfDayDocumentProcessingJobEntity', uuid: string, dateUploadedFor: any, uploadedFileName: string, status: EndOfDayDocumentsProcessingJobStatus };

export type EndOfDayDocumentProcessingJobsQueryVariables = Exact<{
  companyUuid: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  dateUploadedFor: Scalars['DateTime']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type EndOfDayDocumentProcessingJobsQuery = { __typename?: 'Query', endOfDayDocumentProcessingJobs: Array<{ __typename?: 'EndOfDayDocumentProcessingJobEntity', uuid: string, dateUploadedFor: any, uploadedFileName: string, status: EndOfDayDocumentsProcessingJobStatus }> };

export type ShallowRoutesWithDocumentsQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShallowRoutesWithDocumentsQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, name: string, date: any, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string, status: StopStatus, address: { __typename?: 'AddressEntity', city: string }, leg?: { __typename?: 'LegEntity', uuid: string, shipment: { __typename?: 'StandardShipmentEntity', hasSignedPOD: boolean, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } } | null }> }> }> };

export type EquipmentFragment = { __typename?: 'EquipmentEntity', uuid: string, name: string, capacity?: number | null, measurementSystem: MeasurementSystem, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, notes?: string | null, specialRules?: string | null, type: EquipmentType, samsaraVehicleId?: string | null, samsaraIsDeactivated?: boolean | null, motiveVehicleId?: string | null, motiveIsDeactivated?: boolean | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null };

export type EquipmentQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type EquipmentQuery = { __typename?: 'Query', equipment: { __typename?: 'EquipmentEntity', isActive: boolean, uuid: string, name: string, capacity?: number | null, measurementSystem: MeasurementSystem, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, notes?: string | null, specialRules?: string | null, type: EquipmentType, samsaraVehicleId?: string | null, samsaraIsDeactivated?: boolean | null, motiveVehicleId?: string | null, motiveIsDeactivated?: boolean | null, equipmentLicenses: Array<{ __typename?: 'EquipmentLicenseEntity', uuid: string, number: string, licenseType: string, licensingBody: string, issueDate: any, expiryDate: any }>, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }, samsaraOAuthToken?: { __typename?: 'SamsaraOauthTokenEntity', uuid: string } | null, motiveIntegration: { __typename?: 'MotiveIntegrationEntity', connected: boolean } };

export type EquipmentsQueryVariables = Exact<{
  includeNotActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EquipmentsQuery = { __typename?: 'Query', equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, samsaraVehicleId?: string | null, samsaraIsDeactivated?: boolean | null, motiveVehicleId?: string | null, motiveIsDeactivated?: boolean | null, subtype?: string | null, capacity?: number | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, measurementSystem: MeasurementSystem, isActive: boolean, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }> };

export type ExpeditorsApiStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpeditorsApiStatusQuery = { __typename?: 'Query', expeditorsApiStatus: { __typename?: 'ExpeditorsApiStatusEntity', generatedAt: any, windowStart: any, windowEnd: any, timezone: string, transmissionsTotal: number, connection: { __typename?: 'ExpeditorsConnectionHealth', heldCount: number, avgAttempts?: number | null, longestWaitMinutes?: number | null, failingSendsCount: number, degraded: boolean }, transmissions: Array<{ __typename?: 'ExpeditorsTransmissionRow', eventUuid: string, transmittedAt: any, orderUuid?: string | null, orderNumber?: string | null, consigneeName?: string | null, consigneeCity?: string | null, consigneeState?: string | null, kind: ExpeditorsTransmissionKind, result: ExpeditorsTransmissionResult, error?: string | null, retriedLater: boolean }> } };

export type ForwarderBoardQueryVariables = Exact<{
  args: ForwarderBoardArgs;
}>;


export type ForwarderBoardQuery = { __typename?: 'Query', forwarderBoard: { __typename?: 'ForwarderBoardEntity', windowStart: any, windowEnd: any, timezone: string, missingPods: number, awaitingPodTotal: number, awaitingAcceptanceTotal: number, undeliveredTotal: number, lateDeliveriesTotal: number, acceptanceMissesTotal: number, manualOrdersTotal: number, podWithin30: { __typename?: 'ForwarderBoardRateTile', onTime: number, of: number, rate?: number | null }, deliveryEventWithin30: { __typename?: 'ForwarderBoardRateTile', onTime: number, of: number, rate?: number | null }, driverEntered: { __typename?: 'ForwarderBoardRateTile', onTime: number, of: number, rate?: number | null }, acceptedWithin12h: { __typename?: 'ForwarderBoardRateTile', onTime: number, of: number, rate?: number | null }, completedWithin30OfArrival: { __typename?: 'ForwarderBoardRateTile', onTime: number, of: number, rate?: number | null }, electronicDispatchShare: { __typename?: 'ForwarderBoardRateTile', onTime: number, of: number, rate?: number | null }, awaitingPod: Array<{ __typename?: 'ForwarderBoardPodQueueRow', orderUuid: string, workOrderNumber: string, deliveredAt: any, waitingMinutes: number, cause: ForwarderBoardPodCause, uploadAttempts: number, firstUploadAttemptAt?: any | null }>, awaitingAcceptance: Array<{ __typename?: 'ForwarderBoardAcceptanceQueueRow', orderUuid: string, workOrderNumber: string, receivedAt: any, waitingMinutes: number }>, undelivered: Array<{ __typename?: 'ForwarderBoardAgingQueueRow', orderUuid: string, workOrderNumber: string, receivedAt: any, ageDays: number }>, lateDeliveries: Array<{ __typename?: 'ForwarderBoardLateDeliveryRow', orderUuid: string, workOrderNumber: string, deliveredAt: any, podLagMinutes?: number | null, deliveryEventLagMinutes?: number | null, driverEntered: boolean, uploadAttempts: number, firstUploadAttemptAt?: any | null, reachedForwarder: boolean, arrivalToCompletionMinutes?: number | null }>, acceptanceMisses: Array<{ __typename?: 'ForwarderBoardAcceptanceMissRow', orderUuid: string, workOrderNumber: string, receivedAt: any, acceptedAt?: any | null, acceptanceLagMinutes?: number | null }>, manualOrders: Array<{ __typename?: 'ForwarderBoardManualOrderRow', orderUuid: string, orderName: string, receivedAt: any }>, connection: { __typename?: 'ForwarderBoardConnectionStats', heldCount: number, avgAttempts?: number | null, longestWaitMinutes?: number | null } } };

export type ForwarderScorecardQueryVariables = Exact<{
  args: ForwarderScorecardArgs;
}>;


export type ForwarderScorecardQuery = { __typename?: 'Query', forwarderScorecard: { __typename?: 'ForwarderScorecardEntity', companyName: string, generatedAt: any, reportDay: string, dayRowLabel: string, timezone: string, dispatchExceptionsTotal: number, deliveryExceptionsTotal: number, undeliveredTotal: number, dispatchSummary: Array<{ __typename?: 'ForwarderScorecardDispatchSummaryRow', label: string, startDate: any, endDate: any, shipmentsDispatched: number, connectivityPct?: number | null, acceptedPct?: number | null }>, dispatchTrend: Array<{ __typename?: 'ForwarderScorecardDispatchTrendPoint', day: string, connectivityPct?: number | null, acceptedPct?: number | null }>, dispatchExceptions: Array<{ __typename?: 'ForwarderScorecardDispatchExceptionRow', orderUuid: string, workOrderNumber: string, branch?: string | null, receiptAt: any, acceptedAt?: any | null, minutesLate?: number | null, consigneeName: string, consigneeCity: string, consigneeState: string, driverName?: string | null }>, deliverySummary: Array<{ __typename?: 'ForwarderScorecardDeliverySummaryRow', label: string, startDate: any, endDate: any, shipmentsDispatched: number, freightPickedUp: number, outForDelivery: number, arrivedCount: number, dlvWithin30Pct?: number | null, podWithin30Pct?: number | null, missingPodCount: number }>, deliveryTrend: Array<{ __typename?: 'ForwarderScorecardDeliveryTrendPoint', day: string, dlvPct?: number | null, podPct?: number | null }>, deliveryExceptions: Array<{ __typename?: 'ForwarderScorecardDeliveryExceptionRow', orderUuid: string, workOrderNumber: string, branch?: string | null, ediDispatch: boolean, pickedUpSentAt?: any | null, outForDeliverySentAt?: any | null, arrivedSentAt?: any | null, deliveredAt: any, dlvReceivedAt?: any | null, dlvLagMinutes?: number | null, dlvOperator: string, podReceivedAt?: any | null, podLagMinutes?: number | null, consigneeName: string, consigneeCity: string, consigneeState: string, driverName?: string | null }>, undelivered: Array<{ __typename?: 'ForwarderScorecardUndeliveredRow', orderUuid: string, workOrderNumber: string, branch?: string | null, dispatchedElectronically: boolean, freightAvailableAt?: any | null, dispatchedSentAt?: any | null, dispatchedReceivedAt?: any | null, acceptedAt?: any | null, consigneeName: string, consigneeCity: string, consigneeState: string, driverName?: string | null }>, customers: Array<{ __typename?: 'ForwarderScorecardCustomer', uuid: string, displayName: string, isActive: boolean }>, customersNotIncluded: Array<{ __typename?: 'ForwarderScorecardCustomerNotIncluded', uuid: string, displayName: string, isActive: boolean, apiOrders: number }> } };

export type FuelChargeFuelProfileDateRangeFragment = { __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null };

export type FuelChargeFuelProfileDateRangeQueryVariables = Exact<{
  fuelChargeFuelProfileDateRangeInput: FuelChargeFuelProfileDateRangeInput;
}>;


export type FuelChargeFuelProfileDateRangeQuery = { __typename?: 'Query', fuelChargeFuelProfileDateRange: { __typename?: 'FuelChargeFuelProfileDateRangeOutput', fuelProfileDateRange?: { __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null } | null } };

export type LineHaulFuelChargeFuelProfileDateRangeFragment = { __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null };

export type LineHaulFuelChargeFuelProfileDateRangeQueryVariables = Exact<{
  lineHaulFuelChargeFuelProfileDateRangeInput: LineHaulFuelChargeFuelProfileDateRangeInput;
}>;


export type LineHaulFuelChargeFuelProfileDateRangeQuery = { __typename?: 'Query', lineHaulFuelChargeFuelProfileDateRange: { __typename?: 'LineHaulFuelChargeFuelProfileDateRangeOutput', fuelProfileDateRange?: { __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null } | null } };

export type CostCenterStatementReportQueryVariables = Exact<{
  args: CostCenterStatementArgs;
}>;


export type CostCenterStatementReportQuery = { __typename?: 'Query', costCenterStatementReport: { __typename: 'CostCenterStatementReportEntity', shipmentCount: number, revenueUsd: number, pickupDeliveryCostUsd: number, linehaulCostUsd: number, dockCostUsd: number, insuranceClaimsCostUsd: number, billingCollectingCostUsd: number, totalVariableCostUsd: number, variableCostPctOfRevenue?: number | null, contributionDollarsUsd: number, contributionMarginPct?: number | null, fixedOverheadCostUsd: number, operatingIncomeUsd: number, operatingRatio?: number | null, breakevenRevenueUsd?: number | null, percentOfBreakeven?: number | null, revenuePerShipmentUsd?: number | null, variableCostPerShipmentUsd?: number | null, contributionPerShipmentUsd?: number | null, breakevenShipmentCount?: number | null, status?: CostCenterStatementStatus | null, usesBenchmarkDefaults: boolean, costBasis: CostBasis, missingCostInputs: Array<string>, revenueSharedWithAgentsUsd?: number | null, netRevenueUsd?: number | null, pdLaborCostUsd?: number | null, dockLaborCostUsd?: number | null, truckCostUsd?: number | null, outsideCarriersCostUsd?: number | null, nonFreightCostUsd?: number | null, incomeAfterNonFreightUsd?: number | null, workdays?: number | null, netRevenuePerDayUsd?: number | null, fixedCostPerDayUsd?: number | null, contributionPerDayUsd?: number | null, estimatedCostInputs: Array<{ __typename?: 'CostInputEstimatedMonthEntity', month: string, items: Array<string> }>, terminals: Array<{ __typename: 'CostCenterStatementRowEntity', terminalUuid?: string | null, terminalCode?: string | null, terminalName: string, shipmentCount: number, revenueUsd: number, pickupDeliveryCostUsd: number, linehaulCostUsd: number, dockCostUsd: number, insuranceClaimsCostUsd: number, billingCollectingCostUsd: number, totalVariableCostUsd: number, variableCostPctOfRevenue?: number | null, contributionDollarsUsd: number, contributionMarginPct?: number | null, fixedOverheadCostUsd: number, operatingIncomeUsd: number, operatingRatio?: number | null, breakevenRevenueUsd?: number | null, percentOfBreakeven?: number | null, revenuePerShipmentUsd?: number | null, variableCostPerShipmentUsd?: number | null, contributionPerShipmentUsd?: number | null, profileSource: CostCenterProfileSource, status?: CostCenterStatementStatus | null }> } };

export type CostInputCatalogueQueryVariables = Exact<{ [key: string]: never; }>;


export type CostInputCatalogueQuery = { __typename?: 'Query', costInputCatalogue: Array<{ __typename?: 'CostInputDefinitionEntity', field: CostInputField, label: string, group: CostInputGroup, unit: CostInputUnit, cadence: CostInputCadence, sources: Array<CostInputSource>, quickbooksMappable: boolean, whereToFind: string, howToFill: string }> };

export type CostInputEstimatedMonthFragment = { __typename?: 'CostInputEstimatedMonthEntity', month: string, items: Array<string> };

export type CostInputMonthFragment = { __typename?: 'CostInputMonthEntity', month: string, terminalUuid?: string | null, isOpenMonth: boolean, values: Array<{ __typename?: 'CostInputValueEntity', field: CostInputField, value?: number | null, source?: CostInputSource | null, typedValue?: number | null, quickbooksValue?: number | null, samsaraValue?: number | null, tenetValue?: number | null, typedByName?: string | null, typedAt?: any | null }>, reports: Array<{ __typename?: 'CostInputReportReadinessEntity', key: string, label: string, hasCosts: boolean, missing: Array<string> }>, rates?: { __typename?: 'CostInputRatesEntity', pdCostPerHourUsd?: number | null, dockCostPerHourUsd?: number | null, truckCostPerMileUsd?: number | null, operationsBenefitsSharePct?: number | null, pdLaborUsd: number, dockLaborUsd: number, truckCostUsd: number, insuranceClaimsUsd: number, outsideCarriersUsd: number, variableCostUsd: number, fixedCostUsd: number, nonFreightCostUsd: number, breakevenContributionRatio?: number | null, fixedCostPerDayUsd?: number | null, variableCostPerDayUsd?: number | null } | null };

export type CostInputMonthQueryVariables = Exact<{
  args: CostInputMonthArgs;
}>;


export type CostInputMonthQuery = { __typename?: 'Query', costInputMonth: { __typename?: 'CostInputMonthEntity', month: string, terminalUuid?: string | null, isOpenMonth: boolean, values: Array<{ __typename?: 'CostInputValueEntity', field: CostInputField, value?: number | null, source?: CostInputSource | null, typedValue?: number | null, quickbooksValue?: number | null, samsaraValue?: number | null, tenetValue?: number | null, typedByName?: string | null, typedAt?: any | null }>, reports: Array<{ __typename?: 'CostInputReportReadinessEntity', key: string, label: string, hasCosts: boolean, missing: Array<string> }>, rates?: { __typename?: 'CostInputRatesEntity', pdCostPerHourUsd?: number | null, dockCostPerHourUsd?: number | null, truckCostPerMileUsd?: number | null, operationsBenefitsSharePct?: number | null, pdLaborUsd: number, dockLaborUsd: number, truckCostUsd: number, insuranceClaimsUsd: number, outsideCarriersUsd: number, variableCostUsd: number, fixedCostUsd: number, nonFreightCostUsd: number, breakevenContributionRatio?: number | null, fixedCostPerDayUsd?: number | null, variableCostPerDayUsd?: number | null } | null } };

export type CostInputQuickbooksAccountFragment = { __typename?: 'CostInputQuickbooksAccountEntity', quickbooksAccountId: string, accountName: string, sectionPath: string, recentTotalUsd: number, field?: CostInputField | null, isMapped: boolean, isParentAccount: boolean };

export type CostInputQuickbooksAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type CostInputQuickbooksAccountsQuery = { __typename?: 'Query', costInputQuickbooksAccounts: Array<{ __typename?: 'CostInputQuickbooksAccountEntity', quickbooksAccountId: string, accountName: string, sectionPath: string, recentTotalUsd: number, field?: CostInputField | null, isMapped: boolean, isParentAccount: boolean }> };

export type CostInputStatusFragment = { __typename?: 'CostInputStatusEntity', quickbooksConnected: boolean, quickbooksLastSyncedAt?: any | null, quickbooksMatchedAccountCount: number, quickbooksUnmatchedAccountCount: number, truckLeasePerMilePct?: number | null, driverWageSplitPct?: number | null };

export type CostInputStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CostInputStatusQuery = { __typename?: 'Query', costInputStatus: { __typename?: 'CostInputStatusEntity', quickbooksConnected: boolean, quickbooksLastSyncedAt?: any | null, quickbooksMatchedAccountCount: number, quickbooksUnmatchedAccountCount: number, truckLeasePerMilePct?: number | null, driverWageSplitPct?: number | null } };

export type SaveCostInputQuickbooksMappingsMutationVariables = Exact<{
  input: SaveCostInputQuickbooksMappingsInput;
}>;


export type SaveCostInputQuickbooksMappingsMutation = { __typename?: 'Mutation', saveCostInputQuickbooksMappings: Array<{ __typename?: 'CostInputQuickbooksAccountEntity', quickbooksAccountId: string, accountName: string, sectionPath: string, recentTotalUsd: number, field?: CostInputField | null, isMapped: boolean, isParentAccount: boolean }> };

export type SaveCostInputSetupMutationVariables = Exact<{
  input: SaveCostInputSetupInput;
}>;


export type SaveCostInputSetupMutation = { __typename?: 'Mutation', saveCostInputSetup: { __typename?: 'CostInputStatusEntity', quickbooksConnected: boolean, quickbooksLastSyncedAt?: any | null, quickbooksMatchedAccountCount: number, quickbooksUnmatchedAccountCount: number, truckLeasePerMilePct?: number | null, driverWageSplitPct?: number | null } };

export type SaveCostInputsMutationVariables = Exact<{
  input: SaveCostInputsInput;
}>;


export type SaveCostInputsMutation = { __typename?: 'Mutation', saveCostInputs: { __typename?: 'CostInputMonthEntity', month: string, terminalUuid?: string | null, isOpenMonth: boolean, values: Array<{ __typename?: 'CostInputValueEntity', field: CostInputField, value?: number | null, source?: CostInputSource | null, typedValue?: number | null, quickbooksValue?: number | null, samsaraValue?: number | null, tenetValue?: number | null, typedByName?: string | null, typedAt?: any | null }>, reports: Array<{ __typename?: 'CostInputReportReadinessEntity', key: string, label: string, hasCosts: boolean, missing: Array<string> }>, rates?: { __typename?: 'CostInputRatesEntity', pdCostPerHourUsd?: number | null, dockCostPerHourUsd?: number | null, truckCostPerMileUsd?: number | null, operationsBenefitsSharePct?: number | null, pdLaborUsd: number, dockLaborUsd: number, truckCostUsd: number, insuranceClaimsUsd: number, outsideCarriersUsd: number, variableCostUsd: number, fixedCostUsd: number, nonFreightCostUsd: number, breakevenContributionRatio?: number | null, fixedCostPerDayUsd?: number | null, variableCostPerDayUsd?: number | null } | null } };

export type CustomerProfitabilityReportQueryVariables = Exact<{
  args: CustomerProfitabilityArgs;
}>;


export type CustomerProfitabilityReportQuery = { __typename?: 'Query', customerProfitabilityReport: { __typename: 'CustomerProfitabilityReportEntity', breakevenContributionRatio?: number | null, operatingRatio?: number | null, totalRevenueUsd: number, totalVariableCostUsd?: number | null, proratedFixedCostUsd?: number | null, proratedOverheadCostUsd?: number | null, hasCostAssumptions: boolean, costBasis: CostBasis, missingCostInputs: Array<string>, estimatedCostInputs: Array<{ __typename?: 'CostInputEstimatedMonthEntity', month: string, items: Array<string> }>, appliedRates?: { __typename?: 'ProfitabilityCostAssumptionEntity', variableCostPerShipmentUsd: number, variableCostPerHundredweightUsd: number, variableCostPerMileUsd: number } | null, customers: Array<{ __typename: 'CustomerProfitabilityBucketEntity', customerUuid: string, customerName: string, shipmentCount: number, totalWeightLbs: number, totalMiles: number, revenueUsd: number, variableCostUsd?: number | null, actualContributionRatio?: number | null, status?: ProfitabilityStatus | null }> } };

export type DockProductivityReportQueryVariables = Exact<{
  args: DockProductivityArgs;
}>;


export type DockProductivityReportQuery = { __typename?: 'Query', dockProductivityReport: { __typename: 'DockProductivityReportEntity', totalActualHours: number, totalAllowedHours: number, totalSavedHours: number, totalSavedCostUsd?: number | null, overallLaborEfficiencyPct?: number | null, hasTimeAllowances: boolean, actualHoursAreProxy: boolean, costBasis: CostBasis, missingCostInputs: Array<string>, appliedDockCostPerHourUsd?: number | null, estimatedCostInputs: Array<{ __typename?: 'CostInputEstimatedMonthEntity', month: string, items: Array<string> }>, timeAllowances: { __typename: 'DockTimeAllowanceEntity', uuid?: string | null, minutesPerInboundPiece: number, minutesPerOutboundPiece: number, minutesPerHundredweight: number }, terminals: Array<{ __typename: 'DockProductivityTerminalEntity', terminalUuid: string, terminalName: string, terminalCode: string, inboundPieces: number, outboundPieces: number, totalWeightLbs: number, allowedHours: number, actualHours: number, savedHours: number, savedCostUsd?: number | null, laborEfficiencyPct?: number | null, status?: DockProductivityStatus | null }> } };

export type DockTimeAllowancesQueryVariables = Exact<{ [key: string]: never; }>;


export type DockTimeAllowancesQuery = { __typename?: 'Query', dockTimeAllowances: { __typename: 'DockTimeAllowanceEntity', uuid?: string | null, minutesPerInboundPiece: number, minutesPerOutboundPiece: number, minutesPerHundredweight: number } };

export type UpsertDockTimeAllowancesMutationVariables = Exact<{
  input: UpsertDockTimeAllowanceInput;
}>;


export type UpsertDockTimeAllowancesMutation = { __typename?: 'Mutation', upsertDockTimeAllowances: { __typename: 'DockTimeAllowanceEntity', uuid?: string | null, minutesPerInboundPiece: number, minutesPerOutboundPiece: number, minutesPerHundredweight: number } };

export type DriverPlannerAssumptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DriverPlannerAssumptionsQuery = { __typename?: 'Query', driverPlannerAssumptions: { __typename: 'DriverPlannerAssumptionEntity', uuid?: string | null, standardShiftHours: number, targetUtilizationPct: number, targetMgt: number } };

export type DriverPlannerReportQueryVariables = Exact<{
  args: DriverPlannerArgs;
}>;


export type DriverPlannerReportQuery = { __typename?: 'Query', driverPlannerReport: { __typename: 'DriverPlannerReportEntity', tripsRun: number, productiveHours: number, netHours: number, avgProductiveHoursPerTrip?: number | null, avgNetHoursPerTrip?: number | null, actualUtilizationPct?: number | null, requiredTrips?: number | null, excessTrips?: number | null, mgt?: number | null, excessCapacityPct?: number | null, excessCapacityLaborCostUsd?: number | null, status?: DriverPlannerStatus | null, targetProductiveHoursPerTrip: number, driverWageFringePerHourUsd?: number | null, hasTimeAllowances: boolean, costBasis: CostBasis, missingCostInputs: Array<string>, hasAssumptions: boolean, netHoursAreProxy: boolean, estimatedCostInputs: Array<{ __typename?: 'CostInputEstimatedMonthEntity', month: string, items: Array<string> }>, assumptions: { __typename: 'DriverPlannerAssumptionEntity', uuid?: string | null, standardShiftHours: number, targetUtilizationPct: number, targetMgt: number }, terminals: Array<{ __typename: 'DriverPlannerRowEntity', terminalUuid: string, terminalCode: string, terminalName: string, tripsRun: number, productiveHours: number, netHours: number, avgProductiveHoursPerTrip?: number | null, avgNetHoursPerTrip?: number | null, actualUtilizationPct?: number | null, requiredTrips?: number | null, excessTrips?: number | null, mgt?: number | null, excessCapacityPct?: number | null, excessCapacityLaborCostUsd?: number | null, status?: DriverPlannerStatus | null }> } };

export type UpsertDriverPlannerAssumptionsMutationVariables = Exact<{
  input: UpsertDriverPlannerAssumptionsInput;
}>;


export type UpsertDriverPlannerAssumptionsMutation = { __typename?: 'Mutation', upsertDriverPlannerAssumptions: { __typename: 'DriverPlannerAssumptionEntity', uuid?: string | null, standardShiftHours: number, targetUtilizationPct: number, targetMgt: number } };

export type LineHaulUtilizationAssumptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LineHaulUtilizationAssumptionsQuery = { __typename?: 'Query', lineHaulUtilizationAssumptions: { __typename: 'LineHaulUtilizationAssumptionEntity', uuid?: string | null, defaultTrailerWeightCapacityLbs: number, defaultTrailerCubeCapacityCubicFeet: number } };

export type LineHaulUtilizationReportQueryVariables = Exact<{
  args: LineHaulUtilizationArgs;
}>;


export type LineHaulUtilizationReportQuery = { __typename?: 'Query', lineHaulUtilizationReport: { __typename: 'LineHaulUtilizationReportEntity', grain: LineHaulUtilizationGrain, totalManifests: number, totalTrailers: number, totalLoadedWeightLbs: number, totalWeightCapacityLbs: number, overallWeightUtilizationPct?: number | null, totalEquivalentEmptyTrailers: number, hasAssumptions: boolean, usedDefaultCapacity: boolean, assumptions: { __typename: 'LineHaulUtilizationAssumptionEntity', uuid?: string | null, defaultTrailerWeightCapacityLbs: number, defaultTrailerCubeCapacityCubicFeet: number }, rows: Array<{ __typename: 'LineHaulUtilizationRowEntity', key: string, label: string, manifestCount: number, trailerCount: number, loadedWeightLbs: number, loadedCubeCubicFeet: number, weightCapacityLbs: number, cubeCapacityCubicFeet: number, weightUtilizationPct?: number | null, cubeUtilizationPct?: number | null, utilizationPct?: number | null, equivalentEmptyTrailers: number, status?: LineHaulUtilizationStatus | null, laneBalancePct?: number | null, reverseLoadedWeightLbs?: number | null }> } };

export type UpsertLineHaulUtilizationAssumptionsMutationVariables = Exact<{
  input: UpsertLineHaulUtilizationAssumptionInput;
}>;


export type UpsertLineHaulUtilizationAssumptionsMutation = { __typename?: 'Mutation', upsertLineHaulUtilizationAssumptions: { __typename: 'LineHaulUtilizationAssumptionEntity', uuid?: string | null, defaultTrailerWeightCapacityLbs: number, defaultTrailerCubeCapacityCubicFeet: number } };

export type OperationalEfficiencyReportQueryVariables = Exact<{
  args: OperationalEfficiencyArgs;
}>;


export type OperationalEfficiencyReportQuery = { __typename?: 'Query', operationalEfficiencyReport: { __typename?: 'OperationalEfficiencyReportEntity', dimension: OperationalEfficiencyDimension, totalShipments: number, totalRevenueUsd: number, avgShipmentPriceUsd?: number | null, totalMiles: number, shipmentsWithMiles: number, milesCoveragePct: number, revenuePerMileUsd?: number | null, rows: Array<{ __typename?: 'OperationalEfficiencyRowEntity', key: string, label: string, shipmentCount: number, revenueUsd: number, avgShipmentPriceUsd: number, totalMiles: number, shipmentsWithMiles: number, milesCoveragePct: number, revenuePerMileUsd?: number | null, status: OperationalEfficiencyStatus }> } };

export type PdProductivityReportQueryVariables = Exact<{
  args: PdProductivityArgs;
}>;


export type PdProductivityReportQuery = { __typename?: 'Query', pdProductivityReport: { __typename: 'PdProductivityReportEntity', totalActualHours: number, totalAllowedHours: number, totalInefficiencyHours: number, totalInefficiencyCostUsd?: number | null, overallProductivityRatio?: number | null, routesMissingTimestamps: number, hasTimeAllowances: boolean, costBasis: CostBasis, missingCostInputs: Array<string>, appliedDriverCostPerHourUsd?: number | null, truckCostPerMileUsd?: number | null, pdCostUsd?: number | null, costPerStopUsd?: number | null, estimatedCostInputs: Array<{ __typename?: 'CostInputEstimatedMonthEntity', month: string, items: Array<string> }>, timeAllowances: { __typename: 'ProductivityTimeAllowanceEntity', uuid?: string | null, minutesPerStop: number, minutesPerPiece: number, minutesPerHundredweight: number, minutesPerMile: number }, drivers: Array<{ __typename: 'PdProductivityDriverEntity', driverUuid: string, driverName: string, routeCount: number, stopCount: number, pieceCount: number, totalWeightLbs: number, totalMiles: number, actualHours: number, allowedHours: number, inefficiencyHours: number, inefficiencyCostUsd?: number | null, productivityRatio?: number | null, status?: ProductivityStatus | null }> } };

export type ProductivityTimeAllowancesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductivityTimeAllowancesQuery = { __typename?: 'Query', productivityTimeAllowances: { __typename: 'ProductivityTimeAllowanceEntity', uuid?: string | null, minutesPerStop: number, minutesPerPiece: number, minutesPerHundredweight: number, minutesPerMile: number } };

export type UpsertProductivityTimeAllowancesMutationVariables = Exact<{
  input: UpsertTimeAllowanceInput;
}>;


export type UpsertProductivityTimeAllowancesMutation = { __typename?: 'Mutation', upsertProductivityTimeAllowances: { __typename: 'ProductivityTimeAllowanceEntity', uuid?: string | null, minutesPerStop: number, minutesPerPiece: number, minutesPerHundredweight: number, minutesPerMile: number } };

export type SamsaraDiscoveryCatalogueQueryVariables = Exact<{ [key: string]: never; }>;


export type SamsaraDiscoveryCatalogueQuery = { __typename?: 'Query', samsaraDiscoveryCatalogue: { __typename?: 'SamsaraDiscoveryCatalogueEntity', datasets: Array<{ __typename?: 'SamsaraDiscoveryDatasetEntity', key: string, group: SamsaraDatasetGroup, label: string, description: string, dated: boolean, rowCount: number }>, absentEndpoints: Array<{ __typename?: 'SamsaraDiscoveryAbsentEndpointEntity', label: string, reason: string }> } };

export type SamsaraDiscoveryExportQueryVariables = Exact<{
  input: SamsaraDiscoveryExportInput;
}>;


export type SamsaraDiscoveryExportQuery = { __typename?: 'Query', samsaraDiscoveryExport: string };

export type SamsaraDiscoveryMonthlyOverviewQueryVariables = Exact<{
  input: SamsaraDiscoveryMonthlyOverviewInput;
}>;


export type SamsaraDiscoveryMonthlyOverviewQuery = { __typename?: 'Query', samsaraDiscoveryMonthlyOverview: Array<{ __typename?: 'SamsaraDiscoveryMonthEntity', month: string, vehicles?: number | null, miles?: number | null, gallons?: number | null, estFuelUsd?: number | null, idleHours?: number | null, workOrdersCompleted?: number | null, laborUsd?: number | null, partLinesUsd?: number | null, taskPartsCostUsd?: number | null, driveHours?: number | null, onDutyHours?: number | null, iftaMiles?: number | null, iftaGallonsBought?: number | null }> };

export type SamsaraDiscoveryRemoveTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type SamsaraDiscoveryRemoveTokenMutation = { __typename?: 'Mutation', samsaraDiscoveryRemoveToken: { __typename?: 'SamsaraDiscoveryStatusEntity', connected: boolean, samsaraOrgName?: string | null, hasData: boolean, totalRows: number, latestRun?: { __typename?: 'SamsaraDiscoveryRunEntity', uuid: string, status: SamsaraImportRunStatus, startedAt: any, finishedAt?: any | null, fromDate?: any | null, toDate?: any | null, currentDatasetLabel?: string | null, datasetsDone: number, datasetsTotal: number, rowsWritten: number, errorMessage?: string | null } | null } };

export type SamsaraDiscoveryRowsQueryVariables = Exact<{
  input: SamsaraDiscoveryRowsInput;
}>;


export type SamsaraDiscoveryRowsQuery = { __typename?: 'Query', samsaraDiscoveryRows: { __typename?: 'SamsaraDiscoveryRowsPageEntity', headers: Array<string>, rows: Array<Array<string>>, total: number } };

export type SamsaraDiscoveryRunImportMutationVariables = Exact<{ [key: string]: never; }>;


export type SamsaraDiscoveryRunImportMutation = { __typename?: 'Mutation', samsaraDiscoveryRunImport: { __typename?: 'SamsaraDiscoveryStatusEntity', connected: boolean, samsaraOrgName?: string | null, hasData: boolean, totalRows: number, latestRun?: { __typename?: 'SamsaraDiscoveryRunEntity', uuid: string, status: SamsaraImportRunStatus, startedAt: any, finishedAt?: any | null, fromDate?: any | null, toDate?: any | null, currentDatasetLabel?: string | null, datasetsDone: number, datasetsTotal: number, rowsWritten: number, errorMessage?: string | null } | null } };

export type SamsaraDiscoverySetTokenMutationVariables = Exact<{
  input: SamsaraDiscoverySetTokenInput;
}>;


export type SamsaraDiscoverySetTokenMutation = { __typename?: 'Mutation', samsaraDiscoverySetToken: { __typename?: 'SamsaraDiscoveryStatusEntity', connected: boolean, samsaraOrgName?: string | null, hasData: boolean, totalRows: number, latestRun?: { __typename?: 'SamsaraDiscoveryRunEntity', uuid: string, status: SamsaraImportRunStatus, startedAt: any, finishedAt?: any | null, fromDate?: any | null, toDate?: any | null, currentDatasetLabel?: string | null, datasetsDone: number, datasetsTotal: number, rowsWritten: number, errorMessage?: string | null } | null } };

export type SamsaraDiscoveryStatusFragment = { __typename?: 'SamsaraDiscoveryStatusEntity', connected: boolean, samsaraOrgName?: string | null, hasData: boolean, totalRows: number, latestRun?: { __typename?: 'SamsaraDiscoveryRunEntity', uuid: string, status: SamsaraImportRunStatus, startedAt: any, finishedAt?: any | null, fromDate?: any | null, toDate?: any | null, currentDatasetLabel?: string | null, datasetsDone: number, datasetsTotal: number, rowsWritten: number, errorMessage?: string | null } | null };

export type SamsaraDiscoveryStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type SamsaraDiscoveryStatusQuery = { __typename?: 'Query', samsaraDiscoveryStatus: { __typename?: 'SamsaraDiscoveryStatusEntity', connected: boolean, samsaraOrgName?: string | null, hasData: boolean, totalRows: number, latestRun?: { __typename?: 'SamsaraDiscoveryRunEntity', uuid: string, status: SamsaraImportRunStatus, startedAt: any, finishedAt?: any | null, fromDate?: any | null, toDate?: any | null, currentDatasetLabel?: string | null, datasetsDone: number, datasetsTotal: number, rowsWritten: number, errorMessage?: string | null } | null } };

export type TerminalEfficiencyReportQueryVariables = Exact<{
  args: TerminalEfficiencyArgs;
}>;


export type TerminalEfficiencyReportQuery = { __typename?: 'Query', terminalEfficiencyReport: { __typename: 'TerminalEfficiencyReportEntity', totalActualHours: number, totalAllowedHours: number, overallEfficiencyPct?: number | null, hasPdAllowances: boolean, hasDockAllowances: boolean, actualHoursAreProxy: boolean, costBasis: CostBasis, missingCostInputs: Array<string>, estimatedCostInputs: Array<{ __typename?: 'CostInputEstimatedMonthEntity', month: string, items: Array<string> }>, terminals: Array<{ __typename: 'TerminalEfficiencyRowEntity', terminalUuid: string, terminalCode: string, terminalName: string, pdActualHours: number, pdAllowedHours: number, dockActualHours: number, dockAllowedHours: number, totalActualHours: number, totalAllowedHours: number, efficiencyPct?: number | null, status?: TerminalEfficiencyStatus | null }> } };

export type WeightBreakReportQueryVariables = Exact<{
  args: WeightBreakArgs;
}>;


export type WeightBreakReportQuery = { __typename?: 'Query', weightBreakReport: { __typename: 'WeightBreakReportEntity', totalShipmentCount: number, totalRevenueUsd: number, totalVariableCostUsd?: number | null, totalContributionDollarsUsd?: number | null, overallVarCostPctOfRevenue?: number | null, overallContributionRatio?: number | null, overallContributionPerShipmentUsd?: number | null, sweetSpotLabel?: string | null, upsideDownFromLabel?: string | null, hasCostAssumptions: boolean, costBasis: CostBasis, missingCostInputs: Array<string>, estimatedCostInputs: Array<{ __typename?: 'CostInputEstimatedMonthEntity', month: string, items: Array<string> }>, brackets: Array<{ __typename: 'WeightBreakBracketEntity', label: string, minLbs: number, maxLbs?: number | null, shipmentCount: number, revenueUsd: number, variableCostUsd?: number | null, contributionDollarsUsd?: number | null, contributionRatio?: number | null, varCostPctOfRevenue?: number | null, revenuePerShipmentUsd?: number | null, variableCostPerShipmentUsd?: number | null, contributionPerShipmentUsd?: number | null, status?: WeightBreakStatus | null }> } };

export type DeleteInventoryCountMutationVariables = Exact<{
  deleteInventoryCountInput: DeleteInventoryCountInput;
}>;


export type DeleteInventoryCountMutation = { __typename?: 'Mutation', deleteInventoryCount: { __typename: 'DeletedInventoryCountOutput', uuid: string } | { __typename: 'MutationErrorOutput', message: string } };

export type InventoryCountHeaderFragment = { __typename?: 'InventoryCountEntity', uuid: string, statuses: Array<PieceStatus>, searchText?: string | null, unassociatedOnly: boolean, noLocationOnly: boolean, overdueOnly: boolean, startedAt: any, closedAt?: any | null, isClosed: boolean, expectedCount: number, confirmedCount: number, pendingCount: number, unexpectedCount: number, departedCount: number, startedByUser?: { __typename?: 'UserActorEntity', uuid: string, name?: string | null, email?: string | null } | null, startedByWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, closedByUser?: { __typename?: 'UserActorEntity', uuid: string, name?: string | null, email?: string | null } | null, closedByWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null };

export type InventoryCountLineFragment = { __typename?: 'InventoryCountLineEntity', uuid: string, referenceNumber?: string | null, orderName?: string | null, customerName?: string | null, warehouseLocationName?: string | null, state: InventoryCountLineState, pieceStatusAtClose?: PieceStatus | null, scannedAt?: any | null, scannedBarcode?: string | null };

export type InventoryCountQueryVariables = Exact<{
  findInventoryCountInput: FindInventoryCountInput;
}>;


export type InventoryCountQuery = { __typename?: 'Query', inventoryCount: { __typename?: 'FindInventoryCountOutput', inventoryCount: { __typename?: 'InventoryCountEntity', uuid: string, statuses: Array<PieceStatus>, searchText?: string | null, unassociatedOnly: boolean, noLocationOnly: boolean, overdueOnly: boolean, startedAt: any, closedAt?: any | null, isClosed: boolean, expectedCount: number, confirmedCount: number, pendingCount: number, unexpectedCount: number, departedCount: number, startedByUser?: { __typename?: 'UserActorEntity', uuid: string, name?: string | null, email?: string | null } | null, startedByWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, closedByUser?: { __typename?: 'UserActorEntity', uuid: string, name?: string | null, email?: string | null } | null, closedByWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null }, lineConnection: { __typename?: 'InventoryCountLineConnection', edges: Array<{ __typename?: 'InventoryCountLineEdge', cursor: string, node: { __typename?: 'InventoryCountLineEntity', uuid: string, referenceNumber?: string | null, orderName?: string | null, customerName?: string | null, warehouseLocationName?: string | null, state: InventoryCountLineState, pieceStatusAtClose?: PieceStatus | null, scannedAt?: any | null, scannedBarcode?: string | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type InventoryCountsQueryVariables = Exact<{
  findInventoryCountsInput: FindInventoryCountsInput;
}>;


export type InventoryCountsQuery = { __typename?: 'Query', inventoryCounts: { __typename?: 'FindInventoryCountsOutput', inventoryCountConnection: { __typename?: 'InventoryCountConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InventoryCountEdge', cursor: string, node: { __typename?: 'InventoryCountEntity', uuid: string, statuses: Array<PieceStatus>, searchText?: string | null, unassociatedOnly: boolean, noLocationOnly: boolean, overdueOnly: boolean, startedAt: any, closedAt?: any | null, isClosed: boolean, expectedCount: number, confirmedCount: number, pendingCount: number, unexpectedCount: number, departedCount: number, startedByUser?: { __typename?: 'UserActorEntity', uuid: string, name?: string | null, email?: string | null } | null, startedByWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, closedByUser?: { __typename?: 'UserActorEntity', uuid: string, name?: string | null, email?: string | null } | null, closedByWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type CreateDwellTimeAlertConfigMutationVariables = Exact<{
  createDwellTimeAlertConfigInput: CreateDwellTimeAlertConfigInput;
}>;


export type CreateDwellTimeAlertConfigMutation = { __typename?: 'Mutation', createDwellTimeAlertConfig: { __typename?: 'DwellTimeAlertConfigEntity', uuid: string, thresholdDays: number, enabled: boolean, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null } };

export type DeleteDwellTimeAlertConfigMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteDwellTimeAlertConfigMutation = { __typename?: 'Mutation', deleteDwellTimeAlertConfig: boolean };

export type DwellTimeAlertConfigFragment = { __typename?: 'DwellTimeAlertConfigEntity', uuid: string, thresholdDays: number, enabled: boolean, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null };

export type DwellTimeAlertConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type DwellTimeAlertConfigsQuery = { __typename?: 'Query', dwellTimeAlertConfigs: Array<{ __typename?: 'DwellTimeAlertConfigEntity', uuid: string, thresholdDays: number, enabled: boolean, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null }> };

export type UpdateDwellTimeAlertConfigMutationVariables = Exact<{
  updateDwellTimeAlertConfigInput: UpdateDwellTimeAlertConfigInput;
}>;


export type UpdateDwellTimeAlertConfigMutation = { __typename?: 'Mutation', updateDwellTimeAlertConfig: { __typename?: 'DwellTimeAlertConfigEntity', uuid: string, thresholdDays: number, enabled: boolean, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null } };

export type OrderForPackingSlipFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, createdAt: any, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, outboundShipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', serviceDate?: any | null, outboundCarrier?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null } }> } | null };

export type OrdersForPackingSlipQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
}>;


export type OrdersForPackingSlipQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, createdAt: any, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, outboundShipment?: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deliveryDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', serviceDate?: any | null, outboundCarrier?: string | null, appointmentTime?: any | null, endAppointmentTime?: any | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null } }> } | null } }> } };

export type PicklistsFragment = { __typename?: 'PicklistEntity', id: string, date: any, outboundReferenceNumber?: string | null, picklistItemGroups: Array<{ __typename?: 'PicklistItemGroupEntity', id: string, pickedQuantity: number, pickedStatus: PickedStatus, itemGroup: { __typename?: 'ItemGroupEntity', uuid: string, quantity: number, item: { __typename?: 'ItemEntity', sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } }, storageUnit?: { __typename?: 'StorageUnitEntity', name: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null, storageOrder?: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, supplierCompanyName?: string | null, purchaseOrderNumber?: string | null, lotNumber?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null } | null } }> };

export type PicklistsQueryVariables = Exact<{
  picklistsInput: PicklistsInput;
}>;


export type PicklistsQuery = { __typename?: 'Query', picklists: { __typename?: 'PicklistConnection', totalCount: number, edges: Array<{ __typename?: 'PicklistEdge', node: { __typename?: 'PicklistEntity', id: string, date: any, outboundReferenceNumber?: string | null, picklistItemGroups: Array<{ __typename?: 'PicklistItemGroupEntity', id: string, pickedQuantity: number, pickedStatus: PickedStatus, itemGroup: { __typename?: 'ItemGroupEntity', uuid: string, quantity: number, item: { __typename?: 'ItemEntity', sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } }, storageUnit?: { __typename?: 'StorageUnitEntity', name: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null, storageOrder?: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, supplierCompanyName?: string | null, purchaseOrderNumber?: string | null, lotNumber?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null } | null } }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CompanyStatsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyStatsQueryQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', company: { __typename?: 'CompanyEntity', uuid: string, companyStatistics?: { __typename?: 'CompanyStatsEntity', numberOfOrdersDueInFuture: number, numberOfUninvoicedOrdersDueInFuture: number, numberOfOrdersSixtyOneToNinety: number, numberOfOrdersThirtyOneToSixty: number, numberOfOrdersOneToThirty: number, numberOfUninvoicedOrdersSixtyOneToNinety: number, numberOfUninvoicedOrdersThirtyOneToSixty: number, numberOfUninvoicedOrdersOneToThirty: number, numberOfOrdersPastNinetyOne: number, numberOfUninvoicedOrdersPastNinetyOne: number } | null } } | null };

export type ConsolidatableOrderSummaryFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, totalCharge: number, freightChargeRevenue: number, fuelChargeRevenue: number, weight: number, dimWeight: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, customCharges: Array<{ __typename?: 'CustomChargeEntity', name: string, total: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, type?: PackageType | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }> }> };

export type ConsolidatableOrderSummaryQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ConsolidatableOrderSummaryQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, totalCharge: number, freightChargeRevenue: number, fuelChargeRevenue: number, weight: number, dimWeight: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, customCharges: Array<{ __typename?: 'CustomChargeEntity', name: string, total: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, type?: PackageType | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }> }> }> };

type Contact_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, recoveryDiscountRate?: any | null, lineHaulDiscountRate?: any | null, defaultDimFactor?: number | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, includeInExpeditorsScorecard: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultRecoveryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> };

type Contact_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> };

export type ContactFragment = Contact_CustomerContactEntity_Fragment | Contact_ThirdPartyContactEntity_Fragment;

export type CreateConsolidatedOrderFromOrderMutationVariables = Exact<{
  createConsolidatedOrderFromOrderInput: CreateConsolidatedOrderFromOrderInput;
}>;


export type CreateConsolidatedOrderFromOrderMutation = { __typename?: 'Mutation', createConsolidatedOrderFromOrder: { __typename?: 'StandardOrderEntity', uuid: string } };

export type CreateConsolidatedOrderMutationVariables = Exact<{
  createConsolidatedOrderInput: CreateConsolidatedOrderInput;
}>;


export type CreateConsolidatedOrderMutation = { __typename?: 'Mutation', createConsolidatedOrder: { __typename?: 'StandardOrderEntity', uuid: string, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> } };

export type CurrentBillingPeriodInvoiceQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type CurrentBillingPeriodInvoiceQuery = { __typename?: 'Query', currentBillingPeriodInvoice: Array<{ __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus, createdAt: any, lastSyncedToQuickbooksAt?: any | null, lastSyncedFromQuickbooksAt?: any | null, quickbooksInvoiceId?: string | null, dueDate?: any | null, date: any, invoiceTotal: string, inConsolidatedInvoice: boolean, name: string, notes?: string | null, qbInvoiceNumber?: number | null, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, totalChargesAmount: number, failureCount: number, hasFailedStop: boolean, name: string, overridePackageWeight: boolean, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, shipmentType: ShipmentType, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, authoCode?: string | null, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, description?: string | null, quantity: number, billingMethod: FreightBillingMethod, rate: number, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, description?: string | null, name: string, quantity: number, rate: number, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, description?: string | null, quantity: number, rate: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, freightCharge: { __typename?: 'FreightChargeEntity', uuid: string } } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', isSpecial?: boolean | null, uuid: string, arrivedAt?: any | null, completedAt?: any | null, status: StopStatus, appointmentRequired: boolean, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, orderInvoiceByDate?: any | null, name: string, createdAt: any, refNumbers: Array<string>, totalCharge: number, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', code: EdiTransactionCode, status: EdiTransactionStatus }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, uuid: string, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }>, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, class?: number | null, freightClass?: FreightClass | null, hazmat?: boolean | null, nmfc?: string | null, skuNumber?: string | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }> }> };

export type HandleMultipleInvoices210OutboundMutationVariables = Exact<{
  handleMultiple210OutboundInput: HandleMultiple210OutboundInput;
}>;


export type HandleMultipleInvoices210OutboundMutation = { __typename?: 'Mutation', handleMultipleInvoices210Outbound: boolean };

export type InvoiceForDownloadFragmentFragment = { __typename?: 'InvoiceEntity', uuid: string, dueDate?: any | null, date: any, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null, chargeMatrixColumnMappings: Array<{ __typename?: 'ContactChargeMatrixColumnMappingEntity', uuid: string, column: ChargeMatrixColumn, accessorial: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null, chargeMatrixColumnMappings: Array<{ __typename?: 'ContactChargeMatrixColumnMappingEntity', uuid: string, column: ChargeMatrixColumn, accessorial: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } }> }, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, name: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number, totalFreightCharge: number, totalFuelCharge: number }, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, quantity: number, weight?: number | null }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, isCrossDock?: boolean | null, name: string, refNumbers: Array<string>, secondaryRefNumber?: string | null, consolidatedShipmentString?: string | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, service?: { __typename?: 'ServiceEntity', name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null }, startStop?: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, endStop?: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, total: number, description?: string | null, authoCode?: string | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | null } | { __typename?: 'FreightChargeEntity', description?: string | null, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType, name: string } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, authoCode?: string | null } | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, proofOfDeliverySignee?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, zip: string, city: string, state: string } } }> }> };

export type InvoicePdfColumnFragmentFragment = { __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null };

export type InvoiceShipmentOrderForDownloadFragmentFragment = { __typename?: 'StandardOrderEntity', uuid: string, isCrossDock?: boolean | null, name: string, refNumbers: Array<string>, secondaryRefNumber?: string | null, consolidatedShipmentString?: string | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, service?: { __typename?: 'ServiceEntity', name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null }, startStop?: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, endStop?: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null };

export type InvoiceShipmentForDownloadFragmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, name: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number, totalFreightCharge: number, totalFuelCharge: number }, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, quantity: number, weight?: number | null }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, isCrossDock?: boolean | null, name: string, refNumbers: Array<string>, secondaryRefNumber?: string | null, consolidatedShipmentString?: string | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, service?: { __typename?: 'ServiceEntity', name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null }, startStop?: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, endStop?: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, total: number, description?: string | null, authoCode?: string | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | null } | { __typename?: 'FreightChargeEntity', description?: string | null, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType, name: string } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, authoCode?: string | null } | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, proofOfDeliverySignee?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, zip: string, city: string, state: string } } }> };

export type InvoiceFragmentFragment = { __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus, createdAt: any, lastSyncedToQuickbooksAt?: any | null, lastSyncedFromQuickbooksAt?: any | null, quickbooksInvoiceId?: string | null, dueDate?: any | null, date: any, invoiceTotal: string, inConsolidatedInvoice: boolean, name: string, notes?: string | null, qbInvoiceNumber?: number | null, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, totalChargesAmount: number, failureCount: number, hasFailedStop: boolean, name: string, overridePackageWeight: boolean, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, shipmentType: ShipmentType, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, authoCode?: string | null, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, description?: string | null, quantity: number, billingMethod: FreightBillingMethod, rate: number, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, description?: string | null, name: string, quantity: number, rate: number, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, description?: string | null, quantity: number, rate: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, freightCharge: { __typename?: 'FreightChargeEntity', uuid: string } } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', isSpecial?: boolean | null, uuid: string, arrivedAt?: any | null, completedAt?: any | null, status: StopStatus, appointmentRequired: boolean, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, orderInvoiceByDate?: any | null, name: string, createdAt: any, refNumbers: Array<string>, totalCharge: number, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', code: EdiTransactionCode, status: EdiTransactionStatus }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, uuid: string, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }>, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, class?: number | null, freightClass?: FreightClass | null, hazmat?: boolean | null, nmfc?: string | null, skuNumber?: string | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }> };

export type InvoicesQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, qbInvoiceNumber?: number | null, name: string, status: InvoiceStatus, createdAt: any, inConsolidatedInvoice: boolean, invoiceTotal: string, dueDate?: any | null, lastSyncedToQuickbooksAt?: any | null, lastSyncedFromQuickbooksAt?: any | null, quickbooksInvoiceId?: string | null, date: any, notes?: string | null, journalNumber: number, invoiceTerms?: { __typename?: 'InvoiceTermEntity', terms: string, uuid: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, totalChargesAmount: number, name: string, hasFailedStop: boolean, failureCount: number, overridePackageWeight: boolean, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, shipmentType: ShipmentType, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, authoCode?: string | null, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, description?: string | null, quantity: number, billingMethod: FreightBillingMethod, rate: number, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, orderInvoiceByDate?: any | null, name: string, createdAt: any, refNumbers: Array<string>, totalCharge: number, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', code: EdiTransactionCode, status: EdiTransactionStatus }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, uuid: string, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }>, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', isSpecial?: boolean | null, uuid: string, arrivedAt?: any | null, completedAt?: any | null, status: StopStatus, appointmentRequired: boolean, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, class?: number | null, freightClass?: FreightClass | null, hazmat?: boolean | null, nmfc?: string | null, skuNumber?: string | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, type: FuelBillingMethod, flatRate: number, surchargeRate: number, uuid: string, freightCharge: { __typename?: 'FreightChargeEntity', uuid: string } } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null }> }>, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type MarkConsolidatableOrdersAsBilledIndividuallyMutationVariables = Exact<{
  markConsolidatableOrdersAsBilledIndividuallyInput: MarkConsolidatableOrdersAsBilledIndividuallyInput;
}>;


export type MarkConsolidatableOrdersAsBilledIndividuallyMutation = { __typename?: 'Mutation', markConsolidatableOrdersAsBilledIndividually: Array<{ __typename?: 'StandardOrderEntity', uuid: string, shouldBillIndividually: boolean }> };

export type OutstandingOrdersForReviewQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  isUnfinalized?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  orderCompletionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderCompletionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeUuids?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort> | OrderSort>;
}>;


export type OutstandingOrdersForReviewQuery = { __typename?: 'Query', outstandingOrdersForReview: { __typename?: 'OrderConnection', totalCount?: number | null, uuids?: Array<string> | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', totalCharge: number, freightNeedsRate: boolean, updatedAt: any, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, isOverdue: boolean, detailedStatusV2?: OrderDetailedStatus | null, isCrossDock?: boolean | null, isDoorToDoor?: boolean | null, inboundStopIntention?: StopIntention | null, outboundStopIntention?: StopIntention | null, displayChargesInCustomerPortalOverride?: boolean | null, customerPortalChargesVisibleFromOverride?: CustomerPortalChargesVisibility | null, issueReason?: string | null, personName?: string | null, personPhoneNumber?: string | null, personEmail?: string | null, name: string, notes: string, onHand?: boolean | null, dateMarkedOnHand?: any | null, refNumbers: Array<string>, orderConsolidationType: OrderConsolidationType, orderInvoiceByDate?: any | null, paymentMethod?: PaymentMethod | null, source: OrderSource, status: OrderStatus, uuid: string, isDraftOrder: boolean, chargeableWeightCubicMeters?: any | null, totalSkids?: number | null, isReweighed: boolean, secondaryRefNumber?: string | null, lockSecondaryRefNumber: boolean, tertiaryRefNumber?: string | null, quaternaryRefNumber?: string | null, quinaryRefNumber?: string | null, lineHaulCompletedDate: any, consolidatedShipmentString?: string | null, shouldBillIndividually: boolean, enableLineHaul: boolean, inBond: boolean, hazmat: boolean, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, lockShipperBillOfLadingNumber: boolean, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null, measurementUnits: MeasurementUnits, weightUnits: WeightUnits }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null }, billingPartyContactStation?: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, height?: number | null, length?: number | null, quantity: number, type?: PackageType | null, weight?: number | null, width?: number | null, description: string, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }>, originalTransmissionPackages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, description: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, fileType: string, preSignedGetUrl: string, type: DocumentType, customDocumentName?: string | null, notes?: string | null, name?: string | null }>, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, postedAt?: any | null, journalNumber: number } | null, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, user?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null }>, consolidatableOrders: { __typename?: 'ConsolidatableOrdersOutput', error?: FindConsolidatableOrdersError | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, shipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null }, consolidatedOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string } | null, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OutstandingShipmentOrderShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } };

export type OutstandingShipmentOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> };

export type ConsolidatableShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, order?: { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> } | null, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode?: string | null, terminal: string, isArchived: boolean, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed: boolean, appointmentStatus?: AppointmentStatus | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, stopIntention?: StopIntention | null, paperworkMarkedComplete?: boolean | null, failureCount?: number | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> };

export type OutstandingShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, status: ShipmentStatus, consolidatableShipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> } | null }> | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, address: { __typename?: 'AddressEntity', name: string, internalNotes?: string | null, iataCode?: string | null } } }> };

export type OutstandingShipmentQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OutstandingShipmentQuery = { __typename?: 'Query', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, status: ShipmentStatus, consolidatableShipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> } | null }> | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, consolidatedShipmentString?: string | null, name: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, notes: string, orderConsolidationType: OrderConsolidationType, source: OrderSource, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, dimFactor?: number | null, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, address: { __typename?: 'AddressEntity', name: string, internalNotes?: string | null, iataCode?: string | null } } }> } };

export type ShallowInvoicesQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ShallowInvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, qbInvoiceNumber?: number | null, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, name: string, createdAt: any, invoiceTotal: string, status: InvoiceStatus, inConsolidatedInvoice: boolean, dueDate?: any | null, invoiceTerms?: { __typename?: 'InvoiceTermEntity', terms: string } | null, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, firstShipment?: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', status: EdiTransactionStatus, code: EdiTransactionCode }> } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type UnconsolidateOrderMutationVariables = Exact<{
  unconsolidateOrderInput: UnconsolidateOrderInput;
}>;


export type UnconsolidateOrderMutation = { __typename?: 'Mutation', unconsolidateOrder: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null }> };

export type UpdateOrderShipperBillOfLadingNumberMutationVariables = Exact<{
  updateStandardOrderInput: UpdateStandardOrderInput;
}>;


export type UpdateOrderShipperBillOfLadingNumberMutation = { __typename?: 'Mutation', updateStandardOrder: { __typename?: 'StandardOrderEntity', uuid: string } };

export type WmsContactsQueryVariables = Exact<{
  companyUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type WmsContactsQuery = { __typename?: 'Query', wmsContacts: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string, name: string } } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string, name: string } }> };

export type CreateInvoiceMutationVariables = Exact<{
  createInvoiceInput: CreateInvoiceInput;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice: { __typename?: 'InvoiceEntity', uuid: string } };

export type FinalizeInvoicesMutationVariables = Exact<{
  finalizeInvoicesInput: FinalizeInvoicesInput;
}>;


export type FinalizeInvoicesMutation = { __typename?: 'Mutation', finalizeInvoices: { __typename?: 'FinalizeInvoicesOutput', count: number } };

export type DocumentsByInvoiceQueryVariables = Exact<{
  invoiceUuid: Scalars['String']['input'];
}>;


export type DocumentsByInvoiceQuery = { __typename?: 'Query', invoiceDocuments: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string }> };

export type InvoiceQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceQuery = { __typename?: 'Query', invoice?: { __typename?: 'InvoiceEntity', uuid: string, notes?: string | null, name: string, createdAt: any, dueDate?: any | null, status: InvoiceStatus, invoiceTotal: string, lastSyncedToQuickbooksAt?: any | null, lastSyncedFromQuickbooksAt?: any | null, quickbooksInvoiceId?: string | null, date: any, inConsolidatedInvoice: boolean, qbInvoiceNumber?: number | null, journalNumber: number, invoiceTerms?: { __typename?: 'InvoiceTermEntity', terms: string, uuid: string } | null, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, hasSignedPOD: boolean, totalChargesAmount: number, failureCount: number, hasFailedStop: boolean, name: string, overridePackageWeight: boolean, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, shipmentType: ShipmentType, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, authoCode?: string | null, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, description?: string | null, quantity: number, billingMethod: FreightBillingMethod, rate: number, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, description?: string | null, name: string, quantity: number, rate: number, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, description?: string | null, quantity: number, rate: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, freightCharge: { __typename?: 'FreightChargeEntity', uuid: string } } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', isSpecial?: boolean | null, uuid: string, arrivedAt?: any | null, completedAt?: any | null, status: StopStatus, appointmentRequired: boolean, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, orderInvoiceByDate?: any | null, name: string, createdAt: any, refNumbers: Array<string>, totalCharge: number, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', code: EdiTransactionCode, status: EdiTransactionStatus }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, uuid: string, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }>, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, class?: number | null, freightClass?: FreightClass | null, hazmat?: boolean | null, nmfc?: string | null, skuNumber?: string | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }> } | null };

export type InvoiceShipmentFragmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, totalChargesAmount: number, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, status: ShipmentStatus, name: string, failureCount: number, hasFailedStop: boolean, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null }>, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, authoCode?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, authoCode?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, arrivedAt?: any | null, completedAt?: any | null, appointmentRequired: boolean, status: StopStatus, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', name: string, uuid: string, line1: string, line2?: string | null, zip: string, city: string, state: string } } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, refNumbers: Array<string>, totalCharge: number, secondaryRefNumber?: string | null, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits } } | null };

export type UpdateInvoiceLimitedMutationVariables = Exact<{
  updateInvoiceLimitedInput: InvoiceUpdateLimitedInput;
}>;


export type UpdateInvoiceLimitedMutation = { __typename?: 'Mutation', updateInvoiceLimited: { __typename?: 'InvoiceEntity', uuid: string } };

export type AddOrdersToInvoicesMutationVariables = Exact<{
  input: AddOrdersToInvoicesInput;
}>;


export type AddOrdersToInvoicesMutation = { __typename?: 'Mutation', addOrdersToInvoices: { __typename: 'AddOrdersToInvoicesSuccessOutput', success: boolean, invoicesAddedToByContact: Array<{ __typename: 'AddOrdersToInvoicesForContactErrorOutput', success: boolean, contactName: string, contactUuid: string, proposedUpdatesToExistingInvoices: Array<{ __typename?: 'ExistingInvoiceToUpdate', name: string, invoiceUuid: string, ordersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> }>, proposedNewInvoicesToCreate: Array<{ __typename?: 'NewInvoiceToCreate', name?: string | null, ordersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> }> } | { __typename: 'AddOrdersToInvoicesForContactSuccessOutput', success: boolean, contactName: string, contactUuid: string, existingInvoiceAdds: Array<{ __typename: 'AddOrdersToExistingInvoiceErrorOutput', success: boolean, invoiceName: string, invoiceUuid: string, attemptedOrdersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> } | { __typename: 'AddOrdersToInvoiceSuccessOutput', success: boolean, invoiceName: string, invoiceUuid: string, ordersAdded: Array<{ __typename?: 'OrderAddedToInvoice', orderUuid: string, orderName: string }> }>, newInvoiceAdds: Array<{ __typename: 'AddOrdersToInvoiceSuccessOutput', success: boolean, invoiceName: string, invoiceUuid: string, ordersAdded: Array<{ __typename?: 'OrderAddedToInvoice', orderUuid: string, orderName: string }> } | { __typename: 'AddOrdersToNewInvoiceErrorOutput', success: boolean, createdInvoiceName?: string | null, attemptedOrdersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> }> }> } | { __typename: 'MutationErrorOutput', message: string } };

export type PreviewAddOrdersToInvoicesQueryVariables = Exact<{
  previewAddOrdersToInvoicesInput: PreviewAddOrdersToInvoicesInput;
}>;


export type PreviewAddOrdersToInvoicesQuery = { __typename?: 'Query', previewAddOrdersToInvoices: { __typename?: 'PreviewAddOrdersToInvoicesOutput', invoicesToAddToByContact: Array<{ __typename?: 'PreviewAddOrdersToInvoicesForContactOutput', contactUuid: string, contactName: string, existingInvoicesToUpdate: Array<{ __typename?: 'ExistingInvoiceToUpdate', name: string, invoiceUuid: string, ordersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> }>, newInvoicesToCreate: Array<{ __typename?: 'NewInvoiceToCreate', name?: string | null, ordersToAdd: Array<{ __typename?: 'OrderToAddToInvoice', orderUuid: string, orderName: string, shipmentUuids: Array<string> }> }> }> } };

export type ContactsForDunningQueryQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ContactsForDunningQueryQuery = { __typename?: 'Query', contactsByUuids: Array<{ __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, resolvedFreightBillingMethod: FreightBillingMethod, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, useCustomPackageSpecs: boolean, displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, uuid: string, latitude?: number | null, longitude?: number | null } | null, overdueInvoices: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, dueDate?: any | null, date: any, createdAt: any, journalNumber: number, invoiceTotal: string, balanceInCents: number, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, totalCharge: number, balanceInCents: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null }> }>, company: { __typename?: 'CompanyEntity', customDunningReportHeader?: string | null, customDunningReportFooter?: string | null }, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }>, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, freightClass?: FreightClass | null }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> } | { __typename?: 'ThirdPartyContactEntity', displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, uuid: string, latitude?: number | null, longitude?: number | null } | null, overdueInvoices: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, dueDate?: any | null, date: any, createdAt: any, journalNumber: number, invoiceTotal: string, balanceInCents: number, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, totalCharge: number, balanceInCents: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null }> }>, company: { __typename?: 'CompanyEntity', customDunningReportHeader?: string | null, customDunningReportFooter?: string | null }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> }> };

export type DunningReportPdfQueryVariables = Exact<{
  dunningReportInput: DunningReportInput;
}>;


export type DunningReportPdfQuery = { __typename?: 'Query', dunningReportPdf: { __typename?: 'ReportPdfOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type GlCodeReportPdfQueryVariables = Exact<{
  glCodeReportPdfInput: GlCodeReportPdfInput;
}>;


export type GlCodeReportPdfQuery = { __typename?: 'Query', glCodeReportPdf: { __typename?: 'ReportPdfOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type InvoiceEdiTransactionFragment = { __typename?: 'EdiTransactionEntity', createdAt: any, status: EdiTransactionStatus, order?: { __typename?: 'StandardOrderEntity', name: string, secondaryRefNumber?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null };

export type InvoiceEdiTransactionsQueryVariables = Exact<{
  findInvoiceEdiTransactionsInput: FindInvoiceEdiTransactionsInput;
}>;


export type InvoiceEdiTransactionsQuery = { __typename?: 'Query', invoiceEdiTransactions: { __typename?: 'FindInvoiceEdiTransactionsOutput', ediTransactionConnection: { __typename?: 'EdiTransactionConnection', totalCount?: number | null, edges: Array<{ __typename?: 'EdiTransactionEdge', node: { __typename?: 'EdiTransactionEntity', createdAt: any, status: EdiTransactionStatus, order?: { __typename?: 'StandardOrderEntity', name: string, secondaryRefNumber?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type InvoiceEmailSendStatusQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoiceEmailSendStatusQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, emailSendStatus: EmailSendStatus }> };

export type InvoiceForDunningReportFragment = { __typename?: 'InvoiceEntity', uuid: string, name: string, dueDate?: any | null, date: any, createdAt: any, journalNumber: number, invoiceTotal: string, balanceInCents: number, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, totalCharge: number, balanceInCents: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null } | null }> };

export type InvoiceRegisterReportCsvQueryVariables = Exact<{
  invoiceRegisterReportInput: InvoiceRegisterReportInput;
}>;


export type InvoiceRegisterReportCsvQuery = { __typename?: 'Query', invoiceRegisterReportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type InvoiceRegisterReportPdfQueryVariables = Exact<{
  invoiceRegisterReportInput: InvoiceRegisterReportInput;
}>;


export type InvoiceRegisterReportPdfQuery = { __typename?: 'Query', invoiceRegisterReportPdf: { __typename?: 'ReportPdfOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type OnTimePerformanceReportCsvQueryVariables = Exact<{
  input: OnTimePerformanceReportInput;
}>;


export type OnTimePerformanceReportCsvQuery = { __typename?: 'Query', onTimePerformanceReportCsv: { __typename: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type OnTimePerformanceReportPdfQueryVariables = Exact<{
  input: OnTimePerformanceReportInput;
}>;


export type OnTimePerformanceReportPdfQuery = { __typename?: 'Query', onTimePerformanceReportPdf: { __typename: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type SageBusinessWorksInvoiceExportCsvQueryVariables = Exact<{
  invoiceUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SageBusinessWorksInvoiceExportCsvQuery = { __typename?: 'Query', sageBusinessWorksInvoiceExportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type InvoiceShipmentWithChargesByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceShipmentWithChargesByUuidQuery = { __typename?: 'Query', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, shipmentType: ShipmentType, status: ShipmentStatus, name: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFreightCharge: number, totalFuelCharge: number, totalCharge: number }, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, paperworkMarkedComplete?: boolean | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, quantity: number, description?: string | null, rate: number, total: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, postedFuelSurchargeRate?: number | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffType: TariffType, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null }> } };

export type OverdueInvoicesQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type OverdueInvoicesQuery = { __typename?: 'Query', overdueInvoices: Array<{ __typename?: 'InvoiceEntity', name: string, dueDate?: any | null, date: any, journalNumber: number, totalNumber: number, balanceInCents: number }> };

export type ShipmentsByContactUuidQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  startCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  endCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ShipmentsByContactUuidQuery = { __typename?: 'Query', shipmentsByContactUuid?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null };

export type BatchAddShipmentsToInvoicesMultipleMutationVariables = Exact<{
  batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple;
}>;


export type BatchAddShipmentsToInvoicesMultipleMutation = { __typename?: 'Mutation', batchAddShipmentsToInvoicesMultiple: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null }> }> };

export type BatchAddShipmentsToInvoicesPreviewFragment = { __typename?: 'BatchAddShipmentsToInvoicePreview', contactName: string, contactUuid: string, billingCycleDuration: BillingCycleDuration, existingInvoiceAdds: Array<{ __typename?: 'InvoiceAdd', uuid?: string | null, name?: string | null, shipmentUuids: Array<string> }>, newInvoiceAdds: Array<{ __typename?: 'InvoiceAdd', name?: string | null, shipmentUuids: Array<string> }> };

export type BatchAddShipmentsToInvoicesResultInvoiceFragment = { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }>, order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null }> };

export type CheckConsistencyOfInvoicesQueryVariables = Exact<{
  checkConsistencyOfInvoicesInput: CheckConsistencyOfInvoicesInput;
}>;


export type CheckConsistencyOfInvoicesQuery = { __typename?: 'Query', checkConsistencyOfInvoices: Array<boolean> };

export type CreateProratedConsolidatedOrderMutationVariables = Exact<{
  input: CreateProratedConsolidatedOrderInput;
}>;


export type CreateProratedConsolidatedOrderMutation = { __typename?: 'Mutation', createProratedConsolidatedOrder: { __typename?: 'CreateProratedConsolidatedOrderOutput', consolidatedOrderUuid?: string | null, errorMessage?: string | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }> } };

export type OrderForConsolidationFlowFragment = { __typename?: 'StandardOrderEntity', uuid: string, weight: number, dimWeight: number, name: string, status: OrderStatus, pieceCountFromPackages: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, inboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, outboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', name: string } | null };

export type OrderInConsolidationFlowQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderInConsolidationFlowQuery = { __typename?: 'Query', standardOrder: { __typename?: 'StandardOrderEntity', uuid: string, weight: number, dimWeight: number, name: string, status: OrderStatus, pieceCountFromPackages: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, inboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, outboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', name: string } | null } };

export type PreviewProratedConsolidationV2QueryVariables = Exact<{
  previewProratedConsolidationV2Input: PreviewProratedConsolidationV2Input;
}>;


export type PreviewProratedConsolidationV2Query = { __typename?: 'Query', previewProratedConsolidationV2: { __typename: 'PreviewProratedConsolidationV2SuccessOutput', totalAfterProrating: number, consolidationMethod: OrderConsolidationMethod, totalWeightConsolidated: number, proratedOrders: Array<{ __typename?: 'ProratedOrder', uuid: string, name: string, hawb?: string | null, proportionForConsolidation?: number | null, proportionOfTotalWeight: number, weight: number, totalAfterProrating: number, lineHaulInitialTotal?: number | null, orderChargesInitialTotal?: number | null, inboundShipment?: { __typename?: 'ProratedShipment', initialFreightChargeTotal?: number | null, proratedFreightChargeTotal?: number | null, initialFuelChargeTotal?: number | null, proratedFuelChargeTotal?: number | null, customCharges: Array<{ __typename?: 'ProratedCustomChargeV2', initialTotal?: number | null, proratedTotal: number, name: string }> } | null, outboundShipment?: { __typename?: 'ProratedShipment', initialFreightChargeTotal?: number | null, proratedFreightChargeTotal?: number | null, initialFuelChargeTotal?: number | null, proratedFuelChargeTotal?: number | null, customCharges: Array<{ __typename?: 'ProratedCustomChargeV2', initialTotal?: number | null, proratedTotal: number, name: string }> } | null }>, proratedOverview: { __typename?: 'ProratedOverview', inboundFreightCharge?: { __typename?: 'SimpleFreightCharge', billingMethod: FreightBillingMethod, rate: string, quantity: number, amount: number } | null, outboundFreightCharge?: { __typename?: 'SimpleFreightCharge', billingMethod: FreightBillingMethod, rate: string, quantity: number, amount: number } | null, inboundFuelCharge?: { __typename?: 'SimpleFuelCharge', billingMethod: FuelBillingMethod, quantity: number, amount: number } | null, outboundFuelCharge?: { __typename?: 'SimpleFuelCharge', billingMethod: FuelBillingMethod, quantity: number, amount: number } | null, customCharges?: Array<{ __typename?: 'SimpleCustomCharge', name: string, amount: number }> | null } } | { __typename: 'QueryErrorOutput', message: string } };

export type ProratedOrderV2Fragment = { __typename?: 'ProratedOrder', uuid: string, name: string, hawb?: string | null, proportionForConsolidation?: number | null, proportionOfTotalWeight: number, weight: number, totalAfterProrating: number, lineHaulInitialTotal?: number | null, orderChargesInitialTotal?: number | null, inboundShipment?: { __typename?: 'ProratedShipment', initialFreightChargeTotal?: number | null, proratedFreightChargeTotal?: number | null, initialFuelChargeTotal?: number | null, proratedFuelChargeTotal?: number | null, customCharges: Array<{ __typename?: 'ProratedCustomChargeV2', initialTotal?: number | null, proratedTotal: number, name: string }> } | null, outboundShipment?: { __typename?: 'ProratedShipment', initialFreightChargeTotal?: number | null, proratedFreightChargeTotal?: number | null, initialFuelChargeTotal?: number | null, proratedFuelChargeTotal?: number | null, customCharges: Array<{ __typename?: 'ProratedCustomChargeV2', initialTotal?: number | null, proratedTotal: number, name: string }> } | null };

export type ProratedShipmentV2Fragment = { __typename?: 'ProratedShipment', initialFreightChargeTotal?: number | null, proratedFreightChargeTotal?: number | null, initialFuelChargeTotal?: number | null, proratedFuelChargeTotal?: number | null, customCharges: Array<{ __typename?: 'ProratedCustomChargeV2', initialTotal?: number | null, proratedTotal: number, name: string }> };

export type SimpleFreightChargeFragment = { __typename?: 'SimpleFreightCharge', billingMethod: FreightBillingMethod, rate: string, quantity: number, amount: number };

export type SimpleFuelChargeFragment = { __typename?: 'SimpleFuelCharge', billingMethod: FuelBillingMethod, quantity: number, amount: number };

export type SimpleCustomChargeFragment = { __typename?: 'SimpleCustomCharge', name: string, amount: number };

export type PreviewProratedConsolidationQueryVariables = Exact<{
  previewProratedConsolidationInput: PreviewProratedConsolidationInput;
}>;


export type PreviewProratedConsolidationQuery = { __typename?: 'Query', previewProratedConsolidation: { __typename?: 'PreviewProratedConsolidationOutput', proratedOrders: Array<{ __typename?: 'ProratedOrderInformation', order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, totalCharge: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, inboundShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, outboundShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, lineHaulShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, orderChargesShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null }, inboundShipment?: { __typename?: 'ProratedShipmentInformation', freightAndFuelProrateMultiplier: number, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, initialFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, initialFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, proratedFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, proratedFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, customCharges: Array<{ __typename?: 'ProratedCustomCharge', initialOrderUuidsPresentIn: Array<string>, initialTotalCents?: number | null, proratedTotalCents: number, name: string }> } | null, outboundShipment?: { __typename?: 'ProratedShipmentInformation', freightAndFuelProrateMultiplier: number, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, initialFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, initialFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, proratedFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, proratedFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, customCharges: Array<{ __typename?: 'ProratedCustomCharge', initialOrderUuidsPresentIn: Array<string>, initialTotalCents?: number | null, proratedTotalCents: number, name: string }> } | null }> } };

export type ProratedOrderFragment = { __typename?: 'ProratedOrderInformation', order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, totalCharge: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, inboundShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, outboundShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, lineHaulShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null, orderChargesShipment?: { __typename?: 'StandardShipmentEntity', totalChargesAmount: number } | null }, inboundShipment?: { __typename?: 'ProratedShipmentInformation', freightAndFuelProrateMultiplier: number, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, initialFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, initialFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, proratedFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, proratedFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, customCharges: Array<{ __typename?: 'ProratedCustomCharge', initialOrderUuidsPresentIn: Array<string>, initialTotalCents?: number | null, proratedTotalCents: number, name: string }> } | null, outboundShipment?: { __typename?: 'ProratedShipmentInformation', freightAndFuelProrateMultiplier: number, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, initialFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, initialFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, proratedFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, proratedFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, customCharges: Array<{ __typename?: 'ProratedCustomCharge', initialOrderUuidsPresentIn: Array<string>, initialTotalCents?: number | null, proratedTotalCents: number, name: string }> } | null };

export type ProratedShipmentFragment = { __typename?: 'ProratedShipmentInformation', freightAndFuelProrateMultiplier: number, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, initialFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, initialFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, proratedFreightCharge?: { __typename?: 'FreightChargeForProrating', totalCents: number } | null, proratedFuelCharge?: { __typename?: 'FuelChargeForProrating', totalCents: number } | null, customCharges: Array<{ __typename?: 'ProratedCustomCharge', initialOrderUuidsPresentIn: Array<string>, initialTotalCents?: number | null, proratedTotalCents: number, name: string }> };

export type ProrateOrdersMutationVariables = Exact<{
  input: ProrateOrdersInput;
}>;


export type ProrateOrdersMutation = { __typename?: 'Mutation', prorateOrders: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'ProrateOrdersSuccessOutput', orderUuids: Array<string> } };

export type TypeaheadOrderUuidsQueryForConsolidationFlowQueryVariables = Exact<{
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter> | StatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  onInvoice?: InputMaybe<BooleanFilter>;
  versionId?: InputMaybe<Scalars['Float']['input']>;
  includeOrdersPartOfV2ConsolidatedOrdersFilter?: InputMaybe<BooleanFilterV2>;
}>;


export type TypeaheadOrderUuidsQueryForConsolidationFlowQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', versionId?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, weight: number, dimWeight: number, name: string, status: OrderStatus, pieceCountFromPackages: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, inboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, outboundShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string } } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string } | null } | null, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

type ContactForInvoice_CustomerContactEntity_Fragment = { __typename: 'CustomerContactEntity', numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceDownloadDocuments: Array<DocumentType>, enableCreditHold?: boolean | null, defaultInvoiceEmailSubject?: string | null, uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null };

type ContactForInvoice_ThirdPartyContactEntity_Fragment = { __typename: 'ThirdPartyContactEntity', uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null };

export type ContactForInvoiceFragment = ContactForInvoice_CustomerContactEntity_Fragment | ContactForInvoice_ThirdPartyContactEntity_Fragment;

export type ContactsForInvoicesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByContactName?: InputMaybe<Scalars['Boolean']['input']>;
  excludeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactsForInvoicesQuery = { __typename?: 'Query', paginatedContacts: { __typename?: 'ContactConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ContactEdge', node: { __typename: 'CustomerContactEntity', numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceDownloadDocuments: Array<DocumentType>, enableCreditHold?: boolean | null, defaultInvoiceEmailSubject?: string | null, uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null } | { __typename: 'ThirdPartyContactEntity', uuid: string, displayName: string, stediPartnerId?: string | null, contactReferenceNumber?: string | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type CreateContactDocumentMutationVariables = Exact<{
  createContactDocumentInput: CreateContactDocumentInput;
}>;


export type CreateContactDocumentMutation = { __typename?: 'Mutation', createContactDocument: { __typename?: 'DocumentEntity', uuid: string } };

export type CreateInvoiceDocumentsMutationVariables = Exact<{
  createInvoiceDocumentsInput: CreateInvoiceDocumentsInput;
}>;


export type CreateInvoiceDocumentsMutation = { __typename?: 'Mutation', createInvoiceDocuments: Array<{ __typename?: 'DocumentEntity', uuid: string, bucket: string, region: string, key: string, fileName: string, fileType: string, type: DocumentType, invoice?: { __typename?: 'InvoiceEntity', uuid: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null }> };

export type DownloadInvoicesMutationVariables = Exact<{
  downloadInvoicesInput: DownloadInvoicesInput;
}>;


export type DownloadInvoicesMutation = { __typename?: 'Mutation', downloadInvoices: { __typename?: 'DownloadInvoicesOutput', combinedDocument?: { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null } | null, zipDocument?: { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null } | null } };

export type ExportInvoicesToQuickbooksDesktopMutationVariables = Exact<{
  exportInvoicesToQuickbooksInput: ExportInvoicesToQuickbooksInput;
}>;


export type ExportInvoicesToQuickbooksDesktopMutation = { __typename?: 'Mutation', exportInvoicesToQuickbooksDesktop: Array<{ __typename?: 'ExportQuickbooksResult', failedInvoiceUuid: string, missingFreightChargeMappings: Array<string>, missingFuelChargeMappings: Array<string>, missingAccessorialMappings: Array<string>, missingCustomerName?: string | null, missingCustomerUuid?: string | null, duplicateInvoiceError?: string | null, conductorUserFacingErrors: Array<string>, success: boolean, invoice: { __typename?: 'QuickbooksDesktopInvoiceEntity', id: string, name: string, amount: number } }> };

export type GenerateInvoicePreSignedPutUrlsMutationVariables = Exact<{
  generateInvoicePreSignedPutUrlsInput: GenerateInvoicePreSignedPutUrlsInput;
}>;


export type GenerateInvoicePreSignedPutUrlsMutation = { __typename?: 'Mutation', generateInvoicePreSignedPutUrls: Array<{ __typename?: 'GenerateInvoicePreSignedPutUrlOutput', url: string, invoiceUuid: string }> };

export type InvoiceExcelExportDataQueryVariables = Exact<{
  invoiceUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoiceExcelExportDataQuery = { __typename?: 'Query', invoiceExcelExportData: Array<{ __typename?: 'InvoiceExcelExportDataOutput', invoiceUuid: string, shipments: Array<{ __typename?: 'InvoiceExcelShipmentAmounts', uuid: string, totalCharge: number, totalFreightCharge: number, totalFuelCharge: number, smc3FreightText?: string | null, customCharges: Array<{ __typename?: 'InvoiceExcelCustomChargeAmount', uuid: string, total: number }> }> }> };

export type InvoiceForContactFragment = { __typename?: 'InvoiceEntity', uuid: string, source: InvoiceSource, name: string, journalNumber: number, status: InvoiceStatus, date: any, createdAt: any, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type InvoiceForInvoiceSelectionFragment = { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, date: any, dueDate?: any | null };

export type InvoiceGroupsQueryVariables = Exact<{
  groupBy: InvoiceTableGroupByInput;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  isSyncedToQuickbooks?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuickbooksSyncFailure?: InputMaybe<Scalars['Boolean']['input']>;
  quickbooksSyncFailureCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type InvoiceGroupsQuery = { __typename?: 'Query', invoiceGroups: { __typename?: 'InvoiceTableGroupsOutput', hasMore: boolean, groupRows: Array<{ __typename?: 'InvoiceTableGroupRowEntity', key?: string | null, label?: string | null, count: number }> } };

export type InvoiceOrderFragmentFragment = { __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, missingDocuments: Array<DocumentType>, appliedAmount: number, balanceInCents: number, secondaryRefNumber?: string | null, pieceCountFromPackages: number, weight: number, documents: Array<{ __typename?: 'DocumentEntity', type: DocumentType }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, orderPaymentMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', uuid: string, amountInCents: number, payment: { __typename?: 'PaymentEntity', paymentType: PaymentType, contact: { __typename?: 'CustomerContactEntity', displayName: string, uuid: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string } } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null }>, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, address: { __typename?: 'AddressEntity', name: string } } | null };

export type InvoiceOrderWithShipmentsFragment = { __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, missingDocuments: Array<DocumentType>, appliedAmount: number, balanceInCents: number, secondaryRefNumber?: string | null, pieceCountFromPackages: number, weight: number, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, shipmentType: ShipmentType, status: ShipmentStatus, name: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number, totalFreightCharge: number, totalFuelCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, paperworkMarkedComplete?: boolean | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, quantity: number, description?: string | null, rate: number, total: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, postedFuelSurchargeRate?: number | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffType: TariffType, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null }> }>, documents: Array<{ __typename?: 'DocumentEntity', type: DocumentType }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, orderPaymentMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', uuid: string, amountInCents: number, payment: { __typename?: 'PaymentEntity', paymentType: PaymentType, contact: { __typename?: 'CustomerContactEntity', displayName: string, uuid: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string } } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, address: { __typename?: 'AddressEntity', name: string } } | null };

export type AcknowledgeFailedInvoiceSendJobsMutationVariables = Exact<{
  invoiceSendJobBatchUuid: Scalars['String']['input'];
}>;


export type AcknowledgeFailedInvoiceSendJobsMutation = { __typename?: 'Mutation', acknowledgeFailedInvoiceSendJobs: { __typename?: 'InvoiceSendJobBatchEntity', uuid: string } };

export type InvoiceDocumentForDownloadFragment = { __typename?: 'DocumentEntity', fileType: string, preSignedGetUrl: string, invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number } | null };

export type InvoiceSendJobBatchFragment = { __typename?: 'InvoiceSendJobBatchEntity', uuid: string, createdAt: any, type: InvoiceSendJobBatchType, invoiceSendJobBatchProgress: { __typename?: 'InvoiceSendJobBatchProgressEntity', totalCount: number, failCount: number, successCount: number }, invoiceBatchDocuments: { __typename?: 'InvoiceSendJobBatchDocumentsEntity', invoicesBackupDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesCombinedDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesZipDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null } };

export type InvoiceSendJobBatchesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtAsc?: InputMaybe<Scalars['Boolean']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  hasFailures?: InputMaybe<Scalars['Boolean']['input']>;
  createdAtDateFilters?: InputMaybe<Array<DateFilter> | DateFilter>;
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  includeCount: Scalars['Boolean']['input'];
}>;


export type InvoiceSendJobBatchesQuery = { __typename?: 'Query', invoiceSendJobBatches: { __typename?: 'InvoiceSendJobBatchConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceSendJobBatchEdge', node: { __typename?: 'InvoiceSendJobBatchEntity', uuid: string, createdAt: any, type: InvoiceSendJobBatchType, invoiceSendJobBatchProgress: { __typename?: 'InvoiceSendJobBatchProgressEntity', totalCount: number, failCount: number, successCount: number }, invoiceBatchDocuments: { __typename?: 'InvoiceSendJobBatchDocumentsEntity', invoicesBackupDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesCombinedDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesZipDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type InvoiceSendJobShallowFragment = { __typename?: 'InvoiceSendJobEntity', uuid: string, invoice: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } };

export type InvoiceSendJobFragment = { __typename?: 'InvoiceSendJobEntity', uuid: string, createdAt: any, invoiceSendJobError?: InvoiceSendJobError | null, invoiceAttachmentDocumentTypes: Array<DocumentType>, invoiceTransmissionMethod: InvoiceTransmissionMethod, invoiceChargesObject?: string | null, invoice: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string } }, document?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', uuid: string, emailTransactionStatus: EmailTransactionStatus, pdfNotAttached: boolean, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null };

export type InvoiceSendJobsShallowQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  invoiceSendJobBatchUuid: Scalars['String']['input'];
  invoiceSendJobStatus?: InputMaybe<InvoiceSendJobStatus>;
}>;


export type InvoiceSendJobsShallowQuery = { __typename?: 'Query', invoiceSendJobs: { __typename?: 'InvoiceSendJobConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceSendJobEdge', node: { __typename?: 'InvoiceSendJobEntity', uuid: string, invoice: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type InvoiceSendJobsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  invoiceSendJobBatchUuid: Scalars['String']['input'];
  invoiceSendJobStatus?: InputMaybe<InvoiceSendJobStatus>;
}>;


export type InvoiceSendJobsQuery = { __typename?: 'Query', invoiceSendJobs: { __typename?: 'InvoiceSendJobConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceSendJobEdge', node: { __typename?: 'InvoiceSendJobEntity', uuid: string, createdAt: any, invoiceSendJobError?: InvoiceSendJobError | null, invoiceAttachmentDocumentTypes: Array<DocumentType>, invoiceTransmissionMethod: InvoiceTransmissionMethod, invoiceChargesObject?: string | null, invoice: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string } }, document?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', uuid: string, emailTransactionStatus: EmailTransactionStatus, pdfNotAttached: boolean, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type InvoiceShipmentWithChargesFragment = { __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, shipmentType: ShipmentType, status: ShipmentStatus, name: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFreightCharge: number, totalFuelCharge: number, totalCharge: number }, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, paperworkMarkedComplete?: boolean | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, quantity: number, description?: string | null, rate: number, total: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, postedFuelSurchargeRate?: number | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffType: TariffType, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null }> };

export type InvoiceStatFragment = { __typename?: 'InvoiceEntity', balanceInCents: number, invoiceTotal: string, uuid: string };

export type InvoiceStatsByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoiceStatsByUuidsQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', balanceInCents: number, invoiceTotal: string, uuid: string }> };

export type InvoiceTermFragment = { __typename?: 'InvoiceTermEntity', uuid: string, terms: string };

export type InvoiceTotalQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceTotalQuery = { __typename?: 'Query', invoice?: { __typename?: 'InvoiceEntity', invoiceTotal: string } | null };

export type InvoiceTotalsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoiceTotalsQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', balanceInCents: number, invoiceTotal: string, uuid: string }> };

export type InvoiceUuidsForBatchPostQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  sortByDueDateAscending?: InputMaybe<Scalars['Boolean']['input']>;
  sortByDueDateDescending?: InputMaybe<Scalars['Boolean']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooks?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InvoiceUuidsForBatchPostQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus, hasAppliedPayments: boolean } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type InvoiceV2QueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceV2Query = { __typename?: 'Query', invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, createdAt: any, dueDate?: any | null, date: any, status: InvoiceStatus, source: InvoiceSource, qbInvoiceNumber?: number | null, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, quickbooksLastSyncAttemptAt?: any | null, quickbooksSyncFailureCode?: string | null, quickbooksSyncFailureTitle?: string | null, quickbooksSyncFailureDetail?: string | null, quickbooksSyncFailureRemediation?: string | null, quickbooksSyncFailureElement?: string | null, quickbooksSyncFaultCode?: string | null, quickbooksSyncRequestId?: string | null, emailOptions: Array<string>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, stedi210TransactionSettingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, stedi210TransactionSettingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> }, firstShipment?: { __typename?: 'StandardShipmentEntity', uuid: string } | null, latest210EdiStatus?: { __typename?: 'Latest210EdiStatusEntity', uuid: string, status: EdiTransactionStatus, errorSummary?: string | null, updatedAt: any } | null } | null };

export type InvoiceWithOrdersFragment = { __typename?: 'InvoiceEntity', uuid: string, source: InvoiceSource, name: string, journalNumber: number, status: InvoiceStatus, date: any, createdAt: any, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type InvoicesByUuidsForDownloadQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  includeDocuments: Scalars['Boolean']['input'];
}>;


export type InvoicesByUuidsForDownloadQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, dueDate?: any | null, date: any, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null, chargeMatrixColumnMappings: Array<{ __typename?: 'ContactChargeMatrixColumnMappingEntity', uuid: string, column: ChargeMatrixColumn, accessorial: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, invoiceNotes?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null, chargeMatrixColumnMappings: Array<{ __typename?: 'ContactChargeMatrixColumnMappingEntity', uuid: string, column: ChargeMatrixColumn, accessorial: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } }> }, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, name: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number, totalFreightCharge: number, totalFuelCharge: number }, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, quantity: number, weight?: number | null }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, isCrossDock?: boolean | null, name: string, refNumbers: Array<string>, secondaryRefNumber?: string | null, consolidatedShipmentString?: string | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, service?: { __typename?: 'ServiceEntity', name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null }, startStop?: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, endStop?: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, total: number, description?: string | null, authoCode?: string | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | null } | { __typename?: 'FreightChargeEntity', description?: string | null, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType, name: string } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, authoCode?: string | null } | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, proofOfDeliverySignee?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, zip: string, city: string, state: string } } }> }> }> };

export type InvoicesByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoicesByUuidsQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus, createdAt: any, lastSyncedToQuickbooksAt?: any | null, lastSyncedFromQuickbooksAt?: any | null, quickbooksInvoiceId?: string | null, dueDate?: any | null, date: any, invoiceTotal: string, inConsolidatedInvoice: boolean, name: string, notes?: string | null, qbInvoiceNumber?: number | null, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string } | null, addresses: Array<{ __typename?: 'AddressEntity', uuid: string }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string }> }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, totalChargesAmount: number, failureCount: number, hasFailedStop: boolean, name: string, overridePackageWeight: boolean, shouldUseDimWeight: boolean, totalCustomChargesAmount: number, totalFuelChargesAmount: number, totalFreightChargesAmount: number, shipmentType: ShipmentType, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, authoCode?: string | null, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, description?: string | null, quantity: number, billingMethod: FreightBillingMethod, rate: number, authoCode?: string | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, flatRate: number, authoCode?: string | null, type: FuelBillingMethod } | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, description?: string | null, name: string, quantity: number, rate: number, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, percentForSettlement?: number | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, description?: string | null, quantity: number, rate: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, uuid: string, freightCharge: { __typename?: 'FreightChargeEntity', uuid: string } } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', isSpecial?: boolean | null, uuid: string, arrivedAt?: any | null, completedAt?: any | null, status: StopStatus, appointmentRequired: boolean, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, secondaryRefNumber?: string | null, orderInvoiceByDate?: any | null, name: string, createdAt: any, refNumbers: Array<string>, totalCharge: number, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', code: EdiTransactionCode, status: EdiTransactionStatus }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, uuid: string, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }>, billingPartyContact: { __typename?: 'CustomerContactEntity', businessDivision?: { __typename?: 'BusinessDivisionEntity', name: string } | null } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, weight?: number | null, description: string, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, class?: number | null, freightClass?: FreightClass | null, hazmat?: boolean | null, nmfc?: string | null, skuNumber?: string | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, dimFactor: number, type: StandardShipmentType, shipmentWeight: number, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }> }> };

export type InvoicesForContactQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort> | FindInvoicesSort>;
}>;


export type InvoicesForContactQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, source: InvoiceSource, name: string, journalNumber: number, status: InvoiceStatus, date: any, createdAt: any, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type InvoicesForInvoiceSelectionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvoicesForInvoiceSelectionQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, date: any, dueDate?: any | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type InvoiceForRegisterReportFragment = { __typename?: 'InvoiceEntity', uuid: string, date: any, name: string, journalNumber: number, status: InvoiceStatus, inConsolidatedInvoice: boolean, dueDate?: any | null, balanceInCents: number, invoiceTotal: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type InvoicesForRegisterReportQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvoicesForRegisterReportQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, date: any, name: string, journalNumber: number, status: InvoiceStatus, inConsolidatedInvoice: boolean, dueDate?: any | null, balanceInCents: number, invoiceTotal: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type InvoicesMetadataByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoicesMetadataByUuidsQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } }> };

export type InvoicesWithOrdersQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  hasZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort> | FindInvoicesSort>;
}>;


export type InvoicesWithOrdersQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, source: InvoiceSource, name: string, journalNumber: number, status: InvoiceStatus, date: any, createdAt: any, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type LinehaulRevenueReportQueryVariables = Exact<{
  LineHaulRevenueReportInput: LineHaulRevenueReportInput;
}>;


export type LinehaulRevenueReportQuery = { __typename?: 'Query', linehaulRevenueReport: { __typename?: 'LineHaulRevenueReportOutput', url: string, fileName: string } };

export type ManuallySetInvoicesQbSyncStatusMutationVariables = Exact<{
  invoiceUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  synced: Scalars['Boolean']['input'];
}>;


export type ManuallySetInvoicesQbSyncStatusMutation = { __typename?: 'Mutation', manuallySetInvoicesQbSyncStatus: boolean };

export type MoveShipmentsBetweenInvoicesMutationVariables = Exact<{
  moveShipmentsBetweenInvoicesInput: MoveShipmentsBetweenInvoicesInput;
}>;


export type MoveShipmentsBetweenInvoicesMutation = { __typename?: 'Mutation', moveShipmentsBetweenInvoices: { __typename?: 'MoveShipmentsBetweenInvoicesIncompleteOperationOutput', inputShipmentUuids: Array<string>, additionalShipmentUuidsToMove: Array<string>, missingOrders: Array<{ __typename?: 'MissingOrderForInvoiceMoveEntity', uuid: string, name: string }> } | { __typename?: 'MoveShipmentsBetweenInvoicesSuccessOutput', newInvoiceUuid: string, movedShipmentUuids: Array<string> } | { __typename?: 'MutationErrorOutput', message: string } };

export type MoveShipmentsToInvoiceMutationVariables = Exact<{
  moveShipmentsToInvoiceInput: MoveShipmentsToInvoiceInput;
}>;


export type MoveShipmentsToInvoiceMutation = { __typename?: 'Mutation', moveShipmentsToInvoice: { __typename?: 'MoveShipmentsToInvoiceOutput', errors?: Array<string> | null } };

export type NetSalesSummaryReportQueryVariables = Exact<{
  netSalesSummaryReportInput: NetSalesSummaryReportInput;
}>;


export type NetSalesSummaryReportQuery = { __typename?: 'Query', netSalesSummaryReport: { __typename?: 'NetSalesSummaryReportOutput', contactRows: Array<{ __typename?: 'NetSalesSummaryReportOutputRow', contactUuid: string, contactName: string, pieces: number, weight: number, dimWeight: number, openInvoiesTotalInCents: number, adjustmentsInCents: number, netSalesInCents: number }>, reportTotal: { __typename?: 'NetSalesSummaryReportOutputRow', contactUuid: string, contactName: string, pieces: number, weight: number, dimWeight: number, openInvoiesTotalInCents: number, adjustmentsInCents: number, netSalesInCents: number } } };

export type OrderRefSearchQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;


export type OrderRefSearchQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null } }> } };

export type OrderProratedWithFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } };

export type PaginatedOrdersByInvoiceQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid: Scalars['String']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortByShipperBillOfLadingNumberAsc?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<FindOrdersOnInvoiceSort> | FindOrdersOnInvoiceSort>;
}>;


export type PaginatedOrdersByInvoiceQuery = { __typename?: 'Query', paginatedOrdersByInvoice: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, missingDocuments: Array<DocumentType>, appliedAmount: number, balanceInCents: number, secondaryRefNumber?: string | null, pieceCountFromPackages: number, weight: number, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, overridePackageWeight: boolean, shipmentType: ShipmentType, status: ShipmentStatus, name: string, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalCharge: number, totalFreightCharge: number, totalFuelCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, paperworkMarkedComplete?: boolean | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }>, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, quantity: number, description?: string | null, rate: number, total: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, postedFuelSurchargeRate?: number | null, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, invoiceDisplayName?: string | null } | null } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffType: TariffType, tariffZone: { __typename?: 'TariffZoneEntity', name: string, type: TariffZoneType } } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string, settlementFlatRate?: number | null, settlementPercentageRate?: number | null } | null }> }>, documents: Array<{ __typename?: 'DocumentEntity', type: DocumentType }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, orderPaymentMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', uuid: string, amountInCents: number, payment: { __typename?: 'PaymentEntity', paymentType: PaymentType, contact: { __typename?: 'CustomerContactEntity', displayName: string, uuid: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string } } }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, comment: string, showOnInvoice?: boolean | null }>, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, address: { __typename?: 'AddressEntity', name: string } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type AllInvoicesForPaymentApplicationQueryVariables = Exact<{
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  masterAccountUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllInvoicesForPaymentApplicationQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } }> } };

export type ApplyDebitToPaymentMutationVariables = Exact<{
  input: ApplyDebitToPaymentInput;
}>;


export type ApplyDebitToPaymentMutation = { __typename?: 'Mutation', applyDebitToPayment: { __typename?: 'PaymentToPaymentMappingEntity', uuid: string, amountInCents: number, createdAt: any, sourcePayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number }, targetPayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number } } };

export type AverageDaysToPayReportDataFragment = { __typename?: 'AverageDaysToPayForContactEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, averageDaysToPay90: number, averageDaysToPay180: number, averageDaysToPay270: number, averageDaysToPay360: number, averageDaysToPay720: number, averageDaysToPayAll: number };

export type AverageDaysToPayReportQueryVariables = Exact<{ [key: string]: never; }>;


export type AverageDaysToPayReportQuery = { __typename?: 'Query', averageDaysToPayReport: Array<{ __typename?: 'AverageDaysToPayForContactEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, averageDaysToPay90: number, averageDaysToPay180: number, averageDaysToPay270: number, averageDaysToPay360: number, averageDaysToPay720: number, averageDaysToPayAll: number }> };

export type ContactBalancesByOrderUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactBalancesByOrderUuidQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, billingPartyContact: { __typename?: 'CustomerContactEntity', creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, uuid: string, displayName: string, contactOpenInvoiceValue: number, postedInvoicesTotalOpenBalance: number, postedInvoicesTotalClosedBalance: number, paymentsAppliedToContactInvoices: number, unappliedPayments: number, offsetPayments: number, creditsAppliedToContactInvoices: number, unappliedCredits?: number | null, offsetCredits: number, debitsAppliedToContactInvoices: number, unappliedDebits: number, offsetDebits: number, balance: number }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null };

export type ContactBalancesQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ContactBalancesQuery = { __typename?: 'Query', contact: { __typename?: 'CustomerContactEntity', creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, uuid: string, displayName: string, contactOpenInvoiceValue: number, postedInvoicesTotalOpenBalance: number, postedInvoicesTotalClosedBalance: number, paymentsAppliedToContactInvoices: number, unappliedPayments: number, offsetPayments: number, creditsAppliedToContactInvoices: number, unappliedCredits?: number | null, offsetCredits: number, debitsAppliedToContactInvoices: number, unappliedDebits: number, offsetDebits: number, balance: number } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, contactOpenInvoiceValue: number, postedInvoicesTotalOpenBalance: number, postedInvoicesTotalClosedBalance: number, paymentsAppliedToContactInvoices: number, unappliedPayments: number, offsetPayments: number, creditsAppliedToContactInvoices: number, unappliedCredits?: number | null, offsetCredits: number, debitsAppliedToContactInvoices: number, unappliedDebits: number, offsetDebits: number, balance: number } };

type ContactWithBalances_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, uuid: string, displayName: string, contactOpenInvoiceValue: number, postedInvoicesTotalOpenBalance: number, postedInvoicesTotalClosedBalance: number, paymentsAppliedToContactInvoices: number, unappliedPayments: number, offsetPayments: number, creditsAppliedToContactInvoices: number, unappliedCredits?: number | null, offsetCredits: number, debitsAppliedToContactInvoices: number, unappliedDebits: number, offsetDebits: number, balance: number };

type ContactWithBalances_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, contactOpenInvoiceValue: number, postedInvoicesTotalOpenBalance: number, postedInvoicesTotalClosedBalance: number, paymentsAppliedToContactInvoices: number, unappliedPayments: number, offsetPayments: number, creditsAppliedToContactInvoices: number, unappliedCredits?: number | null, offsetCredits: number, debitsAppliedToContactInvoices: number, unappliedDebits: number, offsetDebits: number, balance: number };

export type ContactWithBalancesFragment = ContactWithBalances_CustomerContactEntity_Fragment | ContactWithBalances_ThirdPartyContactEntity_Fragment;

export type CreatePaymentMutationVariables = Exact<{
  createPaymentInput: CreatePaymentInput;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', createPayment: { __typename?: 'PaymentEntity', uuid: string } };

export type DeletePaymentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeletePaymentMutation = { __typename?: 'Mutation', deletePayment: { __typename?: 'PaymentEntity', uuid: string } };

export type OrderAmountsToPayForHawbQueryVariables = Exact<{
  hawb: Scalars['String']['input'];
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  amountInCents: Scalars['Float']['input'];
}>;


export type OrderAmountsToPayForHawbQuery = { __typename?: 'Query', orderAmountsToPayForHawb: Array<{ __typename?: 'OrderToChargeEntity', amountInCents: number, orderUuid: string, invoiceUuid?: string | null, hawb?: string | null, billToContactUuid?: string | null, billToContactDisplayName?: string | null, lineBalanceInCents: number, orderTotalInCents: number, currentBalanceInCents: number }> };

export type OrderAmountsToPayForInvoiceQueryVariables = Exact<{
  invoiceUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  amountInCents: Scalars['Float']['input'];
}>;


export type OrderAmountsToPayForInvoiceQuery = { __typename?: 'Query', orderAmountsToPayForInvoice: Array<{ __typename?: 'OrderToChargeEntity', amountInCents: number, orderUuid: string, invoiceUuid?: string | null, hawb?: string | null, billToContactUuid?: string | null, billToContactDisplayName?: string | null, lineBalanceInCents: number, orderTotalInCents: number, currentBalanceInCents: number }> };

export type OrdersByUuidsForPaymentStatsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersByUuidsForPaymentStatsQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, invoice?: { __typename?: 'InvoiceEntity', balanceInCents: number, invoiceTotal: string } | null }> };

export type OrdersForPaymentFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, appliedAmount: number, totalCharge: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null };

export type InvoiceForPaymentFragment = { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, journalNumber: number };

export type OrdersForPaymentsQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  filterOutZeroBalance?: InputMaybe<Scalars['Boolean']['input']>;
  currentPaymentUuid?: InputMaybe<Scalars['String']['input']>;
  includeTotalCount?: InputMaybe<Scalars['Boolean']['input']>;
  includeTotalCountsByInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  groupOrdersBy?: InputMaybe<GroupOrdersForPaymentsBy>;
  sorts?: InputMaybe<Array<OrdersForPaymentsSort> | OrdersForPaymentsSort>;
}>;


export type OrdersForPaymentsQuery = { __typename?: 'Query', ordersForPayments: { __typename?: 'OrderConnection', totalCount?: number | null, groupedCountsByInvoice?: Array<{ __typename?: 'GroupedCounts', groupUuid: string, count: number }> | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, appliedAmount: number, totalCharge: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OutstandingInvoicesForCustomerQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type OutstandingInvoicesForCustomerQuery = { __typename?: 'Query', outstandingInvoicesForCustomer?: Array<{ __typename?: 'InvoiceEntity', journalNumber: number, name: string }> | null };

export type PaymentByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type PaymentByUuidQuery = { __typename?: 'Query', paymentByUuid?: { __typename?: 'PaymentEntity', uuid: string, amountInCents: number, comment?: string | null, referenceNumber: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, date: any, glTerminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, creditType?: { __typename?: 'CreditTypeEntity', uuid: string, name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', uuid: string, invoice?: { __typename?: 'InvoiceEntity', uuid: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } }> } | null };

export type PaymentCustomerScopeQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type PaymentCustomerScopeQuery = { __typename?: 'Query', paymentCustomerScope: Array<string> };

export type PaymentForCheckRegisterReportFragment = { __typename?: 'PaymentForCheckRegisterReportEntity', paymentUuid: string, referenceNumber: string, paymentDate?: any | null, terminalCodes?: Array<string> | null, contactDisplayName?: string | null, contactReferenceNumber?: string | null, comment?: string | null, amountInCents?: number | null };

export type PaymentForInvoiceFragment = { __typename?: 'PaymentEntity', uuid: string, date: any, amountInCents: number, referenceNumber: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, creditType?: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, systemKey?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } };

export type PaymentForReportFragment = { __typename?: 'PaymentEntity', uuid: string, amountInCents: number, referenceNumber: string, date: any, paymentType: PaymentType, paymentRail?: PaymentRail | null, comment?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null }, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', order: { __typename?: 'StandardOrderEntity', shipments: Array<{ __typename?: 'StandardShipmentEntity', legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> } }> };

export type PaymentOffsetPartyFragment = { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number };

export type PaymentOffsetFragment = { __typename?: 'PaymentToPaymentMappingEntity', uuid: string, amountInCents: number, createdAt: any, sourcePayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number }, targetPayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number } };

export type PaymentOffsetsForPaymentQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type PaymentOffsetsForPaymentQuery = { __typename?: 'Query', paymentByUuid?: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number, paymentOffsets: Array<{ __typename?: 'PaymentToPaymentMappingEntity', uuid: string, amountInCents: number, createdAt: any, sourcePayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number }, targetPayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number } }> } | null };

export type PaymentRefSearchQueryVariables = Exact<{
  referenceNumber: Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;


export type PaymentRefSearchQuery = { __typename?: 'Query', paymentsV2: { __typename?: 'PaymentConnection', edges: Array<{ __typename?: 'PaymentEdge', node: { __typename?: 'PaymentEntity', uuid: string, referenceNumber: string, amountInCents: number, date: any, paymentType: PaymentType, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }> } };

export type PaymentFragment = { __typename?: 'PaymentEntity', uuid: string, amountInCents: number, referenceNumber: string, date: any, comment?: string | null, paymentType: PaymentType, paymentRail?: PaymentRail | null, unappliedAmountInCents: number, creditType?: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, systemKey?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null }, glTerminal?: { __typename?: 'TerminalEntity', name: string } | null, paymentOffsets: Array<{ __typename?: 'PaymentToPaymentMappingEntity', uuid: string, amountInCents: number, createdAt: any, sourcePayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number }, targetPayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number } }>, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', uuid: string, totalCharge: number, invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number, uuid: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } }> };

export type PaymentsByContactUuidQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentsByContactUuidQuery = { __typename?: 'Query', paymentsV2: { __typename?: 'PaymentConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PaymentEdge', cursor: string, node: { __typename?: 'PaymentEntity', uuid: string, amountInCents: number, referenceNumber: string, date: any, comment?: string | null, paymentType: PaymentType, paymentRail?: PaymentRail | null, unappliedAmountInCents: number, creditType?: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, systemKey?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null }, glTerminal?: { __typename?: 'TerminalEntity', name: string } | null, paymentOffsets: Array<{ __typename?: 'PaymentToPaymentMappingEntity', uuid: string, amountInCents: number, createdAt: any, sourcePayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number }, targetPayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number } }>, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', uuid: string, totalCharge: number, invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number, uuid: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type PaymentsByInvoiceUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type PaymentsByInvoiceUuidQuery = { __typename?: 'Query', paymentsByInvoiceUuid: Array<{ __typename?: 'PaymentEntity', uuid: string, date: any, amountInCents: number, referenceNumber: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, creditType?: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, systemKey?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string } | null } }> };

export type PaymentsForCheckRegisterReportOldQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentsForCheckRegisterReportOldQuery = { __typename?: 'Query', paymentsV2: { __typename?: 'PaymentConnection', edges: Array<{ __typename?: 'PaymentEdge', cursor: string, node: { __typename?: 'PaymentEntity', uuid: string, amountInCents: number, referenceNumber: string, date: any, paymentType: PaymentType, paymentRail?: PaymentRail | null, comment?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, contactReferenceNumber?: string | null }, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', order: { __typename?: 'StandardOrderEntity', shipments: Array<{ __typename?: 'StandardShipmentEntity', legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> } }> } }> } };

export type PaymentsForCheckRegisterReportQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentsForCheckRegisterReportQuery = { __typename?: 'Query', checkRegisterReport: Array<{ __typename?: 'PaymentForCheckRegisterReportEntity', paymentUuid: string, referenceNumber: string, paymentDate?: any | null, terminalCodes?: Array<string> | null, contactDisplayName?: string | null, contactReferenceNumber?: string | null, comment?: string | null, amountInCents?: number | null }> };

export type RemovePaymentOffsetMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemovePaymentOffsetMutation = { __typename?: 'Mutation', removePaymentOffset: { __typename?: 'PaymentToPaymentMappingEntity', uuid: string, amountInCents: number, createdAt: any, sourcePayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number }, targetPayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number } } };

export type UnappliedPaymentsForOffsetQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type UnappliedPaymentsForOffsetQuery = { __typename?: 'Query', paymentsV2: { __typename?: 'PaymentConnection', edges: Array<{ __typename?: 'PaymentEdge', node: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }> } };

export type UpdatePaymentOffsetMutationVariables = Exact<{
  input: UpdatePaymentOffsetInput;
}>;


export type UpdatePaymentOffsetMutation = { __typename?: 'Mutation', updatePaymentOffset: { __typename?: 'PaymentToPaymentMappingEntity', uuid: string, amountInCents: number, createdAt: any, sourcePayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number }, targetPayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number } } };

export type UpdatePaymentMutationVariables = Exact<{
  updatePaymentInput: UpdatePaymentInput;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment: { __typename?: 'PaymentEntity', uuid: string } };

export type PreviewBatchAddShipmentsToInvoicesMultipleQueryVariables = Exact<{
  batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple;
}>;


export type PreviewBatchAddShipmentsToInvoicesMultipleQuery = { __typename?: 'Query', previewBatchAddShipmentsToInvoicesMultiple: Array<{ __typename?: 'BatchAddShipmentsToInvoicePreview', contactName: string, contactUuid: string, billingCycleDuration: BillingCycleDuration, existingInvoiceAdds: Array<{ __typename?: 'InvoiceAdd', uuid?: string | null, name?: string | null, shipmentUuids: Array<string> }>, newInvoiceAdds: Array<{ __typename?: 'InvoiceAdd', name?: string | null, shipmentUuids: Array<string> }> }> };

export type OutstandingOrderQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OutstandingOrderQuery = { __typename?: 'Query', standardOrder: { __typename?: 'StandardOrderEntity', freightNeedsRate: boolean, updatedAt: any, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, isOverdue: boolean, detailedStatusV2?: OrderDetailedStatus | null, isCrossDock?: boolean | null, isDoorToDoor?: boolean | null, inboundStopIntention?: StopIntention | null, outboundStopIntention?: StopIntention | null, displayChargesInCustomerPortalOverride?: boolean | null, customerPortalChargesVisibleFromOverride?: CustomerPortalChargesVisibility | null, issueReason?: string | null, personName?: string | null, personPhoneNumber?: string | null, personEmail?: string | null, name: string, notes: string, onHand?: boolean | null, dateMarkedOnHand?: any | null, refNumbers: Array<string>, orderConsolidationType: OrderConsolidationType, orderInvoiceByDate?: any | null, paymentMethod?: PaymentMethod | null, source: OrderSource, status: OrderStatus, uuid: string, isDraftOrder: boolean, chargeableWeightCubicMeters?: any | null, totalSkids?: number | null, isReweighed: boolean, secondaryRefNumber?: string | null, lockSecondaryRefNumber: boolean, tertiaryRefNumber?: string | null, quaternaryRefNumber?: string | null, quinaryRefNumber?: string | null, lineHaulCompletedDate: any, consolidatedShipmentString?: string | null, shouldBillIndividually: boolean, enableLineHaul: boolean, inBond: boolean, hazmat: boolean, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, lockShipperBillOfLadingNumber: boolean, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null, measurementUnits: MeasurementUnits, weightUnits: WeightUnits }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null }, billingPartyContactStation?: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, height?: number | null, length?: number | null, quantity: number, type?: PackageType | null, weight?: number | null, width?: number | null, description: string, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }>, originalTransmissionPackages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, description: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, fileType: string, preSignedGetUrl: string, type: DocumentType, customDocumentName?: string | null, notes?: string | null, name?: string | null }>, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, postedAt?: any | null, journalNumber: number } | null, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, user?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null }>, consolidatableOrders: { __typename?: 'ConsolidatableOrdersOutput', error?: FindConsolidatableOrdersError | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, shipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null }, consolidatedOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string } | null, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null } };

export type AddQuickbooksDesktopCustomersMutationVariables = Exact<{
  contactUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddQuickbooksDesktopCustomersMutation = { __typename?: 'Mutation', addQuickbooksDesktopCustomers: Array<{ __typename?: 'QuickbooksDesktopResultEntity', error?: string | null, quickbooksDesktopObjects?: Array<{ __typename?: 'QuickbooksDesktopObjectEntity', id: string, name: string }> | null }> };

export type GetInvoiceCsvsQueryVariables = Exact<{
  getInvoiceCsvsInput: GetInvoiceCsvsInput;
}>;


export type GetInvoiceCsvsQuery = { __typename?: 'Query', getInvoiceCsvs?: { __typename?: 'FormatCsvResEntity', errors?: Array<string> | null, csvItems: Array<Array<string>>, missingCustomerMappings: Array<string>, missingFreightChargeMappings: Array<string>, missingFuelChargeMappings: Array<string>, missingAccessorialMappings: Array<string> } | null };

export type InvoiceForQuickbooksFragment = { __typename?: 'InvoiceEntity', uuid: string, createdAt: any, name: string, dueDate?: any | null, qbInvoiceNumber?: number | null, status: InvoiceStatus, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }, invoiceTerms?: { __typename?: 'InvoiceTermEntity', terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', secondaryRefNumber?: string | null, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, rate: number, billingMethod: FreightBillingMethod, description?: string | null, fuelCharge?: { __typename?: 'FuelChargeEntity', type: FuelBillingMethod, flatRate: number, surchargeRate: number, description?: string | null } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, rate: number, description?: string | null, quantity: number, total: number, billingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null }> }> };

export type InvoicesByUuidsForQuickbooksQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoicesByUuidsForQuickbooksQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, createdAt: any, name: string, dueDate?: any | null, qbInvoiceNumber?: number | null, status: InvoiceStatus, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }, invoiceTerms?: { __typename?: 'InvoiceTermEntity', terms: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', secondaryRefNumber?: string | null, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null } }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, rate: number, billingMethod: FreightBillingMethod, description?: string | null, fuelCharge?: { __typename?: 'FuelChargeEntity', type: FuelBillingMethod, flatRate: number, surchargeRate: number, description?: string | null } | null } | null, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, rate: number, description?: string | null, quantity: number, total: number, billingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null }> }> }> };

export type PlanQuickbooksSyncQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  options?: InputMaybe<QuickbooksSyncOptionsInput>;
}>;


export type PlanQuickbooksSyncQuery = { __typename?: 'Query', planQuickbooksSync: { __typename?: 'QuickbooksSyncPlan', notFoundUuids: Array<string>, plannedInvoiceCount: number, connection: { __typename?: 'QuickbooksSyncPlanConnection', connected: boolean, realmId?: string | null, quickbooksCompanyName?: string | null, bookCloseDate?: string | null, automatedSalesTaxEnabled: boolean, element: QboSyncElement }, clean: Array<{ __typename?: 'QuickbooksSyncInvoicePlan', invoiceUuid: string, invoiceName: string, billToContactUuid: string, billToContactName: string, status: QuickbooksSyncPlanStatus, failures: Array<{ __typename?: 'SyncInvoiceToQuickbooksFailure', invoiceUuid: string, invoiceName: string, code: SyncInvoiceToQuickbooksFailureCode, element: QboSyncElement, fixIn: QboSyncFixLocation, title: string, detail: string, remediation: string, retryable: boolean, affectedInvoiceCount?: number | null, quickbooksSaid?: string | null, quickbooksFaultCode?: string | null, quickbooksRequestId?: string | null, quickbooksCustomerId?: string | null, quickbooksCustomerName?: string | null, quickbooksItemId?: string | null, quickbooksItemName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, warnings: Array<{ __typename?: 'SyncInvoiceToQuickbooksFailure', invoiceUuid: string, invoiceName: string, code: SyncInvoiceToQuickbooksFailureCode, element: QboSyncElement, fixIn: QboSyncFixLocation, title: string, detail: string, remediation: string, retryable: boolean, affectedInvoiceCount?: number | null, quickbooksSaid?: string | null, quickbooksFaultCode?: string | null, quickbooksRequestId?: string | null, quickbooksCustomerId?: string | null, quickbooksCustomerName?: string | null, quickbooksItemId?: string | null, quickbooksItemName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, notices: Array<{ __typename?: 'SyncInvoiceToQuickbooksNotice', kind: QboSyncNoticeKind, element: QboSyncElement, title: string, detail: string, quickbooksRecordId?: string | null, quickbooksRecordName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, plannedCreates: Array<{ __typename?: 'QuickbooksSyncPlannedCreate', kind: QuickbooksSyncPlannedCreateKind, name: string, reason: string, tenetRecordName?: string | null, tenetRecordUuid?: string | null, tenetUrl?: string | null }> }>, needsReview: Array<{ __typename?: 'QuickbooksSyncInvoicePlan', invoiceUuid: string, invoiceName: string, billToContactUuid: string, billToContactName: string, status: QuickbooksSyncPlanStatus, failures: Array<{ __typename?: 'SyncInvoiceToQuickbooksFailure', invoiceUuid: string, invoiceName: string, code: SyncInvoiceToQuickbooksFailureCode, element: QboSyncElement, fixIn: QboSyncFixLocation, title: string, detail: string, remediation: string, retryable: boolean, affectedInvoiceCount?: number | null, quickbooksSaid?: string | null, quickbooksFaultCode?: string | null, quickbooksRequestId?: string | null, quickbooksCustomerId?: string | null, quickbooksCustomerName?: string | null, quickbooksItemId?: string | null, quickbooksItemName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, warnings: Array<{ __typename?: 'SyncInvoiceToQuickbooksFailure', invoiceUuid: string, invoiceName: string, code: SyncInvoiceToQuickbooksFailureCode, element: QboSyncElement, fixIn: QboSyncFixLocation, title: string, detail: string, remediation: string, retryable: boolean, affectedInvoiceCount?: number | null, quickbooksSaid?: string | null, quickbooksFaultCode?: string | null, quickbooksRequestId?: string | null, quickbooksCustomerId?: string | null, quickbooksCustomerName?: string | null, quickbooksItemId?: string | null, quickbooksItemName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, notices: Array<{ __typename?: 'SyncInvoiceToQuickbooksNotice', kind: QboSyncNoticeKind, element: QboSyncElement, title: string, detail: string, quickbooksRecordId?: string | null, quickbooksRecordName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, plannedCreates: Array<{ __typename?: 'QuickbooksSyncPlannedCreate', kind: QuickbooksSyncPlannedCreateKind, name: string, reason: string, tenetRecordName?: string | null, tenetRecordUuid?: string | null, tenetUrl?: string | null }> }>, blocked: Array<{ __typename?: 'QuickbooksSyncInvoicePlan', invoiceUuid: string, invoiceName: string, billToContactUuid: string, billToContactName: string, status: QuickbooksSyncPlanStatus, failures: Array<{ __typename?: 'SyncInvoiceToQuickbooksFailure', invoiceUuid: string, invoiceName: string, code: SyncInvoiceToQuickbooksFailureCode, element: QboSyncElement, fixIn: QboSyncFixLocation, title: string, detail: string, remediation: string, retryable: boolean, affectedInvoiceCount?: number | null, quickbooksSaid?: string | null, quickbooksFaultCode?: string | null, quickbooksRequestId?: string | null, quickbooksCustomerId?: string | null, quickbooksCustomerName?: string | null, quickbooksItemId?: string | null, quickbooksItemName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, warnings: Array<{ __typename?: 'SyncInvoiceToQuickbooksFailure', invoiceUuid: string, invoiceName: string, code: SyncInvoiceToQuickbooksFailureCode, element: QboSyncElement, fixIn: QboSyncFixLocation, title: string, detail: string, remediation: string, retryable: boolean, affectedInvoiceCount?: number | null, quickbooksSaid?: string | null, quickbooksFaultCode?: string | null, quickbooksRequestId?: string | null, quickbooksCustomerId?: string | null, quickbooksCustomerName?: string | null, quickbooksItemId?: string | null, quickbooksItemName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, notices: Array<{ __typename?: 'SyncInvoiceToQuickbooksNotice', kind: QboSyncNoticeKind, element: QboSyncElement, title: string, detail: string, quickbooksRecordId?: string | null, quickbooksRecordName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, plannedCreates: Array<{ __typename?: 'QuickbooksSyncPlannedCreate', kind: QuickbooksSyncPlannedCreateKind, name: string, reason: string, tenetRecordName?: string | null, tenetRecordUuid?: string | null, tenetUrl?: string | null }> }>, plannedCreates: Array<{ __typename?: 'QuickbooksSyncPlannedCreate', kind: QuickbooksSyncPlannedCreateKind, name: string, reason: string, tenetRecordName?: string | null, tenetRecordUuid?: string | null, tenetUrl?: string | null }> } };

export type QuickbooksSyncFailureFragment = { __typename?: 'SyncInvoiceToQuickbooksFailure', invoiceUuid: string, invoiceName: string, code: SyncInvoiceToQuickbooksFailureCode, element: QboSyncElement, fixIn: QboSyncFixLocation, title: string, detail: string, remediation: string, retryable: boolean, affectedInvoiceCount?: number | null, quickbooksSaid?: string | null, quickbooksFaultCode?: string | null, quickbooksRequestId?: string | null, quickbooksCustomerId?: string | null, quickbooksCustomerName?: string | null, quickbooksItemId?: string | null, quickbooksItemName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null };

export type QuickbooksSyncInvoicePlanFragment = { __typename?: 'QuickbooksSyncInvoicePlan', invoiceUuid: string, invoiceName: string, billToContactUuid: string, billToContactName: string, status: QuickbooksSyncPlanStatus, failures: Array<{ __typename?: 'SyncInvoiceToQuickbooksFailure', invoiceUuid: string, invoiceName: string, code: SyncInvoiceToQuickbooksFailureCode, element: QboSyncElement, fixIn: QboSyncFixLocation, title: string, detail: string, remediation: string, retryable: boolean, affectedInvoiceCount?: number | null, quickbooksSaid?: string | null, quickbooksFaultCode?: string | null, quickbooksRequestId?: string | null, quickbooksCustomerId?: string | null, quickbooksCustomerName?: string | null, quickbooksItemId?: string | null, quickbooksItemName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, warnings: Array<{ __typename?: 'SyncInvoiceToQuickbooksFailure', invoiceUuid: string, invoiceName: string, code: SyncInvoiceToQuickbooksFailureCode, element: QboSyncElement, fixIn: QboSyncFixLocation, title: string, detail: string, remediation: string, retryable: boolean, affectedInvoiceCount?: number | null, quickbooksSaid?: string | null, quickbooksFaultCode?: string | null, quickbooksRequestId?: string | null, quickbooksCustomerId?: string | null, quickbooksCustomerName?: string | null, quickbooksItemId?: string | null, quickbooksItemName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, notices: Array<{ __typename?: 'SyncInvoiceToQuickbooksNotice', kind: QboSyncNoticeKind, element: QboSyncElement, title: string, detail: string, quickbooksRecordId?: string | null, quickbooksRecordName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }>, plannedCreates: Array<{ __typename?: 'QuickbooksSyncPlannedCreate', kind: QuickbooksSyncPlannedCreateKind, name: string, reason: string, tenetRecordName?: string | null, tenetRecordUuid?: string | null, tenetUrl?: string | null }> };

export type QuickbooksSyncNoticeFragment = { __typename?: 'SyncInvoiceToQuickbooksNotice', kind: QboSyncNoticeKind, element: QboSyncElement, title: string, detail: string, quickbooksRecordId?: string | null, quickbooksRecordName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null };

export type QuickbooksSyncPlannedCreateFragment = { __typename?: 'QuickbooksSyncPlannedCreate', kind: QuickbooksSyncPlannedCreateKind, name: string, reason: string, tenetRecordName?: string | null, tenetRecordUuid?: string | null, tenetUrl?: string | null };

export type QuickbooksSyncedInvoiceFragment = { __typename?: 'InvoiceEntity', uuid: string, name: string, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, quickbooksLastSyncAttemptAt?: any | null };

export type SetAccessorialQboItemMappingMutationVariables = Exact<{
  input: SetAccessorialQboItemMappingInput;
}>;


export type SetAccessorialQboItemMappingMutation = { __typename?: 'Mutation', setAccessorialQboItemMapping: { __typename: 'AttemptsAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerSkid: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'StandardAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerUnit: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, waitTimeChargePeriod?: number | null, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerHundredWeight: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } };

export type CompleteRebillMutationVariables = Exact<{
  completeRebillInput: CompleteRebillInput;
}>;


export type CompleteRebillMutation = { __typename?: 'Mutation', completeRebill: { __typename?: 'CompleteRebillOutput', invoiceForRebill: { __typename?: 'InvoiceEntity', uuid: string, name: string } } };

export type CreateDuplicateOrderForRebillMutationVariables = Exact<{
  input: CreateDuplicateOrderForRebillInput;
}>;


export type CreateDuplicateOrderForRebillMutation = { __typename?: 'Mutation', createDuplicateOrderForRebill: { __typename?: 'CreateDuplicateOrderForRebillOutput', duplicatedOrder: { __typename?: 'StandardOrderEntity', uuid: string } } };

export type OrderForRebillQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderForRebillQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', name: string, totalCharge: number, invoice?: { __typename?: 'InvoiceEntity', name: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null } | null };

export type RemoveInvoiceMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveInvoiceMutation = { __typename?: 'Mutation', removeInvoice: { __typename?: 'InvoiceEntity', uuid: string } };

export type RemoveShipmentsFromInvoiceMutationVariables = Exact<{
  removeShipmentsFromInvoiceInput: RemoveShipmentsFromInvoiceInput;
}>;


export type RemoveShipmentsFromInvoiceMutation = { __typename?: 'Mutation', removeShipmentsFromInvoice: Array<{ __typename?: 'StandardShipmentEntity', uuid: string } | null> };

export type AccessorialChargeDetailsDataFragment = { __typename?: 'AccessorialChargeDetailsEntity', accessorialUuid: string, accessorialName: string, chargeDetailsByContact: Array<{ __typename?: 'ContactAccessorialChargeDetailsEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, shipmentsWithAccessorialCount: number, totalAccessorialCharge: number }>, chargeDetailsByTerminal: Array<{ __typename?: 'TerminalAccessorialChargeDetailsEntity', terminalUuid?: string | null, terminalCode?: string | null, chargeDetailsByContact: Array<{ __typename?: 'ContactAccessorialChargeDetailsEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, shipmentsWithAccessorialCount: number, totalAccessorialCharge: number }> }> };

export type ContactAccessorialChargeDetailsDataFragment = { __typename?: 'ContactAccessorialChargeDetailsEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, shipmentsWithAccessorialCount: number, totalAccessorialCharge: number };

export type TerminalAccessorialChargeDetailsDataFragment = { __typename?: 'TerminalAccessorialChargeDetailsEntity', terminalUuid?: string | null, terminalCode?: string | null, chargeDetailsByContact: Array<{ __typename?: 'ContactAccessorialChargeDetailsEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, shipmentsWithAccessorialCount: number, totalAccessorialCharge: number }> };

export type AccessorialChargeDetailsReportQueryVariables = Exact<{
  args: AccessorialChargeDetailsReportArgs;
}>;


export type AccessorialChargeDetailsReportQuery = { __typename?: 'Query', accessorialChargeDetailsReport: Array<{ __typename?: 'AccessorialChargeDetailsEntity', accessorialUuid: string, accessorialName: string, chargeDetailsByContact: Array<{ __typename?: 'ContactAccessorialChargeDetailsEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, shipmentsWithAccessorialCount: number, totalAccessorialCharge: number }>, chargeDetailsByTerminal: Array<{ __typename?: 'TerminalAccessorialChargeDetailsEntity', terminalUuid?: string | null, terminalCode?: string | null, chargeDetailsByContact: Array<{ __typename?: 'ContactAccessorialChargeDetailsEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, shipmentsWithAccessorialCount: number, totalAccessorialCharge: number }> }> }> };

export type AccountsReceivableDataFragment = { __typename?: 'AccountsReceivableReportDataForContactEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, totalInvoices: number, totalPayments: number, unappliedPayments: number, totalCredits: number, unappliedCredits: number, totalDebits: number, unappliedDebits: number, balance: number };

export type AccountsReceivableReportQueryVariables = Exact<{
  args: AccountsReceivableReportArgs;
}>;


export type AccountsReceivableReportQuery = { __typename?: 'Query', accountsReceivableReport: Array<{ __typename?: 'AccountsReceivableReportDataForContactEntity', contactUuid: string, displayName: string, contactReferenceNumber?: string | null, totalInvoices: number, totalPayments: number, unappliedPayments: number, totalCredits: number, unappliedCredits: number, totalDebits: number, unappliedDebits: number, balance: number }> };

export type AgingReportDataFragment = { __typename?: 'AgingReportForContactEntity', contactUuid: string, displayName: string, unappliedPaymentsTotal: number, contactAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null, openInvoiceValueBuckets: Array<{ __typename?: 'AgingReportBucketEntity', greaterThanOrEqualToDays?: number | null, lessThanOrEqualToDays?: number | null, openInvoiceValue: number, label?: string | null }>, invoices: Array<{ __typename?: 'InvoiceForAgingReportEntity', journalNumber?: string | null, totalOpenAmount: number, dueDate?: any | null, date: any, age: number, name: string }> };

export type AgingReportBucketFragment = { __typename?: 'AgingReportBucketEntity', greaterThanOrEqualToDays?: number | null, lessThanOrEqualToDays?: number | null, openInvoiceValue: number, label?: string | null };

export type InvoiceForAgingReportFragment = { __typename?: 'InvoiceForAgingReportEntity', journalNumber?: string | null, totalOpenAmount: number, dueDate?: any | null, date: any, age: number, name: string };

export type AgingReportPdfQueryVariables = Exact<{
  args: InvoiceAgingReportArgs;
}>;


export type AgingReportPdfQuery = { __typename?: 'Query', agingReportPdf: { __typename?: 'AgingReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type AgingReportQueryVariables = Exact<{
  args: InvoiceAgingReportArgs;
}>;


export type AgingReportQuery = { __typename?: 'Query', agingReport: Array<{ __typename?: 'AgingReportForContactEntity', contactUuid: string, displayName: string, unappliedPaymentsTotal: number, contactAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null, openInvoiceValueBuckets: Array<{ __typename?: 'AgingReportBucketEntity', greaterThanOrEqualToDays?: number | null, lessThanOrEqualToDays?: number | null, openInvoiceValue: number, label?: string | null }>, invoices: Array<{ __typename?: 'InvoiceForAgingReportEntity', journalNumber?: string | null, totalOpenAmount: number, dueDate?: any | null, date: any, age: number, name: string }> }> };

export type ChargeBreakdownReportCsvQueryVariables = Exact<{
  input?: InputMaybe<ChargeBreakdownReportInput>;
}>;


export type ChargeBreakdownReportCsvQuery = { __typename?: 'Query', chargeBreakdownReportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type ChargeBreakdownReportPdfQueryVariables = Exact<{
  input?: InputMaybe<ChargeBreakdownReportInput>;
}>;


export type ChargeBreakdownReportPdfQuery = { __typename?: 'Query', chargeBreakdownReportPdf: { __typename?: 'ChargeBreakdownReportPdfOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type PaymentForMemoReportFragment = { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, amountInCents: number, date: any, creditNumber?: number | null, referenceNumber: string, comment?: string | null, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingContactEmail?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingContactEmail?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null }, invoicesAppliedTo: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, date: any, invoiceTotal: string, balanceInCents: number }>, paymentOffsets: Array<{ __typename?: 'PaymentToPaymentMappingEntity', uuid: string, amountInCents: number, createdAt: any, sourcePayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number }, targetPayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number } }>, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', uuid: string, amountInCents: number, order: { __typename?: 'StandardOrderEntity', totalCharge: number, balanceInCents: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null }> } }> };

export type PaymentForMemoReportQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type PaymentForMemoReportQuery = { __typename?: 'Query', paymentByUuid?: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, amountInCents: number, date: any, creditNumber?: number | null, referenceNumber: string, comment?: string | null, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingContactEmail?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingContactEmail?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null }, invoicesAppliedTo: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, date: any, invoiceTotal: string, balanceInCents: number }>, paymentOffsets: Array<{ __typename?: 'PaymentToPaymentMappingEntity', uuid: string, amountInCents: number, createdAt: any, sourcePayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number }, targetPayment: { __typename?: 'PaymentEntity', uuid: string, paymentType: PaymentType, referenceNumber: string, creditNumber?: number | null, date: any, amountInCents: number, appliedAmountInCents: number, unappliedAmountInCents: number, offsetAmountInCents: number } }>, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', uuid: string, amountInCents: number, order: { __typename?: 'StandardOrderEntity', totalCharge: number, balanceInCents: number, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null }> } }> } | null };

export type DriverComplianceReportCsvQueryVariables = Exact<{
  driverComplianceReportInput: DriverComplianceReportInput;
}>;


export type DriverComplianceReportCsvQuery = { __typename?: 'Query', driverComplianceReportCsv: { __typename?: 'DriverComplianceReportFileOutput', fileName: string, mimeType: string, contentBase64: string } };

export type DriverComplianceReportPdfQueryVariables = Exact<{
  driverComplianceReportInput: DriverComplianceReportInput;
}>;


export type DriverComplianceReportPdfQuery = { __typename?: 'Query', driverComplianceReportPdf: { __typename?: 'DriverComplianceReportFileOutput', fileName: string, mimeType: string, contentBase64: string } };

export type DriverDailyLogReportCsvQueryVariables = Exact<{
  driverDailyLogReportCsvInput: DriverDailyLogReportPdfInput;
}>;


export type DriverDailyLogReportCsvQuery = { __typename?: 'Query', driverDailyLogReportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type DriverDailyLogReportPdfQueryVariables = Exact<{
  driverDailyLogReportPdfInput: DriverDailyLogReportPdfInput;
}>;


export type DriverDailyLogReportPdfQuery = { __typename?: 'Query', driverDailyLogReportPdf: { __typename?: 'ReportPdfOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type EmailAccountingReportMutationVariables = Exact<{
  emailAccountingReportInput: EmailAccountingReportInput;
}>;


export type EmailAccountingReportMutation = { __typename?: 'Mutation', emailAccountingReport: { __typename?: 'EmailAccountingReportOutput', status: EmailAccountingReportStatus } };

export type IncomeAnalysisReportV2QueryVariables = Exact<{
  args: IncomeAnalysisReportArgs;
}>;


export type IncomeAnalysisReportV2Query = { __typename?: 'Query', incomeAnalysisReportV2: { __typename?: 'IncomeAnalysisReportOutput', customers: Array<{ __typename?: 'CustomerReportBucketEntity', uuid: string, displayName: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }>, terminals: Array<{ __typename?: 'IncomeAnalysisTerminalBucketEntity', kind: IncomeAnalysisTerminalBucketKind, label: string, terminalUuid?: string | null, totalRevenue: number, numberOfShipments: number }> } };

export type IncomeAnalysisTerminalBucketFragment = { __typename?: 'IncomeAnalysisTerminalBucketEntity', kind: IncomeAnalysisTerminalBucketKind, label: string, terminalUuid?: string | null, totalRevenue: number, numberOfShipments: number };

export type InvoiceBillingSummaryReportV2PdfUrlQueryVariables = Exact<{
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
}>;


export type InvoiceBillingSummaryReportV2PdfUrlQuery = { __typename?: 'Query', invoiceBillingSummaryReportV2PdfUrl: string };

export type InvoiceBillingSummaryReportV2GroupFragment = { __typename?: 'InvoiceBillingSummaryV2Group', groupLabel: string, groupTotal: number, totalLineItems: number, subgroups: Array<{ __typename?: 'InvoiceBillingSummaryV2Subgroup', subgroupLabel?: string | null, subgroupTotal: number, lineItems: Array<{ __typename?: 'InvoiceBillingSummaryLineItemEntity', orderName: string, invoiceName: string, totalCharge: number, shipperBillOfLadingNumber: string, invoiceStatus: string, refNumbers?: Array<string> | null, contactDisplayName: string, contactReferenceNumber?: string | null, serviceLevel: string, invoiceDate?: any | null, serviceDate?: any | null, pieces: number, weight: number, inboundAddressName?: string | null, outboundAddressName?: string | null, shipmentsIncludedInLineItemRevenue: Array<{ __typename?: 'ShipmentIncludedInRevenueEntity', terminalCode?: string | null, shipmentTypeForCharge: ShipmentTypeForCharge }>, orderLineHaulLane?: { __typename?: 'OrderLineHaulLaneEntity', originTerminalCode: string, destinationTerminalCode: string } | null }> }> };

export type InvoiceBillingSummaryReportV2LineItemFragment = { __typename?: 'InvoiceBillingSummaryLineItemEntity', orderName: string, invoiceName: string, totalCharge: number, shipperBillOfLadingNumber: string, invoiceStatus: string, refNumbers?: Array<string> | null, contactDisplayName: string, contactReferenceNumber?: string | null, serviceLevel: string, invoiceDate?: any | null, serviceDate?: any | null, pieces: number, weight: number, inboundAddressName?: string | null, outboundAddressName?: string | null, shipmentsIncludedInLineItemRevenue: Array<{ __typename?: 'ShipmentIncludedInRevenueEntity', terminalCode?: string | null, shipmentTypeForCharge: ShipmentTypeForCharge }>, orderLineHaulLane?: { __typename?: 'OrderLineHaulLaneEntity', originTerminalCode: string, destinationTerminalCode: string } | null };

export type InvoiceBillingSummaryReportV2PdfQueryVariables = Exact<{
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
}>;


export type InvoiceBillingSummaryReportV2PdfQuery = { __typename?: 'Query', invoiceBillingSummaryReportV2Pdf: { __typename?: 'InvoiceBillingSummaryV2PdfOutput', url: string, fileName: string } };

export type InvoiceBillingSummaryReportV2SubgroupFragment = { __typename?: 'InvoiceBillingSummaryV2Subgroup', subgroupLabel?: string | null, subgroupTotal: number, lineItems: Array<{ __typename?: 'InvoiceBillingSummaryLineItemEntity', orderName: string, invoiceName: string, totalCharge: number, shipperBillOfLadingNumber: string, invoiceStatus: string, refNumbers?: Array<string> | null, contactDisplayName: string, contactReferenceNumber?: string | null, serviceLevel: string, invoiceDate?: any | null, serviceDate?: any | null, pieces: number, weight: number, inboundAddressName?: string | null, outboundAddressName?: string | null, shipmentsIncludedInLineItemRevenue: Array<{ __typename?: 'ShipmentIncludedInRevenueEntity', terminalCode?: string | null, shipmentTypeForCharge: ShipmentTypeForCharge }>, orderLineHaulLane?: { __typename?: 'OrderLineHaulLaneEntity', originTerminalCode: string, destinationTerminalCode: string } | null }> };

export type InvoiceBillingSummaryReportV2Fragment = { __typename?: 'InvoiceBillingSummaryV2Output', total: number, groups: Array<{ __typename?: 'InvoiceBillingSummaryV2Group', groupLabel: string, groupTotal: number, totalLineItems: number, subgroups: Array<{ __typename?: 'InvoiceBillingSummaryV2Subgroup', subgroupLabel?: string | null, subgroupTotal: number, lineItems: Array<{ __typename?: 'InvoiceBillingSummaryLineItemEntity', orderName: string, invoiceName: string, totalCharge: number, shipperBillOfLadingNumber: string, invoiceStatus: string, refNumbers?: Array<string> | null, contactDisplayName: string, contactReferenceNumber?: string | null, serviceLevel: string, invoiceDate?: any | null, serviceDate?: any | null, pieces: number, weight: number, inboundAddressName?: string | null, outboundAddressName?: string | null, shipmentsIncludedInLineItemRevenue: Array<{ __typename?: 'ShipmentIncludedInRevenueEntity', terminalCode?: string | null, shipmentTypeForCharge: ShipmentTypeForCharge }>, orderLineHaulLane?: { __typename?: 'OrderLineHaulLaneEntity', originTerminalCode: string, destinationTerminalCode: string } | null }> }> }> };

export type InvoiceBillingSummaryReportV2QueryVariables = Exact<{
  invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input;
}>;


export type InvoiceBillingSummaryReportV2Query = { __typename?: 'Query', invoiceBillingSummaryReportV2: { __typename?: 'InvoiceBillingSummaryV2Output', total: number, groups: Array<{ __typename?: 'InvoiceBillingSummaryV2Group', groupLabel: string, groupTotal: number, totalLineItems: number, subgroups: Array<{ __typename?: 'InvoiceBillingSummaryV2Subgroup', subgroupLabel?: string | null, subgroupTotal: number, lineItems: Array<{ __typename?: 'InvoiceBillingSummaryLineItemEntity', orderName: string, invoiceName: string, totalCharge: number, shipperBillOfLadingNumber: string, invoiceStatus: string, refNumbers?: Array<string> | null, contactDisplayName: string, contactReferenceNumber?: string | null, serviceLevel: string, invoiceDate?: any | null, serviceDate?: any | null, pieces: number, weight: number, inboundAddressName?: string | null, outboundAddressName?: string | null, shipmentsIncludedInLineItemRevenue: Array<{ __typename?: 'ShipmentIncludedInRevenueEntity', terminalCode?: string | null, shipmentTypeForCharge: ShipmentTypeForCharge }>, orderLineHaulLane?: { __typename?: 'OrderLineHaulLaneEntity', originTerminalCode: string, destinationTerminalCode: string } | null }> }> }> } };

export type InvoiceForOpenInvoiceReportFragment = { __typename?: 'InvoiceForOpenInvoiceReportEntity', uuid: string, journalNumber?: string | null, name: string, date: any, dueDate?: any | null, status: InvoiceStatus, invoiceTotalCents: number, invoiceBalanceCents: number, billingPartyContactUuid: string, billingPartyContactDisplayName: string, billingPartyContactReferenceNumber?: string | null, orders: Array<{ __typename?: 'OrderForOpenInvoiceReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, addressName?: string | null, originTerminalCode?: string | null, destinationTerminalCode?: string | null, serviceDate?: any | null, pieces: number, weight: number, orderTotalCents: number, orderBalanceCents: number }> };

export type OrderForOpenInvoiceReportFragment = { __typename?: 'OrderForOpenInvoiceReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, addressName?: string | null, originTerminalCode?: string | null, destinationTerminalCode?: string | null, serviceDate?: any | null, pieces: number, weight: number, orderTotalCents: number, orderBalanceCents: number };

export type OpenInvoiceReportQueryVariables = Exact<{
  openInvoiceReportArgs: OpenInvoiceReportArgs;
}>;


export type OpenInvoiceReportQuery = { __typename?: 'Query', openInvoiceReport: Array<{ __typename?: 'InvoiceForOpenInvoiceReportEntity', uuid: string, journalNumber?: string | null, name: string, date: any, dueDate?: any | null, status: InvoiceStatus, invoiceTotalCents: number, invoiceBalanceCents: number, billingPartyContactUuid: string, billingPartyContactDisplayName: string, billingPartyContactReferenceNumber?: string | null, orders: Array<{ __typename?: 'OrderForOpenInvoiceReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, addressName?: string | null, originTerminalCode?: string | null, destinationTerminalCode?: string | null, serviceDate?: any | null, pieces: number, weight: number, orderTotalCents: number, orderBalanceCents: number }> }> };

export type InvoiceForOrderSummaryReportFragment = { __typename?: 'InvoiceEntity', name: string, date: any, journalNumber: number, invoiceTotal: string, totalOpenAmount: number, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, balanceInCents: number, weight: number, dimWeight: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', quantity: number }> } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', name: string } } }> }>, billToContact: { __typename?: 'CustomerContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } | { __typename?: 'ThirdPartyContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } };

export type InvoiceForOrderSummaryReportQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type InvoiceForOrderSummaryReportQuery = { __typename?: 'Query', invoice?: { __typename?: 'InvoiceEntity', name: string, date: any, journalNumber: number, invoiceTotal: string, totalOpenAmount: number, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, balanceInCents: number, weight: number, dimWeight: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', quantity: number }> } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', name: string } } }> }>, billToContact: { __typename?: 'CustomerContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } | { __typename?: 'ThirdPartyContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } } | null };

export type InvoicesForOrderSummaryReportQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type InvoicesForOrderSummaryReportQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', name: string, date: any, journalNumber: number, invoiceTotal: string, totalOpenAmount: number, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, balanceInCents: number, weight: number, dimWeight: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', quantity: number }> } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, stopType?: StopType | null, address: { __typename?: 'AddressEntity', name: string } } }> }>, billToContact: { __typename?: 'CustomerContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } | { __typename?: 'ThirdPartyContactEntity', displayName: string, billingContactEmail?: string | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null } }> };

export type PaymentApplicationReportQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentApplicationReportQuery = { __typename?: 'Query', paymentApplicationReport: Array<{ __typename?: 'PaymentForPaymentApplicationReportEntity', paymentUuid: string, referenceNumber: string, paymentDate: any, paymentType: PaymentType, paymentRail?: PaymentRail | null, comment?: string | null, totalAmount: number, unappliedAmount: number, contactUuid: string, contactDisplayName: string, contactReferenceNumber?: string | null, masterAccountName?: string | null, orders: Array<{ __typename?: 'OrderForPaymentApplicationReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, inboundAddressName?: string | null, outboundAddressName?: string | null, pieces: number, weight: number, orderTotal: number, orderBalance: number, appliedAmount: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceContactDisplayName?: string | null, invoiceTotal?: number | null, invoiceBalance?: number | null }> }> };

export type PaymentForPaymentApplicationReportFragment = { __typename?: 'PaymentForPaymentApplicationReportEntity', paymentUuid: string, referenceNumber: string, paymentDate: any, paymentType: PaymentType, paymentRail?: PaymentRail | null, comment?: string | null, totalAmount: number, unappliedAmount: number, contactUuid: string, contactDisplayName: string, contactReferenceNumber?: string | null, masterAccountName?: string | null, orders: Array<{ __typename?: 'OrderForPaymentApplicationReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, inboundAddressName?: string | null, outboundAddressName?: string | null, pieces: number, weight: number, orderTotal: number, orderBalance: number, appliedAmount: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceContactDisplayName?: string | null, invoiceTotal?: number | null, invoiceBalance?: number | null }> };

export type OrderForPaymentApplicationReportFragment = { __typename?: 'OrderForPaymentApplicationReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, refNumbers?: Array<string> | null, inboundAddressName?: string | null, outboundAddressName?: string | null, pieces: number, weight: number, orderTotal: number, orderBalance: number, appliedAmount: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceContactDisplayName?: string | null, invoiceTotal?: number | null, invoiceBalance?: number | null };

export type PaymentForJournalReportOldFragment = { __typename?: 'PaymentEntity', paymentType: PaymentType, paymentRail?: PaymentRail | null, amountInCents: number, date: any, referenceNumber: string, creditNumber?: number | null, comment?: string | null, unappliedAmountInCents: number, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, glTerminal?: { __typename?: 'TerminalEntity', name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number, date: any } | null }> } }> };

export type PaymentToOrderMappingForJournalReportFragment = { __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number, date: any } | null }> } };

export type PaymentsForJournalReportQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentsForJournalReportQuery = { __typename?: 'Query', paymentsV2: { __typename?: 'PaymentConnection', edges: Array<{ __typename?: 'PaymentEdge', cursor: string, node: { __typename?: 'PaymentEntity', paymentType: PaymentType, paymentRail?: PaymentRail | null, amountInCents: number, date: any, referenceNumber: string, creditNumber?: number | null, comment?: string | null, unappliedAmountInCents: number, creditType?: { __typename?: 'CreditTypeEntity', name: string } | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, glTerminal?: { __typename?: 'TerminalEntity', name: string } | null, paymentToOrderMappings: Array<{ __typename?: 'PaymentToOrderMappingEntity', amountInCents: number, order: { __typename?: 'StandardOrderEntity', name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', invoice?: { __typename?: 'InvoiceEntity', name: string, journalNumber: number, date: any } | null }> } }> } }> } };

export type PaymentForJournalReportFragment = { __typename?: 'PaymentForPaymentJournalReportEntity', paymentUuid: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, paymentDate: any, referenceNumber: string, creditNumber?: number | null, comment?: string | null, totalAmount: number, unappliedAmountDollars: number, creditTypeName?: string | null, glTerminalName?: string | null, contactUuid: string, contactDisplayName: string, contactReferenceNumber?: string | null, orders: Array<{ __typename?: 'OrderForPaymentJournalReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, appliedAmountDollars: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceCustomerName?: string | null }> };

export type OrderForPaymentJournalReportFragment = { __typename?: 'OrderForPaymentJournalReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, appliedAmountDollars: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceCustomerName?: string | null };

export type PaymentJournalReportQueryVariables = Exact<{
  args: FindPaymentsV2Args;
}>;


export type PaymentJournalReportQuery = { __typename?: 'Query', paymentJournalReport: Array<{ __typename?: 'PaymentForPaymentJournalReportEntity', paymentUuid: string, paymentType: PaymentType, paymentRail?: PaymentRail | null, paymentDate: any, referenceNumber: string, creditNumber?: number | null, comment?: string | null, totalAmount: number, unappliedAmountDollars: number, creditTypeName?: string | null, glTerminalName?: string | null, contactUuid: string, contactDisplayName: string, contactReferenceNumber?: string | null, orders: Array<{ __typename?: 'OrderForPaymentJournalReportEntity', orderUuid: string, orderName: string, shipperBillOfLadingNumber?: string | null, appliedAmountDollars: number, invoiceUuid?: string | null, invoiceName?: string | null, invoiceJournalNumber?: number | null, invoiceDate?: any | null, invoiceCustomerName?: string | null }> }> };

export type PostedVsActualReportQueryVariables = Exact<{ [key: string]: never; }>;


export type PostedVsActualReportQuery = { __typename?: 'Query', postedVsActualReport: Array<{ __typename?: 'PostedVsActualDiscrepancyEntity', invoiceUuid: string, invoiceName: string, invoiceJournalNumber?: number | null, invoiceDate: any, orderUuid: string, orderName: string, postedAmountCents?: number | null, currentAmountCents?: number | null, discrepancyCents: number, customerName: string, customerReferenceNumber?: string | null, serviceDate?: any | null, completedDate?: any | null }> };

export type UnappliedPaymentsReportQueryVariables = Exact<{
  input: UnappliedPaymentReportCsvInput;
}>;


export type UnappliedPaymentsReportQuery = { __typename?: 'Query', unappliedPaymentReportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type RetryAllFailedInvoice210OutboundsForCompanyMutationVariables = Exact<{ [key: string]: never; }>;


export type RetryAllFailedInvoice210OutboundsForCompanyMutation = { __typename?: 'Mutation', retryAllFailedInvoice210OutboundsForCompany: { __typename?: 'RetryInvoice210OutboundResult', queuedCount: number, skippedCount: number } };

export type RetryFailedInvoice210OutboundMutationVariables = Exact<{
  invoiceUuid: Scalars['String']['input'];
}>;


export type RetryFailedInvoice210OutboundMutation = { __typename?: 'Mutation', retryFailedInvoice210Outbound: { __typename?: 'RetryInvoice210OutboundResult', queuedCount: number, skippedCount: number } };

export type RevenueReportOrderDataFragment = { __typename?: 'RevenueReportOrderEntity', uuid: string, name: string, totalCharge: number, pickupRevenue: number, deliveryRevenue: number, lineHaulRevenue: number, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, contactUuid: string, contactName: string, contactReferenceNumber?: string | null, packageQuantity: number, packageWeight: number, podUploaded: boolean, stopTypes: Array<StopType>, serviceDates: Array<any>, controllingTerminalCode?: string | null, inboundAddressString?: string | null, outboundAddressString?: string | null, detailedStatusV2?: OrderDetailedStatus | null, inboundStopType?: OriginStopType | null, outboundStopType?: DestinationStopType | null };

export type SalesVarianceReportCsvQueryVariables = Exact<{
  salesVarianceReportInput: SalesVarianceReportInput;
}>;


export type SalesVarianceReportCsvQuery = { __typename?: 'Query', salesVarianceReportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null } };

export type SendInvoicesMutationVariables = Exact<{
  sendInvoicesInput: SendInvoicesInput;
}>;


export type SendInvoicesMutation = { __typename?: 'Mutation', sendInvoices: { __typename?: 'InvoiceSendJobBatchEntity', uuid: string, createdAt: any, type: InvoiceSendJobBatchType, invoiceSendJobBatchProgress: { __typename?: 'InvoiceSendJobBatchProgressEntity', totalCount: number, failCount: number, successCount: number }, invoiceBatchDocuments: { __typename?: 'InvoiceSendJobBatchDocumentsEntity', invoicesBackupDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesCombinedDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null, invoicesZipDocument?: { __typename?: 'DocumentEntity', preSignedGetUrl: string, fileType: string } | null } } };

export type ShallowInvoiceWithoutShipmentsFragment = { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, createdAt: any, dueDate?: any | null, date: any, status: InvoiceStatus, source: InvoiceSource, qbInvoiceNumber?: number | null, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, quickbooksLastSyncAttemptAt?: any | null, quickbooksSyncFailureCode?: string | null, quickbooksSyncFailureTitle?: string | null, quickbooksSyncFailureDetail?: string | null, quickbooksSyncFailureRemediation?: string | null, quickbooksSyncFailureElement?: string | null, quickbooksSyncFaultCode?: string | null, quickbooksSyncRequestId?: string | null, emailOptions: Array<string>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, stedi210TransactionSettingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, stedi210TransactionSettingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> }, firstShipment?: { __typename?: 'StandardShipmentEntity', uuid: string } | null, latest210EdiStatus?: { __typename?: 'Latest210EdiStatusEntity', uuid: string, status: EdiTransactionStatus, errorSummary?: string | null, updatedAt: any } | null };

export type ShallowInvoicesByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ShallowInvoicesByUuidsQuery = { __typename?: 'Query', invoicesByUuids: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, createdAt: any, dueDate?: any | null, date: any, status: InvoiceStatus, source: InvoiceSource, qbInvoiceNumber?: number | null, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, quickbooksLastSyncAttemptAt?: any | null, quickbooksSyncFailureCode?: string | null, quickbooksSyncFailureTitle?: string | null, quickbooksSyncFailureDetail?: string | null, quickbooksSyncFailureRemediation?: string | null, quickbooksSyncFailureElement?: string | null, quickbooksSyncFaultCode?: string | null, quickbooksSyncRequestId?: string | null, emailOptions: Array<string>, invoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, stedi210TransactionSettingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, ediPartnerships: Array<{ __typename?: 'EdiPartnershipEntity', stedi210MappingId?: string | null, stedi210TransactionSettingId?: string | null, ediOutboundPayloadDestination: EdiOutboundPayloadDestination }> }, firstShipment?: { __typename?: 'StandardShipmentEntity', uuid: string } | null, latest210EdiStatus?: { __typename?: 'Latest210EdiStatusEntity', uuid: string, status: EdiTransactionStatus, errorSummary?: string | null, updatedAt: any } | null }> };

export type InvoiceUuidsQueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  isSyncedToQuickbooks?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuickbooksSyncFailure?: InputMaybe<Scalars['Boolean']['input']>;
  quickbooksSyncFailureCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort> | FindInvoicesSort>;
}>;


export type InvoiceUuidsQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, status: InvoiceStatus, hasAppliedPayments: boolean } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type ShallowInvoiceV2Fragment = { __typename?: 'InvoiceEntity', uuid: string, date: any, createdAt: any, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, lastSyncedFromQuickbooksAt?: any | null, quickbooksLastSyncAttemptAt?: any | null, quickbooksSyncFailureCode?: string | null, quickbooksSyncFailureTitle?: string | null, quickbooksSyncFailureRemediation?: string | null, syncedToQuickbooksDesktopAt?: any | null, manuallySyncedToQuickbooksDesktopAt?: any | null, name: string, journalNumber: number, status: InvoiceStatus, hasAppliedPayments: boolean, dueDate?: any | null, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }, latest210EdiStatus?: { __typename?: 'Latest210EdiStatusEntity', uuid: string, status: EdiTransactionStatus, errorSummary?: string | null, updatedAt: any } | null };

export type ShallowInvoicesV2QueryVariables = Exact<{
  inConsolidatedInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<InvoiceStatus> | InvoiceStatus>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  invoiceNumberFilter?: InputMaybe<IntegerFilterV2>;
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  groupByContact?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  emailSendStatus?: InputMaybe<EmailSendStatus>;
  isSyncedToQuickbooks?: InputMaybe<Scalars['Boolean']['input']>;
  isSyncedToQuickbooksDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  hasQuickbooksSyncFailure?: InputMaybe<Scalars['Boolean']['input']>;
  quickbooksSyncFailureCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sorts?: InputMaybe<Array<FindInvoicesSort> | FindInvoicesSort>;
  groupPath?: InputMaybe<Array<InvoiceTableGroupPathEntryInput> | InvoiceTableGroupPathEntryInput>;
}>;


export type ShallowInvoicesV2Query = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, date: any, createdAt: any, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, lastSyncedFromQuickbooksAt?: any | null, quickbooksLastSyncAttemptAt?: any | null, quickbooksSyncFailureCode?: string | null, quickbooksSyncFailureTitle?: string | null, quickbooksSyncFailureRemediation?: string | null, syncedToQuickbooksDesktopAt?: any | null, manuallySyncedToQuickbooksDesktopAt?: any | null, name: string, journalNumber: number, status: InvoiceStatus, hasAppliedPayments: boolean, dueDate?: any | null, billToContact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }, latest210EdiStatus?: { __typename?: 'Latest210EdiStatusEntity', uuid: string, status: EdiTransactionStatus, errorSummary?: string | null, updatedAt: any } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type SyncInvoiceStatusWithQuickbooksMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type SyncInvoiceStatusWithQuickbooksMutation = { __typename?: 'Mutation', syncInvoiceStatusWithQuickbooks: { __typename?: 'InvoiceEntity', uuid: string, balanceInCents: number, status: InvoiceStatus, lastSyncedFromQuickbooksAt?: any | null } };

export type SyncInvoicesToQuickbooksMutationVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  options?: InputMaybe<QuickbooksSyncOptionsInput>;
}>;


export type SyncInvoicesToQuickbooksMutation = { __typename?: 'Mutation', syncInvoicesToQuickbooks: { __typename?: 'SyncInvoicesToQuickbooksOutput', synced: Array<{ __typename?: 'InvoiceEntity', uuid: string, name: string, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, quickbooksLastSyncAttemptAt?: any | null }>, syncedWithNotices: Array<{ __typename?: 'SyncedInvoiceWithNotices', invoice: { __typename?: 'InvoiceEntity', uuid: string, name: string, quickbooksInvoiceId?: string | null, lastSyncedToQuickbooksAt?: any | null, quickbooksLastSyncAttemptAt?: any | null }, notices: Array<{ __typename?: 'SyncInvoiceToQuickbooksNotice', kind: QboSyncNoticeKind, element: QboSyncElement, title: string, detail: string, quickbooksRecordId?: string | null, quickbooksRecordName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }> }>, failed: Array<{ __typename?: 'SyncInvoiceToQuickbooksFailure', invoiceUuid: string, invoiceName: string, code: SyncInvoiceToQuickbooksFailureCode, element: QboSyncElement, fixIn: QboSyncFixLocation, title: string, detail: string, remediation: string, retryable: boolean, affectedInvoiceCount?: number | null, quickbooksSaid?: string | null, quickbooksFaultCode?: string | null, quickbooksRequestId?: string | null, quickbooksCustomerId?: string | null, quickbooksCustomerName?: string | null, quickbooksItemId?: string | null, quickbooksItemName?: string | null, quickbooksUrl?: string | null, tenetRecordName?: string | null, tenetUrl?: string | null }> } };

export type TypeAheadOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, hideFromBilling: boolean, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null }>, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null };

export type TypeaheadOrderUuidsQueryQueryVariables = Exact<{
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  shipperFilter?: InputMaybe<StringFilter>;
  consigneeFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter> | StatusFilter>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter> | ShipmentStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onInvoice?: InputMaybe<BooleanFilter>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isRefused?: InputMaybe<BooleanFilter>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isPicked?: InputMaybe<BooleanFilter>;
  isOsd?: InputMaybe<BooleanFilter>;
  isSpecial?: InputMaybe<BooleanFilter>;
  orderSource?: InputMaybe<OrderSource>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  standardStopType?: InputMaybe<StandardStopType>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  transferPending?: InputMaybe<BooleanFilter>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  sortByCustomerNameAscending?: InputMaybe<Scalars['Boolean']['input']>;
  versionId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type TypeaheadOrderUuidsQueryQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', versionId?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, hideFromBilling: boolean, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null }>, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OrderRevenueReportQueryVariables = Exact<{
  orderRevenueReportInput: OrderRevenueReportInput;
}>;


export type OrderRevenueReportQuery = { __typename?: 'Query', orderRevenueReport: { __typename?: 'RevenueReportOrderConnection', edges: Array<{ __typename?: 'RevenueReportOrderEdge', node: { __typename?: 'RevenueReportOrderEntity', uuid: string, name: string, totalCharge: number, pickupRevenue: number, deliveryRevenue: number, lineHaulRevenue: number, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, contactUuid: string, contactName: string, contactReferenceNumber?: string | null, packageQuantity: number, packageWeight: number, podUploaded: boolean, stopTypes: Array<StopType>, serviceDates: Array<any>, controllingTerminalCode?: string | null, inboundAddressString?: string | null, outboundAddressString?: string | null, detailedStatusV2?: OrderDetailedStatus | null, inboundStopType?: OriginStopType | null, outboundStopType?: DestinationStopType | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type UnpostInvoiceMutationVariables = Exact<{
  unpostInvoiceInput: UnpostInvoiceInput;
}>;


export type UnpostInvoiceMutation = { __typename?: 'Mutation', unpostInvoice: { __typename?: 'UnpostInvoiceOutput', success: boolean } };

export type UnpostInvoicesMutationVariables = Exact<{
  unpostInvoicesInput: UnpostInvoicesInput;
}>;


export type UnpostInvoicesMutation = { __typename?: 'Mutation', unpostInvoices: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'UnpostInvoicesSuccessOutput', unpostedUuids: Array<string>, skippedWithPaymentsUuids: Array<string>, failedUuids: Array<string> } };

export type CreateItemMutationVariables = Exact<{
  input: CreateItemInput;
}>;


export type CreateItemMutation = { __typename?: 'Mutation', createItem: { __typename?: 'CreateItemOutput', error?: string | null, item?: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null } };

export type ContactItemsItemFragment = { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null };

export type ContactItemsQueryVariables = Exact<{
  findContactItemsInput: FindContactItemsInput;
}>;


export type ContactItemsQuery = { __typename?: 'Query', contactItems: { __typename?: 'FindContactItemsOutput', items: Array<{ __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null }> } };

export type ItemInventorySummaryQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ItemInventorySummaryQuery = { __typename?: 'Query', items: { __typename?: 'ItemConnection', edges: Array<{ __typename?: 'ItemEdge', node: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, quantity: number, storageUnitsCount: number, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string }, storageOrders: Array<{ __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string }> } }> } };

export type ItemQueryVariables = Exact<{
  itemUuid: Scalars['String']['input'];
}>;


export type ItemQuery = { __typename?: 'Query', item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, status: ItemStatus, contact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string }, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure, upcCode?: string | null }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure, upcCode?: string | null, primaryUnitsPerSecondaryUOM?: number | null } | null, itemStorageUnitConfig?: { __typename?: 'ItemStorageUnitConfigEntity', uuid: string, type: MeasurementUnits, length: number, width: number, height: number, weight: number, consolidationUnitUOM: UnitOfMeasure, primaryUnitsPerConsolidationUnit: number, weightUOM: WarehouseMeasurementUnits, dimensionsUOM: WarehouseMeasurementUnits, tie: number, high: number } | null } };

export type ItemsBySkuNameQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
}>;


export type ItemsBySkuNameQuery = { __typename?: 'Query', itemsBySkuName: Array<{ __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } }> };

export type ShallowItemFragment = { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type ShallowItemsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShallowItemsQuery = { __typename?: 'Query', items: { __typename?: 'ItemConnection', edges: Array<{ __typename?: 'ItemEdge', node: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type UpdateItemMutationVariables = Exact<{
  input: UpdateItemInput;
}>;


export type UpdateItemMutation = { __typename?: 'Mutation', updateItem: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } };

export type GenerateLabelMutationVariables = Exact<{
  generateLabelInput: GenerateLabelInput;
}>;


export type GenerateLabelMutation = { __typename?: 'Mutation', generateLabel: string };

export type LegInfoFragment = { __typename?: 'LegEntity', miles?: number | null, flatRate?: number | null, name: string, uuid: string, completedAt?: any | null, endStop: { __typename?: 'StandardStopEntity', completedAt?: any | null, address: { __typename?: 'AddressEntity', name: string } }, shipment: { __typename?: 'StandardShipmentEntity', name: string, totalChargesAmount: number, totalChargesForDriverSettlement: number, uuid: string, charges: Array<{ __typename?: 'CustomChargeEntity', total: number } | { __typename?: 'FreightChargeEntity', total: number }>, legs: Array<{ __typename?: 'LegEntity', uuid: string }>, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, name: string }> } | null } };

export type DispatchApplySuggestedManifestsMutationVariables = Exact<{
  input: DispatchApplySuggestedManifestsInput;
}>;


export type DispatchApplySuggestedManifestsMutation = { __typename?: 'Mutation', dispatchApplySuggestedManifests: { __typename?: 'DispatchApplySuggestedManifestsOutput', results: Array<{ __typename?: 'DispatchSuggestedManifestResult', manifestUuid?: string | null, manifestReferenceNumber?: string | null, created: boolean, outcome: DispatchSuggestedManifestOutcome, orderUuids: Array<string>, reason?: string | null, failedOrders: Array<{ __typename?: 'DispatchSuggestedManifestFailedOrder', orderName: string, reason: string }> }> } };

export type DispatchManifestFreightCountsQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DispatchManifestFreightCountsQuery = { __typename?: 'Query', lineHaulManifest: { __typename?: 'LineHaulManifestEntity', uuid: string, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, piecesAwayFromRunOrigin?: { __typename?: 'PiecesAwayFromRunOrigin', runOriginTerminalCode: string, totalPieceCount: number, awayFromOriginPieceCount: number, unaccountedPieceCount: number, terminalCounts: Array<{ __typename?: 'TerminalPieceCount', terminalCode: string, pieceCount: number }> } | null }> } };

export type GroupOrdersQueryVariables = Exact<{
  input: GroupOrdersInput;
}>;


export type GroupOrdersQuery = { __typename?: 'Query', groupOrders: { __typename?: 'GroupOrdersOutput', rows: { __typename: 'OrderLaneGroupsOutput', totalCount: number, omittedUnreachableCorridorCount: number, groups: Array<{ __typename?: 'OrderLaneGroup', laneKey: string, startTerminalCode: string, endTerminalCode: string, segmentCount: number, pieceCount: number, weightLbs?: number | null }>, unreachableCorridors?: Array<{ __typename?: 'DispatchUnreachableCorridor', originTerminalCode: string, destinationTerminalCode: string, originTerminalUuid: string, destinationTerminalUuid: string, orderCount: number, orders: Array<{ __typename?: 'DispatchUnreachableOrder', orderUuid: string, orderName: string, onHandTerminalCode?: string | null, pieceCount?: number | null, weightLbs?: number | null }> }> | null } | { __typename: 'OrderSegmentLeavesOutput', totalCount: number, rows: Array<{ __typename?: 'DispatchOrderRow', segmentUuid: string, orderUuid: string, laneKey: string, name: string, status: string, pieceCount?: number | null, weightLbs?: number | null, dimWeight?: number | null, originTerminalCode?: string | null, destinationTerminalCode?: string | null, finalDestinationTerminalCode?: string | null, finalDestinationTerminalUuid?: string | null, rerouteFromTerminalCode?: string | null, rerouteFromTerminalUuid?: string | null, orderOriginTerminalCode?: string | null, currentLocationCode?: string | null, currentLocationIsLive: boolean, currentLocationPieceCount: number, totalCountablePieceCount: number, serviceDate?: string | null, outboundServiceDate?: string | null, customerName?: string | null, billOfLadingNumber?: string | null, mawb?: string | null, isSpecial: boolean, pieceTerminalLocations?: string | null, segmentStartTerminalUuid?: string | null, segmentEndTerminalUuid?: string | null, currentManifestUuid?: string | null, currentManifestReferenceNumber?: string | null, currentManifestStatus?: string | null, currentManifestDepartDate?: string | null, isProposed: boolean, routeNodeCodes: Array<string>, routeNodeTerminalUuids: Array<string>, isPathLocked: boolean, routeMissesOrigin: boolean, routeMissesDestination: boolean, piecesAwayFromRunOrigin?: { __typename?: 'PiecesAwayFromRunOrigin', runOriginTerminalCode: string, totalPieceCount: number, awayFromOriginPieceCount: number, unaccountedPieceCount: number, terminalCounts: Array<{ __typename?: 'TerminalPieceCount', terminalCode: string, pieceCount: number }> } | null, pieceStatusLocations?: Array<{ __typename?: 'PieceStatusTerminalCount', status: PieceStatus, terminalCode: string, pieceCount: number }> | null, formattedValues: Array<{ __typename?: 'DispatchFormattedFieldValue', field: OrderTableField, value?: string | null }>, lineHaulManifests: Array<{ __typename?: 'DispatchLineHaulManifest', uuid: string, referenceNumber: string, startTerminalCode: string, endTerminalCode: string, status: string, departDate?: string | null, estimatedArrival?: string | null, completedAt?: string | null }>, routeLegs: Array<{ __typename?: 'DispatchRouteLeg', startTerminalCode: string, endTerminalCode: string }>, alternativeRoutes?: Array<{ __typename?: 'DispatchProposedRoute', nodeCodes: Array<string>, nodeTerminalUuids: Array<string> }> | null }> } } };

export type DispatchManifestPackageStatesQueryVariables = Exact<{
  input: ManifestUuidsInput;
}>;


export type DispatchManifestPackageStatesQuery = { __typename?: 'Query', calmManifestLoadPackages: Array<{ __typename?: 'CalmLoadPackageEntity', packageUuid: string, orderUuid?: string | null, pieces: number, piecesOnHand: number, piecesLoaded: number, piecesDeparted: number, piecesAtDestination: number }> };

export type DispatchManifestsInRangeQueryVariables = Exact<{
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
}>;


export type DispatchManifestsInRangeQuery = { __typename?: 'Query', lineHaulManifests: { __typename?: 'FindLineHaulManifestsOutput', lineHaulManifests: Array<{ __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> }>, unmanifestedSegments: Array<{ __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } };

export type CalmOrderCubeByOrderUuidsQueryVariables = Exact<{
  orderUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CalmOrderCubeByOrderUuidsQuery = { __typename?: 'Query', calmOrderCubeByOrderUuids: Array<{ __typename?: 'CalmOrderCubeEntity', orderUuid: string, cubeFt3: number, weightLbs: number }> };

export type DispatchPlacedLegLoadedPiecesQueryVariables = Exact<{
  input: ManifestUuidsInput;
}>;


export type DispatchPlacedLegLoadedPiecesQuery = { __typename?: 'Query', calmManifestLoadPackages: Array<{ __typename?: 'CalmLoadPackageEntity', manifestUuid: string, orderUuid?: string | null, piecesLoaded: number }> };

export type CalmPreviewLineHaulReroutesQueryVariables = Exact<{
  input: PreviewLineHaulReroutesInput;
}>;


export type CalmPreviewLineHaulReroutesQuery = { __typename?: 'Query', calmPreviewLineHaulReroutes: Array<{ __typename?: 'CalmReroutePreviewEntity', orderUuid: string, freightAtTerminalCode?: string | null, freightAtTerminalUuid?: string | null, refusal?: string | null, travelledLegs: Array<{ __typename?: 'CalmRerouteTravelledLegEntity', startCode: string, endCode: string, runReference: string, arrived: boolean }>, runsToLeave: Array<{ __typename?: 'CalmRerouteRunToLeaveEntity', uuid: string, referenceNumber: string }> }> };

export type CalmRepointOrderFreightMutationVariables = Exact<{
  input: RepointOrderFreightInput;
}>;


export type CalmRepointOrderFreightMutation = { __typename?: 'Mutation', calmRepointOrderFreight: { __typename?: 'RepointOrderFreightEntity', unitsMoved: number, unitsLeftBehind: number, unitsMarkedShort: number, packagesLeftPartiallyShort: number } };

export type SetLineHaulManifestDepartTimeMutationVariables = Exact<{
  input: SetManifestDepartTimeInput;
}>;


export type SetLineHaulManifestDepartTimeMutation = { __typename?: 'Mutation', setLineHaulManifestDepartTime: { __typename?: 'LineHaulManifestEntity', uuid: string, departTimeMinutes?: number | null, estimatedDeparture?: any | null, estimatedArrival?: any | null } };

export type SetLineHaulManifestTrailersMutationVariables = Exact<{
  input: SetManifestTrailersInput;
}>;


export type SetLineHaulManifestTrailersMutation = { __typename?: 'Mutation', setLineHaulManifestTrailers: { __typename?: 'SetManifestTrailersOutput', conflictWarning?: string | null } };

export type AddOrdersToManifestV2MutationVariables = Exact<{
  addOrdersToManifestV2Input: AddOrdersToManifestV2Input;
}>;


export type AddOrdersToManifestV2Mutation = { __typename?: 'Mutation', addOrdersToManifestV2: { __typename: 'AddOrdersToManifestV2PreviousManifestErrorOutput', previousManifestErrors: Array<{ __typename?: 'PreviousManifestError', order: { __typename?: 'StandardOrderEntity', name: string, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null } }>, originTerminalMismatchErrors: Array<{ __typename?: 'OriginTerminalMismatchError', order: { __typename?: 'StandardOrderEntity', uuid: string, name: string } }>, invalidMisroutedOverrideErrors: Array<{ __typename?: 'InvalidMisroutedOverrideError', order: { __typename?: 'StandardOrderEntity', name: string } }>, routeDestinationMismatchErrors: Array<{ __typename?: 'RouteDestinationMismatchError', order: { __typename?: 'StandardOrderEntity', name: string }, manifest: { __typename?: 'LineHaulManifestEntity', endTerminal: { __typename?: 'TerminalEntity', code: string } } }> } | { __typename: 'AddOrdersToManifestV2SuccessOutput', lineHaulManifest: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } } | { __typename: 'MutationErrorOutput', message: string } };

export type AddOrdersToManifestMutationVariables = Exact<{
  addOrdersToManifestInput: AddOrdersToManifestInput;
}>;


export type AddOrdersToManifestMutation = { __typename?: 'Mutation', addOrdersToManifest: { __typename?: 'AddOrdersToManifestOutput', errorMessage?: string | null, lineHaulManifest?: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } | null } };

export type CreateLineHaulManifestMutationVariables = Exact<{
  createLineHaulManifestInput: CreateLineHaulManifestInput;
}>;


export type CreateLineHaulManifestMutation = { __typename?: 'Mutation', createLineHaulManifest: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } };

export type CreateLineHaulManifestsMutationVariables = Exact<{
  input: CreateLineHaulManifestsInput;
}>;


export type CreateLineHaulManifestsMutation = { __typename?: 'Mutation', createLineHaulManifests: { __typename: 'CreateLineHaulManifestsSuccessOutput', lineHaulManifests: Array<{ __typename?: 'LineHaulManifestEntity', uuid: string }> } | { __typename: 'MutationErrorOutput', message: string } };

export type DetailedLineHaulManifestFragment = { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> };

export type GetLineHaulProgressQueryVariables = Exact<{
  getLineHaulProgressInput: GetLineHaulProgressInput;
}>;


export type GetLineHaulProgressQuery = { __typename?: 'Query', getLineHaulProgress: { __typename?: 'GetLineHaulProgressOutput', terminalStatuses: Array<{ __typename?: 'LineHaulStatusByTerminal', markedArrivedAt?: any | null, terminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, manifestDepartingFromThisTerminal?: { __typename?: 'LineHaulManifestEntity', uuid: string, status: LineHaulManifestStatus, departDate: any, startedAt?: any | null, completedAt?: any | null, referenceNumber: string, driver?: { __typename?: 'DriverEntity', firstName: string, lastName: string } | null } | null, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } };

export type TerminalLineHaulStatusFragment = { __typename?: 'LineHaulStatusByTerminal', markedArrivedAt?: any | null, terminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, manifestDepartingFromThisTerminal?: { __typename?: 'LineHaulManifestEntity', uuid: string, status: LineHaulManifestStatus, departDate: any, startedAt?: any | null, completedAt?: any | null, referenceNumber: string, driver?: { __typename?: 'DriverEntity', firstName: string, lastName: string } | null } | null, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> };

export type LineHaulManifestGroupsQueryVariables = Exact<{
  input: LineHaulManifestsGroupsInput;
}>;


export type LineHaulManifestGroupsQuery = { __typename?: 'Query', lineHaulManifestsGroups: { __typename?: 'LineHaulManifestsCategoryGroupsOutput', category: LineHaulManifestsGroupBy, groups: Array<{ __typename?: 'ManifestGroup', category: LineHaulManifestsGroupBy, manifests: Array<{ __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> }> }> } };

export type LineHaulManifestOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, weight: number, dimWeight: number, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, quantity: number, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } };

export type LineHaulManifestQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type LineHaulManifestQuery = { __typename?: 'Query', lineHaulManifest: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } };

export type LineHaulManifestsForPrintQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type LineHaulManifestsForPrintQuery = { __typename?: 'Query', lineHaulManifests: { __typename?: 'FindLineHaulManifestsOutput', lineHaulManifests: Array<{ __typename?: 'LineHaulManifestEntity', referenceNumber: string, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, pieceCountFromPackages: number, refNumbers: Array<string>, hazmat: boolean, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, tags: Array<{ __typename?: 'TagEntity', value: string }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }, segment: { __typename?: 'LineHaulSegmentEntity', ordinal: number, startTerminal: { __typename?: 'TerminalEntity', name: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', name: string, code: string } }, priorOrderLineHaulSegment?: { __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null } | null }> }> } };

export type LineHaulManifestForPrintFragment = { __typename?: 'LineHaulManifestEntity', referenceNumber: string, departDate: any, status: LineHaulManifestStatus, startedAt?: any | null, completedAt?: any | null, uuid: string, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, pieceCountFromPackages: number, refNumbers: Array<string>, hazmat: boolean, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, tags: Array<{ __typename?: 'TagEntity', value: string }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> }, segment: { __typename?: 'LineHaulSegmentEntity', ordinal: number, startTerminal: { __typename?: 'TerminalEntity', name: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', name: string, code: string } }, priorOrderLineHaulSegment?: { __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null } | null }> };

export type LineHaulOrderForPrintedManifestFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, pieceCountFromPackages: number, refNumbers: Array<string>, hazmat: boolean, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, tags: Array<{ __typename?: 'TagEntity', value: string }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }> }> };

export type LineHaulManifestsQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type LineHaulManifestsQuery = { __typename?: 'Query', lineHaulManifests: { __typename?: 'FindLineHaulManifestsOutput', lineHaulManifests: Array<{ __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> }>, unmanifestedSegments: Array<{ __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } };

export type LineHaulOrderWithUpcomingSegmentAndInboundStopStatusFragment = { __typename?: 'StandardOrderEntity', uuid: string, hasNoneOrCompletedInboundStop: boolean, upcomingLineHaulSegment?: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, lastCompletedLineHaulSegment?: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null };

export type LineHaulOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } };

export type LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, hasNoneOrCompletedInboundStop: boolean, upcomingLineHaulSegment?: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, lastCompletedLineHaulSegment?: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null }> };

export type LineHaulSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type LineHaulSegmentsQuery = { __typename?: 'Query', lineHaulSegments: Array<{ __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> };

export type MarkManifestAsArrivedMutationVariables = Exact<{
  markManifestAsArrivedInput: MarkManifestAsArrivedInput;
}>;


export type MarkManifestAsArrivedMutation = { __typename?: 'Mutation', markManifestAsArrived: { __typename?: 'MarkManifestAsArrivedOutput', errorMessage?: string | null, lineHaulManifest?: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } | null } };

export type MarkManifestAsDepartedMutationVariables = Exact<{
  markManifestAsDepartedInput: MarkManifestAsDepartedInput;
}>;


export type MarkManifestAsDepartedMutation = { __typename?: 'Mutation', markManifestAsDeparted: { __typename?: 'MarkManifestAsDepartedOutput', errorMessage?: string | null, lineHaulManifest?: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } | null } };

export type MarkManifestAsPlanningMutationVariables = Exact<{
  markManifestAsPlanningInput: MarkManifestAsPlanningInput;
}>;


export type MarkManifestAsPlanningMutation = { __typename?: 'Mutation', markManifestAsPlanning: { __typename?: 'MarkManifestAsPlanningOutput', errorMessage?: string | null, lineHaulManifest?: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } | null } };

export type RemoveLineHaulManifestMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveLineHaulManifestMutation = { __typename?: 'Mutation', removeLineHaulManifest: string };

export type RemoveOrdersFromManifestV2MutationVariables = Exact<{
  input: RemoveOrdersFromManifestV2Input;
}>;


export type RemoveOrdersFromManifestV2Mutation = { __typename?: 'Mutation', removeOrdersFromManifestV2: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'RemoveOrdersFromManifestV2SuccessOutput' } };

export type RemoveOrdersFromManifestMutationVariables = Exact<{
  removeOrdersFromManifestInput: RemoveOrdersFromManifestInput;
}>;


export type RemoveOrdersFromManifestMutation = { __typename?: 'Mutation', removeOrdersFromManifest: { __typename?: 'AddOrdersToManifestOutput', errorMessage?: string | null, lineHaulManifest?: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } | null } };

export type SegmentedLineHaulOrderFragment = { __typename?: 'OrderLineHaulSegmentEntity', uuid: string, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, pieceCountFromPackages: number, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, hazmat: boolean, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, incomingCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, outboundCarrier?: string | null, destinationAirport?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null } } } | null } | null }, segment: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } };

export type SegmentedLineHaulOrdersV2QueryVariables = Exact<{
  findSegmentedLineHaulOrdersInputV2: FindSegmentedLineHaulOrdersInputV2;
}>;


export type SegmentedLineHaulOrdersV2Query = { __typename?: 'Query', segmentedLineHaulOrdersV2: { __typename?: 'OrderLineHaulSegmentOutput', totalCount?: number | null, edges: Array<{ __typename?: 'OrderLineHaulSegmentEntity', uuid: string, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, pieceCountFromPackages: number, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, hazmat: boolean, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, incomingCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, outboundCarrier?: string | null, destinationAirport?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null } } } | null } | null }, segment: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } }> } };

export type SegmentedLineHaulOrdersQueryVariables = Exact<{
  findSegmentedLineHaulOrdersInput: FindSegmentedLineHaulOrdersInput;
}>;


export type SegmentedLineHaulOrdersQuery = { __typename?: 'Query', segmentedLineHaulOrders: { __typename?: 'OrderLineHaulSegmentConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderLineHaulSegmentEdge', node: { __typename?: 'OrderLineHaulSegmentEntity', uuid: string, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, pieceCountFromPackages: number, dateMarkedReceivedAtOrigin?: any | null, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, hazmat: boolean, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, incomingCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, isSpecial?: boolean | null, outboundCarrier?: string | null, destinationAirport?: string | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null } } } | null } | null }, segment: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type SetLineHaulManifestLoadPositionMutationVariables = Exact<{
  input: SetLineHaulManifestLoadPositionInput;
}>;


export type SetLineHaulManifestLoadPositionMutation = { __typename?: 'Mutation', setLineHaulManifestLoadPosition: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'SetLineHaulManifestLoadPositionSuccessOutput', lineHaulManifest: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } } };

export type SetLineHaulManifestOrderLoadPositionMutationVariables = Exact<{
  input: SetLineHaulManifestOrderLoadPositionInput;
}>;


export type SetLineHaulManifestOrderLoadPositionMutation = { __typename?: 'Mutation', setLineHaulManifestOrderLoadPosition: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'SetLineHaulManifestLoadPositionSuccessOutput', lineHaulManifest: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } } };

export type ShallowLineHaulManifestFragment = { __typename?: 'LineHaulManifestEntity', departDate: any, uuid: string, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string } | null };

export type TerminalForDetailedLineHaulManifestFragment = { __typename?: 'TerminalEntity', uuid: string, code: string };

export type UpdateManifestDriverMutationVariables = Exact<{
  updateManifestDriverInput: UpdateManifestDriverInput;
}>;


export type UpdateManifestDriverMutation = { __typename?: 'Mutation', updateManifestDriver: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } };

export type UpdateManifestVehicleMutationVariables = Exact<{
  updateManifestVehicleInput: UpdateManifestVehicleInput;
}>;


export type UpdateManifestVehicleMutation = { __typename?: 'Mutation', updateManifestVehicle: { __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> } };

export type UpdateManifestsStatusMutationVariables = Exact<{
  input: UpdateManifestsStatusInput;
}>;


export type UpdateManifestsStatusMutation = { __typename?: 'Mutation', updateManifestsStatus: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateManifestsStatusSuccessOutput', lineHaulManifests: Array<{ __typename?: 'LineHaulManifestEntity', referenceNumber: string, createdAt: any, departDate: any, status: LineHaulManifestStatus, isRecurringGenerated: boolean, hasFreightArrivedWhileUndeparted: boolean, estimatedDeparture?: any | null, estimatedArrival?: any | null, departTimeMinutes?: number | null, loadPosition?: LoadPosition | null, startedAt?: any | null, completedAt?: any | null, uuid: string, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, ordinal?: number | null, loadPosition?: LoadPosition | null }>, driver?: { __typename?: 'DriverEntity', uuid: string, driverReferenceNumber?: string | null, firstName: string, lastName: string, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, equipment?: { __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType } | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, dimWeight: number, pieceCountFromPackages: number, hazmat: boolean, refNumbers: Array<string>, dateMarkedReceivedAtOrigin?: any | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', value: string }>, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, weight?: number | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, serviceDate?: any | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } } }> }> }>, orderSegments: Array<{ __typename?: 'OrderLineHaulSegmentEntity', arrivedAt?: any | null, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, receivedDate?: any | null, osd?: boolean | null, status: OrderStatus, weight: number, dimWeight: number, lineHaulServiceDisplayString: string, pieceCountFromPackages: number, refNumbers: Array<string>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', weightUnits: WeightUnits, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, length?: number | null, width?: number | null, height?: number | null, weight?: number | null, type?: PackageType | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } }, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }> }> } };

export type CalmAddStopToRouteMutationVariables = Exact<{
  input: AddStopToRouteInput;
}>;


export type CalmAddStopToRouteMutation = { __typename?: 'Mutation', calmAddStopToRoute: boolean };

export type CalmBuildRunManifestsQueryVariables = Exact<{
  dates: Array<Scalars['DateTime']['input']> | Scalars['DateTime']['input'];
}>;


export type CalmBuildRunManifestsQuery = { __typename?: 'Query', lineHaulManifests: { __typename?: 'FindLineHaulManifestsOutput', lineHaulManifests: Array<{ __typename?: 'LineHaulManifestEntity', uuid: string, referenceNumber: string, status: LineHaulManifestStatus, departDate: any, startTerminal: { __typename?: 'TerminalEntity', code: string }, endTerminal: { __typename?: 'TerminalEntity', code: string }, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, weight: number, pieceCountFromPackages: number }> }> } };

export type CalmCrossdockInstructionsQueryVariables = Exact<{
  terminalUuid: Scalars['String']['input'];
}>;


export type CalmCrossdockInstructionsQuery = { __typename?: 'Query', calmCrossdockInstructions: Array<{ __typename?: 'CalmCrossdockInstructionEntity', orderUuid: string, instruction: string }> };

export type CalmSetCrossdockInstructionMutationVariables = Exact<{
  input: SetCrossdockInstructionInput;
}>;


export type CalmSetCrossdockInstructionMutation = { __typename?: 'Mutation', calmSetCrossdockInstruction: boolean };

export type LineHaulDriverConflictQueryVariables = Exact<{
  input: LineHaulDriverConflictInput;
}>;


export type LineHaulDriverConflictQuery = { __typename?: 'Query', lineHaulDriverConflict: { __typename?: 'LineHaulDriverConflictOutput', conflictWarning?: string | null } };

export type CalmManifestLoadPackagesQueryVariables = Exact<{
  input: ManifestUuidsInput;
}>;


export type CalmManifestLoadPackagesQuery = { __typename?: 'Query', calmManifestLoadPackages: Array<{ __typename?: 'CalmLoadPackageEntity', manifestUuid: string, packageUuid: string, orderUuid?: string | null, orderName: string, hawb?: string | null, mawb?: string | null, customer?: string | null, warehouse?: string | null, warehouseLocation?: string | null, originCode?: string | null, destCode?: string | null, inboundServiceDate?: string | null, outboundServiceDate?: string | null, description: string, pieces: number, piecesOnHand: number, piecesLoaded: number, piecesDeparted: number, onHand: boolean, hazmat: boolean, weightLbs?: number | null, length?: number | null, width?: number | null, height?: number | null, cubeFt3: number, unitDimensions: Array<{ __typename?: 'CalmUnitDimensionsEntity', pieceUuid: string, length: number, width: number, height: number }>, elsewhere?: { __typename?: 'CalmFreightElsewhereEntity', terminalCode: string, onHand: number, loaded: number, departed: number } | null }> };

export type CalmManifestPlacementsQueryVariables = Exact<{
  input: ManifestUuidsInput;
}>;


export type CalmManifestPlacementsQuery = { __typename?: 'Query', calmManifestPlacements: Array<{ __typename?: 'CalmLoadPlacementEntity', manifestUuid: string, packageUuid: string, unitIndex: number, pieceUuid?: string | null, x: number, y: number, z: number, l: number, w: number, h: number, rotated: boolean, trailerEquipmentUuid?: string | null }> };

export type CalmSaveManifestPlacementsMutationVariables = Exact<{
  input: SaveManifestPlacementsInput;
}>;


export type CalmSaveManifestPlacementsMutation = { __typename?: 'Mutation', calmSaveManifestPlacements: { __typename?: 'CalmSavePlacementsResultEntity', saved: number, dropped: number, placements: Array<{ __typename?: 'CalmLoadPlacementEntity', manifestUuid: string, packageUuid: string, unitIndex: number, pieceUuid?: string | null, x: number, y: number, z: number, l: number, w: number, h: number, rotated: boolean, trailerEquipmentUuid?: string | null }> } };

export type CalmManifestsRangeQueryVariables = Exact<{
  dates?: InputMaybe<Array<Scalars['DateTime']['input']> | Scalars['DateTime']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type CalmManifestsRangeQuery = { __typename?: 'Query', lineHaulManifests: { __typename?: 'FindLineHaulManifestsOutput', lineHaulManifests: Array<{ __typename?: 'LineHaulManifestEntity', uuid: string, referenceNumber: string, departDate: any, estimatedArrival?: any | null, estimatedDeparture?: any | null, departTimeMinutes?: number | null, startedAt?: any | null, completedAt?: any | null, doorsClosedAt?: any | null, status: LineHaulManifestStatus, driver?: { __typename?: 'DriverEntity', firstName: string, lastName: string } | null, startTerminal: { __typename?: 'TerminalEntity', code: string }, endTerminal: { __typename?: 'TerminalEntity', code: string }, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string }>, ordersOnManifest: Array<{ __typename?: 'OrderOnLineHaulManifestEntity', orderUuid: string, loadPosition?: LoadPosition | null }> }> } };

export type CalmMoveOrderBetweenRunsMutationVariables = Exact<{
  input: MoveBetweenRunsInput;
}>;


export type CalmMoveOrderBetweenRunsMutation = { __typename?: 'Mutation', calmMoveOrderBetweenRuns: boolean };

export type CalmOrderFinalMileQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type CalmOrderFinalMileQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, endStop?: { __typename?: 'StandardStopEntity', uuid: string, outboundMethod?: OutboundMethod | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, name: string, driver?: { __typename?: 'DriverEntity', user: { __typename?: 'UserActorEntity', name?: string | null } } | null } | null } | null } | null } | null };

export type CalmOrderPiecesQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type CalmOrderPiecesQuery = { __typename?: 'Query', calmOrderPieces: Array<{ __typename?: 'CalmOrderPieceEntity', uuid: string, packageUuid?: string | null, label?: string | null, status: PieceStatus, terminalCode?: string | null, warehouseLocation?: string | null }> };

export type CalmOrderLineHaulRouteQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type CalmOrderLineHaulRouteQuery = { __typename?: 'Query', calmOrderLineHaulRoute: Array<{ __typename?: 'CalmOrderLegEntity', ordinal: number, startUuid: string, startCode: string, endUuid: string, endCode: string, assigned: boolean, manifestRef?: string | null, manifestUuid?: string | null, departDate?: string | null }> };

export type CalmOrderSplitSummaryQueryVariables = Exact<{
  input: OrderSplitSummaryInput;
}>;


export type CalmOrderSplitSummaryQuery = { __typename?: 'Query', calmOrderSplitSummary: Array<{ __typename?: 'CalmOrderSplitSummaryEntity', orderUuid: string, totalUnits: number, manifests: Array<{ __typename?: 'CalmOrderSplitManifestEntity', manifestUuid: string, manifestRef: string, departDate: string, units: number }> }> };

export type CalmOrderTagsQueryVariables = Exact<{
  input: OrderUuidsInput;
}>;


export type CalmOrderTagsQuery = { __typename?: 'Query', calmOrderTags: Array<{ __typename?: 'CalmOrderTagsEntity', orderUuid: string, tags: Array<{ __typename?: 'CalmOrderTagEntity', value: string, color?: string | null }> }> };

export type CalmOrdersByHawbQueryVariables = Exact<{
  input: OrdersByHawbInput;
}>;


export type CalmOrdersByHawbQuery = { __typename?: 'Query', calmOrdersByHawb: { __typename?: 'CalmHawbSearchResultEntity', hasMore: boolean, matches: Array<{ __typename?: 'CalmOrderHawbMatchEntity', orderUuid: string, name: string, hawb?: string | null, status: OrderStatus }> } };

export type CalmOrderPackagesQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type CalmOrderPackagesQuery = { __typename?: 'Query', calmOrderPackages: Array<{ __typename?: 'CalmOrderPackageEntity', uuid: string, description: string, pieces: number, piecesOnHand: number, onHand: boolean, hazmat: boolean, weight?: number | null, commitBy?: string | null, assignments: Array<{ __typename?: 'CalmPackageAssignmentEntity', manifestUuid: string, manifestRef: string, leg: string, departDate: string, departed: boolean }> }> };

export type CalmManifestReadinessQueryVariables = Exact<{
  manifestUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CalmManifestReadinessQuery = { __typename?: 'Query', calmManifestReadiness: Array<{ __typename?: 'CalmManifestReadinessEntity', manifestUuid: string, orders: number, ordersNotOnHand: number, piecesTotal: number, piecesOnHand: number, piecesLoaded: number, piecesDeparted: number, piecesAtDestination: number, weightTotal: number, weightOnHand: number, cubeTotal: number, cubeOnHand: number }> };

export type CalmManifestSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type CalmManifestSearchQuery = { __typename?: 'Query', calmManifestSearch: Array<{ __typename?: 'CalmManifestSearchResultEntity', uuid: string, ref: string, orig: string, dest: string, departDate: string, status: string }> };

export type CalmManifestReschedulablesQueryVariables = Exact<{
  manifestUuid: Scalars['String']['input'];
}>;


export type CalmManifestReschedulablesQuery = { __typename?: 'Query', calmManifestReschedulables: Array<{ __typename?: 'CalmReschedulableEntity', orderUuid: string, orderName: string, packageUuid: string, description: string, pieces: number, piecesOnHand: number, commitBy?: string | null }> };

export type CalmAssignPackagesToManifestMutationVariables = Exact<{
  input: AssignPackagesToManifestInput;
}>;


export type CalmAssignPackagesToManifestMutation = { __typename?: 'Mutation', calmAssignPackagesToManifest: boolean };

export type CalmRemovePackagesFromManifestMutationVariables = Exact<{
  input: AssignPackagesToManifestInput;
}>;


export type CalmRemovePackagesFromManifestMutation = { __typename?: 'Mutation', calmRemovePackagesFromManifest: boolean };

export type CalmLiveRunsQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type CalmLiveRunsQuery = { __typename?: 'Query', calmLiveRuns: Array<{ __typename?: 'CalmLiveRunEntity', uuid: string, ref: string, orig: string, dest: string, driverName: string, departedAt?: string | null, ships: number }> };

export type CalmCommitDatesByOrderUuidsQueryVariables = Exact<{
  input: OrderUuidsInput;
}>;


export type CalmCommitDatesByOrderUuidsQuery = { __typename?: 'Query', calmCommitDatesByOrderUuids: Array<{ __typename?: 'CalmOrderCommitEntity', orderUuid: string, commitBy?: string | null }> };

export type CalmOrderPackagesByOrderUuidsQueryVariables = Exact<{
  input: OrderUuidsInput;
}>;


export type CalmOrderPackagesByOrderUuidsQuery = { __typename?: 'Query', calmOrderPackagesByOrderUuids: Array<{ __typename?: 'CalmOrderPackagesEntity', orderUuid: string, packages: Array<{ __typename?: 'CalmOrderPackageEntity', uuid: string, description: string, pieces: number, piecesOnHand: number, onHand: boolean, hazmat: boolean, weight?: number | null, commitBy?: string | null, assignments: Array<{ __typename?: 'CalmPackageAssignmentEntity', manifestUuid: string, manifestRef: string, leg: string, departDate: string, departed: boolean }> }> }> };

export type CalmLineHaulOrdersToPlanQueryVariables = Exact<{
  input: CalmPlanOrdersInput;
}>;


export type CalmLineHaulOrdersToPlanQuery = { __typename?: 'Query', calmLineHaulOrdersToPlan: Array<{ __typename?: 'CalmPlanOrderEntity', orderUuid: string, name: string, hawb?: string | null, originUuid: string, originCode: string, destUuid: string, destCode: string, pieces: number, piecesOnHand: number, packages: number, packagesOnHand: number, weight: number, hazmat: boolean, ready: boolean, serviceDate?: string | null, inboundServiceDate?: string | null, outboundServiceDate?: string | null }> };

export type CalmLoadOrdersOnManifestMutationVariables = Exact<{
  input: CalmLoadOrdersInput;
}>;


export type CalmLoadOrdersOnManifestMutation = { __typename?: 'Mutation', calmLoadOrdersOnManifest: boolean };

export type CalmPndRouteLoadQueryVariables = Exact<{
  routeUuid: Scalars['String']['input'];
}>;


export type CalmPndRouteLoadQuery = { __typename?: 'Query', calmPndRouteLoad: { __typename?: 'CalmPndRouteLoadEntity', routeUuid: string, vehicleName?: string | null, length?: number | null, width?: number | null, height?: number | null, weightCapacity?: number | null, packages: Array<{ __typename?: 'CalmLoadPackageEntity', manifestUuid: string, packageUuid: string, orderUuid?: string | null, orderName: string, hawb?: string | null, customer?: string | null, originCode?: string | null, destCode?: string | null, inboundServiceDate?: string | null, outboundServiceDate?: string | null, description: string, pieces: number, piecesOnHand: number, onHand: boolean, hazmat: boolean, length?: number | null, width?: number | null, height?: number | null, weightLbs?: number | null, cubeFt3: number, movement?: StopType | null, awaitingInboundRef?: string | null, expectedOnHandAt?: string | null, unitDimensions: Array<{ __typename?: 'CalmUnitDimensionsEntity', pieceUuid: string, length: number, width: number, height: number }> }> } };

export type CalmPreDispatchOrdersQueryVariables = Exact<{
  input: FindSegmentedLineHaulOrdersInputV2;
}>;


export type CalmPreDispatchOrdersQuery = { __typename?: 'Query', segmentedLineHaulOrdersV2: { __typename?: 'OrderLineHaulSegmentOutput', totalCount?: number | null, edges: Array<{ __typename?: 'OrderLineHaulSegmentEntity', uuid: string, order: { __typename?: 'StandardOrderEntity', uuid: string, name: string, weight: number, pieceCountFromPackages: number, dateMarkedReceivedAtOrigin?: any | null, detailedStatusV2?: OrderDetailedStatus | null, hasNoneOrCompletedInboundStop: boolean, hazmat: boolean, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, upcomingLineHaulSegment?: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, expectedInboundArrivalDate?: any | null, terminal?: { __typename?: 'TerminalEntity', code: string } | null } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, pieces?: Array<{ __typename?: 'PieceEntity', uuid: string, status: PieceStatus, markedOnHandAt?: any | null, terminal?: { __typename?: 'TerminalEntity', code: string } | null }> | null }> }, segment: { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } }> } };

export type LineHaulRunConfigsQueryVariables = Exact<{
  manifestUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LineHaulRunConfigsQuery = { __typename?: 'Query', lineHaulRunConfigs: Array<{ __typename?: 'LineHaulRunConfigEntity', manifestUuid: string, cubeCapacity?: number | null, weightCapacity?: number | null, truckLabel?: string | null, recurringTemplateTruckUuid?: string | null, cutoffTime?: string | null, powerUnitName?: string | null, trailers: Array<string>, trailerDetails: Array<{ __typename?: 'RecurringTemplateTruckTrailerEntity', equipmentUuid: string, name: string, capacity?: number | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null }>, powerUnitDetails?: { __typename?: 'LineHaulRunCargoUnitEntity', equipmentUuid: string, name: string, length?: number | null, width?: number | null, height?: number | null } | null }> };

export type CalmRunInboundPlanQueryVariables = Exact<{
  manifestUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CalmRunInboundPlanQuery = { __typename?: 'Query', calmRunInboundPlan: Array<{ __typename?: 'CalmRunInboundPlanEntity', manifestUuid: string, orders: Array<{ __typename?: 'CalmRunInboundOrderEntity', orderUuid: string, source: CalmInboundSource, fromTerminalCode?: string | null, fromManifestUuid?: string | null, fromManifestRef?: string | null }> }> };

export type CalmRunOnwardPlanQueryVariables = Exact<{
  manifestUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CalmRunOnwardPlanQuery = { __typename?: 'Query', calmRunOnwardPlan: Array<{ __typename?: 'CalmRunOnwardPlanEntity', manifestUuid: string, orders: Array<{ __typename?: 'CalmRunOnwardOrderEntity', orderUuid: string, disposition: CalmOnwardDisposition, nextTerminalCode?: string | null, onwardManifestUuid?: string | null, onwardManifestRef?: string | null }> }> };

export type LineHaulSegmentTimingsQueryVariables = Exact<{ [key: string]: never; }>;


export type LineHaulSegmentTimingsQuery = { __typename?: 'Query', lineHaulSegmentTimings: Array<{ __typename?: 'LineHaulSegmentTimingEntity', startTerminalUuid: string, startTerminalCode: string, endTerminalUuid: string, endTerminalCode: string, cutoffTime?: string | null, transitDays?: number | null, transitMinutes?: number | null }> };

export type LineHaulSegmentTimingFragment = { __typename?: 'LineHaulSegmentTimingEntity', startTerminalUuid: string, startTerminalCode: string, endTerminalUuid: string, endTerminalCode: string, cutoffTime?: string | null, transitDays?: number | null, transitMinutes?: number | null };

export type SetLineHaulSegmentTimingMutationVariables = Exact<{
  input: SetLineHaulSegmentTimingInput;
}>;


export type SetLineHaulSegmentTimingMutation = { __typename?: 'Mutation', setLineHaulSegmentTiming: { __typename?: 'SetLineHaulSegmentTimingOutput', updatedCount: number, timing?: { __typename?: 'LineHaulSegmentTimingEntity', startTerminalUuid: string, startTerminalCode: string, endTerminalUuid: string, endTerminalCode: string, cutoffTime?: string | null, transitDays?: number | null, transitMinutes?: number | null } | null } };

export type CalmSetPndRouteDriverMutationVariables = Exact<{
  input: SetPndRouteDriverInput;
}>;


export type CalmSetPndRouteDriverMutation = { __typename?: 'Mutation', calmSetPndRouteDriver: boolean };

export type RecurringTemplateTrucksQueryVariables = Exact<{
  recurringTemplateUuid: Scalars['String']['input'];
}>;


export type RecurringTemplateTrucksQuery = { __typename?: 'Query', recurringTemplateTrucks: Array<{ __typename?: 'RecurringTemplateTruckEntity', uuid: string, recurringTemplateUuid: string, label: string, powerUnitEquipmentUuid?: string | null, powerUnitName?: string | null, cutoffTime?: string | null, daysOfWeek: Array<DayOfWeekAll>, trailers: Array<{ __typename?: 'RecurringTemplateTruckTrailerEntity', equipmentUuid: string, name: string, capacity?: number | null, weight?: number | null }> }> };

export type CreateRecurringTemplateTruckMutationVariables = Exact<{
  input: CreateRecurringTemplateTruckInput;
}>;


export type CreateRecurringTemplateTruckMutation = { __typename?: 'Mutation', createRecurringTemplateTruck: { __typename?: 'RecurringTemplateTruckEntity', uuid: string, recurringTemplateUuid: string, label: string, powerUnitEquipmentUuid?: string | null, powerUnitName?: string | null, cutoffTime?: string | null, daysOfWeek: Array<DayOfWeekAll>, trailers: Array<{ __typename?: 'RecurringTemplateTruckTrailerEntity', equipmentUuid: string, name: string, capacity?: number | null, weight?: number | null }> } };

export type UpdateRecurringTemplateTruckMutationVariables = Exact<{
  input: UpdateRecurringTemplateTruckInput;
}>;


export type UpdateRecurringTemplateTruckMutation = { __typename?: 'Mutation', updateRecurringTemplateTruck: { __typename?: 'RecurringTemplateTruckEntity', uuid: string, recurringTemplateUuid: string, label: string, powerUnitEquipmentUuid?: string | null, powerUnitName?: string | null, cutoffTime?: string | null, daysOfWeek: Array<DayOfWeekAll>, trailers: Array<{ __typename?: 'RecurringTemplateTruckTrailerEntity', equipmentUuid: string, name: string, capacity?: number | null, weight?: number | null }> } };

export type DeleteRecurringTemplateTruckMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteRecurringTemplateTruckMutation = { __typename?: 'Mutation', deleteRecurringTemplateTruck: string };

export type CreateLineHaulTruckRunsMutationVariables = Exact<{
  input: CreateTruckRunsInput;
}>;


export type CreateLineHaulTruckRunsMutation = { __typename?: 'Mutation', createLineHaulTruckRuns: number };

export type SetLineHaulManifestTruckMutationVariables = Exact<{
  input: SetManifestTruckInput;
}>;


export type SetLineHaulManifestTruckMutation = { __typename?: 'Mutation', setLineHaulManifestTruck: { __typename?: 'SetManifestTruckOutput', conflictWarning?: string | null } };

export type GenerateLineHaulRunsMutationVariables = Exact<{
  input: GenerateLineHaulRunsInput;
}>;


export type GenerateLineHaulRunsMutation = { __typename?: 'Mutation', generateLineHaulRuns: { __typename?: 'GenerateLineHaulRunsOutput', created: number, serviceDays: number } };

export type CalmTerminalLanesQueryVariables = Exact<{ [key: string]: never; }>;


export type CalmTerminalLanesQuery = { __typename?: 'Query', terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, isActive: boolean, address: { __typename?: 'AddressEntity', latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> }> };

export type CalmAssignLineHaulRouteMutationVariables = Exact<{
  input: AssignLineHaulRouteInput;
}>;


export type CalmAssignLineHaulRouteMutation = { __typename?: 'Mutation', calmAssignLineHaulRoute: { __typename?: 'AssignLineHaulRouteOutput', orderUuid: string, laneUuid: string, legCount: number } };

export type CalmTerminalOnHandQueryVariables = Exact<{
  terminalUuid: Scalars['String']['input'];
}>;


export type CalmTerminalOnHandQuery = { __typename?: 'Query', calmTerminalOnHand: Array<{ __typename?: 'CalmOnHandPieceEntity', pieceUuid: string, pieceRef?: string | null, packageUuid?: string | null, weightLbs?: number | null, orderUuid?: string | null, orderRef?: string | null, hawb?: string | null, customer?: string | null, destCode?: string | null, inboundServiceDate?: string | null, outboundServiceDate?: string | null, warehouseUuid?: string | null, warehouseName?: string | null, locationUuid?: string | null, locationName?: string | null, markedOnHandAt?: string | null }> };

export type CalmTerminalPndQueryVariables = Exact<{
  terminalUuid: Scalars['String']['input'];
  date: Scalars['String']['input'];
}>;


export type CalmTerminalPndQuery = { __typename?: 'Query', calmTerminalPnd: Array<{ __typename?: 'CalmPndRouteEntity', routeUuid: string, name: string, driverName?: string | null, driverUuid?: string | null, startAt?: string | null, started: boolean, locked: boolean, pickups: number, deliveries: number, stops: number, orderUuids: Array<string> }> };

export type LineHaulTrailerAssignmentsQueryVariables = Exact<{
  manifestUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LineHaulTrailerAssignmentsQuery = { __typename?: 'Query', lineHaulTrailerAssignments: Array<{ __typename?: 'LineHaulTrailerAssignmentEntity', manifestUuid: string, orderUuid: string, trailerEquipmentUuid: string, weightLbs: number, cubeFt3: number }> };

export type AssignOrderToLineHaulTrailerMutationVariables = Exact<{
  input: AssignOrderToTrailerInput;
}>;


export type AssignOrderToLineHaulTrailerMutation = { __typename?: 'Mutation', assignOrderToLineHaulTrailer: boolean };

export type UnassignOrderFromLineHaulTrailerMutationVariables = Exact<{
  input: UnassignOrderFromTrailerInput;
}>;


export type UnassignOrderFromLineHaulTrailerMutation = { __typename?: 'Mutation', unassignOrderFromLineHaulTrailer: boolean };

export type DockDoorAssignmentsQueryVariables = Exact<{
  input: DockDoorAssignmentsInput;
}>;


export type DockDoorAssignmentsQuery = { __typename?: 'Query', dockDoorAssignments: Array<{ __typename?: 'DockDoorAssignmentEntity', manifestUuid?: string | null, routeUuid?: string | null, doorPosition?: number | null, doorEventAt?: string | null, isReturnLeg: boolean }> };

export type AssignDockDoorMutationVariables = Exact<{
  input: AssignDockDoorInput;
}>;


export type AssignDockDoorMutation = { __typename?: 'Mutation', assignDockDoor: Array<{ __typename?: 'DockDoorEntity', uuid: string, position: number, direction: DockDoorDirection }> };

export type DockDoorsQueryVariables = Exact<{
  terminalUuid: Scalars['String']['input'];
}>;


export type DockDoorsQuery = { __typename?: 'Query', dockDoors: Array<{ __typename?: 'DockDoorEntity', uuid: string, position: number, direction: DockDoorDirection }> };

export type SetDockDoorsMutationVariables = Exact<{
  input: SetDockDoorsInput;
}>;


export type SetDockDoorsMutation = { __typename?: 'Mutation', setDockDoors: Array<{ __typename?: 'DockDoorEntity', uuid: string, position: number, direction: DockDoorDirection }> };

export type DockRunTimesQueryVariables = Exact<{
  input: DockRunTimesInput;
}>;


export type DockRunTimesQuery = { __typename?: 'Query', dockRunTimes: Array<{ __typename?: 'DockRunTimeEntity', manifestUuid: string, departAt?: string | null, arriveAt?: string | null, actualDepartAt?: string | null, actualArriveAt?: string | null }> };

export type CompanyDockDoorsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyDockDoorsQuery = { __typename?: 'Query', companyDockDoors: Array<{ __typename?: 'DockDoorEntity', uuid: string, terminalUuid?: string | null, position: number, direction: DockDoorDirection }> };

export type LaneDefaultDoorsQueryVariables = Exact<{ [key: string]: never; }>;


export type LaneDefaultDoorsQuery = { __typename?: 'Query', laneDefaultDoors: Array<{ __typename?: 'LaneDefaultDoorEntity', startTerminalUuid: string, endTerminalUuid: string, originDoorPosition?: number | null, destDoorPosition?: number | null }> };

export type SetLaneDefaultDoorMutationVariables = Exact<{
  input: SetLaneDefaultDoorInput;
}>;


export type SetLaneDefaultDoorMutation = { __typename?: 'Mutation', setLaneDefaultDoor: Array<{ __typename?: 'LaneDefaultDoorEntity', startTerminalUuid: string, endTerminalUuid: string, originDoorPosition?: number | null, destDoorPosition?: number | null }> };

export type MarkManifestAsDoorsClosedMutationVariables = Exact<{
  markManifestAsDoorsClosedInput: MarkManifestAsDoorsClosedInput;
}>;


export type MarkManifestAsDoorsClosedMutation = { __typename?: 'Mutation', markManifestAsDoorsClosed: { __typename?: 'MarkManifestAsDoorsClosedOutput', errorMessage?: string | null, lineHaulManifest?: { __typename?: 'LineHaulManifestEntity', uuid: string, status: LineHaulManifestStatus } | null } };

export type AccessorialGroupFragment = { __typename?: 'AccessorialGroupEntity', id: string, name: string, description?: string | null, accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', name: string, uuid: string } | { __typename: 'PercentageAccessorialEntity', name: string, uuid: string } | { __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename: 'StorageDaysAccessorialEntity', name: string, uuid: string } | { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string }> };

export type AccessorialGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessorialGroupsQuery = { __typename?: 'Query', accessorialGroups: Array<{ __typename?: 'AccessorialGroupEntity', id: string, name: string, description?: string | null, accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', name: string, uuid: string } | { __typename: 'PercentageAccessorialEntity', name: string, uuid: string } | { __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename: 'StorageDaysAccessorialEntity', name: string, uuid: string } | { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string }> }> };

export type CreateAccessorialGroupMutationVariables = Exact<{
  input: CreateAccessorialGroupInput;
}>;


export type CreateAccessorialGroupMutation = { __typename?: 'Mutation', createAccessorialGroup: { __typename?: 'AccessorialGroupEntity', id: string, name: string, description?: string | null, accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', name: string, uuid: string } | { __typename: 'PercentageAccessorialEntity', name: string, uuid: string } | { __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename: 'StorageDaysAccessorialEntity', name: string, uuid: string } | { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string }> } };

export type UpdateAccessorialGroupMutationVariables = Exact<{
  input: UpdateAccessorialGroupInput;
}>;


export type UpdateAccessorialGroupMutation = { __typename?: 'Mutation', updateAccessorialGroup: { __typename?: 'AccessorialGroupEntity', id: string, name: string, description?: string | null, accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', name: string, uuid: string } | { __typename: 'PercentageAccessorialEntity', name: string, uuid: string } | { __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename: 'StorageDaysAccessorialEntity', name: string, uuid: string } | { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string }> } };

export type DeleteAccessorialGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAccessorialGroupMutation = { __typename?: 'Mutation', deleteAccessorialGroup: boolean };

export type CreateRecurringLineHaulManifestTemplateMutationVariables = Exact<{
  input: CreateRecurringLineHaulManifestTemplateInput;
}>;


export type CreateRecurringLineHaulManifestTemplateMutation = { __typename?: 'Mutation', createRecurringLineHaulManifestTemplate: { __typename?: 'RecurringLineHaulManifestTemplateEntity', uuid: string, createdAt: any, updatedAt: any, startTerminalUuid: string, endTerminalUuid: string, daysOfWeek: Array<DayOfWeekAll>, departTimeMinutes: number, transitMinutes: number, startDate: any, endDate?: any | null, manifestsPerOccurrence: number, defaultDriverUuid?: string | null, defaultEquipmentUuid?: string | null, createInAdvanceHours: number, createAheadDays?: number | null, skipDates: Array<any>, isActive: boolean, autoGenerate: boolean, lastProcessedAt?: any | null, truckCount?: number | null } };

export type DeleteRecurringLineHaulManifestTemplateMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteRecurringLineHaulManifestTemplateMutation = { __typename?: 'Mutation', deleteRecurringLineHaulManifestTemplate: string };

export type RecurringLineHaulManifestTemplateFragment = { __typename?: 'RecurringLineHaulManifestTemplateEntity', uuid: string, createdAt: any, updatedAt: any, startTerminalUuid: string, endTerminalUuid: string, daysOfWeek: Array<DayOfWeekAll>, departTimeMinutes: number, transitMinutes: number, startDate: any, endDate?: any | null, manifestsPerOccurrence: number, defaultDriverUuid?: string | null, defaultEquipmentUuid?: string | null, createInAdvanceHours: number, createAheadDays?: number | null, skipDates: Array<any>, isActive: boolean, autoGenerate: boolean, lastProcessedAt?: any | null, truckCount?: number | null };

export type RecurringLineHaulManifestTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type RecurringLineHaulManifestTemplatesQuery = { __typename?: 'Query', recurringLineHaulManifestTemplates: Array<{ __typename?: 'RecurringLineHaulManifestTemplateEntity', uuid: string, createdAt: any, updatedAt: any, startTerminalUuid: string, endTerminalUuid: string, daysOfWeek: Array<DayOfWeekAll>, departTimeMinutes: number, transitMinutes: number, startDate: any, endDate?: any | null, manifestsPerOccurrence: number, defaultDriverUuid?: string | null, defaultEquipmentUuid?: string | null, createInAdvanceHours: number, createAheadDays?: number | null, skipDates: Array<any>, isActive: boolean, autoGenerate: boolean, lastProcessedAt?: any | null, truckCount?: number | null }> };

export type UpdateRecurringLineHaulManifestTemplateMutationVariables = Exact<{
  input: UpdateRecurringLineHaulManifestTemplateInput;
}>;


export type UpdateRecurringLineHaulManifestTemplateMutation = { __typename?: 'Mutation', updateRecurringLineHaulManifestTemplate: { __typename?: 'RecurringLineHaulManifestTemplateEntity', uuid: string, createdAt: any, updatedAt: any, startTerminalUuid: string, endTerminalUuid: string, daysOfWeek: Array<DayOfWeekAll>, departTimeMinutes: number, transitMinutes: number, startDate: any, endDate?: any | null, manifestsPerOccurrence: number, defaultDriverUuid?: string | null, defaultEquipmentUuid?: string | null, createInAdvanceHours: number, createAheadDays?: number | null, skipDates: Array<any>, isActive: boolean, autoGenerate: boolean, lastProcessedAt?: any | null, truckCount?: number | null } };

export type ServiceGroupFragment = { __typename?: 'ServiceGroupEntity', id: string, name: string, description?: string | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> };

export type ServiceGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceGroupsQuery = { __typename?: 'Query', serviceGroups: Array<{ __typename?: 'ServiceGroupEntity', id: string, name: string, description?: string | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> };

export type CreateServiceGroupMutationVariables = Exact<{
  input: CreateServiceGroupInput;
}>;


export type CreateServiceGroupMutation = { __typename?: 'Mutation', createServiceGroup: { __typename?: 'ServiceGroupEntity', id: string, name: string, description?: string | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> } };

export type UpdateServiceGroupMutationVariables = Exact<{
  input: UpdateServiceGroupInput;
}>;


export type UpdateServiceGroupMutation = { __typename?: 'Mutation', updateServiceGroup: { __typename?: 'ServiceGroupEntity', id: string, name: string, description?: string | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> } };

export type DeleteServiceGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteServiceGroupMutation = { __typename?: 'Mutation', deleteServiceGroup: boolean };

export type ArchiveTariffChainMutationVariables = Exact<{
  archiveTariffChainInput: ArchiveTariffChainInput;
}>;


export type ArchiveTariffChainMutation = { __typename?: 'Mutation', archiveTariffChain: { __typename?: 'ArchiveTariffChainSuccessOutput', tariffChain: { __typename?: 'TariffChainEntity', id: string } } | { __typename?: 'MutationErrorOutput', message: string } };

export type CompanyDefaultTariffChainFragment = { __typename?: 'TariffChainEntity', id: string, name: string };

export type CompanyDefaultTariffChainsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyDefaultTariffChainsQuery = { __typename?: 'Query', company: { __typename?: 'CompanyEntity', defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultRecoveryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultOrdinarySettlementTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferSettlementTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultRecoverySettlementTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null } };

export type CreateTariffChainMutationVariables = Exact<{
  createTariffChainInput: CreateTariffChainInput;
}>;


export type CreateTariffChainMutation = { __typename?: 'Mutation', createTariffChain: { __typename?: 'CreateTariffChainSuccessOutput', tariffChain: { __typename?: 'TariffChainEntity', id: string } } | { __typename?: 'MutationErrorOutput', message: string } };

export type RestoreTariffChainMutationVariables = Exact<{
  restoreTariffChainInput: RestoreTariffChainInput;
}>;


export type RestoreTariffChainMutation = { __typename?: 'Mutation', restoreTariffChain: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'RestoreTariffChainSuccessOutput', tariffChain: { __typename?: 'TariffChainEntity', id: string } } };

export type TariffChainWithGroupsFragment = { __typename?: 'TariffChainEntity', id: string, name: string, tariffGroupType: TariffGroupType, tariffGroups: Array<{ __typename?: 'TariffGroupEntity', uuid: string, name?: string | null }> };

export type TariffChainsWithGroupsQueryVariables = Exact<{
  findTariffChainsInput: FindTariffChainsInput;
}>;


export type TariffChainsWithGroupsQuery = { __typename?: 'Query', tariffChains: Array<{ __typename?: 'TariffChainEntity', id: string, name: string, tariffGroupType: TariffGroupType, tariffGroups: Array<{ __typename?: 'TariffGroupEntity', uuid: string, name?: string | null }> }> };

export type UpdateDefaultTariffChainsForCompanyMutationVariables = Exact<{
  updateDefaultTariffChainsForCompanyInput: UpdateDefaultTariffChainsForCompanyInput;
}>;


export type UpdateDefaultTariffChainsForCompanyMutation = { __typename?: 'Mutation', updateDefaultTariffChainsForCompany: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'UpdateDefaultTariffChainsForCompanySuccessOutput', company: { __typename?: 'CompanyEntity', uuid: string } } };

export type UpdateTariffChainMutationVariables = Exact<{
  updateTariffChainInput: UpdateTariffChainInput;
}>;


export type UpdateTariffChainMutation = { __typename?: 'Mutation', updateTariffChain: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'UpdateTariffChainSuccessOutput', tariffChain: { __typename?: 'TariffChainEntity', id: string } } };

export type ContactsWithTariffsQueryVariables = Exact<{
  checkHasTariffs?: InputMaybe<Scalars['Boolean']['input']>;
  checkHasTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContactsWithTariffsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string, customerTariffs: Array<{ __typename?: 'TariffEntity', service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }>, tariffZones: Array<{ __typename?: 'TariffZoneEntity', type: TariffZoneType }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, customerTariffs: Array<{ __typename?: 'TariffEntity', service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null }>, tariffZones: Array<{ __typename?: 'TariffZoneEntity', type: TariffZoneType }> }> };

export type CreateTariffGroupMutationVariables = Exact<{
  createTariffGroupInput: CreateTariffGroupInput;
}>;


export type CreateTariffGroupMutation = { __typename?: 'Mutation', createTariffGroup: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null } };

export type DeleteTariffGroupMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteTariffGroupMutation = { __typename?: 'Mutation', deleteTariffGroup: { __typename?: 'TariffGroupEntity', uuid: string } };

export type DuplicateTariffGroupMutationVariables = Exact<{
  duplicateTariffGroupInput: DuplicateTariffGroupInput;
}>;


export type DuplicateTariffGroupMutation = { __typename?: 'Mutation', duplicateTariffGroup: { __typename?: 'DuplicateTariffGroupOutput', tariffGroup: { __typename?: 'TariffGroupEntity', uuid: string } } };

export type FindDefaultRecoveryTariffGroupForCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type FindDefaultRecoveryTariffGroupForCompanyQuery = { __typename?: 'Query', findDefaultRecoveryTariffGroupForCompany?: { __typename?: 'TariffGroupEntity', uuid: string } | null };

export type FindDefaultTariffGroupForCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type FindDefaultTariffGroupForCompanyQuery = { __typename?: 'Query', findDefaultTariffGroupForCompany?: { __typename?: 'TariffGroupEntity', uuid: string } | null };

export type FindDefaultTransferTariffGroupForCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type FindDefaultTransferTariffGroupForCompanyQuery = { __typename?: 'Query', findDefaultTransferTariffGroupForCompany?: { __typename?: 'TariffGroupEntity', uuid: string } | null };

export type FindTariffGroupsWithContactAndServiceCombinationQueryVariables = Exact<{
  mappingsList: Array<ContactAndServicesCombination> | ContactAndServicesCombination;
}>;


export type FindTariffGroupsWithContactAndServiceCombinationQuery = { __typename?: 'Query', findTariffGroupsWithContactAndServiceCombination: Array<{ __typename?: 'FindTariffGroupsWithContactAndServicesCombinationOutput', contactUuid: string, matchingTariffGroups: Array<{ __typename?: 'MatchingGroupsAlongWithMatchingServices', tariffGroupName?: string | null, tariffGroupUuid: string, serviceUuids: Array<string> }> }> };

export type PointToPointLanesQueryVariables = Exact<{
  tariffGroupUuid: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PointToPointLanesQuery = { __typename?: 'Query', pointToPointLanes: { __typename?: 'PointToPointLaneConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'PointToPointLaneEdge', node: { __typename?: 'PointToPointLaneEntity', tariffUuid: string, version: any, inboundZoneUuid?: string | null, outboundZoneUuid?: string | null, isActive: boolean, minimumUsdCents?: number | null, maximumUsdCents?: number | null, settlementPercentageRate?: any | null, bands: Array<{ __typename?: 'PointToPointLaneBand', lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }> } }> } };

export type SavePointToPointLanesMutationVariables = Exact<{
  input: SavePointToPointLanesInput;
}>;


export type SavePointToPointLanesMutation = { __typename?: 'Mutation', savePointToPointLanes: { __typename?: 'SavePointToPointLanesOutput', lanes: Array<{ __typename?: 'SavedPointToPointLane', inboundZoneUuid: string, outboundZoneUuid: string, tariffUuid: string, version: any }> } };

export type ShallowTariffGroupFuelProfileFragment = { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> };

export type ShallowTariffGroupFragment = { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, tariffs: Array<{ __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, maximumIncludesFuel: boolean, settlementPercentageRate?: any | null, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null } | null }>, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }> };

export type TariffForTariffGroupFragment = { __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, maximumIncludesFuel: boolean, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, settlementPercentageRate?: any | null, isActive: boolean, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, inboundZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string } | null, outboundZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string } | null }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> };

export type TariffGroupEditorShellQueryVariables = Exact<{
  tariffGroupUuid: Scalars['String']['input'];
}>;


export type TariffGroupEditorShellQuery = { __typename?: 'Query', tariffGroup: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupType: TariffGroupType, tariffGroupScope?: TariffGroupScope | null, rateMultiplier?: number | null, startDate?: any | null, endDate?: any | null, useActualWeightInCalculation: boolean, useDeficitBilling?: boolean | null, firstTariff?: { __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, maximumIncludesFuel: boolean, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, settlementPercentageRate?: any | null, isActive: boolean, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, inboundZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string } | null, outboundZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string } | null }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> } | null, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }>, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }> } };

export type TariffGroupForTableFragment = { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, startDate?: any | null, endDate?: any | null, rateMultiplier?: number | null, totalContactsToServicesMappings: number, firstTariff?: { __typename?: 'TariffEntity', tariffType: TariffType, rateType: RateType, tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType } } | null, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string } }>, customerUsage?: { __typename?: 'TariffGroupCustomerUsageEntity', totalDirectCustomers: number, companyDefaultCustomerCount?: number | null, previewCustomers: Array<{ __typename?: 'TariffGroupCustomerPreviewEntity', uuid: string, displayName: string }> } };

export type TariffGroupForTariffFragment = { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null };

export type TariffGroupSettingsFragment = { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupType: TariffGroupType, tariffGroupScope?: TariffGroupScope | null, rateMultiplier?: number | null, startDate?: any | null, endDate?: any | null, useActualWeightInCalculation: boolean, useDeficitBilling?: boolean | null, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }>, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }> };

export type TariffGroupTariffChainsQueryVariables = Exact<{
  tariffGroupUuid: Scalars['String']['input'];
}>;


export type TariffGroupTariffChainsQuery = { __typename?: 'Query', tariffGroup: { __typename?: 'TariffGroupEntity', uuid: string, tariffChains: Array<{ __typename?: 'TariffChainEntity', id: string, name: string, isArchived: boolean }> } };

export type TariffGroupFragment = { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupType: TariffGroupType, tariffGroupScope?: TariffGroupScope | null, rateMultiplier?: number | null, startDate?: any | null, endDate?: any | null, useActualWeightInCalculation: boolean, useDeficitBilling?: boolean | null, tariffs: Array<{ __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, maximumIncludesFuel: boolean, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, settlementPercentageRate?: any | null, isActive: boolean, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, inboundZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string } | null, outboundZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string } | null }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> }>, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }>, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }> };

export type TariffGroupQueryVariables = Exact<{
  tariffGroupUuid: Scalars['String']['input'];
}>;


export type TariffGroupQuery = { __typename?: 'Query', tariffGroup: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupType: TariffGroupType, tariffGroupScope?: TariffGroupScope | null, rateMultiplier?: number | null, startDate?: any | null, endDate?: any | null, useActualWeightInCalculation: boolean, useDeficitBilling?: boolean | null, tariffs: Array<{ __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, maximumIncludesFuel: boolean, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, settlementPercentageRate?: any | null, isActive: boolean, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, inboundZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string } | null, outboundZone?: { __typename?: 'TariffZoneEntity', uuid: string, name: string } | null }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> }>, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }>, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, services: Array<{ __typename?: 'ServiceEntity', uuid: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }> } };

export type TariffOverageRateFragment = { __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean };

export type TariffRangeFragment = { __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number };

export type TariffShallowFragment = { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } };

export type TariffFragment = { __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, maximumIncludesFuel: boolean, settlementPercentageRate?: any | null, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null } | null };

export type TariffFragmentFragment = { __typename?: 'TariffEntity', uuid: string, tariffType: TariffType, minimumUsdCents?: number | null, rateType: RateType, maximumUsdCents?: number | null, maximumIncludesFuel: boolean, billingPartyContactUuid?: string | null, useActualWeightInCalculation: boolean, useActualWeight?: boolean | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, tariffs: Array<{ __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, maximumIncludesFuel: boolean, settlementPercentageRate?: any | null, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null } | null }>, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }> } | null };

export type TariffQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type TariffQuery = { __typename?: 'Query', tariff: { __typename?: 'TariffEntity', uuid: string, tariffType: TariffType, minimumUsdCents?: number | null, rateType: RateType, maximumUsdCents?: number | null, maximumIncludesFuel: boolean, billingPartyContactUuid?: string | null, useActualWeightInCalculation: boolean, useActualWeight?: boolean | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, tariffs: Array<{ __typename?: 'TariffEntity', uuid: string, minimumUsdCents?: number | null, maximumUsdCents?: number | null, maximumIncludesFuel: boolean, settlementPercentageRate?: any | null, tariffType: TariffType, rateType: RateType, billingPartyContactUuid?: string | null, useActualWeight?: boolean | null, useActualWeightInCalculation: boolean, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, flatRateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }>, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> }, tariffRanges: Array<{ __typename?: 'TariffRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }>, tariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, rateMultiplier?: number | null, useActualWeightInCalculation: boolean, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }>, parentTariffGroup?: { __typename?: 'TariffGroupEntity', uuid: string, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null } | null }>, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string }> }> } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string }> } | null } };

export type UpdateContactToServicesTariffGroupMappingsMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  contactToServicesMappings: Array<CreateContactToServicesMappingInput> | CreateContactToServicesMappingInput;
}>;


export type UpdateContactToServicesTariffGroupMappingsMutation = { __typename?: 'Mutation', updateContactToServicesTariffGroupMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', uuid: string, contact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string }, services: Array<{ __typename?: 'ServiceEntity', uuid: string }> }> };

export type UpdateTariffGroupMutationVariables = Exact<{
  updateTariffGroupInput: UpdateTariffGroupInput;
}>;


export type UpdateTariffGroupMutation = { __typename?: 'Mutation', updateTariffGroup: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null } };

export type ArchiveTariffZoneGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveTariffZoneGroupMutation = { __typename?: 'Mutation', archiveTariffZoneGroup: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'TariffZoneGroupArchiveSuccessOutput', tariffZoneGroup: { __typename?: 'TariffZoneGroupEntity', id: string } } };

export type CreateTariffZoneGroupMutationVariables = Exact<{
  tariffZoneGroupCreateInput: TariffZoneGroupCreateInput;
}>;


export type CreateTariffZoneGroupMutation = { __typename?: 'Mutation', createTariffZoneGroup: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'TariffZoneGroupCreateSuccessOutput', tariffZoneGroup: { __typename?: 'TariffZoneGroupEntity', id: string } } };

export type RestoreTariffZoneGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreTariffZoneGroupMutation = { __typename?: 'Mutation', restoreTariffZoneGroup: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'TariffZoneGroupRestoreSuccessOutput', tariffZoneGroup: { __typename?: 'TariffZoneGroupEntity', id: string } } };

export type TariffZoneGroupFragment = { __typename?: 'TariffZoneGroupEntity', id: string, name: string, description?: string | null };

export type TariffZoneGroupsQueryVariables = Exact<{
  findTariffZoneGroupsInput: FindTariffZoneGroupsInput;
}>;


export type TariffZoneGroupsQuery = { __typename?: 'Query', tariffZoneGroups: Array<{ __typename?: 'TariffZoneGroupEntity', id: string, name: string, description?: string | null }> };

export type TariffZoneGroupWithTariffZonesFragment = { __typename?: 'TariffZoneGroupEntity', id: string, name: string, description?: string | null, tariffZones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, tariffZoneLocationType?: TariffZoneLocationType | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', isActive: boolean } | null }> };

export type TariffZonesForGroupQueryVariables = Exact<{
  tariffZoneGroupId: Scalars['String']['input'];
}>;


export type TariffZonesForGroupQuery = { __typename?: 'Query', tariffZoneGroup: { __typename?: 'TariffZoneGroupEntity', id: string, name: string, description?: string | null, tariffZones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, tariffZoneLocationType?: TariffZoneLocationType | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, zipcode?: string | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', isActive: boolean } | null }> } };

export type UpdateTariffZoneGroupMutationVariables = Exact<{
  tariffZoneGroupUpdateInput: TariffZoneGroupUpdateInput;
}>;


export type UpdateTariffZoneGroupMutation = { __typename?: 'Mutation', updateTariffZoneGroup: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'TariffZoneGroupUpdateSuccessOutput', tariffZoneGroup: { __typename?: 'TariffZoneGroupEntity', id: string } } };

export type AccessorialDateRangeConfigByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AccessorialDateRangeConfigByUuidQuery = { __typename?: 'Query', accessorialDateRangeConfigByUuid: { __typename?: 'AccessorialDateRangeConfigEntity', uuid: string, startDate: any, endDate?: any | null, specialChargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, specialMatrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', chargeGroupUuid: string, uuid: string, rate: number, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, mileRangeStart?: number | null, mileRangeEnd?: number | null } }>, accessorialRanges: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> } };

export type AccessorialDateRangeConfigFragment = { __typename?: 'AccessorialDateRangeConfigEntity', uuid: string, startDate: any, endDate?: any | null, percentForSettlement?: number | null, fuelSurchargePercentageRate?: number | null, rate: number, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string } | null, accessorialRanges: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> };

export type AccessorialDateRangeConfigsQueryVariables = Exact<{
  findAccessorialDateRangeConfigsInput: FindAccessorialDateRangeConfigsInput;
}>;


export type AccessorialDateRangeConfigsQuery = { __typename?: 'Query', accessorialDateRangeConfigs: { __typename?: 'FindAccessorialDateRangeConfigsOutput', accessorialDateRangeConfigs: Array<{ __typename?: 'AccessorialDateRangeConfigEntity', uuid: string, startDate: any, endDate?: any | null, percentForSettlement?: number | null, fuelSurchargePercentageRate?: number | null, rate: number, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string } | null, accessorialRanges: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> }> } };

export type CreateAccessorialDateRangeConfigMutationVariables = Exact<{
  createAccessorialDateRangeConfigInput: CreateAccessorialDateRangeConfigInput;
}>;


export type CreateAccessorialDateRangeConfigMutation = { __typename?: 'Mutation', createAccessorialDateRangeConfig: { __typename?: 'CreateAccessorialDateRangeConfigOutput', success: boolean } };

export type DeleteAccessorialDateRangeConfigMutationVariables = Exact<{
  deleteAccessorialDateRangeConfigInput: DeleteAccessorialDateRangeConfigInput;
}>;


export type DeleteAccessorialDateRangeConfigMutation = { __typename?: 'Mutation', deleteAccessorialDateRangeConfig: { __typename?: 'AccessorialDateRangeConfigEntity', uuid: string } };

export type UpdateAccessorialDateRangeConfigMutationVariables = Exact<{
  updateAccessorialDateRangeConfigInput: UpdateAccessorialDateRangeConfigInput;
}>;


export type UpdateAccessorialDateRangeConfigMutation = { __typename?: 'Mutation', updateAccessorialDateRangeConfig: { __typename?: 'UpdateAccessorialDateRangeConfigOutput', success: boolean } };

export type AccessorialNamesByBillingContactQueryVariables = Exact<{
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccessorialNamesByBillingContactQuery = { __typename?: 'Query', accessorialsByBillingContact: Array<{ __typename: 'AttemptsAccessorialEntity', name: string, uuid: string } | { __typename: 'PercentageAccessorialEntity', name: string, uuid: string } | { __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename: 'StorageDaysAccessorialEntity', name: string, uuid: string } | { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string }> };

type AccessorialNames_AttemptsAccessorialEntity_Fragment = { __typename: 'AttemptsAccessorialEntity', name: string, uuid: string };

type AccessorialNames_PercentageAccessorialEntity_Fragment = { __typename: 'PercentageAccessorialEntity', name: string, uuid: string };

type AccessorialNames_SkidBasedAccessorialEntity_Fragment = { __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string };

type AccessorialNames_SpecialAccessorialEntity_Fragment = { __typename: 'SpecialAccessorialEntity', name: string, uuid: string };

type AccessorialNames_StandardAccessorialEntity_Fragment = { __typename: 'StandardAccessorialEntity', name: string, uuid: string };

type AccessorialNames_StorageDaysAccessorialEntity_Fragment = { __typename: 'StorageDaysAccessorialEntity', name: string, uuid: string };

type AccessorialNames_UnitBasedAccessorialEntity_Fragment = { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string };

type AccessorialNames_WaitTimeAccessorialEntity_Fragment = { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string };

type AccessorialNames_WeightBasedAccessorialEntity_Fragment = { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string };

type AccessorialNames_ZoneBasedAccessorialEntity_Fragment = { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string };

export type AccessorialNamesFragment = AccessorialNames_AttemptsAccessorialEntity_Fragment | AccessorialNames_PercentageAccessorialEntity_Fragment | AccessorialNames_SkidBasedAccessorialEntity_Fragment | AccessorialNames_SpecialAccessorialEntity_Fragment | AccessorialNames_StandardAccessorialEntity_Fragment | AccessorialNames_StorageDaysAccessorialEntity_Fragment | AccessorialNames_UnitBasedAccessorialEntity_Fragment | AccessorialNames_WaitTimeAccessorialEntity_Fragment | AccessorialNames_WeightBasedAccessorialEntity_Fragment | AccessorialNames_ZoneBasedAccessorialEntity_Fragment;

export type AccessorialsByBillingContactQueryVariables = Exact<{
  billingPartyContactUuid?: InputMaybe<Scalars['String']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  terminalUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccessorialsByBillingContactQuery = { __typename?: 'Query', accessorialsByBillingContact: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string }> } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, isArchived?: boolean | null, isAuthoCodeRequired: boolean, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string }> }> };

type AccessorialsUuid_AttemptsAccessorialEntity_Fragment = { __typename?: 'AttemptsAccessorialEntity', uuid: string };

type AccessorialsUuid_PercentageAccessorialEntity_Fragment = { __typename?: 'PercentageAccessorialEntity', uuid: string };

type AccessorialsUuid_SkidBasedAccessorialEntity_Fragment = { __typename?: 'SkidBasedAccessorialEntity', uuid: string };

type AccessorialsUuid_SpecialAccessorialEntity_Fragment = { __typename?: 'SpecialAccessorialEntity', uuid: string };

type AccessorialsUuid_StandardAccessorialEntity_Fragment = { __typename?: 'StandardAccessorialEntity', uuid: string };

type AccessorialsUuid_StorageDaysAccessorialEntity_Fragment = { __typename?: 'StorageDaysAccessorialEntity', uuid: string };

type AccessorialsUuid_UnitBasedAccessorialEntity_Fragment = { __typename?: 'UnitBasedAccessorialEntity', uuid: string };

type AccessorialsUuid_WaitTimeAccessorialEntity_Fragment = { __typename?: 'WaitTimeAccessorialEntity', uuid: string };

type AccessorialsUuid_WeightBasedAccessorialEntity_Fragment = { __typename?: 'WeightBasedAccessorialEntity', uuid: string };

type AccessorialsUuid_ZoneBasedAccessorialEntity_Fragment = { __typename?: 'ZoneBasedAccessorialEntity', uuid: string };

export type AccessorialsUuidFragment = AccessorialsUuid_AttemptsAccessorialEntity_Fragment | AccessorialsUuid_PercentageAccessorialEntity_Fragment | AccessorialsUuid_SkidBasedAccessorialEntity_Fragment | AccessorialsUuid_SpecialAccessorialEntity_Fragment | AccessorialsUuid_StandardAccessorialEntity_Fragment | AccessorialsUuid_StorageDaysAccessorialEntity_Fragment | AccessorialsUuid_UnitBasedAccessorialEntity_Fragment | AccessorialsUuid_WaitTimeAccessorialEntity_Fragment | AccessorialsUuid_WeightBasedAccessorialEntity_Fragment | AccessorialsUuid_ZoneBasedAccessorialEntity_Fragment;

export type CreateAccessorialMutationVariables = Exact<{
  input: CreateAccessorialInput;
}>;


export type CreateAccessorialMutation = { __typename?: 'Mutation', createAccessorial: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } };

export type RemoveAccessorialMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type RemoveAccessorialMutation = { __typename?: 'Mutation', removeAccessorial: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } };

export type AccessorialFuelProfileFragment = { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> };

export type AccessorialTerminalFragment = { __typename?: 'TerminalEntity', uuid: string, name: string, code: string };

type AccessorialUnionUuidOnly_AttemptsAccessorialEntity_Fragment = { __typename?: 'AttemptsAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_PercentageAccessorialEntity_Fragment = { __typename?: 'PercentageAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_SkidBasedAccessorialEntity_Fragment = { __typename?: 'SkidBasedAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_SpecialAccessorialEntity_Fragment = { __typename?: 'SpecialAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_StandardAccessorialEntity_Fragment = { __typename?: 'StandardAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_StorageDaysAccessorialEntity_Fragment = { __typename?: 'StorageDaysAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_UnitBasedAccessorialEntity_Fragment = { __typename?: 'UnitBasedAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_WaitTimeAccessorialEntity_Fragment = { __typename?: 'WaitTimeAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_WeightBasedAccessorialEntity_Fragment = { __typename?: 'WeightBasedAccessorialEntity', uuid: string };

type AccessorialUnionUuidOnly_ZoneBasedAccessorialEntity_Fragment = { __typename?: 'ZoneBasedAccessorialEntity', uuid: string };

export type AccessorialUnionUuidOnlyFragment = AccessorialUnionUuidOnly_AttemptsAccessorialEntity_Fragment | AccessorialUnionUuidOnly_PercentageAccessorialEntity_Fragment | AccessorialUnionUuidOnly_SkidBasedAccessorialEntity_Fragment | AccessorialUnionUuidOnly_SpecialAccessorialEntity_Fragment | AccessorialUnionUuidOnly_StandardAccessorialEntity_Fragment | AccessorialUnionUuidOnly_StorageDaysAccessorialEntity_Fragment | AccessorialUnionUuidOnly_UnitBasedAccessorialEntity_Fragment | AccessorialUnionUuidOnly_WaitTimeAccessorialEntity_Fragment | AccessorialUnionUuidOnly_WeightBasedAccessorialEntity_Fragment | AccessorialUnionUuidOnly_ZoneBasedAccessorialEntity_Fragment;

export type AccessorialQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
  specialWindowsDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type AccessorialQuery = { __typename?: 'Query', accessorial: { __typename: 'AttemptsAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'PercentageAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, percentageBasis?: AccessorialPercentageBasis | null, minimumCharge?: number | null, maximumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StorageDaysAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, maximumCharge?: number | null, minimumCharge?: number | null, storageDaysFreeDays?: number | null, storageDaysExcludeWeekends?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } };

type AllAccessorialFields_AttemptsAccessorialEntity_Fragment = { __typename: 'AttemptsAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_PercentageAccessorialEntity_Fragment = { __typename: 'PercentageAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, percentageBasis?: AccessorialPercentageBasis | null, minimumCharge?: number | null, maximumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_SkidBasedAccessorialEntity_Fragment = { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_SpecialAccessorialEntity_Fragment = { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_StandardAccessorialEntity_Fragment = { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_StorageDaysAccessorialEntity_Fragment = { __typename: 'StorageDaysAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, maximumCharge?: number | null, minimumCharge?: number | null, storageDaysFreeDays?: number | null, storageDaysExcludeWeekends?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_UnitBasedAccessorialEntity_Fragment = { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_WaitTimeAccessorialEntity_Fragment = { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

type AllAccessorialFields_WeightBasedAccessorialEntity_Fragment = { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null };

type AllAccessorialFields_ZoneBasedAccessorialEntity_Fragment = { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null };

export type AllAccessorialFieldsFragment = AllAccessorialFields_AttemptsAccessorialEntity_Fragment | AllAccessorialFields_PercentageAccessorialEntity_Fragment | AllAccessorialFields_SkidBasedAccessorialEntity_Fragment | AllAccessorialFields_SpecialAccessorialEntity_Fragment | AllAccessorialFields_StandardAccessorialEntity_Fragment | AllAccessorialFields_StorageDaysAccessorialEntity_Fragment | AllAccessorialFields_UnitBasedAccessorialEntity_Fragment | AllAccessorialFields_WaitTimeAccessorialEntity_Fragment | AllAccessorialFields_WeightBasedAccessorialEntity_Fragment | AllAccessorialFields_ZoneBasedAccessorialEntity_Fragment;

export type DefaultGlobalSpecialAccessorialsQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultGlobalSpecialAccessorialsQuery = { __typename?: 'Query', defaultGlobalSpecialAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity' } | { __typename?: 'PercentageAccessorialEntity' } | { __typename?: 'SkidBasedAccessorialEntity' } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity' } | { __typename?: 'StorageDaysAccessorialEntity' } | { __typename?: 'UnitBasedAccessorialEntity' } | { __typename?: 'WaitTimeAccessorialEntity' } | { __typename?: 'WeightBasedAccessorialEntity' } | { __typename?: 'ZoneBasedAccessorialEntity' }> };

export type AccessorialNamesQueryVariables = Exact<{
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccessorialNamesQuery = { __typename?: 'Query', accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', name: string, uuid: string } | { __typename: 'PercentageAccessorialEntity', name: string, uuid: string } | { __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename: 'StorageDaysAccessorialEntity', name: string, uuid: string } | { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string }> };

type AccessorialsTableRow_AttemptsAccessorialEntity_Fragment = { __typename: 'AttemptsAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_PercentageAccessorialEntity_Fragment = { __typename: 'PercentageAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_SkidBasedAccessorialEntity_Fragment = { __typename: 'SkidBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerSkid: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_SpecialAccessorialEntity_Fragment = { __typename: 'SpecialAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_StandardAccessorialEntity_Fragment = { __typename: 'StandardAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_StorageDaysAccessorialEntity_Fragment = { __typename: 'StorageDaysAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_UnitBasedAccessorialEntity_Fragment = { __typename: 'UnitBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerUnit: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_WaitTimeAccessorialEntity_Fragment = { __typename: 'WaitTimeAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, waitTimeChargePeriod?: number | null, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_WeightBasedAccessorialEntity_Fragment = { __typename: 'WeightBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerHundredWeight: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

type AccessorialsTableRow_ZoneBasedAccessorialEntity_Fragment = { __typename: 'ZoneBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null };

export type AccessorialsTableRowFragment = AccessorialsTableRow_AttemptsAccessorialEntity_Fragment | AccessorialsTableRow_PercentageAccessorialEntity_Fragment | AccessorialsTableRow_SkidBasedAccessorialEntity_Fragment | AccessorialsTableRow_SpecialAccessorialEntity_Fragment | AccessorialsTableRow_StandardAccessorialEntity_Fragment | AccessorialsTableRow_StorageDaysAccessorialEntity_Fragment | AccessorialsTableRow_UnitBasedAccessorialEntity_Fragment | AccessorialsTableRow_WaitTimeAccessorialEntity_Fragment | AccessorialsTableRow_WeightBasedAccessorialEntity_Fragment | AccessorialsTableRow_ZoneBasedAccessorialEntity_Fragment;

export type AccessorialsTableQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AccessorialsTableQuery = { __typename?: 'Query', accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerSkid: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'StandardAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerUnit: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, waitTimeChargePeriod?: number | null, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerHundredWeight: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null }> };

export type AccessorialsQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  onlyShowCompanyAccessorials?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  specialWindowsDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type AccessorialsQuery = { __typename?: 'Query', accessorials: Array<{ __typename: 'AttemptsAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'PercentageAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, percentageBasis?: AccessorialPercentageBasis | null, minimumCharge?: number | null, maximumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StorageDaysAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, maximumCharge?: number | null, minimumCharge?: number | null, storageDaysFreeDays?: number | null, storageDaysExcludeWeekends?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null }> };

export type RemoveSpecialAccessorialMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type RemoveSpecialAccessorialMutation = { __typename?: 'Mutation', removeSpecialAccessorial: { __typename?: 'AttemptsAccessorialEntity' } | { __typename?: 'PercentageAccessorialEntity' } | { __typename?: 'SkidBasedAccessorialEntity' } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity' } | { __typename?: 'StorageDaysAccessorialEntity' } | { __typename?: 'UnitBasedAccessorialEntity' } | { __typename?: 'WaitTimeAccessorialEntity' } | { __typename?: 'WeightBasedAccessorialEntity' } | { __typename?: 'ZoneBasedAccessorialEntity' } };

export type RemoveZoneBasedAccessorialMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type RemoveZoneBasedAccessorialMutation = { __typename?: 'Mutation', removeZoneBasedAccessorial: { __typename?: 'AttemptsAccessorialEntity' } | { __typename?: 'PercentageAccessorialEntity' } | { __typename?: 'SkidBasedAccessorialEntity' } | { __typename?: 'SpecialAccessorialEntity' } | { __typename?: 'StandardAccessorialEntity' } | { __typename?: 'StorageDaysAccessorialEntity' } | { __typename?: 'UnitBasedAccessorialEntity' } | { __typename?: 'WaitTimeAccessorialEntity' } | { __typename?: 'WeightBasedAccessorialEntity' } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } };

export type UpdateAccessorialMutationVariables = Exact<{
  input: UpdateAccessorialInput;
}>;


export type UpdateAccessorialMutation = { __typename?: 'Mutation', updateAccessorial: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } };

export type UpdateQuickAddAccessorialsMutationVariables = Exact<{
  input: UpdateQuickAddAccessorialsInput;
}>;


export type UpdateQuickAddAccessorialsMutation = { __typename?: 'Mutation', updateQuickAddAccessorials: { __typename?: 'UpdateQuickAddAccessorialsOutput', quickAddAccessorials: Array<{ __typename: 'AttemptsAccessorialEntity', name: string, uuid: string } | { __typename: 'PercentageAccessorialEntity', name: string, uuid: string } | { __typename: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename: 'StorageDaysAccessorialEntity', name: string, uuid: string } | { __typename: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename: 'ZoneBasedAccessorialEntity', name: string, uuid: string }> } };

export type ArchiveRecoveryTerminalMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ArchiveRecoveryTerminalMutation = { __typename?: 'Mutation', archiveAirportInfo: { __typename?: 'AirportInfoUpdateOutput', airportInfo: { __typename?: 'AirportInfoEntity', uuid: string, isArchived: boolean } } };

export type SenderIsVerifiedQueryVariables = Exact<{ [key: string]: never; }>;


export type SenderIsVerifiedQuery = { __typename?: 'Query', senderIsVerified?: string | null };

export type CreateCreditTypeMutationVariables = Exact<{
  creditTypeCreateInput: CreditTypeCreateInput;
}>;


export type CreateCreditTypeMutation = { __typename?: 'Mutation', createCreditType: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, systemKey?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } };

export type CreditTypeFragment = { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, systemKey?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null };

export type CreditTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditTypesQuery = { __typename?: 'Query', creditTypes: Array<{ __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, systemKey?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null }> };

export type RemoveCreditTypeMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveCreditTypeMutation = { __typename?: 'Mutation', removeCreditType: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, systemKey?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } };

export type UpdateCreditTypeMutationVariables = Exact<{
  creditTypeUpdateInput: CreditTypeUpdateInput;
}>;


export type UpdateCreditTypeMutation = { __typename?: 'Mutation', updateCreditType: { __typename?: 'CreditTypeEntity', uuid: string, name: string, color?: string | null, systemKey?: string | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string, id: string } | null } };

export type CreateGeneralLedgerCodeMutationVariables = Exact<{
  input: GeneralLedgerCodeCreateInput;
}>;


export type CreateGeneralLedgerCodeMutation = { __typename?: 'Mutation', createGeneralLedgerCode: { __typename: 'CreateGeneralLedgerCodeSuccessOutput', generalLedgerCode: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type DeleteGeneralLedgerCodeMutationVariables = Exact<{
  input: GeneralLedgerCodeDeleteInput;
}>;


export type DeleteGeneralLedgerCodeMutation = { __typename?: 'Mutation', deleteGeneralLedgerCode: { __typename: 'DeleteGeneralLedgerCodeSuccessOutput', id: string } | { __typename: 'MutationErrorOutput', message: string } };

export type GeneralLedgerCodeFragment = { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string, description: string, accessorials: Array<{ __typename?: 'AttemptsAccessorialEntity' } | { __typename?: 'PercentageAccessorialEntity', name: string, uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename?: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename?: 'StorageDaysAccessorialEntity' } | { __typename?: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string, uuid: string }>, creditTypes: Array<{ __typename?: 'CreditTypeEntity', name: string, uuid: string }> };

export type GeneralLedgerCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GeneralLedgerCodesQuery = { __typename?: 'Query', generalLedgerCodes: Array<{ __typename?: 'GeneralLedgerCodeEntity', id: string, code: string, description: string }> };

export type GeneralLedgerConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GeneralLedgerConfigurationQuery = { __typename?: 'Query', generalLedgerConfiguration?: { __typename?: 'GeneralLedgerConfigurationEntity', id: string, deliveryChargeCodeId?: string | null, pickupChargeCodeId?: string | null, recoveryChargeCodeId?: string | null, transferChargeCodeId?: string | null, orderChargeCodeId?: string | null, lineHaulChargeCodeId?: string | null, fuelChargeCodeId?: string | null, accessorialFallbackCodeId?: string | null, generalLedgerCodes: Array<{ __typename?: 'GeneralLedgerCodeEntity', id: string, code: string, description: string, accessorials: Array<{ __typename?: 'AttemptsAccessorialEntity' } | { __typename?: 'PercentageAccessorialEntity', name: string, uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'SpecialAccessorialEntity', name: string, uuid: string } | { __typename?: 'StandardAccessorialEntity', name: string, uuid: string } | { __typename?: 'StorageDaysAccessorialEntity' } | { __typename?: 'UnitBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string, uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string, uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string, uuid: string }>, creditTypes: Array<{ __typename?: 'CreditTypeEntity', name: string, uuid: string }> }> } | null };

export type UpdateGeneralLedgerCodeMutationVariables = Exact<{
  input: GeneralLedgerCodeUpdateInput;
}>;


export type UpdateGeneralLedgerCodeMutation = { __typename?: 'Mutation', updateGeneralLedgerCode: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateGeneralLedgerCodeSuccessOutput', generalLedgerCode: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } } };

export type UpdateGeneralLedgerConfigurationMutationVariables = Exact<{
  input: GeneralLedgerConfigurationUpdateInput;
}>;


export type UpdateGeneralLedgerConfigurationMutation = { __typename?: 'Mutation', updateGeneralLedgerConfiguration: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateGeneralLedgerConfigurationSuccessOutput', generalLedgerConfiguration: { __typename?: 'GeneralLedgerConfigurationEntity', id: string } } };

export type CreateInvoiceNoteRuleMutationVariables = Exact<{
  invoiceNoteRuleInput: InvoiceNoteRuleInput;
}>;


export type CreateInvoiceNoteRuleMutation = { __typename?: 'Mutation', createInvoiceNoteRule: { __typename?: 'InvoiceNoteRuleEntity', uuid: string, contactUuid?: string | null, contactDisplayName?: string | null, serviceUuid?: string | null, serviceName?: string | null, terminalUuid?: string | null, terminalName?: string | null, rebilled?: boolean | null, note: string, includeCompanyNote: boolean } };

export type DeleteInvoiceNoteRuleMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteInvoiceNoteRuleMutation = { __typename?: 'Mutation', deleteInvoiceNoteRule: { __typename?: 'InvoiceNoteRuleEntity', uuid: string } };

export type InvoiceNoteRuleFragment = { __typename?: 'InvoiceNoteRuleEntity', uuid: string, contactUuid?: string | null, contactDisplayName?: string | null, serviceUuid?: string | null, serviceName?: string | null, terminalUuid?: string | null, terminalName?: string | null, rebilled?: boolean | null, note: string, includeCompanyNote: boolean };

export type InvoiceNoteRulesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvoiceNoteRulesQuery = { __typename?: 'Query', invoiceNoteRules: { __typename?: 'InvoiceNoteRuleConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'InvoiceNoteRuleEdge', node: { __typename?: 'InvoiceNoteRuleEntity', uuid: string, contactUuid?: string | null, contactDisplayName?: string | null, serviceUuid?: string | null, serviceName?: string | null, terminalUuid?: string | null, terminalName?: string | null, rebilled?: boolean | null, note: string, includeCompanyNote: boolean } }> } };

export type UpdateInvoiceNoteRuleMutationVariables = Exact<{
  updateInvoiceNoteRuleInput: UpdateInvoiceNoteRuleInput;
}>;


export type UpdateInvoiceNoteRuleMutation = { __typename?: 'Mutation', updateInvoiceNoteRule: { __typename?: 'InvoiceNoteRuleEntity', uuid: string, contactUuid?: string | null, contactDisplayName?: string | null, serviceUuid?: string | null, serviceName?: string | null, terminalUuid?: string | null, terminalName?: string | null, rebilled?: boolean | null, note: string, includeCompanyNote: boolean } };

export type CreateMasterAccountMutationVariables = Exact<{
  createMasterAccountInput: CreateMasterAccountInput;
}>;


export type CreateMasterAccountMutation = { __typename?: 'Mutation', createMasterAccount: { __typename?: 'CreateMasterAccountOutput', success: boolean } };

export type MasterAccountFragment = { __typename?: 'MasterAccountEntity', uuid: string, name: string };

export type MasterAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type MasterAccountsQuery = { __typename?: 'Query', masterAccounts: { __typename?: 'FindMasterAccountsOutput', masterAccounts: Array<{ __typename?: 'MasterAccountEntity', uuid: string, name: string }> } };

export type RemoveMasterAccountMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveMasterAccountMutation = { __typename?: 'Mutation', removeMasterAccount: { __typename?: 'MasterAccountEntity', uuid: string } };

export type UpdateMasterAccountMutationVariables = Exact<{
  updateMasterAccountInput: UpdateMasterAccountInput;
}>;


export type UpdateMasterAccountMutation = { __typename?: 'Mutation', updateMasterAccount: { __typename?: 'UpdateMasterAccountOutput', success: boolean } };

export type CreateSettlementDeductionTypeMutationVariables = Exact<{
  settlementDeductionTypeCreateInput: SettlementDeductionTypeCreateInput;
}>;


export type CreateSettlementDeductionTypeMutation = { __typename?: 'Mutation', createSettlementDeductionType: { __typename?: 'SettlementDeductionTypeEntity', uuid: string, name: string, percentageRate?: number | null, flatRate?: number | null } };

export type RemoveSettlementDeductionTypeMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveSettlementDeductionTypeMutation = { __typename?: 'Mutation', removeSettlementDeductionType: { __typename?: 'SettlementDeductionTypeEntity', uuid: string, name: string, percentageRate?: number | null, flatRate?: number | null } };

export type SettlementDeductionTypeFragment = { __typename?: 'SettlementDeductionTypeEntity', uuid: string, name: string, percentageRate?: number | null, flatRate?: number | null };

export type SettlementDeductionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SettlementDeductionTypesQuery = { __typename?: 'Query', settlementDeductionTypes: Array<{ __typename?: 'SettlementDeductionTypeEntity', uuid: string, name: string, percentageRate?: number | null, flatRate?: number | null }> };

export type UpdateSettlementDeductionTypeMutationVariables = Exact<{
  settlementDeductionTypeUpdateInput: SettlementDeductionTypeUpdateInput;
}>;


export type UpdateSettlementDeductionTypeMutation = { __typename?: 'Mutation', updateSettlementDeductionType: { __typename?: 'SettlementDeductionTypeEntity', uuid: string, name: string, percentageRate?: number | null, flatRate?: number | null } };

export type BulkUploadRouteNamesMutationVariables = Exact<{
  bulkCsvRouteNameInput: BulkCsvRouteNameInput;
}>;


export type BulkUploadRouteNamesMutation = { __typename?: 'Mutation', bulkUploadRouteNames: Array<{ __typename?: 'RouteNameEntity', uuid: string }> };

export type FindBusinessDivisionsFragment = { __typename?: 'BusinessDivisionEntity', uuid: string, name: string };

export type BusinessDivisionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessDivisionsQuery = { __typename?: 'Query', businessDivisions: { __typename?: 'FindBusinessDivisionsOutput', businessDivisions: Array<{ __typename?: 'BusinessDivisionEntity', uuid: string, name: string }> } };

export type CreateBusinessDivisionMutationVariables = Exact<{
  createBusinessDivisionInput: CreateBusinessDivisionInput;
}>;


export type CreateBusinessDivisionMutation = { __typename?: 'Mutation', createBusinessDivision: { __typename?: 'CreateBusinessDivisionOutput', success: boolean } };

export type RemoveBusinessDivisionMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveBusinessDivisionMutation = { __typename?: 'Mutation', removeBusinessDivision: { __typename?: 'BusinessDivisionEntity', uuid: string } };

export type UpdateBusinessDivisionMutationVariables = Exact<{
  updateBusinessDivisionInput: UpdateBusinessDivisionInput;
}>;


export type UpdateBusinessDivisionMutation = { __typename?: 'Mutation', updateBusinessDivision: { __typename?: 'UpdateBusinessDivisionOutput', success: boolean } };

export type CompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyQuery = { __typename?: 'Query', company: { __typename?: 'CompanyEntity', uuid: string } };

export type CreateCustomDriverFormMutationVariables = Exact<{
  createDriverSignableFormTemplateInput: CreateDriverSignableFormTemplateInput;
}>;


export type CreateCustomDriverFormMutation = { __typename?: 'Mutation', createDriverSignableFormTemplate: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string } };

export type CreateEquipmentMutationVariables = Exact<{
  input: CreateEquipmentInput;
}>;


export type CreateEquipmentMutation = { __typename?: 'Mutation', createEquipment: { __typename?: 'EquipmentEntity', uuid: string, name: string } };

export type CreateFuelProfileMutationVariables = Exact<{
  input: CreateFuelProfileInput;
}>;


export type CreateFuelProfileMutation = { __typename?: 'Mutation', createFuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string } | null };

export type CreateServiceMutationVariables = Exact<{
  input: CreateServiceInput;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', createService: { __typename?: 'ServiceEntity', uuid: string, name: string } };

export type CustomDriverSignableFormQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CustomDriverSignableFormQuery = { __typename?: 'Query', customDriverForm?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string, createdAt: any } | null };

export type CustomDriverSignableFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomDriverSignableFormsQuery = { __typename?: 'Query', customDriverForms?: Array<{ __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string, createdAt: any }> | null };

export type DeleteCustomDriverFormMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteCustomDriverFormMutation = { __typename?: 'Mutation', deleteDriverSignableFormTemplate: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string } };

export type DeleteEquipmentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteEquipmentMutation = { __typename?: 'Mutation', deleteEquipment: { __typename?: 'EquipmentEntity', uuid: string } };

export type DeleteRouteNameLocationMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteRouteNameLocationMutation = { __typename?: 'Mutation', deleteRouteNameLocation: { __typename?: 'RouteNameLocationEntity', uuid: string } };

export type DriverSignableFormFragment = { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string, createdAt: any };

export type DriversTableQueryVariables = Exact<{ [key: string]: never; }>;


export type DriversTableQuery = { __typename?: 'Query', drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, driverPayType?: DriverPayType | null, driverReferenceNumber?: string | null, active: boolean, complianceStatus?: DriverComplianceStatus | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }> };

export type ArchiveDriverMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ArchiveDriverMutation = { __typename?: 'Mutation', archiveDriver: { __typename?: 'UpdateDriverOutput', driver: { __typename?: 'DriverEntity', uuid: string, active: boolean } } };

export type ClearDriverSettlementPayBoundMutationVariables = Exact<{
  input: ClearDriverSettlementPayBoundInput;
}>;


export type ClearDriverSettlementPayBoundMutation = { __typename?: 'Mutation', clearDriverSettlementPayBound: Array<{ __typename?: 'DriverSettlementPayBoundEntity', payType: DriverPayType, minPayUsdCents?: number | null, maxPayUsdCents?: number | null }> };

export type CreateDriverCredentialTypeMutationVariables = Exact<{
  input: CreateDriverCredentialTypeInput;
}>;


export type CreateDriverCredentialTypeMutation = { __typename?: 'Mutation', createDriverCredentialType: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } };

export type CreateDriverInsurancePolicyMutationVariables = Exact<{
  input: CreateDriverInsurancePolicyInput;
}>;


export type CreateDriverInsurancePolicyMutation = { __typename?: 'Mutation', createDriverInsurancePolicy: { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> } };

export type CreateDriverTrainingRecordMutationVariables = Exact<{
  input: CreateDriverTrainingRecordInput;
}>;


export type CreateDriverTrainingRecordMutation = { __typename?: 'Mutation', createDriverTrainingRecord: { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> } };

export type CreateDriverMutationVariables = Exact<{
  input: CreateDriverInput;
}>;


export type CreateDriverMutation = { __typename?: 'Mutation', createDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null };

export type DeleteDriverCredentialTypeMutationVariables = Exact<{
  input: DeleteDriverCredentialTypeInput;
}>;


export type DeleteDriverCredentialTypeMutation = { __typename?: 'Mutation', deleteDriverCredentialType: boolean };

export type DeleteDriverInsurancePolicyMutationVariables = Exact<{
  input: DriverComplianceItemInput;
}>;


export type DeleteDriverInsurancePolicyMutation = { __typename?: 'Mutation', deleteDriverInsurancePolicy: { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> } };

export type DeleteDriverTrainingRecordMutationVariables = Exact<{
  input: DriverComplianceItemInput;
}>;


export type DeleteDriverTrainingRecordMutation = { __typename?: 'Mutation', deleteDriverTrainingRecord: { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> } };

export type DriverComplianceFragment = { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> };

export type DriverComplianceQueryVariables = Exact<{
  input: DriverComplianceDriverInput;
}>;


export type DriverComplianceQuery = { __typename?: 'Query', driverCompliance: { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> } };

export type DriverCredentialTypeFragment = { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean };

export type DriverCredentialTypesQueryVariables = Exact<{
  input?: InputMaybe<GetDriverCredentialTypesInput>;
}>;


export type DriverCredentialTypesQuery = { __typename?: 'Query', driverCredentialTypes: Array<{ __typename?: 'DriverCredentialTypeEntity', inUse: boolean, uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean }> };

export type DriverCredentialFragment = { __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } };

export type DriverInsurancePolicyFragment = { __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } };

export type DriverPhoneNumberAvailabilityQueryVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type DriverPhoneNumberAvailabilityQuery = { __typename?: 'Query', driverPhoneNumberAvailability: { __typename?: 'DriverPhoneNumberAvailabilityOutput', available: boolean, sameCompanyDriverName?: string | null, sameCompanyDriverUuid?: string | null } };

export type DriverQualificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DriverQualificationsQuery = { __typename?: 'Query', driverQualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string, name: string }> };

export type DriverSettlementPayBoundFragment = { __typename?: 'DriverSettlementPayBoundEntity', payType: DriverPayType, minPayUsdCents?: number | null, maxPayUsdCents?: number | null };

export type DriverSettlementPayBoundsQueryVariables = Exact<{
  input: GetDriverSettlementPayBoundsInput;
}>;


export type DriverSettlementPayBoundsQuery = { __typename?: 'Query', driverSettlementPayBounds: Array<{ __typename?: 'DriverSettlementPayBoundEntity', payType: DriverPayType, minPayUsdCents?: number | null, maxPayUsdCents?: number | null }> };

export type DriverQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DriverQuery = { __typename?: 'Query', driver: { __typename?: 'DriverEntity', uuid: string, active: boolean, driverPayType?: DriverPayType | null, driverType?: DriverType | null, driverReferenceNumber?: string | null, emailAddress?: string | null, password?: string | null, firstName: string, flatRate?: number | null, fuelCardNumber: string, hourlyRate?: number | null, lastName: string, notes: string, perMileRate?: number | null, percentGrossRevenueRate?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, phoneNumber: string, sendRouteUpdateEmails: boolean, defaultOrdinaryTariffChainId?: string | null, defaultTransferTariffChainId?: string | null, defaultRecoveryTariffChainId?: string | null, defaultLineHaulTariffChainId?: string | null, defaultPointToPointTariffChainId?: string | null, address?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, country: string, name: string, state: string, zip: string, longitude?: number | null, latitude?: number | null } | null, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string, name: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string, name: string }> } };

export type RehireDriverMutationVariables = Exact<{
  input: RehireDriverInput;
}>;


export type RehireDriverMutation = { __typename?: 'Mutation', rehireDriver: { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> } };

export type RestoreDriverMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RestoreDriverMutation = { __typename?: 'Mutation', restoreDriver: { __typename?: 'UpdateDriverOutput', driver: { __typename?: 'DriverEntity', uuid: string, active: boolean } } };

export type SetDriverComplianceDatesMutationVariables = Exact<{
  input: SetDriverComplianceDatesInput;
}>;


export type SetDriverComplianceDatesMutation = { __typename?: 'Mutation', setDriverComplianceDates: { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> } };

export type SetDriverSettlementPayBoundsMutationVariables = Exact<{
  input: SetDriverSettlementPayBoundsInput;
}>;


export type SetDriverSettlementPayBoundsMutation = { __typename?: 'Mutation', setDriverSettlementPayBounds: Array<{ __typename?: 'DriverSettlementPayBoundEntity', payType: DriverPayType, minPayUsdCents?: number | null, maxPayUsdCents?: number | null }> };

export type TerminateDriverMutationVariables = Exact<{
  input: TerminateDriverInput;
}>;


export type TerminateDriverMutation = { __typename?: 'Mutation', terminateDriver: { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> } };

export type UpdateDriverComplianceExpiringSoonDaysMutationVariables = Exact<{
  input: UpdateCompanyConfigurationInput;
}>;


export type UpdateDriverComplianceExpiringSoonDaysMutation = { __typename?: 'Mutation', updateCompanyConfiguration: { __typename?: 'CompanyConfigurationEntity', uuid: string, driverComplianceExpiringSoonDays: number } };

export type UpdateDriverComplianceProfileMutationVariables = Exact<{
  input: UpdateDriverComplianceProfileInput;
}>;


export type UpdateDriverComplianceProfileMutation = { __typename?: 'Mutation', updateDriverComplianceProfile: { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> } };

export type UpdateDriverCredentialTypeMutationVariables = Exact<{
  input: UpdateDriverCredentialTypeInput;
}>;


export type UpdateDriverCredentialTypeMutation = { __typename?: 'Mutation', updateDriverCredentialType: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } };

export type UpdateDriverInsurancePolicyMutationVariables = Exact<{
  input: UpdateDriverInsurancePolicyInput;
}>;


export type UpdateDriverInsurancePolicyMutation = { __typename?: 'Mutation', updateDriverInsurancePolicy: { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> } };

export type UpdateDriverQualificationsMutationVariables = Exact<{
  input: UpdateDriverQualificationsInput;
}>;


export type UpdateDriverQualificationsMutation = { __typename?: 'Mutation', updateDriverQualifications: { __typename?: 'UpdateDriverQualificationsOutput', driverQualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string, name: string }> } };

export type UpdateDriverTrainingRecordMutationVariables = Exact<{
  input: UpdateDriverTrainingRecordInput;
}>;


export type UpdateDriverTrainingRecordMutation = { __typename?: 'Mutation', updateDriverTrainingRecord: { __typename?: 'DriverComplianceEntity', driverUuid: string, profile: { __typename?: 'DriverComplianceProfileEntity', licenseNumber?: string | null, licenseClass?: string | null, licenseState?: string | null, securityId?: string | null, isTerminated: boolean, terminationComments?: string | null, dateOfBirth?: { __typename?: 'PlainDate', iso8601: string } | null, hireDate?: { __typename?: 'PlainDate', iso8601: string } | null, terminationDate?: { __typename?: 'PlainDate', iso8601: string } | null }, credentials: Array<{ __typename?: 'DriverCredentialEntity', uuid: string, referenceNumber?: string | null, notes?: string | null, status: DriverComplianceStatus, completedOn?: { __typename?: 'PlainDate', iso8601: string } | null, expiresOn?: { __typename?: 'PlainDate', iso8601: string } | null, type: { __typename?: 'DriverCredentialTypeEntity', uuid: string, name: string, kind: DriverCredentialKind, systemKey?: DriverCredentialSystemKey | null, active: boolean } }>, insurancePolicies: Array<{ __typename?: 'DriverInsurancePolicyEntity', uuid: string, insuranceType: string, carrierName?: string | null, policyNumber?: string | null, insuredAmountUsd?: number | null, status: DriverComplianceStatus, effectiveOn: { __typename?: 'PlainDate', iso8601: string }, expiresOn: { __typename?: 'PlainDate', iso8601: string } }> } };

export type VehicleTypeQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type VehicleTypeQuery = { __typename?: 'Query', vehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } };

export type FlipIsArchivedMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type FlipIsArchivedMutation = { __typename?: 'Mutation', flipIsArchived: { __typename?: 'AttemptsAccessorialEntity' } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity' } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } };

export type CreateFuelProfileDateRangeMutationVariables = Exact<{
  createFuelProfileDateRangeInput: CreateFuelProfileDateRangeInput;
}>;


export type CreateFuelProfileDateRangeMutation = { __typename?: 'Mutation', createFuelProfileDateRange: { __typename?: 'CreateFuelProfileDateRangeOutput', success: boolean, error?: string | null } };

export type DeleteFuelProfileDateRangeMutationVariables = Exact<{
  deleteFuelProfileDateRangeInput: DeleteFuelProfileDateRangeInput;
}>;


export type DeleteFuelProfileDateRangeMutation = { __typename?: 'Mutation', deleteFuelProfileDateRange: { __typename?: 'DeleteFuelProfileDateRangeOutput', success: boolean } };

export type FindFuelProfileFragment = { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, billingType: FuelBillingMethod, type: FuelProfileType, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> };

export type FuelProfileDateRangeFragment = { __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null };

export type FuelProfileFragment = { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> };

export type FuelProfileQueryVariables = Exact<{
  findFuelProfileInput: FindFuelProfileInput;
}>;


export type FuelProfileQuery = { __typename?: 'Query', fuelProfile: { __typename?: 'FindFuelProfileOutput', fuelProfile: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, billingType: FuelBillingMethod, type: FuelProfileType, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } } };

export type FuelProfilesQueryVariables = Exact<{
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  excludeContactUuid?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FuelProfileType>;
}>;


export type FuelProfilesQuery = { __typename?: 'Query', fuelProfiles: Array<{ __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> }> };

export type RemoveFuelProfileMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveFuelProfileMutation = { __typename?: 'Mutation', removeFuelProfile: { __typename?: 'FuelProfileEntity', uuid: string } };

export type UpdateFuelProfileDateRangeMutationVariables = Exact<{
  updateFuelProfileDateRangeInput: UpdateFuelProfileDateRangeInput;
}>;


export type UpdateFuelProfileDateRangeMutation = { __typename?: 'Mutation', updateFuelProfileDateRange: { __typename?: 'UpdateFuelProfileDateRangeOutput', success: boolean, error?: string | null } };

export type UpdateFuelProfileMutationVariables = Exact<{
  input: UpdateFuelProfileInput;
}>;


export type UpdateFuelProfileMutation = { __typename?: 'Mutation', updateFuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string } | null };

export type CreateHoldReasonMutationVariables = Exact<{
  holdReasonCreateInput: HoldReasonCreateInput;
}>;


export type CreateHoldReasonMutation = { __typename?: 'Mutation', createHoldReason: { __typename?: 'HoldReasonEntity', uuid: string, name: string, isArchived?: boolean | null } };

export type HoldReasonFragment = { __typename?: 'HoldReasonEntity', uuid: string, name: string, isArchived?: boolean | null };

export type HoldReasonsQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HoldReasonsQuery = { __typename?: 'Query', holdReasons: Array<{ __typename?: 'HoldReasonEntity', uuid: string, name: string, isArchived?: boolean | null }> };

export type UpdateHoldReasonMutationVariables = Exact<{
  holdReasonUpdateInput: HoldReasonUpdateInput;
}>;


export type UpdateHoldReasonMutation = { __typename?: 'Mutation', updateHoldReason: { __typename?: 'HoldReasonEntity', uuid: string, name: string, isArchived?: boolean | null } };

export type CreateLineHaulLaneMutationVariables = Exact<{
  createLineHaulLaneInput: CreateLineHaulLaneInput;
}>;


export type CreateLineHaulLaneMutation = { __typename?: 'Mutation', createLineHaulLane: { __typename?: 'CreateLineHaulLaneOutput', errorMessage?: string | null, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string } | null } };

export type LineHaulLaneFragment = { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, destinationTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, segments: Array<{ __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> };

export type LineHaulLaneQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type LineHaulLaneQuery = { __typename?: 'Query', lineHaulLane: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, destinationTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, segments: Array<{ __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } };

export type LineHaulLanesForTerminalsQueryVariables = Exact<{ [key: string]: never; }>;


export type LineHaulLanesForTerminalsQuery = { __typename?: 'Query', lineHaulLanesForTerminals: Array<{ __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> };

export type LineHaulLanesQueryVariables = Exact<{ [key: string]: never; }>;


export type LineHaulLanesQuery = { __typename?: 'Query', lineHaulLanes: Array<{ __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> };

export type ShallowLineHaulLaneFragment = { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } };

export type ShallowLineHaulSegmentFragment = { __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } };

export type UpdateLineHaulLaneMutationVariables = Exact<{
  updateLineHaulLaneInput: UpdateLineHaulLaneInput;
}>;


export type UpdateLineHaulLaneMutation = { __typename?: 'Mutation', updateLineHaulLane: { __typename?: 'UpdateLineHaulLaneOutput', errorMessage?: string | null, lineHaulLane: { __typename?: 'LineHaulLaneEntity', uuid: string } } };

export type MarkOrderAsCancelledMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkOrderAsCancelledMutation = { __typename?: 'Mutation', markAsCancelled: { __typename?: 'StandardOrderEntity', uuid: string } };

export type MarkOrderAsOnHoldMutationVariables = Exact<{
  markAsOnHoldInput: MarkAsOnHoldInput;
}>;


export type MarkOrderAsOnHoldMutation = { __typename?: 'Mutation', markAsOnHold: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null } };

export type MinimalServiceRegionsQueryVariables = Exact<{
  input: GetServiceRegionsInput;
}>;


export type MinimalServiceRegionsQuery = { __typename?: 'Query', serviceRegions: { __typename?: 'GetServiceRegionsOutput', serviceRegions: Array<{ __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean }> } };

export type ArchivePackageSpecMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchivePackageSpecMutation = { __typename?: 'Mutation', archivePackageSpec: { __typename?: 'UpdatePackageSpecOutput', packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, freightClass?: FreightClass | null } } };

export type CreatePackageSpecMutationVariables = Exact<{
  createPackageSpecInput: CreatePackageSpecInput;
}>;


export type CreatePackageSpecMutation = { __typename?: 'Mutation', createPackageSpec: { __typename?: 'CreatePackageSpecOutput', packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, freightClass?: FreightClass | null } } };

export type PackageSpecFragment = { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, freightClass?: FreightClass | null };

export type PackageSpecQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PackageSpecQuery = { __typename?: 'Query', packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, freightClass?: FreightClass | null } };

export type PackageSpecsMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type PackageSpecsMinimalQuery = { __typename?: 'Query', packageSpecs: { __typename?: 'FindPackageSpecsOutput', packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, freightClass?: FreightClass | null }> } };

export type RestorePackageSpecMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestorePackageSpecMutation = { __typename?: 'Mutation', restorePackageSpec: { __typename?: 'UpdatePackageSpecOutput', packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, freightClass?: FreightClass | null } } };

export type UpdatePackageSpecMutationVariables = Exact<{
  updatePackageSpecInput: UpdatePackageSpecInput;
}>;


export type UpdatePackageSpecMutation = { __typename?: 'Mutation', updatePackageSpec: { __typename?: 'UpdatePackageSpecOutput', packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, freightClass?: FreightClass | null } } };

export type CompanyPackageTypeConfigFragment = { __typename: 'CompanyPackageTypeConfigEntity', id: string, packageType: PackageType, isSingleHandlingUnit: boolean };

export type CompanyPackageTypeConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyPackageTypeConfigsQuery = { __typename?: 'Query', companyPackageTypeConfigs: { __typename?: 'FindCompanyPackageTypeConfigsOutput', companyPackageTypeConfigs: Array<{ __typename: 'CompanyPackageTypeConfigEntity', id: string, packageType: PackageType, isSingleHandlingUnit: boolean }> } };

export type UpsertCompanyPackageTypeConfigMutationVariables = Exact<{
  input: UpsertCompanyPackageTypeConfigInput;
}>;


export type UpsertCompanyPackageTypeConfigMutation = { __typename?: 'Mutation', upsertCompanyPackageTypeConfig: { __typename?: 'UpsertCompanyPackageTypeConfigOutput', companyPackageTypeConfig: { __typename: 'CompanyPackageTypeConfigEntity', id: string, packageType: PackageType, isSingleHandlingUnit: boolean } } };

export type RecoveryTerminalFragment = { __typename?: 'AirportInfoEntity', uuid: string, iataCode?: string | null, terminal: string, isArchived: boolean, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } };

export type RecoveryTerminalsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecoveryTerminalsQuery = { __typename?: 'Query', airportInfos: Array<{ __typename?: 'AirportInfoEntity', uuid: string, iataCode?: string | null, terminal: string, isArchived: boolean, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } }> };

export type CreateRecoveryTerminalMutationVariables = Exact<{
  iataCode?: InputMaybe<Scalars['String']['input']>;
  terminal: Scalars['String']['input'];
  addressUuid: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
}>;


export type CreateRecoveryTerminalMutation = { __typename?: 'Mutation', createAirportInfo: { __typename?: 'AirportInfoEntity', uuid: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } };

export type UpdateRecoveryTerminalMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  iataCode?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
  addressUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRecoveryTerminalMutation = { __typename?: 'Mutation', updateAirportInfo: { __typename?: 'AirportInfoEntity', uuid: string } };

export type RestoreRecoveryTerminalMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RestoreRecoveryTerminalMutation = { __typename?: 'Mutation', restoreAirportInfo: { __typename?: 'AirportInfoUpdateOutput', airportInfo: { __typename?: 'AirportInfoEntity', uuid: string, isArchived: boolean } } };

export type RouteAutomationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type RouteAutomationSettingsQuery = { __typename?: 'Query', routeAutomationSettings: { __typename?: 'RouteAutomationSettingsEntity', uuid: string, autoCreateRoutes: boolean, autoPopulateRoutes: boolean, autoAssignTrucks: boolean, dueDateSource: RouteAutomationDueDateSource, pickupOrDelivery: RouteAutomationDirection, serviceUuids: Array<string>, includeTagUuids: Array<string>, excludeTagUuids: Array<string> } };

export type RouteNameQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RouteNameQuery = { __typename?: 'Query', routeName?: { __typename?: 'RouteNameEntity', uuid: string, name: string, routeNameLocations: Array<{ __typename?: 'RouteNameLocationEntity', uuid: string, zipcode: string, city: string }> } | null };

export type RouteNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type RouteNamesQuery = { __typename?: 'Query', routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }> };

export type ServiceForThirdPartyUserFragment = { __typename?: 'ServiceEntity', uuid: string, name: string, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null };

export type ServicesForThirdPartyUserQueryVariables = Exact<{
  findServicesForThirdPartyUserInput: FindServicesForThirdPartyUserInput;
}>;


export type ServicesForThirdPartyUserQuery = { __typename?: 'Query', servicesForThirdPartyUser: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null }> };

export type CreateTerminalLanesMutationVariables = Exact<{
  input: CreateTerminalLanesInput;
}>;


export type CreateTerminalLanesMutation = { __typename?: 'Mutation', createTerminalLanes: { __typename: 'CreateTerminalLanesSuccessOutput', terminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, startTerminal: { __typename?: 'TerminalEntity', uuid: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string } }> } | { __typename: 'MutationErrorOutput', message: string } };

export type CreateTerminalServiceAreasV2MutationVariables = Exact<{
  createTerminalServiceAreaInputs: Array<CreateTerminalServiceAreaInput> | CreateTerminalServiceAreaInput;
}>;


export type CreateTerminalServiceAreasV2Mutation = { __typename?: 'Mutation', createTerminalServiceAreasV2: { __typename?: 'CreateTerminalServiceAreaV2Output', createdCount?: number | null } };

export type CreateTerminalMutationVariables = Exact<{
  input: TerminalCreateInput;
}>;


export type CreateTerminalMutation = { __typename?: 'Mutation', createTerminalV2: { __typename: 'CreateTerminalSuccessOutput', terminal: { __typename?: 'TerminalEntity', uuid: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type DeleteTerminalLanesMutationVariables = Exact<{
  input: DeleteTerminalLanesInput;
}>;


export type DeleteTerminalLanesMutation = { __typename?: 'Mutation', deleteTerminalLanes: { __typename: 'DeleteTerminalLanesSuccessOutput', terminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string }> } | { __typename: 'MutationErrorOutput', message: string } };

export type RemoveTerminalServiceAreaMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveTerminalServiceAreaMutation = { __typename?: 'Mutation', removeTerminalServiceArea: { __typename?: 'TerminalServiceAreaEntity', uuid: string } };

export type ShallowTerminalFragment = { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null };

export type TerminalServiceAreaFragment = { __typename?: 'TerminalServiceAreaEntity', uuid: string, zipcode: string, city?: string | null };

export type TerminalFragment = { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string }, serviceAreas: Array<{ __typename?: 'TerminalServiceAreaEntity', uuid: string, zipcode: string, city?: string | null }>, serviceRegion?: { __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean } | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }> };

export type TerminalQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type TerminalQuery = { __typename?: 'Query', terminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string }, serviceAreas: Array<{ __typename?: 'TerminalServiceAreaEntity', uuid: string, zipcode: string, city?: string | null }>, serviceRegion?: { __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean } | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }> } };

export type TerminalsForThirdPartyUserQueryVariables = Exact<{
  findTerminalsForThirdPartyUserInput: FindTerminalsForThirdPartyUserInput;
}>;


export type TerminalsForThirdPartyUserQuery = { __typename?: 'Query', terminalsForThirdPartyUser: Array<{ __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }> };

export type TerminalsQueryVariables = Exact<{
  getTerminalsInput?: InputMaybe<GetTerminalsInput>;
}>;


export type TerminalsQuery = { __typename?: 'Query', terminals: Array<{ __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }> };

export type UpdateTerminalMutationVariables = Exact<{
  input: TerminalUpdateInput;
}>;


export type UpdateTerminalMutation = { __typename?: 'Mutation', updateTerminalV2: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateTerminalSuccessOutput', terminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string }, serviceAreas: Array<{ __typename?: 'TerminalServiceAreaEntity', uuid: string, zipcode: string, city?: string | null }>, serviceRegion?: { __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean } | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }> } } };

export type CreateThirdPartyBrokerMutationVariables = Exact<{
  thirdPartyBrokerCreateInput: ThirdPartyBrokerCreateInput;
}>;


export type CreateThirdPartyBrokerMutation = { __typename?: 'Mutation', createThirdPartyBroker: { __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string } };

export type RemoveThirdPartyBrokerMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveThirdPartyBrokerMutation = { __typename?: 'Mutation', removeThirdPartyBroker: { __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string } };

export type ThirdPartyBrokerFragment = { __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string };

export type ThirdPartyBrokersQueryVariables = Exact<{ [key: string]: never; }>;


export type ThirdPartyBrokersQuery = { __typename?: 'Query', thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }> };

export type UpdateThirdPartyBrokerMutationVariables = Exact<{
  thirdPartyBrokerUpdateInput: ThirdPartyBrokerUpdateInput;
}>;


export type UpdateThirdPartyBrokerMutation = { __typename?: 'Mutation', updateThirdPartyBroker: { __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string } };

export type UpdateCustomDriverFormMutationVariables = Exact<{
  updateDriverSignableFormTemplateInput: UpdateDriverSignableFormTemplateInput;
}>;


export type UpdateCustomDriverFormMutation = { __typename?: 'Mutation', updateDriverSignableFormTemplate: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string } };

export type UpdateDriverMutationVariables = Exact<{
  input: UpdateDriverInput;
}>;


export type UpdateDriverMutation = { __typename?: 'Mutation', updateDriver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string } };

export type UpdateEquipmentMutationVariables = Exact<{
  input: UpdateEquipmentInput;
}>;


export type UpdateEquipmentMutation = { __typename?: 'Mutation', updateEquipment: { __typename?: 'EquipmentEntity', name: string, uuid: string } };

export type UpdateServiceMutationVariables = Exact<{
  input: UpdateServiceInput;
}>;


export type UpdateServiceMutation = { __typename?: 'Mutation', updateService: { __typename?: 'ServiceEntity', uuid: string, name: string } };

export type UpdateTemplateAndRecordAddressesMutationVariables = Exact<{
  updateAddressInput: UpdateAddressInput;
}>;


export type UpdateTemplateAndRecordAddressesMutation = { __typename?: 'Mutation', updateTemplateAndRecordAddresses: Array<{ __typename?: 'AddressEntity', uuid: string }> };

export type UpsertRouteAutomationSettingsMutationVariables = Exact<{
  input: RouteAutomationSettingsInput;
}>;


export type UpsertRouteAutomationSettingsMutation = { __typename?: 'Mutation', upsertRouteAutomationSettings: { __typename?: 'RouteAutomationSettingsEntity', uuid: string, autoCreateRoutes: boolean, autoPopulateRoutes: boolean, autoAssignTrucks: boolean, dueDateSource: RouteAutomationDueDateSource, pickupOrDelivery: RouteAutomationDirection, serviceUuids: Array<string>, includeTagUuids: Array<string>, excludeTagUuids: Array<string> } };

export type CreateUserV2MutationVariables = Exact<{
  createUserInput: CreateUserInput;
}>;


export type CreateUserV2Mutation = { __typename?: 'Mutation', createUserV2: { __typename?: 'ArchivedUserExistsOutput', archivedUserUuid: string, message: string } | { __typename?: 'CreateUserSuccessOutput', user: { __typename?: 'UserEntity', uuid: string } } | { __typename?: 'MutationErrorOutput', message: string } };

export type ReactivateUserMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ReactivateUserMutation = { __typename?: 'Mutation', reactivateUser: { __typename?: 'UserEntity', uuid: string, isActive: boolean } };

export type ReportsEmailSenderIsVerifiedQueryVariables = Exact<{
  userUuid: Scalars['String']['input'];
}>;


export type ReportsEmailSenderIsVerifiedQuery = { __typename?: 'Query', reportsEmailSenderIsVerified?: boolean | null };

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserEntity', uuid: string, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null } };

export type UpdateUserReportsEmailMutationVariables = Exact<{
  userUuid: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateUserReportsEmailMutation = { __typename?: 'Mutation', updateReportsEmail: { __typename?: 'UserEntity', uuid: string, reportsEmailSendgridSenderId?: string | null } };

export type UserOptionsQueryVariables = Exact<{
  getUsersInput?: InputMaybe<GetUsersInput>;
}>;


export type UserOptionsQuery = { __typename?: 'Query', userOptions: Array<{ __typename?: 'UserOptionEntity', uuid: string, name?: string | null, email?: string | null }> };

export type UserFragment = { __typename?: 'UserEntity', uuid: string, name?: string | null, reportsEmail?: string | null, email: string, phoneNumber?: string | null, sendSummaryEmailWithIncompleteRoutes: boolean, sendAllInvoices?: boolean | null, isActive: boolean, holdsPrivilegedRole: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, roles: Array<{ __typename?: 'RoleEntity', uuid: string, name: string }>, driver?: { __typename?: 'DriverEntity', uuid: string } | null };

export type UsersRoleFragment = { __typename?: 'RoleEntity', uuid: string, name: string };

export type UsersQueryVariables = Exact<{
  getUsersInput?: InputMaybe<GetUsersInput>;
}>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'UserEntity', uuid: string, name?: string | null, reportsEmail?: string | null, email: string, phoneNumber?: string | null, sendSummaryEmailWithIncompleteRoutes: boolean, sendAllInvoices?: boolean | null, isActive: boolean, holdsPrivilegedRole: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, roles: Array<{ __typename?: 'RoleEntity', uuid: string, name: string }>, driver?: { __typename?: 'DriverEntity', uuid: string } | null }> };

export type ArchiveVehicleTypeMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ArchiveVehicleTypeMutation = { __typename?: 'Mutation', archiveVehicleType: { __typename?: 'VehicleTypeUpdateOutput', vehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } } };

export type CreateVehicleTypeMutationVariables = Exact<{
  vehicleTypeCreateInput: VehicleTypeCreateInput;
}>;


export type CreateVehicleTypeMutation = { __typename?: 'Mutation', createVehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } };

export type RestoreVehicleTypeMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RestoreVehicleTypeMutation = { __typename?: 'Mutation', restoreVehicleType: { __typename?: 'VehicleTypeUpdateOutput', vehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } } };

export type UpdateVehicleTypeMutationVariables = Exact<{
  vehicleTypeUpdateInput: VehicleTypeUpdateInput;
}>;


export type UpdateVehicleTypeMutation = { __typename?: 'Mutation', updateVehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } };

export type VehicleTypeFragment = { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> };

export type VehicleTypesMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type VehicleTypesMinimalQuery = { __typename?: 'Query', vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }> };

export type ArchiveWarehouseEmployeeMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ArchiveWarehouseEmployeeMutation = { __typename?: 'Mutation', archiveWarehouseEmployee: { __typename?: 'UpdateWarehouseEmployeeOutput', warehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, isArchived: boolean, active: boolean } | null } };

export type RestoreWarehouseEmployeeMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RestoreWarehouseEmployeeMutation = { __typename?: 'Mutation', restoreWarehouseEmployee: { __typename?: 'UpdateWarehouseEmployeeOutput', warehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, isArchived: boolean, active: boolean } | null } };

export type CreatedWarehouseEmployeeFragment = { __typename?: 'WarehouseEmployeeEntity', uuid: string };

export type CreateWarehouseEmployeeMutationVariables = Exact<{
  createWarehouseEmployeeInput: CreateWarehouseEmployeeInput;
}>;


export type CreateWarehouseEmployeeMutation = { __typename?: 'Mutation', createWarehouseEmployee: { __typename?: 'CreateWarehouseEmployeeOutput', warehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string } | null } };

export type WarehouseEmployeeFragment = { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string, emailAddress?: string | null, phoneNumber: string, active: boolean, isArchived: boolean, password?: string | null };

export type WarehouseEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type WarehouseEmployeesQuery = { __typename?: 'Query', warehouseEmployees: { __typename?: 'FindWarehouseEmployeesOutput', warehouseEmployees: Array<{ __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string, emailAddress?: string | null, phoneNumber: string, active: boolean, isArchived: boolean, password?: string | null }> } };

export type UpdatedWarehouseEmployeeFragment = { __typename?: 'WarehouseEmployeeEntity', uuid: string };

export type UpdateWarehouseEmployeeMutationVariables = Exact<{
  updateWarehouseEmployeeInput: UpdateWarehouseEmployeeInput;
}>;


export type UpdateWarehouseEmployeeMutation = { __typename?: 'Mutation', updateWarehouseEmployee: { __typename?: 'UpdateWarehouseEmployeeOutput', warehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string } | null } };

export type MotiveIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type MotiveIntegrationQuery = { __typename?: 'Query', motiveIntegration: { __typename?: 'MotiveIntegrationEntity', connected: boolean } };

export type RemoveMotiveApiKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveMotiveApiKeyMutation = { __typename?: 'Mutation', removeMotiveApiKey: { __typename?: 'MotiveIntegrationEntity', connected: boolean } };

export type SetMotiveApiKeyMutationVariables = Exact<{
  input: SetMotiveApiKeyInput;
}>;


export type SetMotiveApiKeyMutation = { __typename?: 'Mutation', setMotiveApiKey: { __typename?: 'MotiveIntegrationEntity', connected: boolean } };

export type AcknowledgeNotificationMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AcknowledgeNotificationMutation = { __typename?: 'Mutation', acknowledgeNotification: { __typename?: 'NotificationEntity', uuid: string } };

export type AcknowledgeNotificationsMutationVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AcknowledgeNotificationsMutation = { __typename?: 'Mutation', acknowledgeNotifications: Array<{ __typename?: 'NotificationEntity', uuid: string }> };

export type InAppNotificationFragment = { __typename?: 'InAppNotificationEntity', uuid: string, eventType: string, title: string, body: string, data?: any | null, readAt?: any | null, createdAt: any };

export type InAppNotificationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InAppNotificationsQuery = { __typename?: 'Query', inAppNotifications: { __typename?: 'InAppNotificationConnection', edges: Array<{ __typename?: 'InAppNotificationEdge', cursor: string, node: { __typename?: 'InAppNotificationEntity', uuid: string, eventType: string, title: string, body: string, data?: any | null, readAt?: any | null, createdAt: any } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type MarkAllInAppNotificationsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllInAppNotificationsReadMutation = { __typename?: 'Mutation', markAllInAppNotificationsRead: number };

export type MarkNotificationReadMutationVariables = Exact<{
  input: MarkNotificationReadInput;
}>;


export type MarkNotificationReadMutation = { __typename?: 'Mutation', markNotificationRead: boolean };

export type NotificationFragment = { __typename?: 'NotificationEntity', uuid: string, type: NotificationType, acknowledged?: boolean | null, createdAt: any, partnerCompanyName?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, createdAt: any, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, driverMarkedAttemptedStop?: { __typename?: 'StandardStopEntity', leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', name: string } | null } } | null } | null, driverMarkedAttemptedDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, targetAccessorial?: { __typename: 'AttemptsAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'PercentageAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, percentageBasis?: AccessorialPercentageBasis | null, minimumCharge?: number | null, maximumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StorageDaysAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, maximumCharge?: number | null, minimumCharge?: number | null, storageDaysFreeDays?: number | null, storageDaysExcludeWeekends?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | null, targetStop?: { __typename?: 'StandardStopEntity', leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', name: string } | null } } | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', uuid: string, updatedAt: any, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null };

export type NotificationsQueryVariables = Exact<{
  specialWindowsDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'NotificationEntity', uuid: string, type: NotificationType, acknowledged?: boolean | null, createdAt: any, partnerCompanyName?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, createdAt: any, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, driverMarkedAttemptedStop?: { __typename?: 'StandardStopEntity', leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', name: string } | null } } | null } | null, driverMarkedAttemptedDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, targetAccessorial?: { __typename: 'AttemptsAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'PercentageAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, percentageBasis?: AccessorialPercentageBasis | null, minimumCharge?: number | null, maximumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SkidBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerSkid: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'SpecialAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, specialAccessorialType?: SpecialAccessorialType | null, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, zones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'SpecialAccessorialChargeGroupEntity', uuid: string, dayOfWeek: SpecialDayOfWeek, startTime: any, endTime: any }>, matrixItems: Array<{ __typename?: 'SpecialAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, tariffZoneGroup?: { __typename?: 'TariffZoneGroupEntity', id: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StandardAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'StorageDaysAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, uuid: string, quickbooksDesktopAccessorialId?: string | null, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, maximumCharge?: number | null, minimumCharge?: number | null, storageDaysFreeDays?: number | null, storageDaysExcludeWeekends?: boolean | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'UnitBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerUnit: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WaitTimeAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, rate: number, maximumCharge?: number | null, minimumCharge?: number | null, waitTimeChargePeriod?: number | null, waitTimeFreeMinutes?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | { __typename: 'WeightBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, ratePerHundredWeight: number, maximumCharge?: number | null, minimumCharge?: number | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, accessorialRanges?: Array<{ __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number }> | null, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, id: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', isArchived?: boolean | null, isAuthoCodeRequired: boolean, isDefaultGlobalSpecial: boolean, invoiceDisplayName?: string | null, quickbooksDesktopAccessorialId?: string | null, uuid: string, quickbooksFileMappingChargeName?: string | null, quickbooksMappingId: string, percentForSettlement?: number | null, name: string, code?: string | null, ediCode?: string | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string, name: string }>, chargeGroups: Array<{ __typename?: 'ZoneBasedAccessorialChargeGroupEntity', uuid: string, name: string }>, matrixItems: Array<{ __typename?: 'ZoneBasedAccessorialMatrixItemEntity', zoneUuid: string, chargeGroupUuid: string, uuid: string, rate: number }>, matchingGlobalAccessorial?: { __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string } | null, matchingCustomerAccessorials?: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, fuelProfile?: { __typename?: 'FuelProfileEntity', uuid: string, name?: string | null, startDate?: any | null, expirationDate?: any | null, billingType: FuelBillingMethod, type: FuelProfileType, company: { __typename?: 'CompanyEntity', uuid: string }, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, fuelProfileDateRanges: Array<{ __typename?: 'FuelProfileDateRangeEntity', uuid: string, startDate: any, expirationDate: any, surchargeRate?: number | null, flatRateUsdCents?: number | null }> } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', id: string, code: string } | null } | null, targetStop?: { __typename?: 'StandardStopEntity', leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', name: string } | null } } | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', uuid: string, updatedAt: any, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null }> };

export type UnreadInAppNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadInAppNotificationsCountQuery = { __typename?: 'Query', unreadInAppNotificationsCount: number };

export type OperationsPerformanceReportCsvQueryVariables = Exact<{
  args: OperationsPerformanceFilterArgs;
}>;


export type OperationsPerformanceReportCsvQuery = { __typename?: 'Query', operationsPerformanceReportCsv: { __typename?: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type OperationsPerformanceDurationFieldsFragment = { __typename?: 'OperationsPerformanceDuration', meanSeconds?: number | null, medianSeconds?: number | null, p90Seconds?: number | null, countedOrders: number, backwardOrders: number, prior: { __typename?: 'OperationsPerformancePriorDuration', medianSeconds?: number | null, countedOrders: number } };

export type OperationsPerformanceGroupFieldsFragment = { __typename?: 'OperationsPerformanceGroup', uuid?: string | null, name: string, orders: number, deliveredOrders: number, medianSeconds?: number | null, intervals: Array<{ __typename?: 'OperationsPerformanceGroupInterval', key: OperationsPerformanceInterval, medianSeconds?: number | null, countedOrders: number }> };

export type OperationsPerformanceSummaryQueryVariables = Exact<{
  args: OperationsPerformanceFilterArgs;
}>;


export type OperationsPerformanceSummaryQuery = { __typename?: 'Query', operationsPerformanceSummary: { __typename?: 'OperationsPerformanceSummary', orders: number, timezone: string, orderToDelivered: { __typename?: 'OperationsPerformanceDuration', meanSeconds?: number | null, medianSeconds?: number | null, p90Seconds?: number | null, countedOrders: number, backwardOrders: number, prior: { __typename?: 'OperationsPerformancePriorDuration', medianSeconds?: number | null, countedOrders: number } }, intervals: Array<{ __typename?: 'OperationsPerformanceIntervalDuration', key: OperationsPerformanceInterval, meanSeconds?: number | null, medianSeconds?: number | null, p90Seconds?: number | null, countedOrders: number, backwardOrders: number, prior: { __typename?: 'OperationsPerformancePriorDuration', medianSeconds?: number | null, countedOrders: number } }>, trend: { __typename?: 'OperationsPerformanceTrend', unit: KpiTrendBucketUnit, points: Array<{ __typename?: 'OperationsPerformanceTrendPoint', bucketDate: string, medianSeconds?: number | null, p90Seconds?: number | null, countedOrders: number, backwardOrders: number }> }, byCustomer: Array<{ __typename?: 'OperationsPerformanceGroup', uuid?: string | null, name: string, orders: number, deliveredOrders: number, medianSeconds?: number | null, intervals: Array<{ __typename?: 'OperationsPerformanceGroupInterval', key: OperationsPerformanceInterval, medianSeconds?: number | null, countedOrders: number }> }>, byTerminal: Array<{ __typename?: 'OperationsPerformanceGroup', uuid?: string | null, name: string, orders: number, deliveredOrders: number, medianSeconds?: number | null, intervals: Array<{ __typename?: 'OperationsPerformanceGroupInterval', key: OperationsPerformanceInterval, medianSeconds?: number | null, countedOrders: number }> }>, slowestOrders: Array<{ __typename?: 'OperationsPerformanceSlowOrder', orderUuid: string, orderName: string, customerName: string, terminalCode?: string | null, totalSeconds: number, longestInterval?: { __typename?: 'OperationsPerformanceLongestInterval', key: OperationsPerformanceInterval, seconds: number } | null }>, signals: { __typename?: 'OperationsPerformanceSignals', updatedOrders: number, inboundPieces: number, inboundScannedPieces: number, outboundPieces: number, outboundScannedPieces: number, byMethod: Array<{ __typename?: 'OperationsPerformanceUpdateMethodCount', method: OperationsPerformanceUpdateMethod, orders: number }> }, outliers: Array<{ __typename?: 'OperationsPerformanceOutliers', measure: OperationsPerformanceMeasure, orders: Array<{ __typename?: 'OperationsPerformanceOutlierOrder', orderUuid: string, orderName: string, customerName: string, fromAt: any, toAt: any, seconds: number }> }> } };

export type OperationsPerformanceReportQueryVariables = Exact<{
  args: OperationsPerformancePageArgs;
}>;


export type OperationsPerformanceReportQuery = { __typename?: 'Query', operationsPerformanceReport: { __typename?: 'OperationsPerformanceReport', totalCount: number, timezone: string, rows: Array<{ __typename?: 'OperationsPerformanceRow', orderUuid: string, orderName: string, customerName: string, accountId?: string | null, hawb?: string | null, source: OrderSource, sourceIsEmail: boolean, lastCustomerUpdateAt?: any | null, lastCustomerUpdateMethod?: OperationsPerformanceUpdateMethod | null, createdAt: any, inboundName?: string | null, inboundDispatchedAt?: any | null, createdToInboundDispatchSeconds?: number | null, inboundCompletedAt?: any | null, inboundDispatchToCompletionSeconds?: number | null, inboundScannedPieceCount?: number | null, outboundName?: string | null, outboundDispatchedAt?: any | null, inboundCompletionToOutboundDispatchSeconds?: number | null, outboundCompletedAt?: any | null, outboundDispatchToCompletionSeconds?: number | null, outboundScannedPieceCount?: number | null, pieceCount: number, completedAt?: any | null }> } };

export type AuditLogEntryFragment = { __typename?: 'AuditLogEntry', orderEvent: { __typename?: 'OrderEventEntity', uuid: string, createdAt: any, ignoreSnapshot: boolean, mirroredFromPartner: boolean, message: string, eventType: OrderEventType, sourceType: OrderEventSourceType, targetType: OrderEventTargetType, snapshot?: string | null, targetPhoneNumber?: string | null, targetEmail?: string | null, targetOrderTotalBeforeConsolidation?: number | null, targetOrderTotalAfterConsolidation?: number | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, createdFromOrderTemplate?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } } | null, sourceWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, sourceEdiTransaction?: { __typename?: 'EdiTransactionEntity', uuid: string, status: EdiTransactionStatus, code: EdiTransactionCode, edi214ShipmentStatus?: Edi214ShipmentStatus | null, edi990ActionCode?: Edi990ActionCode | null } | null, sourceSftpUpload?: { __typename?: 'SftpUploadEntity', uuid: string, type: SftpUploadType, status: SftpUploadStatus } | null, sourceOutboundWebhookEvent?: { __typename?: 'OutboundWebhookEventEntity', uuid: string, createdAt: any, type: OutboundWebhookEventType, httpStatusCode?: number | null, error?: string | null } | null, sourceEfmOutboundRequestEvent?: { __typename?: 'EfmOutboundRequestEventEntity', uuid: string, createdAt: any, requestType: EfmOutboundRequestType, statusCode?: EfmOutboundRequestStatusCode | null, httpStatusCode?: number | null, error?: string | null, clockworkStatusQueueId?: string | null } | null, sourceExpeditorsOutboundRequestEvent?: { __typename?: 'ExpeditorsOutboundRequestEventEntity', uuid: string, createdAt: any, requestType: ExpeditorsOutboundRequestType, workOrderNumber?: string | null, httpStatusCode?: number | null, error?: string | null } | null, sourceUser?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, targetContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, phone?: string | null } | null, targetDocument?: { __typename?: 'DocumentEntity', fileName: string, type: DocumentType, uuid: string } | null, targetDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, user: { __typename?: 'UserActorEntity', name?: string | null } } | null, targetInvoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null, targetRoute?: { __typename?: 'RouteEntity', uuid: string, name: string } | null, targetPiece?: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } | null, targetShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, name: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }> } | null, targetShipmentSubscriber?: { __typename?: 'ShipmentSubscriberEntity', uuid: string, phoneNumber?: string | null } | null, targetStop?: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, targetSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null }, snapshotDifference?: { __typename?: 'AuditLogSnapshotDifference', orderDifferences?: { __typename?: 'SnapshotOrderDifferences', billingPartyName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, hawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, mawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, refNumbers?: { __typename?: 'StringArrayFieldDifference', oldValue?: Array<string> | null, newValue?: Array<string> | null } | null, serviceLevel?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, packages?: Array<{ __typename?: 'SnapshotPackageDifferences', wasAdded: boolean, wasDeleted: boolean, height?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, weight?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, length?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, width?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null }> | null } | null, inboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, externalRating?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null, outboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, externalRating?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null } | null };

export type SnapshotDifferenceFragment = { __typename?: 'AuditLogSnapshotDifference', orderDifferences?: { __typename?: 'SnapshotOrderDifferences', billingPartyName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, hawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, mawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, refNumbers?: { __typename?: 'StringArrayFieldDifference', oldValue?: Array<string> | null, newValue?: Array<string> | null } | null, serviceLevel?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, packages?: Array<{ __typename?: 'SnapshotPackageDifferences', wasAdded: boolean, wasDeleted: boolean, height?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, weight?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, length?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, width?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null }> | null } | null, inboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, externalRating?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null, outboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, externalRating?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null };

export type EdiTransactionPayloadByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type EdiTransactionPayloadByUuidQuery = { __typename?: 'Query', ediTransactionPayloadByUuid: string };

export type ExternalApiTransmissionPayloadByOrderEventUuidQueryVariables = Exact<{
  orderEventUuid: Scalars['String']['input'];
}>;


export type ExternalApiTransmissionPayloadByOrderEventUuidQuery = { __typename?: 'Query', externalApiTransmissionPayloadByOrderEventUuid: string };

export type FreightChargeHistorySnapshotFragment = { __typename?: 'FreightChargeEntity', externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string } | null };

export type OrderAuditLogEntriesQueryVariables = Exact<{
  getOrderAuditLogEntriesInput: GetOrderAuditLogEntriesInput;
}>;


export type OrderAuditLogEntriesQuery = { __typename?: 'Query', orderAuditLogEntries?: { __typename?: 'GetOrderAuditLogEntriesOutput', auditLogEntries: Array<{ __typename?: 'AuditLogEntry', orderEvent: { __typename?: 'OrderEventEntity', uuid: string, createdAt: any, ignoreSnapshot: boolean, mirroredFromPartner: boolean, message: string, eventType: OrderEventType, sourceType: OrderEventSourceType, targetType: OrderEventTargetType, snapshot?: string | null, targetPhoneNumber?: string | null, targetEmail?: string | null, targetOrderTotalBeforeConsolidation?: number | null, targetOrderTotalAfterConsolidation?: number | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, createdFromOrderTemplate?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } } | null, sourceWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, sourceEdiTransaction?: { __typename?: 'EdiTransactionEntity', uuid: string, status: EdiTransactionStatus, code: EdiTransactionCode, edi214ShipmentStatus?: Edi214ShipmentStatus | null, edi990ActionCode?: Edi990ActionCode | null } | null, sourceSftpUpload?: { __typename?: 'SftpUploadEntity', uuid: string, type: SftpUploadType, status: SftpUploadStatus } | null, sourceOutboundWebhookEvent?: { __typename?: 'OutboundWebhookEventEntity', uuid: string, createdAt: any, type: OutboundWebhookEventType, httpStatusCode?: number | null, error?: string | null } | null, sourceEfmOutboundRequestEvent?: { __typename?: 'EfmOutboundRequestEventEntity', uuid: string, createdAt: any, requestType: EfmOutboundRequestType, statusCode?: EfmOutboundRequestStatusCode | null, httpStatusCode?: number | null, error?: string | null, clockworkStatusQueueId?: string | null } | null, sourceExpeditorsOutboundRequestEvent?: { __typename?: 'ExpeditorsOutboundRequestEventEntity', uuid: string, createdAt: any, requestType: ExpeditorsOutboundRequestType, workOrderNumber?: string | null, httpStatusCode?: number | null, error?: string | null } | null, sourceUser?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, targetContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, phone?: string | null } | null, targetDocument?: { __typename?: 'DocumentEntity', fileName: string, type: DocumentType, uuid: string } | null, targetDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, user: { __typename?: 'UserActorEntity', name?: string | null } } | null, targetInvoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null, targetRoute?: { __typename?: 'RouteEntity', uuid: string, name: string } | null, targetPiece?: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } | null, targetShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, name: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }> } | null, targetShipmentSubscriber?: { __typename?: 'ShipmentSubscriberEntity', uuid: string, phoneNumber?: string | null } | null, targetStop?: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, targetSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null }, snapshotDifference?: { __typename?: 'AuditLogSnapshotDifference', orderDifferences?: { __typename?: 'SnapshotOrderDifferences', billingPartyName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, hawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, mawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, refNumbers?: { __typename?: 'StringArrayFieldDifference', oldValue?: Array<string> | null, newValue?: Array<string> | null } | null, serviceLevel?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, packages?: Array<{ __typename?: 'SnapshotPackageDifferences', wasAdded: boolean, wasDeleted: boolean, height?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, weight?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, length?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, width?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null }> | null } | null, inboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, externalRating?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null, outboundStopDifferences?: { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, externalRating?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null } | null } | null }> } | null };

export type OrderDifferenceFragment = { __typename?: 'SnapshotOrderDifferences', billingPartyName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, hawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, mawb?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, refNumbers?: { __typename?: 'StringArrayFieldDifference', oldValue?: Array<string> | null, newValue?: Array<string> | null } | null, serviceLevel?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, packages?: Array<{ __typename?: 'SnapshotPackageDifferences', wasAdded: boolean, wasDeleted: boolean, height?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, weight?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, length?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, width?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null }> | null };

export type PackageDifferenceFragment = { __typename?: 'SnapshotPackageDifferences', wasAdded: boolean, wasDeleted: boolean, height?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, weight?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, length?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, width?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null };

export type OrderEventSnapshotFragment = { __typename?: 'OrderEventEntity', uuid: string, createdAt: any, snapshot?: string | null, sourceUser?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null };

export type OrderEventSnapshotsQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
  eventType?: InputMaybe<OrderEventType>;
  sortByCreatedAtAsc?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrderEventSnapshotsQuery = { __typename?: 'Query', orderEvents?: Array<{ __typename?: 'OrderEventEntity', uuid: string, createdAt: any, snapshot?: string | null, sourceUser?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null }> | null };

export type OrderEventFragment = { __typename?: 'OrderEventEntity', uuid: string, createdAt: any, ignoreSnapshot: boolean, mirroredFromPartner: boolean, message: string, eventType: OrderEventType, sourceType: OrderEventSourceType, targetType: OrderEventTargetType, snapshot?: string | null, targetPhoneNumber?: string | null, targetEmail?: string | null, targetOrderTotalBeforeConsolidation?: number | null, targetOrderTotalAfterConsolidation?: number | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, createdFromOrderTemplate?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } } | null, sourceWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, sourceEdiTransaction?: { __typename?: 'EdiTransactionEntity', uuid: string, status: EdiTransactionStatus, code: EdiTransactionCode, edi214ShipmentStatus?: Edi214ShipmentStatus | null, edi990ActionCode?: Edi990ActionCode | null } | null, sourceSftpUpload?: { __typename?: 'SftpUploadEntity', uuid: string, type: SftpUploadType, status: SftpUploadStatus } | null, sourceOutboundWebhookEvent?: { __typename?: 'OutboundWebhookEventEntity', uuid: string, createdAt: any, type: OutboundWebhookEventType, httpStatusCode?: number | null, error?: string | null } | null, sourceEfmOutboundRequestEvent?: { __typename?: 'EfmOutboundRequestEventEntity', uuid: string, createdAt: any, requestType: EfmOutboundRequestType, statusCode?: EfmOutboundRequestStatusCode | null, httpStatusCode?: number | null, error?: string | null, clockworkStatusQueueId?: string | null } | null, sourceExpeditorsOutboundRequestEvent?: { __typename?: 'ExpeditorsOutboundRequestEventEntity', uuid: string, createdAt: any, requestType: ExpeditorsOutboundRequestType, workOrderNumber?: string | null, httpStatusCode?: number | null, error?: string | null } | null, sourceUser?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, targetContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, phone?: string | null } | null, targetDocument?: { __typename?: 'DocumentEntity', fileName: string, type: DocumentType, uuid: string } | null, targetDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, user: { __typename?: 'UserActorEntity', name?: string | null } } | null, targetInvoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null, targetRoute?: { __typename?: 'RouteEntity', uuid: string, name: string } | null, targetPiece?: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } | null, targetShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, name: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }> } | null, targetShipmentSubscriber?: { __typename?: 'ShipmentSubscriberEntity', uuid: string, phoneNumber?: string | null } | null, targetStop?: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, targetSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null };

export type OrderEventShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, name: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }> };

export type OrderEventsQueryVariables = Exact<{
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  storageOrderUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderEventsQuery = { __typename?: 'Query', orderEvents?: Array<{ __typename?: 'OrderEventEntity', uuid: string, createdAt: any, ignoreSnapshot: boolean, mirroredFromPartner: boolean, message: string, eventType: OrderEventType, sourceType: OrderEventSourceType, targetType: OrderEventTargetType, snapshot?: string | null, targetPhoneNumber?: string | null, targetEmail?: string | null, targetOrderTotalBeforeConsolidation?: number | null, targetOrderTotalAfterConsolidation?: number | null, sourcePicklist?: { __typename?: 'PicklistEntity', id: string, outboundReferenceNumber?: string | null, picklistItemGroups: Array<{ __typename?: 'PicklistItemGroupEntity', id: string, pickedQuantity: number, pickedStatus: PickedStatus, itemGroup: { __typename?: 'ItemGroupEntity', quantity: number, item: { __typename?: 'ItemEntity', sku: string, description?: string | null }, storageUnit?: { __typename?: 'StorageUnitEntity', name: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null } | null } }> } | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, createdFromOrderTemplate?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } } | null, sourceWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, sourceEdiTransaction?: { __typename?: 'EdiTransactionEntity', uuid: string, status: EdiTransactionStatus, code: EdiTransactionCode, edi214ShipmentStatus?: Edi214ShipmentStatus | null, edi990ActionCode?: Edi990ActionCode | null } | null, sourceSftpUpload?: { __typename?: 'SftpUploadEntity', uuid: string, type: SftpUploadType, status: SftpUploadStatus } | null, sourceOutboundWebhookEvent?: { __typename?: 'OutboundWebhookEventEntity', uuid: string, createdAt: any, type: OutboundWebhookEventType, httpStatusCode?: number | null, error?: string | null } | null, sourceEfmOutboundRequestEvent?: { __typename?: 'EfmOutboundRequestEventEntity', uuid: string, createdAt: any, requestType: EfmOutboundRequestType, statusCode?: EfmOutboundRequestStatusCode | null, httpStatusCode?: number | null, error?: string | null, clockworkStatusQueueId?: string | null } | null, sourceExpeditorsOutboundRequestEvent?: { __typename?: 'ExpeditorsOutboundRequestEventEntity', uuid: string, createdAt: any, requestType: ExpeditorsOutboundRequestType, workOrderNumber?: string | null, httpStatusCode?: number | null, error?: string | null } | null, sourceUser?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, targetContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, phone?: string | null } | null, targetDocument?: { __typename?: 'DocumentEntity', fileName: string, type: DocumentType, uuid: string } | null, targetDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, user: { __typename?: 'UserActorEntity', name?: string | null } } | null, targetInvoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null, targetRoute?: { __typename?: 'RouteEntity', uuid: string, name: string } | null, targetPiece?: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } | null, targetShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, name: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }> } | null, targetShipmentSubscriber?: { __typename?: 'ShipmentSubscriberEntity', uuid: string, phoneNumber?: string | null } | null, targetStop?: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, targetSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null }> | null };

export type PicklistItemGroupFragment = { __typename?: 'PicklistItemGroupEntity', id: string, pickedQuantity: number, pickedStatus: PickedStatus, itemGroup: { __typename?: 'ItemGroupEntity', quantity: number, item: { __typename?: 'ItemEntity', sku: string, description?: string | null }, storageUnit?: { __typename?: 'StorageUnitEntity', name: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null } | null } };

export type ResendExternalTransmissionMutationVariables = Exact<{
  input: ResendExternalTransmissionInput;
}>;


export type ResendExternalTransmissionMutation = { __typename?: 'Mutation', resendExternalTransmission: boolean };

export type StopDifferenceFragment = { __typename?: 'SnapshotStopDifferences', wasAdded: boolean, wasDeleted: boolean, stopType?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, address?: { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, terminal?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, serviceDate?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, isSpecial?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentRequired?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, appointmentManuallyConfirmed?: { __typename?: 'BooleanFieldDifference', oldValue?: boolean | null, newValue?: boolean | null } | null, freightCharge?: { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, externalRating?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null } | null, customCharges?: Array<{ __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null, independentSettlementBillLineItems?: Array<{ __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null }> | null };

export type AddressDifferenceFragment = { __typename?: 'SnapshotAddressDifferences', name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, line1?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, zip?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, state?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, city?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null };

export type FreightChargeDifferenceFragment = { __typename?: 'SnapshotFreightChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, externalRating?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCharge?: { __typename?: 'SnapshotFuelChargeDifferences', totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null, billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null };

export type CustomChargeDifferenceFragment = { __typename?: 'SnapshotCustomChargeDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null };

export type IndependentSettlementBillLineItemDifferenceFragment = { __typename?: 'SnapshotIndependentSettlementBillLineItemDifferences', wasAdded: boolean, wasDeleted: boolean, driverName?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, freightCost?: { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null } | null, customCosts?: Array<{ __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null }> | null };

export type FreightCostDifferenceFragment = { __typename?: 'SnapshotFreightCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, tariff?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, fuelCost?: { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null } | null };

export type FuelCostDifferenceFragment = { __typename?: 'SnapshotFuelCostDifferences', billingMethod?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null, type?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, surchargeRate?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null };

export type CustomCostDifferenceFragment = { __typename?: 'SnapshotCustomCostDifferences', wasAdded: boolean, wasDeleted: boolean, name?: { __typename?: 'StringFieldDifference', oldValue?: string | null, newValue?: string | null } | null, totalAmountCents?: { __typename?: 'NumberFieldDifference', oldValue?: number | null, newValue?: number | null } | null };

export type BulkDelegateOrdersMutationVariables = Exact<{
  input: BulkDelegateOrdersInput;
}>;


export type BulkDelegateOrdersMutation = { __typename?: 'Mutation', bulkDelegateOrders: { __typename: 'BulkDelegationBatchEntity', uuid: string, total: number, offered: number, pending: number, failed: number, isComplete: boolean, items: Array<{ __typename: 'BulkDelegationItemEntity', orderUuid: string, status: BulkDelegationItemStatus, reason?: string | null }> } };

export type BulkDelegationBatchFragment = { __typename: 'BulkDelegationBatchEntity', uuid: string, total: number, offered: number, pending: number, failed: number, isComplete: boolean, items: Array<{ __typename: 'BulkDelegationItemEntity', orderUuid: string, status: BulkDelegationItemStatus, reason?: string | null }> };

export type BulkDelegationBatchQueryVariables = Exact<{
  batchUuid: Scalars['String']['input'];
}>;


export type BulkDelegationBatchQuery = { __typename?: 'Query', bulkDelegationBatch: { __typename: 'BulkDelegationBatchEntity', uuid: string, total: number, offered: number, pending: number, failed: number, isComplete: boolean, items: Array<{ __typename: 'BulkDelegationItemEntity', orderUuid: string, status: BulkDelegationItemStatus, reason?: string | null }> } };

export type EmailIngestionExclusionsQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailIngestionExclusionsQuery = { __typename?: 'Query', emailIngestionExclusions: { __typename?: 'EmailIngestionExclusionsEntity', excludedDocumentTypes: Array<ClassifiedDocumentType>, excludedCustomers: Array<{ __typename?: 'EmailIngestionExcludedCustomerEntity', uuid: string, displayName: string }> } };

export type EmailProcessingHistoryQueryVariables = Exact<{
  findIngestedOutlookEmailsInput: FindIngestedOutlookEmailsInput;
}>;


export type EmailProcessingHistoryQuery = { __typename?: 'Query', ingestedOutlookEmails: { __typename?: 'IngestedOutlookEmailConnection', edges: Array<{ __typename?: 'IngestedOutlookEmailEdge', node: { __typename?: 'IngestedOutlookEmailEntity', uuid: string, createdAt: any, subject?: string | null, effectiveSenderAddress: string, outlookReceivedDateTime: any } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type IngestedEmailOrderByOrderUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type IngestedEmailOrderByOrderUuidQuery = { __typename?: 'Query', scannedOrderResultByOrderUuid?: { __typename?: 'ScannedOrderResultEntity', uuid: string, scannedOrder: { __typename?: 'ScannedOrderEntity', ingestedOutlookEmailDetails: { __typename?: 'IngestedEmailDetailsEntity', attachmentUuid?: string | null, fromAddress?: string | null, subject?: string | null } } } | null };

export type IngestedEmailOrdersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  contactFilterMode?: InputMaybe<CustomerFilterMode>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  emailIntegrationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type IngestedEmailOrdersQuery = { __typename?: 'Query', numberOfScannedOrderResultsInReview: number, numberOfScannedOrderResultDuplicates: number, scannedOrderResults: { __typename?: 'ScannedOrderResultConnection', edges: Array<{ __typename?: 'ScannedOrderResultEdge', node: { __typename?: 'ScannedOrderResultEntity', uuid: string, createdAt: any, status: ScannedOrderResultStatus, signedPodMatchStatus?: SignedPodMatchStatus | null, failureReason?: ScannedOrderFailureReason | null, dismissed: boolean, filename: string, pageEnd: number, pageStart: number, duplicateOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, duplicateScannedOrderResultOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, scannedOrder: { __typename?: 'ScannedOrderEntity', ingestedOutlookEmailDetails: { __typename?: 'IngestedEmailDetailsEntity', attachmentUuid?: string | null, fromAddress?: string | null, subject?: string | null, outlookIntegrationTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type IngestedOutlookEmailQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type IngestedOutlookEmailQuery = { __typename?: 'Query', ingestedOutlookEmail: { __typename?: 'IngestedOutlookEmailEntity', uuid: string, subject?: string | null, attachments: Array<{ __typename?: 'IngestedOutlookEmailAttachmentEntity', uuid: string, attachmentFilename?: string | null, processingStatus: IngestedOutlookEmailAttachmentProcessingStatus, scannedOrder?: { __typename?: 'ScannedOrderEntity', uuid: string, preSignedGetUrl: string, scannedOrderResults: Array<{ __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageStart: number, pageEnd: number, status: ScannedOrderResultStatus, failureReason?: ScannedOrderFailureReason | null, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null, duplicateOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, duplicateScannedOrderResultOrder?: { __typename?: 'StandardOrderEntity', uuid: string, source: OrderSource } | null, scannedOrderResultDocuments: Array<{ __typename?: 'ScannedOrderResultDocumentEntity', uuid: string, preSignedGetUrl: string, scannedOrderResultDocumentPages: Array<{ __typename?: 'ScannedOrderResultDocumentPageEntity', uuid: string, page: number }> }> }> } | null }> } };

export type OutlookIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OutlookIntegrationsQuery = { __typename?: 'Query', outlookIntegrations: Array<{ __typename?: 'OutlookIntegrationEntity', uuid: string, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null }> };

export type UpdateEmailIngestionExclusionsMutationVariables = Exact<{
  updateEmailIngestionExclusionsInput: UpdateEmailIngestionExclusionsInput;
}>;


export type UpdateEmailIngestionExclusionsMutation = { __typename?: 'Mutation', updateEmailIngestionExclusions: { __typename?: 'EmailIngestionExclusionsEntity', excludedDocumentTypes: Array<ClassifiedDocumentType>, excludedCustomers: Array<{ __typename?: 'EmailIngestionExcludedCustomerEntity', uuid: string, displayName: string }> } };

export type AcceptCustomerPortalOrderMutationVariables = Exact<{
  acceptCustomerPortalOrderInput: AcceptCustomerPortalOrderInput;
}>;


export type AcceptCustomerPortalOrderMutation = { __typename?: 'Mutation', acceptCustomerPortalOrder: { __typename?: 'AcceptCustomerPortalOrderSuccessOutput', orderUuid: string, acceptedAt: any } | { __typename?: 'MutationErrorOutput', message: string } };

export type RejectCustomerPortalOrderMutationVariables = Exact<{
  rejectCustomerPortalOrderInput: RejectCustomerPortalOrderInput;
}>;


export type RejectCustomerPortalOrderMutation = { __typename?: 'Mutation', rejectCustomerPortalOrder: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'RejectCustomerPortalOrderSuccessOutput', orderUuid: string, rejectedAt: any } };

export type AcceptEdiOrApiOrderMutationVariables = Exact<{
  acceptEdiOrApiOrderInput: AcceptEdiOrApiOrderInput;
}>;


export type AcceptEdiOrApiOrderMutation = { __typename?: 'Mutation', acceptEdiOrApiOrder: { __typename?: 'AcceptEdiOrApiOrderOutput', uuid: string } };

export type AcceptExpeditorsWorkOrderMutationVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type AcceptExpeditorsWorkOrderMutation = { __typename?: 'Mutation', acceptExpeditorsWorkOrder: boolean };

export type RejectEdiOrderMutationVariables = Exact<{
  rejectEdiOrderInput: RejectEdiOrderInput;
}>;


export type RejectEdiOrderMutation = { __typename?: 'Mutation', rejectEdiOrder: { __typename?: 'RejectEdiOrderOutput', uuid: string } };

export type RejectEdiOrdersMutationVariables = Exact<{
  rejectEdiOrdersInput: RejectEdiOrdersInput;
}>;


export type RejectEdiOrdersMutation = { __typename?: 'Mutation', rejectEdiOrders: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'RejectEdiOrdersSuccess', successfulOrderUuids: Array<string> } };

export type RejectExpeditorsWorkOrderMutationVariables = Exact<{
  orderUuid: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectExpeditorsWorkOrderMutation = { __typename?: 'Mutation', rejectExpeditorsWorkOrder: boolean };

export type AcknowledgeQuoteAttentionMutationVariables = Exact<{
  acknowledgeQuoteAttentionInput: AcknowledgeQuoteAttentionInput;
}>;


export type AcknowledgeQuoteAttentionMutation = { __typename?: 'Mutation', acknowledgeQuoteAttention: { __typename: 'AcknowledgeQuoteAttentionSuccessOutput', orderQuoteUuid: string, status: OrderQuoteStatus } | { __typename: 'MutationErrorOutput', message: string } };

export type ApproveQuoteReplyMutationVariables = Exact<{
  approveQuoteReplyInput: ApproveQuoteReplyInput;
}>;


export type ApproveQuoteReplyMutation = { __typename?: 'Mutation', approveQuoteReply: { __typename: 'ApproveQuoteReplySuccessOutput', orderQuoteUuid: string, draftReplyUuid: string, approvedAt: any } | { __typename: 'MutationErrorOutput', message: string } | { __typename: 'QuoteReplyRefusedOutput', orderQuoteUuid: string, reason: QuoteReplyRefusalReason, message: string, quotedAmountCents?: number | null, currentAmountCents?: number | null } };

export type ConfirmQuoteAcceptanceMutationVariables = Exact<{
  confirmQuoteAcceptanceInput: ConfirmQuoteAcceptanceInput;
}>;


export type ConfirmQuoteAcceptanceMutation = { __typename?: 'Mutation', confirmQuoteAcceptance: { __typename: 'ConfirmQuoteAcceptanceSuccessOutput', orderQuoteUuid: string, status: OrderQuoteStatus, orderUuid?: string | null } | { __typename: 'MutationErrorOutput', message: string } | { __typename: 'QuoteAcceptanceHeldOutput', orderQuoteUuid: string, reason: QuoteAcceptanceHoldReason, message: string, quotedAmountCents?: number | null, currentAmountCents?: number | null } };

export type DeclineQuoteMutationVariables = Exact<{
  declineQuoteInput: DeclineQuoteInput;
}>;


export type DeclineQuoteMutation = { __typename?: 'Mutation', declineQuote: { __typename: 'DeclineQuoteSuccessOutput', orderQuoteUuid: string, status: OrderQuoteStatus } | { __typename: 'MutationErrorOutput', message: string } };

export type DismissQuoteMutationVariables = Exact<{
  dismissQuoteInput: DismissQuoteInput;
}>;


export type DismissQuoteMutation = { __typename?: 'Mutation', dismissQuote: { __typename: 'DismissQuoteSuccessOutput', orderQuoteUuid: string, status: OrderQuoteStatus } | { __typename: 'MutationErrorOutput', message: string } };

export type MarkQuoteSentMutationVariables = Exact<{
  markQuoteSentInput: MarkQuoteSentInput;
}>;


export type MarkQuoteSentMutation = { __typename?: 'Mutation', markQuoteSent: { __typename: 'MarkQuoteSentSuccessOutput', orderQuoteUuid: string, status: OrderQuoteStatus, sentAt: any, validUntil: any, quotedAmountCents: number } | { __typename: 'MutationErrorOutput', message: string } };

export type OrderQuoteForOrderQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type OrderQuoteForOrderQuery = { __typename?: 'Query', orderQuoteForOrder?: { __typename: 'OrderQuote', uuid: string, number?: string | null, status: OrderQuoteStatus, version: number, quotedAmountCents?: number | null, currency?: string | null, validUntil?: any | null, sentAt?: any | null, needsAttentionAt?: any | null, createdAt: any, updatedAt: any, senderAddress: string, senderDisplayName?: string | null, senderRecoveredFromForward: boolean, missingFields: Array<string>, unpriceableReasons: Array<string>, pricingState: string, attentionReasons: Array<QuoteAttentionReason>, draftReplyUuid?: string | null, draftReplyKind?: QuoteDraftReplyKind | null, draftReplyBody?: string | null, draftReplyApprovedAt?: any | null, unsettledEarlierReply?: { __typename: 'OrderQuoteEarlierReply', orderQuoteUuid: string, version: number, draftReplyUuid: string, draftReplyKind: QuoteDraftReplyKind, draftReplyBody: string, draftReplyApprovedAt: any } | null, order?: { __typename: 'OrderQuoteOrderSummary', uuid: string, name: string } | null, customer?: { __typename: 'OrderQuoteCustomer', uuid: string, name: string } | null, customerCandidates: Array<{ __typename: 'OrderQuoteCustomerCandidate', contactUuid: string, contactName: string, isActive: boolean, matchedBy?: string | null }> } | null };

export type OrderQuoteForReviewFragment = { __typename: 'OrderQuote', uuid: string, number?: string | null, status: OrderQuoteStatus, version: number, quotedAmountCents?: number | null, currency?: string | null, validUntil?: any | null, sentAt?: any | null, needsAttentionAt?: any | null, createdAt: any, updatedAt: any, senderAddress: string, senderDisplayName?: string | null, senderRecoveredFromForward: boolean, missingFields: Array<string>, unpriceableReasons: Array<string>, pricingState: string, attentionReasons: Array<QuoteAttentionReason>, draftReplyUuid?: string | null, draftReplyKind?: QuoteDraftReplyKind | null, draftReplyBody?: string | null, draftReplyApprovedAt?: any | null, unsettledEarlierReply?: { __typename: 'OrderQuoteEarlierReply', orderQuoteUuid: string, version: number, draftReplyUuid: string, draftReplyKind: QuoteDraftReplyKind, draftReplyBody: string, draftReplyApprovedAt: any } | null, order?: { __typename: 'OrderQuoteOrderSummary', uuid: string, name: string } | null, customer?: { __typename: 'OrderQuoteCustomer', uuid: string, name: string } | null, customerCandidates: Array<{ __typename: 'OrderQuoteCustomerCandidate', contactUuid: string, contactName: string, isActive: boolean, matchedBy?: string | null }> };

export type OrderQuotesNeedingActionCountQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderQuotesNeedingActionCountQuery = { __typename?: 'Query', orderQuotesNeedingActionCount: number };

export type PickQuoteCustomerMutationVariables = Exact<{
  pickQuoteCustomerInput: PickQuoteCustomerInput;
}>;


export type PickQuoteCustomerMutation = { __typename?: 'Mutation', pickQuoteCustomer: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'PickQuoteCustomerSuccessOutput', orderQuote: { __typename?: 'OrderQuote', uuid: string, status: OrderQuoteStatus, order?: { __typename?: 'OrderQuoteOrderSummary', uuid: string, name: string } | null } } };

export type QuoteConversationQueryVariables = Exact<{
  orderQuoteUuid: Scalars['String']['input'];
}>;


export type QuoteConversationQuery = { __typename?: 'Query', quoteConversation?: { __typename: 'QuoteConversationEntity', uuid: string, subject: string, status: string, createdAt: any, lastInboundAt?: any | null, lastOutboundAt?: any | null, messageCount: number, messagesTruncated: boolean, messages: Array<{ __typename: 'QuoteConversationMessageEntity', uuid: string, direction: string, senderRecoveredFromForward: boolean, to: Array<string>, cc: Array<string>, subject: string, receivedAt: any, classification?: string | null, bodyText?: string | null, bodyTruncated: boolean, bodyState: string, from: { __typename?: 'QuoteConversationPartyEntity', address: string, name?: string | null }, originalSender?: { __typename?: 'QuoteConversationPartyEntity', address: string, name?: string | null } | null, attachments: Array<{ __typename?: 'QuoteConversationAttachmentEntity', filename?: string | null, contentType?: string | null }> }> } | null };

export type RejectQuoteReplyMutationVariables = Exact<{
  rejectQuoteReplyInput: RejectQuoteReplyInput;
}>;


export type RejectQuoteReplyMutation = { __typename?: 'Mutation', rejectQuoteReply: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'QuoteReplyRefusedOutput', orderQuoteUuid: string, reason: QuoteReplyRefusalReason, message: string, quotedAmountCents?: number | null, currentAmountCents?: number | null } | { __typename: 'RejectQuoteReplySuccessOutput', orderQuoteUuid: string } };

export type RequestQuoteRepriceMutationVariables = Exact<{
  requestQuoteRepriceInput: RequestQuoteRepriceInput;
}>;


export type RequestQuoteRepriceMutation = { __typename?: 'Mutation', requestQuoteReprice: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'RequestQuoteRepriceSuccessOutput', orderQuote: { __typename: 'OrderQuote', uuid: string, number?: string | null, status: OrderQuoteStatus, version: number, quotedAmountCents?: number | null, currency?: string | null, validUntil?: any | null, sentAt?: any | null, needsAttentionAt?: any | null, createdAt: any, updatedAt: any, senderAddress: string, senderDisplayName?: string | null, senderRecoveredFromForward: boolean, missingFields: Array<string>, unpriceableReasons: Array<string>, pricingState: string, attentionReasons: Array<QuoteAttentionReason>, draftReplyUuid?: string | null, draftReplyKind?: QuoteDraftReplyKind | null, draftReplyBody?: string | null, draftReplyApprovedAt?: any | null, unsettledEarlierReply?: { __typename: 'OrderQuoteEarlierReply', orderQuoteUuid: string, version: number, draftReplyUuid: string, draftReplyKind: QuoteDraftReplyKind, draftReplyBody: string, draftReplyApprovedAt: any } | null, order?: { __typename: 'OrderQuoteOrderSummary', uuid: string, name: string } | null, customer?: { __typename: 'OrderQuoteCustomer', uuid: string, name: string } | null, customerCandidates: Array<{ __typename: 'OrderQuoteCustomerCandidate', contactUuid: string, contactName: string, isActive: boolean, matchedBy?: string | null }> } } };

export type RequoteQuoteAtCurrentPriceMutationVariables = Exact<{
  requoteQuoteAtCurrentPriceInput: RequoteQuoteAtCurrentPriceInput;
}>;


export type RequoteQuoteAtCurrentPriceMutation = { __typename?: 'Mutation', requoteQuoteAtCurrentPrice: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'QuoteReplyRefusedOutput', orderQuoteUuid: string, reason: QuoteReplyRefusalReason, message: string, quotedAmountCents?: number | null, currentAmountCents?: number | null } | { __typename: 'RequoteQuoteAtCurrentPriceSuccessOutput', orderQuoteUuid: string, supersededOrderQuoteUuid: string, version: number } };

export type ResolveQuoteReplySendMutationVariables = Exact<{
  resolveQuoteReplySendInput: ResolveQuoteReplySendInput;
}>;


export type ResolveQuoteReplySendMutation = { __typename?: 'Mutation', resolveQuoteReplySend: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'QuoteReplyRefusedOutput', orderQuoteUuid: string, reason: QuoteReplyRefusalReason, message: string, quotedAmountCents?: number | null, currentAmountCents?: number | null } | { __typename: 'ResolveQuoteReplySendSuccessOutput', orderQuoteUuid: string, draftReplyUuid: string, outcome: QuoteReplySendOutcome } };

export type AccessorialForCustomChargeRowQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AccessorialForCustomChargeRowQuery = { __typename?: 'Query', accessorial: { __typename?: 'AttemptsAccessorialEntity' } | { __typename?: 'PercentageAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'StorageDaysAccessorialEntity' } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string } };

export type AccessorialsForCustomChargeRowQueryVariables = Exact<{
  billingPartyContactUuid: Scalars['String']['input'];
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccessorialsForCustomChargeRowQuery = { __typename?: 'Query', accessorialsByBillingContact: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, enableQuickAdd: boolean }> };

export type ApplyDelegationAccessorialProposalMutationVariables = Exact<{
  input: ApplyDelegationAccessorialProposalInput;
}>;


export type ApplyDelegationAccessorialProposalMutation = { __typename?: 'Mutation', applyDelegationAccessorialProposal: { __typename: 'DelegationAccessorialProposalEntity', uuid: string, delegationUuid: string, executingCompanyName: string, name: string, quantity: number, status: DelegationAccessorialProposalStatus, mappedAccessorialUuid?: string | null, mappedAccessorialName?: string | null, mappedAccessorialType?: AccessorialType | null, suggestedZoneBasedMatrixItemUuid?: string | null, appliedCustomChargeUuid?: string | null, decidedAt?: any | null, originalChargesFinalized: boolean } };

export type DelegationAccessorialProposalFieldsFragment = { __typename: 'DelegationAccessorialProposalEntity', uuid: string, delegationUuid: string, executingCompanyName: string, name: string, quantity: number, status: DelegationAccessorialProposalStatus, mappedAccessorialUuid?: string | null, mappedAccessorialName?: string | null, mappedAccessorialType?: AccessorialType | null, suggestedZoneBasedMatrixItemUuid?: string | null, appliedCustomChargeUuid?: string | null, decidedAt?: any | null, originalChargesFinalized: boolean };

export type DelegationAccessorialProposalsQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type DelegationAccessorialProposalsQuery = { __typename?: 'Query', delegationAccessorialProposals: Array<{ __typename: 'DelegationAccessorialProposalEntity', uuid: string, delegationUuid: string, executingCompanyName: string, name: string, quantity: number, status: DelegationAccessorialProposalStatus, mappedAccessorialUuid?: string | null, mappedAccessorialName?: string | null, mappedAccessorialType?: AccessorialType | null, suggestedZoneBasedMatrixItemUuid?: string | null, appliedCustomChargeUuid?: string | null, decidedAt?: any | null, originalChargesFinalized: boolean }> };

export type DismissDelegationAccessorialProposalMutationVariables = Exact<{
  input: DismissDelegationAccessorialProposalInput;
}>;


export type DismissDelegationAccessorialProposalMutation = { __typename?: 'Mutation', dismissDelegationAccessorialProposal: { __typename: 'DelegationAccessorialProposalEntity', uuid: string, delegationUuid: string, executingCompanyName: string, name: string, quantity: number, status: DelegationAccessorialProposalStatus, mappedAccessorialUuid?: string | null, mappedAccessorialName?: string | null, mappedAccessorialType?: AccessorialType | null, suggestedZoneBasedMatrixItemUuid?: string | null, appliedCustomChargeUuid?: string | null, decidedAt?: any | null, originalChargesFinalized: boolean } };

export type PiecesGroupedByStatusQueryVariables = Exact<{
  piecesGroupedByStatusInput: PiecesGroupedByStatusInput;
}>;


export type PiecesGroupedByStatusQuery = { __typename?: 'Query', piecesGroupedByStatus: { __typename?: 'PiecesGroupedByStatusOutput', pieceGroups: Array<{ __typename?: 'PieceGroupEntity', status: PieceStatus, pieceCount: number, terminal?: { __typename?: 'TerminalEntity', code: string } | null }> } };

export type SendStopToAgentMutationVariables = Exact<{
  sendStopToAgentInput: SendStopToAgentInput;
}>;


export type SendStopToAgentMutation = { __typename?: 'Mutation', sendStopToAgent: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'SendStopToAgentSuccessOutput', stop: { __typename?: 'StandardStopEntity', uuid: string } } };

export type UpdatePieceCountMutationVariables = Exact<{
  updatePieceCountInput: UpdatePieceCountInput;
}>;


export type UpdatePieceCountMutation = { __typename?: 'Mutation', updatePieceCount: { __typename?: 'StandardOrderEntity', uuid: string } };

export type VehicleTypeCapacityQueryVariables = Exact<{
  vehicleTypeUuid: Scalars['String']['input'];
}>;


export type VehicleTypeCapacityQuery = { __typename?: 'Query', vehicleType: { __typename?: 'VehicleTypeEntity', uuid: string, capacityNotes?: string | null, maxWeight?: any | null, maxVolume?: any | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } };

export type StopForUnifiedSearchFragment = { __typename?: 'StandardStopEntity', completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any } | null } | null };

export type UnifiedSearchOrdersQueryVariables = Exact<{
  unifiedSearchInput: UnifiedSearchInput;
}>;


export type UnifiedSearchOrdersQuery = { __typename?: 'Query', unifiedSearchOrders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, startStop?: { __typename?: 'StandardStopEntity', completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any } | null } | null } | null, endStop?: { __typename?: 'StandardStopEntity', completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any } | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UnifiedSearchOrdersFragment = { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, startStop?: { __typename?: 'StandardStopEntity', completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any } | null } | null } | null, endStop?: { __typename?: 'StandardStopEntity', completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any } | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type UnifiedSearchUnacceptedEmailOrdersQueryVariables = Exact<{
  unifiedSearchInput: UnifiedSearchInput;
}>;


export type UnifiedSearchUnacceptedEmailOrdersQuery = { __typename?: 'Query', unifiedSearchUnacceptedEmailOrders: { __typename?: 'ScannedOrderResultConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ScannedOrderResultEdge', node: { __typename?: 'ScannedOrderResultEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null } } | null, scannedOrder: { __typename?: 'ScannedOrderEntity', ingestedOutlookEmailDetails: { __typename?: 'IngestedEmailDetailsEntity', fromAddress?: string | null, subject?: string | null, receivedAt?: any | null } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UnifiedSearchUnacceptedEmailOrdersFragment = { __typename?: 'ScannedOrderResultConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ScannedOrderResultEdge', node: { __typename?: 'ScannedOrderResultEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null } } | null, scannedOrder: { __typename?: 'ScannedOrderEntity', ingestedOutlookEmailDetails: { __typename?: 'IngestedEmailDetailsEntity', fromAddress?: string | null, subject?: string | null, receivedAt?: any | null } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type UnifiedSearchUnacceptedEdiAndApiOrdersQueryVariables = Exact<{
  unifiedSearchInput: UnifiedSearchInput;
}>;


export type UnifiedSearchUnacceptedEdiAndApiOrdersQuery = { __typename?: 'Query', unifiedSearchUnacceptedEdiAndApiOrders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UnifiedSearchUnacceptedEdiAndApiOrdersFragment = { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type UnifiedSearchQuotesQueryVariables = Exact<{
  unifiedSearchInput: UnifiedSearchInput;
}>;


export type UnifiedSearchQuotesQuery = { __typename?: 'Query', unifiedSearchQuotes: { __typename?: 'QuoteConnection', totalCount?: number | null, edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'QuoteEntity', uuid: string, number: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UnifiedSearchQuotesFragment = { __typename?: 'QuoteConnection', totalCount?: number | null, edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'QuoteEntity', uuid: string, number: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type UnifiedSearchInvoicesQueryVariables = Exact<{
  unifiedSearchInput: UnifiedSearchInput;
}>;


export type UnifiedSearchInvoicesQuery = { __typename?: 'Query', unifiedSearchInvoices: { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, date: any, name: string, journalNumber: number, balanceInCents: number, balanceInDollars: number, invoiceTotal: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UnifiedSearchInvoicesFragment = { __typename?: 'InvoiceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'InvoiceEdge', node: { __typename?: 'InvoiceEntity', uuid: string, date: any, name: string, journalNumber: number, balanceInCents: number, balanceInDollars: number, invoiceTotal: string, billToContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } };

export type CreateInvoiceDocumentMutationVariables = Exact<{
  createInvoiceDocumentInput: CreateInvoiceDocumentInput;
}>;


export type CreateInvoiceDocumentMutation = { __typename?: 'Mutation', createInvoiceDocument: { __typename?: 'DocumentEntity', uuid: string, bucket: string, region: string, key: string, fileName: string, fileType: string, type: DocumentType } };

export type CreateOrderDocumentMutationVariables = Exact<{
  createOrderDocumentInput: CreateOrderDocumentInput;
}>;


export type CreateOrderDocumentMutation = { __typename?: 'Mutation', createOrderDocument: { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, preSignedGetUrl: string, fileType: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, notes?: string | null, dateUploadedFor?: any | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string } | null } };

export type ApiLogFragment = { __typename?: 'ApiLogEntity', uuid: string, createdAt: any, updatedAt: any, responseStatus?: ApiResponseStatus | null, sourceIpAddress?: string | null, direction: ApiRequestDirection, freightSnapTransaction?: { __typename?: 'FreightSnapTransactionEntity', uuid: string, status?: FreightSnapTransactionStatus | null, failureReason?: FreightSnapFailureReason | null, proNum?: string | null, ehdim?: string | null, eldim?: string | null, ewdim?: string | null, weight?: string | null, imgs: Array<string>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', emailTransactionStatus: EmailTransactionStatus, emailResponseStatus?: number | null, failureReason?: string | null, pdfNotAttached: boolean, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, document: { __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } | null, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null };

export type ApiLogsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<Array<DateFilter> | DateFilter>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoiceEmails: Scalars['Boolean']['input'];
  invoiceUuid?: InputMaybe<Scalars['String']['input']>;
  emailTransactionStatus?: InputMaybe<EmailTransactionStatus>;
  isFreightSnap: Scalars['Boolean']['input'];
  freightSnapTransactionStatus?: InputMaybe<FreightSnapTransactionStatus>;
  freightSnapFailureReason?: InputMaybe<FreightSnapFailureReason>;
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApiLogsQuery = { __typename?: 'Query', apiLogs: { __typename?: 'ApiLogConnection', totalCount: number, edges: Array<{ __typename?: 'ApiLogEdge', node: { __typename?: 'ApiLogEntity', uuid: string, createdAt: any, updatedAt: any, responseStatus?: ApiResponseStatus | null, sourceIpAddress?: string | null, direction: ApiRequestDirection, freightSnapTransaction?: { __typename?: 'FreightSnapTransactionEntity', uuid: string, status?: FreightSnapTransactionStatus | null, failureReason?: FreightSnapFailureReason | null, proNum?: string | null, ehdim?: string | null, eldim?: string | null, ewdim?: string | null, weight?: string | null, imgs: Array<string>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, emailTransaction?: { __typename?: 'EmailTransactionEntity', emailTransactionStatus: EmailTransactionStatus, emailResponseStatus?: number | null, failureReason?: string | null, pdfNotAttached: boolean, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, document: { __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } | null, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type EmailTransactionFragment = { __typename?: 'EmailTransactionEntity', emailTransactionStatus: EmailTransactionStatus, emailResponseStatus?: number | null, failureReason?: string | null, pdfNotAttached: boolean, company: { __typename?: 'CompanyEntity', uuid: string, name: string }, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, document: { __typename?: 'DocumentEntity', uuid: string, preSignedGetUrl: string }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number } | null, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> };

export type FreightSnapTransactionFragment = { __typename?: 'FreightSnapTransactionEntity', uuid: string, status?: FreightSnapTransactionStatus | null, failureReason?: FreightSnapFailureReason | null, proNum?: string | null, ehdim?: string | null, eldim?: string | null, ewdim?: string | null, weight?: string | null, imgs: Array<string>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null };

export type MatchFreightSnapMutationVariables = Exact<{
  freightSnapCreateInput: FreightSnapCreateInput;
}>;


export type MatchFreightSnapMutation = { __typename?: 'Mutation', matchFreightSnap?: { __typename?: 'FreightSnapTransactionEntity', uuid: string, status?: FreightSnapTransactionStatus | null, failureReason?: FreightSnapFailureReason | null, proNum?: string | null, ehdim?: string | null, eldim?: string | null, ewdim?: string | null, weight?: string | null, imgs: Array<string>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null };

export type ShipmentForArrivalNoticeFragment = { __typename?: 'StandardShipmentEntity', totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalChargesAmount: number, shipmentType: ShipmentType, hideFromBilling: boolean, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', code: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null } }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, total: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, charges: Array<{ __typename?: 'CustomChargeEntity' } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null }> };

export type PackageForArrivalNoticeFragment = { __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null };

export type OrderForArrivalNoticeFragment = { __typename?: 'StandardOrderEntity', uuid: string, itTeNumber?: string | null, externalNotes?: string | null, hazmat: boolean, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, isCrossDock?: boolean | null, totalCharge: number, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits, measurementUnits: MeasurementUnits }, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', name: string }>, service?: { __typename?: 'ServiceEntity', name: string } | null, company: { __typename?: 'CompanyEntity', name: string, phone?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalChargesAmount: number, shipmentType: ShipmentType, hideFromBilling: boolean, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', code: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null } }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, total: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, charges: Array<{ __typename?: 'CustomChargeEntity' } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null }> }> };

export type OrdersForArrivalNoticesQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersForArrivalNoticesQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, itTeNumber?: string | null, externalNotes?: string | null, hazmat: boolean, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, isCrossDock?: boolean | null, totalCharge: number, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits, measurementUnits: MeasurementUnits }, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', name: string }>, service?: { __typename?: 'ServiceEntity', name: string } | null, company: { __typename?: 'CompanyEntity', name: string, phone?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalChargesAmount: number, shipmentType: ShipmentType, hideFromBilling: boolean, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', code: string, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null } }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, name: string, total: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null }>, charges: Array<{ __typename?: 'CustomChargeEntity' } | { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null }> }> }> };

export type ArriveAtStopsMutationVariables = Exact<{
  arriveAtStopsInput: ArriveAtStopsInput;
}>;


export type ArriveAtStopsMutation = { __typename?: 'Mutation', arriveAtStops: { __typename?: 'ArriveAtStopsSuccessOutput', arrivedStopUuids: Array<string>, failedStopUuids: Array<string> } | { __typename?: 'MutationErrorOutput', message: string } };

export type AttemptStopsForDriverSettlementQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type AttemptStopsForDriverSettlementQuery = { __typename?: 'Query', leg?: { __typename?: 'LegEntity', previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> } | null };

export type BulkEditOrdersMutationVariables = Exact<{
  bulkEditOrdersInput: BulkEditOrdersInput;
}>;


export type BulkEditOrdersMutation = { __typename?: 'Mutation', bulkEditOrders: { __typename?: 'BulkEditOrdersResponse', success: boolean, orderStateActions?: Array<{ __typename?: 'OrderActionResult', action: OrderAction, results: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } }> | null, stopStateActions?: Array<{ __typename?: 'StopActionResult', action: StopAction, results: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } }> | null } };

export type ClearOrderExecutedByMutationVariables = Exact<{
  input: ClearOrderExecutedByInput;
}>;


export type ClearOrderExecutedByMutation = { __typename?: 'Mutation', clearOrderExecutedBy: boolean };

export type CoverSheetDocumentTypeSequenceFragment = { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> };

export type CoverSheetDocumentTypeSequencesQueryVariables = Exact<{ [key: string]: never; }>;


export type CoverSheetDocumentTypeSequencesQuery = { __typename?: 'Query', coverSheetDocumentTypeSequences: Array<{ __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> }> };

export type CreateCoverSheetDocumentTypeSequenceMutationVariables = Exact<{
  input: CoverSheetDocumentTypeSequenceCreateInput;
}>;


export type CreateCoverSheetDocumentTypeSequenceMutation = { __typename?: 'Mutation', createCoverSheetDocumentTypeSequence: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string } };

export type OrderCoverSheetShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserActorEntity', email?: string | null } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, service?: { __typename?: 'ServiceEntity', name: string } | null } | null };

export type OrderCoverSheetsQueryVariables = Exact<{
  getShipmentsInput?: InputMaybe<GetShipmentsInput>;
}>;


export type OrderCoverSheetsQuery = { __typename?: 'Query', shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserActorEntity', email?: string | null } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null }, service?: { __typename?: 'ServiceEntity', name: string } | null } | null }> };

export type OrderEventForCoverSheetFragment = { __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserActorEntity', email?: string | null } | null };

export type ShipmentForCoverSheetFragment = { __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, ordinal: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, isSpecial?: boolean | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> };

export type OrderForCoverSheetFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, inBond: boolean, itTeNumber?: string | null, hazmat: boolean, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, service?: { __typename?: 'ServiceEntity', name: string } | null, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserActorEntity', email?: string | null } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null, weightUnits: WeightUnits, measurementUnits: MeasurementUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, ordinal: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, isSpecial?: boolean | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> };

export type OrderInfoForCoverSheetFragment = { __typename?: 'StandardOrderEntity', uuid: string, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserActorEntity', email?: string | null } | null }> };

export type OrderInfosForCoverSheetsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrderInfosForCoverSheetsQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserActorEntity', email?: string | null } | null }> }> };

export type OrdersForCoverSheetsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersForCoverSheetsQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, inBond: boolean, itTeNumber?: string | null, hazmat: boolean, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, service?: { __typename?: 'ServiceEntity', name: string } | null, coverSheetDocumentTypeSequence?: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string, name: string, type: CoverSheetDocumentTypeSequenceType, documentTypes: Array<DocumentType> } | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserActorEntity', email?: string | null } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null, weightUnits: WeightUnits, measurementUnits: MeasurementUnits }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, ordinal: number, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, serviceDate?: any | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, isSpecial?: boolean | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> }> };

export type RemoveCoverSheetDocumentTypeSequenceMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveCoverSheetDocumentTypeSequenceMutation = { __typename?: 'Mutation', removeCoverSheetDocumentTypeSequence: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string } };

export type UpdateCoverSheetDocumentTypeSequenceMutationVariables = Exact<{
  input: CoverSheetDocumentTypeSequenceUpdateInput;
}>;


export type UpdateCoverSheetDocumentTypeSequenceMutation = { __typename?: 'Mutation', updateCoverSheetDocumentTypeSequence: { __typename?: 'CoverSheetDocumentTypeSequenceEntity', uuid: string } };

export type CreateAccountingReportDocumentMutationVariables = Exact<{
  createAccountingReportDocumentInput: CreateBasicDocumentInput;
}>;


export type CreateAccountingReportDocumentMutation = { __typename?: 'Mutation', createAccountingReportDocument: { __typename?: 'CreateAccountingReportDocumentOutput', document: { __typename?: 'DocumentEntity', uuid: string, bucket: string, region: string, key: string, fileName: string, fileType: string, type: DocumentType } } };

export type CreateEodDocumentsMutationVariables = Exact<{
  createEodDocumentsInput: CreateEodDocumentsInput;
}>;


export type CreateEodDocumentsMutation = { __typename?: 'Mutation', createEODDocuments: Array<{ __typename?: 'DocumentEntity', uuid: string }> };

export type CreateOrderCommentMutationVariables = Exact<{
  createOrderCommentInput: CreateOrderCommentInput;
}>;


export type CreateOrderCommentMutation = { __typename?: 'Mutation', createOrderComment: { __typename?: 'OrderCommentEntity', uuid: string } };

export type CreateOrderDocumentDocumentMutationVariables = Exact<{
  createOrderDocumentDocumentInput: CreateOrderDocumentDocumentInput;
}>;


export type CreateOrderDocumentDocumentMutation = { __typename?: 'Mutation', createOrderDocumentDocument: { __typename?: 'CreateOrderDocumentDocumentOutput', document: { __typename?: 'DocumentEntity', uuid: string, bucket: string, region: string, key: string, fileName: string, fileType: string, type: DocumentType } } };

export type CreateOrderSnapshotMutationVariables = Exact<{
  orderEventSnapshotCreateInput: OrderEventSnapshotCreateInput;
}>;


export type CreateOrderSnapshotMutation = { __typename?: 'Mutation', createOrderSnapshot?: { __typename?: 'OrderEventEntity', uuid: string } | null };

export type CreateOrdersFromRecurringTemplatesMutationVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateOrdersFromRecurringTemplatesMutation = { __typename?: 'Mutation', createOrdersFromRecurringTemplates: Array<{ __typename?: 'StandardOrderEntity', uuid: string }> };

export type CreatePodReportDocumentMutationVariables = Exact<{
  createPodReportDocumentInput: CreatePodReportDocumentInput;
}>;


export type CreatePodReportDocumentMutation = { __typename?: 'Mutation', createPODReportDocument: { __typename?: 'CreatePodReportDocumentOutput', document: { __typename?: 'DocumentEntity', uuid: string, bucket: string, region: string, key: string, fileName: string, fileType: string, type: DocumentType } } };

export type CreateRecurringRunMutationVariables = Exact<{
  input: CreateRunInput;
}>;


export type CreateRecurringRunMutation = { __typename?: 'Mutation', createRun: { __typename?: 'CreateRunOutput', run: { __typename?: 'RunEntity', uuid: string } } };

export type CreateScannedOrdersMutationVariables = Exact<{
  createScannedOrdersInput: CreateScannedOrdersInput;
}>;


export type CreateScannedOrdersMutation = { __typename?: 'Mutation', createScannedOrders: Array<string> };

export type MatchSignedPoDsMutationVariables = Exact<{
  matchSignedPODsInput: CreateScannedOrdersInput;
}>;


export type MatchSignedPoDsMutation = { __typename?: 'Mutation', matchSignedPODs: boolean };

export type CreateStandardOrderMutationVariables = Exact<{
  createStandardOrderInput: CreateStandardOrderInput;
}>;


export type CreateStandardOrderMutation = { __typename?: 'Mutation', createStandardOrder: { __typename?: 'StandardOrderEntity', uuid: string } };

export type CreateStandardOrderWithDuplicateResolutionMutationVariables = Exact<{
  createStandardOrderInput: CreateStandardOrderInput;
}>;


export type CreateStandardOrderWithDuplicateResolutionMutation = { __typename?: 'Mutation', createStandardOrderWithDuplicateResolution: { __typename?: 'StandardOrderEntity', uuid: string } };

export type CreateTagMutationVariables = Exact<{
  createTagInput: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'TagEntity', uuid: string } };

export type CreateOrUpdateCsvOrdersOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string };

export type CreateOrUpdateCsvOrdersMutationVariables = Exact<{
  createOrUpdateCsvOrdersInput: CreateOrUpdateCsvOrdersInput;
}>;


export type CreateOrUpdateCsvOrdersMutation = { __typename?: 'Mutation', createOrUpdateCsvOrders: { __typename: 'CreateOrUpdateCsvOrdersSuccessOutput', orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }> } | { __typename: 'MutationErrorOutput', message: string } };

export type CsvOrderMappingFragment = { __typename?: 'CsvOrderMappingEntity', uuid: string, name: string };

export type CsvOrderMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CsvOrderMappingsQuery = { __typename?: 'Query', csvOrderMappings: Array<{ __typename?: 'CsvOrderMappingEntity', uuid: string, name: string }> };

export type CsvOrderPreSignedPutUrlFragment = { __typename?: 'CsvOrderPreSignedPutUrlEntity', url: string, bucket: string, key: string, filename: string, filetype: string };

export type GenerateCsvOrderPreSignedPutUrlsQueryVariables = Exact<{
  generateCsvOrderPresignedPutUrlInputs: Array<GenerateCsvOrderPresignedPutUrlInput> | GenerateCsvOrderPresignedPutUrlInput;
}>;


export type GenerateCsvOrderPreSignedPutUrlsQuery = { __typename?: 'Query', generateCsvOrderPreSignedPutUrls: Array<{ __typename?: 'CsvOrderPreSignedPutUrlEntity', url: string, bucket: string, key: string, filename: string, filetype: string }> };

type ParseCsvOrdersContact_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', uuid: string, displayName: string };

type ParseCsvOrdersContact_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string };

export type ParseCsvOrdersContactFragment = ParseCsvOrdersContact_CustomerContactEntity_Fragment | ParseCsvOrdersContact_ThirdPartyContactEntity_Fragment;

export type ParseCsvOrdersOrderUpdateFragment = { __typename?: 'ParsedCsvOrderUpdateEntity', uuid: string, shipperBillOfLadingNumber: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, packages: Array<{ __typename?: 'ParsedCsvOrderPackageEntity', description: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, class?: number | null, freightClass?: FreightClass | null, nmfc?: string | null, uuid: string, isNew?: boolean | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }> };

export type ParseCsvOrdersOrderFragment = { __typename?: 'ParsedCsvOrderEntity', customerReferenceNumber?: string | null, shipperBillOfLadingNumber: string, masterAirwayBillOfLadingNumber?: string | null, referenceNumber?: string | null, notes?: string | null, dimFactor?: number | null, freightChargeRate?: number | null, freightChargeType?: FreightBillingMethod | null, fuelSurcharge?: number | null, fuelChargeType?: FuelBillingMethod | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, inboundStop?: { __typename?: 'ParsedCsvOrderStopEntity', pickupOrDelivery: PickupOrDelivery, addressName: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, contactPersonFirstName?: string | null, contactPersonLastName?: string | null, contactPersonPhone?: string | null, contactPersonEmail?: string | null, specialInstructions?: string | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null, serviceDate: any, appointmentRequired: boolean, terminalName?: string | null, driverName?: string | null, driverReferenceNumber?: string | null, serviceDateV2: { __typename?: 'PlainDate', iso8601: string }, appointmentStartTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, appointmentEndTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null } | null, outboundStop?: { __typename?: 'ParsedCsvOrderStopEntity', pickupOrDelivery: PickupOrDelivery, addressName: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, contactPersonFirstName?: string | null, contactPersonLastName?: string | null, contactPersonPhone?: string | null, contactPersonEmail?: string | null, specialInstructions?: string | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null, serviceDate: any, appointmentRequired: boolean, terminalName?: string | null, driverName?: string | null, driverReferenceNumber?: string | null, serviceDateV2: { __typename?: 'PlainDate', iso8601: string }, appointmentStartTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, appointmentEndTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null } | null, packages: Array<{ __typename?: 'ParsedCsvOrderPackageEntity', description: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, class?: number | null, freightClass?: FreightClass | null, nmfc?: string | null, uuid: string, isNew?: boolean | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }> };

export type ParseCsvOrdersPackageFragment = { __typename?: 'ParsedCsvOrderPackageEntity', description: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, class?: number | null, freightClass?: FreightClass | null, nmfc?: string | null, uuid: string, isNew?: boolean | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null };

export type ParseCsvOrdersRowErrorFragment = { __typename?: 'ParseCsvOrderRowErrorEntity', row: number, message: string };

export type ParseCsvOrdersServiceFragment = { __typename?: 'ServiceEntity', uuid: string, name: string };

export type ParseCsvOrdersStopFragment = { __typename?: 'ParsedCsvOrderStopEntity', pickupOrDelivery: PickupOrDelivery, addressName: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, contactPersonFirstName?: string | null, contactPersonLastName?: string | null, contactPersonPhone?: string | null, contactPersonEmail?: string | null, specialInstructions?: string | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null, serviceDate: any, appointmentRequired: boolean, terminalName?: string | null, driverName?: string | null, driverReferenceNumber?: string | null, serviceDateV2: { __typename?: 'PlainDate', iso8601: string }, appointmentStartTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, appointmentEndTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null };

export type ParseCsvOrdersMutationVariables = Exact<{
  parseCsvOrdersInput: ParseCsvOrdersInput;
}>;


export type ParseCsvOrdersMutation = { __typename?: 'Mutation', parseCsvOrders: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'ParseCsvOrdersSuccessOutput', enableInboundStop: boolean, enableOutboundStop: boolean, parsedOrders: Array<{ __typename?: 'ParsedCsvOrderEntity', customerReferenceNumber?: string | null, shipperBillOfLadingNumber: string, masterAirwayBillOfLadingNumber?: string | null, referenceNumber?: string | null, notes?: string | null, dimFactor?: number | null, freightChargeRate?: number | null, freightChargeType?: FreightBillingMethod | null, fuelSurcharge?: number | null, fuelChargeType?: FuelBillingMethod | null, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, serviceLevel?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, inboundStop?: { __typename?: 'ParsedCsvOrderStopEntity', pickupOrDelivery: PickupOrDelivery, addressName: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, contactPersonFirstName?: string | null, contactPersonLastName?: string | null, contactPersonPhone?: string | null, contactPersonEmail?: string | null, specialInstructions?: string | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null, serviceDate: any, appointmentRequired: boolean, terminalName?: string | null, driverName?: string | null, driverReferenceNumber?: string | null, serviceDateV2: { __typename?: 'PlainDate', iso8601: string }, appointmentStartTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, appointmentEndTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null } | null, outboundStop?: { __typename?: 'ParsedCsvOrderStopEntity', pickupOrDelivery: PickupOrDelivery, addressName: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, contactPersonFirstName?: string | null, contactPersonLastName?: string | null, contactPersonPhone?: string | null, contactPersonEmail?: string | null, specialInstructions?: string | null, deadlineDate?: any | null, deadlineType?: DeadlineType | null, serviceDate: any, appointmentRequired: boolean, terminalName?: string | null, driverName?: string | null, driverReferenceNumber?: string | null, serviceDateV2: { __typename?: 'PlainDate', iso8601: string }, appointmentStartTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, appointmentEndTime?: { __typename?: 'PlainTime', hour: number, minute: number } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null } | null, packages: Array<{ __typename?: 'ParsedCsvOrderPackageEntity', description: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, class?: number | null, freightClass?: FreightClass | null, nmfc?: string | null, uuid: string, isNew?: boolean | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }> }>, parsedOrderUpdates: Array<{ __typename?: 'ParsedCsvOrderUpdateEntity', uuid: string, shipperBillOfLadingNumber: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, packages: Array<{ __typename?: 'ParsedCsvOrderPackageEntity', description: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, class?: number | null, freightClass?: FreightClass | null, nmfc?: string | null, uuid: string, isNew?: boolean | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }> }>, errors: Array<{ __typename?: 'ParseCsvOrderRowErrorEntity', row: number, message: string }> } };

export type CurrentOrderStatusQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CurrentOrderStatusQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', detailedStatusV2?: OrderDetailedStatus | null, updatedAt: any } | null };

export type CurrentOrderStatusFragment = { __typename?: 'StandardOrderEntity', detailedStatusV2?: OrderDetailedStatus | null, updatedAt: any };

export type CustomChargeForOrderFragment = { __typename?: 'CustomChargeEntity', name: string, total: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null };

export type DelegationEndCustomerMatchQueryVariables = Exact<{
  input: DelegationEndCustomerMatchInput;
}>;


export type DelegationEndCustomerMatchQuery = { __typename?: 'Query', delegationEndCustomerMatch: boolean };

export type DeleteOrderMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder?: { __typename?: 'StandardOrderEntity', uuid: string } | null };

export type DocumentExtractionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentExtractionStatusQuery = { __typename?: 'Query', documentExtractionStatus: { __typename?: 'DocumentExtractionStatus', paused: boolean, estimatedResumeAt?: any | null, parkedCount: number } };

export type DocumentsByOrderQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type DocumentsByOrderQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> };

export type DuplicateMergeCandidatesQueryVariables = Exact<{
  shipperBillOfLadingNumber: Scalars['String']['input'];
  billingPartyContactUuid: Scalars['String']['input'];
  excludeOrderUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type DuplicateMergeCandidatesQuery = { __typename?: 'Query', duplicateMergeCandidates: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, createdAt: any }> };

export type EdiAndApiOrdersForReviewQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  sortByCreatedAtDateAsc?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type EdiAndApiOrdersForReviewQuery = { __typename?: 'Query', ediAndApiOrdersForReview: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', createdAt: any, uuid: string, source: OrderSource, name: string, ediServiceLevelCode?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, ediReferences?: Array<{ __typename?: 'EdiReferenceEntity', qualifier: string, value: string, target?: EdiReferenceTarget | null, label?: string | null }> | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type EdiTransactionFragmentFragment = { __typename?: 'EdiTransactionEntity', uuid: string, updatedAt: any, status: EdiTransactionStatus, code: EdiTransactionCode, message?: string | null, payload: string, hawb?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null };

export type EdiTransactionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchTerms?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EdiTransactionsQuery = { __typename?: 'Query', ediTransactions: { __typename?: 'EdiTransactionConnection', edges: Array<{ __typename?: 'EdiTransactionEdge', node: { __typename?: 'EdiTransactionEntity', uuid: string, updatedAt: any, status: EdiTransactionStatus, code: EdiTransactionCode, message?: string | null, payload: string, hawb?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OrderEdiReferencesQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderEdiReferencesQuery = { __typename?: 'Query', order?: { __typename: 'StandardOrderEntity', uuid: string, ediReferences?: Array<{ __typename?: 'EdiReferenceEntity', qualifier: string, value: string, target?: EdiReferenceTarget | null, label?: string | null }> | null } | null };

export type OrderForEdiReviewByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderForEdiReviewByUuidQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', isDraftOrder: boolean, createdAt: any, uuid: string, source: OrderSource, name: string, ediServiceLevelCode?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, ediReferences?: Array<{ __typename?: 'EdiReferenceEntity', qualifier: string, value: string, target?: EdiReferenceTarget | null, label?: string | null }> | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null };

export type OrderFragmentForEdiReviewFragment = { __typename?: 'StandardOrderEntity', createdAt: any, uuid: string, source: OrderSource, name: string, ediServiceLevelCode?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, ediReferences?: Array<{ __typename?: 'EdiReferenceEntity', qualifier: string, value: string, target?: EdiReferenceTarget | null, label?: string | null }> | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } };

export type OrderWithSameBillOfLadingNumberAsReviewOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string };

export type EmailOrderDocumentMutationVariables = Exact<{
  emailOrderDocumentInput: EmailOrderDocumentInput;
}>;


export type EmailOrderDocumentMutation = { __typename?: 'Mutation', emailOrderDocument: { __typename?: 'EmailOrderDocumentOutput', status: EmailOrderDocumentStatus } };

export type FetchMissingAccessorialQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type FetchMissingAccessorialQuery = { __typename?: 'Query', accessorial: { __typename?: 'AttemptsAccessorialEntity' } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity' } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity' } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } };

export type FinalizeOrderMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type FinalizeOrderMutation = { __typename?: 'Mutation', finalizeOrder: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus }> } };

export type FinalizeOrdersMutationVariables = Exact<{
  finalizeOrdersInput: FinalizeOrdersInput;
}>;


export type FinalizeOrdersMutation = { __typename?: 'Mutation', finalizeOrders: { __typename: 'FinalizeOrdersSuccessOutput', finalizedOrderUuids: Array<string>, failedOrderUuids: Array<string> } | { __typename: 'MutationErrorOutput', message: string } };

export type AvailablePieceForLinkingFragment = { __typename?: 'AvailablePieceEntity', uuid: string, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, length?: number | null, width?: number | null, height?: number | null, measurementUnits?: MeasurementUnits | null, type?: PackageType | null, weight?: number | null, weightUnits?: WeightUnits | null, markedOnHandAt?: any | null, createdAt: any, orderUuid?: string | null, orderName?: string | null, customerUuid?: string | null, customerName?: string | null, terminalUuid?: string | null, terminalName?: string | null, warehouseLocationUuid?: string | null, warehouseLocationName?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean };

export type FindAvailablePiecesQueryVariables = Exact<{
  findAvailablePiecesInput: FindAvailablePiecesInput;
}>;


export type FindAvailablePiecesQuery = { __typename?: 'Query', availablePiecesForLinking: { __typename?: 'AvailablePieceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'AvailablePieceEdge', cursor: string, node: { __typename?: 'AvailablePieceEntity', uuid: string, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, length?: number | null, width?: number | null, height?: number | null, measurementUnits?: MeasurementUnits | null, type?: PackageType | null, weight?: number | null, weightUnits?: WeightUnits | null, markedOnHandAt?: any | null, createdAt: any, orderUuid?: string | null, orderName?: string | null, customerUuid?: string | null, customerName?: string | null, terminalUuid?: string | null, terminalName?: string | null, warehouseLocationUuid?: string | null, warehouseLocationName?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type TerminalForAddressQueryVariables = Exact<{
  findTerminalForAddressInput: FindTerminalForAddressInput;
}>;


export type TerminalForAddressQuery = { __typename?: 'Query', terminalForAddress: { __typename?: 'FindTerminalForAddressOutput', terminal?: { __typename?: 'TerminalEntity', name: string, uuid: string } | null } };

export type TerminalsForAddressQueryVariables = Exact<{
  findTerminalForAddressInput: FindTerminalForAddressInput;
}>;


export type TerminalsForAddressQuery = { __typename?: 'Query', terminalsForAddress: { __typename?: 'FindTerminalsForAddressOutput', terminals?: Array<{ __typename?: 'TerminalEntity', name: string, uuid: string }> | null } };

export type FreightChargeNeedsRateFragment = { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, ratingFailure?: { __typename?: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, retryable: boolean } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, status: ExternalRateQuoteStatus, finalCents?: number | null } | null, lastRatedExternalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, finalCents?: number | null } | null };

export type GenerateAccountingReportPreSignedPutUrlMutationVariables = Exact<{
  generateAccountingReportPreSignedPutUrlInput: GenerateAccountingReportPreSignedPutUrlInput;
}>;


export type GenerateAccountingReportPreSignedPutUrlMutation = { __typename?: 'Mutation', generateAccountingReportPreSignedPutUrl: string };

export type GenerateOrderDocumentPreSignedPutUrlMutationVariables = Exact<{
  generateOrderDocumentPreSignedPutUrlInput: GenerateOrderDocumentPreSignedPutUrlInput;
}>;


export type GenerateOrderDocumentPreSignedPutUrlMutation = { __typename?: 'Mutation', generateOrderDocumentPreSignedPutUrl: string };

export type GenerateOrderPreSignedGetAndPutUrlsMutationVariables = Exact<{
  generateOrderPreSignedGetAndPutUrlsInput: GenerateOrderPreSignedGetAndPutUrlsInput;
}>;


export type GenerateOrderPreSignedGetAndPutUrlsMutation = { __typename?: 'Mutation', generateOrderPreSignedGetAndPutUrls: { __typename?: 'GenerateOrderPreSignedGetAndPutUrlsOutput', getUrl: string, putUrl: string } };

export type GeneratePodReportPreSignedPutUrlMutationVariables = Exact<{
  generatePodReportPreSignedPutUrlInput: GeneratePodReportPreSignedPutUrlInput;
}>;


export type GeneratePodReportPreSignedPutUrlMutation = { __typename?: 'Mutation', generatePodReportPreSignedPutUrl: string };

export type GenerateContactPreSignedPutUrlMutationVariables = Exact<{
  generateContactPreSignedPutUrlInput: GenerateContactPreSignedPutUrlInput;
}>;


export type GenerateContactPreSignedPutUrlMutation = { __typename?: 'Mutation', generateContactPreSignedPutUrl: { __typename?: 'GeneratePreSignedPutUrlOutput', url: string } };

export type GenerateInvoicePreSignedPutUrlMutationVariables = Exact<{
  generateInvoicePreSignedPutUrlInput: GenerateInvoicePreSignedPutUrlInput;
}>;


export type GenerateInvoicePreSignedPutUrlMutation = { __typename?: 'Mutation', generateInvoicePreSignedPutUrl: string };

export type GenerateOrderPreSignedPutUrlMutationVariables = Exact<{
  generateOrderPreSignedPutUrlInput: GenerateOrderPreSignedPutUrlInput;
}>;


export type GenerateOrderPreSignedPutUrlMutation = { __typename?: 'Mutation', generateOrderPreSignedPutUrl: string };

export type GenerateScannedOrderPreSignedPutUrlsQueryVariables = Exact<{
  preSignedUrlRequests: Array<PreSignedUrlRequestInput> | PreSignedUrlRequestInput;
}>;


export type GenerateScannedOrderPreSignedPutUrlsQuery = { __typename?: 'Query', generateScannedOrderPreSignedPutUrls: Array<{ __typename?: 'PreSignedPutUrlEntity', url: string, bucket: string, key: string, filename: string, filetype: string }> };

export type GeneratePreSignedPutUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
}>;


export type GeneratePreSignedPutUrlMutation = { __typename?: 'Mutation', generatePreSignedPutUrl: string };

export type InboundMessagesForOrderQueryVariables = Exact<{
  input: InboundMessagesForOrderInput;
}>;


export type InboundMessagesForOrderQuery = { __typename?: 'Query', inboundMessagesForOrder: { __typename?: 'InboundMessagesForOrderOutput', messages: Array<{ __typename?: 'InboundMessageEntity', uuid: string, source: OrderSource, senderName?: string | null, receivedAt: any, state: InboundMessageState, appliedAt?: any | null, conflicts: Array<{ __typename?: 'InboundMessageConflictEntity', key: string, fieldPath: string, targetUuid?: string | null, label: string, kind: InboundConflictKind, valueType: InboundFieldValueType, surface: InboundFieldSurface, incomingValue: string, keptValue?: string | null, adoptable: boolean, note?: string | null, resolvedChoice?: InboundReviewChoice | null }> }> } };

export type IncompleteLegsWithAttemptsQueryVariables = Exact<{ [key: string]: never; }>;


export type IncompleteLegsWithAttemptsQuery = { __typename?: 'Query', incompleteLegsWithAttempts: Array<{ __typename?: 'LegEntity', uuid: string, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, notes?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string }, leg?: { __typename?: 'LegEntity', uuid: string, shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } } | null }> }> };

export type LaneFromOriginAndDestinationTerminalQueryVariables = Exact<{
  findLaneFromOriginAndDestinationTerminalInput: FindLaneFromOriginAndDestinationTerminalInput;
}>;


export type LaneFromOriginAndDestinationTerminalQuery = { __typename?: 'Query', laneFromOriginAndDestinationTerminal: { __typename?: 'FindLaneFromOriginAndDestinationTerminalOutput', lane?: { __typename?: 'LineHaulLaneEntity', uuid: string, name: string, isActive: boolean, originTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, destinationTerminal: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null }, segments: Array<{ __typename?: 'LineHaulSegmentEntity', uuid: string, ordinal: number, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } };

export type LinkPiecesToPackageMutationVariables = Exact<{
  linkPiecesToPackageInput: LinkPiecesToPackageInput;
}>;


export type LinkPiecesToPackageMutation = { __typename?: 'Mutation', linkPiecesToPackage: { __typename?: 'LinkPiecesToPackageOutput', success: boolean, linkedPieces: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus }>, errors: Array<{ __typename?: 'LinkPieceError', pieceUuid: string, reason: string }> } };

export type MarkOrderAsCompleteForceMutationVariables = Exact<{
  markOrderAsCompleteForceInput: MarkOrderAsCompleteForceInput;
}>;


export type MarkOrderAsCompleteForceMutation = { __typename?: 'Mutation', markOrderAsCompleteForce: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus } };

export type MarkOrderAsHasBillingIssueMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkOrderAsHasBillingIssueMutation = { __typename?: 'Mutation', markOrderAsHasBillingIssue: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus } };

export type MarkOrderAsNotCompleteMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkOrderAsNotCompleteMutation = { __typename?: 'Mutation', markOrderAsNotComplete: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus } };

export type MarkOrderAsNotOnHandMutationVariables = Exact<{
  markAsNotOnHandInput: MarkAsNotOnHandInput;
}>;


export type MarkOrderAsNotOnHandMutation = { __typename?: 'Mutation', markOrderAsNotOnHand: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus } };

export type MarkOrderAsNotReadyToInvoiceMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkOrderAsNotReadyToInvoiceMutation = { __typename?: 'Mutation', markOrderAsNotReadyToInvoice: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus } };

export type MarkOrderAsNotReceivedAtOriginMutationVariables = Exact<{
  markAsNotReceivedAtOriginInput: MarkAsNotReceivedAtOriginInput;
}>;


export type MarkOrderAsNotReceivedAtOriginMutation = { __typename?: 'Mutation', markOrderAsNotReceivedAtOrigin: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus } };

export type MarkOrderAsOnHandMutationVariables = Exact<{
  markAsOnHandInput: MarkAsOnHandInput;
}>;


export type MarkOrderAsOnHandMutation = { __typename?: 'Mutation', markOrderAsOnHand: { __typename?: 'StandardOrderEntity', uuid: string, receivedDate?: any | null, detailedStatusV2?: OrderDetailedStatus | null, osd?: boolean | null, status: OrderStatus, shipments: Array<{ __typename?: 'StandardShipmentEntity', status: ShipmentStatus, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', status: StopStatus } }> }> } };

export type MarkOrderAsReadyToInvoiceForceMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  refuseOrderInput?: InputMaybe<RefuseOrderInput>;
}>;


export type MarkOrderAsReadyToInvoiceForceMutation = { __typename?: 'Mutation', markOrderAsReadyToInvoiceForce: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus } };

export type MarkOrderAsReadyToInvoiceMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkOrderAsReadyToInvoiceMutation = { __typename?: 'Mutation', markOrderAsReadyToInvoice: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus } };

export type MarkOrderAsReceivedAtOriginMutationVariables = Exact<{
  markAsReceivedAtOriginInput: MarkAsReceivedAtOriginInput;
}>;


export type MarkOrderAsReceivedAtOriginMutation = { __typename?: 'Mutation', markOrderAsReceivedAtOrigin: { __typename?: 'StandardOrderEntity', uuid: string, dateMarkedReceivedAtOrigin?: any | null, detailedStatusV2?: OrderDetailedStatus | null, osd?: boolean | null, status: OrderStatus, shipments: Array<{ __typename?: 'StandardShipmentEntity', status: ShipmentStatus, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', status: StopStatus } }> }> } };

export type MarkOrderAsRefusedMutationVariables = Exact<{
  markOrderAsRefusedInput: MarkOrderAsRefusedInput;
}>;


export type MarkOrderAsRefusedMutation = { __typename?: 'Mutation', markOrderAsRefused: { __typename?: 'MarkOrderAsRefusedSuccessOutput', success: boolean } | { __typename?: 'MutationErrorOutput', message: string } };

export type MarkOrderAsNotOsdMutationVariables = Exact<{
  markAsNotOsd: MarkNotOsdInput;
}>;


export type MarkOrderAsNotOsdMutation = { __typename?: 'Mutation', markNotOsd: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null } };

export type MarkOrderAsOsdMutationVariables = Exact<{
  markOsdInput: MarkOsdInput;
}>;


export type MarkOrderAsOsdMutation = { __typename?: 'Mutation', markOsd: { __typename?: 'StandardOrderEntity', uuid: string, notes: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null } };

export type MarkOsdOrderFragment = { __typename?: 'StandardOrderEntity', uuid: string, notes: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null };

export type MergeEdiOrderMutationVariables = Exact<{
  mergeEdiOrderInput: MergeEdiOrderInput;
}>;


export type MergeEdiOrderMutation = { __typename?: 'Mutation', mergeEdiOrder: { __typename?: 'MergeEdiOrderOutput', uuid: string } };

export type NumberOfEdiAndApiOrdersForReviewForCurrentCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type NumberOfEdiAndApiOrdersForReviewForCurrentCompanyQuery = { __typename?: 'Query', numberOfEdiAndApiOrdersForReviewForCurrentCompany: number };

export type NumberOfScannedOrderResultsInReviewBySourceQueryVariables = Exact<{
  sourceFilter?: InputMaybe<ScannedOrderResultSourceFilter>;
}>;


export type NumberOfScannedOrderResultsInReviewBySourceQuery = { __typename?: 'Query', numberOfScannedOrderResultsInReview: number };

export type OpenMessageInOutlookMutationVariables = Exact<{
  openMessageInOutlookInput: OpenMessageInOutlookInput;
}>;


export type OpenMessageInOutlookMutation = { __typename?: 'Mutation', openMessageInOutlook: { __typename?: 'OpenMessageInOutlookOutput', linkToOpen: string } };

export type DeleteOrderCommentMutationVariables = Exact<{
  deleteOrderCommentInput: DeleteOrderCommentInput;
}>;


export type DeleteOrderCommentMutation = { __typename?: 'Mutation', deleteOrderComment: { __typename?: 'DeleteOrderCommentSuccessOutput', success: boolean } | { __typename?: 'MutationErrorOutput', message: string } };

export type UpdateOrderCommentMutationVariables = Exact<{
  updateOrderCommentInput: UpdateOrderCommentInput;
}>;


export type UpdateOrderCommentMutation = { __typename?: 'Mutation', updateOrderComment: { __typename?: 'OrderCommentEntity', uuid: string } };

export type OrderForBulkEditFragment = { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, onHand?: boolean | null, pickedDate?: any | null, pieceCount?: number | null, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, secondaryRefNumber?: string | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deadlineType?: DeadlineType | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, notes?: string | null, standardStopType?: StandardStopType | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentTime?: any | null, endAppointmentTime?: any | null, proofOfDeliverySignee?: string | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, completedAt?: any | null, createdAt: any, status: StopStatus, isSpecial?: boolean | null, paperworkMarkedComplete?: boolean | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, latitude?: number | null, longitude?: number | null, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', completedAt?: any | null }> }> }> };

export type StandardOrderForContextMenuFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, refusedBy?: string | null, pickedDate?: any | null, pieceCount?: number | null, onHand?: boolean | null, notes: string, status: OrderStatus, detailedStatus?: string | null, detailedStatusV2?: OrderDetailedStatus | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, endStop?: { __typename?: 'StandardStopEntity', uuid: string, stopType?: StopType | null, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery } } } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, address: { __typename?: 'AddressEntity', line1: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', date: any } | null } | null, address: { __typename?: 'AddressEntity', name: string } } }> }> };

export type StandardOrderForContextMenuQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StandardOrderForContextMenuQuery = { __typename?: 'Query', standardOrder: { __typename?: 'StandardOrderEntity', uuid: string, name: string, refusedBy?: string | null, pickedDate?: any | null, pieceCount?: number | null, onHand?: boolean | null, notes: string, status: OrderStatus, detailedStatus?: string | null, detailedStatusV2?: OrderDetailedStatus | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, endStop?: { __typename?: 'StandardStopEntity', uuid: string, stopType?: StopType | null, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery } } } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, address: { __typename?: 'AddressEntity', line1: string } } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, fields?: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, status: StopStatus, proofOfDeliverySignee?: string | null, completedAt?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', date: any } | null } | null, address: { __typename?: 'AddressEntity', name: string } } }> }> } };

export type OrderForDocumentAttachmentsDownloadFragment = { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> };

export type OrdersForDocumentAttachmentsDownloadQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersForDocumentAttachmentsDownloadQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> }> };

export type OrderForInventoryLabelFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, company: { __typename?: 'CompanyEntity', name: string, defaultWeightUnits: WeightUnits, configuration?: { __typename?: 'CompanyConfigurationEntity', terminalsEnabled: boolean, useHawbForLotLabelBarcode: boolean } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null }, airportInfo?: { __typename?: 'AirportInfoEntity', iataCode?: string | null, terminal: string } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', uuid: string, stopType?: StopType | null, status: StopStatus, destinationAirport?: string | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> };

export type OrderForOrderMatchingFragment = { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }> }> };

export type OrderForOrdersByShipperBillOfLadingNumberFragment = { __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, receivedDate?: any | null, onHand?: boolean | null, source: OrderSource, isDraftOrder: boolean, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }>, scannedOrderResult?: { __typename?: 'ScannedOrderResultEntity', uuid: string, status: ScannedOrderResultStatus } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } };

export type OrderForTabLabelQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderForTabLabelQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null };

export type OrderFreightNeedsRateFragment = { __typename?: 'StandardOrderEntity', freightNeedsRate: boolean, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, ratingFailure?: { __typename?: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, retryable: boolean } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, status: ExternalRateQuoteStatus, finalCents?: number | null } | null, lastRatedExternalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, finalCents?: number | null } | null } | null }> };

export type OrderNameQueryVariables = Exact<{
  billingPartyContactUuid: Scalars['String']['input'];
}>;


export type OrderNameQuery = { __typename?: 'Query', orderName: string };

export type OrderPodReportShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalChargesAmount: number, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, totalCharge: number, totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalCustomChargesAmount: number, notes: string, ordinal: number, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserActorEntity', email?: string | null } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', customCharges: Array<{ __typename?: 'CustomChargeEntity', authoCode?: string | null, name: string, total: number, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', name: string } | { __typename?: 'PercentageAccessorialEntity', name: string } | { __typename?: 'SkidBasedAccessorialEntity', name: string } | { __typename?: 'SpecialAccessorialEntity', name: string } | { __typename?: 'StandardAccessorialEntity', name: string } | { __typename?: 'StorageDaysAccessorialEntity', name: string } | { __typename?: 'UnitBasedAccessorialEntity', name: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string } | null }> }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null, weightUnits: WeightUnits, measurementUnits: MeasurementUnits }, service?: { __typename?: 'ServiceEntity', name: string } | null } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, authoCode?: string | null, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null } | { __typename?: 'FreightChargeEntity', uuid: string, authoCode?: string | null, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }> } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, authoCode?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null }> };

export type OrderPodReportsQueryVariables = Exact<{
  getShipmentsInput?: InputMaybe<GetShipmentsInput>;
}>;


export type OrderPodReportsQuery = { __typename?: 'Query', shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalChargesAmount: number, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, pickupOrDelivery: PickupOrDelivery }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, packages: Array<{ __typename?: 'PackageEntity', description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null }>, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, completedAt?: any | null, specialInstructions?: string | null, proofOfDeliverySignee?: string | null, paperworkMarkedComplete?: boolean | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null } }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, secondaryRefNumber?: string | null, totalCharge: number, totalFreightChargesAmount: number, totalFuelChargesAmount: number, totalCustomChargesAmount: number, notes: string, ordinal: number, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, orderEvents: Array<{ __typename?: 'OrderEventEntity', eventType: OrderEventType, sourceType: OrderEventSourceType, createdAt: any, sourceUser?: { __typename?: 'UserActorEntity', email?: string | null } | null }>, company: { __typename?: 'CompanyEntity', name: string, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', customCharges: Array<{ __typename?: 'CustomChargeEntity', authoCode?: string | null, name: string, total: number, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', name: string } | { __typename?: 'PercentageAccessorialEntity', name: string } | { __typename?: 'SkidBasedAccessorialEntity', name: string } | { __typename?: 'SpecialAccessorialEntity', name: string } | { __typename?: 'StandardAccessorialEntity', name: string } | { __typename?: 'StorageDaysAccessorialEntity', name: string } | { __typename?: 'UnitBasedAccessorialEntity', name: string } | { __typename?: 'WaitTimeAccessorialEntity', name: string } | { __typename?: 'WeightBasedAccessorialEntity', name: string } | { __typename?: 'ZoneBasedAccessorialEntity', name: string } | null }> }>, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', masterAirwayBillOfLadingNumber?: string | null, shipperBillOfLadingNumber?: string | null, weightUnits: WeightUnits, measurementUnits: MeasurementUnits }, service?: { __typename?: 'ServiceEntity', name: string } | null } | null, charges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, authoCode?: string | null, name: string, zoneBasedAccessorialZoneUuid?: string | null, zoneBasedAccessorialChargeGroupUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, quantity: number, description?: string | null, rate: number, total: number, customChargeBillingMethod: CustomChargeBillingMethod, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string } | null } | { __typename?: 'FreightChargeEntity', uuid: string, authoCode?: string | null, billingMethod: FreightBillingMethod, rate: number, description?: string | null, quantity: number, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffOverageRates: Array<{ __typename?: 'TariffOverageRateEntity', uuid: string, name: string, type: TariffOverageRateType, rateUsdCents: number, applicableAboveAmount: number, applyRateToFullAmount: boolean }> } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', description?: string | null, authoCode?: string | null, surchargeRate: number, flatRate: number, type: FuelBillingMethod, uuid: string } | null }> }> };

export type OrderUpdatedAtQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderUpdatedAtQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', updatedAt: any, lastUpdatedByUser?: { __typename?: 'UserActorEntity', uuid: string } | null } | null };

export type OrderQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, notes: string, pieceCount?: number | null, receivedDate?: any | null, pickedDate?: any | null, onHand?: boolean | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, packages: Array<{ __typename?: 'PackageEntity', description: string }> }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } | null };

export type OrdersBySecondaryRefNumberQueryVariables = Exact<{
  secondaryRefNumber: Scalars['String']['input'];
}>;


export type OrdersBySecondaryRefNumberQuery = { __typename?: 'Query', ordersBySecondaryRefNumber: Array<{ __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string }> };

export type OrdersByShipperBillOfLadingNumberQueryVariables = Exact<{
  shipperBillOfLadingNumber: Scalars['String']['input'];
  includeInReviewScannedOrdersFromEmail?: InputMaybe<Scalars['Boolean']['input']>;
  includeInReviewEdiOrders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrdersByShipperBillOfLadingNumberQuery = { __typename?: 'Query', ordersByShipperBillOfLadingNumber: Array<{ __typename?: 'StandardOrderEntity', uuid: string, createdAt: any, name: string, receivedDate?: any | null, onHand?: boolean | null, source: OrderSource, isDraftOrder: boolean, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }>, scannedOrderResult?: { __typename?: 'ScannedOrderResultEntity', uuid: string, status: ScannedOrderResultStatus } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> };

export type OrdersByUuidsForBulkEditQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersByUuidsForBulkEditQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, onHand?: boolean | null, pickedDate?: any | null, pieceCount?: number | null, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, secondaryRefNumber?: string | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deadlineType?: DeadlineType | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, notes?: string | null, standardStopType?: StandardStopType | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentTime?: any | null, endAppointmentTime?: any | null, proofOfDeliverySignee?: string | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, completedAt?: any | null, createdAt: any, status: StopStatus, isSpecial?: boolean | null, paperworkMarkedComplete?: boolean | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, latitude?: number | null, longitude?: number | null, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', completedAt?: any | null }> }> }> }> };

export type OrdersForBulkEditQueryVariables = Exact<{
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  shipperFilter?: InputMaybe<StringFilter>;
  consigneeFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter> | StatusFilter>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter> | ShipmentStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onInvoice?: InputMaybe<BooleanFilter>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isRefused?: InputMaybe<BooleanFilter>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isPicked?: InputMaybe<BooleanFilter>;
  isOsd?: InputMaybe<BooleanFilter>;
  isSpecial?: InputMaybe<BooleanFilter>;
  orderSource?: InputMaybe<OrderSource>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hawbFilter?: InputMaybe<StringFilterV2>;
  mawbFilter?: InputMaybe<StringFilterV2>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  standardStopType?: InputMaybe<StandardStopType>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  transferPending?: InputMaybe<BooleanFilter>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort> | OrderSort>;
  noTerminal?: InputMaybe<BooleanFilter>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  tagUuidsFilter?: InputMaybe<StringsFilter>;
  canDispatchFilter?: InputMaybe<BooleanFilterV2>;
  inboundRoutingFilter?: InputMaybe<StringFilterV2>;
  outboundRoutingFilter?: InputMaybe<StringFilterV2>;
  proofOfDeliverySigneeFilter?: InputMaybe<StringFilterV2>;
}>;


export type OrdersForBulkEditQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, onHand?: boolean | null, pickedDate?: any | null, pieceCount?: number | null, detailedStatusV2?: OrderDetailedStatus | null, refusedBy?: string | null, secondaryRefNumber?: string | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shipmentType: ShipmentType, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', deadlineDate?: any | null, deadlineType?: DeadlineType | null, pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, notes?: string | null, standardStopType?: StandardStopType | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentTime?: any | null, endAppointmentTime?: any | null, proofOfDeliverySignee?: string | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, completedAt?: any | null, createdAt: any, status: StopStatus, isSpecial?: boolean | null, paperworkMarkedComplete?: boolean | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, latitude?: number | null, longitude?: number | null, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', completedAt?: any | null }> }> }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OrdersForInventoryLabelsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrdersForInventoryLabelsQuery = { __typename?: 'Query', ordersByUuids: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, refNumbers: Array<string>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, company: { __typename?: 'CompanyEntity', name: string, defaultWeightUnits: WeightUnits, configuration?: { __typename?: 'CompanyConfigurationEntity', terminalsEnabled: boolean, useHawbForLotLabelBarcode: boolean } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null }, airportInfo?: { __typename?: 'AirportInfoEntity', iataCode?: string | null, terminal: string } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', uuid: string, stopType?: StopType | null, status: StopStatus, destinationAirport?: string | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, incomingCarrier?: string | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } }> }> }> };

export type OrdersForOrderMatchingQueryVariables = Exact<{
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  shipperFilter?: InputMaybe<StringFilter>;
  consigneeFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter> | StatusFilter>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter> | ShipmentStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onInvoice?: InputMaybe<BooleanFilter>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isRefused?: InputMaybe<BooleanFilter>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isPicked?: InputMaybe<BooleanFilter>;
  isOsd?: InputMaybe<BooleanFilter>;
  isSpecial?: InputMaybe<BooleanFilter>;
  orderSource?: InputMaybe<OrderSource>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  standardStopType?: InputMaybe<StandardStopType>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  totalCount?: InputMaybe<Scalars['Boolean']['input']>;
  transferPending?: InputMaybe<BooleanFilter>;
}>;


export type OrdersForOrderMatchingQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }> }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

type ContactForOrdersTable_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', name: string } | null };

type ContactForOrdersTable_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', name: string } | null };

export type ContactForOrdersTableFragment = ContactForOrdersTable_CustomerContactEntity_Fragment | ContactForOrdersTable_ThirdPartyContactEntity_Fragment;

export type CreateOrderTableReportMutationVariables = Exact<{
  createOrderTableReportInput: CreateOrderTableReportInput;
}>;


export type CreateOrderTableReportMutation = { __typename?: 'Mutation', createOrderTableReport: { __typename?: 'MutationErrorOutput' } | { __typename?: 'OrderTableReportDownloadOutput', reportGenerationStatus: ReportGenerationStatus, reportUrl: string } | { __typename?: 'OrderTableReportEmailToUserOutput', reportGenerationStatus: ReportGenerationStatus } };

export type FormattedOrderFieldFragment = { __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string };

export type FormattedOrderFragment = { __typename?: 'FormattedOrderEntity', uuid: string, freightNeedsRate: boolean, pieceTerminalLocationsDisplay?: string | null, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'OrderTableServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null };

export type GetOrderTableFieldValuesForCountQueryVariables = Exact<{
  getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput;
  activeTerminalUuid?: InputMaybe<Scalars['ID']['input']>;
  includePieceTerminalLocationsDisplay?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrderTableFieldValuesForCountQuery = { __typename?: 'Query', getOrderTableFieldValues: { __typename?: 'GetOrderTableFieldValuesOutput', groupRowsHasMore?: boolean | null, orderTableFieldHeaders: Array<{ __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string, isGroupable: boolean, isGroupableOnNewSearch: boolean }>, formattedOrderConnection: { __typename?: 'FormattedOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, freightNeedsRate: boolean, pieceTerminalLocationsDisplay?: string | null, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'OrderTableServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } }, groupRows?: Array<{ __typename?: 'OrderTableGroupRowEntity', key?: string | null, label?: string | null, count: number }> | null } };

export type GetOrderTableFieldValuesForSearchQueryVariables = Exact<{
  getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput;
  activeTerminalUuid?: InputMaybe<Scalars['ID']['input']>;
  includePieceTerminalLocationsDisplay?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrderTableFieldValuesForSearchQuery = { __typename?: 'Query', getOrderTableFieldValues: { __typename?: 'GetOrderTableFieldValuesOutput', groupRowsHasMore?: boolean | null, orderTableFieldHeaders: Array<{ __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string, isGroupable: boolean, isGroupableOnNewSearch: boolean }>, formattedOrderConnection: { __typename?: 'FormattedOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, freightNeedsRate: boolean, pieceTerminalLocationsDisplay?: string | null, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'OrderTableServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } }, groupRows?: Array<{ __typename?: 'OrderTableGroupRowEntity', key?: string | null, label?: string | null, count: number }> | null } };

export type GetOrderTableFieldValuesQueryVariables = Exact<{
  getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput;
  activeTerminalUuid?: InputMaybe<Scalars['ID']['input']>;
  includePieceTerminalLocationsDisplay?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrderTableFieldValuesQuery = { __typename?: 'Query', getOrderTableFieldValues: { __typename?: 'GetOrderTableFieldValuesOutput', groupRowsHasMore?: boolean | null, orderTableFieldHeaders: Array<{ __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string, isGroupable: boolean, isGroupableOnNewSearch: boolean }>, formattedOrderConnection: { __typename?: 'FormattedOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, freightNeedsRate: boolean, pieceTerminalLocationsDisplay?: string | null, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'OrderTableServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } }, groupRows?: Array<{ __typename?: 'OrderTableGroupRowEntity', key?: string | null, label?: string | null, count: number }> | null } };

export type OrderTableCustomChargeFragment = { __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number };

export type OrderTableFieldHeaderFragment = { __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string, isGroupable: boolean, isGroupableOnNewSearch: boolean };

export type RateOrderShipmentChargesForItemizedChargesFragment = { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null };

export type OrderTableFieldItemizedChargesFragment = { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> };

export type OrderTableFieldPackageFragment = { __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null };

export type OrderTableFieldPaperworkFragment = { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null };

export type OrderTableFieldPhotoFragment = { __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string };

export type OrderTableFieldTagFragment = { __typename?: 'OrderTableTagEntity', value: string, color?: string | null };

export type OrderTableFieldValuesFormattedOrderConnectionFragment = { __typename?: 'FormattedOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, freightNeedsRate: boolean, pieceTerminalLocationsDisplay?: string | null, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'OrderTableServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } };

export type OrderTableGroupRowFragment = { __typename?: 'OrderTableGroupRowEntity', key?: string | null, label?: string | null, count: number };

export type OrderTableFieldValuesOutputFragment = { __typename?: 'GetOrderTableFieldValuesOutput', groupRowsHasMore?: boolean | null, orderTableFieldHeaders: Array<{ __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string, isGroupable: boolean, isGroupableOnNewSearch: boolean }>, formattedOrderConnection: { __typename?: 'FormattedOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, freightNeedsRate: boolean, pieceTerminalLocationsDisplay?: string | null, contactUuid: string, formattedOrderFields: Array<{ __typename?: 'FormattedOrderFieldEntity', orderTableField: OrderTableField, value: string }>, paperworkField?: { __typename?: 'OrderTablePaperworkFieldEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null, outboundPaperwork?: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } | null } | null, tagsField?: { __typename?: 'OrderTableTagsFieldEntity', orderTableTags: Array<{ __typename?: 'OrderTableTagEntity', value: string, color?: string | null }> } | null, photosField?: { __typename?: 'OrderTablePhotosFieldEntity', orderTablePhotos: Array<{ __typename?: 'OrderTablePhotoEntity', shipmentUuid: string, shipmentPickupOrDelivery: PickupOrDelivery, fileName: string, type: DocumentType, preSignedGetUrl: string }> } | null, serviceField?: { __typename?: 'OrderTableServiceFieldEntity', service?: { __typename?: 'OrderTableServiceEntity', uuid: string, name: string } | null } | null, packagesField?: { __typename?: 'OrderTablePackagesFieldEntity', orderTablePackages: Array<{ __typename?: 'OrderTablePackageEntity', uuid: string, quantity: number, weight?: any | null, length?: any | null, width?: any | null, height?: any | null }> } | null, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null, lineHaulManifestsField?: { __typename?: 'OrderTableLineHaulManifestsFieldEntity', startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, currentTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, lineHaulManifests: Array<{ __typename?: 'OrderTableLineHaulManifestEntity', status: LineHaulManifestStatus, startTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } }, groupRows?: Array<{ __typename?: 'OrderTableGroupRowEntity', key?: string | null, label?: string | null, count: number }> | null };

export type OrderCommentsQueryVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type OrderCommentsQuery = { __typename?: 'Query', orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, createdAt: any, updatedAt: any, comment: string, user?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, piece?: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } | null }> };

export type OrderPaperworkWithGroupedDocumentsFragment = { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null };

export type OrderPaperworkFragment = { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null };

export type OrderTableFieldHeadersQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderTableFieldHeadersQuery = { __typename?: 'Query', orderTableFieldHeaders: { __typename?: 'GetOrderTableFieldHeadersOutput', orderTableFieldHeaders: Array<{ __typename?: 'OrderTableFieldHeaderEntity', orderTableField: OrderTableField, header: string, isGroupable: boolean, isGroupableOnNewSearch: boolean }> } };

export type OrderUuidsInViewQueryVariables = Exact<{
  findOrderUuidsInViewInput: FindOrderUuidsInViewInput;
}>;


export type OrderUuidsInViewQuery = { __typename?: 'Query', orderUuidsInView: { __typename?: 'FindOrderUuidsInViewOutput', uuids: Array<string>, hasMore: boolean } };

export type OrderUuidsQueryVariables = Exact<{
  addressCityFilter?: InputMaybe<StringFilter>;
  addressZipFilter?: InputMaybe<StringFilter>;
  attemptedAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  completionDateFilters?: InputMaybe<DateFilterStartEnd>;
  deadlineDateFilters?: InputMaybe<DateFilterStartEnd>;
  receivedDateFilters?: InputMaybe<DateFilterStartEnd>;
  createdAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  expectedInboundArrivalDateFilters?: InputMaybe<DateFilterStartEnd>;
  invoiceDateFilters?: InputMaybe<DateFilterStartEnd>;
  scheduledAtDateFilters?: InputMaybe<DateFilterStartEnd>;
  primaryAppointmentDateFilters?: InputMaybe<DateFilterStartEnd>;
  orderNumberFilter?: InputMaybe<StringFilter>;
  billingPartyContactUuidFilter?: InputMaybe<StringFilter>;
  billingPartyContactDisplayNameFilter?: InputMaybe<StringFilter>;
  businessDivisionUuidFilter?: InputMaybe<StringFilter>;
  terminalUuidFilter?: InputMaybe<StringFilter>;
  activeTerminalUuidFilter?: InputMaybe<StringFilter>;
  originTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  destinationTerminalUuidFilter?: InputMaybe<StringFilterNullable>;
  driverUuidFilter?: InputMaybe<StringFilter>;
  shipperFilter?: InputMaybe<StringFilter>;
  consigneeFilter?: InputMaybe<StringFilter>;
  statusFilters?: InputMaybe<Array<StatusFilter> | StatusFilter>;
  shipmentStatusFilters?: InputMaybe<Array<ShipmentStatusFilter> | ShipmentStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  multipleSearches?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  scheduledFilter?: InputMaybe<BooleanFilter>;
  outForDeliveryFilter?: InputMaybe<BooleanFilter>;
  onHand?: InputMaybe<BooleanFilter>;
  onInvoice?: InputMaybe<BooleanFilter>;
  isCancelled?: InputMaybe<BooleanFilter>;
  isRefused?: InputMaybe<BooleanFilter>;
  isFinalized?: InputMaybe<BooleanFilter>;
  isPicked?: InputMaybe<BooleanFilter>;
  isOsd?: InputMaybe<BooleanFilter>;
  isSpecial?: InputMaybe<BooleanFilter>;
  orderSource?: InputMaybe<OrderSource>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointmentScheduled?: InputMaybe<BooleanFilter>;
  appointmentRequired?: InputMaybe<BooleanFilter>;
  hasContactInformation?: InputMaybe<BooleanFilter>;
  hasFailures?: InputMaybe<BooleanFilter>;
  hasRoute?: InputMaybe<BooleanFilter>;
  hideFromBilling?: InputMaybe<BooleanFilter>;
  paperworkComplete?: InputMaybe<BooleanFilter>;
  pickupOrDelivery?: InputMaybe<PickupOrDelivery>;
  isPickupOrDelivery?: InputMaybe<BooleanFilter>;
  inboundNotArrived?: InputMaybe<BooleanFilter>;
  requiresRouting?: InputMaybe<BooleanFilter>;
  requiresRecovery?: InputMaybe<BooleanFilter>;
  serviceDateFilters?: InputMaybe<DateFilterStartEnd>;
  serviceDateFilter?: InputMaybe<DateFilterV2>;
  serviceUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lineHaulLaneUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  showConsolidatedOrders?: InputMaybe<BooleanFilter>;
  hideOriginalConsolidatedOrderIdFilter?: InputMaybe<BooleanFilterV2>;
  standardStopType?: InputMaybe<StandardStopType>;
  stopTypesFilter?: InputMaybe<StopTypesFilter>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  transferPending?: InputMaybe<BooleanFilter>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchHawbOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchRefNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchMiscInfoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  useMultiSearch?: InputMaybe<Scalars['Boolean']['input']>;
  sorts?: InputMaybe<Array<OrderSort> | OrderSort>;
  noTerminal?: InputMaybe<BooleanFilter>;
  isCollectOnDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isHazmat?: InputMaybe<BooleanFilter>;
  isInBond?: InputMaybe<BooleanFilter>;
  billingPartyContactUuidsFilter?: InputMaybe<StringsFilter>;
  terminalUuidsFilter?: InputMaybe<StringsFilter>;
  driverUuidsFilter?: InputMaybe<StringsFilter>;
  tagUuidsFilter?: InputMaybe<StringsFilter>;
}>;


export type OrderUuidsQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'StandardOrderEntity', uuid: string } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OrderWithCommentsFragment = { __typename?: 'StandardOrderEntity', orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, user?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, piece?: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } | null }> };

export type OrderWithInboundOutboundPaperworkQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderWithInboundOutboundPaperworkQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null };

export type OrderWithItemizedChargesQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderWithItemizedChargesQuery = { __typename?: 'Query', getOrderTableFieldValues: { __typename?: 'GetOrderTableFieldValuesOutput', formattedOrderConnection: { __typename?: 'FormattedOrderConnection', edges: Array<{ __typename?: 'FormattedOrderEdge', node: { __typename?: 'FormattedOrderEntity', uuid: string, itemizedChargesField?: { __typename?: 'OrderTableItemizedChargesFieldEntity', freightChargeTotal: number, fuelChargeTotal: number, shipmentCharges: Array<{ __typename?: 'OrderTableItemizedChargesFieldShipmentEntity', shipmentType: ShipmentType, pickupOrDelivery?: PickupOrDelivery | null, stopType?: StopType | null, freightBillingMethod?: FreightBillingMethod | null, freightRate?: any | null, freightQuantity?: number | null, freightTotalAmount?: any | null, fuelBillingMethod?: FuelBillingMethod | null, fuelSurchargeRate?: any | null, fuelFlatRate?: any | null, fuelTotalAmount?: any | null, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string }, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> }>, rateOrderOutput?: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', total: any, freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any, tariffUuid?: string | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any, surchargeRatePercentage?: any | null } | null } | null } | null, customCharges: Array<{ __typename?: 'OrderTableCustomChargeFieldEntity', name: string, billingMethod: CustomChargeBillingMethod, total: number }> } | null } }> } } };

export type OrderWithMissingDocumentsFragment = { __typename?: 'StandardOrderEntity', uuid: string, missingDocuments: Array<DocumentType> };

export type OrderWithMissingDocumentsQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderWithMissingDocumentsQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, missingDocuments: Array<DocumentType> } | null };

export type OrderWithPaperworkFragment = { __typename?: 'StandardOrderEntity', uuid: string, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null } };

export type OrderWithPaperworkQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type OrderWithPaperworkQuery = { __typename?: 'Query', order?: { __typename?: 'StandardOrderEntity', uuid: string, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null } } | null };

export type OrderFragment = { __typename?: 'StandardOrderEntity', weight: number, dimWeight: number, createdAt: any, receivedDate?: any | null, secondaryRefNumber?: string | null, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null, uuid: string, name: string, missingDocuments: Array<DocumentType>, osd?: boolean | null, source: OrderSource, refNumbers: Array<string>, notes: string, dateMarkedLoaded?: any | null, dateMarkedOnHand?: any | null, dateMarkedReceivedAtOrigin?: any | null, pieceCount?: number | null, itTeNumber?: string | null, pieceCountFromPackages: number, inBond: boolean, piecesPicked?: number | null, piecesLoaded?: number | null, refusedBy?: string | null, hasDriverPod: boolean, hasDriverUploadedDocument: boolean, totalSkids?: number | null, externalNotes?: string | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', length?: number | null, width?: number | null, height?: number | null, quantity: number }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, holdReason?: { __typename?: 'HoldReasonEntity', name: string } | null, service?: { __typename?: 'ServiceEntity', name: string } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, billingCycleDuration: BillingCycleDuration, invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', name: string } | null }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, hideFromBilling: boolean, status: ShipmentStatus, shipmentType: ShipmentType, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, airportInfo?: { __typename?: 'AirportInfoEntity', iataCode?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null, deadlineType?: DeadlineType | null, deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', uuid: string, notes?: string | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentTime?: any | null, endAppointmentTime?: any | null, proofOfDeliverySignee?: string | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, completedAt?: any | null, driverCompletedAt?: any | null, createdAt: any, status: StopStatus, isSpecial?: boolean | null, paperworkMarkedComplete?: boolean | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, latitude?: number | null, longitude?: number | null, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', completedAt?: any | null }> }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, preSignedGetUrl: string, type: DocumentType, customDocumentName?: string | null }> }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', name: string, originTerminal: { __typename?: 'TerminalEntity', code: string }, destinationTerminal: { __typename?: 'TerminalEntity', code: string } } | null, startStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, incomingCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', serviceDate?: any | null, outboundCarrier?: string | null, address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }, terminal?: { __typename?: 'TerminalEntity', code: string } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, user?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, piece?: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } | null }> };

export type ShipmentWithDocumentsForOrdersTableFragment = { __typename?: 'StandardShipmentEntity', documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, preSignedGetUrl: string, type: DocumentType, customDocumentName?: string | null }> };

export type StopWithRouteSlotForOrdersTableFragment = { __typename?: 'StandardStopEntity', routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null };

export type OutstandingOrderQueryStopFragment = { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> };

export type OutstandingOrderFragmentFragment = { __typename?: 'StandardOrderEntity', freightNeedsRate: boolean, updatedAt: any, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, isOverdue: boolean, detailedStatusV2?: OrderDetailedStatus | null, isCrossDock?: boolean | null, isDoorToDoor?: boolean | null, inboundStopIntention?: StopIntention | null, outboundStopIntention?: StopIntention | null, displayChargesInCustomerPortalOverride?: boolean | null, customerPortalChargesVisibleFromOverride?: CustomerPortalChargesVisibility | null, issueReason?: string | null, personName?: string | null, personPhoneNumber?: string | null, personEmail?: string | null, name: string, notes: string, onHand?: boolean | null, dateMarkedOnHand?: any | null, refNumbers: Array<string>, orderConsolidationType: OrderConsolidationType, orderInvoiceByDate?: any | null, paymentMethod?: PaymentMethod | null, source: OrderSource, status: OrderStatus, uuid: string, isDraftOrder: boolean, chargeableWeightCubicMeters?: any | null, totalSkids?: number | null, isReweighed: boolean, secondaryRefNumber?: string | null, lockSecondaryRefNumber: boolean, tertiaryRefNumber?: string | null, quaternaryRefNumber?: string | null, quinaryRefNumber?: string | null, lineHaulCompletedDate: any, consolidatedShipmentString?: string | null, shouldBillIndividually: boolean, enableLineHaul: boolean, inBond: boolean, hazmat: boolean, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, lockShipperBillOfLadingNumber: boolean, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null, measurementUnits: MeasurementUnits, weightUnits: WeightUnits }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null }, billingPartyContactStation?: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, height?: number | null, length?: number | null, quantity: number, type?: PackageType | null, weight?: number | null, width?: number | null, description: string, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null }>, originalTransmissionPackages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, description: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, fileType: string, preSignedGetUrl: string, type: DocumentType, customDocumentName?: string | null, notes?: string | null, name?: string | null }>, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, postedAt?: any | null, journalNumber: number } | null, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, user?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null }>, consolidatableOrders: { __typename?: 'ConsolidatableOrdersOutput', error?: FindConsolidatableOrdersError | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, shipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null }, consolidatedOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string } | null, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null };

export type PackageSpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type PackageSpecsQuery = { __typename?: 'Query', packageSpecs: { __typename?: 'FindPackageSpecsOutput', packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, status: PackageSpecStatus, freightClass?: FreightClass | null }> } };

export type PieceLeafFragment = { __typename?: 'PieceEntity', uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null };

export type PieceFragment = { __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null };

export type PiecesByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type PiecesByUuidsQuery = { __typename?: 'Query', piecesByUuids: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, fileType: string, type: DocumentType, preSignedGetUrl: string, notes?: string | null, pageNumber?: number | null }> }> };

export type RecordInboundReviewDecisionsMutationVariables = Exact<{
  input: RecordInboundReviewDecisionsInput;
}>;


export type RecordInboundReviewDecisionsMutation = { __typename?: 'Mutation', recordInboundReviewDecisions: boolean };

export type RecurringOrderTemplateFragment = { __typename?: 'StandardOrderEntity', name: string, uuid: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, recurringOrderFrequency?: { __typename?: 'RecurringOrderFrequencyEntity', uuid: string, startDate: any, endDate?: any | null, repeatFrequencyUnit: RepeatFrequencyUnit, repeatIntervalWeeks?: number | null, repeatInterval: number, daysOfWeek: Array<DayOfWeekAll>, daysOfMonth: Array<number> } | null, run?: { __typename?: 'RunEntity', uuid: string, name: string } | null };

export type RecurringOrderTemplatesQueryVariables = Exact<{
  runUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecurringOrderTemplatesQuery = { __typename?: 'Query', recurringOrderTemplates: Array<{ __typename?: 'StandardOrderEntity', name: string, uuid: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string }, recurringOrderFrequency?: { __typename?: 'RecurringOrderFrequencyEntity', uuid: string, startDate: any, endDate?: any | null, repeatFrequencyUnit: RepeatFrequencyUnit, repeatIntervalWeeks?: number | null, repeatInterval: number, daysOfWeek: Array<DayOfWeekAll>, daysOfMonth: Array<number> } | null, run?: { __typename?: 'RunEntity', uuid: string, name: string } | null }> };

export type RecurringRunTemplateFragment = { __typename?: 'RunEntity', name: string, uuid: string, isArchived: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, status: DriverStatus, firstName: string, lastName: string } | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, recurringOrderTemplates: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, tags: Array<{ __typename?: 'TagEntity', uuid: string }> };

export type RecurringRunsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecurringRunsQuery = { __typename?: 'Query', recurringRuns: Array<{ __typename?: 'RunEntity', name: string, uuid: string, isArchived: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, status: DriverStatus, firstName: string, lastName: string } | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, recurringOrderTemplates: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, tags: Array<{ __typename?: 'TagEntity', uuid: string }> }> };

export type RemoveOrderHoldMutationVariables = Exact<{
  removeOrderHoldInput: RemoveOrderHoldInput;
}>;


export type RemoveOrderHoldMutation = { __typename?: 'Mutation', removeOrderHold: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null } };

export type RemoveSubscriberFromShipmentMutationVariables = Exact<{
  removeSubscriberInput: RemoveSubscriberInput;
}>;


export type RemoveSubscriberFromShipmentMutation = { __typename?: 'Mutation', removeSubscriberFromShipment: { __typename?: 'ShipmentSubscriberEntity', uuid: string } };

export type ReportADocScanIssueMutationVariables = Exact<{
  reportADocScanIssueInput: ReportADocScanIssueInput;
}>;


export type ReportADocScanIssueMutation = { __typename?: 'Mutation', reportADocScanIssue: { __typename?: 'ReportADocScanIssueOutput', success: boolean } };

export type RerateOrderFreightMutationVariables = Exact<{
  orderUuid: Scalars['String']['input'];
}>;


export type RerateOrderFreightMutation = { __typename?: 'Mutation', rerateOrderFreight: { __typename?: 'RerateOrderFreightOutput', externalRatings: Array<{ __typename?: 'FreightChargeRerateResult', freightChargeUuid: string, status: ExternalFreightRatingStatus, externalRating?: { __typename: 'ExternalRatingFailure', message: string } | { __typename: 'ExternalRatingSuccess' } | null }> } };

export type CreateReverseOrderMutationVariables = Exact<{
  createReverseOrderInput: CreateReverseOrderInput;
}>;


export type CreateReverseOrderMutation = { __typename?: 'Mutation', createReverseOrder: { __typename?: 'StandardOrderEntity', uuid: string, name: string, isReverse: boolean } };

export type ScannedOrderProvenanceQueryVariables = Exact<{
  scannedOrderUuid: Scalars['String']['input'];
}>;


export type ScannedOrderProvenanceQuery = { __typename?: 'Query', scannedOrderProvenance?: { __typename?: 'DocumentProvenanceEntity', fields: Array<{ __typename?: 'ProvenanceFieldEntity', fieldKey: string, value?: string | null, fieldStatus: string, sourceKind?: string | null, sourcePage?: number | null, sourceS3Key?: string | null, derivationTag?: string | null, sourceBboxes: Array<{ __typename?: 'ProvenanceBboxEntity', l: number, t: number, w: number, h: number }> }> } | null };

export type ScannedOrderResultByOrderUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ScannedOrderResultByOrderUuidQuery = { __typename?: 'Query', scannedOrderResultByOrderUuid?: { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus }, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string }> } | null };

export type ScannedOrdersByUuidsQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ScannedOrdersByUuidsQuery = { __typename?: 'Query', scannedOrdersByUuids: Array<{ __typename?: 'ScannedOrderEntity', uuid: string, status: ScannedOrderStatus }> };

export type ServicesForOrderQueryVariables = Exact<{
  findServicesForOrderInput: FindServicesForOrderInput;
}>;


export type ServicesForOrderQuery = { __typename?: 'Query', servicesForOrder: { __typename: 'FindServicesForOrderSuccessOutput', services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, isActive: boolean, markOrdersAsSpecial: boolean }> } | { __typename: 'QueryErrorOutput', message: string } };

export type SetOrderExecutedByMutationVariables = Exact<{
  input: SetOrderExecutedByInput;
}>;


export type SetOrderExecutedByMutation = { __typename?: 'Mutation', setOrderExecutedBy: { __typename: 'OrderDelegationEntity', uuid: string, status: OrderDelegationStatus, scope: OrderDelegationScope, executingCompanyName: string, executingCompanyUuid: string, originatorCompanyName: string, originatorCompanyUuid: string, organizationPeerUuid: string, originalOrderUuid: string, duplicateOrderUuid?: string | null, createdAt: any, updatedAt: any, expiresAt?: any | null, acceptedAt?: any | null, declinedAt?: any | null, expiredAt?: any | null, revokedAt?: any | null, completedAt?: any | null } };

export type SettlementBillLineItemForOrderFragment = { __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> };

export type FreightCostForOrderFragment = { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null };

export type FuelCostForOrderFragment = { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number };

export type CustomCostForOrderFragment = { __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null };

type ShallowContact_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', defaultUseTariff?: boolean | null, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, resolvedFreightBillingMethod: FreightBillingMethod, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceType: InvoiceType, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, isPrepaidOnly: boolean, useCustomVehicleTypes: boolean, useCustomPackageSpecs: boolean, displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus }>, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string, name: string, status: PackageSpecStatus, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, freightClass?: FreightClass | null }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> };

type ShallowContact_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', displayName: string, type: ContactType, isActive: boolean, shortCode?: string | null, uuid: string, contactReferenceNumber?: string | null, quickbooksMappingId?: string | null, quickbooksDesktopContactId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingCustomerName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, stediPartnerId?: string | null, billingCycleDuration: BillingCycleDuration, billingContactEmail?: string | null, isEfm?: boolean | null, showEdiReferenceNumbersOnOrderPage: boolean, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, contactStations: Array<{ __typename?: 'ContactStationEntity', id: string, name: string, isArchived: boolean, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null }> };

export type ShallowContactFragment = ShallowContact_CustomerContactEntity_Fragment | ShallowContact_ThirdPartyContactEntity_Fragment;

export type ShipmentBillOfLadingQueryVariables = Exact<{
  shipmentUuid: Scalars['String']['input'];
}>;


export type ShipmentBillOfLadingQuery = { __typename?: 'Query', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, fields?: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, uuid: string, destinationAirport?: string | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } } }>, order?: { __typename?: 'StandardOrderEntity', name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, weightUnits: WeightUnits, measurementUnits: MeasurementUnits }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string }>, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string } | null }, ediTransactions: Array<{ __typename?: 'EdiTransactionEntity', uuid: string, code: EdiTransactionCode, status: EdiTransactionStatus }> } | null } };

export type StandardOrderQueryStopFragment = { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed: boolean, appointmentStatus?: AppointmentStatus | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, stopIntention?: StopIntention | null, paperworkMarkedComplete?: boolean | null, failureCount?: number | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> };

export type StandardOrderQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StandardOrderQuery = { __typename?: 'Query', standardOrder: { __typename?: 'StandardOrderEntity', updatedAt: any, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, isOverdue: boolean, detailedStatusV2?: OrderDetailedStatus | null, hasIssues: boolean, hasDamage: boolean, hasShortage: boolean, isReverse: boolean, isReturnOrder: boolean, osd?: boolean | null, codCheckAmountCents?: number | null, codCheckNumber?: string | null, isCollectOnDelivery: boolean, isCrossDock?: boolean | null, isDoorToDoor?: boolean | null, inboundStopIntention?: StopIntention | null, outboundStopIntention?: StopIntention | null, displayChargesInCustomerPortalOverride?: boolean | null, customerPortalChargesVisibleFromOverride?: CustomerPortalChargesVisibility | null, hasEdiCancellation: boolean, issueReason?: string | null, personName?: string | null, personPhoneNumber?: string | null, personEmail?: string | null, name: string, notes: string, refusedBy?: string | null, refusedDate?: any | null, refusedReason?: string | null, onHand?: boolean | null, refNumbers: Array<string>, pieceCount?: number | null, piecesPicked?: number | null, orderConsolidationType: OrderConsolidationType, orderInvoiceByDate?: any | null, paymentMethod?: PaymentMethod | null, receivedDate?: any | null, pickedDate?: any | null, source: OrderSource, status: OrderStatus, uuid: string, isDraftOrder: boolean, chargeableWeightCubicMeters?: any | null, totalSkids?: number | null, isReweighed: boolean, inBond: boolean, hazmat: boolean, itTeNumber?: string | null, itTeIssueDate?: any | null, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, externalNotes?: string | null, totalAmountCents?: number | null, postedAmountCents?: number | null, secondaryRefNumber?: string | null, lockSecondaryRefNumber: boolean, tertiaryRefNumber?: string | null, quaternaryRefNumber?: string | null, quinaryRefNumber?: string | null, lineHaulCompletedDate: any, dateMarkedLoaded?: any | null, dateMarkedOnHand?: any | null, dateMarkedReceivedAtOrigin?: any | null, piecesLoaded?: number | null, enableLineHaul: boolean, shouldBillIndividually: boolean, consolidatedShipmentString?: string | null, freightNeedsRate: boolean, reversalCounterpart?: { __typename?: 'ReversalCounterpartOrder', uuid: string, name: string, isReturnOrder: boolean } | null, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, holdReason?: { __typename?: 'HoldReasonEntity', uuid: string, name: string } | null, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, postedAt?: any | null } | null, delegations: Array<{ __typename: 'OrderDelegationEntity', uuid: string, status: OrderDelegationStatus, scope: OrderDelegationScope, executingCompanyName: string, executingCompanyUuid: string, originatorCompanyName: string, originatorCompanyUuid: string, organizationPeerUuid: string, originalOrderUuid: string, duplicateOrderUuid?: string | null, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, expiredAt?: any | null, revokedAt?: any | null, completedAt?: any | null, expiresAt?: any | null }>, delegationAsDuplicate?: { __typename: 'OrderDelegationEntity', uuid: string, status: OrderDelegationStatus, scope: OrderDelegationScope, executingCompanyName: string, executingCompanyUuid: string, originatorCompanyName: string, originatorCompanyUuid: string, organizationPeerUuid: string, originalOrderUuid: string, duplicateOrderUuid?: string | null, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, expiredAt?: any | null, revokedAt?: any | null, completedAt?: any | null, originatorProgressStatus?: OrderDetailedStatus | null } | null, driverQualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string, name: string }>, recurringOrderFrequency?: { __typename?: 'RecurringOrderFrequencyEntity', uuid: string, startDate: any, endDate?: any | null, repeatFrequencyUnit: RepeatFrequencyUnit, repeatInterval: number, daysOfWeek: Array<DayOfWeekAll>, daysOfMonth: Array<number>, repeatIntervalWeeks?: number | null } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, lockShipperBillOfLadingNumber: boolean, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null, measurementUnits: MeasurementUnits, weightUnits: WeightUnits }, scannedOrderResult?: { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus, s3Url: string }, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string }> } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, billingPartyContactStation?: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, originalTransmissionPackages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, description: string }>, pieces: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, quantity: number, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, ratingFailure?: { __typename?: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, retryable: boolean } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, status: ExternalRateQuoteStatus, finalCents?: number | null } | null, lastRatedExternalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, finalCents?: number | null } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode?: string | null, terminal: string, isArchived: boolean, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed: boolean, appointmentStatus?: AppointmentStatus | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, stopIntention?: StopIntention | null, paperworkMarkedComplete?: boolean | null, failureCount?: number | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, lineHaulTimeline: Array<{ __typename?: 'OrderLineHaulTimelineEventEntity', markedArrivedAt?: any | null, terminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, departingManifest?: { __typename?: 'LineHaulManifestEntity', uuid: string, status: LineHaulManifestStatus, departDate: any, startedAt?: any | null, completedAt?: any | null, referenceNumber: string, driver?: { __typename?: 'DriverEntity', firstName: string, lastName: string, agentId?: string | null } | null } | null, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }>, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null } | null, lineHaulOriginTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, ordersWithSameBillOfLadingNumberForReviewOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string }> | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, showOnInvoice?: boolean | null, authorName: string, user?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, piece?: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, consolidatableOrders: { __typename?: 'ConsolidatableOrdersOutput', error?: FindConsolidatableOrdersError | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, shipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null }, consolidatedOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> } };

export type StandardOrderFragmentFragment = { __typename?: 'StandardOrderEntity', updatedAt: any, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, isOverdue: boolean, detailedStatusV2?: OrderDetailedStatus | null, hasIssues: boolean, hasDamage: boolean, hasShortage: boolean, isReverse: boolean, isReturnOrder: boolean, osd?: boolean | null, codCheckAmountCents?: number | null, codCheckNumber?: string | null, isCollectOnDelivery: boolean, isCrossDock?: boolean | null, isDoorToDoor?: boolean | null, inboundStopIntention?: StopIntention | null, outboundStopIntention?: StopIntention | null, displayChargesInCustomerPortalOverride?: boolean | null, customerPortalChargesVisibleFromOverride?: CustomerPortalChargesVisibility | null, hasEdiCancellation: boolean, issueReason?: string | null, personName?: string | null, personPhoneNumber?: string | null, personEmail?: string | null, name: string, notes: string, refusedBy?: string | null, refusedDate?: any | null, refusedReason?: string | null, onHand?: boolean | null, refNumbers: Array<string>, pieceCount?: number | null, piecesPicked?: number | null, orderConsolidationType: OrderConsolidationType, orderInvoiceByDate?: any | null, paymentMethod?: PaymentMethod | null, receivedDate?: any | null, pickedDate?: any | null, source: OrderSource, status: OrderStatus, uuid: string, isDraftOrder: boolean, chargeableWeightCubicMeters?: any | null, totalSkids?: number | null, isReweighed: boolean, inBond: boolean, hazmat: boolean, itTeNumber?: string | null, itTeIssueDate?: any | null, unNumber?: string | null, hazmatDescription?: string | null, emergencyResponseNumber?: string | null, requiresPlacard?: boolean | null, hazmatClass?: HazmatClass | null, packageGroup?: PackageGroup | null, externalNotes?: string | null, totalAmountCents?: number | null, postedAmountCents?: number | null, secondaryRefNumber?: string | null, lockSecondaryRefNumber: boolean, tertiaryRefNumber?: string | null, quaternaryRefNumber?: string | null, quinaryRefNumber?: string | null, lineHaulCompletedDate: any, dateMarkedLoaded?: any | null, dateMarkedOnHand?: any | null, dateMarkedReceivedAtOrigin?: any | null, piecesLoaded?: number | null, enableLineHaul: boolean, shouldBillIndividually: boolean, consolidatedShipmentString?: string | null, freightNeedsRate: boolean, reversalCounterpart?: { __typename?: 'ReversalCounterpartOrder', uuid: string, name: string, isReturnOrder: boolean } | null, ordersProratedWith?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, holdReason?: { __typename?: 'HoldReasonEntity', uuid: string, name: string } | null, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, journalNumber: number, postedAt?: any | null } | null, delegations: Array<{ __typename: 'OrderDelegationEntity', uuid: string, status: OrderDelegationStatus, scope: OrderDelegationScope, executingCompanyName: string, executingCompanyUuid: string, originatorCompanyName: string, originatorCompanyUuid: string, organizationPeerUuid: string, originalOrderUuid: string, duplicateOrderUuid?: string | null, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, expiredAt?: any | null, revokedAt?: any | null, completedAt?: any | null, expiresAt?: any | null }>, delegationAsDuplicate?: { __typename: 'OrderDelegationEntity', uuid: string, status: OrderDelegationStatus, scope: OrderDelegationScope, executingCompanyName: string, executingCompanyUuid: string, originatorCompanyName: string, originatorCompanyUuid: string, organizationPeerUuid: string, originalOrderUuid: string, duplicateOrderUuid?: string | null, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, expiredAt?: any | null, revokedAt?: any | null, completedAt?: any | null, originatorProgressStatus?: OrderDetailedStatus | null } | null, driverQualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string, name: string }>, recurringOrderFrequency?: { __typename?: 'RecurringOrderFrequencyEntity', uuid: string, startDate: any, endDate?: any | null, repeatFrequencyUnit: RepeatFrequencyUnit, repeatInterval: number, daysOfWeek: Array<DayOfWeekAll>, daysOfMonth: Array<number>, repeatIntervalWeeks?: number | null } | null, service?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null, lockShipperBillOfLadingNumber: boolean, masterAirwayBillOfLadingNumber?: string | null, dimFactor?: number | null, measurementUnits: MeasurementUnits, weightUnits: WeightUnits }, scannedOrderResult?: { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus, s3Url: string }, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string }> } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, paperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, paperworkMarkedCompleteOverride?: boolean | null, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null }, billingPartyContactStation?: { __typename?: 'ContactStationEntity', id: string, name: string, defaultPerson?: { __typename?: 'PersonEntity', id: string, firstName: string, lastName: string, phone?: string | null, email?: string | null } | null } | null, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }>, originalTransmissionPackages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, description: string }>, pieces: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string }>, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, quantity: number, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, ratingFailure?: { __typename?: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, retryable: boolean } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, status: ExternalRateQuoteStatus, finalCents?: number | null } | null, lastRatedExternalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, finalCents?: number | null } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode?: string | null, terminal: string, isArchived: boolean, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed: boolean, appointmentStatus?: AppointmentStatus | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, stopIntention?: StopIntention | null, paperworkMarkedComplete?: boolean | null, failureCount?: number | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, lineHaulTimeline: Array<{ __typename?: 'OrderLineHaulTimelineEventEntity', markedArrivedAt?: any | null, terminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, departingManifest?: { __typename?: 'LineHaulManifestEntity', uuid: string, status: LineHaulManifestStatus, departDate: any, startedAt?: any | null, completedAt?: any | null, referenceNumber: string, driver?: { __typename?: 'DriverEntity', firstName: string, lastName: string, agentId?: string | null } | null } | null, arrivalScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }>, departureScans: Array<{ __typename?: 'ScanEntity', uuid: string, scannedAt: any }> }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, thirdPartyBrokers: Array<{ __typename?: 'ThirdPartyBrokerEntity', uuid: string, name: string }>, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null } | null, lineHaulOriginTerminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, ordersWithSameBillOfLadingNumberForReviewOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, name: string }> | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, updatedAt: any, comment: string, showOnInvoice?: boolean | null, authorName: string, user?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, piece?: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } | null }>, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, consolidatableOrders: { __typename?: 'ConsolidatableOrdersOutput', error?: FindConsolidatableOrdersError | null, orders: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, shipments?: Array<{ __typename?: 'StandardShipmentEntity', uuid: string }> | null }, consolidatedOrders?: Array<{ __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } }> | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> };

export type StopDriverMapForOrderFragment = { __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } };

export type StopForDriverSettlementFragment = { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> };

export type StopForDriverSettlementQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StopForDriverSettlementQuery = { __typename?: 'Query', stop: { __typename?: 'StandardStopEntity', uuid: string, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> } };

export type UncancelOrderMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type UncancelOrderMutation = { __typename?: 'Mutation', uncancelOrder: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null } };

export type UnfinalizeOrderMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type UnfinalizeOrderMutation = { __typename?: 'Mutation', unfinalizeOrder: { __typename?: 'StandardOrderEntity', uuid: string, status: OrderStatus, detailedStatusV2?: OrderDetailedStatus | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus }> } };

export type UnfinalizeOrdersMutationVariables = Exact<{
  unfinalizeOrdersInput: UnfinalizeOrdersInput;
}>;


export type UnfinalizeOrdersMutation = { __typename?: 'Mutation', unfinalizeOrders: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'UnfinalizeOrdersSuccessOutput', unfinalizedOrderUuids: Array<string>, skippedOnInvoiceOrderUuids: Array<string>, failedOrderUuids: Array<string> } };

export type UnlinkPieceFromPackageMutationVariables = Exact<{
  unlinkPieceFromPackageInput: UnlinkPieceFromPackageInput;
}>;


export type UnlinkPieceFromPackageMutation = { __typename?: 'Mutation', unlinkPieceFromPackage: boolean };

export type UpdateDocumentMutationVariables = Exact<{
  updateDocumentInput: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'DocumentEntity', uuid: string } };

export type UpdatePaperworkCompletedForStopsMutationVariables = Exact<{
  updatePaperworkCompleteInput: UpdatePaperworkCompleteInput;
}>;


export type UpdatePaperworkCompletedForStopsMutation = { __typename?: 'Mutation', updatePaperworkCompletedForStops: Array<{ __typename?: 'StandardStopEntity', uuid: string }> };

export type UpdateRecurringRunMutationVariables = Exact<{
  input: UpdateRunInput;
}>;


export type UpdateRecurringRunMutation = { __typename?: 'Mutation', updateRun: { __typename?: 'UpdateRunOutput', run: { __typename?: 'RunEntity', name: string, uuid: string, isArchived: boolean, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, driver?: { __typename?: 'DriverEntity', uuid: string, status: DriverStatus, firstName: string, lastName: string } | null, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string } | null, recurringOrderTemplates: Array<{ __typename?: 'StandardOrderEntity', uuid: string }>, tags: Array<{ __typename?: 'TagEntity', uuid: string }> } } };

export type UpdateStandardOrderMutationVariables = Exact<{
  updateStandardOrderInput: UpdateStandardOrderInput;
}>;


export type UpdateStandardOrderMutation = { __typename?: 'Mutation', updateStandardOrder: { __typename?: 'StandardOrderEntity', uuid: string, detailedStatusV2?: OrderDetailedStatus | null, status: OrderStatus, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, packages: Array<{ __typename?: 'PackageEntity', uuid: string, quantity: number }> } };

export type BulkEditOrdersResponseFragmentFragment = { __typename?: 'BulkEditOrdersResponse', success: boolean, orderStateActions?: Array<{ __typename?: 'OrderActionResult', action: OrderAction, results: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } }> | null, stopStateActions?: Array<{ __typename?: 'StopActionResult', action: StopAction, results: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } }> | null, warehouseUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null, mawbUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null, secondaryRefNumberUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null, deadlineTypeUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null, deadlineDateUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null, serviceDateUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null };

export type ValidateBulkEditOrdersQueryVariables = Exact<{
  bulkEditOrdersInput: BulkEditOrdersInput;
}>;


export type ValidateBulkEditOrdersQuery = { __typename?: 'Query', validateBulkEditOrders: { __typename?: 'BulkEditOrdersResponse', success: boolean, orderStateActions?: Array<{ __typename?: 'OrderActionResult', action: OrderAction, results: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } }> | null, stopStateActions?: Array<{ __typename?: 'StopActionResult', action: StopAction, results: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } }> | null, warehouseUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null, mawbUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null, secondaryRefNumberUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null, deadlineTypeUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null, deadlineDateUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null, serviceDateUpdate?: { __typename?: 'BulkActionEntityResults', total: number, eligible: number, ineligible: number, succeeded: number, failed: number, eligibleItems: Array<string>, ineligibleItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }>, failedItems: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } | null } };

export type RateOrderByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
  persist: Scalars['Boolean']['input'];
}>;


export type RateOrderByUuidQuery = { __typename?: 'Query', rateOrderByUuid: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean } };

export type RateOrderTotalDollarsQueryVariables = Exact<{
  rateOrderInput: RateOrderInput;
}>;


export type RateOrderTotalDollarsQuery = { __typename?: 'Query', rateOrderContents: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', totalDollars: any } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', totalDollars: any } | null } | null } };

export type RateOrderSettlementBillLineItemFragment = { __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput', customCostTotal: any, success: boolean, total: any, customCosts: Array<{ __typename?: 'RateCustomCostOutput', errorMessage?: number | null, existingCustomCostId?: string | null, fuelSurchargePercentageRate?: number | null, rateDollars?: any | null, totalDollars?: any | null }>, freightCost?: { __typename?: 'RateIndependentFreightCostSuccessOutput', discountRate?: any | null, miles?: number | null, quantity: number, rateDollars: any, tariffUuid?: string | null, totalDollars: any } | null, fuelCost?: { __typename?: 'RateIndependentFuelCostSuccessOutput', surchargeRate?: number | null, surchargeRatePercentage?: any | null, totalDollars: any, flatRateUsdDollars?: any | null, warning?: FuelRatingWarning | null, warningDetails?: { __typename?: 'FuelRatingWarningDetailsEntity', fuelProfileName?: string | null, tariffName?: string | null, fuelProfileExpired: boolean } | null } | null };

type RateOrderExternalRating_ExternalRatingFailure_Fragment = { __typename: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, packageIndex?: number | null, retryable: boolean };

type RateOrderExternalRating_ExternalRatingSuccess_Fragment = { __typename: 'ExternalRatingSuccess', tariffName: string, tariffEffectiveDate: string, minimumAdjustmentCents: number, deficitWeightLbs: number, finalCents: number, lines: Array<{ __typename?: 'ExternalRatingLine', freightClass?: string | null, weightLbs?: number | null, amountCents: number, isMinimumAdjustment: boolean }> };

export type RateOrderExternalRatingFragment = RateOrderExternalRating_ExternalRatingFailure_Fragment | RateOrderExternalRating_ExternalRatingSuccess_Fragment;

export type RateOrderQueryVariables = Exact<{
  rateOrderInput: RateOrderInput;
}>;


export type RateOrderQuery = { __typename?: 'Query', rateOrderContents: { __typename: 'RateOrderErrorOutput', success: boolean, errorMessage?: string | null } | { __typename: 'RateOrderSuccessOutput', success: boolean, totalDollars?: any | null, inboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', rateDollars: any, totalDollars: any, tariffUuid?: string | null, quantity: number, discountRate?: any | null, miles?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, tariffWarning?: FreightRatingWarning | null, expiredTariffGroup?: { __typename?: 'ExpiredTariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType?: TariffGroupType | null, endDate?: any | null, additional: Array<{ __typename?: 'ExpiredTariffGroupSummaryEntity', name?: string | null, endDate?: any | null }> } | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', surchargeRatePercentage?: any | null, totalDollars: any, flatRateUsdDollars?: any | null, fuelProfileName?: string | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, warning?: FuelRatingWarning | null, warningDetails?: { __typename?: 'FuelRatingWarningDetailsEntity', fuelProfileName?: string | null, tariffName?: string | null, fuelProfileExpired: boolean } | null } | null, customCharges: Array<{ __typename?: 'RateCustomChargeOutput', rateDollars?: any | null, totalDollars?: any | null, fuelSurchargePercentageRate?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, warning?: CustomChargeRatingWarning | null }>, independentSettlementBillLineItems: Array<{ __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput', customCostTotal: any, success: boolean, total: any, customCosts: Array<{ __typename?: 'RateCustomCostOutput', errorMessage?: number | null, existingCustomCostId?: string | null, fuelSurchargePercentageRate?: number | null, rateDollars?: any | null, totalDollars?: any | null }>, freightCost?: { __typename?: 'RateIndependentFreightCostSuccessOutput', discountRate?: any | null, miles?: number | null, quantity: number, rateDollars: any, tariffUuid?: string | null, totalDollars: any } | null, fuelCost?: { __typename?: 'RateIndependentFuelCostSuccessOutput', surchargeRate?: number | null, surchargeRatePercentage?: any | null, totalDollars: any, flatRateUsdDollars?: any | null, warning?: FuelRatingWarning | null, warningDetails?: { __typename?: 'FuelRatingWarningDetailsEntity', fuelProfileName?: string | null, tariffName?: string | null, fuelProfileExpired: boolean } | null } | null }>, externalRating?: { __typename: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, packageIndex?: number | null, retryable: boolean } | { __typename: 'ExternalRatingSuccess', tariffName: string, tariffEffectiveDate: string, minimumAdjustmentCents: number, deficitWeightLbs: number, finalCents: number, lines: Array<{ __typename?: 'ExternalRatingLine', freightClass?: string | null, weightLbs?: number | null, amountCents: number, isMinimumAdjustment: boolean }> } | null } | null, outboundShipmentCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', rateDollars: any, totalDollars: any, tariffUuid?: string | null, quantity: number, discountRate?: any | null, miles?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, tariffWarning?: FreightRatingWarning | null, expiredTariffGroup?: { __typename?: 'ExpiredTariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType?: TariffGroupType | null, endDate?: any | null, additional: Array<{ __typename?: 'ExpiredTariffGroupSummaryEntity', name?: string | null, endDate?: any | null }> } | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', surchargeRatePercentage?: any | null, totalDollars: any, flatRateUsdDollars?: any | null, fuelProfileName?: string | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, warning?: FuelRatingWarning | null, warningDetails?: { __typename?: 'FuelRatingWarningDetailsEntity', fuelProfileName?: string | null, tariffName?: string | null, fuelProfileExpired: boolean } | null } | null, customCharges: Array<{ __typename?: 'RateCustomChargeOutput', rateDollars?: any | null, totalDollars?: any | null, fuelSurchargePercentageRate?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, warning?: CustomChargeRatingWarning | null }>, independentSettlementBillLineItems: Array<{ __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput', customCostTotal: any, success: boolean, total: any, customCosts: Array<{ __typename?: 'RateCustomCostOutput', errorMessage?: number | null, existingCustomCostId?: string | null, fuelSurchargePercentageRate?: number | null, rateDollars?: any | null, totalDollars?: any | null }>, freightCost?: { __typename?: 'RateIndependentFreightCostSuccessOutput', discountRate?: any | null, miles?: number | null, quantity: number, rateDollars: any, tariffUuid?: string | null, totalDollars: any } | null, fuelCost?: { __typename?: 'RateIndependentFuelCostSuccessOutput', surchargeRate?: number | null, surchargeRatePercentage?: any | null, totalDollars: any, flatRateUsdDollars?: any | null, warning?: FuelRatingWarning | null, warningDetails?: { __typename?: 'FuelRatingWarningDetailsEntity', fuelProfileName?: string | null, tariffName?: string | null, fuelProfileExpired: boolean } | null } | null }>, externalRating?: { __typename: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, packageIndex?: number | null, retryable: boolean } | { __typename: 'ExternalRatingSuccess', tariffName: string, tariffEffectiveDate: string, minimumAdjustmentCents: number, deficitWeightLbs: number, finalCents: number, lines: Array<{ __typename?: 'ExternalRatingLine', freightClass?: string | null, weightLbs?: number | null, amountCents: number, isMinimumAdjustment: boolean }> } | null } | null, lineHaulCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', rateDollars: any, totalDollars: any, tariffUuid?: string | null, quantity: number, discountRate?: any | null, miles?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, tariffWarning?: FreightRatingWarning | null, expiredTariffGroup?: { __typename?: 'ExpiredTariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType?: TariffGroupType | null, endDate?: any | null, additional: Array<{ __typename?: 'ExpiredTariffGroupSummaryEntity', name?: string | null, endDate?: any | null }> } | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', surchargeRatePercentage?: any | null, totalDollars: any, flatRateUsdDollars?: any | null, fuelProfileName?: string | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, warning?: FuelRatingWarning | null, warningDetails?: { __typename?: 'FuelRatingWarningDetailsEntity', fuelProfileName?: string | null, tariffName?: string | null, fuelProfileExpired: boolean } | null } | null, customCharges: Array<{ __typename?: 'RateCustomChargeOutput', rateDollars?: any | null, totalDollars?: any | null, fuelSurchargePercentageRate?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, warning?: CustomChargeRatingWarning | null }>, independentSettlementBillLineItems: Array<{ __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput', customCostTotal: any, success: boolean, total: any, customCosts: Array<{ __typename?: 'RateCustomCostOutput', errorMessage?: number | null, existingCustomCostId?: string | null, fuelSurchargePercentageRate?: number | null, rateDollars?: any | null, totalDollars?: any | null }>, freightCost?: { __typename?: 'RateIndependentFreightCostSuccessOutput', discountRate?: any | null, miles?: number | null, quantity: number, rateDollars: any, tariffUuid?: string | null, totalDollars: any } | null, fuelCost?: { __typename?: 'RateIndependentFuelCostSuccessOutput', surchargeRate?: number | null, surchargeRatePercentage?: any | null, totalDollars: any, flatRateUsdDollars?: any | null, warning?: FuelRatingWarning | null, warningDetails?: { __typename?: 'FuelRatingWarningDetailsEntity', fuelProfileName?: string | null, tariffName?: string | null, fuelProfileExpired: boolean } | null } | null }>, externalRating?: { __typename: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, packageIndex?: number | null, retryable: boolean } | { __typename: 'ExternalRatingSuccess', tariffName: string, tariffEffectiveDate: string, minimumAdjustmentCents: number, deficitWeightLbs: number, finalCents: number, lines: Array<{ __typename?: 'ExternalRatingLine', freightClass?: string | null, weightLbs?: number | null, amountCents: number, isMinimumAdjustment: boolean }> } | null } | null, orderCharges?: { __typename?: 'RateShipmentForOrderSuccessOutput', freightCharge?: { __typename?: 'RateFreightChargeSuccessOutput', rateDollars: any, totalDollars: any, tariffUuid?: string | null, quantity: number, discountRate?: any | null, miles?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, tariffWarning?: FreightRatingWarning | null, expiredTariffGroup?: { __typename?: 'ExpiredTariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType?: TariffGroupType | null, endDate?: any | null, additional: Array<{ __typename?: 'ExpiredTariffGroupSummaryEntity', name?: string | null, endDate?: any | null }> } | null } | null, fuelCharge?: { __typename?: 'RateFuelChargeSuccessOutput', surchargeRatePercentage?: any | null, totalDollars: any, flatRateUsdDollars?: any | null, fuelProfileName?: string | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, warning?: FuelRatingWarning | null, warningDetails?: { __typename?: 'FuelRatingWarningDetailsEntity', fuelProfileName?: string | null, tariffName?: string | null, fuelProfileExpired: boolean } | null } | null, customCharges: Array<{ __typename?: 'RateCustomChargeOutput', rateDollars?: any | null, totalDollars?: any | null, fuelSurchargePercentageRate?: number | null, settlementFlatRate?: any | null, settlementPercentageRate?: any | null, warning?: CustomChargeRatingWarning | null }>, independentSettlementBillLineItems: Array<{ __typename?: 'RateIndependentSettlementBillLineItemSuccessOutput', customCostTotal: any, success: boolean, total: any, customCosts: Array<{ __typename?: 'RateCustomCostOutput', errorMessage?: number | null, existingCustomCostId?: string | null, fuelSurchargePercentageRate?: number | null, rateDollars?: any | null, totalDollars?: any | null }>, freightCost?: { __typename?: 'RateIndependentFreightCostSuccessOutput', discountRate?: any | null, miles?: number | null, quantity: number, rateDollars: any, tariffUuid?: string | null, totalDollars: any } | null, fuelCost?: { __typename?: 'RateIndependentFuelCostSuccessOutput', surchargeRate?: number | null, surchargeRatePercentage?: any | null, totalDollars: any, flatRateUsdDollars?: any | null, warning?: FuelRatingWarning | null, warningDetails?: { __typename?: 'FuelRatingWarningDetailsEntity', fuelProfileName?: string | null, tariffName?: string | null, fuelProfileExpired: boolean } | null } | null }>, externalRating?: { __typename: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, packageIndex?: number | null, retryable: boolean } | { __typename: 'ExternalRatingSuccess', tariffName: string, tariffEffectiveDate: string, minimumAdjustmentCents: number, deficitWeightLbs: number, finalCents: number, lines: Array<{ __typename?: 'ExternalRatingLine', freightClass?: string | null, weightLbs?: number | null, amountCents: number, isMinimumAdjustment: boolean }> } | null } | null } };

export type ActiveOrganizationMessageBannersQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveOrganizationMessageBannersQuery = { __typename?: 'Query', activeOrganizationMessageBanners: { __typename?: 'OrganizationMessageBannersEntity', nextChangeAt?: any | null, banners: Array<{ __typename?: 'OrganizationMessageBannerEntity', uuid: string, severity: OrganizationMessageSeverity, title: string, body: string, linkType?: OrganizationMessageLinkType | null, linkTarget?: string | null, linkLabel?: string | null, dismissible: boolean }> } };

export type DismissOrganizationMessageMutationVariables = Exact<{
  input: OrganizationMessageUuidInput;
}>;


export type DismissOrganizationMessageMutation = { __typename?: 'Mutation', dismissOrganizationMessage: boolean };

export type BusinessKpiInvoicedOrdersQueryVariables = Exact<{
  args: KpiRecordTableArgs;
}>;


export type BusinessKpiInvoicedOrdersQuery = { __typename?: 'Query', businessKpiInvoicedOrders: { __typename?: 'KpiInvoicedOrderRecordsEntity', totalRecords: number, facets?: { __typename?: 'KpiRecordFacetsEntity', customers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, terminals: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, drivers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }> } | null, records: Array<{ __typename?: 'KpiInvoicedOrderRecordEntity', orderUuid: string, fileNo?: string | null, customerName: string, createdAt: any, invoicedAt: any, invoiceUuid?: string | null, invoiceName?: string | null, days: number }> } };

export type BusinessKpiOrdersPerDriverQueryVariables = Exact<{
  args: KpiRecordTableArgs;
}>;


export type BusinessKpiOrdersPerDriverQuery = { __typename?: 'Query', businessKpiOrdersPerDriver: { __typename?: 'KpiDriverOrdersRecordsEntity', totalRecords: number, facets?: { __typename?: 'KpiRecordFacetsEntity', customers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, terminals: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, drivers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }> } | null, records: Array<{ __typename?: 'KpiDriverOrdersRecordEntity', driverUuid: string, driverName?: string | null, orderCount: number, share?: number | null }> } };

export type BusinessKpiOrdersQueryVariables = Exact<{
  args: KpiRecordTableArgs;
}>;


export type BusinessKpiOrdersQuery = { __typename?: 'Query', businessKpiOrders: { __typename?: 'KpiOrderRecordsEntity', totalRecords: number, revenueVisible: boolean, facets?: { __typename?: 'KpiRecordFacetsEntity', customers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, terminals: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, drivers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }> } | null, records: Array<{ __typename?: 'KpiOrderRecordEntity', orderUuid: string, fileNo?: string | null, customerName: string, serviceDate?: any | null, terminalName?: string | null, driverNames: Array<string>, revenueCents?: number | null }> } };

export type BusinessKpiPaidInvoicesQueryVariables = Exact<{
  args: KpiRecordTableArgs;
}>;


export type BusinessKpiPaidInvoicesQuery = { __typename?: 'Query', businessKpiPaidInvoices: { __typename?: 'KpiPaidInvoiceRecordsEntity', totalRecords: number, amountVisible: boolean, facets?: { __typename?: 'KpiRecordFacetsEntity', customers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, terminals: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, drivers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }> } | null, records: Array<{ __typename?: 'KpiPaidInvoiceRecordEntity', invoiceUuid: string, invoiceName: string, customerName: string, invoiceDate: any, paidAt: any, days: number, amountCents?: number | null }> } };

export type BusinessKpisQueryVariables = Exact<{
  args: KpiReportArgs;
}>;


export type BusinessKpisQuery = { __typename?: 'Query', businessKpis: { __typename?: 'BusinessKpisEntity', current: { __typename?: 'BusinessKpiSetEntity', revenueCents?: number | null, orderCount?: number | null, driverCount?: number | null, ordersPerDriver?: number | null, avgDaysToInvoice?: number | null, invoicedOrderCount?: number | null, avgDaysToPayment?: number | null, paidInvoiceCount?: number | null, unassignedLineHaulCents?: number | null, unassignedNoTerminalCents?: number | null }, lastYear: { __typename?: 'BusinessKpiSetEntity', revenueCents?: number | null, orderCount?: number | null, driverCount?: number | null, ordersPerDriver?: number | null, avgDaysToInvoice?: number | null, invoicedOrderCount?: number | null, avgDaysToPayment?: number | null, paidInvoiceCount?: number | null, unassignedLineHaulCents?: number | null, unassignedNoTerminalCents?: number | null } } };

export type DeliveryFailureKpiQueryVariables = Exact<{
  args: KpiReportArgs;
}>;


export type DeliveryFailureKpiQuery = { __typename?: 'Query', deliveryFailureKpi: { __typename?: 'DeliveryFailureKpiEntity', failurePct?: number | null, scheduledStops: number, deliveredStops: number, failedStops: number, settledStops: number, pendingStops: number, deliveredLateDayStops: number, neverDeliveredStops: number, forceMarkedCompleteStops: number, bucketUnit: KpiTrendBucketUnit, trend: Array<{ __typename?: 'DeliveryFailureTrendBucketEntity', bucketDate: string, settledStops: number, failedStops: number, failurePct?: number | null }>, customers: Array<{ __typename?: 'DeliveryFailureGroupRowEntity', uuid?: string | null, name?: string | null, settledStops: number, failedStops: number, failurePct?: number | null }>, drivers: Array<{ __typename?: 'DeliveryFailureGroupRowEntity', uuid?: string | null, name?: string | null, settledStops: number, failedStops: number, failurePct?: number | null }>, terminals: Array<{ __typename?: 'DeliveryFailureGroupRowEntity', uuid?: string | null, name?: string | null, settledStops: number, failedStops: number, failurePct?: number | null }>, stops: Array<{ __typename?: 'DeliveryFailureStopRowEntity', orderUuid: string, fileNo?: string | null, customerName: string, promisedDate: string, stopTimeZone: string, appointmentTime?: any | null, endAppointmentTime?: any | null, fromDeadline: boolean, stopStatus: string, completedAt?: any | null, terminalName?: string | null, driverNames: Array<string> }> } };

export type DeliveryFailureStopsQueryVariables = Exact<{
  args: KpiRecordTableArgs;
}>;


export type DeliveryFailureStopsQuery = { __typename?: 'Query', deliveryFailureStops: { __typename?: 'DeliveryFailureStopsEntity', totalStops: number, facets: { __typename?: 'KpiRecordFacetsEntity', customers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, terminals: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, drivers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }> }, stops: Array<{ __typename?: 'DeliveryFailureStopRowEntity', orderUuid: string, fileNo?: string | null, customerName: string, promisedDate: string, fromDeadline: boolean, completedAt?: any | null, stopStatus: string, stopTimeZone: string, daysLate: number, terminalName?: string | null, driverNames: Array<string> }> } };

export type DockReceivedKpiReceiptsQueryVariables = Exact<{
  args: KpiRecordTableArgs;
}>;


export type DockReceivedKpiReceiptsQuery = { __typename?: 'Query', dockReceivedKpiReceipts: { __typename?: 'KpiDockReceiptRecordsEntity', totalRecords: number, facets?: { __typename?: 'KpiRecordFacetsEntity', customers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, terminals: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, drivers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }> } | null, records: Array<{ __typename?: 'KpiDockReceiptRecordEntity', pieceName: string, orderUuid?: string | null, fileNo?: string | null, customerName?: string | null, receivedAt: any, terminalName?: string | null }> } };

export type DockReceivedKpiQueryVariables = Exact<{
  args: KpiReportArgs;
}>;


export type DockReceivedKpiQuery = { __typename?: 'Query', dockReceivedKpi: { __typename?: 'DockReceivedKpiEntity', piecesReceivedCount: number, ordersReceivedCount: number, arrivalScanCount: number, unlinkedScanCount: number, bucketUnit: KpiTrendBucketUnit, trend: Array<{ __typename?: 'DockReceivedTrendBucketEntity', bucketDate: string, piecesReceivedCount: number }>, terminals: Array<{ __typename?: 'DockReceivedTerminalRowEntity', uuid?: string | null, name?: string | null, piecesReceivedCount: number, ordersReceivedCount: number }> } };

export type KpiComparisonsQueryVariables = Exact<{
  args: KpiReportArgs;
}>;


export type KpiComparisonsQuery = { __typename?: 'Query', kpiComparisons: { __typename?: 'KpiComparisonsEntity', delivery?: { __typename?: 'KpiComparisonSetEntity', priorPeriod: { __typename?: 'KpiReferenceValueEntity', pct?: number | null, numerator: number, denominator: number }, lastMonth: { __typename?: 'KpiReferenceValueEntity', pct?: number | null, numerator: number, denominator: number } } | null, pickup?: { __typename?: 'KpiComparisonSetEntity', priorPeriod: { __typename?: 'KpiReferenceValueEntity', pct?: number | null, numerator: number, denominator: number }, lastMonth: { __typename?: 'KpiReferenceValueEntity', pct?: number | null, numerator: number, denominator: number } } | null, scan?: { __typename?: 'KpiComparisonSetEntity', priorPeriod: { __typename?: 'KpiReferenceValueEntity', pct?: number | null, numerator: number, denominator: number }, lastMonth: { __typename?: 'KpiReferenceValueEntity', pct?: number | null, numerator: number, denominator: number } } | null, deliveryFailure?: { __typename?: 'KpiComparisonSetEntity', priorPeriod: { __typename?: 'KpiReferenceValueEntity', pct?: number | null, numerator: number, denominator: number }, lastMonth: { __typename?: 'KpiReferenceValueEntity', pct?: number | null, numerator: number, denominator: number } } | null } };

export type KpiDashboardLayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type KpiDashboardLayoutQuery = { __typename?: 'Query', kpiDashboardLayout: { __typename?: 'KpiLayoutEntity', customized: boolean, tiles: Array<{ __typename?: 'KpiTileEntity', metric: KpiTileMetric, format: KpiTileFormat }>, defaultTiles: Array<{ __typename?: 'KpiTileEntity', metric: KpiTileMetric, format: KpiTileFormat }>, availableTiles: Array<{ __typename?: 'KpiTileEntity', metric: KpiTileMetric, format: KpiTileFormat }> } };

export type KpiDashboardLayoutFragment = { __typename?: 'KpiLayoutEntity', customized: boolean, tiles: Array<{ __typename?: 'KpiTileEntity', metric: KpiTileMetric, format: KpiTileFormat }>, defaultTiles: Array<{ __typename?: 'KpiTileEntity', metric: KpiTileMetric, format: KpiTileFormat }>, availableTiles: Array<{ __typename?: 'KpiTileEntity', metric: KpiTileMetric, format: KpiTileFormat }> };

export type KpiDataStartQueryVariables = Exact<{ [key: string]: never; }>;


export type KpiDataStartQuery = { __typename?: 'Query', kpiDataStart: { __typename?: 'KpiDataStartEntity', firstServiceDate?: { __typename?: 'PlainDate', iso8601: string } | null } };

export type KpiRecordFacetsFragment = { __typename?: 'KpiRecordFacetsEntity', customers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, terminals: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, drivers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }> };

export type KpiRecordTableDownloadMutationVariables = Exact<{
  args: KpiRecordTableDownloadArgs;
}>;


export type KpiRecordTableDownloadMutation = { __typename?: 'Mutation', kpiRecordTableDownload: { __typename: 'KpiRecordTableDownloadFileOutput', url: string, fileName: string } | { __typename: 'KpiRecordTableEmailToUserOutput', rowCount: number, emailedTo: string } };

export type OnTimeKpiStopsQueryVariables = Exact<{
  args: OnTimeKpiStopsArgs;
}>;


export type OnTimeKpiStopsQuery = { __typename?: 'Query', onTimeKpiStops: { __typename?: 'OnTimeKpiStopsEntity', totalStops: number, facets: { __typename?: 'KpiRecordFacetsEntity', customers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, terminals: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, drivers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }> }, stops: Array<{ __typename?: 'OnTimeStopRowEntity', orderUuid: string, fileNo?: string | null, customerName: string, promiseSource?: string | null, promisedAt?: any | null, judgedEvent?: string | null, judgedAt?: any | null, arrivedAt?: any | null, completedAt?: any | null, appointmentTime?: any | null, endAppointmentTime?: any | null, stopTimeZone: string, terminalName?: string | null, driverNames: Array<string> }> } };

export type OnTimeKpiQueryVariables = Exact<{
  args: OnTimeKpiArgs;
}>;


export type OnTimeKpiQuery = { __typename?: 'Query', onTimeKpi: { __typename?: 'OnTimeKpiEntity', onTimePct?: number | null, onTimeStops: number, lateStops: number, measurableStops: number, excludedNoPromiseStops: number, completedStops: number, fallbackJudgedStops: number, bucketUnit: KpiTrendBucketUnit, customerAppointment: { __typename?: 'OnTimeCommitmentSplitEntity', measurableStops: number, onTimeStops: number, onTimePct?: number | null }, forwarderDate: { __typename?: 'OnTimeCommitmentSplitEntity', measurableStops: number, onTimeStops: number, onTimePct?: number | null }, trend: Array<{ __typename?: 'OnTimeTrendBucketEntity', bucketDate: string, measurableStops: number, onTimeStops: number, onTimePct?: number | null }>, customers: Array<{ __typename?: 'OnTimeCustomerRowEntity', customerUuid: string, customerName: string, measurableStops: number, lateStops: number, onTimePct?: number | null }>, drivers: Array<{ __typename?: 'OnTimeGroupRowEntity', uuid?: string | null, name?: string | null, measurableStops: number, lateStops: number, onTimePct?: number | null }>, terminals: Array<{ __typename?: 'OnTimeGroupRowEntity', uuid?: string | null, name?: string | null, measurableStops: number, lateStops: number, onTimePct?: number | null }> } };

export type PieceScanKpiPiecesQueryVariables = Exact<{
  args: KpiRecordTableArgs;
}>;


export type PieceScanKpiPiecesQuery = { __typename?: 'Query', pieceScanKpiPieces: { __typename?: 'KpiPieceRecordsEntity', totalRecords: number, facets?: { __typename?: 'KpiRecordFacetsEntity', customers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, terminals: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }>, drivers: Array<{ __typename?: 'KpiRecordFacetOptionEntity', uuid: string, name?: string | null }> } | null, records: Array<{ __typename?: 'KpiPieceRecordEntity', orderUuid: string, fileNo?: string | null, pieceName: string, customerName: string, serviceDate?: any | null, terminalName?: string | null, scanned: boolean, weight?: number | null, weightUnits?: string | null }> } };

export type PieceScanKpiQueryVariables = Exact<{
  args: KpiReportArgs;
}>;


export type PieceScanKpiQuery = { __typename?: 'Query', pieceScanKpi: { __typename?: 'PieceScanKpiEntity', scanRatePct?: number | null, piecesDeliveredWithScanCount: number, piecesDeliveredCount: number, piecesUnscannedCount: number, bucketUnit: KpiTrendBucketUnit, trend: Array<{ __typename?: 'PieceScanTrendBucketEntity', bucketDate: string, piecesDeliveredCount: number, piecesDeliveredWithScanCount: number, scanRatePct?: number | null }>, customers: Array<{ __typename?: 'PieceScanCustomerRowEntity', customerUuid: string, customerName: string, piecesDeliveredCount: number, piecesUnscannedCount: number, scanRatePct?: number | null }>, drivers: Array<{ __typename?: 'PieceScanGroupRowEntity', uuid?: string | null, name?: string | null, piecesDeliveredCount: number, piecesUnscannedCount: number, scanRatePct?: number | null }>, terminals: Array<{ __typename?: 'PieceScanGroupRowEntity', uuid?: string | null, name?: string | null, piecesDeliveredCount: number, piecesUnscannedCount: number, scanRatePct?: number | null }> } };

export type UpdateKpiDashboardLayoutMutationVariables = Exact<{
  input: UpdateKpiLayoutInput;
}>;


export type UpdateKpiDashboardLayoutMutation = { __typename?: 'Mutation', updateKpiDashboardLayout: { __typename?: 'KpiLayoutEntity', customized: boolean, tiles: Array<{ __typename?: 'KpiTileEntity', metric: KpiTileMetric, format: KpiTileFormat }>, defaultTiles: Array<{ __typename?: 'KpiTileEntity', metric: KpiTileMetric, format: KpiTileFormat }>, availableTiles: Array<{ __typename?: 'KpiTileEntity', metric: KpiTileMetric, format: KpiTileFormat }> } };

export type PackageFragment = { __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null };

export type ShallowPackageFragment = { __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null };

export type UpdatePackageMutationVariables = Exact<{
  updatePackageInput: UpdatePackageInput;
}>;


export type UpdatePackageMutation = { __typename?: 'Mutation', updatePackage: { __typename?: 'PackageEntity', uuid: string } };

export type CreatePermissionMutationVariables = Exact<{
  createPermissionInput: CreatePermissionInput;
}>;


export type CreatePermissionMutation = { __typename?: 'Mutation', createPermission: { __typename?: 'CreatePermissionOutput', success: boolean } };

export type DeletePermissionMutationVariables = Exact<{
  deletePermissionInput: DeletePermissionInput;
}>;


export type DeletePermissionMutation = { __typename?: 'Mutation', deletePermission: { __typename?: 'DeletePermissionOutput', success: boolean } };

export type UpdatePermissionAccessLevelMutationVariables = Exact<{
  updatePermissionAccessLevelInput: UpdatePermissionAccessLevelInput;
}>;


export type UpdatePermissionAccessLevelMutation = { __typename?: 'Mutation', updatePermissionAccessLevel: { __typename?: 'UpdatePermissionAccessLevelOutput', success: boolean } };

export type UpdatePermissionMutationVariables = Exact<{
  updatePermissionInput: UpdatePermissionInput;
}>;


export type UpdatePermissionMutation = { __typename?: 'Mutation', updatePermission: { __typename?: 'UpdatePermissionOutput', success: boolean } };

export type AddPiecesToPieceReceiptMutationVariables = Exact<{
  addPiecesToPieceReceiptInput: AddPiecesToPieceReceiptInput;
}>;


export type AddPiecesToPieceReceiptMutation = { __typename?: 'Mutation', addPiecesToPieceReceipt: { __typename?: 'AddPiecesToPieceReceiptOutput', createdCount: number, linkedCount: number, pieceReceipt: { __typename?: 'PieceReceiptEntity', uuid: string, source: PieceReceiptSource, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, trailerNumber?: string | null, sealNumber?: string | null, billOfLadingNumber?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, pieces: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, type?: PackageType | null, quantity: number, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, children: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, quantity: number, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }> }>, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } } };

export type CreatePieceReceiptMutationVariables = Exact<{
  createPieceReceiptInput: CreatePieceReceiptInput;
}>;


export type CreatePieceReceiptMutation = { __typename?: 'Mutation', createPieceReceipt: { __typename?: 'CreatePieceReceiptOutput', pieceReceipt: { __typename?: 'PieceReceiptEntity', uuid: string } } };

export type DeletePieceReceiptMutationVariables = Exact<{
  deletePieceReceiptInput: DeletePieceReceiptInput;
}>;


export type DeletePieceReceiptMutation = { __typename?: 'Mutation', deletePieceReceipt: { __typename?: 'DeletePieceReceiptOutput', success: boolean } };

export type PieceReceiptDetailFragment = { __typename?: 'PieceReceiptEntity', uuid: string, source: PieceReceiptSource, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, trailerNumber?: string | null, sealNumber?: string | null, billOfLadingNumber?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, pieces: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, type?: PackageType | null, quantity: number, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, children: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, quantity: number, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }> }>, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type PieceReceiptEventsQueryVariables = Exact<{
  pieceReceiptUuid: Scalars['String']['input'];
}>;


export type PieceReceiptEventsQuery = { __typename?: 'Query', orderEvents?: Array<{ __typename?: 'OrderEventEntity', uuid: string, createdAt: any, ignoreSnapshot: boolean, mirroredFromPartner: boolean, message: string, eventType: OrderEventType, sourceType: OrderEventSourceType, targetType: OrderEventTargetType, snapshot?: string | null, targetPhoneNumber?: string | null, targetEmail?: string | null, targetOrderTotalBeforeConsolidation?: number | null, targetOrderTotalAfterConsolidation?: number | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null }, quote?: { __typename?: 'QuoteEntity', uuid: string, number: string } | null, createdFromOrderTemplate?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } } | null, sourceWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, sourceEdiTransaction?: { __typename?: 'EdiTransactionEntity', uuid: string, status: EdiTransactionStatus, code: EdiTransactionCode, edi214ShipmentStatus?: Edi214ShipmentStatus | null, edi990ActionCode?: Edi990ActionCode | null } | null, sourceSftpUpload?: { __typename?: 'SftpUploadEntity', uuid: string, type: SftpUploadType, status: SftpUploadStatus } | null, sourceOutboundWebhookEvent?: { __typename?: 'OutboundWebhookEventEntity', uuid: string, createdAt: any, type: OutboundWebhookEventType, httpStatusCode?: number | null, error?: string | null } | null, sourceEfmOutboundRequestEvent?: { __typename?: 'EfmOutboundRequestEventEntity', uuid: string, createdAt: any, requestType: EfmOutboundRequestType, statusCode?: EfmOutboundRequestStatusCode | null, httpStatusCode?: number | null, error?: string | null, clockworkStatusQueueId?: string | null } | null, sourceExpeditorsOutboundRequestEvent?: { __typename?: 'ExpeditorsOutboundRequestEventEntity', uuid: string, createdAt: any, requestType: ExpeditorsOutboundRequestType, workOrderNumber?: string | null, httpStatusCode?: number | null, error?: string | null } | null, sourceUser?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, targetContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, phone?: string | null } | null, targetDocument?: { __typename?: 'DocumentEntity', fileName: string, type: DocumentType, uuid: string } | null, targetDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, user: { __typename?: 'UserActorEntity', name?: string | null } } | null, targetInvoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string } | null, targetRoute?: { __typename?: 'RouteEntity', uuid: string, name: string } | null, targetPiece?: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } | null, targetShipment?: { __typename?: 'StandardShipmentEntity', uuid: string, name: string, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null } }> } | null, targetShipmentSubscriber?: { __typename?: 'ShipmentSubscriberEntity', uuid: string, phoneNumber?: string | null } | null, targetStop?: { __typename?: 'StandardStopEntity', uuid: string, address: { __typename?: 'AddressEntity', uuid: string, name: string } } | null, targetSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, settlementDate?: any | null, finalizedDate?: any | null } | null }> | null };

export type PieceReceiptLinkablePiecesQueryVariables = Exact<{
  findPiecesInput: FindPiecesInput;
}>;


export type PieceReceiptLinkablePiecesQuery = { __typename?: 'Query', pieces: { __typename?: 'PieceConnection', edges: Array<{ __typename?: 'PieceEdge', node: { __typename?: 'PieceListEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, warehouseLocationName?: string | null } }> } };

export type PieceReceiptPieceDetailQueryVariables = Exact<{
  pieceReceiptUuid: Scalars['String']['input'];
  pieceUuid: Scalars['String']['input'];
}>;


export type PieceReceiptPieceDetailQuery = { __typename?: 'Query', pieceReceiptPiece: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, markedOnHandAt?: any | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, children: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, quantity: number }> } };

export type PieceReceiptPieceFragment = { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, type?: PackageType | null, quantity: number, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, children: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, quantity: number, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }> };

export type PieceReceiptSearchResultFragment = { __typename?: 'PieceListEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, warehouseLocationName?: string | null };

export type PieceReceiptFragment = { __typename?: 'PieceReceiptEntity', uuid: string, source: PieceReceiptSource, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, trailerNumber?: string | null, sealNumber?: string | null, billOfLadingNumber?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type PieceReceiptQueryVariables = Exact<{
  findPieceReceiptInput: FindPieceReceiptInput;
}>;


export type PieceReceiptQuery = { __typename?: 'Query', pieceReceipt: { __typename?: 'FindPieceReceiptOutput', pieceReceipt: { __typename?: 'PieceReceiptEntity', uuid: string, source: PieceReceiptSource, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, trailerNumber?: string | null, sealNumber?: string | null, billOfLadingNumber?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, pieces: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, type?: PackageType | null, quantity: number, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, children: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, quantity: number, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }> }>, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } } };

export type PieceReceiptsQueryVariables = Exact<{
  findPieceReceiptsInput: FindPieceReceiptsInput;
}>;


export type PieceReceiptsQuery = { __typename?: 'Query', pieceReceipts: { __typename?: 'FindPieceReceiptsOutput', pieceReceiptConnection: { __typename?: 'PieceReceiptConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PieceReceiptEdge', node: { __typename?: 'PieceReceiptEntity', uuid: string, source: PieceReceiptSource, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, trailerNumber?: string | null, sealNumber?: string | null, billOfLadingNumber?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type RemovePiecesFromPieceReceiptMutationVariables = Exact<{
  removePiecesFromPieceReceiptInput: RemovePiecesFromPieceReceiptInput;
}>;


export type RemovePiecesFromPieceReceiptMutation = { __typename?: 'Mutation', removePiecesFromPieceReceipt: { __typename?: 'RemovePiecesFromPieceReceiptOutput', removedCount: number, pieceReceipt: { __typename?: 'PieceReceiptEntity', uuid: string, source: PieceReceiptSource, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, trailerNumber?: string | null, sealNumber?: string | null, billOfLadingNumber?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, pieces: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, type?: PackageType | null, quantity: number, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, children: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, quantity: number, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null }> }>, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } } };

export type UpdatePieceReceiptPieceMutationVariables = Exact<{
  updatePieceReceiptPieceInput: UpdatePieceReceiptPieceInput;
}>;


export type UpdatePieceReceiptPieceMutation = { __typename?: 'Mutation', updatePieceReceiptPiece: { __typename?: 'UpdatePieceReceiptPieceOutput', piece: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, markedOnHandAt?: any | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null } } };

export type UpdatePieceReceiptMutationVariables = Exact<{
  updatePieceReceiptInput: UpdatePieceReceiptInput;
}>;


export type UpdatePieceReceiptMutation = { __typename?: 'Mutation', updatePieceReceipt: { __typename?: 'UpdatePieceReceiptOutput', pieceReceipt: { __typename?: 'PieceReceiptEntity', uuid: string, source: PieceReceiptSource, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, trailerNumber?: string | null, sealNumber?: string | null, billOfLadingNumber?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } } };

export type BulkDeletePiecesMutationVariables = Exact<{
  input: BulkDeletePiecesInput;
}>;


export type BulkDeletePiecesMutation = { __typename?: 'Mutation', bulkDeletePieces: { __typename?: 'BulkPiecesActionOutput', successCount: number, failureCount: number, failures: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } };

export type BulkDiscardPiecesMutationVariables = Exact<{
  input: BulkDiscardPiecesInput;
}>;


export type BulkDiscardPiecesMutation = { __typename?: 'Mutation', bulkDiscardPieces: { __typename?: 'BulkPiecesActionOutput', successCount: number, failureCount: number, failures: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } };

export type BulkRestorePiecesMutationVariables = Exact<{
  input: BulkRestorePiecesInput;
}>;


export type BulkRestorePiecesMutation = { __typename?: 'Mutation', bulkRestorePieces: { __typename?: 'BulkPiecesActionOutput', successCount: number, failureCount: number, failures: Array<{ __typename?: 'BulkActionItemResult', uuid: string, reason: string }> } };

export type FindPiecesFragment = { __typename?: 'PieceListEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, markedOnHandAt?: any | null, createdAt: any, orderUuid?: string | null, orderName?: string | null, packageUuid?: string | null, packageName?: string | null, packageOrderUuid?: string | null, packageOrderName?: string | null, packedPieceCount: number, hawb?: string | null, mawb?: string | null, terminalUuid?: string | null, terminalName?: string | null, warehouseLocationUuid?: string | null, warehouseLocationName?: string | null, warehouseUuid?: string | null, warehouseName?: string | null, customerUuid?: string | null, customerName?: string | null, isUnalertedFreight: boolean, dwellStatus?: DwellStatus | null, effectiveDwellThresholdDays?: number | null, daysOverDwellThreshold?: number | null };

export type FindPiecesInboundFragment = { __typename?: 'PieceListEntity', weight?: number | null, weightUnits?: WeightUnits | null, carrier?: string | null, eta?: any | null, origin?: string | null, totalPieces?: number | null };

export type FindPiecesDeliveredFragment = { __typename?: 'PieceListEntity', damagedAt?: any | null, refusedAt?: any | null, deliveredAt?: any | null, recipient?: string | null, destination?: string | null, podSignedBy?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean };

export type FindPiecesInTransitFragment = { __typename?: 'PieceListEntity', routeName?: string | null, driverName?: string | null, truckName?: string | null, departedAt?: any | null, etaArrivalTime?: any | null };

export type FindPiecesDiscardedFragment = { __typename?: 'PieceListEntity', discardedAt?: any | null, discardedReason?: string | null, discardedByName?: string | null };

export type FindPiecesQueryVariables = Exact<{
  findPiecesInput: FindPiecesInput;
  includeInboundFields?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeliveredFields?: InputMaybe<Scalars['Boolean']['input']>;
  includeInTransitFields?: InputMaybe<Scalars['Boolean']['input']>;
  includeDiscardedFields?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FindPiecesQuery = { __typename?: 'Query', pieces: { __typename?: 'PieceConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PieceEdge', cursor: string, node: { __typename?: 'PieceListEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, markedOnHandAt?: any | null, createdAt: any, orderUuid?: string | null, orderName?: string | null, packageUuid?: string | null, packageName?: string | null, packageOrderUuid?: string | null, packageOrderName?: string | null, packedPieceCount: number, hawb?: string | null, mawb?: string | null, terminalUuid?: string | null, terminalName?: string | null, warehouseLocationUuid?: string | null, warehouseLocationName?: string | null, warehouseUuid?: string | null, warehouseName?: string | null, customerUuid?: string | null, customerName?: string | null, isUnalertedFreight: boolean, dwellStatus?: DwellStatus | null, effectiveDwellThresholdDays?: number | null, daysOverDwellThreshold?: number | null, weight?: number | null, weightUnits?: WeightUnits | null, carrier?: string | null, eta?: any | null, origin?: string | null, totalPieces?: number | null, damagedAt?: any | null, refusedAt?: any | null, deliveredAt?: any | null, recipient?: string | null, destination?: string | null, podSignedBy?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, routeName?: string | null, driverName?: string | null, truckName?: string | null, departedAt?: any | null, etaArrivalTime?: any | null, discardedAt?: any | null, discardedReason?: string | null, discardedByName?: string | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type LinkPieceToOrderWithRoleMutationVariables = Exact<{
  input: LinkPieceToOrderInput;
}>;


export type LinkPieceToOrderWithRoleMutation = { __typename?: 'Mutation', linkPieceToOrderWithRole: { __typename?: 'PieceEntity', uuid: string, status: PieceStatus } };

export type OrderCommentsByPieceQueryVariables = Exact<{
  pieceUuid: Scalars['String']['input'];
}>;


export type OrderCommentsByPieceQuery = { __typename?: 'Query', orderComments: Array<{ __typename?: 'OrderCommentEntity', uuid: string, createdAt: any, comment: string, authorName: string, piece?: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } | null }> };

export type PieceBucketMetricsQueryVariables = Exact<{
  input: PieceBucketMetricsInput;
}>;


export type PieceBucketMetricsQuery = { __typename?: 'Query', pieceBucketMetrics: { __typename?: 'PieceBucketMetricsOutput', metrics: Array<{ __typename?: 'PieceBucketMetric', key: string, label: string, value?: number | null, unit: PieceBucketMetricUnit }> } };

export type PieceDetailFragment = { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, quantity: number, createdAt: any, markedOnHandAt?: any | null, pickedUpAt?: any | null, damagedAt?: any | null, damagedNote?: string | null, refusedAt?: any | null, refusedReason?: string | null, discardedAt?: any | null, discardedReason?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, hawb?: string | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, customer?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, packageHasPieces?: Array<{ __typename?: 'PackageHasPieceEntity', uuid: string, package: { __typename?: 'PackageEntity', uuid: string, description: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', hawb?: string | null, masterAirwayBillOfLadingNumber?: string | null } } | null } }> | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, fileType: string, type: DocumentType, preSignedGetUrl: string, notes?: string | null, pageNumber?: number | null }>, children: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null }> };

export type PieceDetailQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type PieceDetailQuery = { __typename?: 'Query', piece: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, quantity: number, createdAt: any, markedOnHandAt?: any | null, pickedUpAt?: any | null, damagedAt?: any | null, damagedNote?: string | null, refusedAt?: any | null, refusedReason?: string | null, discardedAt?: any | null, discardedReason?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, hawb?: string | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, customer?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, packageHasPieces?: Array<{ __typename?: 'PackageHasPieceEntity', uuid: string, package: { __typename?: 'PackageEntity', uuid: string, description: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', hawb?: string | null, masterAirwayBillOfLadingNumber?: string | null } } | null } }> | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, fileType: string, type: DocumentType, preSignedGetUrl: string, notes?: string | null, pageNumber?: number | null }>, children: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, type?: PackageType | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null }> } };

export type PieceEventFragment = { __typename?: 'OrderEventEntity', uuid: string, createdAt: any, eventType: OrderEventType, message: string, sourceType: OrderEventSourceType, sourceUser?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, sourceWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null };

export type PieceEventsQueryVariables = Exact<{
  pieceUuid: Scalars['String']['input'];
  sortByCreatedAtAsc?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PieceEventsQuery = { __typename?: 'Query', orderEvents?: Array<{ __typename?: 'OrderEventEntity', uuid: string, createdAt: any, eventType: OrderEventType, message: string, sourceType: OrderEventSourceType, sourceUser?: { __typename?: 'UserActorEntity', uuid: string, email?: string | null } | null, sourceDriver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, sourceWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null }> | null };

export type TransferPieceToOrderMutationVariables = Exact<{
  input: TransferPieceToOrderInput;
}>;


export type TransferPieceToOrderMutation = { __typename?: 'Mutation', transferPieceToOrder: { __typename?: 'PieceEntity', uuid: string, status: PieceStatus } };

export type TransferPieceToOutboundOrderMutationVariables = Exact<{
  input: TransferPieceToOutboundOrderInput;
}>;


export type TransferPieceToOutboundOrderMutation = { __typename?: 'Mutation', transferPieceToOutboundOrder: { __typename?: 'PieceEntity', uuid: string, status: PieceStatus } };

export type UnlinkPieceFromOrderMutationVariables = Exact<{
  input: UnlinkPieceFromOrderInput;
}>;


export type UnlinkPieceFromOrderMutation = { __typename?: 'Mutation', unlinkPieceFromOrder: { __typename?: 'PieceEntity', uuid: string, status: PieceStatus } };

export type UpdatePieceReferenceNumberMutationVariables = Exact<{
  updatePieceInput: UpdatePieceInput;
}>;


export type UpdatePieceReferenceNumberMutation = { __typename?: 'Mutation', updatePiece: { __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null } };

export type EmailQuoteQueueRowFragment = { __typename: 'OrderQuote', uuid: string, number?: string | null, status: OrderQuoteStatus, quotedAmountCents?: number | null, currency?: string | null, sentAt?: any | null, validUntil?: any | null, needsAttentionAt?: any | null, createdAt: any, senderAddress: string, senderDisplayName?: string | null, subject?: string | null, queueGroup: OrderQuoteQueueGroup, missingFields: Array<string>, unpriceableReasons: Array<string>, pricingState: string, attentionReasons: Array<QuoteAttentionReason>, order?: { __typename: 'OrderQuoteOrderSummary', uuid: string } | null, customer?: { __typename: 'OrderQuoteCustomer', uuid: string, name: string } | null };

export type EmailQuoteQueueQueryVariables = Exact<{
  scope: OrderQuoteQueueScope;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmailQuoteQueueQuery = { __typename?: 'Query', orderQuotes: { __typename?: 'OrderQuoteConnection', totalCount?: number | null, needsYouCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'OrderQuoteEdge', cursor: string, node: { __typename: 'OrderQuote', uuid: string, number?: string | null, status: OrderQuoteStatus, quotedAmountCents?: number | null, currency?: string | null, sentAt?: any | null, validUntil?: any | null, needsAttentionAt?: any | null, createdAt: any, senderAddress: string, senderDisplayName?: string | null, subject?: string | null, queueGroup: OrderQuoteQueueGroup, missingFields: Array<string>, unpriceableReasons: Array<string>, pricingState: string, attentionReasons: Array<QuoteAttentionReason>, order?: { __typename: 'OrderQuoteOrderSummary', uuid: string } | null, customer?: { __typename: 'OrderQuoteCustomer', uuid: string, name: string } | null } }> } };

export type EmailQuoteQueryVariables = Exact<{
  orderQuoteUuid: Scalars['String']['input'];
}>;


export type EmailQuoteQuery = { __typename?: 'Query', orderQuote?: { __typename: 'OrderQuote', subject?: string | null, queueGroup: OrderQuoteQueueGroup, latestVersionUuid: string, uuid: string, number?: string | null, status: OrderQuoteStatus, version: number, quotedAmountCents?: number | null, currency?: string | null, validUntil?: any | null, sentAt?: any | null, needsAttentionAt?: any | null, createdAt: any, updatedAt: any, senderAddress: string, senderDisplayName?: string | null, senderRecoveredFromForward: boolean, missingFields: Array<string>, unpriceableReasons: Array<string>, pricingState: string, attentionReasons: Array<QuoteAttentionReason>, draftReplyUuid?: string | null, draftReplyKind?: QuoteDraftReplyKind | null, draftReplyBody?: string | null, draftReplyApprovedAt?: any | null, extractedRequest?: { __typename?: 'OrderQuoteExtractedRequest', shipDate?: string | null, readyTime?: string | null, serviceWording?: string | null, accessorials: Array<string>, hazmat: string, specialInstructions?: string | null, truncatedFields: Array<string>, pickup: { __typename?: 'OrderQuoteExtractedStop', kind: string, companyName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, airportCode?: string | null, airlines: Array<string>, readyWindow?: string | null }, delivery: { __typename?: 'OrderQuoteExtractedStop', kind: string, companyName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, airportCode?: string | null, airlines: Array<string>, readyWindow?: string | null }, shipper: { __typename?: 'OrderQuoteExtractedParty', name?: string | null, contact?: string | null }, consignee: { __typename?: 'OrderQuoteExtractedParty', name?: string | null, contact?: string | null }, packages: Array<{ __typename?: 'OrderQuoteExtractedPackage', quantity?: number | null, packaging: string, piecesPerUnit?: number | null, length?: number | null, width?: number | null, height?: number | null, dimensionUnit: string, dimensionBasis: string, weight?: number | null, weightUnit: string, weightBasis: string, commodity?: string | null }> } | null, unsettledEarlierReply?: { __typename: 'OrderQuoteEarlierReply', orderQuoteUuid: string, version: number, draftReplyUuid: string, draftReplyKind: QuoteDraftReplyKind, draftReplyBody: string, draftReplyApprovedAt: any } | null, order?: { __typename: 'OrderQuoteOrderSummary', uuid: string, name: string } | null, customer?: { __typename: 'OrderQuoteCustomer', uuid: string, name: string } | null, customerCandidates: Array<{ __typename: 'OrderQuoteCustomerCandidate', contactUuid: string, contactName: string, isActive: boolean, matchedBy?: string | null }> } | null };

export type ApproveQuoteMutationVariables = Exact<{
  approveQuoteInput: ApproveQuoteInput;
}>;


export type ApproveQuoteMutation = { __typename?: 'Mutation', approveQuote: { __typename?: 'QuoteEntity', uuid: string } };

export type ClientQuotesQueryVariables = Exact<{
  findClientQuotesInput: FindClientQuotesInput;
}>;


export type ClientQuotesQuery = { __typename?: 'Query', clientQuotes: { __typename?: 'QuoteConnection', totalCount?: number | null, edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'QuoteEntity', uuid: string, createdAt: any, source: QuoteSource, status: QuoteStatus, number: string, totalCharge: any, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, uuid: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string }, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean } } };

export type ClientQuoteFragment = { __typename?: 'QuoteEntity', uuid: string, createdAt: any, source: QuoteSource, status: QuoteStatus, number: string, totalCharge: any, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string, uuid: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string, uuid: string }, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null };

export type CreateQuoteMutationVariables = Exact<{
  createQuoteInput: CreateQuoteInput;
}>;


export type CreateQuoteMutation = { __typename?: 'Mutation', createQuote: { __typename?: 'QuoteEntity', uuid: string } };

export type QuoteContributionRatioQueryVariables = Exact<{
  rateOrderInput: RateOrderInput;
  input: QuoteContributionRatioInput;
}>;


export type QuoteContributionRatioQuery = { __typename?: 'Query', quoteContributionRatio?: { __typename?: 'QuoteContributionRatioEntity', ratio?: number | null, status: QuoteContributionStatus, revenueUsd: number, driverSettlementUsd?: number | null, storedDriverSettlementUsdCents?: number | null, contributionUsd?: number | null, benchmarkUsd?: number | null, actualWeightLb: number, marginalFromRatio: number, profitableFromRatio: number, benchmarkLegs: Array<{ __typename?: 'QuoteContributionBenchmarkLegEntity', leg: QuoteContributionBenchmarkLeg, hasTariff: boolean, tariffGroupName?: string | null, totalUsd: number }> } | null };

export type QuoteFreightNeedsRateFragment = { __typename?: 'QuoteEntity', freightNeedsRate: boolean, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, ratingFailure?: { __typename?: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, retryable: boolean } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, status: ExternalRateQuoteStatus, finalCents?: number | null } | null, lastRatedExternalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, finalCents?: number | null } | null } | null }> };

export type QuoteNameQueryVariables = Exact<{
  billingPartyContactUuid: Scalars['String']['input'];
}>;


export type QuoteNameQuery = { __typename?: 'Query', quoteName: string };

export type QuoteFragment = { __typename?: 'QuoteEntity', uuid: string, number: string, createdAt: any, status: QuoteStatus, dimFactor?: number | null, measurementUnits?: MeasurementUnits | null, weightUnits?: WeightUnits | null, totalSkids?: number | null, source: QuoteSource, enableLineHaul: boolean, service?: { __typename?: 'ServiceEntity', uuid: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode?: string | null, terminal: string, isArchived: boolean, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed: boolean, appointmentStatus?: AppointmentStatus | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, stopIntention?: StopIntention | null, paperworkMarkedComplete?: boolean | null, failureCount?: number | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, recoveryDiscountRate?: any | null, lineHaulDiscountRate?: any | null, defaultDimFactor?: number | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, includeInExpeditorsScorecard: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultRecoveryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, company: { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, qboFreightItemId?: string | null, qboFuelItemId?: string | null, qboLineHaulItemId?: string | null, qboDefaultIncomeAccountId?: string | null, qboDefaultTaxCodeId?: string | null, qboDefaultClassId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopRecoveryId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, enabledExternalRatingProviders: Array<ExternalRatingProvider>, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, quoteAgentEnabled: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, showAccessorialsToDrivers: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, pieceTransferableStatuses: Array<PieceStatus>, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } }, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> };

export type QuoteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type QuoteQuery = { __typename?: 'Query', quote: { __typename?: 'QuoteEntity', uuid: string, number: string, createdAt: any, status: QuoteStatus, dimFactor?: number | null, measurementUnits?: MeasurementUnits | null, weightUnits?: WeightUnits | null, totalSkids?: number | null, source: QuoteSource, enableLineHaul: boolean, freightNeedsRate: boolean, billingPartyContact: { __typename?: 'CustomerContactEntity', defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, recoveryDiscountRate?: any | null, lineHaulDiscountRate?: any | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, includeInExpeditorsScorecard: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultRecoveryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, lineHaulOriginTerminal?: { __typename?: 'TerminalEntity', uuid: string } | null, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', uuid: string, originTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string }, destinationTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string } } | null, service?: { __typename?: 'ServiceEntity', uuid: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, billingMethod: FreightBillingMethod, quantity: number, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, ratingFailure?: { __typename?: 'ExternalRatingFailure', code: ExternalRatingErrorCode, message: string, retryable: boolean } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, status: ExternalRateQuoteStatus, finalCents?: number | null } | null, lastRatedExternalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string, finalCents?: number | null } | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null } | null, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode?: string | null, terminal: string, isArchived: boolean, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed: boolean, appointmentStatus?: AppointmentStatus | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, stopIntention?: StopIntention | null, paperworkMarkedComplete?: boolean | null, failureCount?: number | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, company: { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, qboFreightItemId?: string | null, qboFuelItemId?: string | null, qboLineHaulItemId?: string | null, qboDefaultIncomeAccountId?: string | null, qboDefaultTaxCodeId?: string | null, qboDefaultClassId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopRecoveryId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, enabledExternalRatingProviders: Array<ExternalRatingProvider>, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, quoteAgentEnabled: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, showAccessorialsToDrivers: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, pieceTransferableStatuses: Array<PieceStatus>, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } }, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> } };

export type QuotesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  quoteStatus?: InputMaybe<QuoteStatus>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type QuotesQuery = { __typename?: 'Query', quotes: { __typename?: 'QuoteConnection', edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'QuoteEntity', uuid: string, number: string, createdAt: any, status: QuoteStatus, dimFactor?: number | null, measurementUnits?: MeasurementUnits | null, weightUnits?: WeightUnits | null, totalSkids?: number | null, source: QuoteSource, enableLineHaul: boolean, service?: { __typename?: 'ServiceEntity', uuid: string } | null, shipments: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode?: string | null, terminal: string, isArchived: boolean, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed: boolean, appointmentStatus?: AppointmentStatus | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, stopIntention?: StopIntention | null, paperworkMarkedComplete?: boolean | null, failureCount?: number | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', defaultFuelSurcharge?: number | null, defaultUseTariff?: boolean | null, defaultFreightBillingMethod?: FreightBillingMethod | null, defaultFreightClass?: FreightClass | null, pickupDiscountRate?: any | null, deliveryDiscountRate?: any | null, transferDiscountRate?: any | null, recoveryDiscountRate?: any | null, lineHaulDiscountRate?: any | null, defaultDimFactor?: number | null, billingContactEmail?: string | null, defaultInvoiceType: InvoiceType, defaultInvoiceTransmissionMethod: InvoiceTransmissionMethod, defaultInvoiceDownloadDocuments: Array<DocumentType>, defaultInvoiceDocumentsRequired: Array<DocumentType>, defaultInvoiceEmailSubject?: string | null, invoiceVendorDisplayName: OrganizationInvoiceVendorDisplayName, identifier?: string | null, numberOfOrdersPerInvoice?: number | null, invoiceTimePeriodSplit?: TimePeriod | null, creditHoldLimitInCents?: number | null, enableCreditHold?: boolean | null, maxDaysOutstanding?: number | null, isPrepaidOnly: boolean, allowDriverToCompleteStopAfterAttemptWithoutReassignment: boolean, enableCustomerPortalOrderEntry: boolean, enableCustomerPortalInventory: boolean, displayChargesInCustomerPortal: boolean, customerPortalChargesVisibleFrom: CustomerPortalChargesVisibility, includeInExpeditorsScorecard: boolean, useCustomPackageSpecs: boolean, showEdiReferenceNumbersOnOrderPage: boolean, useCustomVehicleTypes: boolean, uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultInvoiceTerms?: { __typename?: 'InvoiceTermEntity', uuid: string, terms: string } | null, packageSpecs: Array<{ __typename?: 'PackageSpecEntity', id: string }>, vehicleTypes: Array<{ __typename?: 'VehicleTypeEntity', uuid: string }>, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOrdinaryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultLineHaulTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultTransferTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultRecoveryTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, defaultPointToPointTariffChain?: { __typename?: 'TariffChainEntity', id: string, name: string } | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, ediApplicationId?: string | null, ediContactCode?: string | null, isActive: boolean, isaId?: string | null, identifier?: string | null, contactReferenceNumber?: string | null, shortCode?: string | null, stediPartnerId?: string | null, isOverCreditLimit: boolean, quickbooksDesktopContactId?: string | null, quickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, freightChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, type: ContactType, billingCycle?: BillingCycleType | null, billingCycleDuration: BillingCycleDuration, billingPeriod?: number | null, requireDriverToCheckOffPackagesAtStop: boolean, invoiceNotes?: string | null, customDunningReportFooter?: string | null, serviceGroupId?: string | null, accessorialGroupId?: string | null, masterAccount?: { __typename?: 'MasterAccountEntity', uuid: string, name: string } | null, contactComments: Array<{ __typename?: 'ContactCommentEntity', uuid: string, updatedAt: any, createdAt: any, comment: string, authorName: string }>, services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }>, customerAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string }>, invoicePdfColumns: Array<{ __typename?: 'PdfColumnEntity', uuid: string, orderColumnMapping?: OrderPdfColumnMapping | null, shipmentPDFColumnMapping?: ShipmentPdfColumnMapping | null, legPDFColumnMapping?: LegPdfColumnMapping | null, stopPDFColumnMapping?: StopPdfColumnMapping | null }>, addresses: Array<{ __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }>, contactPersons: Array<{ __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any }>, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, defaultContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, defaultService?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> }, company: { __typename?: 'CompanyEntity', invoiceEmail?: string | null, isCourier?: boolean | null, uuid: string, phone?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksDesktopAccountsReceivableId?: string | null, quickbooksFileMappingPickupChargeName?: string | null, quickbooksCompanyId?: string | null, qboFreightItemId?: string | null, qboFuelItemId?: string | null, qboLineHaulItemId?: string | null, qboDefaultIncomeAccountId?: string | null, qboDefaultTaxCodeId?: string | null, qboDefaultClassId?: string | null, freightChargeQuickbooksMappingId?: string | null, fuelChargeQuickbooksMappingId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, quickbooksDesktopCompanyId?: string | null, quickbooksDesktopDeliveryId?: string | null, quickbooksDesktopPickupId?: string | null, quickbooksDesktopTransferId?: string | null, quickbooksDesktopRecoveryId?: string | null, quickbooksDesktopLineHaulId?: string | null, quickbooksDesktopOrderChargeId?: string | null, quickbooksDesktopAccessorialId?: string | null, quickbooksDesktopFuelChargeId?: string | null, segment: Segment, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, qbInvoiceNumberStart?: number | null, productionCompany?: ProductionCompany | null, name: string, orderNameOrdinal?: number | null, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, blockSendingZeroDollarInvoices: boolean, purchasedProductOfferings: Array<PalletProductOffering>, defaultInvoiceEmailSubject?: string | null, defaultNonCompanyDriverSettlementMode: SettlementMode, configuration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, showDriverSettlementInBilling: boolean, sameDayDispatchCellHeader: SameDayDispatchCellHeader, defaultStandardStopType: StandardStopType, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultDimFactor?: number | null, enabledExternalRatingProviders: Array<ExternalRatingProvider>, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, requireSigneeNameForDeliveries: boolean, autoMatchEodDocumentsToOrders: boolean, showChargesOnCustomerPortal: boolean, invoicePdfLogoUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, autoApplyWaitTimeMinutes: boolean, requireReviewForEdiOrderCreation: boolean, quoteAgentEnabled: boolean, startingInvoiceOrdinalNumber?: number | null, useDriverNumberForDispatch: boolean, useJournalNumberForInvoice: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, requireDriverToAcknowledgeRouteChange: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, showAccessorialsToDrivers: boolean, allCapsInOrderPage: boolean, terminalsEnabled: boolean, lineHaulEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, serviceLevelOptional: boolean, showKilogramsAndCentimeters: boolean, addOrdersToOpenInvoices: boolean, restrictEditingOrderName: boolean, notificationsEnabled: boolean, defaultInvoiceDocumentsRequired: Array<DocumentType>, invoiceNotes?: string | null, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, getDriverLocationDataFromMobile: boolean, enableDigitalSignatureFlow: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, pieceTransferableStatuses: Array<PieceStatus>, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean } | null, quickbooksAccessToken?: { __typename?: 'QuickbooksOauthTokenEntity', uuid: string, expiresAt: any } | null, defaultAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, latitude?: number | null, longitude?: number | null, zip: string, state: string, country: string } | null, tags: Array<{ __typename?: 'TagEntity', createdAt: any, updatedAt: any, color?: string | null, uuid: string, value: string }>, referenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }>, orderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } }, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null, deletedAutoAppliedAccessorials: Array<{ __typename?: 'AttemptsAccessorialEntity', uuid: string } | { __typename?: 'PercentageAccessorialEntity', uuid: string } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string } | { __typename?: 'SpecialAccessorialEntity', uuid: string } | { __typename?: 'StandardAccessorialEntity', uuid: string } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type RerateQuoteFreightMutationVariables = Exact<{
  quoteUuid: Scalars['String']['input'];
}>;


export type RerateQuoteFreightMutation = { __typename?: 'Mutation', rerateQuoteFreight: { __typename?: 'RerateQuoteFreightOutput', externalRatings: Array<{ __typename?: 'FreightChargeRerateResult', freightChargeUuid: string, status: ExternalFreightRatingStatus, externalRating?: { __typename: 'ExternalRatingFailure', message: string } | { __typename: 'ExternalRatingSuccess' } | null }> } };

export type UpdateQuoteMutationVariables = Exact<{
  updateQuoteInput: UpdateQuoteInput;
}>;


export type UpdateQuoteMutation = { __typename?: 'Mutation', updateQuote: { __typename?: 'QuoteEntity', uuid: string } };

export type CreateReportGroupConfigurationMutationVariables = Exact<{
  createReportGroupConfigurationInput: ReportGroupConfigurationCreateInput;
}>;


export type CreateReportGroupConfigurationMutation = { __typename?: 'Mutation', createReportGroupConfiguration: { __typename?: 'ReportGroupConfigurationEntity', uuid: string, name: string, orderStatuses: Array<OrderStatus>, stopTypes: Array<PickupOrDelivery>, reportAggregationPeriod: ReportAggregationPeriod, defaultReportType: ReportType, reportRevenueType: ReportRevenueType, reportStatistics: Array<ReportStatistic>, lastNumberOfDays?: number | null, lastNumberOfWeeks?: number | null, lastNumberOfMonths?: number | null, startDate?: any | null, endDate?: any | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, drivers?: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } };

export type CustomerReportBucketFragment = { __typename?: 'CustomerReportBucketEntity', uuid: string, displayName: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type CustomerReportQueryVariables = Exact<{
  args: CustomerReportArgs;
}>;


export type CustomerReportQuery = { __typename?: 'Query', customerReport: Array<{ __typename?: 'CustomerReportBucketEntity', uuid: string, displayName: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type DeleteReportGroupConfigurationMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteReportGroupConfigurationMutation = { __typename?: 'Mutation', deleteReportGroupConfiguration: { __typename?: 'ReportGroupConfigurationEntity', uuid: string, name: string, orderStatuses: Array<OrderStatus>, stopTypes: Array<PickupOrDelivery>, reportAggregationPeriod: ReportAggregationPeriod, defaultReportType: ReportType, reportRevenueType: ReportRevenueType, reportStatistics: Array<ReportStatistic>, lastNumberOfDays?: number | null, lastNumberOfWeeks?: number | null, lastNumberOfMonths?: number | null, startDate?: any | null, endDate?: any | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, drivers?: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } };

export type DriverReportBucketFragment = { __typename?: 'DriverReportBucketEntity', uuid: string, firstName: string, lastName: string, driverType?: string | null, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type DriverReportQueryVariables = Exact<{
  args: DriverReportArgs;
}>;


export type DriverReportQuery = { __typename?: 'Query', driverReport: Array<{ __typename?: 'DriverReportBucketEntity', uuid: string, firstName: string, lastName: string, driverType?: string | null, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type OrderReportBucketFragment = { __typename?: 'OrderReportBucketEntity', startDate: any, endDate: any, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type OrderReportQueryVariables = Exact<{
  args: OrderReportArgs;
}>;


export type OrderReportQuery = { __typename?: 'Query', orderReport: Array<{ __typename?: 'OrderReportBucketEntity', startDate: any, endDate: any, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type ReportGroupConfigurationFragment = { __typename?: 'ReportGroupConfigurationEntity', uuid: string, name: string, orderStatuses: Array<OrderStatus>, stopTypes: Array<PickupOrDelivery>, reportAggregationPeriod: ReportAggregationPeriod, defaultReportType: ReportType, reportRevenueType: ReportRevenueType, reportStatistics: Array<ReportStatistic>, lastNumberOfDays?: number | null, lastNumberOfWeeks?: number | null, lastNumberOfMonths?: number | null, startDate?: any | null, endDate?: any | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, drivers?: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null };

export type ReportGroupConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportGroupConfigurationsQuery = { __typename?: 'Query', reportGroupConfigurations: Array<{ __typename?: 'ReportGroupConfigurationEntity', uuid: string, name: string, orderStatuses: Array<OrderStatus>, stopTypes: Array<PickupOrDelivery>, reportAggregationPeriod: ReportAggregationPeriod, defaultReportType: ReportType, reportRevenueType: ReportRevenueType, reportStatistics: Array<ReportStatistic>, lastNumberOfDays?: number | null, lastNumberOfWeeks?: number | null, lastNumberOfMonths?: number | null, startDate?: any | null, endDate?: any | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, drivers?: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null }> };

export type ReportSendJobBatchProgressFragment = { __typename?: 'ReportSendJobBatchProgressEntity', successCount: number, failCount: number, totalCount: number };

export type ReportSendJobBatchFragment = { __typename?: 'ReportSendJobBatchEntity', id: string, createdAt: any, reportSendJobBatchProgress: { __typename?: 'ReportSendJobBatchProgressEntity', successCount: number, failCount: number, totalCount: number }, reportSendJobs: Array<{ __typename?: 'ReportSendJobEntity', id: string, createdAt: any, reportType: AccountingReportTypeV2 }> };

export type ReportSendJobBatchesQueryVariables = Exact<{
  findReportSendJobBatchesInput: FindReportSendJobBatchesInput;
}>;


export type ReportSendJobBatchesQuery = { __typename?: 'Query', reportSendJobBatches: { __typename?: 'FindReportSendJobBatchesOutput', reportSendJobBatchConnection: { __typename?: 'ReportSendJobBatchConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ReportSendJobBatchEdge', node: { __typename?: 'ReportSendJobBatchEntity', id: string, createdAt: any, reportSendJobBatchProgress: { __typename?: 'ReportSendJobBatchProgressEntity', successCount: number, failCount: number, totalCount: number }, reportSendJobs: Array<{ __typename?: 'ReportSendJobEntity', id: string, createdAt: any, reportType: AccountingReportTypeV2 }> } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type ReportSendJobFragment = { __typename?: 'ReportSendJobEntity', id: string, reportType: AccountingReportTypeV2, reportSendJobError?: ReportSendJobError | null, contact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }, emailTransaction?: { __typename?: 'EmailTransactionEntity', emailTransactionStatus: EmailTransactionStatus, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null, document?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null };

export type ReportSendJobsQueryVariables = Exact<{
  findReportSendJobsInput: FindReportSendJobsInput;
}>;


export type ReportSendJobsQuery = { __typename?: 'Query', reportSendJobs: { __typename?: 'FindReportSendJobsOutput', reportSendJobConnection: { __typename?: 'ReportSendJobConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ReportSendJobEdge', node: { __typename?: 'ReportSendJobEntity', id: string, reportType: AccountingReportTypeV2, reportSendJobError?: ReportSendJobError | null, contact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string }, emailTransaction?: { __typename?: 'EmailTransactionEntity', emailTransactionStatus: EmailTransactionStatus, emailTransactionLogs: Array<{ __typename?: 'EmailTransactionLogEntity', uuid: string, email: string, lastStatus?: EmailTransactionLogStatus | null, reason?: string | null }> } | null, document?: { __typename?: 'DocumentEntity', preSignedGetUrl: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type SendAccountingReportsMutationVariables = Exact<{
  sendAccountingReportsInput: SendAccountingReportsInput;
}>;


export type SendAccountingReportsMutation = { __typename?: 'Mutation', sendAccountingReports: { __typename?: 'MutationErrorOutput', message: string } | { __typename?: 'SendAccountingReportsSuccessOutput', success: boolean } };

export type ServiceLevelReportBucketFragment = { __typename?: 'ServiceLevelReportBucketEntity', uuid: string, name: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type ServiceLevelReportQueryVariables = Exact<{
  args: ServiceLevelReportArgs;
}>;


export type ServiceLevelReportQuery = { __typename?: 'Query', serviceLevelReport: Array<{ __typename?: 'ServiceLevelReportBucketEntity', uuid: string, name: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type StationReportBucketFragment = { __typename?: 'StationReportBucketEntity', startDate: any, endDate: any, stationId?: string | null, stationName?: string | null, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type StationReportQueryVariables = Exact<{
  args: StationReportArgs;
}>;


export type StationReportQuery = { __typename?: 'Query', stationReport: Array<{ __typename?: 'StationReportBucketEntity', startDate: any, endDate: any, stationId?: string | null, stationName?: string | null, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type TerminalReportBucketFragment = { __typename?: 'TerminalReportBucketEntity', uuid: string, name: string, code: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number };

export type TerminalReportQueryVariables = Exact<{
  args: TerminalReportArgs;
}>;


export type TerminalReportQuery = { __typename?: 'Query', terminalReport: Array<{ __typename?: 'TerminalReportBucketEntity', uuid: string, name: string, code: string, freightRevenue: number, fuelRevenue: number, lineHaulRevenue: number, specialRevenue: number, customChargeRevenue: number, surchargeRevenue: number, pickupRevenue: number, deliveryRevenue: number, recoveryRevenue: number, transferRevenue: number, totalRevenue: number, totalWeight: number, numberOfOrders: number, numberOfPackages: number }> };

export type UpdateReportGroupConfigurationMutationVariables = Exact<{
  updateReportGroupConfigurationInput: ReportGroupConfigurationUpdateInput;
}>;


export type UpdateReportGroupConfigurationMutation = { __typename?: 'Mutation', updateReportGroupConfiguration: { __typename?: 'ReportGroupConfigurationEntity', uuid: string, name: string, orderStatuses: Array<OrderStatus>, stopTypes: Array<PickupOrDelivery>, reportAggregationPeriod: ReportAggregationPeriod, defaultReportType: ReportType, reportRevenueType: ReportRevenueType, reportStatistics: Array<ReportStatistic>, lastNumberOfDays?: number | null, lastNumberOfWeeks?: number | null, lastNumberOfMonths?: number | null, startDate?: any | null, endDate?: any | null, contact?: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } | null, contacts?: Array<{ __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }> | null, driver?: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } | null, drivers?: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string }> | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null } };

export type AppointmentOptionsQueryVariables = Exact<{
  input: AppointmentOptionsInput;
}>;


export type AppointmentOptionsQuery = { __typename?: 'Query', appointmentOptions: { __typename?: 'AppointmentOptions', appointmentExists: boolean, rescheduleRequested: boolean, message?: string | null, pageSize: number, options: Array<{ __typename?: 'AppointmentOption', humanDate: string, date: { __typename?: 'PlainDate', year: number, month: number, day: number }, startTime: { __typename?: 'PlainTime', hour: number, minute: number }, endTime: { __typename?: 'PlainTime', hour: number, minute: number } }> } };

export type ChooseAppointmentOptionMutationVariables = Exact<{
  input: ChooseAppointmentOptionInput;
}>;


export type ChooseAppointmentOptionMutation = { __typename?: 'Mutation', chooseAppointmentOption: { __typename: 'ChooseAppointmentOptionSuccessOutput', appointmentDateTime?: string | null } | { __typename: 'MutationErrorOutput', message: string } };

export type QueueAppointmentSchedulingProposalsMutationVariables = Exact<{
  input: QueueAppointmentSchedulingProposalsInput;
}>;


export type QueueAppointmentSchedulingProposalsMutation = { __typename?: 'Mutation', queueAppointmentSchedulingProposals: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'QueueAppointmentSchedulingProposalsSuccessOutput', stopUuids: Array<string>, errorMessages: Array<string> } };

export type AddUserToRoleMutationVariables = Exact<{
  addUserToRoleInput: AddUserToRoleInput;
}>;


export type AddUserToRoleMutation = { __typename?: 'Mutation', addUserToRole: { __typename?: 'AddUserToRoleOutput', success: boolean } };

export type CreateRoleMutationVariables = Exact<{
  createRoleInput: CreateRoleInput;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'CreateRoleOutput', role: { __typename?: 'RoleEntity', uuid: string } } };

export type FindRoleUserFragment = { __typename?: 'UserEntity', uuid: string, email: string };

export type FindRoleFragment = { __typename?: 'RoleEntity', uuid: string, name: string, permissions: Array<{ __typename?: 'PermissionEntity', uuid: string, permissionResource: PermissionResource, accessLevel: AccessLevel }>, users: Array<{ __typename?: 'UserEntity', uuid: string, email: string }> };

export type FindRolePermissionFragment = { __typename?: 'PermissionEntity', uuid: string, permissionResource: PermissionResource, accessLevel: AccessLevel };

export type RoleQueryVariables = Exact<{
  findRoleInput: FindRoleInput;
}>;


export type RoleQuery = { __typename?: 'Query', role: { __typename?: 'FindRoleOutput', role: { __typename?: 'RoleEntity', uuid: string, name: string, permissions: Array<{ __typename?: 'PermissionEntity', uuid: string, permissionResource: PermissionResource, accessLevel: AccessLevel }>, users: Array<{ __typename?: 'UserEntity', uuid: string, email: string }> } } };

export type FindRolesFragment = { __typename?: 'RoleEntity', uuid: string, name: string, isInternalRole: boolean };

export type RolesQueryVariables = Exact<{
  findRolesInput?: InputMaybe<FindRolesInput>;
}>;


export type RolesQuery = { __typename?: 'Query', roles: { __typename?: 'FindRolesOutput', roles: Array<{ __typename?: 'RoleEntity', uuid: string, name: string, isInternalRole: boolean }> } };

export type RemoveUserFromRoleMutationVariables = Exact<{
  removeUserFromRoleInput: RemoveUserFromRoleInput;
}>;


export type RemoveUserFromRoleMutation = { __typename?: 'Mutation', removeUserFromRole: { __typename?: 'RemoveUserFromRoleOutput', success: boolean } };

export type UpdateRoleMutationVariables = Exact<{
  updateRoleInput: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'UpdateRoleOutput', success: boolean } };

export type UsersForRoleFragment = { __typename?: 'UserEntity', uuid: string, email: string, phoneNumber?: string | null, name?: string | null };

export type UsersForRoleQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersForRoleQuery = { __typename?: 'Query', users: Array<{ __typename?: 'UserEntity', uuid: string, email: string, phoneNumber?: string | null, name?: string | null }> };

export type CreateShipmentDocumentMutationVariables = Exact<{
  createShipmentDocumentInput: CreateShipmentDocumentInput;
}>;


export type CreateShipmentDocumentMutation = { __typename?: 'Mutation', createShipmentDocument: { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null } };

export type CompleteStopBulkMutationVariables = Exact<{
  completeStopBulkInput: CompleteStopBulkInput;
}>;


export type CompleteStopBulkMutation = { __typename?: 'Mutation', completeStopBulk: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> };

export type CompleteStopV2MutationVariables = Exact<{
  completeStopInput: CompleteStopInput;
}>;


export type CompleteStopV2Mutation = { __typename?: 'Mutation', completeStopV2: { __typename?: 'CompleteStopEntity', uuid: string } | { __typename?: 'CompleteStopInvalidInputException', message: string } };

export type DeleteDocumentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument?: { __typename?: 'DocumentEntity', uuid: string } | null };

export type GenerateShipmentPreSignedPutUrlMutationVariables = Exact<{
  generateShipmentPreSignedPutUrlInput: GenerateShipmentPreSignedPutUrlInput;
}>;


export type GenerateShipmentPreSignedPutUrlMutation = { __typename?: 'Mutation', generateShipmentPreSignedPutUrl: string };

export type MarkStopAsFailedMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkStopAsFailedMutation = { __typename?: 'Mutation', markStopAsFailed: { __typename?: 'StandardStopEntity', uuid: string } };

export type MarkStopAsFailedV2MutationVariables = Exact<{
  markStopAsFailedV2Input: MarkStopAsFailedV2Input;
}>;


export type MarkStopAsFailedV2Mutation = { __typename?: 'Mutation', markStopAsFailedV2: { __typename?: 'StandardStopEntity', uuid: string } };

export type NameOfRouteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type NameOfRouteQuery = { __typename?: 'Query', route: { __typename?: 'RouteEntity', uuid: string, name: string } };

export type EquipmentsFetchQueryVariables = Exact<{
  equipmentTypes?: InputMaybe<Array<EquipmentType> | EquipmentType>;
}>;


export type EquipmentsFetchQuery = { __typename?: 'Query', equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> };

export type RouteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
  canReadIntelligenceBoard?: Scalars['Boolean']['input'];
}>;


export type RouteQuery = { __typename?: 'Query', route: { __typename?: 'RouteEntity', createdAt: any, date: any, uuid: string, defaultStartTime?: any | null, startTime?: any | null, totalTimeInSeconds?: number | null, totalDistanceInMeters?: number | null, startLoadTimeInMinutes?: number | null, endLoadTimeInMinutes?: number | null, locked: boolean, nameManuallyChanged: boolean, name: string, numberOfRescheduled?: number | null, routeSlotsUpdatedAt?: any | null, routePathUpdatedAt?: any | null, lastDispatched?: any | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, routeInfo: { __typename?: 'RouteInfo', totalStops: number, totalStopsArrived: number, totalStopsNotArrived: number, totalStopsCompleted: number, totalStopsCancelled: number, totalStopsFailed: number, status: RouteStatus, pieceCount: number, totalWeight: number, totalStopsSentToAgent: number, totalStopsConfirmedByAgent: number }, helpers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, phoneNumber: string, driverReferenceNumber?: string | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string, type: EquipmentType, vehicleType?: { __typename?: 'VehicleTypeEntity', uuid: string, name: string, status: VehicleTypeStatus, maxVolume?: any | null, maxWeight?: any | null, maxHeight?: any | null, maxWidth?: any | null, maxLength?: any | null, doorHeight?: any | null, interiorLengthIn?: number | null, interiorWidthIn?: number | null, interiorHeightIn?: number | null, capacityNotes?: string | null, specialRules?: string | null, vehicleTypePackageSpecs: Array<{ __typename?: 'VehicleTypePackageSpecEntity', id: string, maxQuantity?: number | null, packageSpec: { __typename?: 'PackageSpecEntity', id: string, name: string } }> } | null }>, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, phoneNumber: string, driverReferenceNumber?: string | null, agentId?: string | null, driverPayType?: DriverPayType | null, perMileRate?: number | null, percentGrossRevenueRate?: number | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename: 'StandardStopEntity', stopType?: StopType | null, standardStopType?: StandardStopType | null, inboundMethod?: InboundMethod | null, outboundMethod?: OutboundMethod | null, notes?: string | null, isSpecial?: boolean | null, proofOfDeliverySignee?: string | null, status: StopStatus, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, specialInstructions?: string | null, paperworkMarkedComplete?: boolean | null, showDriverModifiedAt?: any | null, routeChangeAcknowledged: boolean, serviceDate?: any | null, overrideServiceTimeInMinutes?: number | null, completedAt?: any | null, uuid: string, appointmentTime?: any | null, endAppointmentTime?: any | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, ordinal: number, route?: { __typename?: 'RouteEntity', uuid: string, name: string } | null } | null, stopDetails?: { __typename?: 'StopDetailsOutput', stopDetailsStatus: StopDetailsStatus, message?: string | null } | null, cachedEta?: { __typename?: 'EtaEntity', arrivalTime: any, finishTime: any } | null, contactPerson?: { __typename?: 'ContactPersonEntity', firstName?: string | null, lastName?: string | null, phone?: string | null } | null, leg?: { __typename?: 'LegEntity', uuid: string, miles?: number | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, shipment?: { __typename?: 'StandardShipmentEntity', uuid: string, hasSignedPOD: boolean, shipmentType: ShipmentType, totalAmountCents?: number | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, terminal: string } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deliveryDate?: any | null, pickupOrDelivery: PickupOrDelivery, deadlineDate?: any | null, deadlineType?: DeadlineType | null }, order?: { __typename?: 'StandardOrderEntity', uuid: string, refusedBy?: string | null, isCollectOnDelivery: boolean, isDoorToDoor?: boolean | null, orderSegmentType: OrderSegmentType, fulfillmentType?: FulfillmentType | null, detailedStatusV2?: OrderDetailedStatus | null, hazmat: boolean, name: string, refNumbers: Array<string>, dateMarkedOnHand?: any | null, totalCharge: number, startStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, endStop?: { __typename?: 'StandardStopEntity', terminal?: { __typename?: 'TerminalEntity', name: string } | null } | null, tags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }>, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, timeInMinutes?: number | null } | null, orderComments: Array<{ __typename?: 'OrderCommentEntity', comment: string }>, shipments: Array<{ __typename?: 'StandardShipmentEntity', shipmentType: ShipmentType, uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, airportInfo?: { __typename?: 'AirportInfoEntity', address: { __typename?: 'AddressEntity', name: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, incomingCarrier?: string | null, inboundMethod?: InboundMethod | null, address: { __typename?: 'AddressEntity', name: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null } }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, description: string, weight?: number | null, quantity: number, length?: number | null, width?: number | null, height?: number | null, type?: PackageType | null, pieces?: Array<{ __typename?: 'PieceEntity', warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }> | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null }>, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, businessDivision?: { __typename?: 'BusinessDivisionEntity', uuid: string, name: string } | null }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, measurementUnits: MeasurementUnits }, inboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null }, outboundPaperwork: { __typename?: 'OrderPaperworkEntity', paperworkComplete: boolean, attachedDocuments?: Array<DocumentType> | null, missingDocuments?: Array<DocumentType> | null, alerts?: Array<DocumentType> | null, proofOfDeliveryOrPickupReadyToSign?: Array<DocumentType> | null, proofOfDeliveryOrPickupSigned?: Array<DocumentType> | null, photos?: Array<DocumentType> | null, other?: Array<DocumentType> | null } } | null } | null }> }> } };

export type ShallowRoutesQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type ShallowRoutesQuery = { __typename?: 'Query', routes: Array<{ __typename?: 'RouteEntity', uuid: string, name: string, date: any, startTime?: any | null, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }>, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string, stops: Array<{ __typename?: 'StandardStopEntity', uuid: string, status: StopStatus, address: { __typename?: 'AddressEntity', city: string } }> }> }> };

export type UpdateServiceDateForAssignedStopsMutationVariables = Exact<{
  updateServiceDateForAssignedStopsInput: UpdateServiceDateForAssignedStopsInput;
}>;


export type UpdateServiceDateForAssignedStopsMutation = { __typename?: 'Mutation', updateServiceDateForAssignedStops: Array<{ __typename?: 'RouteEntity', uuid: string }> };

export type UpdateStopMutationVariables = Exact<{
  updateStopInput: UpdateStopInput;
}>;


export type UpdateStopMutation = { __typename?: 'Mutation', updateStop: { __typename?: 'StandardStopEntity', uuid: string, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, phone?: string | null } | null } };

export type UpdateStopsMutationVariables = Exact<{
  updateStopsInput: UpdateStopsInput;
}>;


export type UpdateStopsMutation = { __typename?: 'Mutation', updateStops: Array<{ __typename?: 'StandardStopEntity', uuid: string }> };

export type SamaraOAuthAuthorizeUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type SamaraOAuthAuthorizeUrlQuery = { __typename?: 'Query', samaraOAuthAuthorizeUrl: string };

export type SamsaraOAuthTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type SamsaraOAuthTokenQuery = { __typename?: 'Query', samsaraOAuthToken?: { __typename?: 'SamsaraOauthTokenEntity', uuid: string } | null };

export type CloneSavedFilterViewMutationVariables = Exact<{
  cloneSavedFilterViewInput: CloneSavedFilterViewInput;
}>;


export type CloneSavedFilterViewMutation = { __typename?: 'Mutation', cloneSavedFilterView: { __typename?: 'SavedFilterViewEntity', uuid: string } };

export type CreateSavedFilterViewMutationVariables = Exact<{
  createSavedFilterViewInput: CreateSavedFilterViewInput;
}>;


export type CreateSavedFilterViewMutation = { __typename?: 'Mutation', createSavedFilterView: { __typename?: 'SavedFilterViewEntity', uuid: string } };

export type DeleteSavedFilterViewMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteSavedFilterViewMutation = { __typename?: 'Mutation', deleteSavedFilterView: { __typename?: 'SavedFilterViewEntity', uuid: string } };

export type GetSavedFilterViewsQueryVariables = Exact<{
  pageType: Scalars['String']['input'];
}>;


export type GetSavedFilterViewsQuery = { __typename?: 'Query', getSavedFilterViews: Array<{ __typename?: 'SavedFilterViewEntity', uuid: string, displayName: string, description?: string | null, savedViewPageType: FilterViewPage, isShared: boolean, isPublicToCompany: boolean, myPermission: ViewPermission, filterModelJson: string, filterModelJsonV2?: any | null, sortModelJson?: any | null, groupModelJson?: any | null, baseTab?: string | null, orderTableFields: Array<OrderTableField>, dispatchTableFields: Array<DispatchTableField>, user: { __typename?: 'UserActorEntity', uuid: string }, grants: Array<{ __typename?: 'SavedFilterViewGrantEntity', uuid: string, granteeType: GranteeType, granteeUuid: string, granteeName: string, permission: ViewPermission }>, lineHaulDispatchFilters?: { __typename?: 'SavedLineHaulDispatchFiltersEntity', laneFilter: { __typename?: 'SavedLineHaulDispatchLaneFilterEntity', originTerminalUuids: Array<string>, destinationTerminalUuids: Array<string> }, boardFilters: { __typename?: 'SavedLineHaulDispatchBoardFiltersEntity', legStates: Array<DispatchLegState>, pieceStatuses: Array<PieceStatus>, detailedStatuses: Array<OrderDetailedStatus> } } | null }> };

export type SavedFilterViewFragment = { __typename?: 'SavedFilterViewEntity', uuid: string, displayName: string, description?: string | null, savedViewPageType: FilterViewPage, isShared: boolean, isPublicToCompany: boolean, myPermission: ViewPermission, filterModelJson: string, filterModelJsonV2?: any | null, sortModelJson?: any | null, groupModelJson?: any | null, baseTab?: string | null, orderTableFields: Array<OrderTableField>, dispatchTableFields: Array<DispatchTableField>, user: { __typename?: 'UserActorEntity', uuid: string }, grants: Array<{ __typename?: 'SavedFilterViewGrantEntity', uuid: string, granteeType: GranteeType, granteeUuid: string, granteeName: string, permission: ViewPermission }>, lineHaulDispatchFilters?: { __typename?: 'SavedLineHaulDispatchFiltersEntity', laneFilter: { __typename?: 'SavedLineHaulDispatchLaneFilterEntity', originTerminalUuids: Array<string>, destinationTerminalUuids: Array<string> }, boardFilters: { __typename?: 'SavedLineHaulDispatchBoardFiltersEntity', legStates: Array<DispatchLegState>, pieceStatuses: Array<PieceStatus>, detailedStatuses: Array<OrderDetailedStatus> } } | null };

export type ShareSavedFilterViewMutationVariables = Exact<{
  shareSavedFilterViewInput: ShareSavedFilterViewInput;
}>;


export type ShareSavedFilterViewMutation = { __typename?: 'Mutation', shareSavedFilterView: { __typename?: 'SavedFilterViewEntity', uuid: string, displayName: string, description?: string | null, savedViewPageType: FilterViewPage, isShared: boolean, isPublicToCompany: boolean, myPermission: ViewPermission, filterModelJson: string, filterModelJsonV2?: any | null, sortModelJson?: any | null, groupModelJson?: any | null, baseTab?: string | null, orderTableFields: Array<OrderTableField>, dispatchTableFields: Array<DispatchTableField>, user: { __typename?: 'UserActorEntity', uuid: string }, grants: Array<{ __typename?: 'SavedFilterViewGrantEntity', uuid: string, granteeType: GranteeType, granteeUuid: string, granteeName: string, permission: ViewPermission }>, lineHaulDispatchFilters?: { __typename?: 'SavedLineHaulDispatchFiltersEntity', laneFilter: { __typename?: 'SavedLineHaulDispatchLaneFilterEntity', originTerminalUuids: Array<string>, destinationTerminalUuids: Array<string> }, boardFilters: { __typename?: 'SavedLineHaulDispatchBoardFiltersEntity', legStates: Array<DispatchLegState>, pieceStatuses: Array<PieceStatus>, detailedStatuses: Array<OrderDetailedStatus> } } | null } };

export type UpdateSavedFilterViewMutationVariables = Exact<{
  updateSavedFilterViewInput: UpdateSavedFilterViewInput;
}>;


export type UpdateSavedFilterViewMutation = { __typename?: 'Mutation', updateSavedFilterView: { __typename?: 'SavedFilterViewEntity', uuid: string } };

export type ScannedOrderResultPageFragmentFragment = { __typename?: 'ScannedOrderResultPageEntity', uuid: string, bucket: string, key: string, page: number, preSignedGetUrl: string };

export type MergeScannedOrderResultIntoPossibleDuplicateMutationVariables = Exact<{
  input: MergeScannedOrderResultIntoPossibleDuplicateInput;
}>;


export type MergeScannedOrderResultIntoPossibleDuplicateMutation = { __typename?: 'Mutation', mergeScannedOrderResultIntoPossibleDuplicate: { __typename?: 'ScannedOrderResultEntity', uuid: string, status: ScannedOrderResultStatus } };

export type ScannedOrderResultFragmentFragment = { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus }, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string }> };

export type ScannedOrderResultQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ScannedOrderResultQuery = { __typename?: 'Query', numberOfScannedOrderResultsInReview: number, scannedOrderResult?: { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, key: string, preSignedGetUrl: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, retryCount: number, status: ScannedOrderStatus }, scannedOrderResultDocuments: Array<{ __typename?: 'ScannedOrderResultDocumentEntity', uuid: string, filename: string, key: string, preSignedGetUrl: string, scannedDocumentType: ScannedDocumentType, scannedOrderResultDocumentPages: Array<{ __typename?: 'ScannedOrderResultDocumentPageEntity', uuid: string, bucket: string, key: string, page: number, preSignedGetUrl: string }> }>, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string, uuid: string, bucket: string, key: string }>, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, possibleDuplicateOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, mergedAwayOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, serviceSelection?: { __typename?: 'ScannedOrderResultServiceSelection', source?: ScannedOrderResultServiceSource | null, extractedText?: string | null, suggestedServiceUuid?: string | null, suggestedServiceSource?: ScannedOrderResultServiceSource | null } | null, nextScannedOrderResultInReview?: { __typename?: 'ScannedOrderResultEntity', uuid: string, filename: string, pageEnd: number, pageStart: number, status: ScannedOrderResultStatus, type: ScannedOrderResultType, failureReason?: ScannedOrderFailureReason | null, signedPodMatchStatus?: SignedPodMatchStatus | null, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus }, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', page: number, preSignedGetUrl: string }> } | null } | null };

export type BillingPartyPickerQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type BillingPartyPickerQuery = { __typename?: 'Query', scannedOrderResult?: { __typename?: 'ScannedOrderResultEntity', uuid: string, status: ScannedOrderResultStatus, failureReason?: ScannedOrderFailureReason | null, dismissed: boolean, filename: string, pageStart: number, pageEnd: number, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null, billingPartyCandidates?: Array<{ __typename?: 'ScannedOrderResultBillingPartyCandidate', contactUuid: string, contactName?: string | null, votes?: number | null, share?: number | null, isActive: boolean }> | null, scannedOrder: { __typename?: 'ScannedOrderEntity', uuid: string, key: string, filename: string, source: ScannedOrderSource, preSignedGetUrl: string, ingestedOutlookEmailDetails: { __typename?: 'IngestedEmailDetailsEntity', fromAddress?: string | null, subject?: string | null, receivedAt?: any | null, bodyPreview?: string | null, body?: string | null } }, scannedOrderResultPages: Array<{ __typename?: 'ScannedOrderResultPageEntity', uuid: string, page: number, preSignedGetUrl: string }> } | null };

export type FirstScannedOrderResultInReviewQueryVariables = Exact<{
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FirstScannedOrderResultInReviewQuery = { __typename?: 'Query', firstScannedOrderResultInReview?: { __typename?: 'ScannedOrderResultEntity', uuid: string, status: ScannedOrderResultStatus, failureReason?: ScannedOrderFailureReason | null, dismissed: boolean, order?: { __typename?: 'StandardOrderEntity', uuid: string } | null } | null };

export type ResolveScannedOrderBillingPartyMutationVariables = Exact<{
  resolveScannedOrderBillingPartyInput: ResolveScannedOrderBillingPartyInput;
}>;


export type ResolveScannedOrderBillingPartyMutation = { __typename?: 'Mutation', resolveScannedOrderBillingParty: { __typename?: 'ScannedOrderResultEntity', uuid: string, status: ScannedOrderResultStatus, failureReason?: ScannedOrderFailureReason | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, duplicateOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null } };

export type ScannedOrderResultWithOrdersFragment = { __typename?: 'ScannedOrderResultEntity', uuid: string, createdAt: any, status: ScannedOrderResultStatus, signedPodMatchStatus?: SignedPodMatchStatus | null, failureReason?: ScannedOrderFailureReason | null, dismissed: boolean, filename: string, pageEnd: number, pageStart: number, duplicateOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource } | null, duplicateScannedOrderResultOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource } | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, podOrder?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null };

export type ScannedOrderResultsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  approvedAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedAtAfter?: InputMaybe<Scalars['DateTime']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  type: ScannedOrderResultType;
  statuses?: InputMaybe<Array<ScannedOrderResultStatus> | ScannedOrderResultStatus>;
  signedPodMatchStatuses?: InputMaybe<Array<SignedPodMatchStatus> | SignedPodMatchStatus>;
  sourceFilter?: InputMaybe<ScannedOrderResultSourceFilter>;
  failureReasonFilter?: InputMaybe<ScannedOrderFailureReason>;
  viewAllUploads?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ScannedOrderResultsQuery = { __typename?: 'Query', numberOfScannedOrderResultDuplicates: number, numberOfScannedOrderResultsInProgress: number, numberOfScannedOrderResultsInReview: number, numberOfScannedOrderResultsFailed: number, numberOfScannedOrderResultsRejected: number, numberOfScannedOrderResultsApproved: number, scannedOrderResults: { __typename?: 'ScannedOrderResultConnection', edges: Array<{ __typename?: 'ScannedOrderResultEdge', node: { __typename?: 'ScannedOrderResultEntity', uuid: string, createdAt: any, status: ScannedOrderResultStatus, signedPodMatchStatus?: SignedPodMatchStatus | null, failureReason?: ScannedOrderFailureReason | null, dismissed: boolean, filename: string, pageEnd: number, pageStart: number, duplicateOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource } | null, duplicateScannedOrderResultOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, source: OrderSource } | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, billingPartyContact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string }, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, podOrder?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type ScannedOrderFragmentFragment = { __typename?: 'ScannedOrderEntity', uuid: string, bucket: string, failureReason?: ScannedOrderFailureReason | null, filename: string, key: string, preSignedGetUrl: string, retryCount: number, status: ScannedOrderStatus, s3Url: string };

export type UpdateScannedOrderResultStatusMutationVariables = Exact<{
  updateScannedOrderResultStatusInput: UpdateScannedOrderResultStatusInput;
}>;


export type UpdateScannedOrderResultStatusMutation = { __typename?: 'Mutation', updateScannedOrderResultStatus: { __typename?: 'ScannedOrderResultEntity', uuid: string } };

export type AllSchedulingRegionFieldsFragment = { __typename?: 'SchedulingRegionEntity', id: string, name: string, dailyCapacityPieces?: number | null, dailyCapacityStops?: number | null, dailyCapacityWeight?: any | null, isArchived: boolean, zones: Array<{ __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> }> };

export type AllSchedulingResourceFieldsFragment = { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, blockedDays: Array<{ __typename?: 'SchedulingResourceBlockedDayEntity', id: string, reason?: string | null, date: { __typename?: 'PlainDate', iso8601: string } }>, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null };

export type AllSchedulingZoneFieldsFragment = { __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> };

export type ArchiveSchedulingRegionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveSchedulingRegionMutation = { __typename?: 'Mutation', archiveSchedulingRegion: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateSchedulingRegionSuccessOutput', schedulingRegion: { __typename?: 'SchedulingRegionEntity', id: string, name: string, dailyCapacityPieces?: number | null, dailyCapacityStops?: number | null, dailyCapacityWeight?: any | null, isArchived: boolean, zones: Array<{ __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> }> } } };

export type ArchiveSchedulingResourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ArchiveSchedulingResourceMutation = { __typename?: 'Mutation', archiveSchedulingResource: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'SchedulingResourceLiveClaimsOutput', message: string, liveClaimCount: number, liveClaimDatesIso8601: Array<string> } | { __typename: 'SchedulingResourceNameConflictOutput', message: string, conflictingSchedulingResourceId: string, conflictingSchedulingResourceName: string } | { __typename: 'SchedulingResourceSuccessOutput', schedulingResource: { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, blockedDays: Array<{ __typename?: 'SchedulingResourceBlockedDayEntity', id: string, reason?: string | null, date: { __typename?: 'PlainDate', iso8601: string } }>, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null } } };

export type BlockCompanySchedulingDayMutationVariables = Exact<{
  input: BlockCompanySchedulingDayInput;
}>;


export type BlockCompanySchedulingDayMutation = { __typename?: 'Mutation', blockCompanySchedulingDay: { __typename: 'CompanySchedulingBlockedDaySuccessOutput', liveClaimCount: number, affectedSchedulingResourceCount: number, schedulingBlockedDay?: { __typename?: 'SchedulingBlockedDayEntity', id: string, reason?: string | null, exemptSchedulingResourceIds: Array<string>, date: { __typename?: 'PlainDate', iso8601: string } } | null, affectedSchedulingResources: Array<{ __typename?: 'CompanySchedulingDayAffectedResourceOutput', id: string, name: string, liveClaimCount: number }> } | { __typename: 'CompanySchedulingDayExemptionsAtRiskOutput', message: string, exemptSchedulingResourceCount: number } | { __typename: 'CompanySchedulingDayLiveClaimsOutput', message: string, liveClaimCount: number, affectedSchedulingResourceCount: number, affectedSchedulingResources: Array<{ __typename?: 'CompanySchedulingDayAffectedResourceOutput', id: string, name: string, liveClaimCount: number }> } | { __typename: 'MutationErrorOutput', message: string } };

export type BlockSchedulingResourceDayMutationVariables = Exact<{
  input: BlockSchedulingResourceDayInput;
}>;


export type BlockSchedulingResourceDayMutation = { __typename?: 'Mutation', blockSchedulingResourceDay: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'SchedulingResourceLiveClaimsOutput', message: string, liveClaimCount: number, liveClaimDatesIso8601: Array<string> } | { __typename: 'SchedulingResourceNameConflictOutput', message: string, conflictingSchedulingResourceId: string, conflictingSchedulingResourceName: string } | { __typename: 'SchedulingResourceSuccessOutput', schedulingResource: { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, blockedDays: Array<{ __typename?: 'SchedulingResourceBlockedDayEntity', id: string, reason?: string | null, date: { __typename?: 'PlainDate', iso8601: string } }>, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null } } };

export type CompanySchedulingBlockedDayFieldsFragment = { __typename?: 'SchedulingBlockedDayEntity', id: string, reason?: string | null, exemptSchedulingResourceIds: Array<string>, date: { __typename?: 'PlainDate', iso8601: string } };

type CompanySchedulingBlockedDayResultFields_CompanySchedulingBlockedDaySuccessOutput_Fragment = { __typename: 'CompanySchedulingBlockedDaySuccessOutput', liveClaimCount: number, affectedSchedulingResourceCount: number, schedulingBlockedDay?: { __typename?: 'SchedulingBlockedDayEntity', id: string, reason?: string | null, exemptSchedulingResourceIds: Array<string>, date: { __typename?: 'PlainDate', iso8601: string } } | null, affectedSchedulingResources: Array<{ __typename?: 'CompanySchedulingDayAffectedResourceOutput', id: string, name: string, liveClaimCount: number }> };

type CompanySchedulingBlockedDayResultFields_CompanySchedulingDayExemptionsAtRiskOutput_Fragment = { __typename: 'CompanySchedulingDayExemptionsAtRiskOutput', message: string, exemptSchedulingResourceCount: number };

type CompanySchedulingBlockedDayResultFields_CompanySchedulingDayLiveClaimsOutput_Fragment = { __typename: 'CompanySchedulingDayLiveClaimsOutput', message: string, liveClaimCount: number, affectedSchedulingResourceCount: number, affectedSchedulingResources: Array<{ __typename?: 'CompanySchedulingDayAffectedResourceOutput', id: string, name: string, liveClaimCount: number }> };

type CompanySchedulingBlockedDayResultFields_MutationErrorOutput_Fragment = { __typename: 'MutationErrorOutput', message: string };

export type CompanySchedulingBlockedDayResultFieldsFragment = CompanySchedulingBlockedDayResultFields_CompanySchedulingBlockedDaySuccessOutput_Fragment | CompanySchedulingBlockedDayResultFields_CompanySchedulingDayExemptionsAtRiskOutput_Fragment | CompanySchedulingBlockedDayResultFields_CompanySchedulingDayLiveClaimsOutput_Fragment | CompanySchedulingBlockedDayResultFields_MutationErrorOutput_Fragment;

export type CompanySchedulingBlockedDaysQueryVariables = Exact<{
  input?: InputMaybe<FindCompanySchedulingBlockedDaysInput>;
}>;


export type CompanySchedulingBlockedDaysQuery = { __typename?: 'Query', companySchedulingBlockedDays: Array<{ __typename?: 'SchedulingBlockedDayEntity', id: string, reason?: string | null, exemptSchedulingResourceIds: Array<string>, date: { __typename?: 'PlainDate', iso8601: string } }> };

export type CreateSchedulingRegionMutationVariables = Exact<{
  input: CreateSchedulingRegionInput;
}>;


export type CreateSchedulingRegionMutation = { __typename?: 'Mutation', createSchedulingRegion: { __typename: 'CreateSchedulingRegionSuccessOutput', schedulingRegion: { __typename?: 'SchedulingRegionEntity', id: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type CreateSchedulingResourceMutationVariables = Exact<{
  input: CreateSchedulingResourceInput;
}>;


export type CreateSchedulingResourceMutation = { __typename?: 'Mutation', createSchedulingResource: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'SchedulingResourceLiveClaimsOutput', message: string, liveClaimCount: number, liveClaimDatesIso8601: Array<string> } | { __typename: 'SchedulingResourceNameConflictOutput', message: string, conflictingSchedulingResourceId: string, conflictingSchedulingResourceName: string } | { __typename: 'SchedulingResourceSuccessOutput', schedulingResource: { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, blockedDays: Array<{ __typename?: 'SchedulingResourceBlockedDayEntity', id: string, reason?: string | null, date: { __typename?: 'PlainDate', iso8601: string } }>, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null } } };

export type CreateSchedulingZoneMutationVariables = Exact<{
  input: CreateSchedulingZoneInput;
}>;


export type CreateSchedulingZoneMutation = { __typename?: 'Mutation', createSchedulingZone: { __typename: 'CreateSchedulingZoneSuccessOutput', schedulingZone: { __typename?: 'SchedulingZoneEntity', id: string } } | { __typename: 'MutationErrorOutput', message: string } };

export type ExemptSchedulingResourceFromCompanyBlockedDayMutationVariables = Exact<{
  input: CompanySchedulingDayExemptionInput;
}>;


export type ExemptSchedulingResourceFromCompanyBlockedDayMutation = { __typename?: 'Mutation', exemptSchedulingResourceFromCompanyBlockedDay: { __typename: 'CompanySchedulingBlockedDaySuccessOutput', liveClaimCount: number, affectedSchedulingResourceCount: number, schedulingBlockedDay?: { __typename?: 'SchedulingBlockedDayEntity', id: string, reason?: string | null, exemptSchedulingResourceIds: Array<string>, date: { __typename?: 'PlainDate', iso8601: string } } | null, affectedSchedulingResources: Array<{ __typename?: 'CompanySchedulingDayAffectedResourceOutput', id: string, name: string, liveClaimCount: number }> } | { __typename: 'CompanySchedulingDayExemptionsAtRiskOutput', message: string, exemptSchedulingResourceCount: number } | { __typename: 'CompanySchedulingDayLiveClaimsOutput', message: string, liveClaimCount: number, affectedSchedulingResourceCount: number, affectedSchedulingResources: Array<{ __typename?: 'CompanySchedulingDayAffectedResourceOutput', id: string, name: string, liveClaimCount: number }> } | { __typename: 'MutationErrorOutput', message: string } };

export type RemoveSchedulingResourceCompanyBlockedDayExemptionMutationVariables = Exact<{
  input: CompanySchedulingDayExemptionInput;
}>;


export type RemoveSchedulingResourceCompanyBlockedDayExemptionMutation = { __typename?: 'Mutation', removeSchedulingResourceCompanyBlockedDayExemption: { __typename: 'CompanySchedulingBlockedDaySuccessOutput', liveClaimCount: number, affectedSchedulingResourceCount: number, schedulingBlockedDay?: { __typename?: 'SchedulingBlockedDayEntity', id: string, reason?: string | null, exemptSchedulingResourceIds: Array<string>, date: { __typename?: 'PlainDate', iso8601: string } } | null, affectedSchedulingResources: Array<{ __typename?: 'CompanySchedulingDayAffectedResourceOutput', id: string, name: string, liveClaimCount: number }> } | { __typename: 'CompanySchedulingDayExemptionsAtRiskOutput', message: string, exemptSchedulingResourceCount: number } | { __typename: 'CompanySchedulingDayLiveClaimsOutput', message: string, liveClaimCount: number, affectedSchedulingResourceCount: number, affectedSchedulingResources: Array<{ __typename?: 'CompanySchedulingDayAffectedResourceOutput', id: string, name: string, liveClaimCount: number }> } | { __typename: 'MutationErrorOutput', message: string } };

export type RestoreSchedulingRegionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreSchedulingRegionMutation = { __typename?: 'Mutation', restoreSchedulingRegion: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'RestoreSchedulingRegionNameConflictOutput', message: string, conflictingSchedulingRegionId: string } | { __typename: 'UpdateSchedulingRegionSuccessOutput', schedulingRegion: { __typename?: 'SchedulingRegionEntity', id: string, name: string, dailyCapacityPieces?: number | null, dailyCapacityStops?: number | null, dailyCapacityWeight?: any | null, isArchived: boolean, zones: Array<{ __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> }> } } };

export type RestoreSchedulingResourceMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreSchedulingResourceMutation = { __typename?: 'Mutation', restoreSchedulingResource: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'SchedulingResourceLiveClaimsOutput', message: string, liveClaimCount: number, liveClaimDatesIso8601: Array<string> } | { __typename: 'SchedulingResourceNameConflictOutput', message: string, conflictingSchedulingResourceId: string, conflictingSchedulingResourceName: string } | { __typename: 'SchedulingResourceSuccessOutput', schedulingResource: { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, blockedDays: Array<{ __typename?: 'SchedulingResourceBlockedDayEntity', id: string, reason?: string | null, date: { __typename?: 'PlainDate', iso8601: string } }>, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null } } };

export type RestoreSchedulingZoneMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RestoreSchedulingZoneMutation = { __typename?: 'Mutation', restoreSchedulingZone: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'RestoreSchedulingZoneNameConflictOutput', message: string, conflictingSchedulingZoneId: string } | { __typename: 'UpdateSchedulingZoneSuccessOutput', schedulingZone: { __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> } } };

export type SchedulingRegionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SchedulingRegionQuery = { __typename?: 'Query', schedulingRegion: { __typename?: 'SchedulingRegionEntity', id: string, name: string, dailyCapacityPieces?: number | null, dailyCapacityStops?: number | null, dailyCapacityWeight?: any | null, isArchived: boolean, zones: Array<{ __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> }> } };

export type SchedulingRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SchedulingRegionsQuery = { __typename?: 'Query', schedulingRegions: { __typename?: 'FindSchedulingRegionsOutput', schedulingRegions: Array<{ __typename?: 'SchedulingRegionEntity', id: string, name: string, isArchived: boolean }> } };

export type SchedulingResourceBlockedDayFieldsFragment = { __typename?: 'SchedulingResourceBlockedDayEntity', id: string, reason?: string | null, date: { __typename?: 'PlainDate', iso8601: string } };

export type SchedulingResourceEligibilityRulesFieldsFragment = { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } };

export type SchedulingResourceListFieldsFragment = { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null };

type SchedulingResourceMutationResultFields_MutationErrorOutput_Fragment = { __typename: 'MutationErrorOutput', message: string };

type SchedulingResourceMutationResultFields_SchedulingResourceLiveClaimsOutput_Fragment = { __typename: 'SchedulingResourceLiveClaimsOutput', message: string, liveClaimCount: number, liveClaimDatesIso8601: Array<string> };

type SchedulingResourceMutationResultFields_SchedulingResourceNameConflictOutput_Fragment = { __typename: 'SchedulingResourceNameConflictOutput', message: string, conflictingSchedulingResourceId: string, conflictingSchedulingResourceName: string };

type SchedulingResourceMutationResultFields_SchedulingResourceSuccessOutput_Fragment = { __typename: 'SchedulingResourceSuccessOutput', schedulingResource: { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, blockedDays: Array<{ __typename?: 'SchedulingResourceBlockedDayEntity', id: string, reason?: string | null, date: { __typename?: 'PlainDate', iso8601: string } }>, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null } };

export type SchedulingResourceMutationResultFieldsFragment = SchedulingResourceMutationResultFields_MutationErrorOutput_Fragment | SchedulingResourceMutationResultFields_SchedulingResourceLiveClaimsOutput_Fragment | SchedulingResourceMutationResultFields_SchedulingResourceNameConflictOutput_Fragment | SchedulingResourceMutationResultFields_SchedulingResourceSuccessOutput_Fragment;

export type SchedulingResourceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SchedulingResourceQuery = { __typename?: 'Query', schedulingResource: { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, blockedDays: Array<{ __typename?: 'SchedulingResourceBlockedDayEntity', id: string, reason?: string | null, date: { __typename?: 'PlainDate', iso8601: string } }>, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null } };

export type SchedulingResourcesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SchedulingResourcesQuery = { __typename?: 'Query', schedulingResources: { __typename?: 'FindSchedulingResourcesOutput', schedulingResourceConnection: { __typename?: 'SchedulingResourceConnection', edges: Array<{ __typename?: 'SchedulingResourceEdge', cursor: string, node: { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type SetSchedulingResourceEligibilityRulesMutationVariables = Exact<{
  input: SetSchedulingResourceEligibilityRulesInput;
}>;


export type SetSchedulingResourceEligibilityRulesMutation = { __typename?: 'Mutation', setSchedulingResourceEligibilityRules: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'SchedulingResourceLiveClaimsOutput', message: string, liveClaimCount: number, liveClaimDatesIso8601: Array<string> } | { __typename: 'SchedulingResourceNameConflictOutput', message: string, conflictingSchedulingResourceId: string, conflictingSchedulingResourceName: string } | { __typename: 'SchedulingResourceSuccessOutput', schedulingResource: { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, blockedDays: Array<{ __typename?: 'SchedulingResourceBlockedDayEntity', id: string, reason?: string | null, date: { __typename?: 'PlainDate', iso8601: string } }>, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null } } };

export type UnblockCompanySchedulingDayMutationVariables = Exact<{
  input: UnblockCompanySchedulingDayInput;
}>;


export type UnblockCompanySchedulingDayMutation = { __typename?: 'Mutation', unblockCompanySchedulingDay: { __typename: 'CompanySchedulingBlockedDaySuccessOutput', liveClaimCount: number, affectedSchedulingResourceCount: number, schedulingBlockedDay?: { __typename?: 'SchedulingBlockedDayEntity', id: string, reason?: string | null, exemptSchedulingResourceIds: Array<string>, date: { __typename?: 'PlainDate', iso8601: string } } | null, affectedSchedulingResources: Array<{ __typename?: 'CompanySchedulingDayAffectedResourceOutput', id: string, name: string, liveClaimCount: number }> } | { __typename: 'CompanySchedulingDayExemptionsAtRiskOutput', message: string, exemptSchedulingResourceCount: number } | { __typename: 'CompanySchedulingDayLiveClaimsOutput', message: string, liveClaimCount: number, affectedSchedulingResourceCount: number, affectedSchedulingResources: Array<{ __typename?: 'CompanySchedulingDayAffectedResourceOutput', id: string, name: string, liveClaimCount: number }> } | { __typename: 'MutationErrorOutput', message: string } };

export type UnblockSchedulingResourceDayMutationVariables = Exact<{
  input: UnblockSchedulingResourceDayInput;
}>;


export type UnblockSchedulingResourceDayMutation = { __typename?: 'Mutation', unblockSchedulingResourceDay: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'SchedulingResourceLiveClaimsOutput', message: string, liveClaimCount: number, liveClaimDatesIso8601: Array<string> } | { __typename: 'SchedulingResourceNameConflictOutput', message: string, conflictingSchedulingResourceId: string, conflictingSchedulingResourceName: string } | { __typename: 'SchedulingResourceSuccessOutput', schedulingResource: { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, blockedDays: Array<{ __typename?: 'SchedulingResourceBlockedDayEntity', id: string, reason?: string | null, date: { __typename?: 'PlainDate', iso8601: string } }>, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null } } };

export type UpdateSchedulingRegionMutationVariables = Exact<{
  input: UpdateSchedulingRegionInput;
}>;


export type UpdateSchedulingRegionMutation = { __typename?: 'Mutation', updateSchedulingRegion: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateSchedulingRegionSuccessOutput', schedulingRegion: { __typename?: 'SchedulingRegionEntity', id: string, name: string, dailyCapacityPieces?: number | null, dailyCapacityStops?: number | null, dailyCapacityWeight?: any | null, isArchived: boolean, zones: Array<{ __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> }> } } };

export type UpdateSchedulingResourceMutationVariables = Exact<{
  input: UpdateSchedulingResourceInput;
}>;


export type UpdateSchedulingResourceMutation = { __typename?: 'Mutation', updateSchedulingResource: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'SchedulingResourceLiveClaimsOutput', message: string, liveClaimCount: number, liveClaimDatesIso8601: Array<string> } | { __typename: 'SchedulingResourceNameConflictOutput', message: string, conflictingSchedulingResourceId: string, conflictingSchedulingResourceName: string } | { __typename: 'SchedulingResourceSuccessOutput', schedulingResource: { __typename?: 'SchedulingResourceEntity', id: string, name: string, dayOfWeek: DayOfWeekAll, timeZone: string, isArchived: boolean, capacityStops?: number | null, capacityPieces?: number | null, capacityWeight?: any | null, blockedDaysCount: number, blockedDays: Array<{ __typename?: 'SchedulingResourceBlockedDayEntity', id: string, reason?: string | null, date: { __typename?: 'PlainDate', iso8601: string } }>, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number }, routeNames: Array<{ __typename?: 'RouteNameEntity', uuid: string, name: string }>, eligibilityRules?: { __typename?: 'SchedulingResourceEligibilityRulesOutput', tags: { __typename?: 'SchedulingResourceTagEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, services: { __typename?: 'SchedulingResourceServiceEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean }, customers: { __typename?: 'SchedulingResourceCustomerEligibilityRulesOutput', allow: Array<string>, deny: Array<string>, restricted: boolean } } | null } } };

export type UpdateSchedulingZoneMutationVariables = Exact<{
  input: UpdateSchedulingZoneInput;
}>;


export type UpdateSchedulingZoneMutation = { __typename?: 'Mutation', updateSchedulingZone: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateSchedulingZoneSuccessOutput', schedulingZone: { __typename?: 'SchedulingZoneEntity', id: string, name: string, isArchived: boolean, availabilities: Array<{ __typename?: 'SchedulingZoneAvailabilityEntity', id: string, dayOfWeek: DayOfWeekAll, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }>, locations: Array<{ __typename?: 'SchedulingZoneLocationEntity', id: string, zipcode: string, city: string }> } } };

export type CreateServiceRegionsMutationVariables = Exact<{
  input: CreateServiceRegionsInput;
}>;


export type CreateServiceRegionsMutation = { __typename?: 'Mutation', createServiceRegions: { __typename: 'CreateServiceRegionsSuccessOutput', serviceRegions: Array<{ __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean }> } | { __typename: 'MutationErrorOutput', message: string } };

export type ServiceRegionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ServiceRegionQuery = { __typename?: 'Query', serviceRegion: { __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean, terminals: Array<{ __typename?: 'TerminalEntity', uuid: string, code: string, name: string, isActive: boolean, serviceAreas: Array<{ __typename?: 'TerminalServiceAreaEntity', uuid: string, zipcode: string, city?: string | null }> }> } };

export type UpdateServiceRegionMutationVariables = Exact<{
  input: UpdateServiceRegionInput;
}>;


export type UpdateServiceRegionMutation = { __typename?: 'Mutation', updateServiceRegion: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'UpdateServiceRegionSuccessOutput', serviceRegion: { __typename?: 'ServiceRegionEntity', id: string, name: string, isArchived: boolean } } };

export type BulkUpdateAccessorialMappingsMutationVariables = Exact<{
  bulkAccessorialUpdateInput: BulkAccessorialUpdateInput;
}>;


export type BulkUpdateAccessorialMappingsMutation = { __typename?: 'Mutation', bulkUpdateAccessorialMappings: Array<{ __typename: 'AttemptsAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerSkid: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'StandardAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerUnit: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, rate: number, waitTimeChargePeriod?: number | null, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, ratePerHundredWeight: number, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, isArchived?: boolean | null, name: string, enableQuickAdd: boolean, qboItemId?: string | null, unsyncedInvoiceCount: number, contact?: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } | null, zones: Array<{ __typename?: 'ZoneBasedAccessorialZoneEntity', uuid: string }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string, code: string } | null, generalLedgerCode?: { __typename?: 'GeneralLedgerCodeEntity', code: string, description: string } | null }> };

export type BulkUpdateContactQuickbooksIdsMutationVariables = Exact<{
  bulkUpdateContactQuickbooksId: UpdateContactQuickbooksIdsInput;
}>;


export type BulkUpdateContactQuickbooksIdsMutation = { __typename?: 'Mutation', bulkUpdateContactQuickbooksIds: Array<{ __typename: 'CustomerContactEntity', uuid: string, displayName: string, quickbooksDesktopContactId?: string | null }> };

export type SettingsCompanyConfigurationChangesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
}>;


export type SettingsCompanyConfigurationChangesQuery = { __typename?: 'Query', companyConfigurationChanges: { __typename?: 'CompanyConfigurationChangeConnection', edges: Array<{ __typename?: 'CompanyConfigurationChangeEdge', cursor: string, node: { __typename: 'CompanyConfigurationChangeEntity', uuid: string, key: string, label: string, oldValue?: any | null, newValue?: any | null, createdAt: any, changedBy?: { __typename: 'CompanyConfigurationChangeActorEntity', uuid: string, name?: string | null, email?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type SettingsCompanyConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsCompanyConfigurationQuery = { __typename?: 'Query', companyConfiguration?: { __typename?: 'CompanyConfigurationEntity', uuid: string, sameDayDispatchCellHeader: SameDayDispatchCellHeader, sendSummaryEmailWithIncompleteRoutes: boolean, startingInvoiceOrdinalNumber?: number | null, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, showChargesOnCustomerPortal: boolean, textNextCustomerForAppointments: boolean, invoicePdfLogoUrl?: string | null, reviewUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, allowDriverToSelectNextStop?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, requireReviewForEdiOrderCreation: boolean, autoApplyWaitTimeMinutes: boolean, useJournalNumberForInvoice: boolean, getDriverLocationDataFromMobile: boolean, mobilePollingIntervalInSeconds?: number | null, requireDriverToAcknowledgeRouteChange: boolean, useDriverNumberForDispatch: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, restrictEditingOrderName: boolean, showKilogramsAndCentimeters: boolean, showDriverSettlementInBilling: boolean, notificationsEnabled: boolean, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, enableDigitalSignatureFlow: boolean, requireDriverSignature: boolean, useSeparateDigitalSignatureStep: boolean, sendSignedPodEmailAfterLateSignature: boolean, requireSignedPodToCompleteStop: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean, appointmentSchedulerModel?: AppointmentSchedulerModel | null, createRecurringOrdersInAdvanceHours: number, serviceLevelOptional: boolean, addOrdersToOpenInvoices: boolean, invoiceNotes?: string | null, defaultInvoiceDocumentsRequired: Array<DocumentType>, autoMatchEodDocumentsToOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, requireSigneeNameForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, quoteAgentEnabled: boolean, quoteAgentDefaultMode: QuoteAgentPolicyMode, quoteAgentAutoSendMaxCents?: number | null, quoteAgentMinConfidence: number, quoteAgentValidityHours: number, quoteAgentDailyModelBudgetCents: number, draftOrderCleanupDays: number, draftOrderCleanupSources: Array<OrderSource>, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, terminalsEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulEnabled: boolean, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, defaultStandardStopType: StandardStopType, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, showAccessorialsToDrivers: boolean, pieceTransferableStatuses: Array<PieceStatus>, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean } | null };

export type CompanyDefaultEdiSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyDefaultEdiSettingsQuery = { __typename?: 'Query', company: { __typename?: 'CompanyEntity', uuid: string, defaultInboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null, defaultInboundOutboundEdiService?: { __typename?: 'ServiceEntity', uuid: string, name: string } | null } };

export type SettingsCompanyFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsCompanyFieldsQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', uuid: string, company: { __typename?: 'CompanyEntity', uuid: string, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, defaultNonCompanyDriverSettlementMode: SettlementMode, invoiceEmail?: string | null, defaultInvoiceEmailSubject?: string | null, blockSendingZeroDollarInvoices: boolean, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, qbInvoiceNumberStart?: number | null, phone?: string | null } } | null };

export type AccessorialToQuickbooksMappingByContactQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type AccessorialToQuickbooksMappingByContactQuery = { __typename?: 'Query', accessorialToQuickbooksMappingByContact: Array<{ __typename?: 'AccessorialToQuickbooksMappingEntity', uuid: string, quickbooksId: string, accessorial: { __typename?: 'AttemptsAccessorialEntity', unsyncedInvoiceCount: number, uuid: string, name: string, qboItemId?: string | null } | { __typename?: 'PercentageAccessorialEntity', unsyncedInvoiceCount: number, uuid: string, name: string, qboItemId?: string | null } | { __typename?: 'SkidBasedAccessorialEntity', unsyncedInvoiceCount: number, uuid: string, name: string, qboItemId?: string | null } | { __typename?: 'SpecialAccessorialEntity', unsyncedInvoiceCount: number, uuid: string, name: string, qboItemId?: string | null } | { __typename?: 'StandardAccessorialEntity', unsyncedInvoiceCount: number, uuid: string, name: string, qboItemId?: string | null } | { __typename?: 'StorageDaysAccessorialEntity', unsyncedInvoiceCount: number, uuid: string, name: string, qboItemId?: string | null } | { __typename?: 'UnitBasedAccessorialEntity', unsyncedInvoiceCount: number, uuid: string, name: string, qboItemId?: string | null } | { __typename?: 'WaitTimeAccessorialEntity', unsyncedInvoiceCount: number, uuid: string, name: string, qboItemId?: string | null } | { __typename?: 'WeightBasedAccessorialEntity', unsyncedInvoiceCount: number, uuid: string, name: string, qboItemId?: string | null } | { __typename?: 'ZoneBasedAccessorialEntity', unsyncedInvoiceCount: number, uuid: string, name: string, qboItemId?: string | null } }> };

export type CreateAccessorialToQuickbooksMappingMutationVariables = Exact<{
  accessorialToQuickbooksMappingCreateInput: AccessorialToQuickbooksMappingCreateInput;
}>;


export type CreateAccessorialToQuickbooksMappingMutation = { __typename?: 'Mutation', createAccessorialToQuickbooksMapping: { __typename?: 'AccessorialToQuickbooksMappingEntity', uuid: string } };

export type CreateManyReferenceNumberLabelsMutationVariables = Exact<{
  referenceNumberLabels: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreateManyReferenceNumberLabelsMutation = { __typename?: 'Mutation', createManyReferenceNumberLabels: Array<{ __typename?: 'ReferenceNumberLabelEntity', name: string }> };

export type CreateQuickbooksHeaderFileMappingMutationVariables = Exact<{
  createQuickbooksHeaderFileMappingInput: CreateQuickbooksHeaderFileMappingInput;
}>;


export type CreateQuickbooksHeaderFileMappingMutation = { __typename?: 'Mutation', createQuickbooksHeaderFileMapping: { __typename?: 'QuickbooksHeaderFileMappingEntity', uuid: string } };

export type DeleteQuickbooksHeaderFileMappingMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteQuickbooksHeaderFileMappingMutation = { __typename?: 'Mutation', deleteQuickbooksHeaderFileMapping: { __typename?: 'QuickbooksHeaderFileMappingEntity', uuid: string } };

export type DeleteTagMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: { __typename?: 'TagEntity', uuid: string } };

export type DisconnectQuickbooksMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectQuickbooksMutation = { __typename?: 'Mutation', disconnectQuickbooks: boolean };

export type DownloadFinancialSnapshotsCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadFinancialSnapshotsCsvQuery = { __typename?: 'Query', downloadFinancialSnapshotsCsv: Array<Array<string>> };

export type QuickbooksOAuthUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksOAuthUrlQuery = { __typename?: 'Query', quickbooksOAuthUrl: string };

export type GetQuickbooksConnectionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickbooksConnectionStatusQuery = { __typename?: 'Query', getQuickbooksConnectionStatus?: { __typename?: 'QuickbooksOauthTokenEntity', authStatus: QuickbooksAuthStatus, lastAuthError?: any | null } | null };

export type MyInAppNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyInAppNotificationPreferencesQuery = { __typename?: 'Query', myInAppNotificationPreferences: Array<{ __typename?: 'InAppNotificationPreferenceEntity', eventType: NotificationEventType, enabled: boolean, mandatory: boolean }> };

export type QueryQuickbooksDesktopItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryQuickbooksDesktopItemsQuery = { __typename?: 'Query', queryQuickbooksDesktopItems: { __typename?: 'QuickbooksDesktopResultEntity', error?: string | null, quickbooksDesktopObjects?: Array<{ __typename?: 'QuickbooksDesktopObjectEntity', id: string, name: string }> | null } };

export type QuickbooksCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksCustomersQuery = { __typename?: 'Query', quickbooksCustomers?: Array<{ __typename?: 'QuickbooksCustomerEntity', id: string, name: string, active: boolean }> | null };

export type QuickbooksClassesQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksClassesQuery = { __typename?: 'Query', quickbooksClasses?: Array<{ __typename?: 'QuickbooksClassEntity', id: string, name: string, active: boolean }> | null };

export type QuickbooksHeaderFileMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksHeaderFileMappingsQuery = { __typename?: 'Query', quickbooksHeaderFileMappings: Array<{ __typename?: 'QuickbooksHeaderFileMappingEntity', uuid: string, name: string, cellNumber: number, headerType: HeaderFileMappingType }> };

export type QuickbooksIncomeAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksIncomeAccountsQuery = { __typename?: 'Query', quickbooksIncomeAccounts?: Array<{ __typename?: 'QuickbooksAccountEntity', id: string, name: string, accountType: string }> | null };

export type QuickbooksItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksItemsQuery = { __typename?: 'Query', quickbooksItems?: Array<{ __typename?: 'QuickbooksItemEntity', id: string, name: string, active: boolean }> | null };

export type QuickbooksTaxCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksTaxCodesQuery = { __typename?: 'Query', quickbooksTaxCodes?: Array<{ __typename?: 'QuickbooksTaxCodeEntity', id: string, name: string, active: boolean }> | null };

export type ReferenceNumberFormatCheckFragment = { __typename?: 'ReferenceNumberFormatCheckEntity', uuid: string, type: ReferenceNumberFormatCheckType, operator?: ReferenceNumberFormatCheckOperator | null, startsWithOperands: Array<string>, lengthOperand?: number | null };

export type ReferenceNumberFormatConfigsQueryVariables = Exact<{
  contactUuid: Scalars['String']['input'];
}>;


export type ReferenceNumberFormatConfigsQuery = { __typename?: 'Query', referenceNumberFormatConfigs?: Array<{ __typename?: 'ReferenceNumberFormatConfigEntity', uuid: string, checks: Array<{ __typename?: 'ReferenceNumberFormatCheckEntity', uuid: string, type: ReferenceNumberFormatCheckType, operator?: ReferenceNumberFormatCheckOperator | null, startsWithOperands: Array<string>, lengthOperand?: number | null }> }> | null };

export type ServiceFragment = { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> };

export type SyncFinancialSnapshotsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncFinancialSnapshotsMutation = { __typename?: 'Mutation', syncFinancialSnapshots: boolean };

export type UpdateAccessorialToQuickbooksMappingMutationVariables = Exact<{
  accessorialToQuickbooksMappingUpdateInput: AccessorialToQuickbooksMappingUpdateInput;
}>;


export type UpdateAccessorialToQuickbooksMappingMutation = { __typename?: 'Mutation', updateAccessorialToQuickbooksMapping: { __typename?: 'AccessorialToQuickbooksMappingEntity', uuid: string } };

export type SettingsUpdateCompanyConfigurationMutationVariables = Exact<{
  input: UpdateCompanyConfigurationInput;
}>;


export type SettingsUpdateCompanyConfigurationMutation = { __typename?: 'Mutation', updateCompanyConfiguration: { __typename?: 'CompanyConfigurationEntity', uuid: string, sameDayDispatchCellHeader: SameDayDispatchCellHeader, sendSummaryEmailWithIncompleteRoutes: boolean, startingInvoiceOrdinalNumber?: number | null, defaultFuelSurchargeBillingMethod: FuelBillingMethod, defaultDimFactor?: number | null, defaultFuelSurcharge?: number | null, defaultFuelSettlementPercentageRate?: number | null, defaultRouteStartTime?: any | null, defaultRouteLoadTimeInMinutes?: number | null, defaultRouteUnloadTimeInMinutes?: number | null, defaultGenerateAppointmentDurationInMinutes: number, defaultGenerateAppointmentEarlyCushionInMinutes: number, enableConsolidatedOrders: boolean, showChargesOnCustomerPortal: boolean, textNextCustomerForAppointments: boolean, invoicePdfLogoUrl?: string | null, reviewUrl?: string | null, showManuallyConfirmedByDefault?: boolean | null, allowDriverToSelectNextStop?: boolean | null, showHelpersColumnInDispatch?: boolean | null, showVehicleInDailyDispatch?: boolean | null, requireReviewForEdiOrderCreation: boolean, autoApplyWaitTimeMinutes: boolean, useJournalNumberForInvoice: boolean, getDriverLocationDataFromMobile: boolean, mobilePollingIntervalInSeconds?: number | null, requireDriverToAcknowledgeRouteChange: boolean, useDriverNumberForDispatch: boolean, defaultToAccessorial: boolean, enablePaymentMethod: boolean, driversShouldMarkFreightAsLoaded: boolean, allCapsInOrderPage: boolean, orderNamingScheme: OrderNamingScheme, companyOrdinalStart?: number | null, minDigitsInCompanyOrdinalOrderName?: number | null, restrictEditingOrderName: boolean, showKilogramsAndCentimeters: boolean, showDriverSettlementInBilling: boolean, notificationsEnabled: boolean, requireDimsToFinalizeCharges: boolean, orderIdentifierForCoverSheet: OrderIdentifier, enableDigitalSignatureFlow: boolean, requireDriverSignature: boolean, useSeparateDigitalSignatureStep: boolean, sendSignedPodEmailAfterLateSignature: boolean, requireSignedPodToCompleteStop: boolean, includeHyphensInInvoiceName: boolean, includeINVInInvoiceName: boolean, appointmentSchedulingSlotHours: number, appointmentSchedulingLeadingBufferHours: number, appointmentSchedulingCutoffDays: number, appointmentChangeCutoffHours: number, appointmentSelfRescheduleLimit: number, requireOnHandBeforeSelfScheduling: boolean, appointmentSchedulerModel?: AppointmentSchedulerModel | null, createRecurringOrdersInAdvanceHours: number, serviceLevelOptional: boolean, addOrdersToOpenInvoices: boolean, invoiceNotes?: string | null, defaultInvoiceDocumentsRequired: Array<DocumentType>, autoMatchEodDocumentsToOrders: boolean, requirePODPhotoAndName: boolean, requirePODPhotoAndNameForPickups: boolean, requirePODPhotoForPickups: boolean, requireSigneeNameForPickups: boolean, requirePODPhotoForDeliveries: boolean, requireSigneeNameForDeliveries: boolean, autoGroupStops: boolean, requireDriverToConfirmStopCompletedAtTime: boolean, packageWarehouseLocationsEnabled: boolean, wmsEnabled: boolean, wmsStorageOrdersEnabled: boolean, wmsShortTermStorageEnabled: boolean, wmsAutoMarkOnHand: boolean, useHawbForLotLabelBarcode: boolean, quoteContributionMarginalFromRatio: number, quoteContributionProfitableFromRatio: number, quoteAgentEnabled: boolean, quoteAgentDefaultMode: QuoteAgentPolicyMode, quoteAgentAutoSendMaxCents?: number | null, quoteAgentMinConfidence: number, quoteAgentValidityHours: number, quoteAgentDailyModelBudgetCents: number, draftOrderCleanupDays: number, draftOrderCleanupSources: Array<OrderSource>, defaultPalletLength?: number | null, defaultPalletWidth?: number | null, defaultPalletHeight?: number | null, terminalsEnabled: boolean, lineHaulBuildAheadDays: number, lineHaulEnabled: boolean, lineHaulMobilePastWindowHours: number, lineHaulMobileFutureWindowHours: number, lineHaulPlanningEnabled: boolean, driverComplianceExpiringSoonDays: number, logisticsSectionEnabled: boolean, fulfillmentTypeEnabled: boolean, pointToPointTariffsEnabled: boolean, recoveryTariffsEnabled: boolean, showCompanyNameOnBillOfLadingDoc: boolean, defaultStandardStopType: StandardStopType, orderLevelOsdEnabled: boolean, markOnHandUponPickup: boolean, showAccessorialsToDrivers: boolean, pieceTransferableStatuses: Array<PieceStatus>, t2tDelegationEnabled: boolean, t2tSyncEnabled: boolean } };

export type SettingsUpdateCompanyFieldsMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type SettingsUpdateCompanyFieldsMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'CompanyEntity', uuid: string, timeZone: string, defaultWeightUnits: WeightUnits, defaultMeasurementUnits: MeasurementUnits, defaultNonCompanyDriverSettlementMode: SettlementMode, invoiceEmail?: string | null, defaultInvoiceEmailSubject?: string | null, blockSendingZeroDollarInvoices: boolean, customDunningReportHeader?: string | null, customDunningReportFooter?: string | null, useSageBusinessWorks: boolean, qbInvoiceNumberStart?: number | null, phone?: string | null } };

export type UpdateCompanyMutationVariables = Exact<{
  updateCompanyInput: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'CompanyEntity', uuid: string, qboFreightItemId?: string | null, freightChargeQuickbooksMappingId?: string | null, qboFuelItemId?: string | null, fuelChargeQuickbooksMappingId?: string | null, qboLineHaulItemId?: string | null, miscCustomChargeQuickbooksMappingId?: string | null, qboDefaultIncomeAccountId?: string | null, qboDefaultTaxCodeId?: string | null, qboDefaultClassId?: string | null, quickbooksFileMappingFreightChargeName?: string | null, quickbooksFileMappingFuelChargeName?: string | null, quickbooksFileMappingAccessorialChargeName?: string | null, quickbooksFileMappingPickupChargeName?: string | null } };

export type UpdateInAppNotificationPreferencesMutationVariables = Exact<{
  input: UpdateInAppNotificationPreferencesInput;
}>;


export type UpdateInAppNotificationPreferencesMutation = { __typename?: 'Mutation', updateInAppNotificationPreferences: Array<{ __typename?: 'InAppNotificationPreferenceEntity', eventType: NotificationEventType, enabled: boolean, mandatory: boolean }> };

export type UpdateOrderFormFieldsMutationVariables = Exact<{
  updateOrderFormFieldsInput: UpdateOrderFormFieldsInput;
}>;


export type UpdateOrderFormFieldsMutation = { __typename?: 'Mutation', updateOrderFormFields: { __typename?: 'OrderFormFieldsEntity', onePackageRequired: boolean, onePackageWeightRequired: boolean } };

export type UpdateQuickbooksHeaderFileMappingMutationVariables = Exact<{
  updateQuickbooksHeaderFileMappingInput: UpdateQuickbooksHeaderFileMappingInput;
}>;


export type UpdateQuickbooksHeaderFileMappingMutation = { __typename?: 'Mutation', updateQuickbooksHeaderFileMapping: { __typename?: 'QuickbooksHeaderFileMappingEntity', uuid: string } };

export type UpdateTagMutationVariables = Exact<{
  updateTagInput: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'TagEntity', uuid: string } };

export type CreateQuoteAgentForwardingAddressMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateQuoteAgentForwardingAddressMutation = { __typename?: 'Mutation', createQuoteAgentForwardingAddress: { __typename: 'CreateQuoteAgentForwardingAddressSuccessOutput', connection: { __typename?: 'QuoteAgentConnection', uuid: string, kind: string, address: string, status: string, createdAt: any } } | { __typename: 'MutationErrorOutput', message: string } };

export type ExpireQuoteAgentPreviousForwardingTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type ExpireQuoteAgentPreviousForwardingTokenMutation = { __typename?: 'Mutation', expireQuoteAgentPreviousForwardingToken: { __typename: 'ExpireQuoteAgentPreviousForwardingTokenSuccessOutput', forwardingAddress: string, previousExpired: boolean } | { __typename: 'MutationErrorOutput', message: string } };

export type QuoteAgentConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuoteAgentConnectionsQuery = { __typename?: 'Query', quoteAgentConnections: { __typename?: 'QuoteAgentConnectionsResult', available: boolean, connections: Array<{ __typename?: 'QuoteAgentConnection', uuid: string, kind: string, address: string, status: string, createdAt: any }> } };

export type QuoteAgentInboundRejectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type QuoteAgentInboundRejectionsQuery = { __typename?: 'Query', quoteAgentInboundRejections: { __typename?: 'QuoteAgentInboundRejectionsResult', available: boolean, rejections: Array<{ __typename?: 'QuoteAgentInboundRejection', receiptUuid: string, rejectedAt: any, reason: string, fromAddress?: string | null, fromName?: string | null, subject?: string | null }> } };

export type RotateQuoteAgentForwardingTokenMutationVariables = Exact<{
  connectionUuid: Scalars['String']['input'];
}>;


export type RotateQuoteAgentForwardingTokenMutation = { __typename?: 'Mutation', rotateQuoteAgentForwardingToken: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'RotateQuoteAgentForwardingTokenSuccessOutput', connectionUuid: string, forwardingAddress: string, previousValidUntil: any } };

export type SaveSmc3SettingsMutationVariables = Exact<{
  input: SaveSmc3SettingsInput;
}>;


export type SaveSmc3SettingsMutation = { __typename?: 'Mutation', saveSmc3Settings: { __typename?: 'Smc3SettingsSaveResultEntity', settings: { __typename?: 'Smc3SettingsEntity', hasCredentials: boolean, isEnabled: boolean, environment?: Smc3Environment | null, defaultTariffName?: string | null, pinnedTariffEffectiveDate?: string | null, version?: string | null, diagnostics?: { __typename?: 'Smc3DiagnosticsEntity', lastSuccessAt?: any | null, lastErrorCode?: ExternalRatingErrorCode | null, lastErrorAt?: any | null } | null }, failure?: { __typename?: 'Smc3ConnectionFailureEntity', code: ExternalRatingErrorCode, providerCode?: string | null, providerMessage?: string | null, retryable: boolean, retryAfter?: any | null } | null } };

export type Smc3AvailableTariffsQueryVariables = Exact<{ [key: string]: never; }>;


export type Smc3AvailableTariffsQuery = { __typename?: 'Query', smc3AvailableTariffs: { __typename?: 'Smc3AvailableTariffsResultEntity', tariffs: Array<{ __typename?: 'Smc3TariffEntity', tariffName: string, effectiveDates: Array<string> }>, failure?: { __typename?: 'Smc3ConnectionFailureEntity', code: ExternalRatingErrorCode, providerCode?: string | null, providerMessage?: string | null, retryable: boolean, retryAfter?: any | null } | null } };

export type Smc3ConnectionFailureFragment = { __typename?: 'Smc3ConnectionFailureEntity', code: ExternalRatingErrorCode, providerCode?: string | null, providerMessage?: string | null, retryable: boolean, retryAfter?: any | null };

export type Smc3SettingsFragment = { __typename?: 'Smc3SettingsEntity', hasCredentials: boolean, isEnabled: boolean, environment?: Smc3Environment | null, defaultTariffName?: string | null, pinnedTariffEffectiveDate?: string | null, version?: string | null, diagnostics?: { __typename?: 'Smc3DiagnosticsEntity', lastSuccessAt?: any | null, lastErrorCode?: ExternalRatingErrorCode | null, lastErrorAt?: any | null } | null };

export type Smc3SettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type Smc3SettingsQuery = { __typename?: 'Query', smc3Settings: { __typename?: 'Smc3SettingsEntity', hasCredentials: boolean, isEnabled: boolean, environment?: Smc3Environment | null, defaultTariffName?: string | null, pinnedTariffEffectiveDate?: string | null, version?: string | null, diagnostics?: { __typename?: 'Smc3DiagnosticsEntity', lastSuccessAt?: any | null, lastErrorCode?: ExternalRatingErrorCode | null, lastErrorAt?: any | null } | null } };

export type TestSmc3ConnectionMutationVariables = Exact<{ [key: string]: never; }>;


export type TestSmc3ConnectionMutation = { __typename?: 'Mutation', testSmc3Connection: { __typename?: 'Smc3ConnectionTestResultEntity', connected: boolean, failure?: { __typename?: 'Smc3ConnectionFailureEntity', code: ExternalRatingErrorCode, providerCode?: string | null, providerMessage?: string | null, retryable: boolean, retryAfter?: any | null } | null } };

export type TestSmc3RateMutationVariables = Exact<{
  input: TestSmc3RateInput;
}>;


export type TestSmc3RateMutation = { __typename?: 'Mutation', testSmc3Rate: { __typename?: 'Smc3TestRateResultEntity', finalCents?: number | null, tariffName?: string | null, tariffEffectiveDate?: string | null, failure?: { __typename?: 'Smc3ConnectionFailureEntity', code: ExternalRatingErrorCode, providerCode?: string | null, providerMessage?: string | null, retryable: boolean, retryAfter?: any | null } | null } };

export type AddLineItemsToSettlementBillsMutationVariables = Exact<{
  addLineItemsToSettlementBillsInput: AddLineItemsToSettlementBillsInput;
}>;


export type AddLineItemsToSettlementBillsMutation = { __typename?: 'Mutation', addLineItemsToSettlementBills: { __typename: 'AddLineItemsToSettlementBillsSuccessOutput', driverSettlementBills: Array<{ __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, billStartDate?: any | null, billEndDate?: any | null, settlementDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string } }> } | { __typename: 'MutationErrorOutput', message: string } };

export type CreateSettlementAdjustmentMutationVariables = Exact<{
  settlementAdjustmentCreateInput: SettlementAdjustmentCreateInput;
}>;


export type CreateSettlementAdjustmentMutation = { __typename?: 'Mutation', createSettlementAdjustment: { __typename: 'CreateOrUpdateSettlementAdjustmentSuccessOutput', settlementAdjustment: { __typename?: 'SettlementAdjustmentEntity', uuid: string, adjustmentType: SettlementAdjustmentType, name: string, flatRate?: number | null, percentageDecimalRate?: number | null, totalDollars: any } } | { __typename: 'MutationErrorOutput', message: string } };

export type DriverSettlementBillByUuidV2QueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DriverSettlementBillByUuidV2Query = { __typename?: 'Query', driverSettlementBill: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, snapshot?: any | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, settlementAdjustments: Array<{ __typename?: 'SettlementAdjustmentEntity', uuid: string, adjustmentType: SettlementAdjustmentType, name: string, flatRate?: number | null, percentageDecimalRate?: number | null, totalDollars: any }>, paymentInformation: { __typename?: 'DriverSettlementPaymentEntity', eligiblePay: any, netAdjustments: any, finalPay: any }, settlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, driver: { __typename?: 'DriverEntity', uuid: string, driverType?: DriverType | null, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, settlementDate?: any | null, finalizedDate?: any | null } | null, shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', uuid: string, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, completedAt?: any | null } }> } }> } };

export type DriverSettlementBillSummaryV2Fragment = { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, payPeriod: string, settlementDate?: any | null, finalizedDate?: any | null, snapshotExists: boolean, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, paymentInformation: { __typename?: 'DriverSettlementPaymentEntity', eligiblePay: any, netAdjustments: any, finalPay: any } };

export type DriverSettlementBillV2Fragment = { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, createdAt: any, billStartDate?: any | null, billEndDate?: any | null, payPeriod: string, settlementDate?: any | null, totalDriverPayoutPreDeduction?: number | null, snapshot?: any | null, finalizedDate?: any | null, driver: { __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, settlementAdjustments: Array<{ __typename?: 'SettlementAdjustmentEntity', uuid: string, adjustmentType: SettlementAdjustmentType, name: string, flatRate?: number | null, percentageDecimalRate?: number | null, totalDollars: any }>, paymentInformation: { __typename?: 'DriverSettlementPaymentEntity', eligiblePay: any, netAdjustments: any, finalPay: any }, settlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, driver: { __typename?: 'DriverEntity', uuid: string, driverType?: DriverType | null, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, settlementDate?: any | null, finalizedDate?: any | null } | null, shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', uuid: string, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, completedAt?: any | null } }> } }> };

export type DriverSettlementBillExportPdfMutationVariables = Exact<{
  driverSettlementBillExportPdfInput: DriverSettlementBillExportPdfInput;
}>;


export type DriverSettlementBillExportPdfMutation = { __typename?: 'Mutation', driverSettlementBillExportPdf: { __typename: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type DriverSettlementBillExportZipMutationVariables = Exact<{
  input: DriverSettlementBillExportPdfInput;
}>;


export type DriverSettlementBillExportZipMutation = { __typename?: 'Mutation', driverSettlementBillExportZip: { __typename: 'ReportFileOutput', url?: string | null, fileName?: string | null, errors?: Array<string> | null } };

export type FinalizeSettlementBillsMutationVariables = Exact<{
  finalizeSettlementBillsInput: FinalizeSettlementBillsInput;
}>;


export type FinalizeSettlementBillsMutation = { __typename?: 'Mutation', finalizeSettlementBills: { __typename: 'FinalizeSettlementBillsSuccessOutput', results: Array<{ __typename?: 'FinalizeSettlementBillResult', error?: string | null, bill: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null } }> } | { __typename: 'MutationErrorOutput', message: string } };

export type SettlementBillLineItemWithCostsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SettlementBillLineItemWithCostsQuery = { __typename?: 'Query', settlementBillLineItem: { __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null } | null } | null } };

export type RemoveLineItemsFromSettlementBillMutationVariables = Exact<{
  removeLineItemsFromSettlementBillInput: RemoveLineItemsFromSettlementBillInput;
}>;


export type RemoveLineItemsFromSettlementBillMutation = { __typename?: 'Mutation', removeLineItemsFromSettlementBill: { __typename: 'MutationErrorOutput', message: string } | { __typename: 'RemoveLineItemsFromSettlementBillSuccessOutput', settlementBillLineItemsCount: number } };

export type RemoveSettlementAdjustmentMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type RemoveSettlementAdjustmentMutation = { __typename?: 'Mutation', removeSettlementAdjustment: { __typename?: 'SettlementAdjustmentEntity', uuid: string } };

export type SettlementAdjustmentFragment = { __typename?: 'SettlementAdjustmentEntity', uuid: string, adjustmentType: SettlementAdjustmentType, name: string, flatRate?: number | null, percentageDecimalRate?: number | null, totalDollars: any };

export type SettlementBillLineItemWithCostsFragment = { __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, tariff?: { __typename?: 'TariffEntity', uuid: string } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null } | null } | null };

export type SettlementBillLineItemFragment = { __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, driver: { __typename?: 'DriverEntity', uuid: string, driverType?: DriverType | null, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, settlementDate?: any | null, finalizedDate?: any | null } | null, shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', uuid: string, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, completedAt?: any | null } }> } };

export type GetSettlementBillLineItemsQueryVariables = Exact<{
  input: FindSettlementBillLineItemsInput;
}>;


export type GetSettlementBillLineItemsQuery = { __typename?: 'Query', settlementBillLineItems: { __typename?: 'SettlementBillLineItemConnection', totalCount?: number | null, edges: Array<{ __typename?: 'SettlementBillLineItemEdge', node: { __typename?: 'SettlementBillLineItemEntity', id: string, totalAmountUsdDollars: number, driver: { __typename?: 'DriverEntity', uuid: string, driverType?: DriverType | null, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, settlementDate?: any | null, finalizedDate?: any | null } | null, shipment: { __typename?: 'StandardShipmentEntity', order?: { __typename?: 'StandardOrderEntity', uuid: string, refNumbers: Array<string>, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null }, billingPartyContact: { __typename?: 'CustomerContactEntity', displayName: string } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, completedAt?: any | null } }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UpdateSettlementAdjustmentMutationVariables = Exact<{
  settlementAdjustmentUpdateInput: SettlementAdjustmentUpdateInput;
}>;


export type UpdateSettlementAdjustmentMutation = { __typename?: 'Mutation', updateSettlementAdjustment: { __typename: 'CreateOrUpdateSettlementAdjustmentSuccessOutput', settlementAdjustment: { __typename?: 'SettlementAdjustmentEntity', uuid: string, adjustmentType: SettlementAdjustmentType, name: string, flatRate?: number | null, percentageDecimalRate?: number | null, totalDollars: any } } | { __typename: 'MutationErrorOutput', message: string } };

export type CustomChargeFragment = { __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null };

export type OutstandingShipmentsUuidsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  isFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromBilling?: InputMaybe<Scalars['Boolean']['input']>;
  isUnfinalized?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  billingPartyContactUuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  billingPartyContactDisplayName?: InputMaybe<StringFilter>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  terminalUuid?: InputMaybe<Scalars['String']['input']>;
  originTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  destinationTerminalUuid?: InputMaybe<Scalars['String']['input']>;
  noMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stopCompletionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  stopCompletionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderUuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OutstandingShipmentsUuidsQuery = { __typename?: 'Query', outstandingShipments: { __typename?: 'ShipmentConnection', edges: Array<{ __typename?: 'ShipmentEdge', node: { __typename?: 'StandardShipmentEntity', uuid: string, order?: { __typename?: 'StandardOrderEntity', uuid: string, billingPartyContact: { __typename?: 'CustomerContactEntity', invoiceTimePeriodSplit?: TimePeriod | null, numberOfOrdersPerInvoice?: number | null, uuid: string } } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OutstandingStandardShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, status: ShipmentStatus, shipmentType: ShipmentType, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, fileType: string, preSignedGetUrl: string, type: DocumentType, customDocumentName?: string | null, notes?: string | null, name?: string | null }>, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, stopType?: StopType | null, stopIntention?: StopIntention | null, appointmentRequired: boolean, deadlineTime?: any | null, proofOfDeliverySignee?: string | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, isSpecial?: boolean | null, settlementDeductionFlatRate?: number | null, settlementDeductionName?: string | null, settlementDeductionPercentageRate?: number | null, standardStopType?: StandardStopType | null, paperworkMarkedComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, invoice?: { __typename?: 'InvoiceEntity', uuid: string, name: string, date: any, postedAt?: any | null, journalNumber: number } | null, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> };

export type ShipmentChargesFragment = { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number };

export type ShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, ordinal: number, hideFromBilling: boolean, status: ShipmentStatus, shipmentType: ShipmentType, invoice?: { __typename?: 'InvoiceEntity', uuid: string } | null, airportInfo?: { __typename?: 'AirportInfoEntity', iataCode?: string | null } | null, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery, deliveryDate?: any | null, deadlineType?: DeadlineType | null, deadlineDate?: any | null }, legs: Array<{ __typename?: 'LegEntity', uuid: string, endStop: { __typename?: 'StandardStopEntity', uuid: string, notes?: string | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, appointmentTextStatus?: AppointmentTextStatus | null, appointmentTime?: any | null, endAppointmentTime?: any | null, proofOfDeliverySignee?: string | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, completedAt?: any | null, driverCompletedAt?: any | null, createdAt: any, status: StopStatus, isSpecial?: boolean | null, paperworkMarkedComplete?: boolean | null, contactPerson?: { __typename?: 'ContactPersonEntity', phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, latitude?: number | null, longitude?: number | null, zip: string }, terminal?: { __typename?: 'TerminalEntity', name: string } | null, routeSlot?: { __typename?: 'RouteSlotEntity', route?: { __typename?: 'RouteEntity', name: string, date: any, drivers: Array<{ __typename?: 'DriverEntity', firstName: string, lastName: string }> } | null } | null }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', completedAt?: any | null }> }>, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, preSignedGetUrl: string, type: DocumentType, customDocumentName?: string | null }> };

export type StandardShipmentFreightChargeFragment = { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string } | null };

export type StandardShipmentFragment = { __typename?: 'StandardShipmentEntity', uuid: string, totalChargesAmount: number, totalAmountCents?: number | null, postedAmountCents?: number | null, shouldBillIndividually: boolean, shouldUseDimWeight: boolean, overridePackageWeight: boolean, name: string, hideFromBilling: boolean, hasSignedPOD: boolean, shipmentType: ShipmentType, status: ShipmentStatus, invoice?: { __typename?: 'InvoiceEntity', uuid: string, date: any, postedAt?: any | null, dueDate?: any | null, name: string, journalNumber: number, billToContact: { __typename?: 'CustomerContactEntity', uuid: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }>, shipmentSubscribers: Array<{ __typename?: 'ShipmentSubscriberEntity', uuid: string, email?: string | null }>, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, airportInfo?: { __typename?: 'AirportInfoEntity', uuid: string, iataCode?: string | null, terminal: string, isArchived: boolean, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } | null, fields?: { __typename?: 'StandardShipmentFieldsEntity', uuid: string, deadlineDate?: any | null, deadlineType?: DeadlineType | null, deliveryDate?: any | null, dimFactor: number, pickupOrDelivery: PickupOrDelivery, outboundMethod?: OutboundMethod | null, inboundMethod?: InboundMethod | null, type: StandardShipmentType, service?: { __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> } | null } | null, legs: Array<{ __typename?: 'LegEntity', uuid: string, miles?: number | null, endStop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, specialInstructions?: string | null, destinationAirport?: string | null, inboundDeadlineDate?: any | null, expectedOutboundDate?: any | null, outboundCarrier?: string | null, appointmentTextStatus?: AppointmentTextStatus | null, incomingCarrier?: string | null, appointmentCallStatus?: AppointmentCallStatus | null, appointmentManuallyConfirmed: boolean, appointmentStatus?: AppointmentStatus | null, deadlineTime?: any | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null, settlementDeductionName?: string | null, proofOfDeliverySignee?: string | null, appointmentTime?: any | null, arrivedAt?: any | null, completedAt?: any | null, inboundMethod?: InboundMethod | null, expectedInboundArrivalDate?: any | null, outboundMethod?: OutboundMethod | null, driverCompletedAt?: any | null, notes?: string | null, serviceDate?: any | null, status: StopStatus, appointmentRequired: boolean, endAppointmentTime?: any | null, isSpecial?: boolean | null, hideFromDispatch?: boolean | null, standardStopType?: StandardStopType | null, stopType?: StopType | null, stopIntention?: StopIntention | null, paperworkMarkedComplete?: boolean | null, failureCount?: number | null, canMarkAttemptComplete?: boolean | null, sentToAgentAt?: any | null, confirmedByAgentAt?: any | null, address: { __typename?: 'AddressEntity', preventCoordRecompute?: boolean | null, internalNotes?: string | null, iataCode?: string | null, uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, transferAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, consigneeContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, serviceDateV2?: { __typename?: 'PlainDate', iso8601: string } | null, shipperAddress?: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } | null, shipperContactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string, date: any, name: string, slots: Array<{ __typename?: 'RouteSlotEntity', uuid: string }>, drivers: Array<{ __typename?: 'DriverEntity', uuid: string, firstName: string, lastName: string, driverType?: DriverType | null, agent?: { __typename?: 'AgentFieldsEntity', uuid: string, name: string } | null }>, equipments: Array<{ __typename?: 'EquipmentEntity', uuid: string, name: string }> } | null } | null, contactPerson?: { __typename?: 'ContactPersonEntity', uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, phone?: string | null, createdAt: any } | null, terminal?: { __typename?: 'TerminalEntity', name: string, code: string, uuid: string, serviceRegionId?: string | null, isActive: boolean, address: { __typename?: 'AddressEntity', line1: string, line2?: string | null, city: string, state: string, zip: string, uuid: string, name: string, latitude?: number | null, longitude?: number | null }, startForTerminalLanes: Array<{ __typename?: 'TerminalLaneEntity', id: string, endTerminal: { __typename?: 'TerminalEntity', uuid: string, code: string, name: string } }>, agent?: { __typename?: 'AgentFieldsEntity', name: string } | null } | null, stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }, previousStopAttempts: Array<{ __typename?: 'StandardStopEntity', stopDriverMaps: Array<{ __typename?: 'StopDriverMapEntity', uuid: string, name?: string | null, enableDriverSettlement?: boolean | null, revenuePercentageRate?: number | null, revenueFlatRate?: number | null, driverPayoutFinalized: boolean, driver: { __typename?: 'DriverEntity', firstName: string, lastName: string, uuid: string, driverType?: DriverType | null, driverReferenceNumber?: string | null, defaultFuelSettlementPercentageRate?: number | null, defaultAccessorialSettlementPercentageRate?: number | null, user: { __typename?: 'UserActorEntity', name?: string | null }, defaultVehicle?: { __typename?: 'EquipmentEntity', uuid: string } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, qualifications: Array<{ __typename?: 'DriverQualificationEntity', id: string }> }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string } | null, stop: { __typename?: 'StandardStopEntity', uuid: string, completedAt?: any | null, settlementDeductionName?: string | null, settlementDeductionFlatRate?: number | null, settlementDeductionPercentageRate?: number | null } }> }> }>, packages: Array<{ __typename?: 'PackageEntity', uuid: string, class?: number | null, freightClass?: FreightClass | null, description: string, hazmat?: boolean | null, height?: number | null, length?: number | null, nmfc?: string | null, quantity: number, skuNumber?: string | null, type?: PackageType | null, weight?: number | null, width?: number | null, quantityCompletedAtStop?: number | null, reasonUncompletedAtStop?: string | null, packageSpec?: { __typename?: 'PackageSpecEntity', id: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, pieces?: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, children: Array<{ __typename?: 'PieceEntity', quantity: number, uuid: string, createdAt: any, packedPieceCount: number, referenceNumber?: string | null, additionalReferenceNumbers: Array<string>, status: PieceStatus, type?: PackageType | null, weight?: number | null, dimWeight?: number | null, length?: number | null, width?: number | null, height?: number | null, weightUnits?: WeightUnits | null, measurementUnits?: MeasurementUnits | null, damagedAt?: any | null, damagedNote?: string | null, isOverage: boolean, isShortage: boolean, isMisrouted: boolean, isUnalertedFreight: boolean, refusedAt?: any | null, refusedReason?: string | null, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string } | null, warehouse?: { __typename?: 'WarehouseEntity', uuid: string, name: string } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null }> | null }>, customCharges: Array<{ __typename?: 'CustomChargeEntity', uuid: string, rate: number, description?: string | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, authoCode?: string | null, quantity: number, billingMethod: CustomChargeBillingMethod, isAutoApplied: boolean, name: string, fuelSurchargeRate?: number | null, postedFuelSurchargeRate?: number | null, zoneBasedAccessorialChargeGroupUuid?: string | null, zoneBasedAccessorialZoneUuid?: string | null, specialAccessorialTariffZoneUuid?: string | null, specialAccessorialChargeGroupUuid?: string | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string, lessThanOrEqualToValue: number, rateUsdCents: number } | null, accessorialTemplate?: { __typename?: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename?: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null }>, freightCharge?: { __typename?: 'FreightChargeEntity', uuid: string, quantity: number, billingMethod: FreightBillingMethod, description?: string | null, authoCode?: string | null, rate: number, discountRate?: any | null, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, total: number, totalAmountCents?: number | null, postedAmountUsdCents?: number | null, fuelCharge?: { __typename?: 'FuelChargeEntity', uuid: string, surchargeRate: number, description?: string | null, authoCode?: string | null, flatRate: number, type: FuelBillingMethod, settlementFlatRate?: number | null, settlementPercentageRate?: number | null, totalAmountCents?: number | null, postedAmountUsdCents?: number | null } | null, tariff?: { __typename?: 'TariffEntity', uuid: string, billingPartyContactUuid?: string | null, tariffGroup?: { __typename?: 'TariffGroupEntity', name?: string | null, tariffGroupScope?: TariffGroupScope | null } | null, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, externalRateQuote?: { __typename?: 'ExternalRateQuoteEntity', uuid: string } | null } | null, inputForConsolidatedOrder?: { __typename?: 'StandardOrderEntity', uuid: string, name: string } | null, shipmentCharges: { __typename?: 'ShipmentChargeEntity', totalFuelCharge: number, totalCustomCharge: number, totalFreightCharge: number, totalCharge: number }, independentSettlementBillLineItems: Array<{ __typename?: 'SettlementBillLineItemEntity', id: string, settlementMode: SettlementMode, totalAmountUsdDollars: number, revenuePercentageRate?: any | null, revenueFlatRate?: number | null, driver: { __typename?: 'DriverEntity', uuid: string, user: { __typename?: 'UserActorEntity', name?: string | null } }, driverSettlementBill?: { __typename?: 'DriverSettlementBillEntity', uuid: string, name?: string | null, finalizedDate?: any | null } | null, freightCost?: { __typename?: 'FreightCostEntity', id: string, billingMethod?: FreightBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity?: number | null, rateUsdDollars?: number | null, discountRate?: any | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, tariff?: { __typename?: 'TariffEntity', uuid: string, tariffZone: { __typename?: 'TariffZoneEntity', name: string } } | null, fuelCost?: { __typename?: 'FuelCostEntity', id: string, billingMethod?: FuelBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, surchargeRate?: number | null, flatRateUsdDollars?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number } | null } | null, customCosts: Array<{ __typename?: 'CustomCostEntity', id: string, name: string, billingMethod?: CustomChargeBillingMethod | null, dependentSettlementBillingMethod?: DependentSettlementBillingMethod | null, percentageRate?: any | null, flatRateUsdDollars?: number | null, quantity: number, rateUsdDollars?: number | null, fuelSurchargeRate?: number | null, totalAmountUsdDollars?: number | null, totalAmountUsdCents: number, accessorialTemplate?: { __typename: 'AttemptsAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'PercentageAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SkidBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'SpecialAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StandardAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'StorageDaysAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'UnitBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WaitTimeAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'WeightBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | { __typename: 'ZoneBasedAccessorialEntity', uuid: string, name: string, type?: AccessorialType | null } | null, specialAccessorialMatrixItem?: { __typename?: 'SpecialAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, zoneBasedAccessorialMatrixItem?: { __typename?: 'ZoneBasedAccessorialMatrixItemEntity', uuid: string, zoneUuid: string, chargeGroupUuid: string } | null, accessorialRange?: { __typename?: 'AccessorialRangeEntity', uuid: string } | null }> }> };

export type CompletedStopNotOnRouteQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type CompletedStopNotOnRouteQuery = { __typename?: 'Query', stop: { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, notes?: string | null, specialInstructions?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, paperworkMarkedComplete?: boolean | null, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string } | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } };

export type CompletedStopNotOnRouteFragment = { __typename?: 'StandardStopEntity', uuid: string, createdAt: any, notes?: string | null, specialInstructions?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, paperworkMarkedComplete?: boolean | null, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string } | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } };

export type CompletedStopsNotOnRoutesQueryVariables = Exact<{
  date: Scalars['DateTime']['input'];
}>;


export type CompletedStopsNotOnRoutesQuery = { __typename?: 'Query', completedStopsNotOnRoutes: Array<{ __typename?: 'StandardStopEntity', uuid: string, createdAt: any, notes?: string | null, specialInstructions?: string | null, status: StopStatus, appointmentTime?: any | null, endAppointmentTime?: any | null, appointmentTextStatus?: AppointmentTextStatus | null, paperworkMarkedComplete?: boolean | null, leg?: { __typename?: 'LegEntity', shipment: { __typename?: 'StandardShipmentEntity', uuid: string, standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery }, order?: { __typename?: 'StandardOrderEntity', uuid: string, name: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', uuid: string, shipperBillOfLadingNumber?: string | null } } | null, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any, dateUploadedFor?: any | null, notes?: string | null, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, shipment?: { __typename?: 'StandardOrderEntity', uuid: string } | null, driverFormTemplate?: { __typename?: 'DriverSignableFormTemplateEntity', uuid: string, title: string, formText: string } | null }> } } | null, routeSlot?: { __typename?: 'RouteSlotEntity', uuid: string, route?: { __typename?: 'RouteEntity', uuid: string } | null } | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } }> };

export type DeleteStopAttemptMutationVariables = Exact<{
  deleteStopAttemptInput: DeleteStopAttemptInput;
}>;


export type DeleteStopAttemptMutation = { __typename?: 'Mutation', deleteStopAttempt: { __typename?: 'DeleteStopAttemptSuccessOutput', success: boolean } | { __typename?: 'MutationErrorOutput', message: string } };

export type MarkAttemptedStopAsCompleteMutationVariables = Exact<{
  stopUuid: Scalars['String']['input'];
}>;


export type MarkAttemptedStopAsCompleteMutation = { __typename?: 'Mutation', markAttemptedStopAsComplete: { __typename?: 'StandardStopEntity', uuid: string } };

export type MarkStopAsIncompleteMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type MarkStopAsIncompleteMutation = { __typename?: 'Mutation', markStopAsIncomplete: { __typename?: 'StandardStopEntity', uuid: string } };

export type StopForCompletionCheckQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type StopForCompletionCheckQuery = { __typename?: 'Query', stop: { __typename?: 'StandardStopEntity', uuid: string, leg?: { __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null }, shipment: { __typename?: 'StandardShipmentEntity', standardShipmentFields: { __typename?: 'StandardShipmentFieldsEntity', pickupOrDelivery: PickupOrDelivery } } } | null, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null, address: { __typename?: 'AddressEntity', line1: string } } };

export type AssignOutboundReferenceNumbersToStorageUnitsMutationVariables = Exact<{
  assignOutboundReferenceNumbersToStorageUnitsInput: AssignOutboundReferenceNumberToStorageUnitsInput;
}>;


export type AssignOutboundReferenceNumbersToStorageUnitsMutation = { __typename?: 'Mutation', assignOutboundReferenceNumbersToStorageUnits: { __typename?: 'AssignOutboundReferenceNumberToStorageUnitsOutput', success: boolean } };

export type CreateStorageOrderDocumentFragment = { __typename?: 'DocumentEntity', uuid: string };

export type CreateStorageOrderDocumentMutationVariables = Exact<{
  createStorageOrderDocumentInput: CreateStorageOrderDocumentInput;
}>;


export type CreateStorageOrderDocumentMutation = { __typename?: 'Mutation', createStorageOrderDocument: { __typename?: 'CreateStorageOrderDocumentOutput', document: { __typename?: 'DocumentEntity', uuid: string } } };

export type CreateStorageOrderFragment = { __typename?: 'StorageOrderEntity', uuid: string };

export type CreateStorageOrderMutationVariables = Exact<{
  createStorageOrderInput: CreateStorageOrderInput;
}>;


export type CreateStorageOrderMutation = { __typename?: 'Mutation', createStorageOrder: { __typename?: 'CreateStorageOrderOutput', storageOrder: { __typename?: 'StorageOrderEntity', uuid: string } } };

export type CreateStorageUnitMutationVariables = Exact<{
  createStorageUnitInput: CreateStorageUnitInput;
}>;


export type CreateStorageUnitMutation = { __typename?: 'Mutation', createStorageUnit: { __typename?: 'CreateStorageUnitOutput', storageUnit: { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, outboundReferenceNumber?: string | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, osdReason?: string | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, items: Array<{ __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } }> } } };

export type DeleteStorageOrderMutationVariables = Exact<{
  deleteStorageOrderInput: DeleteStorageOrderInput;
}>;


export type DeleteStorageOrderMutation = { __typename?: 'Mutation', deleteStorageOrder: { __typename?: 'DeleteStorageOrderOutput', success: boolean } };

export type DeleteStorageUnitMutationVariables = Exact<{
  deleteStorageUnitInput: DeleteStorageUnitInput;
}>;


export type DeleteStorageUnitMutation = { __typename?: 'Mutation', deleteStorageUnit: { __typename?: 'DeleteStorageUnitOutput', success: boolean } };

export type FindStorageOrderStorageUnitsFragment = { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, items: Array<{ __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null } }> };

export type StorageOrderStorageUnitsQueryVariables = Exact<{
  findStorageOrderStorageUnitsInput: FindStorageOrderStorageUnitsInput;
}>;


export type StorageOrderStorageUnitsQuery = { __typename?: 'Query', storageOrderStorageUnits: { __typename?: 'FindStorageOrderStorageUnitsOutput', storageUnits: Array<{ __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, items: Array<{ __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null } }> }> } };

export type StorageOrderDocumentFragment = { __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any };

export type StorageOrderItemFragment = { __typename?: 'ItemForStorageOrder', totalQuantity: number, unassignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } };

export type StorageOrderStorageUnitFragment = { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, outboundReferenceNumber?: string | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, osdReason?: string | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, items: Array<{ __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } }> };

export type FindStorageOrderFragment = { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, isOSD: boolean, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any }>, items: Array<{ __typename?: 'ItemForStorageOrder', totalQuantity: number, unassignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } }>, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type StorageOrderQueryVariables = Exact<{
  findStorageOrderInput: FindStorageOrderInput;
  storageUnitsInput?: InputMaybe<StorageUnitsInput>;
}>;


export type StorageOrderQuery = { __typename?: 'Query', storageOrder: { __typename?: 'FindStorageOrderOutput', storageOrder: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, isOSD: boolean, storageUnits: Array<{ __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, outboundReferenceNumber?: string | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, osdReason?: string | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null, items: Array<{ __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } }> }>, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, documents: Array<{ __typename?: 'DocumentEntity', uuid: string, fileName: string, bucket: string, region: string, key: string, uploadedAt?: any | null, fileType: string, isDeleted: boolean, preSignedGetUrl: string, name?: string | null, type: DocumentType, customDocumentName?: string | null, pageNumber?: number | null, createdAt: any }>, items: Array<{ __typename?: 'ItemForStorageOrder', totalQuantity: number, unassignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, description?: string | null, sku: string, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure }, secondaryUOM?: { __typename?: 'InventorySecondaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } }>, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } } };

export type StorageUnitItemFragment = { __typename?: 'ItemForStorageUnit', assignedQuantity: number, item: { __typename?: 'ItemEntity', uuid: string, sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } };

export type StorageOrderFragment = { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, isOSD: boolean, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

type StorageOrderContact_CustomerContactEntity_Fragment = { __typename?: 'CustomerContactEntity', uuid: string, displayName: string };

type StorageOrderContact_ThirdPartyContactEntity_Fragment = { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string };

export type StorageOrderContactFragment = StorageOrderContact_CustomerContactEntity_Fragment | StorageOrderContact_ThirdPartyContactEntity_Fragment;

export type StorageOrdersQueryVariables = Exact<{
  findStorageOrdersInput: FindStorageOrdersInput;
}>;


export type StorageOrdersQuery = { __typename?: 'Query', storageOrders: { __typename?: 'FindStorageOrdersOutput', storageOrderConnection: { __typename?: 'StorageOrderConnection', totalCount?: number | null, edges: Array<{ __typename?: 'StorageOrderEdge', node: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, purchaseOrderNumber?: string | null, carrier?: string | null, trackingNumber?: string | null, supplierCompanyName?: string | null, lotNumber?: string | null, consigneeName?: string | null, notes?: string | null, pickupDate?: any | null, expectedAt?: any | null, arrivedAt?: any | null, isOSD: boolean, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type FindStorageUnitsForPicklistFragment = { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, markedOnHandAt?: any | null, markedOsdAt?: any | null, pickedAt?: any | null, itemUOM?: UnitOfMeasure | null, sku?: string | null, storageOrder?: { __typename?: 'StorageOrderEntity', referenceNumber: string, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null };

export type StorageUnitsForPicklistQueryVariables = Exact<{
  findStorageUnitsInput: FindStorageUnitsInput;
}>;


export type StorageUnitsForPicklistQuery = { __typename?: 'Query', storageUnits: { __typename?: 'FindStorageUnitsOutput', storageUnitConnection: { __typename?: 'StorageUnitConnection', totalCount?: number | null, edges: Array<{ __typename?: 'StorageUnitEdge', node: { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, markedOnHandAt?: any | null, markedOsdAt?: any | null, pickedAt?: any | null, itemUOM?: UnitOfMeasure | null, sku?: string | null, storageOrder?: { __typename?: 'StorageOrderEntity', referenceNumber: string, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type FindStorageUnitsFragment = { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, outboundReferenceNumber?: string | null, billed?: boolean | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, currentBillableDays: number, numberOfDaysInStorage: number, itemUOM?: UnitOfMeasure | null, sku?: string | null, itemDescription?: string | null, storageOrder?: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null };

export type StorageUnitsQueryVariables = Exact<{
  findStorageUnitsInput: FindStorageUnitsInput;
}>;


export type StorageUnitsQuery = { __typename?: 'Query', storageUnits: { __typename?: 'FindStorageUnitsOutput', storageUnitConnection: { __typename?: 'StorageUnitConnection', totalCount?: number | null, edges: Array<{ __typename?: 'StorageUnitEdge', node: { __typename?: 'StorageUnitEntity', uuid: string, name: string, unitOfMeasure: UnitOfMeasure, outboundReferenceNumber?: string | null, billed?: boolean | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, currentBillableDays: number, numberOfDaysInStorage: number, itemUOM?: UnitOfMeasure | null, sku?: string | null, itemDescription?: string | null, storageOrder?: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string } } | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } };

export type GenerateStorageOrderPreSignedPutUrlMutationVariables = Exact<{
  generateStorageOrderPreSignedPutUrlInput: GenerateStorageOrderPreSignedPutUrlInput;
}>;


export type GenerateStorageOrderPreSignedPutUrlMutation = { __typename?: 'Mutation', generateStorageOrderPreSignedPutUrl: { __typename?: 'GenerateStorageOrderPreSignedPutUrlOutput', preSignedPutUrl: string } };

export type ImportStorageOrdersFromCsvMutationVariables = Exact<{
  importStorageOrdersFromCsvInput: ImportStorageOrdersFromCsvInput;
}>;


export type ImportStorageOrdersFromCsvMutation = { __typename?: 'Mutation', importStorageOrdersFromCSV: { __typename?: 'ImportStorageOrdersFromCsvOutput', errors?: Array<string> | null, storageOrders: Array<{ __typename?: 'StorageOrderEntity', uuid: string }> } };

export type UpsertItemGroupMutationVariables = Exact<{
  upsertItemGroupInput: UpsertItemGroupInput;
}>;


export type UpsertItemGroupMutation = { __typename?: 'Mutation', upsertItemGroup?: { __typename?: 'ItemGroupEntity', uuid: string, storageUnit?: { __typename?: 'StorageUnitEntity', uuid: string } | null } | null };

export type FindItemGroupsFragment = { __typename?: 'ItemGroupEntity', uuid: string, quantity: number, pickedAt?: any | null, storageUnit?: { __typename?: 'StorageUnitEntity', uuid: string, name: string, outboundReferenceNumber?: string | null, billed?: boolean | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, currentBillableDays: number, numberOfDaysInStorage: number, unitOfMeasure: UnitOfMeasure, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, osdReason?: string | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null } | null, storageOrder: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, arrivedAt?: any | null, consigneeName?: string | null, supplierCompanyName?: string | null, purchaseOrderNumber?: string | null, lotNumber?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } }, item: { __typename?: 'ItemEntity', sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } };

export type ItemGroupsQueryVariables = Exact<{
  findItemGroupsInput: FindItemGroupsInput;
}>;


export type ItemGroupsQuery = { __typename?: 'Query', itemGroups: { __typename?: 'ItemGroupConnection', totalCount: number, edges: Array<{ __typename?: 'ItemGroupEdge', node: { __typename?: 'ItemGroupEntity', uuid: string, quantity: number, pickedAt?: any | null, storageUnit?: { __typename?: 'StorageUnitEntity', uuid: string, name: string, outboundReferenceNumber?: string | null, billed?: boolean | null, markedOnHandAt?: any | null, markedOsdAt?: any | null, inventoryLastVerifiedAt?: any | null, pickedAt?: any | null, currentBillableDays: number, numberOfDaysInStorage: number, unitOfMeasure: UnitOfMeasure, weight?: any | null, length?: any | null, width?: any | null, height?: any | null, osdReason?: string | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string, name: string } | null } | null, storageOrder: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, arrivedAt?: any | null, consigneeName?: string | null, supplierCompanyName?: string | null, purchaseOrderNumber?: string | null, lotNumber?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } }, item: { __typename?: 'ItemEntity', sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', uuid: string, unitOfMeasure: UnitOfMeasure } } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type MarkStorageUnitAsBilledMutationVariables = Exact<{
  markStorageUnitAsBilledInput: MarkStorageUnitAsBilledInput;
}>;


export type MarkStorageUnitAsBilledMutation = { __typename?: 'Mutation', markStorageUnitAsBilled: { __typename?: 'MarkStorageUnitAsBilledOutput', success: boolean } };

export type MarkStorageUnitAsOsdMutationVariables = Exact<{
  markStorageUnitAsOsdInput: MarkStorageUnitAsOsdInput;
}>;


export type MarkStorageUnitAsOsdMutation = { __typename?: 'Mutation', markStorageUnitAsOsd: { __typename?: 'MarkStorageUnitAsOsdOutput', success: boolean } };

export type RemoveStorageUnitOsdMutationVariables = Exact<{
  removeStorageUnitOsdInput: RemoveStorageUnitOsdInput;
}>;


export type RemoveStorageUnitOsdMutation = { __typename?: 'Mutation', removeStorageUnitOsd: { __typename?: 'RemoveStorageUnitOsdOutput', success: boolean } };

export type SetStorageOrderItemQuantityMutationVariables = Exact<{
  setStorageOrderItemQuantityInput: SetStorageOrderItemQuantityInput;
}>;


export type SetStorageOrderItemQuantityMutation = { __typename?: 'Mutation', setStorageOrderItemQuantity: { __typename?: 'StorageOrderEntity', uuid: string } };

export type UnassignInventoryItemsMutationVariables = Exact<{
  unassignInventoryItemsInput: UnassignInventoryItemsInput;
}>;


export type UnassignInventoryItemsMutation = { __typename?: 'Mutation', unassignInventoryItems: { __typename?: 'UnassignInventoryItemsOutput', success: boolean } };

export type UpdateStorageOrderFragment = { __typename?: 'StorageOrderEntity', uuid: string };

export type UpdateStorageOrderMutationVariables = Exact<{
  updateStorageOrderInput: UpdateStorageOrderInput;
}>;


export type UpdateStorageOrderMutation = { __typename?: 'Mutation', updateStorageOrder: { __typename?: 'UpdateStorageOrderOutput', storageOrder: { __typename?: 'StorageOrderEntity', uuid: string } } };

export type UpdateStorageUnitFragment = { __typename?: 'StorageUnitEntity', uuid: string };

export type UpdateStorageUnitMutationVariables = Exact<{
  updateStorageUnitInput: UpdateStorageUnitInput;
}>;


export type UpdateStorageUnitMutation = { __typename?: 'Mutation', updateStorageUnit: { __typename?: 'UpdateStorageUnitOutput', storageUnit: { __typename?: 'StorageUnitEntity', uuid: string } } };

export type UpsertPicklistMutationVariables = Exact<{
  upsertPicklistInput: UpsertPicklistInput;
}>;


export type UpsertPicklistMutation = { __typename?: 'Mutation', upsertPicklist: { __typename?: 'UpsertPicklistOutput', error?: string | null, picklist?: { __typename?: 'PicklistEntity', id: string, date: any, outboundReferenceNumber?: string | null, picklistItemGroups: Array<{ __typename?: 'PicklistItemGroupEntity', id: string, pickedQuantity: number, pickedStatus: PickedStatus, itemGroup: { __typename?: 'ItemGroupEntity', uuid: string, quantity: number, item: { __typename?: 'ItemEntity', sku: string, description?: string | null, primaryUOM: { __typename?: 'InventoryPrimaryUnitOfMeasureEntity', unitOfMeasure: UnitOfMeasure } }, storageUnit?: { __typename?: 'StorageUnitEntity', name: string, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', name: string } | null, storageOrder?: { __typename?: 'StorageOrderEntity', uuid: string, referenceNumber: string, supplierCompanyName?: string | null, purchaseOrderNumber?: string | null, lotNumber?: string | null, contact: { __typename?: 'CustomerContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null } | { __typename?: 'ThirdPartyContactEntity', uuid: string, displayName: string, company: { __typename?: 'CompanyEntity', uuid: string }, defaultAddress?: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string } | null }, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } } | null } | null } }> } | null } };

export type TagFragment = { __typename?: 'TagEntity', uuid: string, value: string, color?: string | null };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', getTags: Array<{ __typename?: 'TagEntity', uuid: string, value: string, color?: string | null }> };

export type CreateTariffLocationMutationVariables = Exact<{
  createTariffLocationInput: CreateTariffLocationInput;
}>;


export type CreateTariffLocationMutation = { __typename?: 'Mutation', createTariffLocation: { __typename?: 'CreateTariffLocationOutput', tariffLocation: { __typename?: 'TariffLocationEntity', uuid: string } } };

export type CreateTariffZoneMutationVariables = Exact<{
  tariffZoneCreateInput: TariffZoneCreateInput;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateTariffZoneMutation = { __typename?: 'Mutation', createTariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType } };

export type DeleteTariffLocationMutationVariables = Exact<{
  deleteTariffLocationInput: DeleteTariffLocationInput;
}>;


export type DeleteTariffLocationMutation = { __typename?: 'Mutation', deleteTariffLocation: { __typename?: 'DeleteTariffLocationOutput', tariffLocation: { __typename?: 'TariffLocationEntity', uuid: string } } };

export type DeleteTariffZoneMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteTariffZoneMutation = { __typename?: 'Mutation', deleteTariffZone: { __typename?: 'TariffZoneEntity', uuid: string } };

export type FindTariffZoneByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type FindTariffZoneByUuidQuery = { __typename?: 'Query', findTariffZoneByUuidOrThrow: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }>, terminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null, destinationTerminal?: { __typename?: 'TerminalEntity', uuid: string, name: string } | null } };

export type ShallowTariffZoneFragment = { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType };

export type TariffLocationFragment = { __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null };

export type TariffZoneFragment = { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, mileRangeStart?: number | null, mileRangeEnd?: number | null, billingPartyContactUuid?: string | null, locations: Array<{ __typename?: 'TariffLocationEntity', uuid: string, city?: string | null, zipcode?: string | null }> };

export type TariffZonesQueryVariables = Exact<{
  tariffZoneType?: InputMaybe<TariffZoneType>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  tariffZoneLocationType?: InputMaybe<TariffZoneLocationType>;
  defaultToGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  excludeLineHaulTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
  excludeMileBasedTariffZones?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TariffZonesQuery = { __typename?: 'Query', tariffZones: Array<{ __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType, lineHaulLane?: { __typename?: 'LineHaulLaneEntity', isActive: boolean } | null }> };

export type UpdateTariffZoneMutationVariables = Exact<{
  tariffZoneUpdateInput: TariffZoneUpdateInput;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTariffZoneMutation = { __typename?: 'Mutation', updateTariffZone: { __typename?: 'TariffZoneEntity', uuid: string, name: string, type: TariffZoneType } };

export type ServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ServicesQuery = { __typename?: 'Query', services: Array<{ __typename?: 'ServiceEntity', uuid: string, name: string, createdAt: any, updatedAt: any, timeInMinutes?: number | null, useApptInRouteOptimization: boolean, markOrdersAsSpecial: boolean, defaultAppointmentStartTime?: any | null, defaultAppointmentEndTime?: any | null, defaultStartNow: boolean, defaultInboundStopType?: StopType | null, defaultOutboundStopType?: StopType | null, defaultPickupPadding?: any | null, defaultDeliveryPadding?: any | null, defaultTotalDuration?: any | null, defaultIsLineHaul: boolean, calculateInboundFreightCharges: boolean, calculateOutboundFreightCharges: boolean, calculateLineHaulFreightCharges: boolean, defaultFulfillmentType?: FulfillmentType | null, isActive: boolean, isExposedToCustomers: boolean, serviceAvailabilityDates: Array<{ __typename?: 'ServiceAvailabilityDateEntity', id: string, dayCategory: SpecialDayOfWeek, enabled: boolean, start: { __typename?: 'PlainTime', hour: number, minute: number }, end: { __typename?: 'PlainTime', hour: number, minute: number } }> }> };

export type TariffGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  contactUuid?: InputMaybe<Scalars['String']['input']>;
  serviceUuid?: InputMaybe<Scalars['String']['input']>;
  tariffGroupType?: InputMaybe<TariffGroupType>;
  excludeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  includeCustomerUsage?: Scalars['Boolean']['input'];
}>;


export type TariffGroupsQuery = { __typename?: 'Query', tariffGroupsPaginated: { __typename?: 'TariffGroupConnection', totalCount?: number | null, edges: Array<{ __typename?: 'TariffGroupEdge', node: { __typename?: 'TariffGroupEntity', uuid: string, name?: string | null, tariffGroupScope?: TariffGroupScope | null, tariffGroupType: TariffGroupType, startDate?: any | null, endDate?: any | null, rateMultiplier?: number | null, totalContactsToServicesMappings: number, firstTariff?: { __typename?: 'TariffEntity', tariffType: TariffType, rateType: RateType, tariffZone: { __typename?: 'TariffZoneEntity', type: TariffZoneType } } | null, contactToServicesMappings: Array<{ __typename?: 'ContactToServicesTariffGroupMappingEntity', contact: { __typename?: 'CustomerContactEntity', displayName: string } | { __typename?: 'ThirdPartyContactEntity', displayName: string } }>, customerUsage?: { __typename?: 'TariffGroupCustomerUsageEntity', totalDirectCustomers: number, companyDefaultCustomerCount?: number | null, previewCustomers: Array<{ __typename?: 'TariffGroupCustomerPreviewEntity', uuid: string, displayName: string }> } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type ShipmentsByPhoneOrReferenceNumberQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  companyUuid: Scalars['String']['input'];
}>;


export type ShipmentsByPhoneOrReferenceNumberQuery = { __typename?: 'Query', shipmentsByPhoneOrReferenceNumber: Array<{ __typename?: 'StandardShipmentEntity', uuid: string, status: ShipmentStatus, order?: { __typename?: 'StandardOrderEntity', uuid: string, standardOrderFields: { __typename?: 'StandardOrderFieldsEntity', shipperBillOfLadingNumber?: string | null } } | null, legs: Array<{ __typename?: 'LegEntity', endStop: { __typename?: 'StandardStopEntity', stopType?: StopType | null, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null } } }> }> };

export type BundleChildrenQueryVariables = Exact<{
  uuids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BundleChildrenQuery = { __typename?: 'Query', piecesByUuids: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, children: Array<{ __typename?: 'PieceEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus }> }> };

export type CancelPackingPendencyMutationVariables = Exact<{
  input: CancelPackingPendencyInput;
}>;


export type CancelPackingPendencyMutation = { __typename?: 'Mutation', cancelPackingPendency: { __typename?: 'CancelPackingPendencyOutput', packingPendency: { __typename?: 'PackingPendencyEntity', uuid: string, status: PackingPendencyStatus } } };

export type CreatePackingPendencyMutationVariables = Exact<{
  input: CreatePackingPendencyInput;
}>;


export type CreatePackingPendencyMutation = { __typename?: 'Mutation', createPackingPendency: { __typename?: 'CreatePackingPendencyOutput', packingPendency: { __typename?: 'PackingPendencyEntity', uuid: string, status: PackingPendencyStatus } } };

export type PackPiecesMutationVariables = Exact<{
  input: PackPiecesInput;
}>;


export type PackPiecesMutation = { __typename?: 'Mutation', packPieces: { __typename?: 'PieceEntity', uuid: string, type?: PackageType | null, quantity: number, referenceNumber?: string | null } };

export type PackingPendenciesQueryVariables = Exact<{
  input: FindPackingPendenciesInput;
}>;


export type PackingPendenciesQuery = { __typename?: 'Query', packingPendencies: { __typename?: 'FindPackingPendenciesOutput', packingPendencies: Array<{ __typename?: 'PackingPendencyEntity', uuid: string, kind: PackingPendencyKind, status: PackingPendencyStatus, note?: string | null, createdAt: any, assignedWarehouseEmployee?: { __typename?: 'WarehouseEmployeeEntity', uuid: string, firstName: string, lastName: string } | null, order?: { __typename?: 'PackingPendencyOrderEntity', uuid: string, name: string } | null, pieces: Array<{ __typename?: 'PieceEntity', uuid: string }> }> } };

export type PackingPiecesQueryVariables = Exact<{
  input: PackingPiecesInput;
}>;


export type PackingPiecesQuery = { __typename?: 'Query', packingPieces: { __typename?: 'PackingPiecesOutput', hasMorePackages: boolean, pieces: Array<{ __typename?: 'PieceListEntity', uuid: string, referenceNumber?: string | null, status: PieceStatus, markedOnHandAt?: any | null, createdAt: any, orderUuid?: string | null, orderName?: string | null, packageUuid?: string | null, packageName?: string | null, packageOrderUuid?: string | null, packageOrderName?: string | null, packedPieceCount: number, hawb?: string | null, mawb?: string | null, terminalUuid?: string | null, terminalName?: string | null, warehouseLocationUuid?: string | null, warehouseLocationName?: string | null, warehouseUuid?: string | null, warehouseName?: string | null, customerUuid?: string | null, customerName?: string | null, isUnalertedFreight: boolean, dwellStatus?: DwellStatus | null, effectiveDwellThresholdDays?: number | null, daysOverDwellThreshold?: number | null }> } };

export type UnpackPiecesMutationVariables = Exact<{
  input: UnpackPiecesInput;
}>;


export type UnpackPiecesMutation = { __typename?: 'Mutation', unpackPieces: { __typename?: 'UnpackPiecesOutput', unpackedParentCount: number, restoredPieceCount: number } };

export type DockScanReportQueryVariables = Exact<{
  dockScanReportInput: DockScanReportInput;
}>;


export type DockScanReportQuery = { __typename?: 'Query', dockScanReport: { __typename?: 'DockScanReportOutput', timeZone: string, rows: Array<{ __typename?: 'DockScanReportRow', scanUuid: string, contactName?: string | null, serviceDate?: any | null, scannedAt: any, receivedAt: any, shipperBillOfLadingNumber?: string | null, masterAirwayBillOfLadingNumber?: string | null, pieceName?: string | null, barcode: string, consigneeName?: string | null, osdReason?: string | null, piecesOnHand: number, piecesExpected: number, terminalCode?: string | null, scanType: ScanType, pieceMarkedOnHandOrdinal?: number | null }> } };

export type CreateWarehouseLocationFragment = { __typename?: 'WarehouseLocationEntity', uuid: string };

export type CreateWarehouseLocationMutationVariables = Exact<{
  createWarehouseLocationInput: CreateWarehouseLocationInput;
}>;


export type CreateWarehouseLocationMutation = { __typename?: 'Mutation', createWarehouseLocation: { __typename?: 'CreateWarehouseLocationOutput', errors?: Array<string> | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string } | null } };

export type DeleteUnusedWarehouseLocationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUnusedWarehouseLocationsMutation = { __typename?: 'Mutation', deleteUnusedWarehouseLocations: number };

export type DeleteWarehouseLocationMutationVariables = Exact<{
  deleteWarehouseLocationInput: DeleteWarehouseLocationInput;
}>;


export type DeleteWarehouseLocationMutation = { __typename?: 'Mutation', deleteWarehouseLocation: { __typename?: 'DeleteWarehouseLocationOutput', success: boolean, requiresSecondConfirmation: boolean, impact: { __typename?: 'DeleteWarehouseLocationImpact', piecesCount: number, packagesCount: number, inventoryItemsCount: number, storageUnitsCount: number, itemGroupsCount: number } } };

export type WarehouseLocationsLocationFragment = { __typename?: 'WarehouseLocationEntity', uuid: string, name: string, location1?: string | null, location2?: string | null, location3?: string | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string, terminal?: { __typename?: 'TerminalEntity', uuid: string, isActive: boolean } | null } };

export type WarehouseLocationsQueryVariables = Exact<{
  companyUuid?: InputMaybe<Scalars['String']['input']>;
  warehouseUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type WarehouseLocationsQuery = { __typename?: 'Query', warehouseLocations: { __typename?: 'FindWarehouseLocationsOutput', warehouseLocations: Array<{ __typename?: 'WarehouseLocationEntity', uuid: string, name: string, location1?: string | null, location2?: string | null, location3?: string | null, warehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string, terminal?: { __typename?: 'TerminalEntity', uuid: string, isActive: boolean } | null } }> } };

export type ImportWarehouseLocationsFromCsvMutationVariables = Exact<{
  importWarehouseLocationsFromCsvInput: ImportWarehouseLocationsFromCsvInput;
}>;


export type ImportWarehouseLocationsFromCsvMutation = { __typename?: 'Mutation', importWarehouseLocationsFromCsv: number };

export type ScanOrderMutationVariables = Exact<{
  scanOrderInput: ScanOrderInput;
}>;


export type ScanOrderMutation = { __typename?: 'Mutation', scanOrder: { __typename?: 'StandardOrderEntity', uuid: string } };

export type UpdateWarehouseLocationFragment = { __typename?: 'WarehouseLocationEntity', uuid: string };

export type UpdateWarehouseLocationMutationVariables = Exact<{
  updateWarehouseLocationInput: UpdateWarehouseLocationInput;
}>;


export type UpdateWarehouseLocationMutation = { __typename?: 'Mutation', updateWarehouseLocation: { __typename?: 'UpdateWarehouseLocationOutput', errors?: Array<string> | null, warehouseLocation?: { __typename?: 'WarehouseLocationEntity', uuid: string } | null } };

export type CreateWarehouseMutationVariables = Exact<{
  createWarehouseInput: CreateWarehouseInput;
}>;


export type CreateWarehouseMutation = { __typename?: 'Mutation', createWarehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type DeleteWarehouseMutationVariables = Exact<{
  warehouseUuid: Scalars['String']['input'];
}>;


export type DeleteWarehouseMutation = { __typename?: 'Mutation', deleteWarehouse: { __typename?: 'WarehouseEntity', uuid: string } };

export type ClosestWarehouseToAddressQueryVariables = Exact<{
  addressLatitude: Scalars['Float']['input'];
  addressLongitude: Scalars['Float']['input'];
}>;


export type ClosestWarehouseToAddressQuery = { __typename?: 'Query', closestWarehouseToAddress?: { __typename?: 'WarehouseEntity', name: string, uuid: string } | null };

export type MarkWarehouseAsDefaultMutationVariables = Exact<{
  warehouseUuid: Scalars['String']['input'];
}>;


export type MarkWarehouseAsDefaultMutation = { __typename?: 'Mutation', markWarehouseAsDefault: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type MyWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyWarehousesQuery = { __typename?: 'Query', me?: { __typename?: 'UserEntity', company: { __typename?: 'CompanyEntity', warehouses?: Array<{ __typename?: 'WarehouseEntity', uuid: string, name: string, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null }> | null } } | null };

export type UpdateWarehouseMutationVariables = Exact<{
  updateWarehouseInput: UpdateWarehouseInput;
}>;


export type UpdateWarehouseMutation = { __typename?: 'Mutation', updateWarehouse: { __typename?: 'WarehouseEntity', uuid: string, name: string } };

export type WarehouseQueryVariables = Exact<{
  warehouseUuid: Scalars['String']['input'];
}>;


export type WarehouseQuery = { __typename?: 'Query', warehouse?: { __typename?: 'WarehouseEntity', name: string, uuid: string, isDefault: boolean, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', uuid: string } | null } | null };

export type WarehousesQueryVariables = Exact<{
  warehousesInput: WarehousesInput;
}>;


export type WarehousesQuery = { __typename?: 'Query', warehouses?: Array<{ __typename?: 'WarehouseEntity', uuid: string, name: string, isDefault: boolean, address: { __typename?: 'AddressEntity', uuid: string, name: string, line1: string, line2?: string | null, city: string, state: string, zip: string, country: string, latitude?: number | null, longitude?: number | null, geocodeQuality?: AddressGeocodeQuality | null, standardStopType?: StandardStopType | null, driverInstructions?: string | null, receivingHoursStart?: any | null, receivingHoursEnd?: any | null, specialInstructions?: string | null }, terminal?: { __typename?: 'TerminalEntity', uuid: string, code: string, isActive: boolean } | null }> | null };

export type FindLegsQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type FindLegsQuery = { __typename?: 'Query', legs: Array<{ __typename?: 'LegEntity', uuid: string, scheduledDate?: any | null, shipment: { __typename?: 'StandardShipmentEntity', uuid: string }, endStop: { __typename?: 'StandardStopEntity', address: { __typename?: 'AddressEntity', name: string, line1: string, line2?: string | null, city: string, state: string } } }> };

export const MeRolePermissionFragmentDoc = gql`
    fragment MeRolePermission on PermissionEntity {
  permissionResource
  accessLevel
}
    `;
export const MeRoleFragmentDoc = gql`
    fragment MeRole on RoleEntity {
  uuid
  name
  permissions {
    ...MeRolePermission
  }
}
    ${MeRolePermissionFragmentDoc}`;
export const CompanyConfigurationFragmentDoc = gql`
    fragment CompanyConfiguration on CompanyConfigurationEntity {
  uuid
  showDriverSettlementInBilling
  sameDayDispatchCellHeader
  defaultStandardStopType
  defaultFuelSurchargeBillingMethod
  defaultFuelSurcharge
  defaultFuelSettlementPercentageRate
  defaultDimFactor
  enabledExternalRatingProviders
  defaultRouteStartTime
  defaultRouteLoadTimeInMinutes
  defaultRouteUnloadTimeInMinutes
  defaultGenerateAppointmentDurationInMinutes
  defaultGenerateAppointmentEarlyCushionInMinutes
  enableConsolidatedOrders
  requirePODPhotoAndName
  requirePODPhotoAndNameForPickups
  requirePODPhotoForPickups
  requireSigneeNameForPickups
  requirePODPhotoForDeliveries
  autoGroupStops
  requireDriverToConfirmStopCompletedAtTime
  requireSigneeNameForDeliveries
  autoMatchEodDocumentsToOrders
  showChargesOnCustomerPortal
  invoicePdfLogoUrl
  showManuallyConfirmedByDefault
  showHelpersColumnInDispatch
  showVehicleInDailyDispatch
  autoApplyWaitTimeMinutes
  requireReviewForEdiOrderCreation
  quoteAgentEnabled
  startingInvoiceOrdinalNumber
  useDriverNumberForDispatch
  useJournalNumberForInvoice
  packageWarehouseLocationsEnabled
  wmsEnabled
  wmsStorageOrdersEnabled
  wmsShortTermStorageEnabled
  wmsAutoMarkOnHand
  useHawbForLotLabelBarcode
  quoteContributionMarginalFromRatio
  quoteContributionProfitableFromRatio
  requireDriverToAcknowledgeRouteChange
  defaultToAccessorial
  enablePaymentMethod
  driversShouldMarkFreightAsLoaded
  showAccessorialsToDrivers
  allCapsInOrderPage
  terminalsEnabled
  lineHaulEnabled
  lineHaulBuildAheadDays
  lineHaulMobilePastWindowHours
  lineHaulMobileFutureWindowHours
  lineHaulPlanningEnabled
  driverComplianceExpiringSoonDays
  logisticsSectionEnabled
  fulfillmentTypeEnabled
  pointToPointTariffsEnabled
  recoveryTariffsEnabled
  showCompanyNameOnBillOfLadingDoc
  orderNamingScheme
  companyOrdinalStart
  minDigitsInCompanyOrdinalOrderName
  serviceLevelOptional
  showKilogramsAndCentimeters
  addOrdersToOpenInvoices
  restrictEditingOrderName
  notificationsEnabled
  defaultInvoiceDocumentsRequired
  invoiceNotes
  requireDimsToFinalizeCharges
  orderIdentifierForCoverSheet
  getDriverLocationDataFromMobile
  enableDigitalSignatureFlow
  includeHyphensInInvoiceName
  includeINVInInvoiceName
  pieceTransferableStatuses
  orderLevelOsdEnabled
  markOnHandUponPickup
  defaultPalletLength
  defaultPalletWidth
  defaultPalletHeight
  t2tDelegationEnabled
  t2tSyncEnabled
  appointmentSchedulingSlotHours
  appointmentSchedulingLeadingBufferHours
  appointmentSchedulingCutoffDays
  appointmentChangeCutoffHours
  appointmentSelfRescheduleLimit
  requireOnHandBeforeSelfScheduling
}
    `;
export const OrderFormFieldsFragmentDoc = gql`
    fragment OrderFormFields on OrderFormFieldsEntity {
  onePackageRequired
  onePackageWeightRequired
}
    `;
export const CompanyFragmentDoc = gql`
    fragment Company on CompanyEntity {
  invoiceEmail
  isCourier
  uuid
  configuration {
    ...CompanyConfiguration
  }
  phone
  quickbooksFileMappingAccessorialChargeName
  quickbooksFileMappingFuelChargeName
  quickbooksFileMappingFreightChargeName
  quickbooksDesktopAccountsReceivableId
  quickbooksFileMappingPickupChargeName
  quickbooksCompanyId
  qboFreightItemId
  qboFuelItemId
  qboLineHaulItemId
  qboDefaultIncomeAccountId
  qboDefaultTaxCodeId
  qboDefaultClassId
  freightChargeQuickbooksMappingId
  fuelChargeQuickbooksMappingId
  miscCustomChargeQuickbooksMappingId
  quickbooksDesktopCompanyId
  quickbooksDesktopDeliveryId
  quickbooksDesktopPickupId
  quickbooksDesktopTransferId
  quickbooksDesktopRecoveryId
  quickbooksDesktopLineHaulId
  quickbooksDesktopOrderChargeId
  quickbooksDesktopAccessorialId
  quickbooksDesktopFuelChargeId
  quickbooksAccessToken {
    uuid
    expiresAt
  }
  segment
  timeZone
  defaultWeightUnits
  defaultMeasurementUnits
  qbInvoiceNumberStart
  productionCompany
  name
  defaultAddress {
    uuid
    name
    line1
    line2
    city
    latitude
    longitude
    zip
    state
    country
  }
  tags {
    createdAt
    updatedAt
    color
    uuid
    value
  }
  orderNameOrdinal
  referenceNumberLabels {
    name
  }
  customDunningReportHeader
  customDunningReportFooter
  orderFormFields {
    ...OrderFormFields
  }
  useSageBusinessWorks
  blockSendingZeroDollarInvoices
  purchasedProductOfferings
  defaultInvoiceEmailSubject
  defaultNonCompanyDriverSettlementMode
}
    ${CompanyConfigurationFragmentDoc}
${OrderFormFieldsFragmentDoc}`;
export const MeFragmentDoc = gql`
    fragment Me on UserEntity {
  email
  phoneNumber
  name
  uuid
  createdAt
  reportsEmail
  useMinimizedAppointmentTime
  routeCardWidth
  numberOfStops
  redirectIsAlertedOnFirstSave
  redirectIsAlertedOnOpenOrder
  terminal {
    uuid
    code
    name
  }
  company {
    ...Company
  }
  arrangeStopsAndRoutesVertically
  seenTutorials
}
    ${CompanyFragmentDoc}`;
export const TariffChainFragmentDoc = gql`
    fragment TariffChain on TariffChainEntity {
  id
  name
  tariffGroupType
}
    `;
export const AccessorialUnionUuidOnlyFragmentDoc = gql`
    fragment AccessorialUnionUuidOnly on AccessorialUnion {
  ... on StandardAccessorialEntity {
    uuid
  }
  ... on PercentageAccessorialEntity {
    uuid
  }
  ... on WeightBasedAccessorialEntity {
    uuid
  }
  ... on ZoneBasedAccessorialEntity {
    uuid
  }
  ... on UnitBasedAccessorialEntity {
    uuid
  }
  ... on SkidBasedAccessorialEntity {
    uuid
  }
  ... on SpecialAccessorialEntity {
    uuid
  }
  ... on WaitTimeAccessorialEntity {
    uuid
  }
  ... on AttemptsAccessorialEntity {
    uuid
  }
  ... on StorageDaysAccessorialEntity {
    uuid
  }
}
    `;
export const AccessorialTerminalFragmentDoc = gql`
    fragment AccessorialTerminal on TerminalEntity {
  uuid
  name
  code
}
    `;
export const AccessorialFuelProfileFragmentDoc = gql`
    fragment AccessorialFuelProfile on FuelProfileEntity {
  uuid
  name
  startDate
  expirationDate
  billingType
  type
  company {
    uuid
  }
  contacts {
    uuid
    displayName
  }
  fuelProfileDateRanges {
    uuid
    startDate
    expirationDate
    surchargeRate
    flatRateUsdCents
  }
}
    `;
export const AccessorialRangeFragmentDoc = gql`
    fragment AccessorialRange on AccessorialRangeEntity {
  uuid
  lessThanOrEqualToValue
  rateUsdCents
}
    `;
export const ServiceFragmentDoc = gql`
    fragment Service on ServiceEntity {
  uuid
  name
  createdAt
  updatedAt
  timeInMinutes
  useApptInRouteOptimization
  markOrdersAsSpecial
  defaultAppointmentStartTime
  defaultAppointmentEndTime
  defaultStartNow
  defaultInboundStopType
  defaultOutboundStopType
  defaultPickupPadding
  defaultDeliveryPadding
  defaultTotalDuration
  defaultIsLineHaul
  calculateInboundFreightCharges
  calculateOutboundFreightCharges
  calculateLineHaulFreightCharges
  defaultFulfillmentType
  isActive
  isExposedToCustomers
  serviceAvailabilityDates {
    id
    dayCategory
    start {
      hour
      minute
    }
    end {
      hour
      minute
    }
    enabled
  }
}
    `;
export const AllAccessorialFieldsFragmentDoc = gql`
    fragment AllAccessorialFields on AccessorialUnion {
  ... on StandardAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    rate
    minimumCharge
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on PercentageAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    rate
    percentageBasis
    minimumCharge
    maximumCharge
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on UnitBasedAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    ratePerUnit
    maximumCharge
    minimumCharge
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on SkidBasedAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    ratePerSkid
    maximumCharge
    minimumCharge
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on WaitTimeAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    rate
    maximumCharge
    minimumCharge
    waitTimeChargePeriod
    waitTimeFreeMinutes
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on WeightBasedAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    ratePerHundredWeight
    maximumCharge
    minimumCharge
    accessorialRanges {
      ...AccessorialRange
    }
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      code
      id
    }
  }
  ... on ZoneBasedAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    quickbooksDesktopAccessorialId
    uuid
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    zones {
      uuid
      name
    }
    chargeGroups {
      uuid
      name
    }
    matrixItems {
      zoneUuid
      chargeGroupUuid
      uuid
      rate
    }
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on SpecialAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    specialAccessorialType
    invoiceDisplayName
    uuid
    quickbooksDesktopAccessorialId
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    serviceLevel {
      ...Service
    }
    zones {
      uuid
      name
    }
    chargeGroups(date: $specialWindowsDate) {
      uuid
      dayOfWeek
      startTime
      endTime
    }
    matrixItems(date: $specialWindowsDate) {
      zoneUuid
      chargeGroupUuid
      uuid
      rate
    }
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    tariffZoneGroup {
      id
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on AttemptsAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    uuid
    quickbooksDesktopAccessorialId
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    rate
    maximumCharge
    minimumCharge
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
  ... on StorageDaysAccessorialEntity {
    __typename
    isArchived
    isAuthoCodeRequired
    isDefaultGlobalSpecial
    invoiceDisplayName
    uuid
    quickbooksDesktopAccessorialId
    quickbooksFileMappingChargeName
    quickbooksMappingId
    percentForSettlement
    contact {
      uuid
      displayName
    }
    name
    code
    ediCode
    maximumCharge
    minimumCharge
    storageDaysFreeDays
    storageDaysExcludeWeekends
    accessorialRanges {
      ...AccessorialRange
    }
    matchingGlobalAccessorial {
      ...AccessorialUnionUuidOnly
    }
    matchingCustomerAccessorials {
      ...AccessorialUnionUuidOnly
    }
    terminal {
      ...AccessorialTerminal
    }
    fuelProfile {
      ...AccessorialFuelProfile
    }
    generalLedgerCode {
      id
      code
    }
  }
}
    ${AccessorialUnionUuidOnlyFragmentDoc}
${AccessorialTerminalFragmentDoc}
${AccessorialFuelProfileFragmentDoc}
${AccessorialRangeFragmentDoc}
${ServiceFragmentDoc}`;
export const AutoApplyAccessorialConfigFragmentDoc = gql`
    fragment AutoApplyAccessorialConfig on AutoApplyAccessorialConfigEntity {
  uuid
  accessorials {
    ...AllAccessorialFields
  }
  ruleType
  stopType
  zipCodes
  addresses {
    uuid
    name
    line1
    line2
    city
    state
    zip
    country
  }
  tariffZone {
    uuid
    name
    tariffZoneGroupId
    locations {
      uuid
      zipcode
    }
  }
  tariffZoneGroup {
    id
    name
    tariffZones {
      uuid
      locations {
        uuid
        zipcode
      }
    }
  }
  service {
    uuid
    name
  }
  terminal {
    uuid
    name
    code
  }
  tag {
    uuid
    value
  }
  contact {
    uuid
    displayName
  }
  contactsToExcludeFromRule {
    uuid
    displayName
  }
  contactsToIncludeWithRule {
    uuid
    displayName
  }
}
    ${AllAccessorialFieldsFragmentDoc}`;
export const ContactPersonFragmentDoc = gql`
    fragment ContactPerson on ContactPersonEntity {
  uuid
  firstName
  lastName
  email
  notes
  phone
  createdAt
}
    `;
export const AddressWithContactFragmentDoc = gql`
    fragment AddressWithContact on AddressEntity {
  uuid
  name
  line1
  line2
  city
  state
  zip
  country
  latitude
  longitude
  geocodeQuality
  preventCoordRecompute
  driverInstructions
  receivingHoursStart
  receivingHoursEnd
  specialInstructions
  iataCode
  associatedContact {
    ...ContactPerson
  }
}
    ${ContactPersonFragmentDoc}`;
export const GetCityAndStateOptionsFromZipcodeFragmentDoc = gql`
    fragment GetCityAndStateOptionsFromZipcode on CityAndStateOptionEntity {
  city
  state
}
    `;
export const GetZipcodeOptionsFromCityAndStateFragmentDoc = gql`
    fragment GetZipcodeOptionsFromCityAndState on ZipcodeOptionEntity {
  zipcode
}
    `;
export const DispatchAppointmentFragmentDoc = gql`
    fragment DispatchAppointment on DispatchAppointmentEntity {
  uuid
  orderUuid
  orderName
  hawb
  customerName
  stopType
  status
  committedWindowStart
  committedWindowEnd
  deliveryDate
  projectedArrival
  onRoute
  addressLine
  city
  zip
  contactName
  contactEmail
  contactPhone
  terminalName
  terminalUuid
  customerBookingLinkSentAt
  customerBookingLinkOpenedAt
}
    `;
export const AppointmentFragmentDoc = gql`
    fragment Appointment on StopEntity {
  uuid
  standardStopType
  appointmentRequired
  textResponses
  contactPerson {
    uuid
    phone
    firstName
    lastName
  }
  routeSlot {
    route {
      name
      drivers {
        firstName
        lastName
      }
    }
  }
  appointmentTime
  appointmentManuallyConfirmed
  formattedCallMessage
  endAppointmentTime
  address {
    line1
    city
    zip
  }
  terminal {
    uuid
    name
  }
  shipmentTotalWeight
  shipmentTotalVolume
  lastAppointmentTextTime
  appointmentTextStatus
  appointmentCallStatus
  contactAttemptReportedForCurrentCall
  shipmentConsigneeAddress {
    name
  }
  leg {
    shipment {
      uuid
      order {
        name
        standardOrderFields {
          shipperBillOfLadingNumber
        }
        source
        billingPartyContact {
          uuid
          displayName
        }
      }
      standardShipmentFields {
        uuid
        deliveryDate
        pickupOrDelivery
        service {
          uuid
          name
        }
      }
    }
  }
}
    `;
export const AuditReportBucketFragmentDoc = gql`
    fragment AuditReportBucket on AuditReportBucketEntity {
  startDate
  endDate
  contactUuid
  daysPastDue
  noAction
  onHand
  assigned
  partiallyComplete
  attempted
  onHold
  unfinalized
  cancelledUnfinalized
  billingIssues
  cancelledFinalized
  noChargeFinalized
  onInvoiceUnposted
  onInvoicePosted
}
    `;
export const CompletionToPaymentDurationFieldsFragmentDoc = gql`
    fragment CompletionToPaymentDurationFields on CompletionToPaymentDuration {
  meanSeconds
  medianSeconds
  p90Seconds
  countedOrders
  backwardOrders
  prior {
    medianSeconds
    countedOrders
  }
}
    `;
export const AllContactPersonFieldsFragmentDoc = gql`
    fragment AllContactPersonFields on ContactPersonEntity {
  email
  firstName
  lastName
  phone
  uuid
}
    `;
export const ContactCommunicationConfigFragmentDoc = gql`
    fragment ContactCommunicationConfig on ContactCommunicationConfigEntity {
  uuid
  active
  type
}
    `;
export const ContactForQuickbooksFragmentDoc = gql`
    fragment ContactForQuickbooks on ContactEntity {
  uuid
  displayName
  freightChargeQuickbooksMappingId
  fuelChargeQuickbooksMappingId
  miscCustomChargeQuickbooksMappingId
  quickbooksMappingId
  quickbooksFileMappingCustomerName
  quickbooksFileMappingFreightChargeName
  quickbooksFileMappingFuelChargeName
  quickbooksFileMappingPickupChargeName
  ... on CustomerContactEntity {
    unsyncedInvoiceCount
  }
}
    `;
export const TariffGroupForContactChainTableFragmentDoc = gql`
    fragment TariffGroupForContactChainTable on TariffGroupEntity {
  uuid
  name
  tariffGroupType
  startDate
  endDate
  firstTariff {
    tariffType
    rateType
    tariffZone {
      type
    }
  }
  services {
    uuid
    name
  }
}
    `;
export const ContactTariffChainFragmentDoc = gql`
    fragment ContactTariffChain on TariffChainEntity {
  id
  name
  tariffGroupType
  tariffGroups {
    ...TariffGroupForContactChainTable
  }
}
    ${TariffGroupForContactChainTableFragmentDoc}`;
export const OrganizationPackageTypeConfigFragmentDoc = gql`
    fragment OrganizationPackageTypeConfig on OrganizationPackageTypeConfigEntity {
  __typename
  id
  packageType
  isSingleHandlingUnit
}
    `;
export const TariffGroupForContactsTableFragmentDoc = gql`
    fragment TariffGroupForContactsTable on TariffGroupEntity {
  uuid
  name
  tariffGroupScope
  tariffGroupType
  startDate
  endDate
  rateMultiplier
  firstTariff {
    tariffType
    rateType
    tariffZone {
      type
    }
  }
  totalContactsToServicesMappings
  contactToServicesMappings(first: 10) {
    contact {
      uuid
      displayName
    }
    services {
      uuid
      name
    }
  }
}
    `;
export const UserContactNotificationSubscriptionFragmentDoc = gql`
    fragment UserContactNotificationSubscription on UserContactNotificationSubscriptionEntity {
  uuid
  approveOrderNotification
}
    `;
export const PieceLeafFragmentDoc = gql`
    fragment PieceLeaf on PieceEntity {
  uuid
  createdAt
  packedPieceCount
  referenceNumber
  additionalReferenceNumbers
  status
  type
  weight
  dimWeight
  length
  width
  height
  weightUnits
  measurementUnits
  damagedAt
  damagedNote
  terminal {
    uuid
    code
  }
  warehouse {
    uuid
    name
  }
  warehouseLocation {
    uuid
    name
    warehouse {
      uuid
      name
    }
  }
  isOverage
  isShortage
  isMisrouted
  isUnalertedFreight
  refusedAt
  refusedReason
}
    `;
export const PieceFragmentDoc = gql`
    fragment Piece on PieceEntity {
  ...PieceLeaf
  quantity
  children {
    ...PieceLeaf
    quantity
    children {
      ...PieceLeaf
      quantity
      children {
        ...PieceLeaf
        quantity
      }
    }
  }
}
    ${PieceLeafFragmentDoc}`;
export const PackageFragmentDoc = gql`
    fragment Package on PackageEntity {
  uuid
  packageSpec {
    id
    name
  }
  class
  freightClass
  description
  hazmat
  height
  length
  nmfc
  quantity
  skuNumber
  type
  weight
  width
  type
  quantityCompletedAtStop
  reasonUncompletedAtStop
  warehouseLocation {
    uuid
    name
  }
  pieces {
    ...Piece
  }
}
    ${PieceFragmentDoc}`;
export const AddressFragmentDoc = gql`
    fragment Address on AddressEntity {
  uuid
  name
  line1
  line2
  city
  state
  zip
  country
  latitude
  longitude
  geocodeQuality
  standardStopType
  driverInstructions
  receivingHoursStart
  receivingHoursEnd
  specialInstructions
}
    `;
export const ConsigneePortalOrderFragmentDoc = gql`
    fragment ConsigneePortalOrder on ConsigneePortalOrderEntity {
  uuid
  name
  receivedDate
  status
  notes
  companyTimezone
  shipperBillOfLadingNumber
  masterAirwayBillOfLadingNumber
  packages {
    ...Package
  }
  detailedStatus
  isRefused
  shipments {
    uuid
    deliveryDate
    appointmentTime
    endAppointmentTime
    status
    proofOfDeliverySignee
    addressUuid
    completedAtLocal {
      date {
        year
        month
        day
      }
      time {
        hour
        minute
      }
    }
    completedAtLocalTimeZone
    placeInRoute
    contactPhone
    outboundMethod
    address {
      ...Address
    }
    driverPlaceInRoute
    routeIsToday
    pickupOrDelivery
    stopType
  }
}
    ${PackageFragmentDoc}
${AddressFragmentDoc}`;
export const TariffLocationFragmentDoc = gql`
    fragment TariffLocation on TariffLocationEntity {
  uuid
  city
  zipcode
}
    `;
export const TariffZoneFragmentDoc = gql`
    fragment TariffZone on TariffZoneEntity {
  uuid
  name
  type
  mileRangeStart
  mileRangeEnd
  billingPartyContactUuid
  locations {
    ...TariffLocation
  }
}
    ${TariffLocationFragmentDoc}`;
export const LoadFreightChargeFragmentDoc = gql`
    fragment LoadFreightCharge on FreightChargeEntity {
  uuid
  billingMethod
  tariff {
    uuid
    billingPartyContactUuid
    tariffType
    maximumIncludesFuel
    tariffOverageRates {
      uuid
      name
      type
      rateUsdCents
      flatRateUsdCents
      applicableAboveAmount
      applyRateToFullAmount
    }
    tariffRanges {
      uuid
      lessThanOrEqualToValue
      rateUsdCents
    }
    rateType
    tariffZone {
      ...TariffZone
    }
    useActualWeightInCalculation
  }
  total
  rate
  description
  quantity
  externalRatingLines {
    amountCents
    freightClass
    isMinimumAdjustment
    weightLbs
  }
  fuelCharge {
    description
    surchargeRate
    flatRate
    type
    uuid
    totalAmountCents
    postedAmountUsdCents
  }
}
    ${TariffZoneFragmentDoc}`;
export const LoadCustomChargeFragmentDoc = gql`
    fragment LoadCustomCharge on CustomChargeEntity {
  uuid
  name
  zoneBasedAccessorialZoneUuid
  zoneBasedAccessorialChargeGroupUuid
  specialAccessorialTariffZoneUuid
  specialAccessorialChargeGroupUuid
  quantity
  description
  rate
  total
  customChargeBillingMethod: billingMethod
  accessorialTemplate {
    uuid
    name
    __typename
  }
}
    `;
export const CustomerPortalOrderShipmentFragmentDoc = gql`
    fragment CustomerPortalOrderShipment on ShipmentEntity {
  uuid
  name
  status
  hideFromBilling
  totalChargesAmount
  freightNeedsRate
  shipmentType
  documents {
    uuid
  }
  order {
    standardOrderFields {
      measurementUnits
      weightUnits
    }
  }
  standardShipmentFields {
    deliveryDate
    deadlineDate
    service {
      ...Service
    }
    pickupOrDelivery
  }
  freightCharge {
    ...LoadFreightCharge
  }
  customCharges {
    ...LoadCustomCharge
  }
  legs {
    uuid
    status
    endStop {
      stopType
      localTimeZone
      appointmentTime
      endAppointmentTime
      status
      proofOfDeliverySignee
      completedAt
      outboundMethod
      address {
        ...Address
      }
      routeSlot {
        ordinal
        route {
          slots {
            ordinal
            stops {
              status
              leg {
                shipment {
                  status
                }
              }
            }
          }
          date
        }
      }
      contactPerson {
        ...ContactPerson
      }
    }
  }
  consigneeAddress {
    ...Address
  }
}
    ${ServiceFragmentDoc}
${LoadFreightChargeFragmentDoc}
${LoadCustomChargeFragmentDoc}
${AddressFragmentDoc}
${ContactPersonFragmentDoc}`;
export const CustomerPortalOrderFragmentDoc = gql`
    fragment CustomerPortalOrder on OrderEntity {
  uuid
  name
  detailedStatusV2
  refusedBy
  receivedDate
  status
  osd
  notes
  externalNotes
  company {
    uuid
    segment
    timeZone
  }
  standardOrderFields {
    measurementUnits
    weightUnits
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  shipments {
    ...CustomerPortalOrderShipment
  }
  packages {
    ...Package
  }
  totalCharge
  freightNeedsRate
  shouldDisplayChargesInCustomerPortal
  customerPortalChargesVisibleFrom
  invoice {
    uuid
    status
  }
}
    ${CustomerPortalOrderShipmentFragmentDoc}
${PackageFragmentDoc}`;
export const CustomerPortalQuoteFragmentDoc = gql`
    fragment CustomerPortalQuote on QuoteEntity {
  uuid
  createdAt
  source
  number
  status
  company {
    name
  }
}
    `;
export const CustomerPortalShipmentForTableFragmentDoc = gql`
    fragment CustomerPortalShipmentForTable on ShipmentEntity {
  uuid
  shipmentType
  standardShipmentFields {
    deadlineDate
    deliveryDate
    pickupOrDelivery
  }
  legs {
    endStop {
      stopType
      uuid
      status
      appointmentTime
      endAppointmentTime
      inboundMethod
      outboundMethod
      address {
        ...Address
      }
      routeSlot {
        route {
          date
          uuid
        }
      }
    }
  }
  consigneeAddress {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const CustomerPortalOrderForTableFragmentDoc = gql`
    fragment CustomerPortalOrderForTable on OrderEntity {
  uuid
  name
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  detailedStatusV2
  refusedBy
  osd
  onHold
  isOnHand
  receivedDate
  shipments {
    ...CustomerPortalShipmentForTable
  }
  company {
    uuid
    name
  }
  contact {
    uuid
    displayName
  }
}
    ${CustomerPortalShipmentForTableFragmentDoc}`;
export const CustomerPortalOrdersFragmentDoc = gql`
    fragment CustomerPortalOrders on OrderEntity {
  uuid
  name
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  detailedStatusV2
  packages {
    ...Package
  }
  receivedDate
  osd
  status
  shipments {
    ...CustomerPortalOrderShipment
  }
  company {
    uuid
    name
  }
  contact {
    uuid
    displayName
  }
}
    ${PackageFragmentDoc}
${CustomerPortalOrderShipmentFragmentDoc}`;
export const SameDayDispatchRouteDriverCoordsFragmentDoc = gql`
    fragment SameDayDispatchRouteDriverCoords on RouteEntity {
  uuid
  drivers {
    uuid
    mobilePhoneLatitude
    mobilePhoneLongitude
    mobileCoordsLastUpdatedAt
  }
}
    `;
export const SameDayDispatchConfigFragmentDoc = gql`
    fragment SameDayDispatchConfig on SameDayDispatchConfigEntity {
  pickupAppointmentTimeThreshold
  deliveryAppointmentTimeThreshold
  isSpecialColorCode
  isNextInRouteColorCode
  isPastDeadlineColorCode
  pickupWithinTimeWindowColorCode
  deliveryWithinTimeWindowColorCode
}
    `;
export const OrderDelegationRuleFieldsFragmentDoc = gql`
    fragment OrderDelegationRuleFields on OrderDelegationRuleEntity {
  uuid
  name
  priority
  isActive
  timing
  scope
  pickupHandling
  shareEndCustomer
  offerWindowMinutes
  organizationPeerUuid
  peerCompanyName
  customerOrganizationUuid
  customerName
  terminals {
    uuid
    name
  }
  zipCodes
  orderSources
  createdAt
  updatedAt
}
    `;
export const OrganizationAddressFragmentDoc = gql`
    fragment OrganizationAddress on AddressEntity {
  uuid
  name
  line1
  line2
  city
  state
  zip
  country
  driverInstructions
}
    `;
export const OrganizationAgentTerminalFragmentDoc = gql`
    fragment OrganizationAgentTerminal on TerminalEntity {
  uuid
  name
  code
  serviceRegion {
    id
    name
  }
  address {
    uuid
    name
    line1
    line2
    city
    state
    zip
    country
    driverInstructions
  }
}
    `;
export const AddressForOrganizationFragmentDoc = gql`
    fragment AddressForOrganization on AddressEntity {
  uuid
  line1
  city
}
    `;
export const ContactPersonForOrganizationFragmentDoc = gql`
    fragment ContactPersonForOrganization on ContactPersonEntity {
  uuid
  firstName
  lastName
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on OrganizationEntity {
  isActive
  uuid
  name
  types
  referenceNumber
  email
  defaultContactPerson {
    uuid
  }
  isaId
  ediApplicationId
  ediContactCode
  stediPartnerId
  customerFields {
    defaultAddressUuid
    businessDivisionUuid
    invoiceOrOrderIdentifier
    defaultInboundEdiServiceUuid
    defaultOutboundEdiServiceUuid
    defaultInboundOutboundEdiServiceUuid
    defaultServiceUuid
    services {
      uuid
    }
    serviceGroupId
    accessorialGroupId
    showEdiReferenceNumbersOnOrderPage
    allowDriverToCompleteStopAfterAttemptWithoutReassignment
    defaultOrdinaryTariffChainId
    defaultLineHaulTariffChainId
    defaultTransferTariffChainId
    defaultRecoveryTariffChainId
    defaultPointToPointTariffChainId
    defaultFuelSurcharge
    defaultDimFactor
    defaultUseTariff
    defaultFreightBillingMethod
    defaultFreightClass
    calculateInboundFreightCharges
    calculateOutboundFreightCharges
    calculateLineHaulFreightCharges
    isPrepaidOnly
    useCustomVehicleTypes
    customerVehicleTypes {
      id
      vehicleTypeUuid
    }
    referenceNumberLabels {
      name
    }
    enableCustomerPortalOrderEntry
    enableCustomerPortalInventory
    includeInExpeditorsScorecard
    displayChargesInCustomerPortal
    customerPortalChargesVisibleFrom
    emitPieceLevelWebhooks
  }
}
    `;
export const PaginatedOrganizationFragmentDoc = gql`
    fragment PaginatedOrganization on OrganizationEntity {
  name
  uuid
  referenceNumber
  types
}
    `;
export const BookedStopResourceFragmentDoc = gql`
    fragment BookedStopResource on BookedStopResourceEntity {
  id
  name
  start {
    hour
    minute
  }
  end {
    hour
    minute
  }
  timeZone
}
    `;
export const GenerateRoutesPreviewRouteFragmentDoc = gql`
    fragment GenerateRoutesPreviewRoute on RouteGenerationPreviewEntity {
  stops {
    odometer
    eta
    stop {
      uuid
      appointmentTime
      endAppointmentTime
      isSpecial
      status
      stopType
      stopDetails {
        message
        stopDetailsStatus
      }
      shipment {
        standardShipmentFields {
          deadlineDate
          pickupOrDelivery
        }
        order {
          uuid
          weight
          service {
            uuid
          }
          standardOrderFields {
            shipperBillOfLadingNumber
          }
        }
      }
      address {
        name
        line1
        city
        zip
        latitude
        longitude
      }
    }
  }
  equipment {
    uuid
    name
    vehicleType {
      name
    }
  }
  driver {
    uuid
    firstName
    lastName
    driverReferenceNumber
  }
}
    `;
export const DispatchTableColorFragmentDoc = gql`
    fragment DispatchTableColor on DispatchTableColorEntity {
  uuid
  fields
  appointmentStartWithinMinutes
  appointmentEndWithinMinutes
  deadlineDateFilter
  hasAppointmentDate
  isSpecial
  color
  service {
    uuid
    name
  }
  active
}
    `;
export const OptimizationCompletedFieldsFragmentDoc = gql`
    fragment OptimizationCompletedFields on OptimizationCompleted {
  proposedRoutes {
    routeUuid
    stopOrder
    lateStops {
      stopUuid
      minutesLate
      serviceStartsAt
      windowEndsAt
    }
  }
  unplacedStopCount
  summary {
    proposedDistanceMiles
    proposedDurationSeconds
    currentDistanceMiles
    currentDurationSeconds
    deltaDistanceMiles
    deltaDurationSeconds
  }
}
    `;
export const RouteInfoFragmentDoc = gql`
    fragment RouteInfo on RouteInfo {
  totalStops
  totalStopsArrived
  totalStopsNotArrived
  totalStopsCompleted
  totalStopsCancelled
  totalStopsFailed
  status
  pieceCount
  totalWeight
  totalStopsSentToAgent
  totalStopsConfirmedByAgent
}
    `;
export const StopOnRouteListItemFragmentDoc = gql`
    fragment StopOnRouteListItem on StopEntity {
  __typename
  uuid
  status
  stopType
  standardStopType
  inboundMethod
  outboundMethod
  notes
  specialInstructions
  serviceDate
  completedAt
  appointmentTime
  endAppointmentTime
  isSpecial
  overrideServiceTimeInMinutes
  showDriverModifiedAt
  routeChangeAcknowledged
  leg {
    uuid
    miles
  }
  routeSlot {
    uuid
    ordinal
  }
  stopDetails {
    stopDetailsStatus
    message
  }
  cachedEta {
    arrivalTime
    finishTime
  }
  contactPerson {
    firstName
    lastName
    phone
  }
  address {
    uuid
    name
    line1
    line2
    city
    state
    zip
    country
    latitude
    longitude
  }
  shipment {
    __typename
    uuid
    totalAmountCents
    airportInfo {
      uuid
      terminal
    }
    standardShipmentFields {
      uuid
      pickupOrDelivery
      deliveryDate
      deadlineDate
      deadlineType
    }
    order {
      __typename
      uuid
      name
      detailedStatusV2
      refNumbers
      refusedBy
      hazmat
      hazmatClass
      unNumber
      hasDamage
      hasIssues
      service {
        uuid
        name
        timeInMinutes
      }
      tags {
        uuid
        value
        color
      }
      billingPartyContact {
        uuid
        displayName
        businessDivision {
          uuid
          name
        }
      }
      standardOrderFields {
        masterAirwayBillOfLadingNumber
        shipperBillOfLadingNumber
      }
      packages {
        uuid
        weight
        quantity
        length
        width
        height
      }
    }
  }
}
    `;
export const RouteListItemFragmentDoc = gql`
    fragment RouteListItem on RouteEntity {
  __typename
  uuid
  name
  startTime
  defaultStartTime
  startLoadTimeInMinutes
  endLoadTimeInMinutes
  totalDistanceInMeters
  totalTimeInSeconds
  routeSlotsUpdatedAt
  routePathUpdatedAt
  locked
  date
  productivity @include(if: $canReadIntelligenceBoard) {
    status
    hasTimeAllowances
    productivityRatio
  }
  terminal {
    uuid
  }
  routeInfo {
    ...RouteInfo
  }
  drivers {
    uuid
    firstName
    lastName
    agentId
    phoneNumber
    driverPayType @include(if: $canReadIntelligenceBoard)
    perMileRate @include(if: $canReadIntelligenceBoard)
    percentGrossRevenueRate @include(if: $canReadIntelligenceBoard)
  }
  equipments {
    uuid
    name
    type
    length
    width
    height
    weight
    measurementSystem
    vehicleType {
      uuid
      maxWeight
      maxVolume
      interiorLengthIn
      interiorWidthIn
      interiorHeightIn
    }
  }
  tags {
    uuid
    value
    color
  }
  slots {
    uuid
    stops {
      ...StopOnRouteListItem
    }
  }
}
    ${RouteInfoFragmentDoc}
${StopOnRouteListItemFragmentDoc}`;
export const RoutePathFragmentDoc = gql`
    fragment RoutePath on RoutePathEntity {
  uuid
  coordinates
  route {
    uuid
  }
}
    `;
export const VehicleTypeFragmentDoc = gql`
    fragment VehicleType on VehicleTypeEntity {
  uuid
  name
  status
  maxVolume
  maxWeight
  maxHeight
  maxWidth
  maxLength
  doorHeight
  interiorLengthIn
  interiorWidthIn
  interiorHeightIn
  capacityNotes
  specialRules
  vehicleTypePackageSpecs {
    id
    packageSpec {
      id
      name
    }
    maxQuantity
  }
}
    `;
export const TagFragmentDoc = gql`
    fragment Tag on TagEntity {
  uuid
  value
  color
}
    `;
export const ShallowPackageFragmentDoc = gql`
    fragment ShallowPackage on PackageEntity {
  uuid
  description
  weight
  quantity
  length
  width
  height
  type
  packageSpec {
    id
    name
  }
  warehouseLocation {
    name
  }
}
    `;
export const OrderPaperworkWithGroupedDocumentsFragmentDoc = gql`
    fragment OrderPaperworkWithGroupedDocuments on OrderPaperworkEntity {
  paperworkComplete
  attachedDocuments
  missingDocuments
  alerts
  proofOfDeliveryOrPickupReadyToSign
  proofOfDeliveryOrPickupSigned
  photos
  other
}
    `;
export const OrderForStopOnRouteFragmentDoc = gql`
    fragment OrderForStopOnRoute on StandardOrderEntity {
  uuid
  refusedBy
  isCollectOnDelivery
  isDoorToDoor
  orderSegmentType
  fulfillmentType
  detailedStatusV2
  hazmat
  name
  refNumbers
  dateMarkedOnHand
  startStop {
    terminal {
      name
    }
  }
  endStop {
    terminal {
      name
    }
  }
  tags {
    ...Tag
  }
  service {
    uuid
    name
    timeInMinutes
  }
  orderComments {
    comment
  }
  shipments {
    shipmentType
    uuid
    standardShipmentFields {
      pickupOrDelivery
    }
    airportInfo {
      address {
        name
      }
    }
    legs {
      endStop {
        stopType
        incomingCarrier
        address {
          name
        }
        terminal {
          name
        }
        inboundMethod
      }
    }
  }
  packages {
    ...ShallowPackage
    pieces {
      warehouseLocation {
        name
      }
    }
  }
  billingPartyContact {
    uuid
    displayName
    businessDivision {
      uuid
      name
    }
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    measurementUnits
  }
  inboundPaperwork {
    ...OrderPaperworkWithGroupedDocuments
  }
  outboundPaperwork {
    ...OrderPaperworkWithGroupedDocuments
  }
  totalCharge
}
    ${TagFragmentDoc}
${ShallowPackageFragmentDoc}
${OrderPaperworkWithGroupedDocumentsFragmentDoc}`;
export const StopOnRouteFragmentDoc = gql`
    fragment StopOnRoute on StopEntity {
  __typename
  routeSlot {
    uuid
    ordinal
    route {
      uuid
      name
    }
  }
  stopDetails {
    stopDetailsStatus
    message
  }
  stopType
  standardStopType
  inboundMethod
  outboundMethod
  notes
  isSpecial
  proofOfDeliverySignee
  status
  sentToAgentAt
  confirmedByAgentAt
  appointmentTextStatus
  specialInstructions
  paperworkMarkedComplete
  showDriverModifiedAt
  routeChangeAcknowledged
  serviceDate
  overrideServiceTimeInMinutes
  completedAt
  cachedEta {
    arrivalTime
    finishTime
  }
  contactPerson {
    firstName
    lastName
    phone
  }
  uuid
  appointmentTime
  endAppointmentTime
  leg {
    uuid
    miles
  }
  address {
    ...Address
  }
  shipment {
    uuid
    hasSignedPOD
    shipmentType
    totalAmountCents
    airportInfo {
      uuid
      terminal
    }
    standardShipmentFields {
      uuid
      deliveryDate
      pickupOrDelivery
      deadlineDate
      deadlineType
    }
    order {
      ...OrderForStopOnRoute
    }
  }
}
    ${AddressFragmentDoc}
${OrderForStopOnRouteFragmentDoc}`;
export const RouteFragmentDoc = gql`
    fragment Route on RouteEntity {
  createdAt
  date
  uuid
  defaultStartTime
  startTime
  totalTimeInSeconds
  totalDistanceInMeters
  startLoadTimeInMinutes
  endLoadTimeInMinutes
  locked
  nameManuallyChanged
  name
  numberOfRescheduled
  routeSlotsUpdatedAt
  routePathUpdatedAt
  lastDispatched
  terminal {
    uuid
  }
  routeInfo {
    ...RouteInfo
  }
  helpers {
    firstName
    lastName
    uuid
    phoneNumber
    driverReferenceNumber
  }
  equipments {
    uuid
    name
    type
    vehicleType {
      ...VehicleType
    }
  }
  tags {
    ...Tag
  }
  drivers {
    uuid
    firstName
    lastName
    phoneNumber
    driverReferenceNumber
    terminal {
      uuid
      name
    }
    agentId
    driverPayType @include(if: $canReadIntelligenceBoard)
    perMileRate @include(if: $canReadIntelligenceBoard)
    percentGrossRevenueRate @include(if: $canReadIntelligenceBoard)
  }
  slots {
    uuid
    stops {
      ...StopOnRoute
    }
  }
}
    ${RouteInfoFragmentDoc}
${VehicleTypeFragmentDoc}
${TagFragmentDoc}
${StopOnRouteFragmentDoc}`;
export const SameDayDispatchRouteSlotFragmentDoc = gql`
    fragment SameDayDispatchRouteSlot on RouteSlotEntity {
  uuid
  ordinal
  previousSlotDistanceMeters
  previousSlotDurationSeconds
  stops {
    uuid
    address {
      ...Address
    }
    appointmentTime
    arrivedAt
    completedAt
    endAppointmentTime
    notes
    isSpecial
    stopType
    leg {
      uuid
      shipment {
        uuid
        standardShipmentFields {
          uuid
          pickupOrDelivery
          deliveryDate
        }
        order {
          uuid
          secondaryRefNumber
          name
          pickedDate
          standardOrderFields {
            uuid
            shipperBillOfLadingNumber
          }
          warehouse {
            uuid
            name
          }
          service {
            ...Service
          }
        }
        customCharges {
          accessorialTemplate {
            uuid
            name
          }
        }
      }
    }
    status
    routeChangeAcknowledged
  }
}
    ${AddressFragmentDoc}
${ServiceFragmentDoc}`;
export const SameDayDispatchRouteFragmentDoc = gql`
    fragment SameDayDispatchRoute on RouteEntity {
  uuid
  nameManuallyChanged
  company {
    uuid
  }
  equipments {
    type
    name
    uuid
    samsaraVehicleId
    samsaraIsDeactivated
  }
  nextRouteSlot {
    uuid
    stops {
      uuid
    }
  }
  helpers {
    uuid
    firstName
    lastName
  }
  drivers {
    uuid
    firstName
    lastName
    mobilePhoneLatitude
    mobilePhoneLongitude
    mobileCoordsLastUpdatedAt
    defaultVehicle {
      uuid
      samsaraVehicleId
      name
    }
  }
  name
  slots {
    ...SameDayDispatchRouteSlot
  }
}
    ${SameDayDispatchRouteSlotFragmentDoc}`;
export const StopBySearchTextFragmentDoc = gql`
    fragment StopBySearchText on StopEntity {
  uuid
  status
  completedAt
  isAttempt
  shipment {
    standardShipmentFields {
      pickupOrDelivery
    }
    order {
      uuid
      name
      refNumbers
      detailedStatus
      refusedBy
      standardOrderFields {
        shipperBillOfLadingNumber
      }
    }
  }
  stopDriverMaps {
    uuid
    driver {
      uuid
      firstName
      lastName
      driverType
    }
    driverSettlementBill {
      name
      settlementDate
      finalizedDate
    }
    enableDriverSettlement
  }
}
    `;
export const StopOnRouteBySearchTextFragmentDoc = gql`
    fragment StopOnRouteBySearchText on StopEntity {
  appointmentTime
  endAppointmentTime
  status
  completedAt
  stopType
  cachedEta {
    arrivalTime
  }
  stopDetails {
    message
    stopDetailsStatus
  }
  address {
    ...Address
  }
  shipment {
    standardShipmentFields {
      deliveryDate
      pickupOrDelivery
    }
    order {
      uuid
      refusedBy
      packages {
        ...ShallowPackage
      }
      billingPartyContact {
        uuid
        displayName
      }
      standardOrderFields {
        shipperBillOfLadingNumber
      }
      service {
        uuid
        name
      }
    }
  }
  routeSlot {
    route {
      name
      date
      terminal {
        code
      }
    }
  }
}
    ${AddressFragmentDoc}
${ShallowPackageFragmentDoc}`;
export const RecurringRunHeaderFragmentDoc = gql`
    fragment RecurringRunHeader on RecurringRunHeaderEntity {
  uuid
  name
  driver {
    uuid
    firstName
    lastName
  }
  vehicleType {
    uuid
    name
  }
}
    `;
export const StopTableGroupRowFragmentDoc = gql`
    fragment StopTableGroupRow on StopTableGroupRowEntity {
  key
  label
  count
}
    `;
export const StopBaseFragmentDoc = gql`
    fragment StopBase on CachedStopBaseEntity {
  uuid
  stopType
  stopIntention
  hasPreviousAttempt
  isSpecial
  specialInstructions
  serviceDate
  serviceDateV2 {
    iso8601
  }
  serviceTimeInMinutes
  terminalUuid
  terminalName
  status
  appointmentTime
  endAppointmentTime
  appointmentScheduled
  appointmentRequired
  deadlineDate
  deliveryDate
  createdAt
  standardStopType
  totalCharge
  address {
    name
    line1
    line2
    city
    zip
    state
    routeName
    routeNameUuid
    latitude
    longitude
  }
}
    `;
export const StopFragmentDoc = gql`
    fragment Stop on CachedStopEntity {
  __typename
  stopDetails {
    message
    stopDetailsStatus
  }
  order {
    uuid
    detailedStatusV2
    refusedBy
    isDoorToDoor
    orderSegmentType
    fulfillmentType
    warehouseUuid
    businessDivisionName
    contactUuid
    contactName
    serviceUuid
    serviceName
    name
    vehicleTypeName
    refNumbers
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    receivedDate
    pickedDate
    inboundStopType
    outboundStopType
    inboundName
    outboundName
    inboundZip
    outboundZip
    inboundCity
    inboundPaperwork {
      ...OrderPaperworkWithGroupedDocuments
    }
    outboundPaperwork {
      ...OrderPaperworkWithGroupedDocuments
    }
    outboundCity
    orderComments {
      comment
    }
    tags {
      ...Tag
    }
    packages {
      weight
      length
      width
      height
      quantity
      description
    }
  }
  stop {
    ...StopBase
  }
  linkedEndStop {
    ...StopBase
  }
  otherStop {
    ...StopBase
  }
  recurringRunUuid
}
    ${OrderPaperworkWithGroupedDocumentsFragmentDoc}
${TagFragmentDoc}
${StopBaseFragmentDoc}`;
export const StopDriverMapForDriverCompletedStopsFragmentDoc = gql`
    fragment StopDriverMapForDriverCompletedStops on StopDriverMapForCompletedStopsEntity {
  driver {
    uuid
  }
  serviceDate
  stopType
  isLineHaul
  linehaulStartTerminal {
    code
  }
  linehaulEndTerminal {
    code
  }
  order {
    name
    pieceCount
    standardOrderFields {
      masterAirwayBillOfLadingNumber
      shipperBillOfLadingNumber
    }
    billingPartyContact {
      displayName
    }
    service {
      name
    }
    weight
    totalCharge
    refNumbers
    startStop {
      address {
        name
        line1
        line2
        city
        state
        zip
      }
      terminal {
        name
      }
    }
    endStop {
      address {
        name
        line1
        line2
        city
        state
        zip
      }
      terminal {
        name
      }
    }
  }
}
    `;
export const DriverCompletedStopsFragmentDoc = gql`
    fragment DriverCompletedStops on DriverCompletedStopsEntity {
  stopDriverMaps {
    ...StopDriverMapForDriverCompletedStops
  }
}
    ${StopDriverMapForDriverCompletedStopsFragmentDoc}`;
export const StopDriverMapAddressForDownloadFragmentDoc = gql`
    fragment StopDriverMapAddressForDownload on StopDriverMapAddressForDownloadEntity {
  name
  line1
  line2
  city
  state
  zip
  country
}
    `;
export const StopDriverMapForDownloadFragmentDoc = gql`
    fragment StopDriverMapForDownload on StopDriverMapForDownloadEntity {
  stopUuid
  arrivedAt
  completedAt
  stopType
  address {
    ...StopDriverMapAddressForDownload
  }
  serviceName
  driverSettlementTotalAmounts {
    totalChargesForSettlement
    totalEligibleAmountForStop
    totalDriverPayout
  }
  chargeBreakdown {
    lines {
      lineType
      label
      total
      flatRate
      percentageRate
      eligibleAmount
    }
    totalEligibleAmount
    payBasis {
      basisType
      percentageOutOf100
      flatAmount
      perMileRate
      miles
      minPay
      maxPay
      isBounded
    }
    driverPayout
  }
  shipperBillOfLadingNumber
  orderName
  billingPartyContactName
  isAttempt
  packages {
    uuid
    quantity
    weight
  }
  otherDriversOnStop {
    uuid
    firstName
    lastName
  }
  order {
    totalCharge
  }
}
    ${StopDriverMapAddressForDownloadFragmentDoc}`;
export const DriverSettlementBillForDownloadFragmentDoc = gql`
    fragment DriverSettlementBillForDownload on DriverSettlementBillForDownloadEntity {
  billUuid
  billName
  billStartDate
  billEndDate
  settlementDate
  finalizedDate
  driverFirstName
  driverLastName
  driverStationCode
  settlementDeductions {
    name
    flatRate
    percentageDecimalRate
  }
  driverStationCode
  stopDriverMaps {
    ...StopDriverMapForDownload
  }
}
    ${StopDriverMapForDownloadFragmentDoc}`;
export const SettlementDeductionFragmentDoc = gql`
    fragment SettlementDeduction on SettlementDeductionEntity {
  uuid
  adjustmentType
  name
  flatRate
  percentageDecimalRate
}
    `;
export const DriverSettlementBillFragmentDoc = gql`
    fragment DriverSettlementBill on DriverSettlementBillEntity {
  uuid
  name
  createdAt
  billStartDate
  billEndDate
  payPeriod
  settlementDate
  totalDriverPayoutPreDeduction
  driver {
    uuid
    firstName
    lastName
    user {
      name
    }
  }
  finalizedDate
  settlementDeductions {
    ...SettlementDeduction
  }
}
    ${SettlementDeductionFragmentDoc}`;
export const StopDriverMapWithDriverSettlementTotalAmountsFragmentDoc = gql`
    fragment StopDriverMapWithDriverSettlementTotalAmounts on StopDriverMapEntity {
  driverSettlementTotalAmounts {
    totalChargesForSettlement
    totalEligibleAmountForStop
    totalDriverPayout
    payBasis {
      minPay
      maxPay
      isBounded
    }
  }
}
    `;
export const StopDriverMapSummaryFragmentDoc = gql`
    fragment StopDriverMapSummary on StopDriverMapEntity {
  uuid
  name
  driver {
    uuid
    firstName
    lastName
    driverType
  }
  stop {
    uuid
    settlementDeductionName
    settlementDeductionFlatRate
    settlementDeductionPercentageRate
    stopType
    arrivedAt
    completedAt
    shipment {
      order {
        uuid
        standardOrderFields {
          shipperBillOfLadingNumber
        }
        secondaryRefNumber
        refNumbers
        name
        billingPartyContact {
          displayName
        }
      }
      standardShipmentFields {
        pickupOrDelivery
      }
      shipmentType
    }
    address {
      name
    }
  }
  ...StopDriverMapWithDriverSettlementTotalAmounts @include(if: $includeTotalAmounts)
  driverSettlementBill {
    name
    settlementDate
  }
  enableDriverSettlement
  revenuePercentageRate
  revenueFlatRate
  driverPayoutFinalized
}
    ${StopDriverMapWithDriverSettlementTotalAmountsFragmentDoc}`;
export const StopDriverMapFragmentDoc = gql`
    fragment StopDriverMap on StopDriverMapEntity {
  uuid
  name
  driver {
    firstName
    lastName
    uuid
    driverType
    driverReferenceNumber
    defaultFuelSettlementPercentageRate
  }
  stop {
    uuid
    settlementDeductionName
    settlementDeductionFlatRate
    settlementDeductionPercentageRate
    stopType
    arrivedAt
    completedAt
    shipment {
      order {
        uuid
        standardOrderFields {
          shipperBillOfLadingNumber
        }
        secondaryRefNumber
        refNumbers
        name
      }
      standardShipmentFields {
        pickupOrDelivery
        service {
          name
        }
      }
      packages {
        quantity
        weight
      }
      shipmentType
    }
    address {
      ...Address
    }
  }
  driverSettlementTotalAmounts {
    totalChargesForSettlement
    totalEligibleAmountForStop
    totalDriverPayout
  }
  driverSettlementBill {
    name
  }
  enableDriverSettlement
  revenuePercentageRate
  revenueFlatRate
  driverPayoutFinalized
}
    ${AddressFragmentDoc}`;
export const CsvOrderFieldMappingDetailedFragmentDoc = gql`
    fragment CsvOrderFieldMappingDetailed on CsvOrderFieldMappingEntity {
  sourceColumnName
  targetFieldType
}
    `;
export const CsvOrderMappingDetailedFragmentDoc = gql`
    fragment CsvOrderMappingDetailed on CsvOrderMappingEntity {
  uuid
  name
  csvOrderFieldMappings {
    ...CsvOrderFieldMappingDetailed
  }
  contact {
    uuid
  }
  enableDynamicInboundOrOutboundStop
  enableInboundStop
  enableOutboundStop
  pickupOrDeliveryDefaultValue
  serviceLevelDefaultValue {
    uuid
  }
  deadlineDateDefaultValue
  deadlineTypeDefaultValue
  stopTypeDefaultValue
  freightBillingMethodDefaultValue
  updateOrderOnDuplicateBolNumber
}
    ${CsvOrderFieldMappingDetailedFragmentDoc}`;
export const CsvOrderMappingShallowFragmentDoc = gql`
    fragment CsvOrderMappingShallow on CsvOrderMappingEntity {
  uuid
  name
  csvOrderFieldMappings {
    uuid
  }
}
    `;
export const EndOfDocumentsProcessingJobFragmentDoc = gql`
    fragment EndOfDocumentsProcessingJob on EndOfDayDocumentProcessingJobEntity {
  uuid
  dateUploadedFor
  uploadedFileName
  status
}
    `;
export const EquipmentFragmentDoc = gql`
    fragment Equipment on EquipmentEntity {
  uuid
  name
  capacity
  measurementSystem
  weight
  length
  width
  height
  notes
  specialRules
  type
  samsaraVehicleId
  samsaraIsDeactivated
  motiveVehicleId
  motiveIsDeactivated
  vehicleType {
    ...VehicleType
  }
}
    ${VehicleTypeFragmentDoc}`;
export const FuelChargeFuelProfileDateRangeFragmentDoc = gql`
    fragment FuelChargeFuelProfileDateRange on FuelProfileDateRangeEntity {
  uuid
  startDate
  expirationDate
  surchargeRate
  flatRateUsdCents
}
    `;
export const LineHaulFuelChargeFuelProfileDateRangeFragmentDoc = gql`
    fragment LineHaulFuelChargeFuelProfileDateRange on FuelProfileDateRangeEntity {
  uuid
  startDate
  expirationDate
  surchargeRate
  flatRateUsdCents
}
    `;
export const CostInputEstimatedMonthFragmentDoc = gql`
    fragment CostInputEstimatedMonth on CostInputEstimatedMonthEntity {
  month
  items
}
    `;
export const CostInputMonthFragmentDoc = gql`
    fragment CostInputMonth on CostInputMonthEntity {
  month
  terminalUuid
  isOpenMonth
  values {
    field
    value
    source
    typedValue
    quickbooksValue
    samsaraValue
    tenetValue
    typedByName
    typedAt
  }
  reports {
    key
    label
    hasCosts
    missing
  }
  rates {
    pdCostPerHourUsd
    dockCostPerHourUsd
    truckCostPerMileUsd
    operationsBenefitsSharePct
    pdLaborUsd
    dockLaborUsd
    truckCostUsd
    insuranceClaimsUsd
    outsideCarriersUsd
    variableCostUsd
    fixedCostUsd
    nonFreightCostUsd
    breakevenContributionRatio
    fixedCostPerDayUsd
    variableCostPerDayUsd
  }
}
    `;
export const CostInputQuickbooksAccountFragmentDoc = gql`
    fragment CostInputQuickbooksAccount on CostInputQuickbooksAccountEntity {
  quickbooksAccountId
  accountName
  sectionPath
  recentTotalUsd
  field
  isMapped
  isParentAccount
}
    `;
export const CostInputStatusFragmentDoc = gql`
    fragment CostInputStatus on CostInputStatusEntity {
  quickbooksConnected
  quickbooksLastSyncedAt
  quickbooksMatchedAccountCount
  quickbooksUnmatchedAccountCount
  truckLeasePerMilePct
  driverWageSplitPct
}
    `;
export const SamsaraDiscoveryStatusFragmentDoc = gql`
    fragment SamsaraDiscoveryStatus on SamsaraDiscoveryStatusEntity {
  connected
  samsaraOrgName
  hasData
  totalRows
  latestRun {
    uuid
    status
    startedAt
    finishedAt
    fromDate
    toDate
    currentDatasetLabel
    datasetsDone
    datasetsTotal
    rowsWritten
    errorMessage
  }
}
    `;
export const InventoryCountHeaderFragmentDoc = gql`
    fragment InventoryCountHeader on InventoryCountEntity {
  uuid
  statuses
  searchText
  unassociatedOnly
  noLocationOnly
  overdueOnly
  startedAt
  closedAt
  isClosed
  expectedCount
  confirmedCount
  pendingCount
  unexpectedCount
  departedCount
  startedByUser {
    uuid
    name
    email
  }
  startedByWarehouseEmployee {
    uuid
    firstName
    lastName
  }
  closedByUser {
    uuid
    name
    email
  }
  closedByWarehouseEmployee {
    uuid
    firstName
    lastName
  }
  warehouse {
    uuid
    name
  }
  warehouseLocation {
    uuid
    name
  }
  terminal {
    uuid
    name
  }
  contact {
    uuid
    displayName
  }
}
    `;
export const InventoryCountLineFragmentDoc = gql`
    fragment InventoryCountLine on InventoryCountLineEntity {
  uuid
  referenceNumber
  orderName
  customerName
  warehouseLocationName
  state
  pieceStatusAtClose
  scannedAt
  scannedBarcode
}
    `;
export const DwellTimeAlertConfigFragmentDoc = gql`
    fragment DwellTimeAlertConfig on DwellTimeAlertConfigEntity {
  uuid
  thresholdDays
  enabled
  warehouse {
    uuid
    name
  }
  contact {
    uuid
    displayName
  }
}
    `;
export const OrderForPackingSlipFragmentDoc = gql`
    fragment OrderForPackingSlip on OrderEntity {
  uuid
  name
  createdAt
  billingPartyContact {
    uuid
    displayName
    defaultAddress {
      uuid
      name
      line1
      line2
      city
      state
      zip
      country
    }
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  outboundShipment {
    standardShipmentFields {
      deliveryDate
    }
    legs {
      endStop {
        address {
          name
          line1
          line2
          city
          state
          zip
        }
        terminal {
          code
        }
        serviceDate
        outboundCarrier
        appointmentTime
        endAppointmentTime
        consigneeAddress {
          uuid
          name
          line1
          line2
          city
          state
          zip
        }
      }
    }
  }
}
    `;
export const PicklistsFragmentDoc = gql`
    fragment Picklists on PicklistEntity {
  id
  date
  outboundReferenceNumber
  picklistItemGroups {
    id
    pickedQuantity
    pickedStatus
    itemGroup {
      uuid
      quantity
      item {
        sku
        description
        primaryUOM {
          unitOfMeasure
        }
      }
      storageUnit {
        name
        warehouseLocation {
          name
        }
        storageOrder {
          uuid
          referenceNumber
          supplierCompanyName
          purchaseOrderNumber
          lotNumber
          contact {
            uuid
            displayName
            company {
              uuid
            }
            defaultAddress {
              name
              line1
              line2
              city
              state
              zip
              country
            }
          }
          warehouse {
            uuid
            name
          }
        }
      }
    }
  }
}
    `;
export const CustomChargeForOrderFragmentDoc = gql`
    fragment CustomChargeForOrder on CustomChargeEntity {
  name
  total
  accessorialTemplate {
    uuid
    name
    __typename
  }
}
    `;
export const ConsolidatableOrderSummaryFragmentDoc = gql`
    fragment ConsolidatableOrderSummary on OrderEntity {
  uuid
  name
  standardOrderFields {
    shipperBillOfLadingNumber
    weightUnits
  }
  totalCharge
  freightChargeRevenue
  fuelChargeRevenue
  customCharges {
    ...CustomChargeForOrder
  }
  weight
  dimWeight
  packages {
    uuid
    quantity
    type
  }
  shipments {
    legs {
      endStop {
        stopType
        address {
          ...Address
        }
      }
    }
  }
}
    ${CustomChargeForOrderFragmentDoc}
${AddressFragmentDoc}`;
export const CustomDriverFormFragmentDoc = gql`
    fragment CustomDriverForm on DriverSignableFormTemplateEntity {
  uuid
  title
  formText
}
    `;
export const DocumentFragmentDoc = gql`
    fragment Document on DocumentEntity {
  uuid
  fileName
  bucket
  region
  key
  uploadedAt
  fileType
  isDeleted
  preSignedGetUrl
  name
  type
  customDocumentName
  pageNumber
  createdAt
  dateUploadedFor
  order {
    uuid
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
  shipment {
    uuid
  }
  driverFormTemplate {
    ...CustomDriverForm
  }
  notes
}
    ${CustomDriverFormFragmentDoc}`;
export const InvoiceShipmentOrderForDownloadFragmentFragmentDoc = gql`
    fragment InvoiceShipmentOrderForDownloadFragment on OrderEntity {
  uuid
  isCrossDock
  name
  refNumbers
  secondaryRefNumber
  consolidatedShipmentString
  orderComments {
    uuid
    comment
    showOnInvoice
  }
  documents {
    ...Document
  }
  service {
    name
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    dimFactor
  }
  startStop {
    uuid
    completedAt
    address {
      uuid
      name
    }
  }
  endStop {
    uuid
    completedAt
    address {
      uuid
      name
    }
  }
}
    ${DocumentFragmentDoc}`;
export const InvoiceShipmentForDownloadFragmentFragmentDoc = gql`
    fragment InvoiceShipmentForDownloadFragment on ShipmentEntity {
  uuid
  name
  shipmentType
  standardShipmentFields {
    pickupOrDelivery
  }
  inputForConsolidatedOrder {
    name
  }
  shipmentCharges {
    totalCharge
    totalFreightCharge
    totalFuelCharge
  }
  packages {
    length
    width
    height
    quantity
    weight
  }
  order {
    ...InvoiceShipmentOrderForDownloadFragment
  }
  charges {
    ... on CustomChargeEntity {
      uuid
      name
      total
      description
      accessorialTemplate {
        uuid
        name
        invoiceDisplayName
        ... on StandardAccessorialEntity {
          matchingGlobalAccessorial {
            ...AccessorialUnionUuidOnly
          }
        }
        ... on PercentageAccessorialEntity {
          matchingGlobalAccessorial {
            ...AccessorialUnionUuidOnly
          }
        }
        ... on WeightBasedAccessorialEntity {
          matchingGlobalAccessorial {
            ...AccessorialUnionUuidOnly
          }
        }
        ... on ZoneBasedAccessorialEntity {
          matchingGlobalAccessorial {
            ...AccessorialUnionUuidOnly
          }
        }
        ... on WaitTimeAccessorialEntity {
          matchingGlobalAccessorial {
            ...AccessorialUnionUuidOnly
          }
        }
        ... on UnitBasedAccessorialEntity {
          matchingGlobalAccessorial {
            ...AccessorialUnionUuidOnly
          }
        }
        ... on SkidBasedAccessorialEntity {
          matchingGlobalAccessorial {
            ...AccessorialUnionUuidOnly
          }
        }
        ... on SpecialAccessorialEntity {
          matchingGlobalAccessorial {
            ...AccessorialUnionUuidOnly
          }
        }
        ... on AttemptsAccessorialEntity {
          matchingGlobalAccessorial {
            ...AccessorialUnionUuidOnly
          }
        }
        ... on StorageDaysAccessorialEntity {
          matchingGlobalAccessorial {
            ...AccessorialUnionUuidOnly
          }
        }
      }
      authoCode
    }
    ... on FreightChargeEntity {
      tariff {
        tariffZone {
          type
          name
        }
      }
      description
      authoCode
      fuelCharge {
        description
        authoCode
      }
    }
  }
  legs {
    endStop {
      completedAt
      proofOfDeliverySignee
      address {
        name
        line1
        line2
        zip
        city
        state
      }
    }
  }
}
    ${InvoiceShipmentOrderForDownloadFragmentFragmentDoc}
${AccessorialUnionUuidOnlyFragmentDoc}`;
export const InvoiceForDownloadFragmentFragmentDoc = gql`
    fragment InvoiceForDownloadFragment on InvoiceEntity {
  uuid
  billToContact {
    uuid
    displayName
    defaultAddress {
      ...Address
    }
    businessDivision {
      name
    }
    invoiceNotes
    chargeMatrixColumnMappings {
      uuid
      column
      accessorial {
        uuid
      }
    }
  }
  dueDate
  date
  invoiceTerms {
    uuid
    terms
  }
  name
  journalNumber
  shipments {
    ...InvoiceShipmentForDownloadFragment
  }
}
    ${AddressFragmentDoc}
${InvoiceShipmentForDownloadFragmentFragmentDoc}`;
export const InvoiceShipmentFragmentFragmentDoc = gql`
    fragment InvoiceShipmentFragment on ShipmentEntity {
  uuid
  overridePackageWeight
  totalChargesAmount
  shouldUseDimWeight
  totalCustomChargesAmount
  totalFuelChargesAmount
  totalFreightChargesAmount
  status
  name
  failureCount
  hasFailedStop
  standardShipmentFields {
    pickupOrDelivery
    deliveryDate
    dimFactor
  }
  documents {
    ...Document
  }
  packages {
    uuid
    weight
    description
    quantity
    length
    width
    height
    type
  }
  charges {
    ... on CustomChargeEntity {
      uuid
      name
      zoneBasedAccessorialZoneUuid
      zoneBasedAccessorialChargeGroupUuid
      specialAccessorialTariffZoneUuid
      specialAccessorialChargeGroupUuid
      quantity
      description
      authoCode
      rate
      total
      customChargeBillingMethod: billingMethod
      accessorialTemplate {
        uuid
        name
        __typename
      }
    }
    ... on FreightChargeEntity {
      uuid
      billingMethod
      tariff {
        uuid
        billingPartyContactUuid
        tariffOverageRates {
          uuid
          name
          type
          rateUsdCents
          applicableAboveAmount
          applyRateToFullAmount
        }
        tariffZone {
          name
          type
        }
      }
      rate
      description
      authoCode
      quantity
      fuelCharge {
        description
        authoCode
        surchargeRate
        flatRate
        type
        uuid
      }
    }
  }
  uuid
  status
  shouldUseDimWeight
  standardShipmentFields {
    shipmentWeight: weight
    service {
      ...Service
    }
    uuid
    type
  }
  charges {
    ... on CustomChargeEntity {
      uuid
      name
      zoneBasedAccessorialZoneUuid
      zoneBasedAccessorialChargeGroupUuid
      specialAccessorialTariffZoneUuid
      specialAccessorialChargeGroupUuid
      quantity
      description
      authoCode
      rate
      accessorialTemplate {
        uuid
        name
        __typename
      }
    }
    ... on FreightChargeEntity {
      uuid
      description
      authoCode
      quantity
      tariff {
        uuid
        billingPartyContactUuid
        tariffOverageRates {
          uuid
          name
          type
          rateUsdCents
          applicableAboveAmount
          applyRateToFullAmount
        }
      }
      fuelCharge {
        description
        authoCode
        flatRate
        type
        surchargeRate
        uuid
      }
    }
  }
  legs {
    uuid
    miles
    endStop {
      uuid
      arrivedAt
      completedAt
      appointmentRequired
      status
      proofOfDeliverySignee
      paperworkMarkedComplete
      address {
        name
        uuid
        line1
        line2
        zip
        city
        state
      }
    }
  }
  order {
    uuid
    createdAt
    name
    refNumbers
    totalCharge
    secondaryRefNumber
    billingPartyContact {
      businessDivision {
        name
      }
    }
    standardOrderFields {
      uuid
      shipperBillOfLadingNumber
      masterAirwayBillOfLadingNumber
      weightUnits
    }
  }
  shipmentType
}
    ${DocumentFragmentDoc}
${ServiceFragmentDoc}`;
export const InvoiceFragmentFragmentDoc = gql`
    fragment InvoiceFragment on InvoiceEntity {
  uuid
  status
  billToContact {
    uuid
    displayName
    defaultAddress {
      uuid
    }
    addresses {
      uuid
    }
    contactPersons {
      uuid
    }
  }
  createdAt
  lastSyncedToQuickbooksAt
  lastSyncedFromQuickbooksAt
  quickbooksInvoiceId
  documents {
    ...Document
  }
  dueDate
  date
  invoiceTotal
  invoiceTerms {
    uuid
    terms
  }
  inConsolidatedInvoice
  name
  notes
  qbInvoiceNumber
  journalNumber
  shipments {
    ...InvoiceShipmentFragment
    uuid
    totalChargesAmount
    charges {
      ... on CustomChargeEntity {
        uuid
        name
        zoneBasedAccessorialZoneUuid
        zoneBasedAccessorialChargeGroupUuid
        specialAccessorialTariffZoneUuid
        specialAccessorialChargeGroupUuid
        quantity
        description
        rate
        customChargeBillingMethod: billingMethod
        accessorialTemplate {
          uuid
          name
          percentForSettlement
        }
      }
      ... on FreightChargeEntity {
        uuid
        billingMethod
        tariff {
          uuid
          billingPartyContactUuid
          tariffOverageRates {
            uuid
            name
            type
            rateUsdCents
            applicableAboveAmount
          }
        }
        rate
        description
        quantity
        fuelCharge {
          description
          surchargeRate
          flatRate
          uuid
        }
      }
    }
    customCharges {
      uuid
      accessorialTemplate {
        uuid
        name
        percentForSettlement
      }
      customChargeBillingMethod: billingMethod
      description
      name
      quantity
      rate
      zoneBasedAccessorialChargeGroupUuid
      zoneBasedAccessorialZoneUuid
      specialAccessorialTariffZoneUuid
      specialAccessorialChargeGroupUuid
    }
    failureCount
    freightCharge {
      uuid
      billingMethod
      description
      fuelCharge {
        description
        surchargeRate
        uuid
        freightCharge {
          uuid
        }
      }
      quantity
      rate
      tariff {
        uuid
        billingPartyContactUuid
        tariffOverageRates {
          uuid
          name
          type
          rateUsdCents
          applicableAboveAmount
        }
      }
    }
    hasFailedStop
    legs {
      uuid
      endStop {
        isSpecial
        uuid
        arrivedAt
        completedAt
        status
        address {
          ...Address
        }
      }
      miles
    }
    name
    order {
      uuid
      secondaryRefNumber
      orderInvoiceByDate
      name
      ediTransactions {
        code
        status
      }
      standardOrderFields {
        shipperBillOfLadingNumber
      }
      shipments {
        uuid
        documents {
          ...Document
        }
      }
    }
    packages {
      ...Package
    }
    standardShipmentFields {
      uuid
      deliveryDate
      pickupOrDelivery
      service {
        ...Service
      }
      shipmentWeight: weight
    }
    status
    ... on StandardShipmentEntity {
      uuid
      status
      charges {
        ... on CustomChargeEntity {
          uuid
          name
          zoneBasedAccessorialZoneUuid
          zoneBasedAccessorialChargeGroupUuid
          specialAccessorialTariffZoneUuid
          specialAccessorialChargeGroupUuid
          quantity
          description
          rate
          accessorialTemplate {
            uuid
            name
            percentForSettlement
          }
        }
        ... on FreightChargeEntity {
          uuid
          description
          quantity
          tariff {
            uuid
            billingPartyContactUuid
            tariffOverageRates {
              uuid
              name
              type
              rateUsdCents
              applicableAboveAmount
            }
          }
          fuelCharge {
            description
            surchargeRate
            uuid
          }
        }
      }
    }
  }
}
    ${DocumentFragmentDoc}
${InvoiceShipmentFragmentFragmentDoc}
${AddressFragmentDoc}
${PackageFragmentDoc}
${ServiceFragmentDoc}`;
export const RecoveryTerminalFragmentDoc = gql`
    fragment RecoveryTerminal on AirportInfoEntity {
  uuid
  iataCode
  terminal
  isArchived
  address {
    ...Address
    preventCoordRecompute
  }
}
    ${AddressFragmentDoc}`;
export const ShallowTerminalFragmentDoc = gql`
    fragment ShallowTerminal on TerminalEntity {
  name
  code
  uuid
  serviceRegionId
  address {
    line1
    line2
    city
    state
    zip
    uuid
    name
    latitude
    longitude
  }
  isActive
  startForTerminalLanes {
    id
    endTerminal {
      uuid
      code
      name
    }
  }
  agent {
    name
  }
}
    `;
export const DriverFragmentDoc = gql`
    fragment Driver on DriverEntity {
  firstName
  lastName
  user {
    name
  }
  uuid
  defaultVehicle {
    uuid
  }
  driverType
  driverReferenceNumber
  defaultFuelSettlementPercentageRate
  defaultAccessorialSettlementPercentageRate
  terminal {
    uuid
    name
  }
  qualifications {
    id
  }
}
    `;
export const StopDriverMapForOrderFragmentDoc = gql`
    fragment StopDriverMapForOrder on StopDriverMapEntity {
  uuid
  name
  driver {
    ...Driver
  }
  driverSettlementBill {
    uuid
  }
  stop {
    uuid
    completedAt
    settlementDeductionName
    settlementDeductionFlatRate
    settlementDeductionPercentageRate
  }
  enableDriverSettlement
  revenuePercentageRate
  revenueFlatRate
  driverPayoutFinalized
}
    ${DriverFragmentDoc}`;
export const StandardOrderQueryStopFragmentDoc = gql`
    fragment StandardOrderQueryStop on StopEntity {
  uuid
  createdAt
  specialInstructions
  address {
    ...Address
    preventCoordRecompute
    internalNotes
    iataCode
  }
  destinationAirport
  inboundDeadlineDate
  expectedOutboundDate
  outboundCarrier
  appointmentTextStatus
  incomingCarrier
  appointmentCallStatus
  appointmentManuallyConfirmed
  appointmentStatus
  deadlineTime
  settlementDeductionFlatRate
  settlementDeductionPercentageRate
  settlementDeductionName
  proofOfDeliverySignee
  appointmentTime
  arrivedAt
  completedAt
  inboundMethod
  expectedInboundArrivalDate
  outboundMethod
  transferAddress {
    ...Address
  }
  consigneeAddress {
    ...Address
  }
  consigneeContactPerson {
    ...ContactPerson
  }
  driverCompletedAt
  notes
  serviceDate
  serviceDateV2 {
    iso8601
  }
  shipperAddress {
    ...Address
  }
  shipperContactPerson {
    ...ContactPerson
  }
  status
  appointmentRequired
  endAppointmentTime
  isSpecial
  hideFromDispatch
  routeSlot {
    uuid
    route {
      uuid
      date
      name
      slots {
        uuid
      }
      drivers {
        uuid
        firstName
        lastName
        driverType
        agent {
          uuid
          name
        }
      }
      equipments {
        uuid
        name
      }
    }
  }
  contactPerson {
    ...ContactPerson
  }
  standardStopType
  stopType
  stopIntention
  paperworkMarkedComplete
  failureCount
  terminal {
    ...ShallowTerminal
  }
  canMarkAttemptComplete
  stopDriverMaps {
    ...StopDriverMapForOrder
  }
  sentToAgentAt
  confirmedByAgentAt
}
    ${AddressFragmentDoc}
${ContactPersonFragmentDoc}
${ShallowTerminalFragmentDoc}
${StopDriverMapForOrderFragmentDoc}`;
export const CustomChargeFragmentDoc = gql`
    fragment CustomCharge on CustomChargeEntity {
  uuid
  rate
  description
  total
  totalAmountCents
  postedAmountUsdCents
  authoCode
  quantity
  billingMethod
  isAutoApplied
  name
  fuelSurchargeRate
  postedFuelSurchargeRate
  zoneBasedAccessorialMatrixItem {
    uuid
  }
  zoneBasedAccessorialChargeGroupUuid
  zoneBasedAccessorialZoneUuid
  specialAccessorialMatrixItem {
    uuid
  }
  specialAccessorialTariffZoneUuid
  specialAccessorialChargeGroupUuid
  accessorialRange {
    ...AccessorialRange
  }
  accessorialTemplate {
    uuid
    name
    type
  }
  settlementFlatRate
  settlementPercentageRate
}
    ${AccessorialRangeFragmentDoc}`;
export const FreightChargeHistorySnapshotFragmentDoc = gql`
    fragment FreightChargeHistorySnapshot on FreightChargeEntity {
  externalRateQuote {
    uuid
  }
}
    `;
export const TariffShallowFragmentDoc = gql`
    fragment TariffShallow on TariffEntity {
  uuid
  billingPartyContactUuid
  tariffGroup {
    name
    tariffGroupScope
  }
  tariffZone {
    name
  }
}
    `;
export const StandardShipmentFreightChargeFragmentDoc = gql`
    fragment StandardShipmentFreightCharge on FreightChargeEntity {
  uuid
  ...FreightChargeHistorySnapshot
  quantity
  fuelCharge {
    uuid
    surchargeRate
    description
    authoCode
    flatRate
    type
    settlementFlatRate
    settlementPercentageRate
    totalAmountCents
    postedAmountUsdCents
  }
  tariff {
    ...TariffShallow
  }
  billingMethod
  description
  authoCode
  rate
  discountRate
  settlementFlatRate
  settlementPercentageRate
  total
  totalAmountCents
  postedAmountUsdCents
}
    ${FreightChargeHistorySnapshotFragmentDoc}
${TariffShallowFragmentDoc}`;
export const ShipmentChargesFragmentDoc = gql`
    fragment ShipmentCharges on ShipmentChargeEntity {
  totalFuelCharge
  totalCustomCharge
  totalFreightCharge
  totalCharge
}
    `;
export const FuelCostForOrderFragmentDoc = gql`
    fragment FuelCostForOrder on FuelCostEntity {
  id
  billingMethod
  dependentSettlementBillingMethod
  percentageRate
  surchargeRate
  flatRateUsdDollars
  totalAmountUsdDollars
  totalAmountUsdCents
}
    `;
export const FreightCostForOrderFragmentDoc = gql`
    fragment FreightCostForOrder on FreightCostEntity {
  id
  billingMethod
  dependentSettlementBillingMethod
  percentageRate
  flatRateUsdDollars
  quantity
  rateUsdDollars
  discountRate
  totalAmountUsdDollars
  totalAmountUsdCents
  tariff {
    uuid
    tariffZone {
      name
    }
  }
  fuelCost {
    ...FuelCostForOrder
  }
}
    ${FuelCostForOrderFragmentDoc}`;
export const CustomCostForOrderFragmentDoc = gql`
    fragment CustomCostForOrder on CustomCostEntity {
  id
  name
  billingMethod
  dependentSettlementBillingMethod
  percentageRate
  flatRateUsdDollars
  quantity
  rateUsdDollars
  fuelSurchargeRate
  totalAmountUsdDollars
  totalAmountUsdCents
  accessorialTemplate {
    __typename
    uuid
    name
    type
  }
  specialAccessorialMatrixItem {
    uuid
    zoneUuid
    chargeGroupUuid
  }
  zoneBasedAccessorialMatrixItem {
    uuid
    zoneUuid
    chargeGroupUuid
  }
  accessorialRange {
    uuid
  }
}
    `;
export const SettlementBillLineItemForOrderFragmentDoc = gql`
    fragment SettlementBillLineItemForOrder on SettlementBillLineItemEntity {
  id
  settlementMode
  totalAmountUsdDollars
  revenuePercentageRate
  revenueFlatRate
  driver {
    uuid
    user {
      name
    }
  }
  driverSettlementBill {
    uuid
    name
    finalizedDate
  }
  freightCost {
    ...FreightCostForOrder
  }
  customCosts {
    ...CustomCostForOrder
  }
}
    ${FreightCostForOrderFragmentDoc}
${CustomCostForOrderFragmentDoc}`;
export const StandardShipmentFragmentDoc = gql`
    fragment StandardShipment on StandardShipmentEntity {
  uuid
  totalChargesAmount
  totalAmountCents
  postedAmountCents
  shouldBillIndividually
  shouldUseDimWeight
  overridePackageWeight
  name
  hideFromBilling
  hasSignedPOD
  invoice {
    uuid
    date
    postedAt
    dueDate
    name
    billToContact {
      uuid
    }
    journalNumber
  }
  documents {
    ...Document
  }
  shipmentSubscribers {
    uuid
    email
  }
  shipmentType
  shipperAddress {
    ...Address
  }
  airportInfo {
    ...RecoveryTerminal
  }
  fields {
    uuid
    deadlineDate
    deadlineType
    deliveryDate
    dimFactor
    pickupOrDelivery
    outboundMethod
    inboundMethod
    service {
      ...Service
    }
    type
  }
  legs {
    uuid
    miles
    endStop {
      ...StandardOrderQueryStop
    }
    previousStopAttempts {
      stopDriverMaps {
        ...StopDriverMapForOrder
      }
    }
  }
  packages {
    ...Package
  }
  customCharges {
    ...CustomCharge
  }
  freightCharge {
    ...StandardShipmentFreightCharge
  }
  status
  inputForConsolidatedOrder {
    uuid
    name
  }
  shipmentType
  shipmentCharges {
    ...ShipmentCharges
  }
  independentSettlementBillLineItems {
    ...SettlementBillLineItemForOrder
  }
}
    ${DocumentFragmentDoc}
${AddressFragmentDoc}
${RecoveryTerminalFragmentDoc}
${ServiceFragmentDoc}
${StandardOrderQueryStopFragmentDoc}
${StopDriverMapForOrderFragmentDoc}
${PackageFragmentDoc}
${CustomChargeFragmentDoc}
${StandardShipmentFreightChargeFragmentDoc}
${ShipmentChargesFragmentDoc}
${SettlementBillLineItemForOrderFragmentDoc}`;
export const OutstandingOrderQueryStopFragmentDoc = gql`
    fragment OutstandingOrderQueryStop on StopEntity {
  uuid
  createdAt
  specialInstructions
  stopType
  stopIntention
  address {
    ...Address
    internalNotes
    iataCode
  }
  appointmentRequired
  deadlineTime
  proofOfDeliverySignee
  arrivedAt
  completedAt
  inboundMethod
  expectedInboundArrivalDate
  outboundMethod
  driverCompletedAt
  notes
  serviceDate
  serviceDateV2 {
    iso8601
  }
  status
  appointmentTime
  endAppointmentTime
  isSpecial
  settlementDeductionFlatRate
  settlementDeductionName
  settlementDeductionPercentageRate
  routeSlot {
    uuid
    route {
      uuid
      date
      name
      slots {
        uuid
      }
      drivers {
        uuid
        firstName
        lastName
        driverType
        agent {
          uuid
          name
        }
      }
      equipments {
        uuid
        name
      }
    }
  }
  standardStopType
  paperworkMarkedComplete
  terminal {
    ...ShallowTerminal
  }
  stopDriverMaps {
    ...StopDriverMapForOrder
  }
  sentToAgentAt
  confirmedByAgentAt
}
    ${AddressFragmentDoc}
${ShallowTerminalFragmentDoc}
${StopDriverMapForOrderFragmentDoc}`;
export const OutstandingShipmentOrderShipmentFragmentDoc = gql`
    fragment OutstandingShipmentOrderShipment on StandardShipmentEntity {
  uuid
  totalChargesAmount
  shouldBillIndividually
  shouldUseDimWeight
  overridePackageWeight
  name
  hideFromBilling
  hasSignedPOD
  documents {
    ...Document
  }
  shipmentSubscribers {
    uuid
    email
  }
  standardShipmentFields {
    uuid
    pickupOrDelivery
  }
  fields {
    uuid
    deadlineDate
    deadlineType
    deliveryDate
    dimFactor
    pickupOrDelivery
    service {
      ...Service
    }
    type
  }
  legs {
    uuid
    miles
    endStop {
      ...OutstandingOrderQueryStop
    }
    previousStopAttempts {
      stopDriverMaps {
        ...StopDriverMapForOrder
      }
    }
  }
  packages {
    ...Package
  }
  customCharges {
    ...CustomCharge
  }
  freightCharge {
    uuid
    quantity
    fuelCharge {
      uuid
      surchargeRate
      description
      authoCode
      flatRate
      type
      settlementFlatRate
      settlementPercentageRate
    }
    tariff {
      ...TariffShallow
    }
    billingMethod
    description
    authoCode
    rate
    settlementFlatRate
    settlementPercentageRate
    total
  }
  status
  inputForConsolidatedOrder {
    uuid
  }
  shipmentType
  shipmentCharges {
    ...ShipmentCharges
  }
}
    ${DocumentFragmentDoc}
${ServiceFragmentDoc}
${OutstandingOrderQueryStopFragmentDoc}
${StopDriverMapForOrderFragmentDoc}
${PackageFragmentDoc}
${CustomChargeFragmentDoc}
${TariffShallowFragmentDoc}
${ShipmentChargesFragmentDoc}`;
export const OutstandingShipmentOrderFragmentDoc = gql`
    fragment OutstandingShipmentOrder on OrderEntity {
  uuid
  billingPartyContact {
    uuid
  }
  consolidatedShipmentString
  name
  detailedStatusV2
  status
  notes
  packages {
    ...Package
  }
  orderConsolidationType
  shipments {
    ...OutstandingShipmentOrderShipment
  }
  source
  secondaryRefNumber
  standardOrderFields {
    uuid
    dimFactor
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  tags {
    ...Tag
  }
}
    ${PackageFragmentDoc}
${OutstandingShipmentOrderShipmentFragmentDoc}
${TagFragmentDoc}`;
export const ConsolidatableShipmentFragmentDoc = gql`
    fragment ConsolidatableShipment on ShipmentEntity {
  ...StandardShipment
  order {
    ...OutstandingShipmentOrder
  }
}
    ${StandardShipmentFragmentDoc}
${OutstandingShipmentOrderFragmentDoc}`;
export const OutstandingShipmentFragmentDoc = gql`
    fragment OutstandingShipment on ShipmentEntity {
  consolidatableShipments {
    uuid
    order {
      ...OutstandingShipmentOrder
    }
  }
  order {
    ...OutstandingShipmentOrder
  }
  uuid
  standardShipmentFields {
    uuid
    pickupOrDelivery
  }
  totalChargesAmount
  legs {
    uuid
    endStop {
      address {
        name
        internalNotes
        iataCode
      }
      completedAt
    }
  }
  status
}
    ${OutstandingShipmentOrderFragmentDoc}`;
export const InvoiceEdiTransactionFragmentDoc = gql`
    fragment InvoiceEdiTransaction on EdiTransactionEntity {
  createdAt
  status
  order {
    name
    secondaryRefNumber
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
}
    `;
export const InvoiceForDunningReportFragmentDoc = gql`
    fragment InvoiceForDunningReport on InvoiceEntity {
  uuid
  name
  dueDate
  date
  createdAt
  journalNumber
  invoiceTotal
  balanceInCents
  orders {
    uuid
    name
    refNumbers
    totalCharge
    balanceInCents
    standardOrderFields {
      shipperBillOfLadingNumber
      masterAirwayBillOfLadingNumber
    }
    endStop {
      serviceDate
    }
    startStop {
      serviceDate
    }
  }
}
    `;
export const BatchAddShipmentsToInvoicesPreviewFragmentDoc = gql`
    fragment BatchAddShipmentsToInvoicesPreview on BatchAddShipmentsToInvoicePreview {
  contactName
  contactUuid
  existingInvoiceAdds {
    uuid
    name
    shipmentUuids
  }
  newInvoiceAdds {
    name
    shipmentUuids
  }
  billingCycleDuration
}
    `;
export const BatchAddShipmentsToInvoicesResultInvoiceFragmentDoc = gql`
    fragment BatchAddShipmentsToInvoicesResultInvoice on InvoiceEntity {
  uuid
  name
  journalNumber
  billToContact {
    uuid
    displayName
  }
  shipments {
    uuid
    legs {
      endStop {
        stopType
      }
    }
    order {
      standardOrderFields {
        shipperBillOfLadingNumber
      }
    }
  }
}
    `;
export const OrderForConsolidationFlowFragmentDoc = gql`
    fragment OrderForConsolidationFlow on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  billingPartyContact {
    uuid
    displayName
  }
  inboundShipment {
    uuid
    legs {
      endStop {
        address {
          name
          line1
        }
      }
    }
    freightCharge {
      uuid
    }
  }
  outboundShipment {
    uuid
    legs {
      endStop {
        address {
          name
          line1
        }
      }
    }
    freightCharge {
      uuid
    }
  }
  lineHaulLane {
    name
  }
  weight
  dimWeight
  name
  status
  pieceCountFromPackages
}
    `;
export const ProratedShipmentV2FragmentDoc = gql`
    fragment ProratedShipmentV2 on ProratedShipment {
  initialFreightChargeTotal
  proratedFreightChargeTotal
  initialFuelChargeTotal
  proratedFuelChargeTotal
  customCharges {
    initialTotal
    proratedTotal
    name
  }
}
    `;
export const ProratedOrderV2FragmentDoc = gql`
    fragment ProratedOrderV2 on ProratedOrder {
  uuid
  name
  hawb
  proportionForConsolidation
  proportionOfTotalWeight
  weight
  inboundShipment {
    ...ProratedShipmentV2
  }
  outboundShipment {
    ...ProratedShipmentV2
  }
  totalAfterProrating
  lineHaulInitialTotal
  orderChargesInitialTotal
}
    ${ProratedShipmentV2FragmentDoc}`;
export const SimpleFreightChargeFragmentDoc = gql`
    fragment SimpleFreightCharge on SimpleFreightCharge {
  billingMethod
  rate
  quantity
  amount
}
    `;
export const SimpleFuelChargeFragmentDoc = gql`
    fragment SimpleFuelCharge on SimpleFuelCharge {
  billingMethod
  quantity
  amount
}
    `;
export const SimpleCustomChargeFragmentDoc = gql`
    fragment SimpleCustomCharge on SimpleCustomCharge {
  name
  amount
}
    `;
export const ProratedShipmentFragmentDoc = gql`
    fragment ProratedShipment on ProratedShipmentInformation {
  shipment {
    uuid
  }
  initialFreightCharge {
    totalCents
  }
  initialFuelCharge {
    totalCents
  }
  proratedFreightCharge {
    totalCents
  }
  proratedFuelCharge {
    totalCents
  }
  customCharges {
    initialOrderUuidsPresentIn
    initialTotalCents
    proratedTotalCents
    name
  }
  freightAndFuelProrateMultiplier
}
    `;
export const ProratedOrderFragmentDoc = gql`
    fragment ProratedOrder on ProratedOrderInformation {
  order {
    uuid
    name
    standardOrderFields {
      shipperBillOfLadingNumber
    }
    inboundShipment {
      totalChargesAmount
    }
    outboundShipment {
      totalChargesAmount
    }
    lineHaulShipment {
      totalChargesAmount
    }
    orderChargesShipment {
      totalChargesAmount
    }
    totalCharge
  }
  inboundShipment {
    ...ProratedShipment
  }
  outboundShipment {
    ...ProratedShipment
  }
}
    ${ProratedShipmentFragmentDoc}`;
export const ContactForInvoiceFragmentDoc = gql`
    fragment ContactForInvoice on ContactEntity {
  __typename
  uuid
  displayName
  stediPartnerId
  contactReferenceNumber
  ... on CustomerContactEntity {
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
    defaultInvoiceType
    defaultInvoiceTransmissionMethod
    defaultInvoiceDocumentsRequired
    defaultInvoiceDownloadDocuments
    enableCreditHold
    defaultInvoiceEmailSubject
  }
}
    `;
export const InvoiceForContactFragmentDoc = gql`
    fragment InvoiceForContact on InvoiceEntity {
  uuid
  source
  name
  journalNumber
  status
  billToContact {
    uuid
    displayName
  }
  date
  createdAt
}
    `;
export const InvoiceForInvoiceSelectionFragmentDoc = gql`
    fragment InvoiceForInvoiceSelection on InvoiceEntity {
  uuid
  name
  journalNumber
  date
  dueDate
}
    `;
export const OrderPaperworkFragmentDoc = gql`
    fragment OrderPaperwork on OrderPaperworkEntity {
  paperworkComplete
  paperworkMarkedCompleteOverride
  attachedDocuments
  missingDocuments
}
    `;
export const InvoiceOrderFragmentFragmentDoc = gql`
    fragment InvoiceOrderFragment on OrderEntity {
  uuid
  createdAt
  name
  missingDocuments
  documents {
    type
  }
  paperwork {
    ...OrderPaperwork
  }
  appliedAmount
  balanceInCents
  orderPaymentMappings {
    uuid
    amountInCents
    payment {
      paymentType
      contact {
        displayName
        uuid
      }
    }
  }
  secondaryRefNumber
  standardOrderFields {
    uuid
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    weightUnits
  }
  orderComments {
    uuid
    comment
    showOnInvoice
  }
  shipments {
    uuid
    shipmentCharges {
      totalCharge
    }
    invoice {
      uuid
    }
  }
  endStop {
    serviceDate
    address {
      name
    }
  }
  pieceCountFromPackages
  weight
}
    ${OrderPaperworkFragmentDoc}`;
export const InvoiceShipmentWithChargesFragmentDoc = gql`
    fragment InvoiceShipmentWithCharges on ShipmentEntity {
  uuid
  overridePackageWeight
  shipmentType
  shipmentCharges {
    totalFreightCharge
    totalFuelCharge
    totalCharge
  }
  shipperAddress {
    ...Address
  }
  standardShipmentFields {
    pickupOrDelivery
  }
  uuid
  status
  name
  legs {
    uuid
    endStop {
      completedAt
      paperworkMarkedComplete
      settlementDeductionName
      settlementDeductionFlatRate
      settlementDeductionPercentageRate
      stopType
      address {
        ...Address
      }
    }
  }
  invoice {
    uuid
  }
  charges {
    ... on CustomChargeEntity {
      uuid
      name
      quantity
      description
      rate
      total
      customChargeBillingMethod: billingMethod
      settlementFlatRate
      settlementPercentageRate
      accessorialTemplate {
        uuid
        name
        invoiceDisplayName
        __typename
      }
      postedFuelSurchargeRate
    }
    ... on FreightChargeEntity {
      uuid
      billingMethod
      tariff {
        uuid
        tariffType
        tariffZone {
          name
          type
        }
      }
      rate
      description
      quantity
      settlementFlatRate
      settlementPercentageRate
      fuelCharge {
        surchargeRate
        flatRate
        type
        uuid
        settlementFlatRate
        settlementPercentageRate
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export const InvoiceOrderWithShipmentsFragmentDoc = gql`
    fragment InvoiceOrderWithShipments on OrderEntity {
  ...InvoiceOrderFragment
  shipments {
    ...InvoiceShipmentWithCharges
  }
}
    ${InvoiceOrderFragmentFragmentDoc}
${InvoiceShipmentWithChargesFragmentDoc}`;
export const InvoiceDocumentForDownloadFragmentDoc = gql`
    fragment InvoiceDocumentForDownload on DocumentEntity {
  fileType
  preSignedGetUrl
  invoice {
    name
    journalNumber
  }
}
    `;
export const InvoiceSendJobBatchFragmentDoc = gql`
    fragment InvoiceSendJobBatch on InvoiceSendJobBatchEntity {
  uuid
  createdAt
  type
  invoiceSendJobBatchProgress {
    totalCount
    failCount
    successCount
  }
  invoiceBatchDocuments {
    invoicesBackupDocument {
      preSignedGetUrl
      fileType
    }
    invoicesCombinedDocument {
      preSignedGetUrl
      fileType
    }
    invoicesZipDocument {
      preSignedGetUrl
      fileType
    }
  }
}
    `;
export const InvoiceSendJobShallowFragmentDoc = gql`
    fragment InvoiceSendJobShallow on InvoiceSendJobEntity {
  uuid
  invoice {
    uuid
    name
    journalNumber
  }
}
    `;
export const InvoiceSendJobFragmentDoc = gql`
    fragment InvoiceSendJob on InvoiceSendJobEntity {
  uuid
  createdAt
  invoiceSendJobError
  invoiceAttachmentDocumentTypes
  invoiceTransmissionMethod
  invoice {
    uuid
    name
    journalNumber
    billToContact {
      displayName
    }
  }
  invoiceChargesObject
  document {
    preSignedGetUrl
  }
  emailTransaction {
    uuid
    emailTransactionStatus
    pdfNotAttached
    emailTransactionLogs {
      uuid
      email
      lastStatus
      reason
    }
  }
}
    `;
export const InvoiceStatFragmentDoc = gql`
    fragment InvoiceStat on InvoiceEntity {
  balanceInCents
  invoiceTotal
  uuid
}
    `;
export const InvoiceWithOrdersFragmentDoc = gql`
    fragment InvoiceWithOrders on InvoiceEntity {
  uuid
  source
  name
  journalNumber
  status
  billToContact {
    uuid
    displayName
  }
  date
  createdAt
}
    `;
export const InvoiceForRegisterReportFragmentDoc = gql`
    fragment InvoiceForRegisterReport on InvoiceEntity {
  uuid
  date
  name
  journalNumber
  status
  inConsolidatedInvoice
  dueDate
  billToContact {
    uuid
    displayName
  }
  balanceInCents
  invoiceTotal
}
    `;
export const AverageDaysToPayReportDataFragmentDoc = gql`
    fragment AverageDaysToPayReportData on AverageDaysToPayForContactEntity {
  contactUuid
  displayName
  contactReferenceNumber
  averageDaysToPay90
  averageDaysToPay180
  averageDaysToPay270
  averageDaysToPay360
  averageDaysToPay720
  averageDaysToPayAll
}
    `;
export const ContactWithBalancesFragmentDoc = gql`
    fragment ContactWithBalances on ContactEntity {
  uuid
  displayName
  contactOpenInvoiceValue
  postedInvoicesTotalOpenBalance
  postedInvoicesTotalClosedBalance
  paymentsAppliedToContactInvoices
  unappliedPayments
  offsetPayments
  creditsAppliedToContactInvoices
  unappliedCredits
  offsetCredits
  debitsAppliedToContactInvoices
  unappliedDebits
  offsetDebits
  balance
  ... on CustomerContactEntity {
    creditHoldLimitInCents
    enableCreditHold
  }
}
    `;
export const InvoiceForPaymentFragmentDoc = gql`
    fragment InvoiceForPayment on InvoiceEntity {
  uuid
  name
  date
  journalNumber
}
    `;
export const OrdersForPaymentFragmentDoc = gql`
    fragment OrdersForPayment on OrderEntity {
  uuid
  name
  secondaryRefNumber
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  appliedAmount
  invoice {
    ...InvoiceForPayment
    billToContact {
      uuid
      displayName
    }
  }
  totalCharge
}
    ${InvoiceForPaymentFragmentDoc}`;
export const PaymentForCheckRegisterReportFragmentDoc = gql`
    fragment PaymentForCheckRegisterReport on PaymentForCheckRegisterReportEntity {
  paymentUuid
  referenceNumber
  paymentDate
  terminalCodes
  contactDisplayName
  contactReferenceNumber
  comment
  amountInCents
}
    `;
export const CreditTypeFragmentDoc = gql`
    fragment CreditType on CreditTypeEntity {
  uuid
  name
  color
  systemKey
  generalLedgerCode {
    code
    description
    id
  }
}
    `;
export const PaymentForInvoiceFragmentDoc = gql`
    fragment PaymentForInvoice on PaymentEntity {
  uuid
  date
  amountInCents
  referenceNumber
  paymentType
  paymentRail
  creditType {
    ...CreditType
  }
  contact {
    uuid
    displayName
    masterAccount {
      uuid
    }
  }
}
    ${CreditTypeFragmentDoc}`;
export const PaymentForReportFragmentDoc = gql`
    fragment PaymentForReport on PaymentEntity {
  uuid
  amountInCents
  referenceNumber
  date
  contact {
    uuid
    displayName
    contactReferenceNumber
  }
  paymentType
  paymentRail
  comment
  creditType {
    name
  }
  paymentToOrderMappings {
    order {
      shipments {
        legs {
          endStop {
            terminal {
              uuid
              code
            }
          }
        }
      }
    }
  }
}
    `;
export const PaymentOffsetPartyFragmentDoc = gql`
    fragment PaymentOffsetParty on PaymentEntity {
  uuid
  paymentType
  referenceNumber
  creditNumber
  date
  amountInCents
  appliedAmountInCents
  unappliedAmountInCents
  offsetAmountInCents
}
    `;
export const PaymentOffsetFragmentDoc = gql`
    fragment PaymentOffset on PaymentToPaymentMappingEntity {
  uuid
  amountInCents
  createdAt
  sourcePayment {
    ...PaymentOffsetParty
  }
  targetPayment {
    ...PaymentOffsetParty
  }
}
    ${PaymentOffsetPartyFragmentDoc}`;
export const PaymentFragmentDoc = gql`
    fragment Payment on PaymentEntity {
  uuid
  amountInCents
  referenceNumber
  date
  comment
  paymentType
  paymentRail
  creditType {
    ...CreditType
  }
  contact {
    uuid
    displayName
    masterAccount {
      uuid
    }
  }
  glTerminal {
    name
  }
  unappliedAmountInCents
  paymentOffsets {
    ...PaymentOffset
  }
  paymentToOrderMappings {
    amountInCents
    order {
      uuid
      invoice {
        name
        journalNumber
        uuid
        billToContact {
          uuid
          displayName
        }
      }
      totalCharge
      standardOrderFields {
        shipperBillOfLadingNumber
      }
    }
  }
}
    ${CreditTypeFragmentDoc}
${PaymentOffsetFragmentDoc}`;
export const InvoiceForQuickbooksFragmentDoc = gql`
    fragment InvoiceForQuickbooks on InvoiceEntity {
  uuid
  createdAt
  name
  dueDate
  qbInvoiceNumber
  status
  billToContact {
    displayName
  }
  invoiceTerms {
    terms
  }
  shipments {
    standardShipmentFields {
      pickupOrDelivery
    }
    order {
      secondaryRefNumber
      refNumbers
      standardOrderFields {
        shipperBillOfLadingNumber
      }
    }
    legs {
      endStop {
        completedAt
      }
    }
    freightCharge {
      uuid
      quantity
      rate
      billingMethod
      description
      fuelCharge {
        type
        flatRate
        surchargeRate
        description
      }
    }
    customCharges {
      uuid
      name
      rate
      description
      quantity
      total
      billingMethod
      accessorialTemplate {
        uuid
      }
    }
  }
}
    `;
export const QuickbooksSyncFailureFragmentDoc = gql`
    fragment QuickbooksSyncFailure on SyncInvoiceToQuickbooksFailure {
  invoiceUuid
  invoiceName
  code
  element
  fixIn
  title
  detail
  remediation
  retryable
  affectedInvoiceCount
  quickbooksSaid
  quickbooksFaultCode
  quickbooksRequestId
  quickbooksCustomerId
  quickbooksCustomerName
  quickbooksItemId
  quickbooksItemName
  quickbooksUrl
  tenetRecordName
  tenetUrl
}
    `;
export const QuickbooksSyncNoticeFragmentDoc = gql`
    fragment QuickbooksSyncNotice on SyncInvoiceToQuickbooksNotice {
  kind
  element
  title
  detail
  quickbooksRecordId
  quickbooksRecordName
  quickbooksUrl
  tenetRecordName
  tenetUrl
}
    `;
export const QuickbooksSyncPlannedCreateFragmentDoc = gql`
    fragment QuickbooksSyncPlannedCreate on QuickbooksSyncPlannedCreate {
  kind
  name
  reason
  tenetRecordName
  tenetRecordUuid
  tenetUrl
}
    `;
export const QuickbooksSyncInvoicePlanFragmentDoc = gql`
    fragment QuickbooksSyncInvoicePlan on QuickbooksSyncInvoicePlan {
  invoiceUuid
  invoiceName
  billToContactUuid
  billToContactName
  status
  failures {
    ...QuickbooksSyncFailure
  }
  warnings {
    ...QuickbooksSyncFailure
  }
  notices {
    ...QuickbooksSyncNotice
  }
  plannedCreates {
    ...QuickbooksSyncPlannedCreate
  }
}
    ${QuickbooksSyncFailureFragmentDoc}
${QuickbooksSyncNoticeFragmentDoc}
${QuickbooksSyncPlannedCreateFragmentDoc}`;
export const QuickbooksSyncedInvoiceFragmentDoc = gql`
    fragment QuickbooksSyncedInvoice on InvoiceEntity {
  uuid
  name
  quickbooksInvoiceId
  lastSyncedToQuickbooksAt
  quickbooksLastSyncAttemptAt
}
    `;
export const ContactAccessorialChargeDetailsDataFragmentDoc = gql`
    fragment ContactAccessorialChargeDetailsData on ContactAccessorialChargeDetailsEntity {
  contactUuid
  displayName
  contactReferenceNumber
  shipmentsWithAccessorialCount
  totalAccessorialCharge
}
    `;
export const TerminalAccessorialChargeDetailsDataFragmentDoc = gql`
    fragment TerminalAccessorialChargeDetailsData on TerminalAccessorialChargeDetailsEntity {
  terminalUuid
  terminalCode
  chargeDetailsByContact {
    ...ContactAccessorialChargeDetailsData
  }
}
    ${ContactAccessorialChargeDetailsDataFragmentDoc}`;
export const AccessorialChargeDetailsDataFragmentDoc = gql`
    fragment AccessorialChargeDetailsData on AccessorialChargeDetailsEntity {
  accessorialUuid
  accessorialName
  chargeDetailsByContact {
    ...ContactAccessorialChargeDetailsData
  }
  chargeDetailsByTerminal {
    ...TerminalAccessorialChargeDetailsData
  }
}
    ${ContactAccessorialChargeDetailsDataFragmentDoc}
${TerminalAccessorialChargeDetailsDataFragmentDoc}`;
export const AccountsReceivableDataFragmentDoc = gql`
    fragment AccountsReceivableData on AccountsReceivableReportDataForContactEntity {
  contactUuid
  displayName
  contactReferenceNumber
  totalInvoices
  totalPayments
  unappliedPayments
  totalCredits
  unappliedCredits
  totalDebits
  unappliedDebits
  balance
}
    `;
export const AgingReportBucketFragmentDoc = gql`
    fragment AgingReportBucket on AgingReportBucketEntity {
  greaterThanOrEqualToDays
  lessThanOrEqualToDays
  openInvoiceValue
  label
}
    `;
export const InvoiceForAgingReportFragmentDoc = gql`
    fragment InvoiceForAgingReport on InvoiceForAgingReportEntity {
  journalNumber
  totalOpenAmount
  dueDate
  date
  age
  name
}
    `;
export const AgingReportDataFragmentDoc = gql`
    fragment AgingReportData on AgingReportForContactEntity {
  contactUuid
  displayName
  contactAddress {
    name
    line1
    line2
    city
    state
    zip
  }
  openInvoiceValueBuckets {
    ...AgingReportBucket
  }
  invoices {
    ...InvoiceForAgingReport
  }
  unappliedPaymentsTotal
}
    ${AgingReportBucketFragmentDoc}
${InvoiceForAgingReportFragmentDoc}`;
export const PaymentForMemoReportFragmentDoc = gql`
    fragment PaymentForMemoReport on PaymentEntity {
  uuid
  paymentType
  paymentRail
  amountInCents
  date
  creditNumber
  referenceNumber
  comment
  creditType {
    name
  }
  contact {
    uuid
    displayName
    billingContactEmail
    defaultAddress {
      ...Address
    }
    defaultContactPerson {
      firstName
      lastName
      phone
    }
  }
  invoicesAppliedTo {
    uuid
    name
    journalNumber
    date
    invoiceTotal
    balanceInCents
  }
  paymentOffsets {
    ...PaymentOffset
  }
  paymentToOrderMappings {
    uuid
    amountInCents
    order {
      totalCharge
      balanceInCents
      standardOrderFields {
        shipperBillOfLadingNumber
      }
      shipments {
        invoice {
          uuid
        }
      }
    }
  }
}
    ${AddressFragmentDoc}
${PaymentOffsetFragmentDoc}`;
export const IncomeAnalysisTerminalBucketFragmentDoc = gql`
    fragment IncomeAnalysisTerminalBucket on IncomeAnalysisTerminalBucketEntity {
  kind
  label
  terminalUuid
  totalRevenue
  numberOfShipments
}
    `;
export const InvoiceBillingSummaryReportV2LineItemFragmentDoc = gql`
    fragment InvoiceBillingSummaryReportV2LineItem on InvoiceBillingSummaryLineItemEntity {
  orderName
  invoiceName
  totalCharge
  shipperBillOfLadingNumber
  invoiceStatus
  refNumbers
  contactDisplayName
  contactReferenceNumber
  serviceLevel
  invoiceDate
  serviceDate
  pieces
  weight
  inboundAddressName
  outboundAddressName
  shipmentsIncludedInLineItemRevenue {
    terminalCode
    shipmentTypeForCharge
  }
  orderLineHaulLane {
    originTerminalCode
    destinationTerminalCode
  }
}
    `;
export const InvoiceBillingSummaryReportV2SubgroupFragmentDoc = gql`
    fragment InvoiceBillingSummaryReportV2Subgroup on InvoiceBillingSummaryV2Subgroup {
  subgroupLabel
  lineItems {
    ...InvoiceBillingSummaryReportV2LineItem
  }
  subgroupTotal
}
    ${InvoiceBillingSummaryReportV2LineItemFragmentDoc}`;
export const InvoiceBillingSummaryReportV2GroupFragmentDoc = gql`
    fragment InvoiceBillingSummaryReportV2Group on InvoiceBillingSummaryV2Group {
  groupLabel
  subgroups {
    ...InvoiceBillingSummaryReportV2Subgroup
  }
  groupTotal
  totalLineItems
}
    ${InvoiceBillingSummaryReportV2SubgroupFragmentDoc}`;
export const InvoiceBillingSummaryReportV2FragmentDoc = gql`
    fragment InvoiceBillingSummaryReportV2 on InvoiceBillingSummaryV2Output {
  groups {
    ...InvoiceBillingSummaryReportV2Group
  }
  total
}
    ${InvoiceBillingSummaryReportV2GroupFragmentDoc}`;
export const OrderForOpenInvoiceReportFragmentDoc = gql`
    fragment OrderForOpenInvoiceReport on OrderForOpenInvoiceReportEntity {
  orderUuid
  orderName
  shipperBillOfLadingNumber
  masterAirwayBillOfLadingNumber
  refNumbers
  addressName
  originTerminalCode
  destinationTerminalCode
  serviceDate
  pieces
  weight
  orderTotalCents
  orderBalanceCents
}
    `;
export const InvoiceForOpenInvoiceReportFragmentDoc = gql`
    fragment InvoiceForOpenInvoiceReport on InvoiceForOpenInvoiceReportEntity {
  uuid
  journalNumber
  name
  date
  dueDate
  status
  invoiceTotalCents
  invoiceBalanceCents
  billingPartyContactUuid
  billingPartyContactDisplayName
  billingPartyContactReferenceNumber
  orders {
    ...OrderForOpenInvoiceReport
  }
}
    ${OrderForOpenInvoiceReportFragmentDoc}`;
export const InvoiceForOrderSummaryReportFragmentDoc = gql`
    fragment InvoiceForOrderSummaryReport on InvoiceEntity {
  name
  date
  journalNumber
  invoiceTotal
  totalOpenAmount
  shipments {
    uuid
    totalChargesAmount
    standardShipmentFields {
      pickupOrDelivery
    }
    order {
      uuid
      balanceInCents
      standardOrderFields {
        shipperBillOfLadingNumber
        masterAirwayBillOfLadingNumber
      }
      packages {
        quantity
      }
      weight
      dimWeight
      refNumbers
    }
    legs {
      endStop {
        completedAt
        stopType
        address {
          name
        }
      }
    }
  }
  billToContact {
    displayName
    billingContactEmail
    defaultContactPerson {
      firstName
      lastName
      phone
    }
    defaultAddress {
      ...Address
    }
  }
}
    ${AddressFragmentDoc}`;
export const OrderForPaymentApplicationReportFragmentDoc = gql`
    fragment OrderForPaymentApplicationReport on OrderForPaymentApplicationReportEntity {
  orderUuid
  orderName
  shipperBillOfLadingNumber
  masterAirwayBillOfLadingNumber
  refNumbers
  inboundAddressName
  outboundAddressName
  pieces
  weight
  orderTotal
  orderBalance
  appliedAmount
  invoiceUuid
  invoiceName
  invoiceJournalNumber
  invoiceDate
  invoiceContactDisplayName
  invoiceTotal
  invoiceBalance
}
    `;
export const PaymentForPaymentApplicationReportFragmentDoc = gql`
    fragment PaymentForPaymentApplicationReport on PaymentForPaymentApplicationReportEntity {
  paymentUuid
  referenceNumber
  paymentDate
  paymentType
  paymentRail
  comment
  totalAmount
  unappliedAmount
  contactUuid
  contactDisplayName
  contactReferenceNumber
  masterAccountName
  orders {
    ...OrderForPaymentApplicationReport
  }
}
    ${OrderForPaymentApplicationReportFragmentDoc}`;
export const PaymentToOrderMappingForJournalReportFragmentDoc = gql`
    fragment PaymentToOrderMappingForJournalReport on PaymentToOrderMappingEntity {
  amountInCents
  order {
    name
    standardOrderFields {
      shipperBillOfLadingNumber
    }
    shipments {
      invoice {
        name
        journalNumber
        date
      }
    }
  }
}
    `;
export const PaymentForJournalReportOldFragmentDoc = gql`
    fragment PaymentForJournalReportOld on PaymentEntity {
  paymentType
  paymentRail
  amountInCents
  date
  referenceNumber
  creditNumber
  comment
  unappliedAmountInCents
  creditType {
    name
  }
  contact {
    uuid
    displayName
  }
  glTerminal {
    name
  }
  paymentToOrderMappings {
    ...PaymentToOrderMappingForJournalReport
  }
}
    ${PaymentToOrderMappingForJournalReportFragmentDoc}`;
export const OrderForPaymentJournalReportFragmentDoc = gql`
    fragment OrderForPaymentJournalReport on OrderForPaymentJournalReportEntity {
  orderUuid
  orderName
  shipperBillOfLadingNumber
  appliedAmountDollars
  invoiceUuid
  invoiceName
  invoiceJournalNumber
  invoiceDate
  invoiceCustomerName
}
    `;
export const PaymentForJournalReportFragmentDoc = gql`
    fragment PaymentForJournalReport on PaymentForPaymentJournalReportEntity {
  paymentUuid
  paymentType
  paymentRail
  paymentDate
  referenceNumber
  creditNumber
  comment
  totalAmount
  unappliedAmountDollars
  creditTypeName
  glTerminalName
  contactUuid
  contactDisplayName
  contactReferenceNumber
  orders {
    ...OrderForPaymentJournalReport
  }
}
    ${OrderForPaymentJournalReportFragmentDoc}`;
export const RevenueReportOrderDataFragmentDoc = gql`
    fragment RevenueReportOrderData on RevenueReportOrderEntity {
  uuid
  name
  totalCharge
  pickupRevenue
  deliveryRevenue
  lineHaulRevenue
  shipperBillOfLadingNumber
  masterAirwayBillOfLadingNumber
  contactUuid
  contactName
  contactReferenceNumber
  packageQuantity
  packageWeight
  podUploaded
  stopTypes
  serviceDates
  controllingTerminalCode
  inboundAddressString
  outboundAddressString
  detailedStatusV2
  inboundStopType
  outboundStopType
}
    `;
export const ShallowInvoiceWithoutShipmentsFragmentDoc = gql`
    fragment ShallowInvoiceWithoutShipments on InvoiceEntity {
  uuid
  name
  journalNumber
  createdAt
  dueDate
  date
  status
  source
  qbInvoiceNumber
  quickbooksInvoiceId
  lastSyncedToQuickbooksAt
  quickbooksLastSyncAttemptAt
  quickbooksSyncFailureCode
  quickbooksSyncFailureTitle
  quickbooksSyncFailureDetail
  quickbooksSyncFailureRemediation
  quickbooksSyncFailureElement
  quickbooksSyncFaultCode
  quickbooksSyncRequestId
  emailOptions
  invoiceTerms {
    uuid
    terms
  }
  billToContact {
    uuid
    displayName
    billingCycleDuration
    ediPartnerships {
      stedi210MappingId
      stedi210TransactionSettingId
      ediOutboundPayloadDestination
    }
  }
  firstShipment {
    uuid
  }
  latest210EdiStatus {
    uuid
    status
    errorSummary
    updatedAt
  }
}
    `;
export const ShallowInvoiceV2FragmentDoc = gql`
    fragment ShallowInvoiceV2 on InvoiceEntity {
  uuid
  date
  createdAt
  quickbooksInvoiceId
  lastSyncedToQuickbooksAt
  lastSyncedFromQuickbooksAt
  quickbooksLastSyncAttemptAt
  quickbooksSyncFailureCode
  quickbooksSyncFailureTitle
  quickbooksSyncFailureRemediation
  syncedToQuickbooksDesktopAt
  manuallySyncedToQuickbooksDesktopAt
  name
  journalNumber
  status
  hasAppliedPayments
  dueDate
  billToContact {
    displayName
  }
  latest210EdiStatus {
    uuid
    status
    errorSummary
    updatedAt
  }
}
    `;
export const OrderProratedWithFragmentDoc = gql`
    fragment OrderProratedWith on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  name
  status
}
    `;
export const TypeAheadOrderFragmentDoc = gql`
    fragment TypeAheadOrder on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  billingPartyContact {
    uuid
    invoiceTimePeriodSplit
    numberOfOrdersPerInvoice
    displayName
  }
  shipments {
    uuid
    hideFromBilling
    invoice {
      uuid
    }
  }
  name
  status
  ordersProratedWith {
    ...OrderProratedWith
  }
}
    ${OrderProratedWithFragmentDoc}`;
export const ContactItemsItemFragmentDoc = gql`
    fragment ContactItemsItem on ItemEntity {
  uuid
  sku
  description
  primaryUOM {
    unitOfMeasure
  }
  secondaryUOM {
    unitOfMeasure
  }
}
    `;
export const LegInfoFragmentDoc = gql`
    fragment LegInfo on LegEntity {
  miles
  flatRate
  name
  uuid
  completedAt
  endStop {
    completedAt
    address {
      name
    }
  }
  shipment {
    name
    totalChargesAmount
    totalChargesForDriverSettlement
    charges {
      ... on CustomChargeEntity {
        total
      }
      ... on FreightChargeEntity {
        total
      }
    }
    legs {
      uuid
    }
    standardShipmentFields {
      uuid
      pickupOrDelivery
    }
    uuid
    order {
      uuid
      name
      standardOrderFields {
        shipperBillOfLadingNumber
      }
      shipments {
        uuid
        name
      }
    }
  }
}
    `;
export const TerminalForDetailedLineHaulManifestFragmentDoc = gql`
    fragment TerminalForDetailedLineHaulManifest on TerminalEntity {
  uuid
  code
}
    `;
export const ShallowLineHaulLaneFragmentDoc = gql`
    fragment ShallowLineHaulLane on LineHaulLaneEntity {
  uuid
  name
  originTerminal {
    uuid
    code
  }
  destinationTerminal {
    uuid
    code
  }
  isActive
}
    `;
export const LineHaulOrderFragmentDoc = gql`
    fragment LineHaulOrder on OrderEntity {
  uuid
  name
  standardOrderFields {
    weightUnits
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  detailedStatusV2
  refusedBy
  receivedDate
  osd
  status
  tags {
    ...Tag
  }
  lineHaulLane {
    ...ShallowLineHaulLane
  }
  weight
  dimWeight
  lineHaulServiceDisplayString
  packages {
    uuid
    length
    width
    height
    weight
    type
  }
  pieceCountFromPackages
  billingPartyContact {
    displayName
  }
  refNumbers
}
    ${TagFragmentDoc}
${ShallowLineHaulLaneFragmentDoc}`;
export const DetailedLineHaulManifestFragmentDoc = gql`
    fragment DetailedLineHaulManifest on LineHaulManifestEntity {
  referenceNumber
  startTerminal {
    ...TerminalForDetailedLineHaulManifest
  }
  endTerminal {
    ...TerminalForDetailedLineHaulManifest
  }
  createdAt
  departDate
  status
  isRecurringGenerated
  hasFreightArrivedWhileUndeparted
  estimatedDeparture
  estimatedArrival
  departTimeMinutes
  loadPosition
  ordersOnManifest {
    orderUuid
    ordinal
    loadPosition
  }
  startedAt
  completedAt
  uuid
  driver {
    uuid
    driverReferenceNumber
    firstName
    lastName
    agent {
      name
    }
  }
  equipment {
    uuid
    name
    type
  }
  orders {
    uuid
    name
    standardOrderFields {
      weightUnits
      shipperBillOfLadingNumber
      masterAirwayBillOfLadingNumber
    }
    tags {
      value
    }
    weight
    dimWeight
    pieceCountFromPackages
    packages {
      length
      width
      height
      weight
    }
    billingPartyContact {
      displayName
    }
    hazmat
    refNumbers
    dateMarkedReceivedAtOrigin
    lineHaulLane {
      destinationTerminal {
        code
      }
    }
    shipments {
      standardShipmentFields {
        deadlineDate
      }
      legs {
        endStop {
          stopType
          inboundMethod
          outboundMethod
          serviceDate
          incomingCarrier
          outboundCarrier
          address {
            name
            line1
            line2
            city
            state
            zip
            country
          }
        }
      }
    }
  }
  orderSegments {
    order {
      ...LineHaulOrder
    }
    arrivalScans {
      uuid
      scannedAt
    }
    departureScans {
      uuid
      scannedAt
    }
    arrivedAt
  }
  sentToAgentAt
  confirmedByAgentAt
}
    ${TerminalForDetailedLineHaulManifestFragmentDoc}
${LineHaulOrderFragmentDoc}`;
export const TerminalLineHaulStatusFragmentDoc = gql`
    fragment TerminalLineHaulStatus on LineHaulStatusByTerminal {
  terminal {
    uuid
    code
  }
  markedArrivedAt
  manifestDepartingFromThisTerminal {
    uuid
    status
    departDate
    startedAt
    completedAt
    referenceNumber
    driver {
      firstName
      lastName
    }
  }
  arrivalScans {
    uuid
    scannedAt
  }
  departureScans {
    uuid
    scannedAt
  }
}
    `;
export const LineHaulManifestOrderFragmentDoc = gql`
    fragment LineHaulManifestOrder on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
    weightUnits
  }
  packages {
    uuid
    length
    width
    height
    weight
    quantity
    type
  }
  weight
  dimWeight
  refNumbers
  billingPartyContact {
    displayName
  }
  name
}
    `;
export const LineHaulOrderForPrintedManifestFragmentDoc = gql`
    fragment LineHaulOrderForPrintedManifest on OrderEntity {
  uuid
  name
  dateMarkedReceivedAtOrigin
  standardOrderFields {
    masterAirwayBillOfLadingNumber
    shipperBillOfLadingNumber
  }
  lineHaulLane {
    ...ShallowLineHaulLane
  }
  weight
  dimWeight
  tags {
    value
  }
  pieceCountFromPackages
  billingPartyContact {
    displayName
  }
  shipments {
    standardShipmentFields {
      pickupOrDelivery
      deadlineDate
    }
    airportInfo {
      address {
        name
      }
    }
    legs {
      endStop {
        stopType
        serviceDate
        address {
          name
          line1
          line2
          city
          state
          zip
        }
        inboundMethod
        outboundMethod
        incomingCarrier
        outboundCarrier
      }
    }
  }
  refNumbers
  hazmat
}
    ${ShallowLineHaulLaneFragmentDoc}`;
export const LineHaulManifestForPrintFragmentDoc = gql`
    fragment LineHaulManifestForPrint on LineHaulManifestEntity {
  referenceNumber
  startTerminal {
    ...TerminalForDetailedLineHaulManifest
  }
  endTerminal {
    ...TerminalForDetailedLineHaulManifest
  }
  departDate
  status
  startedAt
  completedAt
  uuid
  driver {
    uuid
    driverReferenceNumber
    firstName
    lastName
  }
  equipment {
    uuid
    name
    type
  }
  orderSegments {
    order {
      ...LineHaulOrderForPrintedManifest
    }
    segment {
      ordinal
      startTerminal {
        name
        code
      }
      endTerminal {
        name
        code
      }
    }
    priorOrderLineHaulSegment {
      arrivedAt
    }
  }
}
    ${TerminalForDetailedLineHaulManifestFragmentDoc}
${LineHaulOrderForPrintedManifestFragmentDoc}`;
export const ShallowLineHaulSegmentFragmentDoc = gql`
    fragment ShallowLineHaulSegment on LineHaulSegmentEntity {
  uuid
  ordinal
  startTerminal {
    uuid
    code
  }
  endTerminal {
    uuid
    code
  }
}
    `;
export const LineHaulOrderWithUpcomingSegmentAndInboundStopStatusFragmentDoc = gql`
    fragment LineHaulOrderWithUpcomingSegmentAndInboundStopStatus on OrderEntity {
  uuid
  upcomingLineHaulSegment {
    ...ShallowLineHaulSegment
  }
  hasNoneOrCompletedInboundStop
  lastCompletedLineHaulSegment {
    ...ShallowLineHaulSegment
  }
}
    ${ShallowLineHaulSegmentFragmentDoc}`;
export const SegmentedLineHaulOrderFragmentDoc = gql`
    fragment SegmentedLineHaulOrder on OrderLineHaulSegmentEntity {
  uuid
  order {
    uuid
    name
    standardOrderFields {
      weightUnits
      shipperBillOfLadingNumber
      masterAirwayBillOfLadingNumber
    }
    pieceCountFromPackages
    tags {
      ...Tag
    }
    dateMarkedReceivedAtOrigin
    lineHaulLane {
      ...ShallowLineHaulLane
    }
    weight
    dimWeight
    lineHaulServiceDisplayString
    billingPartyContact {
      displayName
    }
    hazmat
    startStop {
      serviceDate
      isSpecial
      address {
        name
      }
      incomingCarrier
      terminal {
        code
      }
    }
    endStop {
      serviceDate
      isSpecial
      address {
        name
      }
      outboundCarrier
      destinationAirport
      terminal {
        code
      }
      leg {
        shipment {
          standardShipmentFields {
            deadlineDate
          }
        }
      }
    }
  }
  segment {
    ...ShallowLineHaulSegment
  }
}
    ${TagFragmentDoc}
${ShallowLineHaulLaneFragmentDoc}
${ShallowLineHaulSegmentFragmentDoc}`;
export const ShallowLineHaulManifestFragmentDoc = gql`
    fragment ShallowLineHaulManifest on LineHaulManifestEntity {
  startTerminal {
    uuid
    code
  }
  endTerminal {
    uuid
    code
  }
  departDate
  uuid
  driver {
    uuid
    driverReferenceNumber
    firstName
    lastName
  }
}
    `;
export const LineHaulSegmentTimingFragmentDoc = gql`
    fragment LineHaulSegmentTiming on LineHaulSegmentTimingEntity {
  startTerminalUuid
  startTerminalCode
  endTerminalUuid
  endTerminalCode
  cutoffTime
  transitDays
  transitMinutes
}
    `;
export const AccessorialNamesFragmentDoc = gql`
    fragment AccessorialNames on AccessorialUnion {
  __typename
  ... on StandardAccessorialEntity {
    name
    uuid
  }
  ... on PercentageAccessorialEntity {
    name
    uuid
  }
  ... on WeightBasedAccessorialEntity {
    name
    uuid
  }
  ... on ZoneBasedAccessorialEntity {
    name
    uuid
  }
  ... on WaitTimeAccessorialEntity {
    name
    uuid
  }
  ... on UnitBasedAccessorialEntity {
    name
    uuid
  }
  ... on SkidBasedAccessorialEntity {
    name
    uuid
  }
  ... on SpecialAccessorialEntity {
    name
    uuid
  }
  ... on AttemptsAccessorialEntity {
    name
    uuid
  }
  ... on StorageDaysAccessorialEntity {
    name
    uuid
  }
}
    `;
export const AccessorialGroupFragmentDoc = gql`
    fragment AccessorialGroup on AccessorialGroupEntity {
  id
  name
  description
  accessorials {
    ...AccessorialNames
  }
}
    ${AccessorialNamesFragmentDoc}`;
export const RecurringLineHaulManifestTemplateFragmentDoc = gql`
    fragment RecurringLineHaulManifestTemplate on RecurringLineHaulManifestTemplateEntity {
  uuid
  createdAt
  updatedAt
  startTerminalUuid
  endTerminalUuid
  daysOfWeek
  departTimeMinutes
  transitMinutes
  startDate
  endDate
  manifestsPerOccurrence
  defaultDriverUuid
  defaultEquipmentUuid
  createInAdvanceHours
  createAheadDays
  skipDates
  isActive
  autoGenerate
  lastProcessedAt
  truckCount
}
    `;
export const ServiceGroupFragmentDoc = gql`
    fragment ServiceGroup on ServiceGroupEntity {
  id
  name
  description
  services {
    uuid
    name
  }
}
    `;
export const CompanyDefaultTariffChainFragmentDoc = gql`
    fragment CompanyDefaultTariffChain on TariffChainEntity {
  id
  name
}
    `;
export const TariffChainWithGroupsFragmentDoc = gql`
    fragment TariffChainWithGroups on TariffChainEntity {
  id
  name
  tariffGroupType
  tariffGroups {
    uuid
    name
  }
}
    `;
export const TariffGroupForTableFragmentDoc = gql`
    fragment TariffGroupForTable on TariffGroupEntity {
  uuid
  name
  tariffGroupScope
  tariffGroupType
  startDate
  endDate
  rateMultiplier
  firstTariff {
    tariffType
    rateType
    tariffZone {
      type
    }
  }
  totalContactsToServicesMappings
  contactToServicesMappings(first: 2) {
    contact {
      displayName
    }
  }
  customerUsage @include(if: $includeCustomerUsage) {
    totalDirectCustomers
    companyDefaultCustomerCount
    previewCustomers {
      uuid
      displayName
    }
  }
}
    `;
export const TariffGroupSettingsFragmentDoc = gql`
    fragment TariffGroupSettings on TariffGroupEntity {
  uuid
  name
  tariffGroupType
  tariffGroupScope
  contactToServicesMappings {
    contact {
      uuid
      displayName
    }
    services {
      uuid
      name
    }
  }
  rateMultiplier
  startDate
  endDate
  useActualWeightInCalculation
  useDeficitBilling
  fuelProfile {
    uuid
    name
  }
  terminals {
    uuid
    code
    name
  }
  tariffZoneGroup {
    id
  }
  services {
    uuid
  }
  vehicleTypes {
    uuid
  }
}
    `;
export const TariffOverageRateFragmentDoc = gql`
    fragment TariffOverageRate on TariffOverageRateEntity {
  uuid
  name
  type
  rateUsdCents
  flatRateUsdCents
  applicableAboveAmount
  applyRateToFullAmount
}
    `;
export const TariffRangeFragmentDoc = gql`
    fragment TariffRange on TariffRangeEntity {
  uuid
  lessThanOrEqualToValue
  rateUsdCents
}
    `;
export const TariffForTariffGroupFragmentDoc = gql`
    fragment TariffForTariffGroup on TariffEntity {
  uuid
  minimumUsdCents
  maximumUsdCents
  maximumIncludesFuel
  tariffType
  rateType
  billingPartyContactUuid
  settlementPercentageRate
  isActive
  service {
    ...Service
  }
  tariffOverageRates {
    ...TariffOverageRate
  }
  tariffZone {
    uuid
    name
    type
    mileRangeStart
    mileRangeEnd
    billingPartyContactUuid
    inboundZone {
      uuid
      name
    }
    outboundZone {
      uuid
      name
    }
  }
  tariffRanges {
    ...TariffRange
  }
  useActualWeight
  useActualWeightInCalculation
}
    ${ServiceFragmentDoc}
${TariffOverageRateFragmentDoc}
${TariffRangeFragmentDoc}`;
export const TariffGroupFragmentDoc = gql`
    fragment TariffGroup on TariffGroupEntity {
  ...TariffGroupSettings
  tariffs {
    ...TariffForTariffGroup
  }
}
    ${TariffGroupSettingsFragmentDoc}
${TariffForTariffGroupFragmentDoc}`;
export const FuelProfileDateRangeFragmentDoc = gql`
    fragment FuelProfileDateRange on FuelProfileDateRangeEntity {
  uuid
  startDate
  expirationDate
  surchargeRate
  flatRateUsdCents
}
    `;
export const ShallowTariffGroupFuelProfileFragmentDoc = gql`
    fragment ShallowTariffGroupFuelProfile on FuelProfileEntity {
  uuid
  name
  startDate
  expirationDate
  billingType
  type
  company {
    uuid
  }
  contacts {
    uuid
    displayName
  }
  fuelProfileDateRanges {
    ...FuelProfileDateRange
  }
}
    ${FuelProfileDateRangeFragmentDoc}`;
export const TariffGroupForTariffFragmentDoc = gql`
    fragment TariffGroupForTariff on TariffGroupEntity {
  uuid
  name
  tariffGroupScope
  tariffGroupType
  contactToServicesMappings {
    contact {
      uuid
      displayName
    }
    services {
      uuid
      name
    }
  }
  parentTariffGroup {
    uuid
    contactToServicesMappings {
      contact {
        uuid
        displayName
      }
      services {
        uuid
        name
      }
    }
  }
  rateMultiplier
  useActualWeightInCalculation
  fuelProfile {
    ...ShallowTariffGroupFuelProfile
  }
}
    ${ShallowTariffGroupFuelProfileFragmentDoc}`;
export const TariffFragmentDoc = gql`
    fragment Tariff on TariffEntity {
  uuid
  minimumUsdCents
  maximumUsdCents
  maximumIncludesFuel
  settlementPercentageRate
  tariffType
  rateType
  billingPartyContactUuid
  service {
    ...Service
  }
  tariffOverageRates {
    ...TariffOverageRate
  }
  tariffZone {
    ...TariffZone
  }
  tariffRanges {
    ...TariffRange
  }
  tariffGroup {
    ...TariffGroupForTariff
  }
  useActualWeight
  useActualWeightInCalculation
}
    ${ServiceFragmentDoc}
${TariffOverageRateFragmentDoc}
${TariffZoneFragmentDoc}
${TariffRangeFragmentDoc}
${TariffGroupForTariffFragmentDoc}`;
export const ShallowTariffGroupFragmentDoc = gql`
    fragment ShallowTariffGroup on TariffGroupEntity {
  uuid
  name
  tariffGroupScope
  tariffGroupType
  contactToServicesMappings {
    contact {
      uuid
      displayName
    }
    services {
      uuid
      name
    }
  }
  parentTariffGroup {
    uuid
    tariffs {
      ...Tariff
    }
    contactToServicesMappings {
      contact {
        uuid
        displayName
      }
      services {
        uuid
        name
      }
    }
  }
  rateMultiplier
  useActualWeightInCalculation
  fuelProfile {
    ...ShallowTariffGroupFuelProfile
  }
  terminals {
    uuid
    code
    name
  }
}
    ${TariffFragmentDoc}
${ShallowTariffGroupFuelProfileFragmentDoc}`;
export const TariffFragmentFragmentDoc = gql`
    fragment TariffFragment on TariffEntity {
  uuid
  tariffType
  minimumUsdCents
  rateType
  maximumUsdCents
  maximumIncludesFuel
  billingPartyContactUuid
  service {
    ...Service
  }
  tariffZone {
    ...TariffZone
  }
  tariffOverageRates {
    ...TariffOverageRate
  }
  tariffRanges {
    ...TariffRange
  }
  useActualWeightInCalculation
  useActualWeight
  tariffGroup {
    ...ShallowTariffGroup
  }
}
    ${ServiceFragmentDoc}
${TariffZoneFragmentDoc}
${TariffOverageRateFragmentDoc}
${TariffRangeFragmentDoc}
${ShallowTariffGroupFragmentDoc}`;
export const TariffZoneGroupFragmentDoc = gql`
    fragment TariffZoneGroup on TariffZoneGroupEntity {
  id
  name
  description
}
    `;
export const TariffZoneGroupWithTariffZonesFragmentDoc = gql`
    fragment TariffZoneGroupWithTariffZones on TariffZoneGroupEntity {
  id
  name
  description
  tariffZones {
    uuid
    name
    type
    tariffZoneLocationType
    locations {
      uuid
      zipcode
    }
    lineHaulLane {
      isActive
    }
  }
}
    `;
export const AccessorialDateRangeConfigFragmentDoc = gql`
    fragment AccessorialDateRangeConfig on AccessorialDateRangeConfigEntity {
  uuid
  startDate
  endDate
  percentForSettlement
  fuelSurchargePercentageRate
  rate
  fuelProfile {
    uuid
  }
  accessorialRanges {
    ...AccessorialRange
  }
}
    ${AccessorialRangeFragmentDoc}`;
export const AccessorialsUuidFragmentDoc = gql`
    fragment AccessorialsUuid on AccessorialUnion {
  ... on StandardAccessorialEntity {
    uuid
  }
  ... on PercentageAccessorialEntity {
    uuid
  }
  ... on WeightBasedAccessorialEntity {
    uuid
  }
  ... on ZoneBasedAccessorialEntity {
    uuid
  }
  ... on WaitTimeAccessorialEntity {
    uuid
  }
  ... on UnitBasedAccessorialEntity {
    uuid
  }
  ... on SkidBasedAccessorialEntity {
    uuid
  }
  ... on SpecialAccessorialEntity {
    uuid
  }
  ... on AttemptsAccessorialEntity {
    uuid
  }
  ... on StorageDaysAccessorialEntity {
    uuid
  }
}
    `;
export const AccessorialsTableRowFragmentDoc = gql`
    fragment AccessorialsTableRow on AccessorialUnion {
  ... on StandardAccessorialEntity {
    __typename
    uuid
    isArchived
    name
    enableQuickAdd
    rate
    qboItemId
    unsyncedInvoiceCount
    contact {
      uuid
    }
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on PercentageAccessorialEntity {
    __typename
    uuid
    isArchived
    name
    enableQuickAdd
    rate
    qboItemId
    unsyncedInvoiceCount
    contact {
      uuid
    }
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on UnitBasedAccessorialEntity {
    __typename
    uuid
    isArchived
    name
    enableQuickAdd
    ratePerUnit
    qboItemId
    unsyncedInvoiceCount
    contact {
      uuid
    }
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on SkidBasedAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    ratePerSkid
    qboItemId
    unsyncedInvoiceCount
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on WaitTimeAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    rate
    waitTimeChargePeriod
    qboItemId
    unsyncedInvoiceCount
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on WeightBasedAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    ratePerHundredWeight
    qboItemId
    unsyncedInvoiceCount
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on ZoneBasedAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    zones {
      uuid
    }
    qboItemId
    unsyncedInvoiceCount
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on SpecialAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    qboItemId
    unsyncedInvoiceCount
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on AttemptsAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    qboItemId
    unsyncedInvoiceCount
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
  ... on StorageDaysAccessorialEntity {
    __typename
    uuid
    isArchived
    contact {
      uuid
    }
    name
    enableQuickAdd
    qboItemId
    unsyncedInvoiceCount
    terminal {
      ...AccessorialTerminal
    }
    generalLedgerCode {
      code
      description
    }
  }
}
    ${AccessorialTerminalFragmentDoc}`;
export const GeneralLedgerCodeFragmentDoc = gql`
    fragment GeneralLedgerCode on GeneralLedgerCodeEntity {
  id
  code
  description
  accessorials {
    ... on StandardAccessorialEntity {
      name
      uuid
    }
    ... on PercentageAccessorialEntity {
      name
      uuid
    }
    ... on UnitBasedAccessorialEntity {
      name
      uuid
    }
    ... on SkidBasedAccessorialEntity {
      name
      uuid
    }
    ... on WaitTimeAccessorialEntity {
      name
      uuid
    }
    ... on WeightBasedAccessorialEntity {
      name
      uuid
    }
    ... on SpecialAccessorialEntity {
      name
      uuid
    }
    ... on ZoneBasedAccessorialEntity {
      name
      uuid
    }
  }
  creditTypes {
    name
    uuid
  }
}
    `;
export const InvoiceNoteRuleFragmentDoc = gql`
    fragment InvoiceNoteRule on InvoiceNoteRuleEntity {
  uuid
  contactUuid
  contactDisplayName
  serviceUuid
  serviceName
  terminalUuid
  terminalName
  rebilled
  note
  includeCompanyNote
}
    `;
export const MasterAccountFragmentDoc = gql`
    fragment MasterAccount on MasterAccountEntity {
  uuid
  name
}
    `;
export const SettlementDeductionTypeFragmentDoc = gql`
    fragment SettlementDeductionType on SettlementDeductionTypeEntity {
  uuid
  name
  percentageRate
  flatRate
}
    `;
export const FindBusinessDivisionsFragmentDoc = gql`
    fragment FindBusinessDivisions on BusinessDivisionEntity {
  uuid
  name
}
    `;
export const DriverSignableFormFragmentDoc = gql`
    fragment DriverSignableForm on DriverSignableFormTemplateEntity {
  uuid
  title
  formText
  createdAt
}
    `;
export const DriverCredentialTypeFragmentDoc = gql`
    fragment DriverCredentialType on DriverCredentialTypeEntity {
  uuid
  name
  kind
  systemKey
  active
}
    `;
export const DriverCredentialFragmentDoc = gql`
    fragment DriverCredential on DriverCredentialEntity {
  uuid
  referenceNumber
  completedOn {
    iso8601
  }
  expiresOn {
    iso8601
  }
  notes
  status
  type {
    ...DriverCredentialType
  }
}
    ${DriverCredentialTypeFragmentDoc}`;
export const DriverInsurancePolicyFragmentDoc = gql`
    fragment DriverInsurancePolicy on DriverInsurancePolicyEntity {
  uuid
  insuranceType
  carrierName
  policyNumber
  insuredAmountUsd
  effectiveOn {
    iso8601
  }
  expiresOn {
    iso8601
  }
  status
}
    `;
export const DriverComplianceFragmentDoc = gql`
    fragment DriverCompliance on DriverComplianceEntity {
  driverUuid
  profile {
    licenseNumber
    licenseClass
    licenseState
    securityId
    dateOfBirth {
      iso8601
    }
    hireDate {
      iso8601
    }
    isTerminated
    terminationDate {
      iso8601
    }
    terminationComments
  }
  credentials {
    ...DriverCredential
  }
  insurancePolicies {
    ...DriverInsurancePolicy
  }
}
    ${DriverCredentialFragmentDoc}
${DriverInsurancePolicyFragmentDoc}`;
export const DriverSettlementPayBoundFragmentDoc = gql`
    fragment DriverSettlementPayBound on DriverSettlementPayBoundEntity {
  payType
  minPayUsdCents
  maxPayUsdCents
}
    `;
export const FindFuelProfileFragmentDoc = gql`
    fragment FindFuelProfile on FuelProfileEntity {
  uuid
  name
  billingType
  type
  fuelProfileDateRanges {
    ...FuelProfileDateRange
  }
}
    ${FuelProfileDateRangeFragmentDoc}`;
export const FuelProfileFragmentDoc = gql`
    fragment FuelProfile on FuelProfileEntity {
  uuid
  name
  startDate
  expirationDate
  billingType
  type
  company {
    uuid
  }
  contacts {
    uuid
    displayName
  }
  fuelProfileDateRanges {
    ...FuelProfileDateRange
  }
}
    ${FuelProfileDateRangeFragmentDoc}`;
export const HoldReasonFragmentDoc = gql`
    fragment HoldReason on HoldReasonEntity {
  uuid
  name
  isArchived
}
    `;
export const LineHaulLaneFragmentDoc = gql`
    fragment LineHaulLane on LineHaulLaneEntity {
  uuid
  name
  originTerminal {
    ...ShallowTerminal
  }
  destinationTerminal {
    ...ShallowTerminal
  }
  segments {
    ...ShallowLineHaulSegment
  }
  isActive
}
    ${ShallowTerminalFragmentDoc}
${ShallowLineHaulSegmentFragmentDoc}`;
export const PackageSpecFragmentDoc = gql`
    fragment PackageSpec on PackageSpecEntity {
  id
  name
  status
  weight
  length
  width
  height
  freightClass
}
    `;
export const CompanyPackageTypeConfigFragmentDoc = gql`
    fragment CompanyPackageTypeConfig on CompanyPackageTypeConfigEntity {
  __typename
  id
  packageType
  isSingleHandlingUnit
}
    `;
export const ServiceForThirdPartyUserFragmentDoc = gql`
    fragment ServiceForThirdPartyUser on ServiceEntity {
  uuid
  name
  defaultInboundStopType
  defaultOutboundStopType
}
    `;
export const TerminalServiceAreaFragmentDoc = gql`
    fragment TerminalServiceArea on TerminalServiceAreaEntity {
  uuid
  zipcode
  city
}
    `;
export const TerminalFragmentDoc = gql`
    fragment Terminal on TerminalEntity {
  name
  code
  uuid
  address {
    line1
    line2
    city
    state
    zip
    uuid
    name
  }
  serviceAreas {
    ...TerminalServiceArea
  }
  isActive
  serviceRegion {
    id
    name
    isArchived
  }
  agent {
    uuid
    name
  }
  startForTerminalLanes {
    id
    endTerminal {
      uuid
      code
      name
    }
  }
}
    ${TerminalServiceAreaFragmentDoc}`;
export const UsersRoleFragmentDoc = gql`
    fragment UsersRole on RoleEntity {
  uuid
  name
}
    `;
export const UserFragmentDoc = gql`
    fragment User on UserEntity {
  uuid
  name
  reportsEmail
  email
  phoneNumber
  sendSummaryEmailWithIncompleteRoutes
  sendAllInvoices
  terminal {
    uuid
    name
  }
  roles {
    ...UsersRole
  }
  isActive
  holdsPrivilegedRole
  driver {
    uuid
  }
}
    ${UsersRoleFragmentDoc}`;
export const CreatedWarehouseEmployeeFragmentDoc = gql`
    fragment CreatedWarehouseEmployee on WarehouseEmployeeEntity {
  uuid
}
    `;
export const WarehouseEmployeeFragmentDoc = gql`
    fragment WarehouseEmployee on WarehouseEmployeeEntity {
  uuid
  firstName
  lastName
  emailAddress
  phoneNumber
  active
  isArchived
  password
}
    `;
export const UpdatedWarehouseEmployeeFragmentDoc = gql`
    fragment UpdatedWarehouseEmployee on WarehouseEmployeeEntity {
  uuid
}
    `;
export const InAppNotificationFragmentDoc = gql`
    fragment InAppNotification on InAppNotificationEntity {
  uuid
  eventType
  title
  body
  data
  readAt
  createdAt
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on NotificationEntity {
  uuid
  type
  acknowledged
  createdAt
  partnerCompanyName
  order {
    uuid
    name
    createdAt
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
  driverMarkedAttemptedStop {
    leg {
      shipment {
        order {
          name
        }
      }
    }
  }
  driverMarkedAttemptedDriver {
    uuid
    firstName
    lastName
  }
  targetAccessorial {
    ...AllAccessorialFields
  }
  targetStop {
    leg {
      shipment {
        order {
          name
        }
      }
    }
  }
  sourceDriver {
    uuid
    firstName
    lastName
  }
  emailTransaction {
    uuid
    updatedAt
    invoice {
      uuid
      name
      journalNumber
      billToContact {
        uuid
        displayName
      }
    }
    emailTransactionLogs {
      uuid
      email
      lastStatus
      reason
    }
  }
}
    ${AllAccessorialFieldsFragmentDoc}`;
export const OperationsPerformanceDurationFieldsFragmentDoc = gql`
    fragment OperationsPerformanceDurationFields on OperationsPerformanceDuration {
  meanSeconds
  medianSeconds
  p90Seconds
  countedOrders
  backwardOrders
  prior {
    medianSeconds
    countedOrders
  }
}
    `;
export const OperationsPerformanceGroupFieldsFragmentDoc = gql`
    fragment OperationsPerformanceGroupFields on OperationsPerformanceGroup {
  uuid
  name
  orders
  deliveredOrders
  medianSeconds
  intervals {
    key
    medianSeconds
    countedOrders
  }
}
    `;
export const OrderEventShipmentFragmentDoc = gql`
    fragment OrderEventShipment on ShipmentEntity {
  uuid
  name
  legs {
    endStop {
      stopType
    }
  }
}
    `;
export const OrderEventFragmentDoc = gql`
    fragment OrderEvent on OrderEventEntity {
  uuid
  createdAt
  ignoreSnapshot
  mirroredFromPartner
  message
  eventType
  sourceType
  targetType
  snapshot
  targetPhoneNumber
  targetEmail
  targetOrderTotalBeforeConsolidation
  targetOrderTotalAfterConsolidation
  order {
    uuid
    name
    standardOrderFields {
      uuid
      shipperBillOfLadingNumber
    }
    quote {
      uuid
      number
    }
    createdFromOrderTemplate {
      uuid
      name
    }
    source
  }
  sourceDriver {
    uuid
    firstName
    lastName
    user {
      name
    }
  }
  sourceWarehouseEmployee {
    uuid
    firstName
    lastName
  }
  sourceEdiTransaction {
    uuid
    status
    code
    edi214ShipmentStatus
    edi990ActionCode
  }
  sourceSftpUpload {
    uuid
    type
    status
  }
  sourceOutboundWebhookEvent {
    uuid
    createdAt
    type
    httpStatusCode
    error
  }
  sourceEfmOutboundRequestEvent {
    uuid
    createdAt
    requestType
    statusCode
    httpStatusCode
    error
    clockworkStatusQueueId
  }
  sourceExpeditorsOutboundRequestEvent {
    uuid
    createdAt
    requestType
    workOrderNumber
    httpStatusCode
    error
  }
  sourceUser {
    uuid
    email
  }
  targetContactPerson {
    uuid
    firstName
    lastName
    phone
  }
  targetDocument {
    fileName
    type
    uuid
  }
  targetDriver {
    uuid
    firstName
    lastName
    phoneNumber
    user {
      name
    }
  }
  targetInvoice {
    uuid
    name
  }
  targetRoute {
    uuid
    name
  }
  targetPiece {
    uuid
    referenceNumber
  }
  targetShipment {
    ...OrderEventShipment
  }
  targetShipmentSubscriber {
    uuid
    phoneNumber
  }
  targetStop {
    uuid
    address {
      uuid
      name
    }
  }
  targetSettlementBill {
    uuid
    name
    settlementDate
    finalizedDate
  }
}
    ${OrderEventShipmentFragmentDoc}`;
export const PackageDifferenceFragmentDoc = gql`
    fragment PackageDifference on SnapshotPackageDifferences {
  height {
    oldValue
    newValue
  }
  weight {
    oldValue
    newValue
  }
  length {
    oldValue
    newValue
  }
  width {
    oldValue
    newValue
  }
  type {
    oldValue
    newValue
  }
  wasAdded
  wasDeleted
}
    `;
export const OrderDifferenceFragmentDoc = gql`
    fragment OrderDifference on SnapshotOrderDifferences {
  billingPartyName {
    oldValue
    newValue
  }
  hawb {
    oldValue
    newValue
  }
  mawb {
    oldValue
    newValue
  }
  refNumbers {
    oldValue
    newValue
  }
  serviceLevel {
    oldValue
    newValue
  }
  totalAmountCents {
    oldValue
    newValue
  }
  packages {
    ...PackageDifference
  }
}
    ${PackageDifferenceFragmentDoc}`;
export const AddressDifferenceFragmentDoc = gql`
    fragment AddressDifference on SnapshotAddressDifferences {
  name {
    oldValue
    newValue
  }
  line1 {
    oldValue
    newValue
  }
  zip {
    oldValue
    newValue
  }
  state {
    oldValue
    newValue
  }
  city {
    oldValue
    newValue
  }
}
    `;
export const FreightChargeDifferenceFragmentDoc = gql`
    fragment FreightChargeDifference on SnapshotFreightChargeDifferences {
  totalAmountCents {
    oldValue
    newValue
  }
  externalRating {
    oldValue
    newValue
  }
  tariff {
    oldValue
    newValue
  }
  fuelCharge {
    totalAmountCents {
      oldValue
      newValue
    }
  }
  billingMethod {
    oldValue
    newValue
  }
}
    `;
export const CustomChargeDifferenceFragmentDoc = gql`
    fragment CustomChargeDifference on SnapshotCustomChargeDifferences {
  wasAdded
  wasDeleted
  name {
    oldValue
    newValue
  }
  totalAmountCents {
    oldValue
    newValue
  }
}
    `;
export const FuelCostDifferenceFragmentDoc = gql`
    fragment FuelCostDifference on SnapshotFuelCostDifferences {
  billingMethod {
    oldValue
    newValue
  }
  totalAmountCents {
    oldValue
    newValue
  }
  type {
    oldValue
    newValue
  }
  surchargeRate {
    oldValue
    newValue
  }
}
    `;
export const FreightCostDifferenceFragmentDoc = gql`
    fragment FreightCostDifference on SnapshotFreightCostDifferences {
  billingMethod {
    oldValue
    newValue
  }
  totalAmountCents {
    oldValue
    newValue
  }
  tariff {
    oldValue
    newValue
  }
  fuelCost {
    ...FuelCostDifference
  }
}
    ${FuelCostDifferenceFragmentDoc}`;
export const CustomCostDifferenceFragmentDoc = gql`
    fragment CustomCostDifference on SnapshotCustomCostDifferences {
  wasAdded
  wasDeleted
  name {
    oldValue
    newValue
  }
  totalAmountCents {
    oldValue
    newValue
  }
}
    `;
export const IndependentSettlementBillLineItemDifferenceFragmentDoc = gql`
    fragment IndependentSettlementBillLineItemDifference on SnapshotIndependentSettlementBillLineItemDifferences {
  wasAdded
  wasDeleted
  driverName {
    oldValue
    newValue
  }
  freightCost {
    ...FreightCostDifference
  }
  customCosts {
    ...CustomCostDifference
  }
}
    ${FreightCostDifferenceFragmentDoc}
${CustomCostDifferenceFragmentDoc}`;
export const StopDifferenceFragmentDoc = gql`
    fragment StopDifference on SnapshotStopDifferences {
  wasAdded
  wasDeleted
  stopType {
    oldValue
    newValue
  }
  address {
    ...AddressDifference
  }
  terminal {
    oldValue
    newValue
  }
  serviceDate {
    oldValue
    newValue
  }
  isSpecial {
    oldValue
    newValue
  }
  appointmentRequired {
    oldValue
    newValue
  }
  appointmentManuallyConfirmed {
    oldValue
    newValue
  }
  freightCharge {
    ...FreightChargeDifference
  }
  customCharges {
    ...CustomChargeDifference
  }
  independentSettlementBillLineItems {
    ...IndependentSettlementBillLineItemDifference
  }
}
    ${AddressDifferenceFragmentDoc}
${FreightChargeDifferenceFragmentDoc}
${CustomChargeDifferenceFragmentDoc}
${IndependentSettlementBillLineItemDifferenceFragmentDoc}`;
export const SnapshotDifferenceFragmentDoc = gql`
    fragment SnapshotDifference on AuditLogSnapshotDifference {
  orderDifferences {
    ...OrderDifference
  }
  inboundStopDifferences {
    ...StopDifference
  }
  outboundStopDifferences {
    ...StopDifference
  }
}
    ${OrderDifferenceFragmentDoc}
${StopDifferenceFragmentDoc}`;
export const AuditLogEntryFragmentDoc = gql`
    fragment AuditLogEntry on AuditLogEntry {
  orderEvent {
    ...OrderEvent
  }
  snapshotDifference {
    ...SnapshotDifference
  }
}
    ${OrderEventFragmentDoc}
${SnapshotDifferenceFragmentDoc}`;
export const OrderEventSnapshotFragmentDoc = gql`
    fragment OrderEventSnapshot on OrderEventEntity {
  uuid
  createdAt
  snapshot
  sourceUser {
    uuid
    email
  }
}
    `;
export const PicklistItemGroupFragmentDoc = gql`
    fragment PicklistItemGroup on PicklistItemGroupEntity {
  id
  pickedQuantity
  pickedStatus
  itemGroup {
    quantity
    item {
      sku
      description
    }
    storageUnit {
      name
      warehouseLocation {
        name
      }
    }
  }
}
    `;
export const BulkDelegationBatchFragmentDoc = gql`
    fragment BulkDelegationBatch on BulkDelegationBatchEntity {
  __typename
  uuid
  total
  offered
  pending
  failed
  isComplete
  items {
    __typename
    orderUuid
    status
    reason
  }
}
    `;
export const OrderQuoteForReviewFragmentDoc = gql`
    fragment OrderQuoteForReview on OrderQuote {
  __typename
  uuid
  number
  status
  version
  quotedAmountCents
  currency
  validUntil
  sentAt
  needsAttentionAt
  createdAt
  updatedAt
  senderAddress
  senderDisplayName
  senderRecoveredFromForward
  missingFields
  unpriceableReasons
  pricingState
  attentionReasons
  draftReplyUuid
  draftReplyKind
  draftReplyBody
  draftReplyApprovedAt
  unsettledEarlierReply {
    __typename
    orderQuoteUuid
    version
    draftReplyUuid
    draftReplyKind
    draftReplyBody
    draftReplyApprovedAt
  }
  order {
    __typename
    uuid
    name
  }
  customer {
    __typename
    uuid
    name
  }
  customerCandidates {
    __typename
    contactUuid
    contactName
    isActive
    matchedBy
  }
}
    `;
export const DelegationAccessorialProposalFieldsFragmentDoc = gql`
    fragment DelegationAccessorialProposalFields on DelegationAccessorialProposalEntity {
  __typename
  uuid
  delegationUuid
  executingCompanyName
  name
  quantity
  status
  mappedAccessorialUuid
  mappedAccessorialName
  mappedAccessorialType
  suggestedZoneBasedMatrixItemUuid
  appliedCustomChargeUuid
  decidedAt
  originalChargesFinalized
}
    `;
export const StopForUnifiedSearchFragmentDoc = gql`
    fragment StopForUnifiedSearch on StopEntity {
  completedAt
  routeSlot {
    route {
      name
      date
    }
  }
}
    `;
export const UnifiedSearchOrdersFragmentDoc = gql`
    fragment UnifiedSearchOrders on OrderConnection {
  edges {
    node {
      uuid
      name
      source
      billingPartyContact {
        displayName
      }
      standardOrderFields {
        shipperBillOfLadingNumber
        masterAirwayBillOfLadingNumber
      }
      startStop {
        ...StopForUnifiedSearch
      }
      endStop {
        ...StopForUnifiedSearch
      }
    }
  }
  totalCount
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    ${StopForUnifiedSearchFragmentDoc}`;
export const UnifiedSearchUnacceptedEmailOrdersFragmentDoc = gql`
    fragment UnifiedSearchUnacceptedEmailOrders on ScannedOrderResultConnection {
  edges {
    node {
      uuid
      order {
        uuid
        name
        billingPartyContact {
          uuid
          displayName
        }
        standardOrderFields {
          shipperBillOfLadingNumber
          masterAirwayBillOfLadingNumber
        }
      }
      scannedOrder {
        ingestedOutlookEmailDetails {
          fromAddress
          subject
          receivedAt
        }
      }
    }
  }
  totalCount
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    `;
export const UnifiedSearchUnacceptedEdiAndApiOrdersFragmentDoc = gql`
    fragment UnifiedSearchUnacceptedEdiAndApiOrders on OrderConnection {
  edges {
    node {
      uuid
      name
      billingPartyContact {
        uuid
        displayName
      }
      standardOrderFields {
        shipperBillOfLadingNumber
        masterAirwayBillOfLadingNumber
      }
    }
  }
  totalCount
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    `;
export const UnifiedSearchQuotesFragmentDoc = gql`
    fragment UnifiedSearchQuotes on QuoteConnection {
  edges {
    node {
      uuid
      number
      billingPartyContact {
        uuid
        displayName
      }
    }
  }
  totalCount
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    `;
export const UnifiedSearchInvoicesFragmentDoc = gql`
    fragment UnifiedSearchInvoices on InvoiceConnection {
  edges {
    node {
      uuid
      date
      name
      journalNumber
      billToContact {
        uuid
        displayName
      }
      balanceInCents
      balanceInDollars
      invoiceTotal
    }
  }
  totalCount
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
}
    `;
export const FreightSnapTransactionFragmentDoc = gql`
    fragment FreightSnapTransaction on FreightSnapTransactionEntity {
  uuid
  status
  failureReason
  proNum
  ehdim
  eldim
  ewdim
  weight
  imgs
  order {
    uuid
    name
  }
}
    `;
export const EmailTransactionFragmentDoc = gql`
    fragment EmailTransaction on EmailTransactionEntity {
  emailTransactionStatus
  company {
    uuid
    name
  }
  contact {
    uuid
    displayName
  }
  document {
    uuid
    preSignedGetUrl
  }
  invoice {
    uuid
    name
    journalNumber
  }
  emailResponseStatus
  failureReason
  pdfNotAttached
  emailTransactionLogs {
    uuid
    email
    lastStatus
    reason
  }
}
    `;
export const ApiLogFragmentDoc = gql`
    fragment ApiLog on ApiLogEntity {
  uuid
  createdAt
  updatedAt
  responseStatus
  sourceIpAddress
  direction
  freightSnapTransaction {
    ...FreightSnapTransaction @include(if: $isFreightSnap)
  }
  emailTransaction {
    ...EmailTransaction @include(if: $isInvoiceEmails)
  }
}
    ${FreightSnapTransactionFragmentDoc}
${EmailTransactionFragmentDoc}`;
export const PackageForArrivalNoticeFragmentDoc = gql`
    fragment PackageForArrivalNotice on PackageEntity {
  description
  weight
  quantity
  length
  width
  height
  type
}
    `;
export const ShipmentForArrivalNoticeFragmentDoc = gql`
    fragment ShipmentForArrivalNotice on ShipmentEntity {
  totalFreightChargesAmount
  totalFuelChargesAmount
  totalChargesAmount
  shipmentType
  hideFromBilling
  standardShipmentFields {
    pickupOrDelivery
  }
  legs {
    endStop {
      stopType
      inboundMethod
      outboundMethod
      address {
        ...Address
      }
      terminal {
        code
        address {
          ...Address
        }
      }
      contactPerson {
        phone
        email
        firstName
        lastName
      }
    }
  }
  customCharges {
    uuid
    name
    total
    accessorialTemplate {
      uuid
      name
      __typename
    }
  }
  charges {
    ... on FreightChargeEntity {
      uuid
      billingMethod
      rate
      description
      quantity
      fuelCharge {
        description
        surchargeRate
        flatRate
        type
        uuid
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export const OrderForArrivalNoticeFragmentDoc = gql`
    fragment OrderForArrivalNotice on OrderEntity {
  uuid
  itTeNumber
  externalNotes
  hazmat
  unNumber
  hazmatDescription
  emergencyResponseNumber
  requiresPlacard
  hazmatClass
  packageGroup
  isCrossDock
  totalCharge
  name
  billingPartyContact {
    displayName
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    weightUnits
    measurementUnits
  }
  thirdPartyBrokers {
    name
  }
  service {
    name
  }
  company {
    name
    defaultAddress {
      ...Address
    }
    phone
  }
  packages {
    ...PackageForArrivalNotice
  }
  shipments {
    ...ShipmentForArrivalNotice
  }
}
    ${AddressFragmentDoc}
${PackageForArrivalNoticeFragmentDoc}
${ShipmentForArrivalNoticeFragmentDoc}`;
export const CoverSheetDocumentTypeSequenceFragmentDoc = gql`
    fragment CoverSheetDocumentTypeSequence on CoverSheetDocumentTypeSequenceEntity {
  uuid
  name
  type
  documentTypes
}
    `;
export const OrderCoverSheetShipmentFragmentDoc = gql`
    fragment OrderCoverSheetShipment on ShipmentEntity {
  uuid
  ordinal
  standardShipmentFields {
    deadlineDate
    pickupOrDelivery
  }
  packages {
    description
    weight
    quantity
    length
    width
    height
  }
  legs {
    endStop {
      stopType
      status
      appointmentTime
      endAppointmentTime
      completedAt
      specialInstructions
      address {
        ...Address
      }
      terminal {
        code
      }
      contactPerson {
        phone
        email
        firstName
        lastName
      }
      routeSlot {
        route {
          name
          drivers {
            firstName
            lastName
          }
        }
      }
    }
  }
  order {
    uuid
    name
    refNumbers
    coverSheetDocumentTypeSequence {
      ...CoverSheetDocumentTypeSequence
    }
    billingPartyContact {
      uuid
      displayName
    }
    orderEvents {
      eventType
      sourceType
      createdAt
      sourceUser {
        email
      }
    }
    company {
      name
      defaultAddress {
        ...Address
      }
    }
    standardOrderFields {
      masterAirwayBillOfLadingNumber
      shipperBillOfLadingNumber
    }
    service {
      name
    }
  }
}
    ${AddressFragmentDoc}
${CoverSheetDocumentTypeSequenceFragmentDoc}`;
export const OrderEventForCoverSheetFragmentDoc = gql`
    fragment OrderEventForCoverSheet on OrderEventEntity {
  eventType
  sourceType
  createdAt
  sourceUser {
    email
  }
}
    `;
export const ShipmentForCoverSheetFragmentDoc = gql`
    fragment ShipmentForCoverSheet on ShipmentEntity {
  uuid
  shipmentType
  ordinal
  standardShipmentFields {
    deadlineDate
    pickupOrDelivery
  }
  packages {
    description
    weight
    quantity
    length
    width
    height
  }
  legs {
    endStop {
      stopType
      status
      appointmentTime
      endAppointmentTime
      completedAt
      specialInstructions
      serviceDate
      serviceDateV2 {
        iso8601
      }
      inboundMethod
      outboundMethod
      isSpecial
      address {
        ...Address
      }
      contactPerson {
        phone
        email
        firstName
        lastName
      }
      routeSlot {
        route {
          name
          drivers {
            firstName
            lastName
          }
        }
      }
      terminal {
        uuid
        code
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export const OrderForCoverSheetFragmentDoc = gql`
    fragment OrderForCoverSheet on OrderEntity {
  uuid
  name
  refNumbers
  service {
    name
  }
  coverSheetDocumentTypeSequence {
    ...CoverSheetDocumentTypeSequence
  }
  billingPartyContact {
    uuid
    displayName
  }
  orderEvents {
    ...OrderEventForCoverSheet
  }
  company {
    name
    defaultAddress {
      ...Address
    }
  }
  standardOrderFields {
    masterAirwayBillOfLadingNumber
    shipperBillOfLadingNumber
    weightUnits
    measurementUnits
  }
  shipments {
    ...ShipmentForCoverSheet
  }
  inBond
  itTeNumber
  hazmat
  unNumber
  hazmatDescription
  emergencyResponseNumber
  requiresPlacard
  hazmatClass
  packageGroup
}
    ${CoverSheetDocumentTypeSequenceFragmentDoc}
${OrderEventForCoverSheetFragmentDoc}
${AddressFragmentDoc}
${ShipmentForCoverSheetFragmentDoc}`;
export const OrderInfoForCoverSheetFragmentDoc = gql`
    fragment OrderInfoForCoverSheet on OrderEntity {
  uuid
  coverSheetDocumentTypeSequence {
    ...CoverSheetDocumentTypeSequence
  }
  orderEvents {
    ...OrderEventForCoverSheet
  }
}
    ${CoverSheetDocumentTypeSequenceFragmentDoc}
${OrderEventForCoverSheetFragmentDoc}`;
export const CreateOrUpdateCsvOrdersOrderFragmentDoc = gql`
    fragment CreateOrUpdateCsvOrdersOrder on OrderEntity {
  uuid
}
    `;
export const CsvOrderMappingFragmentDoc = gql`
    fragment CsvOrderMapping on CsvOrderMappingEntity {
  uuid
  name
}
    `;
export const CsvOrderPreSignedPutUrlFragmentDoc = gql`
    fragment CsvOrderPreSignedPutUrl on CsvOrderPreSignedPutUrlEntity {
  url
  bucket
  key
  filename
  filetype
}
    `;
export const ParseCsvOrdersContactFragmentDoc = gql`
    fragment ParseCsvOrdersContact on ContactEntity {
  uuid
  displayName
}
    `;
export const ParseCsvOrdersPackageFragmentDoc = gql`
    fragment ParseCsvOrdersPackage on ParsedCsvOrderPackageEntity {
  description
  quantity
  type
  packageSpec {
    id
    name
  }
  weight
  length
  width
  height
  class
  freightClass
  nmfc
  uuid
  isNew
}
    `;
export const ParseCsvOrdersOrderUpdateFragmentDoc = gql`
    fragment ParseCsvOrdersOrderUpdate on ParsedCsvOrderUpdateEntity {
  uuid
  billingPartyContact {
    ...ParseCsvOrdersContact
  }
  shipperBillOfLadingNumber
  packages {
    ...ParseCsvOrdersPackage
  }
}
    ${ParseCsvOrdersContactFragmentDoc}
${ParseCsvOrdersPackageFragmentDoc}`;
export const ParseCsvOrdersServiceFragmentDoc = gql`
    fragment ParseCsvOrdersService on ServiceEntity {
  uuid
  name
}
    `;
export const ParseCsvOrdersStopFragmentDoc = gql`
    fragment ParseCsvOrdersStop on ParsedCsvOrderStopEntity {
  pickupOrDelivery
  addressName
  addressLine1
  addressLine2
  addressCity
  addressState
  addressZip
  contactPersonFirstName
  contactPersonLastName
  contactPersonPhone
  contactPersonEmail
  specialInstructions
  deadlineDate
  deadlineType
  serviceDate
  serviceDateV2 {
    iso8601
  }
  appointmentStartTime {
    hour
    minute
  }
  appointmentEndTime {
    hour
    minute
  }
  appointmentRequired
  terminalName
  terminal {
    uuid
    name
  }
  driverName
  driverReferenceNumber
  driver {
    uuid
    firstName
    lastName
  }
}
    `;
export const ParseCsvOrdersOrderFragmentDoc = gql`
    fragment ParseCsvOrdersOrder on ParsedCsvOrderEntity {
  billingPartyContact {
    ...ParseCsvOrdersContact
  }
  customerReferenceNumber
  shipperBillOfLadingNumber
  masterAirwayBillOfLadingNumber
  referenceNumber
  notes
  serviceLevel {
    ...ParseCsvOrdersService
  }
  inboundStop {
    ...ParseCsvOrdersStop
  }
  outboundStop {
    ...ParseCsvOrdersStop
  }
  dimFactor
  freightChargeRate
  freightChargeType
  fuelSurcharge
  fuelChargeType
  packages {
    ...ParseCsvOrdersPackage
  }
}
    ${ParseCsvOrdersContactFragmentDoc}
${ParseCsvOrdersServiceFragmentDoc}
${ParseCsvOrdersStopFragmentDoc}
${ParseCsvOrdersPackageFragmentDoc}`;
export const ParseCsvOrdersRowErrorFragmentDoc = gql`
    fragment ParseCsvOrdersRowError on ParseCsvOrderRowErrorEntity {
  row
  message
}
    `;
export const CurrentOrderStatusFragmentDoc = gql`
    fragment CurrentOrderStatus on OrderEntity {
  detailedStatusV2
  updatedAt
}
    `;
export const EdiTransactionFragmentFragmentDoc = gql`
    fragment EdiTransactionFragment on EdiTransactionEntity {
  uuid
  updatedAt
  status
  code
  message
  payload
  hawb
  order {
    uuid
    name
    secondaryRefNumber
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
}
    `;
export const OrderFragmentForEdiReviewFragmentDoc = gql`
    fragment OrderFragmentForEdiReview on OrderEntity {
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  createdAt
  uuid
  source
  name
  ediServiceLevelCode
  ediReferences {
    qualifier
    value
    target
    label
  }
  contact {
    uuid
    displayName
  }
}
    `;
export const AvailablePieceForLinkingFragmentDoc = gql`
    fragment AvailablePieceForLinking on AvailablePieceEntity {
  uuid
  referenceNumber
  additionalReferenceNumbers
  status
  length
  width
  height
  measurementUnits
  type
  weight
  weightUnits
  markedOnHandAt
  createdAt
  orderUuid
  orderName
  customerUuid
  customerName
  terminalUuid
  terminalName
  warehouseLocationUuid
  warehouseLocationName
  isOverage
  isShortage
  isMisrouted
  isUnalertedFreight
}
    `;
export const MarkOsdOrderFragmentDoc = gql`
    fragment MarkOsdOrder on OrderEntity {
  uuid
  notes
  status
  detailedStatusV2
}
    `;
export const OrderForBulkEditFragmentDoc = gql`
    fragment OrderForBulkEdit on OrderEntity {
  uuid
  status
  onHand
  pickedDate
  pieceCount
  detailedStatusV2
  refusedBy
  warehouse {
    uuid
    name
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  secondaryRefNumber
  shipments {
    uuid
    shipmentType
    standardShipmentFields {
      deadlineDate
      deadlineType
      pickupOrDelivery
    }
    legs {
      uuid
      endStop {
        stopType
        uuid
        notes
        standardStopType
        appointmentTextStatus
        appointmentTime
        endAppointmentTime
        proofOfDeliverySignee
        inboundMethod
        expectedInboundArrivalDate
        outboundMethod
        completedAt
        createdAt
        status
        isSpecial
        paperworkMarkedComplete
        contactPerson {
          phone
          email
          firstName
          lastName
        }
        address {
          uuid
          name
          line1
          line2
          city
          state
          latitude
          longitude
          zip
        }
        terminal {
          name
        }
      }
      previousStopAttempts {
        completedAt
      }
    }
  }
}
    `;
export const StandardOrderForContextMenuFragmentDoc = gql`
    fragment StandardOrderForContextMenu on StandardOrderEntity {
  uuid
  name
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  refusedBy
  pickedDate
  pieceCount
  onHand
  notes
  status
  detailedStatus
  detailedStatusV2
  endStop {
    uuid
    stopType
    leg {
      shipment {
        standardShipmentFields {
          pickupOrDelivery
        }
      }
    }
    terminal {
      uuid
    }
    address {
      line1
    }
  }
  shipments {
    standardShipmentFields {
      pickupOrDelivery
    }
    fields {
      pickupOrDelivery
      outboundMethod
      inboundMethod
    }
    legs {
      endStop {
        stopType
        uuid
        status
        proofOfDeliverySignee
        completedAt
        routeSlot {
          route {
            date
          }
        }
        address {
          name
        }
      }
    }
  }
}
    `;
export const OrderForDocumentAttachmentsDownloadFragmentDoc = gql`
    fragment OrderForDocumentAttachmentsDownload on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  documents {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export const OrderForInventoryLabelFragmentDoc = gql`
    fragment OrderForInventoryLabel on OrderEntity {
  uuid
  name
  refNumbers
  billingPartyContact {
    uuid
    displayName
    referenceNumberLabels {
      name
    }
  }
  company {
    name
    defaultWeightUnits
    configuration {
      terminalsEnabled
      useHawbForLotLabelBarcode
    }
    referenceNumberLabels {
      name
    }
  }
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    weightUnits
  }
  packages {
    ...Package
  }
  shipments {
    uuid
    standardShipmentFields {
      pickupOrDelivery
      deadlineDate
    }
    airportInfo {
      iataCode
      terminal
    }
    legs {
      endStop {
        uuid
        stopType
        status
        destinationAirport
        inboundMethod
        outboundMethod
        incomingCarrier
        outboundCarrier
        address {
          ...Address
        }
        terminal {
          uuid
          code
        }
      }
    }
  }
}
    ${PackageFragmentDoc}
${AddressFragmentDoc}`;
export const OrderForOrderMatchingFragmentDoc = gql`
    fragment OrderForOrderMatching on OrderEntity {
  uuid
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  name
  shipments {
    uuid
    standardShipmentFields {
      pickupOrDelivery
    }
    legs {
      endStop {
        address {
          ...Address
        }
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export const OrderForOrdersByShipperBillOfLadingNumberFragmentDoc = gql`
    fragment OrderForOrdersByShipperBillOfLadingNumber on OrderEntity {
  uuid
  createdAt
  name
  receivedDate
  onHand
  shipments {
    uuid
  }
  scannedOrderResult {
    uuid
    status
  }
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  source
  isDraftOrder
}
    `;
export const OrderPodReportShipmentFragmentDoc = gql`
    fragment OrderPodReportShipment on ShipmentEntity {
  uuid
  ordinal
  totalFreightChargesAmount
  totalFuelChargesAmount
  totalChargesAmount
  shipmentType
  standardShipmentFields {
    deadlineDate
    pickupOrDelivery
  }
  documents {
    ...Document
  }
  packages {
    description
    weight
    quantity
    length
    width
    height
  }
  legs {
    endStop {
      stopType
      status
      appointmentTime
      endAppointmentTime
      completedAt
      specialInstructions
      proofOfDeliverySignee
      paperworkMarkedComplete
      address {
        ...Address
      }
      contactPerson {
        phone
        email
        firstName
        lastName
      }
      routeSlot {
        route {
          name
          drivers {
            firstName
            lastName
          }
        }
      }
    }
  }
  order {
    uuid
    name
    secondaryRefNumber
    totalCharge
    totalFreightChargesAmount
    totalFuelChargesAmount
    totalCustomChargesAmount
    notes
    billingPartyContact {
      uuid
      displayName
    }
    ordinal
    orderEvents {
      eventType
      sourceType
      createdAt
      sourceUser {
        email
      }
    }
    company {
      name
      defaultAddress {
        ...Address
      }
    }
    shipments {
      customCharges {
        authoCode
        name
        accessorialTemplate {
          name
        }
        total
      }
    }
    standardOrderFields {
      masterAirwayBillOfLadingNumber
      shipperBillOfLadingNumber
      weightUnits
      measurementUnits
    }
    service {
      name
    }
  }
  charges {
    ... on CustomChargeEntity {
      uuid
      authoCode
      name
      zoneBasedAccessorialZoneUuid
      zoneBasedAccessorialChargeGroupUuid
      specialAccessorialTariffZoneUuid
      specialAccessorialChargeGroupUuid
      quantity
      description
      rate
      total
      customChargeBillingMethod: billingMethod
      accessorialTemplate {
        uuid
        name
        __typename
      }
    }
    ... on FreightChargeEntity {
      uuid
      authoCode
      billingMethod
      tariff {
        uuid
        billingPartyContactUuid
        tariffOverageRates {
          uuid
          name
          type
          rateUsdCents
          applicableAboveAmount
          applyRateToFullAmount
        }
      }
      rate
      description
      quantity
      fuelCharge {
        description
        authoCode
        surchargeRate
        flatRate
        type
        uuid
      }
    }
  }
}
    ${DocumentFragmentDoc}
${AddressFragmentDoc}`;
export const OrderTableFieldHeaderFragmentDoc = gql`
    fragment OrderTableFieldHeader on OrderTableFieldHeaderEntity {
  orderTableField
  header
  isGroupable
  isGroupableOnNewSearch
}
    `;
export const FormattedOrderFieldFragmentDoc = gql`
    fragment FormattedOrderField on FormattedOrderFieldEntity {
  orderTableField
  value
}
    `;
export const OrderTableFieldPaperworkFragmentDoc = gql`
    fragment OrderTableFieldPaperwork on OrderTablePaperworkFieldEntity {
  paperwork {
    ...OrderPaperwork
  }
  inboundPaperwork {
    ...OrderPaperworkWithGroupedDocuments
  }
  outboundPaperwork {
    ...OrderPaperworkWithGroupedDocuments
  }
}
    ${OrderPaperworkFragmentDoc}
${OrderPaperworkWithGroupedDocumentsFragmentDoc}`;
export const OrderTableFieldTagFragmentDoc = gql`
    fragment OrderTableFieldTag on OrderTableTagEntity {
  value
  color
}
    `;
export const OrderTableFieldPhotoFragmentDoc = gql`
    fragment OrderTableFieldPhoto on OrderTablePhotoEntity {
  shipmentUuid
  shipmentPickupOrDelivery
  fileName
  type
  preSignedGetUrl
}
    `;
export const OrderTableFieldPackageFragmentDoc = gql`
    fragment OrderTableFieldPackage on OrderTablePackageEntity {
  uuid
  quantity
  weight
  length
  width
  height
}
    `;
export const OrderTableCustomChargeFragmentDoc = gql`
    fragment OrderTableCustomCharge on OrderTableCustomChargeFieldEntity {
  name
  billingMethod
  total
}
    `;
export const RateOrderShipmentChargesForItemizedChargesFragmentDoc = gql`
    fragment RateOrderShipmentChargesForItemizedCharges on RateShipmentForOrderSuccessOutput {
  total
  freightCharge {
    totalDollars
    tariffUuid
  }
  fuelCharge {
    totalDollars
    surchargeRatePercentage
  }
}
    `;
export const OrderTableFieldItemizedChargesFragmentDoc = gql`
    fragment OrderTableFieldItemizedCharges on OrderTableItemizedChargesFieldEntity {
  freightChargeTotal
  fuelChargeTotal
  shipmentCharges {
    shipmentType
    pickupOrDelivery
    stopType
    tariff {
      uuid
      tariffZone {
        uuid
        name
      }
      tariffGroup {
        name
      }
    }
    freightBillingMethod
    freightRate
    freightQuantity
    freightTotalAmount
    fuelBillingMethod
    fuelSurchargeRate
    fuelFlatRate
    fuelTotalAmount
    customCharges {
      ...OrderTableCustomCharge
    }
  }
  rateOrderOutput {
    __typename
    ... on RateOrderSuccessOutput {
      success
      totalDollars
      inboundShipmentCharges {
        ...RateOrderShipmentChargesForItemizedCharges
      }
      outboundShipmentCharges {
        ...RateOrderShipmentChargesForItemizedCharges
      }
      orderCharges {
        ...RateOrderShipmentChargesForItemizedCharges
      }
      lineHaulCharges {
        ...RateOrderShipmentChargesForItemizedCharges
      }
    }
    ... on RateOrderErrorOutput {
      success
      errorMessage
    }
  }
  customCharges {
    ...OrderTableCustomCharge
  }
}
    ${OrderTableCustomChargeFragmentDoc}
${RateOrderShipmentChargesForItemizedChargesFragmentDoc}`;
export const FormattedOrderFragmentDoc = gql`
    fragment FormattedOrder on FormattedOrderEntity {
  uuid
  freightNeedsRate
  formattedOrderFields {
    ...FormattedOrderField
  }
  paperworkField {
    ...OrderTableFieldPaperwork
  }
  tagsField {
    orderTableTags {
      ...OrderTableFieldTag
    }
  }
  photosField {
    orderTablePhotos {
      ...OrderTableFieldPhoto
    }
  }
  serviceField {
    service {
      uuid
      name
    }
  }
  packagesField {
    orderTablePackages {
      ...OrderTableFieldPackage
    }
  }
  itemizedChargesField {
    ...OrderTableFieldItemizedCharges
  }
  pieceTerminalLocationsDisplay(activeTerminalUuid: $activeTerminalUuid) @include(if: $includePieceTerminalLocationsDisplay)
  lineHaulManifestsField {
    startTerminal {
      uuid
      code
    }
    endTerminal {
      uuid
      code
    }
    currentTerminal {
      uuid
      code
    }
    lineHaulManifests {
      startTerminal {
        uuid
        code
      }
      endTerminal {
        uuid
        code
      }
      status
    }
  }
  contactUuid
}
    ${FormattedOrderFieldFragmentDoc}
${OrderTableFieldPaperworkFragmentDoc}
${OrderTableFieldTagFragmentDoc}
${OrderTableFieldPhotoFragmentDoc}
${OrderTableFieldPackageFragmentDoc}
${OrderTableFieldItemizedChargesFragmentDoc}`;
export const OrderTableFieldValuesFormattedOrderConnectionFragmentDoc = gql`
    fragment OrderTableFieldValuesFormattedOrderConnection on FormattedOrderConnection {
  edges {
    node {
      ...FormattedOrder
    }
  }
  totalCount
  pageInfo {
    startCursor
    endCursor
    hasNextPage
    hasPreviousPage
  }
}
    ${FormattedOrderFragmentDoc}`;
export const OrderTableGroupRowFragmentDoc = gql`
    fragment OrderTableGroupRow on OrderTableGroupRowEntity {
  key
  label
  count
}
    `;
export const OrderTableFieldValuesOutputFragmentDoc = gql`
    fragment OrderTableFieldValuesOutput on GetOrderTableFieldValuesOutput {
  orderTableFieldHeaders {
    ...OrderTableFieldHeader
  }
  formattedOrderConnection {
    ...OrderTableFieldValuesFormattedOrderConnection
  }
  groupRows {
    ...OrderTableGroupRow
  }
  groupRowsHasMore
}
    ${OrderTableFieldHeaderFragmentDoc}
${OrderTableFieldValuesFormattedOrderConnectionFragmentDoc}
${OrderTableGroupRowFragmentDoc}`;
export const OrderWithMissingDocumentsFragmentDoc = gql`
    fragment OrderWithMissingDocuments on OrderEntity {
  uuid
  missingDocuments
}
    `;
export const OrderWithPaperworkFragmentDoc = gql`
    fragment OrderWithPaperwork on OrderEntity {
  uuid
  paperwork {
    ...OrderPaperwork
  }
}
    ${OrderPaperworkFragmentDoc}`;
export const ContactForOrdersTableFragmentDoc = gql`
    fragment ContactForOrdersTable on ContactEntity {
  uuid
  displayName
  billingCycleDuration
  businessDivision {
    uuid
    name
  }
  masterAccount {
    name
  }
  invoiceTimePeriodSplit
  numberOfOrdersPerInvoice
}
    `;
export const ShipmentWithDocumentsForOrdersTableFragmentDoc = gql`
    fragment ShipmentWithDocumentsForOrdersTable on ShipmentEntity {
  documents {
    uuid
    fileName
    preSignedGetUrl
    type
    customDocumentName
  }
}
    `;
export const StopWithRouteSlotForOrdersTableFragmentDoc = gql`
    fragment StopWithRouteSlotForOrdersTable on StopEntity {
  routeSlot {
    route {
      name
      date
      drivers {
        firstName
        lastName
      }
    }
  }
}
    `;
export const ShipmentFragmentDoc = gql`
    fragment Shipment on ShipmentEntity {
  invoice {
    uuid
  }
  uuid
  ordinal
  ...ShipmentWithDocumentsForOrdersTable @include(if: $includeDocuments)
  hideFromBilling
  status
  airportInfo {
    iataCode
  }
  standardShipmentFields {
    pickupOrDelivery
    deliveryDate
    deadlineType
    deadlineDate
  }
  legs {
    uuid
    endStop {
      uuid
      notes
      ...StopWithRouteSlotForOrdersTable @include(if: $includeRouteSlot)
      standardStopType
      stopType
      appointmentTextStatus
      appointmentTime
      endAppointmentTime
      proofOfDeliverySignee
      inboundMethod
      expectedInboundArrivalDate
      outboundMethod
      completedAt
      driverCompletedAt
      createdAt
      status
      isSpecial
      paperworkMarkedComplete
      contactPerson {
        phone
        email
        firstName
        lastName
      }
      address {
        uuid
        name
        line1
        line2
        city
        state
        latitude
        longitude
        zip
      }
      terminal {
        name
      }
    }
    previousStopAttempts {
      completedAt
    }
  }
  shipmentType
}
    ${ShipmentWithDocumentsForOrdersTableFragmentDoc}
${StopWithRouteSlotForOrdersTableFragmentDoc}`;
export const OrderWithCommentsFragmentDoc = gql`
    fragment OrderWithComments on OrderEntity {
  orderComments {
    uuid
    updatedAt
    user {
      uuid
      email
    }
    comment
    piece {
      uuid
      referenceNumber
    }
  }
}
    `;
export const OrderFragmentDoc = gql`
    fragment Order on OrderEntity {
  standardOrderFields {
    shipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
  }
  packages {
    length
    width
    height
    quantity
  }
  weight
  dimWeight
  createdAt
  receivedDate
  secondaryRefNumber
  status
  detailedStatusV2
  uuid
  name
  missingDocuments
  paperwork {
    ...OrderPaperwork
  }
  osd
  source
  refNumbers
  secondaryRefNumber
  notes
  dateMarkedLoaded
  dateMarkedOnHand
  dateMarkedReceivedAtOrigin
  pieceCount
  itTeNumber
  pieceCountFromPackages
  inBond
  piecesPicked
  piecesLoaded
  refusedBy
  hasDriverPod
  hasDriverUploadedDocument
  holdReason {
    name
  }
  service {
    name
  }
  tags {
    ...Tag
  }
  billingPartyContact {
    ...ContactForOrdersTable
  }
  documents {
    ...Document
  }
  shipments {
    ...Shipment
  }
  lineHaulLane {
    name
    originTerminal {
      code
    }
    destinationTerminal {
      code
    }
  }
  startStop {
    address {
      name
      line1
      line2
      city
      state
      zip
    }
    terminal {
      code
    }
    serviceDate
    serviceDateV2 {
      iso8601
    }
    incomingCarrier
  }
  endStop {
    address {
      name
      line1
      line2
      city
      state
      zip
    }
    terminal {
      code
    }
    serviceDate
    serviceDateV2 {
      iso8601
    }
    outboundCarrier
  }
  totalSkids
  externalNotes
  ...OrderWithComments @include(if: $includeOrderComments)
}
    ${OrderPaperworkFragmentDoc}
${TagFragmentDoc}
${ContactForOrdersTableFragmentDoc}
${DocumentFragmentDoc}
${ShipmentFragmentDoc}
${OrderWithCommentsFragmentDoc}`;
export const ThirdPartyBrokerFragmentDoc = gql`
    fragment ThirdPartyBroker on ThirdPartyBrokerEntity {
  uuid
  name
}
    `;
export const OutstandingStandardShipmentFragmentDoc = gql`
    fragment OutstandingStandardShipment on StandardShipmentEntity {
  uuid
  shouldBillIndividually
  shouldUseDimWeight
  overridePackageWeight
  name
  hideFromBilling
  hasSignedPOD
  documents {
    uuid
    fileName
    fileType
    preSignedGetUrl
    type
    customDocumentName
    notes
    name
  }
  fields {
    uuid
    deadlineDate
    deadlineType
    deliveryDate
    dimFactor
    pickupOrDelivery
    outboundMethod
    inboundMethod
    service {
      ...Service
    }
    type
  }
  legs {
    uuid
    miles
    endStop {
      ...OutstandingOrderQueryStop
    }
    previousStopAttempts {
      stopDriverMaps {
        ...StopDriverMapForOrder
      }
    }
  }
  customCharges {
    ...CustomCharge
  }
  freightCharge {
    ...StandardShipmentFreightCharge
  }
  status
  inputForConsolidatedOrder {
    uuid
    name
  }
  shipmentType
  shipmentCharges {
    ...ShipmentCharges
  }
  invoice {
    uuid
    name
    date
    postedAt
    journalNumber
  }
  independentSettlementBillLineItems {
    ...SettlementBillLineItemForOrder
  }
}
    ${ServiceFragmentDoc}
${OutstandingOrderQueryStopFragmentDoc}
${StopDriverMapForOrderFragmentDoc}
${CustomChargeFragmentDoc}
${StandardShipmentFreightChargeFragmentDoc}
${ShipmentChargesFragmentDoc}
${SettlementBillLineItemForOrderFragmentDoc}`;
export const OutstandingOrderFragmentFragmentDoc = gql`
    fragment OutstandingOrderFragment on StandardOrderEntity {
  freightNeedsRate
  updatedAt
  orderSegmentType
  fulfillmentType
  isOverdue
  detailedStatusV2
  isCrossDock
  isDoorToDoor
  inboundStopIntention
  outboundStopIntention
  displayChargesInCustomerPortalOverride
  customerPortalChargesVisibleFromOverride
  issueReason
  personName
  personPhoneNumber
  personEmail
  name
  notes
  onHand
  dateMarkedOnHand
  refNumbers
  orderConsolidationType
  orderInvoiceByDate
  paymentMethod
  source
  status
  uuid
  isDraftOrder
  chargeableWeightCubicMeters
  totalSkids
  isReweighed
  tags {
    ...Tag
  }
  thirdPartyBrokers {
    ...ThirdPartyBroker
  }
  service {
    uuid
    name
  }
  standardOrderFields {
    uuid
    shipperBillOfLadingNumber
    lockShipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    dimFactor
    measurementUnits
    weightUnits
  }
  secondaryRefNumber
  lockSecondaryRefNumber
  tertiaryRefNumber
  quaternaryRefNumber
  quinaryRefNumber
  documents {
    ...Document
  }
  paperwork {
    ...OrderPaperwork
  }
  billingPartyContact {
    uuid
    displayName
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
  }
  billingPartyContactStation {
    id
    name
    defaultPerson {
      id
      firstName
      lastName
      phone
      email
    }
  }
  packages {
    uuid
    packageSpec {
      id
      name
    }
    height
    length
    quantity
    type
    weight
    width
    description
  }
  originalTransmissionPackages {
    uuid
    quantity
    type
    weight
    length
    width
    height
    description
  }
  shipments {
    ...OutstandingStandardShipment
  }
  lineHaulCompletedDate
  orderComments {
    uuid
    updatedAt
    user {
      uuid
      email
    }
    comment
  }
  consolidatedShipmentString
  consolidatableOrders {
    error
    orders {
      uuid
    }
    shipments {
      uuid
    }
  }
  shouldBillIndividually
  consolidatedOrders {
    uuid
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
  deletedAutoAppliedAccessorials {
    ... on StandardAccessorialEntity {
      uuid
    }
    ... on PercentageAccessorialEntity {
      uuid
    }
    ... on WeightBasedAccessorialEntity {
      uuid
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
    }
    ... on WaitTimeAccessorialEntity {
      uuid
    }
    ... on UnitBasedAccessorialEntity {
      uuid
    }
    ... on SkidBasedAccessorialEntity {
      uuid
    }
    ... on SpecialAccessorialEntity {
      uuid
    }
    ... on AttemptsAccessorialEntity {
      uuid
    }
    ... on StorageDaysAccessorialEntity {
      uuid
    }
  }
  enableLineHaul
  lineHaulLane {
    uuid
  }
  inBond
  hazmat
  ordersProratedWith {
    ...OrderProratedWith
  }
}
    ${TagFragmentDoc}
${ThirdPartyBrokerFragmentDoc}
${DocumentFragmentDoc}
${OrderPaperworkFragmentDoc}
${OutstandingStandardShipmentFragmentDoc}
${OrderProratedWithFragmentDoc}`;
export const RecurringOrderTemplateFragmentDoc = gql`
    fragment RecurringOrderTemplate on StandardOrderEntity {
  name
  uuid
  source
  standardOrderFields {
    shipperBillOfLadingNumber
  }
  billingPartyContact {
    displayName
  }
  recurringOrderFrequency {
    uuid
    startDate
    endDate
    repeatFrequencyUnit
    repeatIntervalWeeks
    repeatInterval
    daysOfWeek
    daysOfMonth
  }
  run {
    uuid
    name
  }
}
    `;
export const RecurringRunTemplateFragmentDoc = gql`
    fragment RecurringRunTemplate on RunEntity {
  name
  uuid
  isArchived
  terminal {
    uuid
    name
  }
  driver {
    uuid
    status
    firstName
    lastName
  }
  vehicleType {
    uuid
    name
  }
  recurringOrderTemplates {
    uuid
  }
  tags {
    uuid
  }
}
    `;
export const ShallowContactFragmentDoc = gql`
    fragment ShallowContact on ContactEntity {
  displayName
  type
  isActive
  shortCode
  uuid
  contactReferenceNumber
  quickbooksMappingId
  quickbooksDesktopContactId
  quickbooksFileMappingFreightChargeName
  quickbooksFileMappingCustomerName
  quickbooksFileMappingFuelChargeName
  quickbooksFileMappingPickupChargeName
  quickbooksDesktopAccountsReceivableId
  freightChargeQuickbooksMappingId
  fuelChargeQuickbooksMappingId
  miscCustomChargeQuickbooksMappingId
  stediPartnerId
  billingCycleDuration
  billingContactEmail
  isEfm
  services {
    uuid
    name
    markOrdersAsSpecial
    defaultAppointmentStartTime
    defaultAppointmentEndTime
  }
  defaultService {
    uuid
    name
  }
  defaultAddress {
    uuid
    line1
    line2
    city
    latitude
    longitude
    zip
    state
  }
  referenceNumberLabels {
    name
  }
  contactStations {
    id
    name
    isArchived
    defaultPerson {
      id
      firstName
      lastName
      phone
      email
    }
  }
  showEdiReferenceNumbersOnOrderPage
  ... on CustomerContactEntity {
    defaultUseTariff
    defaultFreightBillingMethod
    defaultFreightClass
    resolvedFreightBillingMethod
    defaultInvoiceTransmissionMethod
    defaultInvoiceType
    defaultInvoiceDownloadDocuments
    defaultInvoiceDocumentsRequired
    defaultDimFactor
    defaultFuelSurcharge
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
    isPrepaidOnly
    useCustomVehicleTypes
    vehicleTypes {
      uuid
      name
      status
    }
    useCustomPackageSpecs
    packageSpecs {
      id
      name
      status
      weight
      length
      width
      height
      freightClass
    }
  }
}
    `;
export const ScannedOrderResultFragmentFragmentDoc = gql`
    fragment ScannedOrderResultFragment on ScannedOrderResultEntity {
  uuid
  filename
  pageEnd
  pageStart
  status
  type
  failureReason
  scannedOrder {
    uuid
    bucket
    failureReason
    filename
    key
    preSignedGetUrl
    retryCount
    status
  }
  scannedOrderResultPages {
    page
    preSignedGetUrl
  }
  signedPodMatchStatus
}
    `;
export const ScannedOrderFragmentFragmentDoc = gql`
    fragment ScannedOrderFragment on ScannedOrderEntity {
  uuid
  bucket
  failureReason
  filename
  key
  preSignedGetUrl
  retryCount
  status
  s3Url
}
    `;
export const OrderWithSameBillOfLadingNumberAsReviewOrderFragmentDoc = gql`
    fragment OrderWithSameBillOfLadingNumberAsReviewOrder on StandardOrderEntity {
  uuid
  name
}
    `;
export const FreightChargeNeedsRateFragmentDoc = gql`
    fragment FreightChargeNeedsRate on FreightChargeEntity {
  uuid
  billingMethod
  ratingFailure {
    code
    message
    retryable
  }
  externalRateQuote {
    uuid
    status
    finalCents
  }
  lastRatedExternalRateQuote {
    uuid
    finalCents
  }
}
    `;
export const OrderFreightNeedsRateFragmentDoc = gql`
    fragment OrderFreightNeedsRate on StandardOrderEntity {
  freightNeedsRate
  shipments {
    uuid
    freightCharge {
      ...FreightChargeNeedsRate
    }
  }
}
    ${FreightChargeNeedsRateFragmentDoc}`;
export const StandardOrderFragmentFragmentDoc = gql`
    fragment StandardOrderFragment on StandardOrderEntity {
  updatedAt
  orderSegmentType
  fulfillmentType
  isOverdue
  detailedStatusV2
  hasIssues
  hasDamage
  hasShortage
  isReverse
  isReturnOrder
  reversalCounterpart {
    uuid
    name
    isReturnOrder
  }
  osd
  codCheckAmountCents
  codCheckNumber
  isCollectOnDelivery
  isCrossDock
  isDoorToDoor
  inboundStopIntention
  outboundStopIntention
  displayChargesInCustomerPortalOverride
  customerPortalChargesVisibleFromOverride
  hasEdiCancellation
  issueReason
  personName
  personPhoneNumber
  personEmail
  name
  notes
  refusedBy
  refusedDate
  refusedReason
  ordersProratedWith {
    ...OrderProratedWith
  }
  vehicleType {
    uuid
    name
  }
  holdReason {
    uuid
    name
  }
  quote {
    uuid
    number
  }
  onHand
  refNumbers
  pieceCount
  piecesPicked
  orderConsolidationType
  orderInvoiceByDate
  invoice {
    uuid
    name
    journalNumber
    postedAt
  }
  paymentMethod
  receivedDate
  pickedDate
  source
  status
  delegations {
    __typename
    uuid
    status
    scope
    executingCompanyName
    executingCompanyUuid
    originatorCompanyName
    originatorCompanyUuid
    organizationPeerUuid
    originalOrderUuid
    duplicateOrderUuid
    createdAt
    updatedAt
    acceptedAt
    declinedAt
    expiredAt
    revokedAt
    completedAt
    expiresAt
  }
  delegationAsDuplicate {
    __typename
    uuid
    status
    scope
    executingCompanyName
    executingCompanyUuid
    originatorCompanyName
    originatorCompanyUuid
    organizationPeerUuid
    originalOrderUuid
    duplicateOrderUuid
    createdAt
    updatedAt
    acceptedAt
    declinedAt
    expiredAt
    revokedAt
    completedAt
    originatorProgressStatus
  }
  uuid
  isDraftOrder
  chargeableWeightCubicMeters
  totalSkids
  isReweighed
  driverQualifications {
    id
    name
  }
  inBond
  hazmat
  itTeNumber
  itTeIssueDate
  unNumber
  hazmatDescription
  emergencyResponseNumber
  requiresPlacard
  hazmatClass
  packageGroup
  externalNotes
  totalAmountCents
  postedAmountCents
  recurringOrderFrequency {
    uuid
    startDate
    endDate
    repeatFrequencyUnit
    repeatInterval
    daysOfWeek
    daysOfMonth
    repeatIntervalWeeks
  }
  service {
    uuid
    name
  }
  standardOrderFields {
    uuid
    shipperBillOfLadingNumber
    lockShipperBillOfLadingNumber
    masterAirwayBillOfLadingNumber
    dimFactor
    measurementUnits
    weightUnits
  }
  scannedOrderResult {
    ...ScannedOrderResultFragment
    scannedOrder {
      ...ScannedOrderFragment
    }
  }
  secondaryRefNumber
  lockSecondaryRefNumber
  tertiaryRefNumber
  quaternaryRefNumber
  quinaryRefNumber
  documents {
    ...Document
  }
  paperwork {
    ...OrderPaperwork
  }
  billingPartyContact {
    defaultAddress {
      ...Address
    }
    uuid
    displayName
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
  }
  billingPartyContactStation {
    id
    name
    defaultPerson {
      id
      firstName
      lastName
      phone
      email
    }
  }
  packages {
    ...Package
    pieces {
      documents {
        uuid
      }
    }
  }
  originalTransmissionPackages {
    uuid
    quantity
    type
    weight
    length
    width
    height
    description
  }
  pieces {
    ...Piece
    documents {
      uuid
    }
  }
  shipments {
    ...StandardShipment
  }
  lineHaulCompletedDate
  lineHaulTimeline {
    terminal {
      uuid
      code
    }
    markedArrivedAt
    departingManifest {
      uuid
      status
      departDate
      startedAt
      completedAt
      referenceNumber
      driver {
        firstName
        lastName
        agentId
      }
    }
    arrivalScans {
      uuid
      scannedAt
    }
    departureScans {
      uuid
      scannedAt
    }
  }
  tags {
    ...Tag
  }
  thirdPartyBrokers {
    ...ThirdPartyBroker
  }
  warehouse {
    uuid
    name
    terminal {
      uuid
    }
  }
  lineHaulOriginTerminal {
    uuid
    code
  }
  ordersWithSameBillOfLadingNumberForReviewOrders {
    ...OrderWithSameBillOfLadingNumberAsReviewOrder
  }
  orderComments {
    uuid
    updatedAt
    user {
      uuid
      email
    }
    comment
    showOnInvoice
    authorName
    piece {
      uuid
      referenceNumber
    }
  }
  dateMarkedLoaded
  dateMarkedOnHand
  dateMarkedReceivedAtOrigin
  pieceCount
  piecesPicked
  piecesLoaded
  enableLineHaul
  lineHaulLane {
    uuid
    originTerminal {
      uuid
      code
    }
    destinationTerminal {
      uuid
      code
    }
  }
  consolidatableOrders {
    error
    orders {
      uuid
    }
    shipments {
      uuid
    }
  }
  shouldBillIndividually
  consolidatedShipmentString
  consolidatedOrders {
    uuid
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
  deletedAutoAppliedAccessorials {
    ... on StandardAccessorialEntity {
      uuid
    }
    ... on PercentageAccessorialEntity {
      uuid
    }
    ... on WeightBasedAccessorialEntity {
      uuid
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
    }
    ... on WaitTimeAccessorialEntity {
      uuid
    }
    ... on UnitBasedAccessorialEntity {
      uuid
    }
    ... on SkidBasedAccessorialEntity {
      uuid
    }
    ... on SpecialAccessorialEntity {
      uuid
    }
    ... on AttemptsAccessorialEntity {
      uuid
    }
    ... on StorageDaysAccessorialEntity {
      uuid
    }
  }
  ...OrderFreightNeedsRate
}
    ${OrderProratedWithFragmentDoc}
${ScannedOrderResultFragmentFragmentDoc}
${ScannedOrderFragmentFragmentDoc}
${DocumentFragmentDoc}
${OrderPaperworkFragmentDoc}
${AddressFragmentDoc}
${PackageFragmentDoc}
${PieceFragmentDoc}
${StandardShipmentFragmentDoc}
${TagFragmentDoc}
${ThirdPartyBrokerFragmentDoc}
${OrderWithSameBillOfLadingNumberAsReviewOrderFragmentDoc}
${OrderFreightNeedsRateFragmentDoc}`;
export const StopForDriverSettlementFragmentDoc = gql`
    fragment StopForDriverSettlement on StopEntity {
  uuid
  stopDriverMaps {
    ...StopDriverMapForOrder
  }
  settlementDeductionName
  settlementDeductionFlatRate
  settlementDeductionPercentageRate
}
    ${StopDriverMapForOrderFragmentDoc}`;
export const BulkEditOrdersResponseFragmentFragmentDoc = gql`
    fragment BulkEditOrdersResponseFragment on BulkEditOrdersResponse {
  success
  orderStateActions {
    action
    results {
      total
      eligible
      ineligible
      succeeded
      failed
      eligibleItems
      ineligibleItems {
        uuid
        reason
      }
      failedItems {
        uuid
        reason
      }
    }
  }
  stopStateActions {
    action
    results {
      total
      eligible
      ineligible
      succeeded
      failed
      eligibleItems
      ineligibleItems {
        uuid
        reason
      }
      failedItems {
        uuid
        reason
      }
    }
  }
  warehouseUpdate {
    total
    eligible
    ineligible
    succeeded
    failed
    eligibleItems
    ineligibleItems {
      uuid
      reason
    }
    failedItems {
      uuid
      reason
    }
  }
  mawbUpdate {
    total
    eligible
    ineligible
    succeeded
    failed
    eligibleItems
    ineligibleItems {
      uuid
      reason
    }
    failedItems {
      uuid
      reason
    }
  }
  secondaryRefNumberUpdate {
    total
    eligible
    ineligible
    succeeded
    failed
    eligibleItems
    ineligibleItems {
      uuid
      reason
    }
    failedItems {
      uuid
      reason
    }
  }
  deadlineTypeUpdate {
    total
    eligible
    ineligible
    succeeded
    failed
    eligibleItems
    ineligibleItems {
      uuid
      reason
    }
    failedItems {
      uuid
      reason
    }
  }
  deadlineDateUpdate {
    total
    eligible
    ineligible
    succeeded
    failed
    eligibleItems
    ineligibleItems {
      uuid
      reason
    }
    failedItems {
      uuid
      reason
    }
  }
  serviceDateUpdate {
    total
    eligible
    ineligible
    succeeded
    failed
    eligibleItems
    ineligibleItems {
      uuid
      reason
    }
    failedItems {
      uuid
      reason
    }
  }
}
    `;
export const RateOrderSettlementBillLineItemFragmentDoc = gql`
    fragment RateOrderSettlementBillLineItem on RateIndependentSettlementBillLineItemSuccessOutput {
  customCostTotal
  customCosts {
    errorMessage
    existingCustomCostId
    fuelSurchargePercentageRate
    rateDollars
    totalDollars
  }
  freightCost {
    discountRate
    miles
    quantity
    rateDollars
    tariffUuid
    totalDollars
  }
  fuelCost {
    surchargeRate
    surchargeRatePercentage
    totalDollars
    flatRateUsdDollars
    warning
    warningDetails {
      fuelProfileName
      tariffName
      fuelProfileExpired
    }
  }
  success
  total
}
    `;
export const RateOrderExternalRatingFragmentDoc = gql`
    fragment RateOrderExternalRating on ExternalRatingResult {
  __typename
  ... on ExternalRatingSuccess {
    tariffName
    tariffEffectiveDate
    lines {
      freightClass
      weightLbs
      amountCents
      isMinimumAdjustment
    }
    minimumAdjustmentCents
    deficitWeightLbs
    finalCents
  }
  ... on ExternalRatingFailure {
    code
    message
    packageIndex
    retryable
  }
}
    `;
export const KpiDashboardLayoutFragmentDoc = gql`
    fragment KpiDashboardLayout on KpiLayoutEntity {
  customized
  tiles {
    metric
    format
  }
  defaultTiles {
    metric
    format
  }
  availableTiles {
    metric
    format
  }
}
    `;
export const KpiRecordFacetsFragmentDoc = gql`
    fragment KpiRecordFacets on KpiRecordFacetsEntity {
  customers {
    uuid
    name
  }
  terminals {
    uuid
    name
  }
  drivers {
    uuid
    name
  }
}
    `;
export const PieceReceiptFragmentDoc = gql`
    fragment PieceReceipt on PieceReceiptEntity {
  uuid
  source
  referenceNumber
  purchaseOrderNumber
  carrier
  trackingNumber
  supplierCompanyName
  lotNumber
  consigneeName
  trailerNumber
  sealNumber
  billOfLadingNumber
  notes
  pickupDate
  expectedAt
  arrivedAt
  contact {
    uuid
    displayName
  }
  warehouse {
    uuid
    name
  }
}
    `;
export const PieceReceiptPieceFragmentDoc = gql`
    fragment PieceReceiptPiece on PieceEntity {
  uuid
  referenceNumber
  status
  type
  quantity
  warehouseLocation {
    uuid
    name
  }
  children {
    uuid
    referenceNumber
    status
    quantity
    warehouseLocation {
      uuid
      name
    }
  }
}
    `;
export const PieceReceiptDetailFragmentDoc = gql`
    fragment PieceReceiptDetail on PieceReceiptEntity {
  ...PieceReceipt
  pieces {
    ...PieceReceiptPiece
  }
}
    ${PieceReceiptFragmentDoc}
${PieceReceiptPieceFragmentDoc}`;
export const PieceReceiptSearchResultFragmentDoc = gql`
    fragment PieceReceiptSearchResult on PieceListEntity {
  uuid
  referenceNumber
  status
  warehouseLocationName
}
    `;
export const FindPiecesFragmentDoc = gql`
    fragment FindPieces on PieceListEntity {
  uuid
  referenceNumber
  status
  markedOnHandAt
  createdAt
  orderUuid
  orderName
  packageUuid
  packageName
  packageOrderUuid
  packageOrderName
  packedPieceCount
  hawb
  mawb
  terminalUuid
  terminalName
  warehouseLocationUuid
  warehouseLocationName
  warehouseUuid
  warehouseName
  customerUuid
  customerName
  isUnalertedFreight
  dwellStatus
  effectiveDwellThresholdDays
  daysOverDwellThreshold
}
    `;
export const FindPiecesInboundFragmentDoc = gql`
    fragment FindPiecesInbound on PieceListEntity {
  weight
  weightUnits
  carrier
  eta
  origin
  totalPieces
}
    `;
export const FindPiecesDeliveredFragmentDoc = gql`
    fragment FindPiecesDelivered on PieceListEntity {
  damagedAt
  refusedAt
  deliveredAt
  recipient
  destination
  podSignedBy
  isOverage
  isShortage
  isMisrouted
}
    `;
export const FindPiecesInTransitFragmentDoc = gql`
    fragment FindPiecesInTransit on PieceListEntity {
  routeName
  driverName
  truckName
  departedAt
  etaArrivalTime
}
    `;
export const FindPiecesDiscardedFragmentDoc = gql`
    fragment FindPiecesDiscarded on PieceListEntity {
  discardedAt
  discardedReason
  discardedByName
}
    `;
export const PieceDetailFragmentDoc = gql`
    fragment PieceDetail on PieceEntity {
  uuid
  referenceNumber
  additionalReferenceNumbers
  status
  type
  quantity
  createdAt
  markedOnHandAt
  pickedUpAt
  damagedAt
  damagedNote
  refusedAt
  refusedReason
  discardedAt
  discardedReason
  isOverage
  isShortage
  isMisrouted
  isUnalertedFreight
  hawb
  customer {
    uuid
    displayName
  }
  weight
  dimWeight
  length
  width
  height
  weightUnits
  measurementUnits
  terminal {
    uuid
    name
  }
  warehouse {
    uuid
    name
  }
  warehouseLocation {
    uuid
    name
  }
  packageHasPieces {
    uuid
    package {
      uuid
      description
      order {
        uuid
        name
        standardOrderFields {
          hawb
          masterAirwayBillOfLadingNumber
        }
      }
    }
  }
  documents {
    uuid
    fileName
    fileType
    type
    preSignedGetUrl
    notes
    pageNumber
  }
  children {
    uuid
    referenceNumber
    status
    type
    weight
    length
    width
    height
    weightUnits
    measurementUnits
  }
}
    `;
export const PieceEventFragmentDoc = gql`
    fragment PieceEvent on OrderEventEntity {
  uuid
  createdAt
  eventType
  message
  sourceType
  sourceUser {
    uuid
    email
  }
  sourceDriver {
    uuid
    firstName
    lastName
  }
  sourceWarehouseEmployee {
    uuid
    firstName
    lastName
  }
}
    `;
export const EmailQuoteQueueRowFragmentDoc = gql`
    fragment EmailQuoteQueueRow on OrderQuote {
  __typename
  uuid
  number
  status
  quotedAmountCents
  currency
  sentAt
  validUntil
  needsAttentionAt
  createdAt
  senderAddress
  senderDisplayName
  subject
  queueGroup
  missingFields
  unpriceableReasons
  pricingState
  attentionReasons
  order {
    __typename
    uuid
  }
  customer {
    __typename
    uuid
    name
  }
}
    `;
export const ClientQuoteFragmentDoc = gql`
    fragment ClientQuote on QuoteEntity {
  uuid
  createdAt
  source
  status
  number
  billingPartyContact {
    displayName
    uuid
  }
  totalCharge
  order {
    uuid
  }
}
    `;
export const QuoteFreightNeedsRateFragmentDoc = gql`
    fragment QuoteFreightNeedsRate on QuoteEntity {
  freightNeedsRate
  shipments {
    uuid
    freightCharge {
      ...FreightChargeNeedsRate
    }
  }
}
    ${FreightChargeNeedsRateFragmentDoc}`;
export const InvoicePdfColumnFragmentFragmentDoc = gql`
    fragment InvoicePdfColumnFragment on PdfColumnEntity {
  uuid
  orderColumnMapping
  shipmentPDFColumnMapping
  legPDFColumnMapping
  stopPDFColumnMapping
}
    `;
export const InvoiceTermFragmentDoc = gql`
    fragment InvoiceTerm on InvoiceTermEntity {
  uuid
  terms
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on ContactEntity {
  uuid
  displayName
  ediApplicationId
  ediContactCode
  isActive
  isaId
  identifier
  contactReferenceNumber
  shortCode
  stediPartnerId
  isOverCreditLimit
  quickbooksDesktopContactId
  stediPartnerId
  quickbooksMappingId
  fuelChargeQuickbooksMappingId
  freightChargeQuickbooksMappingId
  miscCustomChargeQuickbooksMappingId
  type
  billingCycle
  billingCycleDuration
  billingPeriod
  requireDriverToCheckOffPackagesAtStop
  invoiceNotes
  customDunningReportFooter
  masterAccount {
    uuid
  }
  contactComments {
    uuid
    updatedAt
    createdAt
    comment
    authorName
  }
  serviceGroupId
  accessorialGroupId
  services {
    ...Service
  }
  customerAccessorials {
    ... on StandardAccessorialEntity {
      uuid
      name
    }
    ... on PercentageAccessorialEntity {
      uuid
      name
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
      name
    }
    ... on UnitBasedAccessorialEntity {
      uuid
      name
    }
    ... on SkidBasedAccessorialEntity {
      uuid
      name
    }
    ... on WeightBasedAccessorialEntity {
      uuid
      name
    }
    ... on WaitTimeAccessorialEntity {
      uuid
      name
    }
    ... on SpecialAccessorialEntity {
      uuid
      name
    }
    ... on AttemptsAccessorialEntity {
      uuid
      name
    }
    ... on StorageDaysAccessorialEntity {
      uuid
      name
    }
  }
  invoicePdfColumns {
    ...InvoicePdfColumnFragment
  }
  addresses {
    ...Address
  }
  contactPersons {
    ...ContactPerson
  }
  defaultAddress {
    ...Address
  }
  defaultContactPerson {
    ...ContactPerson
  }
  defaultService {
    ...Service
  }
  businessDivision {
    uuid
    name
  }
  masterAccount {
    uuid
    name
  }
  referenceNumberLabels {
    name
  }
  ... on CustomerContactEntity {
    defaultFuelSurcharge
    defaultUseTariff
    defaultFreightBillingMethod
    defaultFreightClass
    pickupDiscountRate
    deliveryDiscountRate
    transferDiscountRate
    recoveryDiscountRate
    lineHaulDiscountRate
    defaultDimFactor
    billingContactEmail
    defaultInvoiceType
    defaultInvoiceTransmissionMethod
    defaultInvoiceDownloadDocuments
    defaultInvoiceDocumentsRequired
    defaultInvoiceEmailSubject
    invoiceVendorDisplayName
    defaultAddress {
      ...Address
    }
    defaultContactPerson {
      ...ContactPerson
    }
    identifier
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
    defaultInvoiceTerms {
      ...InvoiceTerm
    }
    creditHoldLimitInCents
    enableCreditHold
    maxDaysOutstanding
    isPrepaidOnly
    allowDriverToCompleteStopAfterAttemptWithoutReassignment
    enableCustomerPortalOrderEntry
    enableCustomerPortalInventory
    displayChargesInCustomerPortal
    customerPortalChargesVisibleFrom
    includeInExpeditorsScorecard
    useCustomPackageSpecs
    packageSpecs {
      id
    }
    showEdiReferenceNumbersOnOrderPage
    useCustomVehicleTypes
    vehicleTypes {
      uuid
    }
    defaultInboundEdiService {
      uuid
      name
    }
    defaultOutboundEdiService {
      uuid
      name
    }
    defaultInboundOutboundEdiService {
      uuid
      name
    }
    defaultOrdinaryTariffChain {
      id
      name
    }
    defaultLineHaulTariffChain {
      id
      name
    }
    defaultTransferTariffChain {
      id
      name
    }
    defaultRecoveryTariffChain {
      id
      name
    }
    defaultPointToPointTariffChain {
      id
      name
    }
  }
}
    ${ServiceFragmentDoc}
${InvoicePdfColumnFragmentFragmentDoc}
${AddressFragmentDoc}
${ContactPersonFragmentDoc}
${InvoiceTermFragmentDoc}`;
export const QuoteFragmentDoc = gql`
    fragment Quote on QuoteEntity {
  uuid
  number
  createdAt
  service {
    uuid
  }
  status
  dimFactor
  measurementUnits
  weightUnits
  totalSkids
  source
  shipments {
    ...StandardShipment
  }
  packages {
    ...Package
  }
  billingPartyContact {
    ...Contact
  }
  company {
    ...Company
  }
  order {
    uuid
  }
  deletedAutoAppliedAccessorials {
    ... on StandardAccessorialEntity {
      uuid
    }
    ... on PercentageAccessorialEntity {
      uuid
    }
    ... on WeightBasedAccessorialEntity {
      uuid
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
    }
    ... on WaitTimeAccessorialEntity {
      uuid
    }
    ... on UnitBasedAccessorialEntity {
      uuid
    }
    ... on SkidBasedAccessorialEntity {
      uuid
    }
    ... on SpecialAccessorialEntity {
      uuid
    }
    ... on AttemptsAccessorialEntity {
      uuid
    }
    ... on StorageDaysAccessorialEntity {
      uuid
    }
  }
  enableLineHaul
}
    ${StandardShipmentFragmentDoc}
${PackageFragmentDoc}
${ContactFragmentDoc}
${CompanyFragmentDoc}`;
export const CustomerReportBucketFragmentDoc = gql`
    fragment CustomerReportBucket on CustomerReportBucketEntity {
  uuid
  displayName
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const DriverReportBucketFragmentDoc = gql`
    fragment DriverReportBucket on DriverReportBucketEntity {
  uuid
  firstName
  lastName
  driverType
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const OrderReportBucketFragmentDoc = gql`
    fragment OrderReportBucket on OrderReportBucketEntity {
  startDate
  endDate
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const ReportGroupConfigurationFragmentDoc = gql`
    fragment ReportGroupConfiguration on ReportGroupConfigurationEntity {
  uuid
  name
  contact {
    uuid
    displayName
  }
  contacts {
    uuid
    displayName
  }
  driver {
    uuid
    firstName
    lastName
  }
  drivers {
    uuid
    firstName
    lastName
  }
  orderStatuses
  stopTypes
  reportAggregationPeriod
  defaultReportType
  reportRevenueType
  reportStatistics
  lastNumberOfDays
  lastNumberOfWeeks
  lastNumberOfMonths
  startDate
  endDate
  terminal {
    uuid
    code
  }
}
    `;
export const ReportSendJobBatchProgressFragmentDoc = gql`
    fragment ReportSendJobBatchProgress on ReportSendJobBatchProgressEntity {
  successCount
  failCount
  totalCount
}
    `;
export const ReportSendJobBatchFragmentDoc = gql`
    fragment ReportSendJobBatch on ReportSendJobBatchEntity {
  id
  createdAt
  reportSendJobBatchProgress {
    ...ReportSendJobBatchProgress
  }
  reportSendJobs {
    id
    createdAt
    reportType
  }
}
    ${ReportSendJobBatchProgressFragmentDoc}`;
export const ReportSendJobFragmentDoc = gql`
    fragment ReportSendJob on ReportSendJobEntity {
  id
  reportType
  contact {
    displayName
  }
  reportSendJobError
  emailTransaction {
    emailTransactionStatus
    emailTransactionLogs {
      uuid
      email
      lastStatus
      reason
    }
  }
  document {
    preSignedGetUrl
  }
}
    `;
export const ServiceLevelReportBucketFragmentDoc = gql`
    fragment ServiceLevelReportBucket on ServiceLevelReportBucketEntity {
  uuid
  name
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const StationReportBucketFragmentDoc = gql`
    fragment StationReportBucket on StationReportBucketEntity {
  startDate
  endDate
  stationId
  stationName
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const TerminalReportBucketFragmentDoc = gql`
    fragment TerminalReportBucket on TerminalReportBucketEntity {
  uuid
  name
  code
  freightRevenue
  fuelRevenue
  lineHaulRevenue
  specialRevenue
  customChargeRevenue
  surchargeRevenue
  pickupRevenue
  deliveryRevenue
  recoveryRevenue
  transferRevenue
  totalRevenue
  totalWeight
  numberOfOrders
  numberOfPackages
}
    `;
export const FindRolePermissionFragmentDoc = gql`
    fragment FindRolePermission on PermissionEntity {
  uuid
  permissionResource
  accessLevel
}
    `;
export const FindRoleUserFragmentDoc = gql`
    fragment FindRoleUser on UserEntity {
  uuid
  email
}
    `;
export const FindRoleFragmentDoc = gql`
    fragment FindRole on RoleEntity {
  uuid
  name
  permissions {
    ...FindRolePermission
  }
  users {
    ...FindRoleUser
  }
}
    ${FindRolePermissionFragmentDoc}
${FindRoleUserFragmentDoc}`;
export const FindRolesFragmentDoc = gql`
    fragment FindRoles on RoleEntity {
  uuid
  name
  isInternalRole
}
    `;
export const UsersForRoleFragmentDoc = gql`
    fragment UsersForRole on UserEntity {
  uuid
  email
  phoneNumber
  name
}
    `;
export const SavedFilterViewFragmentDoc = gql`
    fragment SavedFilterView on SavedFilterViewEntity {
  uuid
  user {
    uuid
  }
  displayName
  description
  savedViewPageType
  isShared
  isPublicToCompany
  myPermission
  grants {
    uuid
    granteeType
    granteeUuid
    granteeName
    permission
  }
  filterModelJson
  filterModelJsonV2
  sortModelJson
  groupModelJson
  baseTab
  orderTableFields
  dispatchTableFields
  lineHaulDispatchFilters {
    laneFilter {
      originTerminalUuids
      destinationTerminalUuids
    }
    boardFilters {
      legStates
      pieceStatuses
      detailedStatuses
    }
  }
}
    `;
export const ScannedOrderResultPageFragmentFragmentDoc = gql`
    fragment ScannedOrderResultPageFragment on ScannedOrderResultPageEntity {
  uuid
  bucket
  key
  page
  preSignedGetUrl
}
    `;
export const ScannedOrderResultWithOrdersFragmentDoc = gql`
    fragment ScannedOrderResultWithOrders on ScannedOrderResultEntity {
  uuid
  createdAt
  duplicateOrder {
    uuid
    name
    source
  }
  duplicateScannedOrderResultOrder {
    uuid
    name
    source
  }
  status
  signedPodMatchStatus
  failureReason
  dismissed
  filename
  pageEnd
  pageStart
  order {
    uuid
    name
    billingPartyContact {
      uuid
      displayName
    }
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
  podOrder {
    uuid
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
}
    `;
export const AllSchedulingZoneFieldsFragmentDoc = gql`
    fragment AllSchedulingZoneFields on SchedulingZoneEntity {
  id
  name
  isArchived
  availabilities {
    id
    dayOfWeek
    start {
      hour
      minute
    }
    end {
      hour
      minute
    }
  }
  locations {
    id
    zipcode
    city
  }
}
    `;
export const AllSchedulingRegionFieldsFragmentDoc = gql`
    fragment AllSchedulingRegionFields on SchedulingRegionEntity {
  id
  name
  dailyCapacityPieces
  dailyCapacityStops
  dailyCapacityWeight
  isArchived
  zones {
    ...AllSchedulingZoneFields
  }
}
    ${AllSchedulingZoneFieldsFragmentDoc}`;
export const CompanySchedulingBlockedDayFieldsFragmentDoc = gql`
    fragment CompanySchedulingBlockedDayFields on SchedulingBlockedDayEntity {
  id
  reason
  exemptSchedulingResourceIds
  date {
    iso8601
  }
}
    `;
export const CompanySchedulingBlockedDayResultFieldsFragmentDoc = gql`
    fragment CompanySchedulingBlockedDayResultFields on CompanySchedulingBlockedDayOutput {
  __typename
  ... on CompanySchedulingBlockedDaySuccessOutput {
    liveClaimCount
    affectedSchedulingResourceCount
    schedulingBlockedDay {
      ...CompanySchedulingBlockedDayFields
    }
    affectedSchedulingResources {
      id
      name
      liveClaimCount
    }
  }
  ... on CompanySchedulingDayLiveClaimsOutput {
    message
    liveClaimCount
    affectedSchedulingResourceCount
    affectedSchedulingResources {
      id
      name
      liveClaimCount
    }
  }
  ... on CompanySchedulingDayExemptionsAtRiskOutput {
    message
    exemptSchedulingResourceCount
  }
  ... on MutationErrorOutput {
    message
  }
}
    ${CompanySchedulingBlockedDayFieldsFragmentDoc}`;
export const SchedulingResourceEligibilityRulesFieldsFragmentDoc = gql`
    fragment SchedulingResourceEligibilityRulesFields on SchedulingResourceEligibilityRulesOutput {
  tags {
    allow
    deny
    restricted
  }
  services {
    allow
    deny
    restricted
  }
  customers {
    allow
    deny
    restricted
  }
}
    `;
export const SchedulingResourceListFieldsFragmentDoc = gql`
    fragment SchedulingResourceListFields on SchedulingResourceEntity {
  id
  name
  dayOfWeek
  timeZone
  isArchived
  start {
    hour
    minute
  }
  end {
    hour
    minute
  }
  capacityStops
  capacityPieces
  capacityWeight
  routeNames {
    uuid
    name
  }
  blockedDaysCount
  eligibilityRules {
    ...SchedulingResourceEligibilityRulesFields
  }
}
    ${SchedulingResourceEligibilityRulesFieldsFragmentDoc}`;
export const SchedulingResourceBlockedDayFieldsFragmentDoc = gql`
    fragment SchedulingResourceBlockedDayFields on SchedulingResourceBlockedDayEntity {
  id
  reason
  date {
    iso8601
  }
}
    `;
export const AllSchedulingResourceFieldsFragmentDoc = gql`
    fragment AllSchedulingResourceFields on SchedulingResourceEntity {
  ...SchedulingResourceListFields
  blockedDays {
    ...SchedulingResourceBlockedDayFields
  }
}
    ${SchedulingResourceListFieldsFragmentDoc}
${SchedulingResourceBlockedDayFieldsFragmentDoc}`;
export const SchedulingResourceMutationResultFieldsFragmentDoc = gql`
    fragment SchedulingResourceMutationResultFields on SchedulingResourceOutput {
  __typename
  ... on SchedulingResourceSuccessOutput {
    schedulingResource {
      ...AllSchedulingResourceFields
    }
  }
  ... on SchedulingResourceNameConflictOutput {
    message
    conflictingSchedulingResourceId
    conflictingSchedulingResourceName
  }
  ... on SchedulingResourceLiveClaimsOutput {
    message
    liveClaimCount
    liveClaimDatesIso8601
  }
  ... on MutationErrorOutput {
    message
  }
}
    ${AllSchedulingResourceFieldsFragmentDoc}`;
export const ReferenceNumberFormatCheckFragmentDoc = gql`
    fragment ReferenceNumberFormatCheck on ReferenceNumberFormatCheckEntity {
  uuid
  type
  operator
  startsWithOperands
  lengthOperand
}
    `;
export const Smc3ConnectionFailureFragmentDoc = gql`
    fragment Smc3ConnectionFailure on Smc3ConnectionFailureEntity {
  code
  providerCode
  providerMessage
  retryable
  retryAfter
}
    `;
export const Smc3SettingsFragmentDoc = gql`
    fragment Smc3Settings on Smc3SettingsEntity {
  hasCredentials
  isEnabled
  environment
  defaultTariffName
  pinnedTariffEffectiveDate
  version
  diagnostics {
    lastSuccessAt
    lastErrorCode
    lastErrorAt
  }
}
    `;
export const DriverSettlementBillSummaryV2FragmentDoc = gql`
    fragment DriverSettlementBillSummaryV2 on DriverSettlementBillEntity {
  uuid
  name
  payPeriod
  settlementDate
  finalizedDate
  snapshotExists
  driver {
    uuid
    user {
      name
    }
  }
  paymentInformation {
    eligiblePay
    netAdjustments
    finalPay
  }
}
    `;
export const SettlementAdjustmentFragmentDoc = gql`
    fragment SettlementAdjustment on SettlementAdjustmentEntity {
  uuid
  adjustmentType
  name
  flatRate
  percentageDecimalRate
  totalDollars
}
    `;
export const SettlementBillLineItemFragmentDoc = gql`
    fragment SettlementBillLineItem on SettlementBillLineItemEntity {
  id
  totalAmountUsdDollars
  driver {
    uuid
    driverType
    user {
      name
    }
  }
  driverSettlementBill {
    uuid
    settlementDate
    finalizedDate
  }
  shipment {
    order {
      uuid
      refNumbers
      name
      standardOrderFields {
        shipperBillOfLadingNumber
      }
      billingPartyContact {
        displayName
      }
    }
    legs {
      endStop {
        stopType
        completedAt
      }
    }
  }
}
    `;
export const DriverSettlementBillV2FragmentDoc = gql`
    fragment DriverSettlementBillV2 on DriverSettlementBillEntity {
  uuid
  name
  createdAt
  billStartDate
  billEndDate
  payPeriod
  settlementDate
  totalDriverPayoutPreDeduction
  snapshot
  driver {
    uuid
    firstName
    lastName
    user {
      name
    }
  }
  finalizedDate
  settlementAdjustments {
    ...SettlementAdjustment
  }
  paymentInformation {
    eligiblePay
    netAdjustments
    finalPay
  }
  settlementBillLineItems {
    ...SettlementBillLineItem
  }
}
    ${SettlementAdjustmentFragmentDoc}
${SettlementBillLineItemFragmentDoc}`;
export const SettlementBillLineItemWithCostsFragmentDoc = gql`
    fragment SettlementBillLineItemWithCosts on SettlementBillLineItemEntity {
  id
  totalAmountUsdDollars
  customCosts {
    id
    name
    billingMethod
    dependentSettlementBillingMethod
    percentageRate
    flatRateUsdDollars
    quantity
    rateUsdDollars
    fuelSurchargeRate
    totalAmountUsdDollars
    accessorialTemplate {
      uuid
      name
      type
    }
  }
  freightCost {
    id
    billingMethod
    dependentSettlementBillingMethod
    percentageRate
    flatRateUsdDollars
    quantity
    rateUsdDollars
    discountRate
    totalAmountUsdDollars
    tariff {
      uuid
    }
    fuelCost {
      id
      billingMethod
      dependentSettlementBillingMethod
      percentageRate
      surchargeRate
      flatRateUsdDollars
      totalAmountUsdDollars
    }
  }
}
    `;
export const CompletedStopNotOnRouteFragmentDoc = gql`
    fragment CompletedStopNotOnRoute on StopEntity {
  uuid
  createdAt
  notes
  specialInstructions
  leg {
    shipment {
      uuid
      standardShipmentFields {
        pickupOrDelivery
      }
      order {
        uuid
        name
        standardOrderFields {
          uuid
          shipperBillOfLadingNumber
        }
      }
      documents {
        ...Document
      }
    }
  }
  routeSlot {
    uuid
    route {
      uuid
    }
  }
  status
  appointmentTime
  endAppointmentTime
  appointmentTextStatus
  address {
    ...Address
  }
  paperworkMarkedComplete
}
    ${DocumentFragmentDoc}
${AddressFragmentDoc}`;
export const CreateStorageOrderDocumentFragmentDoc = gql`
    fragment CreateStorageOrderDocument on DocumentEntity {
  uuid
}
    `;
export const CreateStorageOrderFragmentDoc = gql`
    fragment CreateStorageOrder on StorageOrderEntity {
  uuid
}
    `;
export const FindStorageOrderStorageUnitsFragmentDoc = gql`
    fragment FindStorageOrderStorageUnits on StorageUnitEntity {
  uuid
  name
  unitOfMeasure
  items {
    assignedQuantity
    item {
      uuid
      sku
      description
    }
  }
}
    `;
export const StorageUnitItemFragmentDoc = gql`
    fragment StorageUnitItem on ItemForStorageUnit {
  item {
    uuid
    primaryUOM {
      uuid
      unitOfMeasure
    }
    sku
    description
  }
  assignedQuantity
}
    `;
export const StorageOrderStorageUnitFragmentDoc = gql`
    fragment StorageOrderStorageUnit on StorageUnitEntity {
  uuid
  name
  unitOfMeasure
  weight
  length
  width
  height
  outboundReferenceNumber
  markedOnHandAt
  markedOsdAt
  osdReason
  inventoryLastVerifiedAt
  pickedAt
  warehouseLocation {
    uuid
    name
  }
  items {
    ...StorageUnitItem
  }
}
    ${StorageUnitItemFragmentDoc}`;
export const StorageOrderContactFragmentDoc = gql`
    fragment StorageOrderContact on ContactEntity {
  uuid
  displayName
}
    `;
export const StorageOrderDocumentFragmentDoc = gql`
    fragment StorageOrderDocument on DocumentEntity {
  uuid
  fileName
  bucket
  region
  key
  uploadedAt
  fileType
  isDeleted
  preSignedGetUrl
  name
  type
  customDocumentName
  pageNumber
  createdAt
}
    `;
export const ShallowItemFragmentDoc = gql`
    fragment ShallowItem on ItemEntity {
  uuid
  description
  sku
  primaryUOM {
    unitOfMeasure
  }
  secondaryUOM {
    unitOfMeasure
  }
  warehouse {
    uuid
    name
  }
}
    `;
export const StorageOrderItemFragmentDoc = gql`
    fragment StorageOrderItem on ItemForStorageOrder {
  item {
    ...ShallowItem
  }
  totalQuantity
  unassignedQuantity
}
    ${ShallowItemFragmentDoc}`;
export const FindStorageOrderFragmentDoc = gql`
    fragment FindStorageOrder on StorageOrderEntity {
  uuid
  referenceNumber
  purchaseOrderNumber
  carrier
  trackingNumber
  supplierCompanyName
  lotNumber
  consigneeName
  notes
  pickupDate
  expectedAt
  arrivedAt
  contact {
    ...StorageOrderContact
  }
  documents {
    ...StorageOrderDocument
  }
  items {
    ...StorageOrderItem
  }
  isOSD
  warehouse {
    uuid
    name
  }
}
    ${StorageOrderContactFragmentDoc}
${StorageOrderDocumentFragmentDoc}
${StorageOrderItemFragmentDoc}`;
export const StorageOrderFragmentDoc = gql`
    fragment StorageOrder on StorageOrderEntity {
  uuid
  referenceNumber
  purchaseOrderNumber
  carrier
  trackingNumber
  supplierCompanyName
  lotNumber
  consigneeName
  notes
  pickupDate
  expectedAt
  arrivedAt
  contact {
    ...StorageOrderContact
  }
  isOSD
  warehouse {
    uuid
    name
  }
}
    ${StorageOrderContactFragmentDoc}`;
export const FindStorageUnitsForPicklistFragmentDoc = gql`
    fragment FindStorageUnitsForPicklist on StorageUnitEntity {
  uuid
  name
  unitOfMeasure
  markedOnHandAt
  markedOsdAt
  pickedAt
  storageOrder {
    referenceNumber
    contact {
      uuid
      displayName
    }
  }
  warehouseLocation {
    uuid
    name
  }
  itemUOM
  sku
}
    `;
export const FindStorageUnitsFragmentDoc = gql`
    fragment FindStorageUnits on StorageUnitEntity {
  uuid
  name
  unitOfMeasure
  outboundReferenceNumber
  billed
  markedOnHandAt
  markedOsdAt
  inventoryLastVerifiedAt
  pickedAt
  currentBillableDays
  numberOfDaysInStorage
  storageOrder {
    uuid
    referenceNumber
    contact {
      uuid
      displayName
    }
  }
  warehouseLocation {
    uuid
    name
  }
  itemUOM
  sku
  itemDescription
}
    `;
export const FindItemGroupsFragmentDoc = gql`
    fragment FindItemGroups on ItemGroupEntity {
  uuid
  quantity
  pickedAt
  storageUnit {
    uuid
    name
    outboundReferenceNumber
    billed
    markedOnHandAt
    markedOsdAt
    inventoryLastVerifiedAt
    pickedAt
    currentBillableDays
    numberOfDaysInStorage
    unitOfMeasure
    warehouseLocation {
      uuid
      name
    }
    weight
    length
    width
    height
    osdReason
  }
  storageOrder {
    uuid
    referenceNumber
    contact {
      uuid
      displayName
    }
    arrivedAt
    consigneeName
    supplierCompanyName
    purchaseOrderNumber
    lotNumber
    warehouse {
      uuid
      name
    }
  }
  item {
    sku
    description
    primaryUOM {
      uuid
      unitOfMeasure
    }
  }
}
    `;
export const UpdateStorageOrderFragmentDoc = gql`
    fragment UpdateStorageOrder on StorageOrderEntity {
  uuid
}
    `;
export const UpdateStorageUnitFragmentDoc = gql`
    fragment UpdateStorageUnit on StorageUnitEntity {
  uuid
}
    `;
export const ShallowTariffZoneFragmentDoc = gql`
    fragment ShallowTariffZone on TariffZoneEntity {
  uuid
  name
  type
}
    `;
export const CreateWarehouseLocationFragmentDoc = gql`
    fragment CreateWarehouseLocation on WarehouseLocationEntity {
  uuid
}
    `;
export const WarehouseLocationsLocationFragmentDoc = gql`
    fragment WarehouseLocationsLocation on WarehouseLocationEntity {
  uuid
  name
  location1
  location2
  location3
  warehouse {
    uuid
    name
    terminal {
      uuid
      isActive
    }
  }
}
    `;
export const UpdateWarehouseLocationFragmentDoc = gql`
    fragment UpdateWarehouseLocation on WarehouseLocationEntity {
  uuid
}
    `;
export const AblyTokenDocument = gql`
    query ablyToken {
  ablyToken {
    token
  }
}
    `;
export const ActiveAgentsDocument = gql`
    query activeAgents {
  activeAgents {
    uuid
    name
  }
}
    `;
export const ContactForAutocompleteDocument = gql`
    query contactForAutocomplete($uuid: String!) {
  contact(uuid: $uuid) {
    displayName
    uuid
    ... on CustomerContactEntity {
      isPrepaidOnly
    }
    isActive
    isOverCreditLimit
    calculateInboundFreightCharges
    calculateOutboundFreightCharges
    calculateLineHaulFreightCharges
  }
}
    `;
export const ContactPackageSpecsDocument = gql`
    query ContactPackageSpecs($contactUuid: String!) {
  contact(uuid: $contactUuid) {
    uuid
    ... on CustomerContactEntity {
      useCustomPackageSpecs
      defaultFreightClass
      packageSpecs {
        id
        name
        status
        freightClass
      }
    }
  }
}
    `;
export const ContactsForAutocompleteDocument = gql`
    query contactsForAutocomplete($excludeNonActive: Boolean) {
  contacts(excludeNonActive: $excludeNonActive) {
    displayName
    uuid
    ... on CustomerContactEntity {
      isPrepaidOnly
    }
    isActive
  }
}
    `;
export const DispatchableDriversDocument = gql`
    query dispatchableDrivers($getDispatchableDriversInput: GetDispatchableDriversInput!, $canReadIntelligenceBoard: Boolean! = false) {
  dispatchableDrivers(getDispatchableDriversInput: $getDispatchableDriversInput) {
    companyDrivers {
      user {
        name
      }
      firstName
      lastName
      uuid
      phoneNumber
      terminal {
        name
      }
      driverReferenceNumber
      driverType
      driverPayType @include(if: $canReadIntelligenceBoard)
      perMileRate @include(if: $canReadIntelligenceBoard)
      percentGrossRevenueRate @include(if: $canReadIntelligenceBoard)
    }
    agents {
      uuid
      name
      defaultDriver {
        uuid
        driverType
      }
    }
  }
}
    `;
export const DriverMinimalDocument = gql`
    query driverMinimal($uuid: String!, $canReadIntelligenceBoard: Boolean! = false) {
  driver(uuid: $uuid) {
    uuid
    user {
      name
    }
    agent {
      uuid
      name
    }
    firstName
    lastName
    phoneNumber
    driverType
    driverPayType @include(if: $canReadIntelligenceBoard)
    perMileRate @include(if: $canReadIntelligenceBoard)
    percentGrossRevenueRate @include(if: $canReadIntelligenceBoard)
    terminal {
      name
    }
  }
}
    `;
export const LoginDocument = gql`
    mutation login($loginInputData: LoginInput!) {
  login(loginInputData: $loginInputData) {
    status
    fullAccessUser {
      uuid
      company {
        purchasedProductOfferings
      }
    }
    thirdPartyUser {
      uuid
    }
    clientChallenge {
      uuid
      name
      squareLogoUrl
    }
    kind
  }
}
    `;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export const MeAsThirdPartyUserForAuthDocument = gql`
    query meAsThirdPartyUserForAuth {
  meAsThirdPartyUser {
    email
    uuid
    contacts {
      company {
        uuid
        name
      }
    }
  }
}
    `;
export const MeAsThirdPartyUserDocument = gql`
    query meAsThirdPartyUser {
  meAsThirdPartyUser {
    email
    uuid
    contacts {
      uuid
      displayName
      showChargesOnCustomerPortal
      ... on CustomerContactEntity {
        enableCustomerPortalOrderEntry
        enableCustomerPortalInventory
      }
      isPrepaidOnly
      company {
        uuid
        segment
        timeZone
        defaultWeightUnits
        services {
          ...Service
        }
        isCourier
        customerPortalConfiguration {
          defaultDimFactor
          terminalsEnabled
          logisticsSectionEnabled
        }
        defaultMeasurementUnits
        productionCompany
        name
      }
    }
  }
}
    ${ServiceFragmentDoc}`;
export const MeForAuthDocument = gql`
    query MeForAuth {
  me {
    email
    uuid
    company {
      uuid
      name
    }
  }
}
    `;
export const MarkTutorialSeenDocument = gql`
    mutation markTutorialSeen($tutorialId: TutorialId!) {
  markTutorialSeen(tutorialId: $tutorialId)
}
    `;
export const MeDocument = gql`
    query me {
  me {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export const UserRolesDocument = gql`
    query userRoles {
  userRoles {
    ...MeRole
  }
}
    ${MeRoleFragmentDoc}`;
export const TableFieldsDocument = gql`
    query tableFields {
  tableFields {
    orderTableFields
    billingReviewOrderTableFields
    linehaulDispatchTableFields
    dispatchTableFields
    routeCardStopTableFields
    dispatchTableColumnWidths {
      colId
      width
    }
    ordersTableColumnWidths {
      colId
      width
    }
    invoicesTableColumnWidths {
      colId
      width
    }
    routeCardStopTableColumnWidths {
      colId
      width
    }
  }
}
    `;
export const TariffChainsDocument = gql`
    query tariffChains($findTariffChainsInput: FindTariffChainsInput!) {
  tariffChains(findTariffChainsInput: $findTariffChainsInput) {
    ...TariffChain
  }
}
    ${TariffChainFragmentDoc}`;
export const TemplateAddressesDocument = gql`
    query templateAddresses($first: Int, $searchText: String) {
  templateAddresses(first: $first, searchText: $searchText) {
    ...AddressWithContact
  }
}
    ${AddressWithContactFragmentDoc}`;
export const WhiteLabelCompanyDocument = gql`
    query whiteLabelCompany($uuid: String!) {
  whiteLabelCompany(uuid: $uuid) {
    uuid
    companyLandscapeLogoUrl
    companySquareLogoUrl
    name
  }
}
    `;
export const AutoApplyAccessorialConfigDocument = gql`
    query autoApplyAccessorialConfig($uuid: String!, $specialWindowsDate: DateTime) {
  autoApplyAccessorialConfig(uuid: $uuid) {
    ...AutoApplyAccessorialConfig
  }
}
    ${AutoApplyAccessorialConfigFragmentDoc}`;
export const AutoApplyAccessorialConfigsDocument = gql`
    query autoApplyAccessorialConfigs($specialWindowsDate: DateTime) {
  autoApplyAccessorialConfigs {
    ...AutoApplyAccessorialConfig
  }
}
    ${AutoApplyAccessorialConfigFragmentDoc}`;
export const CreateAutoApplyAccessorialConfigDocument = gql`
    mutation createAutoApplyAccessorialConfig($createAutoApplyAccessorialConfigInput: CreateAutoApplyAccessorialConfigInput!, $specialWindowsDate: DateTime) {
  createAutoApplyAccessorialConfig(
    createAutoApplyAccessorialConfigInput: $createAutoApplyAccessorialConfigInput
  ) {
    ...AutoApplyAccessorialConfig
  }
}
    ${AutoApplyAccessorialConfigFragmentDoc}`;
export const DeleteAutoApplyAccessorialConfigDocument = gql`
    mutation deleteAutoApplyAccessorialConfig($uuid: String!) {
  deleteAutoApplyAccessorialConfig(uuid: $uuid)
}
    `;
export const SelectSpecialAccessorialDocument = gql`
    query selectSpecialAccessorial($selectSpecialAccessorialInput: SelectSpecialAccessorialInput!) {
  selectSpecialAccessorial(
    selectSpecialAccessorialInput: $selectSpecialAccessorialInput
  ) {
    accessorialUuid
    accessorialName
    tariffZoneUuid
    chargeGroupUuid
    matrixItemUuid
  }
}
    `;
export const UpdateAutoApplyAccessorialConfigDocument = gql`
    mutation updateAutoApplyAccessorialConfig($updateAutoApplyAccessorialConfigInput: UpdateAutoApplyAccessorialConfigInput!, $specialWindowsDate: DateTime) {
  updateAutoApplyAccessorialConfig(
    updateAutoApplyAccessorialConfigInput: $updateAutoApplyAccessorialConfigInput
  ) {
    ...AutoApplyAccessorialConfig
  }
}
    ${AutoApplyAccessorialConfigFragmentDoc}`;
export const CoordinatesForAddressDocument = gql`
    query coordinatesForAddress($line1: String, $line2: String, $city: String, $state: String, $country: String, $zip: String) {
  coordinatesForAddress(
    line1: $line1
    line2: $line2
    city: $city
    state: $state
    country: $country
    zip: $zip
  ) {
    latitude
    longitude
    quality
  }
}
    `;
export const GetCityAndStateOptionsFromZipcodeDocument = gql`
    query getCityAndStateOptionsFromZipcode($getCityAndStateFromZipcodeInput: GetCityAndStateOptionsFromZipcodeInput!) {
  getCityAndStateOptionsFromZipcode(
    getCityAndStateOptionsFromZipcodeInput: $getCityAndStateFromZipcodeInput
  ) {
    zipcode
    citiesAndStates {
      ...GetCityAndStateOptionsFromZipcode
    }
  }
}
    ${GetCityAndStateOptionsFromZipcodeFragmentDoc}`;
export const GetZipcodeOptionsFromCityAndStateDocument = gql`
    query getZipcodeOptionsFromCityAndState($getZipcodeFromCityAndStateInput: GetZipcodeOptionsFromCityAndStateInput!) {
  getZipcodeOptionsFromCityAndState(
    getZipcodeOptionsFromCityAndStateInput: $getZipcodeFromCityAndStateInput
  ) {
    city
    state
    zipcodes {
      ...GetZipcodeOptionsFromCityAndState
    }
  }
}
    ${GetZipcodeOptionsFromCityAndStateFragmentDoc}`;
export const ManualStandardStopTypeForAddressDocument = gql`
    query ManualStandardStopTypeForAddress($input: ManualStandardStopTypeForAddressInput!) {
  manualStandardStopTypeForAddress(input: $input)
}
    `;
export const AirportInfoDocument = gql`
    query airportInfo($uuid: String!) {
  airportInfo(uuid: $uuid) {
    ...RecoveryTerminal
  }
}
    ${RecoveryTerminalFragmentDoc}`;
export const AppointmentStatusHistoryDocument = gql`
    query appointmentStatusHistory($stopUuid: String!, $first: Int, $after: String) {
  appointmentStatusHistory(stopUuid: $stopUuid, first: $first, after: $after) {
    edges {
      cursor
      node {
        createdAt
        fromStatus
        toStatus
        actor
        userUuid
        userDisplayName
        reason
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;
export const DispatchAppointmentSummaryDocument = gql`
    query dispatchAppointmentSummary($deliveryDateFilter: DateFilterStartEnd, $oncomingWindow: DateFilterStartEnd) {
  dispatchAppointmentSummary(
    deliveryDateFilter: $deliveryDateFilter
    oncomingWindow: $oncomingWindow
  ) {
    all
    unconfirmed
    oncoming
    noContact
    awaitingCustomerBooking
  }
}
    `;
export const DispatchAppointmentsDocument = gql`
    query dispatchAppointments($first: Int, $after: String, $includeCount: Boolean, $deliveryDateFilter: DateFilterStartEnd, $oncomingWindow: DateFilterStartEnd, $preset: DispatchAppointmentPreset, $statuses: [DispatchAppointmentStatus!], $stopTypes: [StopType!], $contactChannel: DispatchAppointmentContactChannel, $terminalUuids: [String!], $searchText: String, $sortBy: DispatchAppointmentSortField, $sortDirection: SortDirection) {
  dispatchAppointments(
    first: $first
    after: $after
    includeCount: $includeCount
    deliveryDateFilter: $deliveryDateFilter
    oncomingWindow: $oncomingWindow
    preset: $preset
    statuses: $statuses
    stopTypes: $stopTypes
    contactChannel: $contactChannel
    terminalUuids: $terminalUuids
    searchText: $searchText
    sortBy: $sortBy
    sortDirection: $sortDirection
  ) {
    edges {
      cursor
      node {
        ...DispatchAppointment
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${DispatchAppointmentFragmentDoc}`;
export const TransitionAppointmentDocument = gql`
    mutation transitionAppointment($transitionAppointmentInput: TransitionAppointmentInput!) {
  transitionAppointment(transitionAppointmentInput: $transitionAppointmentInput) {
    ... on TransitionAppointmentSuccessOutput {
      stopUuid
      status
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const AppointmentConfirmationInfoDocument = gql`
    query AppointmentConfirmationInfo($stopUuid: String!) {
  appointmentConfirmationInfo(uuid: $stopUuid) {
    appointmentDateTime
    appointmentConfirmed
    rescheduleRequested
    stopType
  }
}
    `;
export const GetAppointmentsDocument = gql`
    query getAppointments($deliveryDate: DateTime!) {
  appointments(deliveryDate: $deliveryDate) {
    ...Appointment
  }
}
    ${AppointmentFragmentDoc}`;
export const BulkConfirmAppointmentsDocument = gql`
    mutation bulkConfirmAppointments($bulkConfirmAppointmentsArgs: BulkConfirmAppointmentsArgs!) {
  bulkConfirmAppointments(
    bulkConfirmAppointmentsArgs: $bulkConfirmAppointmentsArgs
  )
}
    `;
export const BulkChangeCallStatusDocument = gql`
    mutation bulkChangeCallStatus($changeCallStatusArgs: BulkChangeCallStatusArgs!) {
  bulkChangeCallStatus(changeCallStatusArgs: $changeCallStatusArgs)
}
    `;
export const BulkUnconfirmAppointmentsDocument = gql`
    mutation bulkUnconfirmAppointments($bulkUnconfirmAppointmentsArgs: BulkUnconfirmAppointmentsArgs!) {
  bulkUnconfirmAppointments(
    bulkUnconfirmAppointmentsArgs: $bulkUnconfirmAppointmentsArgs
  )
}
    `;
export const CallStopsDocument = gql`
    mutation callStops($callStopsInput: CallStopsInput!) {
  callStops(callStopsInput: $callStopsInput) {
    uuid
  }
}
    `;
export const GetDefaultTextsDocument = gql`
    query getDefaultTexts($generateDefaultAppointmentTextsArgs: GenerateDefaultAppointmentTextsArgs!) {
  generateDefaultAppointmentTexts(
    generateDefaultAppointmentTextsArgs: $generateDefaultAppointmentTextsArgs
  ) {
    appointmentUuid
    message
  }
}
    `;
export const MakeAppointmentConfirmationDecisionDocument = gql`
    mutation MakeAppointmentConfirmationDecision($input: MakeAppointmentConfirmationDecisionInput!) {
  makeAppointmentConfirmationDecision(input: $input) {
    __typename
    ... on AppointmentConfirmationInfoOutput {
      appointmentDateTime
      appointmentConfirmed
      rescheduleRequested
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const QueueAppointmentTextsDocument = gql`
    mutation queueAppointmentTexts($queueAppointmentTextsArgs: QueueAppointmentTextsArgs!) {
  queueAppointmentTexts(queueAppointmentTextsArgs: $queueAppointmentTextsArgs) {
    sentCount
    skippedNoContactCount
    skippedMissingDetailsCount
    skippedLandlineCount
    suppressedCount
    failedCount
  }
}
    `;
export const RecordContactAttemptedDocument = gql`
    mutation recordContactAttempted($recordContactAttemptedArgs: RecordContactAttemptedArgs!) {
  recordContactAttempted(recordContactAttemptedArgs: $recordContactAttemptedArgs)
}
    `;
export const RemoveStopsFromRoutesDocument = gql`
    mutation removeStopsFromRoutes($removeStopsFromRoutesInput: RemoveStopsFromRoutesInputType!) {
  removeStopsFromRoutes(removeStopsFromRoutesInput: $removeStopsFromRoutesInput)
}
    `;
export const AuditReportDocument = gql`
    query auditReport($args: AuditReportArgs!) {
  auditReport(args: $args) {
    ...AuditReportBucket
  }
}
    ${AuditReportBucketFragmentDoc}`;
export const CompanyConfigurationDocument = gql`
    query companyConfiguration {
  companyConfiguration {
    ...CompanyConfiguration
  }
}
    ${CompanyConfigurationFragmentDoc}`;
export const CompletionToPaymentReportCsvDocument = gql`
    query CompletionToPaymentReportCsv($args: CompletionToPaymentFilterArgs!) {
  completionToPaymentReportCsv(args: $args) {
    url
    fileName
    errors
  }
}
    `;
export const CompletionToPaymentSummaryDocument = gql`
    query CompletionToPaymentSummary($args: CompletionToPaymentFilterArgs!) {
  completionToPaymentSummary(args: $args) {
    orders
    postedOrders
    settledOrders
    timezone
    completeToPosted {
      ...CompletionToPaymentDurationFields
    }
    completeToPaid {
      ...CompletionToPaymentDurationFields
    }
    intervals {
      key
      meanSeconds
      medianSeconds
      p90Seconds
      countedOrders
      backwardOrders
      prior {
        medianSeconds
        countedOrders
      }
    }
    waiting {
      stage
      orders
      medianAgeSeconds
      over30Days
      over60Days
    }
    flags {
      onHold
      ratingErrors
      ratingErrorsUnpaid
    }
    trend {
      unit
      points {
        bucketDate
        medianSeconds
        p90Seconds
        countedOrders
        completedOrders
      }
    }
    byCustomer {
      uuid
      name
      orders
      postedOrders
      settledOrders
      toPostedMedianSeconds
      toPostedCountedOrders
      postedToPaidMedianSeconds
      postedToPaidCountedOrders
      unpaidOver30Days
    }
    byTerminal {
      uuid
      name
      orders
      postedOrders
      settledOrders
      toPostedMedianSeconds
      toPostedCountedOrders
      postedToPaidMedianSeconds
      postedToPaidCountedOrders
      unpaidOver30Days
    }
    oldestUnpaid {
      orderUuid
      orderName
      customerName
      invoiceName
      postedAt
      ageSeconds
    }
    slowestToBill {
      orderUuid
      orderName
      customerName
      terminalCode
      secondsToPosted
      longestInterval {
        key
        seconds
      }
    }
    outliers {
      measure
      orders {
        orderUuid
        orderName
        customerName
        fromAt
        toAt
        seconds
      }
    }
  }
}
    ${CompletionToPaymentDurationFieldsFragmentDoc}`;
export const CompletionToPaymentReportDocument = gql`
    query CompletionToPaymentReport($args: CompletionToPaymentPageArgs!) {
  completionToPaymentReport(args: $args) {
    totalCount
    timezone
    rows {
      orderUuid
      orderName
      customerName
      accountId
      hawb
      onHold
      hasRatingErrors
      completedAt
      chargesFinalizedAt
      onInvoiceAt
      invoicePostedAt
      invoicePaidAt
      completeToFinalizedSeconds
      finalizedToOnInvoiceSeconds
      onInvoiceToPostedSeconds
      postedToPaidSeconds
    }
  }
}
    `;
export const ContactPersonsDocument = gql`
    query contactPersons {
  contactPersons {
    ...ContactPerson
  }
}
    ${ContactPersonFragmentDoc}`;
export const ArchiveContactStationDocument = gql`
    mutation archiveContactStation($id: String!) {
  archiveContactStation(id: $id) {
    __typename
    ... on ContactStationUpdateSuccessOutput {
      contactStation {
        id
        isArchived
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ArchivePersonDocument = gql`
    mutation ArchivePerson($id: String!) {
  archivePerson(id: $id) {
    person {
      id
      status
    }
  }
}
    `;
export const ContactChargeMatrixColumnMappingsDocument = gql`
    query contactChargeMatrixColumnMappings($contactUuid: String!) {
  contactChargeMatrixColumnMappings(contactUuid: $contactUuid) {
    uuid
    column
    accessorial {
      uuid
      name
    }
  }
}
    `;
export const CreateContactCommentDocument = gql`
    mutation createContactComment($createContactCommentInput: CreateContactCommentInput!) {
  createContactComment(createContactCommentInput: $createContactCommentInput) {
    uuid
  }
}
    `;
export const DeleteContactCommentDocument = gql`
    mutation deleteContactComment($deleteContactCommentInput: DeleteContactCommentInput!) {
  deleteContactComment(deleteContactCommentInput: $deleteContactCommentInput) {
    ... on DeleteContactCommentSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdateContactCommentDocument = gql`
    mutation updateContactComment($updateContactCommentInput: UpdateContactCommentInput!) {
  updateContactComment(updateContactCommentInput: $updateContactCommentInput) {
    ... on UpdateContactCommentSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ContactCommunicationConfigsDocument = gql`
    query contactCommunicationConfigs($contactUuid: String!) {
  contactCommunicationConfigs(contactUuid: $contactUuid) {
    ...ContactCommunicationConfig
  }
}
    ${ContactCommunicationConfigFragmentDoc}`;
export const ContactDefaultSurchargeDocument = gql`
    query contactDefaultSurcharge($uuid: String!) {
  contact(uuid: $uuid) {
    uuid
    ... on CustomerContactEntity {
      defaultFuelSurcharge
    }
  }
}
    `;
export const ContactEmailSuppressionsDocument = gql`
    query contactEmailSuppressions($contactUuid: String!) {
  contact(uuid: $contactUuid) {
    uuid
    emailSuppressions {
      email
      type
    }
  }
}
    `;
export const ContactEmailsDocument = gql`
    query contactEmails($contactUuid: String!) {
  contactEmails(contactUuid: $contactUuid) {
    uuid
    email
    type
  }
}
    `;
export const ContactIsOverCreditLimitByOrderUuidDocument = gql`
    query contactIsOverCreditLimitByOrderUuid($uuid: String!) {
  order(uuid: $uuid) {
    standardOrderFields {
      shipperBillOfLadingNumber
    }
    contact {
      isOverCreditLimit
    }
  }
}
    `;
export const ContactIsOverCreditLimitDocument = gql`
    query contactIsOverCreditLimit($uuid: String!) {
  contact(uuid: $uuid) {
    isOverCreditLimit
  }
}
    `;
export const ContactLogosDocument = gql`
    query contactLogos($contactUuid: String!) {
  contact(uuid: $contactUuid) {
    uuid
    logo {
      preSignedGetUrl
    }
    logoType {
      preSignedGetUrl
    }
  }
}
    `;
export const ContactQueryForBluebirdDocument = gql`
    query contactQueryForBluebird($uuid: String!) {
  contact(uuid: $uuid) {
    uuid
  }
}
    `;
export const ContactServicesDocument = gql`
    query contactServices($uuid: String!) {
  contact(uuid: $uuid) {
    uuid
    services {
      uuid
      name
    }
    defaultService {
      uuid
      name
    }
  }
}
    `;
export const ContactStationsDocument = gql`
    query contactStations($contactUuid: String!) {
  contactStations(contactUuid: $contactUuid) {
    id
    name
    isArchived
    defaultPerson {
      id
      firstName
      lastName
      phone
      email
    }
  }
}
    `;
export const ContactTariffChainsDocument = gql`
    query contactTariffChains($uuid: String!) {
  contact(uuid: $uuid) {
    uuid
    effectiveTariffChains {
      tariffGroupType
      source
      tariffChain {
        ...ContactTariffChain
      }
    }
  }
}
    ${ContactTariffChainFragmentDoc}`;
export const ContactTariffGroupsDocument = gql`
    query contactTariffGroups($first: Int, $after: String, $last: Int, $before: String, $contactUuid: String, $searchText: String, $serviceUuid: String, $tariffGroupType: TariffGroupType, $isActive: Boolean, $excludeDefault: Boolean) {
  tariffGroupsPaginated(
    first: $first
    after: $after
    before: $before
    last: $last
    contactUuid: $contactUuid
    searchText: $searchText
    serviceUuid: $serviceUuid
    tariffGroupType: $tariffGroupType
    isActive: $isActive
    excludeDefault: $excludeDefault
  ) {
    edges {
      node {
        ...TariffGroupForContactsTable
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
    totalCount
  }
}
    ${TariffGroupForContactsTableFragmentDoc}`;
export const ContactDocument = gql`
    query contact($uuid: String!) {
  contact(uuid: $uuid) {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;
export const ContactsForInvoicingDocument = gql`
    query contactsForInvoicing($invoiceUuids: [String!]!) {
  contacts(invoiceUuids: $invoiceUuids) {
    ...ContactForInvoice
  }
}
    ${ContactForInvoiceFragmentDoc}`;
export const ContactsForQuickbooksDocument = gql`
    query contactsForQuickbooks {
  contacts {
    ...ContactForQuickbooks
  }
}
    ${ContactForQuickbooksFragmentDoc}`;
export const ContactsPageListingDocument = gql`
    query contactsPageListing {
  contacts {
    uuid
    contactReferenceNumber
    displayName
    isActive
    type
  }
}
    `;
export const ContactsReportDocument = gql`
    query contactsReport {
  contactsReport {
    name
    email
    shortcode
    active
    addressName
    addressLine1
    addressLine2
    city
    state
    zipcode
    businessDivision
    type
    referenceNumber
    numberOfOrdersPerInvoice
    invoiceTimePeriodSplit
    enableCreditHold
    creditLimit
    billingCycle
    defaultInvoiceTransmissionMethod
    defaultInvoiceType
  }
}
    `;
export const ContactsSimpleDocument = gql`
    query contactsSimple($excludeNonActive: Boolean) {
  contacts(excludeNonActive: $excludeNonActive) {
    uuid
    displayName
    contactReferenceNumber
    isOverCreditLimit
    calculateInboundFreightCharges
    calculateOutboundFreightCharges
    calculateLineHaulFreightCharges
    masterAccount {
      uuid
    }
  }
}
    `;
export const ContactsDocument = gql`
    query contacts {
  contacts {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;
export const CreateAddressDocument = gql`
    mutation createAddress($input: CreateAddressInput!) {
  createAddress(createAddressInput: $input) {
    uuid
  }
}
    `;
export const CreateContactEmailDocument = gql`
    mutation createContactEmail($createContactEmailInput: CreateContactEmailInput!) {
  createContactEmail(createContactEmailInput: $createContactEmailInput) {
    uuid
  }
}
    `;
export const CreateContactStationDocument = gql`
    mutation createContactStation($input: ContactStationCreateInput!) {
  createContactStation(contactStationCreateInput: $input) {
    __typename
    ... on ContactStationCreateSuccessOutput {
      contactStation {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CreateCustomerContactDocument = gql`
    mutation createCustomerContact($input: CreateCustomerContactInput!) {
  createCustomerContact(createCustomerContactInput: $input) {
    uuid
  }
}
    `;
export const CreatePersonDocument = gql`
    mutation CreatePerson($input: CreatePersonInput!) {
  createPerson(input: $input) {
    person {
      id
    }
  }
}
    `;
export const FindServicesForCustomerConfigurationDocument = gql`
    query findServicesForCustomerConfiguration($findServicesForCustomerConfigurationInput: FindServicesForCustomerConfigurationInput!) {
  findServicesForCustomerConfiguration(
    findServicesForCustomerConfigurationInput: $findServicesForCustomerConfigurationInput
  ) {
    __typename
    ... on FindServicesForCustomerConfigurationSuccessOutput {
      services {
        uuid
        name
        isActive
      }
    }
    ... on QueryErrorOutput {
      message
    }
  }
}
    `;
export const DeleteContactEmailDocument = gql`
    mutation deleteContactEmail($deleteContactEmailInput: DeleteContactEmailInput!) {
  deleteContactEmail(deleteContactEmailInput: $deleteContactEmailInput) {
    uuid
  }
}
    `;
export const InvoiceTermsDocument = gql`
    query invoiceTerms {
  invoiceTerms {
    ...InvoiceTerm
  }
}
    ${InvoiceTermFragmentDoc}`;
export const OrderEventNotificationSubscriptionsDocument = gql`
    query OrderEventNotificationSubscriptions($contactUuid: String!) {
  orderEventNotificationSubscriptions(contactUuid: $contactUuid) {
    id
    eventType
    channel
    subscriberType
  }
}
    `;
export const OrganizationEffectivePackageTypeConfigsDocument = gql`
    query OrganizationEffectivePackageTypeConfigs($organizationUuid: String!) {
  organizationEffectivePackageTypeConfigs(organizationUuid: $organizationUuid) {
    effectivePackageTypeConfigs {
      __typename
      packageType
      isSingleHandlingUnit
    }
  }
}
    `;
export const PaginatedContactsDocument = gql`
    query paginatedContacts($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $sortByContactName: Boolean) {
  paginatedContacts(
    first: $first
    after: $after
    before: $before
    last: $last
    searchText: $searchText
    sortByContactName: $sortByContactName
  ) {
    edges {
      node {
        uuid
        displayName
      }
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const PersonsDocument = gql`
    query Persons($contactUuid: String) {
  persons(contactUuid: $contactUuid) {
    persons {
      id
      status
      firstName
      lastName
      phone
      email
      defaultPickupAddress {
        uuid
        name
        line1
        line2
        city
        state
        zip
        country
        specialInstructions
      }
      defaultDeliveryAddress {
        uuid
        name
        line1
        line2
        city
        state
        zip
        country
        specialInstructions
      }
      defaultService {
        uuid
        name
      }
      defaultVehicleType {
        uuid
        name
      }
      defaultForContactStations {
        id
        name
        isArchived
      }
    }
  }
}
    `;
export const QueryQuickbooksDesktopAccountsDocument = gql`
    query queryQuickbooksDesktopAccounts {
  queryQuickbooksDesktopAccounts {
    quickbooksDesktopObjects {
      id
      name
    }
    error
  }
}
    `;
export const QueryQuickbooksDesktopCustomersDocument = gql`
    query queryQuickbooksDesktopCustomers {
  queryQuickbooksDesktopCustomers {
    quickbooksDesktopObjects {
      id
      name
    }
    error
  }
}
    `;
export const RemoveAddressDocument = gql`
    mutation removeAddress($uuid: String!) {
  removeAddress(uuid: $uuid) {
    uuid
  }
}
    `;
export const RestoreContactStationDocument = gql`
    mutation restoreContactStation($id: String!) {
  restoreContactStation(id: $id) {
    __typename
    ... on ContactStationUpdateSuccessOutput {
      contactStation {
        id
        isArchived
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RestorePersonDocument = gql`
    mutation RestorePerson($id: String!) {
  restorePerson(id: $id) {
    person {
      id
      status
    }
  }
}
    `;
export const SetContactChargeMatrixColumnMappingsDocument = gql`
    mutation setContactChargeMatrixColumnMappings($setContactChargeMatrixColumnMappingsInput: SetContactChargeMatrixColumnMappingsInput!) {
  setContactChargeMatrixColumnMappings(
    setContactChargeMatrixColumnMappingsInput: $setContactChargeMatrixColumnMappingsInput
  ) {
    uuid
    column
    accessorial {
      uuid
      name
    }
  }
}
    `;
export const ShallowContactDocument = gql`
    query shallowContact($uuid: String!) {
  contact(uuid: $uuid) {
    ...ShallowContact
  }
}
    ${ShallowContactFragmentDoc}`;
export const ShallowContactsByUuidsDocument = gql`
    query shallowContactsByUuids($uuids: [String!]!) {
  contactsByUuids(uuids: $uuids) {
    ...ShallowContact
  }
}
    ${ShallowContactFragmentDoc}`;
export const ShallowContactsDocument = gql`
    query shallowContacts {
  contacts {
    ...ShallowContact
  }
}
    ${ShallowContactFragmentDoc}`;
export const ThirdPartyUserByUuidDocument = gql`
    query thirdPartyUserByUuid($uuid: String!) {
  thirdPartyUserByUuid(uuid: $uuid) {
    uuid
    email
    contacts {
      displayName
    }
  }
}
    `;
export const ThirdPartyUsersByContactDocument = gql`
    query thirdPartyUsersByContact($contactUuid: String!) {
  thirdPartyUsersByContact(contactUuid: $contactUuid) {
    uuid
    email
  }
}
    `;
export const UpdateAddressDocument = gql`
    mutation updateAddress($input: UpdateAddressInput!) {
  updateAddress(updateAddressInput: $input) {
    uuid
  }
}
    `;
export const UpdateContactCommunicationConfigDocument = gql`
    mutation updateContactCommunicationConfig($updateContactCommunicationConfigInput: UpdateContactCommunicationConfigInput!) {
  updateContactCommunicationConfig(
    updateContactCommunicationConfigInput: $updateContactCommunicationConfigInput
  ) {
    uuid
  }
}
    `;
export const UpdateContactEmailsDocument = gql`
    mutation UpdateContactEmails($input: UpdateContactEmailsInput!) {
  updateContactEmails(input: $input) {
    __typename
    ... on UpdateContactEmailsSuccessOutput {
      contactUuid
      contactCommunicationConfigs {
        uuid
        type
        active
      }
      contactEmails {
        uuid
        email
        type
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdateContactStationDocument = gql`
    mutation updateContactStation($input: ContactStationUpdateInput!) {
  updateContactStation(contactStationUpdateInput: $input) {
    __typename
    ... on ContactStationUpdateSuccessOutput {
      contactStation {
        id
        name
        defaultPerson {
          firstName
          lastName
          phone
          email
        }
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdateCustomerContactDocument = gql`
    mutation updateCustomerContact($input: UpdateCustomerContactInput!) {
  updateCustomerContact(updateCustomerContactInput: $input) {
    uuid
    quickbooksMappingId
    freightChargeQuickbooksMappingId
    fuelChargeQuickbooksMappingId
    miscCustomChargeQuickbooksMappingId
    quickbooksFileMappingCustomerName
    quickbooksFileMappingFreightChargeName
    quickbooksFileMappingFuelChargeName
    quickbooksFileMappingPickupChargeName
  }
}
    `;
export const UpdateOrderEventNotificationSubscriptionsDocument = gql`
    mutation UpdateOrderEventNotificationSubscriptions($input: UpdateOrderEventNotificationSubscriptionsInput!) {
  updateOrderEventNotificationSubscriptions(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on UpdateOrderEventNotificationSubscriptionsSuccessOutput {
      contactUuid
      subscriptions {
        id
        eventType
        channel
        subscriberType
      }
    }
  }
}
    `;
export const UpdatePersonDocument = gql`
    mutation UpdatePerson($input: UpdatePersonInput!) {
  updatePerson(input: $input) {
    person {
      id
      status
      firstName
      lastName
      phone
      email
      defaultPickupAddress {
        uuid
        name
        line1
        line2
        city
        state
        zip
        country
        specialInstructions
      }
      defaultDeliveryAddress {
        uuid
        name
        line1
        line2
        city
        state
        zip
        country
        specialInstructions
      }
      defaultService {
        uuid
        name
      }
      defaultVehicleType {
        uuid
        name
      }
    }
  }
}
    `;
export const UpsertAddressDocument = gql`
    mutation upsertAddress($upsertAddressInput: UpsertAddressInput!) {
  upsertAddress(upsertAddressInput: $upsertAddressInput) {
    uuid
  }
}
    `;
export const UpsertOrganizationPackageTypeConfigDocument = gql`
    mutation UpsertOrganizationPackageTypeConfig($input: UpsertOrganizationPackageTypeConfigInput!) {
  upsertOrganizationPackageTypeConfig(input: $input) {
    organizationPackageTypeConfig {
      ...OrganizationPackageTypeConfig
    }
  }
}
    ${OrganizationPackageTypeConfigFragmentDoc}`;
export const UpsertUserContactNotificationSubscriptionDocument = gql`
    mutation upsertUserContactNotificationSubscription($input: UserContactNotificationSubscriptionUpsertInput!) {
  upsertUserContactNotificationSubscription(
    userContactNotificationSubscriptionUpsertInput: $input
  ) {
    ...UserContactNotificationSubscription
  }
}
    ${UserContactNotificationSubscriptionFragmentDoc}`;
export const UserContactNotificationSubscriptionDocument = gql`
    query userContactNotificationSubscription($contactUuid: String!) {
  userContactNotificationSubscription(contactUuid: $contactUuid) {
    ...UserContactNotificationSubscription
  }
}
    ${UserContactNotificationSubscriptionFragmentDoc}`;
export const BookCustomerAppointmentDocument = gql`
    mutation BookCustomerAppointment($input: BookCustomerAppointmentInput!) {
  bookCustomerAppointment(input: $input) {
    __typename
    ... on BookCustomerAppointmentSuccessOutput {
      message
      canReschedule
      bookedAppointment {
        serviceDateIso8601
        startsAt
        endsAt
        timeZone
      }
    }
    ... on BookCustomerAppointmentRefusedOutput {
      reason
      message
      alternativeSlots {
        serviceDateIso8601
        startsAt
        endsAt
        timeZone
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CustomerAppointmentInvitationDocument = gql`
    query CustomerAppointmentInvitation($input: CustomerAppointmentTokenInput!) {
  customerAppointmentInvitation(input: $input) {
    status
    message
    canRequestNewLink
    companyName
    companyPhone
    stopType
    serviceAddress
    notes
    selfReschedulesRemaining
    bookedAppointment {
      serviceDateIso8601
      startsAt
      endsAt
      timeZone
    }
    slots {
      serviceDateIso8601
      startsAt
      endsAt
      timeZone
    }
  }
}
    `;
export const DeclineCustomerAppointmentOptionsDocument = gql`
    mutation DeclineCustomerAppointmentOptions($input: CustomerAppointmentTokenInput!) {
  declineCustomerAppointmentOptions(input: $input) {
    __typename
    ... on CustomerAppointmentAcknowledgementOutput {
      message
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RequestCustomerAppointmentLinkDocument = gql`
    mutation RequestCustomerAppointmentLink($input: CustomerAppointmentTokenInput!) {
  requestCustomerAppointmentLink(input: $input) {
    __typename
    ... on CustomerAppointmentAcknowledgementOutput {
      message
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CustomerPortalQuoteContactDocument = gql`
    query customerPortalQuoteContact($uuid: String!) {
  contact(uuid: $uuid) {
    ... on CustomerContactEntity {
      uuid
      defaultDimFactor
      defaultFreightClass
      displayChargesInCustomerPortal
      resolvedFreightBillingMethod
    }
  }
}
    `;
export const RateCustomerPortalSmc3QuoteDocument = gql`
    query rateCustomerPortalSmc3Quote($rateOrderInput: RateOrderInput!) {
  rateOrderContents(rateOrderInput: $rateOrderInput) {
    __typename
    ... on RateOrderSuccessOutput {
      success
      orderCharges {
        externalRating {
          ...RateOrderExternalRating
        }
      }
    }
    ... on RateOrderErrorOutput {
      success
      errorMessage
    }
  }
}
    ${RateOrderExternalRatingFragmentDoc}`;
export const AddThirdPartyUserToContactDocument = gql`
    mutation addThirdPartyUserToContact($addThirdPartyUserToContactInput: AddThirdPartyUserToContactInput!) {
  addThirdPartyUserToContact(
    addThirdPartyUserToContactInput: $addThirdPartyUserToContactInput
  ) {
    uuid
  }
}
    `;
export const ConsigneePortalOrderDocument = gql`
    query consigneePortalOrder($uuid: String!) {
  consigneePortalOrder(uuid: $uuid) {
    ...ConsigneePortalOrder
  }
}
    ${ConsigneePortalOrderFragmentDoc}`;
export const CustomerPortalMeDocument = gql`
    query customerPortalMe {
  me {
    company {
      uuid
      name
    }
  }
}
    `;
export const CustomerPortalOrderDocument = gql`
    query customerPortalOrder($uuid: String!) {
  order(uuid: $uuid) {
    ...CustomerPortalOrder
  }
}
    ${CustomerPortalOrderFragmentDoc}`;
export const CustomerPortalPiecesDocument = gql`
    query customerPortalPieces($customerPortalPiecesInput: CustomerPortalPiecesInput!) {
  customerPortalPieces(customerPortalPiecesInput: $customerPortalPiecesInput) {
    edges {
      node {
        ...FindPieces
      }
      cursor
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${FindPiecesFragmentDoc}`;
export const CustomerPortalQuotesDocument = gql`
    query customerPortalQuotes($findCustomerPortalQuotesInput: FindCustomerPortalQuotesInput!) {
  customerPortalQuotes(
    findCustomerPortalQuotesInput: $findCustomerPortalQuotesInput
  ) {
    edges {
      node {
        ...CustomerPortalQuote
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    ${CustomerPortalQuoteFragmentDoc}`;
export const CustomerPortalOrdersDocument = gql`
    query customerPortalOrders($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $stopTypesFilter: StopTypesFilter, $appointmentDateFilters: DateFilterStartEnd, $createdAtDateFilters: DateFilterStartEnd, $receivedDateFilters: DateFilterStartEnd, $plannedDateFilters: DateFilterStartEnd, $dispatched: BooleanFilter, $ofdOfp: BooleanFilter, $onHand: BooleanFilter, $completionDateFilters: DateFilterStartEnd, $companyFilter: String, $contactFilter: String, $orderStatusBuckets: [CustomerPortalOrderStatusBucketInput!]) {
  customerPortalOrders(
    first: $first
    after: $after
    last: $last
    before: $before
    searchText: $searchText
    stopTypesFilter: $stopTypesFilter
    appointmentDateFilters: $appointmentDateFilters
    createdAtDateFilters: $createdAtDateFilters
    receivedDateFilters: $receivedDateFilters
    plannedDateFilters: $plannedDateFilters
    dispatched: $dispatched
    ofdOfp: $ofdOfp
    onHand: $onHand
    completionDateFilters: $completionDateFilters
    companyFilter: $companyFilter
    contactFilter: $contactFilter
    orderStatusBuckets: $orderStatusBuckets
  ) {
    totalCount
    edges {
      node {
        ...CustomerPortalOrderForTable
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${CustomerPortalOrderForTableFragmentDoc}`;
export const EtaForCustomerPortalDocument = gql`
    query etaForCustomerPortal($uuid: String!) {
  etaForCustomerPortal(uuid: $uuid) {
    arrivalTime
    finishTime
  }
}
    `;
export const PublicUpsertShipmentSubscriberDocument = gql`
    mutation publicUpsertShipmentSubscriber($upsertShipmentSubscriberInput: UpsertShipmentSubscriberInput!, $companyUuid: String!) {
  upsertShipmentSubscriberForCompany(
    upsertShipmentSubscriberInput: $upsertShipmentSubscriberInput
    companyUuid: $companyUuid
  ) {
    phoneNumber
    uuid
  }
}
    `;
export const RemoveThirdPartyUserFromContactDocument = gql`
    mutation removeThirdPartyUserFromContact($removeThirdPartyUserFromContactInput: RemoveThirdPartyUserFromContactInput!) {
  removeThirdPartyUserFromContact(
    removeThirdPartyUserFromContactInput: $removeThirdPartyUserFromContactInput
  ) {
    uuid
  }
}
    `;
export const SignUpForThirdPartyUserAccountDocument = gql`
    mutation signUpForThirdPartyUserAccount($signUpForThirdPartyUserAccountInput: SignUpForThirdPartyUserAccountInput!) {
  signUpForThirdPartyUserAccount(
    signUpForThirdPartyUserAccountInput: $signUpForThirdPartyUserAccountInput
  ) {
    status
  }
}
    `;
export const CalculateRouteEtasDocument = gql`
    mutation calculateRouteEtas($uuids: [String!]!) {
  calculateRouteEtas(uuids: $uuids) {
    arrivalTime
    finishTime
  }
}
    `;
export const SameDayDispatchRoutesWithDriverCoordsDocument = gql`
    query sameDayDispatchRoutesWithDriverCoords($date: DateTime!, $searchText: String) {
  routes(date: $date, searchText: $searchText) {
    ...SameDayDispatchRouteDriverCoords
  }
}
    ${SameDayDispatchRouteDriverCoordsFragmentDoc}`;
export const DispatchDriversDocument = gql`
    query dispatchDrivers($startDate: DateTime!, $endDate: DateTime!) {
  drivers {
    uuid
    status
    firstName
    lastName
    driverReferenceNumber
    lastCompletedLeg(startDate: $startDate, endDate: $endDate) {
      uuid
      completedAt
      endStop {
        uuid
        address {
          line1
          line2
          city
        }
      }
    }
    currentLeg {
      uuid
      name
      completedAt
      endStop {
        uuid
        address {
          line1
          line2
          city
        }
      }
    }
    defaultVehicle {
      uuid
      name
    }
  }
}
    `;
export const EquipmentsByTypeDocument = gql`
    query equipmentsByType($equipmentType: [EquipmentType!]) {
  equipments(types: $equipmentType) {
    uuid
    type
    name
  }
}
    `;
export const LegDocument = gql`
    query leg($uuid: String!) {
  leg(uuid: $uuid) {
    uuid
    completedAt
    previousStopAttempts {
      uuid
      notes
      completedAt
      canMarkAttemptComplete
      routeSlot {
        route {
          name
          drivers {
            uuid
            firstName
            lastName
          }
        }
      }
      stopDriverMaps {
        driver {
          uuid
          firstName
          lastName
        }
      }
    }
    shipment {
      uuid
    }
  }
}
    `;
export const LegsDocument = gql`
    query legs($statuses: [LegStatus!], $maxOneUnassignedPerShipment: Boolean!) {
  legs(
    statuses: $statuses
    maxOneUnassignedPerShipment: $maxOneUnassignedPerShipment
  ) {
    uuid
    name
    shipment {
      uuid
    }
    status
    drivers {
      uuid
      firstName
      lastName
      status
    }
    completedAt
    endStop {
      uuid
      address {
        uuid
        line1
        line2
        city
        latitude
        longitude
      }
      appointmentTime
    }
  }
}
    `;
export const RefreshEtasForRouteDocument = gql`
    mutation refreshEtasForRoute($uuid: String!) {
  refreshEtasForRoute(uuid: $uuid) {
    arrivalTime
    finishTime
  }
}
    `;
export const UnassignLegFromDriverDocument = gql`
    mutation unassignLegFromDriver($unassignLegFromDriver: UnassignLegFromDriverInput!) {
  unassignLegFromDriver(unassignLegFromDriver: $unassignLegFromDriver) {
    uuid
  }
}
    `;
export const SameDayDispatchConfigDocument = gql`
    query sameDayDispatchConfig {
  sameDayDispatchConfig {
    ...SameDayDispatchConfig
  }
}
    ${SameDayDispatchConfigFragmentDoc}`;
export const UpdateSameDayDispatchConfigDocument = gql`
    mutation updateSameDayDispatchConfig($updateSameDayDispatchConfigInput: UpdateSameDayDispatchConfigInput!) {
  updateSameDayDispatchConfig(
    updateSameDayDispatchConfigInput: $updateSameDayDispatchConfigInput
  ) {
    uuid
  }
}
    `;
export const UpdateShipmentDocument = gql`
    mutation updateShipment($updateShipmentInput: UpdateShipmentInput!) {
  updateShipment(updateShipmentInput: $updateShipmentInput) {
    uuid
  }
}
    `;
export const AcceptOrderDelegationDocument = gql`
    mutation acceptOrderDelegation($input: AcceptOrderDelegationInput!) {
  acceptOrderDelegation(input: $input) {
    __typename
    uuid
    status
    duplicateOrderUuid
    acceptedAt
  }
}
    `;
export const DeclineOrderDelegationDocument = gql`
    mutation declineOrderDelegation($input: DeclineOrderDelegationInput!) {
  declineOrderDelegation(input: $input) {
    __typename
    uuid
    status
    declinedAt
  }
}
    `;
export const DelegatedOrdersInboxDocument = gql`
    query delegatedOrdersInbox($first: Int, $after: String, $filter: DelegatedOrdersInboxFilterInput) {
  delegatedOrdersInbox(first: $first, after: $after, filter: $filter) {
    edges {
      cursor
      node {
        __typename
        uuid
        createdAt
        acceptedAt
        declinedAt
        expiredAt
        expiresAt
        revokedAt
        duplicateOrderUuid
        originatorCompanyName
        originatorCompanyUuid
        scope
        status
        pickupHandling
        offerSummary {
          __typename
          version
          scope
          refNumbers
          pickupLocation {
            __typename
            city
            state
            zip
          }
          deliveryLocation {
            __typename
            city
            state
            zip
          }
          earliestServiceDate
          packageCount
          totalWeight
          weightUnits
          hazmat
          inBond
          offerNote
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;
export const DelegatedOrdersOutboxDocument = gql`
    query delegatedOrdersOutbox($first: Int, $after: String, $filter: DelegatedOrdersOutboxFilterInput) {
  delegatedOrdersOutbox(first: $first, after: $after, filter: $filter) {
    edges {
      cursor
      node {
        __typename
        uuid
        originalOrderUuid
        originalOrderName
        duplicateOrderUuid
        organizationPeerUuid
        originatorCompanyUuid
        originatorCompanyName
        executingCompanyUuid
        executingCompanyName
        scope
        status
        createdAt
        updatedAt
        acceptedAt
        declinedAt
        revokedAt
        expiredAt
        completedAt
        expiresAt
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;
export const InitiateDelegatedOrderReviewDocument = gql`
    mutation initiateDelegatedOrderReview($input: InitiateDelegatedOrderReviewInput!) {
  initiateDelegatedOrderReview(input: $input) {
    __typename
    draftOrderUuid
  }
}
    `;
export const OrderEndCustomerSharingDocument = gql`
    query orderEndCustomerSharing($uuid: String!) {
  standardOrder(uuid: $uuid) {
    __typename
    uuid
    delegations {
      __typename
      uuid
      sharesEndCustomer
    }
    delegationAsDuplicate {
      __typename
      uuid
      sharesEndCustomer
      endCustomer {
        name
        address {
          name
          line1
          line2
          city
          state
          zip
          country
        }
        contactName
        emails
        phone
        billingEmails
        addressBook {
          name
          line1
          line2
          city
          state
          zip
          country
        }
        addressBookTotalCount
        people {
          name
          emails
          phone
        }
        peopleTotalCount
        executorOrganization {
          uuid
          displayName
        }
      }
    }
  }
}
    `;
export const PendingOrderDelegationsCountDocument = gql`
    query pendingOrderDelegationsCount {
  pendingOrderDelegationsCount
}
    `;
export const RejectDelegationEndCustomerLinkDocument = gql`
    mutation rejectDelegationEndCustomerLink($input: RejectDelegationEndCustomerLinkInput!) {
  rejectDelegationEndCustomerLink(input: $input) {
    __typename
    uuid
  }
}
    `;
export const CreateOrderDelegationRuleDocument = gql`
    mutation CreateOrderDelegationRule($input: CreateOrderDelegationRuleInput!) {
  createOrderDelegationRule(input: $input) {
    ...OrderDelegationRuleFields
  }
}
    ${OrderDelegationRuleFieldsFragmentDoc}`;
export const DeleteOrderDelegationRuleDocument = gql`
    mutation DeleteOrderDelegationRule($input: DeleteOrderDelegationRuleInput!) {
  deleteOrderDelegationRule(input: $input)
}
    `;
export const OrderDelegationRulesDocument = gql`
    query OrderDelegationRules {
  orderDelegationRules {
    ...OrderDelegationRuleFields
  }
}
    ${OrderDelegationRuleFieldsFragmentDoc}`;
export const UpdateOrderDelegationRuleDocument = gql`
    mutation UpdateOrderDelegationRule($input: UpdateOrderDelegationRuleInput!) {
  updateOrderDelegationRule(input: $input) {
    ...OrderDelegationRuleFields
  }
}
    ${OrderDelegationRuleFieldsFragmentDoc}`;
export const AcceptOrganizationPeerDocument = gql`
    mutation acceptOrganizationPeer($input: AcceptOrganizationPeerInput!) {
  acceptOrganizationPeer(input: $input) {
    __typename
    uuid
    status
    peerCompanyUuid
    peerCompanyName
    organizationUuid
    acceptedAt
    createdAt
  }
}
    `;
export const ArchiveOrganizationDocument = gql`
    mutation archiveOrganization($input: ArchiveOrganizationInput!) {
  archiveOrganization(input: $input) {
    ... on ArchiveOrganizationSuccessOutput {
      organization {
        ...Organization
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${OrganizationFragmentDoc}`;
export const AvailablePeerCompaniesDocument = gql`
    query availablePeerCompanies {
  availablePeerCompanies {
    __typename
    uuid
    name
  }
}
    `;
export const CreateOrganizationPeerDocument = gql`
    mutation createOrganizationPeer($input: CreateOrganizationPeerInput!) {
  createOrganizationPeer(input: $input) {
    __typename
    uuid
    status
    peerCompanyUuid
    peerCompanyName
    organizationUuid
    createdAt
  }
}
    `;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    ... on CreateOrganizationSuccessOutput {
      organization {
        ...Organization
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${OrganizationFragmentDoc}`;
export const IncomingOrganizationPeersDocument = gql`
    query incomingOrganizationPeers($input: FindPaginatedOrganizationPeersInput!) {
  incomingOrganizationPeers(input: $input) {
    edges {
      node {
        __typename
        uuid
        status
        companyUuid
        companyName
        peerCompanyUuid
        peerCompanyName
        organizationUuid
        acceptedAt
        revokedAt
        createdAt
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;
export const OrganizationForAddressBookDocument = gql`
    query organizationForAddressBook($input: FindOrganizationInput!) {
  organization(input: $input) {
    addresses {
      ...OrganizationAddress
    }
    agentFields {
      activeTerminals {
        ...OrganizationAgentTerminal
      }
    }
  }
}
    ${OrganizationAddressFragmentDoc}
${OrganizationAgentTerminalFragmentDoc}`;
export const OrganizationForFrontendHookDocument = gql`
    query organizationForFrontendHook($input: FindOrganizationInput!) {
  organization(input: $input) {
    uuid
    isActive
    addresses {
      ...AddressForOrganization
    }
    contactPersons {
      ...ContactPersonForOrganization
    }
    types
    customerFields {
      emitPieceLevelWebhooks
    }
  }
}
    ${AddressForOrganizationFragmentDoc}
${ContactPersonForOrganizationFragmentDoc}`;
export const OrganizationNotesDocument = gql`
    query organizationNotes($findOrganizationNotesInput: FindOrganizationNotesInput!) {
  organizationNotes(findOrganizationNotesInput: $findOrganizationNotesInput) {
    uuid
    createdAt
    updatedAt
    comment
    authorName
  }
}
    `;
export const OrganizationPeersDocument = gql`
    query organizationPeers($input: FindPaginatedOrganizationPeersInput!) {
  organizationPeers(input: $input) {
    edges {
      node {
        __typename
        uuid
        status
        companyUuid
        companyName
        peerCompanyUuid
        peerCompanyName
        organizationUuid
        acceptedAt
        revokedAt
        createdAt
        autoAcceptOffers
        shareProgressWithPeer
        autoApplyPeerAccessorials
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;
export const OrganizationDocument = gql`
    query organization($input: FindOrganizationInput!) {
  organization(input: $input) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export const PaginatedOrganizationsDocument = gql`
    query paginatedOrganizations($findPaginatedOrganizationsInput: FindPaginatedOrganizationsInput!) {
  paginatedOrganizations(
    findPaginatedOrganizationsInput: $findPaginatedOrganizationsInput
  ) {
    edges {
      node {
        ...PaginatedOrganization
      }
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${PaginatedOrganizationFragmentDoc}`;
export const RestoreOrganizationDocument = gql`
    mutation restoreOrganization($input: RestoreOrganizationInput!) {
  restoreOrganization(input: $input) {
    ... on RestoreOrganizationSuccessOutput {
      organization {
        ...Organization
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${OrganizationFragmentDoc}`;
export const RevokeOrganizationPeerDocument = gql`
    mutation revokeOrganizationPeer($input: RevokeOrganizationPeerInput!) {
  revokeOrganizationPeer(input: $input) {
    __typename
    uuid
    status
    peerCompanyUuid
    peerCompanyName
    organizationUuid
    revokedAt
    createdAt
  }
}
    `;
export const SetOrganizationEmitPieceLevelWebhooksDocument = gql`
    mutation setOrganizationEmitPieceLevelWebhooks($organizationUuid: String!, $enabled: Boolean!) {
  setOrganizationEmitPieceLevelWebhooks(
    organizationUuid: $organizationUuid
    enabled: $enabled
  ) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export const UpdateOrganizationPeersSettingsDocument = gql`
    mutation updateOrganizationPeersSettings($input: UpdateOrganizationPeersSettingsInput!) {
  updateOrganizationPeersSettings(input: $input) {
    __typename
    uuid
    autoAcceptOffers
    shareProgressWithPeer
    autoApplyPeerAccessorials
  }
}
    `;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    ... on UpdateOrganizationSuccessOutput {
      organization {
        ...Organization
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${OrganizationFragmentDoc}`;
export const IncomingPeerAccessorialMappingsDocument = gql`
    query incomingPeerAccessorialMappings($peerUuid: String!) {
  incomingPeerAccessorialMappings(peerUuid: $peerUuid) {
    __typename
    uuid
    executorAccessorialName
    originatorAccessorialUuid
    suggestedAccessorialUuid
  }
}
    `;
export const MapPeerAccessorialDocument = gql`
    mutation mapPeerAccessorial($input: MapPeerAccessorialInput!) {
  mapPeerAccessorial(input: $input) {
    __typename
    uuid
    executorAccessorialName
    originatorAccessorialUuid
    suggestedAccessorialUuid
  }
}
    `;
export const MappableAccessorialsDocument = gql`
    query mappableAccessorials {
  accessorials(includeArchived: false, onlyShowCompanyAccessorials: true) {
    ... on AttemptsAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on PercentageAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on SkidBasedAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on SpecialAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on StandardAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on StorageDaysAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on UnitBasedAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on WaitTimeAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on WeightBasedAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on ZoneBasedAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
      zones {
        uuid
        name
      }
      chargeGroups {
        uuid
        name
      }
      matrixItems {
        uuid
        zoneUuid
        chargeGroupUuid
      }
    }
  }
}
    `;
export const PeerAccessorialSharesDocument = gql`
    query peerAccessorialShares($peerUuid: String!) {
  peerAccessorialShares(peerUuid: $peerUuid)
}
    `;
export const SetPeerAccessorialSharesDocument = gql`
    mutation setPeerAccessorialShares($input: SetPeerAccessorialSharesInput!) {
  setPeerAccessorialShares(input: $input)
}
    `;
export const ShareableAccessorialsDocument = gql`
    query shareableAccessorials {
  accessorials(includeArchived: false, onlyShowCompanyAccessorials: true) {
    ... on AttemptsAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on PercentageAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on SkidBasedAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on SpecialAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on StandardAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on StorageDaysAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on UnitBasedAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on WaitTimeAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on WeightBasedAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
    ... on ZoneBasedAccessorialEntity {
      __typename
      uuid
      name
      isArchived
      contact {
        uuid
      }
    }
  }
}
    `;
export const IncomingPeerServiceMappingsDocument = gql`
    query incomingPeerServiceMappings($peerUuid: String!) {
  incomingPeerServiceMappings(peerUuid: $peerUuid) {
    __typename
    uuid
    originatorServiceName
    executorServiceUuid
    suggestedServiceUuid
  }
}
    `;
export const MapPeerServiceDocument = gql`
    mutation mapPeerService($input: MapPeerServiceInput!) {
  mapPeerService(input: $input) {
    __typename
    uuid
    originatorServiceName
    executorServiceUuid
    suggestedServiceUuid
  }
}
    `;
export const PeerServiceSharesDocument = gql`
    query peerServiceShares($peerUuid: String!) {
  peerServiceShares(peerUuid: $peerUuid) {
    __typename
    uuid
    serviceUuid
    serviceName
    isActive
  }
}
    `;
export const SetPeerServiceSharesDocument = gql`
    mutation setPeerServiceShares($input: SetPeerServiceSharesInput!) {
  setPeerServiceShares(input: $input) {
    __typename
    uuid
    serviceUuid
    serviceName
    isActive
  }
}
    `;
export const AutoCreateRoutesV2Document = gql`
    mutation autoCreateRoutesV2($input: AutoCreateRoutesV2Input!) {
  autoCreateRoutesV2(input: $input) {
    dryRun
    replayed
    eligibleStopCount
    matchedStopCount
    unmatchedStopCount
    routesCreated
    routesAppended
    routeSummaries {
      routeUuid
      routeName
      created
      stopsAttached
      equipmentUuid
      equipmentName
      truckFitNote
      stops {
        stopUuid
        stopType
        orderName
        customerName
        addressOneLine
      }
    }
    unmatchedStops {
      stopUuid
      reason
      stopType
      orderName
      customerName
      addressOneLine
      matchAttempt
    }
  }
}
    `;
export const BookedStopsByResourceDocument = gql`
    query bookedStopsByResource($input: FindBookedStopsByResourceInput!) {
  bookedStopsByResource(input: $input) {
    serviceDateIso8601
    isTruncated
    isResourceSetTruncated
    groups {
      kind
      bookedCount
      customerBookedCount
      routedCount
      isOverCapacity
      schedulingResource {
        ...BookedStopResource
      }
      stops {
        stopUuid
        orderUuid
        orderName
        houseAirwayBillOfLadingNumber
        customerName
        addressLine1
        city
        zipcode
        appointmentTime
        endAppointmentTime
        attribution
        isRouted
        routeUuid
        routeName
        candidateResources {
          ...BookedStopResource
        }
      }
    }
  }
}
    ${BookedStopResourceFragmentDoc}`;
export const CreateDispatchViewDocument = gql`
    mutation createDispatchView($input: DispatchViewCreateInput!) {
  createDispatchView(dispatchViewCreateInput: $input) {
    __typename
    ... on DispatchViewCreateSuccessOutput {
      dispatchView {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const DispatchViewsDocument = gql`
    query dispatchViews {
  dispatchViews {
    id
    name
    tabIndex
    useMinimizedAppointmentTime
    numberOfStops
    showCompleteStops
    routeCardStopTableColumnWidths
    routeCardWidth
    routeCardStopTableFields
    dispatchTableColors {
      ...DispatchTableColor
    }
  }
}
    ${DispatchTableColorFragmentDoc}`;
export const RemoveDispatchViewDocument = gql`
    mutation removeDispatchView($id: String!) {
  removeDispatchView(id: $id) {
    id
  }
}
    `;
export const UpdateDispatchViewDocument = gql`
    mutation updateDispatchView($input: DispatchViewUpdateInput!) {
  updateDispatchView(dispatchViewUpdateInput: $input) {
    __typename
    ... on DispatchViewUpdateSuccessOutput {
      dispatchView {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const DriversForSelectionDocument = gql`
    query driversForSelection {
  drivers {
    uuid
    firstName
    lastName
    driverType
    driverReferenceNumber
    active
    terminal {
      uuid
      name
    }
    defaultVehicle {
      uuid
      name
      vehicleType {
        uuid
        name
        maxVolume
        maxWeight
      }
    }
  }
}
    `;
export const GenerateRoutesDocument = gql`
    query generateRoutes($generateRoutesInput: GenerateRoutesInput!) {
  generateRoutes(generateRoutesInput: $generateRoutesInput) {
    routes {
      ...GenerateRoutesPreviewRoute
    }
    unassignedStopUuids
    errorMessage
  }
}
    ${GenerateRoutesPreviewRouteFragmentDoc}`;
export const DispatchTableColorsDocument = gql`
    query dispatchTableColors {
  dispatchTableColors {
    ...DispatchTableColor
  }
}
    ${DispatchTableColorFragmentDoc}`;
export const UpdateDispatchTableColorsDocument = gql`
    mutation UpdateDispatchTableColors($input: UpdateDispatchTableColorsInput!) {
  updateDispatchTableColors(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CreateRouteSlotDocument = gql`
    mutation CreateRouteSlot($routeSlotCreateInput: RouteSlotCreateInput!, $routeUuid: String!) {
  createRouteSlot(
    createRouteSlotInput: {routeSlotCreateInput: $routeSlotCreateInput, routeUuid: $routeUuid}
  ) {
    uuid
  }
}
    `;
export const DriversDocument = gql`
    query drivers($active: Boolean) {
  drivers(active: $active) {
    ...Driver
  }
}
    ${DriverFragmentDoc}`;
export const DriversWithRoutesDocument = gql`
    query driversWithRoutes($date: DateTime!) {
  drivers {
    ...Driver
    route(date: $date) {
      uuid
    }
  }
}
    ${DriverFragmentDoc}`;
export const GetOptimizationResultsDocument = gql`
    query getOptimizationResults($routeOptimizationUuid: String!) {
  getOptimizationResults(routeOptimizationUuid: $routeOptimizationUuid) {
    slots
    error
  }
}
    `;
export const GroupByStopsDocument = gql`
    query groupByStops($groupByStopsInput: GroupByStopsInput!) {
  groupByStops(groupByStopsInput: $groupByStopsInput) {
    count
    __typename
    rows {
      ... on GroupsOutput {
        groupValues
      }
      ... on StopOutput {
        stopValues {
          ADDRESS
          ADDRESS_TYPE
          APPOINTMENT
          APPOINTMENT_SCHEDULED
          APPOINTMENT_DATE
          APPOINTMENT_REQUIRED
          APPOINTMENT_TIME
          BUSINESS_DIVISION
          CITY
          CONSIGNEE
          CUSTOMER
          DIMS
          DUE_DATE
          INBOUND_NAME
          INBOUND_CITY
          INBOUND_METHOD
          INBOUND_TERMINAL
          INBOUND_ZIP
          MAWB
          ORDER_NAME
          ORDER_NOTES
          ORDER_NUMBER
          SERVICE_LEVEL
          orderUuid
          OUTBOUND_NAME
          OUTBOUND_CITY
          OUTBOUND_METHOD
          OUTBOUND_TERMINAL
          OUTBOUND_ZIP
          PIECE_COUNT
          REF_NUMBER
          ROUTE_NAME
          SERVICE_DATE
          SERVICE_TIME
          SPECIAL
          SPECIAL_INSTRUCTIONS
          ORDER_STATUS
          STOP_TYPE
          TAGS
          TERMINAL
          TOTAL_CHARGES
          uuid
          VEHICLE_TYPE_NAME
          WEIGHT
          ZIP_CODE
          orderNumberCellColor
          stopDetails {
            message
            stopDetailsStatus
          }
        }
      }
      __typename
    }
  }
}
    `;
export const NumberOfStopsDocument = gql`
    query numberOfStops($appointmentRequired: Boolean, $tagUuids: [String!], $hideOnHold: Boolean, $hideStopsWithoutAddress: Boolean, $isAssigned: Boolean, $previouslyAttempted: Boolean, $serviceLevelUuids: [String!], $onHand: Boolean, $standardStopTypes: [StandardStopType!], $statuses: [StopStatus!], $orderStatuses: [OrderStatus!], $customerUuid: String, $createdAtFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $serviceDateFilters: DateFilterStartEnd, $includeUnscheduledStops: Boolean, $appointmentTimeFilters: DateFilterStartEnd, $transferPending: Boolean, $pickupOrDeliveryTypes: [PickupOrDelivery!], $requiresRecovery: Boolean, $hasAppointment: Boolean, $warehouseUuid: String, $terminalUuid: String, $filters: [FindStopsFiltersInput!], $groupFilters: GroupByStopsFiltersInput, $useCache: Boolean, $includeCount: Boolean) {
  numberOfStops(
    appointmentRequired: $appointmentRequired
    tagUuids: $tagUuids
    hideOnHold: $hideOnHold
    hideStopsWithoutAddress: $hideStopsWithoutAddress
    isAssigned: $isAssigned
    previouslyAttempted: $previouslyAttempted
    onHand: $onHand
    standardStopTypes: $standardStopTypes
    statuses: $statuses
    orderStatuses: $orderStatuses
    customerUuid: $customerUuid
    serviceLevelUuids: $serviceLevelUuids
    createdAtFilters: $createdAtFilters
    deadlineDateFilters: $deadlineDateFilters
    serviceDateFilters: $serviceDateFilters
    includeUnscheduledStops: $includeUnscheduledStops
    appointmentTimeFilters: $appointmentTimeFilters
    transferPending: $transferPending
    pickupOrDeliveryTypes: $pickupOrDeliveryTypes
    requiresRecovery: $requiresRecovery
    hasAppointment: $hasAppointment
    warehouseUuid: $warehouseUuid
    terminalUuid: $terminalUuid
    filters: $filters
    groupFilters: $groupFilters
    useCache: $useCache
    includeCount: $includeCount
  )
}
    `;
export const RouteEtaDocument = gql`
    query routeEta($uuid: String!) {
  route(uuid: $uuid) {
    uuid
    etas {
      arrivalTime
      finishTime
    }
  }
}
    `;
export const AddRouteStopDocument = gql`
    mutation addRouteStop($addRouteStopInput: AddRouteStopInput!) {
  addRouteStop(addRouteStopInput: $addRouteStopInput) {
    uuid
    stopType
    status
  }
}
    `;
export const ApplyRouteOptimizationDocument = gql`
    mutation applyRouteOptimization($input: ApplyRouteOptimizationInput!) {
  applyRouteOptimization(input: $input)
}
    `;
export const AssignHelperToRouteDocument = gql`
    mutation assignHelperToRoute($helperUuid: String!, $routeUuid: String!) {
  assignHelperToRoute(helperUuid: $helperUuid, routeUuid: $routeUuid) {
    uuid
  }
}
    `;
export const CreateAppointmentsForRouteDocument = gql`
    mutation createAppointmentsForRoute($uuid: String!, $canReadIntelligenceBoard: Boolean! = false) {
  createAppointmentsForRoute(uuid: $uuid) {
    ...Route
  }
}
    ${RouteFragmentDoc}`;
export const CreateRoutePathsDocument = gql`
    mutation createRoutePaths($routePathsCreateInput: RoutePathsCreateInput!) {
  createRoutePaths(routePathsCreateInput: $routePathsCreateInput) {
    ...RoutePath
  }
}
    ${RoutePathFragmentDoc}`;
export const CreateRoutesDocument = gql`
    mutation createRoutes($createRoutesInput: CreateRoutesInput!, $canReadIntelligenceBoard: Boolean! = false) {
  createRoutes(createRoutesInput: $createRoutesInput) {
    ...Route
  }
}
    ${RouteFragmentDoc}`;
export const DeleteSlotsFromRouteDocument = gql`
    mutation deleteSlotsFromRoute($deleteSlotsFromRouteInput: DeleteSlotsFromRouteInput!) {
  deleteSlotsFromRoute(deleteSlotsFromRouteInput: $deleteSlotsFromRouteInput)
}
    `;
export const DriversForHelpersDocument = gql`
    query driversForHelpers($date: DateTime!) {
  drivers {
    ...Driver
    route(date: $date) {
      uuid
    }
  }
}
    ${DriverFragmentDoc}`;
export const OptimizationStatusDocument = gql`
    query optimizationStatus($jobUuid: String!) {
  optimizationStatus(jobUuid: $jobUuid) {
    __typename
    ...OptimizationCompletedFields
    ... on OptimizationPending {
      jobUuid
    }
    ... on OptimizationFailed {
      message
    }
  }
}
    ${OptimizationCompletedFieldsFragmentDoc}`;
export const OptimizeRouteSequenceDocument = gql`
    mutation optimizeRouteSequence($input: OptimizeRouteSequenceInput!) {
  optimizeRouteSequence(input: $input) {
    __typename
    ...OptimizationCompletedFields
    ... on OptimizationPending {
      jobUuid
    }
  }
}
    ${OptimizationCompletedFieldsFragmentDoc}`;
export const RunOptimizationDocument = gql`
    mutation runOptimization($createOptimizationRunInput: CreateOptimizationRunDto!) {
  runOptimization(createOptimizationRunInput: $createOptimizationRunInput) {
    uuid
  }
}
    `;
export const OptimizeRoutesTogetherDocument = gql`
    mutation optimizeRoutesTogether($input: OptimizeRoutesTogetherInput!) {
  optimizeRoutesTogether(input: $input) {
    __typename
    jobUuid
  }
}
    `;
export const ReassignRouteSlotDocument = gql`
    mutation reassignRouteSlot($routeSlotReassignInput: RouteSlotReassignInput!, $canReadIntelligenceBoard: Boolean! = false) {
  reassignRouteSlot(routeSlotReassignInput: $routeSlotReassignInput) {
    ...Route
  }
}
    ${RouteFragmentDoc}`;
export const RemoveHelperFromRouteDocument = gql`
    mutation removeHelperFromRoute($helperUuid: String!, $routeUuid: String!) {
  removeHelperFromRoute(helperUuid: $helperUuid, routeUuid: $routeUuid)
}
    `;
export const RemoveRouteDocument = gql`
    mutation removeRoute($uuid: String!) {
  removeRoute(uuid: $uuid) {
    uuid
  }
}
    `;
export const RoutePathByRouteDocument = gql`
    query routePathByRoute($uuid: String!) {
  route(uuid: $uuid) {
    routePath {
      ...RoutePath
    }
  }
}
    ${RoutePathFragmentDoc}`;
export const RoutePathsDocument = gql`
    query routePaths($date: DateTime!) {
  routes(date: $date) {
    routePath {
      ...RoutePath
    }
  }
}
    ${RoutePathFragmentDoc}`;
export const RoutesForDispatchV2Document = gql`
    query routesForDispatchV2($first: Int, $after: String, $last: Int, $before: String, $date: DateTime, $dateFrom: DateTime, $dateTo: DateTime, $terminalUuid: String, $routeUuids: [String!], $searchText: String, $routeSort: RouteSort, $versionId: String, $canReadIntelligenceBoard: Boolean!) {
  paginatedRoutes(
    first: $first
    after: $after
    last: $last
    before: $before
    date: $date
    dateFrom: $dateFrom
    dateTo: $dateTo
    routeUuids: $routeUuids
    terminalUuid: $terminalUuid
    searchText: $searchText
    routeSort: $routeSort
    versionId: $versionId
  ) {
    totalCount
    versionId
    edges {
      node {
        ...RouteListItem
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${RouteListItemFragmentDoc}`;
export const RoutesDocument = gql`
    query routes($date: DateTime, $terminalUuid: String, $routeUuids: [String!], $canReadIntelligenceBoard: Boolean! = false) {
  routes(date: $date, routeUuids: $routeUuids, terminalUuid: $terminalUuid) {
    ...Route
  }
}
    ${RouteFragmentDoc}`;
export const RoutesSamsaraVehicleLocationsDocument = gql`
    query routesSamsaraVehicleLocations($routeUuids: [String!]!) {
  routesSamsaraVehicleLocations(routeUuids: $routeUuids) {
    routeCoordinates {
      routeUuid
      latitude
      longitude
      updatedAt
      headingDegrees
      speedMph
      placeLabel
    }
  }
}
    `;
export const RoutesWithDriverMobilePhoneCoordinatesDocument = gql`
    query routesWithDriverMobilePhoneCoordinates($routeUuids: [String!]!) {
  routes(routeUuids: $routeUuids) {
    uuid
    currentDriverMobilePhoneLocation {
      latitude
      longitude
      updatedAt
    }
  }
}
    `;
export const RoutesWithEtaDocument = gql`
    query routesWithEta($date: DateTime!) {
  routes(date: $date) {
    uuid
    date
    totalTimeInSeconds
    nameManuallyChanged
    locked
    etas {
      arrivalTime
      finishTime
    }
    helpers {
      firstName
      lastName
      uuid
      phoneNumber
    }
    defaultStartTime
    startLoadTimeInMinutes
    endLoadTimeInMinutes
    name
    numberOfRescheduled
    routeSlotsUpdatedAt
    lastDispatched
    equipments {
      name
      type
      uuid
    }
    drivers {
      defaultVehicle {
        name
        uuid
      }
      firstName
      lastName
      phoneNumber
      uuid
    }
    slots {
      uuid
      stops {
        ...StopOnRoute
      }
    }
  }
}
    ${StopOnRouteFragmentDoc}`;
export const PaginatedRoutesDocument = gql`
    query paginatedRoutes($first: Int, $after: String, $last: Int, $before: String, $date: DateTime, $terminalUuid: String, $routeUuids: [String!], $searchText: String, $routeSort: RouteSort, $versionId: String, $canReadIntelligenceBoard: Boolean! = false) {
  paginatedRoutes(
    first: $first
    after: $after
    last: $last
    before: $before
    date: $date
    routeUuids: $routeUuids
    terminalUuid: $terminalUuid
    searchText: $searchText
    routeSort: $routeSort
    versionId: $versionId
  ) {
    totalCount
    versionId
    edges {
      node {
        ...Route
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${RouteFragmentDoc}`;
export const StopOnRouteDetailDocument = gql`
    query stopOnRouteDetail($uuid: String!) {
  stop(uuid: $uuid) {
    ...StopOnRoute
  }
}
    ${StopOnRouteFragmentDoc}`;
export const UpdateRouteDocument = gql`
    mutation updateRoute($updateRouteInput: UpdateRouteInput!) {
  updateRoute(updateRouteInput: $updateRouteInput) {
    uuid
  }
}
    `;
export const UpdateStandaloneStopDocument = gql`
    mutation updateStandaloneStop($updateStandaloneStopInput: UpdateStandaloneStopInput!) {
  updateStandaloneStop(updateStandaloneStopInput: $updateStandaloneStopInput) {
    ...StopOnRouteListItem
  }
}
    ${StopOnRouteListItemFragmentDoc}`;
export const UpdateVehicleForRouteDocument = gql`
    mutation updateVehicleForRoute($routeUuid: String!, $vehicleUuid: String!) {
  updateVehicleForRoute(routeUuid: $routeUuid, vehicleUuid: $vehicleUuid) {
    uuid
  }
}
    `;
export const SameDayDispatchRoutesDocument = gql`
    query sameDayDispatchRoutes($date: DateTime!, $searchText: String, $terminalUuid: String) {
  routes(date: $date, searchText: $searchText, terminalUuid: $terminalUuid) {
    ...SameDayDispatchRoute
  }
}
    ${SameDayDispatchRouteFragmentDoc}`;
export const SamsaraVehicleStatsFeedDocument = gql`
    query samsaraVehicleStatsFeed($samsaraVehicleIds: [String!]!) {
  samsaraVehicleStatsFeed(samsaraVehicleIds: $samsaraVehicleIds) {
    data {
      id
      gps {
        latitude
        longitude
        time
      }
    }
    pagination {
      hasNextPage
      endCursor
    }
  }
}
    `;
export const SendRouteToAgentDocument = gql`
    mutation sendRouteToAgent($sendRouteToAgentInput: SendRouteToAgentInput!) {
  sendRouteToAgent(input: $sendRouteToAgentInput) {
    ... on SendRouteToAgentSuccessOutput {
      route {
        uuid
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const StopsBySearchTextDocument = gql`
    query stopsBySearchText($searchText: String!) {
  stopsBySearchText(searchText: $searchText) {
    ...StopBySearchText
  }
}
    ${StopBySearchTextFragmentDoc}`;
export const StopsOnRoutesBySearchTextDocument = gql`
    query stopsOnRoutesBySearchText($searchText: String!) {
  stopsOnRoutesBySearchText(searchText: $searchText) {
    ...StopOnRouteBySearchText
  }
}
    ${StopOnRouteBySearchTextFragmentDoc}`;
export const GroupableDispatchTableFieldsDocument = gql`
    query groupableDispatchTableFields {
  groupableDispatchTableFields
}
    `;
export const StopQueryForOverrideMinutesDocument = gql`
    query stopQueryForOverrideMinutes($uuid: String!) {
  stop(uuid: $uuid) {
    uuid
    overrideServiceTimeInMinutes
    routeSlot {
      route {
        uuid
      }
    }
  }
}
    `;
export const StopUuidsInGroupDocument = gql`
    query stopUuidsInGroup($first: Int, $after: String, $last: Int, $before: String, $includeCount: Boolean = false, $sort: StopSort, $sorts: [StopSort!], $useCache: Boolean, $cacheStartIndex: Float, $uuid: String, $uuids: [String!], $orderUuid: String, $searchText: String, $addressType: StandardStopType, $appointmentRequired: Boolean, $appointmentScheduled: Boolean, $tagUuids: [String!], $isAssigned: Boolean, $previouslyAttempted: Boolean, $businessDivisionUuid: String, $serviceLevelUuids: [String!], $onHand: Boolean, $isPicked: Boolean, $isRefusedFilter: BooleanFilterV2, $statuses: [StopStatus!], $orderStatuses: [OrderStatus!], $customerUuid: String, $createdAtFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $serviceDateFilters: DateFilterStartEnd, $includeUnscheduledStops: Boolean, $appointmentTimeFilters: DateFilterStartEnd, $transferPending: Boolean, $pickupOrDeliveryTypes: [PickupOrDelivery!], $requiresRecovery: Boolean, $hasAppointment: Boolean, $warehouseUuid: String, $terminalUuid: String, $onHandTerminalUuid: String, $hideOnHold: Boolean, $hideStopsWithoutAddress: Boolean, $isSpecial: Boolean, $routeNameUuid: String, $includeRecurringRunHeaders: Boolean, $filters: [FindStopsFiltersInput!], $groupFilters: GroupByStopsFiltersInput, $groupBy: StopTableGroupByInput) {
  stopUuidsInGroup(
    first: $first
    after: $after
    last: $last
    before: $before
    includeCount: $includeCount
    sort: $sort
    sorts: $sorts
    useCache: $useCache
    cacheStartIndex: $cacheStartIndex
    uuid: $uuid
    uuids: $uuids
    orderUuid: $orderUuid
    searchText: $searchText
    addressType: $addressType
    appointmentRequired: $appointmentRequired
    appointmentScheduled: $appointmentScheduled
    isAssigned: $isAssigned
    previouslyAttempted: $previouslyAttempted
    onHand: $onHand
    isPicked: $isPicked
    isRefusedFilter: $isRefusedFilter
    statuses: $statuses
    orderStatuses: $orderStatuses
    customerUuid: $customerUuid
    businessDivisionUuid: $businessDivisionUuid
    serviceLevelUuids: $serviceLevelUuids
    createdAtFilters: $createdAtFilters
    deadlineDateFilters: $deadlineDateFilters
    serviceDateFilters: $serviceDateFilters
    includeUnscheduledStops: $includeUnscheduledStops
    appointmentTimeFilters: $appointmentTimeFilters
    transferPending: $transferPending
    pickupOrDeliveryTypes: $pickupOrDeliveryTypes
    requiresRecovery: $requiresRecovery
    hasAppointment: $hasAppointment
    warehouseUuid: $warehouseUuid
    terminalUuid: $terminalUuid
    onHandTerminalUuid: $onHandTerminalUuid
    tagUuids: $tagUuids
    hideOnHold: $hideOnHold
    hideStopsWithoutAddress: $hideStopsWithoutAddress
    isSpecial: $isSpecial
    routeNameUuid: $routeNameUuid
    includeRecurringRunHeaders: $includeRecurringRunHeaders
    filters: $filters
    groupFilters: $groupFilters
    groupBy: $groupBy
  ) {
    uuids
    exceedsCap
  }
}
    `;
export const StopsDocument = gql`
    query stops($first: Int, $after: String, $last: Int, $before: String, $includeCount: Boolean = false, $sort: StopSort, $sorts: [StopSort!], $useCache: Boolean, $cacheStartIndex: Float, $uuid: String, $uuids: [String!], $orderUuid: String, $searchText: String, $addressType: StandardStopType, $appointmentRequired: Boolean, $appointmentScheduled: Boolean, $tagUuids: [String!], $isAssigned: Boolean, $previouslyAttempted: Boolean, $businessDivisionUuid: String, $serviceLevelUuids: [String!], $onHand: Boolean, $isPicked: Boolean, $isRefusedFilter: BooleanFilterV2, $statuses: [StopStatus!], $orderStatuses: [OrderStatus!], $customerUuid: String, $createdAtFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $serviceDateFilters: DateFilterStartEnd, $includeUnscheduledStops: Boolean, $appointmentTimeFilters: DateFilterStartEnd, $transferPending: Boolean, $pickupOrDeliveryTypes: [PickupOrDelivery!], $requiresRecovery: Boolean, $hasAppointment: Boolean, $warehouseUuid: String, $terminalUuid: String, $onHandTerminalUuid: String, $hideOnHold: Boolean, $hideStopsWithoutAddress: Boolean, $isSpecial: Boolean, $routeNameUuid: String, $includeRecurringRunHeaders: Boolean, $filters: [FindStopsFiltersInput!], $groupFilters: GroupByStopsFiltersInput, $groupBy: StopTableGroupByInput) {
  stops(
    first: $first
    after: $after
    last: $last
    before: $before
    includeCount: $includeCount
    sort: $sort
    sorts: $sorts
    useCache: $useCache
    cacheStartIndex: $cacheStartIndex
    uuid: $uuid
    uuids: $uuids
    orderUuid: $orderUuid
    searchText: $searchText
    addressType: $addressType
    appointmentRequired: $appointmentRequired
    appointmentScheduled: $appointmentScheduled
    isAssigned: $isAssigned
    previouslyAttempted: $previouslyAttempted
    onHand: $onHand
    isPicked: $isPicked
    isRefusedFilter: $isRefusedFilter
    statuses: $statuses
    orderStatuses: $orderStatuses
    customerUuid: $customerUuid
    businessDivisionUuid: $businessDivisionUuid
    serviceLevelUuids: $serviceLevelUuids
    createdAtFilters: $createdAtFilters
    deadlineDateFilters: $deadlineDateFilters
    serviceDateFilters: $serviceDateFilters
    includeUnscheduledStops: $includeUnscheduledStops
    appointmentTimeFilters: $appointmentTimeFilters
    transferPending: $transferPending
    pickupOrDeliveryTypes: $pickupOrDeliveryTypes
    requiresRecovery: $requiresRecovery
    hasAppointment: $hasAppointment
    warehouseUuid: $warehouseUuid
    terminalUuid: $terminalUuid
    onHandTerminalUuid: $onHandTerminalUuid
    tagUuids: $tagUuids
    hideOnHold: $hideOnHold
    hideStopsWithoutAddress: $hideStopsWithoutAddress
    isSpecial: $isSpecial
    routeNameUuid: $routeNameUuid
    includeRecurringRunHeaders: $includeRecurringRunHeaders
    filters: $filters
    groupFilters: $groupFilters
    groupBy: $groupBy
  ) {
    totalCount @include(if: $includeCount)
    recurringRunsCount
    groupRows {
      ...StopTableGroupRow
    }
    groupRowsHasMore
    edges {
      node {
        __typename
        ... on CachedStopEntity {
          ...Stop
        }
        ... on RecurringRunHeaderEntity {
          ...RecurringRunHeader
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${StopTableGroupRowFragmentDoc}
${StopFragmentDoc}
${RecurringRunHeaderFragmentDoc}`;
export const UnassignedStopPinsDocument = gql`
    query unassignedStopPins($first: Int, $after: String, $last: Int, $before: String, $includeCount: Boolean = false, $sort: StopSort, $sorts: [StopSort!], $useCache: Boolean, $cacheStartIndex: Float, $uuid: String, $uuids: [String!], $orderUuid: String, $searchText: String, $addressType: StandardStopType, $appointmentRequired: Boolean, $appointmentScheduled: Boolean, $tagUuids: [String!], $isAssigned: Boolean, $previouslyAttempted: Boolean, $businessDivisionUuid: String, $serviceLevelUuids: [String!], $onHand: Boolean, $isPicked: Boolean, $isRefusedFilter: BooleanFilterV2, $statuses: [StopStatus!], $orderStatuses: [OrderStatus!], $customerUuid: String, $createdAtFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $serviceDateFilters: DateFilterStartEnd, $includeUnscheduledStops: Boolean, $appointmentTimeFilters: DateFilterStartEnd, $transferPending: Boolean, $pickupOrDeliveryTypes: [PickupOrDelivery!], $requiresRecovery: Boolean, $hasAppointment: Boolean, $warehouseUuid: String, $terminalUuid: String, $onHandTerminalUuid: String, $hideOnHold: Boolean, $hideStopsWithoutAddress: Boolean, $isSpecial: Boolean, $routeNameUuid: String, $includeRecurringRunHeaders: Boolean, $filters: [FindStopsFiltersInput!]) {
  stops(
    first: $first
    after: $after
    last: $last
    before: $before
    includeCount: $includeCount
    sort: $sort
    sorts: $sorts
    useCache: $useCache
    cacheStartIndex: $cacheStartIndex
    uuid: $uuid
    uuids: $uuids
    orderUuid: $orderUuid
    searchText: $searchText
    addressType: $addressType
    appointmentRequired: $appointmentRequired
    appointmentScheduled: $appointmentScheduled
    isAssigned: $isAssigned
    previouslyAttempted: $previouslyAttempted
    onHand: $onHand
    isPicked: $isPicked
    isRefusedFilter: $isRefusedFilter
    statuses: $statuses
    orderStatuses: $orderStatuses
    customerUuid: $customerUuid
    businessDivisionUuid: $businessDivisionUuid
    serviceLevelUuids: $serviceLevelUuids
    createdAtFilters: $createdAtFilters
    deadlineDateFilters: $deadlineDateFilters
    serviceDateFilters: $serviceDateFilters
    includeUnscheduledStops: $includeUnscheduledStops
    appointmentTimeFilters: $appointmentTimeFilters
    transferPending: $transferPending
    pickupOrDeliveryTypes: $pickupOrDeliveryTypes
    requiresRecovery: $requiresRecovery
    hasAppointment: $hasAppointment
    warehouseUuid: $warehouseUuid
    terminalUuid: $terminalUuid
    onHandTerminalUuid: $onHandTerminalUuid
    tagUuids: $tagUuids
    hideOnHold: $hideOnHold
    hideStopsWithoutAddress: $hideStopsWithoutAddress
    isSpecial: $isSpecial
    routeNameUuid: $routeNameUuid
    includeRecurringRunHeaders: $includeRecurringRunHeaders
    filters: $filters
  ) {
    totalCount @include(if: $includeCount)
    edges {
      node {
        __typename
        ... on CachedStopEntity {
          stop {
            uuid
            stopType
            serviceDate
            serviceDateV2 {
              iso8601
            }
            appointmentTime
            endAppointmentTime
            address {
              name
              line1
              city
              state
              zip
              latitude
              longitude
            }
          }
          order {
            uuid
            name
            shipperBillOfLadingNumber
            masterAirwayBillOfLadingNumber
            contactName
            serviceName
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;
export const DispatchTextDriverDocument = gql`
    mutation dispatchTextDriver($textDriverInput: TextDriverInput!) {
  dispatchTextDriver(textDriverInput: $textDriverInput) {
    driver {
      uuid
    }
    textSent
    textNotSentReason
  }
}
    `;
export const UpdateRouteDriversDocument = gql`
    mutation updateRouteDrivers($updateRouteDriversInput: UpdateRouteDriversInput!) {
  updateRouteDrivers(updateRouteDriversInput: $updateRouteDriversInput) {
    uuid
  }
}
    `;
export const UpdateRouteSlotsDocument = gql`
    mutation updateRouteSlots($updateRouteSlotsInput: UpdateRouteSlotsInput!) {
  updateRouteSlots(updateRouteSlotsInput: $updateRouteSlotsInput) {
    uuid
  }
}
    `;
export const DocumentationItemDocument = gql`
    query DocumentationItem($slug: String!) {
  documentationItem(slug: $slug) {
    uuid
    slug
    title
    code
    html
    updatedAt
  }
}
    `;
export const DocumentationSearchDocument = gql`
    query DocumentationSearch($input: DocumentationSearchInput!) {
  documentationSearch(input: $input) {
    uuid
    slug
    title
    code
    topicUuid
    topicTitle
    snippet
  }
}
    `;
export const DocumentationTopicsDocument = gql`
    query DocumentationTopics {
  documentationTopics {
    uuid
    title
    description
    items {
      uuid
      title
      slug
      code
    }
  }
}
    `;
export const CompanyDocumentsDocument = gql`
    query companyDocuments($companyUuid: String!, $terminalUuid: String, $first: Int, $after: String, $last: Int, $before: String, $date: String!, $statusFilter: FindCompanyDocumentStatusFilter!, $searchText: String, $uploadDateAscending: Boolean) {
  companyDocuments(
    companyUuid: $companyUuid
    terminalUuid: $terminalUuid
    first: $first
    after: $after
    last: $last
    before: $before
    date: $date
    statusFilter: $statusFilter
    searchText: $searchText
    uploadDateAscending: $uploadDateAscending
  ) {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export const CompanySchemasDocument = gql`
    query companySchemas {
  companySchemas {
    uuid
    companyUuid
    contactUuid
    isMultiPage
    name
    originalFilename
    scannedDocumentType
  }
}
    `;
export const CustomDocumentNamesDocument = gql`
    query customDocumentNames {
  customDocumentNames {
    uuid
    name
  }
}
    `;
export const DeleteCustomDocumentNameDocument = gql`
    mutation deleteCustomDocumentName($uuid: String!) {
  deleteCustomDocumentName(uuid: $uuid) {
    uuid
  }
}
    `;
export const SplitAndProcessOrderDocumentsDocument = gql`
    mutation splitAndProcessOrderDocuments($splitAndProcessOrderDocumentsInput: SplitAndProcessOrderDocumentsInput!) {
  splitAndProcessOrderDocuments(
    splitAndProcessOrderDocumentsInput: $splitAndProcessOrderDocumentsInput
  )
}
    `;
export const UpdateDocumentsDocument = gql`
    mutation updateDocuments($updateDocumentsInput: UpdateDocumentsInput!) {
  updateDocuments(updateDocumentsInput: $updateDocumentsInput) {
    uuid
  }
}
    `;
export const CreateAdjustmentStopDriverMapDocument = gql`
    mutation createAdjustmentStopDriverMap($input: AdjustmentStopDriverMapCreateInput!) {
  createAdjustmentStopDriverMap(adjustmentStopDriverMapCreateInput: $input) {
    ...StopDriverMapForOrder
  }
}
    ${StopDriverMapForOrderFragmentDoc}`;
export const CreateDriverSettlementBillDocument = gql`
    mutation createDriverSettlementBill($createDriverSettlementBillInput: CreateDriverSettlementBillInput!) {
  createDriverSettlementBill(
    createDriverSettlementBillInput: $createDriverSettlementBillInput
  ) {
    ...DriverSettlementBill
  }
}
    ${DriverSettlementBillFragmentDoc}`;
export const DeleteStopDriverMapDocument = gql`
    mutation deleteStopDriverMap($uuid: String!) {
  deleteStopDriverMap(uuid: $uuid) {
    uuid
  }
}
    `;
export const DriverCompletedStopsLogDocument = gql`
    query driverCompletedStopsLog($driverUuid: String, $startDate: DateTime!, $endDate: DateTime!) {
  driverCompletedStopsLog(
    driverUuid: $driverUuid
    startDate: $startDate
    endDate: $endDate
  ) {
    ...DriverCompletedStops
  }
}
    ${DriverCompletedStopsFragmentDoc}`;
export const DriverSettlementBillByUuidDocument = gql`
    query driverSettlementBillByUuid($uuid: String!) {
  driverSettlementBill(uuid: $uuid) {
    ...DriverSettlementBill
  }
}
    ${DriverSettlementBillFragmentDoc}`;
export const DriverSettlementBillsCountDocument = gql`
    query driverSettlementBillsCount {
  driverSettlementBillsCountForCompany
}
    `;
export const DriverSettlementBillsForDownloadDocument = gql`
    query driverSettlementBillsForDownload($startDate: DateTime, $endDate: DateTime, $isFinalized: Boolean, $driverUuid: String, $searchText: String, $uuids: [String!]) {
  driverSettlementBillsForDownload(
    startDate: $startDate
    endDate: $endDate
    isFinalized: $isFinalized
    driverUuid: $driverUuid
    searchText: $searchText
    uuids: $uuids
  ) {
    ...DriverSettlementBillForDownload
  }
}
    ${DriverSettlementBillForDownloadFragmentDoc}`;
export const DriverSettlementBillsV2Document = gql`
    query driverSettlementBillsV2($first: Int, $after: String, $last: Int, $before: String, $limit: Int, $startDate: DateTime, $endDate: DateTime, $sortByBillStartDateAscending: Boolean, $sortBySettlementDateAscending: Boolean, $isFinalized: Boolean, $driverUuid: String, $driverUuids: [String!], $searchText: String) {
  driverSettlementBills(
    first: $first
    after: $after
    last: $last
    before: $before
    limit: $limit
    startDate: $startDate
    endDate: $endDate
    sortByBillStartDateAscending: $sortByBillStartDateAscending
    sortBySettlementDateAscending: $sortBySettlementDateAscending
    isFinalized: $isFinalized
    driverUuid: $driverUuid
    driverUuids: $driverUuids
    searchText: $searchText
  ) {
    totalCount
    edges {
      node {
        ...DriverSettlementBillSummaryV2
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${DriverSettlementBillSummaryV2FragmentDoc}`;
export const DriverSettlementBillsDocument = gql`
    query driverSettlementBills($first: Int, $after: String, $last: Int, $before: String, $limit: Int, $startDate: DateTime, $endDate: DateTime, $sortByBillStartDateAscending: Boolean, $sortBySettlementDateAscending: Boolean, $isFinalized: Boolean, $driverUuid: String, $driverUuids: [String!], $searchText: String) {
  driverSettlementBills(
    first: $first
    after: $after
    last: $last
    before: $before
    limit: $limit
    startDate: $startDate
    endDate: $endDate
    sortByBillStartDateAscending: $sortByBillStartDateAscending
    sortBySettlementDateAscending: $sortBySettlementDateAscending
    isFinalized: $isFinalized
    driverUuid: $driverUuid
    driverUuids: $driverUuids
    searchText: $searchText
  ) {
    totalCount
    edges {
      node {
        ...DriverSettlementBill
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${DriverSettlementBillFragmentDoc}`;
export const FinalizeDriverSettlementBillsDocument = gql`
    mutation finalizeDriverSettlementBills($startDate: DateTime, $endDate: DateTime, $isFinalized: Boolean, $driverUuid: String, $searchText: String, $uuids: [String!]) {
  finalizeDriverSettlementBills(
    startDate: $startDate
    endDate: $endDate
    isFinalized: $isFinalized
    driverUuid: $driverUuid
    searchText: $searchText
    uuids: $uuids
  )
}
    `;
export const InvoiceShipmentByStopUuidDocument = gql`
    query invoiceShipmentByStopUuid($uuid: String!) {
  stop(uuid: $uuid) {
    shipment {
      ...InvoiceShipmentWithCharges
    }
  }
}
    ${InvoiceShipmentWithChargesFragmentDoc}`;
export const RemoveDriverSettlementBillDocument = gql`
    mutation removeDriverSettlementBill($uuid: String!) {
  removeDriverSettlementBill(uuid: $uuid) {
    uuid
  }
}
    `;
export const CreateSettlementDeductionDocument = gql`
    mutation createSettlementDeduction($settlementDeductionCreateInput: SettlementDeductionCreateInput!) {
  createSettlementDeduction(
    settlementDeductionCreateInput: $settlementDeductionCreateInput
  ) {
    uuid
  }
}
    `;
export const RemoveSettlementDeductionDocument = gql`
    mutation removeSettlementDeduction($uuid: String!) {
  removeSettlementDeduction(uuid: $uuid) {
    uuid
  }
}
    `;
export const UpdateSettlementDeductionDocument = gql`
    mutation updateSettlementDeduction($settlementDeductionUpdateInput: SettlementDeductionUpdateInput!) {
  updateSettlementDeduction(
    settlementDeductionUpdateInput: $settlementDeductionUpdateInput
  ) {
    uuid
  }
}
    `;
export const StopDriverMapsSummaryDocument = gql`
    query stopDriverMapsSummary($first: Int, $after: String, $last: Int, $before: String, $noMaximum: Boolean, $completedStartDate: DateTime, $completedEndDate: DateTime, $completionStatus: StopCompletionStatus, $settlementStartDate: DateTime, $settlementEndDate: DateTime, $sortByCompletedDateAsc: Boolean, $sortBySettlementDateAsc: Boolean, $onDriverSettlementBill: Boolean, $driverSettlementFinalized: Boolean, $onInvoice: Boolean, $chargesFinalized: Boolean, $invoiceStatuses: [InvoiceStatus!], $driverSettlementBillUuid: String, $driverUuid: String, $searchText: String, $stopTypes: [StopType!], $includeStopDriverMapUuids: [String!], $excludeStopDriverMapUuids: [String!], $includeTotalAmounts: Boolean!) {
  stopDriverMaps(
    first: $first
    after: $after
    last: $last
    before: $before
    noMaximum: $noMaximum
    completedStartDate: $completedStartDate
    completedEndDate: $completedEndDate
    completionStatus: $completionStatus
    settlementStartDate: $settlementStartDate
    settlementEndDate: $settlementEndDate
    sortByCompletedDateAsc: $sortByCompletedDateAsc
    sortBySettlementDateAsc: $sortBySettlementDateAsc
    onDriverSettlementBill: $onDriverSettlementBill
    driverSettlementFinalized: $driverSettlementFinalized
    onInvoice: $onInvoice
    chargesFinalized: $chargesFinalized
    invoiceStatuses: $invoiceStatuses
    driverSettlementBillUuid: $driverSettlementBillUuid
    driverUuid: $driverUuid
    searchText: $searchText
    stopTypes: $stopTypes
    includeStopDriverMapUuids: $includeStopDriverMapUuids
    excludeStopDriverMapUuids: $excludeStopDriverMapUuids
  ) {
    totalCount
    edges {
      node {
        ...StopDriverMapSummary
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${StopDriverMapSummaryFragmentDoc}`;
export const StopDriverMapsDocument = gql`
    query stopDriverMaps($first: Int, $after: String, $last: Int, $before: String, $noMaximum: Boolean, $completedStartDate: DateTime, $completedEndDate: DateTime, $completionStatus: StopCompletionStatus, $sortByCompletedDateAsc: Boolean, $onDriverSettlementBill: Boolean, $driverSettlementFinalized: Boolean, $onInvoice: Boolean, $chargesFinalized: Boolean, $invoiceStatuses: [InvoiceStatus!], $driverSettlementBillUuid: String, $driverUuid: String, $searchText: String, $stopTypes: [StopType!], $includeStopDriverMapUuids: [String!], $excludeStopDriverMapUuids: [String!]) {
  stopDriverMaps(
    first: $first
    after: $after
    last: $last
    before: $before
    noMaximum: $noMaximum
    completedStartDate: $completedStartDate
    completedEndDate: $completedEndDate
    completionStatus: $completionStatus
    sortByCompletedDateAsc: $sortByCompletedDateAsc
    onDriverSettlementBill: $onDriverSettlementBill
    driverSettlementFinalized: $driverSettlementFinalized
    onInvoice: $onInvoice
    chargesFinalized: $chargesFinalized
    invoiceStatuses: $invoiceStatuses
    driverSettlementBillUuid: $driverSettlementBillUuid
    driverUuid: $driverUuid
    searchText: $searchText
    stopTypes: $stopTypes
    includeStopDriverMapUuids: $includeStopDriverMapUuids
    excludeStopDriverMapUuids: $excludeStopDriverMapUuids
  ) {
    totalCount
    edges {
      node {
        ...StopDriverMap
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${StopDriverMapFragmentDoc}`;
export const UpdateDriverSettlementBillDocument = gql`
    mutation updateDriverSettlementBill($updateDriverSettlementBillInput: UpdateDriverSettlementBillInput!) {
  updateDriverSettlementBill(
    updateDriverSettlementBillInput: $updateDriverSettlementBillInput
  ) {
    ...DriverSettlementBill
  }
}
    ${DriverSettlementBillFragmentDoc}`;
export const UpdateStopDriverMapDocument = gql`
    mutation updateStopDriverMap($input: UpdateStopDriverMapInput!) {
  updateStopDriverMap(updateStopDriverMapInput: $input) {
    ...StopDriverMapForOrder
  }
}
    ${StopDriverMapForOrderFragmentDoc}`;
export const CreateCsvOrderMappingDocument = gql`
    mutation createCsvOrderMapping($createCsvOrderMappingInput: CreateCsvOrderMappingInput!) {
  createCsvOrderMapping(createCsvOrderMappingInput: $createCsvOrderMappingInput) {
    ...CsvOrderMappingDetailed
  }
}
    ${CsvOrderMappingDetailedFragmentDoc}`;
export const CsvOrderMappingDocument = gql`
    query csvOrderMapping($input: CsvOrderMappingQueryInput!) {
  csvOrderMapping(input: $input) {
    ...CsvOrderMappingDetailed
  }
}
    ${CsvOrderMappingDetailedFragmentDoc}`;
export const CsvOrderMappingsForEmailToolDocument = gql`
    query csvOrderMappingsForEmailTool {
  csvOrderMappings {
    ...CsvOrderMappingShallow
  }
}
    ${CsvOrderMappingShallowFragmentDoc}`;
export const UpdateCsvOrderMappingDocument = gql`
    mutation updateCsvOrderMapping($updateCsvOrderMappingInput: UpdateCsvOrderMappingInput!) {
  updateCsvOrderMapping(updateCsvOrderMappingInput: $updateCsvOrderMappingInput) {
    ...CsvOrderMappingDetailed
  }
}
    ${CsvOrderMappingDetailedFragmentDoc}`;
export const CreateEndOfDayDocumentProcessingJobDocument = gql`
    mutation createEndOfDayDocumentProcessingJob($createEndOfDayDocumentProcessingJobInput: CreateEndOfDayDocumentProcessingJobInput!) {
  createEndOfDayDocumentProcessingJob(
    createEndOfDayDocumentProcessingJobInput: $createEndOfDayDocumentProcessingJobInput
  ) {
    uuid
  }
}
    `;
export const DetachDocumentsFromShipmentsDocument = gql`
    mutation detachDocumentsFromShipments($detachDocumentsFromShipmentsInput: DetachDocumentsFromShipmentsInput!) {
  detachDocumentsFromShipments(
    detachDocumentsFromShipmentsInput: $detachDocumentsFromShipmentsInput
  ) {
    uuid
    fileName
    bucket
    region
    key
    type
    fileType
  }
}
    `;
export const DetachDocumentFromShipmentDocument = gql`
    mutation detachDocumentFromShipment($uuid: String!) {
  detachDocumentFromShipment(uuid: $uuid) {
    uuid
    fileName
    bucket
    region
    key
    type
    fileType
  }
}
    `;
export const DocumentsByShipmentDocument = gql`
    query documentsByShipment($uuid: String!) {
  shipmentV2(uuid: $uuid) {
    documents {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;
export const EndOfDayDocumentProcessingJobsDocument = gql`
    query endOfDayDocumentProcessingJobs($companyUuid: String!, $terminalUuid: String, $dateUploadedFor: DateTime!, $searchText: String) {
  endOfDayDocumentProcessingJobs(
    companyUuid: $companyUuid
    terminalUuid: $terminalUuid
    dateUploadedFor: $dateUploadedFor
    searchText: $searchText
  ) {
    ...EndOfDocumentsProcessingJob
  }
}
    ${EndOfDocumentsProcessingJobFragmentDoc}`;
export const ShallowRoutesWithDocumentsDocument = gql`
    query shallowRoutesWithDocuments($date: DateTime!, $terminalUuid: String) {
  routes(date: $date, terminalUuid: $terminalUuid) {
    uuid
    name
    date
    drivers {
      firstName
      lastName
    }
    slots {
      uuid
      stops {
        uuid
        status
        address {
          city
        }
        leg {
          uuid
          shipment {
            documents {
              ...Document
            }
            hasSignedPOD
          }
        }
      }
    }
  }
}
    ${DocumentFragmentDoc}`;
export const EquipmentDocument = gql`
    query equipment($uuid: String!) {
  equipment(uuid: $uuid) {
    ...Equipment
    equipmentLicenses {
      uuid
      number
      licenseType
      licensingBody
      issueDate
      expiryDate
    }
    vehicleType {
      uuid
    }
    isActive
  }
  samsaraOAuthToken {
    uuid
  }
  motiveIntegration {
    connected
  }
}
    ${EquipmentFragmentDoc}`;
export const EquipmentsDocument = gql`
    query equipments($includeNotActive: Boolean) {
  equipments(includeNotActive: $includeNotActive) {
    uuid
    name
    type
    samsaraVehicleId
    samsaraIsDeactivated
    motiveVehicleId
    motiveIsDeactivated
    subtype
    capacity
    weight
    length
    width
    height
    measurementSystem
    vehicleType {
      ...VehicleType
    }
    isActive
  }
}
    ${VehicleTypeFragmentDoc}`;
export const ExpeditorsApiStatusDocument = gql`
    query ExpeditorsApiStatus {
  expeditorsApiStatus {
    generatedAt
    windowStart
    windowEnd
    timezone
    transmissionsTotal
    connection {
      heldCount
      avgAttempts
      longestWaitMinutes
      failingSendsCount
      degraded
    }
    transmissions {
      eventUuid
      transmittedAt
      orderUuid
      orderNumber
      consigneeName
      consigneeCity
      consigneeState
      kind
      result
      error
      retriedLater
    }
  }
}
    `;
export const ForwarderBoardDocument = gql`
    query ForwarderBoard($args: ForwarderBoardArgs!) {
  forwarderBoard(args: $args) {
    windowStart
    windowEnd
    timezone
    podWithin30 {
      onTime
      of
      rate
    }
    deliveryEventWithin30 {
      onTime
      of
      rate
    }
    missingPods
    driverEntered {
      onTime
      of
      rate
    }
    acceptedWithin12h {
      onTime
      of
      rate
    }
    completedWithin30OfArrival {
      onTime
      of
      rate
    }
    electronicDispatchShare {
      onTime
      of
      rate
    }
    awaitingPod {
      orderUuid
      workOrderNumber
      deliveredAt
      waitingMinutes
      cause
      uploadAttempts
      firstUploadAttemptAt
    }
    awaitingPodTotal
    awaitingAcceptance {
      orderUuid
      workOrderNumber
      receivedAt
      waitingMinutes
    }
    awaitingAcceptanceTotal
    undelivered {
      orderUuid
      workOrderNumber
      receivedAt
      ageDays
    }
    undeliveredTotal
    lateDeliveries {
      orderUuid
      workOrderNumber
      deliveredAt
      podLagMinutes
      deliveryEventLagMinutes
      driverEntered
      uploadAttempts
      firstUploadAttemptAt
      reachedForwarder
      arrivalToCompletionMinutes
    }
    lateDeliveriesTotal
    acceptanceMisses {
      orderUuid
      workOrderNumber
      receivedAt
      acceptedAt
      acceptanceLagMinutes
    }
    acceptanceMissesTotal
    manualOrders {
      orderUuid
      orderName
      receivedAt
    }
    manualOrdersTotal
    connection {
      heldCount
      avgAttempts
      longestWaitMinutes
    }
  }
}
    `;
export const ForwarderScorecardDocument = gql`
    query ForwarderScorecard($args: ForwarderScorecardArgs!) {
  forwarderScorecard(args: $args) {
    companyName
    generatedAt
    reportDay
    dayRowLabel
    timezone
    dispatchSummary {
      label
      startDate
      endDate
      shipmentsDispatched
      connectivityPct
      acceptedPct
    }
    dispatchTrend {
      day
      connectivityPct
      acceptedPct
    }
    dispatchExceptions {
      orderUuid
      workOrderNumber
      branch
      receiptAt
      acceptedAt
      minutesLate
      consigneeName
      consigneeCity
      consigneeState
      driverName
    }
    dispatchExceptionsTotal
    deliverySummary {
      label
      startDate
      endDate
      shipmentsDispatched
      freightPickedUp
      outForDelivery
      arrivedCount
      dlvWithin30Pct
      podWithin30Pct
      missingPodCount
    }
    deliveryTrend {
      day
      dlvPct
      podPct
    }
    deliveryExceptions {
      orderUuid
      workOrderNumber
      branch
      ediDispatch
      pickedUpSentAt
      outForDeliverySentAt
      arrivedSentAt
      deliveredAt
      dlvReceivedAt
      dlvLagMinutes
      dlvOperator
      podReceivedAt
      podLagMinutes
      consigneeName
      consigneeCity
      consigneeState
      driverName
    }
    deliveryExceptionsTotal
    undelivered {
      orderUuid
      workOrderNumber
      branch
      dispatchedElectronically
      freightAvailableAt
      dispatchedSentAt
      dispatchedReceivedAt
      acceptedAt
      consigneeName
      consigneeCity
      consigneeState
      driverName
    }
    undeliveredTotal
    customers {
      uuid
      displayName
      isActive
    }
    customersNotIncluded {
      uuid
      displayName
      isActive
      apiOrders
    }
  }
}
    `;
export const FuelChargeFuelProfileDateRangeDocument = gql`
    query fuelChargeFuelProfileDateRange($fuelChargeFuelProfileDateRangeInput: FuelChargeFuelProfileDateRangeInput!) {
  fuelChargeFuelProfileDateRange(
    fuelChargeFuelProfileDateRangeInput: $fuelChargeFuelProfileDateRangeInput
  ) {
    fuelProfileDateRange {
      ...FuelChargeFuelProfileDateRange
    }
  }
}
    ${FuelChargeFuelProfileDateRangeFragmentDoc}`;
export const LineHaulFuelChargeFuelProfileDateRangeDocument = gql`
    query lineHaulFuelChargeFuelProfileDateRange($lineHaulFuelChargeFuelProfileDateRangeInput: LineHaulFuelChargeFuelProfileDateRangeInput!) {
  lineHaulFuelChargeFuelProfileDateRange(
    lineHaulFuelChargeFuelProfileDateRangeInput: $lineHaulFuelChargeFuelProfileDateRangeInput
  ) {
    fuelProfileDateRange {
      ...LineHaulFuelChargeFuelProfileDateRange
    }
  }
}
    ${LineHaulFuelChargeFuelProfileDateRangeFragmentDoc}`;
export const CostCenterStatementReportDocument = gql`
    query CostCenterStatementReport($args: CostCenterStatementArgs!) {
  costCenterStatementReport(args: $args) {
    __typename
    shipmentCount
    revenueUsd
    pickupDeliveryCostUsd
    linehaulCostUsd
    dockCostUsd
    insuranceClaimsCostUsd
    billingCollectingCostUsd
    totalVariableCostUsd
    variableCostPctOfRevenue
    contributionDollarsUsd
    contributionMarginPct
    fixedOverheadCostUsd
    operatingIncomeUsd
    operatingRatio
    breakevenRevenueUsd
    percentOfBreakeven
    revenuePerShipmentUsd
    variableCostPerShipmentUsd
    contributionPerShipmentUsd
    breakevenShipmentCount
    status
    usesBenchmarkDefaults
    costBasis
    estimatedCostInputs {
      ...CostInputEstimatedMonth
    }
    missingCostInputs
    revenueSharedWithAgentsUsd
    netRevenueUsd
    pdLaborCostUsd
    dockLaborCostUsd
    truckCostUsd
    outsideCarriersCostUsd
    nonFreightCostUsd
    incomeAfterNonFreightUsd
    workdays
    netRevenuePerDayUsd
    fixedCostPerDayUsd
    contributionPerDayUsd
    terminals {
      __typename
      terminalUuid
      terminalCode
      terminalName
      shipmentCount
      revenueUsd
      pickupDeliveryCostUsd
      linehaulCostUsd
      dockCostUsd
      insuranceClaimsCostUsd
      billingCollectingCostUsd
      totalVariableCostUsd
      variableCostPctOfRevenue
      contributionDollarsUsd
      contributionMarginPct
      fixedOverheadCostUsd
      operatingIncomeUsd
      operatingRatio
      breakevenRevenueUsd
      percentOfBreakeven
      revenuePerShipmentUsd
      variableCostPerShipmentUsd
      contributionPerShipmentUsd
      profileSource
      status
    }
  }
}
    ${CostInputEstimatedMonthFragmentDoc}`;
export const CostInputCatalogueDocument = gql`
    query CostInputCatalogue {
  costInputCatalogue {
    field
    label
    group
    unit
    cadence
    sources
    quickbooksMappable
    whereToFind
    howToFill
  }
}
    `;
export const CostInputMonthDocument = gql`
    query CostInputMonth($args: CostInputMonthArgs!) {
  costInputMonth(args: $args) {
    ...CostInputMonth
  }
}
    ${CostInputMonthFragmentDoc}`;
export const CostInputQuickbooksAccountsDocument = gql`
    query CostInputQuickbooksAccounts {
  costInputQuickbooksAccounts {
    ...CostInputQuickbooksAccount
  }
}
    ${CostInputQuickbooksAccountFragmentDoc}`;
export const CostInputStatusDocument = gql`
    query CostInputStatus {
  costInputStatus {
    ...CostInputStatus
  }
}
    ${CostInputStatusFragmentDoc}`;
export const SaveCostInputQuickbooksMappingsDocument = gql`
    mutation SaveCostInputQuickbooksMappings($input: SaveCostInputQuickbooksMappingsInput!) {
  saveCostInputQuickbooksMappings(input: $input) {
    ...CostInputQuickbooksAccount
  }
}
    ${CostInputQuickbooksAccountFragmentDoc}`;
export const SaveCostInputSetupDocument = gql`
    mutation SaveCostInputSetup($input: SaveCostInputSetupInput!) {
  saveCostInputSetup(input: $input) {
    ...CostInputStatus
  }
}
    ${CostInputStatusFragmentDoc}`;
export const SaveCostInputsDocument = gql`
    mutation SaveCostInputs($input: SaveCostInputsInput!) {
  saveCostInputs(input: $input) {
    ...CostInputMonth
  }
}
    ${CostInputMonthFragmentDoc}`;
export const CustomerProfitabilityReportDocument = gql`
    query CustomerProfitabilityReport($args: CustomerProfitabilityArgs!) {
  customerProfitabilityReport(args: $args) {
    __typename
    breakevenContributionRatio
    operatingRatio
    totalRevenueUsd
    totalVariableCostUsd
    proratedFixedCostUsd
    proratedOverheadCostUsd
    hasCostAssumptions
    costBasis
    estimatedCostInputs {
      ...CostInputEstimatedMonth
    }
    missingCostInputs
    appliedRates {
      variableCostPerShipmentUsd
      variableCostPerHundredweightUsd
      variableCostPerMileUsd
    }
    customers {
      __typename
      customerUuid
      customerName
      shipmentCount
      totalWeightLbs
      totalMiles
      revenueUsd
      variableCostUsd
      actualContributionRatio
      status
    }
  }
}
    ${CostInputEstimatedMonthFragmentDoc}`;
export const DockProductivityReportDocument = gql`
    query DockProductivityReport($args: DockProductivityArgs!) {
  dockProductivityReport(args: $args) {
    __typename
    totalActualHours
    totalAllowedHours
    totalSavedHours
    totalSavedCostUsd
    overallLaborEfficiencyPct
    hasTimeAllowances
    actualHoursAreProxy
    costBasis
    estimatedCostInputs {
      ...CostInputEstimatedMonth
    }
    missingCostInputs
    appliedDockCostPerHourUsd
    timeAllowances {
      __typename
      uuid
      minutesPerInboundPiece
      minutesPerOutboundPiece
      minutesPerHundredweight
    }
    terminals {
      __typename
      terminalUuid
      terminalName
      terminalCode
      inboundPieces
      outboundPieces
      totalWeightLbs
      allowedHours
      actualHours
      savedHours
      savedCostUsd
      laborEfficiencyPct
      status
    }
  }
}
    ${CostInputEstimatedMonthFragmentDoc}`;
export const DockTimeAllowancesDocument = gql`
    query DockTimeAllowances {
  dockTimeAllowances {
    __typename
    uuid
    minutesPerInboundPiece
    minutesPerOutboundPiece
    minutesPerHundredweight
  }
}
    `;
export const UpsertDockTimeAllowancesDocument = gql`
    mutation UpsertDockTimeAllowances($input: UpsertDockTimeAllowanceInput!) {
  upsertDockTimeAllowances(input: $input) {
    __typename
    uuid
    minutesPerInboundPiece
    minutesPerOutboundPiece
    minutesPerHundredweight
  }
}
    `;
export const DriverPlannerAssumptionsDocument = gql`
    query DriverPlannerAssumptions {
  driverPlannerAssumptions {
    __typename
    uuid
    standardShiftHours
    targetUtilizationPct
    targetMgt
  }
}
    `;
export const DriverPlannerReportDocument = gql`
    query DriverPlannerReport($args: DriverPlannerArgs!) {
  driverPlannerReport(args: $args) {
    __typename
    tripsRun
    productiveHours
    netHours
    avgProductiveHoursPerTrip
    avgNetHoursPerTrip
    actualUtilizationPct
    requiredTrips
    excessTrips
    mgt
    excessCapacityPct
    excessCapacityLaborCostUsd
    status
    targetProductiveHoursPerTrip
    driverWageFringePerHourUsd
    hasTimeAllowances
    costBasis
    estimatedCostInputs {
      ...CostInputEstimatedMonth
    }
    missingCostInputs
    hasAssumptions
    netHoursAreProxy
    assumptions {
      __typename
      uuid
      standardShiftHours
      targetUtilizationPct
      targetMgt
    }
    terminals {
      __typename
      terminalUuid
      terminalCode
      terminalName
      tripsRun
      productiveHours
      netHours
      avgProductiveHoursPerTrip
      avgNetHoursPerTrip
      actualUtilizationPct
      requiredTrips
      excessTrips
      mgt
      excessCapacityPct
      excessCapacityLaborCostUsd
      status
    }
  }
}
    ${CostInputEstimatedMonthFragmentDoc}`;
export const UpsertDriverPlannerAssumptionsDocument = gql`
    mutation UpsertDriverPlannerAssumptions($input: UpsertDriverPlannerAssumptionsInput!) {
  upsertDriverPlannerAssumptions(input: $input) {
    __typename
    uuid
    standardShiftHours
    targetUtilizationPct
    targetMgt
  }
}
    `;
export const LineHaulUtilizationAssumptionsDocument = gql`
    query LineHaulUtilizationAssumptions {
  lineHaulUtilizationAssumptions {
    __typename
    uuid
    defaultTrailerWeightCapacityLbs
    defaultTrailerCubeCapacityCubicFeet
  }
}
    `;
export const LineHaulUtilizationReportDocument = gql`
    query LineHaulUtilizationReport($args: LineHaulUtilizationArgs!) {
  lineHaulUtilizationReport(args: $args) {
    __typename
    grain
    totalManifests
    totalTrailers
    totalLoadedWeightLbs
    totalWeightCapacityLbs
    overallWeightUtilizationPct
    totalEquivalentEmptyTrailers
    hasAssumptions
    usedDefaultCapacity
    assumptions {
      __typename
      uuid
      defaultTrailerWeightCapacityLbs
      defaultTrailerCubeCapacityCubicFeet
    }
    rows {
      __typename
      key
      label
      manifestCount
      trailerCount
      loadedWeightLbs
      loadedCubeCubicFeet
      weightCapacityLbs
      cubeCapacityCubicFeet
      weightUtilizationPct
      cubeUtilizationPct
      utilizationPct
      equivalentEmptyTrailers
      status
      laneBalancePct
      reverseLoadedWeightLbs
    }
  }
}
    `;
export const UpsertLineHaulUtilizationAssumptionsDocument = gql`
    mutation UpsertLineHaulUtilizationAssumptions($input: UpsertLineHaulUtilizationAssumptionInput!) {
  upsertLineHaulUtilizationAssumptions(input: $input) {
    __typename
    uuid
    defaultTrailerWeightCapacityLbs
    defaultTrailerCubeCapacityCubicFeet
  }
}
    `;
export const OperationalEfficiencyReportDocument = gql`
    query OperationalEfficiencyReport($args: OperationalEfficiencyArgs!) {
  operationalEfficiencyReport(args: $args) {
    dimension
    totalShipments
    totalRevenueUsd
    avgShipmentPriceUsd
    totalMiles
    shipmentsWithMiles
    milesCoveragePct
    revenuePerMileUsd
    rows {
      key
      label
      shipmentCount
      revenueUsd
      avgShipmentPriceUsd
      totalMiles
      shipmentsWithMiles
      milesCoveragePct
      revenuePerMileUsd
      status
    }
  }
}
    `;
export const PdProductivityReportDocument = gql`
    query PdProductivityReport($args: PdProductivityArgs!) {
  pdProductivityReport(args: $args) {
    __typename
    totalActualHours
    totalAllowedHours
    totalInefficiencyHours
    totalInefficiencyCostUsd
    overallProductivityRatio
    routesMissingTimestamps
    hasTimeAllowances
    costBasis
    estimatedCostInputs {
      ...CostInputEstimatedMonth
    }
    missingCostInputs
    appliedDriverCostPerHourUsd
    truckCostPerMileUsd
    pdCostUsd
    costPerStopUsd
    timeAllowances {
      __typename
      uuid
      minutesPerStop
      minutesPerPiece
      minutesPerHundredweight
      minutesPerMile
    }
    drivers {
      __typename
      driverUuid
      driverName
      routeCount
      stopCount
      pieceCount
      totalWeightLbs
      totalMiles
      actualHours
      allowedHours
      inefficiencyHours
      inefficiencyCostUsd
      productivityRatio
      status
    }
  }
}
    ${CostInputEstimatedMonthFragmentDoc}`;
export const ProductivityTimeAllowancesDocument = gql`
    query ProductivityTimeAllowances {
  productivityTimeAllowances {
    __typename
    uuid
    minutesPerStop
    minutesPerPiece
    minutesPerHundredweight
    minutesPerMile
  }
}
    `;
export const UpsertProductivityTimeAllowancesDocument = gql`
    mutation UpsertProductivityTimeAllowances($input: UpsertTimeAllowanceInput!) {
  upsertProductivityTimeAllowances(input: $input) {
    __typename
    uuid
    minutesPerStop
    minutesPerPiece
    minutesPerHundredweight
    minutesPerMile
  }
}
    `;
export const SamsaraDiscoveryCatalogueDocument = gql`
    query SamsaraDiscoveryCatalogue {
  samsaraDiscoveryCatalogue {
    datasets {
      key
      group
      label
      description
      dated
      rowCount
    }
    absentEndpoints {
      label
      reason
    }
  }
}
    `;
export const SamsaraDiscoveryExportDocument = gql`
    query SamsaraDiscoveryExport($input: SamsaraDiscoveryExportInput!) {
  samsaraDiscoveryExport(input: $input)
}
    `;
export const SamsaraDiscoveryMonthlyOverviewDocument = gql`
    query SamsaraDiscoveryMonthlyOverview($input: SamsaraDiscoveryMonthlyOverviewInput!) {
  samsaraDiscoveryMonthlyOverview(input: $input) {
    month
    vehicles
    miles
    gallons
    estFuelUsd
    idleHours
    workOrdersCompleted
    laborUsd
    partLinesUsd
    taskPartsCostUsd
    driveHours
    onDutyHours
    iftaMiles
    iftaGallonsBought
  }
}
    `;
export const SamsaraDiscoveryRemoveTokenDocument = gql`
    mutation SamsaraDiscoveryRemoveToken {
  samsaraDiscoveryRemoveToken {
    ...SamsaraDiscoveryStatus
  }
}
    ${SamsaraDiscoveryStatusFragmentDoc}`;
export const SamsaraDiscoveryRowsDocument = gql`
    query SamsaraDiscoveryRows($input: SamsaraDiscoveryRowsInput!) {
  samsaraDiscoveryRows(input: $input) {
    headers
    rows
    total
  }
}
    `;
export const SamsaraDiscoveryRunImportDocument = gql`
    mutation SamsaraDiscoveryRunImport {
  samsaraDiscoveryRunImport {
    ...SamsaraDiscoveryStatus
  }
}
    ${SamsaraDiscoveryStatusFragmentDoc}`;
export const SamsaraDiscoverySetTokenDocument = gql`
    mutation SamsaraDiscoverySetToken($input: SamsaraDiscoverySetTokenInput!) {
  samsaraDiscoverySetToken(input: $input) {
    ...SamsaraDiscoveryStatus
  }
}
    ${SamsaraDiscoveryStatusFragmentDoc}`;
export const SamsaraDiscoveryStatusDocument = gql`
    query SamsaraDiscoveryStatus {
  samsaraDiscoveryStatus {
    ...SamsaraDiscoveryStatus
  }
}
    ${SamsaraDiscoveryStatusFragmentDoc}`;
export const TerminalEfficiencyReportDocument = gql`
    query TerminalEfficiencyReport($args: TerminalEfficiencyArgs!) {
  terminalEfficiencyReport(args: $args) {
    __typename
    totalActualHours
    totalAllowedHours
    overallEfficiencyPct
    hasPdAllowances
    hasDockAllowances
    actualHoursAreProxy
    costBasis
    estimatedCostInputs {
      ...CostInputEstimatedMonth
    }
    missingCostInputs
    terminals {
      __typename
      terminalUuid
      terminalCode
      terminalName
      pdActualHours
      pdAllowedHours
      dockActualHours
      dockAllowedHours
      totalActualHours
      totalAllowedHours
      efficiencyPct
      status
    }
  }
}
    ${CostInputEstimatedMonthFragmentDoc}`;
export const WeightBreakReportDocument = gql`
    query WeightBreakReport($args: WeightBreakArgs!) {
  weightBreakReport(args: $args) {
    __typename
    totalShipmentCount
    totalRevenueUsd
    totalVariableCostUsd
    totalContributionDollarsUsd
    overallVarCostPctOfRevenue
    overallContributionRatio
    overallContributionPerShipmentUsd
    sweetSpotLabel
    upsideDownFromLabel
    hasCostAssumptions
    costBasis
    estimatedCostInputs {
      ...CostInputEstimatedMonth
    }
    missingCostInputs
    brackets {
      __typename
      label
      minLbs
      maxLbs
      shipmentCount
      revenueUsd
      variableCostUsd
      contributionDollarsUsd
      contributionRatio
      varCostPctOfRevenue
      revenuePerShipmentUsd
      variableCostPerShipmentUsd
      contributionPerShipmentUsd
      status
    }
  }
}
    ${CostInputEstimatedMonthFragmentDoc}`;
export const DeleteInventoryCountDocument = gql`
    mutation deleteInventoryCount($deleteInventoryCountInput: DeleteInventoryCountInput!) {
  deleteInventoryCount(deleteInventoryCountInput: $deleteInventoryCountInput) {
    __typename
    ... on DeletedInventoryCountOutput {
      uuid
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const InventoryCountDocument = gql`
    query inventoryCount($findInventoryCountInput: FindInventoryCountInput!) {
  inventoryCount(findInventoryCountInput: $findInventoryCountInput) {
    inventoryCount {
      ...InventoryCountHeader
    }
    lineConnection {
      edges {
        cursor
        node {
          ...InventoryCountLine
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${InventoryCountHeaderFragmentDoc}
${InventoryCountLineFragmentDoc}`;
export const InventoryCountsDocument = gql`
    query inventoryCounts($findInventoryCountsInput: FindInventoryCountsInput!) {
  inventoryCounts(findInventoryCountsInput: $findInventoryCountsInput) {
    inventoryCountConnection {
      totalCount
      edges {
        cursor
        node {
          ...InventoryCountHeader
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${InventoryCountHeaderFragmentDoc}`;
export const CreateDwellTimeAlertConfigDocument = gql`
    mutation createDwellTimeAlertConfig($createDwellTimeAlertConfigInput: CreateDwellTimeAlertConfigInput!) {
  createDwellTimeAlertConfig(
    createDwellTimeAlertConfigInput: $createDwellTimeAlertConfigInput
  ) {
    ...DwellTimeAlertConfig
  }
}
    ${DwellTimeAlertConfigFragmentDoc}`;
export const DeleteDwellTimeAlertConfigDocument = gql`
    mutation deleteDwellTimeAlertConfig($uuid: String!) {
  deleteDwellTimeAlertConfig(uuid: $uuid)
}
    `;
export const DwellTimeAlertConfigsDocument = gql`
    query dwellTimeAlertConfigs {
  dwellTimeAlertConfigs {
    ...DwellTimeAlertConfig
  }
}
    ${DwellTimeAlertConfigFragmentDoc}`;
export const UpdateDwellTimeAlertConfigDocument = gql`
    mutation updateDwellTimeAlertConfig($updateDwellTimeAlertConfigInput: UpdateDwellTimeAlertConfigInput!) {
  updateDwellTimeAlertConfig(
    updateDwellTimeAlertConfigInput: $updateDwellTimeAlertConfigInput
  ) {
    ...DwellTimeAlertConfig
  }
}
    ${DwellTimeAlertConfigFragmentDoc}`;
export const OrdersForPackingSlipDocument = gql`
    query ordersForPackingSlip($searchText: String, $billingPartyContactUuidsFilter: StringsFilter) {
  orders(
    first: 10
    searchText: $searchText
    billingPartyContactUuidsFilter: $billingPartyContactUuidsFilter
  ) {
    edges {
      node {
        ...OrderForPackingSlip
      }
    }
  }
}
    ${OrderForPackingSlipFragmentDoc}`;
export const PicklistsDocument = gql`
    query picklists($picklistsInput: PicklistsInput!) {
  picklists(picklistsInput: $picklistsInput) {
    edges {
      node {
        ...Picklists
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${PicklistsFragmentDoc}`;
export const CompanyStatsQueryDocument = gql`
    query companyStatsQuery {
  me {
    company {
      uuid
      companyStatistics {
        numberOfOrdersDueInFuture
        numberOfUninvoicedOrdersDueInFuture
        numberOfOrdersSixtyOneToNinety
        numberOfOrdersThirtyOneToSixty
        numberOfOrdersOneToThirty
        numberOfUninvoicedOrdersSixtyOneToNinety
        numberOfUninvoicedOrdersThirtyOneToSixty
        numberOfUninvoicedOrdersOneToThirty
        numberOfOrdersPastNinetyOne
        numberOfUninvoicedOrdersPastNinetyOne
      }
    }
  }
}
    `;
export const ConsolidatableOrderSummaryDocument = gql`
    query consolidatableOrderSummary($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...ConsolidatableOrderSummary
  }
}
    ${ConsolidatableOrderSummaryFragmentDoc}`;
export const CreateConsolidatedOrderFromOrderDocument = gql`
    mutation createConsolidatedOrderFromOrder($createConsolidatedOrderFromOrderInput: CreateConsolidatedOrderFromOrderInput!) {
  createConsolidatedOrderFromOrder(
    createConsolidatedOrderFromOrderInput: $createConsolidatedOrderFromOrderInput
  ) {
    uuid
  }
}
    `;
export const CreateConsolidatedOrderDocument = gql`
    mutation createConsolidatedOrder($createConsolidatedOrderInput: CreateConsolidatedOrderInput!) {
  createConsolidatedOrder(
    createConsolidatedOrderInput: $createConsolidatedOrderInput
  ) {
    uuid
    shipments {
      uuid
    }
  }
}
    `;
export const CurrentBillingPeriodInvoiceDocument = gql`
    query currentBillingPeriodInvoice($contactUuid: String!) {
  currentBillingPeriodInvoice(contactUuid: $contactUuid) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export const HandleMultipleInvoices210OutboundDocument = gql`
    mutation handleMultipleInvoices210Outbound($handleMultiple210OutboundInput: HandleMultiple210OutboundInput!) {
  handleMultipleInvoices210Outbound(
    handleMultiple210OutboundInput: $handleMultiple210OutboundInput
  )
}
    `;
export const InvoicesDocument = gql`
    query invoices($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String, $sortByDueDateAscending: Boolean, $sortByDueDateDescending: Boolean, $groupByContact: Boolean) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    sortByDueDateAscending: $sortByDueDateAscending
    sortByDueDateDescending: $sortByDueDateDescending
    groupByContact: $groupByContact
  ) {
    edges {
      node {
        ...InvoiceFragment
        uuid
        qbInvoiceNumber
        name
        status
        createdAt
        invoiceTerms {
          terms
        }
        shipments {
          uuid
          totalChargesAmount
          status
          name
          hasFailedStop
          order {
            uuid
            name
            secondaryRefNumber
            standardOrderFields {
              shipperBillOfLadingNumber
            }
          }
          legs {
            endStop {
              completedAt
            }
          }
          standardShipmentFields {
            pickupOrDelivery
            deliveryDate
            dimFactor
          }
          documents {
            ...Document
          }
          packages {
            uuid
            weight
            description
            quantity
            length
            width
            height
            type
          }
          freightCharge {
            uuid
            billingMethod
            tariff {
              uuid
              billingPartyContactUuid
              tariffOverageRates {
                uuid
                name
                type
                rateUsdCents
                applicableAboveAmount
              }
            }
            rate
            description
            quantity
            fuelCharge {
              description
              type
              flatRate
              surchargeRate
              uuid
              freightCharge {
                uuid
              }
            }
          }
          customCharges {
            uuid
            name
            zoneBasedAccessorialZoneUuid
            zoneBasedAccessorialChargeGroupUuid
            specialAccessorialTariffZoneUuid
            specialAccessorialChargeGroupUuid
            quantity
            description
            rate
            customChargeBillingMethod: billingMethod
            accessorialTemplate {
              uuid
              name
              percentForSettlement
            }
          }
        }
        inConsolidatedInvoice
        invoiceTotal
        dueDate
        billToContact {
          uuid
          displayName
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${InvoiceFragmentFragmentDoc}
${DocumentFragmentDoc}`;
export const MarkConsolidatableOrdersAsBilledIndividuallyDocument = gql`
    mutation markConsolidatableOrdersAsBilledIndividually($markConsolidatableOrdersAsBilledIndividuallyInput: MarkConsolidatableOrdersAsBilledIndividuallyInput!) {
  markConsolidatableOrdersAsBilledIndividually(
    markConsolidatableOrdersAsBilledIndividuallyInput: $markConsolidatableOrdersAsBilledIndividuallyInput
  ) {
    uuid
    shouldBillIndividually
  }
}
    `;
export const OutstandingOrdersForReviewDocument = gql`
    query outstandingOrdersForReview($first: Int, $after: String, $last: Int, $before: String, $isFinalized: Boolean, $hasIssues: Boolean, $isUnfinalized: Boolean, $isCancelled: Boolean, $contactUuid: String, $billingPartyContactUuids: [String!], $originTerminalUuid: String, $destinationTerminalUuid: String, $searchText: String, $uuids: [String!]!, $orderCompletionStartDate: DateTime, $orderCompletionEndDate: DateTime, $multipleSearches: [String!], $includeUuids: Boolean, $sorts: [OrderSort!]) {
  outstandingOrdersForReview(
    first: $first
    after: $after
    before: $before
    last: $last
    isFinalized: $isFinalized
    hasIssues: $hasIssues
    isUnfinalized: $isUnfinalized
    isCancelled: $isCancelled
    contactUuid: $contactUuid
    billingPartyContactUuids: $billingPartyContactUuids
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
    searchText: $searchText
    uuids: $uuids
    orderCompletionStartDate: $orderCompletionStartDate
    orderCompletionEndDate: $orderCompletionEndDate
    multipleSearches: $multipleSearches
    includeUuids: $includeUuids
    sorts: $sorts
  ) {
    totalCount
    uuids
    edges {
      node {
        totalCharge
        ...OutstandingOrderFragment
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OutstandingOrderFragmentFragmentDoc}`;
export const OutstandingShipmentDocument = gql`
    query outstandingShipment($uuid: String!) {
  shipment(uuid: $uuid) {
    ...OutstandingShipment
  }
}
    ${OutstandingShipmentFragmentDoc}`;
export const ShallowInvoicesDocument = gql`
    query shallowInvoices($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String, $sortByDueDateAscending: Boolean, $sortByDueDateDescending: Boolean, $groupByContact: Boolean) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    sortByDueDateAscending: $sortByDueDateAscending
    sortByDueDateDescending: $sortByDueDateDescending
    groupByContact: $groupByContact
  ) {
    totalCount
    edges {
      node {
        uuid
        qbInvoiceNumber
        quickbooksInvoiceId
        lastSyncedToQuickbooksAt
        name
        createdAt
        invoiceTerms {
          terms
        }
        invoiceTotal
        status
        inConsolidatedInvoice
        dueDate
        billToContact {
          uuid
          displayName
        }
        firstShipment {
          order {
            ediTransactions {
              status
              code
            }
          }
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const UnconsolidateOrderDocument = gql`
    mutation unconsolidateOrder($unconsolidateOrderInput: UnconsolidateOrderInput!) {
  unconsolidateOrder(unconsolidateOrderInput: $unconsolidateOrderInput) {
    uuid
    order {
      uuid
    }
  }
}
    `;
export const UpdateOrderShipperBillOfLadingNumberDocument = gql`
    mutation updateOrderShipperBillOfLadingNumber($updateStandardOrderInput: UpdateStandardOrderInput!) {
  updateStandardOrder(updateStandardOrderInput: $updateStandardOrderInput) {
    uuid
  }
}
    `;
export const WmsContactsDocument = gql`
    query wmsContacts($companyUuid: String) {
  wmsContacts(companyUuid: $companyUuid) {
    uuid
    displayName
    company {
      uuid
      name
    }
  }
}
    `;
export const CreateInvoiceDocument = gql`
    mutation createInvoice($createInvoiceInput: CreateInvoiceInput!) {
  createInvoice(createInvoiceInput: $createInvoiceInput) {
    uuid
  }
}
    `;
export const FinalizeInvoicesDocument = gql`
    mutation finalizeInvoices($finalizeInvoicesInput: FinalizeInvoicesInput!) {
  finalizeInvoices(finalizeInvoicesInput: $finalizeInvoicesInput) {
    count
  }
}
    `;
export const DocumentsByInvoiceDocument = gql`
    query documentsByInvoice($invoiceUuid: String!) {
  invoiceDocuments(invoiceUuid: $invoiceUuid) {
    uuid
    fileName
    bucket
    region
    fileName
    key
  }
}
    `;
export const InvoiceDocument = gql`
    query invoice($uuid: String!) {
  invoice(uuid: $uuid) {
    ...InvoiceFragment
    uuid
    notes
    name
    createdAt
    dueDate
    status
    invoiceTotal
    invoiceTerms {
      uuid
      terms
    }
    billToContact {
      uuid
      displayName
      defaultAddress {
        uuid
      }
      addresses {
        uuid
      }
      contactPersons {
        uuid
      }
    }
    dueDate
    documents {
      ...Document
    }
    shipments {
      ...InvoiceShipmentFragment
      hasSignedPOD
    }
  }
}
    ${InvoiceFragmentFragmentDoc}
${DocumentFragmentDoc}
${InvoiceShipmentFragmentFragmentDoc}`;
export const UpdateInvoiceLimitedDocument = gql`
    mutation updateInvoiceLimited($updateInvoiceLimitedInput: InvoiceUpdateLimitedInput!) {
  updateInvoiceLimited(updateInvoiceLimitedInput: $updateInvoiceLimitedInput) {
    uuid
  }
}
    `;
export const AddOrdersToInvoicesDocument = gql`
    mutation addOrdersToInvoices($input: AddOrdersToInvoicesInput!) {
  addOrdersToInvoices(input: $input) {
    __typename
    ... on AddOrdersToInvoicesSuccessOutput {
      success
      invoicesAddedToByContact {
        __typename
        ... on AddOrdersToInvoicesForContactSuccessOutput {
          success
          contactName
          contactUuid
          existingInvoiceAdds {
            __typename
            ... on AddOrdersToInvoiceSuccessOutput {
              success
              invoiceName
              invoiceUuid
              ordersAdded {
                orderUuid
                orderName
              }
            }
            ... on AddOrdersToExistingInvoiceErrorOutput {
              success
              invoiceName
              invoiceUuid
              attemptedOrdersToAdd {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
          newInvoiceAdds {
            __typename
            ... on AddOrdersToInvoiceSuccessOutput {
              success
              invoiceName
              invoiceUuid
              ordersAdded {
                orderUuid
                orderName
              }
            }
            ... on AddOrdersToNewInvoiceErrorOutput {
              success
              createdInvoiceName
              attemptedOrdersToAdd {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
        }
        ... on AddOrdersToInvoicesForContactErrorOutput {
          success
          contactName
          contactUuid
          proposedUpdatesToExistingInvoices {
            ... on ExistingInvoiceToUpdate {
              name
              invoiceUuid
              ordersToAdd {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
          proposedNewInvoicesToCreate {
            ... on NewInvoiceToCreate {
              name
              ordersToAdd {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
        }
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const PreviewAddOrdersToInvoicesDocument = gql`
    query previewAddOrdersToInvoices($previewAddOrdersToInvoicesInput: PreviewAddOrdersToInvoicesInput!) {
  previewAddOrdersToInvoices(
    previewAddOrdersToInvoicesInput: $previewAddOrdersToInvoicesInput
  ) {
    invoicesToAddToByContact {
      ... on PreviewAddOrdersToInvoicesForContactOutput {
        contactUuid
        contactName
        existingInvoicesToUpdate {
          ... on ExistingInvoiceToUpdate {
            name
            invoiceUuid
            ordersToAdd {
              ... on OrderToAddToInvoice {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
        }
        newInvoicesToCreate {
          ... on NewInvoiceToCreate {
            name
            ordersToAdd {
              ... on OrderToAddToInvoice {
                orderUuid
                orderName
                shipmentUuids
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const ContactsForDunningQueryDocument = gql`
    query contactsForDunningQuery($uuids: [String!]!) {
  contactsByUuids(uuids: $uuids) {
    ...ShallowContact
    defaultAddress {
      name
      line1
      line2
      city
      state
      zip
      country
    }
    overdueInvoices {
      ...InvoiceForDunningReport
    }
    company {
      customDunningReportHeader
      customDunningReportFooter
    }
  }
}
    ${ShallowContactFragmentDoc}
${InvoiceForDunningReportFragmentDoc}`;
export const DunningReportPdfDocument = gql`
    query dunningReportPdf($dunningReportInput: DunningReportInput!) {
  dunningReportPdf(dunningReportInput: $dunningReportInput) {
    url
    fileName
    errors
  }
}
    `;
export const GlCodeReportPdfDocument = gql`
    query glCodeReportPdf($glCodeReportPdfInput: GLCodeReportPdfInput!) {
  glCodeReportPdf(glCodeReportPdfInput: $glCodeReportPdfInput) {
    url
    fileName
    errors
  }
}
    `;
export const InvoiceEdiTransactionsDocument = gql`
    query invoiceEdiTransactions($findInvoiceEdiTransactionsInput: FindInvoiceEdiTransactionsInput!) {
  invoiceEdiTransactions(
    findInvoiceEdiTransactionsInput: $findInvoiceEdiTransactionsInput
  ) {
    ediTransactionConnection {
      edges {
        node {
          ...InvoiceEdiTransaction
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
}
    ${InvoiceEdiTransactionFragmentDoc}`;
export const InvoiceEmailSendStatusDocument = gql`
    query invoiceEmailSendStatus($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    uuid
    emailSendStatus: transmissionSendStatus
  }
}
    `;
export const InvoiceRegisterReportCsvDocument = gql`
    query invoiceRegisterReportCsv($invoiceRegisterReportInput: InvoiceRegisterReportInput!) {
  invoiceRegisterReportCsv(
    invoiceRegisterReportInput: $invoiceRegisterReportInput
  ) {
    url
    fileName
    errors
  }
}
    `;
export const InvoiceRegisterReportPdfDocument = gql`
    query invoiceRegisterReportPdf($invoiceRegisterReportInput: InvoiceRegisterReportInput!) {
  invoiceRegisterReportPdf(
    invoiceRegisterReportInput: $invoiceRegisterReportInput
  ) {
    url
    fileName
    errors
  }
}
    `;
export const OnTimePerformanceReportCsvDocument = gql`
    query onTimePerformanceReportCsv($input: OnTimePerformanceReportInput!) {
  onTimePerformanceReportCsv(onTimePerformanceReportInput: $input) {
    __typename
    url
    fileName
    errors
  }
}
    `;
export const OnTimePerformanceReportPdfDocument = gql`
    query onTimePerformanceReportPdf($input: OnTimePerformanceReportInput!) {
  onTimePerformanceReportPdf(onTimePerformanceReportInput: $input) {
    __typename
    url
    fileName
    errors
  }
}
    `;
export const SageBusinessWorksInvoiceExportCsvDocument = gql`
    query sageBusinessWorksInvoiceExportCsv($invoiceUuids: [String!]!) {
  sageBusinessWorksInvoiceExportCsv(invoiceUuids: $invoiceUuids) {
    url
    fileName
    errors
  }
}
    `;
export const InvoiceShipmentWithChargesByUuidDocument = gql`
    query invoiceShipmentWithChargesByUuid($uuid: String!) {
  shipment(uuid: $uuid) {
    ...InvoiceShipmentWithCharges
  }
}
    ${InvoiceShipmentWithChargesFragmentDoc}`;
export const OverdueInvoicesDocument = gql`
    query overdueInvoices($contactUuid: String!) {
  overdueInvoices(contactUuid: $contactUuid) {
    name
    dueDate
    date
    journalNumber
    totalNumber
    balanceInCents
  }
}
    `;
export const ShipmentsByContactUuidDocument = gql`
    query shipmentsByContactUuid($contactUuid: String, $startCompletedDate: DateTime, $endCompletedDate: DateTime) {
  shipmentsByContactUuid(
    contactUuid: $contactUuid
    startCompletedDate: $startCompletedDate
    endCompletedDate: $endCompletedDate
  ) {
    uuid
  }
}
    `;
export const BatchAddShipmentsToInvoicesMultipleDocument = gql`
    mutation batchAddShipmentsToInvoicesMultiple($batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple!) {
  batchAddShipmentsToInvoicesMultiple(
    batchAddShipmentsToInvoicesInputMultiple: $batchAddShipmentsToInvoicesInputMultiple
  ) {
    ...BatchAddShipmentsToInvoicesResultInvoice
  }
}
    ${BatchAddShipmentsToInvoicesResultInvoiceFragmentDoc}`;
export const CheckConsistencyOfInvoicesDocument = gql`
    query CheckConsistencyOfInvoices($checkConsistencyOfInvoicesInput: CheckConsistencyOfInvoicesInput!) {
  checkConsistencyOfInvoices(
    checkConsistencyOfInvoicesInput: $checkConsistencyOfInvoicesInput
  )
}
    `;
export const CreateProratedConsolidatedOrderDocument = gql`
    mutation createProratedConsolidatedOrder($input: CreateProratedConsolidatedOrderInput!) {
  createProratedConsolidatedOrder(createProratedConsolidatedOrderInput: $input) {
    orders {
      uuid
    }
    consolidatedOrderUuid
    errorMessage
  }
}
    `;
export const OrderInConsolidationFlowDocument = gql`
    query orderInConsolidationFlow($uuid: String!) {
  standardOrder(uuid: $uuid) {
    ...OrderForConsolidationFlow
  }
}
    ${OrderForConsolidationFlowFragmentDoc}`;
export const PreviewProratedConsolidationV2Document = gql`
    query previewProratedConsolidationV2($previewProratedConsolidationV2Input: PreviewProratedConsolidationV2Input!) {
  previewProratedConsolidationV2(
    previewProratedConsolidationV2Input: $previewProratedConsolidationV2Input
  ) {
    __typename
    ... on PreviewProratedConsolidationV2SuccessOutput {
      proratedOrders {
        ...ProratedOrderV2
      }
      totalAfterProrating
      consolidationMethod
      totalWeightConsolidated
      proratedOverview {
        inboundFreightCharge {
          ...SimpleFreightCharge
        }
        outboundFreightCharge {
          ...SimpleFreightCharge
        }
        inboundFuelCharge {
          ...SimpleFuelCharge
        }
        outboundFuelCharge {
          ...SimpleFuelCharge
        }
        customCharges {
          ...SimpleCustomCharge
        }
      }
    }
    ... on QueryErrorOutput {
      message
    }
  }
}
    ${ProratedOrderV2FragmentDoc}
${SimpleFreightChargeFragmentDoc}
${SimpleFuelChargeFragmentDoc}
${SimpleCustomChargeFragmentDoc}`;
export const PreviewProratedConsolidationDocument = gql`
    query previewProratedConsolidation($previewProratedConsolidationInput: PreviewProratedConsolidationInput!) {
  previewProratedConsolidation(
    previewProratedConsolidationInput: $previewProratedConsolidationInput
  ) {
    proratedOrders {
      ...ProratedOrder
    }
  }
}
    ${ProratedOrderFragmentDoc}`;
export const ProrateOrdersDocument = gql`
    mutation prorateOrders($input: ProrateOrdersInput!) {
  prorateOrders(prorateOrdersInput: $input) {
    __typename
    ... on ProrateOrdersSuccessOutput {
      orderUuids
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const TypeaheadOrderUuidsQueryForConsolidationFlowDocument = gql`
    query typeaheadOrderUuidsQueryForConsolidationFlow($billingPartyContactUuidFilter: StringFilter, $statusFilters: [StatusFilter!], $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $onInvoice: BooleanFilter, $versionId: Float, $includeOrdersPartOfV2ConsolidatedOrdersFilter: BooleanFilterV2) {
  orders(
    first: $first
    last: $last
    after: $after
    before: $before
    billingPartyContactUuidFilter: $billingPartyContactUuidFilter
    onInvoice: $onInvoice
    searchText: $searchText
    statusFilters: $statusFilters
    versionId: $versionId
    includeOrdersPartOfV2ConsolidatedOrdersFilter: $includeOrdersPartOfV2ConsolidatedOrdersFilter
  ) {
    versionId
    edges {
      node {
        ...OrderForConsolidationFlow
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OrderForConsolidationFlowFragmentDoc}`;
export const ContactsForInvoicesDocument = gql`
    query contactsForInvoices($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $sortByContactName: Boolean, $excludeNonActive: Boolean) {
  paginatedContacts(
    first: $first
    after: $after
    before: $before
    last: $last
    searchText: $searchText
    sortByContactName: $sortByContactName
    excludeNonActive: $excludeNonActive
  ) {
    edges {
      node {
        ...ContactForInvoice
      }
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ContactForInvoiceFragmentDoc}`;
export const CreateContactDocumentDocument = gql`
    mutation createContactDocument($createContactDocumentInput: CreateContactDocumentInput!) {
  createContactDocument(createContactDocumentInput: $createContactDocumentInput) {
    uuid
  }
}
    `;
export const CreateInvoiceDocumentsDocument = gql`
    mutation createInvoiceDocuments($createInvoiceDocumentsInput: CreateInvoiceDocumentsInput!) {
  createInvoiceDocuments(
    createInvoiceDocumentsInput: $createInvoiceDocumentsInput
  ) {
    uuid
    bucket
    region
    region
    key
    fileName
    fileType
    type
    invoice {
      uuid
      billToContact {
        uuid
      }
    }
  }
}
    `;
export const DownloadInvoicesDocument = gql`
    mutation downloadInvoices($downloadInvoicesInput: DownloadInvoicesInput!) {
  downloadInvoices(downloadInvoicesInput: $downloadInvoicesInput) {
    combinedDocument {
      ...Document
    }
    zipDocument {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;
export const ExportInvoicesToQuickbooksDesktopDocument = gql`
    mutation exportInvoicesToQuickbooksDesktop($exportInvoicesToQuickbooksInput: ExportInvoicesToQuickbooksInput!) {
  exportInvoicesToQuickbooksDesktop(
    exportInvoicesToQuickbooksInput: $exportInvoicesToQuickbooksInput
  ) {
    invoice {
      id
      name
      amount
    }
    failedInvoiceUuid
    missingFreightChargeMappings
    missingFuelChargeMappings
    missingAccessorialMappings
    missingCustomerName
    missingCustomerUuid
    duplicateInvoiceError
    conductorUserFacingErrors
    success
  }
}
    `;
export const GenerateInvoicePreSignedPutUrlsDocument = gql`
    mutation generateInvoicePreSignedPutUrls($generateInvoicePreSignedPutUrlsInput: GenerateInvoicePreSignedPutUrlsInput!) {
  generateInvoicePreSignedPutUrls(
    generateInvoicePreSignedPutUrlsInput: $generateInvoicePreSignedPutUrlsInput
  ) {
    url
    invoiceUuid
  }
}
    `;
export const InvoiceExcelExportDataDocument = gql`
    query invoiceExcelExportData($invoiceUuids: [String!]!) {
  invoiceExcelExportData(invoiceUuids: $invoiceUuids) {
    invoiceUuid
    shipments {
      uuid
      totalCharge
      totalFreightCharge
      totalFuelCharge
      smc3FreightText
      customCharges {
        uuid
        total
      }
    }
  }
}
    `;
export const InvoiceGroupsDocument = gql`
    query invoiceGroups($groupBy: InvoiceTableGroupByInput!, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $invoiceNumberFilter: IntegerFilterV2, $billingPartyContactUuid: String, $isClosed: Boolean, $emailSendStatus: EmailSendStatus, $isSyncedToQuickbooks: Boolean, $isSyncedToQuickbooksDesktop: Boolean, $hasQuickbooksSyncFailure: Boolean, $quickbooksSyncFailureCodes: [String!]) {
  invoiceGroups(
    groupBy: $groupBy
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    invoiceNumberFilter: $invoiceNumberFilter
    billingPartyContactUuid: $billingPartyContactUuid
    isClosed: $isClosed
    emailSendStatus: $emailSendStatus
    isSyncedToQuickbooks: $isSyncedToQuickbooks
    isSyncedToQuickbooksDesktop: $isSyncedToQuickbooksDesktop
    hasQuickbooksSyncFailure: $hasQuickbooksSyncFailure
    quickbooksSyncFailureCodes: $quickbooksSyncFailureCodes
  ) {
    groupRows {
      key
      label
      count
    }
    hasMore
  }
}
    `;
export const AcknowledgeFailedInvoiceSendJobsDocument = gql`
    mutation acknowledgeFailedInvoiceSendJobs($invoiceSendJobBatchUuid: String!) {
  acknowledgeFailedInvoiceSendJobs(
    invoiceSendJobBatchUuid: $invoiceSendJobBatchUuid
  ) {
    uuid
  }
}
    `;
export const InvoiceSendJobBatchesDocument = gql`
    query invoiceSendJobBatches($first: Int, $after: String, $last: Int, $before: String, $sortByCreatedAtAsc: Boolean, $inProgress: Boolean, $hasFailures: Boolean, $createdAtDateFilters: [DateFilter!], $acknowledged: Boolean, $includeCount: Boolean!) {
  invoiceSendJobBatches(
    first: $first
    after: $after
    last: $last
    before: $before
    sortByCreatedAtAsc: $sortByCreatedAtAsc
    inProgress: $inProgress
    hasFailures: $hasFailures
    createdAtDateFilters: $createdAtDateFilters
    acknowledged: $acknowledged
    includeCount: $includeCount
  ) {
    totalCount @include(if: $includeCount)
    edges {
      node {
        ...InvoiceSendJobBatch
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${InvoiceSendJobBatchFragmentDoc}`;
export const InvoiceSendJobsShallowDocument = gql`
    query invoiceSendJobsShallow($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $invoiceSendJobBatchUuid: String!, $invoiceSendJobStatus: InvoiceSendJobStatus) {
  invoiceSendJobs(
    first: $first
    after: $after
    last: $last
    before: $before
    searchText: $searchText
    invoiceSendJobBatchUuid: $invoiceSendJobBatchUuid
    invoiceSendJobStatus: $invoiceSendJobStatus
  ) {
    totalCount
    edges {
      node {
        ...InvoiceSendJobShallow
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${InvoiceSendJobShallowFragmentDoc}`;
export const InvoiceSendJobsDocument = gql`
    query invoiceSendJobs($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $invoiceSendJobBatchUuid: String!, $invoiceSendJobStatus: InvoiceSendJobStatus) {
  invoiceSendJobs(
    first: $first
    after: $after
    last: $last
    before: $before
    searchText: $searchText
    invoiceSendJobBatchUuid: $invoiceSendJobBatchUuid
    invoiceSendJobStatus: $invoiceSendJobStatus
  ) {
    totalCount
    edges {
      node {
        ...InvoiceSendJob
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${InvoiceSendJobFragmentDoc}`;
export const InvoiceStatsByUuidsDocument = gql`
    query invoiceStatsByUuids($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...InvoiceStat
  }
}
    ${InvoiceStatFragmentDoc}`;
export const InvoiceTotalDocument = gql`
    query invoiceTotal($uuid: String!) {
  invoice(uuid: $uuid) {
    invoiceTotal
  }
}
    `;
export const InvoiceTotalsDocument = gql`
    query invoiceTotals($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...InvoiceStat
  }
}
    ${InvoiceStatFragmentDoc}`;
export const InvoiceUuidsForBatchPostDocument = gql`
    query invoiceUuidsForBatchPost($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $emailSendStatus: EmailSendStatus, $searchText: String, $billingPartyContactUuid: String, $sortByDueDateAscending: Boolean, $sortByDueDateDescending: Boolean, $groupByContact: Boolean, $uuids: [String!], $isClosed: Boolean, $isSyncedToQuickbooks: Boolean, $isSyncedToQuickbooksDesktop: Boolean) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    emailSendStatus: $emailSendStatus
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    sortByDueDateAscending: $sortByDueDateAscending
    sortByDueDateDescending: $sortByDueDateDescending
    groupByContact: $groupByContact
    uuids: $uuids
    isClosed: $isClosed
    isSyncedToQuickbooks: $isSyncedToQuickbooks
    isSyncedToQuickbooksDesktop: $isSyncedToQuickbooksDesktop
  ) {
    totalCount
    edges {
      node {
        uuid
        status
        hasAppliedPayments
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const InvoiceV2Document = gql`
    query invoiceV2($uuid: String!) {
  invoice(uuid: $uuid) {
    ...ShallowInvoiceWithoutShipments
  }
}
    ${ShallowInvoiceWithoutShipmentsFragmentDoc}`;
export const InvoicesByUuidsForDownloadDocument = gql`
    query invoicesByUuidsForDownload($uuids: [String!]!, $includeDocuments: Boolean!) {
  invoicesByUuids(uuids: $uuids, includeDocuments: $includeDocuments) {
    ...InvoiceForDownloadFragment
  }
}
    ${InvoiceForDownloadFragmentFragmentDoc}`;
export const InvoicesByUuidsDocument = gql`
    query invoicesByUuids($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export const InvoicesForContactDocument = gql`
    query invoicesForContact($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String, $groupByContact: Boolean, $uuids: [String!], $isClosed: Boolean, $emailSendStatus: EmailSendStatus, $hasZeroBalance: Boolean, $sorts: [FindInvoicesSort!]) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    groupByContact: $groupByContact
    uuids: $uuids
    isClosed: $isClosed
    emailSendStatus: $emailSendStatus
    hasZeroBalance: $hasZeroBalance
    sorts: $sorts
  ) {
    totalCount
    edges {
      node {
        ...InvoiceForContact
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${InvoiceForContactFragmentDoc}`;
export const InvoicesForInvoiceSelectionDocument = gql`
    query invoicesForInvoiceSelection($first: Int, $after: String, $last: Int, $before: String, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String) {
  invoices(
    first: $first
    after: $after
    before: $before
    last: $last
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
  ) {
    edges {
      node {
        ...InvoiceForInvoiceSelection
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${InvoiceForInvoiceSelectionFragmentDoc}`;
export const InvoicesForRegisterReportDocument = gql`
    query invoicesForRegisterReport($first: Int, $after: String, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $billingPartyContactUuid: String) {
  invoices(
    first: $first
    after: $after
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    billingPartyContactUuid: $billingPartyContactUuid
  ) {
    totalCount
    edges {
      node {
        ...InvoiceForRegisterReport
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${InvoiceForRegisterReportFragmentDoc}`;
export const InvoicesMetadataByUuidsDocument = gql`
    query invoicesMetadataByUuids($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    uuid
    name
    billToContact {
      uuid
      displayName
    }
    journalNumber
  }
}
    `;
export const InvoicesWithOrdersDocument = gql`
    query invoicesWithOrders($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $billingPartyContactUuid: String, $groupByContact: Boolean, $uuids: [String!], $isClosed: Boolean, $emailSendStatus: EmailSendStatus, $hasZeroBalance: Boolean, $sorts: [FindInvoicesSort!]) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    billingPartyContactUuid: $billingPartyContactUuid
    groupByContact: $groupByContact
    uuids: $uuids
    isClosed: $isClosed
    emailSendStatus: $emailSendStatus
    hasZeroBalance: $hasZeroBalance
    sorts: $sorts
  ) {
    totalCount
    edges {
      node {
        ...InvoiceForContact
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${InvoiceForContactFragmentDoc}`;
export const LinehaulRevenueReportDocument = gql`
    query linehaulRevenueReport($LineHaulRevenueReportInput: LineHaulRevenueReportInput!) {
  linehaulRevenueReport(LineHaulRevenueReportInput: $LineHaulRevenueReportInput) {
    url
    fileName
  }
}
    `;
export const ManuallySetInvoicesQbSyncStatusDocument = gql`
    mutation ManuallySetInvoicesQbSyncStatus($invoiceUuids: [String!]!, $synced: Boolean!) {
  manuallySetInvoicesQbSyncStatus(invoiceUuids: $invoiceUuids, synced: $synced)
}
    `;
export const MoveShipmentsBetweenInvoicesDocument = gql`
    mutation moveShipmentsBetweenInvoices($moveShipmentsBetweenInvoicesInput: MoveShipmentsBetweenInvoicesInput!) {
  moveShipmentsBetweenInvoices(
    moveShipmentsBetweenInvoicesInput: $moveShipmentsBetweenInvoicesInput
  ) {
    ... on MoveShipmentsBetweenInvoicesSuccessOutput {
      newInvoiceUuid
      movedShipmentUuids
    }
    ... on MoveShipmentsBetweenInvoicesIncompleteOperationOutput {
      inputShipmentUuids
      additionalShipmentUuidsToMove
      missingOrders {
        uuid
        name
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const MoveShipmentsToInvoiceDocument = gql`
    mutation moveShipmentsToInvoice($moveShipmentsToInvoiceInput: MoveShipmentsToInvoiceInput!) {
  moveShipmentsToInvoice(
    moveShipmentsToInvoiceInput: $moveShipmentsToInvoiceInput
  ) {
    errors
  }
}
    `;
export const NetSalesSummaryReportDocument = gql`
    query netSalesSummaryReport($netSalesSummaryReportInput: NetSalesSummaryReportInput!) {
  netSalesSummaryReport(netSalesSummaryReportInput: $netSalesSummaryReportInput) {
    contactRows {
      contactUuid
      contactName
      pieces
      weight
      dimWeight
      openInvoiesTotalInCents
      adjustmentsInCents
      netSalesInCents
    }
    reportTotal {
      contactUuid
      contactName
      pieces
      weight
      dimWeight
      openInvoiesTotalInCents
      adjustmentsInCents
      netSalesInCents
    }
  }
}
    `;
export const OrderRefSearchDocument = gql`
    query orderRefSearch($searchText: String!, $first: Int!) {
  orders(searchText: $searchText, first: $first, onInvoiceFilter: {eq: true}) {
    edges {
      node {
        uuid
        name
        standardOrderFields {
          shipperBillOfLadingNumber
        }
        invoice {
          uuid
          name
          journalNumber
          billToContact {
            uuid
            displayName
          }
        }
      }
    }
  }
}
    `;
export const PaginatedOrdersByInvoiceDocument = gql`
    query paginatedOrdersByInvoice($first: Int, $after: String, $last: Int, $before: String, $invoiceUuid: String!, $searchText: String, $sortByShipperBillOfLadingNumberAsc: Boolean, $sorts: [FindOrdersOnInvoiceSort!]) {
  paginatedOrdersByInvoice(
    first: $first
    after: $after
    last: $last
    before: $before
    invoiceUuid: $invoiceUuid
    searchText: $searchText
    sortByShipperBillOfLadingNumberAsc: $sortByShipperBillOfLadingNumberAsc
    sorts: $sorts
  ) {
    totalCount
    edges {
      node {
        ...InvoiceOrderWithShipments
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${InvoiceOrderWithShipmentsFragmentDoc}`;
export const AllInvoicesForPaymentApplicationDocument = gql`
    query allInvoicesForPaymentApplication($billingPartyContactUuid: String, $masterAccountUuid: String) {
  invoices(
    billingPartyContactUuid: $billingPartyContactUuid
    masterAccountUuid: $masterAccountUuid
  ) {
    edges {
      node {
        uuid
        name
        journalNumber
      }
    }
  }
}
    `;
export const ApplyDebitToPaymentDocument = gql`
    mutation applyDebitToPayment($input: ApplyDebitToPaymentInput!) {
  applyDebitToPayment(input: $input) {
    ...PaymentOffset
  }
}
    ${PaymentOffsetFragmentDoc}`;
export const AverageDaysToPayReportDocument = gql`
    query averageDaysToPayReport {
  averageDaysToPayReport {
    ...AverageDaysToPayReportData
  }
}
    ${AverageDaysToPayReportDataFragmentDoc}`;
export const ContactBalancesByOrderUuidDocument = gql`
    query contactBalancesByOrderUuid($uuid: String!) {
  order(uuid: $uuid) {
    uuid
    billingPartyContact {
      ...ContactWithBalances
    }
    standardOrderFields {
      shipperBillOfLadingNumber
    }
  }
}
    ${ContactWithBalancesFragmentDoc}`;
export const ContactBalancesDocument = gql`
    query contactBalances($uuid: String!) {
  contact(uuid: $uuid) {
    ...ContactWithBalances
  }
}
    ${ContactWithBalancesFragmentDoc}`;
export const CreatePaymentDocument = gql`
    mutation createPayment($createPaymentInput: CreatePaymentInput!) {
  createPayment(createPaymentInput: $createPaymentInput) {
    uuid
  }
}
    `;
export const DeletePaymentDocument = gql`
    mutation deletePayment($uuid: String!) {
  deletePayment(uuid: $uuid) {
    uuid
  }
}
    `;
export const OrderAmountsToPayForHawbDocument = gql`
    query orderAmountsToPayForHawb($hawb: String!, $contactUuid: String, $amountInCents: Float!) {
  orderAmountsToPayForHawb(
    hawb: $hawb
    contactUuid: $contactUuid
    amountInCents: $amountInCents
  ) {
    amountInCents
    orderUuid
    invoiceUuid
    hawb
    billToContactUuid
    billToContactDisplayName
    lineBalanceInCents
    orderTotalInCents
    currentBalanceInCents
  }
}
    `;
export const OrderAmountsToPayForInvoiceDocument = gql`
    query orderAmountsToPayForInvoice($invoiceUuids: [String!]!, $amountInCents: Float!) {
  orderAmountsToPayForInvoice(
    invoiceUuids: $invoiceUuids
    amountInCents: $amountInCents
  ) {
    amountInCents
    orderUuid
    invoiceUuid
    hawb
    billToContactUuid
    billToContactDisplayName
    lineBalanceInCents
    orderTotalInCents
    currentBalanceInCents
  }
}
    `;
export const OrdersByUuidsForPaymentStatsDocument = gql`
    query ordersByUuidsForPaymentStats($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    uuid
    invoice {
      balanceInCents
      invoiceTotal
    }
  }
}
    `;
export const OrdersForPaymentsDocument = gql`
    query ordersForPayments($contactUuid: String, $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $invoiceUuid: String, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $filterOutZeroBalance: Boolean, $currentPaymentUuid: String, $includeTotalCount: Boolean, $includeTotalCountsByInvoice: Boolean, $groupOrdersBy: GroupOrdersForPaymentsBy, $sorts: [OrdersForPaymentsSort!]) {
  ordersForPayments(
    contactUuid: $contactUuid
    first: $first
    last: $last
    after: $after
    before: $before
    searchText: $searchText
    invoiceUuid: $invoiceUuid
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    filterOutZeroBalance: $filterOutZeroBalance
    currentPaymentUuid: $currentPaymentUuid
    includeTotalCount: $includeTotalCount
    includeTotalCountsByInvoice: $includeTotalCountsByInvoice
    groupOrdersBy: $groupOrdersBy
    sorts: $sorts
  ) {
    totalCount
    groupedCountsByInvoice {
      groupUuid
      count
    }
    edges {
      node {
        ...OrdersForPayment
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OrdersForPaymentFragmentDoc}`;
export const OutstandingInvoicesForCustomerDocument = gql`
    query outstandingInvoicesForCustomer($contactUuid: String!) {
  outstandingInvoicesForCustomer(contactUuid: $contactUuid) {
    journalNumber
    name
  }
}
    `;
export const PaymentByUuidDocument = gql`
    query paymentByUuid($uuid: String!) {
  paymentByUuid(uuid: $uuid) {
    uuid
    amountInCents
    comment
    referenceNumber
    paymentType
    paymentRail
    date
    glTerminal {
      uuid
      name
    }
    creditType {
      uuid
      name
    }
    paymentToOrderMappings {
      amountInCents
      order {
        invoice {
          uuid
          billToContact {
            uuid
            displayName
          }
        }
        uuid
        standardOrderFields {
          shipperBillOfLadingNumber
        }
      }
    }
  }
}
    `;
export const PaymentCustomerScopeDocument = gql`
    query paymentCustomerScope($contactUuid: String!) {
  paymentCustomerScope(contactUuid: $contactUuid)
}
    `;
export const PaymentOffsetsForPaymentDocument = gql`
    query paymentOffsetsForPayment($uuid: String!) {
  paymentByUuid(uuid: $uuid) {
    ...PaymentOffsetParty
    paymentOffsets {
      ...PaymentOffset
    }
  }
}
    ${PaymentOffsetPartyFragmentDoc}
${PaymentOffsetFragmentDoc}`;
export const PaymentRefSearchDocument = gql`
    query paymentRefSearch($referenceNumber: String!, $first: Int!) {
  paymentsV2(
    args: {referenceNumber: {containsIgnoreCase: $referenceNumber}, first: $first, sorts: [{sortBy: date, sortDirection: DESC}]}
  ) {
    edges {
      node {
        uuid
        referenceNumber
        amountInCents
        date
        paymentType
        contact {
          uuid
          displayName
        }
      }
    }
  }
}
    `;
export const PaymentsByContactUuidDocument = gql`
    query paymentsByContactUuid($args: FindPaymentsV2Args!) {
  paymentsV2(args: $args) {
    edges {
      node {
        ...Payment
      }
      cursor
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${PaymentFragmentDoc}`;
export const PaymentsByInvoiceUuidDocument = gql`
    query paymentsByInvoiceUuid($uuid: String!) {
  paymentsByInvoiceUuid(uuid: $uuid) {
    ...PaymentForInvoice
  }
}
    ${PaymentForInvoiceFragmentDoc}`;
export const PaymentsForCheckRegisterReportOldDocument = gql`
    query paymentsForCheckRegisterReportOld($args: FindPaymentsV2Args!) {
  paymentsV2(args: $args) {
    edges {
      node {
        ...PaymentForReport
      }
      cursor
    }
  }
}
    ${PaymentForReportFragmentDoc}`;
export const PaymentsForCheckRegisterReportDocument = gql`
    query paymentsForCheckRegisterReport($args: FindPaymentsV2Args!) {
  checkRegisterReport(args: $args) {
    ...PaymentForCheckRegisterReport
  }
}
    ${PaymentForCheckRegisterReportFragmentDoc}`;
export const RemovePaymentOffsetDocument = gql`
    mutation removePaymentOffset($uuid: String!) {
  removePaymentOffset(uuid: $uuid) {
    ...PaymentOffset
  }
}
    ${PaymentOffsetFragmentDoc}`;
export const UnappliedPaymentsForOffsetDocument = gql`
    query unappliedPaymentsForOffset($args: FindPaymentsV2Args!) {
  paymentsV2(args: $args) {
    edges {
      node {
        ...PaymentOffsetParty
        contact {
          uuid
          displayName
        }
      }
    }
  }
}
    ${PaymentOffsetPartyFragmentDoc}`;
export const UpdatePaymentOffsetDocument = gql`
    mutation updatePaymentOffset($input: UpdatePaymentOffsetInput!) {
  updatePaymentOffset(input: $input) {
    ...PaymentOffset
  }
}
    ${PaymentOffsetFragmentDoc}`;
export const UpdatePaymentDocument = gql`
    mutation updatePayment($updatePaymentInput: UpdatePaymentInput!) {
  updatePayment(updatePaymentInput: $updatePaymentInput) {
    uuid
  }
}
    `;
export const PreviewBatchAddShipmentsToInvoicesMultipleDocument = gql`
    query previewBatchAddShipmentsToInvoicesMultiple($batchAddShipmentsToInvoicesInputMultiple: BatchAddShipmentsToInvoicesInputMultiple!) {
  previewBatchAddShipmentsToInvoicesMultiple(
    batchAddShipmentsToInvoicesInputMultiple: $batchAddShipmentsToInvoicesInputMultiple
  ) {
    ...BatchAddShipmentsToInvoicesPreview
  }
}
    ${BatchAddShipmentsToInvoicesPreviewFragmentDoc}`;
export const OutstandingOrderDocument = gql`
    query outstandingOrder($uuid: String!) {
  standardOrder(uuid: $uuid) {
    ...OutstandingOrderFragment
  }
}
    ${OutstandingOrderFragmentFragmentDoc}`;
export const AddQuickbooksDesktopCustomersDocument = gql`
    mutation addQuickbooksDesktopCustomers($contactUuids: [String!]!) {
  addQuickbooksDesktopCustomers(contactUuids: $contactUuids) {
    quickbooksDesktopObjects {
      id
      name
    }
    error
  }
}
    `;
export const GetInvoiceCsvsDocument = gql`
    query getInvoiceCsvs($getInvoiceCsvsInput: GetInvoiceCsvsInput!) {
  getInvoiceCsvs(getInvoiceCsvsInput: $getInvoiceCsvsInput) {
    errors
    csvItems
    missingCustomerMappings
    missingFreightChargeMappings
    missingFuelChargeMappings
    missingAccessorialMappings
  }
}
    `;
export const InvoicesByUuidsForQuickbooksDocument = gql`
    query invoicesByUuidsForQuickbooks($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...InvoiceForQuickbooks
  }
}
    ${InvoiceForQuickbooksFragmentDoc}`;
export const PlanQuickbooksSyncDocument = gql`
    query PlanQuickbooksSync($uuids: [String!]!, $options: QuickbooksSyncOptionsInput) {
  planQuickbooksSync(uuids: $uuids, options: $options) {
    connection {
      connected
      realmId
      quickbooksCompanyName
      bookCloseDate
      automatedSalesTaxEnabled
      element
    }
    clean {
      ...QuickbooksSyncInvoicePlan
    }
    needsReview {
      ...QuickbooksSyncInvoicePlan
    }
    blocked {
      ...QuickbooksSyncInvoicePlan
    }
    plannedCreates {
      ...QuickbooksSyncPlannedCreate
    }
    notFoundUuids
    plannedInvoiceCount
  }
}
    ${QuickbooksSyncInvoicePlanFragmentDoc}
${QuickbooksSyncPlannedCreateFragmentDoc}`;
export const SetAccessorialQboItemMappingDocument = gql`
    mutation SetAccessorialQboItemMapping($input: SetAccessorialQboItemMappingInput!) {
  setAccessorialQboItemMapping(input: $input) {
    ...AccessorialsTableRow
  }
}
    ${AccessorialsTableRowFragmentDoc}`;
export const CompleteRebillDocument = gql`
    mutation completeRebill($completeRebillInput: CompleteRebillInput!) {
  completeRebill(completeRebillInput: $completeRebillInput) {
    invoiceForRebill {
      uuid
      name
    }
  }
}
    `;
export const CreateDuplicateOrderForRebillDocument = gql`
    mutation createDuplicateOrderForRebill($input: CreateDuplicateOrderForRebillInput!) {
  createDuplicateOrderForRebill(createDuplicateOrderForRebillInput: $input) {
    duplicatedOrder {
      uuid
    }
  }
}
    `;
export const OrderForRebillDocument = gql`
    query orderForRebill($uuid: String!) {
  order(uuid: $uuid) {
    name
    totalCharge
    invoice {
      name
      billToContact {
        uuid
      }
    }
  }
}
    `;
export const RemoveInvoiceDocument = gql`
    mutation removeInvoice($uuid: String!) {
  removeInvoice(uuid: $uuid) {
    uuid
  }
}
    `;
export const RemoveShipmentsFromInvoiceDocument = gql`
    mutation removeShipmentsFromInvoice($removeShipmentsFromInvoiceInput: RemoveShipmentsFromInvoiceInput!) {
  removeShipmentsFromInvoice(
    removeShipmentsFromInvoiceInput: $removeShipmentsFromInvoiceInput
  ) {
    uuid
  }
}
    `;
export const AccessorialChargeDetailsReportDocument = gql`
    query accessorialChargeDetailsReport($args: AccessorialChargeDetailsReportArgs!) {
  accessorialChargeDetailsReport(args: $args) {
    ...AccessorialChargeDetailsData
  }
}
    ${AccessorialChargeDetailsDataFragmentDoc}`;
export const AccountsReceivableReportDocument = gql`
    query accountsReceivableReport($args: AccountsReceivableReportArgs!) {
  accountsReceivableReport(args: $args) {
    ...AccountsReceivableData
  }
}
    ${AccountsReceivableDataFragmentDoc}`;
export const AgingReportPdfDocument = gql`
    query agingReportPdf($args: InvoiceAgingReportArgs!) {
  agingReportPdf(args: $args) {
    url
    fileName
    errors
  }
}
    `;
export const AgingReportDocument = gql`
    query agingReport($args: InvoiceAgingReportArgs!) {
  agingReport(args: $args) {
    ...AgingReportData
  }
}
    ${AgingReportDataFragmentDoc}`;
export const ChargeBreakdownReportCsvDocument = gql`
    query chargeBreakdownReportCsv($input: ChargeBreakdownReportInput) {
  chargeBreakdownReportCsv(input: $input) {
    url
    fileName
    errors
  }
}
    `;
export const ChargeBreakdownReportPdfDocument = gql`
    query chargeBreakdownReportPdf($input: ChargeBreakdownReportInput) {
  chargeBreakdownReportPdf(input: $input) {
    url
    fileName
    errors
  }
}
    `;
export const PaymentForMemoReportDocument = gql`
    query paymentForMemoReport($uuid: String!) {
  paymentByUuid(uuid: $uuid) {
    ...PaymentForMemoReport
  }
}
    ${PaymentForMemoReportFragmentDoc}`;
export const DriverComplianceReportCsvDocument = gql`
    query driverComplianceReportCsv($driverComplianceReportInput: DriverComplianceReportInput!) {
  driverComplianceReportCsv(
    driverComplianceReportInput: $driverComplianceReportInput
  ) {
    fileName
    mimeType
    contentBase64
  }
}
    `;
export const DriverComplianceReportPdfDocument = gql`
    query driverComplianceReportPdf($driverComplianceReportInput: DriverComplianceReportInput!) {
  driverComplianceReportPdf(
    driverComplianceReportInput: $driverComplianceReportInput
  ) {
    fileName
    mimeType
    contentBase64
  }
}
    `;
export const DriverDailyLogReportCsvDocument = gql`
    query driverDailyLogReportCsv($driverDailyLogReportCsvInput: DriverDailyLogReportPdfInput!) {
  driverDailyLogReportCsv(
    driverDailyLogReportCsvInput: $driverDailyLogReportCsvInput
  ) {
    url
    fileName
    errors
  }
}
    `;
export const DriverDailyLogReportPdfDocument = gql`
    query driverDailyLogReportPdf($driverDailyLogReportPdfInput: DriverDailyLogReportPdfInput!) {
  driverDailyLogReportPdf(
    driverDailyLogReportPdfInput: $driverDailyLogReportPdfInput
  ) {
    url
    fileName
    errors
  }
}
    `;
export const EmailAccountingReportDocument = gql`
    mutation emailAccountingReport($emailAccountingReportInput: EmailAccountingReportInput!) {
  emailAccountingReport(emailAccountingReportInput: $emailAccountingReportInput) {
    status
  }
}
    `;
export const IncomeAnalysisReportV2Document = gql`
    query incomeAnalysisReportV2($args: IncomeAnalysisReportArgs!) {
  incomeAnalysisReportV2(args: $args) {
    customers {
      ...CustomerReportBucket
    }
    terminals {
      ...IncomeAnalysisTerminalBucket
    }
  }
}
    ${CustomerReportBucketFragmentDoc}
${IncomeAnalysisTerminalBucketFragmentDoc}`;
export const InvoiceBillingSummaryReportV2PdfUrlDocument = gql`
    query invoiceBillingSummaryReportV2PdfUrl($invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input!) {
  invoiceBillingSummaryReportV2PdfUrl(
    invoiceBillingSummaryV2Input: $invoiceBillingSummaryV2Input
  )
}
    `;
export const InvoiceBillingSummaryReportV2PdfDocument = gql`
    query invoiceBillingSummaryReportV2Pdf($invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input!) {
  invoiceBillingSummaryReportV2Pdf(
    invoiceBillingSummaryV2Input: $invoiceBillingSummaryV2Input
  ) {
    url
    fileName
  }
}
    `;
export const InvoiceBillingSummaryReportV2Document = gql`
    query invoiceBillingSummaryReportV2($invoiceBillingSummaryV2Input: InvoiceBillingSummaryV2Input!) {
  invoiceBillingSummaryReportV2(
    invoiceBillingSummaryV2Input: $invoiceBillingSummaryV2Input
  ) {
    ...InvoiceBillingSummaryReportV2
  }
}
    ${InvoiceBillingSummaryReportV2FragmentDoc}`;
export const OpenInvoiceReportDocument = gql`
    query openInvoiceReport($openInvoiceReportArgs: OpenInvoiceReportArgs!) {
  openInvoiceReport(openInvoiceReportArgs: $openInvoiceReportArgs) {
    ...InvoiceForOpenInvoiceReport
  }
}
    ${InvoiceForOpenInvoiceReportFragmentDoc}`;
export const InvoiceForOrderSummaryReportDocument = gql`
    query invoiceForOrderSummaryReport($uuid: String!) {
  invoice(uuid: $uuid) {
    ...InvoiceForOrderSummaryReport
  }
}
    ${InvoiceForOrderSummaryReportFragmentDoc}`;
export const InvoicesForOrderSummaryReportDocument = gql`
    query invoicesForOrderSummaryReport($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...InvoiceForOrderSummaryReport
  }
}
    ${InvoiceForOrderSummaryReportFragmentDoc}`;
export const PaymentApplicationReportDocument = gql`
    query paymentApplicationReport($args: FindPaymentsV2Args!) {
  paymentApplicationReport(args: $args) {
    ...PaymentForPaymentApplicationReport
  }
}
    ${PaymentForPaymentApplicationReportFragmentDoc}`;
export const PaymentsForJournalReportDocument = gql`
    query paymentsForJournalReport($args: FindPaymentsV2Args!) {
  paymentsV2(args: $args) {
    edges {
      node {
        ...PaymentForJournalReportOld
      }
      cursor
    }
  }
}
    ${PaymentForJournalReportOldFragmentDoc}`;
export const PaymentJournalReportDocument = gql`
    query paymentJournalReport($args: FindPaymentsV2Args!) {
  paymentJournalReport(args: $args) {
    ...PaymentForJournalReport
  }
}
    ${PaymentForJournalReportFragmentDoc}`;
export const PostedVsActualReportDocument = gql`
    query PostedVsActualReport {
  postedVsActualReport {
    invoiceUuid
    invoiceName
    invoiceJournalNumber
    invoiceDate
    orderUuid
    orderName
    postedAmountCents
    currentAmountCents
    discrepancyCents
    customerName
    customerReferenceNumber
    serviceDate
    completedDate
  }
}
    `;
export const UnappliedPaymentsReportDocument = gql`
    query unappliedPaymentsReport($input: UnappliedPaymentReportCsvInput!) {
  unappliedPaymentReportCsv(unappliedPaymentReportCsvInput: $input) {
    url
    fileName
    errors
  }
}
    `;
export const RetryAllFailedInvoice210OutboundsForCompanyDocument = gql`
    mutation retryAllFailedInvoice210OutboundsForCompany {
  retryAllFailedInvoice210OutboundsForCompany {
    queuedCount
    skippedCount
  }
}
    `;
export const RetryFailedInvoice210OutboundDocument = gql`
    mutation retryFailedInvoice210Outbound($invoiceUuid: String!) {
  retryFailedInvoice210Outbound(invoiceUuid: $invoiceUuid) {
    queuedCount
    skippedCount
  }
}
    `;
export const SalesVarianceReportCsvDocument = gql`
    query salesVarianceReportCsv($salesVarianceReportInput: SalesVarianceReportInput!) {
  salesVarianceReportCsv(salesVarianceReportInput: $salesVarianceReportInput) {
    url
    fileName
  }
}
    `;
export const SendInvoicesDocument = gql`
    mutation sendInvoices($sendInvoicesInput: SendInvoicesInput!) {
  sendInvoices(sendInvoicesInput: $sendInvoicesInput) {
    ...InvoiceSendJobBatch
  }
}
    ${InvoiceSendJobBatchFragmentDoc}`;
export const ShallowInvoicesByUuidsDocument = gql`
    query shallowInvoicesByUuids($uuids: [String!]!) {
  invoicesByUuids(uuids: $uuids) {
    ...ShallowInvoiceWithoutShipments
  }
}
    ${ShallowInvoiceWithoutShipmentsFragmentDoc}`;
export const InvoiceUuidsDocument = gql`
    query invoiceUuids($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $invoiceNumberFilter: IntegerFilterV2, $billingPartyContactUuid: String, $groupByContact: Boolean, $uuids: [String!], $isClosed: Boolean, $emailSendStatus: EmailSendStatus, $isSyncedToQuickbooks: Boolean, $isSyncedToQuickbooksDesktop: Boolean, $hasQuickbooksSyncFailure: Boolean, $quickbooksSyncFailureCodes: [String!], $sorts: [FindInvoicesSort!]) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    invoiceNumberFilter: $invoiceNumberFilter
    billingPartyContactUuid: $billingPartyContactUuid
    groupByContact: $groupByContact
    uuids: $uuids
    isClosed: $isClosed
    emailSendStatus: $emailSendStatus
    isSyncedToQuickbooks: $isSyncedToQuickbooks
    isSyncedToQuickbooksDesktop: $isSyncedToQuickbooksDesktop
    hasQuickbooksSyncFailure: $hasQuickbooksSyncFailure
    quickbooksSyncFailureCodes: $quickbooksSyncFailureCodes
    sorts: $sorts
  ) {
    totalCount
    edges {
      node {
        uuid
        status
        hasAppliedPayments
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;
export const ShallowInvoicesV2Document = gql`
    query shallowInvoicesV2($inConsolidatedInvoice: Boolean, $first: Int, $after: String, $last: Int, $before: String, $startDate: DateTime, $endDate: DateTime, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime, $invoiceStartDate: DateTime, $invoiceEndDate: DateTime, $statuses: [InvoiceStatus!], $searchText: String, $invoiceNumberFilter: IntegerFilterV2, $billingPartyContactUuid: String, $groupByContact: Boolean, $uuids: [String!], $isClosed: Boolean, $emailSendStatus: EmailSendStatus, $isSyncedToQuickbooks: Boolean, $isSyncedToQuickbooksDesktop: Boolean, $hasQuickbooksSyncFailure: Boolean, $quickbooksSyncFailureCodes: [String!], $sorts: [FindInvoicesSort!], $groupPath: [InvoiceTableGroupPathEntryInput!]) {
  invoices(
    inConsolidatedInvoice: $inConsolidatedInvoice
    first: $first
    after: $after
    before: $before
    last: $last
    startDate: $startDate
    endDate: $endDate
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
    invoiceStartDate: $invoiceStartDate
    invoiceEndDate: $invoiceEndDate
    statuses: $statuses
    searchText: $searchText
    invoiceNumberFilter: $invoiceNumberFilter
    billingPartyContactUuid: $billingPartyContactUuid
    groupByContact: $groupByContact
    uuids: $uuids
    isClosed: $isClosed
    emailSendStatus: $emailSendStatus
    isSyncedToQuickbooks: $isSyncedToQuickbooks
    isSyncedToQuickbooksDesktop: $isSyncedToQuickbooksDesktop
    hasQuickbooksSyncFailure: $hasQuickbooksSyncFailure
    quickbooksSyncFailureCodes: $quickbooksSyncFailureCodes
    sorts: $sorts
    groupPath: $groupPath
  ) {
    totalCount
    edges {
      node {
        ...ShallowInvoiceV2
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${ShallowInvoiceV2FragmentDoc}`;
export const SyncInvoiceStatusWithQuickbooksDocument = gql`
    mutation SyncInvoiceStatusWithQuickbooks($uuid: String!) {
  syncInvoiceStatusWithQuickbooks(uuid: $uuid) {
    uuid
    balanceInCents
    status
    lastSyncedFromQuickbooksAt
  }
}
    `;
export const SyncInvoicesToQuickbooksDocument = gql`
    mutation SyncInvoicesToQuickbooks($uuids: [String!]!, $options: QuickbooksSyncOptionsInput) {
  syncInvoicesToQuickbooks(uuids: $uuids, options: $options) {
    synced {
      ...QuickbooksSyncedInvoice
    }
    syncedWithNotices {
      invoice {
        ...QuickbooksSyncedInvoice
      }
      notices {
        ...QuickbooksSyncNotice
      }
    }
    failed {
      ...QuickbooksSyncFailure
    }
  }
}
    ${QuickbooksSyncedInvoiceFragmentDoc}
${QuickbooksSyncNoticeFragmentDoc}
${QuickbooksSyncFailureFragmentDoc}`;
export const TypeaheadOrderUuidsQueryDocument = gql`
    query typeaheadOrderUuidsQuery($addressCityFilter: StringFilter, $addressZipFilter: StringFilter, $attemptedAtDateFilters: DateFilterStartEnd, $completionDateFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $receivedDateFilters: DateFilterStartEnd, $createdAtDateFilters: DateFilterStartEnd, $expectedInboundArrivalDateFilters: DateFilterStartEnd, $scheduledAtDateFilters: DateFilterStartEnd, $primaryAppointmentDateFilters: DateFilterStartEnd, $orderNumberFilter: StringFilter, $billingPartyContactUuidFilter: StringFilter, $driverUuidFilter: StringFilter, $shipperFilter: StringFilter, $consigneeFilter: StringFilter, $statusFilters: [StatusFilter!], $shipmentStatusFilters: [ShipmentStatusFilter!], $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $multipleSearches: [String!], $scheduledFilter: BooleanFilter, $outForDeliveryFilter: BooleanFilter, $onHand: BooleanFilter, $onInvoice: BooleanFilter, $isCancelled: BooleanFilter, $isRefused: BooleanFilter, $isFinalized: BooleanFilter, $isPicked: BooleanFilter, $isOsd: BooleanFilter, $isSpecial: BooleanFilter, $orderSource: OrderSource, $noMaximum: Boolean, $hasAppointmentScheduled: BooleanFilter, $appointmentRequired: BooleanFilter, $hasContactInformation: BooleanFilter, $hasFailures: BooleanFilter, $hasRoute: BooleanFilter, $hideFromBilling: BooleanFilter, $paperworkComplete: BooleanFilter, $pickupOrDelivery: PickupOrDelivery, $isPickupOrDelivery: BooleanFilter, $inboundNotArrived: BooleanFilter, $requiresRouting: BooleanFilter, $requiresRecovery: BooleanFilter, $serviceUuids: [String!], $showConsolidatedOrders: BooleanFilter, $standardStopType: StandardStopType, $stopTypesFilter: StopTypesFilter, $tagUuids: [String!], $totalCount: Boolean, $transferPending: BooleanFilter, $uuids: [String!], $searchRefNumbersOnly: Boolean, $searchMiscInfoOnly: Boolean, $useMultiSearch: Boolean, $sortByCustomerNameAscending: Boolean, $versionId: Float) {
  orders(
    first: $first
    last: $last
    after: $after
    before: $before
    addressCityFilter: $addressCityFilter
    addressZipFilter: $addressZipFilter
    attemptedAtDateFilters: $attemptedAtDateFilters
    billingPartyContactUuidFilter: $billingPartyContactUuidFilter
    driverUuidFilter: $driverUuidFilter
    completionDateFilters: $completionDateFilters
    deadlineDateFilters: $deadlineDateFilters
    receivedDateFilters: $receivedDateFilters
    createdAtDateFilters: $createdAtDateFilters
    scheduledAtDateFilters: $scheduledAtDateFilters
    primaryAppointmentDateFilters: $primaryAppointmentDateFilters
    expectedInboundArrivalDateFilters: $expectedInboundArrivalDateFilters
    consigneeFilter: $consigneeFilter
    hasAppointmentScheduled: $hasAppointmentScheduled
    appointmentRequired: $appointmentRequired
    hasContactInformation: $hasContactInformation
    hasFailures: $hasFailures
    hasRoute: $hasRoute
    hideFromBilling: $hideFromBilling
    noMaximum: $noMaximum
    orderNumberFilter: $orderNumberFilter
    onHand: $onHand
    onInvoice: $onInvoice
    isCancelled: $isCancelled
    isRefused: $isRefused
    isFinalized: $isFinalized
    isPicked: $isPicked
    isOsd: $isOsd
    multipleSearches: $multipleSearches
    isSpecial: $isSpecial
    orderSource: $orderSource
    outForDeliveryFilter: $outForDeliveryFilter
    paperworkComplete: $paperworkComplete
    pickupOrDelivery: $pickupOrDelivery
    isPickupOrDelivery: $isPickupOrDelivery
    inboundNotArrived: $inboundNotArrived
    requiresRouting: $requiresRouting
    requiresRecovery: $requiresRecovery
    scheduledFilter: $scheduledFilter
    searchText: $searchText
    serviceUuids: $serviceUuids
    showConsolidatedOrders: $showConsolidatedOrders
    shipperFilter: $shipperFilter
    statusFilters: $statusFilters
    shipmentStatusFilters: $shipmentStatusFilters
    standardStopType: $standardStopType
    stopTypesFilter: $stopTypesFilter
    tagUuids: $tagUuids
    transferPending: $transferPending
    totalCount: $totalCount
    uuids: $uuids
    searchRefNumbersOnly: $searchRefNumbersOnly
    searchMiscInfoOnly: $searchMiscInfoOnly
    useMultiSearch: $useMultiSearch
    sortByCustomerNameAscending: $sortByCustomerNameAscending
    versionId: $versionId
  ) {
    versionId
    edges {
      node {
        ...TypeAheadOrder
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${TypeAheadOrderFragmentDoc}`;
export const OrderRevenueReportDocument = gql`
    query orderRevenueReport($orderRevenueReportInput: OrderRevenueReportInput!) {
  orderRevenueReport(orderRevenueReportInput: $orderRevenueReportInput) {
    edges {
      node {
        ...RevenueReportOrderData
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${RevenueReportOrderDataFragmentDoc}`;
export const UnpostInvoiceDocument = gql`
    mutation unpostInvoice($unpostInvoiceInput: UnpostInvoiceInput!) {
  unpostInvoice(unpostInvoiceInput: $unpostInvoiceInput) {
    success
  }
}
    `;
export const UnpostInvoicesDocument = gql`
    mutation UnpostInvoices($unpostInvoicesInput: UnpostInvoicesInput!) {
  unpostInvoices(unpostInvoicesInput: $unpostInvoicesInput) {
    ... on UnpostInvoicesSuccessOutput {
      unpostedUuids
      skippedWithPaymentsUuids
      failedUuids
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CreateItemDocument = gql`
    mutation createItem($input: CreateItemInput!) {
  createItem(createItemInput: $input) {
    item {
      ...ShallowItem
    }
    error
  }
}
    ${ShallowItemFragmentDoc}`;
export const ContactItemsDocument = gql`
    query contactItems($findContactItemsInput: FindContactItemsInput!) {
  contactItems(findContactItemsInput: $findContactItemsInput) {
    items {
      ...ContactItemsItem
    }
  }
}
    ${ContactItemsItemFragmentDoc}`;
export const ItemInventorySummaryDocument = gql`
    query itemInventorySummary($contactUuid: String, $warehouseUuid: String) {
  items(contactUuid: $contactUuid, warehouseUuid: $warehouseUuid) {
    edges {
      node {
        uuid
        sku
        description
        quantity
        storageUnitsCount
        contact {
          uuid
          displayName
        }
        warehouse {
          uuid
          name
        }
        storageOrders {
          uuid
          referenceNumber
        }
      }
    }
  }
}
    `;
export const ItemDocument = gql`
    query item($itemUuid: String!) {
  item(itemUuid: $itemUuid) {
    uuid
    sku
    description
    status
    contact {
      uuid
    }
    warehouse {
      uuid
      name
    }
    primaryUOM {
      uuid
      unitOfMeasure
      upcCode
    }
    secondaryUOM {
      uuid
      unitOfMeasure
      upcCode
      primaryUnitsPerSecondaryUOM
    }
    itemStorageUnitConfig {
      uuid
      type
      length
      width
      height
      weight
      consolidationUnitUOM
      primaryUnitsPerConsolidationUnit
      weightUOM
      dimensionsUOM
      tie
      high
    }
  }
}
    `;
export const ItemsBySkuNameDocument = gql`
    query itemsBySkuName($contactUuid: String, $sku: String!) {
  itemsBySkuName(contactUuid: $contactUuid, sku: $sku) {
    ...ShallowItem
  }
}
    ${ShallowItemFragmentDoc}`;
export const ShallowItemsDocument = gql`
    query shallowItems($contactUuid: String!, $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $warehouseUuid: String) {
  items(
    contactUuid: $contactUuid
    first: $first
    after: $after
    last: $last
    before: $before
    searchText: $searchText
    warehouseUuid: $warehouseUuid
  ) {
    edges {
      node {
        ...ShallowItem
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ShallowItemFragmentDoc}`;
export const UpdateItemDocument = gql`
    mutation updateItem($input: UpdateItemInput!) {
  updateItem(updateItemInput: $input) {
    ...ShallowItem
  }
}
    ${ShallowItemFragmentDoc}`;
export const GenerateLabelDocument = gql`
    mutation generateLabel($generateLabelInput: GenerateLabelInput!) {
  generateLabel(generateLabelInput: $generateLabelInput)
}
    `;
export const DispatchApplySuggestedManifestsDocument = gql`
    mutation DispatchApplySuggestedManifests($input: DispatchApplySuggestedManifestsInput!) {
  dispatchApplySuggestedManifests(input: $input) {
    results {
      manifestUuid
      manifestReferenceNumber
      created
      outcome
      orderUuids
      failedOrders {
        orderName
        reason
      }
      reason
    }
  }
}
    `;
export const DispatchManifestFreightCountsDocument = gql`
    query dispatchManifestFreightCounts($uuid: String!) {
  lineHaulManifest(uuid: $uuid) {
    uuid
    ordersOnManifest {
      orderUuid
      piecesAwayFromRunOrigin {
        runOriginTerminalCode
        totalPieceCount
        awayFromOriginPieceCount
        unaccountedPieceCount
        terminalCounts {
          terminalCode
          pieceCount
        }
      }
    }
  }
}
    `;
export const GroupOrdersDocument = gql`
    query GroupOrders($input: GroupOrdersInput!) {
  groupOrders(input: $input) {
    rows {
      __typename
      ... on OrderLaneGroupsOutput {
        groups {
          laneKey
          startTerminalCode
          endTerminalCode
          segmentCount
          pieceCount
          weightLbs
        }
        totalCount
        unreachableCorridors {
          originTerminalCode
          destinationTerminalCode
          originTerminalUuid
          destinationTerminalUuid
          orderCount
          orders {
            orderUuid
            orderName
            onHandTerminalCode
            pieceCount
            weightLbs
          }
        }
        omittedUnreachableCorridorCount
      }
      ... on OrderSegmentLeavesOutput {
        rows {
          segmentUuid
          orderUuid
          laneKey
          name
          status
          pieceCount
          weightLbs
          dimWeight
          originTerminalCode
          destinationTerminalCode
          finalDestinationTerminalCode
          finalDestinationTerminalUuid
          rerouteFromTerminalCode
          rerouteFromTerminalUuid
          orderOriginTerminalCode
          currentLocationCode
          currentLocationIsLive
          currentLocationPieceCount
          totalCountablePieceCount
          serviceDate
          outboundServiceDate
          customerName
          billOfLadingNumber
          mawb
          isSpecial
          pieceTerminalLocations
          piecesAwayFromRunOrigin {
            runOriginTerminalCode
            totalPieceCount
            awayFromOriginPieceCount
            unaccountedPieceCount
            terminalCounts {
              terminalCode
              pieceCount
            }
          }
          pieceStatusLocations {
            status
            terminalCode
            pieceCount
          }
          formattedValues {
            field
            value
          }
          lineHaulManifests {
            uuid
            referenceNumber
            startTerminalCode
            endTerminalCode
            status
            departDate
            estimatedArrival
            completedAt
          }
          segmentStartTerminalUuid
          segmentEndTerminalUuid
          currentManifestUuid
          currentManifestReferenceNumber
          currentManifestStatus
          currentManifestDepartDate
          isProposed
          routeNodeCodes
          routeNodeTerminalUuids
          routeLegs {
            startTerminalCode
            endTerminalCode
          }
          isPathLocked
          routeMissesOrigin
          routeMissesDestination
          alternativeRoutes {
            nodeCodes
            nodeTerminalUuids
          }
        }
        totalCount
      }
    }
  }
}
    `;
export const DispatchManifestPackageStatesDocument = gql`
    query DispatchManifestPackageStates($input: ManifestUuidsInput!) {
  calmManifestLoadPackages(input: $input) {
    packageUuid
    orderUuid
    pieces
    piecesOnHand
    piecesLoaded
    piecesDeparted
    piecesAtDestination
  }
}
    `;
export const DispatchManifestsInRangeDocument = gql`
    query DispatchManifestsInRange($fromDate: DateTime!, $toDate: DateTime!) {
  lineHaulManifests(fromDate: $fromDate, toDate: $toDate) {
    lineHaulManifests {
      ...DetailedLineHaulManifest
    }
    unmanifestedSegments {
      ...ShallowLineHaulSegment
    }
  }
}
    ${DetailedLineHaulManifestFragmentDoc}
${ShallowLineHaulSegmentFragmentDoc}`;
export const CalmOrderCubeByOrderUuidsDocument = gql`
    query CalmOrderCubeByOrderUuids($orderUuids: [String!]!) {
  calmOrderCubeByOrderUuids(input: {orderUuids: $orderUuids}) {
    orderUuid
    cubeFt3
    weightLbs
  }
}
    `;
export const DispatchPlacedLegLoadedPiecesDocument = gql`
    query DispatchPlacedLegLoadedPieces($input: ManifestUuidsInput!) {
  calmManifestLoadPackages(input: $input) {
    manifestUuid
    orderUuid
    piecesLoaded
  }
}
    `;
export const CalmPreviewLineHaulReroutesDocument = gql`
    query CalmPreviewLineHaulReroutes($input: PreviewLineHaulReroutesInput!) {
  calmPreviewLineHaulReroutes(input: $input) {
    orderUuid
    freightAtTerminalCode
    freightAtTerminalUuid
    travelledLegs {
      startCode
      endCode
      runReference
      arrived
    }
    runsToLeave {
      uuid
      referenceNumber
    }
    refusal
  }
}
    `;
export const CalmRepointOrderFreightDocument = gql`
    mutation calmRepointOrderFreight($input: RepointOrderFreightInput!) {
  calmRepointOrderFreight(input: $input) {
    unitsMoved
    unitsLeftBehind
    unitsMarkedShort
    packagesLeftPartiallyShort
  }
}
    `;
export const SetLineHaulManifestDepartTimeDocument = gql`
    mutation SetLineHaulManifestDepartTime($input: SetManifestDepartTimeInput!) {
  setLineHaulManifestDepartTime(input: $input) {
    uuid
    departTimeMinutes
    estimatedDeparture
    estimatedArrival
  }
}
    `;
export const SetLineHaulManifestTrailersDocument = gql`
    mutation SetLineHaulManifestTrailers($input: SetManifestTrailersInput!) {
  setLineHaulManifestTrailers(input: $input) {
    conflictWarning
  }
}
    `;
export const AddOrdersToManifestV2Document = gql`
    mutation addOrdersToManifestV2($addOrdersToManifestV2Input: AddOrdersToManifestV2Input!) {
  addOrdersToManifestV2(input: $addOrdersToManifestV2Input) {
    __typename
    ... on AddOrdersToManifestV2PreviousManifestErrorOutput {
      previousManifestErrors {
        order {
          name
          endStop {
            terminal {
              name
            }
          }
        }
      }
      originTerminalMismatchErrors {
        order {
          uuid
          name
        }
      }
      invalidMisroutedOverrideErrors {
        order {
          name
        }
      }
      routeDestinationMismatchErrors {
        order {
          name
        }
        manifest {
          endTerminal {
            code
          }
        }
      }
    }
    ... on AddOrdersToManifestV2SuccessOutput {
      lineHaulManifest {
        ...DetailedLineHaulManifest
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const AddOrdersToManifestDocument = gql`
    mutation addOrdersToManifest($addOrdersToManifestInput: AddOrdersToManifestInput!) {
  addOrdersToManifest(addOrdersToManifestInput: $addOrdersToManifestInput) {
    lineHaulManifest {
      ...DetailedLineHaulManifest
    }
    errorMessage
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const CreateLineHaulManifestDocument = gql`
    mutation createLineHaulManifest($createLineHaulManifestInput: CreateLineHaulManifestInput!) {
  createLineHaulManifest(
    createLineHaulManifestInput: $createLineHaulManifestInput
  ) {
    ...DetailedLineHaulManifest
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const CreateLineHaulManifestsDocument = gql`
    mutation createLineHaulManifests($input: CreateLineHaulManifestsInput!) {
  createLineHaulManifests(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on CreateLineHaulManifestsSuccessOutput {
      lineHaulManifests {
        uuid
      }
    }
  }
}
    `;
export const GetLineHaulProgressDocument = gql`
    query getLineHaulProgress($getLineHaulProgressInput: GetLineHaulProgressInput!) {
  getLineHaulProgress(getLineHaulProgressInput: $getLineHaulProgressInput) {
    terminalStatuses {
      ...TerminalLineHaulStatus
    }
  }
}
    ${TerminalLineHaulStatusFragmentDoc}`;
export const LineHaulManifestGroupsDocument = gql`
    query LineHaulManifestGroups($input: LineHaulManifestsGroupsInput!) {
  lineHaulManifestsGroups(input: $input) {
    category
    groups {
      category
      manifests {
        ...DetailedLineHaulManifest
      }
    }
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const LineHaulManifestDocument = gql`
    query lineHaulManifest($uuid: String!) {
  lineHaulManifest(uuid: $uuid) {
    ...DetailedLineHaulManifest
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const LineHaulManifestsForPrintDocument = gql`
    query lineHaulManifestsForPrint($date: DateTime!, $uuids: [String!]) {
  lineHaulManifests(date: $date, uuids: $uuids) {
    lineHaulManifests {
      ...LineHaulManifestForPrint
    }
  }
}
    ${LineHaulManifestForPrintFragmentDoc}`;
export const LineHaulManifestsDocument = gql`
    query lineHaulManifests($date: DateTime!, $uuids: [String!]) {
  lineHaulManifests(date: $date, uuids: $uuids) {
    lineHaulManifests {
      ...DetailedLineHaulManifest
    }
    unmanifestedSegments {
      ...ShallowLineHaulSegment
    }
  }
}
    ${DetailedLineHaulManifestFragmentDoc}
${ShallowLineHaulSegmentFragmentDoc}`;
export const LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusDocument = gql`
    query lineHaulOrdersWithUpcomingSegmentAndInboundStopStatus($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...LineHaulOrderWithUpcomingSegmentAndInboundStopStatus
  }
}
    ${LineHaulOrderWithUpcomingSegmentAndInboundStopStatusFragmentDoc}`;
export const LineHaulSegmentsDocument = gql`
    query lineHaulSegments {
  lineHaulSegments {
    ...ShallowLineHaulSegment
  }
}
    ${ShallowLineHaulSegmentFragmentDoc}`;
export const MarkManifestAsArrivedDocument = gql`
    mutation markManifestAsArrived($markManifestAsArrivedInput: MarkManifestAsArrivedInput!) {
  markManifestAsArrived(markManifestAsArrivedInput: $markManifestAsArrivedInput) {
    lineHaulManifest {
      ...DetailedLineHaulManifest
    }
    errorMessage
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const MarkManifestAsDepartedDocument = gql`
    mutation markManifestAsDeparted($markManifestAsDepartedInput: MarkManifestAsDepartedInput!) {
  markManifestAsDeparted(
    markManifestAsDepartedInput: $markManifestAsDepartedInput
  ) {
    lineHaulManifest {
      ...DetailedLineHaulManifest
    }
    errorMessage
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const MarkManifestAsPlanningDocument = gql`
    mutation markManifestAsPlanning($markManifestAsPlanningInput: MarkManifestAsPlanningInput!) {
  markManifestAsPlanning(
    markManifestAsPlanningInput: $markManifestAsPlanningInput
  ) {
    lineHaulManifest {
      ...DetailedLineHaulManifest
    }
    errorMessage
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const RemoveLineHaulManifestDocument = gql`
    mutation removeLineHaulManifest($uuid: String!) {
  removeLineHaulManifest(uuid: $uuid)
}
    `;
export const RemoveOrdersFromManifestV2Document = gql`
    mutation removeOrdersFromManifestV2($input: RemoveOrdersFromManifestV2Input!) {
  removeOrdersFromManifestV2(input: $input) {
    ... on RemoveOrdersFromManifestV2SuccessOutput {
      __typename
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    `;
export const RemoveOrdersFromManifestDocument = gql`
    mutation removeOrdersFromManifest($removeOrdersFromManifestInput: RemoveOrdersFromManifestInput!) {
  removeOrdersFromManifest(
    removeOrdersFromManifestInput: $removeOrdersFromManifestInput
  ) {
    lineHaulManifest {
      ...DetailedLineHaulManifest
    }
    errorMessage
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const SegmentedLineHaulOrdersV2Document = gql`
    query segmentedLineHaulOrdersV2($findSegmentedLineHaulOrdersInputV2: FindSegmentedLineHaulOrdersInputV2!) {
  segmentedLineHaulOrdersV2(
    findSegmentedLineHaulOrdersInputV2: $findSegmentedLineHaulOrdersInputV2
  ) {
    edges {
      ...SegmentedLineHaulOrder
    }
    totalCount
  }
}
    ${SegmentedLineHaulOrderFragmentDoc}`;
export const SegmentedLineHaulOrdersDocument = gql`
    query segmentedLineHaulOrders($findSegmentedLineHaulOrdersInput: FindSegmentedLineHaulOrdersInput!) {
  segmentedLineHaulOrders(
    findSegmentedLineHaulOrdersInput: $findSegmentedLineHaulOrdersInput
  ) {
    totalCount
    edges {
      node {
        ...SegmentedLineHaulOrder
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${SegmentedLineHaulOrderFragmentDoc}`;
export const SetLineHaulManifestLoadPositionDocument = gql`
    mutation setLineHaulManifestLoadPosition($input: SetLineHaulManifestLoadPositionInput!) {
  setLineHaulManifestLoadPosition(input: $input) {
    __typename
    ... on SetLineHaulManifestLoadPositionSuccessOutput {
      lineHaulManifest {
        ...DetailedLineHaulManifest
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const SetLineHaulManifestOrderLoadPositionDocument = gql`
    mutation setLineHaulManifestOrderLoadPosition($input: SetLineHaulManifestOrderLoadPositionInput!) {
  setLineHaulManifestOrderLoadPosition(input: $input) {
    __typename
    ... on SetLineHaulManifestLoadPositionSuccessOutput {
      lineHaulManifest {
        ...DetailedLineHaulManifest
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const UpdateManifestDriverDocument = gql`
    mutation updateManifestDriver($updateManifestDriverInput: UpdateManifestDriverInput!) {
  updateManifestDriver(updateManifestDriverInput: $updateManifestDriverInput) {
    ...DetailedLineHaulManifest
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const UpdateManifestVehicleDocument = gql`
    mutation updateManifestVehicle($updateManifestVehicleInput: UpdateManifestVehicleInput!) {
  updateManifestVehicle(updateManifestVehicleInput: $updateManifestVehicleInput) {
    ...DetailedLineHaulManifest
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const UpdateManifestsStatusDocument = gql`
    mutation updateManifestsStatus($input: UpdateManifestsStatusInput!) {
  updateManifestsStatus(input: $input) {
    __typename
    ... on UpdateManifestsStatusSuccessOutput {
      __typename
      lineHaulManifests {
        ...DetailedLineHaulManifest
      }
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    ${DetailedLineHaulManifestFragmentDoc}`;
export const CalmAddStopToRouteDocument = gql`
    mutation CalmAddStopToRoute($input: AddStopToRouteInput!) {
  calmAddStopToRoute(input: $input)
}
    `;
export const CalmBuildRunManifestsDocument = gql`
    query CalmBuildRunManifests($dates: [DateTime!]!) {
  lineHaulManifests(dates: $dates) {
    lineHaulManifests {
      uuid
      referenceNumber
      status
      departDate
      startTerminal {
        code
      }
      endTerminal {
        code
      }
      orders {
        uuid
        weight
        pieceCountFromPackages
      }
    }
  }
}
    `;
export const CalmCrossdockInstructionsDocument = gql`
    query CalmCrossdockInstructions($terminalUuid: String!) {
  calmCrossdockInstructions(terminalUuid: $terminalUuid) {
    orderUuid
    instruction
  }
}
    `;
export const CalmSetCrossdockInstructionDocument = gql`
    mutation CalmSetCrossdockInstruction($input: SetCrossdockInstructionInput!) {
  calmSetCrossdockInstruction(input: $input)
}
    `;
export const LineHaulDriverConflictDocument = gql`
    query LineHaulDriverConflict($input: LineHaulDriverConflictInput!) {
  lineHaulDriverConflict(input: $input) {
    conflictWarning
  }
}
    `;
export const CalmManifestLoadPackagesDocument = gql`
    query CalmManifestLoadPackages($input: ManifestUuidsInput!) {
  calmManifestLoadPackages(input: $input) {
    manifestUuid
    packageUuid
    orderUuid
    orderName
    hawb
    mawb
    customer
    warehouse
    warehouseLocation
    originCode
    destCode
    inboundServiceDate
    outboundServiceDate
    description
    pieces
    piecesOnHand
    piecesLoaded
    piecesDeparted
    onHand
    hazmat
    weightLbs
    length
    width
    height
    cubeFt3
    unitDimensions {
      pieceUuid
      length
      width
      height
    }
    elsewhere {
      terminalCode
      onHand
      loaded
      departed
    }
  }
}
    `;
export const CalmManifestPlacementsDocument = gql`
    query CalmManifestPlacements($input: ManifestUuidsInput!) {
  calmManifestPlacements(input: $input) {
    manifestUuid
    packageUuid
    unitIndex
    pieceUuid
    x
    y
    z
    l
    w
    h
    rotated
    trailerEquipmentUuid
  }
}
    `;
export const CalmSaveManifestPlacementsDocument = gql`
    mutation CalmSaveManifestPlacements($input: SaveManifestPlacementsInput!) {
  calmSaveManifestPlacements(input: $input) {
    saved
    dropped
    placements {
      manifestUuid
      packageUuid
      unitIndex
      pieceUuid
      x
      y
      z
      l
      w
      h
      rotated
      trailerEquipmentUuid
    }
  }
}
    `;
export const CalmManifestsRangeDocument = gql`
    query CalmManifestsRange($dates: [DateTime!], $destinationTerminalUuid: String) {
  lineHaulManifests(
    dates: $dates
    destinationTerminalUuid: $destinationTerminalUuid
  ) {
    lineHaulManifests {
      uuid
      referenceNumber
      departDate
      estimatedArrival
      estimatedDeparture
      departTimeMinutes
      startedAt
      completedAt
      doorsClosedAt
      status
      driver {
        firstName
        lastName
      }
      startTerminal {
        code
      }
      endTerminal {
        code
      }
      orders {
        uuid
        name
      }
      ordersOnManifest {
        orderUuid
        loadPosition
      }
    }
  }
}
    `;
export const CalmMoveOrderBetweenRunsDocument = gql`
    mutation CalmMoveOrderBetweenRuns($input: MoveBetweenRunsInput!) {
  calmMoveOrderBetweenRuns(input: $input)
}
    `;
export const CalmOrderFinalMileDocument = gql`
    query CalmOrderFinalMile($orderUuid: String!) {
  order(uuid: $orderUuid) {
    uuid
    endStop {
      uuid
      outboundMethod
      serviceDateV2 {
        iso8601
      }
      terminal {
        uuid
        code
      }
      address {
        name
        line1
        line2
        city
        state
        zip
      }
      routeSlot {
        uuid
        route {
          uuid
          name
          driver {
            user {
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const CalmOrderPiecesDocument = gql`
    query CalmOrderPieces($orderUuid: String!) {
  calmOrderPieces(orderUuid: $orderUuid) {
    uuid
    packageUuid
    label
    status
    terminalCode
    warehouseLocation
  }
}
    `;
export const CalmOrderLineHaulRouteDocument = gql`
    query CalmOrderLineHaulRoute($orderUuid: String!) {
  calmOrderLineHaulRoute(orderUuid: $orderUuid) {
    ordinal
    startUuid
    startCode
    endUuid
    endCode
    assigned
    manifestRef
    manifestUuid
    departDate
  }
}
    `;
export const CalmOrderSplitSummaryDocument = gql`
    query CalmOrderSplitSummary($input: OrderSplitSummaryInput!) {
  calmOrderSplitSummary(input: $input) {
    orderUuid
    totalUnits
    manifests {
      manifestUuid
      manifestRef
      departDate
      units
    }
  }
}
    `;
export const CalmOrderTagsDocument = gql`
    query CalmOrderTags($input: OrderUuidsInput!) {
  calmOrderTags(input: $input) {
    orderUuid
    tags {
      value
      color
    }
  }
}
    `;
export const CalmOrdersByHawbDocument = gql`
    query CalmOrdersByHawb($input: OrdersByHawbInput!) {
  calmOrdersByHawb(input: $input) {
    hasMore
    matches {
      orderUuid
      name
      hawb
      status
    }
  }
}
    `;
export const CalmOrderPackagesDocument = gql`
    query CalmOrderPackages($orderUuid: String!) {
  calmOrderPackages(orderUuid: $orderUuid) {
    uuid
    description
    pieces
    piecesOnHand
    onHand
    hazmat
    weight
    commitBy
    assignments {
      manifestUuid
      manifestRef
      leg
      departDate
      departed
    }
  }
}
    `;
export const CalmManifestReadinessDocument = gql`
    query CalmManifestReadiness($manifestUuids: [String!]!) {
  calmManifestReadiness(input: {manifestUuids: $manifestUuids}) {
    manifestUuid
    orders
    ordersNotOnHand
    piecesTotal
    piecesOnHand
    piecesLoaded
    piecesDeparted
    piecesAtDestination
    weightTotal
    weightOnHand
    cubeTotal
    cubeOnHand
  }
}
    `;
export const CalmManifestSearchDocument = gql`
    query CalmManifestSearch($query: String!) {
  calmManifestSearch(query: $query) {
    uuid
    ref
    orig
    dest
    departDate
    status
  }
}
    `;
export const CalmManifestReschedulablesDocument = gql`
    query CalmManifestReschedulables($manifestUuid: String!) {
  calmManifestReschedulables(manifestUuid: $manifestUuid) {
    orderUuid
    orderName
    packageUuid
    description
    pieces
    piecesOnHand
    commitBy
  }
}
    `;
export const CalmAssignPackagesToManifestDocument = gql`
    mutation CalmAssignPackagesToManifest($input: AssignPackagesToManifestInput!) {
  calmAssignPackagesToManifest(input: $input)
}
    `;
export const CalmRemovePackagesFromManifestDocument = gql`
    mutation CalmRemovePackagesFromManifest($input: AssignPackagesToManifestInput!) {
  calmRemovePackagesFromManifest(input: $input)
}
    `;
export const CalmLiveRunsDocument = gql`
    query CalmLiveRuns($date: String!) {
  calmLiveRuns(date: $date) {
    uuid
    ref
    orig
    dest
    driverName
    departedAt
    ships
  }
}
    `;
export const CalmCommitDatesByOrderUuidsDocument = gql`
    query CalmCommitDatesByOrderUuids($input: OrderUuidsInput!) {
  calmCommitDatesByOrderUuids(input: $input) {
    orderUuid
    commitBy
  }
}
    `;
export const CalmOrderPackagesByOrderUuidsDocument = gql`
    query CalmOrderPackagesByOrderUuids($input: OrderUuidsInput!) {
  calmOrderPackagesByOrderUuids(input: $input) {
    orderUuid
    packages {
      uuid
      description
      pieces
      piecesOnHand
      onHand
      hazmat
      weight
      commitBy
      assignments {
        manifestUuid
        manifestRef
        leg
        departDate
        departed
      }
    }
  }
}
    `;
export const CalmLineHaulOrdersToPlanDocument = gql`
    query CalmLineHaulOrdersToPlan($input: CalmPlanOrdersInput!) {
  calmLineHaulOrdersToPlan(input: $input) {
    orderUuid
    name
    hawb
    originUuid
    originCode
    destUuid
    destCode
    pieces
    piecesOnHand
    packages
    packagesOnHand
    weight
    hazmat
    ready
    serviceDate
    inboundServiceDate
    outboundServiceDate
  }
}
    `;
export const CalmLoadOrdersOnManifestDocument = gql`
    mutation CalmLoadOrdersOnManifest($input: CalmLoadOrdersInput!) {
  calmLoadOrdersOnManifest(input: $input)
}
    `;
export const CalmPndRouteLoadDocument = gql`
    query CalmPndRouteLoad($routeUuid: String!) {
  calmPndRouteLoad(routeUuid: $routeUuid) {
    routeUuid
    vehicleName
    length
    width
    height
    weightCapacity
    packages {
      manifestUuid
      packageUuid
      orderUuid
      orderName
      hawb
      customer
      originCode
      destCode
      inboundServiceDate
      outboundServiceDate
      description
      pieces
      piecesOnHand
      onHand
      hazmat
      length
      width
      height
      weightLbs
      cubeFt3
      unitDimensions {
        pieceUuid
        length
        width
        height
      }
      movement
      awaitingInboundRef
      expectedOnHandAt
    }
  }
}
    `;
export const CalmPreDispatchOrdersDocument = gql`
    query CalmPreDispatchOrders($input: FindSegmentedLineHaulOrdersInputV2!) {
  segmentedLineHaulOrdersV2(findSegmentedLineHaulOrdersInputV2: $input) {
    totalCount
    edges {
      uuid
      order {
        uuid
        name
        weight
        pieceCountFromPackages
        dateMarkedReceivedAtOrigin
        detailedStatusV2
        hasNoneOrCompletedInboundStop
        hazmat
        lineHaulLane {
          uuid
          name
          isActive
          originTerminal {
            uuid
            code
          }
          destinationTerminal {
            uuid
            code
          }
        }
        upcomingLineHaulSegment {
          uuid
          ordinal
          startTerminal {
            uuid
            code
          }
          endTerminal {
            uuid
            code
          }
        }
        startStop {
          serviceDate
          expectedInboundArrivalDate
          terminal {
            code
          }
        }
        packages {
          uuid
          pieces {
            uuid
            status
            markedOnHandAt
            terminal {
              code
            }
          }
        }
      }
      segment {
        uuid
        ordinal
        startTerminal {
          uuid
          code
        }
        endTerminal {
          uuid
          code
        }
      }
    }
  }
}
    `;
export const LineHaulRunConfigsDocument = gql`
    query LineHaulRunConfigs($manifestUuids: [String!]!) {
  lineHaulRunConfigs(manifestUuids: $manifestUuids) {
    manifestUuid
    cubeCapacity
    weightCapacity
    truckLabel
    recurringTemplateTruckUuid
    cutoffTime
    powerUnitName
    trailers
    trailerDetails {
      equipmentUuid
      name
      capacity
      weight
      length
      width
      height
    }
    powerUnitDetails {
      equipmentUuid
      name
      length
      width
      height
    }
  }
}
    `;
export const CalmRunInboundPlanDocument = gql`
    query CalmRunInboundPlan($manifestUuids: [String!]!) {
  calmRunInboundPlan(input: {manifestUuids: $manifestUuids}) {
    manifestUuid
    orders {
      orderUuid
      source
      fromTerminalCode
      fromManifestUuid
      fromManifestRef
    }
  }
}
    `;
export const CalmRunOnwardPlanDocument = gql`
    query CalmRunOnwardPlan($manifestUuids: [String!]!) {
  calmRunOnwardPlan(input: {manifestUuids: $manifestUuids}) {
    manifestUuid
    orders {
      orderUuid
      disposition
      nextTerminalCode
      onwardManifestUuid
      onwardManifestRef
    }
  }
}
    `;
export const LineHaulSegmentTimingsDocument = gql`
    query LineHaulSegmentTimings {
  lineHaulSegmentTimings {
    ...LineHaulSegmentTiming
  }
}
    ${LineHaulSegmentTimingFragmentDoc}`;
export const SetLineHaulSegmentTimingDocument = gql`
    mutation SetLineHaulSegmentTiming($input: SetLineHaulSegmentTimingInput!) {
  setLineHaulSegmentTiming(input: $input) {
    updatedCount
    timing {
      ...LineHaulSegmentTiming
    }
  }
}
    ${LineHaulSegmentTimingFragmentDoc}`;
export const CalmSetPndRouteDriverDocument = gql`
    mutation CalmSetPndRouteDriver($input: SetPndRouteDriverInput!) {
  calmSetPndRouteDriver(input: $input)
}
    `;
export const RecurringTemplateTrucksDocument = gql`
    query RecurringTemplateTrucks($recurringTemplateUuid: String!) {
  recurringTemplateTrucks(recurringTemplateUuid: $recurringTemplateUuid) {
    uuid
    recurringTemplateUuid
    label
    powerUnitEquipmentUuid
    powerUnitName
    cutoffTime
    daysOfWeek
    trailers {
      equipmentUuid
      name
      capacity
      weight
    }
  }
}
    `;
export const CreateRecurringTemplateTruckDocument = gql`
    mutation CreateRecurringTemplateTruck($input: CreateRecurringTemplateTruckInput!) {
  createRecurringTemplateTruck(input: $input) {
    uuid
    recurringTemplateUuid
    label
    powerUnitEquipmentUuid
    powerUnitName
    cutoffTime
    daysOfWeek
    trailers {
      equipmentUuid
      name
      capacity
      weight
    }
  }
}
    `;
export const UpdateRecurringTemplateTruckDocument = gql`
    mutation UpdateRecurringTemplateTruck($input: UpdateRecurringTemplateTruckInput!) {
  updateRecurringTemplateTruck(input: $input) {
    uuid
    recurringTemplateUuid
    label
    powerUnitEquipmentUuid
    powerUnitName
    cutoffTime
    daysOfWeek
    trailers {
      equipmentUuid
      name
      capacity
      weight
    }
  }
}
    `;
export const DeleteRecurringTemplateTruckDocument = gql`
    mutation DeleteRecurringTemplateTruck($uuid: String!) {
  deleteRecurringTemplateTruck(uuid: $uuid)
}
    `;
export const CreateLineHaulTruckRunsDocument = gql`
    mutation CreateLineHaulTruckRuns($input: CreateTruckRunsInput!) {
  createLineHaulTruckRuns(input: $input)
}
    `;
export const SetLineHaulManifestTruckDocument = gql`
    mutation SetLineHaulManifestTruck($input: SetManifestTruckInput!) {
  setLineHaulManifestTruck(input: $input) {
    conflictWarning
  }
}
    `;
export const GenerateLineHaulRunsDocument = gql`
    mutation GenerateLineHaulRuns($input: GenerateLineHaulRunsInput!) {
  generateLineHaulRuns(input: $input) {
    created
    serviceDays
  }
}
    `;
export const CalmTerminalLanesDocument = gql`
    query CalmTerminalLanes {
  terminals {
    uuid
    code
    isActive
    address {
      latitude
      longitude
    }
    startForTerminalLanes {
      id
      startTerminal {
        uuid
        code
      }
      endTerminal {
        uuid
        code
      }
    }
  }
}
    `;
export const CalmAssignLineHaulRouteDocument = gql`
    mutation CalmAssignLineHaulRoute($input: AssignLineHaulRouteInput!) {
  calmAssignLineHaulRoute(input: $input) {
    orderUuid
    laneUuid
    legCount
  }
}
    `;
export const CalmTerminalOnHandDocument = gql`
    query CalmTerminalOnHand($terminalUuid: String!) {
  calmTerminalOnHand(terminalUuid: $terminalUuid) {
    pieceUuid
    pieceRef
    packageUuid
    weightLbs
    orderUuid
    orderRef
    hawb
    customer
    destCode
    inboundServiceDate
    outboundServiceDate
    warehouseUuid
    warehouseName
    locationUuid
    locationName
    markedOnHandAt
  }
}
    `;
export const CalmTerminalPndDocument = gql`
    query CalmTerminalPnd($terminalUuid: String!, $date: String!) {
  calmTerminalPnd(terminalUuid: $terminalUuid, date: $date) {
    routeUuid
    name
    driverName
    driverUuid
    startAt
    started
    locked
    pickups
    deliveries
    stops
    orderUuids
  }
}
    `;
export const LineHaulTrailerAssignmentsDocument = gql`
    query LineHaulTrailerAssignments($manifestUuids: [String!]!) {
  lineHaulTrailerAssignments(manifestUuids: $manifestUuids) {
    manifestUuid
    orderUuid
    trailerEquipmentUuid
    weightLbs
    cubeFt3
  }
}
    `;
export const AssignOrderToLineHaulTrailerDocument = gql`
    mutation AssignOrderToLineHaulTrailer($input: AssignOrderToTrailerInput!) {
  assignOrderToLineHaulTrailer(input: $input)
}
    `;
export const UnassignOrderFromLineHaulTrailerDocument = gql`
    mutation UnassignOrderFromLineHaulTrailer($input: UnassignOrderFromTrailerInput!) {
  unassignOrderFromLineHaulTrailer(input: $input)
}
    `;
export const DockDoorAssignmentsDocument = gql`
    query DockDoorAssignments($input: DockDoorAssignmentsInput!) {
  dockDoorAssignments(input: $input) {
    manifestUuid
    routeUuid
    doorPosition
    doorEventAt
    isReturnLeg
  }
}
    `;
export const AssignDockDoorDocument = gql`
    mutation AssignDockDoor($input: AssignDockDoorInput!) {
  assignDockDoor(input: $input) {
    uuid
    position
    direction
  }
}
    `;
export const DockDoorsDocument = gql`
    query DockDoors($terminalUuid: String!) {
  dockDoors(terminalUuid: $terminalUuid) {
    uuid
    position
    direction
  }
}
    `;
export const SetDockDoorsDocument = gql`
    mutation SetDockDoors($input: SetDockDoorsInput!) {
  setDockDoors(input: $input) {
    uuid
    position
    direction
  }
}
    `;
export const DockRunTimesDocument = gql`
    query DockRunTimes($input: DockRunTimesInput!) {
  dockRunTimes(input: $input) {
    manifestUuid
    departAt
    arriveAt
    actualDepartAt
    actualArriveAt
  }
}
    `;
export const CompanyDockDoorsDocument = gql`
    query CompanyDockDoors {
  companyDockDoors {
    uuid
    terminalUuid
    position
    direction
  }
}
    `;
export const LaneDefaultDoorsDocument = gql`
    query LaneDefaultDoors {
  laneDefaultDoors {
    startTerminalUuid
    endTerminalUuid
    originDoorPosition
    destDoorPosition
  }
}
    `;
export const SetLaneDefaultDoorDocument = gql`
    mutation SetLaneDefaultDoor($input: SetLaneDefaultDoorInput!) {
  setLaneDefaultDoor(input: $input) {
    startTerminalUuid
    endTerminalUuid
    originDoorPosition
    destDoorPosition
  }
}
    `;
export const MarkManifestAsDoorsClosedDocument = gql`
    mutation markManifestAsDoorsClosed($markManifestAsDoorsClosedInput: MarkManifestAsDoorsClosedInput!) {
  markManifestAsDoorsClosed(
    markManifestAsDoorsClosedInput: $markManifestAsDoorsClosedInput
  ) {
    lineHaulManifest {
      uuid
      status
    }
    errorMessage
  }
}
    `;
export const AccessorialGroupsDocument = gql`
    query accessorialGroups {
  accessorialGroups {
    ...AccessorialGroup
  }
}
    ${AccessorialGroupFragmentDoc}`;
export const CreateAccessorialGroupDocument = gql`
    mutation createAccessorialGroup($input: CreateAccessorialGroupInput!) {
  createAccessorialGroup(input: $input) {
    ...AccessorialGroup
  }
}
    ${AccessorialGroupFragmentDoc}`;
export const UpdateAccessorialGroupDocument = gql`
    mutation updateAccessorialGroup($input: UpdateAccessorialGroupInput!) {
  updateAccessorialGroup(input: $input) {
    ...AccessorialGroup
  }
}
    ${AccessorialGroupFragmentDoc}`;
export const DeleteAccessorialGroupDocument = gql`
    mutation deleteAccessorialGroup($id: String!) {
  deleteAccessorialGroup(id: $id)
}
    `;
export const CreateRecurringLineHaulManifestTemplateDocument = gql`
    mutation createRecurringLineHaulManifestTemplate($input: CreateRecurringLineHaulManifestTemplateInput!) {
  createRecurringLineHaulManifestTemplate(input: $input) {
    ...RecurringLineHaulManifestTemplate
  }
}
    ${RecurringLineHaulManifestTemplateFragmentDoc}`;
export const DeleteRecurringLineHaulManifestTemplateDocument = gql`
    mutation deleteRecurringLineHaulManifestTemplate($uuid: String!) {
  deleteRecurringLineHaulManifestTemplate(uuid: $uuid)
}
    `;
export const RecurringLineHaulManifestTemplatesDocument = gql`
    query recurringLineHaulManifestTemplates {
  recurringLineHaulManifestTemplates {
    ...RecurringLineHaulManifestTemplate
  }
}
    ${RecurringLineHaulManifestTemplateFragmentDoc}`;
export const UpdateRecurringLineHaulManifestTemplateDocument = gql`
    mutation updateRecurringLineHaulManifestTemplate($input: UpdateRecurringLineHaulManifestTemplateInput!) {
  updateRecurringLineHaulManifestTemplate(input: $input) {
    ...RecurringLineHaulManifestTemplate
  }
}
    ${RecurringLineHaulManifestTemplateFragmentDoc}`;
export const ServiceGroupsDocument = gql`
    query serviceGroups {
  serviceGroups {
    ...ServiceGroup
  }
}
    ${ServiceGroupFragmentDoc}`;
export const CreateServiceGroupDocument = gql`
    mutation createServiceGroup($input: CreateServiceGroupInput!) {
  createServiceGroup(input: $input) {
    ...ServiceGroup
  }
}
    ${ServiceGroupFragmentDoc}`;
export const UpdateServiceGroupDocument = gql`
    mutation updateServiceGroup($input: UpdateServiceGroupInput!) {
  updateServiceGroup(input: $input) {
    ...ServiceGroup
  }
}
    ${ServiceGroupFragmentDoc}`;
export const DeleteServiceGroupDocument = gql`
    mutation deleteServiceGroup($id: String!) {
  deleteServiceGroup(id: $id)
}
    `;
export const ArchiveTariffChainDocument = gql`
    mutation archiveTariffChain($archiveTariffChainInput: ArchiveTariffChainInput!) {
  archiveTariffChain(archiveTariffChainInput: $archiveTariffChainInput) {
    ... on ArchiveTariffChainSuccessOutput {
      tariffChain {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CompanyDefaultTariffChainsDocument = gql`
    query companyDefaultTariffChains {
  company {
    defaultOrdinaryTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultLineHaulTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultTransferTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultRecoveryTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultPointToPointTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultOrdinarySettlementTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultTransferSettlementTariffChain {
      ...CompanyDefaultTariffChain
    }
    defaultRecoverySettlementTariffChain {
      ...CompanyDefaultTariffChain
    }
  }
}
    ${CompanyDefaultTariffChainFragmentDoc}`;
export const CreateTariffChainDocument = gql`
    mutation createTariffChain($createTariffChainInput: CreateTariffChainInput!) {
  createTariffChain(createTariffChainInput: $createTariffChainInput) {
    ... on CreateTariffChainSuccessOutput {
      tariffChain {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RestoreTariffChainDocument = gql`
    mutation restoreTariffChain($restoreTariffChainInput: RestoreTariffChainInput!) {
  restoreTariffChain(restoreTariffChainInput: $restoreTariffChainInput) {
    ... on RestoreTariffChainSuccessOutput {
      tariffChain {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const TariffChainsWithGroupsDocument = gql`
    query tariffChainsWithGroups($findTariffChainsInput: FindTariffChainsInput!) {
  tariffChains(findTariffChainsInput: $findTariffChainsInput) {
    ...TariffChainWithGroups
  }
}
    ${TariffChainWithGroupsFragmentDoc}`;
export const UpdateDefaultTariffChainsForCompanyDocument = gql`
    mutation updateDefaultTariffChainsForCompany($updateDefaultTariffChainsForCompanyInput: UpdateDefaultTariffChainsForCompanyInput!) {
  updateDefaultTariffChainsForCompany(
    updateDefaultTariffChainsForCompanyInput: $updateDefaultTariffChainsForCompanyInput
  ) {
    ... on UpdateDefaultTariffChainsForCompanySuccessOutput {
      company {
        uuid
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdateTariffChainDocument = gql`
    mutation updateTariffChain($updateTariffChainInput: UpdateTariffChainInput!) {
  updateTariffChain(updateTariffChainInput: $updateTariffChainInput) {
    ... on UpdateTariffChainSuccessOutput {
      tariffChain {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ContactsWithTariffsDocument = gql`
    query contactsWithTariffs($checkHasTariffs: Boolean, $checkHasTariffZones: Boolean) {
  contacts(
    checkHasTariffs: $checkHasTariffs
    checkHasTariffZones: $checkHasTariffZones
  ) {
    uuid
    displayName
    customerTariffs {
      service {
        ...Service
      }
    }
    tariffZones {
      type
    }
  }
}
    ${ServiceFragmentDoc}`;
export const CreateTariffGroupDocument = gql`
    mutation createTariffGroup($createTariffGroupInput: CreateTariffGroupInput!) {
  createTariffGroup(createTariffGroupInput: $createTariffGroupInput) {
    uuid
    name
  }
}
    `;
export const DeleteTariffGroupDocument = gql`
    mutation deleteTariffGroup($uuid: String!) {
  deleteTariffGroup(uuid: $uuid) {
    uuid
  }
}
    `;
export const DuplicateTariffGroupDocument = gql`
    mutation duplicateTariffGroup($duplicateTariffGroupInput: DuplicateTariffGroupInput!) {
  duplicateTariffGroup(duplicateTariffGroupInput: $duplicateTariffGroupInput) {
    tariffGroup {
      uuid
    }
  }
}
    `;
export const FindDefaultRecoveryTariffGroupForCompanyDocument = gql`
    query findDefaultRecoveryTariffGroupForCompany {
  findDefaultRecoveryTariffGroupForCompany {
    uuid
  }
}
    `;
export const FindDefaultTariffGroupForCompanyDocument = gql`
    query findDefaultTariffGroupForCompany {
  findDefaultTariffGroupForCompany {
    uuid
  }
}
    `;
export const FindDefaultTransferTariffGroupForCompanyDocument = gql`
    query findDefaultTransferTariffGroupForCompany {
  findDefaultTransferTariffGroupForCompany {
    uuid
  }
}
    `;
export const FindTariffGroupsWithContactAndServiceCombinationDocument = gql`
    query findTariffGroupsWithContactAndServiceCombination($mappingsList: [ContactAndServicesCombination!]!) {
  findTariffGroupsWithContactAndServiceCombination(mappingsList: $mappingsList) {
    contactUuid
    matchingTariffGroups {
      tariffGroupName
      tariffGroupUuid
      serviceUuids
    }
  }
}
    `;
export const PointToPointLanesDocument = gql`
    query pointToPointLanes($tariffGroupUuid: String!, $after: String) {
  pointToPointLanes(tariffGroupUuid: $tariffGroupUuid, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        tariffUuid
        version
        inboundZoneUuid
        outboundZoneUuid
        isActive
        minimumUsdCents
        maximumUsdCents
        settlementPercentageRate
        bands {
          lessThanOrEqualToValue
          rateUsdCents
        }
        tariffOverageRates {
          ...TariffOverageRate
        }
      }
    }
  }
}
    ${TariffOverageRateFragmentDoc}`;
export const SavePointToPointLanesDocument = gql`
    mutation savePointToPointLanes($input: SavePointToPointLanesInput!) {
  savePointToPointLanes(input: $input) {
    lanes {
      inboundZoneUuid
      outboundZoneUuid
      tariffUuid
      version
    }
  }
}
    `;
export const TariffGroupEditorShellDocument = gql`
    query tariffGroupEditorShell($tariffGroupUuid: String!) {
  tariffGroup(uuid: $tariffGroupUuid) {
    ...TariffGroupSettings
    firstTariff {
      ...TariffForTariffGroup
    }
  }
}
    ${TariffGroupSettingsFragmentDoc}
${TariffForTariffGroupFragmentDoc}`;
export const TariffGroupTariffChainsDocument = gql`
    query tariffGroupTariffChains($tariffGroupUuid: String!) {
  tariffGroup(uuid: $tariffGroupUuid) {
    uuid
    tariffChains {
      id
      name
      isArchived
    }
  }
}
    `;
export const TariffGroupDocument = gql`
    query tariffGroup($tariffGroupUuid: String!) {
  tariffGroup(uuid: $tariffGroupUuid) {
    ...TariffGroup
  }
}
    ${TariffGroupFragmentDoc}`;
export const TariffDocument = gql`
    query tariff($uuid: String!) {
  tariff(uuid: $uuid) {
    ...TariffFragment
  }
}
    ${TariffFragmentFragmentDoc}`;
export const UpdateContactToServicesTariffGroupMappingsDocument = gql`
    mutation updateContactToServicesTariffGroupMappings($uuid: String!, $contactToServicesMappings: [CreateContactToServicesMappingInput!]!) {
  updateContactToServicesTariffGroupMappings(
    uuid: $uuid
    contactToServicesMappings: $contactToServicesMappings
  ) {
    uuid
    contact {
      uuid
    }
    services {
      uuid
    }
  }
}
    `;
export const UpdateTariffGroupDocument = gql`
    mutation updateTariffGroup($updateTariffGroupInput: UpdateTariffGroupInput!) {
  updateTariffGroup(updateTariffGroupInput: $updateTariffGroupInput) {
    uuid
    name
  }
}
    `;
export const ArchiveTariffZoneGroupDocument = gql`
    mutation archiveTariffZoneGroup($id: String!) {
  archiveTariffZoneGroup(id: $id) {
    ... on TariffZoneGroupArchiveSuccessOutput {
      tariffZoneGroup {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CreateTariffZoneGroupDocument = gql`
    mutation createTariffZoneGroup($tariffZoneGroupCreateInput: TariffZoneGroupCreateInput!) {
  createTariffZoneGroup(tariffZoneGroupCreateInput: $tariffZoneGroupCreateInput) {
    ... on TariffZoneGroupCreateSuccessOutput {
      tariffZoneGroup {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RestoreTariffZoneGroupDocument = gql`
    mutation restoreTariffZoneGroup($id: String!) {
  restoreTariffZoneGroup(id: $id) {
    ... on TariffZoneGroupRestoreSuccessOutput {
      tariffZoneGroup {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const TariffZoneGroupsDocument = gql`
    query tariffZoneGroups($findTariffZoneGroupsInput: FindTariffZoneGroupsInput!) {
  tariffZoneGroups(findTariffZoneGroupsInput: $findTariffZoneGroupsInput) {
    ...TariffZoneGroup
  }
}
    ${TariffZoneGroupFragmentDoc}`;
export const TariffZonesForGroupDocument = gql`
    query tariffZonesForGroup($tariffZoneGroupId: String!) {
  tariffZoneGroup(id: $tariffZoneGroupId) {
    ...TariffZoneGroupWithTariffZones
  }
}
    ${TariffZoneGroupWithTariffZonesFragmentDoc}`;
export const UpdateTariffZoneGroupDocument = gql`
    mutation updateTariffZoneGroup($tariffZoneGroupUpdateInput: TariffZoneGroupUpdateInput!) {
  updateTariffZoneGroup(tariffZoneGroupUpdateInput: $tariffZoneGroupUpdateInput) {
    ... on TariffZoneGroupUpdateSuccessOutput {
      tariffZoneGroup {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const AccessorialDateRangeConfigByUuidDocument = gql`
    query accessorialDateRangeConfigByUuid($uuid: String!) {
  accessorialDateRangeConfigByUuid(uuid: $uuid) {
    uuid
    startDate
    endDate
    specialChargeGroups {
      uuid
      dayOfWeek
      startTime
      endTime
    }
    specialMatrixItems {
      tariffZone {
        uuid
        name
        mileRangeStart
        mileRangeEnd
      }
      chargeGroupUuid
      uuid
      rate
    }
    accessorialRanges {
      ...AccessorialRange
    }
  }
}
    ${AccessorialRangeFragmentDoc}`;
export const AccessorialDateRangeConfigsDocument = gql`
    query accessorialDateRangeConfigs($findAccessorialDateRangeConfigsInput: FindAccessorialDateRangeConfigsInput!) {
  accessorialDateRangeConfigs(
    findAccessorialDateRangeConfigsInput: $findAccessorialDateRangeConfigsInput
  ) {
    accessorialDateRangeConfigs {
      ...AccessorialDateRangeConfig
    }
  }
}
    ${AccessorialDateRangeConfigFragmentDoc}`;
export const CreateAccessorialDateRangeConfigDocument = gql`
    mutation createAccessorialDateRangeConfig($createAccessorialDateRangeConfigInput: CreateAccessorialDateRangeConfigInput!) {
  createAccessorialDateRangeConfig(
    createAccessorialDateRangeConfigInput: $createAccessorialDateRangeConfigInput
  ) {
    success
  }
}
    `;
export const DeleteAccessorialDateRangeConfigDocument = gql`
    mutation deleteAccessorialDateRangeConfig($deleteAccessorialDateRangeConfigInput: DeleteAccessorialDateRangeConfigInput!) {
  deleteAccessorialDateRangeConfig(
    deleteAccessorialDateRangeConfigInput: $deleteAccessorialDateRangeConfigInput
  ) {
    uuid
  }
}
    `;
export const UpdateAccessorialDateRangeConfigDocument = gql`
    mutation updateAccessorialDateRangeConfig($updateAccessorialDateRangeConfigInput: UpdateAccessorialDateRangeConfigInput!) {
  updateAccessorialDateRangeConfig(
    updateAccessorialDateRangeConfigInput: $updateAccessorialDateRangeConfigInput
  ) {
    success
  }
}
    `;
export const AccessorialNamesByBillingContactDocument = gql`
    query accessorialNamesByBillingContact($billingPartyContactUuid: String, $onlyShowCompanyAccessorials: Boolean) {
  accessorialsByBillingContact(
    billingPartyContactUuid: $billingPartyContactUuid
    onlyShowCompanyAccessorials: $onlyShowCompanyAccessorials
  ) {
    ...AccessorialNames
  }
}
    ${AccessorialNamesFragmentDoc}`;
export const AccessorialsByBillingContactDocument = gql`
    query accessorialsByBillingContact($billingPartyContactUuid: String, $onlyShowCompanyAccessorials: Boolean, $terminalUuids: [String!], $includeArchived: Boolean) {
  accessorialsByBillingContact(
    billingPartyContactUuid: $billingPartyContactUuid
    onlyShowCompanyAccessorials: $onlyShowCompanyAccessorials
    terminalUuids: $terminalUuids
    includeArchived: $includeArchived
  ) {
    ... on StandardAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on PercentageAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on WeightBasedAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
      zones {
        uuid
      }
      chargeGroups {
        uuid
      }
    }
    ... on WaitTimeAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on UnitBasedAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on SkidBasedAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on SpecialAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
      chargeGroups {
        uuid
      }
    }
    ... on AttemptsAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
    ... on StorageDaysAccessorialEntity {
      uuid
      name
      isArchived
      isAuthoCodeRequired
      contact {
        uuid
      }
      matchingGlobalAccessorial {
        ...AccessorialUnionUuidOnly
      }
    }
  }
}
    ${AccessorialUnionUuidOnlyFragmentDoc}`;
export const CreateAccessorialDocument = gql`
    mutation CreateAccessorial($input: CreateAccessorialInput!) {
  createAccessorial(createAccessorialInput: $input) {
    ...AccessorialsUuid
  }
}
    ${AccessorialsUuidFragmentDoc}`;
export const RemoveAccessorialDocument = gql`
    mutation RemoveAccessorial($input: String!) {
  removeAccessorial(uuid: $input) {
    ...AccessorialsUuid
  }
}
    ${AccessorialsUuidFragmentDoc}`;
export const AccessorialDocument = gql`
    query accessorial($uuid: String!, $specialWindowsDate: DateTime) {
  accessorial(uuid: $uuid) {
    ...AllAccessorialFields
  }
}
    ${AllAccessorialFieldsFragmentDoc}`;
export const DefaultGlobalSpecialAccessorialsDocument = gql`
    query defaultGlobalSpecialAccessorials {
  defaultGlobalSpecialAccessorials {
    ... on SpecialAccessorialEntity {
      __typename
      uuid
      name
    }
  }
}
    `;
export const AccessorialNamesDocument = gql`
    query accessorialNames($onlyShowCompanyAccessorials: Boolean) {
  accessorials(onlyShowCompanyAccessorials: $onlyShowCompanyAccessorials) {
    ...AccessorialNames
  }
}
    ${AccessorialNamesFragmentDoc}`;
export const AccessorialsTableDocument = gql`
    query accessorialsTable($contactUuid: String, $onlyShowCompanyAccessorials: Boolean, $includeArchived: Boolean) {
  accessorials(
    contactUuid: $contactUuid
    onlyShowCompanyAccessorials: $onlyShowCompanyAccessorials
    includeArchived: $includeArchived
  ) {
    ...AccessorialsTableRow
  }
}
    ${AccessorialsTableRowFragmentDoc}`;
export const AccessorialsDocument = gql`
    query accessorials($contactUuid: String, $onlyShowCompanyAccessorials: Boolean, $includeArchived: Boolean, $specialWindowsDate: DateTime) {
  accessorials(
    contactUuid: $contactUuid
    onlyShowCompanyAccessorials: $onlyShowCompanyAccessorials
    includeArchived: $includeArchived
  ) {
    ...AllAccessorialFields
  }
}
    ${AllAccessorialFieldsFragmentDoc}`;
export const RemoveSpecialAccessorialDocument = gql`
    mutation RemoveSpecialAccessorial($input: String!) {
  removeSpecialAccessorial(uuid: $input) {
    ... on SpecialAccessorialEntity {
      uuid
    }
  }
}
    `;
export const RemoveZoneBasedAccessorialDocument = gql`
    mutation RemoveZoneBasedAccessorial($input: String!) {
  removeZoneBasedAccessorial(uuid: $input) {
    ... on ZoneBasedAccessorialEntity {
      uuid
    }
  }
}
    `;
export const UpdateAccessorialDocument = gql`
    mutation UpdateAccessorial($input: UpdateAccessorialInput!) {
  updateAccessorial(updateAccessorialInput: $input) {
    ...AccessorialsUuid
  }
}
    ${AccessorialsUuidFragmentDoc}`;
export const UpdateQuickAddAccessorialsDocument = gql`
    mutation UpdateQuickAddAccessorials($input: UpdateQuickAddAccessorialsInput!) {
  updateQuickAddAccessorials(input: $input) {
    quickAddAccessorials {
      ...AccessorialNames
    }
  }
}
    ${AccessorialNamesFragmentDoc}`;
export const ArchiveRecoveryTerminalDocument = gql`
    mutation ArchiveRecoveryTerminal($uuid: String!) {
  archiveAirportInfo(uuid: $uuid) {
    airportInfo {
      uuid
      isArchived
    }
  }
}
    `;
export const SenderIsVerifiedDocument = gql`
    query senderIsVerified {
  senderIsVerified
}
    `;
export const CreateCreditTypeDocument = gql`
    mutation createCreditType($creditTypeCreateInput: CreditTypeCreateInput!) {
  createCreditType(creditTypeCreateInput: $creditTypeCreateInput) {
    ...CreditType
  }
}
    ${CreditTypeFragmentDoc}`;
export const CreditTypesDocument = gql`
    query creditTypes {
  creditTypes {
    ...CreditType
  }
}
    ${CreditTypeFragmentDoc}`;
export const RemoveCreditTypeDocument = gql`
    mutation removeCreditType($uuid: String!) {
  removeCreditType(uuid: $uuid) {
    ...CreditType
  }
}
    ${CreditTypeFragmentDoc}`;
export const UpdateCreditTypeDocument = gql`
    mutation updateCreditType($creditTypeUpdateInput: CreditTypeUpdateInput!) {
  updateCreditType(creditTypeUpdateInput: $creditTypeUpdateInput) {
    ...CreditType
  }
}
    ${CreditTypeFragmentDoc}`;
export const CreateGeneralLedgerCodeDocument = gql`
    mutation createGeneralLedgerCode($input: GeneralLedgerCodeCreateInput!) {
  createGeneralLedgerCode(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on CreateGeneralLedgerCodeSuccessOutput {
      generalLedgerCode {
        code
        description
      }
    }
  }
}
    `;
export const DeleteGeneralLedgerCodeDocument = gql`
    mutation deleteGeneralLedgerCode($input: GeneralLedgerCodeDeleteInput!) {
  deleteGeneralLedgerCode(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on DeleteGeneralLedgerCodeSuccessOutput {
      id
    }
  }
}
    `;
export const GeneralLedgerCodesDocument = gql`
    query generalLedgerCodes {
  generalLedgerCodes {
    id
    code
    description
  }
}
    `;
export const GeneralLedgerConfigurationDocument = gql`
    query generalLedgerConfiguration {
  generalLedgerConfiguration {
    id
    generalLedgerCodes {
      ...GeneralLedgerCode
    }
    deliveryChargeCodeId
    pickupChargeCodeId
    recoveryChargeCodeId
    transferChargeCodeId
    orderChargeCodeId
    lineHaulChargeCodeId
    fuelChargeCodeId
    accessorialFallbackCodeId
  }
}
    ${GeneralLedgerCodeFragmentDoc}`;
export const UpdateGeneralLedgerCodeDocument = gql`
    mutation updateGeneralLedgerCode($input: GeneralLedgerCodeUpdateInput!) {
  updateGeneralLedgerCode(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on UpdateGeneralLedgerCodeSuccessOutput {
      generalLedgerCode {
        code
        description
      }
    }
  }
}
    `;
export const UpdateGeneralLedgerConfigurationDocument = gql`
    mutation updateGeneralLedgerConfiguration($input: GeneralLedgerConfigurationUpdateInput!) {
  updateGeneralLedgerConfiguration(input: $input) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on UpdateGeneralLedgerConfigurationSuccessOutput {
      generalLedgerConfiguration {
        id
      }
    }
  }
}
    `;
export const CreateInvoiceNoteRuleDocument = gql`
    mutation createInvoiceNoteRule($invoiceNoteRuleInput: InvoiceNoteRuleInput!) {
  createInvoiceNoteRule(invoiceNoteRuleInput: $invoiceNoteRuleInput) {
    ...InvoiceNoteRule
  }
}
    ${InvoiceNoteRuleFragmentDoc}`;
export const DeleteInvoiceNoteRuleDocument = gql`
    mutation deleteInvoiceNoteRule($uuid: String!) {
  deleteInvoiceNoteRule(uuid: $uuid) {
    uuid
  }
}
    `;
export const InvoiceNoteRulesDocument = gql`
    query invoiceNoteRules($first: Int, $after: String, $contactUuid: String) {
  invoiceNoteRules(first: $first, after: $after, contactUuid: $contactUuid) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...InvoiceNoteRule
      }
    }
  }
}
    ${InvoiceNoteRuleFragmentDoc}`;
export const UpdateInvoiceNoteRuleDocument = gql`
    mutation updateInvoiceNoteRule($updateInvoiceNoteRuleInput: UpdateInvoiceNoteRuleInput!) {
  updateInvoiceNoteRule(updateInvoiceNoteRuleInput: $updateInvoiceNoteRuleInput) {
    ...InvoiceNoteRule
  }
}
    ${InvoiceNoteRuleFragmentDoc}`;
export const CreateMasterAccountDocument = gql`
    mutation createMasterAccount($createMasterAccountInput: CreateMasterAccountInput!) {
  createMasterAccount(createMasterAccountInput: $createMasterAccountInput) {
    success
  }
}
    `;
export const MasterAccountsDocument = gql`
    query masterAccounts {
  masterAccounts {
    masterAccounts {
      ...MasterAccount
    }
  }
}
    ${MasterAccountFragmentDoc}`;
export const RemoveMasterAccountDocument = gql`
    mutation removeMasterAccount($uuid: String!) {
  removeMasterAccount(uuid: $uuid) {
    uuid
  }
}
    `;
export const UpdateMasterAccountDocument = gql`
    mutation updateMasterAccount($updateMasterAccountInput: UpdateMasterAccountInput!) {
  updateMasterAccount(updateMasterAccountInput: $updateMasterAccountInput) {
    success
  }
}
    `;
export const CreateSettlementDeductionTypeDocument = gql`
    mutation createSettlementDeductionType($settlementDeductionTypeCreateInput: SettlementDeductionTypeCreateInput!) {
  createSettlementDeductionType(
    settlementDeductionTypeCreateInput: $settlementDeductionTypeCreateInput
  ) {
    ...SettlementDeductionType
  }
}
    ${SettlementDeductionTypeFragmentDoc}`;
export const RemoveSettlementDeductionTypeDocument = gql`
    mutation removeSettlementDeductionType($uuid: String!) {
  removeSettlementDeductionType(uuid: $uuid) {
    ...SettlementDeductionType
  }
}
    ${SettlementDeductionTypeFragmentDoc}`;
export const SettlementDeductionTypesDocument = gql`
    query settlementDeductionTypes {
  settlementDeductionTypes {
    ...SettlementDeductionType
  }
}
    ${SettlementDeductionTypeFragmentDoc}`;
export const UpdateSettlementDeductionTypeDocument = gql`
    mutation updateSettlementDeductionType($settlementDeductionTypeUpdateInput: SettlementDeductionTypeUpdateInput!) {
  updateSettlementDeductionType(
    settlementDeductionTypeInput: $settlementDeductionTypeUpdateInput
  ) {
    ...SettlementDeductionType
  }
}
    ${SettlementDeductionTypeFragmentDoc}`;
export const BulkUploadRouteNamesDocument = gql`
    mutation bulkUploadRouteNames($bulkCsvRouteNameInput: BulkCsvRouteNameInput!) {
  bulkUploadRouteNames(bulkCsvRouteNameInput: $bulkCsvRouteNameInput) {
    uuid
  }
}
    `;
export const BusinessDivisionsDocument = gql`
    query businessDivisions {
  businessDivisions {
    businessDivisions {
      ...FindBusinessDivisions
    }
  }
}
    ${FindBusinessDivisionsFragmentDoc}`;
export const CreateBusinessDivisionDocument = gql`
    mutation createBusinessDivision($createBusinessDivisionInput: CreateBusinessDivisionInput!) {
  createBusinessDivision(
    createBusinessDivisionInput: $createBusinessDivisionInput
  ) {
    success
  }
}
    `;
export const RemoveBusinessDivisionDocument = gql`
    mutation removeBusinessDivision($uuid: String!) {
  removeBusinessDivision(uuid: $uuid) {
    uuid
  }
}
    `;
export const UpdateBusinessDivisionDocument = gql`
    mutation updateBusinessDivision($updateBusinessDivisionInput: UpdateBusinessDivisionInput!) {
  updateBusinessDivision(
    updateBusinessDivisionInput: $updateBusinessDivisionInput
  ) {
    success
  }
}
    `;
export const CompanyDocument = gql`
    query company {
  company {
    uuid
  }
}
    `;
export const CreateCustomDriverFormDocument = gql`
    mutation createCustomDriverForm($createDriverSignableFormTemplateInput: CreateDriverSignableFormTemplateInput!) {
  createDriverSignableFormTemplate(
    createDriverSignableFormTemplateInput: $createDriverSignableFormTemplateInput
  ) {
    uuid
  }
}
    `;
export const CreateEquipmentDocument = gql`
    mutation CreateEquipment($input: CreateEquipmentInput!) {
  createEquipment(createEquipmentInput: $input) {
    uuid
    name
    uuid
  }
}
    `;
export const CreateFuelProfileDocument = gql`
    mutation createFuelProfile($input: CreateFuelProfileInput!) {
  createFuelProfile(createFuelProfileInput: $input) {
    uuid
  }
}
    `;
export const CreateServiceDocument = gql`
    mutation createService($input: CreateServiceInput!) {
  createService(createServiceInput: $input) {
    uuid
    name
  }
}
    `;
export const CustomDriverSignableFormDocument = gql`
    query customDriverSignableForm($uuid: String!) {
  customDriverForm(uuid: $uuid) {
    ...DriverSignableForm
  }
}
    ${DriverSignableFormFragmentDoc}`;
export const CustomDriverSignableFormsDocument = gql`
    query customDriverSignableForms {
  customDriverForms {
    ...DriverSignableForm
  }
}
    ${DriverSignableFormFragmentDoc}`;
export const DeleteCustomDriverFormDocument = gql`
    mutation deleteCustomDriverForm($uuid: String!) {
  deleteDriverSignableFormTemplate(uuid: $uuid) {
    uuid
  }
}
    `;
export const DeleteEquipmentDocument = gql`
    mutation deleteEquipment($uuid: String!) {
  deleteEquipment(uuid: $uuid) {
    uuid
  }
}
    `;
export const DeleteRouteNameLocationDocument = gql`
    mutation deleteRouteNameLocation($uuid: String!) {
  deleteRouteNameLocation(uuid: $uuid) {
    uuid
  }
}
    `;
export const DriversTableDocument = gql`
    query driversTable {
  drivers {
    uuid
    firstName
    lastName
    driverType
    driverPayType
    driverReferenceNumber
    active
    complianceStatus
    terminal {
      uuid
      name
    }
  }
}
    `;
export const ArchiveDriverDocument = gql`
    mutation ArchiveDriver($uuid: String!) {
  archiveDriver(uuid: $uuid) {
    driver {
      uuid
      active
    }
  }
}
    `;
export const ClearDriverSettlementPayBoundDocument = gql`
    mutation ClearDriverSettlementPayBound($input: ClearDriverSettlementPayBoundInput!) {
  clearDriverSettlementPayBound(input: $input) {
    ...DriverSettlementPayBound
  }
}
    ${DriverSettlementPayBoundFragmentDoc}`;
export const CreateDriverCredentialTypeDocument = gql`
    mutation CreateDriverCredentialType($input: CreateDriverCredentialTypeInput!) {
  createDriverCredentialType(input: $input) {
    ...DriverCredentialType
  }
}
    ${DriverCredentialTypeFragmentDoc}`;
export const CreateDriverInsurancePolicyDocument = gql`
    mutation CreateDriverInsurancePolicy($input: CreateDriverInsurancePolicyInput!) {
  createDriverInsurancePolicy(input: $input) {
    ...DriverCompliance
  }
}
    ${DriverComplianceFragmentDoc}`;
export const CreateDriverTrainingRecordDocument = gql`
    mutation CreateDriverTrainingRecord($input: CreateDriverTrainingRecordInput!) {
  createDriverTrainingRecord(input: $input) {
    ...DriverCompliance
  }
}
    ${DriverComplianceFragmentDoc}`;
export const CreateDriverDocument = gql`
    mutation CreateDriver($input: CreateDriverInput!) {
  createDriver(createDriverInput: $input) {
    uuid
    firstName
    lastName
  }
}
    `;
export const DeleteDriverCredentialTypeDocument = gql`
    mutation DeleteDriverCredentialType($input: DeleteDriverCredentialTypeInput!) {
  deleteDriverCredentialType(input: $input)
}
    `;
export const DeleteDriverInsurancePolicyDocument = gql`
    mutation DeleteDriverInsurancePolicy($input: DriverComplianceItemInput!) {
  deleteDriverInsurancePolicy(input: $input) {
    ...DriverCompliance
  }
}
    ${DriverComplianceFragmentDoc}`;
export const DeleteDriverTrainingRecordDocument = gql`
    mutation DeleteDriverTrainingRecord($input: DriverComplianceItemInput!) {
  deleteDriverTrainingRecord(input: $input) {
    ...DriverCompliance
  }
}
    ${DriverComplianceFragmentDoc}`;
export const DriverComplianceDocument = gql`
    query DriverCompliance($input: DriverComplianceDriverInput!) {
  driverCompliance(input: $input) {
    ...DriverCompliance
  }
}
    ${DriverComplianceFragmentDoc}`;
export const DriverCredentialTypesDocument = gql`
    query DriverCredentialTypes($input: GetDriverCredentialTypesInput) {
  driverCredentialTypes(input: $input) {
    ...DriverCredentialType
    inUse
  }
}
    ${DriverCredentialTypeFragmentDoc}`;
export const DriverPhoneNumberAvailabilityDocument = gql`
    query driverPhoneNumberAvailability($phoneNumber: String!) {
  driverPhoneNumberAvailability(phoneNumber: $phoneNumber) {
    available
    sameCompanyDriverName
    sameCompanyDriverUuid
  }
}
    `;
export const DriverQualificationsDocument = gql`
    query DriverQualifications {
  driverQualifications {
    id
    name
  }
}
    `;
export const DriverSettlementPayBoundsDocument = gql`
    query DriverSettlementPayBounds($input: GetDriverSettlementPayBoundsInput!) {
  driverSettlementPayBounds(input: $input) {
    ...DriverSettlementPayBound
  }
}
    ${DriverSettlementPayBoundFragmentDoc}`;
export const DriverDocument = gql`
    query driver($uuid: String!) {
  driver(uuid: $uuid) {
    uuid
    active
    driverPayType
    driverType
    driverReferenceNumber
    emailAddress
    password
    address {
      uuid
      line1
      line2
      city
      country
      name
      state
      zip
      longitude
      latitude
    }
    firstName
    flatRate
    fuelCardNumber
    hourlyRate
    lastName
    notes
    perMileRate
    percentGrossRevenueRate
    defaultFuelSettlementPercentageRate
    defaultAccessorialSettlementPercentageRate
    phoneNumber
    defaultVehicle {
      uuid
      name
    }
    terminal {
      uuid
      name
      code
    }
    qualifications {
      id
      name
    }
    sendRouteUpdateEmails
    defaultOrdinaryTariffChainId
    defaultTransferTariffChainId
    defaultRecoveryTariffChainId
    defaultLineHaulTariffChainId
    defaultPointToPointTariffChainId
  }
}
    `;
export const RehireDriverDocument = gql`
    mutation RehireDriver($input: RehireDriverInput!) {
  rehireDriver(input: $input) {
    ...DriverCompliance
  }
}
    ${DriverComplianceFragmentDoc}`;
export const RestoreDriverDocument = gql`
    mutation RestoreDriver($uuid: String!) {
  restoreDriver(uuid: $uuid) {
    driver {
      uuid
      active
    }
  }
}
    `;
export const SetDriverComplianceDatesDocument = gql`
    mutation SetDriverComplianceDates($input: SetDriverComplianceDatesInput!) {
  setDriverComplianceDates(input: $input) {
    ...DriverCompliance
  }
}
    ${DriverComplianceFragmentDoc}`;
export const SetDriverSettlementPayBoundsDocument = gql`
    mutation SetDriverSettlementPayBounds($input: SetDriverSettlementPayBoundsInput!) {
  setDriverSettlementPayBounds(input: $input) {
    ...DriverSettlementPayBound
  }
}
    ${DriverSettlementPayBoundFragmentDoc}`;
export const TerminateDriverDocument = gql`
    mutation TerminateDriver($input: TerminateDriverInput!) {
  terminateDriver(input: $input) {
    ...DriverCompliance
  }
}
    ${DriverComplianceFragmentDoc}`;
export const UpdateDriverComplianceExpiringSoonDaysDocument = gql`
    mutation UpdateDriverComplianceExpiringSoonDays($input: UpdateCompanyConfigurationInput!) {
  updateCompanyConfiguration(updateCompanyConfigurationInput: $input) {
    uuid
    driverComplianceExpiringSoonDays
  }
}
    `;
export const UpdateDriverComplianceProfileDocument = gql`
    mutation UpdateDriverComplianceProfile($input: UpdateDriverComplianceProfileInput!) {
  updateDriverComplianceProfile(input: $input) {
    ...DriverCompliance
  }
}
    ${DriverComplianceFragmentDoc}`;
export const UpdateDriverCredentialTypeDocument = gql`
    mutation UpdateDriverCredentialType($input: UpdateDriverCredentialTypeInput!) {
  updateDriverCredentialType(input: $input) {
    ...DriverCredentialType
  }
}
    ${DriverCredentialTypeFragmentDoc}`;
export const UpdateDriverInsurancePolicyDocument = gql`
    mutation UpdateDriverInsurancePolicy($input: UpdateDriverInsurancePolicyInput!) {
  updateDriverInsurancePolicy(input: $input) {
    ...DriverCompliance
  }
}
    ${DriverComplianceFragmentDoc}`;
export const UpdateDriverQualificationsDocument = gql`
    mutation UpdateDriverQualifications($input: UpdateDriverQualificationsInput!) {
  updateDriverQualifications(input: $input) {
    driverQualifications {
      id
      name
    }
  }
}
    `;
export const UpdateDriverTrainingRecordDocument = gql`
    mutation UpdateDriverTrainingRecord($input: UpdateDriverTrainingRecordInput!) {
  updateDriverTrainingRecord(input: $input) {
    ...DriverCompliance
  }
}
    ${DriverComplianceFragmentDoc}`;
export const VehicleTypeDocument = gql`
    query VehicleType($uuid: String!) {
  vehicleType(uuid: $uuid) {
    ...VehicleType
  }
}
    ${VehicleTypeFragmentDoc}`;
export const FlipIsArchivedDocument = gql`
    mutation flipIsArchived($uuid: String!) {
  flipIsArchived(uuid: $uuid) {
    ... on StandardAccessorialEntity {
      uuid
    }
    ... on PercentageAccessorialEntity {
      uuid
    }
    ... on WeightBasedAccessorialEntity {
      uuid
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
    }
    ... on WaitTimeAccessorialEntity {
      uuid
    }
    ... on UnitBasedAccessorialEntity {
      uuid
    }
    ... on SkidBasedAccessorialEntity {
      uuid
    }
    ... on SpecialAccessorialEntity {
      uuid
    }
  }
}
    `;
export const CreateFuelProfileDateRangeDocument = gql`
    mutation createFuelProfileDateRange($createFuelProfileDateRangeInput: CreateFuelProfileDateRangeInput!) {
  createFuelProfileDateRange(
    createFuelProfileDateRangeInput: $createFuelProfileDateRangeInput
  ) {
    success
    error
  }
}
    `;
export const DeleteFuelProfileDateRangeDocument = gql`
    mutation deleteFuelProfileDateRange($deleteFuelProfileDateRangeInput: DeleteFuelProfileDateRangeInput!) {
  deleteFuelProfileDateRange(
    deleteFuelProfileDateRangeInput: $deleteFuelProfileDateRangeInput
  ) {
    success
  }
}
    `;
export const FuelProfileDocument = gql`
    query fuelProfile($findFuelProfileInput: FindFuelProfileInput!) {
  fuelProfile(findFuelProfileInput: $findFuelProfileInput) {
    fuelProfile {
      ...FindFuelProfile
    }
  }
}
    ${FindFuelProfileFragmentDoc}`;
export const FuelProfilesDocument = gql`
    query fuelProfiles($contactUuid: String, $orderUuid: String, $excludeContactUuid: String, $type: FuelProfileType) {
  fuelProfiles(
    contactUuid: $contactUuid
    orderUuid: $orderUuid
    excludeContactUuid: $excludeContactUuid
    type: $type
  ) {
    ...FuelProfile
  }
}
    ${FuelProfileFragmentDoc}`;
export const RemoveFuelProfileDocument = gql`
    mutation removeFuelProfile($uuid: String!) {
  removeFuelProfile(uuid: $uuid) {
    uuid
  }
}
    `;
export const UpdateFuelProfileDateRangeDocument = gql`
    mutation updateFuelProfileDateRange($updateFuelProfileDateRangeInput: UpdateFuelProfileDateRangeInput!) {
  updateFuelProfileDateRange(
    updateFuelProfileDateRangeInput: $updateFuelProfileDateRangeInput
  ) {
    success
    error
  }
}
    `;
export const UpdateFuelProfileDocument = gql`
    mutation updateFuelProfile($input: UpdateFuelProfileInput!) {
  updateFuelProfile(updateFuelProfileInput: $input) {
    uuid
  }
}
    `;
export const CreateHoldReasonDocument = gql`
    mutation createHoldReason($holdReasonCreateInput: HoldReasonCreateInput!) {
  createHoldReason(holdReasonCreateInput: $holdReasonCreateInput) {
    ...HoldReason
  }
}
    ${HoldReasonFragmentDoc}`;
export const HoldReasonsDocument = gql`
    query holdReasons($archived: Boolean) {
  holdReasons(archived: $archived) {
    ...HoldReason
  }
}
    ${HoldReasonFragmentDoc}`;
export const UpdateHoldReasonDocument = gql`
    mutation updateHoldReason($holdReasonUpdateInput: HoldReasonUpdateInput!) {
  updateHoldReason(holdReasonUpdateInput: $holdReasonUpdateInput) {
    ...HoldReason
  }
}
    ${HoldReasonFragmentDoc}`;
export const CreateLineHaulLaneDocument = gql`
    mutation createLineHaulLane($createLineHaulLaneInput: CreateLineHaulLaneInput!) {
  createLineHaulLane(createLineHaulLaneInput: $createLineHaulLaneInput) {
    lineHaulLane {
      uuid
    }
    errorMessage
  }
}
    `;
export const LineHaulLaneDocument = gql`
    query lineHaulLane($uuid: String!) {
  lineHaulLane(uuid: $uuid) {
    ...LineHaulLane
  }
}
    ${LineHaulLaneFragmentDoc}`;
export const LineHaulLanesForTerminalsDocument = gql`
    query lineHaulLanesForTerminals {
  lineHaulLanesForTerminals {
    ...ShallowLineHaulLane
  }
}
    ${ShallowLineHaulLaneFragmentDoc}`;
export const LineHaulLanesDocument = gql`
    query lineHaulLanes {
  lineHaulLanes {
    ...ShallowLineHaulLane
  }
}
    ${ShallowLineHaulLaneFragmentDoc}`;
export const UpdateLineHaulLaneDocument = gql`
    mutation updateLineHaulLane($updateLineHaulLaneInput: UpdateLineHaulLaneInput!) {
  updateLineHaulLane(updateLineHaulLaneInput: $updateLineHaulLaneInput) {
    lineHaulLane {
      uuid
    }
    errorMessage
  }
}
    `;
export const MarkOrderAsCancelledDocument = gql`
    mutation markOrderAsCancelled($uuid: String!) {
  markAsCancelled(uuid: $uuid) {
    uuid
  }
}
    `;
export const MarkOrderAsOnHoldDocument = gql`
    mutation markOrderAsOnHold($markAsOnHoldInput: MarkAsOnHoldInput!) {
  markAsOnHold(markAsOnHoldInput: $markAsOnHoldInput) {
    uuid
    status
    detailedStatusV2
  }
}
    `;
export const MinimalServiceRegionsDocument = gql`
    query MinimalServiceRegions($input: GetServiceRegionsInput!) {
  serviceRegions(input: $input) {
    serviceRegions {
      id
      name
      isArchived
    }
  }
}
    `;
export const ArchivePackageSpecDocument = gql`
    mutation ArchivePackageSpec($id: String!) {
  archivePackageSpec(id: $id) {
    packageSpec {
      ...PackageSpec
    }
  }
}
    ${PackageSpecFragmentDoc}`;
export const CreatePackageSpecDocument = gql`
    mutation CreatePackageSpec($createPackageSpecInput: CreatePackageSpecInput!) {
  createPackageSpec(createPackageSpecInput: $createPackageSpecInput) {
    packageSpec {
      ...PackageSpec
    }
  }
}
    ${PackageSpecFragmentDoc}`;
export const PackageSpecDocument = gql`
    query PackageSpec($id: String!) {
  packageSpec(id: $id) {
    ...PackageSpec
  }
}
    ${PackageSpecFragmentDoc}`;
export const PackageSpecsMinimalDocument = gql`
    query PackageSpecsMinimal {
  packageSpecs {
    packageSpecs {
      id
      name
      status
      freightClass
    }
  }
}
    `;
export const RestorePackageSpecDocument = gql`
    mutation RestorePackageSpec($id: String!) {
  restorePackageSpec(id: $id) {
    packageSpec {
      ...PackageSpec
    }
  }
}
    ${PackageSpecFragmentDoc}`;
export const UpdatePackageSpecDocument = gql`
    mutation UpdatePackageSpec($updatePackageSpecInput: UpdatePackageSpecInput!) {
  updatePackageSpec(updatePackageSpecInput: $updatePackageSpecInput) {
    packageSpec {
      ...PackageSpec
    }
  }
}
    ${PackageSpecFragmentDoc}`;
export const CompanyPackageTypeConfigsDocument = gql`
    query CompanyPackageTypeConfigs {
  companyPackageTypeConfigs {
    companyPackageTypeConfigs {
      ...CompanyPackageTypeConfig
    }
  }
}
    ${CompanyPackageTypeConfigFragmentDoc}`;
export const UpsertCompanyPackageTypeConfigDocument = gql`
    mutation UpsertCompanyPackageTypeConfig($input: UpsertCompanyPackageTypeConfigInput!) {
  upsertCompanyPackageTypeConfig(input: $input) {
    companyPackageTypeConfig {
      ...CompanyPackageTypeConfig
    }
  }
}
    ${CompanyPackageTypeConfigFragmentDoc}`;
export const RecoveryTerminalsDocument = gql`
    query RecoveryTerminals {
  airportInfos {
    ...RecoveryTerminal
  }
}
    ${RecoveryTerminalFragmentDoc}`;
export const CreateRecoveryTerminalDocument = gql`
    mutation CreateRecoveryTerminal($iataCode: String, $terminal: String!, $addressUuid: String!, $companyUuid: String!) {
  createAirportInfo(
    createAirportInfoInput: {iataCode: $iataCode, terminal: $terminal, addressUuid: $addressUuid, companyUuid: $companyUuid}
  ) {
    uuid
    address {
      ...Address
    }
  }
}
    ${AddressFragmentDoc}`;
export const UpdateRecoveryTerminalDocument = gql`
    mutation UpdateRecoveryTerminal($uuid: String!, $iataCode: String, $terminal: String, $addressUuid: String) {
  updateAirportInfo(
    updateAirportInfoInput: {uuid: $uuid, iataCode: $iataCode, terminal: $terminal, addressUuid: $addressUuid}
  ) {
    uuid
  }
}
    `;
export const RestoreRecoveryTerminalDocument = gql`
    mutation RestoreRecoveryTerminal($uuid: String!) {
  restoreAirportInfo(uuid: $uuid) {
    airportInfo {
      uuid
      isArchived
    }
  }
}
    `;
export const RouteAutomationSettingsDocument = gql`
    query routeAutomationSettings {
  routeAutomationSettings {
    uuid
    autoCreateRoutes
    autoPopulateRoutes
    autoAssignTrucks
    dueDateSource
    pickupOrDelivery
    serviceUuids
    includeTagUuids
    excludeTagUuids
  }
}
    `;
export const RouteNameDocument = gql`
    query routeName($uuid: String!) {
  routeName(uuid: $uuid) {
    uuid
    name
    routeNameLocations {
      uuid
      zipcode
      city
    }
  }
}
    `;
export const RouteNamesDocument = gql`
    query routeNames {
  routeNames {
    uuid
    name
  }
}
    `;
export const ServicesForThirdPartyUserDocument = gql`
    query servicesForThirdPartyUser($findServicesForThirdPartyUserInput: FindServicesForThirdPartyUserInput!) {
  servicesForThirdPartyUser(
    findServicesForThirdPartyUserInput: $findServicesForThirdPartyUserInput
  ) {
    ...ServiceForThirdPartyUser
  }
}
    ${ServiceForThirdPartyUserFragmentDoc}`;
export const CreateTerminalLanesDocument = gql`
    mutation createTerminalLanes($input: CreateTerminalLanesInput!) {
  createTerminalLanes(input: $input) {
    __typename
    ... on CreateTerminalLanesSuccessOutput {
      terminalLanes {
        id
        startTerminal {
          uuid
        }
        endTerminal {
          uuid
        }
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CreateTerminalServiceAreasV2Document = gql`
    mutation createTerminalServiceAreasV2($createTerminalServiceAreaInputs: [CreateTerminalServiceAreaInput!]!) {
  createTerminalServiceAreasV2(
    createTerminalServiceAreaInputs: $createTerminalServiceAreaInputs
  ) {
    createdCount
  }
}
    `;
export const CreateTerminalDocument = gql`
    mutation createTerminal($input: TerminalCreateInput!) {
  createTerminalV2(input: $input) {
    __typename
    ... on CreateTerminalSuccessOutput {
      terminal {
        uuid
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const DeleteTerminalLanesDocument = gql`
    mutation deleteTerminalLanes($input: DeleteTerminalLanesInput!) {
  deleteTerminalLanes(input: $input) {
    __typename
    ... on DeleteTerminalLanesSuccessOutput {
      terminalLanes {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RemoveTerminalServiceAreaDocument = gql`
    mutation removeTerminalServiceArea($uuid: String!) {
  removeTerminalServiceArea(uuid: $uuid) {
    uuid
  }
}
    `;
export const TerminalDocument = gql`
    query terminal($uuid: String!) {
  terminal(uuid: $uuid) {
    ...Terminal
  }
}
    ${TerminalFragmentDoc}`;
export const TerminalsForThirdPartyUserDocument = gql`
    query terminalsForThirdPartyUser($findTerminalsForThirdPartyUserInput: FindTerminalsForThirdPartyUserInput!) {
  terminalsForThirdPartyUser(
    findTerminalsForThirdPartyUserInput: $findTerminalsForThirdPartyUserInput
  ) {
    ...ShallowTerminal
  }
}
    ${ShallowTerminalFragmentDoc}`;
export const TerminalsDocument = gql`
    query terminals($getTerminalsInput: GetTerminalsInput) {
  terminals(getTerminalsInput: $getTerminalsInput) {
    ...ShallowTerminal
  }
}
    ${ShallowTerminalFragmentDoc}`;
export const UpdateTerminalDocument = gql`
    mutation updateTerminal($input: TerminalUpdateInput!) {
  updateTerminalV2(input: $input) {
    __typename
    ... on UpdateTerminalSuccessOutput {
      terminal {
        ...Terminal
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${TerminalFragmentDoc}`;
export const CreateThirdPartyBrokerDocument = gql`
    mutation createThirdPartyBroker($thirdPartyBrokerCreateInput: ThirdPartyBrokerCreateInput!) {
  createThirdPartyBroker(
    thirdPartyBrokerCreateInput: $thirdPartyBrokerCreateInput
  ) {
    ...ThirdPartyBroker
  }
}
    ${ThirdPartyBrokerFragmentDoc}`;
export const RemoveThirdPartyBrokerDocument = gql`
    mutation removeThirdPartyBroker($uuid: String!) {
  removeThirdPartyBroker(uuid: $uuid) {
    ...ThirdPartyBroker
  }
}
    ${ThirdPartyBrokerFragmentDoc}`;
export const ThirdPartyBrokersDocument = gql`
    query thirdPartyBrokers {
  thirdPartyBrokers {
    ...ThirdPartyBroker
  }
}
    ${ThirdPartyBrokerFragmentDoc}`;
export const UpdateThirdPartyBrokerDocument = gql`
    mutation updateThirdPartyBroker($thirdPartyBrokerUpdateInput: ThirdPartyBrokerUpdateInput!) {
  updateThirdPartyBroker(
    thirdPartyBrokerUpdateInput: $thirdPartyBrokerUpdateInput
  ) {
    ...ThirdPartyBroker
  }
}
    ${ThirdPartyBrokerFragmentDoc}`;
export const UpdateCustomDriverFormDocument = gql`
    mutation updateCustomDriverForm($updateDriverSignableFormTemplateInput: UpdateDriverSignableFormTemplateInput!) {
  updateDriverSignableFormTemplate(
    updateDriverSignableFormTemplateInput: $updateDriverSignableFormTemplateInput
  ) {
    uuid
  }
}
    `;
export const UpdateDriverDocument = gql`
    mutation UpdateDriver($input: UpdateDriverInput!) {
  updateDriver(updateDriverInput: $input) {
    firstName
    lastName
    uuid
  }
}
    `;
export const UpdateEquipmentDocument = gql`
    mutation UpdateEquipment($input: UpdateEquipmentInput!) {
  updateEquipment(updateEquipmentInput: $input) {
    name
    uuid
  }
}
    `;
export const UpdateServiceDocument = gql`
    mutation updateService($input: UpdateServiceInput!) {
  updateService(updateServiceInput: $input) {
    uuid
    name
  }
}
    `;
export const UpdateTemplateAndRecordAddressesDocument = gql`
    mutation updateTemplateAndRecordAddresses($updateAddressInput: UpdateAddressInput!) {
  updateTemplateAndRecordAddresses(updateAddressInput: $updateAddressInput) {
    uuid
  }
}
    `;
export const UpsertRouteAutomationSettingsDocument = gql`
    mutation upsertRouteAutomationSettings($input: RouteAutomationSettingsInput!) {
  upsertRouteAutomationSettings(input: $input) {
    uuid
    autoCreateRoutes
    autoPopulateRoutes
    autoAssignTrucks
    dueDateSource
    pickupOrDelivery
    serviceUuids
    includeTagUuids
    excludeTagUuids
  }
}
    `;
export const CreateUserV2Document = gql`
    mutation CreateUserV2($createUserInput: CreateUserInput!) {
  createUserV2(createUserInput: $createUserInput) {
    ... on CreateUserSuccessOutput {
      user {
        uuid
      }
    }
    ... on ArchivedUserExistsOutput {
      archivedUserUuid
      message
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ReactivateUserDocument = gql`
    mutation ReactivateUser($uuid: String!) {
  reactivateUser(uuid: $uuid) {
    uuid
    isActive
  }
}
    `;
export const ReportsEmailSenderIsVerifiedDocument = gql`
    query reportsEmailSenderIsVerified($userUuid: String!) {
  reportsEmailSenderIsVerified(userUuid: $userUuid)
}
    `;
export const UpdateUserDocument = gql`
    mutation UpdateUser($updateUserInput: UpdateUserInput!) {
  updateUser(updateUserInput: $updateUserInput) {
    uuid
    terminal {
      uuid
    }
  }
}
    `;
export const UpdateUserReportsEmailDocument = gql`
    mutation updateUserReportsEmail($userUuid: String!, $email: String!) {
  updateReportsEmail(userUuid: $userUuid, email: $email) {
    uuid
    reportsEmailSendgridSenderId
  }
}
    `;
export const UserOptionsDocument = gql`
    query userOptions($getUsersInput: GetUsersInput) {
  userOptions(getUsersInput: $getUsersInput) {
    uuid
    name
    email
  }
}
    `;
export const UsersDocument = gql`
    query users($getUsersInput: GetUsersInput) {
  users(getUsersInput: $getUsersInput) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const ArchiveVehicleTypeDocument = gql`
    mutation ArchiveVehicleType($uuid: String!) {
  archiveVehicleType(uuid: $uuid) {
    vehicleType {
      ...VehicleType
    }
  }
}
    ${VehicleTypeFragmentDoc}`;
export const CreateVehicleTypeDocument = gql`
    mutation createVehicleType($vehicleTypeCreateInput: VehicleTypeCreateInput!) {
  createVehicleType(vehicleTypeCreateInput: $vehicleTypeCreateInput) {
    ...VehicleType
  }
}
    ${VehicleTypeFragmentDoc}`;
export const RestoreVehicleTypeDocument = gql`
    mutation RestoreVehicleType($uuid: String!) {
  restoreVehicleType(uuid: $uuid) {
    vehicleType {
      ...VehicleType
    }
  }
}
    ${VehicleTypeFragmentDoc}`;
export const UpdateVehicleTypeDocument = gql`
    mutation updateVehicleType($vehicleTypeUpdateInput: VehicleTypeUpdateInput!) {
  updateVehicleType(vehicleTypeUpdateInput: $vehicleTypeUpdateInput) {
    ...VehicleType
  }
}
    ${VehicleTypeFragmentDoc}`;
export const VehicleTypesMinimalDocument = gql`
    query VehicleTypesMinimal {
  vehicleTypes {
    uuid
    name
    status
  }
}
    `;
export const ArchiveWarehouseEmployeeDocument = gql`
    mutation archiveWarehouseEmployee($uuid: String!) {
  archiveWarehouseEmployee(uuid: $uuid) {
    warehouseEmployee {
      uuid
      isArchived
      active
    }
  }
}
    `;
export const RestoreWarehouseEmployeeDocument = gql`
    mutation restoreWarehouseEmployee($uuid: String!) {
  restoreWarehouseEmployee(uuid: $uuid) {
    warehouseEmployee {
      uuid
      isArchived
      active
    }
  }
}
    `;
export const CreateWarehouseEmployeeDocument = gql`
    mutation createWarehouseEmployee($createWarehouseEmployeeInput: CreateWarehouseEmployeeInput!) {
  createWarehouseEmployee(
    createWarehouseEmployeeInput: $createWarehouseEmployeeInput
  ) {
    warehouseEmployee {
      ...CreatedWarehouseEmployee
    }
  }
}
    ${CreatedWarehouseEmployeeFragmentDoc}`;
export const WarehouseEmployeesDocument = gql`
    query warehouseEmployees {
  warehouseEmployees {
    warehouseEmployees {
      ...WarehouseEmployee
    }
  }
}
    ${WarehouseEmployeeFragmentDoc}`;
export const UpdateWarehouseEmployeeDocument = gql`
    mutation updateWarehouseEmployee($updateWarehouseEmployeeInput: UpdateWarehouseEmployeeInput!) {
  updateWarehouseEmployee(
    updateWarehouseEmployeeInput: $updateWarehouseEmployeeInput
  ) {
    warehouseEmployee {
      ...UpdatedWarehouseEmployee
    }
  }
}
    ${UpdatedWarehouseEmployeeFragmentDoc}`;
export const MotiveIntegrationDocument = gql`
    query motiveIntegration {
  motiveIntegration {
    connected
  }
}
    `;
export const RemoveMotiveApiKeyDocument = gql`
    mutation removeMotiveApiKey {
  removeMotiveApiKey {
    connected
  }
}
    `;
export const SetMotiveApiKeyDocument = gql`
    mutation setMotiveApiKey($input: SetMotiveApiKeyInput!) {
  setMotiveApiKey(input: $input) {
    connected
  }
}
    `;
export const AcknowledgeNotificationDocument = gql`
    mutation acknowledgeNotification($uuid: String!) {
  acknowledgeNotification(uuid: $uuid) {
    uuid
  }
}
    `;
export const AcknowledgeNotificationsDocument = gql`
    mutation acknowledgeNotifications($uuids: [String!]!) {
  acknowledgeNotifications(uuids: $uuids) {
    uuid
  }
}
    `;
export const InAppNotificationsDocument = gql`
    query inAppNotifications($first: Int, $after: String) {
  inAppNotifications(first: $first, after: $after) {
    edges {
      cursor
      node {
        ...InAppNotification
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${InAppNotificationFragmentDoc}`;
export const MarkAllInAppNotificationsReadDocument = gql`
    mutation markAllInAppNotificationsRead {
  markAllInAppNotificationsRead
}
    `;
export const MarkNotificationReadDocument = gql`
    mutation markNotificationRead($input: MarkNotificationReadInput!) {
  markNotificationRead(input: $input)
}
    `;
export const NotificationsDocument = gql`
    query notifications($specialWindowsDate: DateTime) {
  notifications {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;
export const UnreadInAppNotificationsCountDocument = gql`
    query unreadInAppNotificationsCount {
  unreadInAppNotificationsCount
}
    `;
export const OperationsPerformanceReportCsvDocument = gql`
    query OperationsPerformanceReportCsv($args: OperationsPerformanceFilterArgs!) {
  operationsPerformanceReportCsv(args: $args) {
    url
    fileName
    errors
  }
}
    `;
export const OperationsPerformanceSummaryDocument = gql`
    query OperationsPerformanceSummary($args: OperationsPerformanceFilterArgs!) {
  operationsPerformanceSummary(args: $args) {
    orders
    timezone
    orderToDelivered {
      ...OperationsPerformanceDurationFields
    }
    intervals {
      key
      meanSeconds
      medianSeconds
      p90Seconds
      countedOrders
      backwardOrders
      prior {
        medianSeconds
        countedOrders
      }
    }
    trend {
      unit
      points {
        bucketDate
        medianSeconds
        p90Seconds
        countedOrders
        backwardOrders
      }
    }
    byCustomer {
      ...OperationsPerformanceGroupFields
    }
    byTerminal {
      ...OperationsPerformanceGroupFields
    }
    slowestOrders {
      orderUuid
      orderName
      customerName
      terminalCode
      totalSeconds
      longestInterval {
        key
        seconds
      }
    }
    signals {
      updatedOrders
      byMethod {
        method
        orders
      }
      inboundPieces
      inboundScannedPieces
      outboundPieces
      outboundScannedPieces
    }
    outliers {
      measure
      orders {
        orderUuid
        orderName
        customerName
        fromAt
        toAt
        seconds
      }
    }
  }
}
    ${OperationsPerformanceDurationFieldsFragmentDoc}
${OperationsPerformanceGroupFieldsFragmentDoc}`;
export const OperationsPerformanceReportDocument = gql`
    query OperationsPerformanceReport($args: OperationsPerformancePageArgs!) {
  operationsPerformanceReport(args: $args) {
    totalCount
    timezone
    rows {
      orderUuid
      orderName
      customerName
      accountId
      hawb
      source
      sourceIsEmail
      lastCustomerUpdateAt
      lastCustomerUpdateMethod
      createdAt
      inboundName
      inboundDispatchedAt
      createdToInboundDispatchSeconds
      inboundCompletedAt
      inboundDispatchToCompletionSeconds
      inboundScannedPieceCount
      outboundName
      outboundDispatchedAt
      inboundCompletionToOutboundDispatchSeconds
      outboundCompletedAt
      outboundDispatchToCompletionSeconds
      outboundScannedPieceCount
      pieceCount
      completedAt
    }
  }
}
    `;
export const EdiTransactionPayloadByUuidDocument = gql`
    query EdiTransactionPayloadByUuid($uuid: String!) {
  ediTransactionPayloadByUuid(uuid: $uuid)
}
    `;
export const ExternalApiTransmissionPayloadByOrderEventUuidDocument = gql`
    query ExternalApiTransmissionPayloadByOrderEventUuid($orderEventUuid: String!) {
  externalApiTransmissionPayloadByOrderEventUuid(orderEventUuid: $orderEventUuid)
}
    `;
export const OrderAuditLogEntriesDocument = gql`
    query orderAuditLogEntries($getOrderAuditLogEntriesInput: GetOrderAuditLogEntriesInput!) {
  orderAuditLogEntries(
    getOrderAuditLogEntriesInput: $getOrderAuditLogEntriesInput
  ) {
    auditLogEntries {
      ...AuditLogEntry
    }
  }
}
    ${AuditLogEntryFragmentDoc}`;
export const OrderEventSnapshotsDocument = gql`
    query orderEventSnapshots($orderUuid: String!, $eventType: OrderEventType, $sortByCreatedAtAsc: Boolean) {
  orderEvents(
    orderUuid: $orderUuid
    eventType: $eventType
    sortByCreatedAtAsc: $sortByCreatedAtAsc
  ) {
    ...OrderEventSnapshot
  }
}
    ${OrderEventSnapshotFragmentDoc}`;
export const OrderEventsDocument = gql`
    query orderEvents($orderUuid: String, $storageOrderUuid: String) {
  orderEvents(orderUuid: $orderUuid, storageOrderUuid: $storageOrderUuid) {
    ...OrderEvent
    sourcePicklist {
      id
      outboundReferenceNumber
      picklistItemGroups(storageOrderUuid: $storageOrderUuid) {
        ...PicklistItemGroup
      }
    }
  }
}
    ${OrderEventFragmentDoc}
${PicklistItemGroupFragmentDoc}`;
export const ResendExternalTransmissionDocument = gql`
    mutation ResendExternalTransmission($input: ResendExternalTransmissionInput!) {
  resendExternalTransmission(input: $input)
}
    `;
export const BulkDelegateOrdersDocument = gql`
    mutation bulkDelegateOrders($input: BulkDelegateOrdersInput!) {
  bulkDelegateOrders(input: $input) {
    ...BulkDelegationBatch
  }
}
    ${BulkDelegationBatchFragmentDoc}`;
export const BulkDelegationBatchDocument = gql`
    query bulkDelegationBatch($batchUuid: String!) {
  bulkDelegationBatch(batchUuid: $batchUuid) {
    ...BulkDelegationBatch
  }
}
    ${BulkDelegationBatchFragmentDoc}`;
export const EmailIngestionExclusionsDocument = gql`
    query emailIngestionExclusions {
  emailIngestionExclusions {
    excludedCustomers {
      uuid
      displayName
    }
    excludedDocumentTypes
  }
}
    `;
export const EmailProcessingHistoryDocument = gql`
    query emailProcessingHistory($findIngestedOutlookEmailsInput: FindIngestedOutlookEmailsInput!) {
  ingestedOutlookEmails(
    findIngestedOutlookEmailsInput: $findIngestedOutlookEmailsInput
  ) {
    edges {
      node {
        uuid
        createdAt
        subject
        effectiveSenderAddress
        outlookReceivedDateTime
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const IngestedEmailOrderByOrderUuidDocument = gql`
    query ingestedEmailOrderByOrderUuid($uuid: String!) {
  scannedOrderResultByOrderUuid(uuid: $uuid) {
    uuid
    scannedOrder {
      ingestedOutlookEmailDetails {
        attachmentUuid
        fromAddress
        subject
      }
    }
  }
}
    `;
export const IngestedEmailOrdersDocument = gql`
    query ingestedEmailOrders($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $contactUuid: String, $contactFilterMode: CustomerFilterMode, $originTerminalUuid: String, $destinationTerminalUuid: String, $emailIntegrationTerminalUuid: String) {
  numberOfScannedOrderResultsInReview(
    searchText: $searchText
    sourceFilter: EMAIL_INTEGRATION
    contactUuid: $contactUuid
    contactFilterMode: $contactFilterMode
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
    emailIntegrationTerminalUuid: $emailIntegrationTerminalUuid
  )
  numberOfScannedOrderResultDuplicates(
    searchText: $searchText
    sourceFilter: EMAIL_INTEGRATION
    contactUuid: $contactUuid
    contactFilterMode: $contactFilterMode
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
    emailIntegrationTerminalUuid: $emailIntegrationTerminalUuid
  )
  scannedOrderResults(
    first: $first
    after: $after
    last: $last
    before: $before
    searchText: $searchText
    type: ORDER
    statuses: [IN_REVIEW]
    sourceFilter: EMAIL_INTEGRATION
    emailIntegrationTerminalUuid: $emailIntegrationTerminalUuid
    contactUuid: $contactUuid
    contactFilterMode: $contactFilterMode
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
  ) {
    edges {
      node {
        uuid
        createdAt
        duplicateOrder {
          uuid
          source
        }
        duplicateScannedOrderResultOrder {
          uuid
          source
        }
        status
        signedPodMatchStatus
        failureReason
        dismissed
        filename
        pageEnd
        pageStart
        order {
          uuid
          name
          source
          billingPartyContact {
            uuid
            displayName
          }
          standardOrderFields {
            shipperBillOfLadingNumber
          }
        }
        scannedOrder {
          ingestedOutlookEmailDetails {
            attachmentUuid
            fromAddress
            subject
            outlookIntegrationTerminal {
              uuid
              code
            }
          }
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const IngestedOutlookEmailDocument = gql`
    query ingestedOutlookEmail($uuid: String!) {
  ingestedOutlookEmail(uuid: $uuid) {
    uuid
    subject
    attachments {
      uuid
      attachmentFilename
      processingStatus
      scannedOrder {
        uuid
        preSignedGetUrl
        scannedOrderResults {
          uuid
          filename
          pageStart
          pageEnd
          status
          failureReason
          order {
            uuid
          }
          duplicateOrder {
            uuid
            source
          }
          duplicateScannedOrderResultOrder {
            uuid
            source
          }
          scannedOrderResultDocuments {
            uuid
            preSignedGetUrl
            scannedOrderResultDocumentPages {
              uuid
              page
            }
          }
        }
      }
    }
  }
}
    `;
export const OutlookIntegrationsDocument = gql`
    query outlookIntegrations {
  outlookIntegrations {
    uuid
    terminal {
      uuid
      code
    }
  }
}
    `;
export const UpdateEmailIngestionExclusionsDocument = gql`
    mutation updateEmailIngestionExclusions($updateEmailIngestionExclusionsInput: UpdateEmailIngestionExclusionsInput!) {
  updateEmailIngestionExclusions(
    updateEmailIngestionExclusionsInput: $updateEmailIngestionExclusionsInput
  ) {
    excludedCustomers {
      uuid
      displayName
    }
    excludedDocumentTypes
  }
}
    `;
export const AcceptCustomerPortalOrderDocument = gql`
    mutation acceptCustomerPortalOrder($acceptCustomerPortalOrderInput: AcceptCustomerPortalOrderInput!) {
  acceptCustomerPortalOrder(
    acceptCustomerPortalOrderInput: $acceptCustomerPortalOrderInput
  ) {
    ... on AcceptCustomerPortalOrderSuccessOutput {
      orderUuid
      acceptedAt
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RejectCustomerPortalOrderDocument = gql`
    mutation rejectCustomerPortalOrder($rejectCustomerPortalOrderInput: RejectCustomerPortalOrderInput!) {
  rejectCustomerPortalOrder(
    rejectCustomerPortalOrderInput: $rejectCustomerPortalOrderInput
  ) {
    ... on RejectCustomerPortalOrderSuccessOutput {
      orderUuid
      rejectedAt
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const AcceptEdiOrApiOrderDocument = gql`
    mutation acceptEdiOrApiOrder($acceptEdiOrApiOrderInput: AcceptEdiOrApiOrderInput!) {
  acceptEdiOrApiOrder(acceptEdiOrApiOrderInput: $acceptEdiOrApiOrderInput) {
    uuid
  }
}
    `;
export const AcceptExpeditorsWorkOrderDocument = gql`
    mutation acceptExpeditorsWorkOrder($orderUuid: String!) {
  acceptExpeditorsWorkOrder(orderUuid: $orderUuid)
}
    `;
export const RejectEdiOrderDocument = gql`
    mutation rejectEdiOrder($rejectEdiOrderInput: RejectEdiOrderInput!) {
  rejectEdiOrder(rejectEdiOrderInput: $rejectEdiOrderInput) {
    uuid
  }
}
    `;
export const RejectEdiOrdersDocument = gql`
    mutation rejectEdiOrders($rejectEdiOrdersInput: RejectEdiOrdersInput!) {
  rejectEdiOrders(rejectEdiOrdersInput: $rejectEdiOrdersInput) {
    __typename
    ... on RejectEdiOrdersSuccess {
      successfulOrderUuids
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RejectExpeditorsWorkOrderDocument = gql`
    mutation rejectExpeditorsWorkOrder($orderUuid: String!, $reason: String) {
  rejectExpeditorsWorkOrder(orderUuid: $orderUuid, reason: $reason)
}
    `;
export const AcknowledgeQuoteAttentionDocument = gql`
    mutation acknowledgeQuoteAttention($acknowledgeQuoteAttentionInput: AcknowledgeQuoteAttentionInput!) {
  acknowledgeQuoteAttention(
    acknowledgeQuoteAttentionInput: $acknowledgeQuoteAttentionInput
  ) {
    __typename
    ... on AcknowledgeQuoteAttentionSuccessOutput {
      orderQuoteUuid
      status
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ApproveQuoteReplyDocument = gql`
    mutation approveQuoteReply($approveQuoteReplyInput: ApproveQuoteReplyInput!) {
  approveQuoteReply(approveQuoteReplyInput: $approveQuoteReplyInput) {
    __typename
    ... on ApproveQuoteReplySuccessOutput {
      orderQuoteUuid
      draftReplyUuid
      approvedAt
    }
    ... on QuoteReplyRefusedOutput {
      orderQuoteUuid
      reason
      message
      quotedAmountCents
      currentAmountCents
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ConfirmQuoteAcceptanceDocument = gql`
    mutation confirmQuoteAcceptance($confirmQuoteAcceptanceInput: ConfirmQuoteAcceptanceInput!) {
  confirmQuoteAcceptance(
    confirmQuoteAcceptanceInput: $confirmQuoteAcceptanceInput
  ) {
    __typename
    ... on ConfirmQuoteAcceptanceSuccessOutput {
      orderQuoteUuid
      status
      orderUuid
    }
    ... on QuoteAcceptanceHeldOutput {
      orderQuoteUuid
      reason
      message
      quotedAmountCents
      currentAmountCents
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const DeclineQuoteDocument = gql`
    mutation declineQuote($declineQuoteInput: DeclineQuoteInput!) {
  declineQuote(declineQuoteInput: $declineQuoteInput) {
    __typename
    ... on DeclineQuoteSuccessOutput {
      orderQuoteUuid
      status
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const DismissQuoteDocument = gql`
    mutation dismissQuote($dismissQuoteInput: DismissQuoteInput!) {
  dismissQuote(dismissQuoteInput: $dismissQuoteInput) {
    __typename
    ... on DismissQuoteSuccessOutput {
      orderQuoteUuid
      status
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const MarkQuoteSentDocument = gql`
    mutation markQuoteSent($markQuoteSentInput: MarkQuoteSentInput!) {
  markQuoteSent(markQuoteSentInput: $markQuoteSentInput) {
    __typename
    ... on MarkQuoteSentSuccessOutput {
      orderQuoteUuid
      status
      sentAt
      validUntil
      quotedAmountCents
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const OrderQuoteForOrderDocument = gql`
    query orderQuoteForOrder($orderUuid: String!) {
  orderQuoteForOrder(orderUuid: $orderUuid) {
    ...OrderQuoteForReview
  }
}
    ${OrderQuoteForReviewFragmentDoc}`;
export const OrderQuotesNeedingActionCountDocument = gql`
    query orderQuotesNeedingActionCount {
  orderQuotesNeedingActionCount
}
    `;
export const PickQuoteCustomerDocument = gql`
    mutation pickQuoteCustomer($pickQuoteCustomerInput: PickQuoteCustomerInput!) {
  pickQuoteCustomer(pickQuoteCustomerInput: $pickQuoteCustomerInput) {
    __typename
    ... on PickQuoteCustomerSuccessOutput {
      orderQuote {
        uuid
        status
        order {
          uuid
          name
        }
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const QuoteConversationDocument = gql`
    query quoteConversation($orderQuoteUuid: String!) {
  quoteConversation(orderQuoteUuid: $orderQuoteUuid) {
    __typename
    uuid
    subject
    status
    createdAt
    lastInboundAt
    lastOutboundAt
    messageCount
    messagesTruncated
    messages {
      __typename
      uuid
      direction
      from {
        address
        name
      }
      originalSender {
        address
        name
      }
      senderRecoveredFromForward
      to
      cc
      subject
      receivedAt
      classification
      bodyText
      bodyTruncated
      bodyState
      attachments {
        filename
        contentType
      }
    }
  }
}
    `;
export const RejectQuoteReplyDocument = gql`
    mutation rejectQuoteReply($rejectQuoteReplyInput: RejectQuoteReplyInput!) {
  rejectQuoteReply(rejectQuoteReplyInput: $rejectQuoteReplyInput) {
    __typename
    ... on RejectQuoteReplySuccessOutput {
      orderQuoteUuid
    }
    ... on QuoteReplyRefusedOutput {
      orderQuoteUuid
      reason
      message
      quotedAmountCents
      currentAmountCents
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const RequestQuoteRepriceDocument = gql`
    mutation requestQuoteReprice($requestQuoteRepriceInput: RequestQuoteRepriceInput!) {
  requestQuoteReprice(requestQuoteRepriceInput: $requestQuoteRepriceInput) {
    __typename
    ... on RequestQuoteRepriceSuccessOutput {
      orderQuote {
        ...OrderQuoteForReview
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${OrderQuoteForReviewFragmentDoc}`;
export const RequoteQuoteAtCurrentPriceDocument = gql`
    mutation requoteQuoteAtCurrentPrice($requoteQuoteAtCurrentPriceInput: RequoteQuoteAtCurrentPriceInput!) {
  requoteQuoteAtCurrentPrice(
    requoteQuoteAtCurrentPriceInput: $requoteQuoteAtCurrentPriceInput
  ) {
    __typename
    ... on RequoteQuoteAtCurrentPriceSuccessOutput {
      orderQuoteUuid
      supersededOrderQuoteUuid
      version
    }
    ... on QuoteReplyRefusedOutput {
      orderQuoteUuid
      reason
      message
      quotedAmountCents
      currentAmountCents
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ResolveQuoteReplySendDocument = gql`
    mutation resolveQuoteReplySend($resolveQuoteReplySendInput: ResolveQuoteReplySendInput!) {
  resolveQuoteReplySend(resolveQuoteReplySendInput: $resolveQuoteReplySendInput) {
    __typename
    ... on ResolveQuoteReplySendSuccessOutput {
      orderQuoteUuid
      draftReplyUuid
      outcome
    }
    ... on QuoteReplyRefusedOutput {
      orderQuoteUuid
      reason
      message
      quotedAmountCents
      currentAmountCents
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const AccessorialForCustomChargeRowDocument = gql`
    query accessorialForCustomChargeRow($uuid: String!) {
  accessorial(uuid: $uuid) {
    ... on StandardAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on PercentageAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on WeightBasedAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on WaitTimeAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on UnitBasedAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on SkidBasedAccessorialEntity {
      uuid
      isArchived
      name
    }
    ... on SpecialAccessorialEntity {
      uuid
      isArchived
      name
    }
  }
}
    `;
export const AccessorialsForCustomChargeRowDocument = gql`
    query accessorialsForCustomChargeRow($billingPartyContactUuid: String!, $terminalUuid: String) {
  accessorialsByBillingContact(
    billingPartyContactUuid: $billingPartyContactUuid
    terminalUuid: $terminalUuid
  ) {
    ... on StandardAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on PercentageAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on WeightBasedAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on ZoneBasedAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on WaitTimeAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on UnitBasedAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on SkidBasedAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on SpecialAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on AttemptsAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
    ... on StorageDaysAccessorialEntity {
      uuid
      name
      enableQuickAdd
    }
  }
}
    `;
export const ApplyDelegationAccessorialProposalDocument = gql`
    mutation applyDelegationAccessorialProposal($input: ApplyDelegationAccessorialProposalInput!) {
  applyDelegationAccessorialProposal(input: $input) {
    ...DelegationAccessorialProposalFields
  }
}
    ${DelegationAccessorialProposalFieldsFragmentDoc}`;
export const DelegationAccessorialProposalsDocument = gql`
    query delegationAccessorialProposals($orderUuid: String!) {
  delegationAccessorialProposals(orderUuid: $orderUuid) {
    ...DelegationAccessorialProposalFields
  }
}
    ${DelegationAccessorialProposalFieldsFragmentDoc}`;
export const DismissDelegationAccessorialProposalDocument = gql`
    mutation dismissDelegationAccessorialProposal($input: DismissDelegationAccessorialProposalInput!) {
  dismissDelegationAccessorialProposal(input: $input) {
    ...DelegationAccessorialProposalFields
  }
}
    ${DelegationAccessorialProposalFieldsFragmentDoc}`;
export const PiecesGroupedByStatusDocument = gql`
    query piecesGroupedByStatus($piecesGroupedByStatusInput: PiecesGroupedByStatusInput!) {
  piecesGroupedByStatus(piecesGroupedByStatusInput: $piecesGroupedByStatusInput) {
    pieceGroups {
      status
      terminal {
        code
      }
      pieceCount
    }
  }
}
    `;
export const SendStopToAgentDocument = gql`
    mutation sendStopToAgent($sendStopToAgentInput: SendStopToAgentInput!) {
  sendStopToAgent(input: $sendStopToAgentInput) {
    ... on SendStopToAgentSuccessOutput {
      stop {
        uuid
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdatePieceCountDocument = gql`
    mutation updatePieceCount($updatePieceCountInput: UpdatePieceCountInput!) {
  updatePieceCount(updatePieceCountInput: $updatePieceCountInput) {
    uuid
  }
}
    `;
export const VehicleTypeCapacityDocument = gql`
    query VehicleTypeCapacity($vehicleTypeUuid: String!) {
  vehicleType(uuid: $vehicleTypeUuid) {
    uuid
    capacityNotes
    maxWeight
    maxVolume
    vehicleTypePackageSpecs {
      id
      packageSpec {
        id
        name
      }
      maxQuantity
    }
  }
}
    `;
export const UnifiedSearchOrdersDocument = gql`
    query unifiedSearchOrders($unifiedSearchInput: UnifiedSearchInput!) {
  unifiedSearchOrders(unifiedSearchInput: $unifiedSearchInput) {
    ...UnifiedSearchOrders
  }
}
    ${UnifiedSearchOrdersFragmentDoc}`;
export const UnifiedSearchUnacceptedEmailOrdersDocument = gql`
    query unifiedSearchUnacceptedEmailOrders($unifiedSearchInput: UnifiedSearchInput!) {
  unifiedSearchUnacceptedEmailOrders(unifiedSearchInput: $unifiedSearchInput) {
    ...UnifiedSearchUnacceptedEmailOrders
  }
}
    ${UnifiedSearchUnacceptedEmailOrdersFragmentDoc}`;
export const UnifiedSearchUnacceptedEdiAndApiOrdersDocument = gql`
    query unifiedSearchUnacceptedEdiAndApiOrders($unifiedSearchInput: UnifiedSearchInput!) {
  unifiedSearchUnacceptedEdiAndApiOrders(unifiedSearchInput: $unifiedSearchInput) {
    ...UnifiedSearchUnacceptedEdiAndApiOrders
  }
}
    ${UnifiedSearchUnacceptedEdiAndApiOrdersFragmentDoc}`;
export const UnifiedSearchQuotesDocument = gql`
    query unifiedSearchQuotes($unifiedSearchInput: UnifiedSearchInput!) {
  unifiedSearchQuotes(unifiedSearchInput: $unifiedSearchInput) {
    ...UnifiedSearchQuotes
  }
}
    ${UnifiedSearchQuotesFragmentDoc}`;
export const UnifiedSearchInvoicesDocument = gql`
    query unifiedSearchInvoices($unifiedSearchInput: UnifiedSearchInput!) {
  unifiedSearchInvoices(unifiedSearchInput: $unifiedSearchInput) {
    ...UnifiedSearchInvoices
  }
}
    ${UnifiedSearchInvoicesFragmentDoc}`;
export const CreateInvoiceDocumentDocument = gql`
    mutation createInvoiceDocument($createInvoiceDocumentInput: CreateInvoiceDocumentInput!) {
  createInvoiceDocument(createInvoiceDocumentInput: $createInvoiceDocumentInput) {
    uuid
    bucket
    region
    region
    key
    fileName
    fileType
    type
  }
}
    `;
export const CreateOrderDocumentDocument = gql`
    mutation createOrderDocument($createOrderDocumentInput: CreateOrderDocumentInput!) {
  createOrderDocument(createOrderDocumentInput: $createOrderDocumentInput) {
    uuid
    fileName
    bucket
    region
    key
    preSignedGetUrl
    fileType
    name
    type
    customDocumentName
    notes
    driverFormTemplate {
      uuid
    }
    dateUploadedFor
  }
}
    `;
export const ApiLogsDocument = gql`
    query apiLogs($first: Int, $after: String, $last: Int, $before: String, $createdAtDateFilters: [DateFilter!], $sortByCreatedAtDateAsc: Boolean, $isInvoiceEmails: Boolean!, $invoiceUuid: String, $emailTransactionStatus: EmailTransactionStatus, $isFreightSnap: Boolean!, $freightSnapTransactionStatus: FreightSnapTransactionStatus, $freightSnapFailureReason: FreightSnapFailureReason, $searchText: String) {
  apiLogs(
    first: $first
    after: $after
    last: $last
    before: $before
    createdAtDateFilters: $createdAtDateFilters
    sortByCreatedAtDateAsc: $sortByCreatedAtDateAsc
    isInvoiceEmails: $isInvoiceEmails
    invoiceUuid: $invoiceUuid
    emailTransactionStatus: $emailTransactionStatus
    isFreightSnap: $isFreightSnap
    freightSnapTransactionStatus: $freightSnapTransactionStatus
    freightSnapFailureReason: $freightSnapFailureReason
    searchText: $searchText
  ) {
    totalCount
    edges {
      node {
        ...ApiLog
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ApiLogFragmentDoc}`;
export const MatchFreightSnapDocument = gql`
    mutation matchFreightSnap($freightSnapCreateInput: FreightSnapCreateInput!) {
  matchFreightSnap(freightSnapCreateInput: $freightSnapCreateInput) {
    ...FreightSnapTransaction
  }
}
    ${FreightSnapTransactionFragmentDoc}`;
export const OrdersForArrivalNoticesDocument = gql`
    query ordersForArrivalNotices($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderForArrivalNotice
  }
}
    ${OrderForArrivalNoticeFragmentDoc}`;
export const ArriveAtStopsDocument = gql`
    mutation arriveAtStops($arriveAtStopsInput: ArriveAtStopsInput!) {
  arriveAtStops(arriveAtStopsInput: $arriveAtStopsInput) {
    ... on ArriveAtStopsSuccessOutput {
      arrivedStopUuids
      failedStopUuids
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const AttemptStopsForDriverSettlementDocument = gql`
    query attemptStopsForDriverSettlement($uuid: String!) {
  leg(uuid: $uuid) {
    previousStopAttempts {
      ...StopForDriverSettlement
    }
  }
}
    ${StopForDriverSettlementFragmentDoc}`;
export const BulkEditOrdersDocument = gql`
    mutation bulkEditOrders($bulkEditOrdersInput: BulkEditOrdersInput!) {
  bulkEditOrders(bulkEditOrdersInput: $bulkEditOrdersInput) {
    success
    orderStateActions {
      action
      results {
        total
        eligible
        ineligible
        succeeded
        failed
        ineligibleItems {
          uuid
          reason
        }
        failedItems {
          uuid
          reason
        }
      }
    }
    stopStateActions {
      action
      results {
        total
        eligible
        ineligible
        succeeded
        failed
        ineligibleItems {
          uuid
          reason
        }
        failedItems {
          uuid
          reason
        }
      }
    }
  }
}
    `;
export const ClearOrderExecutedByDocument = gql`
    mutation clearOrderExecutedBy($input: ClearOrderExecutedByInput!) {
  clearOrderExecutedBy(input: $input)
}
    `;
export const CoverSheetDocumentTypeSequencesDocument = gql`
    query coverSheetDocumentTypeSequences {
  coverSheetDocumentTypeSequences {
    ...CoverSheetDocumentTypeSequence
  }
}
    ${CoverSheetDocumentTypeSequenceFragmentDoc}`;
export const CreateCoverSheetDocumentTypeSequenceDocument = gql`
    mutation createCoverSheetDocumentTypeSequence($input: CoverSheetDocumentTypeSequenceCreateInput!) {
  createCoverSheetDocumentTypeSequence(
    coverSheetDocumentTypeSequenceCreateInput: $input
  ) {
    uuid
  }
}
    `;
export const OrderCoverSheetsDocument = gql`
    query orderCoverSheets($getShipmentsInput: GetShipmentsInput) {
  shipments(getShipmentsInput: $getShipmentsInput) {
    ...OrderCoverSheetShipment
  }
}
    ${OrderCoverSheetShipmentFragmentDoc}`;
export const OrderInfosForCoverSheetsDocument = gql`
    query orderInfosForCoverSheets($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderInfoForCoverSheet
  }
}
    ${OrderInfoForCoverSheetFragmentDoc}`;
export const OrdersForCoverSheetsDocument = gql`
    query ordersForCoverSheets($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderForCoverSheet
  }
}
    ${OrderForCoverSheetFragmentDoc}`;
export const RemoveCoverSheetDocumentTypeSequenceDocument = gql`
    mutation removeCoverSheetDocumentTypeSequence($uuid: String!) {
  removeCoverSheetDocumentTypeSequence(uuid: $uuid) {
    uuid
  }
}
    `;
export const UpdateCoverSheetDocumentTypeSequenceDocument = gql`
    mutation updateCoverSheetDocumentTypeSequence($input: CoverSheetDocumentTypeSequenceUpdateInput!) {
  updateCoverSheetDocumentTypeSequence(
    coverSheetDocumentTypeSequenceUpdateInput: $input
  ) {
    uuid
  }
}
    `;
export const CreateAccountingReportDocumentDocument = gql`
    mutation createAccountingReportDocument($createAccountingReportDocumentInput: CreateBasicDocumentInput!) {
  createAccountingReportDocument(
    createAccountingReportDocumentInput: $createAccountingReportDocumentInput
  ) {
    document {
      uuid
      bucket
      region
      region
      key
      fileName
      fileType
      type
    }
  }
}
    `;
export const CreateEodDocumentsDocument = gql`
    mutation createEODDocuments($createEodDocumentsInput: CreateEodDocumentsInput!) {
  createEODDocuments(createEodDocumentsInput: $createEodDocumentsInput) {
    uuid
  }
}
    `;
export const CreateOrderCommentDocument = gql`
    mutation createOrderComment($createOrderCommentInput: CreateOrderCommentInput!) {
  createOrderComment(createOrderCommentInput: $createOrderCommentInput) {
    uuid
  }
}
    `;
export const CreateOrderDocumentDocumentDocument = gql`
    mutation createOrderDocumentDocument($createOrderDocumentDocumentInput: CreateOrderDocumentDocumentInput!) {
  createOrderDocumentDocument(
    createOrderDocumentDocumentInput: $createOrderDocumentDocumentInput
  ) {
    document {
      uuid
      bucket
      region
      region
      key
      fileName
      fileType
      type
    }
  }
}
    `;
export const CreateOrderSnapshotDocument = gql`
    mutation createOrderSnapshot($orderEventSnapshotCreateInput: OrderEventSnapshotCreateInput!) {
  createOrderSnapshot(
    orderEventSnapshotCreateInput: $orderEventSnapshotCreateInput
  ) {
    uuid
  }
}
    `;
export const CreateOrdersFromRecurringTemplatesDocument = gql`
    mutation createOrdersFromRecurringTemplates($uuids: [String!]!) {
  createOrdersFromRecurringTemplates(uuids: $uuids) {
    uuid
  }
}
    `;
export const CreatePodReportDocumentDocument = gql`
    mutation createPODReportDocument($createPodReportDocumentInput: CreatePodReportDocumentInput!) {
  createPODReportDocument(
    createPodReportDocumentInput: $createPodReportDocumentInput
  ) {
    document {
      uuid
      bucket
      region
      region
      key
      fileName
      fileType
      type
    }
  }
}
    `;
export const CreateRecurringRunDocument = gql`
    mutation createRecurringRun($input: CreateRunInput!) {
  createRun(createRunInput: $input) {
    run {
      uuid
    }
  }
}
    `;
export const CreateScannedOrdersDocument = gql`
    mutation createScannedOrders($createScannedOrdersInput: CreateScannedOrdersInput!) {
  createScannedOrders(createScannedOrdersInput: $createScannedOrdersInput)
}
    `;
export const MatchSignedPoDsDocument = gql`
    mutation matchSignedPODs($matchSignedPODsInput: CreateScannedOrdersInput!) {
  matchSignedPODs(matchSignedPODsInput: $matchSignedPODsInput)
}
    `;
export const CreateStandardOrderDocument = gql`
    mutation createStandardOrder($createStandardOrderInput: CreateStandardOrderInput!) {
  createStandardOrder(createStandardOrderInput: $createStandardOrderInput) {
    uuid
  }
}
    `;
export const CreateStandardOrderWithDuplicateResolutionDocument = gql`
    mutation createStandardOrderWithDuplicateResolution($createStandardOrderInput: CreateStandardOrderInput!) {
  createStandardOrderWithDuplicateResolution(
    createStandardOrderInput: $createStandardOrderInput
  ) {
    uuid
  }
}
    `;
export const CreateTagDocument = gql`
    mutation createTag($createTagInput: CreateTagInput!) {
  createTag(createTagInput: $createTagInput) {
    uuid
  }
}
    `;
export const CreateOrUpdateCsvOrdersDocument = gql`
    mutation createOrUpdateCsvOrders($createOrUpdateCsvOrdersInput: CreateOrUpdateCsvOrdersInput!) {
  createOrUpdateCsvOrders(
    createOrUpdateCsvOrdersInput: $createOrUpdateCsvOrdersInput
  ) {
    __typename
    ... on CreateOrUpdateCsvOrdersSuccessOutput {
      orders {
        ...CreateOrUpdateCsvOrdersOrder
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${CreateOrUpdateCsvOrdersOrderFragmentDoc}`;
export const CsvOrderMappingsDocument = gql`
    query csvOrderMappings {
  csvOrderMappings {
    ...CsvOrderMapping
  }
}
    ${CsvOrderMappingFragmentDoc}`;
export const GenerateCsvOrderPreSignedPutUrlsDocument = gql`
    query generateCsvOrderPreSignedPutUrls($generateCsvOrderPresignedPutUrlInputs: [GenerateCsvOrderPresignedPutUrlInput!]!) {
  generateCsvOrderPreSignedPutUrls(
    generateCsvOrderPresignedPutUrlInputs: $generateCsvOrderPresignedPutUrlInputs
  ) {
    ...CsvOrderPreSignedPutUrl
  }
}
    ${CsvOrderPreSignedPutUrlFragmentDoc}`;
export const ParseCsvOrdersDocument = gql`
    mutation parseCsvOrders($parseCsvOrdersInput: ParseCsvOrdersInput!) {
  parseCsvOrders(input: $parseCsvOrdersInput) {
    __typename
    ... on ParseCsvOrdersSuccessOutput {
      parsedOrders {
        ...ParseCsvOrdersOrder
      }
      parsedOrderUpdates {
        ...ParseCsvOrdersOrderUpdate
      }
      errors {
        ...ParseCsvOrdersRowError
      }
      enableInboundStop
      enableOutboundStop
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${ParseCsvOrdersOrderFragmentDoc}
${ParseCsvOrdersOrderUpdateFragmentDoc}
${ParseCsvOrdersRowErrorFragmentDoc}`;
export const CurrentOrderStatusDocument = gql`
    query currentOrderStatus($uuid: String!) {
  order(uuid: $uuid) {
    ...CurrentOrderStatus
  }
}
    ${CurrentOrderStatusFragmentDoc}`;
export const DelegationEndCustomerMatchDocument = gql`
    query DelegationEndCustomerMatch($input: DelegationEndCustomerMatchInput!) {
  delegationEndCustomerMatch(input: $input)
}
    `;
export const DeleteOrderDocument = gql`
    mutation deleteOrder($uuid: String!) {
  deleteOrder(uuid: $uuid) {
    uuid
  }
}
    `;
export const DocumentExtractionStatusDocument = gql`
    query DocumentExtractionStatus {
  documentExtractionStatus {
    paused
    estimatedResumeAt
    parkedCount
  }
}
    `;
export const DocumentsByOrderDocument = gql`
    query documentsByOrder($orderUuid: String!) {
  documents(orderUuid: $orderUuid) {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export const DuplicateMergeCandidatesDocument = gql`
    query duplicateMergeCandidates($shipperBillOfLadingNumber: String!, $billingPartyContactUuid: String!, $excludeOrderUuid: String) {
  duplicateMergeCandidates(
    shipperBillOfLadingNumber: $shipperBillOfLadingNumber
    billingPartyContactUuid: $billingPartyContactUuid
    excludeOrderUuid: $excludeOrderUuid
  ) {
    uuid
    name
    source
    createdAt
  }
}
    `;
export const EdiAndApiOrdersForReviewDocument = gql`
    query ediAndApiOrdersForReview($first: Int, $after: String, $last: Int, $before: String, $createdAtDateFilters: DateFilterStartEnd, $contactUuid: String, $sortByCreatedAtDateAsc: Boolean, $searchText: String, $originTerminalUuid: String, $destinationTerminalUuid: String) {
  ediAndApiOrdersForReview(
    first: $first
    after: $after
    last: $last
    before: $before
    createdAtDateFilters: $createdAtDateFilters
    contactUuid: $contactUuid
    sortByCreatedAtDateAsc: $sortByCreatedAtDateAsc
    searchText: $searchText
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
  ) {
    totalCount
    edges {
      node {
        ...OrderFragmentForEdiReview
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OrderFragmentForEdiReviewFragmentDoc}`;
export const EdiTransactionsDocument = gql`
    query ediTransactions($first: Int, $after: String, $last: Int, $before: String, $searchTerms: [String!]) {
  ediTransactions(
    first: $first
    after: $after
    last: $last
    before: $before
    searchTerms: $searchTerms
  ) {
    edges {
      node {
        ...EdiTransactionFragment
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${EdiTransactionFragmentFragmentDoc}`;
export const OrderEdiReferencesDocument = gql`
    query orderEdiReferences($uuid: String!) {
  order(uuid: $uuid) {
    __typename
    uuid
    ediReferences {
      qualifier
      value
      target
      label
    }
  }
}
    `;
export const OrderForEdiReviewByUuidDocument = gql`
    query orderForEdiReviewByUuid($uuid: String!) {
  order(uuid: $uuid) {
    ...OrderFragmentForEdiReview
    isDraftOrder
  }
}
    ${OrderFragmentForEdiReviewFragmentDoc}`;
export const EmailOrderDocumentDocument = gql`
    mutation emailOrderDocument($emailOrderDocumentInput: EmailOrderDocumentInput!) {
  emailOrderDocument(emailOrderDocumentInput: $emailOrderDocumentInput) {
    status
  }
}
    `;
export const FetchMissingAccessorialDocument = gql`
    query fetchMissingAccessorial($uuid: String!) {
  accessorial(uuid: $uuid) {
    ... on StandardAccessorialEntity {
      __typename
      uuid
      name
    }
    ... on PercentageAccessorialEntity {
      __typename
      uuid
      name
    }
    ... on UnitBasedAccessorialEntity {
      __typename
      uuid
      name
    }
    ... on WaitTimeAccessorialEntity {
      __typename
      uuid
      name
    }
    ... on WeightBasedAccessorialEntity {
      __typename
      uuid
      name
    }
    ... on ZoneBasedAccessorialEntity {
      __typename
      uuid
      name
    }
    ... on SpecialAccessorialEntity {
      __typename
      uuid
      name
    }
  }
}
    `;
export const FinalizeOrderDocument = gql`
    mutation finalizeOrder($uuid: String!) {
  finalizeOrder(uuid: $uuid) {
    uuid
    status
    detailedStatusV2
    shipments {
      uuid
      status
    }
  }
}
    `;
export const FinalizeOrdersDocument = gql`
    mutation finalizeOrders($finalizeOrdersInput: FinalizeOrdersInput!) {
  finalizeOrders(finalizeOrdersInput: $finalizeOrdersInput) {
    __typename
    ... on MutationErrorOutput {
      message
    }
    ... on FinalizeOrdersSuccessOutput {
      finalizedOrderUuids
      failedOrderUuids
    }
  }
}
    `;
export const FindAvailablePiecesDocument = gql`
    query findAvailablePieces($findAvailablePiecesInput: FindAvailablePiecesInput!) {
  availablePiecesForLinking(findAvailablePiecesInput: $findAvailablePiecesInput) {
    edges {
      node {
        ...AvailablePieceForLinking
      }
      cursor
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${AvailablePieceForLinkingFragmentDoc}`;
export const TerminalForAddressDocument = gql`
    query terminalForAddress($findTerminalForAddressInput: FindTerminalForAddressInput!) {
  terminalForAddress(findTerminalForAddressInput: $findTerminalForAddressInput) {
    terminal {
      name
      uuid
    }
  }
}
    `;
export const TerminalsForAddressDocument = gql`
    query terminalsForAddress($findTerminalForAddressInput: FindTerminalForAddressInput!) {
  terminalsForAddress(findTerminalForAddressInput: $findTerminalForAddressInput) {
    terminals {
      name
      uuid
    }
  }
}
    `;
export const GenerateAccountingReportPreSignedPutUrlDocument = gql`
    mutation generateAccountingReportPreSignedPutUrl($generateAccountingReportPreSignedPutUrlInput: GenerateAccountingReportPreSignedPutUrlInput!) {
  generateAccountingReportPreSignedPutUrl(
    generateAccountingReportPreSignedPutUrlInput: $generateAccountingReportPreSignedPutUrlInput
  )
}
    `;
export const GenerateOrderDocumentPreSignedPutUrlDocument = gql`
    mutation generateOrderDocumentPreSignedPutUrl($generateOrderDocumentPreSignedPutUrlInput: GenerateOrderDocumentPreSignedPutUrlInput!) {
  generateOrderDocumentPreSignedPutUrl(
    generateOrderDocumentPreSignedPutUrlInput: $generateOrderDocumentPreSignedPutUrlInput
  )
}
    `;
export const GenerateOrderPreSignedGetAndPutUrlsDocument = gql`
    mutation generateOrderPreSignedGetAndPutUrls($generateOrderPreSignedGetAndPutUrlsInput: GenerateOrderPreSignedGetAndPutUrlsInput!) {
  generateOrderPreSignedGetAndPutUrls(
    generateOrderPreSignedGetAndPutUrlsInput: $generateOrderPreSignedGetAndPutUrlsInput
  ) {
    getUrl
    putUrl
  }
}
    `;
export const GeneratePodReportPreSignedPutUrlDocument = gql`
    mutation generatePodReportPreSignedPutUrl($generatePodReportPreSignedPutUrlInput: GeneratePodReportPreSignedPutUrlInput!) {
  generatePodReportPreSignedPutUrl(
    generatePodReportPreSignedPutUrlInput: $generatePodReportPreSignedPutUrlInput
  )
}
    `;
export const GenerateContactPreSignedPutUrlDocument = gql`
    mutation generateContactPreSignedPutUrl($generateContactPreSignedPutUrlInput: GenerateContactPreSignedPutUrlInput!) {
  generateContactPreSignedPutUrl(
    generateContactPreSignedPutUrlInput: $generateContactPreSignedPutUrlInput
  ) {
    url
  }
}
    `;
export const GenerateInvoicePreSignedPutUrlDocument = gql`
    mutation generateInvoicePreSignedPutUrl($generateInvoicePreSignedPutUrlInput: GenerateInvoicePreSignedPutUrlInput!) {
  generateInvoicePreSignedPutUrl(
    generateInvoicePreSignedPutUrlInput: $generateInvoicePreSignedPutUrlInput
  )
}
    `;
export const GenerateOrderPreSignedPutUrlDocument = gql`
    mutation generateOrderPreSignedPutUrl($generateOrderPreSignedPutUrlInput: GenerateOrderPreSignedPutUrlInput!) {
  generateOrderPreSignedPutUrl(
    generateOrderPreSignedPutUrlInput: $generateOrderPreSignedPutUrlInput
  )
}
    `;
export const GenerateScannedOrderPreSignedPutUrlsDocument = gql`
    query generateScannedOrderPreSignedPutUrls($preSignedUrlRequests: [PreSignedUrlRequestInput!]!) {
  generateScannedOrderPreSignedPutUrls(
    preSignedUrlRequests: $preSignedUrlRequests
  ) {
    url
    bucket
    key
    filename
    filetype
  }
}
    `;
export const GeneratePreSignedPutUrlDocument = gql`
    mutation generatePreSignedPutUrl($fileName: String!, $fileType: String!) {
  generatePreSignedPutUrl(fileName: $fileName, fileType: $fileType)
}
    `;
export const InboundMessagesForOrderDocument = gql`
    query inboundMessagesForOrder($input: InboundMessagesForOrderInput!) {
  inboundMessagesForOrder(input: $input) {
    messages {
      uuid
      source
      senderName
      receivedAt
      state
      appliedAt
      conflicts {
        key
        fieldPath
        targetUuid
        label
        kind
        valueType
        surface
        incomingValue
        keptValue
        adoptable
        note
        resolvedChoice
      }
    }
  }
}
    `;
export const IncompleteLegsWithAttemptsDocument = gql`
    query incompleteLegsWithAttempts {
  incompleteLegsWithAttempts {
    uuid
    previousStopAttempts {
      uuid
      completedAt
      address {
        name
        line1
      }
      leg {
        uuid
        shipment {
          order {
            standardOrderFields {
              shipperBillOfLadingNumber
            }
          }
        }
      }
      notes
    }
  }
}
    `;
export const LaneFromOriginAndDestinationTerminalDocument = gql`
    query laneFromOriginAndDestinationTerminal($findLaneFromOriginAndDestinationTerminalInput: FindLaneFromOriginAndDestinationTerminalInput!) {
  laneFromOriginAndDestinationTerminal(
    findLaneFromOriginAndDestinationTerminalInput: $findLaneFromOriginAndDestinationTerminalInput
  ) {
    lane {
      ...LineHaulLane
    }
  }
}
    ${LineHaulLaneFragmentDoc}`;
export const LinkPiecesToPackageDocument = gql`
    mutation linkPiecesToPackage($linkPiecesToPackageInput: LinkPiecesToPackageInput!) {
  linkPiecesToPackage(linkPiecesToPackageInput: $linkPiecesToPackageInput) {
    success
    linkedPieces {
      uuid
      referenceNumber
      status
    }
    errors {
      pieceUuid
      reason
    }
  }
}
    `;
export const MarkOrderAsCompleteForceDocument = gql`
    mutation markOrderAsCompleteForce($markOrderAsCompleteForceInput: MarkOrderAsCompleteForceInput!) {
  markOrderAsCompleteForce(
    markOrderAsCompleteForceInput: $markOrderAsCompleteForceInput
  ) {
    uuid
    detailedStatusV2
    status
  }
}
    `;
export const MarkOrderAsHasBillingIssueDocument = gql`
    mutation markOrderAsHasBillingIssue($uuid: String!) {
  markOrderAsHasBillingIssue(uuid: $uuid) {
    uuid
    status
  }
}
    `;
export const MarkOrderAsNotCompleteDocument = gql`
    mutation markOrderAsNotComplete($uuid: String!) {
  markOrderAsNotComplete(uuid: $uuid) {
    uuid
    detailedStatusV2
    status
  }
}
    `;
export const MarkOrderAsNotOnHandDocument = gql`
    mutation markOrderAsNotOnHand($markAsNotOnHandInput: MarkAsNotOnHandInput!) {
  markOrderAsNotOnHand(markAsNotOnHandInput: $markAsNotOnHandInput) {
    uuid
    detailedStatusV2
    status
  }
}
    `;
export const MarkOrderAsNotReadyToInvoiceDocument = gql`
    mutation markOrderAsNotReadyToInvoice($uuid: String!) {
  markOrderAsNotReadyToInvoice(uuid: $uuid) {
    uuid
    status
  }
}
    `;
export const MarkOrderAsNotReceivedAtOriginDocument = gql`
    mutation markOrderAsNotReceivedAtOrigin($markAsNotReceivedAtOriginInput: MarkAsNotReceivedAtOriginInput!) {
  markOrderAsNotReceivedAtOrigin(
    markAsNotReceivedAtOriginInput: $markAsNotReceivedAtOriginInput
  ) {
    uuid
    detailedStatusV2
    status
  }
}
    `;
export const MarkOrderAsOnHandDocument = gql`
    mutation markOrderAsOnHand($markAsOnHandInput: MarkAsOnHandInput!) {
  markOrderAsOnHand(markAsOnHandInput: $markAsOnHandInput) {
    uuid
    receivedDate
    detailedStatusV2
    osd
    status
    shipments {
      standardShipmentFields {
        pickupOrDelivery
      }
      status
      legs {
        endStop {
          status
        }
      }
    }
  }
}
    `;
export const MarkOrderAsReadyToInvoiceForceDocument = gql`
    mutation markOrderAsReadyToInvoiceForce($uuid: String!, $refuseOrderInput: RefuseOrderInput) {
  markOrderAsReadyToInvoiceForce(uuid: $uuid, refuseOrderInput: $refuseOrderInput) {
    uuid
    detailedStatusV2
    status
  }
}
    `;
export const MarkOrderAsReadyToInvoiceDocument = gql`
    mutation markOrderAsReadyToInvoice($uuid: String!) {
  markOrderAsReadyToInvoice(uuid: $uuid) {
    uuid
    status
  }
}
    `;
export const MarkOrderAsReceivedAtOriginDocument = gql`
    mutation markOrderAsReceivedAtOrigin($markAsReceivedAtOriginInput: MarkAsReceivedAtOriginInput!) {
  markOrderAsReceivedAtOrigin(
    markAsReceivedAtOriginInput: $markAsReceivedAtOriginInput
  ) {
    uuid
    dateMarkedReceivedAtOrigin
    detailedStatusV2
    osd
    status
    shipments {
      standardShipmentFields {
        pickupOrDelivery
      }
      status
      legs {
        endStop {
          status
        }
      }
    }
  }
}
    `;
export const MarkOrderAsRefusedDocument = gql`
    mutation markOrderAsRefused($markOrderAsRefusedInput: MarkOrderAsRefusedInput!) {
  markOrderAsRefused(markOrderAsRefusedInput: $markOrderAsRefusedInput) {
    ... on MarkOrderAsRefusedSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const MarkOrderAsNotOsdDocument = gql`
    mutation markOrderAsNotOsd($markAsNotOsd: MarkNotOsdInput!) {
  markNotOsd(markAsNotOsd: $markAsNotOsd) {
    uuid
    status
    detailedStatusV2
  }
}
    `;
export const MarkOrderAsOsdDocument = gql`
    mutation markOrderAsOSD($markOsdInput: MarkOsdInput!) {
  markOsd(markOsdInput: $markOsdInput) {
    ...MarkOsdOrder
  }
}
    ${MarkOsdOrderFragmentDoc}`;
export const MergeEdiOrderDocument = gql`
    mutation mergeEdiOrder($mergeEdiOrderInput: MergeEdiOrderInput!) {
  mergeEdiOrder(mergeEdiOrderInput: $mergeEdiOrderInput) {
    uuid
  }
}
    `;
export const NumberOfEdiAndApiOrdersForReviewForCurrentCompanyDocument = gql`
    query numberOfEdiAndApiOrdersForReviewForCurrentCompany {
  numberOfEdiAndApiOrdersForReviewForCurrentCompany
}
    `;
export const NumberOfScannedOrderResultsInReviewBySourceDocument = gql`
    query numberOfScannedOrderResultsInReviewBySource($sourceFilter: ScannedOrderResultSourceFilter) {
  numberOfScannedOrderResultsInReview(sourceFilter: $sourceFilter)
}
    `;
export const OpenMessageInOutlookDocument = gql`
    mutation openMessageInOutlook($openMessageInOutlookInput: OpenMessageInOutlookInput!) {
  openMessageInOutlook(openMessageInOutlookInput: $openMessageInOutlookInput) {
    linkToOpen
  }
}
    `;
export const DeleteOrderCommentDocument = gql`
    mutation deleteOrderComment($deleteOrderCommentInput: DeleteOrderCommentInput!) {
  deleteOrderComment(deleteOrderCommentInput: $deleteOrderCommentInput) {
    ... on DeleteOrderCommentSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UpdateOrderCommentDocument = gql`
    mutation updateOrderComment($updateOrderCommentInput: UpdateOrderCommentInput!) {
  updateOrderComment(updateOrderCommentInput: $updateOrderCommentInput) {
    uuid
  }
}
    `;
export const StandardOrderForContextMenuDocument = gql`
    query standardOrderForContextMenu($uuid: String!) {
  standardOrder(uuid: $uuid) {
    ...StandardOrderForContextMenu
  }
}
    ${StandardOrderForContextMenuFragmentDoc}`;
export const OrdersForDocumentAttachmentsDownloadDocument = gql`
    query ordersForDocumentAttachmentsDownload($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderForDocumentAttachmentsDownload
  }
}
    ${OrderForDocumentAttachmentsDownloadFragmentDoc}`;
export const OrderForTabLabelDocument = gql`
    query orderForTabLabel($uuid: String!) {
  order(uuid: $uuid) {
    uuid
    name
  }
}
    `;
export const OrderNameDocument = gql`
    query orderName($billingPartyContactUuid: String!) {
  orderName(billingPartyContactUuid: $billingPartyContactUuid)
}
    `;
export const OrderPodReportsDocument = gql`
    query orderPodReports($getShipmentsInput: GetShipmentsInput) {
  shipments(getShipmentsInput: $getShipmentsInput) {
    ...OrderPodReportShipment
  }
}
    ${OrderPodReportShipmentFragmentDoc}`;
export const OrderUpdatedAtDocument = gql`
    query orderUpdatedAt($uuid: String!) {
  order(uuid: $uuid) {
    updatedAt
    lastUpdatedByUser {
      uuid
    }
  }
}
    `;
export const OrderDocument = gql`
    query order($uuid: String!) {
  order(uuid: $uuid) {
    uuid
    name
    status
    notes
    pieceCount
    receivedDate
    pickedDate
    onHand
    standardOrderFields {
      shipperBillOfLadingNumber
    }
    shipments {
      uuid
      packages {
        description
      }
    }
    documents {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;
export const OrdersBySecondaryRefNumberDocument = gql`
    query ordersBySecondaryRefNumber($secondaryRefNumber: String!) {
  ordersBySecondaryRefNumber(secondaryRefNumber: $secondaryRefNumber) {
    uuid
    createdAt
    name
  }
}
    `;
export const OrdersByShipperBillOfLadingNumberDocument = gql`
    query ordersByShipperBillOfLadingNumber($shipperBillOfLadingNumber: String!, $includeInReviewScannedOrdersFromEmail: Boolean, $includeInReviewEdiOrders: Boolean) {
  ordersByShipperBillOfLadingNumber(
    shipperBillOfLadingNumber: $shipperBillOfLadingNumber
    includeInReviewScannedOrdersFromEmail: $includeInReviewScannedOrdersFromEmail
    includeInReviewEdiOrders: $includeInReviewEdiOrders
  ) {
    ...OrderForOrdersByShipperBillOfLadingNumber
  }
}
    ${OrderForOrdersByShipperBillOfLadingNumberFragmentDoc}`;
export const OrdersByUuidsForBulkEditDocument = gql`
    query ordersByUuidsForBulkEdit($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderForBulkEdit
  }
}
    ${OrderForBulkEditFragmentDoc}`;
export const OrdersForBulkEditDocument = gql`
    query ordersForBulkEdit($addressCityFilter: StringFilter, $addressZipFilter: StringFilter, $attemptedAtDateFilters: DateFilterStartEnd, $completionDateFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $receivedDateFilters: DateFilterStartEnd, $createdAtDateFilters: DateFilterStartEnd, $expectedInboundArrivalDateFilters: DateFilterStartEnd, $invoiceDateFilters: DateFilterStartEnd, $scheduledAtDateFilters: DateFilterStartEnd, $primaryAppointmentDateFilters: DateFilterStartEnd, $orderNumberFilter: StringFilter, $billingPartyContactUuidFilter: StringFilter, $businessDivisionUuidFilter: StringFilter, $terminalUuidFilter: StringFilter, $activeTerminalUuidFilter: StringFilter, $originTerminalUuidFilter: StringFilterNullable, $destinationTerminalUuidFilter: StringFilterNullable, $driverUuidFilter: StringFilter, $shipperFilter: StringFilter, $consigneeFilter: StringFilter, $statusFilters: [StatusFilter!], $shipmentStatusFilters: [ShipmentStatusFilter!], $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $multipleSearches: [String!], $scheduledFilter: BooleanFilter, $outForDeliveryFilter: BooleanFilter, $onHand: BooleanFilter, $onInvoice: BooleanFilter, $isCancelled: BooleanFilter, $isRefused: BooleanFilter, $isFinalized: BooleanFilter, $isPicked: BooleanFilter, $isOsd: BooleanFilter, $isSpecial: BooleanFilter, $orderSource: OrderSource, $noMaximum: Boolean, $hasAppointmentScheduled: BooleanFilter, $appointmentRequired: BooleanFilter, $hasContactInformation: BooleanFilter, $hasFailures: BooleanFilter, $hasRoute: BooleanFilter, $hawbFilter: StringFilterV2, $mawbFilter: StringFilterV2, $hideFromBilling: BooleanFilter, $paperworkComplete: BooleanFilter, $pickupOrDelivery: PickupOrDelivery, $isPickupOrDelivery: BooleanFilter, $inboundNotArrived: BooleanFilter, $requiresRouting: BooleanFilter, $requiresRecovery: BooleanFilter, $serviceDateFilters: DateFilterStartEnd, $serviceDateFilter: DateFilterV2, $serviceUuids: [String!], $lineHaulLaneUuids: [String!], $showConsolidatedOrders: BooleanFilter, $standardStopType: StandardStopType, $stopTypesFilter: StopTypesFilter, $tagUuids: [String!], $totalCount: Boolean, $transferPending: BooleanFilter, $uuids: [String!], $searchHawbOnly: Boolean, $searchRefNumbersOnly: Boolean, $searchMiscInfoOnly: Boolean, $useMultiSearch: Boolean, $sorts: [OrderSort!], $noTerminal: BooleanFilter, $billingPartyContactUuidsFilter: StringsFilter, $terminalUuidsFilter: StringsFilter, $driverUuidsFilter: StringsFilter, $tagUuidsFilter: StringsFilter, $canDispatchFilter: BooleanFilterV2, $inboundRoutingFilter: StringFilterV2, $outboundRoutingFilter: StringFilterV2, $proofOfDeliverySigneeFilter: StringFilterV2) {
  orders(
    first: $first
    last: $last
    after: $after
    before: $before
    addressCityFilter: $addressCityFilter
    addressZipFilter: $addressZipFilter
    attemptedAtDateFilters: $attemptedAtDateFilters
    billingPartyContactUuidFilter: $billingPartyContactUuidFilter
    businessDivisionUuidFilter: $businessDivisionUuidFilter
    terminalUuidFilter: $terminalUuidFilter
    activeTerminalUuidFilter: $activeTerminalUuidFilter
    originTerminalUuidFilter: $originTerminalUuidFilter
    destinationTerminalUuidFilter: $destinationTerminalUuidFilter
    driverUuidFilter: $driverUuidFilter
    completionDateFilters: $completionDateFilters
    deadlineDateFilters: $deadlineDateFilters
    receivedDateFilters: $receivedDateFilters
    createdAtDateFilters: $createdAtDateFilters
    scheduledAtDateFilters: $scheduledAtDateFilters
    primaryAppointmentDateFilters: $primaryAppointmentDateFilters
    expectedInboundArrivalDateFilters: $expectedInboundArrivalDateFilters
    invoiceDateFilters: $invoiceDateFilters
    consigneeFilter: $consigneeFilter
    hasAppointmentScheduled: $hasAppointmentScheduled
    appointmentRequired: $appointmentRequired
    hasContactInformation: $hasContactInformation
    hasFailures: $hasFailures
    hasRoute: $hasRoute
    hawbFilter: $hawbFilter
    mawbFilter: $mawbFilter
    hideFromBilling: $hideFromBilling
    noMaximum: $noMaximum
    orderNumberFilter: $orderNumberFilter
    onHand: $onHand
    onInvoice: $onInvoice
    isCancelled: $isCancelled
    isRefused: $isRefused
    isFinalized: $isFinalized
    isPicked: $isPicked
    isOsd: $isOsd
    multipleSearches: $multipleSearches
    isSpecial: $isSpecial
    orderSource: $orderSource
    outForDeliveryFilter: $outForDeliveryFilter
    paperworkComplete: $paperworkComplete
    pickupOrDelivery: $pickupOrDelivery
    isPickupOrDelivery: $isPickupOrDelivery
    inboundNotArrived: $inboundNotArrived
    requiresRouting: $requiresRouting
    requiresRecovery: $requiresRecovery
    scheduledFilter: $scheduledFilter
    searchText: $searchText
    serviceDateFilters: $serviceDateFilters
    serviceDateFilter: $serviceDateFilter
    serviceUuids: $serviceUuids
    lineHaulLaneUuids: $lineHaulLaneUuids
    showConsolidatedOrders: $showConsolidatedOrders
    shipperFilter: $shipperFilter
    statusFilters: $statusFilters
    shipmentStatusFilters: $shipmentStatusFilters
    standardStopType: $standardStopType
    stopTypesFilter: $stopTypesFilter
    tagUuids: $tagUuids
    transferPending: $transferPending
    totalCount: $totalCount
    uuids: $uuids
    searchHawbOnly: $searchHawbOnly
    searchRefNumbersOnly: $searchRefNumbersOnly
    searchMiscInfoOnly: $searchMiscInfoOnly
    useMultiSearch: $useMultiSearch
    noTerminal: $noTerminal
    billingPartyContactUuidsFilter: $billingPartyContactUuidsFilter
    terminalUuidsFilter: $terminalUuidsFilter
    driverUuidsFilter: $driverUuidsFilter
    tagUuidsFilter: $tagUuidsFilter
    sorts: $sorts
    canDispatchFilter: $canDispatchFilter
    inboundRoutingFilter: $inboundRoutingFilter
    outboundRoutingFilter: $outboundRoutingFilter
    proofOfDeliverySigneeFilter: $proofOfDeliverySigneeFilter
  ) {
    totalCount
    edges {
      node {
        ...OrderForBulkEdit
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OrderForBulkEditFragmentDoc}`;
export const OrdersForInventoryLabelsDocument = gql`
    query ordersForInventoryLabels($uuids: [String!]!) {
  ordersByUuids(uuids: $uuids) {
    ...OrderForInventoryLabel
  }
}
    ${OrderForInventoryLabelFragmentDoc}`;
export const OrdersForOrderMatchingDocument = gql`
    query ordersForOrderMatching($addressCityFilter: StringFilter, $addressZipFilter: StringFilter, $attemptedAtDateFilters: DateFilterStartEnd, $completionDateFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $receivedDateFilters: DateFilterStartEnd, $createdAtDateFilters: DateFilterStartEnd, $expectedInboundArrivalDateFilters: DateFilterStartEnd, $invoiceDateFilters: DateFilterStartEnd, $scheduledAtDateFilters: DateFilterStartEnd, $orderNumberFilter: StringFilter, $billingPartyContactUuidFilter: StringFilter, $driverUuidFilter: StringFilter, $shipperFilter: StringFilter, $consigneeFilter: StringFilter, $statusFilters: [StatusFilter!], $shipmentStatusFilters: [ShipmentStatusFilter!], $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $scheduledFilter: BooleanFilter, $outForDeliveryFilter: BooleanFilter, $onHand: BooleanFilter, $onInvoice: BooleanFilter, $isCancelled: BooleanFilter, $isRefused: BooleanFilter, $isFinalized: BooleanFilter, $isPicked: BooleanFilter, $isOsd: BooleanFilter, $isSpecial: BooleanFilter, $orderSource: OrderSource, $noMaximum: Boolean, $hasAppointmentScheduled: BooleanFilter, $appointmentRequired: BooleanFilter, $hasContactInformation: BooleanFilter, $hasFailures: BooleanFilter, $hasRoute: BooleanFilter, $hideFromBilling: BooleanFilter, $paperworkComplete: BooleanFilter, $pickupOrDelivery: PickupOrDelivery, $isPickupOrDelivery: BooleanFilter, $inboundNotArrived: BooleanFilter, $requiresRouting: BooleanFilter, $requiresRecovery: BooleanFilter, $serviceUuids: [String!], $lineHaulLaneUuids: [String!], $showConsolidatedOrders: BooleanFilter, $standardStopType: StandardStopType, $stopTypesFilter: StopTypesFilter, $tagUuids: [String!], $totalCount: Boolean, $transferPending: BooleanFilter) {
  orders(
    first: $first
    last: $last
    after: $after
    before: $before
    addressCityFilter: $addressCityFilter
    addressZipFilter: $addressZipFilter
    attemptedAtDateFilters: $attemptedAtDateFilters
    billingPartyContactUuidFilter: $billingPartyContactUuidFilter
    driverUuidFilter: $driverUuidFilter
    completionDateFilters: $completionDateFilters
    deadlineDateFilters: $deadlineDateFilters
    receivedDateFilters: $receivedDateFilters
    createdAtDateFilters: $createdAtDateFilters
    scheduledAtDateFilters: $scheduledAtDateFilters
    expectedInboundArrivalDateFilters: $expectedInboundArrivalDateFilters
    invoiceDateFilters: $invoiceDateFilters
    consigneeFilter: $consigneeFilter
    hasAppointmentScheduled: $hasAppointmentScheduled
    appointmentRequired: $appointmentRequired
    hasContactInformation: $hasContactInformation
    hasFailures: $hasFailures
    hasRoute: $hasRoute
    hideFromBilling: $hideFromBilling
    noMaximum: $noMaximum
    orderNumberFilter: $orderNumberFilter
    onHand: $onHand
    onInvoice: $onInvoice
    isCancelled: $isCancelled
    isRefused: $isRefused
    isFinalized: $isFinalized
    isPicked: $isPicked
    isOsd: $isOsd
    isSpecial: $isSpecial
    orderSource: $orderSource
    outForDeliveryFilter: $outForDeliveryFilter
    paperworkComplete: $paperworkComplete
    pickupOrDelivery: $pickupOrDelivery
    isPickupOrDelivery: $isPickupOrDelivery
    inboundNotArrived: $inboundNotArrived
    requiresRouting: $requiresRouting
    requiresRecovery: $requiresRecovery
    scheduledFilter: $scheduledFilter
    searchText: $searchText
    serviceUuids: $serviceUuids
    lineHaulLaneUuids: $lineHaulLaneUuids
    showConsolidatedOrders: $showConsolidatedOrders
    shipperFilter: $shipperFilter
    statusFilters: $statusFilters
    shipmentStatusFilters: $shipmentStatusFilters
    standardStopType: $standardStopType
    stopTypesFilter: $stopTypesFilter
    tagUuids: $tagUuids
    transferPending: $transferPending
    totalCount: $totalCount
  ) {
    totalCount
    edges {
      node {
        ...OrderForOrderMatching
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${OrderForOrderMatchingFragmentDoc}`;
export const CreateOrderTableReportDocument = gql`
    mutation createOrderTableReport($createOrderTableReportInput: CreateOrderTableReportInput!) {
  createOrderTableReport(
    createOrderTableReportInput: $createOrderTableReportInput
  ) {
    ... on OrderTableReportDownloadOutput {
      reportGenerationStatus
      reportUrl
    }
    ... on OrderTableReportEmailToUserOutput {
      reportGenerationStatus
    }
  }
}
    `;
export const GetOrderTableFieldValuesForCountDocument = gql`
    query getOrderTableFieldValuesForCount($getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput!, $activeTerminalUuid: ID, $includePieceTerminalLocationsDisplay: Boolean = false) {
  getOrderTableFieldValues(
    getOrderTableFieldValuesInput: $getOrderTableFieldValuesInput
  ) {
    ...OrderTableFieldValuesOutput
  }
}
    ${OrderTableFieldValuesOutputFragmentDoc}`;
export const GetOrderTableFieldValuesForSearchDocument = gql`
    query getOrderTableFieldValuesForSearch($getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput!, $activeTerminalUuid: ID, $includePieceTerminalLocationsDisplay: Boolean = false) {
  getOrderTableFieldValues(
    getOrderTableFieldValuesInput: $getOrderTableFieldValuesInput
  ) {
    ...OrderTableFieldValuesOutput
  }
}
    ${OrderTableFieldValuesOutputFragmentDoc}`;
export const GetOrderTableFieldValuesDocument = gql`
    query getOrderTableFieldValues($getOrderTableFieldValuesInput: GetOrderTableFieldValuesInput!, $activeTerminalUuid: ID, $includePieceTerminalLocationsDisplay: Boolean = false) {
  getOrderTableFieldValues(
    getOrderTableFieldValuesInput: $getOrderTableFieldValuesInput
  ) {
    ...OrderTableFieldValuesOutput
  }
}
    ${OrderTableFieldValuesOutputFragmentDoc}`;
export const OrderCommentsDocument = gql`
    query orderComments($orderUuid: String!) {
  orderComments(orderUuid: $orderUuid) {
    uuid
    createdAt
    updatedAt
    comment
    user {
      uuid
      email
    }
    piece {
      uuid
      referenceNumber
    }
  }
}
    `;
export const OrderTableFieldHeadersDocument = gql`
    query orderTableFieldHeaders {
  orderTableFieldHeaders {
    orderTableFieldHeaders {
      ...OrderTableFieldHeader
    }
  }
}
    ${OrderTableFieldHeaderFragmentDoc}`;
export const OrderUuidsInViewDocument = gql`
    query orderUuidsInView($findOrderUuidsInViewInput: FindOrderUuidsInViewInput!) {
  orderUuidsInView(findOrderUuidsInViewInput: $findOrderUuidsInViewInput) {
    uuids
    hasMore
  }
}
    `;
export const OrderUuidsDocument = gql`
    query orderUuids($addressCityFilter: StringFilter, $addressZipFilter: StringFilter, $attemptedAtDateFilters: DateFilterStartEnd, $completionDateFilters: DateFilterStartEnd, $deadlineDateFilters: DateFilterStartEnd, $receivedDateFilters: DateFilterStartEnd, $createdAtDateFilters: DateFilterStartEnd, $expectedInboundArrivalDateFilters: DateFilterStartEnd, $invoiceDateFilters: DateFilterStartEnd, $scheduledAtDateFilters: DateFilterStartEnd, $primaryAppointmentDateFilters: DateFilterStartEnd, $orderNumberFilter: StringFilter, $billingPartyContactUuidFilter: StringFilter, $billingPartyContactDisplayNameFilter: StringFilter, $businessDivisionUuidFilter: StringFilter, $terminalUuidFilter: StringFilter, $activeTerminalUuidFilter: StringFilter, $originTerminalUuidFilter: StringFilterNullable, $destinationTerminalUuidFilter: StringFilterNullable, $driverUuidFilter: StringFilter, $shipperFilter: StringFilter, $consigneeFilter: StringFilter, $statusFilters: [StatusFilter!], $shipmentStatusFilters: [ShipmentStatusFilter!], $first: Int, $after: String, $last: Int, $before: String, $searchText: String, $multipleSearches: [String!], $scheduledFilter: BooleanFilter, $outForDeliveryFilter: BooleanFilter, $onHand: BooleanFilter, $onInvoice: BooleanFilter, $isCancelled: BooleanFilter, $isRefused: BooleanFilter, $isFinalized: BooleanFilter, $isPicked: BooleanFilter, $isOsd: BooleanFilter, $isSpecial: BooleanFilter, $orderSource: OrderSource, $noMaximum: Boolean, $hasAppointmentScheduled: BooleanFilter, $appointmentRequired: BooleanFilter, $hasContactInformation: BooleanFilter, $hasFailures: BooleanFilter, $hasRoute: BooleanFilter, $hideFromBilling: BooleanFilter, $paperworkComplete: BooleanFilter, $pickupOrDelivery: PickupOrDelivery, $isPickupOrDelivery: BooleanFilter, $inboundNotArrived: BooleanFilter, $requiresRouting: BooleanFilter, $requiresRecovery: BooleanFilter, $serviceDateFilters: DateFilterStartEnd, $serviceDateFilter: DateFilterV2, $serviceUuids: [String!], $lineHaulLaneUuids: [String!], $showConsolidatedOrders: BooleanFilter, $hideOriginalConsolidatedOrderIdFilter: BooleanFilterV2, $standardStopType: StandardStopType, $stopTypesFilter: StopTypesFilter, $tagUuids: [String!], $transferPending: BooleanFilter, $uuids: [String!], $searchHawbOnly: Boolean, $searchRefNumbersOnly: Boolean, $searchMiscInfoOnly: Boolean, $useMultiSearch: Boolean, $sorts: [OrderSort!], $noTerminal: BooleanFilter, $isCollectOnDelivery: Boolean, $isHazmat: BooleanFilter, $isInBond: BooleanFilter, $billingPartyContactUuidsFilter: StringsFilter, $terminalUuidsFilter: StringsFilter, $driverUuidsFilter: StringsFilter, $tagUuidsFilter: StringsFilter) {
  orders(
    first: $first
    last: $last
    after: $after
    before: $before
    addressCityFilter: $addressCityFilter
    addressZipFilter: $addressZipFilter
    attemptedAtDateFilters: $attemptedAtDateFilters
    billingPartyContactUuidFilter: $billingPartyContactUuidFilter
    billingPartyContactDisplayNameFilter: $billingPartyContactDisplayNameFilter
    businessDivisionUuidFilter: $businessDivisionUuidFilter
    terminalUuidFilter: $terminalUuidFilter
    activeTerminalUuidFilter: $activeTerminalUuidFilter
    originTerminalUuidFilter: $originTerminalUuidFilter
    destinationTerminalUuidFilter: $destinationTerminalUuidFilter
    driverUuidFilter: $driverUuidFilter
    completionDateFilters: $completionDateFilters
    deadlineDateFilters: $deadlineDateFilters
    receivedDateFilters: $receivedDateFilters
    createdAtDateFilters: $createdAtDateFilters
    scheduledAtDateFilters: $scheduledAtDateFilters
    primaryAppointmentDateFilters: $primaryAppointmentDateFilters
    expectedInboundArrivalDateFilters: $expectedInboundArrivalDateFilters
    invoiceDateFilters: $invoiceDateFilters
    consigneeFilter: $consigneeFilter
    hasAppointmentScheduled: $hasAppointmentScheduled
    appointmentRequired: $appointmentRequired
    hasContactInformation: $hasContactInformation
    hasFailures: $hasFailures
    hasRoute: $hasRoute
    hideFromBilling: $hideFromBilling
    noMaximum: $noMaximum
    orderNumberFilter: $orderNumberFilter
    onHand: $onHand
    onInvoice: $onInvoice
    isCancelled: $isCancelled
    isRefused: $isRefused
    isFinalized: $isFinalized
    isPicked: $isPicked
    isOsd: $isOsd
    multipleSearches: $multipleSearches
    isSpecial: $isSpecial
    orderSource: $orderSource
    outForDeliveryFilter: $outForDeliveryFilter
    paperworkComplete: $paperworkComplete
    pickupOrDelivery: $pickupOrDelivery
    isPickupOrDelivery: $isPickupOrDelivery
    inboundNotArrived: $inboundNotArrived
    requiresRouting: $requiresRouting
    requiresRecovery: $requiresRecovery
    scheduledFilter: $scheduledFilter
    searchText: $searchText
    serviceDateFilters: $serviceDateFilters
    serviceDateFilter: $serviceDateFilter
    serviceUuids: $serviceUuids
    lineHaulLaneUuids: $lineHaulLaneUuids
    showConsolidatedOrders: $showConsolidatedOrders
    hideOriginalConsolidatedOrderIdFilter: $hideOriginalConsolidatedOrderIdFilter
    shipperFilter: $shipperFilter
    statusFilters: $statusFilters
    shipmentStatusFilters: $shipmentStatusFilters
    standardStopType: $standardStopType
    stopTypesFilter: $stopTypesFilter
    tagUuids: $tagUuids
    transferPending: $transferPending
    uuids: $uuids
    searchHawbOnly: $searchHawbOnly
    searchRefNumbersOnly: $searchRefNumbersOnly
    searchMiscInfoOnly: $searchMiscInfoOnly
    useMultiSearch: $useMultiSearch
    noTerminal: $noTerminal
    sorts: $sorts
    isCollectOnDelivery: $isCollectOnDelivery
    isHazmat: $isHazmat
    isInBond: $isInBond
    billingPartyContactUuidsFilter: $billingPartyContactUuidsFilter
    terminalUuidsFilter: $terminalUuidsFilter
    driverUuidsFilter: $driverUuidsFilter
    tagUuidsFilter: $tagUuidsFilter
  ) {
    totalCount
    edges {
      node {
        uuid
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const OrderWithInboundOutboundPaperworkDocument = gql`
    query orderWithInboundOutboundPaperwork($uuid: String!) {
  order(uuid: $uuid) {
    paperwork {
      ...OrderPaperwork
    }
    inboundPaperwork {
      ...OrderPaperworkWithGroupedDocuments
    }
    outboundPaperwork {
      ...OrderPaperworkWithGroupedDocuments
    }
  }
}
    ${OrderPaperworkFragmentDoc}
${OrderPaperworkWithGroupedDocumentsFragmentDoc}`;
export const OrderWithItemizedChargesDocument = gql`
    query orderWithItemizedCharges($uuid: String!) {
  getOrderTableFieldValues(
    getOrderTableFieldValuesInput: {uuids: [$uuid], includeOrders: true, orderTableFields: [TOTAL_CHARGES_WITH_ITEMIZED]}
  ) {
    formattedOrderConnection {
      edges {
        node {
          uuid
          itemizedChargesField {
            ...OrderTableFieldItemizedCharges
          }
        }
      }
    }
  }
}
    ${OrderTableFieldItemizedChargesFragmentDoc}`;
export const OrderWithMissingDocumentsDocument = gql`
    query orderWithMissingDocuments($uuid: String!) {
  order(uuid: $uuid) {
    ...OrderWithMissingDocuments
  }
}
    ${OrderWithMissingDocumentsFragmentDoc}`;
export const OrderWithPaperworkDocument = gql`
    query orderWithPaperwork($uuid: String!) {
  order(uuid: $uuid) {
    ...OrderWithPaperwork
  }
}
    ${OrderWithPaperworkFragmentDoc}`;
export const PackageSpecsDocument = gql`
    query PackageSpecs {
  packageSpecs {
    packageSpecs {
      id
      name
      weight
      length
      width
      height
      status
      freightClass
    }
  }
}
    `;
export const PiecesByUuidsDocument = gql`
    query PiecesByUuids($uuids: [String!]!) {
  piecesByUuids(uuids: $uuids) {
    uuid
    referenceNumber
    documents {
      uuid
      fileName
      fileType
      type
      preSignedGetUrl
      notes
      pageNumber
    }
  }
}
    `;
export const RecordInboundReviewDecisionsDocument = gql`
    mutation RecordInboundReviewDecisions($input: RecordInboundReviewDecisionsInput!) {
  recordInboundReviewDecisions(input: $input)
}
    `;
export const RecurringOrderTemplatesDocument = gql`
    query recurringOrderTemplates($runUuid: String) {
  recurringOrderTemplates(runUuid: $runUuid) {
    ...RecurringOrderTemplate
  }
}
    ${RecurringOrderTemplateFragmentDoc}`;
export const RecurringRunsDocument = gql`
    query recurringRuns {
  recurringRuns {
    ...RecurringRunTemplate
  }
}
    ${RecurringRunTemplateFragmentDoc}`;
export const RemoveOrderHoldDocument = gql`
    mutation removeOrderHold($removeOrderHoldInput: RemoveOrderHoldInput!) {
  removeOrderHold(removeOrderHoldInput: $removeOrderHoldInput) {
    uuid
    status
    detailedStatusV2
  }
}
    `;
export const RemoveSubscriberFromShipmentDocument = gql`
    mutation removeSubscriberFromShipment($removeSubscriberInput: RemoveSubscriberInput!) {
  removeSubscriberFromShipment(removeSubscriberInput: $removeSubscriberInput) {
    uuid
  }
}
    `;
export const ReportADocScanIssueDocument = gql`
    mutation reportADocScanIssue($reportADocScanIssueInput: ReportADocScanIssueInput!) {
  reportADocScanIssue(reportADocScanIssueInput: $reportADocScanIssueInput) {
    success
  }
}
    `;
export const RerateOrderFreightDocument = gql`
    mutation RerateOrderFreight($orderUuid: String!) {
  rerateOrderFreight(orderUuid: $orderUuid) {
    externalRatings {
      freightChargeUuid
      status
      externalRating {
        __typename
        ... on ExternalRatingFailure {
          message
        }
      }
    }
  }
}
    `;
export const CreateReverseOrderDocument = gql`
    mutation CreateReverseOrder($createReverseOrderInput: CreateReverseOrderInput!) {
  createReverseOrder(createReverseOrderInput: $createReverseOrderInput) {
    uuid
    name
    isReverse
  }
}
    `;
export const ScannedOrderProvenanceDocument = gql`
    query scannedOrderProvenance($scannedOrderUuid: String!) {
  scannedOrderProvenance(scannedOrderUuid: $scannedOrderUuid) {
    fields {
      fieldKey
      value
      fieldStatus
      sourceKind
      sourcePage
      sourceS3Key
      sourceBboxes {
        l
        t
        w
        h
      }
      derivationTag
    }
  }
}
    `;
export const ScannedOrderResultByOrderUuidDocument = gql`
    query scannedOrderResultByOrderUuid($uuid: String!) {
  scannedOrderResultByOrderUuid(uuid: $uuid) {
    ...ScannedOrderResultFragment
  }
}
    ${ScannedOrderResultFragmentFragmentDoc}`;
export const ScannedOrdersByUuidsDocument = gql`
    query scannedOrdersByUuids($uuids: [String!]!) {
  scannedOrdersByUuids(uuids: $uuids) {
    uuid
    status
  }
}
    `;
export const ServicesForOrderDocument = gql`
    query servicesForOrder($findServicesForOrderInput: FindServicesForOrderInput!) {
  servicesForOrder(findServicesForOrderInput: $findServicesForOrderInput) {
    __typename
    ... on FindServicesForOrderSuccessOutput {
      services {
        uuid
        name
        isActive
        markOrdersAsSpecial
      }
    }
    ... on QueryErrorOutput {
      message
    }
  }
}
    `;
export const SetOrderExecutedByDocument = gql`
    mutation setOrderExecutedBy($input: SetOrderExecutedByInput!) {
  setOrderExecutedBy(input: $input) {
    __typename
    uuid
    status
    scope
    executingCompanyName
    executingCompanyUuid
    originatorCompanyName
    originatorCompanyUuid
    organizationPeerUuid
    originalOrderUuid
    duplicateOrderUuid
    createdAt
    updatedAt
    expiresAt
    acceptedAt
    declinedAt
    expiredAt
    revokedAt
    completedAt
  }
}
    `;
export const ShipmentBillOfLadingDocument = gql`
    query shipmentBillOfLading($shipmentUuid: String!) {
  shipment(uuid: $shipmentUuid) {
    uuid
    ... on StandardShipmentEntity {
      fields {
        pickupOrDelivery
        deadlineDate
      }
    }
    shipperAddress {
      uuid
      name
      line1
      line2
      city
      state
      zip
    }
    legs {
      uuid
      endStop {
        stopType
        uuid
        destinationAirport
        address {
          uuid
          name
          line1
          line2
          city
          state
          zip
        }
      }
    }
    order {
      name
      standardOrderFields {
        shipperBillOfLadingNumber
        masterAirwayBillOfLadingNumber
        weightUnits
        measurementUnits
      }
      packages {
        ...ShallowPackage
      }
      billingPartyContact {
        uuid
        displayName
        addresses {
          uuid
          name
          line1
          line2
          city
          state
          zip
        }
        defaultAddress {
          name
          line1
          line2
          city
          state
          zip
        }
      }
      ediTransactions {
        uuid
        code
        status
      }
    }
  }
}
    ${ShallowPackageFragmentDoc}`;
export const StandardOrderDocument = gql`
    query standardOrder($uuid: String!) {
  standardOrder(uuid: $uuid) {
    ...StandardOrderFragment
  }
}
    ${StandardOrderFragmentFragmentDoc}`;
export const StopForDriverSettlementDocument = gql`
    query stopForDriverSettlement($uuid: String!) {
  stop(uuid: $uuid) {
    ...StopForDriverSettlement
  }
}
    ${StopForDriverSettlementFragmentDoc}`;
export const UncancelOrderDocument = gql`
    mutation uncancelOrder($uuid: String!) {
  uncancelOrder(uuid: $uuid) {
    uuid
    status
    detailedStatusV2
  }
}
    `;
export const UnfinalizeOrderDocument = gql`
    mutation unfinalizeOrder($uuid: String!) {
  unfinalizeOrder(uuid: $uuid) {
    uuid
    status
    detailedStatusV2
    shipments {
      uuid
      status
    }
  }
}
    `;
export const UnfinalizeOrdersDocument = gql`
    mutation UnfinalizeOrders($unfinalizeOrdersInput: UnfinalizeOrdersInput!) {
  unfinalizeOrders(unfinalizeOrdersInput: $unfinalizeOrdersInput) {
    ... on UnfinalizeOrdersSuccessOutput {
      unfinalizedOrderUuids
      skippedOnInvoiceOrderUuids
      failedOrderUuids
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const UnlinkPieceFromPackageDocument = gql`
    mutation unlinkPieceFromPackage($unlinkPieceFromPackageInput: UnlinkPieceFromPackageInput!) {
  unlinkPieceFromPackage(
    unlinkPieceFromPackageInput: $unlinkPieceFromPackageInput
  )
}
    `;
export const UpdateDocumentDocument = gql`
    mutation updateDocument($updateDocumentInput: UpdateDocumentInput!) {
  updateDocument(updateDocumentInput: $updateDocumentInput) {
    uuid
  }
}
    `;
export const UpdatePaperworkCompletedForStopsDocument = gql`
    mutation updatePaperworkCompletedForStops($updatePaperworkCompleteInput: UpdatePaperworkCompleteInput!) {
  updatePaperworkCompletedForStops(
    updatePaperworkCompleteInput: $updatePaperworkCompleteInput
  ) {
    uuid
  }
}
    `;
export const UpdateRecurringRunDocument = gql`
    mutation updateRecurringRun($input: UpdateRunInput!) {
  updateRun(updateRunInput: $input) {
    run {
      ...RecurringRunTemplate
    }
  }
}
    ${RecurringRunTemplateFragmentDoc}`;
export const UpdateStandardOrderDocument = gql`
    mutation updateStandardOrder($updateStandardOrderInput: UpdateStandardOrderInput!) {
  updateStandardOrder(updateStandardOrderInput: $updateStandardOrderInput) {
    uuid
    detailedStatusV2
    standardOrderFields {
      shipperBillOfLadingNumber
    }
    status
    packages {
      uuid
      quantity
    }
  }
}
    `;
export const ValidateBulkEditOrdersDocument = gql`
    query validateBulkEditOrders($bulkEditOrdersInput: BulkEditOrdersInput!) {
  validateBulkEditOrders(bulkEditOrdersInput: $bulkEditOrdersInput) {
    ...BulkEditOrdersResponseFragment
  }
}
    ${BulkEditOrdersResponseFragmentFragmentDoc}`;
export const RateOrderByUuidDocument = gql`
    query rateOrderByUuid($uuid: String!, $persist: Boolean!) {
  rateOrderByUuid(uuid: $uuid, persist: $persist) {
    __typename
    ... on RateOrderSuccessOutput {
      success
    }
    ... on RateOrderErrorOutput {
      success
      errorMessage
    }
  }
}
    `;
export const RateOrderTotalDollarsDocument = gql`
    query rateOrderTotalDollars($rateOrderInput: RateOrderInput!) {
  rateOrderContents(rateOrderInput: $rateOrderInput) {
    __typename
    ... on RateOrderSuccessOutput {
      success
      totalDollars
      inboundShipmentCharges {
        freightCharge {
          totalDollars
        }
        fuelCharge {
          totalDollars
        }
      }
      outboundShipmentCharges {
        freightCharge {
          totalDollars
        }
        fuelCharge {
          totalDollars
        }
      }
    }
    ... on RateOrderErrorOutput {
      success
      errorMessage
    }
  }
}
    `;
export const RateOrderDocument = gql`
    query rateOrder($rateOrderInput: RateOrderInput!) {
  rateOrderContents(
    rateOrderInput: $rateOrderInput
    withholdExpiredTariffFallback: true
  ) {
    __typename
    ... on RateOrderSuccessOutput {
      success
      totalDollars
      inboundShipmentCharges {
        freightCharge {
          rateDollars
          totalDollars
          tariffUuid
          quantity
          discountRate
          miles
          settlementFlatRate
          settlementPercentageRate
          tariffWarning
          expiredTariffGroup {
            name
            tariffGroupScope
            tariffGroupType
            endDate
            additional {
              name
              endDate
            }
          }
        }
        fuelCharge {
          surchargeRatePercentage
          totalDollars
          flatRateUsdDollars
          fuelProfileName
          settlementFlatRate
          settlementPercentageRate
          warning
          warningDetails {
            fuelProfileName
            tariffName
            fuelProfileExpired
          }
        }
        customCharges {
          rateDollars
          totalDollars
          fuelSurchargePercentageRate
          settlementFlatRate
          settlementPercentageRate
          warning
        }
        independentSettlementBillLineItems {
          ...RateOrderSettlementBillLineItem
        }
        externalRating {
          ...RateOrderExternalRating
        }
      }
      outboundShipmentCharges {
        freightCharge {
          rateDollars
          totalDollars
          tariffUuid
          quantity
          discountRate
          miles
          settlementFlatRate
          settlementPercentageRate
          tariffWarning
          expiredTariffGroup {
            name
            tariffGroupScope
            tariffGroupType
            endDate
            additional {
              name
              endDate
            }
          }
        }
        fuelCharge {
          surchargeRatePercentage
          totalDollars
          flatRateUsdDollars
          fuelProfileName
          settlementFlatRate
          settlementPercentageRate
          warning
          warningDetails {
            fuelProfileName
            tariffName
            fuelProfileExpired
          }
        }
        customCharges {
          rateDollars
          totalDollars
          fuelSurchargePercentageRate
          settlementFlatRate
          settlementPercentageRate
          warning
        }
        independentSettlementBillLineItems {
          ...RateOrderSettlementBillLineItem
        }
        externalRating {
          ...RateOrderExternalRating
        }
      }
      lineHaulCharges {
        freightCharge {
          rateDollars
          totalDollars
          tariffUuid
          quantity
          discountRate
          miles
          settlementFlatRate
          settlementPercentageRate
          tariffWarning
          expiredTariffGroup {
            name
            tariffGroupScope
            tariffGroupType
            endDate
            additional {
              name
              endDate
            }
          }
        }
        fuelCharge {
          surchargeRatePercentage
          totalDollars
          flatRateUsdDollars
          fuelProfileName
          settlementFlatRate
          settlementPercentageRate
          warning
          warningDetails {
            fuelProfileName
            tariffName
            fuelProfileExpired
          }
        }
        customCharges {
          rateDollars
          totalDollars
          fuelSurchargePercentageRate
          settlementFlatRate
          settlementPercentageRate
          warning
        }
        independentSettlementBillLineItems {
          ...RateOrderSettlementBillLineItem
        }
        externalRating {
          ...RateOrderExternalRating
        }
      }
      orderCharges {
        freightCharge {
          rateDollars
          totalDollars
          tariffUuid
          quantity
          discountRate
          miles
          settlementFlatRate
          settlementPercentageRate
          tariffWarning
          expiredTariffGroup {
            name
            tariffGroupScope
            tariffGroupType
            endDate
            additional {
              name
              endDate
            }
          }
        }
        fuelCharge {
          surchargeRatePercentage
          totalDollars
          flatRateUsdDollars
          fuelProfileName
          settlementFlatRate
          settlementPercentageRate
          warning
          warningDetails {
            fuelProfileName
            tariffName
            fuelProfileExpired
          }
        }
        customCharges {
          rateDollars
          totalDollars
          fuelSurchargePercentageRate
          settlementFlatRate
          settlementPercentageRate
          warning
        }
        independentSettlementBillLineItems {
          ...RateOrderSettlementBillLineItem
        }
        externalRating {
          ...RateOrderExternalRating
        }
      }
    }
    ... on RateOrderErrorOutput {
      success
      errorMessage
    }
  }
}
    ${RateOrderSettlementBillLineItemFragmentDoc}
${RateOrderExternalRatingFragmentDoc}`;
export const ActiveOrganizationMessageBannersDocument = gql`
    query ActiveOrganizationMessageBanners {
  activeOrganizationMessageBanners {
    banners {
      uuid
      severity
      title
      body
      linkType
      linkTarget
      linkLabel
      dismissible
    }
    nextChangeAt
  }
}
    `;
export const DismissOrganizationMessageDocument = gql`
    mutation DismissOrganizationMessage($input: OrganizationMessageUuidInput!) {
  dismissOrganizationMessage(input: $input)
}
    `;
export const BusinessKpiInvoicedOrdersDocument = gql`
    query BusinessKpiInvoicedOrders($args: KpiRecordTableArgs!) {
  businessKpiInvoicedOrders(args: $args) {
    totalRecords
    facets {
      ...KpiRecordFacets
    }
    records {
      orderUuid
      fileNo
      customerName
      createdAt
      invoicedAt
      invoiceUuid
      invoiceName
      days
    }
  }
}
    ${KpiRecordFacetsFragmentDoc}`;
export const BusinessKpiOrdersPerDriverDocument = gql`
    query BusinessKpiOrdersPerDriver($args: KpiRecordTableArgs!) {
  businessKpiOrdersPerDriver(args: $args) {
    totalRecords
    facets {
      ...KpiRecordFacets
    }
    records {
      driverUuid
      driverName
      orderCount
      share
    }
  }
}
    ${KpiRecordFacetsFragmentDoc}`;
export const BusinessKpiOrdersDocument = gql`
    query BusinessKpiOrders($args: KpiRecordTableArgs!) {
  businessKpiOrders(args: $args) {
    totalRecords
    revenueVisible
    facets {
      ...KpiRecordFacets
    }
    records {
      orderUuid
      fileNo
      customerName
      serviceDate
      terminalName
      driverNames
      revenueCents
    }
  }
}
    ${KpiRecordFacetsFragmentDoc}`;
export const BusinessKpiPaidInvoicesDocument = gql`
    query BusinessKpiPaidInvoices($args: KpiRecordTableArgs!) {
  businessKpiPaidInvoices(args: $args) {
    totalRecords
    amountVisible
    facets {
      ...KpiRecordFacets
    }
    records {
      invoiceUuid
      invoiceName
      customerName
      invoiceDate
      paidAt
      days
      amountCents
    }
  }
}
    ${KpiRecordFacetsFragmentDoc}`;
export const BusinessKpisDocument = gql`
    query BusinessKpis($args: KpiReportArgs!) {
  businessKpis(args: $args) {
    current {
      revenueCents
      orderCount
      driverCount
      ordersPerDriver
      avgDaysToInvoice
      invoicedOrderCount
      avgDaysToPayment
      paidInvoiceCount
      unassignedLineHaulCents
      unassignedNoTerminalCents
    }
    lastYear {
      revenueCents
      orderCount
      driverCount
      ordersPerDriver
      avgDaysToInvoice
      invoicedOrderCount
      avgDaysToPayment
      paidInvoiceCount
      unassignedLineHaulCents
      unassignedNoTerminalCents
    }
  }
}
    `;
export const DeliveryFailureKpiDocument = gql`
    query DeliveryFailureKpi($args: KpiReportArgs!) {
  deliveryFailureKpi(args: $args) {
    failurePct
    scheduledStops
    deliveredStops
    failedStops
    settledStops
    pendingStops
    deliveredLateDayStops
    neverDeliveredStops
    forceMarkedCompleteStops
    bucketUnit
    trend {
      bucketDate
      settledStops
      failedStops
      failurePct
    }
    customers {
      uuid
      name
      settledStops
      failedStops
      failurePct
    }
    drivers {
      uuid
      name
      settledStops
      failedStops
      failurePct
    }
    terminals {
      uuid
      name
      settledStops
      failedStops
      failurePct
    }
    stops {
      orderUuid
      fileNo
      customerName
      promisedDate
      stopTimeZone
      appointmentTime
      endAppointmentTime
      fromDeadline
      stopStatus
      completedAt
      terminalName
      driverNames
    }
  }
}
    `;
export const DeliveryFailureStopsDocument = gql`
    query DeliveryFailureStops($args: KpiRecordTableArgs!) {
  deliveryFailureStops(args: $args) {
    totalStops
    facets {
      ...KpiRecordFacets
    }
    stops {
      orderUuid
      fileNo
      customerName
      promisedDate
      fromDeadline
      completedAt
      stopStatus
      stopTimeZone
      daysLate
      terminalName
      driverNames
    }
  }
}
    ${KpiRecordFacetsFragmentDoc}`;
export const DockReceivedKpiReceiptsDocument = gql`
    query DockReceivedKpiReceipts($args: KpiRecordTableArgs!) {
  dockReceivedKpiReceipts(args: $args) {
    totalRecords
    facets {
      ...KpiRecordFacets
    }
    records {
      pieceName
      orderUuid
      fileNo
      customerName
      receivedAt
      terminalName
    }
  }
}
    ${KpiRecordFacetsFragmentDoc}`;
export const DockReceivedKpiDocument = gql`
    query DockReceivedKpi($args: KpiReportArgs!) {
  dockReceivedKpi(args: $args) {
    piecesReceivedCount
    ordersReceivedCount
    arrivalScanCount
    unlinkedScanCount
    bucketUnit
    trend {
      bucketDate
      piecesReceivedCount
    }
    terminals {
      uuid
      name
      piecesReceivedCount
      ordersReceivedCount
    }
  }
}
    `;
export const KpiComparisonsDocument = gql`
    query KpiComparisons($args: KpiReportArgs!) {
  kpiComparisons(args: $args) {
    delivery {
      priorPeriod {
        pct
        numerator
        denominator
      }
      lastMonth {
        pct
        numerator
        denominator
      }
    }
    pickup {
      priorPeriod {
        pct
        numerator
        denominator
      }
      lastMonth {
        pct
        numerator
        denominator
      }
    }
    scan {
      priorPeriod {
        pct
        numerator
        denominator
      }
      lastMonth {
        pct
        numerator
        denominator
      }
    }
    deliveryFailure {
      priorPeriod {
        pct
        numerator
        denominator
      }
      lastMonth {
        pct
        numerator
        denominator
      }
    }
  }
}
    `;
export const KpiDashboardLayoutDocument = gql`
    query KpiDashboardLayout {
  kpiDashboardLayout {
    ...KpiDashboardLayout
  }
}
    ${KpiDashboardLayoutFragmentDoc}`;
export const KpiDataStartDocument = gql`
    query KpiDataStart {
  kpiDataStart {
    firstServiceDate {
      iso8601
    }
  }
}
    `;
export const KpiRecordTableDownloadDocument = gql`
    mutation KpiRecordTableDownload($args: KpiRecordTableDownloadArgs!) {
  kpiRecordTableDownload(args: $args) {
    __typename
    ... on KpiRecordTableDownloadFileOutput {
      url
      fileName
    }
    ... on KpiRecordTableEmailToUserOutput {
      rowCount
      emailedTo
    }
  }
}
    `;
export const OnTimeKpiStopsDocument = gql`
    query OnTimeKpiStops($args: OnTimeKpiStopsArgs!) {
  onTimeKpiStops(args: $args) {
    totalStops
    facets {
      ...KpiRecordFacets
    }
    stops {
      orderUuid
      fileNo
      customerName
      promiseSource
      promisedAt
      judgedEvent
      judgedAt
      arrivedAt
      completedAt
      appointmentTime
      endAppointmentTime
      stopTimeZone
      terminalName
      driverNames
    }
  }
}
    ${KpiRecordFacetsFragmentDoc}`;
export const OnTimeKpiDocument = gql`
    query OnTimeKpi($args: OnTimeKpiArgs!) {
  onTimeKpi(args: $args) {
    onTimePct
    onTimeStops
    lateStops
    measurableStops
    excludedNoPromiseStops
    completedStops
    fallbackJudgedStops
    customerAppointment {
      measurableStops
      onTimeStops
      onTimePct
    }
    forwarderDate {
      measurableStops
      onTimeStops
      onTimePct
    }
    bucketUnit
    trend {
      bucketDate
      measurableStops
      onTimeStops
      onTimePct
    }
    customers {
      customerUuid
      customerName
      measurableStops
      lateStops
      onTimePct
    }
    drivers {
      uuid
      name
      measurableStops
      lateStops
      onTimePct
    }
    terminals {
      uuid
      name
      measurableStops
      lateStops
      onTimePct
    }
  }
}
    `;
export const PieceScanKpiPiecesDocument = gql`
    query PieceScanKpiPieces($args: KpiRecordTableArgs!) {
  pieceScanKpiPieces(args: $args) {
    totalRecords
    facets {
      ...KpiRecordFacets
    }
    records {
      orderUuid
      fileNo
      pieceName
      customerName
      serviceDate
      terminalName
      scanned
      weight
      weightUnits
    }
  }
}
    ${KpiRecordFacetsFragmentDoc}`;
export const PieceScanKpiDocument = gql`
    query PieceScanKpi($args: KpiReportArgs!) {
  pieceScanKpi(args: $args) {
    scanRatePct
    piecesDeliveredWithScanCount
    piecesDeliveredCount
    piecesUnscannedCount
    bucketUnit
    trend {
      bucketDate
      piecesDeliveredCount
      piecesDeliveredWithScanCount
      scanRatePct
    }
    customers {
      customerUuid
      customerName
      piecesDeliveredCount
      piecesUnscannedCount
      scanRatePct
    }
    drivers {
      uuid
      name
      piecesDeliveredCount
      piecesUnscannedCount
      scanRatePct
    }
    terminals {
      uuid
      name
      piecesDeliveredCount
      piecesUnscannedCount
      scanRatePct
    }
  }
}
    `;
export const UpdateKpiDashboardLayoutDocument = gql`
    mutation UpdateKpiDashboardLayout($input: UpdateKpiLayoutInput!) {
  updateKpiDashboardLayout(input: $input) {
    ...KpiDashboardLayout
  }
}
    ${KpiDashboardLayoutFragmentDoc}`;
export const UpdatePackageDocument = gql`
    mutation updatePackage($updatePackageInput: UpdatePackageInput!) {
  updatePackage(updatePackageInput: $updatePackageInput) {
    uuid
  }
}
    `;
export const CreatePermissionDocument = gql`
    mutation createPermission($createPermissionInput: CreatePermissionInput!) {
  createPermission(createPermissionInput: $createPermissionInput) {
    success
  }
}
    `;
export const DeletePermissionDocument = gql`
    mutation deletePermission($deletePermissionInput: DeletePermissionInput!) {
  deletePermission(deletePermissionInput: $deletePermissionInput) {
    success
  }
}
    `;
export const UpdatePermissionAccessLevelDocument = gql`
    mutation updatePermissionAccessLevel($updatePermissionAccessLevelInput: UpdatePermissionAccessLevelInput!) {
  updatePermissionAccessLevel(
    updatePermissionAccessLevelInput: $updatePermissionAccessLevelInput
  ) {
    success
  }
}
    `;
export const UpdatePermissionDocument = gql`
    mutation updatePermission($updatePermissionInput: UpdatePermissionInput!) {
  updatePermission(updatePermissionInput: $updatePermissionInput) {
    success
  }
}
    `;
export const AddPiecesToPieceReceiptDocument = gql`
    mutation addPiecesToPieceReceipt($addPiecesToPieceReceiptInput: AddPiecesToPieceReceiptInput!) {
  addPiecesToPieceReceipt(
    addPiecesToPieceReceiptInput: $addPiecesToPieceReceiptInput
  ) {
    pieceReceipt {
      ...PieceReceiptDetail
    }
    createdCount
    linkedCount
  }
}
    ${PieceReceiptDetailFragmentDoc}`;
export const CreatePieceReceiptDocument = gql`
    mutation createPieceReceipt($createPieceReceiptInput: CreatePieceReceiptInput!) {
  createPieceReceipt(createPieceReceiptInput: $createPieceReceiptInput) {
    pieceReceipt {
      uuid
    }
  }
}
    `;
export const DeletePieceReceiptDocument = gql`
    mutation deletePieceReceipt($deletePieceReceiptInput: DeletePieceReceiptInput!) {
  deletePieceReceipt(deletePieceReceiptInput: $deletePieceReceiptInput) {
    success
  }
}
    `;
export const PieceReceiptEventsDocument = gql`
    query pieceReceiptEvents($pieceReceiptUuid: String!) {
  orderEvents(pieceReceiptUuid: $pieceReceiptUuid) {
    ...OrderEvent
  }
}
    ${OrderEventFragmentDoc}`;
export const PieceReceiptLinkablePiecesDocument = gql`
    query pieceReceiptLinkablePieces($findPiecesInput: FindPiecesInput!) {
  pieces(findPiecesInput: $findPiecesInput) {
    edges {
      node {
        ...PieceReceiptSearchResult
      }
    }
  }
}
    ${PieceReceiptSearchResultFragmentDoc}`;
export const PieceReceiptPieceDetailDocument = gql`
    query pieceReceiptPieceDetail($pieceReceiptUuid: String!, $pieceUuid: String!) {
  pieceReceiptPiece(pieceReceiptUuid: $pieceReceiptUuid, pieceUuid: $pieceUuid) {
    uuid
    referenceNumber
    status
    type
    weight
    dimWeight
    length
    width
    height
    weightUnits
    measurementUnits
    markedOnHandAt
    warehouseLocation {
      uuid
      name
    }
    children {
      uuid
      referenceNumber
      status
      quantity
    }
  }
}
    `;
export const PieceReceiptDocument = gql`
    query pieceReceipt($findPieceReceiptInput: FindPieceReceiptInput!) {
  pieceReceipt(findPieceReceiptInput: $findPieceReceiptInput) {
    pieceReceipt {
      ...PieceReceiptDetail
    }
  }
}
    ${PieceReceiptDetailFragmentDoc}`;
export const PieceReceiptsDocument = gql`
    query pieceReceipts($findPieceReceiptsInput: FindPieceReceiptsInput!) {
  pieceReceipts(findPieceReceiptsInput: $findPieceReceiptsInput) {
    pieceReceiptConnection {
      totalCount
      edges {
        node {
          ...PieceReceipt
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${PieceReceiptFragmentDoc}`;
export const RemovePiecesFromPieceReceiptDocument = gql`
    mutation removePiecesFromPieceReceipt($removePiecesFromPieceReceiptInput: RemovePiecesFromPieceReceiptInput!) {
  removePiecesFromPieceReceipt(
    removePiecesFromPieceReceiptInput: $removePiecesFromPieceReceiptInput
  ) {
    pieceReceipt {
      ...PieceReceiptDetail
    }
    removedCount
  }
}
    ${PieceReceiptDetailFragmentDoc}`;
export const UpdatePieceReceiptPieceDocument = gql`
    mutation updatePieceReceiptPiece($updatePieceReceiptPieceInput: UpdatePieceReceiptPieceInput!) {
  updatePieceReceiptPiece(
    updatePieceReceiptPieceInput: $updatePieceReceiptPieceInput
  ) {
    piece {
      uuid
      referenceNumber
      status
      type
      weight
      dimWeight
      length
      width
      height
      weightUnits
      measurementUnits
      markedOnHandAt
      warehouseLocation {
        uuid
        name
      }
    }
  }
}
    `;
export const UpdatePieceReceiptDocument = gql`
    mutation updatePieceReceipt($updatePieceReceiptInput: UpdatePieceReceiptInput!) {
  updatePieceReceipt(updatePieceReceiptInput: $updatePieceReceiptInput) {
    pieceReceipt {
      ...PieceReceipt
    }
  }
}
    ${PieceReceiptFragmentDoc}`;
export const BulkDeletePiecesDocument = gql`
    mutation BulkDeletePieces($input: BulkDeletePiecesInput!) {
  bulkDeletePieces(input: $input) {
    successCount
    failureCount
    failures {
      uuid
      reason
    }
  }
}
    `;
export const BulkDiscardPiecesDocument = gql`
    mutation BulkDiscardPieces($input: BulkDiscardPiecesInput!) {
  bulkDiscardPieces(input: $input) {
    successCount
    failureCount
    failures {
      uuid
      reason
    }
  }
}
    `;
export const BulkRestorePiecesDocument = gql`
    mutation BulkRestorePieces($input: BulkRestorePiecesInput!) {
  bulkRestorePieces(input: $input) {
    successCount
    failureCount
    failures {
      uuid
      reason
    }
  }
}
    `;
export const FindPiecesDocument = gql`
    query findPieces($findPiecesInput: FindPiecesInput!, $includeInboundFields: Boolean = false, $includeDeliveredFields: Boolean = false, $includeInTransitFields: Boolean = false, $includeDiscardedFields: Boolean = false) {
  pieces(findPiecesInput: $findPiecesInput) {
    edges {
      node {
        ...FindPieces
        ...FindPiecesInbound @include(if: $includeInboundFields)
        ...FindPiecesDelivered @include(if: $includeDeliveredFields)
        ...FindPiecesInTransit @include(if: $includeInTransitFields)
        ...FindPiecesDiscarded @include(if: $includeDiscardedFields)
      }
      cursor
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${FindPiecesFragmentDoc}
${FindPiecesInboundFragmentDoc}
${FindPiecesDeliveredFragmentDoc}
${FindPiecesInTransitFragmentDoc}
${FindPiecesDiscardedFragmentDoc}`;
export const LinkPieceToOrderWithRoleDocument = gql`
    mutation LinkPieceToOrderWithRole($input: LinkPieceToOrderInput!) {
  linkPieceToOrderWithRole(input: $input) {
    uuid
    status
  }
}
    `;
export const OrderCommentsByPieceDocument = gql`
    query orderCommentsByPiece($pieceUuid: String!) {
  orderComments(pieceUuid: $pieceUuid) {
    uuid
    createdAt
    comment
    authorName
    piece {
      uuid
      referenceNumber
    }
  }
}
    `;
export const PieceBucketMetricsDocument = gql`
    query pieceBucketMetrics($input: PieceBucketMetricsInput!) {
  pieceBucketMetrics(input: $input) {
    metrics {
      key
      label
      value
      unit
    }
  }
}
    `;
export const PieceDetailDocument = gql`
    query pieceDetail($uuid: String!) {
  piece(uuid: $uuid) {
    ...PieceDetail
  }
}
    ${PieceDetailFragmentDoc}`;
export const PieceEventsDocument = gql`
    query pieceEvents($pieceUuid: String!, $sortByCreatedAtAsc: Boolean) {
  orderEvents(pieceUuid: $pieceUuid, sortByCreatedAtAsc: $sortByCreatedAtAsc) {
    ...PieceEvent
  }
}
    ${PieceEventFragmentDoc}`;
export const TransferPieceToOrderDocument = gql`
    mutation TransferPieceToOrder($input: TransferPieceToOrderInput!) {
  transferPieceToOrder(input: $input) {
    uuid
    status
  }
}
    `;
export const TransferPieceToOutboundOrderDocument = gql`
    mutation TransferPieceToOutboundOrder($input: TransferPieceToOutboundOrderInput!) {
  transferPieceToOutboundOrder(input: $input) {
    uuid
    status
  }
}
    `;
export const UnlinkPieceFromOrderDocument = gql`
    mutation UnlinkPieceFromOrder($input: UnlinkPieceFromOrderInput!) {
  unlinkPieceFromOrder(input: $input) {
    uuid
    status
  }
}
    `;
export const UpdatePieceReferenceNumberDocument = gql`
    mutation UpdatePieceReferenceNumber($updatePieceInput: UpdatePieceInput!) {
  updatePiece(updatePieceInput: $updatePieceInput) {
    uuid
    referenceNumber
  }
}
    `;
export const EmailQuoteQueueDocument = gql`
    query emailQuoteQueue($scope: OrderQuoteQueueScope!, $first: Int, $last: Int, $after: String, $before: String) {
  orderQuotes(
    scope: $scope
    first: $first
    last: $last
    after: $after
    before: $before
    includeCount: true
  ) {
    totalCount
    needsYouCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ...EmailQuoteQueueRow
      }
    }
  }
}
    ${EmailQuoteQueueRowFragmentDoc}`;
export const EmailQuoteDocument = gql`
    query emailQuote($orderQuoteUuid: String!) {
  orderQuote(orderQuoteUuid: $orderQuoteUuid) {
    ...OrderQuoteForReview
    subject
    queueGroup
    latestVersionUuid
    extractedRequest {
      pickup {
        kind
        companyName
        line1
        line2
        city
        state
        zip
        country
        airportCode
        airlines
        readyWindow
      }
      delivery {
        kind
        companyName
        line1
        line2
        city
        state
        zip
        country
        airportCode
        airlines
        readyWindow
      }
      shipper {
        name
        contact
      }
      consignee {
        name
        contact
      }
      packages {
        quantity
        packaging
        piecesPerUnit
        length
        width
        height
        dimensionUnit
        dimensionBasis
        weight
        weightUnit
        weightBasis
        commodity
      }
      shipDate
      readyTime
      serviceWording
      accessorials
      hazmat
      specialInstructions
      truncatedFields
    }
  }
}
    ${OrderQuoteForReviewFragmentDoc}`;
export const ApproveQuoteDocument = gql`
    mutation approveQuote($approveQuoteInput: ApproveQuoteInput!) {
  approveQuote(approveQuoteInput: $approveQuoteInput) {
    uuid
  }
}
    `;
export const ClientQuotesDocument = gql`
    query clientQuotes($findClientQuotesInput: FindClientQuotesInput!) {
  clientQuotes(findClientQuotesInput: $findClientQuotesInput) {
    edges {
      node {
        ...ClientQuote
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    ${ClientQuoteFragmentDoc}`;
export const CreateQuoteDocument = gql`
    mutation createQuote($createQuoteInput: CreateQuoteInput!) {
  createQuote(createQuoteInput: $createQuoteInput) {
    uuid
  }
}
    `;
export const QuoteContributionRatioDocument = gql`
    query quoteContributionRatio($rateOrderInput: RateOrderInput!, $input: QuoteContributionRatioInput!) {
  quoteContributionRatio(rateOrderInput: $rateOrderInput, input: $input) {
    ratio
    status
    revenueUsd
    driverSettlementUsd
    storedDriverSettlementUsdCents
    contributionUsd
    benchmarkUsd
    benchmarkLegs {
      leg
      hasTariff
      tariffGroupName
      totalUsd
    }
    actualWeightLb
    marginalFromRatio
    profitableFromRatio
  }
}
    `;
export const QuoteNameDocument = gql`
    query quoteName($billingPartyContactUuid: String!) {
  quoteName(billingPartyContactUuid: $billingPartyContactUuid)
}
    `;
export const QuoteDocument = gql`
    query quote($uuid: String!) {
  quote(uuid: $uuid) {
    ...Quote
    ...QuoteFreightNeedsRate
    billingPartyContact {
      ... on CustomerContactEntity {
        defaultDimFactor
        defaultFuelSurcharge
        defaultUseTariff
      }
    }
    lineHaulOriginTerminal {
      uuid
    }
    lineHaulLane {
      uuid
      originTerminal {
        uuid
        code
      }
      destinationTerminal {
        uuid
        code
      }
    }
  }
}
    ${QuoteFragmentDoc}
${QuoteFreightNeedsRateFragmentDoc}`;
export const QuotesDocument = gql`
    query quotes($first: Int, $after: String, $last: Int, $before: String, $searchText: String, $quoteStatus: QuoteStatus, $originTerminalUuid: String, $destinationTerminalUuid: String, $createdAtStartDate: DateTime, $createdAtEndDate: DateTime) {
  quotes(
    first: $first
    last: $last
    after: $after
    before: $before
    searchText: $searchText
    quoteStatus: $quoteStatus
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
    createdAtStartDate: $createdAtStartDate
    createdAtEndDate: $createdAtEndDate
  ) {
    edges {
      node {
        ...Quote
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${QuoteFragmentDoc}`;
export const RerateQuoteFreightDocument = gql`
    mutation RerateQuoteFreight($quoteUuid: String!) {
  rerateQuoteFreight(quoteUuid: $quoteUuid) {
    externalRatings {
      freightChargeUuid
      status
      externalRating {
        __typename
        ... on ExternalRatingFailure {
          message
        }
      }
    }
  }
}
    `;
export const UpdateQuoteDocument = gql`
    mutation updateQuote($updateQuoteInput: UpdateQuoteInput!) {
  updateQuote(updateQuoteInput: $updateQuoteInput) {
    uuid
  }
}
    `;
export const CreateReportGroupConfigurationDocument = gql`
    mutation createReportGroupConfiguration($createReportGroupConfigurationInput: ReportGroupConfigurationCreateInput!) {
  createReportGroupConfiguration(
    createReportGroupConfigurationInput: $createReportGroupConfigurationInput
  ) {
    ...ReportGroupConfiguration
  }
}
    ${ReportGroupConfigurationFragmentDoc}`;
export const CustomerReportDocument = gql`
    query customerReport($args: CustomerReportArgs!) {
  customerReport(args: $args) {
    ...CustomerReportBucket
  }
}
    ${CustomerReportBucketFragmentDoc}`;
export const DeleteReportGroupConfigurationDocument = gql`
    mutation deleteReportGroupConfiguration($uuid: String!) {
  deleteReportGroupConfiguration(uuid: $uuid) {
    ...ReportGroupConfiguration
  }
}
    ${ReportGroupConfigurationFragmentDoc}`;
export const DriverReportDocument = gql`
    query driverReport($args: DriverReportArgs!) {
  driverReport(args: $args) {
    ...DriverReportBucket
  }
}
    ${DriverReportBucketFragmentDoc}`;
export const OrderReportDocument = gql`
    query orderReport($args: OrderReportArgs!) {
  orderReport(args: $args) {
    ...OrderReportBucket
  }
}
    ${OrderReportBucketFragmentDoc}`;
export const ReportGroupConfigurationsDocument = gql`
    query reportGroupConfigurations {
  reportGroupConfigurations {
    ...ReportGroupConfiguration
  }
}
    ${ReportGroupConfigurationFragmentDoc}`;
export const ReportSendJobBatchesDocument = gql`
    query reportSendJobBatches($findReportSendJobBatchesInput: FindReportSendJobBatchesInput!) {
  reportSendJobBatches(
    findReportSendJobBatchesInput: $findReportSendJobBatchesInput
  ) {
    reportSendJobBatchConnection {
      totalCount
      edges {
        node {
          ...ReportSendJobBatch
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ReportSendJobBatchFragmentDoc}`;
export const ReportSendJobsDocument = gql`
    query reportSendJobs($findReportSendJobsInput: FindReportSendJobsInput!) {
  reportSendJobs(findReportSendJobsInput: $findReportSendJobsInput) {
    reportSendJobConnection {
      totalCount
      edges {
        node {
          ...ReportSendJob
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ReportSendJobFragmentDoc}`;
export const SendAccountingReportsDocument = gql`
    mutation sendAccountingReports($sendAccountingReportsInput: SendAccountingReportsInput!) {
  sendAccountingReports(sendAccountingReportsInput: $sendAccountingReportsInput) {
    ... on SendAccountingReportsSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ServiceLevelReportDocument = gql`
    query serviceLevelReport($args: ServiceLevelReportArgs!) {
  serviceLevelReport(args: $args) {
    ...ServiceLevelReportBucket
  }
}
    ${ServiceLevelReportBucketFragmentDoc}`;
export const StationReportDocument = gql`
    query stationReport($args: StationReportArgs!) {
  stationReport(args: $args) {
    ...StationReportBucket
  }
}
    ${StationReportBucketFragmentDoc}`;
export const TerminalReportDocument = gql`
    query terminalReport($args: TerminalReportArgs!) {
  terminalReport(args: $args) {
    ...TerminalReportBucket
  }
}
    ${TerminalReportBucketFragmentDoc}`;
export const UpdateReportGroupConfigurationDocument = gql`
    mutation updateReportGroupConfiguration($updateReportGroupConfigurationInput: ReportGroupConfigurationUpdateInput!) {
  updateReportGroupConfiguration(
    updateReportGroupConfigurationInput: $updateReportGroupConfigurationInput
  ) {
    ...ReportGroupConfiguration
  }
}
    ${ReportGroupConfigurationFragmentDoc}`;
export const AppointmentOptionsDocument = gql`
    query AppointmentOptions($input: AppointmentOptionsInput!) {
  appointmentOptions(input: $input) {
    appointmentExists
    rescheduleRequested
    message
    options {
      date {
        year
        month
        day
      }
      startTime {
        hour
        minute
      }
      endTime {
        hour
        minute
      }
      humanDate
    }
    pageSize
  }
}
    `;
export const ChooseAppointmentOptionDocument = gql`
    mutation ChooseAppointmentOption($input: ChooseAppointmentOptionInput!) {
  chooseAppointmentOption(input: $input) {
    __typename
    ... on ChooseAppointmentOptionSuccessOutput {
      appointmentDateTime
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const QueueAppointmentSchedulingProposalsDocument = gql`
    mutation QueueAppointmentSchedulingProposals($input: QueueAppointmentSchedulingProposalsInput!) {
  queueAppointmentSchedulingProposals(input: $input) {
    __typename
    ... on QueueAppointmentSchedulingProposalsSuccessOutput {
      stopUuids
      errorMessages
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const AddUserToRoleDocument = gql`
    mutation addUserToRole($addUserToRoleInput: AddUserToRoleInput!) {
  addUserToRole(addUserToRoleInput: $addUserToRoleInput) {
    success
  }
}
    `;
export const CreateRoleDocument = gql`
    mutation createRole($createRoleInput: CreateRoleInput!) {
  createRole(createRoleInput: $createRoleInput) {
    role {
      uuid
    }
  }
}
    `;
export const RoleDocument = gql`
    query role($findRoleInput: FindRoleInput!) {
  role(findRoleInput: $findRoleInput) {
    role {
      ...FindRole
    }
  }
}
    ${FindRoleFragmentDoc}`;
export const RolesDocument = gql`
    query roles($findRolesInput: FindRolesInput) {
  roles(findRolesInput: $findRolesInput) {
    roles {
      ...FindRoles
    }
  }
}
    ${FindRolesFragmentDoc}`;
export const RemoveUserFromRoleDocument = gql`
    mutation removeUserFromRole($removeUserFromRoleInput: RemoveUserFromRoleInput!) {
  removeUserFromRole(removeUserFromRoleInput: $removeUserFromRoleInput) {
    success
  }
}
    `;
export const UpdateRoleDocument = gql`
    mutation updateRole($updateRoleInput: UpdateRoleInput!) {
  updateRole(updateRoleInput: $updateRoleInput) {
    success
  }
}
    `;
export const UsersForRoleDocument = gql`
    query usersForRole {
  users {
    ...UsersForRole
  }
}
    ${UsersForRoleFragmentDoc}`;
export const CreateShipmentDocumentDocument = gql`
    mutation createShipmentDocument($createShipmentDocumentInput: CreateShipmentDocumentInput!) {
  createShipmentDocument(
    createShipmentDocumentInput: $createShipmentDocumentInput
  ) {
    ...Document
  }
}
    ${DocumentFragmentDoc}`;
export const CompleteStopBulkDocument = gql`
    mutation completeStopBulk($completeStopBulkInput: CompleteStopBulkInput!) {
  completeStopBulk(completeStopBulkInput: $completeStopBulkInput) {
    ...StopOnRoute
  }
}
    ${StopOnRouteFragmentDoc}`;
export const CompleteStopV2Document = gql`
    mutation completeStopV2($completeStopInput: CompleteStopInput!) {
  completeStopV2(completeStopInput: $completeStopInput) {
    ... on CompleteStopEntity {
      uuid
    }
    ... on CompleteStopInvalidInputException {
      message
    }
  }
}
    `;
export const DeleteDocumentDocument = gql`
    mutation deleteDocument($uuid: String!) {
  deleteDocument(uuid: $uuid) {
    uuid
  }
}
    `;
export const GenerateShipmentPreSignedPutUrlDocument = gql`
    mutation generateShipmentPreSignedPutUrl($generateShipmentPreSignedPutUrlInput: GenerateShipmentPreSignedPutUrlInput!) {
  generateShipmentPreSignedPutUrl(
    generateShipmentPreSignedPutUrlInput: $generateShipmentPreSignedPutUrlInput
  )
}
    `;
export const MarkStopAsFailedDocument = gql`
    mutation markStopAsFailed($uuid: String!) {
  markStopAsFailed(uuid: $uuid) {
    uuid
  }
}
    `;
export const MarkStopAsFailedV2Document = gql`
    mutation markStopAsFailedV2($markStopAsFailedV2Input: MarkStopAsFailedV2Input!) {
  markStopAsFailedV2(markStopAsFailedV2Input: $markStopAsFailedV2Input) {
    uuid
  }
}
    `;
export const NameOfRouteDocument = gql`
    query nameOfRoute($uuid: String!) {
  route(uuid: $uuid) {
    uuid
    name
  }
}
    `;
export const EquipmentsFetchDocument = gql`
    query equipmentsFetch($equipmentTypes: [EquipmentType!]) {
  equipments(types: $equipmentTypes) {
    uuid
    name
  }
}
    `;
export const RouteDocument = gql`
    query route($uuid: String!, $canReadIntelligenceBoard: Boolean! = false) {
  route(uuid: $uuid) {
    ...Route
  }
}
    ${RouteFragmentDoc}`;
export const ShallowRoutesDocument = gql`
    query shallowRoutes($date: DateTime!) {
  routes(date: $date) {
    uuid
    name
    date
    drivers {
      firstName
      lastName
    }
    startTime
    slots {
      uuid
      stops {
        uuid
        status
        address {
          city
        }
      }
    }
  }
}
    `;
export const UpdateServiceDateForAssignedStopsDocument = gql`
    mutation updateServiceDateForAssignedStops($updateServiceDateForAssignedStopsInput: UpdateServiceDateForAssignedStopsInput!) {
  updateServiceDateForAssignedStops(
    updateServiceDateForAssignedStopsInput: $updateServiceDateForAssignedStopsInput
  ) {
    uuid
  }
}
    `;
export const UpdateStopDocument = gql`
    mutation updateStop($updateStopInput: UpdateStopInput!) {
  updateStop(updateStopInput: $updateStopInput) {
    uuid
    contactPerson {
      uuid
      phone
    }
  }
}
    `;
export const UpdateStopsDocument = gql`
    mutation updateStops($updateStopsInput: UpdateStopsInput!) {
  updateStops(updateStopsInput: $updateStopsInput) {
    uuid
  }
}
    `;
export const SamaraOAuthAuthorizeUrlDocument = gql`
    query samaraOAuthAuthorizeUrl {
  samaraOAuthAuthorizeUrl
}
    `;
export const SamsaraOAuthTokenDocument = gql`
    query samsaraOAuthToken {
  samsaraOAuthToken {
    uuid
  }
}
    `;
export const CloneSavedFilterViewDocument = gql`
    mutation cloneSavedFilterView($cloneSavedFilterViewInput: CloneSavedFilterViewInput!) {
  cloneSavedFilterView(cloneSavedFilterViewInput: $cloneSavedFilterViewInput) {
    uuid
  }
}
    `;
export const CreateSavedFilterViewDocument = gql`
    mutation createSavedFilterView($createSavedFilterViewInput: CreateSavedFilterViewInput!) {
  createSavedFilterView(createSavedFilterViewInput: $createSavedFilterViewInput) {
    uuid
  }
}
    `;
export const DeleteSavedFilterViewDocument = gql`
    mutation deleteSavedFilterView($uuid: String!) {
  deleteSavedFilterView(uuid: $uuid) {
    uuid
  }
}
    `;
export const GetSavedFilterViewsDocument = gql`
    query getSavedFilterViews($pageType: String!) {
  getSavedFilterViews(pageType: $pageType) {
    ...SavedFilterView
  }
}
    ${SavedFilterViewFragmentDoc}`;
export const ShareSavedFilterViewDocument = gql`
    mutation shareSavedFilterView($shareSavedFilterViewInput: ShareSavedFilterViewInput!) {
  shareSavedFilterView(shareSavedFilterViewInput: $shareSavedFilterViewInput) {
    ...SavedFilterView
  }
}
    ${SavedFilterViewFragmentDoc}`;
export const UpdateSavedFilterViewDocument = gql`
    mutation updateSavedFilterView($updateSavedFilterViewInput: UpdateSavedFilterViewInput!) {
  updateSavedFilterView(updateSavedFilterViewInput: $updateSavedFilterViewInput) {
    uuid
  }
}
    `;
export const MergeScannedOrderResultIntoPossibleDuplicateDocument = gql`
    mutation mergeScannedOrderResultIntoPossibleDuplicate($input: MergeScannedOrderResultIntoPossibleDuplicateInput!) {
  mergeScannedOrderResultIntoPossibleDuplicate(input: $input) {
    uuid
    status
  }
}
    `;
export const ScannedOrderResultDocument = gql`
    query scannedOrderResult($uuid: String!, $viewAllUploads: Boolean) {
  numberOfScannedOrderResultsInReview(viewAllUploads: $viewAllUploads)
  scannedOrderResult(uuid: $uuid) {
    ...ScannedOrderResultFragment
    scannedOrder {
      uuid
      key
      preSignedGetUrl
    }
    scannedOrderResultDocuments {
      uuid
      filename
      key
      preSignedGetUrl
      scannedDocumentType
      scannedOrderResultDocumentPages {
        uuid
        bucket
        key
        page
        preSignedGetUrl
      }
    }
    scannedOrderResultPages {
      ...ScannedOrderResultPageFragment
    }
    order {
      uuid
      name
    }
    possibleDuplicateOrder {
      uuid
      name
    }
    mergedAwayOrder {
      uuid
      name
    }
    serviceSelection {
      source
      extractedText
      suggestedServiceUuid
      suggestedServiceSource
    }
    nextScannedOrderResultInReview(viewAllUploads: $viewAllUploads) {
      ...ScannedOrderResultFragment
      uuid
      order {
        uuid
      }
    }
  }
}
    ${ScannedOrderResultFragmentFragmentDoc}
${ScannedOrderResultPageFragmentFragmentDoc}`;
export const BillingPartyPickerDocument = gql`
    query billingPartyPicker($uuid: String!) {
  scannedOrderResult(uuid: $uuid) {
    uuid
    status
    failureReason
    dismissed
    filename
    pageStart
    pageEnd
    order {
      uuid
    }
    billingPartyCandidates {
      contactUuid
      contactName
      votes
      share
      isActive
    }
    scannedOrder {
      uuid
      key
      filename
      source
      preSignedGetUrl
      ingestedOutlookEmailDetails {
        fromAddress
        subject
        receivedAt
        bodyPreview
        body
      }
    }
    scannedOrderResultPages {
      uuid
      page
      preSignedGetUrl
    }
  }
}
    `;
export const FirstScannedOrderResultInReviewDocument = gql`
    query firstScannedOrderResultInReview($viewAllUploads: Boolean) {
  firstScannedOrderResultInReview(viewAllUploads: $viewAllUploads) {
    uuid
    status
    failureReason
    dismissed
    order {
      uuid
    }
  }
}
    `;
export const ResolveScannedOrderBillingPartyDocument = gql`
    mutation resolveScannedOrderBillingParty($resolveScannedOrderBillingPartyInput: ResolveScannedOrderBillingPartyInput!) {
  resolveScannedOrderBillingParty(
    resolveScannedOrderBillingPartyInput: $resolveScannedOrderBillingPartyInput
  ) {
    uuid
    status
    failureReason
    order {
      uuid
      name
    }
    duplicateOrder {
      uuid
      name
    }
  }
}
    `;
export const ScannedOrderResultsDocument = gql`
    query scannedOrderResults($first: Int, $after: String, $last: Int, $before: String, $approvedAtAfter: DateTime, $createdAtAfter: DateTime, $rejectedAtAfter: DateTime, $searchText: String, $type: ScannedOrderResultType!, $statuses: [ScannedOrderResultStatus!], $signedPodMatchStatuses: [SignedPodMatchStatus!], $sourceFilter: ScannedOrderResultSourceFilter, $failureReasonFilter: ScannedOrderFailureReason, $viewAllUploads: Boolean) {
  numberOfScannedOrderResultDuplicates(
    searchText: $searchText
    sourceFilter: $sourceFilter
    viewAllUploads: $viewAllUploads
  )
  numberOfScannedOrderResultsInProgress(
    searchText: $searchText
    sourceFilter: $sourceFilter
    viewAllUploads: $viewAllUploads
  )
  numberOfScannedOrderResultsInReview(
    searchText: $searchText
    sourceFilter: $sourceFilter
    viewAllUploads: $viewAllUploads
  )
  numberOfScannedOrderResultsFailed(
    searchText: $searchText
    sourceFilter: $sourceFilter
    viewAllUploads: $viewAllUploads
  )
  numberOfScannedOrderResultsRejected(
    searchText: $searchText
    sourceFilter: $sourceFilter
    viewAllUploads: $viewAllUploads
  )
  numberOfScannedOrderResultsApproved(
    searchText: $searchText
    sourceFilter: $sourceFilter
    viewAllUploads: $viewAllUploads
  )
  scannedOrderResults(
    first: $first
    after: $after
    last: $last
    before: $before
    approvedAtAfter: $approvedAtAfter
    createdAtAfter: $createdAtAfter
    rejectedAtAfter: $rejectedAtAfter
    searchText: $searchText
    type: $type
    statuses: $statuses
    signedPodMatchStatuses: $signedPodMatchStatuses
    sourceFilter: $sourceFilter
    failureReasonFilter: $failureReasonFilter
    viewAllUploads: $viewAllUploads
  ) {
    edges {
      node {
        ...ScannedOrderResultWithOrders
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ScannedOrderResultWithOrdersFragmentDoc}`;
export const UpdateScannedOrderResultStatusDocument = gql`
    mutation updateScannedOrderResultStatus($updateScannedOrderResultStatusInput: UpdateScannedOrderResultStatusInput!) {
  updateScannedOrderResultStatus(
    updateScannedOrderResultStatusInput: $updateScannedOrderResultStatusInput
  ) {
    uuid
  }
}
    `;
export const ArchiveSchedulingRegionDocument = gql`
    mutation ArchiveSchedulingRegion($id: String!) {
  archiveSchedulingRegion(id: $id) {
    __typename
    ... on UpdateSchedulingRegionSuccessOutput {
      schedulingRegion {
        ...AllSchedulingRegionFields
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${AllSchedulingRegionFieldsFragmentDoc}`;
export const ArchiveSchedulingResourceDocument = gql`
    mutation ArchiveSchedulingResource($id: String!) {
  archiveSchedulingResource(id: $id) {
    ...SchedulingResourceMutationResultFields
  }
}
    ${SchedulingResourceMutationResultFieldsFragmentDoc}`;
export const BlockCompanySchedulingDayDocument = gql`
    mutation BlockCompanySchedulingDay($input: BlockCompanySchedulingDayInput!) {
  blockCompanySchedulingDay(input: $input) {
    ...CompanySchedulingBlockedDayResultFields
  }
}
    ${CompanySchedulingBlockedDayResultFieldsFragmentDoc}`;
export const BlockSchedulingResourceDayDocument = gql`
    mutation BlockSchedulingResourceDay($input: BlockSchedulingResourceDayInput!) {
  blockSchedulingResourceDay(input: $input) {
    ...SchedulingResourceMutationResultFields
  }
}
    ${SchedulingResourceMutationResultFieldsFragmentDoc}`;
export const CompanySchedulingBlockedDaysDocument = gql`
    query CompanySchedulingBlockedDays($input: FindCompanySchedulingBlockedDaysInput) {
  companySchedulingBlockedDays(input: $input) {
    ...CompanySchedulingBlockedDayFields
  }
}
    ${CompanySchedulingBlockedDayFieldsFragmentDoc}`;
export const CreateSchedulingRegionDocument = gql`
    mutation CreateSchedulingRegion($input: CreateSchedulingRegionInput!) {
  createSchedulingRegion(input: $input) {
    __typename
    ... on CreateSchedulingRegionSuccessOutput {
      schedulingRegion {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const CreateSchedulingResourceDocument = gql`
    mutation CreateSchedulingResource($input: CreateSchedulingResourceInput!) {
  createSchedulingResource(input: $input) {
    ...SchedulingResourceMutationResultFields
  }
}
    ${SchedulingResourceMutationResultFieldsFragmentDoc}`;
export const CreateSchedulingZoneDocument = gql`
    mutation CreateSchedulingZone($input: CreateSchedulingZoneInput!) {
  createSchedulingZone(input: $input) {
    __typename
    ... on CreateSchedulingZoneSuccessOutput {
      schedulingZone {
        id
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ExemptSchedulingResourceFromCompanyBlockedDayDocument = gql`
    mutation ExemptSchedulingResourceFromCompanyBlockedDay($input: CompanySchedulingDayExemptionInput!) {
  exemptSchedulingResourceFromCompanyBlockedDay(input: $input) {
    ...CompanySchedulingBlockedDayResultFields
  }
}
    ${CompanySchedulingBlockedDayResultFieldsFragmentDoc}`;
export const RemoveSchedulingResourceCompanyBlockedDayExemptionDocument = gql`
    mutation RemoveSchedulingResourceCompanyBlockedDayExemption($input: CompanySchedulingDayExemptionInput!) {
  removeSchedulingResourceCompanyBlockedDayExemption(input: $input) {
    ...CompanySchedulingBlockedDayResultFields
  }
}
    ${CompanySchedulingBlockedDayResultFieldsFragmentDoc}`;
export const RestoreSchedulingRegionDocument = gql`
    mutation RestoreSchedulingRegion($id: String!) {
  restoreSchedulingRegion(id: $id) {
    __typename
    ... on UpdateSchedulingRegionSuccessOutput {
      schedulingRegion {
        ...AllSchedulingRegionFields
      }
    }
    ... on RestoreSchedulingRegionNameConflictOutput {
      message
      conflictingSchedulingRegionId
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${AllSchedulingRegionFieldsFragmentDoc}`;
export const RestoreSchedulingResourceDocument = gql`
    mutation RestoreSchedulingResource($id: String!) {
  restoreSchedulingResource(id: $id) {
    ...SchedulingResourceMutationResultFields
  }
}
    ${SchedulingResourceMutationResultFieldsFragmentDoc}`;
export const RestoreSchedulingZoneDocument = gql`
    mutation RestoreSchedulingZone($id: String!) {
  restoreSchedulingZone(id: $id) {
    __typename
    ... on UpdateSchedulingZoneSuccessOutput {
      schedulingZone {
        ...AllSchedulingZoneFields
      }
    }
    ... on RestoreSchedulingZoneNameConflictOutput {
      message
      conflictingSchedulingZoneId
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${AllSchedulingZoneFieldsFragmentDoc}`;
export const SchedulingRegionDocument = gql`
    query SchedulingRegion($id: String!) {
  schedulingRegion(id: $id) {
    ...AllSchedulingRegionFields
  }
}
    ${AllSchedulingRegionFieldsFragmentDoc}`;
export const SchedulingRegionsDocument = gql`
    query SchedulingRegions {
  schedulingRegions {
    schedulingRegions {
      id
      name
      isArchived
    }
  }
}
    `;
export const SchedulingResourceDocument = gql`
    query SchedulingResource($id: String!) {
  schedulingResource(id: $id) {
    ...AllSchedulingResourceFields
  }
}
    ${AllSchedulingResourceFieldsFragmentDoc}`;
export const SchedulingResourcesDocument = gql`
    query SchedulingResources($first: Int!, $after: String, $includeArchived: Boolean) {
  schedulingResources(
    input: {first: $first, after: $after, includeArchived: $includeArchived}
  ) {
    schedulingResourceConnection {
      edges {
        cursor
        node {
          ...SchedulingResourceListFields
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${SchedulingResourceListFieldsFragmentDoc}`;
export const SetSchedulingResourceEligibilityRulesDocument = gql`
    mutation SetSchedulingResourceEligibilityRules($input: SetSchedulingResourceEligibilityRulesInput!) {
  setSchedulingResourceEligibilityRules(input: $input) {
    ...SchedulingResourceMutationResultFields
  }
}
    ${SchedulingResourceMutationResultFieldsFragmentDoc}`;
export const UnblockCompanySchedulingDayDocument = gql`
    mutation UnblockCompanySchedulingDay($input: UnblockCompanySchedulingDayInput!) {
  unblockCompanySchedulingDay(input: $input) {
    ...CompanySchedulingBlockedDayResultFields
  }
}
    ${CompanySchedulingBlockedDayResultFieldsFragmentDoc}`;
export const UnblockSchedulingResourceDayDocument = gql`
    mutation UnblockSchedulingResourceDay($input: UnblockSchedulingResourceDayInput!) {
  unblockSchedulingResourceDay(input: $input) {
    ...SchedulingResourceMutationResultFields
  }
}
    ${SchedulingResourceMutationResultFieldsFragmentDoc}`;
export const UpdateSchedulingRegionDocument = gql`
    mutation UpdateSchedulingRegion($input: UpdateSchedulingRegionInput!) {
  updateSchedulingRegion(input: $input) {
    __typename
    ... on UpdateSchedulingRegionSuccessOutput {
      schedulingRegion {
        ...AllSchedulingRegionFields
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${AllSchedulingRegionFieldsFragmentDoc}`;
export const UpdateSchedulingResourceDocument = gql`
    mutation UpdateSchedulingResource($input: UpdateSchedulingResourceInput!) {
  updateSchedulingResource(input: $input) {
    ...SchedulingResourceMutationResultFields
  }
}
    ${SchedulingResourceMutationResultFieldsFragmentDoc}`;
export const UpdateSchedulingZoneDocument = gql`
    mutation UpdateSchedulingZone($input: UpdateSchedulingZoneInput!) {
  updateSchedulingZone(input: $input) {
    __typename
    ... on UpdateSchedulingZoneSuccessOutput {
      schedulingZone {
        ...AllSchedulingZoneFields
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    ${AllSchedulingZoneFieldsFragmentDoc}`;
export const CreateServiceRegionsDocument = gql`
    mutation CreateServiceRegions($input: CreateServiceRegionsInput!) {
  createServiceRegions(input: $input) {
    __typename
    ... on CreateServiceRegionsSuccessOutput {
      serviceRegions {
        id
        name
        isArchived
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ServiceRegionDocument = gql`
    query ServiceRegion($id: String!) {
  serviceRegion(id: $id) {
    id
    name
    isArchived
    terminals {
      uuid
      code
      name
      isActive
      serviceAreas {
        uuid
        zipcode
        city
      }
    }
  }
}
    `;
export const UpdateServiceRegionDocument = gql`
    mutation UpdateServiceRegion($input: UpdateServiceRegionInput!) {
  updateServiceRegion(input: $input) {
    __typename
    ... on UpdateServiceRegionSuccessOutput {
      serviceRegion {
        id
        name
        isArchived
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const BulkUpdateAccessorialMappingsDocument = gql`
    mutation bulkUpdateAccessorialMappings($bulkAccessorialUpdateInput: BulkAccessorialUpdateInput!) {
  bulkUpdateAccessorialMappings(
    bulkAccessorialUpdateInput: $bulkAccessorialUpdateInput
  ) {
    ...AccessorialsTableRow
  }
}
    ${AccessorialsTableRowFragmentDoc}`;
export const BulkUpdateContactQuickbooksIdsDocument = gql`
    mutation bulkUpdateContactQuickbooksIds($bulkUpdateContactQuickbooksId: UpdateContactQuickbooksIdsInput!) {
  bulkUpdateContactQuickbooksIds(
    bulkUpdateContactQuickbooksId: $bulkUpdateContactQuickbooksId
  ) {
    uuid
    displayName
    quickbooksDesktopContactId
    __typename
  }
}
    `;
export const SettingsCompanyConfigurationChangesDocument = gql`
    query SettingsCompanyConfigurationChanges($first: Int, $after: String, $key: String) {
  companyConfigurationChanges(first: $first, after: $after, key: $key) {
    edges {
      cursor
      node {
        __typename
        uuid
        key
        label
        oldValue
        newValue
        createdAt
        changedBy {
          __typename
          uuid
          name
          email
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;
export const SettingsCompanyConfigurationDocument = gql`
    query SettingsCompanyConfiguration {
  companyConfiguration {
    uuid
    sameDayDispatchCellHeader
    sendSummaryEmailWithIncompleteRoutes
    startingInvoiceOrdinalNumber
    defaultFuelSurchargeBillingMethod
    defaultDimFactor
    defaultFuelSurcharge
    defaultFuelSettlementPercentageRate
    defaultRouteStartTime
    defaultRouteLoadTimeInMinutes
    defaultRouteUnloadTimeInMinutes
    defaultGenerateAppointmentDurationInMinutes
    defaultGenerateAppointmentEarlyCushionInMinutes
    enableConsolidatedOrders
    showChargesOnCustomerPortal
    textNextCustomerForAppointments
    invoicePdfLogoUrl
    reviewUrl
    showManuallyConfirmedByDefault
    allowDriverToSelectNextStop
    showHelpersColumnInDispatch
    showVehicleInDailyDispatch
    requireReviewForEdiOrderCreation
    autoApplyWaitTimeMinutes
    useJournalNumberForInvoice
    getDriverLocationDataFromMobile
    mobilePollingIntervalInSeconds
    requireDriverToAcknowledgeRouteChange
    useDriverNumberForDispatch
    defaultToAccessorial
    enablePaymentMethod
    driversShouldMarkFreightAsLoaded
    allCapsInOrderPage
    orderNamingScheme
    companyOrdinalStart
    minDigitsInCompanyOrdinalOrderName
    restrictEditingOrderName
    showKilogramsAndCentimeters
    showDriverSettlementInBilling
    notificationsEnabled
    requireDimsToFinalizeCharges
    orderIdentifierForCoverSheet
    enableDigitalSignatureFlow
    requireDriverSignature
    useSeparateDigitalSignatureStep
    sendSignedPodEmailAfterLateSignature
    requireSignedPodToCompleteStop
    includeHyphensInInvoiceName
    includeINVInInvoiceName
    appointmentSchedulingSlotHours
    appointmentSchedulingLeadingBufferHours
    appointmentSchedulingCutoffDays
    appointmentChangeCutoffHours
    appointmentSelfRescheduleLimit
    requireOnHandBeforeSelfScheduling
    appointmentSchedulerModel
    createRecurringOrdersInAdvanceHours
    serviceLevelOptional
    addOrdersToOpenInvoices
    invoiceNotes
    defaultInvoiceDocumentsRequired
    autoMatchEodDocumentsToOrders
    requirePODPhotoAndName
    requirePODPhotoAndNameForPickups
    requirePODPhotoForPickups
    requireSigneeNameForPickups
    requirePODPhotoForDeliveries
    requireSigneeNameForDeliveries
    autoGroupStops
    requireDriverToConfirmStopCompletedAtTime
    packageWarehouseLocationsEnabled
    wmsEnabled
    wmsStorageOrdersEnabled
    wmsShortTermStorageEnabled
    wmsAutoMarkOnHand
    useHawbForLotLabelBarcode
    quoteContributionMarginalFromRatio
    quoteContributionProfitableFromRatio
    quoteAgentEnabled
    quoteAgentDefaultMode
    quoteAgentAutoSendMaxCents
    quoteAgentMinConfidence
    quoteAgentValidityHours
    quoteAgentDailyModelBudgetCents
    draftOrderCleanupDays
    draftOrderCleanupSources
    defaultPalletLength
    defaultPalletWidth
    defaultPalletHeight
    terminalsEnabled
    lineHaulBuildAheadDays
    lineHaulEnabled
    lineHaulMobilePastWindowHours
    lineHaulMobileFutureWindowHours
    lineHaulPlanningEnabled
    driverComplianceExpiringSoonDays
    logisticsSectionEnabled
    fulfillmentTypeEnabled
    pointToPointTariffsEnabled
    recoveryTariffsEnabled
    showCompanyNameOnBillOfLadingDoc
    defaultStandardStopType
    orderLevelOsdEnabled
    markOnHandUponPickup
    showAccessorialsToDrivers
    pieceTransferableStatuses
    t2tDelegationEnabled
    t2tSyncEnabled
  }
}
    `;
export const CompanyDefaultEdiSettingsDocument = gql`
    query companyDefaultEdiSettings {
  company {
    uuid
    defaultInboundEdiService {
      uuid
      name
    }
    defaultOutboundEdiService {
      uuid
      name
    }
    defaultInboundOutboundEdiService {
      uuid
      name
    }
  }
}
    `;
export const SettingsCompanyFieldsDocument = gql`
    query SettingsCompanyFields {
  me {
    uuid
    company {
      uuid
      timeZone
      defaultWeightUnits
      defaultMeasurementUnits
      defaultNonCompanyDriverSettlementMode
      invoiceEmail
      defaultInvoiceEmailSubject
      blockSendingZeroDollarInvoices
      customDunningReportHeader
      customDunningReportFooter
      useSageBusinessWorks
      qbInvoiceNumberStart
      phone
    }
  }
}
    `;
export const AccessorialToQuickbooksMappingByContactDocument = gql`
    query accessorialToQuickbooksMappingByContact($contactUuid: String!) {
  accessorialToQuickbooksMappingByContact(contactUuid: $contactUuid) {
    uuid
    quickbooksId
    accessorial {
      uuid
      name
      qboItemId
      ... on StandardAccessorialEntity {
        unsyncedInvoiceCount
      }
      ... on PercentageAccessorialEntity {
        unsyncedInvoiceCount
      }
      ... on UnitBasedAccessorialEntity {
        unsyncedInvoiceCount
      }
      ... on SkidBasedAccessorialEntity {
        unsyncedInvoiceCount
      }
      ... on WaitTimeAccessorialEntity {
        unsyncedInvoiceCount
      }
      ... on WeightBasedAccessorialEntity {
        unsyncedInvoiceCount
      }
      ... on ZoneBasedAccessorialEntity {
        unsyncedInvoiceCount
      }
      ... on SpecialAccessorialEntity {
        unsyncedInvoiceCount
      }
      ... on AttemptsAccessorialEntity {
        unsyncedInvoiceCount
      }
      ... on StorageDaysAccessorialEntity {
        unsyncedInvoiceCount
      }
    }
  }
}
    `;
export const CreateAccessorialToQuickbooksMappingDocument = gql`
    mutation createAccessorialToQuickbooksMapping($accessorialToQuickbooksMappingCreateInput: AccessorialToQuickbooksMappingCreateInput!) {
  createAccessorialToQuickbooksMapping(
    accessorialToQuickbooksMappingCreateInput: $accessorialToQuickbooksMappingCreateInput
  ) {
    uuid
  }
}
    `;
export const CreateManyReferenceNumberLabelsDocument = gql`
    mutation CreateManyReferenceNumberLabels($referenceNumberLabels: [String!]!) {
  createManyReferenceNumberLabels(referenceNumberLabels: $referenceNumberLabels) {
    name
  }
}
    `;
export const CreateQuickbooksHeaderFileMappingDocument = gql`
    mutation createQuickbooksHeaderFileMapping($createQuickbooksHeaderFileMappingInput: CreateQuickbooksHeaderFileMappingInput!) {
  createQuickbooksHeaderFileMapping(
    createQuickbooksHeaderFileMappingInput: $createQuickbooksHeaderFileMappingInput
  ) {
    uuid
  }
}
    `;
export const DeleteQuickbooksHeaderFileMappingDocument = gql`
    mutation deleteQuickbooksHeaderFileMapping($uuid: String!) {
  deleteQuickbooksHeaderFileMapping(uuid: $uuid) {
    uuid
  }
}
    `;
export const DeleteTagDocument = gql`
    mutation deleteTag($uuid: String!) {
  deleteTag(uuid: $uuid) {
    uuid
  }
}
    `;
export const DisconnectQuickbooksDocument = gql`
    mutation DisconnectQuickbooks {
  disconnectQuickbooks
}
    `;
export const DownloadFinancialSnapshotsCsvDocument = gql`
    query DownloadFinancialSnapshotsCsv {
  downloadFinancialSnapshotsCsv
}
    `;
export const QuickbooksOAuthUrlDocument = gql`
    query quickbooksOAuthUrl {
  quickbooksOAuthUrl
}
    `;
export const GetQuickbooksConnectionStatusDocument = gql`
    query getQuickbooksConnectionStatus {
  getQuickbooksConnectionStatus {
    authStatus
    lastAuthError
  }
}
    `;
export const MyInAppNotificationPreferencesDocument = gql`
    query MyInAppNotificationPreferences {
  myInAppNotificationPreferences {
    eventType
    enabled
    mandatory
  }
}
    `;
export const QueryQuickbooksDesktopItemsDocument = gql`
    query queryQuickbooksDesktopItems {
  queryQuickbooksDesktopItems {
    quickbooksDesktopObjects {
      id
      name
    }
    error
  }
}
    `;
export const QuickbooksCustomersDocument = gql`
    query quickbooksCustomers {
  quickbooksCustomers {
    id
    name
    active
  }
}
    `;
export const QuickbooksClassesDocument = gql`
    query quickbooksClasses {
  quickbooksClasses {
    id
    name
    active
  }
}
    `;
export const QuickbooksHeaderFileMappingsDocument = gql`
    query quickbooksHeaderFileMappings {
  quickbooksHeaderFileMappings {
    uuid
    name
    cellNumber
    headerType
  }
}
    `;
export const QuickbooksIncomeAccountsDocument = gql`
    query quickbooksIncomeAccounts {
  quickbooksIncomeAccounts {
    id
    name
    accountType
  }
}
    `;
export const QuickbooksItemsDocument = gql`
    query quickbooksItems {
  quickbooksItems {
    id
    name
    active
  }
}
    `;
export const QuickbooksTaxCodesDocument = gql`
    query quickbooksTaxCodes {
  quickbooksTaxCodes {
    id
    name
    active
  }
}
    `;
export const ReferenceNumberFormatConfigsDocument = gql`
    query referenceNumberFormatConfigs($contactUuid: String!) {
  referenceNumberFormatConfigs(contactUuid: $contactUuid) {
    uuid
    checks {
      ...ReferenceNumberFormatCheck
    }
  }
}
    ${ReferenceNumberFormatCheckFragmentDoc}`;
export const SyncFinancialSnapshotsDocument = gql`
    mutation SyncFinancialSnapshots {
  syncFinancialSnapshots
}
    `;
export const UpdateAccessorialToQuickbooksMappingDocument = gql`
    mutation updateAccessorialToQuickbooksMapping($accessorialToQuickbooksMappingUpdateInput: AccessorialToQuickbooksMappingUpdateInput!) {
  updateAccessorialToQuickbooksMapping(
    accessorialToQuickbooksMappingUpdateInput: $accessorialToQuickbooksMappingUpdateInput
  ) {
    uuid
  }
}
    `;
export const SettingsUpdateCompanyConfigurationDocument = gql`
    mutation SettingsUpdateCompanyConfiguration($input: UpdateCompanyConfigurationInput!) {
  updateCompanyConfiguration(updateCompanyConfigurationInput: $input) {
    uuid
    sameDayDispatchCellHeader
    sendSummaryEmailWithIncompleteRoutes
    startingInvoiceOrdinalNumber
    defaultFuelSurchargeBillingMethod
    defaultDimFactor
    defaultFuelSurcharge
    defaultFuelSettlementPercentageRate
    defaultRouteStartTime
    defaultRouteLoadTimeInMinutes
    defaultRouteUnloadTimeInMinutes
    defaultGenerateAppointmentDurationInMinutes
    defaultGenerateAppointmentEarlyCushionInMinutes
    enableConsolidatedOrders
    showChargesOnCustomerPortal
    textNextCustomerForAppointments
    invoicePdfLogoUrl
    reviewUrl
    showManuallyConfirmedByDefault
    allowDriverToSelectNextStop
    showHelpersColumnInDispatch
    showVehicleInDailyDispatch
    requireReviewForEdiOrderCreation
    autoApplyWaitTimeMinutes
    useJournalNumberForInvoice
    getDriverLocationDataFromMobile
    mobilePollingIntervalInSeconds
    requireDriverToAcknowledgeRouteChange
    useDriverNumberForDispatch
    defaultToAccessorial
    enablePaymentMethod
    driversShouldMarkFreightAsLoaded
    allCapsInOrderPage
    orderNamingScheme
    companyOrdinalStart
    minDigitsInCompanyOrdinalOrderName
    restrictEditingOrderName
    showKilogramsAndCentimeters
    showDriverSettlementInBilling
    notificationsEnabled
    requireDimsToFinalizeCharges
    orderIdentifierForCoverSheet
    enableDigitalSignatureFlow
    requireDriverSignature
    useSeparateDigitalSignatureStep
    sendSignedPodEmailAfterLateSignature
    requireSignedPodToCompleteStop
    includeHyphensInInvoiceName
    includeINVInInvoiceName
    appointmentSchedulingSlotHours
    appointmentSchedulingLeadingBufferHours
    appointmentSchedulingCutoffDays
    appointmentChangeCutoffHours
    appointmentSelfRescheduleLimit
    requireOnHandBeforeSelfScheduling
    appointmentSchedulerModel
    createRecurringOrdersInAdvanceHours
    serviceLevelOptional
    addOrdersToOpenInvoices
    invoiceNotes
    defaultInvoiceDocumentsRequired
    autoMatchEodDocumentsToOrders
    requirePODPhotoAndName
    requirePODPhotoAndNameForPickups
    requirePODPhotoForPickups
    requireSigneeNameForPickups
    requirePODPhotoForDeliveries
    requireSigneeNameForDeliveries
    autoGroupStops
    requireDriverToConfirmStopCompletedAtTime
    packageWarehouseLocationsEnabled
    wmsEnabled
    wmsStorageOrdersEnabled
    wmsShortTermStorageEnabled
    wmsAutoMarkOnHand
    useHawbForLotLabelBarcode
    quoteContributionMarginalFromRatio
    quoteContributionProfitableFromRatio
    quoteAgentEnabled
    quoteAgentDefaultMode
    quoteAgentAutoSendMaxCents
    quoteAgentMinConfidence
    quoteAgentValidityHours
    quoteAgentDailyModelBudgetCents
    draftOrderCleanupDays
    draftOrderCleanupSources
    defaultPalletLength
    defaultPalletWidth
    defaultPalletHeight
    terminalsEnabled
    lineHaulBuildAheadDays
    lineHaulEnabled
    lineHaulMobilePastWindowHours
    lineHaulMobileFutureWindowHours
    lineHaulPlanningEnabled
    driverComplianceExpiringSoonDays
    logisticsSectionEnabled
    fulfillmentTypeEnabled
    pointToPointTariffsEnabled
    recoveryTariffsEnabled
    showCompanyNameOnBillOfLadingDoc
    defaultStandardStopType
    orderLevelOsdEnabled
    markOnHandUponPickup
    showAccessorialsToDrivers
    pieceTransferableStatuses
    t2tDelegationEnabled
    t2tSyncEnabled
  }
}
    `;
export const SettingsUpdateCompanyFieldsDocument = gql`
    mutation SettingsUpdateCompanyFields($input: UpdateCompanyInput!) {
  updateCompany(updateCompanyInput: $input) {
    uuid
    timeZone
    defaultWeightUnits
    defaultMeasurementUnits
    defaultNonCompanyDriverSettlementMode
    invoiceEmail
    defaultInvoiceEmailSubject
    blockSendingZeroDollarInvoices
    customDunningReportHeader
    customDunningReportFooter
    useSageBusinessWorks
    qbInvoiceNumberStart
    phone
  }
}
    `;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($updateCompanyInput: UpdateCompanyInput!) {
  updateCompany(updateCompanyInput: $updateCompanyInput) {
    uuid
    qboFreightItemId
    freightChargeQuickbooksMappingId
    qboFuelItemId
    fuelChargeQuickbooksMappingId
    qboLineHaulItemId
    miscCustomChargeQuickbooksMappingId
    qboDefaultIncomeAccountId
    qboDefaultTaxCodeId
    qboDefaultClassId
    quickbooksFileMappingFreightChargeName
    quickbooksFileMappingFuelChargeName
    quickbooksFileMappingAccessorialChargeName
    quickbooksFileMappingPickupChargeName
  }
}
    `;
export const UpdateInAppNotificationPreferencesDocument = gql`
    mutation UpdateInAppNotificationPreferences($input: UpdateInAppNotificationPreferencesInput!) {
  updateInAppNotificationPreferences(input: $input) {
    eventType
    enabled
    mandatory
  }
}
    `;
export const UpdateOrderFormFieldsDocument = gql`
    mutation updateOrderFormFields($updateOrderFormFieldsInput: UpdateOrderFormFieldsInput!) {
  updateOrderFormFields(updateOrderFormFieldsInput: $updateOrderFormFieldsInput) {
    onePackageRequired
    onePackageWeightRequired
  }
}
    `;
export const UpdateQuickbooksHeaderFileMappingDocument = gql`
    mutation updateQuickbooksHeaderFileMapping($updateQuickbooksHeaderFileMappingInput: UpdateQuickbooksHeaderFileMappingInput!) {
  updateQuickbooksHeaderFileMapping(
    updateQuickbooksHeaderFileMappingInput: $updateQuickbooksHeaderFileMappingInput
  ) {
    uuid
  }
}
    `;
export const UpdateTagDocument = gql`
    mutation updateTag($updateTagInput: UpdateTagInput!) {
  updateTag(updateTagInput: $updateTagInput) {
    uuid
  }
}
    `;
export const CreateQuoteAgentForwardingAddressDocument = gql`
    mutation CreateQuoteAgentForwardingAddress {
  createQuoteAgentForwardingAddress {
    __typename
    ... on CreateQuoteAgentForwardingAddressSuccessOutput {
      connection {
        uuid
        kind
        address
        status
        createdAt
      }
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const ExpireQuoteAgentPreviousForwardingTokenDocument = gql`
    mutation ExpireQuoteAgentPreviousForwardingToken {
  expireQuoteAgentPreviousForwardingToken {
    __typename
    ... on ExpireQuoteAgentPreviousForwardingTokenSuccessOutput {
      forwardingAddress
      previousExpired
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const QuoteAgentConnectionsDocument = gql`
    query QuoteAgentConnections {
  quoteAgentConnections {
    available
    connections {
      uuid
      kind
      address
      status
      createdAt
    }
  }
}
    `;
export const QuoteAgentInboundRejectionsDocument = gql`
    query QuoteAgentInboundRejections {
  quoteAgentInboundRejections {
    available
    rejections {
      receiptUuid
      rejectedAt
      reason
      fromAddress
      fromName
      subject
    }
  }
}
    `;
export const RotateQuoteAgentForwardingTokenDocument = gql`
    mutation RotateQuoteAgentForwardingToken($connectionUuid: String!) {
  rotateQuoteAgentForwardingToken(connectionUuid: $connectionUuid) {
    __typename
    ... on RotateQuoteAgentForwardingTokenSuccessOutput {
      connectionUuid
      forwardingAddress
      previousValidUntil
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const SaveSmc3SettingsDocument = gql`
    mutation SaveSmc3Settings($input: SaveSmc3SettingsInput!) {
  saveSmc3Settings(input: $input) {
    settings {
      ...Smc3Settings
    }
    failure {
      ...Smc3ConnectionFailure
    }
  }
}
    ${Smc3SettingsFragmentDoc}
${Smc3ConnectionFailureFragmentDoc}`;
export const Smc3AvailableTariffsDocument = gql`
    query Smc3AvailableTariffs {
  smc3AvailableTariffs {
    tariffs {
      tariffName
      effectiveDates
    }
    failure {
      ...Smc3ConnectionFailure
    }
  }
}
    ${Smc3ConnectionFailureFragmentDoc}`;
export const Smc3SettingsDocument = gql`
    query Smc3Settings {
  smc3Settings {
    ...Smc3Settings
  }
}
    ${Smc3SettingsFragmentDoc}`;
export const TestSmc3ConnectionDocument = gql`
    mutation TestSmc3Connection {
  testSmc3Connection {
    connected
    failure {
      ...Smc3ConnectionFailure
    }
  }
}
    ${Smc3ConnectionFailureFragmentDoc}`;
export const TestSmc3RateDocument = gql`
    mutation TestSmc3Rate($input: TestSmc3RateInput!) {
  testSmc3Rate(input: $input) {
    finalCents
    tariffName
    tariffEffectiveDate
    failure {
      ...Smc3ConnectionFailure
    }
  }
}
    ${Smc3ConnectionFailureFragmentDoc}`;
export const AddLineItemsToSettlementBillsDocument = gql`
    mutation addLineItemsToSettlementBills($addLineItemsToSettlementBillsInput: AddLineItemsToSettlementBillsInput!) {
  addLineItemsToSettlementBills(
    addLineItemsToSettlementBillsInput: $addLineItemsToSettlementBillsInput
  ) {
    ... on AddLineItemsToSettlementBillsSuccessOutput {
      __typename
      driverSettlementBills {
        uuid
        name
        driver {
          uuid
          firstName
          lastName
        }
        billStartDate
        billEndDate
        settlementDate
      }
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    `;
export const CreateSettlementAdjustmentDocument = gql`
    mutation CreateSettlementAdjustment($settlementAdjustmentCreateInput: SettlementAdjustmentCreateInput!) {
  createSettlementAdjustment(
    settlementAdjustmentCreateInput: $settlementAdjustmentCreateInput
  ) {
    ... on CreateOrUpdateSettlementAdjustmentSuccessOutput {
      __typename
      settlementAdjustment {
        ...SettlementAdjustment
      }
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    ${SettlementAdjustmentFragmentDoc}`;
export const DriverSettlementBillByUuidV2Document = gql`
    query driverSettlementBillByUuidV2($uuid: String!) {
  driverSettlementBill(uuid: $uuid) {
    ...DriverSettlementBillV2
  }
}
    ${DriverSettlementBillV2FragmentDoc}`;
export const DriverSettlementBillExportPdfDocument = gql`
    mutation driverSettlementBillExportPdf($driverSettlementBillExportPdfInput: DriverSettlementBillExportPdfInput!) {
  driverSettlementBillExportPdf(
    driverSettlementBillExportPdfInput: $driverSettlementBillExportPdfInput
  ) {
    __typename
    url
    fileName
    errors
  }
}
    `;
export const DriverSettlementBillExportZipDocument = gql`
    mutation driverSettlementBillExportZip($input: DriverSettlementBillExportPdfInput!) {
  driverSettlementBillExportZip(input: $input) {
    __typename
    url
    fileName
    errors
  }
}
    `;
export const FinalizeSettlementBillsDocument = gql`
    mutation finalizeSettlementBills($finalizeSettlementBillsInput: FinalizeSettlementBillsInput!) {
  finalizeSettlementBills(
    finalizeSettlementBillsInput: $finalizeSettlementBillsInput
  ) {
    ... on FinalizeSettlementBillsSuccessOutput {
      __typename
      results {
        bill {
          uuid
          name
        }
        error
      }
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    `;
export const SettlementBillLineItemWithCostsDocument = gql`
    query SettlementBillLineItemWithCosts($id: String!) {
  settlementBillLineItem(id: $id) {
    ...SettlementBillLineItemWithCosts
  }
}
    ${SettlementBillLineItemWithCostsFragmentDoc}`;
export const RemoveLineItemsFromSettlementBillDocument = gql`
    mutation removeLineItemsFromSettlementBill($removeLineItemsFromSettlementBillInput: RemoveLineItemsFromSettlementBillInput!) {
  removeLineItemsFromSettlementBill(
    removeLineItemsFromSettlementBillInput: $removeLineItemsFromSettlementBillInput
  ) {
    ... on RemoveLineItemsFromSettlementBillSuccessOutput {
      __typename
      settlementBillLineItemsCount
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    `;
export const RemoveSettlementAdjustmentDocument = gql`
    mutation RemoveSettlementAdjustment($uuid: String!) {
  removeSettlementAdjustment(uuid: $uuid) {
    uuid
  }
}
    `;
export const GetSettlementBillLineItemsDocument = gql`
    query getSettlementBillLineItems($input: FindSettlementBillLineItemsInput!) {
  settlementBillLineItems(findSettlementBillLineItemInput: $input) {
    edges {
      node {
        ...SettlementBillLineItem
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${SettlementBillLineItemFragmentDoc}`;
export const UpdateSettlementAdjustmentDocument = gql`
    mutation UpdateSettlementAdjustment($settlementAdjustmentUpdateInput: SettlementAdjustmentUpdateInput!) {
  updateSettlementAdjustment(
    settlementAdjustmentUpdateInput: $settlementAdjustmentUpdateInput
  ) {
    ... on CreateOrUpdateSettlementAdjustmentSuccessOutput {
      __typename
      settlementAdjustment {
        ...SettlementAdjustment
      }
    }
    ... on MutationErrorOutput {
      __typename
      message
    }
  }
}
    ${SettlementAdjustmentFragmentDoc}`;
export const OutstandingShipmentsUuidsDocument = gql`
    query outstandingShipmentsUuids($first: Int, $after: String, $last: Int, $before: String, $isFinalized: Boolean, $hasIssues: Boolean, $hideFromBilling: Boolean, $isUnfinalized: Boolean, $isCancelled: Boolean, $contactUuid: String, $billingPartyContactUuids: [String!], $billingPartyContactDisplayName: StringFilter, $serviceUuid: String, $terminalUuid: String, $originTerminalUuid: String, $destinationTerminalUuid: String, $noMaximum: Boolean, $searchText: String, $stopCompletionEndDate: DateTime, $stopCompletionStartDate: DateTime, $uuids: [String!], $orderUuids: [String!]!) {
  outstandingShipments(
    first: $first
    after: $after
    before: $before
    last: $last
    isFinalized: $isFinalized
    hasIssues: $hasIssues
    hideFromBilling: $hideFromBilling
    isUnfinalized: $isUnfinalized
    isCancelled: $isCancelled
    contactUuid: $contactUuid
    billingPartyContactUuids: $billingPartyContactUuids
    billingPartyContactDisplayName: $billingPartyContactDisplayName
    serviceUuid: $serviceUuid
    terminalUuid: $terminalUuid
    originTerminalUuid: $originTerminalUuid
    destinationTerminalUuid: $destinationTerminalUuid
    noMaximum: $noMaximum
    searchText: $searchText
    stopCompletionEndDate: $stopCompletionEndDate
    stopCompletionStartDate: $stopCompletionStartDate
    uuids: $uuids
    orderUuids: $orderUuids
  ) {
    edges {
      node {
        uuid
        order {
          uuid
          billingPartyContact {
            invoiceTimePeriodSplit
            numberOfOrdersPerInvoice
            uuid
          }
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const CompletedStopNotOnRouteDocument = gql`
    query completedStopNotOnRoute($uuid: String!) {
  stop(uuid: $uuid) {
    ...CompletedStopNotOnRoute
  }
}
    ${CompletedStopNotOnRouteFragmentDoc}`;
export const CompletedStopsNotOnRoutesDocument = gql`
    query completedStopsNotOnRoutes($date: DateTime!) {
  completedStopsNotOnRoutes(date: $date) {
    ...CompletedStopNotOnRoute
  }
}
    ${CompletedStopNotOnRouteFragmentDoc}`;
export const DeleteStopAttemptDocument = gql`
    mutation deleteStopAttempt($deleteStopAttemptInput: DeleteStopAttemptInput!) {
  deleteStopAttempt(deleteStopAttemptInput: $deleteStopAttemptInput) {
    ... on DeleteStopAttemptSuccessOutput {
      success
    }
    ... on MutationErrorOutput {
      message
    }
  }
}
    `;
export const MarkAttemptedStopAsCompleteDocument = gql`
    mutation markAttemptedStopAsComplete($stopUuid: String!) {
  markAttemptedStopAsComplete(stopUuid: $stopUuid) {
    uuid
  }
}
    `;
export const MarkStopAsIncompleteDocument = gql`
    mutation markStopAsIncomplete($uuid: String!) {
  markStopAsIncomplete(uuid: $uuid) {
    uuid
  }
}
    `;
export const StopForCompletionCheckDocument = gql`
    query stopForCompletionCheck($uuid: String!) {
  stop(uuid: $uuid) {
    uuid
    leg {
      endStop {
        stopType
      }
      shipment {
        standardShipmentFields {
          pickupOrDelivery
        }
      }
    }
    terminal {
      uuid
    }
    address {
      line1
    }
  }
}
    `;
export const AssignOutboundReferenceNumbersToStorageUnitsDocument = gql`
    mutation assignOutboundReferenceNumbersToStorageUnits($assignOutboundReferenceNumbersToStorageUnitsInput: AssignOutboundReferenceNumberToStorageUnitsInput!) {
  assignOutboundReferenceNumbersToStorageUnits(
    assignOutboundReferenceNumbersToStorageUnitsInput: $assignOutboundReferenceNumbersToStorageUnitsInput
  ) {
    success
  }
}
    `;
export const CreateStorageOrderDocumentDocument = gql`
    mutation createStorageOrderDocument($createStorageOrderDocumentInput: CreateStorageOrderDocumentInput!) {
  createStorageOrderDocument(
    createStorageOrderDocumentInput: $createStorageOrderDocumentInput
  ) {
    document {
      ...CreateStorageOrderDocument
    }
  }
}
    ${CreateStorageOrderDocumentFragmentDoc}`;
export const CreateStorageOrderDocument = gql`
    mutation createStorageOrder($createStorageOrderInput: CreateStorageOrderInput!) {
  createStorageOrder(createStorageOrderInput: $createStorageOrderInput) {
    storageOrder {
      ...CreateStorageOrder
    }
  }
}
    ${CreateStorageOrderFragmentDoc}`;
export const CreateStorageUnitDocument = gql`
    mutation createStorageUnit($createStorageUnitInput: CreateStorageUnitInput!) {
  createStorageUnit(createStorageUnitInput: $createStorageUnitInput) {
    storageUnit {
      ...StorageOrderStorageUnit
    }
  }
}
    ${StorageOrderStorageUnitFragmentDoc}`;
export const DeleteStorageOrderDocument = gql`
    mutation deleteStorageOrder($deleteStorageOrderInput: DeleteStorageOrderInput!) {
  deleteStorageOrder(deleteStorageOrderInput: $deleteStorageOrderInput) {
    success
  }
}
    `;
export const DeleteStorageUnitDocument = gql`
    mutation deleteStorageUnit($deleteStorageUnitInput: DeleteStorageUnitInput!) {
  deleteStorageUnit(deleteStorageUnitInput: $deleteStorageUnitInput) {
    success
  }
}
    `;
export const StorageOrderStorageUnitsDocument = gql`
    query storageOrderStorageUnits($findStorageOrderStorageUnitsInput: FindStorageOrderStorageUnitsInput!) {
  storageOrderStorageUnits(
    findStorageOrderStorageUnitsInput: $findStorageOrderStorageUnitsInput
  ) {
    storageUnits {
      ...FindStorageOrderStorageUnits
    }
  }
}
    ${FindStorageOrderStorageUnitsFragmentDoc}`;
export const StorageOrderDocument = gql`
    query storageOrder($findStorageOrderInput: FindStorageOrderInput!, $storageUnitsInput: StorageUnitsInput) {
  storageOrder(findStorageOrderInput: $findStorageOrderInput) {
    storageOrder {
      ...FindStorageOrder
      storageUnits(storageUnitsInput: $storageUnitsInput) {
        ...StorageOrderStorageUnit
      }
    }
  }
}
    ${FindStorageOrderFragmentDoc}
${StorageOrderStorageUnitFragmentDoc}`;
export const StorageOrdersDocument = gql`
    query storageOrders($findStorageOrdersInput: FindStorageOrdersInput!) {
  storageOrders(findStorageOrdersInput: $findStorageOrdersInput) {
    storageOrderConnection {
      totalCount
      edges {
        node {
          ...StorageOrder
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${StorageOrderFragmentDoc}`;
export const StorageUnitsForPicklistDocument = gql`
    query storageUnitsForPicklist($findStorageUnitsInput: FindStorageUnitsInput!) {
  storageUnits(findStorageUnitsInput: $findStorageUnitsInput) {
    storageUnitConnection {
      totalCount
      edges {
        node {
          ...FindStorageUnitsForPicklist
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${FindStorageUnitsForPicklistFragmentDoc}`;
export const StorageUnitsDocument = gql`
    query storageUnits($findStorageUnitsInput: FindStorageUnitsInput!) {
  storageUnits(findStorageUnitsInput: $findStorageUnitsInput) {
    storageUnitConnection {
      totalCount
      edges {
        node {
          ...FindStorageUnits
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${FindStorageUnitsFragmentDoc}`;
export const GenerateStorageOrderPreSignedPutUrlDocument = gql`
    mutation generateStorageOrderPreSignedPutUrl($generateStorageOrderPreSignedPutUrlInput: GenerateStorageOrderPreSignedPutUrlInput!) {
  generateStorageOrderPreSignedPutUrl(
    generateStorageOrderPreSignedPutUrlInput: $generateStorageOrderPreSignedPutUrlInput
  ) {
    preSignedPutUrl
  }
}
    `;
export const ImportStorageOrdersFromCsvDocument = gql`
    mutation importStorageOrdersFromCSV($importStorageOrdersFromCsvInput: ImportStorageOrdersFromCsvInput!) {
  importStorageOrdersFromCSV(
    importStorageOrdersFromCsvInput: $importStorageOrdersFromCsvInput
  ) {
    storageOrders {
      uuid
    }
    errors
  }
}
    `;
export const UpsertItemGroupDocument = gql`
    mutation upsertItemGroup($upsertItemGroupInput: UpsertItemGroupInput!) {
  upsertItemGroup(upsertItemGroupInput: $upsertItemGroupInput) {
    uuid
    storageUnit {
      uuid
    }
  }
}
    `;
export const ItemGroupsDocument = gql`
    query itemGroups($findItemGroupsInput: FindItemGroupsInput!) {
  itemGroups(findItemGroupsInput: $findItemGroupsInput) {
    edges {
      node {
        ...FindItemGroups
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${FindItemGroupsFragmentDoc}`;
export const MarkStorageUnitAsBilledDocument = gql`
    mutation markStorageUnitAsBilled($markStorageUnitAsBilledInput: MarkStorageUnitAsBilledInput!) {
  markStorageUnitAsBilled(
    markStorageUnitAsBilledInput: $markStorageUnitAsBilledInput
  ) {
    success
  }
}
    `;
export const MarkStorageUnitAsOsdDocument = gql`
    mutation markStorageUnitAsOsd($markStorageUnitAsOsdInput: MarkStorageUnitAsOsdInput!) {
  markStorageUnitAsOsd(markStorageUnitAsOsdInput: $markStorageUnitAsOsdInput) {
    success
  }
}
    `;
export const RemoveStorageUnitOsdDocument = gql`
    mutation removeStorageUnitOsd($removeStorageUnitOsdInput: RemoveStorageUnitOsdInput!) {
  removeStorageUnitOsd(removeStorageUnitOsdInput: $removeStorageUnitOsdInput) {
    success
  }
}
    `;
export const SetStorageOrderItemQuantityDocument = gql`
    mutation setStorageOrderItemQuantity($setStorageOrderItemQuantityInput: SetStorageOrderItemQuantityInput!) {
  setStorageOrderItemQuantity(
    setStorageOrderItemQuantityInput: $setStorageOrderItemQuantityInput
  ) {
    uuid
  }
}
    `;
export const UnassignInventoryItemsDocument = gql`
    mutation unassignInventoryItems($unassignInventoryItemsInput: UnassignInventoryItemsInput!) {
  unassignInventoryItems(
    unassignInventoryItemsInput: $unassignInventoryItemsInput
  ) {
    success
  }
}
    `;
export const UpdateStorageOrderDocument = gql`
    mutation updateStorageOrder($updateStorageOrderInput: UpdateStorageOrderInput!) {
  updateStorageOrder(updateStorageOrderInput: $updateStorageOrderInput) {
    storageOrder {
      ...UpdateStorageOrder
    }
  }
}
    ${UpdateStorageOrderFragmentDoc}`;
export const UpdateStorageUnitDocument = gql`
    mutation updateStorageUnit($updateStorageUnitInput: UpdateStorageUnitInput!) {
  updateStorageUnit(updateStorageUnitInput: $updateStorageUnitInput) {
    storageUnit {
      ...UpdateStorageUnit
    }
  }
}
    ${UpdateStorageUnitFragmentDoc}`;
export const UpsertPicklistDocument = gql`
    mutation upsertPicklist($upsertPicklistInput: UpsertPicklistInput!) {
  upsertPicklist(upsertPicklistInput: $upsertPicklistInput) {
    picklist {
      ...Picklists
    }
    error
  }
}
    ${PicklistsFragmentDoc}`;
export const TagsDocument = gql`
    query tags {
  getTags {
    ...Tag
  }
}
    ${TagFragmentDoc}`;
export const CreateTariffLocationDocument = gql`
    mutation createTariffLocation($createTariffLocationInput: CreateTariffLocationInput!) {
  createTariffLocation(createTariffLocationInput: $createTariffLocationInput) {
    tariffLocation {
      uuid
    }
  }
}
    `;
export const CreateTariffZoneDocument = gql`
    mutation createTariffZone($tariffZoneCreateInput: TariffZoneCreateInput!, $contactUuid: String) {
  createTariffZone(
    tariffZoneCreateInput: $tariffZoneCreateInput
    contactUuid: $contactUuid
  ) {
    uuid
    name
    type
  }
}
    `;
export const DeleteTariffLocationDocument = gql`
    mutation deleteTariffLocation($deleteTariffLocationInput: DeleteTariffLocationInput!) {
  deleteTariffLocation(deleteTariffLocationInput: $deleteTariffLocationInput) {
    tariffLocation {
      uuid
    }
  }
}
    `;
export const DeleteTariffZoneDocument = gql`
    mutation deleteTariffZone($uuid: String!) {
  deleteTariffZone(uuid: $uuid) {
    uuid
  }
}
    `;
export const FindTariffZoneByUuidDocument = gql`
    query findTariffZoneByUuid($uuid: String!) {
  findTariffZoneByUuidOrThrow(uuid: $uuid) {
    uuid
    name
    type
    locations {
      ...TariffLocation
    }
    terminal {
      uuid
      name
    }
    destinationTerminal {
      uuid
      name
    }
  }
}
    ${TariffLocationFragmentDoc}`;
export const TariffZonesDocument = gql`
    query tariffZones($tariffZoneType: TariffZoneType, $contactUuid: String, $tariffZoneLocationType: TariffZoneLocationType, $defaultToGlobal: Boolean, $excludeLineHaulTariffZones: Boolean, $excludeMileBasedTariffZones: Boolean) {
  tariffZones(
    tariffZoneType: $tariffZoneType
    contactUuid: $contactUuid
    tariffZoneLocationType: $tariffZoneLocationType
    defaultToGlobal: $defaultToGlobal
    excludeLineHaulTariffZones: $excludeLineHaulTariffZones
    excludeMileBasedTariffZones: $excludeMileBasedTariffZones
  ) {
    uuid
    name
    type
    lineHaulLane {
      isActive
    }
  }
}
    `;
export const UpdateTariffZoneDocument = gql`
    mutation updateTariffZone($tariffZoneUpdateInput: TariffZoneUpdateInput!, $contactUuid: String) {
  updateTariffZone(
    tariffZoneUpdateInput: $tariffZoneUpdateInput
    contactUuid: $contactUuid
  ) {
    uuid
    name
    type
  }
}
    `;
export const ServicesDocument = gql`
    query services {
  services {
    ...Service
  }
}
    ${ServiceFragmentDoc}`;
export const TariffGroupsDocument = gql`
    query tariffGroups($first: Int, $after: String, $last: Int, $before: String, $uuids: [String!], $searchText: String, $contactUuid: String, $serviceUuid: String, $tariffGroupType: TariffGroupType, $excludeDefault: Boolean, $includeCustomerUsage: Boolean! = false) {
  tariffGroupsPaginated(
    first: $first
    after: $after
    before: $before
    last: $last
    uuids: $uuids
    searchText: $searchText
    contactUuid: $contactUuid
    serviceUuid: $serviceUuid
    tariffGroupType: $tariffGroupType
    excludeDefault: $excludeDefault
  ) {
    edges {
      node {
        ...TariffGroupForTable
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
    totalCount
  }
}
    ${TariffGroupForTableFragmentDoc}`;
export const ShipmentsByPhoneOrReferenceNumberDocument = gql`
    query shipmentsByPhoneOrReferenceNumber($searchText: String!, $companyUuid: String!) {
  shipmentsByPhoneOrReferenceNumber(
    searchText: $searchText
    companyUuid: $companyUuid
  ) {
    uuid
    order {
      uuid
      standardOrderFields {
        shipperBillOfLadingNumber
      }
    }
    status
    legs {
      endStop {
        stopType
        address {
          ...Address
        }
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export const BundleChildrenDocument = gql`
    query BundleChildren($uuids: [String!]!) {
  piecesByUuids(uuids: $uuids) {
    uuid
    referenceNumber
    children {
      uuid
      referenceNumber
      status
    }
  }
}
    `;
export const CancelPackingPendencyDocument = gql`
    mutation CancelPackingPendency($input: CancelPackingPendencyInput!) {
  cancelPackingPendency(input: $input) {
    packingPendency {
      uuid
      status
    }
  }
}
    `;
export const CreatePackingPendencyDocument = gql`
    mutation CreatePackingPendency($input: CreatePackingPendencyInput!) {
  createPackingPendency(input: $input) {
    packingPendency {
      uuid
      status
    }
  }
}
    `;
export const PackPiecesDocument = gql`
    mutation PackPieces($input: PackPiecesInput!) {
  packPieces(input: $input) {
    uuid
    type
    quantity
    referenceNumber
  }
}
    `;
export const PackingPendenciesDocument = gql`
    query PackingPendencies($input: FindPackingPendenciesInput!) {
  packingPendencies(input: $input) {
    packingPendencies {
      uuid
      kind
      status
      note
      createdAt
      assignedWarehouseEmployee {
        uuid
        firstName
        lastName
      }
      order {
        uuid
        name
      }
      pieces {
        uuid
      }
    }
  }
}
    `;
export const PackingPiecesDocument = gql`
    query PackingPieces($input: PackingPiecesInput!) {
  packingPieces(input: $input) {
    hasMorePackages
    pieces {
      ...FindPieces
    }
  }
}
    ${FindPiecesFragmentDoc}`;
export const UnpackPiecesDocument = gql`
    mutation UnpackPieces($input: UnpackPiecesInput!) {
  unpackPieces(input: $input) {
    unpackedParentCount
    restoredPieceCount
  }
}
    `;
export const DockScanReportDocument = gql`
    query dockScanReport($dockScanReportInput: DockScanReportInput!) {
  dockScanReport(dockScanReportInput: $dockScanReportInput) {
    rows {
      scanUuid
      contactName
      serviceDate
      scannedAt
      receivedAt
      shipperBillOfLadingNumber
      masterAirwayBillOfLadingNumber
      pieceName
      barcode
      consigneeName
      osdReason
      piecesOnHand
      piecesExpected
      terminalCode
      scanType
      pieceMarkedOnHandOrdinal
    }
    timeZone
  }
}
    `;
export const CreateWarehouseLocationDocument = gql`
    mutation createWarehouseLocation($createWarehouseLocationInput: CreateWarehouseLocationInput!) {
  createWarehouseLocation(
    createWarehouseLocationInput: $createWarehouseLocationInput
  ) {
    warehouseLocation {
      ...CreateWarehouseLocation
    }
    errors
  }
}
    ${CreateWarehouseLocationFragmentDoc}`;
export const DeleteUnusedWarehouseLocationsDocument = gql`
    mutation deleteUnusedWarehouseLocations {
  deleteUnusedWarehouseLocations
}
    `;
export const DeleteWarehouseLocationDocument = gql`
    mutation deleteWarehouseLocation($deleteWarehouseLocationInput: DeleteWarehouseLocationInput!) {
  deleteWarehouseLocation(
    deleteWarehouseLocationInput: $deleteWarehouseLocationInput
  ) {
    success
    requiresSecondConfirmation
    impact {
      piecesCount
      packagesCount
      inventoryItemsCount
      storageUnitsCount
      itemGroupsCount
    }
  }
}
    `;
export const WarehouseLocationsDocument = gql`
    query warehouseLocations($companyUuid: String, $warehouseUuid: String) {
  warehouseLocations(companyUuid: $companyUuid, warehouseUuid: $warehouseUuid) {
    warehouseLocations {
      ...WarehouseLocationsLocation
    }
  }
}
    ${WarehouseLocationsLocationFragmentDoc}`;
export const ImportWarehouseLocationsFromCsvDocument = gql`
    mutation importWarehouseLocationsFromCsv($importWarehouseLocationsFromCsvInput: ImportWarehouseLocationsFromCsvInput!) {
  importWarehouseLocationsFromCsv(
    importWarehouseLocationsFromCsvInput: $importWarehouseLocationsFromCsvInput
  )
}
    `;
export const ScanOrderDocument = gql`
    mutation scanOrder($scanOrderInput: ScanOrderInput!) {
  scanOrder(scanOrderInput: $scanOrderInput) {
    uuid
  }
}
    `;
export const UpdateWarehouseLocationDocument = gql`
    mutation updateWarehouseLocation($updateWarehouseLocationInput: UpdateWarehouseLocationInput!) {
  updateWarehouseLocation(
    updateWarehouseLocationInput: $updateWarehouseLocationInput
  ) {
    warehouseLocation {
      ...UpdateWarehouseLocation
    }
    errors
  }
}
    ${UpdateWarehouseLocationFragmentDoc}`;
export const CreateWarehouseDocument = gql`
    mutation createWarehouse($createWarehouseInput: CreateWarehouseInput!) {
  createWarehouse(createWarehouseInput: $createWarehouseInput) {
    uuid
    name
  }
}
    `;
export const DeleteWarehouseDocument = gql`
    mutation deleteWarehouse($warehouseUuid: String!) {
  deleteWarehouse(warehouseUuid: $warehouseUuid) {
    uuid
  }
}
    `;
export const ClosestWarehouseToAddressDocument = gql`
    query closestWarehouseToAddress($addressLatitude: Float!, $addressLongitude: Float!) {
  closestWarehouseToAddress(
    addressLatitude: $addressLatitude
    addressLongitude: $addressLongitude
  ) {
    name
    uuid
  }
}
    `;
export const MarkWarehouseAsDefaultDocument = gql`
    mutation markWarehouseAsDefault($warehouseUuid: String!) {
  markWarehouseAsDefault(warehouseUuid: $warehouseUuid) {
    uuid
    name
  }
}
    `;
export const MyWarehousesDocument = gql`
    query myWarehouses {
  me {
    company {
      warehouses {
        uuid
        name
        terminal {
          uuid
        }
      }
    }
  }
}
    `;
export const UpdateWarehouseDocument = gql`
    mutation updateWarehouse($updateWarehouseInput: UpdateWarehouseInput!) {
  updateWarehouse(updateWarehouseInput: $updateWarehouseInput) {
    uuid
    name
  }
}
    `;
export const WarehouseDocument = gql`
    query warehouse($warehouseUuid: String!) {
  warehouse(warehouseUuid: $warehouseUuid) {
    name
    uuid
    address {
      ...Address
    }
    isDefault
    terminal {
      uuid
    }
  }
}
    ${AddressFragmentDoc}`;
export const WarehousesDocument = gql`
    query warehouses($warehousesInput: WarehousesInput!) {
  warehouses(warehousesInput: $warehousesInput) {
    uuid
    name
    address {
      ...Address
    }
    isDefault
    terminal {
      uuid
      code
      isActive
    }
  }
}
    ${AddressFragmentDoc}`;
export const FindLegsDocument = gql`
    query findLegs($startDate: DateTime!, $endDate: DateTime!) {
  legs(
    startDate: $startDate
    endDate: $endDate
    shipHasArrived: true
    showUnscheduled: true
  ) {
    uuid
    shipment {
      uuid
    }
    scheduledDate
    endStop {
      address {
        name
        line1
        line2
        city
        state
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    ablyToken(variables?: AblyTokenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AblyTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AblyTokenQuery>(AblyTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ablyToken', 'query', variables);
    },
    activeAgents(variables?: ActiveAgentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActiveAgentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActiveAgentsQuery>(ActiveAgentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'activeAgents', 'query', variables);
    },
    contactForAutocomplete(variables: ContactForAutocompleteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactForAutocompleteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactForAutocompleteQuery>(ContactForAutocompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactForAutocomplete', 'query', variables);
    },
    ContactPackageSpecs(variables: ContactPackageSpecsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactPackageSpecsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactPackageSpecsQuery>(ContactPackageSpecsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ContactPackageSpecs', 'query', variables);
    },
    contactsForAutocomplete(variables?: ContactsForAutocompleteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsForAutocompleteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsForAutocompleteQuery>(ContactsForAutocompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsForAutocomplete', 'query', variables);
    },
    dispatchableDrivers(variables: DispatchableDriversQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchableDriversQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchableDriversQuery>(DispatchableDriversDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchableDrivers', 'query', variables);
    },
    driverMinimal(variables: DriverMinimalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverMinimalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverMinimalQuery>(DriverMinimalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverMinimal', 'query', variables);
    },
    login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>(LoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'login', 'mutation', variables);
    },
    logout(variables?: LogoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LogoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LogoutMutation>(LogoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'logout', 'mutation', variables);
    },
    meAsThirdPartyUserForAuth(variables?: MeAsThirdPartyUserForAuthQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeAsThirdPartyUserForAuthQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeAsThirdPartyUserForAuthQuery>(MeAsThirdPartyUserForAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meAsThirdPartyUserForAuth', 'query', variables);
    },
    meAsThirdPartyUser(variables?: MeAsThirdPartyUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeAsThirdPartyUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeAsThirdPartyUserQuery>(MeAsThirdPartyUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'meAsThirdPartyUser', 'query', variables);
    },
    MeForAuth(variables?: MeForAuthQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeForAuthQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeForAuthQuery>(MeForAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MeForAuth', 'query', variables);
    },
    markTutorialSeen(variables: MarkTutorialSeenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkTutorialSeenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkTutorialSeenMutation>(MarkTutorialSeenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markTutorialSeen', 'mutation', variables);
    },
    me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>(MeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'me', 'query', variables);
    },
    userRoles(variables?: UserRolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserRolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserRolesQuery>(UserRolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userRoles', 'query', variables);
    },
    tableFields(variables?: TableFieldsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TableFieldsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TableFieldsQuery>(TableFieldsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tableFields', 'query', variables);
    },
    tariffChains(variables: TariffChainsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffChainsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffChainsQuery>(TariffChainsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffChains', 'query', variables);
    },
    templateAddresses(variables?: TemplateAddressesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TemplateAddressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TemplateAddressesQuery>(TemplateAddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'templateAddresses', 'query', variables);
    },
    whiteLabelCompany(variables: WhiteLabelCompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WhiteLabelCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WhiteLabelCompanyQuery>(WhiteLabelCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'whiteLabelCompany', 'query', variables);
    },
    autoApplyAccessorialConfig(variables: AutoApplyAccessorialConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutoApplyAccessorialConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutoApplyAccessorialConfigQuery>(AutoApplyAccessorialConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'autoApplyAccessorialConfig', 'query', variables);
    },
    autoApplyAccessorialConfigs(variables?: AutoApplyAccessorialConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutoApplyAccessorialConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutoApplyAccessorialConfigsQuery>(AutoApplyAccessorialConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'autoApplyAccessorialConfigs', 'query', variables);
    },
    createAutoApplyAccessorialConfig(variables: CreateAutoApplyAccessorialConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAutoApplyAccessorialConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAutoApplyAccessorialConfigMutation>(CreateAutoApplyAccessorialConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAutoApplyAccessorialConfig', 'mutation', variables);
    },
    deleteAutoApplyAccessorialConfig(variables: DeleteAutoApplyAccessorialConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteAutoApplyAccessorialConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAutoApplyAccessorialConfigMutation>(DeleteAutoApplyAccessorialConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAutoApplyAccessorialConfig', 'mutation', variables);
    },
    selectSpecialAccessorial(variables: SelectSpecialAccessorialQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SelectSpecialAccessorialQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SelectSpecialAccessorialQuery>(SelectSpecialAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'selectSpecialAccessorial', 'query', variables);
    },
    updateAutoApplyAccessorialConfig(variables: UpdateAutoApplyAccessorialConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAutoApplyAccessorialConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAutoApplyAccessorialConfigMutation>(UpdateAutoApplyAccessorialConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAutoApplyAccessorialConfig', 'mutation', variables);
    },
    coordinatesForAddress(variables?: CoordinatesForAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CoordinatesForAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CoordinatesForAddressQuery>(CoordinatesForAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'coordinatesForAddress', 'query', variables);
    },
    getCityAndStateOptionsFromZipcode(variables: GetCityAndStateOptionsFromZipcodeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCityAndStateOptionsFromZipcodeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCityAndStateOptionsFromZipcodeQuery>(GetCityAndStateOptionsFromZipcodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCityAndStateOptionsFromZipcode', 'query', variables);
    },
    getZipcodeOptionsFromCityAndState(variables: GetZipcodeOptionsFromCityAndStateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetZipcodeOptionsFromCityAndStateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetZipcodeOptionsFromCityAndStateQuery>(GetZipcodeOptionsFromCityAndStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getZipcodeOptionsFromCityAndState', 'query', variables);
    },
    ManualStandardStopTypeForAddress(variables: ManualStandardStopTypeForAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ManualStandardStopTypeForAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ManualStandardStopTypeForAddressQuery>(ManualStandardStopTypeForAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ManualStandardStopTypeForAddress', 'query', variables);
    },
    airportInfo(variables: AirportInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AirportInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AirportInfoQuery>(AirportInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'airportInfo', 'query', variables);
    },
    appointmentStatusHistory(variables: AppointmentStatusHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppointmentStatusHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppointmentStatusHistoryQuery>(AppointmentStatusHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'appointmentStatusHistory', 'query', variables);
    },
    dispatchAppointmentSummary(variables?: DispatchAppointmentSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchAppointmentSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchAppointmentSummaryQuery>(DispatchAppointmentSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchAppointmentSummary', 'query', variables);
    },
    dispatchAppointments(variables?: DispatchAppointmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchAppointmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchAppointmentsQuery>(DispatchAppointmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchAppointments', 'query', variables);
    },
    transitionAppointment(variables: TransitionAppointmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TransitionAppointmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TransitionAppointmentMutation>(TransitionAppointmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'transitionAppointment', 'mutation', variables);
    },
    AppointmentConfirmationInfo(variables: AppointmentConfirmationInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppointmentConfirmationInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppointmentConfirmationInfoQuery>(AppointmentConfirmationInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AppointmentConfirmationInfo', 'query', variables);
    },
    getAppointments(variables: GetAppointmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAppointmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAppointmentsQuery>(GetAppointmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAppointments', 'query', variables);
    },
    bulkConfirmAppointments(variables: BulkConfirmAppointmentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkConfirmAppointmentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkConfirmAppointmentsMutation>(BulkConfirmAppointmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkConfirmAppointments', 'mutation', variables);
    },
    bulkChangeCallStatus(variables: BulkChangeCallStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkChangeCallStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkChangeCallStatusMutation>(BulkChangeCallStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkChangeCallStatus', 'mutation', variables);
    },
    bulkUnconfirmAppointments(variables: BulkUnconfirmAppointmentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkUnconfirmAppointmentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUnconfirmAppointmentsMutation>(BulkUnconfirmAppointmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUnconfirmAppointments', 'mutation', variables);
    },
    callStops(variables: CallStopsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CallStopsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CallStopsMutation>(CallStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'callStops', 'mutation', variables);
    },
    getDefaultTexts(variables: GetDefaultTextsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetDefaultTextsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDefaultTextsQuery>(GetDefaultTextsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDefaultTexts', 'query', variables);
    },
    MakeAppointmentConfirmationDecision(variables: MakeAppointmentConfirmationDecisionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MakeAppointmentConfirmationDecisionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MakeAppointmentConfirmationDecisionMutation>(MakeAppointmentConfirmationDecisionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MakeAppointmentConfirmationDecision', 'mutation', variables);
    },
    queueAppointmentTexts(variables: QueueAppointmentTextsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueueAppointmentTextsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueueAppointmentTextsMutation>(QueueAppointmentTextsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queueAppointmentTexts', 'mutation', variables);
    },
    recordContactAttempted(variables: RecordContactAttemptedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecordContactAttemptedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecordContactAttemptedMutation>(RecordContactAttemptedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'recordContactAttempted', 'mutation', variables);
    },
    removeStopsFromRoutes(variables: RemoveStopsFromRoutesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveStopsFromRoutesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveStopsFromRoutesMutation>(RemoveStopsFromRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeStopsFromRoutes', 'mutation', variables);
    },
    auditReport(variables: AuditReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AuditReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuditReportQuery>(AuditReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'auditReport', 'query', variables);
    },
    companyConfiguration(variables?: CompanyConfigurationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyConfigurationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyConfigurationQuery>(CompanyConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyConfiguration', 'query', variables);
    },
    CompletionToPaymentReportCsv(variables: CompletionToPaymentReportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompletionToPaymentReportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompletionToPaymentReportCsvQuery>(CompletionToPaymentReportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompletionToPaymentReportCsv', 'query', variables);
    },
    CompletionToPaymentSummary(variables: CompletionToPaymentSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompletionToPaymentSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompletionToPaymentSummaryQuery>(CompletionToPaymentSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompletionToPaymentSummary', 'query', variables);
    },
    CompletionToPaymentReport(variables: CompletionToPaymentReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompletionToPaymentReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompletionToPaymentReportQuery>(CompletionToPaymentReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompletionToPaymentReport', 'query', variables);
    },
    contactPersons(variables?: ContactPersonsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactPersonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactPersonsQuery>(ContactPersonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactPersons', 'query', variables);
    },
    archiveContactStation(variables: ArchiveContactStationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveContactStationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveContactStationMutation>(ArchiveContactStationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'archiveContactStation', 'mutation', variables);
    },
    ArchivePerson(variables: ArchivePersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchivePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchivePersonMutation>(ArchivePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchivePerson', 'mutation', variables);
    },
    contactChargeMatrixColumnMappings(variables: ContactChargeMatrixColumnMappingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactChargeMatrixColumnMappingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactChargeMatrixColumnMappingsQuery>(ContactChargeMatrixColumnMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactChargeMatrixColumnMappings', 'query', variables);
    },
    createContactComment(variables: CreateContactCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateContactCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateContactCommentMutation>(CreateContactCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createContactComment', 'mutation', variables);
    },
    deleteContactComment(variables: DeleteContactCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteContactCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteContactCommentMutation>(DeleteContactCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteContactComment', 'mutation', variables);
    },
    updateContactComment(variables: UpdateContactCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateContactCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContactCommentMutation>(UpdateContactCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateContactComment', 'mutation', variables);
    },
    contactCommunicationConfigs(variables: ContactCommunicationConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactCommunicationConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactCommunicationConfigsQuery>(ContactCommunicationConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactCommunicationConfigs', 'query', variables);
    },
    contactDefaultSurcharge(variables: ContactDefaultSurchargeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactDefaultSurchargeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactDefaultSurchargeQuery>(ContactDefaultSurchargeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactDefaultSurcharge', 'query', variables);
    },
    contactEmailSuppressions(variables: ContactEmailSuppressionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactEmailSuppressionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactEmailSuppressionsQuery>(ContactEmailSuppressionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactEmailSuppressions', 'query', variables);
    },
    contactEmails(variables: ContactEmailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactEmailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactEmailsQuery>(ContactEmailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactEmails', 'query', variables);
    },
    contactIsOverCreditLimitByOrderUuid(variables: ContactIsOverCreditLimitByOrderUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactIsOverCreditLimitByOrderUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactIsOverCreditLimitByOrderUuidQuery>(ContactIsOverCreditLimitByOrderUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactIsOverCreditLimitByOrderUuid', 'query', variables);
    },
    contactIsOverCreditLimit(variables: ContactIsOverCreditLimitQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactIsOverCreditLimitQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactIsOverCreditLimitQuery>(ContactIsOverCreditLimitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactIsOverCreditLimit', 'query', variables);
    },
    contactLogos(variables: ContactLogosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactLogosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactLogosQuery>(ContactLogosDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactLogos', 'query', variables);
    },
    contactQueryForBluebird(variables: ContactQueryForBluebirdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactQueryForBluebirdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactQueryForBluebirdQuery>(ContactQueryForBluebirdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactQueryForBluebird', 'query', variables);
    },
    contactServices(variables: ContactServicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactServicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactServicesQuery>(ContactServicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactServices', 'query', variables);
    },
    contactStations(variables: ContactStationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactStationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactStationsQuery>(ContactStationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactStations', 'query', variables);
    },
    contactTariffChains(variables: ContactTariffChainsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactTariffChainsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactTariffChainsQuery>(ContactTariffChainsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactTariffChains', 'query', variables);
    },
    contactTariffGroups(variables?: ContactTariffGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactTariffGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactTariffGroupsQuery>(ContactTariffGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactTariffGroups', 'query', variables);
    },
    contact(variables: ContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactQuery>(ContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contact', 'query', variables);
    },
    contactsForInvoicing(variables: ContactsForInvoicingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsForInvoicingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsForInvoicingQuery>(ContactsForInvoicingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsForInvoicing', 'query', variables);
    },
    contactsForQuickbooks(variables?: ContactsForQuickbooksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsForQuickbooksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsForQuickbooksQuery>(ContactsForQuickbooksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsForQuickbooks', 'query', variables);
    },
    contactsPageListing(variables?: ContactsPageListingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsPageListingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsPageListingQuery>(ContactsPageListingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsPageListing', 'query', variables);
    },
    contactsReport(variables?: ContactsReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsReportQuery>(ContactsReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsReport', 'query', variables);
    },
    contactsSimple(variables?: ContactsSimpleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsSimpleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsSimpleQuery>(ContactsSimpleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsSimple', 'query', variables);
    },
    contacts(variables?: ContactsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsQuery>(ContactsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contacts', 'query', variables);
    },
    createAddress(variables: CreateAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAddressMutation>(CreateAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAddress', 'mutation', variables);
    },
    createContactEmail(variables: CreateContactEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateContactEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateContactEmailMutation>(CreateContactEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createContactEmail', 'mutation', variables);
    },
    createContactStation(variables: CreateContactStationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateContactStationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateContactStationMutation>(CreateContactStationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createContactStation', 'mutation', variables);
    },
    createCustomerContact(variables: CreateCustomerContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCustomerContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCustomerContactMutation>(CreateCustomerContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCustomerContact', 'mutation', variables);
    },
    CreatePerson(variables: CreatePersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePersonMutation>(CreatePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePerson', 'mutation', variables);
    },
    findServicesForCustomerConfiguration(variables: FindServicesForCustomerConfigurationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindServicesForCustomerConfigurationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindServicesForCustomerConfigurationQuery>(FindServicesForCustomerConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findServicesForCustomerConfiguration', 'query', variables);
    },
    deleteContactEmail(variables: DeleteContactEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteContactEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteContactEmailMutation>(DeleteContactEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteContactEmail', 'mutation', variables);
    },
    invoiceTerms(variables?: InvoiceTermsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceTermsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceTermsQuery>(InvoiceTermsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceTerms', 'query', variables);
    },
    OrderEventNotificationSubscriptions(variables: OrderEventNotificationSubscriptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderEventNotificationSubscriptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderEventNotificationSubscriptionsQuery>(OrderEventNotificationSubscriptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrderEventNotificationSubscriptions', 'query', variables);
    },
    OrganizationEffectivePackageTypeConfigs(variables: OrganizationEffectivePackageTypeConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganizationEffectivePackageTypeConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationEffectivePackageTypeConfigsQuery>(OrganizationEffectivePackageTypeConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrganizationEffectivePackageTypeConfigs', 'query', variables);
    },
    paginatedContacts(variables?: PaginatedContactsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaginatedContactsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaginatedContactsQuery>(PaginatedContactsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paginatedContacts', 'query', variables);
    },
    Persons(variables?: PersonsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PersonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PersonsQuery>(PersonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Persons', 'query', variables);
    },
    queryQuickbooksDesktopAccounts(variables?: QueryQuickbooksDesktopAccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueryQuickbooksDesktopAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryQuickbooksDesktopAccountsQuery>(QueryQuickbooksDesktopAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queryQuickbooksDesktopAccounts', 'query', variables);
    },
    queryQuickbooksDesktopCustomers(variables?: QueryQuickbooksDesktopCustomersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueryQuickbooksDesktopCustomersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryQuickbooksDesktopCustomersQuery>(QueryQuickbooksDesktopCustomersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queryQuickbooksDesktopCustomers', 'query', variables);
    },
    removeAddress(variables: RemoveAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveAddressMutation>(RemoveAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeAddress', 'mutation', variables);
    },
    restoreContactStation(variables: RestoreContactStationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreContactStationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreContactStationMutation>(RestoreContactStationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'restoreContactStation', 'mutation', variables);
    },
    RestorePerson(variables: RestorePersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestorePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestorePersonMutation>(RestorePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestorePerson', 'mutation', variables);
    },
    setContactChargeMatrixColumnMappings(variables: SetContactChargeMatrixColumnMappingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetContactChargeMatrixColumnMappingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetContactChargeMatrixColumnMappingsMutation>(SetContactChargeMatrixColumnMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setContactChargeMatrixColumnMappings', 'mutation', variables);
    },
    shallowContact(variables: ShallowContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowContactQuery>(ShallowContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowContact', 'query', variables);
    },
    shallowContactsByUuids(variables: ShallowContactsByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowContactsByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowContactsByUuidsQuery>(ShallowContactsByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowContactsByUuids', 'query', variables);
    },
    shallowContacts(variables?: ShallowContactsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowContactsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowContactsQuery>(ShallowContactsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowContacts', 'query', variables);
    },
    thirdPartyUserByUuid(variables: ThirdPartyUserByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ThirdPartyUserByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThirdPartyUserByUuidQuery>(ThirdPartyUserByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'thirdPartyUserByUuid', 'query', variables);
    },
    thirdPartyUsersByContact(variables: ThirdPartyUsersByContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ThirdPartyUsersByContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThirdPartyUsersByContactQuery>(ThirdPartyUsersByContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'thirdPartyUsersByContact', 'query', variables);
    },
    updateAddress(variables: UpdateAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAddressMutation>(UpdateAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAddress', 'mutation', variables);
    },
    updateContactCommunicationConfig(variables: UpdateContactCommunicationConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateContactCommunicationConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContactCommunicationConfigMutation>(UpdateContactCommunicationConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateContactCommunicationConfig', 'mutation', variables);
    },
    UpdateContactEmails(variables: UpdateContactEmailsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateContactEmailsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContactEmailsMutation>(UpdateContactEmailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateContactEmails', 'mutation', variables);
    },
    updateContactStation(variables: UpdateContactStationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateContactStationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContactStationMutation>(UpdateContactStationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateContactStation', 'mutation', variables);
    },
    updateCustomerContact(variables: UpdateCustomerContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCustomerContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomerContactMutation>(UpdateCustomerContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCustomerContact', 'mutation', variables);
    },
    UpdateOrderEventNotificationSubscriptions(variables: UpdateOrderEventNotificationSubscriptionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderEventNotificationSubscriptionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderEventNotificationSubscriptionsMutation>(UpdateOrderEventNotificationSubscriptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateOrderEventNotificationSubscriptions', 'mutation', variables);
    },
    UpdatePerson(variables: UpdatePersonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePersonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePersonMutation>(UpdatePersonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePerson', 'mutation', variables);
    },
    upsertAddress(variables: UpsertAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertAddressMutation>(UpsertAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertAddress', 'mutation', variables);
    },
    UpsertOrganizationPackageTypeConfig(variables: UpsertOrganizationPackageTypeConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertOrganizationPackageTypeConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertOrganizationPackageTypeConfigMutation>(UpsertOrganizationPackageTypeConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpsertOrganizationPackageTypeConfig', 'mutation', variables);
    },
    upsertUserContactNotificationSubscription(variables: UpsertUserContactNotificationSubscriptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertUserContactNotificationSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertUserContactNotificationSubscriptionMutation>(UpsertUserContactNotificationSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertUserContactNotificationSubscription', 'mutation', variables);
    },
    userContactNotificationSubscription(variables: UserContactNotificationSubscriptionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserContactNotificationSubscriptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserContactNotificationSubscriptionQuery>(UserContactNotificationSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userContactNotificationSubscription', 'query', variables);
    },
    BookCustomerAppointment(variables: BookCustomerAppointmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BookCustomerAppointmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookCustomerAppointmentMutation>(BookCustomerAppointmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BookCustomerAppointment', 'mutation', variables);
    },
    CustomerAppointmentInvitation(variables: CustomerAppointmentInvitationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerAppointmentInvitationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerAppointmentInvitationQuery>(CustomerAppointmentInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CustomerAppointmentInvitation', 'query', variables);
    },
    DeclineCustomerAppointmentOptions(variables: DeclineCustomerAppointmentOptionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeclineCustomerAppointmentOptionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeclineCustomerAppointmentOptionsMutation>(DeclineCustomerAppointmentOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeclineCustomerAppointmentOptions', 'mutation', variables);
    },
    RequestCustomerAppointmentLink(variables: RequestCustomerAppointmentLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RequestCustomerAppointmentLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestCustomerAppointmentLinkMutation>(RequestCustomerAppointmentLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RequestCustomerAppointmentLink', 'mutation', variables);
    },
    customerPortalQuoteContact(variables: CustomerPortalQuoteContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerPortalQuoteContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerPortalQuoteContactQuery>(CustomerPortalQuoteContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerPortalQuoteContact', 'query', variables);
    },
    rateCustomerPortalSmc3Quote(variables: RateCustomerPortalSmc3QuoteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RateCustomerPortalSmc3QuoteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RateCustomerPortalSmc3QuoteQuery>(RateCustomerPortalSmc3QuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rateCustomerPortalSmc3Quote', 'query', variables);
    },
    addThirdPartyUserToContact(variables: AddThirdPartyUserToContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddThirdPartyUserToContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddThirdPartyUserToContactMutation>(AddThirdPartyUserToContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addThirdPartyUserToContact', 'mutation', variables);
    },
    consigneePortalOrder(variables: ConsigneePortalOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConsigneePortalOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsigneePortalOrderQuery>(ConsigneePortalOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consigneePortalOrder', 'query', variables);
    },
    customerPortalMe(variables?: CustomerPortalMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerPortalMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerPortalMeQuery>(CustomerPortalMeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerPortalMe', 'query', variables);
    },
    customerPortalOrder(variables: CustomerPortalOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerPortalOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerPortalOrderQuery>(CustomerPortalOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerPortalOrder', 'query', variables);
    },
    customerPortalPieces(variables: CustomerPortalPiecesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerPortalPiecesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerPortalPiecesQuery>(CustomerPortalPiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerPortalPieces', 'query', variables);
    },
    customerPortalQuotes(variables: CustomerPortalQuotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerPortalQuotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerPortalQuotesQuery>(CustomerPortalQuotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerPortalQuotes', 'query', variables);
    },
    customerPortalOrders(variables?: CustomerPortalOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerPortalOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerPortalOrdersQuery>(CustomerPortalOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerPortalOrders', 'query', variables);
    },
    etaForCustomerPortal(variables: EtaForCustomerPortalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EtaForCustomerPortalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EtaForCustomerPortalQuery>(EtaForCustomerPortalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'etaForCustomerPortal', 'query', variables);
    },
    publicUpsertShipmentSubscriber(variables: PublicUpsertShipmentSubscriberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PublicUpsertShipmentSubscriberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PublicUpsertShipmentSubscriberMutation>(PublicUpsertShipmentSubscriberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'publicUpsertShipmentSubscriber', 'mutation', variables);
    },
    removeThirdPartyUserFromContact(variables: RemoveThirdPartyUserFromContactMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveThirdPartyUserFromContactMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveThirdPartyUserFromContactMutation>(RemoveThirdPartyUserFromContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeThirdPartyUserFromContact', 'mutation', variables);
    },
    signUpForThirdPartyUserAccount(variables: SignUpForThirdPartyUserAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SignUpForThirdPartyUserAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SignUpForThirdPartyUserAccountMutation>(SignUpForThirdPartyUserAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'signUpForThirdPartyUserAccount', 'mutation', variables);
    },
    calculateRouteEtas(variables: CalculateRouteEtasMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalculateRouteEtasMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalculateRouteEtasMutation>(CalculateRouteEtasDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'calculateRouteEtas', 'mutation', variables);
    },
    sameDayDispatchRoutesWithDriverCoords(variables: SameDayDispatchRoutesWithDriverCoordsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SameDayDispatchRoutesWithDriverCoordsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SameDayDispatchRoutesWithDriverCoordsQuery>(SameDayDispatchRoutesWithDriverCoordsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sameDayDispatchRoutesWithDriverCoords', 'query', variables);
    },
    dispatchDrivers(variables: DispatchDriversQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchDriversQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchDriversQuery>(DispatchDriversDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchDrivers', 'query', variables);
    },
    equipmentsByType(variables?: EquipmentsByTypeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EquipmentsByTypeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EquipmentsByTypeQuery>(EquipmentsByTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'equipmentsByType', 'query', variables);
    },
    leg(variables: LegQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LegQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LegQuery>(LegDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'leg', 'query', variables);
    },
    legs(variables: LegsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LegsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LegsQuery>(LegsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'legs', 'query', variables);
    },
    refreshEtasForRoute(variables: RefreshEtasForRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefreshEtasForRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshEtasForRouteMutation>(RefreshEtasForRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refreshEtasForRoute', 'mutation', variables);
    },
    unassignLegFromDriver(variables: UnassignLegFromDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnassignLegFromDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnassignLegFromDriverMutation>(UnassignLegFromDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unassignLegFromDriver', 'mutation', variables);
    },
    sameDayDispatchConfig(variables?: SameDayDispatchConfigQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SameDayDispatchConfigQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SameDayDispatchConfigQuery>(SameDayDispatchConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sameDayDispatchConfig', 'query', variables);
    },
    updateSameDayDispatchConfig(variables: UpdateSameDayDispatchConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSameDayDispatchConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSameDayDispatchConfigMutation>(UpdateSameDayDispatchConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSameDayDispatchConfig', 'mutation', variables);
    },
    updateShipment(variables: UpdateShipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateShipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateShipmentMutation>(UpdateShipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateShipment', 'mutation', variables);
    },
    acceptOrderDelegation(variables: AcceptOrderDelegationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcceptOrderDelegationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptOrderDelegationMutation>(AcceptOrderDelegationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acceptOrderDelegation', 'mutation', variables);
    },
    declineOrderDelegation(variables: DeclineOrderDelegationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeclineOrderDelegationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeclineOrderDelegationMutation>(DeclineOrderDelegationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'declineOrderDelegation', 'mutation', variables);
    },
    delegatedOrdersInbox(variables?: DelegatedOrdersInboxQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DelegatedOrdersInboxQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DelegatedOrdersInboxQuery>(DelegatedOrdersInboxDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'delegatedOrdersInbox', 'query', variables);
    },
    delegatedOrdersOutbox(variables?: DelegatedOrdersOutboxQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DelegatedOrdersOutboxQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DelegatedOrdersOutboxQuery>(DelegatedOrdersOutboxDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'delegatedOrdersOutbox', 'query', variables);
    },
    initiateDelegatedOrderReview(variables: InitiateDelegatedOrderReviewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InitiateDelegatedOrderReviewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InitiateDelegatedOrderReviewMutation>(InitiateDelegatedOrderReviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'initiateDelegatedOrderReview', 'mutation', variables);
    },
    orderEndCustomerSharing(variables: OrderEndCustomerSharingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderEndCustomerSharingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderEndCustomerSharingQuery>(OrderEndCustomerSharingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderEndCustomerSharing', 'query', variables);
    },
    pendingOrderDelegationsCount(variables?: PendingOrderDelegationsCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PendingOrderDelegationsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PendingOrderDelegationsCountQuery>(PendingOrderDelegationsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pendingOrderDelegationsCount', 'query', variables);
    },
    rejectDelegationEndCustomerLink(variables: RejectDelegationEndCustomerLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RejectDelegationEndCustomerLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectDelegationEndCustomerLinkMutation>(RejectDelegationEndCustomerLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectDelegationEndCustomerLink', 'mutation', variables);
    },
    CreateOrderDelegationRule(variables: CreateOrderDelegationRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderDelegationRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderDelegationRuleMutation>(CreateOrderDelegationRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateOrderDelegationRule', 'mutation', variables);
    },
    DeleteOrderDelegationRule(variables: DeleteOrderDelegationRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteOrderDelegationRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOrderDelegationRuleMutation>(DeleteOrderDelegationRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteOrderDelegationRule', 'mutation', variables);
    },
    OrderDelegationRules(variables?: OrderDelegationRulesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderDelegationRulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderDelegationRulesQuery>(OrderDelegationRulesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrderDelegationRules', 'query', variables);
    },
    UpdateOrderDelegationRule(variables: UpdateOrderDelegationRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderDelegationRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderDelegationRuleMutation>(UpdateOrderDelegationRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateOrderDelegationRule', 'mutation', variables);
    },
    acceptOrganizationPeer(variables: AcceptOrganizationPeerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcceptOrganizationPeerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptOrganizationPeerMutation>(AcceptOrganizationPeerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acceptOrganizationPeer', 'mutation', variables);
    },
    archiveOrganization(variables: ArchiveOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveOrganizationMutation>(ArchiveOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'archiveOrganization', 'mutation', variables);
    },
    availablePeerCompanies(variables?: AvailablePeerCompaniesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AvailablePeerCompaniesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AvailablePeerCompaniesQuery>(AvailablePeerCompaniesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'availablePeerCompanies', 'query', variables);
    },
    createOrganizationPeer(variables: CreateOrganizationPeerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrganizationPeerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrganizationPeerMutation>(CreateOrganizationPeerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrganizationPeer', 'mutation', variables);
    },
    createOrganization(variables: CreateOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrganizationMutation>(CreateOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrganization', 'mutation', variables);
    },
    incomingOrganizationPeers(variables: IncomingOrganizationPeersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IncomingOrganizationPeersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IncomingOrganizationPeersQuery>(IncomingOrganizationPeersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'incomingOrganizationPeers', 'query', variables);
    },
    organizationForAddressBook(variables: OrganizationForAddressBookQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganizationForAddressBookQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationForAddressBookQuery>(OrganizationForAddressBookDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organizationForAddressBook', 'query', variables);
    },
    organizationForFrontendHook(variables: OrganizationForFrontendHookQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganizationForFrontendHookQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationForFrontendHookQuery>(OrganizationForFrontendHookDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organizationForFrontendHook', 'query', variables);
    },
    organizationNotes(variables: OrganizationNotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganizationNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationNotesQuery>(OrganizationNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organizationNotes', 'query', variables);
    },
    organizationPeers(variables: OrganizationPeersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganizationPeersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationPeersQuery>(OrganizationPeersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organizationPeers', 'query', variables);
    },
    organization(variables: OrganizationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationQuery>(OrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organization', 'query', variables);
    },
    paginatedOrganizations(variables: PaginatedOrganizationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaginatedOrganizationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaginatedOrganizationsQuery>(PaginatedOrganizationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paginatedOrganizations', 'query', variables);
    },
    restoreOrganization(variables: RestoreOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreOrganizationMutation>(RestoreOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'restoreOrganization', 'mutation', variables);
    },
    revokeOrganizationPeer(variables: RevokeOrganizationPeerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RevokeOrganizationPeerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RevokeOrganizationPeerMutation>(RevokeOrganizationPeerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'revokeOrganizationPeer', 'mutation', variables);
    },
    setOrganizationEmitPieceLevelWebhooks(variables: SetOrganizationEmitPieceLevelWebhooksMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetOrganizationEmitPieceLevelWebhooksMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetOrganizationEmitPieceLevelWebhooksMutation>(SetOrganizationEmitPieceLevelWebhooksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setOrganizationEmitPieceLevelWebhooks', 'mutation', variables);
    },
    updateOrganizationPeersSettings(variables: UpdateOrganizationPeersSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrganizationPeersSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrganizationPeersSettingsMutation>(UpdateOrganizationPeersSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrganizationPeersSettings', 'mutation', variables);
    },
    updateOrganization(variables: UpdateOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrganizationMutation>(UpdateOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrganization', 'mutation', variables);
    },
    incomingPeerAccessorialMappings(variables: IncomingPeerAccessorialMappingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IncomingPeerAccessorialMappingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IncomingPeerAccessorialMappingsQuery>(IncomingPeerAccessorialMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'incomingPeerAccessorialMappings', 'query', variables);
    },
    mapPeerAccessorial(variables: MapPeerAccessorialMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MapPeerAccessorialMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MapPeerAccessorialMutation>(MapPeerAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mapPeerAccessorial', 'mutation', variables);
    },
    mappableAccessorials(variables?: MappableAccessorialsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MappableAccessorialsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MappableAccessorialsQuery>(MappableAccessorialsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mappableAccessorials', 'query', variables);
    },
    peerAccessorialShares(variables: PeerAccessorialSharesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PeerAccessorialSharesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PeerAccessorialSharesQuery>(PeerAccessorialSharesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'peerAccessorialShares', 'query', variables);
    },
    setPeerAccessorialShares(variables: SetPeerAccessorialSharesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetPeerAccessorialSharesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetPeerAccessorialSharesMutation>(SetPeerAccessorialSharesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setPeerAccessorialShares', 'mutation', variables);
    },
    shareableAccessorials(variables?: ShareableAccessorialsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShareableAccessorialsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShareableAccessorialsQuery>(ShareableAccessorialsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shareableAccessorials', 'query', variables);
    },
    incomingPeerServiceMappings(variables: IncomingPeerServiceMappingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IncomingPeerServiceMappingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IncomingPeerServiceMappingsQuery>(IncomingPeerServiceMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'incomingPeerServiceMappings', 'query', variables);
    },
    mapPeerService(variables: MapPeerServiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MapPeerServiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MapPeerServiceMutation>(MapPeerServiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mapPeerService', 'mutation', variables);
    },
    peerServiceShares(variables: PeerServiceSharesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PeerServiceSharesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PeerServiceSharesQuery>(PeerServiceSharesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'peerServiceShares', 'query', variables);
    },
    setPeerServiceShares(variables: SetPeerServiceSharesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetPeerServiceSharesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetPeerServiceSharesMutation>(SetPeerServiceSharesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setPeerServiceShares', 'mutation', variables);
    },
    autoCreateRoutesV2(variables: AutoCreateRoutesV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AutoCreateRoutesV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AutoCreateRoutesV2Mutation>(AutoCreateRoutesV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'autoCreateRoutesV2', 'mutation', variables);
    },
    bookedStopsByResource(variables: BookedStopsByResourceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BookedStopsByResourceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BookedStopsByResourceQuery>(BookedStopsByResourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bookedStopsByResource', 'query', variables);
    },
    createDispatchView(variables: CreateDispatchViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDispatchViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDispatchViewMutation>(CreateDispatchViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDispatchView', 'mutation', variables);
    },
    dispatchViews(variables?: DispatchViewsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchViewsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchViewsQuery>(DispatchViewsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchViews', 'query', variables);
    },
    removeDispatchView(variables: RemoveDispatchViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveDispatchViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveDispatchViewMutation>(RemoveDispatchViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeDispatchView', 'mutation', variables);
    },
    updateDispatchView(variables: UpdateDispatchViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDispatchViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDispatchViewMutation>(UpdateDispatchViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDispatchView', 'mutation', variables);
    },
    driversForSelection(variables?: DriversForSelectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriversForSelectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriversForSelectionQuery>(DriversForSelectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driversForSelection', 'query', variables);
    },
    generateRoutes(variables: GenerateRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateRoutesQuery>(GenerateRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateRoutes', 'query', variables);
    },
    dispatchTableColors(variables?: DispatchTableColorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchTableColorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchTableColorsQuery>(DispatchTableColorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchTableColors', 'query', variables);
    },
    UpdateDispatchTableColors(variables: UpdateDispatchTableColorsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDispatchTableColorsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDispatchTableColorsMutation>(UpdateDispatchTableColorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDispatchTableColors', 'mutation', variables);
    },
    CreateRouteSlot(variables: CreateRouteSlotMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRouteSlotMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRouteSlotMutation>(CreateRouteSlotDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateRouteSlot', 'mutation', variables);
    },
    drivers(variables?: DriversQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriversQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriversQuery>(DriversDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'drivers', 'query', variables);
    },
    driversWithRoutes(variables: DriversWithRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriversWithRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriversWithRoutesQuery>(DriversWithRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driversWithRoutes', 'query', variables);
    },
    getOptimizationResults(variables: GetOptimizationResultsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOptimizationResultsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOptimizationResultsQuery>(GetOptimizationResultsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOptimizationResults', 'query', variables);
    },
    groupByStops(variables: GroupByStopsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GroupByStopsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GroupByStopsQuery>(GroupByStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'groupByStops', 'query', variables);
    },
    numberOfStops(variables?: NumberOfStopsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NumberOfStopsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NumberOfStopsQuery>(NumberOfStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'numberOfStops', 'query', variables);
    },
    routeEta(variables: RouteEtaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RouteEtaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RouteEtaQuery>(RouteEtaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routeEta', 'query', variables);
    },
    addRouteStop(variables: AddRouteStopMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddRouteStopMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddRouteStopMutation>(AddRouteStopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addRouteStop', 'mutation', variables);
    },
    applyRouteOptimization(variables: ApplyRouteOptimizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplyRouteOptimizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyRouteOptimizationMutation>(ApplyRouteOptimizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applyRouteOptimization', 'mutation', variables);
    },
    assignHelperToRoute(variables: AssignHelperToRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AssignHelperToRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignHelperToRouteMutation>(AssignHelperToRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'assignHelperToRoute', 'mutation', variables);
    },
    createAppointmentsForRoute(variables: CreateAppointmentsForRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAppointmentsForRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAppointmentsForRouteMutation>(CreateAppointmentsForRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAppointmentsForRoute', 'mutation', variables);
    },
    createRoutePaths(variables: CreateRoutePathsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRoutePathsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRoutePathsMutation>(CreateRoutePathsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRoutePaths', 'mutation', variables);
    },
    createRoutes(variables: CreateRoutesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRoutesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRoutesMutation>(CreateRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRoutes', 'mutation', variables);
    },
    deleteSlotsFromRoute(variables: DeleteSlotsFromRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteSlotsFromRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSlotsFromRouteMutation>(DeleteSlotsFromRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteSlotsFromRoute', 'mutation', variables);
    },
    driversForHelpers(variables: DriversForHelpersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriversForHelpersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriversForHelpersQuery>(DriversForHelpersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driversForHelpers', 'query', variables);
    },
    optimizationStatus(variables: OptimizationStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OptimizationStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OptimizationStatusQuery>(OptimizationStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'optimizationStatus', 'query', variables);
    },
    optimizeRouteSequence(variables: OptimizeRouteSequenceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OptimizeRouteSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OptimizeRouteSequenceMutation>(OptimizeRouteSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'optimizeRouteSequence', 'mutation', variables);
    },
    runOptimization(variables: RunOptimizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RunOptimizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RunOptimizationMutation>(RunOptimizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'runOptimization', 'mutation', variables);
    },
    optimizeRoutesTogether(variables: OptimizeRoutesTogetherMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OptimizeRoutesTogetherMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OptimizeRoutesTogetherMutation>(OptimizeRoutesTogetherDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'optimizeRoutesTogether', 'mutation', variables);
    },
    reassignRouteSlot(variables: ReassignRouteSlotMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReassignRouteSlotMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReassignRouteSlotMutation>(ReassignRouteSlotDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reassignRouteSlot', 'mutation', variables);
    },
    removeHelperFromRoute(variables: RemoveHelperFromRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveHelperFromRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveHelperFromRouteMutation>(RemoveHelperFromRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeHelperFromRoute', 'mutation', variables);
    },
    removeRoute(variables: RemoveRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveRouteMutation>(RemoveRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeRoute', 'mutation', variables);
    },
    routePathByRoute(variables: RoutePathByRouteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutePathByRouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutePathByRouteQuery>(RoutePathByRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routePathByRoute', 'query', variables);
    },
    routePaths(variables: RoutePathsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutePathsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutePathsQuery>(RoutePathsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routePaths', 'query', variables);
    },
    routesForDispatchV2(variables: RoutesForDispatchV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutesForDispatchV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutesForDispatchV2Query>(RoutesForDispatchV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routesForDispatchV2', 'query', variables);
    },
    routes(variables?: RoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutesQuery>(RoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routes', 'query', variables);
    },
    routesSamsaraVehicleLocations(variables: RoutesSamsaraVehicleLocationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutesSamsaraVehicleLocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutesSamsaraVehicleLocationsQuery>(RoutesSamsaraVehicleLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routesSamsaraVehicleLocations', 'query', variables);
    },
    routesWithDriverMobilePhoneCoordinates(variables: RoutesWithDriverMobilePhoneCoordinatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutesWithDriverMobilePhoneCoordinatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutesWithDriverMobilePhoneCoordinatesQuery>(RoutesWithDriverMobilePhoneCoordinatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routesWithDriverMobilePhoneCoordinates', 'query', variables);
    },
    routesWithEta(variables: RoutesWithEtaQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoutesWithEtaQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoutesWithEtaQuery>(RoutesWithEtaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routesWithEta', 'query', variables);
    },
    paginatedRoutes(variables?: PaginatedRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaginatedRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaginatedRoutesQuery>(PaginatedRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paginatedRoutes', 'query', variables);
    },
    stopOnRouteDetail(variables: StopOnRouteDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopOnRouteDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopOnRouteDetailQuery>(StopOnRouteDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopOnRouteDetail', 'query', variables);
    },
    updateRoute(variables: UpdateRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRouteMutation>(UpdateRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRoute', 'mutation', variables);
    },
    updateStandaloneStop(variables: UpdateStandaloneStopMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStandaloneStopMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStandaloneStopMutation>(UpdateStandaloneStopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStandaloneStop', 'mutation', variables);
    },
    updateVehicleForRoute(variables: UpdateVehicleForRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateVehicleForRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleForRouteMutation>(UpdateVehicleForRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicleForRoute', 'mutation', variables);
    },
    sameDayDispatchRoutes(variables: SameDayDispatchRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SameDayDispatchRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SameDayDispatchRoutesQuery>(SameDayDispatchRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sameDayDispatchRoutes', 'query', variables);
    },
    samsaraVehicleStatsFeed(variables: SamsaraVehicleStatsFeedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraVehicleStatsFeedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraVehicleStatsFeedQuery>(SamsaraVehicleStatsFeedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'samsaraVehicleStatsFeed', 'query', variables);
    },
    sendRouteToAgent(variables: SendRouteToAgentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendRouteToAgentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendRouteToAgentMutation>(SendRouteToAgentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendRouteToAgent', 'mutation', variables);
    },
    stopsBySearchText(variables: StopsBySearchTextQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopsBySearchTextQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopsBySearchTextQuery>(StopsBySearchTextDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopsBySearchText', 'query', variables);
    },
    stopsOnRoutesBySearchText(variables: StopsOnRoutesBySearchTextQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopsOnRoutesBySearchTextQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopsOnRoutesBySearchTextQuery>(StopsOnRoutesBySearchTextDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopsOnRoutesBySearchText', 'query', variables);
    },
    groupableDispatchTableFields(variables?: GroupableDispatchTableFieldsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GroupableDispatchTableFieldsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GroupableDispatchTableFieldsQuery>(GroupableDispatchTableFieldsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'groupableDispatchTableFields', 'query', variables);
    },
    stopQueryForOverrideMinutes(variables: StopQueryForOverrideMinutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopQueryForOverrideMinutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopQueryForOverrideMinutesQuery>(StopQueryForOverrideMinutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopQueryForOverrideMinutes', 'query', variables);
    },
    stopUuidsInGroup(variables?: StopUuidsInGroupQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopUuidsInGroupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopUuidsInGroupQuery>(StopUuidsInGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopUuidsInGroup', 'query', variables);
    },
    stops(variables?: StopsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopsQuery>(StopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stops', 'query', variables);
    },
    unassignedStopPins(variables?: UnassignedStopPinsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnassignedStopPinsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnassignedStopPinsQuery>(UnassignedStopPinsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unassignedStopPins', 'query', variables);
    },
    dispatchTextDriver(variables: DispatchTextDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchTextDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchTextDriverMutation>(DispatchTextDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchTextDriver', 'mutation', variables);
    },
    updateRouteDrivers(variables: UpdateRouteDriversMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRouteDriversMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRouteDriversMutation>(UpdateRouteDriversDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRouteDrivers', 'mutation', variables);
    },
    updateRouteSlots(variables: UpdateRouteSlotsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRouteSlotsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRouteSlotsMutation>(UpdateRouteSlotsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRouteSlots', 'mutation', variables);
    },
    DocumentationItem(variables: DocumentationItemQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentationItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentationItemQuery>(DocumentationItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DocumentationItem', 'query', variables);
    },
    DocumentationSearch(variables: DocumentationSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentationSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentationSearchQuery>(DocumentationSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DocumentationSearch', 'query', variables);
    },
    DocumentationTopics(variables?: DocumentationTopicsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentationTopicsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentationTopicsQuery>(DocumentationTopicsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DocumentationTopics', 'query', variables);
    },
    companyDocuments(variables: CompanyDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyDocumentsQuery>(CompanyDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyDocuments', 'query', variables);
    },
    companySchemas(variables?: CompanySchemasQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanySchemasQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanySchemasQuery>(CompanySchemasDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companySchemas', 'query', variables);
    },
    customDocumentNames(variables?: CustomDocumentNamesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomDocumentNamesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomDocumentNamesQuery>(CustomDocumentNamesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customDocumentNames', 'query', variables);
    },
    deleteCustomDocumentName(variables: DeleteCustomDocumentNameMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteCustomDocumentNameMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCustomDocumentNameMutation>(DeleteCustomDocumentNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCustomDocumentName', 'mutation', variables);
    },
    splitAndProcessOrderDocuments(variables: SplitAndProcessOrderDocumentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SplitAndProcessOrderDocumentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SplitAndProcessOrderDocumentsMutation>(SplitAndProcessOrderDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'splitAndProcessOrderDocuments', 'mutation', variables);
    },
    updateDocuments(variables: UpdateDocumentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDocumentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDocumentsMutation>(UpdateDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDocuments', 'mutation', variables);
    },
    createAdjustmentStopDriverMap(variables: CreateAdjustmentStopDriverMapMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAdjustmentStopDriverMapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAdjustmentStopDriverMapMutation>(CreateAdjustmentStopDriverMapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAdjustmentStopDriverMap', 'mutation', variables);
    },
    createDriverSettlementBill(variables: CreateDriverSettlementBillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDriverSettlementBillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDriverSettlementBillMutation>(CreateDriverSettlementBillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDriverSettlementBill', 'mutation', variables);
    },
    deleteStopDriverMap(variables: DeleteStopDriverMapMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteStopDriverMapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteStopDriverMapMutation>(DeleteStopDriverMapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteStopDriverMap', 'mutation', variables);
    },
    driverCompletedStopsLog(variables: DriverCompletedStopsLogQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverCompletedStopsLogQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverCompletedStopsLogQuery>(DriverCompletedStopsLogDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverCompletedStopsLog', 'query', variables);
    },
    driverSettlementBillByUuid(variables: DriverSettlementBillByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillByUuidQuery>(DriverSettlementBillByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillByUuid', 'query', variables);
    },
    driverSettlementBillsCount(variables?: DriverSettlementBillsCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillsCountQuery>(DriverSettlementBillsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillsCount', 'query', variables);
    },
    driverSettlementBillsForDownload(variables?: DriverSettlementBillsForDownloadQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillsForDownloadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillsForDownloadQuery>(DriverSettlementBillsForDownloadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillsForDownload', 'query', variables);
    },
    driverSettlementBillsV2(variables?: DriverSettlementBillsV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillsV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillsV2Query>(DriverSettlementBillsV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillsV2', 'query', variables);
    },
    driverSettlementBills(variables?: DriverSettlementBillsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillsQuery>(DriverSettlementBillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBills', 'query', variables);
    },
    finalizeDriverSettlementBills(variables?: FinalizeDriverSettlementBillsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinalizeDriverSettlementBillsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeDriverSettlementBillsMutation>(FinalizeDriverSettlementBillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeDriverSettlementBills', 'mutation', variables);
    },
    invoiceShipmentByStopUuid(variables: InvoiceShipmentByStopUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceShipmentByStopUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceShipmentByStopUuidQuery>(InvoiceShipmentByStopUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceShipmentByStopUuid', 'query', variables);
    },
    removeDriverSettlementBill(variables: RemoveDriverSettlementBillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveDriverSettlementBillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveDriverSettlementBillMutation>(RemoveDriverSettlementBillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeDriverSettlementBill', 'mutation', variables);
    },
    createSettlementDeduction(variables: CreateSettlementDeductionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSettlementDeductionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSettlementDeductionMutation>(CreateSettlementDeductionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSettlementDeduction', 'mutation', variables);
    },
    removeSettlementDeduction(variables: RemoveSettlementDeductionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSettlementDeductionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSettlementDeductionMutation>(RemoveSettlementDeductionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeSettlementDeduction', 'mutation', variables);
    },
    updateSettlementDeduction(variables: UpdateSettlementDeductionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSettlementDeductionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSettlementDeductionMutation>(UpdateSettlementDeductionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSettlementDeduction', 'mutation', variables);
    },
    stopDriverMapsSummary(variables: StopDriverMapsSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopDriverMapsSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopDriverMapsSummaryQuery>(StopDriverMapsSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopDriverMapsSummary', 'query', variables);
    },
    stopDriverMaps(variables?: StopDriverMapsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopDriverMapsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopDriverMapsQuery>(StopDriverMapsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopDriverMaps', 'query', variables);
    },
    updateDriverSettlementBill(variables: UpdateDriverSettlementBillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverSettlementBillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverSettlementBillMutation>(UpdateDriverSettlementBillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDriverSettlementBill', 'mutation', variables);
    },
    updateStopDriverMap(variables: UpdateStopDriverMapMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStopDriverMapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStopDriverMapMutation>(UpdateStopDriverMapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStopDriverMap', 'mutation', variables);
    },
    createCsvOrderMapping(variables: CreateCsvOrderMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCsvOrderMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCsvOrderMappingMutation>(CreateCsvOrderMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCsvOrderMapping', 'mutation', variables);
    },
    csvOrderMapping(variables: CsvOrderMappingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CsvOrderMappingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CsvOrderMappingQuery>(CsvOrderMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'csvOrderMapping', 'query', variables);
    },
    csvOrderMappingsForEmailTool(variables?: CsvOrderMappingsForEmailToolQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CsvOrderMappingsForEmailToolQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CsvOrderMappingsForEmailToolQuery>(CsvOrderMappingsForEmailToolDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'csvOrderMappingsForEmailTool', 'query', variables);
    },
    updateCsvOrderMapping(variables: UpdateCsvOrderMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCsvOrderMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCsvOrderMappingMutation>(UpdateCsvOrderMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCsvOrderMapping', 'mutation', variables);
    },
    createEndOfDayDocumentProcessingJob(variables: CreateEndOfDayDocumentProcessingJobMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateEndOfDayDocumentProcessingJobMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEndOfDayDocumentProcessingJobMutation>(CreateEndOfDayDocumentProcessingJobDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createEndOfDayDocumentProcessingJob', 'mutation', variables);
    },
    detachDocumentsFromShipments(variables: DetachDocumentsFromShipmentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DetachDocumentsFromShipmentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DetachDocumentsFromShipmentsMutation>(DetachDocumentsFromShipmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'detachDocumentsFromShipments', 'mutation', variables);
    },
    detachDocumentFromShipment(variables: DetachDocumentFromShipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DetachDocumentFromShipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DetachDocumentFromShipmentMutation>(DetachDocumentFromShipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'detachDocumentFromShipment', 'mutation', variables);
    },
    documentsByShipment(variables: DocumentsByShipmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentsByShipmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentsByShipmentQuery>(DocumentsByShipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentsByShipment', 'query', variables);
    },
    endOfDayDocumentProcessingJobs(variables: EndOfDayDocumentProcessingJobsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EndOfDayDocumentProcessingJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EndOfDayDocumentProcessingJobsQuery>(EndOfDayDocumentProcessingJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'endOfDayDocumentProcessingJobs', 'query', variables);
    },
    shallowRoutesWithDocuments(variables: ShallowRoutesWithDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowRoutesWithDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowRoutesWithDocumentsQuery>(ShallowRoutesWithDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowRoutesWithDocuments', 'query', variables);
    },
    equipment(variables: EquipmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EquipmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EquipmentQuery>(EquipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'equipment', 'query', variables);
    },
    equipments(variables?: EquipmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EquipmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EquipmentsQuery>(EquipmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'equipments', 'query', variables);
    },
    ExpeditorsApiStatus(variables?: ExpeditorsApiStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExpeditorsApiStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExpeditorsApiStatusQuery>(ExpeditorsApiStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ExpeditorsApiStatus', 'query', variables);
    },
    ForwarderBoard(variables: ForwarderBoardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ForwarderBoardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForwarderBoardQuery>(ForwarderBoardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ForwarderBoard', 'query', variables);
    },
    ForwarderScorecard(variables: ForwarderScorecardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ForwarderScorecardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ForwarderScorecardQuery>(ForwarderScorecardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ForwarderScorecard', 'query', variables);
    },
    fuelChargeFuelProfileDateRange(variables: FuelChargeFuelProfileDateRangeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FuelChargeFuelProfileDateRangeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FuelChargeFuelProfileDateRangeQuery>(FuelChargeFuelProfileDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fuelChargeFuelProfileDateRange', 'query', variables);
    },
    lineHaulFuelChargeFuelProfileDateRange(variables: LineHaulFuelChargeFuelProfileDateRangeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulFuelChargeFuelProfileDateRangeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulFuelChargeFuelProfileDateRangeQuery>(LineHaulFuelChargeFuelProfileDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulFuelChargeFuelProfileDateRange', 'query', variables);
    },
    CostCenterStatementReport(variables: CostCenterStatementReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CostCenterStatementReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CostCenterStatementReportQuery>(CostCenterStatementReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CostCenterStatementReport', 'query', variables);
    },
    CostInputCatalogue(variables?: CostInputCatalogueQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CostInputCatalogueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CostInputCatalogueQuery>(CostInputCatalogueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CostInputCatalogue', 'query', variables);
    },
    CostInputMonth(variables: CostInputMonthQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CostInputMonthQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CostInputMonthQuery>(CostInputMonthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CostInputMonth', 'query', variables);
    },
    CostInputQuickbooksAccounts(variables?: CostInputQuickbooksAccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CostInputQuickbooksAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CostInputQuickbooksAccountsQuery>(CostInputQuickbooksAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CostInputQuickbooksAccounts', 'query', variables);
    },
    CostInputStatus(variables?: CostInputStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CostInputStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CostInputStatusQuery>(CostInputStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CostInputStatus', 'query', variables);
    },
    SaveCostInputQuickbooksMappings(variables: SaveCostInputQuickbooksMappingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveCostInputQuickbooksMappingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveCostInputQuickbooksMappingsMutation>(SaveCostInputQuickbooksMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveCostInputQuickbooksMappings', 'mutation', variables);
    },
    SaveCostInputSetup(variables: SaveCostInputSetupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveCostInputSetupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveCostInputSetupMutation>(SaveCostInputSetupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveCostInputSetup', 'mutation', variables);
    },
    SaveCostInputs(variables: SaveCostInputsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveCostInputsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveCostInputsMutation>(SaveCostInputsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveCostInputs', 'mutation', variables);
    },
    CustomerProfitabilityReport(variables: CustomerProfitabilityReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerProfitabilityReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerProfitabilityReportQuery>(CustomerProfitabilityReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CustomerProfitabilityReport', 'query', variables);
    },
    DockProductivityReport(variables: DockProductivityReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DockProductivityReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DockProductivityReportQuery>(DockProductivityReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DockProductivityReport', 'query', variables);
    },
    DockTimeAllowances(variables?: DockTimeAllowancesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DockTimeAllowancesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DockTimeAllowancesQuery>(DockTimeAllowancesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DockTimeAllowances', 'query', variables);
    },
    UpsertDockTimeAllowances(variables: UpsertDockTimeAllowancesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertDockTimeAllowancesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertDockTimeAllowancesMutation>(UpsertDockTimeAllowancesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpsertDockTimeAllowances', 'mutation', variables);
    },
    DriverPlannerAssumptions(variables?: DriverPlannerAssumptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverPlannerAssumptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverPlannerAssumptionsQuery>(DriverPlannerAssumptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DriverPlannerAssumptions', 'query', variables);
    },
    DriverPlannerReport(variables: DriverPlannerReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverPlannerReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverPlannerReportQuery>(DriverPlannerReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DriverPlannerReport', 'query', variables);
    },
    UpsertDriverPlannerAssumptions(variables: UpsertDriverPlannerAssumptionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertDriverPlannerAssumptionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertDriverPlannerAssumptionsMutation>(UpsertDriverPlannerAssumptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpsertDriverPlannerAssumptions', 'mutation', variables);
    },
    LineHaulUtilizationAssumptions(variables?: LineHaulUtilizationAssumptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulUtilizationAssumptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulUtilizationAssumptionsQuery>(LineHaulUtilizationAssumptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LineHaulUtilizationAssumptions', 'query', variables);
    },
    LineHaulUtilizationReport(variables: LineHaulUtilizationReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulUtilizationReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulUtilizationReportQuery>(LineHaulUtilizationReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LineHaulUtilizationReport', 'query', variables);
    },
    UpsertLineHaulUtilizationAssumptions(variables: UpsertLineHaulUtilizationAssumptionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertLineHaulUtilizationAssumptionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertLineHaulUtilizationAssumptionsMutation>(UpsertLineHaulUtilizationAssumptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpsertLineHaulUtilizationAssumptions', 'mutation', variables);
    },
    OperationalEfficiencyReport(variables: OperationalEfficiencyReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OperationalEfficiencyReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OperationalEfficiencyReportQuery>(OperationalEfficiencyReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OperationalEfficiencyReport', 'query', variables);
    },
    PdProductivityReport(variables: PdProductivityReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PdProductivityReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PdProductivityReportQuery>(PdProductivityReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PdProductivityReport', 'query', variables);
    },
    ProductivityTimeAllowances(variables?: ProductivityTimeAllowancesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductivityTimeAllowancesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductivityTimeAllowancesQuery>(ProductivityTimeAllowancesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProductivityTimeAllowances', 'query', variables);
    },
    UpsertProductivityTimeAllowances(variables: UpsertProductivityTimeAllowancesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertProductivityTimeAllowancesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertProductivityTimeAllowancesMutation>(UpsertProductivityTimeAllowancesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpsertProductivityTimeAllowances', 'mutation', variables);
    },
    SamsaraDiscoveryCatalogue(variables?: SamsaraDiscoveryCatalogueQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraDiscoveryCatalogueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraDiscoveryCatalogueQuery>(SamsaraDiscoveryCatalogueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SamsaraDiscoveryCatalogue', 'query', variables);
    },
    SamsaraDiscoveryExport(variables: SamsaraDiscoveryExportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraDiscoveryExportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraDiscoveryExportQuery>(SamsaraDiscoveryExportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SamsaraDiscoveryExport', 'query', variables);
    },
    SamsaraDiscoveryMonthlyOverview(variables: SamsaraDiscoveryMonthlyOverviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraDiscoveryMonthlyOverviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraDiscoveryMonthlyOverviewQuery>(SamsaraDiscoveryMonthlyOverviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SamsaraDiscoveryMonthlyOverview', 'query', variables);
    },
    SamsaraDiscoveryRemoveToken(variables?: SamsaraDiscoveryRemoveTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraDiscoveryRemoveTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraDiscoveryRemoveTokenMutation>(SamsaraDiscoveryRemoveTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SamsaraDiscoveryRemoveToken', 'mutation', variables);
    },
    SamsaraDiscoveryRows(variables: SamsaraDiscoveryRowsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraDiscoveryRowsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraDiscoveryRowsQuery>(SamsaraDiscoveryRowsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SamsaraDiscoveryRows', 'query', variables);
    },
    SamsaraDiscoveryRunImport(variables?: SamsaraDiscoveryRunImportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraDiscoveryRunImportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraDiscoveryRunImportMutation>(SamsaraDiscoveryRunImportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SamsaraDiscoveryRunImport', 'mutation', variables);
    },
    SamsaraDiscoverySetToken(variables: SamsaraDiscoverySetTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraDiscoverySetTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraDiscoverySetTokenMutation>(SamsaraDiscoverySetTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SamsaraDiscoverySetToken', 'mutation', variables);
    },
    SamsaraDiscoveryStatus(variables?: SamsaraDiscoveryStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraDiscoveryStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraDiscoveryStatusQuery>(SamsaraDiscoveryStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SamsaraDiscoveryStatus', 'query', variables);
    },
    TerminalEfficiencyReport(variables: TerminalEfficiencyReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalEfficiencyReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalEfficiencyReportQuery>(TerminalEfficiencyReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TerminalEfficiencyReport', 'query', variables);
    },
    WeightBreakReport(variables: WeightBreakReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WeightBreakReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WeightBreakReportQuery>(WeightBreakReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'WeightBreakReport', 'query', variables);
    },
    deleteInventoryCount(variables: DeleteInventoryCountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteInventoryCountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteInventoryCountMutation>(DeleteInventoryCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteInventoryCount', 'mutation', variables);
    },
    inventoryCount(variables: InventoryCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InventoryCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InventoryCountQuery>(InventoryCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inventoryCount', 'query', variables);
    },
    inventoryCounts(variables: InventoryCountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InventoryCountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InventoryCountsQuery>(InventoryCountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inventoryCounts', 'query', variables);
    },
    createDwellTimeAlertConfig(variables: CreateDwellTimeAlertConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDwellTimeAlertConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDwellTimeAlertConfigMutation>(CreateDwellTimeAlertConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDwellTimeAlertConfig', 'mutation', variables);
    },
    deleteDwellTimeAlertConfig(variables: DeleteDwellTimeAlertConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteDwellTimeAlertConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDwellTimeAlertConfigMutation>(DeleteDwellTimeAlertConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteDwellTimeAlertConfig', 'mutation', variables);
    },
    dwellTimeAlertConfigs(variables?: DwellTimeAlertConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DwellTimeAlertConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DwellTimeAlertConfigsQuery>(DwellTimeAlertConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dwellTimeAlertConfigs', 'query', variables);
    },
    updateDwellTimeAlertConfig(variables: UpdateDwellTimeAlertConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDwellTimeAlertConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDwellTimeAlertConfigMutation>(UpdateDwellTimeAlertConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDwellTimeAlertConfig', 'mutation', variables);
    },
    ordersForPackingSlip(variables?: OrdersForPackingSlipQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForPackingSlipQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForPackingSlipQuery>(OrdersForPackingSlipDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForPackingSlip', 'query', variables);
    },
    picklists(variables: PicklistsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PicklistsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PicklistsQuery>(PicklistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'picklists', 'query', variables);
    },
    companyStatsQuery(variables?: CompanyStatsQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyStatsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyStatsQueryQuery>(CompanyStatsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyStatsQuery', 'query', variables);
    },
    consolidatableOrderSummary(variables: ConsolidatableOrderSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConsolidatableOrderSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsolidatableOrderSummaryQuery>(ConsolidatableOrderSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consolidatableOrderSummary', 'query', variables);
    },
    createConsolidatedOrderFromOrder(variables: CreateConsolidatedOrderFromOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateConsolidatedOrderFromOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateConsolidatedOrderFromOrderMutation>(CreateConsolidatedOrderFromOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createConsolidatedOrderFromOrder', 'mutation', variables);
    },
    createConsolidatedOrder(variables: CreateConsolidatedOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateConsolidatedOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateConsolidatedOrderMutation>(CreateConsolidatedOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createConsolidatedOrder', 'mutation', variables);
    },
    currentBillingPeriodInvoice(variables: CurrentBillingPeriodInvoiceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentBillingPeriodInvoiceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentBillingPeriodInvoiceQuery>(CurrentBillingPeriodInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentBillingPeriodInvoice', 'query', variables);
    },
    handleMultipleInvoices210Outbound(variables: HandleMultipleInvoices210OutboundMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HandleMultipleInvoices210OutboundMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<HandleMultipleInvoices210OutboundMutation>(HandleMultipleInvoices210OutboundDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'handleMultipleInvoices210Outbound', 'mutation', variables);
    },
    invoices(variables?: InvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesQuery>(InvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoices', 'query', variables);
    },
    markConsolidatableOrdersAsBilledIndividually(variables: MarkConsolidatableOrdersAsBilledIndividuallyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkConsolidatableOrdersAsBilledIndividuallyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkConsolidatableOrdersAsBilledIndividuallyMutation>(MarkConsolidatableOrdersAsBilledIndividuallyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markConsolidatableOrdersAsBilledIndividually', 'mutation', variables);
    },
    outstandingOrdersForReview(variables: OutstandingOrdersForReviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutstandingOrdersForReviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutstandingOrdersForReviewQuery>(OutstandingOrdersForReviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outstandingOrdersForReview', 'query', variables);
    },
    outstandingShipment(variables: OutstandingShipmentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutstandingShipmentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutstandingShipmentQuery>(OutstandingShipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outstandingShipment', 'query', variables);
    },
    shallowInvoices(variables?: ShallowInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowInvoicesQuery>(ShallowInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowInvoices', 'query', variables);
    },
    unconsolidateOrder(variables: UnconsolidateOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnconsolidateOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnconsolidateOrderMutation>(UnconsolidateOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unconsolidateOrder', 'mutation', variables);
    },
    updateOrderShipperBillOfLadingNumber(variables: UpdateOrderShipperBillOfLadingNumberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderShipperBillOfLadingNumberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderShipperBillOfLadingNumberMutation>(UpdateOrderShipperBillOfLadingNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderShipperBillOfLadingNumber', 'mutation', variables);
    },
    wmsContacts(variables?: WmsContactsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WmsContactsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WmsContactsQuery>(WmsContactsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'wmsContacts', 'query', variables);
    },
    createInvoice(variables: CreateInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvoiceMutation>(CreateInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvoice', 'mutation', variables);
    },
    finalizeInvoices(variables: FinalizeInvoicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinalizeInvoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeInvoicesMutation>(FinalizeInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeInvoices', 'mutation', variables);
    },
    documentsByInvoice(variables: DocumentsByInvoiceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentsByInvoiceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentsByInvoiceQuery>(DocumentsByInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentsByInvoice', 'query', variables);
    },
    invoice(variables: InvoiceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceQuery>(InvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoice', 'query', variables);
    },
    updateInvoiceLimited(variables: UpdateInvoiceLimitedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateInvoiceLimitedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvoiceLimitedMutation>(UpdateInvoiceLimitedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvoiceLimited', 'mutation', variables);
    },
    addOrdersToInvoices(variables: AddOrdersToInvoicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddOrdersToInvoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddOrdersToInvoicesMutation>(AddOrdersToInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addOrdersToInvoices', 'mutation', variables);
    },
    previewAddOrdersToInvoices(variables: PreviewAddOrdersToInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewAddOrdersToInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewAddOrdersToInvoicesQuery>(PreviewAddOrdersToInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewAddOrdersToInvoices', 'query', variables);
    },
    contactsForDunningQuery(variables: ContactsForDunningQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsForDunningQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsForDunningQueryQuery>(ContactsForDunningQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsForDunningQuery', 'query', variables);
    },
    dunningReportPdf(variables: DunningReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DunningReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DunningReportPdfQuery>(DunningReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dunningReportPdf', 'query', variables);
    },
    glCodeReportPdf(variables: GlCodeReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GlCodeReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GlCodeReportPdfQuery>(GlCodeReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'glCodeReportPdf', 'query', variables);
    },
    invoiceEdiTransactions(variables: InvoiceEdiTransactionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceEdiTransactionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceEdiTransactionsQuery>(InvoiceEdiTransactionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceEdiTransactions', 'query', variables);
    },
    invoiceEmailSendStatus(variables: InvoiceEmailSendStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceEmailSendStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceEmailSendStatusQuery>(InvoiceEmailSendStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceEmailSendStatus', 'query', variables);
    },
    invoiceRegisterReportCsv(variables: InvoiceRegisterReportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceRegisterReportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceRegisterReportCsvQuery>(InvoiceRegisterReportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceRegisterReportCsv', 'query', variables);
    },
    invoiceRegisterReportPdf(variables: InvoiceRegisterReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceRegisterReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceRegisterReportPdfQuery>(InvoiceRegisterReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceRegisterReportPdf', 'query', variables);
    },
    onTimePerformanceReportCsv(variables: OnTimePerformanceReportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OnTimePerformanceReportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnTimePerformanceReportCsvQuery>(OnTimePerformanceReportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'onTimePerformanceReportCsv', 'query', variables);
    },
    onTimePerformanceReportPdf(variables: OnTimePerformanceReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OnTimePerformanceReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnTimePerformanceReportPdfQuery>(OnTimePerformanceReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'onTimePerformanceReportPdf', 'query', variables);
    },
    sageBusinessWorksInvoiceExportCsv(variables: SageBusinessWorksInvoiceExportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SageBusinessWorksInvoiceExportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SageBusinessWorksInvoiceExportCsvQuery>(SageBusinessWorksInvoiceExportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sageBusinessWorksInvoiceExportCsv', 'query', variables);
    },
    invoiceShipmentWithChargesByUuid(variables: InvoiceShipmentWithChargesByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceShipmentWithChargesByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceShipmentWithChargesByUuidQuery>(InvoiceShipmentWithChargesByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceShipmentWithChargesByUuid', 'query', variables);
    },
    overdueInvoices(variables: OverdueInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OverdueInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OverdueInvoicesQuery>(OverdueInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'overdueInvoices', 'query', variables);
    },
    shipmentsByContactUuid(variables?: ShipmentsByContactUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShipmentsByContactUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShipmentsByContactUuidQuery>(ShipmentsByContactUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shipmentsByContactUuid', 'query', variables);
    },
    batchAddShipmentsToInvoicesMultiple(variables: BatchAddShipmentsToInvoicesMultipleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BatchAddShipmentsToInvoicesMultipleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BatchAddShipmentsToInvoicesMultipleMutation>(BatchAddShipmentsToInvoicesMultipleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'batchAddShipmentsToInvoicesMultiple', 'mutation', variables);
    },
    CheckConsistencyOfInvoices(variables: CheckConsistencyOfInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckConsistencyOfInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckConsistencyOfInvoicesQuery>(CheckConsistencyOfInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckConsistencyOfInvoices', 'query', variables);
    },
    createProratedConsolidatedOrder(variables: CreateProratedConsolidatedOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateProratedConsolidatedOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateProratedConsolidatedOrderMutation>(CreateProratedConsolidatedOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createProratedConsolidatedOrder', 'mutation', variables);
    },
    orderInConsolidationFlow(variables: OrderInConsolidationFlowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderInConsolidationFlowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderInConsolidationFlowQuery>(OrderInConsolidationFlowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderInConsolidationFlow', 'query', variables);
    },
    previewProratedConsolidationV2(variables: PreviewProratedConsolidationV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewProratedConsolidationV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewProratedConsolidationV2Query>(PreviewProratedConsolidationV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewProratedConsolidationV2', 'query', variables);
    },
    previewProratedConsolidation(variables: PreviewProratedConsolidationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewProratedConsolidationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewProratedConsolidationQuery>(PreviewProratedConsolidationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewProratedConsolidation', 'query', variables);
    },
    prorateOrders(variables: ProrateOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProrateOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProrateOrdersMutation>(ProrateOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'prorateOrders', 'mutation', variables);
    },
    typeaheadOrderUuidsQueryForConsolidationFlow(variables?: TypeaheadOrderUuidsQueryForConsolidationFlowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TypeaheadOrderUuidsQueryForConsolidationFlowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TypeaheadOrderUuidsQueryForConsolidationFlowQuery>(TypeaheadOrderUuidsQueryForConsolidationFlowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'typeaheadOrderUuidsQueryForConsolidationFlow', 'query', variables);
    },
    contactsForInvoices(variables?: ContactsForInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsForInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsForInvoicesQuery>(ContactsForInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsForInvoices', 'query', variables);
    },
    createContactDocument(variables: CreateContactDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateContactDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateContactDocumentMutation>(CreateContactDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createContactDocument', 'mutation', variables);
    },
    createInvoiceDocuments(variables: CreateInvoiceDocumentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateInvoiceDocumentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvoiceDocumentsMutation>(CreateInvoiceDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvoiceDocuments', 'mutation', variables);
    },
    downloadInvoices(variables: DownloadInvoicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadInvoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadInvoicesMutation>(DownloadInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'downloadInvoices', 'mutation', variables);
    },
    exportInvoicesToQuickbooksDesktop(variables: ExportInvoicesToQuickbooksDesktopMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExportInvoicesToQuickbooksDesktopMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExportInvoicesToQuickbooksDesktopMutation>(ExportInvoicesToQuickbooksDesktopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exportInvoicesToQuickbooksDesktop', 'mutation', variables);
    },
    generateInvoicePreSignedPutUrls(variables: GenerateInvoicePreSignedPutUrlsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateInvoicePreSignedPutUrlsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateInvoicePreSignedPutUrlsMutation>(GenerateInvoicePreSignedPutUrlsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateInvoicePreSignedPutUrls', 'mutation', variables);
    },
    invoiceExcelExportData(variables: InvoiceExcelExportDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceExcelExportDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceExcelExportDataQuery>(InvoiceExcelExportDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceExcelExportData', 'query', variables);
    },
    invoiceGroups(variables: InvoiceGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceGroupsQuery>(InvoiceGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceGroups', 'query', variables);
    },
    acknowledgeFailedInvoiceSendJobs(variables: AcknowledgeFailedInvoiceSendJobsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcknowledgeFailedInvoiceSendJobsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcknowledgeFailedInvoiceSendJobsMutation>(AcknowledgeFailedInvoiceSendJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acknowledgeFailedInvoiceSendJobs', 'mutation', variables);
    },
    invoiceSendJobBatches(variables: InvoiceSendJobBatchesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceSendJobBatchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceSendJobBatchesQuery>(InvoiceSendJobBatchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceSendJobBatches', 'query', variables);
    },
    invoiceSendJobsShallow(variables: InvoiceSendJobsShallowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceSendJobsShallowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceSendJobsShallowQuery>(InvoiceSendJobsShallowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceSendJobsShallow', 'query', variables);
    },
    invoiceSendJobs(variables: InvoiceSendJobsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceSendJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceSendJobsQuery>(InvoiceSendJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceSendJobs', 'query', variables);
    },
    invoiceStatsByUuids(variables: InvoiceStatsByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceStatsByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceStatsByUuidsQuery>(InvoiceStatsByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceStatsByUuids', 'query', variables);
    },
    invoiceTotal(variables: InvoiceTotalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceTotalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceTotalQuery>(InvoiceTotalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceTotal', 'query', variables);
    },
    invoiceTotals(variables: InvoiceTotalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceTotalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceTotalsQuery>(InvoiceTotalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceTotals', 'query', variables);
    },
    invoiceUuidsForBatchPost(variables?: InvoiceUuidsForBatchPostQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceUuidsForBatchPostQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceUuidsForBatchPostQuery>(InvoiceUuidsForBatchPostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceUuidsForBatchPost', 'query', variables);
    },
    invoiceV2(variables: InvoiceV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceV2Query>(InvoiceV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceV2', 'query', variables);
    },
    invoicesByUuidsForDownload(variables: InvoicesByUuidsForDownloadQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesByUuidsForDownloadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesByUuidsForDownloadQuery>(InvoicesByUuidsForDownloadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesByUuidsForDownload', 'query', variables);
    },
    invoicesByUuids(variables: InvoicesByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesByUuidsQuery>(InvoicesByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesByUuids', 'query', variables);
    },
    invoicesForContact(variables?: InvoicesForContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesForContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesForContactQuery>(InvoicesForContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesForContact', 'query', variables);
    },
    invoicesForInvoiceSelection(variables?: InvoicesForInvoiceSelectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesForInvoiceSelectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesForInvoiceSelectionQuery>(InvoicesForInvoiceSelectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesForInvoiceSelection', 'query', variables);
    },
    invoicesForRegisterReport(variables?: InvoicesForRegisterReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesForRegisterReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesForRegisterReportQuery>(InvoicesForRegisterReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesForRegisterReport', 'query', variables);
    },
    invoicesMetadataByUuids(variables: InvoicesMetadataByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesMetadataByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesMetadataByUuidsQuery>(InvoicesMetadataByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesMetadataByUuids', 'query', variables);
    },
    invoicesWithOrders(variables?: InvoicesWithOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesWithOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesWithOrdersQuery>(InvoicesWithOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesWithOrders', 'query', variables);
    },
    linehaulRevenueReport(variables: LinehaulRevenueReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LinehaulRevenueReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinehaulRevenueReportQuery>(LinehaulRevenueReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'linehaulRevenueReport', 'query', variables);
    },
    ManuallySetInvoicesQbSyncStatus(variables: ManuallySetInvoicesQbSyncStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ManuallySetInvoicesQbSyncStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ManuallySetInvoicesQbSyncStatusMutation>(ManuallySetInvoicesQbSyncStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ManuallySetInvoicesQbSyncStatus', 'mutation', variables);
    },
    moveShipmentsBetweenInvoices(variables: MoveShipmentsBetweenInvoicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MoveShipmentsBetweenInvoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoveShipmentsBetweenInvoicesMutation>(MoveShipmentsBetweenInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveShipmentsBetweenInvoices', 'mutation', variables);
    },
    moveShipmentsToInvoice(variables: MoveShipmentsToInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MoveShipmentsToInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MoveShipmentsToInvoiceMutation>(MoveShipmentsToInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'moveShipmentsToInvoice', 'mutation', variables);
    },
    netSalesSummaryReport(variables: NetSalesSummaryReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NetSalesSummaryReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NetSalesSummaryReportQuery>(NetSalesSummaryReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'netSalesSummaryReport', 'query', variables);
    },
    orderRefSearch(variables: OrderRefSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderRefSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderRefSearchQuery>(OrderRefSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderRefSearch', 'query', variables);
    },
    paginatedOrdersByInvoice(variables: PaginatedOrdersByInvoiceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaginatedOrdersByInvoiceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaginatedOrdersByInvoiceQuery>(PaginatedOrdersByInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paginatedOrdersByInvoice', 'query', variables);
    },
    allInvoicesForPaymentApplication(variables?: AllInvoicesForPaymentApplicationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AllInvoicesForPaymentApplicationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllInvoicesForPaymentApplicationQuery>(AllInvoicesForPaymentApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allInvoicesForPaymentApplication', 'query', variables);
    },
    applyDebitToPayment(variables: ApplyDebitToPaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplyDebitToPaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyDebitToPaymentMutation>(ApplyDebitToPaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applyDebitToPayment', 'mutation', variables);
    },
    averageDaysToPayReport(variables?: AverageDaysToPayReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AverageDaysToPayReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AverageDaysToPayReportQuery>(AverageDaysToPayReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'averageDaysToPayReport', 'query', variables);
    },
    contactBalancesByOrderUuid(variables: ContactBalancesByOrderUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactBalancesByOrderUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactBalancesByOrderUuidQuery>(ContactBalancesByOrderUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactBalancesByOrderUuid', 'query', variables);
    },
    contactBalances(variables: ContactBalancesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactBalancesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactBalancesQuery>(ContactBalancesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactBalances', 'query', variables);
    },
    createPayment(variables: CreatePaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePaymentMutation>(CreatePaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPayment', 'mutation', variables);
    },
    deletePayment(variables: DeletePaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeletePaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePaymentMutation>(DeletePaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePayment', 'mutation', variables);
    },
    orderAmountsToPayForHawb(variables: OrderAmountsToPayForHawbQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderAmountsToPayForHawbQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderAmountsToPayForHawbQuery>(OrderAmountsToPayForHawbDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderAmountsToPayForHawb', 'query', variables);
    },
    orderAmountsToPayForInvoice(variables: OrderAmountsToPayForInvoiceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderAmountsToPayForInvoiceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderAmountsToPayForInvoiceQuery>(OrderAmountsToPayForInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderAmountsToPayForInvoice', 'query', variables);
    },
    ordersByUuidsForPaymentStats(variables: OrdersByUuidsForPaymentStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersByUuidsForPaymentStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersByUuidsForPaymentStatsQuery>(OrdersByUuidsForPaymentStatsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersByUuidsForPaymentStats', 'query', variables);
    },
    ordersForPayments(variables?: OrdersForPaymentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForPaymentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForPaymentsQuery>(OrdersForPaymentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForPayments', 'query', variables);
    },
    outstandingInvoicesForCustomer(variables: OutstandingInvoicesForCustomerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutstandingInvoicesForCustomerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutstandingInvoicesForCustomerQuery>(OutstandingInvoicesForCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outstandingInvoicesForCustomer', 'query', variables);
    },
    paymentByUuid(variables: PaymentByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentByUuidQuery>(PaymentByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentByUuid', 'query', variables);
    },
    paymentCustomerScope(variables: PaymentCustomerScopeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentCustomerScopeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentCustomerScopeQuery>(PaymentCustomerScopeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentCustomerScope', 'query', variables);
    },
    paymentOffsetsForPayment(variables: PaymentOffsetsForPaymentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentOffsetsForPaymentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentOffsetsForPaymentQuery>(PaymentOffsetsForPaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentOffsetsForPayment', 'query', variables);
    },
    paymentRefSearch(variables: PaymentRefSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentRefSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentRefSearchQuery>(PaymentRefSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentRefSearch', 'query', variables);
    },
    paymentsByContactUuid(variables: PaymentsByContactUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentsByContactUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentsByContactUuidQuery>(PaymentsByContactUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentsByContactUuid', 'query', variables);
    },
    paymentsByInvoiceUuid(variables: PaymentsByInvoiceUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentsByInvoiceUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentsByInvoiceUuidQuery>(PaymentsByInvoiceUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentsByInvoiceUuid', 'query', variables);
    },
    paymentsForCheckRegisterReportOld(variables: PaymentsForCheckRegisterReportOldQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentsForCheckRegisterReportOldQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentsForCheckRegisterReportOldQuery>(PaymentsForCheckRegisterReportOldDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentsForCheckRegisterReportOld', 'query', variables);
    },
    paymentsForCheckRegisterReport(variables: PaymentsForCheckRegisterReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentsForCheckRegisterReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentsForCheckRegisterReportQuery>(PaymentsForCheckRegisterReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentsForCheckRegisterReport', 'query', variables);
    },
    removePaymentOffset(variables: RemovePaymentOffsetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemovePaymentOffsetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemovePaymentOffsetMutation>(RemovePaymentOffsetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removePaymentOffset', 'mutation', variables);
    },
    unappliedPaymentsForOffset(variables: UnappliedPaymentsForOffsetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnappliedPaymentsForOffsetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnappliedPaymentsForOffsetQuery>(UnappliedPaymentsForOffsetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unappliedPaymentsForOffset', 'query', variables);
    },
    updatePaymentOffset(variables: UpdatePaymentOffsetMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePaymentOffsetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePaymentOffsetMutation>(UpdatePaymentOffsetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePaymentOffset', 'mutation', variables);
    },
    updatePayment(variables: UpdatePaymentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePaymentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePaymentMutation>(UpdatePaymentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePayment', 'mutation', variables);
    },
    previewBatchAddShipmentsToInvoicesMultiple(variables: PreviewBatchAddShipmentsToInvoicesMultipleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PreviewBatchAddShipmentsToInvoicesMultipleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PreviewBatchAddShipmentsToInvoicesMultipleQuery>(PreviewBatchAddShipmentsToInvoicesMultipleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'previewBatchAddShipmentsToInvoicesMultiple', 'query', variables);
    },
    outstandingOrder(variables: OutstandingOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutstandingOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutstandingOrderQuery>(OutstandingOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outstandingOrder', 'query', variables);
    },
    addQuickbooksDesktopCustomers(variables: AddQuickbooksDesktopCustomersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddQuickbooksDesktopCustomersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddQuickbooksDesktopCustomersMutation>(AddQuickbooksDesktopCustomersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addQuickbooksDesktopCustomers', 'mutation', variables);
    },
    getInvoiceCsvs(variables: GetInvoiceCsvsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetInvoiceCsvsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetInvoiceCsvsQuery>(GetInvoiceCsvsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getInvoiceCsvs', 'query', variables);
    },
    invoicesByUuidsForQuickbooks(variables: InvoicesByUuidsForQuickbooksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesByUuidsForQuickbooksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesByUuidsForQuickbooksQuery>(InvoicesByUuidsForQuickbooksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesByUuidsForQuickbooks', 'query', variables);
    },
    PlanQuickbooksSync(variables: PlanQuickbooksSyncQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PlanQuickbooksSyncQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PlanQuickbooksSyncQuery>(PlanQuickbooksSyncDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PlanQuickbooksSync', 'query', variables);
    },
    SetAccessorialQboItemMapping(variables: SetAccessorialQboItemMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetAccessorialQboItemMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetAccessorialQboItemMappingMutation>(SetAccessorialQboItemMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetAccessorialQboItemMapping', 'mutation', variables);
    },
    completeRebill(variables: CompleteRebillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompleteRebillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteRebillMutation>(CompleteRebillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeRebill', 'mutation', variables);
    },
    createDuplicateOrderForRebill(variables: CreateDuplicateOrderForRebillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDuplicateOrderForRebillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDuplicateOrderForRebillMutation>(CreateDuplicateOrderForRebillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createDuplicateOrderForRebill', 'mutation', variables);
    },
    orderForRebill(variables: OrderForRebillQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderForRebillQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderForRebillQuery>(OrderForRebillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderForRebill', 'query', variables);
    },
    removeInvoice(variables: RemoveInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveInvoiceMutation>(RemoveInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeInvoice', 'mutation', variables);
    },
    removeShipmentsFromInvoice(variables: RemoveShipmentsFromInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveShipmentsFromInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveShipmentsFromInvoiceMutation>(RemoveShipmentsFromInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeShipmentsFromInvoice', 'mutation', variables);
    },
    accessorialChargeDetailsReport(variables: AccessorialChargeDetailsReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialChargeDetailsReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialChargeDetailsReportQuery>(AccessorialChargeDetailsReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialChargeDetailsReport', 'query', variables);
    },
    accountsReceivableReport(variables: AccountsReceivableReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccountsReceivableReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccountsReceivableReportQuery>(AccountsReceivableReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accountsReceivableReport', 'query', variables);
    },
    agingReportPdf(variables: AgingReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AgingReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AgingReportPdfQuery>(AgingReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'agingReportPdf', 'query', variables);
    },
    agingReport(variables: AgingReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AgingReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AgingReportQuery>(AgingReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'agingReport', 'query', variables);
    },
    chargeBreakdownReportCsv(variables?: ChargeBreakdownReportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChargeBreakdownReportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChargeBreakdownReportCsvQuery>(ChargeBreakdownReportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'chargeBreakdownReportCsv', 'query', variables);
    },
    chargeBreakdownReportPdf(variables?: ChargeBreakdownReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChargeBreakdownReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChargeBreakdownReportPdfQuery>(ChargeBreakdownReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'chargeBreakdownReportPdf', 'query', variables);
    },
    paymentForMemoReport(variables: PaymentForMemoReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentForMemoReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentForMemoReportQuery>(PaymentForMemoReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentForMemoReport', 'query', variables);
    },
    driverComplianceReportCsv(variables: DriverComplianceReportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverComplianceReportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverComplianceReportCsvQuery>(DriverComplianceReportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverComplianceReportCsv', 'query', variables);
    },
    driverComplianceReportPdf(variables: DriverComplianceReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverComplianceReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverComplianceReportPdfQuery>(DriverComplianceReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverComplianceReportPdf', 'query', variables);
    },
    driverDailyLogReportCsv(variables: DriverDailyLogReportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverDailyLogReportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverDailyLogReportCsvQuery>(DriverDailyLogReportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverDailyLogReportCsv', 'query', variables);
    },
    driverDailyLogReportPdf(variables: DriverDailyLogReportPdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverDailyLogReportPdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverDailyLogReportPdfQuery>(DriverDailyLogReportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverDailyLogReportPdf', 'query', variables);
    },
    emailAccountingReport(variables: EmailAccountingReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmailAccountingReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailAccountingReportMutation>(EmailAccountingReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'emailAccountingReport', 'mutation', variables);
    },
    incomeAnalysisReportV2(variables: IncomeAnalysisReportV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IncomeAnalysisReportV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<IncomeAnalysisReportV2Query>(IncomeAnalysisReportV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'incomeAnalysisReportV2', 'query', variables);
    },
    invoiceBillingSummaryReportV2PdfUrl(variables: InvoiceBillingSummaryReportV2PdfUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceBillingSummaryReportV2PdfUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceBillingSummaryReportV2PdfUrlQuery>(InvoiceBillingSummaryReportV2PdfUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceBillingSummaryReportV2PdfUrl', 'query', variables);
    },
    invoiceBillingSummaryReportV2Pdf(variables: InvoiceBillingSummaryReportV2PdfQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceBillingSummaryReportV2PdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceBillingSummaryReportV2PdfQuery>(InvoiceBillingSummaryReportV2PdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceBillingSummaryReportV2Pdf', 'query', variables);
    },
    invoiceBillingSummaryReportV2(variables: InvoiceBillingSummaryReportV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceBillingSummaryReportV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceBillingSummaryReportV2Query>(InvoiceBillingSummaryReportV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceBillingSummaryReportV2', 'query', variables);
    },
    openInvoiceReport(variables: OpenInvoiceReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OpenInvoiceReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OpenInvoiceReportQuery>(OpenInvoiceReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'openInvoiceReport', 'query', variables);
    },
    invoiceForOrderSummaryReport(variables: InvoiceForOrderSummaryReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceForOrderSummaryReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceForOrderSummaryReportQuery>(InvoiceForOrderSummaryReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceForOrderSummaryReport', 'query', variables);
    },
    invoicesForOrderSummaryReport(variables: InvoicesForOrderSummaryReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesForOrderSummaryReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesForOrderSummaryReportQuery>(InvoicesForOrderSummaryReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesForOrderSummaryReport', 'query', variables);
    },
    paymentApplicationReport(variables: PaymentApplicationReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentApplicationReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentApplicationReportQuery>(PaymentApplicationReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentApplicationReport', 'query', variables);
    },
    paymentsForJournalReport(variables: PaymentsForJournalReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentsForJournalReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentsForJournalReportQuery>(PaymentsForJournalReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentsForJournalReport', 'query', variables);
    },
    paymentJournalReport(variables: PaymentJournalReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentJournalReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentJournalReportQuery>(PaymentJournalReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentJournalReport', 'query', variables);
    },
    PostedVsActualReport(variables?: PostedVsActualReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PostedVsActualReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostedVsActualReportQuery>(PostedVsActualReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PostedVsActualReport', 'query', variables);
    },
    unappliedPaymentsReport(variables: UnappliedPaymentsReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnappliedPaymentsReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnappliedPaymentsReportQuery>(UnappliedPaymentsReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unappliedPaymentsReport', 'query', variables);
    },
    retryAllFailedInvoice210OutboundsForCompany(variables?: RetryAllFailedInvoice210OutboundsForCompanyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RetryAllFailedInvoice210OutboundsForCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RetryAllFailedInvoice210OutboundsForCompanyMutation>(RetryAllFailedInvoice210OutboundsForCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'retryAllFailedInvoice210OutboundsForCompany', 'mutation', variables);
    },
    retryFailedInvoice210Outbound(variables: RetryFailedInvoice210OutboundMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RetryFailedInvoice210OutboundMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RetryFailedInvoice210OutboundMutation>(RetryFailedInvoice210OutboundDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'retryFailedInvoice210Outbound', 'mutation', variables);
    },
    salesVarianceReportCsv(variables: SalesVarianceReportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SalesVarianceReportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SalesVarianceReportCsvQuery>(SalesVarianceReportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'salesVarianceReportCsv', 'query', variables);
    },
    sendInvoices(variables: SendInvoicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendInvoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendInvoicesMutation>(SendInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendInvoices', 'mutation', variables);
    },
    shallowInvoicesByUuids(variables: ShallowInvoicesByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowInvoicesByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowInvoicesByUuidsQuery>(ShallowInvoicesByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowInvoicesByUuids', 'query', variables);
    },
    invoiceUuids(variables?: InvoiceUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceUuidsQuery>(InvoiceUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceUuids', 'query', variables);
    },
    shallowInvoicesV2(variables?: ShallowInvoicesV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowInvoicesV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowInvoicesV2Query>(ShallowInvoicesV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowInvoicesV2', 'query', variables);
    },
    SyncInvoiceStatusWithQuickbooks(variables: SyncInvoiceStatusWithQuickbooksMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SyncInvoiceStatusWithQuickbooksMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncInvoiceStatusWithQuickbooksMutation>(SyncInvoiceStatusWithQuickbooksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SyncInvoiceStatusWithQuickbooks', 'mutation', variables);
    },
    SyncInvoicesToQuickbooks(variables: SyncInvoicesToQuickbooksMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SyncInvoicesToQuickbooksMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncInvoicesToQuickbooksMutation>(SyncInvoicesToQuickbooksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SyncInvoicesToQuickbooks', 'mutation', variables);
    },
    typeaheadOrderUuidsQuery(variables?: TypeaheadOrderUuidsQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TypeaheadOrderUuidsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TypeaheadOrderUuidsQueryQuery>(TypeaheadOrderUuidsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'typeaheadOrderUuidsQuery', 'query', variables);
    },
    orderRevenueReport(variables: OrderRevenueReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderRevenueReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderRevenueReportQuery>(OrderRevenueReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderRevenueReport', 'query', variables);
    },
    unpostInvoice(variables: UnpostInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnpostInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnpostInvoiceMutation>(UnpostInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unpostInvoice', 'mutation', variables);
    },
    UnpostInvoices(variables: UnpostInvoicesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnpostInvoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnpostInvoicesMutation>(UnpostInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnpostInvoices', 'mutation', variables);
    },
    createItem(variables: CreateItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateItemMutation>(CreateItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createItem', 'mutation', variables);
    },
    contactItems(variables: ContactItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactItemsQuery>(ContactItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactItems', 'query', variables);
    },
    itemInventorySummary(variables?: ItemInventorySummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ItemInventorySummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ItemInventorySummaryQuery>(ItemInventorySummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'itemInventorySummary', 'query', variables);
    },
    item(variables: ItemQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ItemQuery>(ItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'item', 'query', variables);
    },
    itemsBySkuName(variables: ItemsBySkuNameQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ItemsBySkuNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ItemsBySkuNameQuery>(ItemsBySkuNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'itemsBySkuName', 'query', variables);
    },
    shallowItems(variables: ShallowItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowItemsQuery>(ShallowItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowItems', 'query', variables);
    },
    updateItem(variables: UpdateItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateItemMutation>(UpdateItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateItem', 'mutation', variables);
    },
    generateLabel(variables: GenerateLabelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateLabelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateLabelMutation>(GenerateLabelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateLabel', 'mutation', variables);
    },
    DispatchApplySuggestedManifests(variables: DispatchApplySuggestedManifestsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchApplySuggestedManifestsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchApplySuggestedManifestsMutation>(DispatchApplySuggestedManifestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DispatchApplySuggestedManifests', 'mutation', variables);
    },
    dispatchManifestFreightCounts(variables: DispatchManifestFreightCountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchManifestFreightCountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchManifestFreightCountsQuery>(DispatchManifestFreightCountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dispatchManifestFreightCounts', 'query', variables);
    },
    GroupOrders(variables: GroupOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GroupOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GroupOrdersQuery>(GroupOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GroupOrders', 'query', variables);
    },
    DispatchManifestPackageStates(variables: DispatchManifestPackageStatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchManifestPackageStatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchManifestPackageStatesQuery>(DispatchManifestPackageStatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DispatchManifestPackageStates', 'query', variables);
    },
    DispatchManifestsInRange(variables: DispatchManifestsInRangeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchManifestsInRangeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchManifestsInRangeQuery>(DispatchManifestsInRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DispatchManifestsInRange', 'query', variables);
    },
    CalmOrderCubeByOrderUuids(variables: CalmOrderCubeByOrderUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmOrderCubeByOrderUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmOrderCubeByOrderUuidsQuery>(CalmOrderCubeByOrderUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmOrderCubeByOrderUuids', 'query', variables);
    },
    DispatchPlacedLegLoadedPieces(variables: DispatchPlacedLegLoadedPiecesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DispatchPlacedLegLoadedPiecesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DispatchPlacedLegLoadedPiecesQuery>(DispatchPlacedLegLoadedPiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DispatchPlacedLegLoadedPieces', 'query', variables);
    },
    CalmPreviewLineHaulReroutes(variables: CalmPreviewLineHaulReroutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmPreviewLineHaulReroutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmPreviewLineHaulReroutesQuery>(CalmPreviewLineHaulReroutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmPreviewLineHaulReroutes', 'query', variables);
    },
    calmRepointOrderFreight(variables: CalmRepointOrderFreightMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmRepointOrderFreightMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmRepointOrderFreightMutation>(CalmRepointOrderFreightDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'calmRepointOrderFreight', 'mutation', variables);
    },
    SetLineHaulManifestDepartTime(variables: SetLineHaulManifestDepartTimeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetLineHaulManifestDepartTimeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetLineHaulManifestDepartTimeMutation>(SetLineHaulManifestDepartTimeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetLineHaulManifestDepartTime', 'mutation', variables);
    },
    SetLineHaulManifestTrailers(variables: SetLineHaulManifestTrailersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetLineHaulManifestTrailersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetLineHaulManifestTrailersMutation>(SetLineHaulManifestTrailersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetLineHaulManifestTrailers', 'mutation', variables);
    },
    addOrdersToManifestV2(variables: AddOrdersToManifestV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddOrdersToManifestV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddOrdersToManifestV2Mutation>(AddOrdersToManifestV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addOrdersToManifestV2', 'mutation', variables);
    },
    addOrdersToManifest(variables: AddOrdersToManifestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddOrdersToManifestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddOrdersToManifestMutation>(AddOrdersToManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addOrdersToManifest', 'mutation', variables);
    },
    createLineHaulManifest(variables: CreateLineHaulManifestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateLineHaulManifestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateLineHaulManifestMutation>(CreateLineHaulManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createLineHaulManifest', 'mutation', variables);
    },
    createLineHaulManifests(variables: CreateLineHaulManifestsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateLineHaulManifestsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateLineHaulManifestsMutation>(CreateLineHaulManifestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createLineHaulManifests', 'mutation', variables);
    },
    getLineHaulProgress(variables: GetLineHaulProgressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetLineHaulProgressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLineHaulProgressQuery>(GetLineHaulProgressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLineHaulProgress', 'query', variables);
    },
    LineHaulManifestGroups(variables: LineHaulManifestGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulManifestGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulManifestGroupsQuery>(LineHaulManifestGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LineHaulManifestGroups', 'query', variables);
    },
    lineHaulManifest(variables: LineHaulManifestQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulManifestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulManifestQuery>(LineHaulManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulManifest', 'query', variables);
    },
    lineHaulManifestsForPrint(variables: LineHaulManifestsForPrintQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulManifestsForPrintQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulManifestsForPrintQuery>(LineHaulManifestsForPrintDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulManifestsForPrint', 'query', variables);
    },
    lineHaulManifests(variables: LineHaulManifestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulManifestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulManifestsQuery>(LineHaulManifestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulManifests', 'query', variables);
    },
    lineHaulOrdersWithUpcomingSegmentAndInboundStopStatus(variables: LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusQuery>(LineHaulOrdersWithUpcomingSegmentAndInboundStopStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulOrdersWithUpcomingSegmentAndInboundStopStatus', 'query', variables);
    },
    lineHaulSegments(variables?: LineHaulSegmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulSegmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulSegmentsQuery>(LineHaulSegmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulSegments', 'query', variables);
    },
    markManifestAsArrived(variables: MarkManifestAsArrivedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkManifestAsArrivedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkManifestAsArrivedMutation>(MarkManifestAsArrivedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markManifestAsArrived', 'mutation', variables);
    },
    markManifestAsDeparted(variables: MarkManifestAsDepartedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkManifestAsDepartedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkManifestAsDepartedMutation>(MarkManifestAsDepartedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markManifestAsDeparted', 'mutation', variables);
    },
    markManifestAsPlanning(variables: MarkManifestAsPlanningMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkManifestAsPlanningMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkManifestAsPlanningMutation>(MarkManifestAsPlanningDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markManifestAsPlanning', 'mutation', variables);
    },
    removeLineHaulManifest(variables: RemoveLineHaulManifestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveLineHaulManifestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveLineHaulManifestMutation>(RemoveLineHaulManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeLineHaulManifest', 'mutation', variables);
    },
    removeOrdersFromManifestV2(variables: RemoveOrdersFromManifestV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveOrdersFromManifestV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOrdersFromManifestV2Mutation>(RemoveOrdersFromManifestV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeOrdersFromManifestV2', 'mutation', variables);
    },
    removeOrdersFromManifest(variables: RemoveOrdersFromManifestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveOrdersFromManifestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOrdersFromManifestMutation>(RemoveOrdersFromManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeOrdersFromManifest', 'mutation', variables);
    },
    segmentedLineHaulOrdersV2(variables: SegmentedLineHaulOrdersV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SegmentedLineHaulOrdersV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<SegmentedLineHaulOrdersV2Query>(SegmentedLineHaulOrdersV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'segmentedLineHaulOrdersV2', 'query', variables);
    },
    segmentedLineHaulOrders(variables: SegmentedLineHaulOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SegmentedLineHaulOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SegmentedLineHaulOrdersQuery>(SegmentedLineHaulOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'segmentedLineHaulOrders', 'query', variables);
    },
    setLineHaulManifestLoadPosition(variables: SetLineHaulManifestLoadPositionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetLineHaulManifestLoadPositionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetLineHaulManifestLoadPositionMutation>(SetLineHaulManifestLoadPositionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setLineHaulManifestLoadPosition', 'mutation', variables);
    },
    setLineHaulManifestOrderLoadPosition(variables: SetLineHaulManifestOrderLoadPositionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetLineHaulManifestOrderLoadPositionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetLineHaulManifestOrderLoadPositionMutation>(SetLineHaulManifestOrderLoadPositionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setLineHaulManifestOrderLoadPosition', 'mutation', variables);
    },
    updateManifestDriver(variables: UpdateManifestDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateManifestDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateManifestDriverMutation>(UpdateManifestDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateManifestDriver', 'mutation', variables);
    },
    updateManifestVehicle(variables: UpdateManifestVehicleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateManifestVehicleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateManifestVehicleMutation>(UpdateManifestVehicleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateManifestVehicle', 'mutation', variables);
    },
    updateManifestsStatus(variables: UpdateManifestsStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateManifestsStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateManifestsStatusMutation>(UpdateManifestsStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateManifestsStatus', 'mutation', variables);
    },
    CalmAddStopToRoute(variables: CalmAddStopToRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmAddStopToRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmAddStopToRouteMutation>(CalmAddStopToRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmAddStopToRoute', 'mutation', variables);
    },
    CalmBuildRunManifests(variables: CalmBuildRunManifestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmBuildRunManifestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmBuildRunManifestsQuery>(CalmBuildRunManifestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmBuildRunManifests', 'query', variables);
    },
    CalmCrossdockInstructions(variables: CalmCrossdockInstructionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmCrossdockInstructionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmCrossdockInstructionsQuery>(CalmCrossdockInstructionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmCrossdockInstructions', 'query', variables);
    },
    CalmSetCrossdockInstruction(variables: CalmSetCrossdockInstructionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmSetCrossdockInstructionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmSetCrossdockInstructionMutation>(CalmSetCrossdockInstructionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmSetCrossdockInstruction', 'mutation', variables);
    },
    LineHaulDriverConflict(variables: LineHaulDriverConflictQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulDriverConflictQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulDriverConflictQuery>(LineHaulDriverConflictDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LineHaulDriverConflict', 'query', variables);
    },
    CalmManifestLoadPackages(variables: CalmManifestLoadPackagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmManifestLoadPackagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmManifestLoadPackagesQuery>(CalmManifestLoadPackagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmManifestLoadPackages', 'query', variables);
    },
    CalmManifestPlacements(variables: CalmManifestPlacementsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmManifestPlacementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmManifestPlacementsQuery>(CalmManifestPlacementsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmManifestPlacements', 'query', variables);
    },
    CalmSaveManifestPlacements(variables: CalmSaveManifestPlacementsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmSaveManifestPlacementsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmSaveManifestPlacementsMutation>(CalmSaveManifestPlacementsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmSaveManifestPlacements', 'mutation', variables);
    },
    CalmManifestsRange(variables?: CalmManifestsRangeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmManifestsRangeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmManifestsRangeQuery>(CalmManifestsRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmManifestsRange', 'query', variables);
    },
    CalmMoveOrderBetweenRuns(variables: CalmMoveOrderBetweenRunsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmMoveOrderBetweenRunsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmMoveOrderBetweenRunsMutation>(CalmMoveOrderBetweenRunsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmMoveOrderBetweenRuns', 'mutation', variables);
    },
    CalmOrderFinalMile(variables: CalmOrderFinalMileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmOrderFinalMileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmOrderFinalMileQuery>(CalmOrderFinalMileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmOrderFinalMile', 'query', variables);
    },
    CalmOrderPieces(variables: CalmOrderPiecesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmOrderPiecesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmOrderPiecesQuery>(CalmOrderPiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmOrderPieces', 'query', variables);
    },
    CalmOrderLineHaulRoute(variables: CalmOrderLineHaulRouteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmOrderLineHaulRouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmOrderLineHaulRouteQuery>(CalmOrderLineHaulRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmOrderLineHaulRoute', 'query', variables);
    },
    CalmOrderSplitSummary(variables: CalmOrderSplitSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmOrderSplitSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmOrderSplitSummaryQuery>(CalmOrderSplitSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmOrderSplitSummary', 'query', variables);
    },
    CalmOrderTags(variables: CalmOrderTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmOrderTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmOrderTagsQuery>(CalmOrderTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmOrderTags', 'query', variables);
    },
    CalmOrdersByHawb(variables: CalmOrdersByHawbQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmOrdersByHawbQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmOrdersByHawbQuery>(CalmOrdersByHawbDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmOrdersByHawb', 'query', variables);
    },
    CalmOrderPackages(variables: CalmOrderPackagesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmOrderPackagesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmOrderPackagesQuery>(CalmOrderPackagesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmOrderPackages', 'query', variables);
    },
    CalmManifestReadiness(variables: CalmManifestReadinessQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmManifestReadinessQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmManifestReadinessQuery>(CalmManifestReadinessDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmManifestReadiness', 'query', variables);
    },
    CalmManifestSearch(variables: CalmManifestSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmManifestSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmManifestSearchQuery>(CalmManifestSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmManifestSearch', 'query', variables);
    },
    CalmManifestReschedulables(variables: CalmManifestReschedulablesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmManifestReschedulablesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmManifestReschedulablesQuery>(CalmManifestReschedulablesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmManifestReschedulables', 'query', variables);
    },
    CalmAssignPackagesToManifest(variables: CalmAssignPackagesToManifestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmAssignPackagesToManifestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmAssignPackagesToManifestMutation>(CalmAssignPackagesToManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmAssignPackagesToManifest', 'mutation', variables);
    },
    CalmRemovePackagesFromManifest(variables: CalmRemovePackagesFromManifestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmRemovePackagesFromManifestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmRemovePackagesFromManifestMutation>(CalmRemovePackagesFromManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmRemovePackagesFromManifest', 'mutation', variables);
    },
    CalmLiveRuns(variables: CalmLiveRunsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmLiveRunsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmLiveRunsQuery>(CalmLiveRunsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmLiveRuns', 'query', variables);
    },
    CalmCommitDatesByOrderUuids(variables: CalmCommitDatesByOrderUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmCommitDatesByOrderUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmCommitDatesByOrderUuidsQuery>(CalmCommitDatesByOrderUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmCommitDatesByOrderUuids', 'query', variables);
    },
    CalmOrderPackagesByOrderUuids(variables: CalmOrderPackagesByOrderUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmOrderPackagesByOrderUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmOrderPackagesByOrderUuidsQuery>(CalmOrderPackagesByOrderUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmOrderPackagesByOrderUuids', 'query', variables);
    },
    CalmLineHaulOrdersToPlan(variables: CalmLineHaulOrdersToPlanQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmLineHaulOrdersToPlanQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmLineHaulOrdersToPlanQuery>(CalmLineHaulOrdersToPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmLineHaulOrdersToPlan', 'query', variables);
    },
    CalmLoadOrdersOnManifest(variables: CalmLoadOrdersOnManifestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmLoadOrdersOnManifestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmLoadOrdersOnManifestMutation>(CalmLoadOrdersOnManifestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmLoadOrdersOnManifest', 'mutation', variables);
    },
    CalmPndRouteLoad(variables: CalmPndRouteLoadQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmPndRouteLoadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmPndRouteLoadQuery>(CalmPndRouteLoadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmPndRouteLoad', 'query', variables);
    },
    CalmPreDispatchOrders(variables: CalmPreDispatchOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmPreDispatchOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmPreDispatchOrdersQuery>(CalmPreDispatchOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmPreDispatchOrders', 'query', variables);
    },
    LineHaulRunConfigs(variables: LineHaulRunConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulRunConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulRunConfigsQuery>(LineHaulRunConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LineHaulRunConfigs', 'query', variables);
    },
    CalmRunInboundPlan(variables: CalmRunInboundPlanQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmRunInboundPlanQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmRunInboundPlanQuery>(CalmRunInboundPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmRunInboundPlan', 'query', variables);
    },
    CalmRunOnwardPlan(variables: CalmRunOnwardPlanQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmRunOnwardPlanQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmRunOnwardPlanQuery>(CalmRunOnwardPlanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmRunOnwardPlan', 'query', variables);
    },
    LineHaulSegmentTimings(variables?: LineHaulSegmentTimingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulSegmentTimingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulSegmentTimingsQuery>(LineHaulSegmentTimingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LineHaulSegmentTimings', 'query', variables);
    },
    SetLineHaulSegmentTiming(variables: SetLineHaulSegmentTimingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetLineHaulSegmentTimingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetLineHaulSegmentTimingMutation>(SetLineHaulSegmentTimingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetLineHaulSegmentTiming', 'mutation', variables);
    },
    CalmSetPndRouteDriver(variables: CalmSetPndRouteDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmSetPndRouteDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmSetPndRouteDriverMutation>(CalmSetPndRouteDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmSetPndRouteDriver', 'mutation', variables);
    },
    RecurringTemplateTrucks(variables: RecurringTemplateTrucksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecurringTemplateTrucksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecurringTemplateTrucksQuery>(RecurringTemplateTrucksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecurringTemplateTrucks', 'query', variables);
    },
    CreateRecurringTemplateTruck(variables: CreateRecurringTemplateTruckMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRecurringTemplateTruckMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRecurringTemplateTruckMutation>(CreateRecurringTemplateTruckDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateRecurringTemplateTruck', 'mutation', variables);
    },
    UpdateRecurringTemplateTruck(variables: UpdateRecurringTemplateTruckMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRecurringTemplateTruckMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRecurringTemplateTruckMutation>(UpdateRecurringTemplateTruckDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateRecurringTemplateTruck', 'mutation', variables);
    },
    DeleteRecurringTemplateTruck(variables: DeleteRecurringTemplateTruckMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteRecurringTemplateTruckMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteRecurringTemplateTruckMutation>(DeleteRecurringTemplateTruckDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteRecurringTemplateTruck', 'mutation', variables);
    },
    CreateLineHaulTruckRuns(variables: CreateLineHaulTruckRunsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateLineHaulTruckRunsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateLineHaulTruckRunsMutation>(CreateLineHaulTruckRunsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateLineHaulTruckRuns', 'mutation', variables);
    },
    SetLineHaulManifestTruck(variables: SetLineHaulManifestTruckMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetLineHaulManifestTruckMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetLineHaulManifestTruckMutation>(SetLineHaulManifestTruckDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetLineHaulManifestTruck', 'mutation', variables);
    },
    GenerateLineHaulRuns(variables: GenerateLineHaulRunsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateLineHaulRunsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateLineHaulRunsMutation>(GenerateLineHaulRunsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GenerateLineHaulRuns', 'mutation', variables);
    },
    CalmTerminalLanes(variables?: CalmTerminalLanesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmTerminalLanesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmTerminalLanesQuery>(CalmTerminalLanesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmTerminalLanes', 'query', variables);
    },
    CalmAssignLineHaulRoute(variables: CalmAssignLineHaulRouteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmAssignLineHaulRouteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmAssignLineHaulRouteMutation>(CalmAssignLineHaulRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmAssignLineHaulRoute', 'mutation', variables);
    },
    CalmTerminalOnHand(variables: CalmTerminalOnHandQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmTerminalOnHandQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmTerminalOnHandQuery>(CalmTerminalOnHandDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmTerminalOnHand', 'query', variables);
    },
    CalmTerminalPnd(variables: CalmTerminalPndQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CalmTerminalPndQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CalmTerminalPndQuery>(CalmTerminalPndDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CalmTerminalPnd', 'query', variables);
    },
    LineHaulTrailerAssignments(variables: LineHaulTrailerAssignmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulTrailerAssignmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulTrailerAssignmentsQuery>(LineHaulTrailerAssignmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LineHaulTrailerAssignments', 'query', variables);
    },
    AssignOrderToLineHaulTrailer(variables: AssignOrderToLineHaulTrailerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AssignOrderToLineHaulTrailerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignOrderToLineHaulTrailerMutation>(AssignOrderToLineHaulTrailerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AssignOrderToLineHaulTrailer', 'mutation', variables);
    },
    UnassignOrderFromLineHaulTrailer(variables: UnassignOrderFromLineHaulTrailerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnassignOrderFromLineHaulTrailerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnassignOrderFromLineHaulTrailerMutation>(UnassignOrderFromLineHaulTrailerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnassignOrderFromLineHaulTrailer', 'mutation', variables);
    },
    DockDoorAssignments(variables: DockDoorAssignmentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DockDoorAssignmentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DockDoorAssignmentsQuery>(DockDoorAssignmentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DockDoorAssignments', 'query', variables);
    },
    AssignDockDoor(variables: AssignDockDoorMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AssignDockDoorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignDockDoorMutation>(AssignDockDoorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AssignDockDoor', 'mutation', variables);
    },
    DockDoors(variables: DockDoorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DockDoorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DockDoorsQuery>(DockDoorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DockDoors', 'query', variables);
    },
    SetDockDoors(variables: SetDockDoorsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetDockDoorsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetDockDoorsMutation>(SetDockDoorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetDockDoors', 'mutation', variables);
    },
    DockRunTimes(variables: DockRunTimesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DockRunTimesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DockRunTimesQuery>(DockRunTimesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DockRunTimes', 'query', variables);
    },
    CompanyDockDoors(variables?: CompanyDockDoorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyDockDoorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyDockDoorsQuery>(CompanyDockDoorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompanyDockDoors', 'query', variables);
    },
    LaneDefaultDoors(variables?: LaneDefaultDoorsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LaneDefaultDoorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LaneDefaultDoorsQuery>(LaneDefaultDoorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LaneDefaultDoors', 'query', variables);
    },
    SetLaneDefaultDoor(variables: SetLaneDefaultDoorMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetLaneDefaultDoorMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetLaneDefaultDoorMutation>(SetLaneDefaultDoorDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetLaneDefaultDoor', 'mutation', variables);
    },
    markManifestAsDoorsClosed(variables: MarkManifestAsDoorsClosedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkManifestAsDoorsClosedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkManifestAsDoorsClosedMutation>(MarkManifestAsDoorsClosedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markManifestAsDoorsClosed', 'mutation', variables);
    },
    accessorialGroups(variables?: AccessorialGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialGroupsQuery>(AccessorialGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialGroups', 'query', variables);
    },
    createAccessorialGroup(variables: CreateAccessorialGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAccessorialGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAccessorialGroupMutation>(CreateAccessorialGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAccessorialGroup', 'mutation', variables);
    },
    updateAccessorialGroup(variables: UpdateAccessorialGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAccessorialGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAccessorialGroupMutation>(UpdateAccessorialGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAccessorialGroup', 'mutation', variables);
    },
    deleteAccessorialGroup(variables: DeleteAccessorialGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteAccessorialGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAccessorialGroupMutation>(DeleteAccessorialGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAccessorialGroup', 'mutation', variables);
    },
    createRecurringLineHaulManifestTemplate(variables: CreateRecurringLineHaulManifestTemplateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRecurringLineHaulManifestTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRecurringLineHaulManifestTemplateMutation>(CreateRecurringLineHaulManifestTemplateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRecurringLineHaulManifestTemplate', 'mutation', variables);
    },
    deleteRecurringLineHaulManifestTemplate(variables: DeleteRecurringLineHaulManifestTemplateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteRecurringLineHaulManifestTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteRecurringLineHaulManifestTemplateMutation>(DeleteRecurringLineHaulManifestTemplateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteRecurringLineHaulManifestTemplate', 'mutation', variables);
    },
    recurringLineHaulManifestTemplates(variables?: RecurringLineHaulManifestTemplatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecurringLineHaulManifestTemplatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecurringLineHaulManifestTemplatesQuery>(RecurringLineHaulManifestTemplatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'recurringLineHaulManifestTemplates', 'query', variables);
    },
    updateRecurringLineHaulManifestTemplate(variables: UpdateRecurringLineHaulManifestTemplateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRecurringLineHaulManifestTemplateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRecurringLineHaulManifestTemplateMutation>(UpdateRecurringLineHaulManifestTemplateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRecurringLineHaulManifestTemplate', 'mutation', variables);
    },
    serviceGroups(variables?: ServiceGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceGroupsQuery>(ServiceGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceGroups', 'query', variables);
    },
    createServiceGroup(variables: CreateServiceGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateServiceGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateServiceGroupMutation>(CreateServiceGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createServiceGroup', 'mutation', variables);
    },
    updateServiceGroup(variables: UpdateServiceGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateServiceGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateServiceGroupMutation>(UpdateServiceGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateServiceGroup', 'mutation', variables);
    },
    deleteServiceGroup(variables: DeleteServiceGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteServiceGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteServiceGroupMutation>(DeleteServiceGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteServiceGroup', 'mutation', variables);
    },
    archiveTariffChain(variables: ArchiveTariffChainMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveTariffChainMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveTariffChainMutation>(ArchiveTariffChainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'archiveTariffChain', 'mutation', variables);
    },
    companyDefaultTariffChains(variables?: CompanyDefaultTariffChainsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyDefaultTariffChainsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyDefaultTariffChainsQuery>(CompanyDefaultTariffChainsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyDefaultTariffChains', 'query', variables);
    },
    createTariffChain(variables: CreateTariffChainMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTariffChainMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTariffChainMutation>(CreateTariffChainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTariffChain', 'mutation', variables);
    },
    restoreTariffChain(variables: RestoreTariffChainMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreTariffChainMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreTariffChainMutation>(RestoreTariffChainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'restoreTariffChain', 'mutation', variables);
    },
    tariffChainsWithGroups(variables: TariffChainsWithGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffChainsWithGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffChainsWithGroupsQuery>(TariffChainsWithGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffChainsWithGroups', 'query', variables);
    },
    updateDefaultTariffChainsForCompany(variables: UpdateDefaultTariffChainsForCompanyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDefaultTariffChainsForCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDefaultTariffChainsForCompanyMutation>(UpdateDefaultTariffChainsForCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDefaultTariffChainsForCompany', 'mutation', variables);
    },
    updateTariffChain(variables: UpdateTariffChainMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTariffChainMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTariffChainMutation>(UpdateTariffChainDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTariffChain', 'mutation', variables);
    },
    contactsWithTariffs(variables?: ContactsWithTariffsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsWithTariffsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsWithTariffsQuery>(ContactsWithTariffsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsWithTariffs', 'query', variables);
    },
    createTariffGroup(variables: CreateTariffGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTariffGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTariffGroupMutation>(CreateTariffGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTariffGroup', 'mutation', variables);
    },
    deleteTariffGroup(variables: DeleteTariffGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTariffGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTariffGroupMutation>(DeleteTariffGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTariffGroup', 'mutation', variables);
    },
    duplicateTariffGroup(variables: DuplicateTariffGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DuplicateTariffGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicateTariffGroupMutation>(DuplicateTariffGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'duplicateTariffGroup', 'mutation', variables);
    },
    findDefaultRecoveryTariffGroupForCompany(variables?: FindDefaultRecoveryTariffGroupForCompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindDefaultRecoveryTariffGroupForCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindDefaultRecoveryTariffGroupForCompanyQuery>(FindDefaultRecoveryTariffGroupForCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findDefaultRecoveryTariffGroupForCompany', 'query', variables);
    },
    findDefaultTariffGroupForCompany(variables?: FindDefaultTariffGroupForCompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindDefaultTariffGroupForCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindDefaultTariffGroupForCompanyQuery>(FindDefaultTariffGroupForCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findDefaultTariffGroupForCompany', 'query', variables);
    },
    findDefaultTransferTariffGroupForCompany(variables?: FindDefaultTransferTariffGroupForCompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindDefaultTransferTariffGroupForCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindDefaultTransferTariffGroupForCompanyQuery>(FindDefaultTransferTariffGroupForCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findDefaultTransferTariffGroupForCompany', 'query', variables);
    },
    findTariffGroupsWithContactAndServiceCombination(variables: FindTariffGroupsWithContactAndServiceCombinationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindTariffGroupsWithContactAndServiceCombinationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindTariffGroupsWithContactAndServiceCombinationQuery>(FindTariffGroupsWithContactAndServiceCombinationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findTariffGroupsWithContactAndServiceCombination', 'query', variables);
    },
    pointToPointLanes(variables: PointToPointLanesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PointToPointLanesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PointToPointLanesQuery>(PointToPointLanesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pointToPointLanes', 'query', variables);
    },
    savePointToPointLanes(variables: SavePointToPointLanesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SavePointToPointLanesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SavePointToPointLanesMutation>(SavePointToPointLanesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'savePointToPointLanes', 'mutation', variables);
    },
    tariffGroupEditorShell(variables: TariffGroupEditorShellQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffGroupEditorShellQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffGroupEditorShellQuery>(TariffGroupEditorShellDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffGroupEditorShell', 'query', variables);
    },
    tariffGroupTariffChains(variables: TariffGroupTariffChainsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffGroupTariffChainsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffGroupTariffChainsQuery>(TariffGroupTariffChainsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffGroupTariffChains', 'query', variables);
    },
    tariffGroup(variables: TariffGroupQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffGroupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffGroupQuery>(TariffGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffGroup', 'query', variables);
    },
    tariff(variables: TariffQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffQuery>(TariffDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariff', 'query', variables);
    },
    updateContactToServicesTariffGroupMappings(variables: UpdateContactToServicesTariffGroupMappingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateContactToServicesTariffGroupMappingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateContactToServicesTariffGroupMappingsMutation>(UpdateContactToServicesTariffGroupMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateContactToServicesTariffGroupMappings', 'mutation', variables);
    },
    updateTariffGroup(variables: UpdateTariffGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTariffGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTariffGroupMutation>(UpdateTariffGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTariffGroup', 'mutation', variables);
    },
    archiveTariffZoneGroup(variables: ArchiveTariffZoneGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveTariffZoneGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveTariffZoneGroupMutation>(ArchiveTariffZoneGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'archiveTariffZoneGroup', 'mutation', variables);
    },
    createTariffZoneGroup(variables: CreateTariffZoneGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTariffZoneGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTariffZoneGroupMutation>(CreateTariffZoneGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTariffZoneGroup', 'mutation', variables);
    },
    restoreTariffZoneGroup(variables: RestoreTariffZoneGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreTariffZoneGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreTariffZoneGroupMutation>(RestoreTariffZoneGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'restoreTariffZoneGroup', 'mutation', variables);
    },
    tariffZoneGroups(variables: TariffZoneGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffZoneGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffZoneGroupsQuery>(TariffZoneGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffZoneGroups', 'query', variables);
    },
    tariffZonesForGroup(variables: TariffZonesForGroupQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffZonesForGroupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffZonesForGroupQuery>(TariffZonesForGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffZonesForGroup', 'query', variables);
    },
    updateTariffZoneGroup(variables: UpdateTariffZoneGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTariffZoneGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTariffZoneGroupMutation>(UpdateTariffZoneGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTariffZoneGroup', 'mutation', variables);
    },
    accessorialDateRangeConfigByUuid(variables: AccessorialDateRangeConfigByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialDateRangeConfigByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialDateRangeConfigByUuidQuery>(AccessorialDateRangeConfigByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialDateRangeConfigByUuid', 'query', variables);
    },
    accessorialDateRangeConfigs(variables: AccessorialDateRangeConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialDateRangeConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialDateRangeConfigsQuery>(AccessorialDateRangeConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialDateRangeConfigs', 'query', variables);
    },
    createAccessorialDateRangeConfig(variables: CreateAccessorialDateRangeConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAccessorialDateRangeConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAccessorialDateRangeConfigMutation>(CreateAccessorialDateRangeConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAccessorialDateRangeConfig', 'mutation', variables);
    },
    deleteAccessorialDateRangeConfig(variables: DeleteAccessorialDateRangeConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteAccessorialDateRangeConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAccessorialDateRangeConfigMutation>(DeleteAccessorialDateRangeConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteAccessorialDateRangeConfig', 'mutation', variables);
    },
    updateAccessorialDateRangeConfig(variables: UpdateAccessorialDateRangeConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAccessorialDateRangeConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAccessorialDateRangeConfigMutation>(UpdateAccessorialDateRangeConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAccessorialDateRangeConfig', 'mutation', variables);
    },
    accessorialNamesByBillingContact(variables?: AccessorialNamesByBillingContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialNamesByBillingContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialNamesByBillingContactQuery>(AccessorialNamesByBillingContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialNamesByBillingContact', 'query', variables);
    },
    accessorialsByBillingContact(variables?: AccessorialsByBillingContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialsByBillingContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialsByBillingContactQuery>(AccessorialsByBillingContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialsByBillingContact', 'query', variables);
    },
    CreateAccessorial(variables: CreateAccessorialMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAccessorialMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAccessorialMutation>(CreateAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateAccessorial', 'mutation', variables);
    },
    RemoveAccessorial(variables: RemoveAccessorialMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveAccessorialMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveAccessorialMutation>(RemoveAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveAccessorial', 'mutation', variables);
    },
    accessorial(variables: AccessorialQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialQuery>(AccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorial', 'query', variables);
    },
    defaultGlobalSpecialAccessorials(variables?: DefaultGlobalSpecialAccessorialsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultGlobalSpecialAccessorialsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultGlobalSpecialAccessorialsQuery>(DefaultGlobalSpecialAccessorialsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'defaultGlobalSpecialAccessorials', 'query', variables);
    },
    accessorialNames(variables?: AccessorialNamesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialNamesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialNamesQuery>(AccessorialNamesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialNames', 'query', variables);
    },
    accessorialsTable(variables?: AccessorialsTableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialsTableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialsTableQuery>(AccessorialsTableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialsTable', 'query', variables);
    },
    accessorials(variables?: AccessorialsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialsQuery>(AccessorialsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorials', 'query', variables);
    },
    RemoveSpecialAccessorial(variables: RemoveSpecialAccessorialMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSpecialAccessorialMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSpecialAccessorialMutation>(RemoveSpecialAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveSpecialAccessorial', 'mutation', variables);
    },
    RemoveZoneBasedAccessorial(variables: RemoveZoneBasedAccessorialMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveZoneBasedAccessorialMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveZoneBasedAccessorialMutation>(RemoveZoneBasedAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveZoneBasedAccessorial', 'mutation', variables);
    },
    UpdateAccessorial(variables: UpdateAccessorialMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAccessorialMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAccessorialMutation>(UpdateAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateAccessorial', 'mutation', variables);
    },
    UpdateQuickAddAccessorials(variables: UpdateQuickAddAccessorialsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateQuickAddAccessorialsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateQuickAddAccessorialsMutation>(UpdateQuickAddAccessorialsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateQuickAddAccessorials', 'mutation', variables);
    },
    ArchiveRecoveryTerminal(variables: ArchiveRecoveryTerminalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveRecoveryTerminalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveRecoveryTerminalMutation>(ArchiveRecoveryTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveRecoveryTerminal', 'mutation', variables);
    },
    senderIsVerified(variables?: SenderIsVerifiedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SenderIsVerifiedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SenderIsVerifiedQuery>(SenderIsVerifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'senderIsVerified', 'query', variables);
    },
    createCreditType(variables: CreateCreditTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCreditTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCreditTypeMutation>(CreateCreditTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCreditType', 'mutation', variables);
    },
    creditTypes(variables?: CreditTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreditTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditTypesQuery>(CreditTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'creditTypes', 'query', variables);
    },
    removeCreditType(variables: RemoveCreditTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveCreditTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCreditTypeMutation>(RemoveCreditTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCreditType', 'mutation', variables);
    },
    updateCreditType(variables: UpdateCreditTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCreditTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCreditTypeMutation>(UpdateCreditTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCreditType', 'mutation', variables);
    },
    createGeneralLedgerCode(variables: CreateGeneralLedgerCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateGeneralLedgerCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateGeneralLedgerCodeMutation>(CreateGeneralLedgerCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createGeneralLedgerCode', 'mutation', variables);
    },
    deleteGeneralLedgerCode(variables: DeleteGeneralLedgerCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteGeneralLedgerCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteGeneralLedgerCodeMutation>(DeleteGeneralLedgerCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteGeneralLedgerCode', 'mutation', variables);
    },
    generalLedgerCodes(variables?: GeneralLedgerCodesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GeneralLedgerCodesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GeneralLedgerCodesQuery>(GeneralLedgerCodesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generalLedgerCodes', 'query', variables);
    },
    generalLedgerConfiguration(variables?: GeneralLedgerConfigurationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GeneralLedgerConfigurationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GeneralLedgerConfigurationQuery>(GeneralLedgerConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generalLedgerConfiguration', 'query', variables);
    },
    updateGeneralLedgerCode(variables: UpdateGeneralLedgerCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateGeneralLedgerCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGeneralLedgerCodeMutation>(UpdateGeneralLedgerCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateGeneralLedgerCode', 'mutation', variables);
    },
    updateGeneralLedgerConfiguration(variables: UpdateGeneralLedgerConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateGeneralLedgerConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateGeneralLedgerConfigurationMutation>(UpdateGeneralLedgerConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateGeneralLedgerConfiguration', 'mutation', variables);
    },
    createInvoiceNoteRule(variables: CreateInvoiceNoteRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateInvoiceNoteRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvoiceNoteRuleMutation>(CreateInvoiceNoteRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvoiceNoteRule', 'mutation', variables);
    },
    deleteInvoiceNoteRule(variables: DeleteInvoiceNoteRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteInvoiceNoteRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteInvoiceNoteRuleMutation>(DeleteInvoiceNoteRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteInvoiceNoteRule', 'mutation', variables);
    },
    invoiceNoteRules(variables?: InvoiceNoteRulesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceNoteRulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceNoteRulesQuery>(InvoiceNoteRulesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceNoteRules', 'query', variables);
    },
    updateInvoiceNoteRule(variables: UpdateInvoiceNoteRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateInvoiceNoteRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInvoiceNoteRuleMutation>(UpdateInvoiceNoteRuleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateInvoiceNoteRule', 'mutation', variables);
    },
    createMasterAccount(variables: CreateMasterAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateMasterAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateMasterAccountMutation>(CreateMasterAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createMasterAccount', 'mutation', variables);
    },
    masterAccounts(variables?: MasterAccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MasterAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MasterAccountsQuery>(MasterAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'masterAccounts', 'query', variables);
    },
    removeMasterAccount(variables: RemoveMasterAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveMasterAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveMasterAccountMutation>(RemoveMasterAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeMasterAccount', 'mutation', variables);
    },
    updateMasterAccount(variables: UpdateMasterAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateMasterAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateMasterAccountMutation>(UpdateMasterAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateMasterAccount', 'mutation', variables);
    },
    createSettlementDeductionType(variables: CreateSettlementDeductionTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSettlementDeductionTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSettlementDeductionTypeMutation>(CreateSettlementDeductionTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSettlementDeductionType', 'mutation', variables);
    },
    removeSettlementDeductionType(variables: RemoveSettlementDeductionTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSettlementDeductionTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSettlementDeductionTypeMutation>(RemoveSettlementDeductionTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeSettlementDeductionType', 'mutation', variables);
    },
    settlementDeductionTypes(variables?: SettlementDeductionTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SettlementDeductionTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SettlementDeductionTypesQuery>(SettlementDeductionTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'settlementDeductionTypes', 'query', variables);
    },
    updateSettlementDeductionType(variables: UpdateSettlementDeductionTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSettlementDeductionTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSettlementDeductionTypeMutation>(UpdateSettlementDeductionTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSettlementDeductionType', 'mutation', variables);
    },
    bulkUploadRouteNames(variables: BulkUploadRouteNamesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkUploadRouteNamesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUploadRouteNamesMutation>(BulkUploadRouteNamesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUploadRouteNames', 'mutation', variables);
    },
    businessDivisions(variables?: BusinessDivisionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BusinessDivisionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BusinessDivisionsQuery>(BusinessDivisionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'businessDivisions', 'query', variables);
    },
    createBusinessDivision(variables: CreateBusinessDivisionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateBusinessDivisionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateBusinessDivisionMutation>(CreateBusinessDivisionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createBusinessDivision', 'mutation', variables);
    },
    removeBusinessDivision(variables: RemoveBusinessDivisionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveBusinessDivisionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveBusinessDivisionMutation>(RemoveBusinessDivisionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeBusinessDivision', 'mutation', variables);
    },
    updateBusinessDivision(variables: UpdateBusinessDivisionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateBusinessDivisionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBusinessDivisionMutation>(UpdateBusinessDivisionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateBusinessDivision', 'mutation', variables);
    },
    company(variables?: CompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyQuery>(CompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'company', 'query', variables);
    },
    createCustomDriverForm(variables: CreateCustomDriverFormMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCustomDriverFormMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCustomDriverFormMutation>(CreateCustomDriverFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCustomDriverForm', 'mutation', variables);
    },
    CreateEquipment(variables: CreateEquipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateEquipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEquipmentMutation>(CreateEquipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateEquipment', 'mutation', variables);
    },
    createFuelProfile(variables: CreateFuelProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateFuelProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFuelProfileMutation>(CreateFuelProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFuelProfile', 'mutation', variables);
    },
    createService(variables: CreateServiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateServiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateServiceMutation>(CreateServiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createService', 'mutation', variables);
    },
    customDriverSignableForm(variables: CustomDriverSignableFormQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomDriverSignableFormQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomDriverSignableFormQuery>(CustomDriverSignableFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customDriverSignableForm', 'query', variables);
    },
    customDriverSignableForms(variables?: CustomDriverSignableFormsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomDriverSignableFormsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomDriverSignableFormsQuery>(CustomDriverSignableFormsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customDriverSignableForms', 'query', variables);
    },
    deleteCustomDriverForm(variables: DeleteCustomDriverFormMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteCustomDriverFormMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCustomDriverFormMutation>(DeleteCustomDriverFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCustomDriverForm', 'mutation', variables);
    },
    deleteEquipment(variables: DeleteEquipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteEquipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteEquipmentMutation>(DeleteEquipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteEquipment', 'mutation', variables);
    },
    deleteRouteNameLocation(variables: DeleteRouteNameLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteRouteNameLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteRouteNameLocationMutation>(DeleteRouteNameLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteRouteNameLocation', 'mutation', variables);
    },
    driversTable(variables?: DriversTableQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriversTableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriversTableQuery>(DriversTableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driversTable', 'query', variables);
    },
    ArchiveDriver(variables: ArchiveDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveDriverMutation>(ArchiveDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveDriver', 'mutation', variables);
    },
    ClearDriverSettlementPayBound(variables: ClearDriverSettlementPayBoundMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ClearDriverSettlementPayBoundMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClearDriverSettlementPayBoundMutation>(ClearDriverSettlementPayBoundDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ClearDriverSettlementPayBound', 'mutation', variables);
    },
    CreateDriverCredentialType(variables: CreateDriverCredentialTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDriverCredentialTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDriverCredentialTypeMutation>(CreateDriverCredentialTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateDriverCredentialType', 'mutation', variables);
    },
    CreateDriverInsurancePolicy(variables: CreateDriverInsurancePolicyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDriverInsurancePolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDriverInsurancePolicyMutation>(CreateDriverInsurancePolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateDriverInsurancePolicy', 'mutation', variables);
    },
    CreateDriverTrainingRecord(variables: CreateDriverTrainingRecordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDriverTrainingRecordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDriverTrainingRecordMutation>(CreateDriverTrainingRecordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateDriverTrainingRecord', 'mutation', variables);
    },
    CreateDriver(variables: CreateDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateDriverMutation>(CreateDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateDriver', 'mutation', variables);
    },
    DeleteDriverCredentialType(variables: DeleteDriverCredentialTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteDriverCredentialTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDriverCredentialTypeMutation>(DeleteDriverCredentialTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteDriverCredentialType', 'mutation', variables);
    },
    DeleteDriverInsurancePolicy(variables: DeleteDriverInsurancePolicyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteDriverInsurancePolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDriverInsurancePolicyMutation>(DeleteDriverInsurancePolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteDriverInsurancePolicy', 'mutation', variables);
    },
    DeleteDriverTrainingRecord(variables: DeleteDriverTrainingRecordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteDriverTrainingRecordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDriverTrainingRecordMutation>(DeleteDriverTrainingRecordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteDriverTrainingRecord', 'mutation', variables);
    },
    DriverCompliance(variables: DriverComplianceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverComplianceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverComplianceQuery>(DriverComplianceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DriverCompliance', 'query', variables);
    },
    DriverCredentialTypes(variables?: DriverCredentialTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverCredentialTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverCredentialTypesQuery>(DriverCredentialTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DriverCredentialTypes', 'query', variables);
    },
    driverPhoneNumberAvailability(variables: DriverPhoneNumberAvailabilityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverPhoneNumberAvailabilityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverPhoneNumberAvailabilityQuery>(DriverPhoneNumberAvailabilityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverPhoneNumberAvailability', 'query', variables);
    },
    DriverQualifications(variables?: DriverQualificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverQualificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverQualificationsQuery>(DriverQualificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DriverQualifications', 'query', variables);
    },
    DriverSettlementPayBounds(variables: DriverSettlementPayBoundsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementPayBoundsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementPayBoundsQuery>(DriverSettlementPayBoundsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DriverSettlementPayBounds', 'query', variables);
    },
    driver(variables: DriverQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverQuery>(DriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driver', 'query', variables);
    },
    RehireDriver(variables: RehireDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RehireDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RehireDriverMutation>(RehireDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RehireDriver', 'mutation', variables);
    },
    RestoreDriver(variables: RestoreDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreDriverMutation>(RestoreDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestoreDriver', 'mutation', variables);
    },
    SetDriverComplianceDates(variables: SetDriverComplianceDatesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetDriverComplianceDatesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetDriverComplianceDatesMutation>(SetDriverComplianceDatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetDriverComplianceDates', 'mutation', variables);
    },
    SetDriverSettlementPayBounds(variables: SetDriverSettlementPayBoundsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetDriverSettlementPayBoundsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetDriverSettlementPayBoundsMutation>(SetDriverSettlementPayBoundsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetDriverSettlementPayBounds', 'mutation', variables);
    },
    TerminateDriver(variables: TerminateDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminateDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminateDriverMutation>(TerminateDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TerminateDriver', 'mutation', variables);
    },
    UpdateDriverComplianceExpiringSoonDays(variables: UpdateDriverComplianceExpiringSoonDaysMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverComplianceExpiringSoonDaysMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverComplianceExpiringSoonDaysMutation>(UpdateDriverComplianceExpiringSoonDaysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDriverComplianceExpiringSoonDays', 'mutation', variables);
    },
    UpdateDriverComplianceProfile(variables: UpdateDriverComplianceProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverComplianceProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverComplianceProfileMutation>(UpdateDriverComplianceProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDriverComplianceProfile', 'mutation', variables);
    },
    UpdateDriverCredentialType(variables: UpdateDriverCredentialTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverCredentialTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverCredentialTypeMutation>(UpdateDriverCredentialTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDriverCredentialType', 'mutation', variables);
    },
    UpdateDriverInsurancePolicy(variables: UpdateDriverInsurancePolicyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverInsurancePolicyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverInsurancePolicyMutation>(UpdateDriverInsurancePolicyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDriverInsurancePolicy', 'mutation', variables);
    },
    UpdateDriverQualifications(variables: UpdateDriverQualificationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverQualificationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverQualificationsMutation>(UpdateDriverQualificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDriverQualifications', 'mutation', variables);
    },
    UpdateDriverTrainingRecord(variables: UpdateDriverTrainingRecordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverTrainingRecordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverTrainingRecordMutation>(UpdateDriverTrainingRecordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDriverTrainingRecord', 'mutation', variables);
    },
    VehicleType(variables: VehicleTypeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VehicleTypeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VehicleTypeQuery>(VehicleTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VehicleType', 'query', variables);
    },
    flipIsArchived(variables: FlipIsArchivedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FlipIsArchivedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FlipIsArchivedMutation>(FlipIsArchivedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'flipIsArchived', 'mutation', variables);
    },
    createFuelProfileDateRange(variables: CreateFuelProfileDateRangeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateFuelProfileDateRangeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateFuelProfileDateRangeMutation>(CreateFuelProfileDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createFuelProfileDateRange', 'mutation', variables);
    },
    deleteFuelProfileDateRange(variables: DeleteFuelProfileDateRangeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteFuelProfileDateRangeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteFuelProfileDateRangeMutation>(DeleteFuelProfileDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteFuelProfileDateRange', 'mutation', variables);
    },
    fuelProfile(variables: FuelProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FuelProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FuelProfileQuery>(FuelProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fuelProfile', 'query', variables);
    },
    fuelProfiles(variables?: FuelProfilesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FuelProfilesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FuelProfilesQuery>(FuelProfilesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fuelProfiles', 'query', variables);
    },
    removeFuelProfile(variables: RemoveFuelProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveFuelProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveFuelProfileMutation>(RemoveFuelProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeFuelProfile', 'mutation', variables);
    },
    updateFuelProfileDateRange(variables: UpdateFuelProfileDateRangeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateFuelProfileDateRangeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFuelProfileDateRangeMutation>(UpdateFuelProfileDateRangeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFuelProfileDateRange', 'mutation', variables);
    },
    updateFuelProfile(variables: UpdateFuelProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateFuelProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateFuelProfileMutation>(UpdateFuelProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateFuelProfile', 'mutation', variables);
    },
    createHoldReason(variables: CreateHoldReasonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateHoldReasonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateHoldReasonMutation>(CreateHoldReasonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createHoldReason', 'mutation', variables);
    },
    holdReasons(variables?: HoldReasonsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<HoldReasonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<HoldReasonsQuery>(HoldReasonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'holdReasons', 'query', variables);
    },
    updateHoldReason(variables: UpdateHoldReasonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateHoldReasonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateHoldReasonMutation>(UpdateHoldReasonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateHoldReason', 'mutation', variables);
    },
    createLineHaulLane(variables: CreateLineHaulLaneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateLineHaulLaneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateLineHaulLaneMutation>(CreateLineHaulLaneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createLineHaulLane', 'mutation', variables);
    },
    lineHaulLane(variables: LineHaulLaneQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulLaneQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulLaneQuery>(LineHaulLaneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulLane', 'query', variables);
    },
    lineHaulLanesForTerminals(variables?: LineHaulLanesForTerminalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulLanesForTerminalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulLanesForTerminalsQuery>(LineHaulLanesForTerminalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulLanesForTerminals', 'query', variables);
    },
    lineHaulLanes(variables?: LineHaulLanesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LineHaulLanesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LineHaulLanesQuery>(LineHaulLanesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lineHaulLanes', 'query', variables);
    },
    updateLineHaulLane(variables: UpdateLineHaulLaneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateLineHaulLaneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateLineHaulLaneMutation>(UpdateLineHaulLaneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateLineHaulLane', 'mutation', variables);
    },
    markOrderAsCancelled(variables: MarkOrderAsCancelledMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsCancelledMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsCancelledMutation>(MarkOrderAsCancelledDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsCancelled', 'mutation', variables);
    },
    markOrderAsOnHold(variables: MarkOrderAsOnHoldMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsOnHoldMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsOnHoldMutation>(MarkOrderAsOnHoldDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsOnHold', 'mutation', variables);
    },
    MinimalServiceRegions(variables: MinimalServiceRegionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MinimalServiceRegionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MinimalServiceRegionsQuery>(MinimalServiceRegionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MinimalServiceRegions', 'query', variables);
    },
    ArchivePackageSpec(variables: ArchivePackageSpecMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchivePackageSpecMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchivePackageSpecMutation>(ArchivePackageSpecDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchivePackageSpec', 'mutation', variables);
    },
    CreatePackageSpec(variables: CreatePackageSpecMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePackageSpecMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePackageSpecMutation>(CreatePackageSpecDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePackageSpec', 'mutation', variables);
    },
    PackageSpec(variables: PackageSpecQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PackageSpecQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackageSpecQuery>(PackageSpecDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PackageSpec', 'query', variables);
    },
    PackageSpecsMinimal(variables?: PackageSpecsMinimalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PackageSpecsMinimalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackageSpecsMinimalQuery>(PackageSpecsMinimalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PackageSpecsMinimal', 'query', variables);
    },
    RestorePackageSpec(variables: RestorePackageSpecMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestorePackageSpecMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestorePackageSpecMutation>(RestorePackageSpecDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestorePackageSpec', 'mutation', variables);
    },
    UpdatePackageSpec(variables: UpdatePackageSpecMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePackageSpecMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePackageSpecMutation>(UpdatePackageSpecDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePackageSpec', 'mutation', variables);
    },
    CompanyPackageTypeConfigs(variables?: CompanyPackageTypeConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyPackageTypeConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyPackageTypeConfigsQuery>(CompanyPackageTypeConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompanyPackageTypeConfigs', 'query', variables);
    },
    UpsertCompanyPackageTypeConfig(variables: UpsertCompanyPackageTypeConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertCompanyPackageTypeConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertCompanyPackageTypeConfigMutation>(UpsertCompanyPackageTypeConfigDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpsertCompanyPackageTypeConfig', 'mutation', variables);
    },
    RecoveryTerminals(variables?: RecoveryTerminalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecoveryTerminalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecoveryTerminalsQuery>(RecoveryTerminalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecoveryTerminals', 'query', variables);
    },
    CreateRecoveryTerminal(variables: CreateRecoveryTerminalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRecoveryTerminalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRecoveryTerminalMutation>(CreateRecoveryTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateRecoveryTerminal', 'mutation', variables);
    },
    UpdateRecoveryTerminal(variables: UpdateRecoveryTerminalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRecoveryTerminalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRecoveryTerminalMutation>(UpdateRecoveryTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateRecoveryTerminal', 'mutation', variables);
    },
    RestoreRecoveryTerminal(variables: RestoreRecoveryTerminalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreRecoveryTerminalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreRecoveryTerminalMutation>(RestoreRecoveryTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestoreRecoveryTerminal', 'mutation', variables);
    },
    routeAutomationSettings(variables?: RouteAutomationSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RouteAutomationSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RouteAutomationSettingsQuery>(RouteAutomationSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routeAutomationSettings', 'query', variables);
    },
    routeName(variables: RouteNameQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RouteNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RouteNameQuery>(RouteNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routeName', 'query', variables);
    },
    routeNames(variables?: RouteNamesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RouteNamesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RouteNamesQuery>(RouteNamesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'routeNames', 'query', variables);
    },
    servicesForThirdPartyUser(variables: ServicesForThirdPartyUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServicesForThirdPartyUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServicesForThirdPartyUserQuery>(ServicesForThirdPartyUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'servicesForThirdPartyUser', 'query', variables);
    },
    createTerminalLanes(variables: CreateTerminalLanesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTerminalLanesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTerminalLanesMutation>(CreateTerminalLanesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTerminalLanes', 'mutation', variables);
    },
    createTerminalServiceAreasV2(variables: CreateTerminalServiceAreasV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTerminalServiceAreasV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTerminalServiceAreasV2Mutation>(CreateTerminalServiceAreasV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTerminalServiceAreasV2', 'mutation', variables);
    },
    createTerminal(variables: CreateTerminalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTerminalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTerminalMutation>(CreateTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTerminal', 'mutation', variables);
    },
    deleteTerminalLanes(variables: DeleteTerminalLanesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTerminalLanesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTerminalLanesMutation>(DeleteTerminalLanesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTerminalLanes', 'mutation', variables);
    },
    removeTerminalServiceArea(variables: RemoveTerminalServiceAreaMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveTerminalServiceAreaMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveTerminalServiceAreaMutation>(RemoveTerminalServiceAreaDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeTerminalServiceArea', 'mutation', variables);
    },
    terminal(variables: TerminalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalQuery>(TerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminal', 'query', variables);
    },
    terminalsForThirdPartyUser(variables: TerminalsForThirdPartyUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalsForThirdPartyUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalsForThirdPartyUserQuery>(TerminalsForThirdPartyUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminalsForThirdPartyUser', 'query', variables);
    },
    terminals(variables?: TerminalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalsQuery>(TerminalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminals', 'query', variables);
    },
    updateTerminal(variables: UpdateTerminalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTerminalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTerminalMutation>(UpdateTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTerminal', 'mutation', variables);
    },
    createThirdPartyBroker(variables: CreateThirdPartyBrokerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateThirdPartyBrokerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateThirdPartyBrokerMutation>(CreateThirdPartyBrokerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createThirdPartyBroker', 'mutation', variables);
    },
    removeThirdPartyBroker(variables: RemoveThirdPartyBrokerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveThirdPartyBrokerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveThirdPartyBrokerMutation>(RemoveThirdPartyBrokerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeThirdPartyBroker', 'mutation', variables);
    },
    thirdPartyBrokers(variables?: ThirdPartyBrokersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ThirdPartyBrokersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThirdPartyBrokersQuery>(ThirdPartyBrokersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'thirdPartyBrokers', 'query', variables);
    },
    updateThirdPartyBroker(variables: UpdateThirdPartyBrokerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateThirdPartyBrokerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateThirdPartyBrokerMutation>(UpdateThirdPartyBrokerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateThirdPartyBroker', 'mutation', variables);
    },
    updateCustomDriverForm(variables: UpdateCustomDriverFormMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCustomDriverFormMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCustomDriverFormMutation>(UpdateCustomDriverFormDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCustomDriverForm', 'mutation', variables);
    },
    UpdateDriver(variables: UpdateDriverMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDriverMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDriverMutation>(UpdateDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateDriver', 'mutation', variables);
    },
    UpdateEquipment(variables: UpdateEquipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateEquipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEquipmentMutation>(UpdateEquipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateEquipment', 'mutation', variables);
    },
    updateService(variables: UpdateServiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateServiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateServiceMutation>(UpdateServiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateService', 'mutation', variables);
    },
    updateTemplateAndRecordAddresses(variables: UpdateTemplateAndRecordAddressesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTemplateAndRecordAddressesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTemplateAndRecordAddressesMutation>(UpdateTemplateAndRecordAddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTemplateAndRecordAddresses', 'mutation', variables);
    },
    upsertRouteAutomationSettings(variables: UpsertRouteAutomationSettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertRouteAutomationSettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertRouteAutomationSettingsMutation>(UpsertRouteAutomationSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertRouteAutomationSettings', 'mutation', variables);
    },
    CreateUserV2(variables: CreateUserV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateUserV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateUserV2Mutation>(CreateUserV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateUserV2', 'mutation', variables);
    },
    ReactivateUser(variables: ReactivateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReactivateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReactivateUserMutation>(ReactivateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReactivateUser', 'mutation', variables);
    },
    reportsEmailSenderIsVerified(variables: ReportsEmailSenderIsVerifiedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReportsEmailSenderIsVerifiedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportsEmailSenderIsVerifiedQuery>(ReportsEmailSenderIsVerifiedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reportsEmailSenderIsVerified', 'query', variables);
    },
    UpdateUser(variables: UpdateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMutation>(UpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUser', 'mutation', variables);
    },
    updateUserReportsEmail(variables: UpdateUserReportsEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserReportsEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserReportsEmailMutation>(UpdateUserReportsEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserReportsEmail', 'mutation', variables);
    },
    userOptions(variables?: UserOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserOptionsQuery>(UserOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userOptions', 'query', variables);
    },
    users(variables?: UsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UsersQuery>(UsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'users', 'query', variables);
    },
    ArchiveVehicleType(variables: ArchiveVehicleTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveVehicleTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveVehicleTypeMutation>(ArchiveVehicleTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveVehicleType', 'mutation', variables);
    },
    createVehicleType(variables: CreateVehicleTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateVehicleTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateVehicleTypeMutation>(CreateVehicleTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createVehicleType', 'mutation', variables);
    },
    RestoreVehicleType(variables: RestoreVehicleTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreVehicleTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreVehicleTypeMutation>(RestoreVehicleTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestoreVehicleType', 'mutation', variables);
    },
    updateVehicleType(variables: UpdateVehicleTypeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateVehicleTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateVehicleTypeMutation>(UpdateVehicleTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateVehicleType', 'mutation', variables);
    },
    VehicleTypesMinimal(variables?: VehicleTypesMinimalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VehicleTypesMinimalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VehicleTypesMinimalQuery>(VehicleTypesMinimalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VehicleTypesMinimal', 'query', variables);
    },
    archiveWarehouseEmployee(variables: ArchiveWarehouseEmployeeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveWarehouseEmployeeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveWarehouseEmployeeMutation>(ArchiveWarehouseEmployeeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'archiveWarehouseEmployee', 'mutation', variables);
    },
    restoreWarehouseEmployee(variables: RestoreWarehouseEmployeeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreWarehouseEmployeeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreWarehouseEmployeeMutation>(RestoreWarehouseEmployeeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'restoreWarehouseEmployee', 'mutation', variables);
    },
    createWarehouseEmployee(variables: CreateWarehouseEmployeeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateWarehouseEmployeeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWarehouseEmployeeMutation>(CreateWarehouseEmployeeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createWarehouseEmployee', 'mutation', variables);
    },
    warehouseEmployees(variables?: WarehouseEmployeesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WarehouseEmployeesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WarehouseEmployeesQuery>(WarehouseEmployeesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'warehouseEmployees', 'query', variables);
    },
    updateWarehouseEmployee(variables: UpdateWarehouseEmployeeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateWarehouseEmployeeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWarehouseEmployeeMutation>(UpdateWarehouseEmployeeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWarehouseEmployee', 'mutation', variables);
    },
    motiveIntegration(variables?: MotiveIntegrationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MotiveIntegrationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MotiveIntegrationQuery>(MotiveIntegrationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'motiveIntegration', 'query', variables);
    },
    removeMotiveApiKey(variables?: RemoveMotiveApiKeyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveMotiveApiKeyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveMotiveApiKeyMutation>(RemoveMotiveApiKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeMotiveApiKey', 'mutation', variables);
    },
    setMotiveApiKey(variables: SetMotiveApiKeyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetMotiveApiKeyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetMotiveApiKeyMutation>(SetMotiveApiKeyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setMotiveApiKey', 'mutation', variables);
    },
    acknowledgeNotification(variables: AcknowledgeNotificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcknowledgeNotificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcknowledgeNotificationMutation>(AcknowledgeNotificationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acknowledgeNotification', 'mutation', variables);
    },
    acknowledgeNotifications(variables: AcknowledgeNotificationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcknowledgeNotificationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcknowledgeNotificationsMutation>(AcknowledgeNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acknowledgeNotifications', 'mutation', variables);
    },
    inAppNotifications(variables?: InAppNotificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InAppNotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InAppNotificationsQuery>(InAppNotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inAppNotifications', 'query', variables);
    },
    markAllInAppNotificationsRead(variables?: MarkAllInAppNotificationsReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkAllInAppNotificationsReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkAllInAppNotificationsReadMutation>(MarkAllInAppNotificationsReadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markAllInAppNotificationsRead', 'mutation', variables);
    },
    markNotificationRead(variables: MarkNotificationReadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkNotificationReadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkNotificationReadMutation>(MarkNotificationReadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markNotificationRead', 'mutation', variables);
    },
    notifications(variables?: NotificationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NotificationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotificationsQuery>(NotificationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'notifications', 'query', variables);
    },
    unreadInAppNotificationsCount(variables?: UnreadInAppNotificationsCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnreadInAppNotificationsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnreadInAppNotificationsCountQuery>(UnreadInAppNotificationsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unreadInAppNotificationsCount', 'query', variables);
    },
    OperationsPerformanceReportCsv(variables: OperationsPerformanceReportCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OperationsPerformanceReportCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OperationsPerformanceReportCsvQuery>(OperationsPerformanceReportCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OperationsPerformanceReportCsv', 'query', variables);
    },
    OperationsPerformanceSummary(variables: OperationsPerformanceSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OperationsPerformanceSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OperationsPerformanceSummaryQuery>(OperationsPerformanceSummaryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OperationsPerformanceSummary', 'query', variables);
    },
    OperationsPerformanceReport(variables: OperationsPerformanceReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OperationsPerformanceReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OperationsPerformanceReportQuery>(OperationsPerformanceReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OperationsPerformanceReport', 'query', variables);
    },
    EdiTransactionPayloadByUuid(variables: EdiTransactionPayloadByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EdiTransactionPayloadByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EdiTransactionPayloadByUuidQuery>(EdiTransactionPayloadByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EdiTransactionPayloadByUuid', 'query', variables);
    },
    ExternalApiTransmissionPayloadByOrderEventUuid(variables: ExternalApiTransmissionPayloadByOrderEventUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExternalApiTransmissionPayloadByOrderEventUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExternalApiTransmissionPayloadByOrderEventUuidQuery>(ExternalApiTransmissionPayloadByOrderEventUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ExternalApiTransmissionPayloadByOrderEventUuid', 'query', variables);
    },
    orderAuditLogEntries(variables: OrderAuditLogEntriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderAuditLogEntriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderAuditLogEntriesQuery>(OrderAuditLogEntriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderAuditLogEntries', 'query', variables);
    },
    orderEventSnapshots(variables: OrderEventSnapshotsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderEventSnapshotsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderEventSnapshotsQuery>(OrderEventSnapshotsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderEventSnapshots', 'query', variables);
    },
    orderEvents(variables?: OrderEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderEventsQuery>(OrderEventsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderEvents', 'query', variables);
    },
    ResendExternalTransmission(variables: ResendExternalTransmissionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ResendExternalTransmissionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResendExternalTransmissionMutation>(ResendExternalTransmissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ResendExternalTransmission', 'mutation', variables);
    },
    bulkDelegateOrders(variables: BulkDelegateOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkDelegateOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkDelegateOrdersMutation>(BulkDelegateOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkDelegateOrders', 'mutation', variables);
    },
    bulkDelegationBatch(variables: BulkDelegationBatchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkDelegationBatchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkDelegationBatchQuery>(BulkDelegationBatchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkDelegationBatch', 'query', variables);
    },
    emailIngestionExclusions(variables?: EmailIngestionExclusionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmailIngestionExclusionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailIngestionExclusionsQuery>(EmailIngestionExclusionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'emailIngestionExclusions', 'query', variables);
    },
    emailProcessingHistory(variables: EmailProcessingHistoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmailProcessingHistoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailProcessingHistoryQuery>(EmailProcessingHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'emailProcessingHistory', 'query', variables);
    },
    ingestedEmailOrderByOrderUuid(variables: IngestedEmailOrderByOrderUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IngestedEmailOrderByOrderUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IngestedEmailOrderByOrderUuidQuery>(IngestedEmailOrderByOrderUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ingestedEmailOrderByOrderUuid', 'query', variables);
    },
    ingestedEmailOrders(variables?: IngestedEmailOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IngestedEmailOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IngestedEmailOrdersQuery>(IngestedEmailOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ingestedEmailOrders', 'query', variables);
    },
    ingestedOutlookEmail(variables: IngestedOutlookEmailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IngestedOutlookEmailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IngestedOutlookEmailQuery>(IngestedOutlookEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ingestedOutlookEmail', 'query', variables);
    },
    outlookIntegrations(variables?: OutlookIntegrationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutlookIntegrationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutlookIntegrationsQuery>(OutlookIntegrationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outlookIntegrations', 'query', variables);
    },
    updateEmailIngestionExclusions(variables: UpdateEmailIngestionExclusionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateEmailIngestionExclusionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEmailIngestionExclusionsMutation>(UpdateEmailIngestionExclusionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateEmailIngestionExclusions', 'mutation', variables);
    },
    acceptCustomerPortalOrder(variables: AcceptCustomerPortalOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcceptCustomerPortalOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptCustomerPortalOrderMutation>(AcceptCustomerPortalOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acceptCustomerPortalOrder', 'mutation', variables);
    },
    rejectCustomerPortalOrder(variables: RejectCustomerPortalOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RejectCustomerPortalOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectCustomerPortalOrderMutation>(RejectCustomerPortalOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectCustomerPortalOrder', 'mutation', variables);
    },
    acceptEdiOrApiOrder(variables: AcceptEdiOrApiOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcceptEdiOrApiOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptEdiOrApiOrderMutation>(AcceptEdiOrApiOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acceptEdiOrApiOrder', 'mutation', variables);
    },
    acceptExpeditorsWorkOrder(variables: AcceptExpeditorsWorkOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcceptExpeditorsWorkOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcceptExpeditorsWorkOrderMutation>(AcceptExpeditorsWorkOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acceptExpeditorsWorkOrder', 'mutation', variables);
    },
    rejectEdiOrder(variables: RejectEdiOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RejectEdiOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectEdiOrderMutation>(RejectEdiOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectEdiOrder', 'mutation', variables);
    },
    rejectEdiOrders(variables: RejectEdiOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RejectEdiOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectEdiOrdersMutation>(RejectEdiOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectEdiOrders', 'mutation', variables);
    },
    rejectExpeditorsWorkOrder(variables: RejectExpeditorsWorkOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RejectExpeditorsWorkOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectExpeditorsWorkOrderMutation>(RejectExpeditorsWorkOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectExpeditorsWorkOrder', 'mutation', variables);
    },
    acknowledgeQuoteAttention(variables: AcknowledgeQuoteAttentionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AcknowledgeQuoteAttentionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcknowledgeQuoteAttentionMutation>(AcknowledgeQuoteAttentionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'acknowledgeQuoteAttention', 'mutation', variables);
    },
    approveQuoteReply(variables: ApproveQuoteReplyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApproveQuoteReplyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApproveQuoteReplyMutation>(ApproveQuoteReplyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'approveQuoteReply', 'mutation', variables);
    },
    confirmQuoteAcceptance(variables: ConfirmQuoteAcceptanceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConfirmQuoteAcceptanceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfirmQuoteAcceptanceMutation>(ConfirmQuoteAcceptanceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'confirmQuoteAcceptance', 'mutation', variables);
    },
    declineQuote(variables: DeclineQuoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeclineQuoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeclineQuoteMutation>(DeclineQuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'declineQuote', 'mutation', variables);
    },
    dismissQuote(variables: DismissQuoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DismissQuoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DismissQuoteMutation>(DismissQuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dismissQuote', 'mutation', variables);
    },
    markQuoteSent(variables: MarkQuoteSentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkQuoteSentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkQuoteSentMutation>(MarkQuoteSentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markQuoteSent', 'mutation', variables);
    },
    orderQuoteForOrder(variables: OrderQuoteForOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderQuoteForOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderQuoteForOrderQuery>(OrderQuoteForOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderQuoteForOrder', 'query', variables);
    },
    orderQuotesNeedingActionCount(variables?: OrderQuotesNeedingActionCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderQuotesNeedingActionCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderQuotesNeedingActionCountQuery>(OrderQuotesNeedingActionCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderQuotesNeedingActionCount', 'query', variables);
    },
    pickQuoteCustomer(variables: PickQuoteCustomerMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PickQuoteCustomerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PickQuoteCustomerMutation>(PickQuoteCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pickQuoteCustomer', 'mutation', variables);
    },
    quoteConversation(variables: QuoteConversationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteConversationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteConversationQuery>(QuoteConversationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quoteConversation', 'query', variables);
    },
    rejectQuoteReply(variables: RejectQuoteReplyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RejectQuoteReplyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RejectQuoteReplyMutation>(RejectQuoteReplyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rejectQuoteReply', 'mutation', variables);
    },
    requestQuoteReprice(variables: RequestQuoteRepriceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RequestQuoteRepriceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequestQuoteRepriceMutation>(RequestQuoteRepriceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'requestQuoteReprice', 'mutation', variables);
    },
    requoteQuoteAtCurrentPrice(variables: RequoteQuoteAtCurrentPriceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RequoteQuoteAtCurrentPriceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RequoteQuoteAtCurrentPriceMutation>(RequoteQuoteAtCurrentPriceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'requoteQuoteAtCurrentPrice', 'mutation', variables);
    },
    resolveQuoteReplySend(variables: ResolveQuoteReplySendMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ResolveQuoteReplySendMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResolveQuoteReplySendMutation>(ResolveQuoteReplySendDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'resolveQuoteReplySend', 'mutation', variables);
    },
    accessorialForCustomChargeRow(variables: AccessorialForCustomChargeRowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialForCustomChargeRowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialForCustomChargeRowQuery>(AccessorialForCustomChargeRowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialForCustomChargeRow', 'query', variables);
    },
    accessorialsForCustomChargeRow(variables: AccessorialsForCustomChargeRowQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialsForCustomChargeRowQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialsForCustomChargeRowQuery>(AccessorialsForCustomChargeRowDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialsForCustomChargeRow', 'query', variables);
    },
    applyDelegationAccessorialProposal(variables: ApplyDelegationAccessorialProposalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplyDelegationAccessorialProposalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplyDelegationAccessorialProposalMutation>(ApplyDelegationAccessorialProposalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applyDelegationAccessorialProposal', 'mutation', variables);
    },
    delegationAccessorialProposals(variables: DelegationAccessorialProposalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DelegationAccessorialProposalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DelegationAccessorialProposalsQuery>(DelegationAccessorialProposalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'delegationAccessorialProposals', 'query', variables);
    },
    dismissDelegationAccessorialProposal(variables: DismissDelegationAccessorialProposalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DismissDelegationAccessorialProposalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DismissDelegationAccessorialProposalMutation>(DismissDelegationAccessorialProposalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dismissDelegationAccessorialProposal', 'mutation', variables);
    },
    piecesGroupedByStatus(variables: PiecesGroupedByStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PiecesGroupedByStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PiecesGroupedByStatusQuery>(PiecesGroupedByStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'piecesGroupedByStatus', 'query', variables);
    },
    sendStopToAgent(variables: SendStopToAgentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendStopToAgentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendStopToAgentMutation>(SendStopToAgentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendStopToAgent', 'mutation', variables);
    },
    updatePieceCount(variables: UpdatePieceCountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePieceCountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePieceCountMutation>(UpdatePieceCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePieceCount', 'mutation', variables);
    },
    VehicleTypeCapacity(variables: VehicleTypeCapacityQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VehicleTypeCapacityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VehicleTypeCapacityQuery>(VehicleTypeCapacityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VehicleTypeCapacity', 'query', variables);
    },
    unifiedSearchOrders(variables: UnifiedSearchOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnifiedSearchOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnifiedSearchOrdersQuery>(UnifiedSearchOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unifiedSearchOrders', 'query', variables);
    },
    unifiedSearchUnacceptedEmailOrders(variables: UnifiedSearchUnacceptedEmailOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnifiedSearchUnacceptedEmailOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnifiedSearchUnacceptedEmailOrdersQuery>(UnifiedSearchUnacceptedEmailOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unifiedSearchUnacceptedEmailOrders', 'query', variables);
    },
    unifiedSearchUnacceptedEdiAndApiOrders(variables: UnifiedSearchUnacceptedEdiAndApiOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnifiedSearchUnacceptedEdiAndApiOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnifiedSearchUnacceptedEdiAndApiOrdersQuery>(UnifiedSearchUnacceptedEdiAndApiOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unifiedSearchUnacceptedEdiAndApiOrders', 'query', variables);
    },
    unifiedSearchQuotes(variables: UnifiedSearchQuotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnifiedSearchQuotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnifiedSearchQuotesQuery>(UnifiedSearchQuotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unifiedSearchQuotes', 'query', variables);
    },
    unifiedSearchInvoices(variables: UnifiedSearchInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnifiedSearchInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnifiedSearchInvoicesQuery>(UnifiedSearchInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unifiedSearchInvoices', 'query', variables);
    },
    createInvoiceDocument(variables: CreateInvoiceDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateInvoiceDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateInvoiceDocumentMutation>(CreateInvoiceDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createInvoiceDocument', 'mutation', variables);
    },
    createOrderDocument(variables: CreateOrderDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderDocumentMutation>(CreateOrderDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderDocument', 'mutation', variables);
    },
    apiLogs(variables: ApiLogsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApiLogsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApiLogsQuery>(ApiLogsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'apiLogs', 'query', variables);
    },
    matchFreightSnap(variables: MatchFreightSnapMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MatchFreightSnapMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatchFreightSnapMutation>(MatchFreightSnapDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchFreightSnap', 'mutation', variables);
    },
    ordersForArrivalNotices(variables: OrdersForArrivalNoticesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForArrivalNoticesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForArrivalNoticesQuery>(OrdersForArrivalNoticesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForArrivalNotices', 'query', variables);
    },
    arriveAtStops(variables: ArriveAtStopsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArriveAtStopsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArriveAtStopsMutation>(ArriveAtStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'arriveAtStops', 'mutation', variables);
    },
    attemptStopsForDriverSettlement(variables: AttemptStopsForDriverSettlementQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AttemptStopsForDriverSettlementQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AttemptStopsForDriverSettlementQuery>(AttemptStopsForDriverSettlementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'attemptStopsForDriverSettlement', 'query', variables);
    },
    bulkEditOrders(variables: BulkEditOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkEditOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkEditOrdersMutation>(BulkEditOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkEditOrders', 'mutation', variables);
    },
    clearOrderExecutedBy(variables: ClearOrderExecutedByMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ClearOrderExecutedByMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClearOrderExecutedByMutation>(ClearOrderExecutedByDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'clearOrderExecutedBy', 'mutation', variables);
    },
    coverSheetDocumentTypeSequences(variables?: CoverSheetDocumentTypeSequencesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CoverSheetDocumentTypeSequencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CoverSheetDocumentTypeSequencesQuery>(CoverSheetDocumentTypeSequencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'coverSheetDocumentTypeSequences', 'query', variables);
    },
    createCoverSheetDocumentTypeSequence(variables: CreateCoverSheetDocumentTypeSequenceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCoverSheetDocumentTypeSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCoverSheetDocumentTypeSequenceMutation>(CreateCoverSheetDocumentTypeSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCoverSheetDocumentTypeSequence', 'mutation', variables);
    },
    orderCoverSheets(variables?: OrderCoverSheetsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderCoverSheetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderCoverSheetsQuery>(OrderCoverSheetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderCoverSheets', 'query', variables);
    },
    orderInfosForCoverSheets(variables: OrderInfosForCoverSheetsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderInfosForCoverSheetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderInfosForCoverSheetsQuery>(OrderInfosForCoverSheetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderInfosForCoverSheets', 'query', variables);
    },
    ordersForCoverSheets(variables: OrdersForCoverSheetsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForCoverSheetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForCoverSheetsQuery>(OrdersForCoverSheetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForCoverSheets', 'query', variables);
    },
    removeCoverSheetDocumentTypeSequence(variables: RemoveCoverSheetDocumentTypeSequenceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveCoverSheetDocumentTypeSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveCoverSheetDocumentTypeSequenceMutation>(RemoveCoverSheetDocumentTypeSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeCoverSheetDocumentTypeSequence', 'mutation', variables);
    },
    updateCoverSheetDocumentTypeSequence(variables: UpdateCoverSheetDocumentTypeSequenceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCoverSheetDocumentTypeSequenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCoverSheetDocumentTypeSequenceMutation>(UpdateCoverSheetDocumentTypeSequenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCoverSheetDocumentTypeSequence', 'mutation', variables);
    },
    createAccountingReportDocument(variables: CreateAccountingReportDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAccountingReportDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAccountingReportDocumentMutation>(CreateAccountingReportDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAccountingReportDocument', 'mutation', variables);
    },
    createEODDocuments(variables: CreateEodDocumentsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateEodDocumentsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateEodDocumentsMutation>(CreateEodDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createEODDocuments', 'mutation', variables);
    },
    createOrderComment(variables: CreateOrderCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderCommentMutation>(CreateOrderCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderComment', 'mutation', variables);
    },
    createOrderDocumentDocument(variables: CreateOrderDocumentDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderDocumentDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderDocumentDocumentMutation>(CreateOrderDocumentDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderDocumentDocument', 'mutation', variables);
    },
    createOrderSnapshot(variables: CreateOrderSnapshotMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderSnapshotMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderSnapshotMutation>(CreateOrderSnapshotDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderSnapshot', 'mutation', variables);
    },
    createOrdersFromRecurringTemplates(variables: CreateOrdersFromRecurringTemplatesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrdersFromRecurringTemplatesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrdersFromRecurringTemplatesMutation>(CreateOrdersFromRecurringTemplatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrdersFromRecurringTemplates', 'mutation', variables);
    },
    createPODReportDocument(variables: CreatePodReportDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePodReportDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePodReportDocumentMutation>(CreatePodReportDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPODReportDocument', 'mutation', variables);
    },
    createRecurringRun(variables: CreateRecurringRunMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRecurringRunMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRecurringRunMutation>(CreateRecurringRunDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRecurringRun', 'mutation', variables);
    },
    createScannedOrders(variables: CreateScannedOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateScannedOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateScannedOrdersMutation>(CreateScannedOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createScannedOrders', 'mutation', variables);
    },
    matchSignedPODs(variables: MatchSignedPoDsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MatchSignedPoDsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatchSignedPoDsMutation>(MatchSignedPoDsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matchSignedPODs', 'mutation', variables);
    },
    createStandardOrder(variables: CreateStandardOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateStandardOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateStandardOrderMutation>(CreateStandardOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createStandardOrder', 'mutation', variables);
    },
    createStandardOrderWithDuplicateResolution(variables: CreateStandardOrderWithDuplicateResolutionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateStandardOrderWithDuplicateResolutionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateStandardOrderWithDuplicateResolutionMutation>(CreateStandardOrderWithDuplicateResolutionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createStandardOrderWithDuplicateResolution', 'mutation', variables);
    },
    createTag(variables: CreateTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTagMutation>(CreateTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTag', 'mutation', variables);
    },
    createOrUpdateCsvOrders(variables: CreateOrUpdateCsvOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrUpdateCsvOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrUpdateCsvOrdersMutation>(CreateOrUpdateCsvOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrUpdateCsvOrders', 'mutation', variables);
    },
    csvOrderMappings(variables?: CsvOrderMappingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CsvOrderMappingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CsvOrderMappingsQuery>(CsvOrderMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'csvOrderMappings', 'query', variables);
    },
    generateCsvOrderPreSignedPutUrls(variables: GenerateCsvOrderPreSignedPutUrlsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateCsvOrderPreSignedPutUrlsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateCsvOrderPreSignedPutUrlsQuery>(GenerateCsvOrderPreSignedPutUrlsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateCsvOrderPreSignedPutUrls', 'query', variables);
    },
    parseCsvOrders(variables: ParseCsvOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ParseCsvOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ParseCsvOrdersMutation>(ParseCsvOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'parseCsvOrders', 'mutation', variables);
    },
    currentOrderStatus(variables: CurrentOrderStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CurrentOrderStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CurrentOrderStatusQuery>(CurrentOrderStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'currentOrderStatus', 'query', variables);
    },
    DelegationEndCustomerMatch(variables: DelegationEndCustomerMatchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DelegationEndCustomerMatchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DelegationEndCustomerMatchQuery>(DelegationEndCustomerMatchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DelegationEndCustomerMatch', 'query', variables);
    },
    deleteOrder(variables: DeleteOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOrderMutation>(DeleteOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOrder', 'mutation', variables);
    },
    DocumentExtractionStatus(variables?: DocumentExtractionStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentExtractionStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentExtractionStatusQuery>(DocumentExtractionStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DocumentExtractionStatus', 'query', variables);
    },
    documentsByOrder(variables: DocumentsByOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentsByOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentsByOrderQuery>(DocumentsByOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentsByOrder', 'query', variables);
    },
    duplicateMergeCandidates(variables: DuplicateMergeCandidatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DuplicateMergeCandidatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DuplicateMergeCandidatesQuery>(DuplicateMergeCandidatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'duplicateMergeCandidates', 'query', variables);
    },
    ediAndApiOrdersForReview(variables?: EdiAndApiOrdersForReviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EdiAndApiOrdersForReviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EdiAndApiOrdersForReviewQuery>(EdiAndApiOrdersForReviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ediAndApiOrdersForReview', 'query', variables);
    },
    ediTransactions(variables?: EdiTransactionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EdiTransactionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EdiTransactionsQuery>(EdiTransactionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ediTransactions', 'query', variables);
    },
    orderEdiReferences(variables: OrderEdiReferencesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderEdiReferencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderEdiReferencesQuery>(OrderEdiReferencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderEdiReferences', 'query', variables);
    },
    orderForEdiReviewByUuid(variables: OrderForEdiReviewByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderForEdiReviewByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderForEdiReviewByUuidQuery>(OrderForEdiReviewByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderForEdiReviewByUuid', 'query', variables);
    },
    emailOrderDocument(variables: EmailOrderDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmailOrderDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailOrderDocumentMutation>(EmailOrderDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'emailOrderDocument', 'mutation', variables);
    },
    fetchMissingAccessorial(variables: FetchMissingAccessorialQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FetchMissingAccessorialQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FetchMissingAccessorialQuery>(FetchMissingAccessorialDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchMissingAccessorial', 'query', variables);
    },
    finalizeOrder(variables: FinalizeOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinalizeOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeOrderMutation>(FinalizeOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeOrder', 'mutation', variables);
    },
    finalizeOrders(variables: FinalizeOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinalizeOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeOrdersMutation>(FinalizeOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeOrders', 'mutation', variables);
    },
    findAvailablePieces(variables: FindAvailablePiecesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindAvailablePiecesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindAvailablePiecesQuery>(FindAvailablePiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findAvailablePieces', 'query', variables);
    },
    terminalForAddress(variables: TerminalForAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalForAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalForAddressQuery>(TerminalForAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminalForAddress', 'query', variables);
    },
    terminalsForAddress(variables: TerminalsForAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalsForAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalsForAddressQuery>(TerminalsForAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminalsForAddress', 'query', variables);
    },
    generateAccountingReportPreSignedPutUrl(variables: GenerateAccountingReportPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateAccountingReportPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateAccountingReportPreSignedPutUrlMutation>(GenerateAccountingReportPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateAccountingReportPreSignedPutUrl', 'mutation', variables);
    },
    generateOrderDocumentPreSignedPutUrl(variables: GenerateOrderDocumentPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateOrderDocumentPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateOrderDocumentPreSignedPutUrlMutation>(GenerateOrderDocumentPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateOrderDocumentPreSignedPutUrl', 'mutation', variables);
    },
    generateOrderPreSignedGetAndPutUrls(variables: GenerateOrderPreSignedGetAndPutUrlsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateOrderPreSignedGetAndPutUrlsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateOrderPreSignedGetAndPutUrlsMutation>(GenerateOrderPreSignedGetAndPutUrlsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateOrderPreSignedGetAndPutUrls', 'mutation', variables);
    },
    generatePodReportPreSignedPutUrl(variables: GeneratePodReportPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GeneratePodReportPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GeneratePodReportPreSignedPutUrlMutation>(GeneratePodReportPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generatePodReportPreSignedPutUrl', 'mutation', variables);
    },
    generateContactPreSignedPutUrl(variables: GenerateContactPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateContactPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateContactPreSignedPutUrlMutation>(GenerateContactPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateContactPreSignedPutUrl', 'mutation', variables);
    },
    generateInvoicePreSignedPutUrl(variables: GenerateInvoicePreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateInvoicePreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateInvoicePreSignedPutUrlMutation>(GenerateInvoicePreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateInvoicePreSignedPutUrl', 'mutation', variables);
    },
    generateOrderPreSignedPutUrl(variables: GenerateOrderPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateOrderPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateOrderPreSignedPutUrlMutation>(GenerateOrderPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateOrderPreSignedPutUrl', 'mutation', variables);
    },
    generateScannedOrderPreSignedPutUrls(variables: GenerateScannedOrderPreSignedPutUrlsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateScannedOrderPreSignedPutUrlsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateScannedOrderPreSignedPutUrlsQuery>(GenerateScannedOrderPreSignedPutUrlsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateScannedOrderPreSignedPutUrls', 'query', variables);
    },
    generatePreSignedPutUrl(variables: GeneratePreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GeneratePreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GeneratePreSignedPutUrlMutation>(GeneratePreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generatePreSignedPutUrl', 'mutation', variables);
    },
    inboundMessagesForOrder(variables: InboundMessagesForOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InboundMessagesForOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InboundMessagesForOrderQuery>(InboundMessagesForOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'inboundMessagesForOrder', 'query', variables);
    },
    incompleteLegsWithAttempts(variables?: IncompleteLegsWithAttemptsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<IncompleteLegsWithAttemptsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<IncompleteLegsWithAttemptsQuery>(IncompleteLegsWithAttemptsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'incompleteLegsWithAttempts', 'query', variables);
    },
    laneFromOriginAndDestinationTerminal(variables: LaneFromOriginAndDestinationTerminalQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LaneFromOriginAndDestinationTerminalQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LaneFromOriginAndDestinationTerminalQuery>(LaneFromOriginAndDestinationTerminalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'laneFromOriginAndDestinationTerminal', 'query', variables);
    },
    linkPiecesToPackage(variables: LinkPiecesToPackageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LinkPiecesToPackageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinkPiecesToPackageMutation>(LinkPiecesToPackageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'linkPiecesToPackage', 'mutation', variables);
    },
    markOrderAsCompleteForce(variables: MarkOrderAsCompleteForceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsCompleteForceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsCompleteForceMutation>(MarkOrderAsCompleteForceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsCompleteForce', 'mutation', variables);
    },
    markOrderAsHasBillingIssue(variables: MarkOrderAsHasBillingIssueMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsHasBillingIssueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsHasBillingIssueMutation>(MarkOrderAsHasBillingIssueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsHasBillingIssue', 'mutation', variables);
    },
    markOrderAsNotComplete(variables: MarkOrderAsNotCompleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsNotCompleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsNotCompleteMutation>(MarkOrderAsNotCompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsNotComplete', 'mutation', variables);
    },
    markOrderAsNotOnHand(variables: MarkOrderAsNotOnHandMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsNotOnHandMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsNotOnHandMutation>(MarkOrderAsNotOnHandDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsNotOnHand', 'mutation', variables);
    },
    markOrderAsNotReadyToInvoice(variables: MarkOrderAsNotReadyToInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsNotReadyToInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsNotReadyToInvoiceMutation>(MarkOrderAsNotReadyToInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsNotReadyToInvoice', 'mutation', variables);
    },
    markOrderAsNotReceivedAtOrigin(variables: MarkOrderAsNotReceivedAtOriginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsNotReceivedAtOriginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsNotReceivedAtOriginMutation>(MarkOrderAsNotReceivedAtOriginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsNotReceivedAtOrigin', 'mutation', variables);
    },
    markOrderAsOnHand(variables: MarkOrderAsOnHandMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsOnHandMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsOnHandMutation>(MarkOrderAsOnHandDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsOnHand', 'mutation', variables);
    },
    markOrderAsReadyToInvoiceForce(variables: MarkOrderAsReadyToInvoiceForceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsReadyToInvoiceForceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsReadyToInvoiceForceMutation>(MarkOrderAsReadyToInvoiceForceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsReadyToInvoiceForce', 'mutation', variables);
    },
    markOrderAsReadyToInvoice(variables: MarkOrderAsReadyToInvoiceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsReadyToInvoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsReadyToInvoiceMutation>(MarkOrderAsReadyToInvoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsReadyToInvoice', 'mutation', variables);
    },
    markOrderAsReceivedAtOrigin(variables: MarkOrderAsReceivedAtOriginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsReceivedAtOriginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsReceivedAtOriginMutation>(MarkOrderAsReceivedAtOriginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsReceivedAtOrigin', 'mutation', variables);
    },
    markOrderAsRefused(variables: MarkOrderAsRefusedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsRefusedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsRefusedMutation>(MarkOrderAsRefusedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsRefused', 'mutation', variables);
    },
    markOrderAsNotOsd(variables: MarkOrderAsNotOsdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsNotOsdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsNotOsdMutation>(MarkOrderAsNotOsdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsNotOsd', 'mutation', variables);
    },
    markOrderAsOSD(variables: MarkOrderAsOsdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkOrderAsOsdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkOrderAsOsdMutation>(MarkOrderAsOsdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markOrderAsOSD', 'mutation', variables);
    },
    mergeEdiOrder(variables: MergeEdiOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MergeEdiOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MergeEdiOrderMutation>(MergeEdiOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mergeEdiOrder', 'mutation', variables);
    },
    numberOfEdiAndApiOrdersForReviewForCurrentCompany(variables?: NumberOfEdiAndApiOrdersForReviewForCurrentCompanyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NumberOfEdiAndApiOrdersForReviewForCurrentCompanyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NumberOfEdiAndApiOrdersForReviewForCurrentCompanyQuery>(NumberOfEdiAndApiOrdersForReviewForCurrentCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'numberOfEdiAndApiOrdersForReviewForCurrentCompany', 'query', variables);
    },
    numberOfScannedOrderResultsInReviewBySource(variables?: NumberOfScannedOrderResultsInReviewBySourceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NumberOfScannedOrderResultsInReviewBySourceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NumberOfScannedOrderResultsInReviewBySourceQuery>(NumberOfScannedOrderResultsInReviewBySourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'numberOfScannedOrderResultsInReviewBySource', 'query', variables);
    },
    openMessageInOutlook(variables: OpenMessageInOutlookMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OpenMessageInOutlookMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OpenMessageInOutlookMutation>(OpenMessageInOutlookDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'openMessageInOutlook', 'mutation', variables);
    },
    deleteOrderComment(variables: DeleteOrderCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteOrderCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOrderCommentMutation>(DeleteOrderCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOrderComment', 'mutation', variables);
    },
    updateOrderComment(variables: UpdateOrderCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderCommentMutation>(UpdateOrderCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderComment', 'mutation', variables);
    },
    standardOrderForContextMenu(variables: StandardOrderForContextMenuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StandardOrderForContextMenuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StandardOrderForContextMenuQuery>(StandardOrderForContextMenuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'standardOrderForContextMenu', 'query', variables);
    },
    ordersForDocumentAttachmentsDownload(variables: OrdersForDocumentAttachmentsDownloadQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForDocumentAttachmentsDownloadQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForDocumentAttachmentsDownloadQuery>(OrdersForDocumentAttachmentsDownloadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForDocumentAttachmentsDownload', 'query', variables);
    },
    orderForTabLabel(variables: OrderForTabLabelQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderForTabLabelQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderForTabLabelQuery>(OrderForTabLabelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderForTabLabel', 'query', variables);
    },
    orderName(variables: OrderNameQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderNameQuery>(OrderNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderName', 'query', variables);
    },
    orderPodReports(variables?: OrderPodReportsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderPodReportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderPodReportsQuery>(OrderPodReportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderPodReports', 'query', variables);
    },
    orderUpdatedAt(variables: OrderUpdatedAtQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderUpdatedAtQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderUpdatedAtQuery>(OrderUpdatedAtDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderUpdatedAt', 'query', variables);
    },
    order(variables: OrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderQuery>(OrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'order', 'query', variables);
    },
    ordersBySecondaryRefNumber(variables: OrdersBySecondaryRefNumberQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersBySecondaryRefNumberQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersBySecondaryRefNumberQuery>(OrdersBySecondaryRefNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersBySecondaryRefNumber', 'query', variables);
    },
    ordersByShipperBillOfLadingNumber(variables: OrdersByShipperBillOfLadingNumberQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersByShipperBillOfLadingNumberQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersByShipperBillOfLadingNumberQuery>(OrdersByShipperBillOfLadingNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersByShipperBillOfLadingNumber', 'query', variables);
    },
    ordersByUuidsForBulkEdit(variables: OrdersByUuidsForBulkEditQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersByUuidsForBulkEditQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersByUuidsForBulkEditQuery>(OrdersByUuidsForBulkEditDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersByUuidsForBulkEdit', 'query', variables);
    },
    ordersForBulkEdit(variables?: OrdersForBulkEditQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForBulkEditQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForBulkEditQuery>(OrdersForBulkEditDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForBulkEdit', 'query', variables);
    },
    ordersForInventoryLabels(variables: OrdersForInventoryLabelsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForInventoryLabelsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForInventoryLabelsQuery>(OrdersForInventoryLabelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForInventoryLabels', 'query', variables);
    },
    ordersForOrderMatching(variables?: OrdersForOrderMatchingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersForOrderMatchingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersForOrderMatchingQuery>(OrdersForOrderMatchingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ordersForOrderMatching', 'query', variables);
    },
    createOrderTableReport(variables: CreateOrderTableReportMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOrderTableReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrderTableReportMutation>(CreateOrderTableReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOrderTableReport', 'mutation', variables);
    },
    getOrderTableFieldValuesForCount(variables: GetOrderTableFieldValuesForCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderTableFieldValuesForCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderTableFieldValuesForCountQuery>(GetOrderTableFieldValuesForCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderTableFieldValuesForCount', 'query', variables);
    },
    getOrderTableFieldValuesForSearch(variables: GetOrderTableFieldValuesForSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderTableFieldValuesForSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderTableFieldValuesForSearchQuery>(GetOrderTableFieldValuesForSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderTableFieldValuesForSearch', 'query', variables);
    },
    getOrderTableFieldValues(variables: GetOrderTableFieldValuesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderTableFieldValuesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderTableFieldValuesQuery>(GetOrderTableFieldValuesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderTableFieldValues', 'query', variables);
    },
    orderComments(variables: OrderCommentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderCommentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderCommentsQuery>(OrderCommentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderComments', 'query', variables);
    },
    orderTableFieldHeaders(variables?: OrderTableFieldHeadersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderTableFieldHeadersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderTableFieldHeadersQuery>(OrderTableFieldHeadersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderTableFieldHeaders', 'query', variables);
    },
    orderUuidsInView(variables: OrderUuidsInViewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderUuidsInViewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderUuidsInViewQuery>(OrderUuidsInViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderUuidsInView', 'query', variables);
    },
    orderUuids(variables?: OrderUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderUuidsQuery>(OrderUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderUuids', 'query', variables);
    },
    orderWithInboundOutboundPaperwork(variables: OrderWithInboundOutboundPaperworkQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderWithInboundOutboundPaperworkQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderWithInboundOutboundPaperworkQuery>(OrderWithInboundOutboundPaperworkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderWithInboundOutboundPaperwork', 'query', variables);
    },
    orderWithItemizedCharges(variables: OrderWithItemizedChargesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderWithItemizedChargesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderWithItemizedChargesQuery>(OrderWithItemizedChargesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderWithItemizedCharges', 'query', variables);
    },
    orderWithMissingDocuments(variables: OrderWithMissingDocumentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderWithMissingDocumentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderWithMissingDocumentsQuery>(OrderWithMissingDocumentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderWithMissingDocuments', 'query', variables);
    },
    orderWithPaperwork(variables: OrderWithPaperworkQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderWithPaperworkQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderWithPaperworkQuery>(OrderWithPaperworkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderWithPaperwork', 'query', variables);
    },
    PackageSpecs(variables?: PackageSpecsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PackageSpecsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackageSpecsQuery>(PackageSpecsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PackageSpecs', 'query', variables);
    },
    PiecesByUuids(variables: PiecesByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PiecesByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PiecesByUuidsQuery>(PiecesByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PiecesByUuids', 'query', variables);
    },
    RecordInboundReviewDecisions(variables: RecordInboundReviewDecisionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecordInboundReviewDecisionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecordInboundReviewDecisionsMutation>(RecordInboundReviewDecisionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecordInboundReviewDecisions', 'mutation', variables);
    },
    recurringOrderTemplates(variables?: RecurringOrderTemplatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecurringOrderTemplatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecurringOrderTemplatesQuery>(RecurringOrderTemplatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'recurringOrderTemplates', 'query', variables);
    },
    recurringRuns(variables?: RecurringRunsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecurringRunsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecurringRunsQuery>(RecurringRunsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'recurringRuns', 'query', variables);
    },
    removeOrderHold(variables: RemoveOrderHoldMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveOrderHoldMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOrderHoldMutation>(RemoveOrderHoldDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeOrderHold', 'mutation', variables);
    },
    removeSubscriberFromShipment(variables: RemoveSubscriberFromShipmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSubscriberFromShipmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSubscriberFromShipmentMutation>(RemoveSubscriberFromShipmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeSubscriberFromShipment', 'mutation', variables);
    },
    reportADocScanIssue(variables: ReportADocScanIssueMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReportADocScanIssueMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportADocScanIssueMutation>(ReportADocScanIssueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reportADocScanIssue', 'mutation', variables);
    },
    RerateOrderFreight(variables: RerateOrderFreightMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RerateOrderFreightMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RerateOrderFreightMutation>(RerateOrderFreightDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RerateOrderFreight', 'mutation', variables);
    },
    CreateReverseOrder(variables: CreateReverseOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateReverseOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateReverseOrderMutation>(CreateReverseOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateReverseOrder', 'mutation', variables);
    },
    scannedOrderProvenance(variables: ScannedOrderProvenanceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ScannedOrderProvenanceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScannedOrderProvenanceQuery>(ScannedOrderProvenanceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scannedOrderProvenance', 'query', variables);
    },
    scannedOrderResultByOrderUuid(variables: ScannedOrderResultByOrderUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ScannedOrderResultByOrderUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScannedOrderResultByOrderUuidQuery>(ScannedOrderResultByOrderUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scannedOrderResultByOrderUuid', 'query', variables);
    },
    scannedOrdersByUuids(variables: ScannedOrdersByUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ScannedOrdersByUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScannedOrdersByUuidsQuery>(ScannedOrdersByUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scannedOrdersByUuids', 'query', variables);
    },
    servicesForOrder(variables: ServicesForOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServicesForOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServicesForOrderQuery>(ServicesForOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'servicesForOrder', 'query', variables);
    },
    setOrderExecutedBy(variables: SetOrderExecutedByMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetOrderExecutedByMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetOrderExecutedByMutation>(SetOrderExecutedByDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setOrderExecutedBy', 'mutation', variables);
    },
    shipmentBillOfLading(variables: ShipmentBillOfLadingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShipmentBillOfLadingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShipmentBillOfLadingQuery>(ShipmentBillOfLadingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shipmentBillOfLading', 'query', variables);
    },
    standardOrder(variables: StandardOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StandardOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StandardOrderQuery>(StandardOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'standardOrder', 'query', variables);
    },
    stopForDriverSettlement(variables: StopForDriverSettlementQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopForDriverSettlementQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopForDriverSettlementQuery>(StopForDriverSettlementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopForDriverSettlement', 'query', variables);
    },
    uncancelOrder(variables: UncancelOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UncancelOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UncancelOrderMutation>(UncancelOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'uncancelOrder', 'mutation', variables);
    },
    unfinalizeOrder(variables: UnfinalizeOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnfinalizeOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnfinalizeOrderMutation>(UnfinalizeOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unfinalizeOrder', 'mutation', variables);
    },
    UnfinalizeOrders(variables: UnfinalizeOrdersMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnfinalizeOrdersMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnfinalizeOrdersMutation>(UnfinalizeOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnfinalizeOrders', 'mutation', variables);
    },
    unlinkPieceFromPackage(variables: UnlinkPieceFromPackageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnlinkPieceFromPackageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnlinkPieceFromPackageMutation>(UnlinkPieceFromPackageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unlinkPieceFromPackage', 'mutation', variables);
    },
    updateDocument(variables: UpdateDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateDocumentMutation>(UpdateDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateDocument', 'mutation', variables);
    },
    updatePaperworkCompletedForStops(variables: UpdatePaperworkCompletedForStopsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePaperworkCompletedForStopsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePaperworkCompletedForStopsMutation>(UpdatePaperworkCompletedForStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePaperworkCompletedForStops', 'mutation', variables);
    },
    updateRecurringRun(variables: UpdateRecurringRunMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRecurringRunMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRecurringRunMutation>(UpdateRecurringRunDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRecurringRun', 'mutation', variables);
    },
    updateStandardOrder(variables: UpdateStandardOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStandardOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStandardOrderMutation>(UpdateStandardOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStandardOrder', 'mutation', variables);
    },
    validateBulkEditOrders(variables: ValidateBulkEditOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ValidateBulkEditOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ValidateBulkEditOrdersQuery>(ValidateBulkEditOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'validateBulkEditOrders', 'query', variables);
    },
    rateOrderByUuid(variables: RateOrderByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RateOrderByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RateOrderByUuidQuery>(RateOrderByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rateOrderByUuid', 'query', variables);
    },
    rateOrderTotalDollars(variables: RateOrderTotalDollarsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RateOrderTotalDollarsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RateOrderTotalDollarsQuery>(RateOrderTotalDollarsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rateOrderTotalDollars', 'query', variables);
    },
    rateOrder(variables: RateOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RateOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RateOrderQuery>(RateOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rateOrder', 'query', variables);
    },
    ActiveOrganizationMessageBanners(variables?: ActiveOrganizationMessageBannersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActiveOrganizationMessageBannersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActiveOrganizationMessageBannersQuery>(ActiveOrganizationMessageBannersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActiveOrganizationMessageBanners', 'query', variables);
    },
    DismissOrganizationMessage(variables: DismissOrganizationMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DismissOrganizationMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DismissOrganizationMessageMutation>(DismissOrganizationMessageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DismissOrganizationMessage', 'mutation', variables);
    },
    BusinessKpiInvoicedOrders(variables: BusinessKpiInvoicedOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BusinessKpiInvoicedOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BusinessKpiInvoicedOrdersQuery>(BusinessKpiInvoicedOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BusinessKpiInvoicedOrders', 'query', variables);
    },
    BusinessKpiOrdersPerDriver(variables: BusinessKpiOrdersPerDriverQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BusinessKpiOrdersPerDriverQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BusinessKpiOrdersPerDriverQuery>(BusinessKpiOrdersPerDriverDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BusinessKpiOrdersPerDriver', 'query', variables);
    },
    BusinessKpiOrders(variables: BusinessKpiOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BusinessKpiOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BusinessKpiOrdersQuery>(BusinessKpiOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BusinessKpiOrders', 'query', variables);
    },
    BusinessKpiPaidInvoices(variables: BusinessKpiPaidInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BusinessKpiPaidInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BusinessKpiPaidInvoicesQuery>(BusinessKpiPaidInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BusinessKpiPaidInvoices', 'query', variables);
    },
    BusinessKpis(variables: BusinessKpisQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BusinessKpisQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BusinessKpisQuery>(BusinessKpisDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BusinessKpis', 'query', variables);
    },
    DeliveryFailureKpi(variables: DeliveryFailureKpiQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeliveryFailureKpiQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeliveryFailureKpiQuery>(DeliveryFailureKpiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeliveryFailureKpi', 'query', variables);
    },
    DeliveryFailureStops(variables: DeliveryFailureStopsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeliveryFailureStopsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeliveryFailureStopsQuery>(DeliveryFailureStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeliveryFailureStops', 'query', variables);
    },
    DockReceivedKpiReceipts(variables: DockReceivedKpiReceiptsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DockReceivedKpiReceiptsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DockReceivedKpiReceiptsQuery>(DockReceivedKpiReceiptsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DockReceivedKpiReceipts', 'query', variables);
    },
    DockReceivedKpi(variables: DockReceivedKpiQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DockReceivedKpiQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DockReceivedKpiQuery>(DockReceivedKpiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DockReceivedKpi', 'query', variables);
    },
    KpiComparisons(variables: KpiComparisonsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<KpiComparisonsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<KpiComparisonsQuery>(KpiComparisonsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'KpiComparisons', 'query', variables);
    },
    KpiDashboardLayout(variables?: KpiDashboardLayoutQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<KpiDashboardLayoutQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<KpiDashboardLayoutQuery>(KpiDashboardLayoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'KpiDashboardLayout', 'query', variables);
    },
    KpiDataStart(variables?: KpiDataStartQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<KpiDataStartQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<KpiDataStartQuery>(KpiDataStartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'KpiDataStart', 'query', variables);
    },
    KpiRecordTableDownload(variables: KpiRecordTableDownloadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<KpiRecordTableDownloadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<KpiRecordTableDownloadMutation>(KpiRecordTableDownloadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'KpiRecordTableDownload', 'mutation', variables);
    },
    OnTimeKpiStops(variables: OnTimeKpiStopsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OnTimeKpiStopsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnTimeKpiStopsQuery>(OnTimeKpiStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnTimeKpiStops', 'query', variables);
    },
    OnTimeKpi(variables: OnTimeKpiQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OnTimeKpiQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OnTimeKpiQuery>(OnTimeKpiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OnTimeKpi', 'query', variables);
    },
    PieceScanKpiPieces(variables: PieceScanKpiPiecesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PieceScanKpiPiecesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PieceScanKpiPiecesQuery>(PieceScanKpiPiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PieceScanKpiPieces', 'query', variables);
    },
    PieceScanKpi(variables: PieceScanKpiQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PieceScanKpiQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PieceScanKpiQuery>(PieceScanKpiDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PieceScanKpi', 'query', variables);
    },
    UpdateKpiDashboardLayout(variables: UpdateKpiDashboardLayoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateKpiDashboardLayoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateKpiDashboardLayoutMutation>(UpdateKpiDashboardLayoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateKpiDashboardLayout', 'mutation', variables);
    },
    updatePackage(variables: UpdatePackageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePackageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePackageMutation>(UpdatePackageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePackage', 'mutation', variables);
    },
    createPermission(variables: CreatePermissionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePermissionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePermissionMutation>(CreatePermissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPermission', 'mutation', variables);
    },
    deletePermission(variables: DeletePermissionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeletePermissionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePermissionMutation>(DeletePermissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePermission', 'mutation', variables);
    },
    updatePermissionAccessLevel(variables: UpdatePermissionAccessLevelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePermissionAccessLevelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePermissionAccessLevelMutation>(UpdatePermissionAccessLevelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePermissionAccessLevel', 'mutation', variables);
    },
    updatePermission(variables: UpdatePermissionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePermissionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePermissionMutation>(UpdatePermissionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePermission', 'mutation', variables);
    },
    addPiecesToPieceReceipt(variables: AddPiecesToPieceReceiptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddPiecesToPieceReceiptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddPiecesToPieceReceiptMutation>(AddPiecesToPieceReceiptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addPiecesToPieceReceipt', 'mutation', variables);
    },
    createPieceReceipt(variables: CreatePieceReceiptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePieceReceiptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePieceReceiptMutation>(CreatePieceReceiptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createPieceReceipt', 'mutation', variables);
    },
    deletePieceReceipt(variables: DeletePieceReceiptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeletePieceReceiptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePieceReceiptMutation>(DeletePieceReceiptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePieceReceipt', 'mutation', variables);
    },
    pieceReceiptEvents(variables: PieceReceiptEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PieceReceiptEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PieceReceiptEventsQuery>(PieceReceiptEventsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pieceReceiptEvents', 'query', variables);
    },
    pieceReceiptLinkablePieces(variables: PieceReceiptLinkablePiecesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PieceReceiptLinkablePiecesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PieceReceiptLinkablePiecesQuery>(PieceReceiptLinkablePiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pieceReceiptLinkablePieces', 'query', variables);
    },
    pieceReceiptPieceDetail(variables: PieceReceiptPieceDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PieceReceiptPieceDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PieceReceiptPieceDetailQuery>(PieceReceiptPieceDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pieceReceiptPieceDetail', 'query', variables);
    },
    pieceReceipt(variables: PieceReceiptQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PieceReceiptQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PieceReceiptQuery>(PieceReceiptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pieceReceipt', 'query', variables);
    },
    pieceReceipts(variables: PieceReceiptsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PieceReceiptsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PieceReceiptsQuery>(PieceReceiptsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pieceReceipts', 'query', variables);
    },
    removePiecesFromPieceReceipt(variables: RemovePiecesFromPieceReceiptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemovePiecesFromPieceReceiptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemovePiecesFromPieceReceiptMutation>(RemovePiecesFromPieceReceiptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removePiecesFromPieceReceipt', 'mutation', variables);
    },
    updatePieceReceiptPiece(variables: UpdatePieceReceiptPieceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePieceReceiptPieceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePieceReceiptPieceMutation>(UpdatePieceReceiptPieceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePieceReceiptPiece', 'mutation', variables);
    },
    updatePieceReceipt(variables: UpdatePieceReceiptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePieceReceiptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePieceReceiptMutation>(UpdatePieceReceiptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePieceReceipt', 'mutation', variables);
    },
    BulkDeletePieces(variables: BulkDeletePiecesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkDeletePiecesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkDeletePiecesMutation>(BulkDeletePiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BulkDeletePieces', 'mutation', variables);
    },
    BulkDiscardPieces(variables: BulkDiscardPiecesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkDiscardPiecesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkDiscardPiecesMutation>(BulkDiscardPiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BulkDiscardPieces', 'mutation', variables);
    },
    BulkRestorePieces(variables: BulkRestorePiecesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkRestorePiecesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkRestorePiecesMutation>(BulkRestorePiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BulkRestorePieces', 'mutation', variables);
    },
    findPieces(variables: FindPiecesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindPiecesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindPiecesQuery>(FindPiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findPieces', 'query', variables);
    },
    LinkPieceToOrderWithRole(variables: LinkPieceToOrderWithRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LinkPieceToOrderWithRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinkPieceToOrderWithRoleMutation>(LinkPieceToOrderWithRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LinkPieceToOrderWithRole', 'mutation', variables);
    },
    orderCommentsByPiece(variables: OrderCommentsByPieceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderCommentsByPieceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderCommentsByPieceQuery>(OrderCommentsByPieceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderCommentsByPiece', 'query', variables);
    },
    pieceBucketMetrics(variables: PieceBucketMetricsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PieceBucketMetricsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PieceBucketMetricsQuery>(PieceBucketMetricsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pieceBucketMetrics', 'query', variables);
    },
    pieceDetail(variables: PieceDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PieceDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PieceDetailQuery>(PieceDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pieceDetail', 'query', variables);
    },
    pieceEvents(variables: PieceEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PieceEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PieceEventsQuery>(PieceEventsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'pieceEvents', 'query', variables);
    },
    TransferPieceToOrder(variables: TransferPieceToOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TransferPieceToOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TransferPieceToOrderMutation>(TransferPieceToOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TransferPieceToOrder', 'mutation', variables);
    },
    TransferPieceToOutboundOrder(variables: TransferPieceToOutboundOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TransferPieceToOutboundOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TransferPieceToOutboundOrderMutation>(TransferPieceToOutboundOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TransferPieceToOutboundOrder', 'mutation', variables);
    },
    UnlinkPieceFromOrder(variables: UnlinkPieceFromOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnlinkPieceFromOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnlinkPieceFromOrderMutation>(UnlinkPieceFromOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnlinkPieceFromOrder', 'mutation', variables);
    },
    UpdatePieceReferenceNumber(variables: UpdatePieceReferenceNumberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePieceReferenceNumberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePieceReferenceNumberMutation>(UpdatePieceReferenceNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePieceReferenceNumber', 'mutation', variables);
    },
    emailQuoteQueue(variables: EmailQuoteQueueQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmailQuoteQueueQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailQuoteQueueQuery>(EmailQuoteQueueDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'emailQuoteQueue', 'query', variables);
    },
    emailQuote(variables: EmailQuoteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EmailQuoteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EmailQuoteQuery>(EmailQuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'emailQuote', 'query', variables);
    },
    approveQuote(variables: ApproveQuoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApproveQuoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApproveQuoteMutation>(ApproveQuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'approveQuote', 'mutation', variables);
    },
    clientQuotes(variables: ClientQuotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ClientQuotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClientQuotesQuery>(ClientQuotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'clientQuotes', 'query', variables);
    },
    createQuote(variables: CreateQuoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateQuoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateQuoteMutation>(CreateQuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createQuote', 'mutation', variables);
    },
    quoteContributionRatio(variables: QuoteContributionRatioQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteContributionRatioQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteContributionRatioQuery>(QuoteContributionRatioDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quoteContributionRatio', 'query', variables);
    },
    quoteName(variables: QuoteNameQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteNameQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteNameQuery>(QuoteNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quoteName', 'query', variables);
    },
    quote(variables: QuoteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteQuery>(QuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quote', 'query', variables);
    },
    quotes(variables?: QuotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuotesQuery>(QuotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quotes', 'query', variables);
    },
    RerateQuoteFreight(variables: RerateQuoteFreightMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RerateQuoteFreightMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RerateQuoteFreightMutation>(RerateQuoteFreightDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RerateQuoteFreight', 'mutation', variables);
    },
    updateQuote(variables: UpdateQuoteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateQuoteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateQuoteMutation>(UpdateQuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateQuote', 'mutation', variables);
    },
    createReportGroupConfiguration(variables: CreateReportGroupConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateReportGroupConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateReportGroupConfigurationMutation>(CreateReportGroupConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createReportGroupConfiguration', 'mutation', variables);
    },
    customerReport(variables: CustomerReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerReportQuery>(CustomerReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerReport', 'query', variables);
    },
    deleteReportGroupConfiguration(variables: DeleteReportGroupConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteReportGroupConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteReportGroupConfigurationMutation>(DeleteReportGroupConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteReportGroupConfiguration', 'mutation', variables);
    },
    driverReport(variables: DriverReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverReportQuery>(DriverReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverReport', 'query', variables);
    },
    orderReport(variables: OrderReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderReportQuery>(OrderReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderReport', 'query', variables);
    },
    reportGroupConfigurations(variables?: ReportGroupConfigurationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReportGroupConfigurationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportGroupConfigurationsQuery>(ReportGroupConfigurationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reportGroupConfigurations', 'query', variables);
    },
    reportSendJobBatches(variables: ReportSendJobBatchesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReportSendJobBatchesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportSendJobBatchesQuery>(ReportSendJobBatchesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reportSendJobBatches', 'query', variables);
    },
    reportSendJobs(variables: ReportSendJobsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReportSendJobsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReportSendJobsQuery>(ReportSendJobsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reportSendJobs', 'query', variables);
    },
    sendAccountingReports(variables: SendAccountingReportsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendAccountingReportsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendAccountingReportsMutation>(SendAccountingReportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendAccountingReports', 'mutation', variables);
    },
    serviceLevelReport(variables: ServiceLevelReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceLevelReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceLevelReportQuery>(ServiceLevelReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceLevelReport', 'query', variables);
    },
    stationReport(variables: StationReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StationReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StationReportQuery>(StationReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stationReport', 'query', variables);
    },
    terminalReport(variables: TerminalReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TerminalReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TerminalReportQuery>(TerminalReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'terminalReport', 'query', variables);
    },
    updateReportGroupConfiguration(variables: UpdateReportGroupConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateReportGroupConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateReportGroupConfigurationMutation>(UpdateReportGroupConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateReportGroupConfiguration', 'mutation', variables);
    },
    AppointmentOptions(variables: AppointmentOptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppointmentOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppointmentOptionsQuery>(AppointmentOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AppointmentOptions', 'query', variables);
    },
    ChooseAppointmentOption(variables: ChooseAppointmentOptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChooseAppointmentOptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChooseAppointmentOptionMutation>(ChooseAppointmentOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChooseAppointmentOption', 'mutation', variables);
    },
    QueueAppointmentSchedulingProposals(variables: QueueAppointmentSchedulingProposalsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueueAppointmentSchedulingProposalsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueueAppointmentSchedulingProposalsMutation>(QueueAppointmentSchedulingProposalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'QueueAppointmentSchedulingProposals', 'mutation', variables);
    },
    addUserToRole(variables: AddUserToRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddUserToRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUserToRoleMutation>(AddUserToRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addUserToRole', 'mutation', variables);
    },
    createRole(variables: CreateRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRoleMutation>(CreateRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createRole', 'mutation', variables);
    },
    role(variables: RoleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoleQuery>(RoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'role', 'query', variables);
    },
    roles(variables?: RolesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RolesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RolesQuery>(RolesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'roles', 'query', variables);
    },
    removeUserFromRole(variables: RemoveUserFromRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveUserFromRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveUserFromRoleMutation>(RemoveUserFromRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeUserFromRole', 'mutation', variables);
    },
    updateRole(variables: UpdateRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateRoleMutation>(UpdateRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateRole', 'mutation', variables);
    },
    usersForRole(variables?: UsersForRoleQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UsersForRoleQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UsersForRoleQuery>(UsersForRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'usersForRole', 'query', variables);
    },
    createShipmentDocument(variables: CreateShipmentDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateShipmentDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateShipmentDocumentMutation>(CreateShipmentDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createShipmentDocument', 'mutation', variables);
    },
    completeStopBulk(variables: CompleteStopBulkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompleteStopBulkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteStopBulkMutation>(CompleteStopBulkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeStopBulk', 'mutation', variables);
    },
    completeStopV2(variables: CompleteStopV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompleteStopV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompleteStopV2Mutation>(CompleteStopV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completeStopV2', 'mutation', variables);
    },
    deleteDocument(variables: DeleteDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteDocumentMutation>(DeleteDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteDocument', 'mutation', variables);
    },
    generateShipmentPreSignedPutUrl(variables: GenerateShipmentPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateShipmentPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateShipmentPreSignedPutUrlMutation>(GenerateShipmentPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateShipmentPreSignedPutUrl', 'mutation', variables);
    },
    markStopAsFailed(variables: MarkStopAsFailedMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkStopAsFailedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkStopAsFailedMutation>(MarkStopAsFailedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markStopAsFailed', 'mutation', variables);
    },
    markStopAsFailedV2(variables: MarkStopAsFailedV2MutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkStopAsFailedV2Mutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkStopAsFailedV2Mutation>(MarkStopAsFailedV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markStopAsFailedV2', 'mutation', variables);
    },
    nameOfRoute(variables: NameOfRouteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NameOfRouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NameOfRouteQuery>(NameOfRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'nameOfRoute', 'query', variables);
    },
    equipmentsFetch(variables?: EquipmentsFetchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EquipmentsFetchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EquipmentsFetchQuery>(EquipmentsFetchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'equipmentsFetch', 'query', variables);
    },
    route(variables: RouteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RouteQuery>(RouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'route', 'query', variables);
    },
    shallowRoutes(variables: ShallowRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShallowRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShallowRoutesQuery>(ShallowRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shallowRoutes', 'query', variables);
    },
    updateServiceDateForAssignedStops(variables: UpdateServiceDateForAssignedStopsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateServiceDateForAssignedStopsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateServiceDateForAssignedStopsMutation>(UpdateServiceDateForAssignedStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateServiceDateForAssignedStops', 'mutation', variables);
    },
    updateStop(variables: UpdateStopMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStopMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStopMutation>(UpdateStopDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStop', 'mutation', variables);
    },
    updateStops(variables: UpdateStopsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStopsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStopsMutation>(UpdateStopsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStops', 'mutation', variables);
    },
    samaraOAuthAuthorizeUrl(variables?: SamaraOAuthAuthorizeUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamaraOAuthAuthorizeUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamaraOAuthAuthorizeUrlQuery>(SamaraOAuthAuthorizeUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'samaraOAuthAuthorizeUrl', 'query', variables);
    },
    samsaraOAuthToken(variables?: SamsaraOAuthTokenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SamsaraOAuthTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SamsaraOAuthTokenQuery>(SamsaraOAuthTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'samsaraOAuthToken', 'query', variables);
    },
    cloneSavedFilterView(variables: CloneSavedFilterViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CloneSavedFilterViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CloneSavedFilterViewMutation>(CloneSavedFilterViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cloneSavedFilterView', 'mutation', variables);
    },
    createSavedFilterView(variables: CreateSavedFilterViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSavedFilterViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSavedFilterViewMutation>(CreateSavedFilterViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSavedFilterView', 'mutation', variables);
    },
    deleteSavedFilterView(variables: DeleteSavedFilterViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteSavedFilterViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSavedFilterViewMutation>(DeleteSavedFilterViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteSavedFilterView', 'mutation', variables);
    },
    getSavedFilterViews(variables: GetSavedFilterViewsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSavedFilterViewsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSavedFilterViewsQuery>(GetSavedFilterViewsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSavedFilterViews', 'query', variables);
    },
    shareSavedFilterView(variables: ShareSavedFilterViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShareSavedFilterViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShareSavedFilterViewMutation>(ShareSavedFilterViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shareSavedFilterView', 'mutation', variables);
    },
    updateSavedFilterView(variables: UpdateSavedFilterViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSavedFilterViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSavedFilterViewMutation>(UpdateSavedFilterViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSavedFilterView', 'mutation', variables);
    },
    mergeScannedOrderResultIntoPossibleDuplicate(variables: MergeScannedOrderResultIntoPossibleDuplicateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MergeScannedOrderResultIntoPossibleDuplicateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MergeScannedOrderResultIntoPossibleDuplicateMutation>(MergeScannedOrderResultIntoPossibleDuplicateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mergeScannedOrderResultIntoPossibleDuplicate', 'mutation', variables);
    },
    scannedOrderResult(variables: ScannedOrderResultQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ScannedOrderResultQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScannedOrderResultQuery>(ScannedOrderResultDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scannedOrderResult', 'query', variables);
    },
    billingPartyPicker(variables: BillingPartyPickerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BillingPartyPickerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BillingPartyPickerQuery>(BillingPartyPickerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'billingPartyPicker', 'query', variables);
    },
    firstScannedOrderResultInReview(variables?: FirstScannedOrderResultInReviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FirstScannedOrderResultInReviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FirstScannedOrderResultInReviewQuery>(FirstScannedOrderResultInReviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'firstScannedOrderResultInReview', 'query', variables);
    },
    resolveScannedOrderBillingParty(variables: ResolveScannedOrderBillingPartyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ResolveScannedOrderBillingPartyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResolveScannedOrderBillingPartyMutation>(ResolveScannedOrderBillingPartyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'resolveScannedOrderBillingParty', 'mutation', variables);
    },
    scannedOrderResults(variables: ScannedOrderResultsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ScannedOrderResultsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScannedOrderResultsQuery>(ScannedOrderResultsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scannedOrderResults', 'query', variables);
    },
    updateScannedOrderResultStatus(variables: UpdateScannedOrderResultStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateScannedOrderResultStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateScannedOrderResultStatusMutation>(UpdateScannedOrderResultStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateScannedOrderResultStatus', 'mutation', variables);
    },
    ArchiveSchedulingRegion(variables: ArchiveSchedulingRegionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveSchedulingRegionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveSchedulingRegionMutation>(ArchiveSchedulingRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveSchedulingRegion', 'mutation', variables);
    },
    ArchiveSchedulingResource(variables: ArchiveSchedulingResourceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveSchedulingResourceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveSchedulingResourceMutation>(ArchiveSchedulingResourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveSchedulingResource', 'mutation', variables);
    },
    BlockCompanySchedulingDay(variables: BlockCompanySchedulingDayMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlockCompanySchedulingDayMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlockCompanySchedulingDayMutation>(BlockCompanySchedulingDayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlockCompanySchedulingDay', 'mutation', variables);
    },
    BlockSchedulingResourceDay(variables: BlockSchedulingResourceDayMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BlockSchedulingResourceDayMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BlockSchedulingResourceDayMutation>(BlockSchedulingResourceDayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BlockSchedulingResourceDay', 'mutation', variables);
    },
    CompanySchedulingBlockedDays(variables?: CompanySchedulingBlockedDaysQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanySchedulingBlockedDaysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanySchedulingBlockedDaysQuery>(CompanySchedulingBlockedDaysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CompanySchedulingBlockedDays', 'query', variables);
    },
    CreateSchedulingRegion(variables: CreateSchedulingRegionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSchedulingRegionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSchedulingRegionMutation>(CreateSchedulingRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSchedulingRegion', 'mutation', variables);
    },
    CreateSchedulingResource(variables: CreateSchedulingResourceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSchedulingResourceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSchedulingResourceMutation>(CreateSchedulingResourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSchedulingResource', 'mutation', variables);
    },
    CreateSchedulingZone(variables: CreateSchedulingZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSchedulingZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSchedulingZoneMutation>(CreateSchedulingZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSchedulingZone', 'mutation', variables);
    },
    ExemptSchedulingResourceFromCompanyBlockedDay(variables: ExemptSchedulingResourceFromCompanyBlockedDayMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExemptSchedulingResourceFromCompanyBlockedDayMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExemptSchedulingResourceFromCompanyBlockedDayMutation>(ExemptSchedulingResourceFromCompanyBlockedDayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ExemptSchedulingResourceFromCompanyBlockedDay', 'mutation', variables);
    },
    RemoveSchedulingResourceCompanyBlockedDayExemption(variables: RemoveSchedulingResourceCompanyBlockedDayExemptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSchedulingResourceCompanyBlockedDayExemptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSchedulingResourceCompanyBlockedDayExemptionMutation>(RemoveSchedulingResourceCompanyBlockedDayExemptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveSchedulingResourceCompanyBlockedDayExemption', 'mutation', variables);
    },
    RestoreSchedulingRegion(variables: RestoreSchedulingRegionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreSchedulingRegionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreSchedulingRegionMutation>(RestoreSchedulingRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestoreSchedulingRegion', 'mutation', variables);
    },
    RestoreSchedulingResource(variables: RestoreSchedulingResourceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreSchedulingResourceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreSchedulingResourceMutation>(RestoreSchedulingResourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestoreSchedulingResource', 'mutation', variables);
    },
    RestoreSchedulingZone(variables: RestoreSchedulingZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RestoreSchedulingZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RestoreSchedulingZoneMutation>(RestoreSchedulingZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RestoreSchedulingZone', 'mutation', variables);
    },
    SchedulingRegion(variables: SchedulingRegionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SchedulingRegionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SchedulingRegionQuery>(SchedulingRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SchedulingRegion', 'query', variables);
    },
    SchedulingRegions(variables?: SchedulingRegionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SchedulingRegionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SchedulingRegionsQuery>(SchedulingRegionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SchedulingRegions', 'query', variables);
    },
    SchedulingResource(variables: SchedulingResourceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SchedulingResourceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SchedulingResourceQuery>(SchedulingResourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SchedulingResource', 'query', variables);
    },
    SchedulingResources(variables: SchedulingResourcesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SchedulingResourcesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SchedulingResourcesQuery>(SchedulingResourcesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SchedulingResources', 'query', variables);
    },
    SetSchedulingResourceEligibilityRules(variables: SetSchedulingResourceEligibilityRulesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetSchedulingResourceEligibilityRulesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetSchedulingResourceEligibilityRulesMutation>(SetSchedulingResourceEligibilityRulesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetSchedulingResourceEligibilityRules', 'mutation', variables);
    },
    UnblockCompanySchedulingDay(variables: UnblockCompanySchedulingDayMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnblockCompanySchedulingDayMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnblockCompanySchedulingDayMutation>(UnblockCompanySchedulingDayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnblockCompanySchedulingDay', 'mutation', variables);
    },
    UnblockSchedulingResourceDay(variables: UnblockSchedulingResourceDayMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnblockSchedulingResourceDayMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnblockSchedulingResourceDayMutation>(UnblockSchedulingResourceDayDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnblockSchedulingResourceDay', 'mutation', variables);
    },
    UpdateSchedulingRegion(variables: UpdateSchedulingRegionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSchedulingRegionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSchedulingRegionMutation>(UpdateSchedulingRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSchedulingRegion', 'mutation', variables);
    },
    UpdateSchedulingResource(variables: UpdateSchedulingResourceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSchedulingResourceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSchedulingResourceMutation>(UpdateSchedulingResourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSchedulingResource', 'mutation', variables);
    },
    UpdateSchedulingZone(variables: UpdateSchedulingZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSchedulingZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSchedulingZoneMutation>(UpdateSchedulingZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSchedulingZone', 'mutation', variables);
    },
    CreateServiceRegions(variables: CreateServiceRegionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateServiceRegionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateServiceRegionsMutation>(CreateServiceRegionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateServiceRegions', 'mutation', variables);
    },
    ServiceRegion(variables: ServiceRegionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRegionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRegionQuery>(ServiceRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ServiceRegion', 'query', variables);
    },
    UpdateServiceRegion(variables: UpdateServiceRegionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateServiceRegionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateServiceRegionMutation>(UpdateServiceRegionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateServiceRegion', 'mutation', variables);
    },
    bulkUpdateAccessorialMappings(variables: BulkUpdateAccessorialMappingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkUpdateAccessorialMappingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdateAccessorialMappingsMutation>(BulkUpdateAccessorialMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpdateAccessorialMappings', 'mutation', variables);
    },
    bulkUpdateContactQuickbooksIds(variables: BulkUpdateContactQuickbooksIdsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BulkUpdateContactQuickbooksIdsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BulkUpdateContactQuickbooksIdsMutation>(BulkUpdateContactQuickbooksIdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'bulkUpdateContactQuickbooksIds', 'mutation', variables);
    },
    SettingsCompanyConfigurationChanges(variables?: SettingsCompanyConfigurationChangesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SettingsCompanyConfigurationChangesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SettingsCompanyConfigurationChangesQuery>(SettingsCompanyConfigurationChangesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SettingsCompanyConfigurationChanges', 'query', variables);
    },
    SettingsCompanyConfiguration(variables?: SettingsCompanyConfigurationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SettingsCompanyConfigurationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SettingsCompanyConfigurationQuery>(SettingsCompanyConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SettingsCompanyConfiguration', 'query', variables);
    },
    companyDefaultEdiSettings(variables?: CompanyDefaultEdiSettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompanyDefaultEdiSettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompanyDefaultEdiSettingsQuery>(CompanyDefaultEdiSettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'companyDefaultEdiSettings', 'query', variables);
    },
    SettingsCompanyFields(variables?: SettingsCompanyFieldsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SettingsCompanyFieldsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SettingsCompanyFieldsQuery>(SettingsCompanyFieldsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SettingsCompanyFields', 'query', variables);
    },
    accessorialToQuickbooksMappingByContact(variables: AccessorialToQuickbooksMappingByContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AccessorialToQuickbooksMappingByContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AccessorialToQuickbooksMappingByContactQuery>(AccessorialToQuickbooksMappingByContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'accessorialToQuickbooksMappingByContact', 'query', variables);
    },
    createAccessorialToQuickbooksMapping(variables: CreateAccessorialToQuickbooksMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAccessorialToQuickbooksMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAccessorialToQuickbooksMappingMutation>(CreateAccessorialToQuickbooksMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createAccessorialToQuickbooksMapping', 'mutation', variables);
    },
    CreateManyReferenceNumberLabels(variables: CreateManyReferenceNumberLabelsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateManyReferenceNumberLabelsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateManyReferenceNumberLabelsMutation>(CreateManyReferenceNumberLabelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateManyReferenceNumberLabels', 'mutation', variables);
    },
    createQuickbooksHeaderFileMapping(variables: CreateQuickbooksHeaderFileMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateQuickbooksHeaderFileMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateQuickbooksHeaderFileMappingMutation>(CreateQuickbooksHeaderFileMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createQuickbooksHeaderFileMapping', 'mutation', variables);
    },
    deleteQuickbooksHeaderFileMapping(variables: DeleteQuickbooksHeaderFileMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteQuickbooksHeaderFileMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteQuickbooksHeaderFileMappingMutation>(DeleteQuickbooksHeaderFileMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteQuickbooksHeaderFileMapping', 'mutation', variables);
    },
    deleteTag(variables: DeleteTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTagMutation>(DeleteTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTag', 'mutation', variables);
    },
    DisconnectQuickbooks(variables?: DisconnectQuickbooksMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DisconnectQuickbooksMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DisconnectQuickbooksMutation>(DisconnectQuickbooksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DisconnectQuickbooks', 'mutation', variables);
    },
    DownloadFinancialSnapshotsCsv(variables?: DownloadFinancialSnapshotsCsvQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DownloadFinancialSnapshotsCsvQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DownloadFinancialSnapshotsCsvQuery>(DownloadFinancialSnapshotsCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DownloadFinancialSnapshotsCsv', 'query', variables);
    },
    quickbooksOAuthUrl(variables?: QuickbooksOAuthUrlQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuickbooksOAuthUrlQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuickbooksOAuthUrlQuery>(QuickbooksOAuthUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quickbooksOAuthUrl', 'query', variables);
    },
    getQuickbooksConnectionStatus(variables?: GetQuickbooksConnectionStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetQuickbooksConnectionStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetQuickbooksConnectionStatusQuery>(GetQuickbooksConnectionStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getQuickbooksConnectionStatus', 'query', variables);
    },
    MyInAppNotificationPreferences(variables?: MyInAppNotificationPreferencesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MyInAppNotificationPreferencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyInAppNotificationPreferencesQuery>(MyInAppNotificationPreferencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MyInAppNotificationPreferences', 'query', variables);
    },
    queryQuickbooksDesktopItems(variables?: QueryQuickbooksDesktopItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QueryQuickbooksDesktopItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QueryQuickbooksDesktopItemsQuery>(QueryQuickbooksDesktopItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'queryQuickbooksDesktopItems', 'query', variables);
    },
    quickbooksCustomers(variables?: QuickbooksCustomersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuickbooksCustomersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuickbooksCustomersQuery>(QuickbooksCustomersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quickbooksCustomers', 'query', variables);
    },
    quickbooksClasses(variables?: QuickbooksClassesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuickbooksClassesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuickbooksClassesQuery>(QuickbooksClassesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quickbooksClasses', 'query', variables);
    },
    quickbooksHeaderFileMappings(variables?: QuickbooksHeaderFileMappingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuickbooksHeaderFileMappingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuickbooksHeaderFileMappingsQuery>(QuickbooksHeaderFileMappingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quickbooksHeaderFileMappings', 'query', variables);
    },
    quickbooksIncomeAccounts(variables?: QuickbooksIncomeAccountsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuickbooksIncomeAccountsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuickbooksIncomeAccountsQuery>(QuickbooksIncomeAccountsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quickbooksIncomeAccounts', 'query', variables);
    },
    quickbooksItems(variables?: QuickbooksItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuickbooksItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuickbooksItemsQuery>(QuickbooksItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quickbooksItems', 'query', variables);
    },
    quickbooksTaxCodes(variables?: QuickbooksTaxCodesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuickbooksTaxCodesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuickbooksTaxCodesQuery>(QuickbooksTaxCodesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quickbooksTaxCodes', 'query', variables);
    },
    referenceNumberFormatConfigs(variables: ReferenceNumberFormatConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReferenceNumberFormatConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReferenceNumberFormatConfigsQuery>(ReferenceNumberFormatConfigsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'referenceNumberFormatConfigs', 'query', variables);
    },
    SyncFinancialSnapshots(variables?: SyncFinancialSnapshotsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SyncFinancialSnapshotsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncFinancialSnapshotsMutation>(SyncFinancialSnapshotsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SyncFinancialSnapshots', 'mutation', variables);
    },
    updateAccessorialToQuickbooksMapping(variables: UpdateAccessorialToQuickbooksMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateAccessorialToQuickbooksMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateAccessorialToQuickbooksMappingMutation>(UpdateAccessorialToQuickbooksMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateAccessorialToQuickbooksMapping', 'mutation', variables);
    },
    SettingsUpdateCompanyConfiguration(variables: SettingsUpdateCompanyConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SettingsUpdateCompanyConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SettingsUpdateCompanyConfigurationMutation>(SettingsUpdateCompanyConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SettingsUpdateCompanyConfiguration', 'mutation', variables);
    },
    SettingsUpdateCompanyFields(variables: SettingsUpdateCompanyFieldsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SettingsUpdateCompanyFieldsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SettingsUpdateCompanyFieldsMutation>(SettingsUpdateCompanyFieldsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SettingsUpdateCompanyFields', 'mutation', variables);
    },
    updateCompany(variables: UpdateCompanyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCompanyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompanyMutation>(UpdateCompanyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCompany', 'mutation', variables);
    },
    UpdateInAppNotificationPreferences(variables: UpdateInAppNotificationPreferencesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateInAppNotificationPreferencesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateInAppNotificationPreferencesMutation>(UpdateInAppNotificationPreferencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateInAppNotificationPreferences', 'mutation', variables);
    },
    updateOrderFormFields(variables: UpdateOrderFormFieldsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOrderFormFieldsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrderFormFieldsMutation>(UpdateOrderFormFieldsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOrderFormFields', 'mutation', variables);
    },
    updateQuickbooksHeaderFileMapping(variables: UpdateQuickbooksHeaderFileMappingMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateQuickbooksHeaderFileMappingMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateQuickbooksHeaderFileMappingMutation>(UpdateQuickbooksHeaderFileMappingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateQuickbooksHeaderFileMapping', 'mutation', variables);
    },
    updateTag(variables: UpdateTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTagMutation>(UpdateTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTag', 'mutation', variables);
    },
    CreateQuoteAgentForwardingAddress(variables?: CreateQuoteAgentForwardingAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateQuoteAgentForwardingAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateQuoteAgentForwardingAddressMutation>(CreateQuoteAgentForwardingAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateQuoteAgentForwardingAddress', 'mutation', variables);
    },
    ExpireQuoteAgentPreviousForwardingToken(variables?: ExpireQuoteAgentPreviousForwardingTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExpireQuoteAgentPreviousForwardingTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExpireQuoteAgentPreviousForwardingTokenMutation>(ExpireQuoteAgentPreviousForwardingTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ExpireQuoteAgentPreviousForwardingToken', 'mutation', variables);
    },
    QuoteAgentConnections(variables?: QuoteAgentConnectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteAgentConnectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteAgentConnectionsQuery>(QuoteAgentConnectionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'QuoteAgentConnections', 'query', variables);
    },
    QuoteAgentInboundRejections(variables?: QuoteAgentInboundRejectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteAgentInboundRejectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteAgentInboundRejectionsQuery>(QuoteAgentInboundRejectionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'QuoteAgentInboundRejections', 'query', variables);
    },
    RotateQuoteAgentForwardingToken(variables: RotateQuoteAgentForwardingTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RotateQuoteAgentForwardingTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RotateQuoteAgentForwardingTokenMutation>(RotateQuoteAgentForwardingTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RotateQuoteAgentForwardingToken', 'mutation', variables);
    },
    SaveSmc3Settings(variables: SaveSmc3SettingsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveSmc3SettingsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveSmc3SettingsMutation>(SaveSmc3SettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SaveSmc3Settings', 'mutation', variables);
    },
    Smc3AvailableTariffs(variables?: Smc3AvailableTariffsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Smc3AvailableTariffsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Smc3AvailableTariffsQuery>(Smc3AvailableTariffsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Smc3AvailableTariffs', 'query', variables);
    },
    Smc3Settings(variables?: Smc3SettingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Smc3SettingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Smc3SettingsQuery>(Smc3SettingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Smc3Settings', 'query', variables);
    },
    TestSmc3Connection(variables?: TestSmc3ConnectionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TestSmc3ConnectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TestSmc3ConnectionMutation>(TestSmc3ConnectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TestSmc3Connection', 'mutation', variables);
    },
    TestSmc3Rate(variables: TestSmc3RateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TestSmc3RateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TestSmc3RateMutation>(TestSmc3RateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TestSmc3Rate', 'mutation', variables);
    },
    addLineItemsToSettlementBills(variables: AddLineItemsToSettlementBillsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddLineItemsToSettlementBillsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddLineItemsToSettlementBillsMutation>(AddLineItemsToSettlementBillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addLineItemsToSettlementBills', 'mutation', variables);
    },
    CreateSettlementAdjustment(variables: CreateSettlementAdjustmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateSettlementAdjustmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSettlementAdjustmentMutation>(CreateSettlementAdjustmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSettlementAdjustment', 'mutation', variables);
    },
    driverSettlementBillByUuidV2(variables: DriverSettlementBillByUuidV2QueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillByUuidV2Query> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillByUuidV2Query>(DriverSettlementBillByUuidV2Document, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillByUuidV2', 'query', variables);
    },
    driverSettlementBillExportPdf(variables: DriverSettlementBillExportPdfMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillExportPdfMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillExportPdfMutation>(DriverSettlementBillExportPdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillExportPdf', 'mutation', variables);
    },
    driverSettlementBillExportZip(variables: DriverSettlementBillExportZipMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DriverSettlementBillExportZipMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DriverSettlementBillExportZipMutation>(DriverSettlementBillExportZipDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'driverSettlementBillExportZip', 'mutation', variables);
    },
    finalizeSettlementBills(variables: FinalizeSettlementBillsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FinalizeSettlementBillsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FinalizeSettlementBillsMutation>(FinalizeSettlementBillsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'finalizeSettlementBills', 'mutation', variables);
    },
    SettlementBillLineItemWithCosts(variables: SettlementBillLineItemWithCostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SettlementBillLineItemWithCostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SettlementBillLineItemWithCostsQuery>(SettlementBillLineItemWithCostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SettlementBillLineItemWithCosts', 'query', variables);
    },
    removeLineItemsFromSettlementBill(variables: RemoveLineItemsFromSettlementBillMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveLineItemsFromSettlementBillMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveLineItemsFromSettlementBillMutation>(RemoveLineItemsFromSettlementBillDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeLineItemsFromSettlementBill', 'mutation', variables);
    },
    RemoveSettlementAdjustment(variables: RemoveSettlementAdjustmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveSettlementAdjustmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveSettlementAdjustmentMutation>(RemoveSettlementAdjustmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveSettlementAdjustment', 'mutation', variables);
    },
    getSettlementBillLineItems(variables: GetSettlementBillLineItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSettlementBillLineItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSettlementBillLineItemsQuery>(GetSettlementBillLineItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSettlementBillLineItems', 'query', variables);
    },
    UpdateSettlementAdjustment(variables: UpdateSettlementAdjustmentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateSettlementAdjustmentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSettlementAdjustmentMutation>(UpdateSettlementAdjustmentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSettlementAdjustment', 'mutation', variables);
    },
    outstandingShipmentsUuids(variables: OutstandingShipmentsUuidsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OutstandingShipmentsUuidsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OutstandingShipmentsUuidsQuery>(OutstandingShipmentsUuidsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'outstandingShipmentsUuids', 'query', variables);
    },
    completedStopNotOnRoute(variables: CompletedStopNotOnRouteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompletedStopNotOnRouteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompletedStopNotOnRouteQuery>(CompletedStopNotOnRouteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completedStopNotOnRoute', 'query', variables);
    },
    completedStopsNotOnRoutes(variables: CompletedStopsNotOnRoutesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CompletedStopsNotOnRoutesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CompletedStopsNotOnRoutesQuery>(CompletedStopsNotOnRoutesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'completedStopsNotOnRoutes', 'query', variables);
    },
    deleteStopAttempt(variables: DeleteStopAttemptMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteStopAttemptMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteStopAttemptMutation>(DeleteStopAttemptDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteStopAttempt', 'mutation', variables);
    },
    markAttemptedStopAsComplete(variables: MarkAttemptedStopAsCompleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkAttemptedStopAsCompleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkAttemptedStopAsCompleteMutation>(MarkAttemptedStopAsCompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markAttemptedStopAsComplete', 'mutation', variables);
    },
    markStopAsIncomplete(variables: MarkStopAsIncompleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkStopAsIncompleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkStopAsIncompleteMutation>(MarkStopAsIncompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markStopAsIncomplete', 'mutation', variables);
    },
    stopForCompletionCheck(variables: StopForCompletionCheckQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StopForCompletionCheckQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StopForCompletionCheckQuery>(StopForCompletionCheckDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stopForCompletionCheck', 'query', variables);
    },
    assignOutboundReferenceNumbersToStorageUnits(variables: AssignOutboundReferenceNumbersToStorageUnitsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AssignOutboundReferenceNumbersToStorageUnitsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignOutboundReferenceNumbersToStorageUnitsMutation>(AssignOutboundReferenceNumbersToStorageUnitsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'assignOutboundReferenceNumbersToStorageUnits', 'mutation', variables);
    },
    createStorageOrderDocument(variables: CreateStorageOrderDocumentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateStorageOrderDocumentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateStorageOrderDocumentMutation>(CreateStorageOrderDocumentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createStorageOrderDocument', 'mutation', variables);
    },
    createStorageOrder(variables: CreateStorageOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateStorageOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateStorageOrderMutation>(CreateStorageOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createStorageOrder', 'mutation', variables);
    },
    createStorageUnit(variables: CreateStorageUnitMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateStorageUnitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateStorageUnitMutation>(CreateStorageUnitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createStorageUnit', 'mutation', variables);
    },
    deleteStorageOrder(variables: DeleteStorageOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteStorageOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteStorageOrderMutation>(DeleteStorageOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteStorageOrder', 'mutation', variables);
    },
    deleteStorageUnit(variables: DeleteStorageUnitMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteStorageUnitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteStorageUnitMutation>(DeleteStorageUnitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteStorageUnit', 'mutation', variables);
    },
    storageOrderStorageUnits(variables: StorageOrderStorageUnitsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StorageOrderStorageUnitsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StorageOrderStorageUnitsQuery>(StorageOrderStorageUnitsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'storageOrderStorageUnits', 'query', variables);
    },
    storageOrder(variables: StorageOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StorageOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StorageOrderQuery>(StorageOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'storageOrder', 'query', variables);
    },
    storageOrders(variables: StorageOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StorageOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StorageOrdersQuery>(StorageOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'storageOrders', 'query', variables);
    },
    storageUnitsForPicklist(variables: StorageUnitsForPicklistQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StorageUnitsForPicklistQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StorageUnitsForPicklistQuery>(StorageUnitsForPicklistDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'storageUnitsForPicklist', 'query', variables);
    },
    storageUnits(variables: StorageUnitsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StorageUnitsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StorageUnitsQuery>(StorageUnitsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'storageUnits', 'query', variables);
    },
    generateStorageOrderPreSignedPutUrl(variables: GenerateStorageOrderPreSignedPutUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GenerateStorageOrderPreSignedPutUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateStorageOrderPreSignedPutUrlMutation>(GenerateStorageOrderPreSignedPutUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateStorageOrderPreSignedPutUrl', 'mutation', variables);
    },
    importStorageOrdersFromCSV(variables: ImportStorageOrdersFromCsvMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ImportStorageOrdersFromCsvMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportStorageOrdersFromCsvMutation>(ImportStorageOrdersFromCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importStorageOrdersFromCSV', 'mutation', variables);
    },
    upsertItemGroup(variables: UpsertItemGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertItemGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertItemGroupMutation>(UpsertItemGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertItemGroup', 'mutation', variables);
    },
    itemGroups(variables: ItemGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ItemGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ItemGroupsQuery>(ItemGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'itemGroups', 'query', variables);
    },
    markStorageUnitAsBilled(variables: MarkStorageUnitAsBilledMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkStorageUnitAsBilledMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkStorageUnitAsBilledMutation>(MarkStorageUnitAsBilledDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markStorageUnitAsBilled', 'mutation', variables);
    },
    markStorageUnitAsOsd(variables: MarkStorageUnitAsOsdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkStorageUnitAsOsdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkStorageUnitAsOsdMutation>(MarkStorageUnitAsOsdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markStorageUnitAsOsd', 'mutation', variables);
    },
    removeStorageUnitOsd(variables: RemoveStorageUnitOsdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveStorageUnitOsdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveStorageUnitOsdMutation>(RemoveStorageUnitOsdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'removeStorageUnitOsd', 'mutation', variables);
    },
    setStorageOrderItemQuantity(variables: SetStorageOrderItemQuantityMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetStorageOrderItemQuantityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetStorageOrderItemQuantityMutation>(SetStorageOrderItemQuantityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setStorageOrderItemQuantity', 'mutation', variables);
    },
    unassignInventoryItems(variables: UnassignInventoryItemsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnassignInventoryItemsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnassignInventoryItemsMutation>(UnassignInventoryItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unassignInventoryItems', 'mutation', variables);
    },
    updateStorageOrder(variables: UpdateStorageOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStorageOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStorageOrderMutation>(UpdateStorageOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStorageOrder', 'mutation', variables);
    },
    updateStorageUnit(variables: UpdateStorageUnitMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateStorageUnitMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateStorageUnitMutation>(UpdateStorageUnitDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateStorageUnit', 'mutation', variables);
    },
    upsertPicklist(variables: UpsertPicklistMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertPicklistMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertPicklistMutation>(UpsertPicklistDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertPicklist', 'mutation', variables);
    },
    tags(variables?: TagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TagsQuery>(TagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tags', 'query', variables);
    },
    createTariffLocation(variables: CreateTariffLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTariffLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTariffLocationMutation>(CreateTariffLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTariffLocation', 'mutation', variables);
    },
    createTariffZone(variables: CreateTariffZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateTariffZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTariffZoneMutation>(CreateTariffZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTariffZone', 'mutation', variables);
    },
    deleteTariffLocation(variables: DeleteTariffLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTariffLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTariffLocationMutation>(DeleteTariffLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTariffLocation', 'mutation', variables);
    },
    deleteTariffZone(variables: DeleteTariffZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteTariffZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTariffZoneMutation>(DeleteTariffZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTariffZone', 'mutation', variables);
    },
    findTariffZoneByUuid(variables: FindTariffZoneByUuidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindTariffZoneByUuidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindTariffZoneByUuidQuery>(FindTariffZoneByUuidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findTariffZoneByUuid', 'query', variables);
    },
    tariffZones(variables?: TariffZonesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffZonesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffZonesQuery>(TariffZonesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffZones', 'query', variables);
    },
    updateTariffZone(variables: UpdateTariffZoneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateTariffZoneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTariffZoneMutation>(UpdateTariffZoneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTariffZone', 'mutation', variables);
    },
    services(variables?: ServicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServicesQuery>(ServicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'services', 'query', variables);
    },
    tariffGroups(variables?: TariffGroupsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TariffGroupsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TariffGroupsQuery>(TariffGroupsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tariffGroups', 'query', variables);
    },
    shipmentsByPhoneOrReferenceNumber(variables: ShipmentsByPhoneOrReferenceNumberQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShipmentsByPhoneOrReferenceNumberQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShipmentsByPhoneOrReferenceNumberQuery>(ShipmentsByPhoneOrReferenceNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'shipmentsByPhoneOrReferenceNumber', 'query', variables);
    },
    BundleChildren(variables: BundleChildrenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BundleChildrenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BundleChildrenQuery>(BundleChildrenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'BundleChildren', 'query', variables);
    },
    CancelPackingPendency(variables: CancelPackingPendencyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CancelPackingPendencyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CancelPackingPendencyMutation>(CancelPackingPendencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CancelPackingPendency', 'mutation', variables);
    },
    CreatePackingPendency(variables: CreatePackingPendencyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreatePackingPendencyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreatePackingPendencyMutation>(CreatePackingPendencyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePackingPendency', 'mutation', variables);
    },
    PackPieces(variables: PackPiecesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PackPiecesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackPiecesMutation>(PackPiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PackPieces', 'mutation', variables);
    },
    PackingPendencies(variables: PackingPendenciesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PackingPendenciesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackingPendenciesQuery>(PackingPendenciesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PackingPendencies', 'query', variables);
    },
    PackingPieces(variables: PackingPiecesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PackingPiecesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PackingPiecesQuery>(PackingPiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PackingPieces', 'query', variables);
    },
    UnpackPieces(variables: UnpackPiecesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnpackPiecesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnpackPiecesMutation>(UnpackPiecesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnpackPieces', 'mutation', variables);
    },
    dockScanReport(variables: DockScanReportQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DockScanReportQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DockScanReportQuery>(DockScanReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dockScanReport', 'query', variables);
    },
    createWarehouseLocation(variables: CreateWarehouseLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateWarehouseLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWarehouseLocationMutation>(CreateWarehouseLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createWarehouseLocation', 'mutation', variables);
    },
    deleteUnusedWarehouseLocations(variables?: DeleteUnusedWarehouseLocationsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteUnusedWarehouseLocationsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUnusedWarehouseLocationsMutation>(DeleteUnusedWarehouseLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteUnusedWarehouseLocations', 'mutation', variables);
    },
    deleteWarehouseLocation(variables: DeleteWarehouseLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteWarehouseLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteWarehouseLocationMutation>(DeleteWarehouseLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteWarehouseLocation', 'mutation', variables);
    },
    warehouseLocations(variables?: WarehouseLocationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WarehouseLocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WarehouseLocationsQuery>(WarehouseLocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'warehouseLocations', 'query', variables);
    },
    importWarehouseLocationsFromCsv(variables: ImportWarehouseLocationsFromCsvMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ImportWarehouseLocationsFromCsvMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImportWarehouseLocationsFromCsvMutation>(ImportWarehouseLocationsFromCsvDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'importWarehouseLocationsFromCsv', 'mutation', variables);
    },
    scanOrder(variables: ScanOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ScanOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ScanOrderMutation>(ScanOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'scanOrder', 'mutation', variables);
    },
    updateWarehouseLocation(variables: UpdateWarehouseLocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateWarehouseLocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWarehouseLocationMutation>(UpdateWarehouseLocationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWarehouseLocation', 'mutation', variables);
    },
    createWarehouse(variables: CreateWarehouseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateWarehouseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateWarehouseMutation>(CreateWarehouseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createWarehouse', 'mutation', variables);
    },
    deleteWarehouse(variables: DeleteWarehouseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteWarehouseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteWarehouseMutation>(DeleteWarehouseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteWarehouse', 'mutation', variables);
    },
    closestWarehouseToAddress(variables: ClosestWarehouseToAddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ClosestWarehouseToAddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ClosestWarehouseToAddressQuery>(ClosestWarehouseToAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'closestWarehouseToAddress', 'query', variables);
    },
    markWarehouseAsDefault(variables: MarkWarehouseAsDefaultMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarkWarehouseAsDefaultMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarkWarehouseAsDefaultMutation>(MarkWarehouseAsDefaultDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'markWarehouseAsDefault', 'mutation', variables);
    },
    myWarehouses(variables?: MyWarehousesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MyWarehousesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MyWarehousesQuery>(MyWarehousesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'myWarehouses', 'query', variables);
    },
    updateWarehouse(variables: UpdateWarehouseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateWarehouseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateWarehouseMutation>(UpdateWarehouseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateWarehouse', 'mutation', variables);
    },
    warehouse(variables: WarehouseQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WarehouseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WarehouseQuery>(WarehouseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'warehouse', 'query', variables);
    },
    warehouses(variables: WarehousesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WarehousesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WarehousesQuery>(WarehousesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'warehouses', 'query', variables);
    },
    findLegs(variables: FindLegsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindLegsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindLegsQuery>(FindLegsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findLegs', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;